/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		19: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"c7f977ef","1":"9985786a","2":"ec57ec14","3":"2f776cb4","4":"fc2ff3cd","5":"f3483cfe","6":"245b038a","7":"ae63eb8b","8":"fefa174b","9":"6adf231e","10":"8ea3987c","11":"91ea971d","12":"ff9878d0","13":"d7735901","14":"dff1cc90","15":"f28661e1","16":"fb266745","17":"84712995","18":"3dd0e4d1"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 857);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(864);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(869)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBEMClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addModifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bem_helper__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bem_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_bem_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_pickBy__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var getBEMClasses = function getBEMClasses() {
  var _Array$prototype;

  for (var _len = arguments.length, classes = Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  classes = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, _toConsumableArray(classes)).filter(function (item) {
    return item;
  });

  var BEMClasses = classes.map(function (className) {
    return new __WEBPACK_IMPORTED_MODULE_0_react_bem_helper___default.a({
      name: className,
      outputIsString: true
    });
  });
  return function (element, modifier) {
    return BEMClasses.map(function (BEMClass) {
      return BEMClass(element, processModifiers(modifier));
    }).join(' ');
  };
};

function processModifiers(modifiers) {
  return isObject(modifiers) ? __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default()(modifiers) : modifiers;
}

function isObject(obj) {
  return obj === Object(obj) && !Array.isArray(obj);
}

var addModifier = function addModifier(modifiers, newModifier) {
  var result = void 0;

  if (Array.isArray(modifiers)) {
    result = [newModifier].concat(_toConsumableArray(modifiers));
  } else if (typeof modifiers === 'string') {
    result = [newModifier, modifiers];
  } else if ((typeof modifiers === 'undefined' ? 'undefined' : _typeof(modifiers)) === 'object') {
    result = modifiers;
    result[newModifier] = true;
  }

  return result;
};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(875);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
var toSubscriber_1 = __webpack_require__(1589);
var observable_1 = __webpack_require__(270);
var pipe_1 = __webpack_require__(383);
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i - 0] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipe_1.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable.prototype.toPromise = function (PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return actionTypes; });
/* unused harmony export arrayInsert */
/* unused harmony export arrayMove */
/* unused harmony export arrayPop */
/* unused harmony export arrayPush */
/* unused harmony export arrayRemove */
/* unused harmony export arrayRemoveAll */
/* unused harmony export arrayShift */
/* unused harmony export arraySplice */
/* unused harmony export arraySwap */
/* unused harmony export arrayUnshift */
/* unused harmony export autofill */
/* unused harmony export blur */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return change; });
/* unused harmony export clearAsyncError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearFields; });
/* unused harmony export clearSubmitErrors */
/* unused harmony export destroy */
/* unused harmony export focus */
/* unused harmony export initialize */
/* unused harmony export registerField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return reset; });
/* unused harmony export resetSection */
/* unused harmony export setSubmitFailed */
/* unused harmony export setSubmitSucceeded */
/* unused harmony export startAsyncValidation */
/* unused harmony export startSubmit */
/* unused harmony export stopAsyncValidation */
/* unused harmony export stopSubmit */
/* unused harmony export submit */
/* unused harmony export touch */
/* unused harmony export unregisterField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return untouch; });
/* unused harmony export updateSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(458);
/* unused harmony reexport defaultShouldAsyncValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(459);
/* unused harmony reexport defaultShouldValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(460);
/* unused harmony reexport defaultShouldError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(461);
/* unused harmony reexport defaultShouldWarn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormName__ = __webpack_require__(906);
/* unused harmony reexport FormName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSection__ = __webpack_require__(907);
/* unused harmony reexport FormSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmissionError__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__SubmissionError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes__ = __webpack_require__(909);
/* unused harmony reexport propTypes */
/* unused harmony reexport fieldInputPropTypes */
/* unused harmony reexport fieldMetaPropTypes */
/* unused harmony reexport fieldPropTypes */
/* unused harmony reexport fieldArrayFieldsPropTypes */
/* unused harmony reexport fieldArrayMetaPropTypes */
/* unused harmony reexport fieldArrayPropTypes */
/* unused harmony reexport formPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Field__ = __webpack_require__(910);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fields__ = __webpack_require__(977);
/* unused harmony reexport Fields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldArray__ = __webpack_require__(980);
/* unused harmony reexport FieldArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValueSelector__ = __webpack_require__(998);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_14__formValueSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formValues__ = __webpack_require__(1000);
/* unused harmony reexport formValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormError__ = __webpack_require__(1004);
/* unused harmony reexport getFormError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormNames__ = __webpack_require__(1006);
/* unused harmony reexport getFormNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormValues__ = __webpack_require__(1008);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_18__getFormValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__ = __webpack_require__(1010);
/* unused harmony reexport getFormInitialValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__ = __webpack_require__(1012);
/* unused harmony reexport getFormSyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormMeta__ = __webpack_require__(1014);
/* unused harmony reexport getFormMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__ = __webpack_require__(1016);
/* unused harmony reexport getFormAsyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__ = __webpack_require__(1018);
/* unused harmony reexport getFormSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__ = __webpack_require__(1020);
/* unused harmony reexport getFormSubmitErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__ = __webpack_require__(1022);
/* unused harmony reexport isAsyncValidating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isDirty__ = __webpack_require__(1024);
/* unused harmony reexport isDirty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isInvalid__ = __webpack_require__(1026);
/* unused harmony reexport isInvalid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isPristine__ = __webpack_require__(1029);
/* unused harmony reexport isPristine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValid__ = __webpack_require__(1030);
/* unused harmony reexport isValid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isSubmitting__ = __webpack_require__(1031);
/* unused harmony reexport isSubmitting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__ = __webpack_require__(1033);
/* unused harmony reexport hasSubmitSucceeded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__ = __webpack_require__(1035);
/* unused harmony reexport hasSubmitFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reduxForm__ = __webpack_require__(1037);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_33__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducer__ = __webpack_require__(1068);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_34__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__values__ = __webpack_require__(1071);
/* unused harmony reexport values */










// alias for propTypes


























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearAsyncError = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearAsyncError;
var clearFields = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearFields;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var resetSection = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].resetSection;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;
var updateSyncWarnings = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].updateSyncWarnings;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assignConfigWithLocal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configDefault_json__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configDefault_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__configDefault_json__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



var config = {};
var configLocal = window.APEXWebConfig || {};
// Reliably confirms that x is an Object, but not a Function, Array, etc.
var isObject = function isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};
for (var key in __WEBPACK_IMPORTED_MODULE_0__configDefault_json___default.a) {
  if (isObject(__WEBPACK_IMPORTED_MODULE_0__configDefault_json___default.a[key]) && isObject(configLocal[key])) {
    config[key] = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__configDefault_json___default.a[key], configLocal[key]);
  } else {
    config[key] = __WEBPACK_IMPORTED_MODULE_0__configDefault_json___default.a[key];
  }
}

var _ref = JSON.parse(localStorage.getItem('apexTemplate')) || {},
    localChart = _ref.chart,
    localConfig = _objectWithoutProperties(_ref, ['chart']);

var assignConfigWithLocal = function assignConfigWithLocal() {
  config.global = Object.assign({}, config.global, localConfig);

  config.TradingLayout.chart = localChart || config.TradingLayout.chart;
};

assignConfigWithLocal();

/* harmony default export */ __webpack_exports__["b"] = (config);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatPercentageValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatToThousands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatNumberToLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return parseNumberToLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return replaceZeroWithDash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return truncateToDecimals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getParsedDecimal; });
/* unused harmony export getLocaleSettings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bignumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral_locales__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral_locales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral_locales__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parse_decimal_number__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_parse_decimal_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_parse_decimal_number__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var makeBigNumber = function makeBigNumber(value) {
  return new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(isNaN(value) ? 0 : value);
};

var NumberFormatter = function () {
  function NumberFormatter() {
    _classCallCheck(this, NumberFormatter);

    this.locale = null;
    this.abbreviations = null;
    this.delimiters = null;
    this.getDecimalPlaces = null;
  }

  /**
   * @param {Object} options
   * @param {String} options.locale
   * @param {Function} options.getDecimalPlaces
   */


  _createClass(NumberFormatter, [{
    key: 'init',
    value: function init(options) {
      this.locale = options.locale;
      this.getDecimalPlaces = options.getDecimalPlaces;

      var _getLocaleSettings = this.getLocaleSettings(),
          delimiters = _getLocaleSettings.delimiters,
          abbreviations = _getLocaleSettings.abbreviations;

      this.abbreviations = abbreviations;
      this.delimiters = delimiters;

      __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a.config({
        ROUNDING_MODE: options.roundingMode ? options.roundingMode : __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a.ROUND_FLOOR,
        FORMAT: {
          decimalSeparator: delimiters.decimal,
          groupSeparator: delimiters.thousands,
          groupSize: 3
        }
      });
    }
  }, {
    key: 'currency',
    value: function currency(value, symbol) {
      var currency = makeBigNumber(value);
      currency.symbol = symbol;
      return currency;
    }
  }, {
    key: 'formatPercentageValue',
    value: function formatPercentageValue(value) {
      var number = makeBigNumber(value);
      return number.toFormat(2) + '%';
    }
  }, {
    key: 'formatToThousands',
    value: function formatToThousands(value) {
      var number = makeBigNumber(value);
      return '' + number.div(1000).toFormat(2) + this.abbreviations.thousand;
    }

    /**
     *
     * @param {string|number|BigNumber} value
     * @param {string|number} symbolOrDecimals
     */

  }, {
    key: 'formatNumberToLocale',
    value: function formatNumberToLocale(value, symbolOrDecimals) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        removeTrailingZeroes: false
      };

      var num = makeBigNumber(value);
      var decimals = void 0;

      if (typeof symbolOrDecimals === 'string') {
        var decimalPlaces = this.getDecimalPlaces();
        decimals = decimalPlaces[symbolOrDecimals];
      } else {
        decimals = symbolOrDecimals;
      }

      if (options.removeTrailingZeroes) return num.decimalPlaces(decimals).toString();
      return num.toFormat(decimals);
    }
  }, {
    key: 'parseNumberToLocale',
    value: function parseNumberToLocale(value, localeOverride) {
      var negativeIsNaN = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var settings = this.getLocaleSettings(localeOverride);
      var reg = new RegExp('\\' + settings.delimiters.thousands, 'g');
      var formatValue = value.toString().replace(reg, '');
      if (formatValue === '' || formatValue === settings.delimiters.decimal) return 0;
      var parsed = __WEBPACK_IMPORTED_MODULE_3_parse_decimal_number___default()(formatValue, settings.delimiters);
      return negativeIsNaN && parsed < 0 ? NaN : parsed;
    }
  }, {
    key: 'replaceZeroWithDash',
    value: function replaceZeroWithDash(value) {
      return value === 0 ? '-' : value;
    }
  }, {
    key: 'truncateToDecimals',
    value: function truncateToDecimals(value, decimalPlaces) {
      var roundingMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var number = makeBigNumber(value);
      return number.decimalPlaces(decimalPlaces, roundingMode);
    }
  }, {
    key: 'getParsedDecimal',
    value: function getParsedDecimal(value, decimalPlaces) {
      var localeOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      // returns an object useful for complex rendering of decimal values
      var _ref = localeOverride ? this.getLocaleSettings(localeOverride).delimiters : this.delimiters,
          thousands = _ref.thousands,
          decimal = _ref.decimal;

      var BN = localeOverride ? __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a.clone({
        FORMAT: {
          decimalSeparator: decimal,
          groupSeparator: thousands,
          groupSize: 3
        }
      }) : __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a;
      var bigNum = new BN(isNaN(value) ? 0 : value);
      var parts = bigNum.toFormat().split(decimal);
      var units = parts[0];
      var decimals = parts.length > 1 && parts[1].length ? parts[1] : '0';
      if (decimals.length > decimalPlaces) {
        // concat
        decimals = decimals.substr(0, decimalPlaces);
      }
      var padding = decimals.length < decimalPlaces ? '0'.repeat(decimalPlaces - decimals.length) : '';

      return {
        negative: bigNum.isNegative(),
        units: units,
        decimalSeparator: decimal,
        decimals: decimals,
        padding: padding
      };
    }
  }, {
    key: 'getLocaleSettings',
    value: function getLocaleSettings() {
      var localeOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var localeCode = localeOverride || this.locale;
      var settings = void 0;
      try {
        // numberal keys for locales can be without country code (e.g "en")
        settings = __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData(localeCode);
      } catch (e) {
        try {
          settings = __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData(localeCode.split('-')[0]);
        } catch (e) {
          // there can be the case that numeral doesn't have key for only lang code (e.g for pt key is pt-pt)
          settings = __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData(localeCode + '-' + localeCode);
        }
      }
      return settings;
    }
  }]);

  return NumberFormatter;
}();

var numberFormatter = new NumberFormatter();

var init = numberFormatter.init.bind(numberFormatter);
var currency = numberFormatter.currency.bind(numberFormatter);
var formatPercentageValue = numberFormatter.formatPercentageValue.bind(numberFormatter);
var formatToThousands = numberFormatter.formatToThousands.bind(numberFormatter);
var formatNumberToLocale = numberFormatter.formatNumberToLocale.bind(numberFormatter);
var parseNumberToLocale = numberFormatter.parseNumberToLocale.bind(numberFormatter);
var replaceZeroWithDash = numberFormatter.replaceZeroWithDash.bind(numberFormatter);
var truncateToDecimals = numberFormatter.truncateToDecimals.bind(numberFormatter);
var getParsedDecimal = numberFormatter.getParsedDecimal.bind(numberFormatter);
var getLocaleSettings = numberFormatter.getLocaleSettings.bind(numberFormatter);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return standardInstrumentsWithProductFullNamesAndProductSymbols; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return instrumentsWithProductFullNamesAndProductSymbols; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return instrumentSelectorInstruments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectedInstrumentSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_positionFormatter__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_tradingStyleConstants__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__positionSelectors__ = __webpack_require__(52);






var getInstrumentsWithProductFullNamesAndProductSymbols = function getInstrumentsWithProductFullNamesAndProductSymbols(instrument, product) {
  return instrument.instruments.filter(function (instrument) {
    var product1 = product.products.find(function (product) {
      return product.ProductId === instrument.Product1;
    });
    var product2 = product.products.find(function (product) {
      return product.ProductId === instrument.Product2;
    });
    return product1 && product2;
  }).map(function (instrument) {
    var product1 = product.products.find(function (product) {
      return product.ProductId === instrument.Product1;
    });
    var product2 = product.products.find(function (product) {
      return product.ProductId === instrument.Product2;
    });

    var _ref = product1 && product1,
        Product1Symbol = _ref.Product,
        Product1FullName = _ref.ProductFullName;

    var _ref2 = product2 && product2,
        Product2Symbol = _ref2.Product,
        Product2FullName = _ref2.ProductFullName;

    return Object.assign({}, instrument, {
      Product1FullName: Product1FullName,
      Product2FullName: Product2FullName,
      Product1Symbol: Product1Symbol,
      Product2Symbol: Product2Symbol
    });
  });
};

var standardInstrumentsWithProductFullNamesAndProductSymbols = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.apexCore.instrument;
}, function (state) {
  return state.apexCore.product;
}, function (instrument, product) {
  return getInstrumentsWithProductFullNamesAndProductSymbols(instrument, product);
});

var marginInstrumentsWithProductFullNamesAndProductSymbols = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.margin.instrument;
}, function (state) {
  return state.apexCore.product;
}, function (instrument, product) {
  return getInstrumentsWithProductFullNamesAndProductSymbols(instrument, product);
});

var instrumentsWithProductFullNamesAndProductSymbols = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.user.userInfo.MarginBorrowerEnabled;
}, function (state) {
  return state.form.tradingStyle;
}, function (state) {
  return state.margin;
}, function (state) {
  return state;
}, function (marginEnabled, formObj, margin, state) {
  var tradingStyle = void 0;
  if (formObj) {
    tradingStyle = formObj.values.tradingStyle;
  }

  if (margin && marginEnabled && !margin.instrument.fetching && tradingStyle === __WEBPACK_IMPORTED_MODULE_3__constants_tradingStyleConstants__["a" /* marginTrade */]) {
    return marginInstrumentsWithProductFullNamesAndProductSymbols(state);
  }

  return standardInstrumentsWithProductFullNamesAndProductSymbols(state);
});

var instrumentSelectorInstruments = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(instrumentsWithProductFullNamesAndProductSymbols, function () {
  return __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */];
}, function (instruments, config) {
  if (config.InstrumentSelector.instruments.length === 0) {
    return instruments;
  }

  return instruments.filter(function (instrument) {
    return config.InstrumentSelector.instruments.includes(instrument.Symbol);
  });
});

var selectedStandardInstrumentSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([instrumentsWithProductFullNamesAndProductSymbols, function (state) {
  return state.apexCore.instrument.selectedInstrumentId;
}], function (instruments, selectedInstrumentId) {
  return instruments.find(function (i) {
    return i.InstrumentId === selectedInstrumentId;
  }) || {};
});

var selectedMarginInstrumentSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([instrumentsWithProductFullNamesAndProductSymbols, function (state) {
  return state.margin.instrument.selectedInstrumentId;
}], function (instruments, selectedInstrumentId) {
  return instruments.find(function (i) {
    return i.InstrumentId === selectedInstrumentId;
  });
});

var selectedInstrumentSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.user.userInfo.MarginBorrowerEnabled;
}, function (state) {
  return state.form.tradingStyle;
}, function (state) {
  return state.margin;
}, function (state) {
  return state;
}], function (marginEnabled, formObj, margin, state) {
  var tradingStyle = void 0;
  if (formObj) {
    tradingStyle = formObj.values.tradingStyle;
  }

  if (margin && marginEnabled && !margin.instrument.fetching && tradingStyle === __WEBPACK_IMPORTED_MODULE_3__constants_tradingStyleConstants__["a" /* marginTrade */]) {
    return selectedMarginInstrumentSelector(state);
  }

  return selectedStandardInstrumentSelector(state);
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4__positionSelectors__["b" /* positionSelector */], selectedInstrumentSelector], function (positions, instrument) {
  var defaultPositions = {
    position1: {},
    position2: {}
  };

  if (!instrument || !positions[instrument.Product1] || !positions[instrument.Product2]) {
    return defaultPositions;
  }

  var position1 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_positionFormatter__["a" /* default */])(positions[instrument.Product1], instrument.Product1Symbol);
  var position2 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_positionFormatter__["a" /* default */])(positions[instrument.Product2], instrument.Product2Symbol);

  return { position1: position1, position2: position2 };
}));

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OPEN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return openModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MODAL_TYPES; });
var CLOSE_MODAL = 'CLOSE_MODAL';
var OPEN_MODAL = 'OPEN_MODAL';

var openModal = function openModal(name, modalProps) {
  return {
    type: OPEN_MODAL,
    payload: { name: name, modalProps: modalProps }
  };
};

var closeModal = function closeModal(name) {
  return {
    type: CLOSE_MODAL,
    payload: { name: name }
  };
};

var MODAL_TYPES = {
  NEW_API_KEY: 'NEW_API_KEY',
  REMOVE_API_KEY: 'REMOVE_API_KEY',
  CONFIRM_SINGLE_REPORT: 'CONFIRM_SINGLE_REPORT',
  CONFIRM_CYCLICAL_REPORT: 'CONFIRM_CYCLICAL_REPORT',
  CONFIRM_FIAT_DEPOSIT: 'CONFIRM_FIAT_DEPOSIT',
  CONFIRM_FIAT_WITHDRAW: 'CONFIRM_FIAT_WITHDRAW',
  CONFIRM_BLOCK_REPORT: 'CONFIRM_BLOCK_REPORT',
  CONFIRM_ORDER_REPORT: 'CONFIRM_ORDER_REPORT',
  RETAIL_SUBMIT_ORDER: 'RETAIL_SUBMIT_ORDER',
  EOTC_SUBMIT_ORDER: 'EOTC_SUBMIT_ORDER',
  NEW_AFFILIATE_KEY: 'NEW_AFFILIATE_KEY',
  ENABLE_2FA: 'ENABLE_2FA',
  DISABLE_2FA: 'DISABLE_2FA',
  DEPOSIT_STATUS: 'DEPOSIT_STATUS',
  DEPOSIT_REFERENCE_ID: 'DEPOSIT_REFERENCE_ID',
  SEND_REQUEST_2FA: 'SEND_REQUEST_2FA',
  SUBMIT_LIMIT_ORDER: 'SUBMIT_LIMIT_ORDER',
  MARGIN_DEPOSIT: 'MARGIN_DEPOSIT',
  MARGIN_WITHDRAW: 'MARGIN_WITHDRAW',
  MARGIN_TRADING: 'MARGIN_TRADING',
  MARGIN_CONFIRM: 'MARGIN_CONFIRM',
  MARGIN_DISABLE: 'MARGIN_DISABLE',
  MARGIN_CLOSE_POSITION: 'MARGIN_CLOSE_POSITION',
  MARGIN_TRANSFER_ASSETS: 'MARGIN_TRANSFER_ASSETS',
  GET_GOOGLE_2FA_RECOVERY_CODE: 'GET_GOOGLE_2FA_RECOVERY_CODE',
  REQUIRE_2FA: 'REQUIRE_2FA',
  PREVIEW_CLOSE_BY_SETTLEMENT: 'PREVIEW_CLOSE_BY_SETTLEMENT',
  INTEREST_ACCOUNTS_CONFIRMATION: 'INTEREST_ACCOUNTS_CONFIRMATION',
  INTEREST_LENDING_ENABLE: 'INTEREST_LENDING_ENABLE',
  INTEREST_DISABLE: 'INTEREST_DISABLE'
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_components_common_Buttons_css__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_components_common_Buttons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_components_common_Buttons_css__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var APButton = function APButton(props) {
  var children = props.children,
      styleName = props.styleName,
      baseClass = props.baseClass,
      customClass = props.customClass,
      classModifiers = props.classModifiers,
      disabled = props.disabled,
      dataTest = props.dataTest,
      otherProps = _objectWithoutProperties(props, ['children', 'styleName', 'baseClass', 'customClass', 'classModifiers', 'disabled', 'dataTest']);

  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass, classModifiers);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      Object.assign({
        disabled: disabled,
        'data-test': dataTest,
        className: bemClasses('btn', [styleName, classModifiers])
      }, otherProps),
      children
    )
  );
};

APButton.defaultProps = {
  name: '',
  value: '',
  type: '',
  autoFocus: false,
  disabled: false,
  baseClass: 'ap-button',
  styleName: __WEBPACK_IMPORTED_MODULE_2__propTypes_commonComponent__["b" /* styleNames */].general
};

APButton.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  styleName: __WEBPACK_IMPORTED_MODULE_2__propTypes_commonComponent__["a" /* styleNamePropType */]
};

APButton.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (APButton);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(268);
var Subscription_1 = __webpack_require__(46);
var Observer_1 = __webpack_require__(672);
var rxSubscriber_1 = __webpack_require__(269);
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if (isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[rxSubscriber_1.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
function isTrustedSubscriber(obj) {
    return obj instanceof Subscriber || ('syncErrorThrowable' in obj && obj[rxSubscriber_1.rxSubscriber]);
}
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1073);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APIcon_js__ = __webpack_require__(158);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__APIcon_js__["a" /* default */]);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(230);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APLabelWithText__ = __webpack_require__(647);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__APLabelWithText__["a" /* default */]);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_history__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_css__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Modal_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var baseClass = 'ap-modal';

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.getBEMClasses = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, _this.props.customClass);
    };

    _this.renderCloseIcon = function () {
      var bemClasses = _this.getBEMClasses();
      var onClick = _this.props.onCancel || _this.props.close;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { onClick: onClick, className: bemClasses('close-icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__APIcon__["a" /* default */], { name: 'close', classModifiers: 'big' })
      );
    };

    _this.handleFooterButtonClick = function (e) {
      _this.props.footer.onClick();
      !_this.props.footer.overrideClose && _this.props.close();
    };

    _this.modalRef = null;
    _this.unlisten = null;
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_react_modal___default.a.setAppElement(this.modalRef);
      this.unlisten = __WEBPACK_IMPORTED_MODULE_6__helpers_history__["a" /* default */].listen(function (location, action) {
        var close = _this2.props.onCancel || _this2.props.close;
        if (action === 'POP' && _this2.props.isOpen) {
          close();
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unlisten();
      this.unlisten = null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.props.isOpen) return null;

      var bemClasses = this.getBEMClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { ref: function ref(_ref) {
            return _this3.modalRef = _ref;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,
          {
            className: bemClasses(),
            ariaHideApp: false,
            overlayClassName: bemClasses('overlay'),
            onRequestClose: this.props.onCancel || this.props.close,
            isOpen: this.props.isOpen },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('header') },
            this.props.title
          ),
          this.renderCloseIcon(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('content') },
            this.props.children
          ),
          this.props.footer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('footer') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__APButton__["a" /* default */],
              {
                customClass: bemClasses(),
                onClick: this.handleFooterButtonClick,
                styleName: this.props.footer.buttonStyle,
                disabled: this.props.footer.disabled },
              this.props.footer.buttonText
            )
          )
        )
      );
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  overrideClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Modal.defaultProps = {
  overrideClose: false
};
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
exports.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
var isArrayLike_1 = __webpack_require__(674);
var isPromise_1 = __webpack_require__(675);
var isObject_1 = __webpack_require__(670);
var Observable_1 = __webpack_require__(4);
var iterator_1 = __webpack_require__(186);
var InnerSubscriber_1 = __webpack_require__(1598);
var observable_1 = __webpack_require__(270);
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    }
    else if (isArrayLike_1.isArrayLike(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root_1.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator_1.iterator] === 'function') {
        var iterator = result[iterator_1.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable_1.observable] === 'function') {
        var obs = result[observable_1.observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
exports.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(976);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_SNACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_SNACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_SNACK_BY_UNIQUE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showSnack; });
/* unused harmony export dismissSnack */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dismissSnackByUniqueId; });
var ADD_SNACK = 'ADD_SNACK';
var REMOVE_SNACK = 'REMOVE_SNACK';
var REMOVE_SNACK_BY_UNIQUE_ID = 'REMOVE_SNACK_BY_UNIQUE_ID';

var showSnack = function showSnack(payload) {
  return function (dispatch, getState) {
    var _getState = getState(),
        snackbar = _getState.snackbar;

    var snacks = snackbar.snacks;
    var snack = payload;
    if (snacks.length !== 0) {
      var _snack = snacks.find(function (snack) {
        return snack.id === payload.id;
      });
      if (_snack) {
        _snack.count ? _snack.count++ : _snack.count = 2;
        _snack.text = payload.text + ' (' + _snack.count.toString() + ')';
        dispatch(dismissSnackByUniqueId(_snack.uniqueId));
      }
    }
    dispatch(addSnack(snack));
  };
};

var dismissSnack = function dismissSnack(payload) {
  return {
    type: REMOVE_SNACK,
    payload: payload
  };
};

var dismissSnackByUniqueId = function dismissSnackByUniqueId(payload) {
  return {
    type: REMOVE_SNACK_BY_UNIQUE_ID,
    payload: payload
  };
};

var addSnack = function addSnack(payload) {
  return {
    type: ADD_SNACK,
    payload: Object.assign({}, payload, {
      uniqueId: Date.now()
    })
  };
};

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setGateway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initApex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getApex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_alphapoint__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_alphapoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_alphapoint__);


var apex = { connection: {}, gateway: '' };

var setGateway = function setGateway(gateway) {
  apex.gateway = gateway;
  apex.connection = {};
};

var initApex = function initApex(onopen, onclose) {
  var gateway = apex.gateway;
  apex.connection = new __WEBPACK_IMPORTED_MODULE_0_alphapoint__["APEX"](gateway, {
    onopen: onopen,
    onclose: onclose
  });
  apex.connection.standardCallback = function () {};
};

var getApex = function getApex() {
  var onopen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var onclose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (!apex.connection.ws) {
    var server = void 0;
    var cookie = localStorage.getItem('tradingServer');
    if (apex.gateway) server = apex.gateway;
    if (cookie) server = cookie;

    if (!server) {
      // context.t("Gateway not selected")
      throw new Error('Gateway not selected');
    }

    setGateway(server);
    initApex(onopen, onclose);
  }

  return apex;
};

/* harmony default export */ __webpack_exports__["a"] = (apex);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* unused harmony export HashRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NavLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(75);
/* unused harmony reexport MemoryRouter */
/* unused harmony reexport Prompt */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });
/* unused harmony reexport StaticRouter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* unused harmony reexport generatePath */
/* unused harmony reexport matchPath */
/* unused harmony reexport useHistory */
/* unused harmony reexport useLocation */
/* unused harmony reexport useParams */
/* unused harmony reexport useRouteMatch */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(294);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_SIDE_PANE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_SIDE_PANE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return openSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return closeSidePane; });
/* unused harmony export openAdvancedOrderSidePane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeAdvancedOrderSidePane; });
/* unused harmony export openReportBlockTradeSidePane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return closeReportBlockTradeSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return openReportsSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return closeReportsSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return openDepositSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return closeDepositSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return openWithdrawSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return closeWithdrawSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return openApiKeysSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeApiKeysSidePane; });
/* unused harmony export openKYCSidePane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return openKYC_IMSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return openKYC_IMLegacySidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return openKYC_JumioSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return openKYC_ManualSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return closeKYCSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return closeKYC_JumioSidePane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return openRetailSendReceiveSidePane; });
/* unused harmony export closeRetailSendReceiveSidePane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return openRetailFiatSidePane; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__ = __webpack_require__(501);


var CLOSE_SIDE_PANE = 'CLOSE_SIDE_PANE';
var OPEN_SIDE_PANE = 'OPEN_SIDE_PANE';

var openSidePane = function openSidePane(pane, props) {
  return {
    type: OPEN_SIDE_PANE,
    payload: { pane: pane, sidePaneProps: props }
  };
};

var closeSidePane = function closeSidePane(pane) {
  return {
    type: CLOSE_SIDE_PANE,
    payload: pane
  };
};

var openAdvancedOrderSidePane = function openAdvancedOrderSidePane() {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].ADVANCED_ORDER);
};
var closeAdvancedOrderSidePane = function closeAdvancedOrderSidePane() {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].ADVANCED_ORDER);
};
var openReportBlockTradeSidePane = function openReportBlockTradeSidePane() {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].ADVANCED_ORDER);
};
var closeReportBlockTradeSidePane = function closeReportBlockTradeSidePane() {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].REPORT_BLOCK_TRADE);
};

var openReportsSidePane = function openReportsSidePane(index) {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].REPORTS, index);
};
var closeReportsSidePane = function closeReportsSidePane() {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].REPORTS);
};

var openDepositSidePane = function openDepositSidePane(product) {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].DEPOSITS, { product: product });
};
var closeDepositSidePane = function closeDepositSidePane() {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].DEPOSITS);
};

var openWithdrawSidePane = function openWithdrawSidePane(product) {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].WITHDRAWS, { product: product });
};
var closeWithdrawSidePane = function closeWithdrawSidePane() {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].WITHDRAWS);
};

var openApiKeysSidePane = function openApiKeysSidePane() {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].API_KEYS);
};
var closeApiKeysSidePane = function closeApiKeysSidePane() {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].API_KEYS);
};

var openKYCSidePane = function openKYCSidePane() {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].KYC);
};
var openKYC_IMSidePane = function openKYC_IMSidePane() {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].KYC_IM);
};
var openKYC_IMLegacySidePane = function openKYC_IMLegacySidePane() {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].KYC_IMLegacy);
};
var openKYC_JumioSidePane = function openKYC_JumioSidePane() {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].KYC_Jumio);
};
var openKYC_ManualSidePane = function openKYC_ManualSidePane() {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].KYC_Manual);
};
var closeKYCSidePane = function closeKYCSidePane() {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].KYC);
};
var closeKYC_JumioSidePane = function closeKYC_JumioSidePane() {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].KYC_Jumio);
};

var openRetailSendReceiveSidePane = function openRetailSendReceiveSidePane(isSend, product) {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].RETAIL_SEND_RECEIVE, { isSend: isSend, product: product });
};

var closeRetailSendReceiveSidePane = function closeRetailSendReceiveSidePane(isSend, product) {
  return closeSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].RETAIL_SEND_RECEIVE);
};

var openRetailFiatSidePane = function openRetailFiatSidePane(isSend, product, isDepositDisabled, isWithdrawDisabled) {
  return openSidePane(__WEBPACK_IMPORTED_MODULE_0__constants_sidePanesConstants__["a" /* SIDE_PANES */].RETAIL_FIAT, {
    isSend: isSend,
    product: product,
    isDepositDisabled: isDepositDisabled,
    isWithdrawDisabled: isWithdrawDisabled
  });
};

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner_css__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Spinner_css__);






var spinnerClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('spinner');

var Spinner = function Spinner(_ref) {
  var isVisible = _ref.isVisible,
      isInline = _ref.isInline,
      text = _ref.text,
      customClass = _ref.customClass,
      classModifiers = _ref.classModifiers;

  var baseClass = typeof customClass === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])(customClass) : customClass || function () {
    return '';
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    isVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: spinnerClasses('container', isInline && 'inline') + ' ' + baseClass('spinner-container', classModifiers) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: spinnerClasses('circle', isInline && 'inline') + ' ' + baseClass('spinner-circle', classModifiers)
      }),
      text && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: spinnerClasses('text') },
        text
      )
    )
  );
};

Spinner.propTypes = {
  isInline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Spinner.defaultProps = {
  isVisible: true
};

/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__ = __webpack_require__(9);



var modalDecorator = function modalDecorator(_ref) {
  var name = _ref.name;

  var mapStateToProps = function mapStateToProps(state) {
    if (state.modal.hasOwnProperty(name)) {
      var _state$modal$name = state.modal[name],
          isOpen = _state$modal$name.isOpen,
          modalProps = _state$modal$name.modalProps;


      return Object.assign({
        isOpen: isOpen
      }, modalProps);
    }
    return {
      isOpen: false
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      close: function close() {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["d" /* closeModal */])(name));
      }
    };
  };

  return function (WrappedComponent) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(WrappedComponent);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (modalDecorator);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_API_INFO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS; });
/* unused harmony export receiveValidate2FARequiredEndpoints */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getApiInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return callAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalActions__ = __webpack_require__(9);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_API_INFO = 'GET_API_INFO';
var RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS = 'RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS';

var receiveValidate2FARequiredEndpoints = function receiveValidate2FARequiredEndpoints(payload) {
  return {
    type: RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS,
    payload: payload
  };
};

var getApiInfo = function getApiInfo() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var _getState, OMSId, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), OMSId = _getState.user.userInfo.OMSId;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCPromise('GetValidate2FARequiredEndpoints', {
                OMSId: OMSId
              });

            case 3:
              data = _context.sent;


              if (data) dispatch(receiveValidate2FARequiredEndpoints(JSON.parse(data.o)));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var callAPI = function callAPI(endpoint, apiPayload) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var state, validate2FARequiredEndpoints, apiCall, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              validate2FARequiredEndpoints = state.api.validate2FARequiredEndpoints;

              if (!validate2FARequiredEndpoints[endpoint.toLowerCase()]) {
                _context3.next = 5;
                break;
              }

              apiCall = function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(data) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCPromise(endpoint, data);

                        case 2:
                          return _context2.abrupt('return', _context2.sent);

                        case 3:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this);
                }));

                return function apiCall(_x5) {
                  return _ref3.apply(this, arguments);
                };
              }();

              return _context3.abrupt('return', new Promise(function (resolve, reject) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_2__modalActions__["b" /* MODAL_TYPES */].REQUIRE_2FA, {
                  apiPayload: JSON.stringify(apiPayload),
                  apiCall: apiCall,
                  resolve: resolve,
                  reject: reject
                }));
              }));

            case 5:
              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCPromise(endpoint, apiPayload);

            case 7:
              res = _context3.sent;
              return _context3.abrupt('return', JSON.parse(res.o));

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (path) {
  return "" + "" + path;
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sellValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return orderTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return advancedOrderFormTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return submitButtonTextOptions; });
var _submitButtonTextOpti;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sellValue = '1';
var buyValue = '0';

var orderTypes = {
  //context.t('Market')
  market: {
    orderType: '1',
    displayName: 'Market Order'
  },
  //context.t('Limit')
  limit: {
    orderType: '2',
    displayName: 'Limit Order'
  },
  //context.t('Stop Market')
  stopMarket: {
    orderType: '3',
    displayName: 'Stop Market'
  },
  //context.t('Stop Limit')
  stopLimit: {
    orderType: '4',
    displayName: 'Stop Limit'
  },
  //context.t('Trailing Stop Market')
  trailingStopMarket: {
    orderType: '5',
    displayName: 'Trailing Stop Market'
  },
  //context.t('Trailing Stop Limit')
  trailingStopLimit: {
    orderType: '6',
    displayName: 'Trailing Stop Limit'
  },
  //context.t('Report Block Trade')
  reportBlockTrade: {
    orderType: '7',
    displayName: 'Report Block Trade'
  },
  //context.t('Fill Or Kill')
  fillOrKill: {
    orderType: '2',
    displayName: 'Fill Or Kill'
  },
  //context.t('Immediate or Cancel')
  immediateOrCancel: {
    orderType: '2',
    displayName: 'Immediate or Cancel'
  },
  //context.t('Reserve Order')
  reserveOrder: {
    orderType: '2',
    displayName: 'Reserve Order'
  }
};

var advancedOrderFormTypes = {
  market: orderTypes.market,
  limit: orderTypes.limit,
  stopMarket: orderTypes.stopMarket,
  stopLimit: orderTypes.stopLimit,
  trailingStopMarket: orderTypes.trailingStopMarket,
  trailingStopLimit: orderTypes.trailingStopLimit,
  fillOrKill: orderTypes.fillOrKill,
  immediateOrCancel: orderTypes.immediateOrCancel,
  reserveOrder: orderTypes.reserveOrder
};

/**
 * context.t('Place Sell Order')
 * context.t('Place Buy Order')
 */
var submitButtonTextOptions = (_submitButtonTextOpti = {}, _defineProperty(_submitButtonTextOpti, sellValue, 'Place Sell Order'), _defineProperty(_submitButtonTextOpti, buyValue, 'Place Buy Order'), _submitButtonTextOpti);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = ticksToDateString;
/* harmony export (immutable) */ __webpack_exports__["e"] = parseDate;
/* harmony export (immutable) */ __webpack_exports__["f"] = parseTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatDateTime;
/* harmony export (immutable) */ __webpack_exports__["a"] = createInputDateMask;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_is_date__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





/**
 * converts .NET ticks to UTC timestamp
 */
function ticksToDateString(ticks) {
  if (typeof ticks !== 'number') return false;
  if (ticks === 0) return 'N/A';

  var ticksSinceEpoch = ticks - 621355968000000000;
  var millisecondsSinceEpoch = ticksSinceEpoch / 10000;
  var date = new Date(millisecondsSinceEpoch);

  return formatDateTime(date);
}

// Formats supported are any ordering of M/MM, D/DD and YYYY with -, /, or . separators.
function parseDate(dateString) {
  if (dateString.length === 0) {
    return '';
  }
  var dateFormat = __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.dateFormat;

  var regex = /[^.\-/]+/g;
  var keys = dateFormat.match(regex);
  var parsed = dateString.match(regex);
  var dateObj = {};
  keys.forEach(function (key, index) {
    dateObj[key.charAt(0)] = parseInt(parsed[index], 10);
  });
  return new Date(dateObj['Y'], dateObj['M'] - 1, dateObj['D']);
}

function parseTime(timeArg) {
  if (!timeArg) return;
  if (__WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default()(timeArg)) return timeArg;

  var _timeArg$split = timeArg.split(' '),
      _timeArg$split2 = _slicedToArray(_timeArg$split, 2),
      time = _timeArg$split2[0],
      amPm = _timeArg$split2[1];

  var _time$split = time.split(':'),
      _time$split2 = _slicedToArray(_time$split, 2),
      hours = _time$split2[0],
      minutes = _time$split2[1];

  if (amPm && amPm.toLowerCase() === 'pm') {
    hours = +hours + 12;
  }

  return new Date(0, 0, 0, +hours, +minutes);
}

function formatDate(date, customFormat) {
  return __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(date, customFormat || __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.dateFormat);
}

function formatTime(time) {
  return __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(time, __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.timeFormat);
}

function formatDateTime(dateTime) {
  return __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(dateTime, __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.dateTimeFormat);
}

function createInputDateMask() {
  // Divide dateFormat to groups like [M/,D/,YYYY]
  var formatMask = '',
      inputMask = '';
  var separator = __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.dateFormat.match(/(\W)/g)[0];
  var reg = new RegExp('([A-Za-z]+' + separator + ')([A-Za-z]+' + separator + ')([A-Za-z]+)');
  var regArray = __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.dateFormat.match(reg);
  var maxGroupsSize = 3;

  for (var i = 1; i <= maxGroupsSize; i++) {
    if (regArray[i].length === 2 && regArray[i].match('' + separator)) {
      // Check option like M/ and replace with MM/
      formatMask += regArray[i].slice(0, -1) + regArray[i];
    } else if (regArray[i].length === 1) {
      formatMask += regArray[i].repeat(2);
    } else {
      formatMask += regArray[i];
    }
  }

  // Replace all symbols to 9
  inputMask = formatMask.replace(/[A-Za-z]/g, '9');
  return { inputMask: inputMask, formatMask: formatMask };
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertIncrementToIntDecimalPlaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return incrementUiValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bignumber_js__);


/**
 * Converts Price/Quantity Increment to expected (int) decimalPlaces.
 *  i.e., Xe-8 => 8.
 * @param {number} increment
 */
var convertIncrementToIntDecimalPlaces = function convertIncrementToIntDecimalPlaces(increment) {
  if (!increment || increment >= 1) return 0;

  return parseFloat(increment.toExponential().split('-')[1]);
};

/**
 * Ensure value is in units of increment.
 * Better name: "roundDownToNearestIncrement"
 *
 * @param {number} val
 * @param {number} increment
 */
var incrementUiValue = function incrementUiValue(val, increment) {
  var A = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(val);
  var B = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(increment);

  return A.minus(A.modulo(B));
};

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return requiredNumeric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return matchingPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return validateReceiverEmail; });
/* unused harmony export noWhiteSpace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alphanumeric; });
/* unused harmony export alphabetic */
/* unused harmony export alphanumericspace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return numeric; });
/* unused harmony export biggerThanValue */
/* unused harmony export biggerThanOrEqualToValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lessThanValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return biggerThanZero; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return biggerThanOrEqualToZero; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return validatePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return maxLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isValidPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return maxFileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return maxDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return minDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return minTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return maxTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_libphonenumber_js_custom__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_libphonenumber_js_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js_metadata_min_json__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js_metadata_min_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_libphonenumber_js_metadata_min_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dateHelper__ = __webpack_require__(29);




var required = function required(value) {
  return value ? undefined : 'Required';
};
// context.t('Required')

var requiredNumeric = function requiredNumeric(value) {
  return value !== undefined && value !== '' ? undefined : 'Required';
};
// context.t('Required')

var matchingPassword = function matchingPassword(value, allValues) {
  return value !== allValues.password ? 'Passwords do not match' : undefined;
};
// context.t('Passwords do not match')

var email = function email(value) {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? 'Invalid email address' : undefined;
};
// context.t('Invalid email address')

var validateReceiverEmail = function validateReceiverEmail(value, userEmail) {
  return value === userEmail ? 'You can\'t use your own email as receiver address' : undefined;
};
// context.t(`You can't use your own email as receiver address`)

var noWhiteSpace = function noWhiteSpace(value) {
  return value && /\s/.test(value) ? 'Must not contain whitespace' : undefined;
};
// context.t('Must not contain whitespace')

var alphanumeric = function alphanumeric(value) {
  return value && !/^[a-z0-9]*$/i.test(value) ? 'Input should only contain alphanumeric characters' : undefined;
};
// context.t('Input should only contain alphanumeric characters')

var alphabetic = function alphabetic(value) {
  return value && !/^[a-z]*$/i.test(value) ? 'Input should only contain alphabetic characters' : undefined;
};
// context.t('Input should only contain alphabetic characters')

var alphanumericspace = function alphanumericspace(value) {
  return !/^[a-z\d\s]*$/i.test(value) ? 'Input should only contain alphanumeric and space characters' : undefined;
};
// context.t('Input should only contain alphanumeric and space characters')

var numeric = function numeric(value) {
  return value && !/^\d*$/i.test(value) ? 'Input should only contain numeric characters' : undefined;
};
// context.t('Input should only contain numeric characters')

var biggerThanValue = function biggerThanValue(min) {
  return function (value) {
    return value !== undefined && value <= min ? 'Must be bigger than ' + min : undefined;
  };
};
/* context.t('Must be bigger than {a}', {
   a: min
}) */

var biggerThanOrEqualToValue = function biggerThanOrEqualToValue(min) {
  return function (value) {
    return value !== undefined && value !== '' && value < min ? 'Must be bigger than or equal to ' + min : undefined;
  };
};
/* context.t('Must be bigger than or equal to {a}', {
   a: min
}) */

var lessThanValue = function lessThanValue(max, value) {
  return value && value > max ? 'Must be less than ' + max : undefined;
};
/* context.t('Must be less than {a}', {
   a: max
}) */

var biggerThanZero = biggerThanValue(0);

var biggerThanOrEqualToZero = biggerThanOrEqualToValue(0);

var validatePassword = function validatePassword(value) {
  return value && !/^(?=.{8,})(?=.*[A-Z])(?=.*[0-9]).*$/g.test(value) ? 'Password must contain at least 8 characters, one number, and at least one capital letter' : undefined;
};
// context.t('Password must contain at least 8 characters, one number, and at least one capital letter')

var isDate = function isDate(value) {
  var isInvalid = Object.prototype.toString.call(value) === '[object Date]' ? isNaN(value.getTime()) : true;
  return value && isInvalid ? 'Invalid date' : undefined;
};
// context.t('Invalid date')

var maxLength = function maxLength(max) {
  return function (value) {
    return value && value.length > max ? 'Must be ' + max + ' characters or less' : undefined;
  };
};
/* context.t('Must be {a} characters or less', {
   a: max
}) */

var isValidPhone = function isValidPhone(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js_custom__["isValidNumber"])(value, __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js_metadata_min_json___default.a) ? undefined : 'Must be a valid phone number';
};
// context.t('Must be a valid phone number')

var maxFileSize = function maxFileSize(value, maxSize) {
  return value && value.file && maxSize <= value.file.size / 1024 / 1024 ? 'File size must be under ' + maxSize + 'mb' : undefined;
};

/* context.t('File size must be under {a}mb', {
   a: maxSize
}) */

var maxDate = function maxDate(value, _maxDate) {
  return value && value > _maxDate ? 'Date must be before ' + Object(__WEBPACK_IMPORTED_MODULE_2__dateHelper__["b" /* formatDate */])(_maxDate) : undefined;
};

/* context.t('Date must be before {a}', {
   a: maxDate
}) */

var minDate = function minDate(value, _minDate) {
  return value && value < _minDate ? 'Date must be after ' + Object(__WEBPACK_IMPORTED_MODULE_2__dateHelper__["b" /* formatDate */])(_minDate) : undefined;
};

/* context.t('Date must be after {a}', {
   a: minDate
}) */

var minTime = function minTime(value, _minTime) {
  if (!value) return;
  var time = getTimeObj(value);
  var min = getTimeObj(_minTime);

  return time.hours < min.hours || time.hours === min.hours && time.minutes < min.minutes ? 'Time must be after ' + Object(__WEBPACK_IMPORTED_MODULE_2__dateHelper__["d" /* formatTime */])(_minTime) : undefined;
};

/* context.t('Time must be after {a}', {
   a: maxDate
}) */

var maxTime = function maxTime(value, _maxTime) {
  if (!value) return;
  var time = getTimeObj(value);
  var max = getTimeObj(_maxTime);

  return time.hours > max.hours || time.hours === max.hours && time.minutes > max.minutes ? 'Time must be before ' + Object(__WEBPACK_IMPORTED_MODULE_2__dateHelper__["d" /* formatTime */])(_maxTime) : undefined;
};

/* context.t('Time must be before {a}', {
   a: minDate
}) */

var getTimeObj = function getTimeObj(date) {
  return {
    hours: date.getHours(),
    minutes: date.getMinutes()
  };
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBEMClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addModifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bem_helper__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bem_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_bem_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_pickBy__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var getBEMClasses=function getBEMClasses(){var _Array$prototype;for(var _len=arguments.length,classes=Array(_len),_key=0;_key<_len;_key++){classes[_key]=arguments[_key];}classes=(_Array$prototype=Array.prototype).concat.apply(_Array$prototype,_toConsumableArray(classes)).filter(function(item){return item;});var BEMClasses=classes.map(function(className){return new __WEBPACK_IMPORTED_MODULE_0_react_bem_helper___default.a({name:className,outputIsString:true});});return function(element,modifier){return BEMClasses.map(function(BEMClass){return BEMClass(element,processModifiers(modifier));}).join(' ');};};function processModifiers(modifiers){return isObject(modifiers)?__WEBPACK_IMPORTED_MODULE_1_lodash_pickBy___default()(modifiers):modifiers;}function isObject(obj){return obj===Object(obj)&&!Array.isArray(obj);}var addModifier=function addModifier(modifiers,newModifier){var result=void 0;if(Array.isArray(modifiers)){result=[newModifier].concat(_toConsumableArray(modifiers));}else if(typeof modifiers==='string'){result=[newModifier,modifiers];}else if((typeof modifiers==='undefined'?'undefined':_typeof(modifiers))==='object'){result=modifiers;result[newModifier]=true;}return result;};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncAction_1 = __webpack_require__(191);
var AsyncScheduler_1 = __webpack_require__(192);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */
exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
//# sourceMappingURL=async.js.map

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tradingStyleSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMarginActiveSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMarginEnabledSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return marginAccountSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return notMarginAccountsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultAccountSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return marginBaseAssetSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_tradingStyleConstants__ = __webpack_require__(168);



var tradingStyleSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.form.tradingStyle;
}, function (tradingStyleForm) {
  if (tradingStyleForm) {
    return tradingStyleForm.values.tradingStyle;
  }
  return __WEBPACK_IMPORTED_MODULE_1__constants_tradingStyleConstants__["b" /* standardTrade */];
});

// Checks whether a user has margin trading activated in the UI.
var isMarginActiveSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([tradingStyleSelector], function (tradingStyle) {
  return tradingStyle === __WEBPACK_IMPORTED_MODULE_1__constants_tradingStyleConstants__["a" /* marginTrade */];
});

// Checks whether the Operator + User has margin capability.
var isMarginEnabledSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.user.userInfo;
}, function (state) {
  return state.margin.accountState;
}, function (userInfo, marginAccountState) {
  return !!userInfo.MarginBorrowerEnabled && marginAccountState.accountState.AccountStateStatus === 'Open';
});

var marginAccountSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts.find(function (account) {
    return account.AccountType === 'MarginAsset';
  });
});

var notMarginAccountsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.user.accounts;
}, function (accounts) {
  return accounts.filter(function (account) {
    return account.AccountType !== 'MarginAsset';
  });
});

var accountIdSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(marginAccountSelector, function (state) {
  return state.user.selectedAccountId;
}, isMarginActiveSelector, function (marginAccount, selectedAccountId, isMarginActive) {
  return isMarginActive ? marginAccount.AccountId : selectedAccountId;
});

var defaultAccountSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(notMarginAccountsSelector, function (state) {
  return state.user.userInfo.AccountId;
}, function (accounts, defaultAccountId) {
  return accounts.find(function (acct) {
    return acct.AccountId === defaultAccountId;
  });
});

var marginBaseAssetSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return state.margin.accountState.settings;
}, function (products, settings) {
  if (!settings || !settings.BasedAssetId || !products.length) return {
    Product: 'USD'
  };

  return products.find(function (i) {
    return i.ProductId === settings.BasedAssetId;
  });
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getQuantityForPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPriceForQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return syncPriceWithQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return syncQuantityWithPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isMakerOrTaker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOrderFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOrderLeverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOrderBorrowingPower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getOrderPricePerUnit; });
/* unused harmony export getOrderTotal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOrderNet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOrdersBySide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getSubmitButtonText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMarketPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return mergeOpenOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getValuesFromDealValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOrderPrice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bignumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_makerTakerConstants__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








/* This is reusable, project independent helper. Here shouldn't be store, or specific forms (except place order forms),
 only pure helpers */
var getQuantityForPrice = function getQuantityForPrice(price) {
  var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var orders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var fill = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var side = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */];

  var parsedPrice = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(price);
  var parsedPadding = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(padding);
  var paddedPrice = parsedPrice.minus(parsedPadding.times(parsedPrice));
  var remainingPrice = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(paddedPrice);
  var sum = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(0);
  var quantity = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(0);
  var lastPrice = void 0;
  var lastOrder = void 0;
  orders = [].concat(_toConsumableArray(orders));

  if (side === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]) {
    orders.reverse();
  }

  if (orders.length) {
    orders.some(function (order) {
      var orderQty = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(order.Quantity);
      var orderPx = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(order.Price);
      var orderTotal = orderQty.times(orderPx);

      sum = sum.plus(orderTotal);
      if (sum.lt(paddedPrice)) {
        quantity = quantity.plus(orderQty);
      } else {
        var remainder = paddedPrice.minus(sum.minus(orderTotal));
        quantity = quantity.plus(remainder.div(orderPx));
        lastPrice = orderPx;
      }
      remainingPrice = remainingPrice.minus(orderTotal);
      lastOrder = order;
      return sum.gte(paddedPrice);
    });
  }
  if (fill && remainingPrice.gt(0) && orders.length) {
    quantity = quantity.plus(remainingPrice.div(lastOrder.Price));
    sum = paddedPrice;
  }
  if (sum.lt(paddedPrice)) {
    return { Price: parsedPrice, Quantity: '-' };
  }
  return {
    Price: parsedPrice,
    Quantity: quantity,
    LimitPrice: lastPrice || (lastOrder ? '' + lastOrder.Price : '0')
  };
};

var getPriceForQuantity = function getPriceForQuantity(quantity) {
  var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var orders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var fill = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var side = arguments[4];

  var parsedQuantity = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(quantity);
  var parsedPadding = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(padding);
  var paddedQty = parsedQuantity.plus(parsedPadding.times(quantity));
  var price = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(0);
  var remainingQty = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(paddedQty);
  var lastOrderPrice = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(0);
  var sortedOrders = [].concat(_toConsumableArray(orders));

  if (side === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]) {
    sortedOrders.sort(function (a, b) {
      return a.Price - b.Price;
    });
  } else {
    sortedOrders.sort(function (a, b) {
      return b.Price - a.Price;
    });
  }

  sortedOrders.some(function (order) {
    var orderQuantity = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(order.Quantity);
    var orderPrice = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(order.Price);

    if (remainingQty.gt(orderQuantity)) {
      price = price.plus(orderQuantity.times(orderPrice));
    } else {
      price = price.plus(remainingQty.times(orderPrice));
    }
    remainingQty = remainingQty.minus(orderQuantity);
    lastOrderPrice = orderPrice;
    return remainingQty.lte(0);
  });

  if (fill && remainingQty.gt(0)) {
    price = price.plus(remainingQty.times(lastOrderPrice));
    remainingQty = 0;
  }
  if (remainingQty > 0) {
    return { Quantity: parsedQuantity, Price: '-', LimitPrice: lastOrderPrice };
  }

  return { Quantity: parsedQuantity, Price: price, LimitPrice: lastOrderPrice };
};

/**
 * @param {String} quantity
 * @param {Object} options
 * @param {Object} options.level2
 * @param {Array} options.level2.buy
 * @param {Array} options.level2.sell
 * @param {Object} options.selectedInstrument
 * @param {String} options.side
 */
var syncPriceWithQuantity = function syncPriceWithQuantity(quantity, options) {
  var level2 = options.level2,
      selectedInstrument = options.selectedInstrument,
      side = options.side;

  var orders = getOrdersBySide(side, level2);
  var _config$OrderCalcBuff = __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].OrderCalcBuffer;
  _config$OrderCalcBuff = _config$OrderCalcBuff === undefined ? {} : _config$OrderCalcBuff;
  var priceBuffer = _config$OrderCalcBuff.priceBuffer;


  if (orders.length) {
    var priceForQuantity = getPriceForQuantity(quantity, priceBuffer, orders, true, side).Price;
    return Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["i" /* truncateToDecimals */])(priceForQuantity, Object(__WEBPACK_IMPORTED_MODULE_5__decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement));
  }

  return 0;
};

/**
 * @param {String} price
 * @param {Object} options
 * @param {Object} options.level2
 * @param {Array} options.level2.buy
 * @param {Array} options.level2.sell
 * @param {Object} options.selectedInstrument
 * @param {String} options.side
 */
var syncQuantityWithPrice = function syncQuantityWithPrice(price, options) {
  var level2 = options.level2,
      selectedInstrument = options.selectedInstrument,
      side = options.side;

  var orders = getOrdersBySide(side, level2);
  var _config$OrderCalcBuff2 = __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].OrderCalcBuffer;
  _config$OrderCalcBuff2 = _config$OrderCalcBuff2 === undefined ? {} : _config$OrderCalcBuff2;
  var quantityBuffer = _config$OrderCalcBuff2.quantityBuffer;


  if (orders.length) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["i" /* truncateToDecimals */])(getQuantityForPrice(price, quantityBuffer, orders, true, side).Quantity, Object(__WEBPACK_IMPORTED_MODULE_5__decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement));
  }

  return 0;
};

var isMakerOrTaker = function isMakerOrTaker(buyOrSell, price, bestBid, bestOffer, orderType) {
  var takerOrderTypes = [__WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].market.displayName, __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].immediateOrCancel.displayName, __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName, __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopMarket.displayName];
  if (takerOrderTypes.includes(orderType)) {
    return __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_makerTakerConstants__["b" /* takerValue */];
  }
  if (buyOrSell === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]) {
    return price < bestOffer || Number(bestOffer) === 0 ? __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_makerTakerConstants__["a" /* makerValue */] : __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_makerTakerConstants__["b" /* takerValue */];
  } else if (buyOrSell === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */]) {
    return price > bestBid || Number(bestBid) === 0 ? __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_makerTakerConstants__["a" /* makerValue */] : __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_makerTakerConstants__["b" /* takerValue */];
  }

  console.error('Incorrect buyOrSell value is provided: ' + buyOrSell);

  return __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_makerTakerConstants__["b" /* takerValue */];
};

var getOrderFee = function getOrderFee(form, positions) {
  var symbolPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'beginning';
  var fee = form.values.fee;

  if (fee) {
    var OrderFee = fee.OrderFee,
        ProductId = fee.ProductId,
        FeeProductId = fee.FeeProductId;

    var feeProductId = FeeProductId ? FeeProductId : ProductId;

    var _ref = positions[feeProductId] || { ProductSymbol: '' },
        ProductSymbol = _ref.ProductSymbol;

    var formattedFee = Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["b" /* formatNumberToLocale */])(OrderFee, ProductSymbol);
    if (symbolPosition === 'beginning') return ProductSymbol + ' ' + formattedFee;
    if (symbolPosition === 'end') return formattedFee + ' ' + ProductSymbol;
  }
  return '0';
};

var getOrderLeverage = function getOrderLeverage(form) {
  var fee = form.values.fee;

  if (fee) {
    return fee.Leverage || '—';
  }
  return '—';
};

var getOrderBorrowingPower = function getOrderBorrowingPower(form, selectedInstrument) {
  var products = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var _form$values = form.values,
      fee = _form$values.fee,
      side = _form$values.side;


  if (fee && fee.BorrowingPower) {
    return fee.BorrowingPower;
  } else if (products.length > 0) {
    var productSymbol = side === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? selectedInstrument.Product2Symbol : selectedInstrument.Product1Symbol;
    var product = products.find(function (product) {
      return product.ProductSymbol === productSymbol;
    });
    var borrowingPower = product ? product.BorrowingPower : '0';

    return borrowingPower;
  }
  return '0';
};

var getOrderPricePerUnit = function getOrderPricePerUnit(pricePerUnit, ProductSymbol, decimalPlaces) {
  if (!pricePerUnit) {
    return '0';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["b" /* formatNumberToLocale */])(Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["g" /* parseNumberToLocale */])(pricePerUnit), decimalPlaces) + ' per ' + ProductSymbol;
};

var getOrderTotal = function getOrderTotal(form, instrument) {
  var totalAmount = form.values.totalAmount;
  var Product2Symbol = instrument.Product2Symbol;

  if (!totalAmount) {
    return '0';
  }
  return Product2Symbol + ' ' + Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["b" /* formatNumberToLocale */])(totalAmount, Object(__WEBPACK_IMPORTED_MODULE_5__decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement));
};

var getOrderNet = function getOrderNet(form, instrument, orderTotal) {
  var displaySymbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var _form$values2 = form.values,
      quantity = _form$values2.quantity,
      fee = _form$values2.fee,
      side = _form$values2.side;
  var PriceIncrement = instrument.PriceIncrement,
      QuantityIncrement = instrument.QuantityIncrement,
      Product1 = instrument.Product1,
      Product2 = instrument.Product2,
      Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;

  var productDecimalPlaces = Object(__WEBPACK_IMPORTED_MODULE_5__decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(side === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? QuantityIncrement : PriceIncrement);
  var productSymbol = side === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? Product1Symbol : Product2Symbol;
  var orderNet = void 0;

  if (!orderTotal || !quantity) {
    return '0';
  }

  if (side === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]) {
    orderNet = quantity - (fee.ProductId === Product1 || fee.FeeProductId === Product1 ? fee.OrderFee : 0);
  } else {
    orderNet = orderTotal - (fee.ProductId === Product2 || fee.FeeProductId === Product2 ? fee.OrderFee : 0);
  }

  if (!displaySymbol) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["b" /* formatNumberToLocale */])(orderNet, productDecimalPlaces);
  }

  return productSymbol + ' ' + Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["b" /* formatNumberToLocale */])(orderNet, productDecimalPlaces);
};

var getOrdersBySide = function getOrdersBySide(side, level2) {
  return side === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? level2.sell : level2.buy;
};

var getSubmitButtonText = function getSubmitButtonText(form) {
  var side = form.values.side;

  return side ? __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["e" /* submitButtonTextOptions */][side] : __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["e" /* submitButtonTextOptions */][__WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]];
};

var getMarketPrice = function getMarketPrice(side, instrument, l1, decimalPlacesInt) {
  if (side && instrument && l1) {
    var marketPrice = (side === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? l1.BestOffer : l1.BestBid) || 0;

    return Object(__WEBPACK_IMPORTED_MODULE_3__numberFormatter__["i" /* truncateToDecimals */])(marketPrice, decimalPlacesInt);
  }

  return '0';
};

var mergeOpenOrders = function mergeOpenOrders(orders) {
  var userOrders = [].concat(_toConsumableArray(orders));
  var uniqOrders = [];

  userOrders.sort(function (a, b) {
    return a.Price.minus(b.Price);
  });

  userOrders.forEach(function (item) {
    var itemBefore = uniqOrders[uniqOrders.length - 1];

    if (itemBefore && item.Price.eq(itemBefore.Price)) {
      var mergeItem = Object.assign({}, item, {
        DisplayQuantity: new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(item.DisplayQuantity).plus(new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(itemBefore.DisplayQuantity)),
        OrigQuantity: item.OrigQuantity.plus(itemBefore.OrigQuantity),
        OrderIds: [item.OrderId].concat(itemBefore.OrderIds)
      });

      uniqOrders.splice(uniqOrders.length - 1, 1, mergeItem);
    } else {
      uniqOrders.push(Object.assign({}, item, { OrderIds: [item.OrderId] }));
    }
  });

  return uniqOrders;
};

var getValuesFromDealValues = function getValuesFromDealValues(dealValues, value) {
  var fieldToSearch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'price';

  return dealValues.find(function (i) {
    return parseFloat(i[fieldToSearch]) === parseFloat(value);
  }) || {};
};

var getOrderPrice = function getOrderPrice(form, marketPrice) {
  if (form.values.orderType === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName) {
    return form.values.limitPrice;
  } else if (form.values.orderType === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName) {
    return form.values.stopPrice;
  } else if (form.values.orderType === __WEBPACK_IMPORTED_MODULE_1__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].market.displayName) {
    return marketPrice;
  }
  return '—';
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_INFO_FETCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_CONFIG_FETCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_USER_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ACCOUNT; });
/* unused harmony export RECEIVE_KYC */
/* unused harmony export UPDATE_ACCOUNT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_GOOGLE_QRCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_GOOGLE_QRCODE; });
/* unused harmony export userInfoFetched */
/* unused harmony export setUserInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getUserInfo; });
/* unused harmony export userConfigFetched */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getUserConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateUserConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setUserConfig; });
/* unused harmony export getUserPermissions */
/* unused harmony export receiveUserPermissions */
/* unused harmony export getUserAccounts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return selectAccount; });
/* unused harmony export receiveAccount */
/* unused harmony export setAccount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return goToResetPasswordFormStep; });
/* unused harmony export goToBaseCurrencyFormStep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return sendResetPasswordEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return submitResetPasswordForm; });
/* unused harmony export setGoogleQrCode */
/* unused harmony export clearGoogleQrCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getGoogleQrCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return disable2FA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return enable2FA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getGoogle2FARecoveryCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return resendVerificationEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orderHistoryActions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__depositActions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__withdrawActions__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__languageActions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_errorTextFormatter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__kycActions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transferActions__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__transferRequestActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_affiliateActions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__positionActions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__marketStateUpdateActions__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__eotcSettlementActions__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__marginActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__authActions__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__loyaltyFeeActions__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_subscriptions_AccountEventsSubscriptionService__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config__ = __webpack_require__(6);


var _this = this;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



























var USER_INFO_FETCHED = 'USER_INFO_FETCHED';
var USER_CONFIG_FETCHED = 'USER_CONFIG_FETCHED';
var RECEIVE_USER_PERMISSIONS = 'RECEIVE_USER_PERMISSIONS';
var RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT';
var SET_ACCOUNT = 'SET_ACCOUNT';
var RECEIVE_KYC = 'RECEIVE_KYC';
var UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
var SET_GOOGLE_QRCODE = 'SET_GOOGLE_QRCODE';
var CLEAR_GOOGLE_QRCODE = 'CLEAR_GOOGLE_QRCODE';

var userInfoFetched = function userInfoFetched(payload) {
  return {
    type: USER_INFO_FETCHED,
    payload: payload
  };
};

var setUserInfo = function setUserInfo(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var userInfo;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('SetUserInfo', {
                UserName: payload.username,
                Email: payload.email
              }));

            case 2:
              userInfo = _context.sent;

              if (userInfo.result !== false) {
                dispatch(userInfoFetched(userInfo));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__languageActions__["b" /* changeLanguage */])(payload.language));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'setUserInfoError',
                  text: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_errorTextFormatter__["a" /* formatErrorText */])(userInfo),
                  type: 'warning'
                }));
              }

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getUserInfo = function getUserInfo(UserId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      var userInfo;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserInfo', { UserId: UserId })).catch(function (e) {
                console.error('getUserInfo action error', e);
                return;
              });

            case 2:
              userInfo = _context2.sent;


              dispatch(userInfoFetched(userInfo));
              dispatch(getUserPermissions(userInfo.UserId));
              dispatch(getUserAccounts(userInfo.OMSId));
              dispatch(getUserConfig(userInfo.UserId, userInfo.UserName));
              dispatch(selectAccount(userInfo.AccountId, userInfo.OMSId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_affiliateActions__["d" /* getAffiliate */])(userInfo.OMSId, userInfo.UserId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__loyaltyFeeActions__["d" /* getOperatorLoyaltyFeeConfigs */])(userInfo.OMSId));

              return _context2.abrupt('return', userInfo);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var userConfigFetched = function userConfigFetched(payload) {
  return {
    type: USER_CONFIG_FETCHED,
    payload: payload
  };
};

var getUserConfig = function getUserConfig(UserId, UserName) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch) {
      var userConfig;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              userConfig = void 0;
              _context3.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserConfig', { UserId: UserId, UserName: UserName })).catch(function (e) {
                console.error('getUserConfig action error', e);
                return;
              });

            case 3:
              userConfig = _context3.sent;


              dispatch(userConfigFetched(userConfig));

              return _context3.abrupt('return', userConfig);

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/**
 * Merge `config` arg with existing user config
 */
var updateUserConfig = function updateUserConfig(config) {
  return function (dispatch, getState) {
    var mergedConfig = [].concat(_toConsumableArray(getState().user.userConfig));

    config.forEach(function (current) {
      var index = mergedConfig.findIndex(function (i) {
        return i.Key === current.Key;
      });

      if (index !== -1) {
        mergedConfig[index] = current;
      } else {
        mergedConfig.push(current);
      }
    });

    dispatch(userConfigFetched(mergedConfig));
  };
};

var setUserConfig = function setUserConfig(UserId, UserName, Config) {
  var getUserConfigAfterSetUserConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var _getState, _getState$user, userInfo, userConfig;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _getState = getState(), _getState$user = _getState.user;
              _getState$user = _getState$user === undefined ? {} : _getState$user;
              userInfo = _getState$user.userInfo;
              _context4.next = 5;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('SetUserConfig', {
                UserId: UserId || userInfo.UserId,
                UserName: UserName || userInfo.UserName,
                Config: Config
              }));

            case 5:
              userConfig = _context4.sent;


              if (userConfig.result !== false) {
                if (getUserConfigAfterSetUserConfig) dispatch(getUserConfig(UserId, UserName));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'setUserConfigError',
                  text: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_errorTextFormatter__["a" /* formatErrorText */])(userConfig),
                  type: 'warning'
                }));
              }

              return _context4.abrupt('return', userConfig);

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var getUserPermissions = function getUserPermissions(UserId) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch) {
      var permissions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserPermissions', { UserId: UserId }));

            case 2:
              permissions = _context5.sent;

              dispatch(receiveUserPermissions(permissions));

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var receiveUserPermissions = function receiveUserPermissions(payload) {
  return {
    type: RECEIVE_USER_PERMISSIONS,
    payload: payload
  };
};

var getUserAccounts = function getUserAccounts(OMSId) {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch) {
      var userAccountIds, accountInfoArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, accountId, accountInfo;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserAccounts', { OMSId: OMSId }));

            case 2:
              userAccountIds = _context6.sent;
              accountInfoArray = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context6.prev = 7;
              _iterator = userAccountIds[Symbol.iterator]();

            case 9:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context6.next = 19;
                break;
              }

              accountId = _step.value;
              _context6.next = 13;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetAccountInfo', {
                AccountId: accountId,
                OMSId: OMSId
              }));

            case 13:
              accountInfo = _context6.sent;

              dispatch(receiveAccount([accountInfo]));
              accountInfoArray.push(accountInfo);

            case 16:
              _iteratorNormalCompletion = true;
              _context6.next = 9;
              break;

            case 19:
              _context6.next = 25;
              break;

            case 21:
              _context6.prev = 21;
              _context6.t0 = _context6['catch'](7);
              _didIteratorError = true;
              _iteratorError = _context6.t0;

            case 25:
              _context6.prev = 25;
              _context6.prev = 26;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 28:
              _context6.prev = 28;

              if (!_didIteratorError) {
                _context6.next = 31;
                break;
              }

              throw _iteratorError;

            case 31:
              return _context6.finish(28);

            case 32:
              return _context6.finish(25);

            case 33:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__kycActions__["g" /* subscribeToVerificationLevelUpdateEvents */])(accountInfoArray[0]));

            case 34:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
    }));

    return function (_x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var updateAccount = function updateAccount(loyaltyProduct) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch, getState) {
      var _getState$user2, selectedAccountId, accounts, OMSId, currentAccount, payload, Amount, ProductId, response, text;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _getState$user2 = getState().user, selectedAccountId = _getState$user2.selectedAccountId, accounts = _getState$user2.accounts, OMSId = _getState$user2.userInfo.OMSId;
              currentAccount = accounts.find(function (account) {
                return selectedAccountId === account.AccountId;
              });
              payload = Object.assign({}, currentAccount, {
                LoyaltyProductId: 0,
                LoyaltyEnabled: false
              });


              if (loyaltyProduct) {
                Amount = loyaltyProduct.Amount, ProductId = loyaltyProduct.ProductId;

                payload.LoyaltyProductId = ProductId;

                // Never enable the loyalty token functionality if the balance is 0.
                if (Amount > 0) {
                  payload.LoyaltyEnabled = true;
                }
              }

              _context7.next = 6;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('UpdateAccount', payload));

            case 6:
              response = _context7.sent;


              if (response.result) {
                text = loyaltyProduct ? 'Fee token successfully set' : 'Fee token successfully unset';

                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'UpdateAccountSuccess',
                  text: text,
                  type: 'success'
                }));
                dispatch(getUserAccounts(OMSId));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_redux_form__["e" /* change */])('loyaltyTokenForm', 'loyaltyToken', currentAccount.LoyaltyProductId));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'UpdateAccountError',
                  text: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_errorTextFormatter__["a" /* formatErrorText */])(response),
                  type: 'warning'
                }));
              }

            case 8:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function (_x9, _x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var selectAccount = function selectAccount(accountId, OMSId) {
  return function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch, getState) {
      var marginAccount, marginAccountId;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch(setAccount(accountId));

              if (__WEBPACK_IMPORTED_MODULE_23__config__["b" /* default */].global.privateMarketData) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__orderHistoryActions__["x" /* getOrders */])(accountId, OMSId));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__orderHistoryActions__["v" /* getOpenOrders */])(accountId, OMSId));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__orderHistoryActions__["u" /* getInactiveOrders */])(accountId, OMSId));
              }

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__orderHistoryActions__["t" /* getAccountTrades */])(accountId, OMSId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__orderHistoryActions__["w" /* getOpenTradeReports */])(accountId, OMSId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__depositActions__["q" /* getDepositTickets */])(accountId, OMSId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__withdrawActions__["q" /* getWithdrawTickets */])(accountId, OMSId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__withdrawActions__["r" /* subscribeToWithdrawalTickets */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__orderHistoryActions__["y" /* initOrderHistorySubscription */])(accountId, OMSId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__orderHistoryActions__["z" /* subscribeToOrderHistory */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__transferActions__["e" /* getTransfers */])(accountId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__transferActions__["d" /* getIncomingTransfers */])(OMSId, accountId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__transferRequestActions__["i" /* getTransferRequestsReceived */])(accountId, OMSId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__transferRequestActions__["j" /* getTransferRequestsRequested */])(accountId, OMSId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__marketStateUpdateActions__["a" /* initMarketTradeSubscription */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__marketStateUpdateActions__["b" /* subscribeToMarketTradeUpdated */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__eotcSettlementActions__["d" /* subscribeToAccountSettlements */])());
              __WEBPACK_IMPORTED_MODULE_22__services_subscriptions_AccountEventsSubscriptionService__["a" /* default */].subscribe(function (update) {
                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__kycActions__["i" /* updateAccount */])({
                  item: update,
                  index: getState().user.accounts.findIndex(function (i) {
                    return i.AccountId === accountId;
                  })
                }));
              });

              marginAccount = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_marginSelectors__["e" /* marginAccountSelector */])(getState());
              marginAccountId = marginAccount ? marginAccount.AccountId : null;


              if (accountId !== marginAccountId) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__positionActions__["g" /* subscribeToAccountPositionEvents */])(accountId));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__positionActions__["e" /* getAccountPositions */])({ accountId: accountId, OMSId: OMSId }));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__marginActions__["o" /* getMarginAccountState */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__marginActions__["t" /* subscribeToMarginAccountPositionEvents */])(accountId, __WEBPACK_IMPORTED_MODULE_18__marginActions__["r" /* receiveMarginAccountPositionEvent */]));
              }

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__depositActions__["r" /* subscribeToDeposits */])());

            case 21:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    }));

    return function (_x11, _x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};

var receiveAccount = function receiveAccount(payload) {
  return {
    type: RECEIVE_ACCOUNT,
    payload: payload
  };
};

var setAccount = function setAccount(payload) {
  return {
    type: SET_ACCOUNT,
    payload: payload
  };
};

var goToResetPasswordFormStep = function goToResetPasswordFormStep(step) {
  return function (dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_redux_form__["e" /* change */])('resetPasswordRequest', 'step', step));
  };
};

var goToBaseCurrencyFormStep = function goToBaseCurrencyFormStep(step) {
  return function (dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_redux_form__["e" /* change */])('baseCurrencies', 'step', step));
  };
};

var sendResetPasswordEmail = function sendResetPasswordEmail(UserName) {
  return function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch) {
      var Apex, response, snackbarPayload;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              Apex = void 0;
              _context9.prev = 1;

              Apex = Object(__WEBPACK_IMPORTED_MODULE_2__apex__["b" /* getApex */])();
              _context9.next = 8;
              break;

            case 5:
              _context9.prev = 5;
              _context9.t0 = _context9['catch'](1);
              return _context9.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                id: 'apexError',
                text: _context9.t0.message,
                type: 'warning'
              })));

            case 8:
              _context9.next = 10;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('ResetPassword', { UserName: UserName }));

            case 10:
              response = _context9.sent;
              snackbarPayload = response.result ? {
                id: 'sendResetPasswordEmailSuccess',
                // context.t('Check Your Email For Reset Password Link');
                text: 'Check Your Email For Reset Password Link',
                type: 'success'
              } : {
                id: 'sendResetPasswordEmailError',
                text: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_errorTextFormatter__["a" /* formatErrorText */])(response),
                type: 'warning'
              };


              dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])(snackbarPayload));
              setTimeout(function () {
                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__authActions__["j" /* logout */])());
              }, __WEBPACK_IMPORTED_MODULE_23__config__["b" /* default */].Snackbar.timeout);

            case 14:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this, [[1, 5]]);
    }));

    return function (_x13) {
      return _ref9.apply(this, arguments);
    };
  }();
};

var submitResetPasswordForm = function submitResetPasswordForm() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        user = _getState2.user;

    dispatch(sendResetPasswordEmail(user.userInfo.UserName));
  };
};

var setGoogleQrCode = function setGoogleQrCode(payload) {
  return {
    type: SET_GOOGLE_QRCODE,
    payload: payload
  };
};

var clearGoogleQrCode = function clearGoogleQrCode() {
  return {
    type: CLEAR_GOOGLE_QRCODE
  };
};

var getGoogleQrCode = function getGoogleQrCode() {
  return function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch) {
      var qrCode;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.EnableGoogle2FA();

            case 2:
              qrCode = _context10.sent;

              dispatch(setGoogleQrCode(qrCode));

            case 4:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this);
    }));

    return function (_x14) {
      return _ref10.apply(this, arguments);
    };
  }();
};

var disable2FA = function disable2FA(code) {
  return function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch, getState) {
      var userInfo, auth;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              userInfo = getState().user.userInfo;
              _context11.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.Disable2FA();

            case 3:
              _context11.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.Authenticate2FA({
                Code: code
              });

            case 5:
              auth = _context11.sent;


              if (auth.Authenticated) {
                dispatch(userInfoFetched(Object.assign({}, userInfo, { Use2FA: false })));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_9__modalActions__["b" /* MODAL_TYPES */].DISABLE_2FA));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'DISABLE_2FA_SUCCESS',
                  // context.t('Two Factor Authenticated is disabled')
                  text: 'Two-Factor Authenticated is disabled',
                  type: 'success'
                }));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'DISABLE_2FA_ERROR',
                  // context.t('Code Rejected')
                  text: 'Code Rejected',
                  type: 'warning'
                }));
              }

            case 7:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this);
    }));

    return function (_x15, _x16) {
      return _ref11.apply(this, arguments);
    };
  }();
};

var enable2FA = function enable2FA(code) {
  return function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatch, getState) {
      var userInfo, auth;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              userInfo = getState().user.userInfo;
              _context12.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.Authenticate2FA({
                Code: code
              });

            case 3:
              auth = _context12.sent;


              if (auth.Authenticated) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__authActions__["h" /* authSuccess */])(auth));
                dispatch(userInfoFetched(Object.assign({}, userInfo, { Use2FA: true })));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_9__modalActions__["b" /* MODAL_TYPES */].ENABLE_2FA));
                dispatch(clearGoogleQrCode());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'ENABLE_2FA_SUCCESS',
                  // context.t('Two Factor Authenticated is enabled')
                  text: 'Two-Factor Authenticated is enabled',
                  type: 'success'
                }));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'ENABLE_2FA_ERROR',
                  // context.t('Code Rejected')
                  text: 'Code Rejected',
                  type: 'warning'
                }));
              }

            case 5:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this);
    }));

    return function (_x17, _x18) {
      return _ref12.apply(this, arguments);
    };
  }();
};

var getGoogle2FARecoveryCode = function getGoogle2FARecoveryCode(code) {
  return function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatch) {
      var response, recoveryCode;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.RPCPromise('GetGoogle2FARecoveryKey', {
                Code: code
              });

            case 2:
              response = _context13.sent;
              recoveryCode = JSON.parse(response.o);


              if (recoveryCode.Authenticated) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_redux_form__["e" /* change */])('google2FARecoveryKeyModal', 'recoveryKey', recoveryCode.RecoveryKey));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                  id: 'RECOVERY_ERROR',
                  text: recoveryCode.errormsg,
                  type: 'warning'
                }));
              }

            case 5:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this);
    }));

    return function (_x19) {
      return _ref13.apply(this, arguments);
    };
  }();
};

var resendVerificationEmail = function resendVerificationEmail(payload) {
  return function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatch) {
      var Apex, response, snackbarPayload;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              Apex = void 0;
              _context14.prev = 1;

              Apex = Object(__WEBPACK_IMPORTED_MODULE_2__apex__["b" /* getApex */])();
              _context14.next = 8;
              break;

            case 5:
              _context14.prev = 5;
              _context14.t0 = _context14['catch'](1);
              return _context14.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                id: 'apexError',
                text: _context14.t0.message,
                type: 'warning'
              })));

            case 8:
              if (Apex.connection.ResendVerificationEmail) {
                _context14.next = 10;
                break;
              }

              return _context14.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])({
                id: 'resendVerificationEmailError',
                text: 'Feature Not Available.',
                type: 'warning'
              })));

            case 10:
              _context14.next = 12;
              return Apex.connection.ResendVerificationEmail(payload);

            case 12:
              response = _context14.sent;
              snackbarPayload = response.result ? {
                id: 'resendVerificationEmailSuccess',
                // context.t('Check Your Email For An Account Verification Email');
                text: 'Check Your Email For An Account Verification Email',
                type: 'success'
              } : {
                id: 'resendVerificationEmailError',
                text: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_errorTextFormatter__["a" /* formatErrorText */])(response),
                type: 'warning'
              };


              dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__snackbarActions__["e" /* showSnack */])(snackbarPayload));

            case 15:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this, [[1, 5]]);
    }));

    return function (_x20) {
      return _ref14.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseSubscriptionService = function () {
  function BaseSubscriptionService() {
    _classCallCheck(this, BaseSubscriptionService);

    this.subscription = null;
  }

  /**
   * 1) Tell server to subscribe to level1 data for passed `instrumentId`
   * 2) Get first portion of data
   */


  _createClass(BaseSubscriptionService, [{
    key: 'initSubscribtion',
    value: function initSubscribtion(instrumentId) {
      throw Error('not implemented');
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      throw Error('not implemented');
    }

    /**
     * Stop getting updates from server
     */

  }, {
    key: 'stop',
    value: function stop() {
      throw Error('not implemented');
    }

    /**
     * Stop getting updates from server for one instrument
     *
     */

  }, {
    key: 'stopOne',
    value: function stopOne(insrtumentId) {
      throw Error('not implemented');
    }

    /**
     * Remove listener
     */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      this.subscription = null;
    }

    /**
     * 1) Tell server to stop getting updates
     * 2) Remove listener
     */

  }, {
    key: 'stopAll',
    value: function stopAll() {
      this.unsubscribe();
      this.stop();
    }
  }]);

  return BaseSubscriptionService;
}();

/* harmony default export */ __webpack_exports__["a"] = (BaseSubscriptionService);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchingSelector; });
/* unused harmony export productPositionSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return productPositionAssetsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProductByIdSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fundedPositionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return unfundedPositionsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_positionFormatter__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__positionSelectors__ = __webpack_require__(52);




var productsSelector = function productsSelector(state) {
  return state.apexCore.product.products;
};
var assetsSelector = function assetsSelector(state) {
  return state.productManifest.manifest;
};

var fetchingSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.product;
}, function (state) {
  return state.apexCore.position;
}, function (state) {
  return state.productManifest;
}], function (product, position, manifest) {
  return product.fetching || position.fetching || manifest.fetching;
});

var productPositionSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([productsSelector, function (state) {
  return state.apexCore.product.decimalPlaces;
}, __WEBPACK_IMPORTED_MODULE_2__positionSelectors__["b" /* positionSelector */]], function (products, decimalPlaces, positions) {
  return products.map(function (product) {
    var position = positions[product.ProductId];

    if (!position) {
      return product;
    }

    var positionDecimals = decimalPlaces[product.Product];
    var formattedPosition = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_positionFormatter__["a" /* default */])(position, positionDecimals);

    return Object.assign({}, formattedPosition, product);
  });
});

var productPositionAssetsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([productPositionSelector, assetsSelector], function (products, assets) {
  return products.map(function (product) {
    var asset = assets[product.Product] || {
      iconFileName: product.Product + 'DEFAULT_ICON'
    };

    return Object.assign({}, product, asset);
  });
});

var getProductByIdSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([productPositionAssetsSelector, function (state, productId) {
  return productId;
}], function (products, productId) {
  return products.find(function (item) {
    return item.ProductId === productId;
  });
});

var fundedPositionsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(productPositionAssetsSelector, function (positions) {
  // productPositionsSelector replaces Amount 0 with '-'
  return positions.filter(function (position) {
    return position.Amount !== '-';
  });
});

var unfundedPositionsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(productPositionAssetsSelector, function (positions) {
  // productPositionsSelector replaces Amount 0 with '-'
  return positions.filter(function (position) {
    return position.Amount === '-';
  });
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMetadata = validateMetadata;
exports.getExtPrefix = getExtPrefix;
exports.getCountryCallingCode = getCountryCallingCode;
exports.isSupportedCountry = isSupportedCountry;
exports["default"] = void 0;

var _semverCompare = _interopRequireDefault(__webpack_require__(1341));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".
var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata =
/*#__PURE__*/
function () {
  function Metadata(metadata) {
    _classCallCheck(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

exports["default"] = Metadata;

var NumberingPlan =
/*#__PURE__*/
function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format =
/*#__PURE__*/
function () {
  function Format(format, metadata) {
    _classCallCheck(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type =
/*#__PURE__*/
function () {
  function Type(type, metadata) {
    _classCallCheck(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var is_object = function is_object(_) {
  return _typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return _typeof(_);
};
/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */


function getExtPrefix(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).ext();
  }

  return DEFAULT_EXT_PREFIX;
}
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */


function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}

function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if ((0, _semverCompare["default"])(version, V3) === -1) {
      this.v2 = true;
    } else if ((0, _semverCompare["default"])(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }
//# sourceMappingURL=metadata.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1460)
var ieee754 = __webpack_require__(1461)
var isArray = __webpack_require__(1462)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APSelect_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__APSelect__ = __webpack_require__(111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__APSelect__["a"]; });




/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__APSelect_js__["b" /* default */]);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return marketPriceOfSelectedInstrumentSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isBuySideBuySellFormSelector; });
/* unused harmony export getPriceDataForPricesSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceDataForPresetValuesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPriceDataForPresetAndCustomValuesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPriceDataForQuantitiesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getQuantityDataForPresetValuesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getQuantityDataForPresetAndCustomValuesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOrderFormInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return tradingDisabledSelector; });
/* unused harmony export noBalanceSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Retail_RetailBuySell_BuySell_BuySellLayoutTypes__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);













var marketPriceOfSelectedInstrumentSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], function (state) {
  return state.apexCore.level1;
}, function (state, options) {
  return options;
}], function (instrument, level1, options) {
  var side = options.side,
      formatToLocale = options.formatToLocale;

  var formatToLocaleOption = formatToLocale === undefined || formatToLocale;
  var l1 = instrument ? level1[instrument.InstrumentId] : null;

  var marketPrice = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__["a" /* getMarketPrice */])(side, instrument, l1, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement));

  if (instrument && formatToLocaleOption) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["b" /* formatNumberToLocale */])(marketPrice, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement));
  }

  return marketPrice;
});

var isBuySideBuySellFormSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.form.buySell;
}], function (formObj) {
  return formObj ? formObj.values.side === __WEBPACK_IMPORTED_MODULE_8__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] : true;
});

/**
 * accept array of prices values and return price, quantity, limitPrice and pricePerUnit for them
 */
var getPriceDataForPricesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.level2;
}, function (state) {
  return state.apexCore.product;
}, function (state, side) {
  return side;
}, function (state, side, prices) {
  return prices;
}, __WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */]], function (level2, product, side, prices, selectedInstrument) {
  var decimalPlaces = product.decimalPlaces;
  var _config$OrderCalcBuff = __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].OrderCalcBuffer;
  _config$OrderCalcBuff = _config$OrderCalcBuff === undefined ? {} : _config$OrderCalcBuff;
  var quantityBuffer = _config$OrderCalcBuff.quantityBuffer;

  var orders = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__["h" /* getOrdersBySide */])(side, level2);

  return prices.map(function (price) {
    var _getQuantityForPrice = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__["j" /* getQuantityForPrice */])(price, quantityBuffer, orders, false, side),
        Quantity = _getQuantityForPrice.Quantity,
        LimitPrice = _getQuantityForPrice.LimitPrice;

    var quantity = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["i" /* truncateToDecimals */])(Quantity, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement)).toNumber();
    var pricePerUnit = quantity > 0 ? Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["i" /* truncateToDecimals */])(price / quantity, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)).toNumber() : null;

    return {
      price: price,
      quantity: quantity,
      limitPrice: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["i" /* truncateToDecimals */])(LimitPrice, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)).toNumber(),
      pricePerUnit: pricePerUnit
    };
  });
});

/**
 * return array of object of format {price, quantity, limitPrice and pricePerUnit} for preset values
 */
var getPriceDataForPresetValuesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, function (state, buySell) {
  return buySell;
}, __WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */]], function (state, side, selectedInstrument) {
  var dealPrices = __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].RetailBuySell.dealPrices;


  var prices = dealPrices[selectedInstrument.Symbol];

  if (!prices) {
    prices = dealPrices['DEFAULT'];
  }

  return getPriceDataForPricesSelector(state, side, prices);
});

/**
 * return array of object of format {price, quantity, limitPrice and pricePerUnit}
 * for preset values and custom row
 */
var getPriceDataForPresetAndCustomValuesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, function (state, buySell) {
  return buySell;
}, function (state, buySell, customPrice) {
  return customPrice;
}, __WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */]], function (state, side, customPrice, selectedInstrument) {
  var dealPrices = __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].RetailBuySell.dealPrices;


  var prices = dealPrices[selectedInstrument.Symbol];

  if (!prices) {
    prices = dealPrices['DEFAULT'];
  }

  var totalPrices = [customPrice].concat(prices);

  return getPriceDataForPricesSelector(state, side, totalPrices);
});

/**
 * accept array of quantity values and return quantity, price, limitPrice and pricePerUnit for them
 */
var getPriceDataForQuantitiesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.level2;
}, function (state) {
  return state.apexCore.product;
}, function (state, side) {
  return side;
}, function (state, side, quantities) {
  return quantities;
}, __WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */]], function (level2, product, side, quantities, selectedInstrument) {
  var decimalPlaces = product.decimalPlaces;
  var _config$OrderCalcBuff2 = __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].OrderCalcBuffer;
  _config$OrderCalcBuff2 = _config$OrderCalcBuff2 === undefined ? {} : _config$OrderCalcBuff2;
  var priceBuffer = _config$OrderCalcBuff2.priceBuffer;

  var orders = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__["h" /* getOrdersBySide */])(side, level2);

  return quantities.map(function (quantity) {
    var _getPriceForQuantity = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__["i" /* getPriceForQuantity */])(quantity, priceBuffer, orders, false, side),
        Price = _getPriceForQuantity.Price,
        LimitPrice = _getPriceForQuantity.LimitPrice;

    var price = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["i" /* truncateToDecimals */])(Price, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement)).toNumber();

    var pricePerUnit = price / quantity;
    pricePerUnit = quantity > 0 && pricePerUnit ? Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["b" /* formatNumberToLocale */])(pricePerUnit, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)).toString() : null;

    return {
      price: price,
      quantity: quantity,
      limitPrice: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["i" /* truncateToDecimals */])(LimitPrice, Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)).toNumber(),
      pricePerUnit: pricePerUnit
    };
  });
});

/**
 * return array of object of format {quantity, price, limitPrice and pricePerUnit} for preset values
 */
var getQuantityDataForPresetValuesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, function (state, buySell) {
  return buySell;
}, __WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */]], function (state, side, selectedInstrument) {
  var dealQuantities = __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].RetailBuySell.dealPrices;


  var quantities = dealQuantities[selectedInstrument.Symbol];

  if (!quantities) {
    return [];
  }

  return getPriceDataForQuantitiesSelector(state, side, quantities);
});

/**
 * return array of object of format {quantity, price, limitPrice and pricePerUnit}
 * for preset values and custom row
 */
var getQuantityDataForPresetAndCustomValuesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, function (state, buySell) {
  return buySell;
}, function (state, buySell, customQuantity) {
  return customQuantity;
}, __WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */]], function (state, side, customQuantity, selectedInstrument) {
  var dealQuantities = __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].RetailBuySell.dealPrices;


  var quantities = dealQuantities[selectedInstrument.Symbol];

  if (!quantities) {
    return [];
  }

  var totalQuantities = [customQuantity].concat(quantities);

  return getPriceDataForQuantitiesSelector(state, side, totalQuantities);
});

// responsible to return price, quantity, limitPrice, pricePerUnit
// from current state of buySell form depending on layoutType,
// what is selected (custom radio section or initally set values)
var getOrderFormInfoSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, function (state) {
  return state.form.buySell || { values: {} };
}], function (state, form) {
  var _form$values = form.values,
      side = _form$values.side,
      amountRadio = _form$values.amountRadio;

  var isPricePerUnitLayoutType = form.values.layoutType === __WEBPACK_IMPORTED_MODULE_7__components_Retail_RetailBuySell_BuySell_BuySellLayoutTypes__["a" /* BUY_SELL_LAYOUTS */].PRICE_PER_UNIT;

  var fieldToSearch = isPricePerUnitLayoutType ? 'quantity' : 'price';
  var value = amountRadio === 'custom' ? form.values[fieldToSearch] : amountRadio;
  var dealValues = isPricePerUnitLayoutType ? getQuantityDataForPresetAndCustomValuesSelector(state, side, value) : getPriceDataForPresetAndCustomValuesSelector(state, side, value);

  return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__["l" /* getValuesFromDealValues */])(dealValues, value, fieldToSearch);
});

var tradingDisabledSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}], function (state) {
  return Object(__WEBPACK_IMPORTED_MODULE_6__selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state).disableTrading;
});

var noBalanceSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, function (state) {
  return isBuySideBuySellFormSelector(state);
}, function (state) {
  return state.form.buySell || { values: {} };
}], function (state, isBuySide, form) {
  var selector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('buySell');

  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var product1 = Object(__WEBPACK_IMPORTED_MODULE_10__productPositionSelectors__["c" /* getProductByIdSelector */])(state, selectedInstrument.Product1);
  var product2 = Object(__WEBPACK_IMPORTED_MODULE_10__productPositionSelectors__["c" /* getProductByIdSelector */])(state, selectedInstrument.Product2);

  var selectedValue = getOrderFormInfoSelector(state);

  var activeAmount = selector(state, 'amountRadio');
  var price = activeAmount === 'custom' ? form.values.price : +activeAmount;
  var quantity = selectedValue.quantity;

  var negativeIsNaN = false;

  return isBuySide ? Object(__WEBPACK_IMPORTED_MODULE_4__helpers_productHelper__["a" /* getAvailableProductBalance */])(product2, negativeIsNaN) < price : Object(__WEBPACK_IMPORTED_MODULE_4__helpers_productHelper__["a" /* getAvailableProductBalance */])(product1, negativeIsNaN) < quantity;
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Pagination_PaginationContainer__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_layout_Table_css__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_layout_Table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_layout_Table_css__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var filterInvalid = function filterInvalid() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var selectedInstrument = _ref.selectedInstrument,
      rowIndex = _ref.rowIndex,
      rest = _objectWithoutProperties(_ref, ['selectedInstrument', 'rowIndex']);

  return rest;
};

var APTable = function APTable(props, context) {
  var title = props.title,
      columns = props.columns,
      baseClass = props.baseClass,
      rows = props.rows,
      empty = props.empty,
      onRowClicked = props.onRowClicked,
      fetching = props.fetching,
      headerOutside = props.headerOutside,
      pageSize = props.pageSize,
      minRow = props.minRow,
      alwaysShowPagination = props.alwaysShowPagination,
      rowProps = props.rowProps,
      selectedRow = props.selectedRow,
      componentName = props.componentName,
      usePagination = props.usePagination,
      showOnlyActivePage = props.showOnlyActivePage;


  var flexTable = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('flex-table');
  var customClass = baseClass || function () {
    return '';
  };

  var header = columns.map(function (col, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        'data-test': col.dataTest,
        key: index,
        title: col.title || undefined,
        className: flexTable('column') + ' ' + customClass('header-column', col.classModifier) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: flexTable('header-cell', headerOutside ? 'absolute' : 'fixed') + ' ' + customClass('fixed', col.classModifier) },
        col.header
      )
    );
  });

  var emptyRow = function emptyRow() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: flexTable('row', 'empty') + ' ' + customClass('row-empty') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: flexTable('column', 'empty') + ' ' + customClass('column-empty') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__APIcon__["a" /* default */], {
          name: 'stop',
          customClass: flexTable('empty-icon') + ' ' + customClass('empty-icon')
        }),
        empty
      )
    );
  };

  var getTableRows = function getTableRows(data) {
    return data && data.length && data[0] === undefined ? data.map(function (row, rowIndex) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          key: rowIndex,
          className: flexTable('row', 'no-hover') + ' ' + customClass('row') },
        rowIndex === 0 && emptyRow()
      );
    }) : data.map(function (row, rowIndex) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        Object.assign({}, row && filterInvalid(rowProps(row, rowIndex)), {
          onClick: function onClick() {
            return row && onRowClicked && onRowClicked(row);
          },
          key: rowIndex,
          className: flexTable('row', !row && 'no-hover') + ' ' + customClass('row', selectedRow.key && selectedRow.value === row[selectedRow.key] ? 'selected' : '') }),
        row && columns.map(function (col, colIndex) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: col.style,
              key: col.accessor || colIndex,
              className: flexTable('column') + ' ' + customClass('column', col.classModifier) },
            col.cell ? col.cell(row, rowProps(row, rowIndex)) : row[col.accessor]
          );
        })
      );
    });
  };
  var renderTable = function renderTable(data, containerClasses) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: flexTable('wide-row-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: flexTable() + ' ' + customClass() + ' ' + containerClasses },
        title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: flexTable('title') + ' ' + customClass('table-title') },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: flexTable('header', 'background') + ' ' + customClass('table-header', 'background')
        }),
        headerOutside && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: flexTable('header') + ' ' + customClass('table-header', baseClass.classModifier) },
          header
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: flexTable('body') + ' ' + customClass('body') },
          !headerOutside && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: flexTable('header', 'inside') + ' ' + customClass('table-header', baseClass.classModifier) },
            header
          ),
          fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Spinner_Spinner__["a" /* default */], { text: context.t('Loading...'), customClass: baseClass }) : data.length === 0 ? emptyRow() : getTableRows(data)
        )
      )
    );
  };

  var getMinimumOf = function getMinimumOf(data, min) {
    var emptyRows = min - data.length;
    return minRow && min && emptyRows > 0 ? [].concat(_toConsumableArray(data), _toConsumableArray(new Array(Math.min(minRow || emptyRows, emptyRows)))) : data;
  };

  var renderTableWithPagination = function renderTableWithPagination(totalPages, data) {
    var containerClasses = customClass('body', 'multipage');
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Pagination_PaginationContainer__["a" /* default */], {
      totalPages: totalPages,
      containerClassName: flexTable('pagination-container'),
      content: function content(page) {
        var rows = data.slice(pageSize * page, pageSize * (page + 1));
        return renderTable(getMinimumOf(rows, minRow || pageSize), containerClasses);
      },
      componentName: componentName,
      customClass: baseClass(),
      showOnlyActivePage: showOnlyActivePage
    });
  };

  var totalPages = Math.ceil(rows.length / pageSize || rows.length);
  var containerClasses = customClass('body', 'single-page');

  return usePagination && (alwaysShowPagination || pageSize && totalPages > 1) ? renderTableWithPagination(totalPages, rows) : renderTable(getMinimumOf(rows, minRow || pageSize), containerClasses);
};

APTable.propTypes = {
  columns: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    accessor: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    header: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    cell: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    classModifier: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })).isRequired,
  rows: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,
  rowProps: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  empty: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  onRowClicked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  baseClass: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  fetching: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  minRow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  pageSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  alwaysShowPagination: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  selectedRow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  usePagination: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

APTable.defaultProps = {
  headerOutside: true,
  rowProps: function rowProps(row, rowIndex) {
    return { rowIndex: rowIndex };
  },
  selectedRow: {
    key: '',
    value: ''
  },
  usePagination: true
};

APTable.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (APTable);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(82);
var isObject_1 = __webpack_require__(670);
var isFunction_1 = __webpack_require__(268);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var UnsubscriptionError_1 = __webpack_require__(671);
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return placeOrderWithChecks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return placeOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buyPriceClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buyQuantityClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sellPriceClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sellQuantityClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearOrderForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearBuySellForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return showBuySellSuccessMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return showBuySellFailMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return synchronizeQuantityWithPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return synchronizePriceWithQuantity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bignumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_placeOrderHelper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors_level2Selectors__ = __webpack_require__(311);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }















var placeOrderWithChecks = function placeOrderWithChecks(orderFormType, form) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var _getState, apexCore, level1, instrument, limitPrice, marketPrice;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), apexCore = _getState.apexCore;
              level1 = apexCore.level1, instrument = apexCore.instrument;

              if (!(form.orderType === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName && form.side === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */])) {
                _context.next = 7;
                break;
              }

              limitPrice = new __WEBPACK_IMPORTED_MODULE_3_bignumber_js___default.a(form.limitPrice);
              marketPrice = new __WEBPACK_IMPORTED_MODULE_3_bignumber_js___default.a(level1[instrument.selectedInstrumentId.toString()].BestOffer);

              if (!limitPrice.lt(marketPrice)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_6__modalActions__["b" /* MODAL_TYPES */].SUBMIT_LIMIT_ORDER, { orderFormType: orderFormType })));

            case 7:
              return _context.abrupt('return', dispatch(placeOrder(orderFormType, form)));

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var placeOrder = function placeOrder(orderFormType, form) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      useNewForm = _ref2.useNewForm;

  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var state, selectedAccountId, _getState2, userInfo, _getState2$apexCore, product, level1, level2, selectedInstrument, priceDecimalPlaces, quantityDecimalPlaces, options, response;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              selectedAccountId = Object(__WEBPACK_IMPORTED_MODULE_10__selectors_marginSelectors__["a" /* accountIdSelector */])(state);
              _getState2 = getState(), userInfo = _getState2.user.userInfo, _getState2$apexCore = _getState2.apexCore, product = _getState2$apexCore.product, level1 = _getState2$apexCore.level1, level2 = _getState2$apexCore.level2;
              selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(getState());
              priceDecimalPlaces = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement);
              quantityDecimalPlaces = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement);
              options = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_placeOrderHelper__["a" /* getFormValuesForSubmittingOrder */])(orderFormType, {
                state: getState(),
                decimalPlaces: product.decimalPlaces,
                instrument: { selectedInstrumentId: selectedInstrument.InstrumentId },
                form: form,
                userInfo: userInfo,
                selectedAccountId: selectedAccountId,
                priceDecimalPlaces: priceDecimalPlaces,
                quantityDecimalPlaces: quantityDecimalPlaces,
                level1: level1,
                level2: level2,
                useNewForm: useNewForm
              });
              response = void 0;

              if (!(orderFormType === __WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].block)) {
                _context2.next = 14;
                break;
              }

              _context2.next = 11;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('SubmitBlockTrade', options));

            case 11:
              response = _context2.sent;
              _context2.next = 17;
              break;

            case 14:
              _context2.next = 16;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('SendOrder', options));

            case 16:
              response = _context2.sent;

            case 17:
              return _context2.abrupt('return', response);

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var buyPriceClicked = function buyPriceClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var price = e.currentTarget.dataset.price;

    var state = getState();
    var selectedOrderType = state.form.orderEntry.values.orderType;
    var isStopOrder = selectedOrderType === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName;

    var _selectedInstrumentSe = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
        PriceIncrement = _selectedInstrumentSe.PriceIncrement;

    var convertedPriceIncrement = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement);

    if (!isStopOrder) {
      dispatch(checkAndSwitchToLimitOrderType());
    }
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'side', __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */]));
    dispatch(clearFeeAndTotalAmountValues('orderEntry'));

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', isStopOrder ? 'stopPrice' : 'limitPrice', Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["i" /* truncateToDecimals */])(parseFloat(price), convertedPriceIncrement)));
  };
};

var buyQuantityClicked = function buyQuantityClicked(e) {
  return function (dispatch, getState) {
    e.persist();

    var _e$currentTarget$data = e.currentTarget.dataset,
        quantity = _e$currentTarget$data.quantity,
        index = _e$currentTarget$data.index;

    dispatch(clearFeeAndTotalAmountValues('orderEntry'));
    var state = getState();
    var buy = Object(__WEBPACK_IMPORTED_MODULE_13__selectors_level2Selectors__["a" /* level2BuySelector */])(state, { filterMode: 'selectedInstrumentId' });

    var _selectedInstrumentSe2 = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
        QuantityIncrement = _selectedInstrumentSe2.QuantityIncrement;

    var convertedQuantityIncrement = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(QuantityIncrement);
    var overallQuantity = calculateQuantity(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["i" /* truncateToDecimals */])(quantity, convertedQuantityIncrement), buy, index);
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'quantity', overallQuantity));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'side', __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */]));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'orderType', __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].market.displayName));
  };
};

var sellPriceClicked = function sellPriceClicked(e) {
  return function (dispatch, getState) {
    e.persist();
    var price = e.currentTarget.dataset.price;

    var state = getState();
    var selectedOrderType = state.form.orderEntry.values.orderType;
    var isStopOrder = selectedOrderType === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName;

    dispatch(clearFeeAndTotalAmountValues('orderEntry'));

    if (!isStopOrder) {
      dispatch(checkAndSwitchToLimitOrderType());
    }

    var _selectedInstrumentSe3 = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
        PriceIncrement = _selectedInstrumentSe3.PriceIncrement;

    var convertedPriceIncrement = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement);

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', isStopOrder ? 'stopPrice' : 'limitPrice', Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["i" /* truncateToDecimals */])(parseFloat(price), convertedPriceIncrement)));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'side', __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]));
  };
};

var sellQuantityClicked = function sellQuantityClicked(e) {
  return function (dispatch, getState) {
    e.persist();

    var _e$currentTarget$data2 = e.currentTarget.dataset,
        quantity = _e$currentTarget$data2.quantity,
        index = _e$currentTarget$data2.index;

    dispatch(clearFeeAndTotalAmountValues('orderEntry'));

    var state = getState();
    var sell = Object(__WEBPACK_IMPORTED_MODULE_13__selectors_level2Selectors__["c" /* level2SellSelector */])(state, {
      filterMode: 'selectedInstrumentId'
    });

    var _selectedInstrumentSe4 = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
        QuantityIncrement = _selectedInstrumentSe4.QuantityIncrement;

    var convertedQuantityIncrement = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(QuantityIncrement);
    var overallQuantity = calculateQuantity(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["i" /* truncateToDecimals */])(quantity, convertedQuantityIncrement), sell, index, false);
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'quantity', overallQuantity));

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'side', __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'orderType', __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].market.displayName));
  };
};

var clearOrderForm = function clearOrderForm(formName) {
  return function (dispatch) {
    dispatch(clearFeeAndTotalAmountValues(formName));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["k" /* reset */])(formName));
  };
};

var clearBuySellForm = function clearBuySellForm() {
  return function (dispatch) {
    var form = 'buySell';
    dispatch(clearField(form, 'quantity', ''));
    dispatch(clearField(form, 'price', ''));
    dispatch(clearField(form, 'amountRadio', 'custom'));
    dispatch(clearField(form, 'limitPrice', ''));
    dispatch(clearField(form, 'fee', '0'));
    dispatch(clearField(form, 'responseMessage', ''));
  };
};

var showBuySellSuccessMessage = function showBuySellSuccessMessage() {
  return function (dispatch) {
    // context.t('Your order was filled successfully!')
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('buySell', 'responseMessage', 'Your order was filled successfully!'));
  };
};

var showBuySellFailMessage = function showBuySellFailMessage() {
  return function (dispatch) {
    // context.t('Your order failed, please try again')
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('buySell', 'responseMessage', 'Your order failed, please try again'));
  };
};

var synchronizeQuantityWithPrice = function synchronizeQuantityWithPrice(price, form, field, formObj) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        _getState3$apexCore = _getState3.apexCore,
        level2 = _getState3$apexCore.level2,
        decimalPlaces = _getState3$apexCore.product.decimalPlaces;

    var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(getState());
    var quantity = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper__["p" /* syncQuantityWithPrice */])(price, {
      level2: level2,
      selectedInstrument: selectedInstrument,
      side: formObj.values.side,
      decimalPlaces: decimalPlaces
    });
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(form, field, quantity));
  };
};

var synchronizePriceWithQuantity = function synchronizePriceWithQuantity(quantity, form, field, formObj) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        _getState4$apexCore = _getState4.apexCore,
        level2 = _getState4$apexCore.level2,
        decimalPlaces = _getState4$apexCore.product.decimalPlaces;

    var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_9__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(getState());
    var price = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper__["o" /* syncPriceWithQuantity */])(quantity, {
      level2: level2,
      selectedInstrument: selectedInstrument,
      side: formObj.values.side,
      decimalPlaces: decimalPlaces
    });
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(form, field, price));
  };
};

var calculateQuantity = function calculateQuantity(initValue, orders, quantityIndex) {
  var buy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var init = new __WEBPACK_IMPORTED_MODULE_3_bignumber_js___default.a(initValue);

  var quantity = orders.filter(function (data, index) {
    return buy ? index < quantityIndex : index > quantityIndex;
  }).reduce(function (prev, current) {
    return prev.plus(current.Quantity);
  }, init);

  return quantity.toString();
};

/**
 * Switch order type to 'Limit' if 'Market' is selected before
 */
var checkAndSwitchToLimitOrderType = function checkAndSwitchToLimitOrderType() {
  return function (dispatch, getState) {
    var selectedOrderType = getState().form.orderEntry.values.orderType;

    if (selectedOrderType === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].market.displayName) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('orderEntry', 'orderType', __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName));
    }
  };
};

var clearFeeAndTotalAmountValues = function clearFeeAndTotalAmountValues(form) {
  return function (dispatch) {
    dispatch(clearField(form, 'fee', '0'));
    dispatch(clearField(form, 'totalAmount', '0'));
  };
};

var clearField = function clearField(form, field, initialValue) {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(form, field, initialValue));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["l" /* untouch */])(form, field));
  };
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Metadata; });
/* unused harmony export validateMetadata */
/* harmony export (immutable) */ __webpack_exports__["c"] = getExtPrefix;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCountryCallingCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSupportedCountry;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_semver_compare__ = __webpack_require__(1398);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

 // Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".

var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata =
/*#__PURE__*/
function () {
  function Metadata(metadata) {
    _classCallCheck(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();



var NumberingPlan =
/*#__PURE__*/
function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format =
/*#__PURE__*/
function () {
  function Format(format, metadata) {
    _classCallCheck(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type =
/*#__PURE__*/
function () {
  function Type(type, metadata) {
    _classCallCheck(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return _typeof(_);
};
/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */


function getExtPrefix(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).ext();
  }

  return DEFAULT_EXT_PREFIX;
}
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__tools_semver_compare__["a" /* default */])(version, V3) === -1) {
      this.v2 = true;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__tools_semver_compare__["a" /* default */])(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }
//# sourceMappingURL=metadata.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var Subscriber_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(46);
var ObjectUnsubscribedError_1 = __webpack_require__(271);
var SubjectSubscription_1 = __webpack_require__(673);
var rxSubscriber_1 = __webpack_require__(269);
/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}(Subscriber_1.Subscriber));
exports.SubjectSubscriber = SubjectSubscriber;
/**
 * @class Subject<T>
 */
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable_1.Observable));
exports.Subject = Subject;
/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription_1.Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));
exports.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductIcon__ = __webpack_require__(1446);



var mapStateToProps = function mapStateToProps(state, ownProps) {
  var productManifest = state.productManifest;
  var iconFileName = ownProps.iconFileName;
  var size = ownProps.size || 48;

  return { productManifest: productManifest, iconFileName: iconFileName, size: size };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ProductIcon__["a" /* default */]));

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return positionSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return positionByProductIdSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);



var positionSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.user;
}, function (state) {
  return state.apexCore.position;
}], function (_ref, _ref2) {
  var selectedAccountId = _ref.selectedAccountId;
  var positions = _ref2.positions;
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(positions, selectedAccountId, {});
});

var positionByProductIdSelector = function positionByProductIdSelector(productId) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(positionSelector, function (positions) {
    if (productId) {
      return positions[productId];
    }

    return {};
  });
};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return kycVerificationLevelsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kycLevelFormSelector; });
/* unused harmony export kycLevelFormSelectorCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_verificationRequiredHelper__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_arrayHelper__ = __webpack_require__(88);






var kycVerificationLevelsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.user.selectedAccountId;
}, function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.userConfig;
}], function (AccountId, accounts, userConfig) {
  var _ref = accounts.find(function (account) {
    return account.AccountId === AccountId;
  }) || {},
      verificationLevel = _ref.VerificationLevel;

  var kycConfig = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */], 'KYC', {});

  var levelIncreaseStatus = (userConfig.find(function (config) {
    return config.Key === 'levelIncreaseStatus';
  }) || {}).Value;

  levelIncreaseStatus = kycConfig.type === 'Manual' ? Number(levelIncreaseStatus) : levelIncreaseStatus;

  var _getVerifiedToTradeSt = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_verificationRequiredHelper__["a" /* getVerifiedToTradeStatus */])(verificationLevel, levelIncreaseStatus),
      isUnderReview = _getVerifiedToTradeSt.isUnderReview,
      disableTrading = _getVerifiedToTradeSt.disableTrading;

  var disableWithdraw = verificationLevel < __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].Withdraw.MinimumVerificationLevel;
  var disableDeposit = verificationLevel < __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].Deposit.MinimumVerificationLevel;

  return {
    kycConfig: kycConfig,
    levelIncreaseStatus: levelIncreaseStatus,
    verificationLevel: verificationLevel,
    disableTrading: disableTrading,
    isUnderReview: isUnderReview,
    disableWithdraw: disableWithdraw,
    disableDeposit: disableDeposit
  };
});

var kycLevelFormSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apiProcessing;
}, function (state) {
  return state.user.userInfo;
}, function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.userConfig;
}, function (state) {
  return state.user.kyc;
}, function (state) {
  return state.auth.token;
}], kycLevelFormSelectorCallback);

function kycLevelFormSelectorCallback(apiProcessing, userInfo, accounts, userConfig, kyc, token) {
  var AccountId = userInfo.AccountId,
      UserId = userInfo.UserId,
      userName = userInfo.UserName,
      email = userInfo.Email;

  var levelIncreaseStatus = (userConfig.filter(function (config) {
    return config.Key === 'levelIncreaseStatus';
  })[0] || {}).Value;

  var _ref2 = accounts.filter(function (account) {
    return account.AccountId === AccountId;
  })[0] || {},
      verificationLevel = _ref2.VerificationLevel;

  var kycConfig = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */], 'KYC', {});
  var processing = kycConfig.type === 'Manual' ? apiProcessing.processingSetUserConfig : apiProcessing.processingValidateUserRegistration;
  var levelIncreaseStatusIndex = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_arrayHelper__["b" /* findIndexOfObject */])(userConfig, 'Key', 'levelIncreaseStatus');

  return {
    alphaPointSessiontoken: token,
    alphaPointUserID: UserId + '',
    userConfig: userConfig,
    userName: userName,
    email: email,
    verificationLevel: verificationLevel,
    levelIncreaseStatus: levelIncreaseStatus,
    kycConfig: kycConfig,
    kyc: kyc,
    processing: processing,
    levelIncreaseStatusIndex: levelIncreaseStatusIndex
  };
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__(50);
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return styleNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styleNamePropType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var styleNames = {
  general: 'general',
  additive: 'additive',
  subtractive: 'subtractive'
};

var styleNamePropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([styleNames.general, styleNames.additive, styleNames.subtractive]);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
exports.root = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REQUEST_MARGIN_ACCOUNT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_MARGIN_ACCOUNT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_MARGIN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return enableMargin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return disableMargin; });
/* unused harmony export getMarginInstruments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createMarginRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return disableMarginRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getMarginAccountState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getMarginStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_MARGIN_ACCT_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return receiveMarginAccountPositionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return subscribeToMarginAccountPositionEvents; });
/* unused harmony export subscribeToMarginAccountState */
/* unused harmony export requestMarginAccountState */
/* unused harmony export receiveMarginAccountState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REQUEST_MARGIN_INSTRUMENTS; });
/* unused harmony export requestMarginInstruments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_MARGIN_INSTRUMENTS; });
/* unused harmony export receiveMarginInstruments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_MARGIN_INSTRUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setMarginInstrument; });
/* unused harmony export receiveMarginStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return activateMarginTradingStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deactivateMarginTradingStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_MARGIN_SETTINGS; });
/* unused harmony export receiveMarginSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getMarginSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_subscriptions_AccountEventsSubscriptionService__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_subscriptions_marginAccountStateSubscriptionService__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_subscriptions_marginAccountPositionEventSubscriptionService__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__marginHistoryActions__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__marginProductActions__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_tradingStyleConstants__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__orderHistoryActions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__transferActions__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__transferRequestActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__marketStateUpdateActions__ = __webpack_require__(503);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

















var REQUEST_MARGIN_ACCOUNT_STATE = 'REQUEST_MARGIN_ACCOUNT_STATE';
var RECEIVE_MARGIN_ACCOUNT_STATE = 'RECEIVE_MARGIN_ACCOUNT_STATE';
var RECEIVE_MARGIN_STATUS = 'RECEIVE_MARGIN_STATUS';

var subscribeAccountEvents = function subscribeAccountEvents(AccountId, OMSId) {
  return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            __WEBPACK_IMPORTED_MODULE_5__services_subscriptions_AccountEventsSubscriptionService__["a" /* default */].initSubscription({ AccountId: AccountId, OMSId: OMSId });

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));
};

var enableMargin = function enableMargin() {
  return function (dispatch, getState) {
    var state = getState();
    var OMSId = 1;
    var marginAccount = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_marginSelectors__["e" /* marginAccountSelector */])(state);
    if (marginAccount) {
      localStorage.setItem('tradingStyle', 'Margin');
      var AccountId = marginAccount.AccountId;


      dispatch(getMarginSettings(OMSId));
      dispatch(getMarginAccountState());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__marginProductActions__["d" /* getMarginProducts */])(AccountId, OMSId));
      dispatch(getMarginInstruments(OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__marginHistoryActions__["o" /* getOpenPositions */])(AccountId, OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__marginHistoryActions__["m" /* getClosedPositions */])(AccountId, OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__marginHistoryActions__["n" /* getMarginPositionPayments */])(AccountId, OMSId));

      // Below is duplicated from userActions.selectAccount.
      // However, it does not update state.user.selectedAccountId.
      // So it does not break wallets page.
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__orderHistoryActions__["v" /* getOpenOrders */])(AccountId, OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__orderHistoryActions__["t" /* getAccountTrades */])(AccountId, OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__orderHistoryActions__["w" /* getOpenTradeReports */])(AccountId, OMSId));

      dispatch(subscribeAccountEvents(AccountId, OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__orderHistoryActions__["z" /* subscribeToOrderHistory */])());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__marginHistoryActions__["q" /* subscribeToMarginPositionStates */])(AccountId, OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__marginProductActions__["e" /* subscribeToMarginAccountProducts */])(AccountId, OMSId));
      dispatch(subscribeToMarginAccountState());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__marginHistoryActions__["p" /* subscribeToMarginPositionPayments */])());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__marketStateUpdateActions__["b" /* subscribeToMarketTradeUpdated */])());
      dispatch(subscribeToMarginAccountPositionEvents(AccountId));

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__transferActions__["e" /* getTransfers */])(AccountId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__transferActions__["d" /* getIncomingTransfers */])(OMSId, AccountId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__transferRequestActions__["i" /* getTransferRequestsReceived */])(AccountId, OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__transferRequestActions__["j" /* getTransferRequestsRequested */])(AccountId, OMSId));
    }
  };
};

var disableMargin = function disableMargin() {
  return function (dispatch, getState) {
    localStorage.setItem('tradingStyle', null);

    var state = getState();
    var OMSId = 1;
    var defaultAccountId = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_marginSelectors__["b" /* defaultAccountSelector */])(state).AccountId;

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__userActions__["p" /* selectAccount */])(defaultAccountId, OMSId));
  };
};

var getMarginInstruments = function getMarginInstruments(OMSId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var selectedInstrumentId, instruments;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
              _context2.prev = 1;

              dispatch(requestMarginInstruments());

              _context2.next = 5;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('GetMarginEnabledInstruments', {
                OMSId: OMSId
              }));

            case 5:
              instruments = _context2.sent;


              dispatch(receiveMarginInstruments({
                instruments: instruments,
                selectedInstrumentId: selectedInstrumentId
              }));
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](1);

              console.error('GetMarginInstruments error: ', _context2.t0);

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[1, 9]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var createMarginRequest = function createMarginRequest() {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch) {
      var OMSId, responseObj;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              OMSId = 1;
              _context3.prev = 1;
              _context3.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('CreateMarginBorrowerAccountRequest', {
                OMSId: OMSId
              }));

            case 4:
              responseObj = _context3.sent;

              if (!responseObj.result) {
                _context3.next = 10;
                break;
              }

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'createMarginRequestSuccess',
                text: responseObj.detail || 'Successful Margin Account Request',
                type: 'success'
              }));
              return _context3.abrupt('return', true);

            case 10:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'createMarginRequestError',
                text: responseObj.detail,
                type: 'warning'
              }));
              return _context3.abrupt('return', false);

            case 12:
              _context3.next = 19;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3['catch'](1);

              console.error('createMarginBorrowerAccountRequest error: ', _context3.t0);
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'createMarginRequestError',
                text: _context3.t0.o,
                type: 'warning'
              }));
              return _context3.abrupt('return', false);

            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[1, 14]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var disableMarginRequest = function disableMarginRequest() {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var OMSId, UserId, responseObj;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              OMSId = 1;
              UserId = getState().user.userInfo.UserId;
              _context4.prev = 2;
              _context4.next = 5;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('SetUserMarginDisabled', {
                OMSId: OMSId
              }));

            case 5:
              responseObj = _context4.sent;


              if (responseObj.result) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                  id: 'disableMarginRequestSuccess',
                  text: responseObj.detail || 'Margin disabled successfully',
                  type: 'success'
                }));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__userActions__["m" /* getUserInfo */])(UserId));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                  id: 'disableMarginRequestError',
                  text: responseObj.detail,
                  type: 'warning'
                }));
              }
              _context4.next = 13;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4['catch'](2);

              console.error('disableMarginRequest error: ', _context4.t0);
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'disableMarginRequestError',
                text: _context4.t0.o,
                type: 'warning'
              }));

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[2, 9]]);
    }));

    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var getMarginAccountState = function getMarginAccountState() {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      var OMSId, state, marginAccount, responseObj;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              OMSId = 1;
              state = getState();
              marginAccount = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_marginSelectors__["e" /* marginAccountSelector */])(state);

              if (marginAccount) {
                _context5.next = 7;
                break;
              }

              console.error('There is no margin account');
              _context5.next = 18;
              break;

            case 7:
              _context5.prev = 7;

              dispatch(requestMarginAccountState);
              _context5.next = 11;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('GetMarginAccountState', {
                OMSId: OMSId,
                AccountId: marginAccount.AccountId
              }));

            case 11:
              responseObj = _context5.sent;


              dispatch(receiveMarginAccountState(responseObj));
              _context5.next = 18;
              break;

            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5['catch'](7);

              console.error('getMarginAccountState error: ', _context5.t0);

            case 18:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[7, 15]]);
    }));

    return function (_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var getMarginStatus = function getMarginStatus() {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch, getState) {
      var OMSId, UserId, responseObj;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              OMSId = 1;
              UserId = getState().user.userInfo.UserId;
              _context6.prev = 2;
              _context6.next = 5;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('GetMarginBorrowerAccountRequest', {
                OMSId: OMSId,
                UserId: UserId
              }));

            case 5:
              responseObj = _context6.sent;


              dispatch(receiveMarginStatus(responseObj.Status));
              _context6.next = 12;
              break;

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6['catch'](2);

              console.error('getMarginStatus error: ', _context6.t0);

            case 12:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[2, 9]]);
    }));

    return function (_x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var RECEIVE_MARGIN_ACCT_POSITION = 'RECEIVE_MARGIN_ACCT_POSITION';
var receiveMarginAccountPositionEvent = function receiveMarginAccountPositionEvent(payload) {
  return {
    type: RECEIVE_MARGIN_ACCT_POSITION,
    payload: payload
  };
};

var subscribeToMarginAccountPositionEvents = function subscribeToMarginAccountPositionEvents(marginAccountId) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_7__services_subscriptions_marginAccountPositionEventSubscriptionService__["a" /* default */].subscribe(function (updates) {
      if (updates.AccountId === marginAccountId) dispatch(receiveMarginAccountPositionEvent(updates));
    });
  };
};

var subscribeToMarginAccountState = function subscribeToMarginAccountState() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_6__services_subscriptions_marginAccountStateSubscriptionService__["a" /* default */].subscribe(function (updates) {
      dispatch(receiveMarginAccountState(updates));
    });
  };
};

var requestMarginAccountState = {
  type: REQUEST_MARGIN_ACCOUNT_STATE
};

var receiveMarginAccountState = function receiveMarginAccountState(payload) {
  return {
    type: RECEIVE_MARGIN_ACCOUNT_STATE,
    payload: payload
  };
};

var REQUEST_MARGIN_INSTRUMENTS = 'REQUEST_MARGIN_INSTRUMENTS';
var requestMarginInstruments = function requestMarginInstruments() {
  return {
    type: REQUEST_MARGIN_INSTRUMENTS
  };
};

var RECEIVE_MARGIN_INSTRUMENTS = 'RECEIVE_MARGIN_INSTRUMENTS';
var receiveMarginInstruments = function receiveMarginInstruments(instruments) {
  return {
    type: RECEIVE_MARGIN_INSTRUMENTS,
    payload: instruments
  };
};

var SET_MARGIN_INSTRUMENT = 'SET_MARGIN_INSTRUMENT';
var setMarginInstrument = function setMarginInstrument(instrumentId) {
  return {
    type: SET_MARGIN_INSTRUMENT,
    payload: instrumentId
  };
};

var receiveMarginStatus = function receiveMarginStatus(marginStatus) {
  return {
    type: RECEIVE_MARGIN_STATUS,
    payload: marginStatus
  };
};

var activateMarginTradingStyle = function activateMarginTradingStyle() {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('tradingStyle', 'tradingStyle', __WEBPACK_IMPORTED_MODULE_11__constants_tradingStyleConstants__["a" /* marginTrade */]));
  };
};

var deactivateMarginTradingStyle = function deactivateMarginTradingStyle() {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('tradingStyle', 'tradingStyle', __WEBPACK_IMPORTED_MODULE_11__constants_tradingStyleConstants__["b" /* standardTrade */]));
  };
};

var RECEIVE_MARGIN_SETTINGS = 'RECEIVE_MARGIN_SETTINGS';
var receiveMarginSettings = function receiveMarginSettings(payload) {
  return {
    type: RECEIVE_MARGIN_SETTINGS,
    payload: payload
  };
};

var getMarginSettings = function getMarginSettings(OMSId) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('GetMarginPublicSettings', { OMSId: OMSId })).then(function (data) {
                dispatch(receiveMarginSettings(data));
              });

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function (_x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APInput_js__ = __webpack_require__(593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__APInput_js__["a"]; });




/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__APInput_js__["b" /* default */]);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bignumber_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var separators = ['.', ','];

var InnerNumberInput = function (_React$Component) {
  _inherits(InnerNumberInput, _React$Component);

  function InnerNumberInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InnerNumberInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InnerNumberInput.__proto__ || Object.getPrototypeOf(InnerNumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayValue: ''
    }, _this.handleChange = function (e) {
      // custom onChange to parse and validate input value
      // before calling standard onChange from redux-form and customChange (if exists)

      var _this$props = _this.props,
          allowNegative = _this$props.allowNegative,
          customChange = _this$props.customChange;

      var inputValue = e.target.value;

      var value = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["g" /* parseNumberToLocale */])(inputValue, null, !allowNegative);
      // prevent adding two dots or two commas
      var validSeparator = !inputValue.includes('..') && !inputValue.includes(',,');

      if (!Number.isNaN(value) && _this.validateDecimalPlaces(inputValue) && validSeparator) {
        _this.setState({ displayValue: inputValue });
        _this.props.input.onChange(value);

        if (customChange) {
          customChange(value);
        }
      }
    }, _this.handleFocus = function (e) {
      if (Number(_this.state.displayValue) === 0) {
        _this.setState({ displayValue: '' });
      }
    }, _this.validateDecimalPlaces = function (valueString) {
      var decimalPlaces = _this.props.decimalPlaces;

      if (decimalPlaces >= 0) {
        // Handle multiple zeroes after the comma, valueString contains these
        var decimals = valueString.split('.')[1];

        return !decimals || decimals.length <= decimalPlaces;
      }

      return true;
    }, _this.isSeparator = function (value) {
      return separators.includes(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // state.displayValue and props.input.value aren't in sync. Why:
  // props.input.value - redux-form value from reducer and it is source of truth.
  // state.displayValue - value that shown in input
  // Conditions when input.value and state.displayValue aren't in sync:
  // 1) user prints fractional number:
  // - Imagine user wants to enter 5.9
  //    User enters `5`: reducer (props.input.value) stores `5`, state.displayValue stores `5`
  //    User enters `.`: reducer stores `5` (!!!), state.displayValue stores `5.`
  //    User enters `9`: reducer stores `5.9`, state.displayValue stores `5.9`
  // 2) input change forced from outside by dispatching redux-form's change directly (examples: clearing order form, sync price and quantity)


  _createClass(InnerNumberInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.input.value !== this.props.input.value) {
        // handle forced change based on difference between input.value and displayValue
        // exclude case with entering the separator symbol first
        // keep input.value and displayValue in sync otherwise

        if (this.props.input.value === '' || Number(this.state.displayValue) !== 0 && (Number(this.props.input.value) === 0 || Number.isNaN(Number(this.props.input.value))) && !this.isSeparator(this.state.displayValue)) {
          this.setState({
            displayValue: ''
          });
        } else if (!this.isSeparator(this.state.displayValue)) {
          this.setState({
            displayValue: new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(this.props.input.value).toFixed()
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          input = _props.input,
          allowNegative = _props.allowNegative,
          customChange = _props.customChange,
          decimalPlaces = _props.decimalPlaces,
          passedProps = _objectWithoutProperties(_props, ['input', 'allowNegative', 'customChange', 'decimalPlaces']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__APInput__["a" /* InnerInput */], Object.assign({
        step: 'any'
      }, passedProps, {
        autoComplete: 'off',
        type: 'number',
        input: Object.assign({}, input, {
          value: this.state.displayValue,
          onChange: this.handleChange,
          //call onBlur without args so the stored value is not changed
          onBlur: function onBlur() {
            return input.onBlur();
          }
        }),
        onClick: function onClick() {
          input.onFocus();
          _this2.handleFocus('onClick');
        },
        onFocus: function onFocus() {
          input.onFocus();
          _this2.handleFocus('onFocus');
        }
      }));
    }
  }]);

  return InnerNumberInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var APNumberInput = function APNumberInput(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: InnerNumberInput }, props));
};

APNumberInput.defaultProps = {
  allowNegative: false
};

APNumberInput.propTypes = {
  allowNegative: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  decimalPlaces: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (APNumberInput);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function (globalObject) {
  'use strict';

/*
 *      bignumber.js v7.0.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */


  var BigNumber,
    isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,

    mathceil = Math.ceil,
    mathfloor = Math.floor,

    bignumberError = '[BigNumber Error] ',
    tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ',

    BASE = 1e14,
    LOG_BASE = 14,
    MAX_SAFE_INTEGER = 0x1fffffffffffff,         // 2^53 - 1
    // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
    SQRT_BASE = 1e7,

    // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9;                                   // 0 to MAX_INT32


  /*
   * Create and return a BigNumber constructor.
   */
  function clone(configObject) {
    var div, convertBase, parseNumeric,
      P = BigNumber.prototype = { constructor: BigNumber, toString: null, valueOf: null },
      ONE = new BigNumber(1),


      //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------


      // The default values below must be integers within the inclusive ranges stated.
      // The values can also be changed at run-time using BigNumber.set.

      // The maximum number of decimal places for operations involving division.
      DECIMAL_PLACES = 20,                     // 0 to MAX

      // The rounding mode used when rounding to the above decimal places, and when using
      // toExponential, toFixed, toFormat and toPrecision, and round (default value).
      // UP         0 Away from zero.
      // DOWN       1 Towards zero.
      // CEIL       2 Towards +Infinity.
      // FLOOR      3 Towards -Infinity.
      // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      ROUNDING_MODE = 4,                       // 0 to 8

      // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

      // The exponent value at and beneath which toString returns exponential notation.
      // Number type: -7
      TO_EXP_NEG = -7,                         // 0 to -MAX

      // The exponent value at and above which toString returns exponential notation.
      // Number type: 21
      TO_EXP_POS = 21,                         // 0 to MAX

      // RANGE : [MIN_EXP, MAX_EXP]

      // The minimum exponent value, beneath which underflow to zero occurs.
      // Number type: -324  (5e-324)
      MIN_EXP = -1e7,                          // -1 to -MAX

      // The maximum exponent value, above which overflow to Infinity occurs.
      // Number type:  308  (1.7976931348623157e+308)
      // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
      MAX_EXP = 1e7,                           // 1 to MAX

      // Whether to use cryptographically-secure random number generation, if available.
      CRYPTO = false,                          // true or false

      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP        0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN      1 The remainder has the same sign as the dividend.
      //             This modulo mode is commonly known as 'truncated division' and is
      //             equivalent to (a % n) in JavaScript.
      // FLOOR     3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
      // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
      //             The remainder is always positive.
      //
      // The truncated division, floored division, Euclidian division and IEEE 754 remainder
      // modes are commonly used for the modulus operation.
      // Although the other rounding modes can also be used, they may not give useful results.
      MODULO_MODE = 1,                         // 0 to 9

      // The maximum number of significant digits of the result of the exponentiatedBy operation.
      // If POW_PRECISION is 0, there will be unlimited significant digits.
      POW_PRECISION = 0,                    // 0 to MAX

      // The format specification used by the BigNumber.prototype.toFormat method.
      FORMAT = {
        decimalSeparator: '.',
        groupSeparator: ',',
        groupSize: 3,
        secondaryGroupSize: 0,
        fractionGroupSeparator: '\xA0',      // non-breaking space
        fractionGroupSize: 0
      },

      // The alphabet used for base conversion.
      // It must be at least 2 characters long, with no '.' or repeated character.
      // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
      ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';


    //------------------------------------------------------------------------------------------


    // CONSTRUCTOR


    /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * n {number|string|BigNumber} A numeric value.
     * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
     */
    function BigNumber(n, b) {
      var alphabet, c, caseChanged, e, i, isNum, len, str,
        x = this;

      // Enable constructor usage without new.
      if (!(x instanceof BigNumber)) {

        // Don't throw on constructor call without new (#81).
        // '[BigNumber Error] Constructor call without new: {n}'
        //throw Error(bignumberError + ' Constructor call without new: ' + n);
        return new BigNumber(n, b);
      }

      if (b == null) {

        // Duplicate.
        if (n instanceof BigNumber) {
          x.s = n.s;
          x.e = n.e;
          x.c = (n = n.c) ? n.slice() : n;
          return;
        }

        isNum = typeof n == 'number';

        if (isNum && n * 0 == 0) {

          // Use `1 / n` to handle minus zero also.
          x.s = 1 / n < 0 ? (n = -n, -1) : 1;

          // Faster path for integers.
          if (n === ~~n) {
            for (e = 0, i = n; i >= 10; i /= 10, e++);
            x.e = e;
            x.c = [n];
            return;
          }

          str = n + '';
        } else {
          if (!isNumeric.test(str = n + '')) return parseNumeric(x, str, isNum);
          x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
        }

        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {

          // Determine exponent.
          if (e < 0) e = i;
          e += +str.slice(i + 1);
          str = str.substring(0, i);
        } else if (e < 0) {

          // Integer.
          e = str.length;
        }

      } else {

        // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
        intCheck(b, 2, ALPHABET.length, 'Base');
        str = n + '';

        // Allow exponential notation to be used with base 10 argument, while
        // also rounding to DECIMAL_PLACES as with other bases.
        if (b == 10) {
          x = new BigNumber(n instanceof BigNumber ? n : str);
          return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
        }

        isNum = typeof n == 'number';

        if (isNum) {

          // Avoid potential interpretation of Infinity and NaN as base 44+ values.
          if (n * 0 != 0) return parseNumeric(x, str, isNum, b);

          x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;

          // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
          if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) {
            throw Error
             (tooManyDigits + n);
          }

          // Prevent later check for length on converted number.
          isNum = false;
        } else {
          x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
        }

        alphabet = ALPHABET.slice(0, b);
        e = i = 0;

        // Check that str is a valid base b number.
        // Don't use RegExp so alphabet can contain special characters.
        for (len = str.length; i < len; i++) {
          if (alphabet.indexOf(c = str.charAt(i)) < 0) {
            if (c == '.') {

              // If '.' is not the first character and it has not be found before.
              if (i > e) {
                e = len;
                continue;
              }
            } else if (!caseChanged) {

              // Allow e.g. hexadecimal 'FF' as well as 'ff'.
              if (str == str.toUpperCase() && (str = str.toLowerCase()) ||
                  str == str.toLowerCase() && (str = str.toUpperCase())) {
                caseChanged = true;
                i = -1;
                e = 0;
                continue;
              }
            }

            return parseNumeric(x, n + '', isNum, b);
          }
        }

        str = convertBase(str, b, 10, x.s);

        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        else e = str.length;
      }

      // Determine leading zeros.
      for (i = 0; str.charCodeAt(i) === 48; i++);

      // Determine trailing zeros.
      for (len = str.length; str.charCodeAt(--len) === 48;);

      str = str.slice(i, ++len);

      if (str) {
        len -= i;

        // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
        if (isNum && BigNumber.DEBUG &&
          len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) {
            throw Error
             (tooManyDigits + (x.s * n));
        }

        e = e - i - 1;

         // Overflow?
        if (e > MAX_EXP) {

          // Infinity.
          x.c = x.e = null;

        // Underflow?
        } else if (e < MIN_EXP) {

          // Zero.
          x.c = [x.e = 0];
        } else {
          x.e = e;
          x.c = [];

          // Transform base

          // e is the base 10 exponent.
          // i is where to slice str to get the first element of the coefficient array.
          i = (e + 1) % LOG_BASE;
          if (e < 0) i += LOG_BASE;

          if (i < len) {
            if (i) x.c.push(+str.slice(0, i));

            for (len -= LOG_BASE; i < len;) {
              x.c.push(+str.slice(i, i += LOG_BASE));
            }

            str = str.slice(i);
            i = LOG_BASE - str.length;
          } else {
            i -= len;
          }

          for (; i--; str += '0');
          x.c.push(+str);
        }
      } else {

        // Zero.
        x.c = [x.e = 0];
      }
    }


    // CONSTRUCTOR PROPERTIES


    BigNumber.clone = clone;

    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;


    /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *      decimalSeparator       {string}
     *      groupSeparator         {string}
     *      groupSize              {number}
     *      secondaryGroupSize     {number}
     *      fractionGroupSeparator {string}
     *      fractionGroupSize      {number}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */
    BigNumber.config = BigNumber.set = function (obj) {
      var p, v;

      if (obj != null) {

        if (typeof obj == 'object') {

          // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
          // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
            v = obj[p];
            intCheck(v, 0, MAX, p);
            DECIMAL_PLACES = v;
          }

          // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
          // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
            v = obj[p];
            intCheck(v, 0, 8, p);
            ROUNDING_MODE = v;
          }

          // EXPONENTIAL_AT {number|number[]}
          // Integer, -MAX to MAX inclusive or
          // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
          // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
            v = obj[p];
            if (isArray(v)) {
              intCheck(v[0], -MAX, 0, p);
              intCheck(v[1], 0, MAX, p);
              TO_EXP_NEG = v[0];
              TO_EXP_POS = v[1];
            } else {
              intCheck(v, -MAX, MAX, p);
              TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
            }
          }

          // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
          // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
          // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
          if (obj.hasOwnProperty(p = 'RANGE')) {
            v = obj[p];
            if (isArray(v)) {
              intCheck(v[0], -MAX, -1, p);
              intCheck(v[1], 1, MAX, p);
              MIN_EXP = v[0];
              MAX_EXP = v[1];
            } else {
              intCheck(v, -MAX, MAX, p);
              if (v) {
                MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
              } else {
                throw Error
                 (bignumberError + p + ' cannot be zero: ' + v);
              }
            }
          }

          // CRYPTO {boolean} true or false.
          // '[BigNumber Error] CRYPTO not true or false: {v}'
          // '[BigNumber Error] crypto unavailable'
          if (obj.hasOwnProperty(p = 'CRYPTO')) {
            v = obj[p];
            if (v === !!v) {
              if (v) {
                if (typeof crypto != 'undefined' && crypto &&
                 (crypto.getRandomValues || crypto.randomBytes)) {
                  CRYPTO = v;
                } else {
                  CRYPTO = !v;
                  throw Error
                   (bignumberError + 'crypto unavailable');
                }
              } else {
                CRYPTO = v;
              }
            } else {
              throw Error
               (bignumberError + p + ' not true or false: ' + v);
            }
          }

          // MODULO_MODE {number} Integer, 0 to 9 inclusive.
          // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
            v = obj[p];
            intCheck(v, 0, 9, p);
            MODULO_MODE = v;
          }

          // POW_PRECISION {number} Integer, 0 to MAX inclusive.
          // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
            v = obj[p];
            intCheck(v, 0, MAX, p);
            POW_PRECISION = v;
          }

          // FORMAT {object}
          // '[BigNumber Error] FORMAT not an object: {v}'
          if (obj.hasOwnProperty(p = 'FORMAT')) {
            v = obj[p];
            if (typeof v == 'object') FORMAT = v;
            else throw Error
             (bignumberError + p + ' not an object: ' + v);
          }

          // ALPHABET {string}
          // '[BigNumber Error] ALPHABET invalid: {v}'
          if (obj.hasOwnProperty(p = 'ALPHABET')) {
            v = obj[p];

            // Disallow if only one character, or contains '.' or a repeated character.
            if (typeof v == 'string' && !/^.$|\.|(.).*\1/.test(v)) {
              ALPHABET = v;
            } else {
              throw Error
               (bignumberError + p + ' invalid: ' + v);
            }
          }

        } else {

          // '[BigNumber Error] Object expected: {v}'
          throw Error
           (bignumberError + 'Object expected: ' + obj);
        }
      }

      return {
        DECIMAL_PLACES: DECIMAL_PLACES,
        ROUNDING_MODE: ROUNDING_MODE,
        EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
        RANGE: [MIN_EXP, MAX_EXP],
        CRYPTO: CRYPTO,
        MODULO_MODE: MODULO_MODE,
        POW_PRECISION: POW_PRECISION,
        FORMAT: FORMAT,
        ALPHABET: ALPHABET
      };
    };


    /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * v {any}
     */
    BigNumber.isBigNumber = function (v) {
      return v instanceof BigNumber || v && v._isBigNumber === true || false;
    };


    /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */
    BigNumber.maximum = BigNumber.max = function () {
      return maxOrMin(arguments, P.lt);
    };


    /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */
    BigNumber.minimum = BigNumber.min = function () {
      return maxOrMin(arguments, P.gt);
    };


    /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */
    BigNumber.random = (function () {
      var pow2_53 = 0x20000000000000;

      // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
      // Check if Math.random() produces more than 32 bits of randomness.
      // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
      // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
      var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
       ? function () { return mathfloor(Math.random() * pow2_53); }
       : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
         (Math.random() * 0x800000 | 0); };

      return function (dp) {
        var a, b, e, k, v,
          i = 0,
          c = [],
          rand = new BigNumber(ONE);

        if (dp == null) dp = DECIMAL_PLACES;
        else intCheck(dp, 0, MAX);

        k = mathceil(dp / LOG_BASE);

        if (CRYPTO) {

          // Browsers supporting crypto.getRandomValues.
          if (crypto.getRandomValues) {

            a = crypto.getRandomValues(new Uint32Array(k *= 2));

            for (; i < k;) {

              // 53 bits:
              // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
              // 11111 11111111 11111111 11111111 11100000 00000000 00000000
              // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
              //                                     11111 11111111 11111111
              // 0x20000 is 2^21.
              v = a[i] * 0x20000 + (a[i + 1] >>> 11);

              // Rejection sampling:
              // 0 <= v < 9007199254740992
              // Probability that v >= 9e15, is
              // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
              if (v >= 9e15) {
                b = crypto.getRandomValues(new Uint32Array(2));
                a[i] = b[0];
                a[i + 1] = b[1];
              } else {

                // 0 <= v <= 8999999999999999
                // 0 <= (v % 1e14) <= 99999999999999
                c.push(v % 1e14);
                i += 2;
              }
            }
            i = k / 2;

          // Node.js supporting crypto.randomBytes.
          } else if (crypto.randomBytes) {

            // buffer
            a = crypto.randomBytes(k *= 7);

            for (; i < k;) {

              // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
              // 0x100000000 is 2^32, 0x1000000 is 2^24
              // 11111 11111111 11111111 11111111 11111111 11111111 11111111
              // 0 <= v < 9007199254740992
              v = ((a[i] & 31) * 0x1000000000000) + (a[i + 1] * 0x10000000000) +
                 (a[i + 2] * 0x100000000) + (a[i + 3] * 0x1000000) +
                 (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];

              if (v >= 9e15) {
                crypto.randomBytes(7).copy(a, i);
              } else {

                // 0 <= (v % 1e14) <= 99999999999999
                c.push(v % 1e14);
                i += 7;
              }
            }
            i = k / 7;
          } else {
            CRYPTO = false;
            throw Error
             (bignumberError + 'crypto unavailable');
          }
        }

        // Use Math.random.
        if (!CRYPTO) {

          for (; i < k;) {
            v = random53bitInt();
            if (v < 9e15) c[i++] = v % 1e14;
          }
        }

        k = c[--i];
        dp %= LOG_BASE;

        // Convert trailing digits to zeros according to dp.
        if (k && dp) {
          v = POWS_TEN[LOG_BASE - dp];
          c[i] = mathfloor(k / v) * v;
        }

        // Remove trailing elements which are zero.
        for (; c[i] === 0; c.pop(), i--);

        // Zero?
        if (i < 0) {
          c = [e = 0];
        } else {

          // Remove leading elements which are zero and adjust exponent accordingly.
          for (e = -1 ; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);

          // Count the digits of the first element of c to determine leading zeros, and...
          for (i = 1, v = c[0]; v >= 10; v /= 10, i++);

          // adjust the exponent accordingly.
          if (i < LOG_BASE) e -= LOG_BASE - i;
        }

        rand.e = e;
        rand.c = c;
        return rand;
      };
    })();


    // PRIVATE FUNCTIONS


    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = (function () {
      var decimal = '0123456789';

      /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */
      function toBaseOut(str, baseIn, baseOut, alphabet) {
        var j,
          arr = [0],
          arrL,
          i = 0,
          len = str.length;

        for (; i < len;) {
          for (arrL = arr.length; arrL--; arr[arrL] *= baseIn);

          arr[0] += alphabet.indexOf(str.charAt(i++));

          for (j = 0; j < arr.length; j++) {

            if (arr[j] > baseOut - 1) {
              if (arr[j + 1] == null) arr[j + 1] = 0;
              arr[j + 1] += arr[j] / baseOut | 0;
              arr[j] %= baseOut;
            }
          }
        }

        return arr.reverse();
      }

      // Convert a numeric string of baseIn to a numeric string of baseOut.
      // If the caller is toString, we are converting from base 10 to baseOut.
      // If the caller is BigNumber, we are converting from baseIn to base 10.
      return function (str, baseIn, baseOut, sign, callerIsToString) {
        var alphabet, d, e, k, r, x, xc, y,
          i = str.indexOf('.'),
          dp = DECIMAL_PLACES,
          rm = ROUNDING_MODE;

        // Non-integer.
        if (i >= 0) {
          k = POW_PRECISION;

          // Unlimited precision.
          POW_PRECISION = 0;
          str = str.replace('.', '');
          y = new BigNumber(baseIn);
          x = y.pow(str.length - i);
          POW_PRECISION = k;

          // Convert str as if an integer, then restore the fraction part by dividing the
          // result by its base raised to a power.

          y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'),
           10, baseOut, decimal);
          y.e = y.c.length;
        }

        // Convert the number as integer.

        xc = toBaseOut(str, baseIn, baseOut, callerIsToString
         ? (alphabet = ALPHABET, decimal)
         : (alphabet = decimal, ALPHABET));

        // xc now represents str as an integer and converted to baseOut. e is the exponent.
        e = k = xc.length;

        // Remove trailing zeros.
        for (; xc[--k] == 0; xc.pop());

        // Zero?
        if (!xc[0]) return alphabet.charAt(0);

        // Does str represent an integer? If so, no need for the division.
        if (i < 0) {
          --e;
        } else {
          x.c = xc;
          x.e = e;

          // The sign is needed for correct rounding.
          x.s = sign;
          x = div(x, y, dp, rm, baseOut);
          xc = x.c;
          r = x.r;
          e = x.e;
        }

        // xc now represents str converted to baseOut.

        // THe index of the rounding digit.
        d = e + dp + 1;

        // The rounding digit: the digit to the right of the digit that may be rounded up.
        i = xc[d];

        // Look at the rounding digits and mode to determine whether to round up.

        k = baseOut / 2;
        r = r || d < 0 || xc[d + 1] != null;

        r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
              : i > k || i == k &&(rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
               rm == (x.s < 0 ? 8 : 7));

        // If the index of the rounding digit is not greater than zero, or xc represents
        // zero, then the result of the base conversion is zero or, if rounding up, a value
        // such as 0.00001.
        if (d < 1 || !xc[0]) {

          // 1^-dp or 0
          str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0))
              : alphabet.charAt(0);
        } else {

          // Truncate xc to the required number of decimal places.
          xc.length = d;

          // Round up?
          if (r) {

            // Rounding up may mean the previous digit has to be rounded up and so on.
            for (--baseOut; ++xc[--d] > baseOut;) {
              xc[d] = 0;

              if (!d) {
                ++e;
                xc = [1].concat(xc);
              }
            }
          }

          // Determine trailing zeros.
          for (k = xc.length; !xc[--k];);

          // E.g. [4, 11, 15] becomes 4bf.
          for (i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));

          // Add leading zeros, decimal point and trailing zeros as required.
          str = toFixedPoint(str, e, alphabet.charAt(0));
        }

        // The caller will add the sign.
        return str;
      };
    })();


    // Perform division in the specified base. Called by div and convertBase.
    div = (function () {

      // Assume non-zero x and k.
      function multiply(x, k, base) {
        var m, temp, xlo, xhi,
          carry = 0,
          i = x.length,
          klo = k % SQRT_BASE,
          khi = k / SQRT_BASE | 0;

        for (x = x.slice(); i--;) {
          xlo = x[i] % SQRT_BASE;
          xhi = x[i] / SQRT_BASE | 0;
          m = khi * xlo + xhi * klo;
          temp = klo * xlo + ((m % SQRT_BASE) * SQRT_BASE) + carry;
          carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
          x[i] = temp % base;
        }

        if (carry) x = [carry].concat(x);

        return x;
      }

      function compare(a, b, aL, bL) {
        var i, cmp;

        if (aL != bL) {
          cmp = aL > bL ? 1 : -1;
        } else {

          for (i = cmp = 0; i < aL; i++) {

            if (a[i] != b[i]) {
              cmp = a[i] > b[i] ? 1 : -1;
              break;
            }
          }
        }

        return cmp;
      }

      function subtract(a, b, aL, base) {
        var i = 0;

        // Subtract b from a.
        for (; aL--;) {
          a[aL] -= i;
          i = a[aL] < b[aL] ? 1 : 0;
          a[aL] = i * base + a[aL] - b[aL];
        }

        // Remove leading zeros.
        for (; !a[0] && a.length > 1; a.splice(0, 1));
      }

      // x: dividend, y: divisor.
      return function (x, y, dp, rm, base) {
        var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
          yL, yz,
          s = x.s == y.s ? 1 : -1,
          xc = x.c,
          yc = y.c;

        // Either NaN, Infinity or 0?
        if (!xc || !xc[0] || !yc || !yc[0]) {

          return new BigNumber(

           // Return NaN if either NaN, or both Infinity or 0.
           !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN :

            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0
         );
        }

        q = new BigNumber(s);
        qc = q.c = [];
        e = x.e - y.e;
        s = dp + e + 1;

        if (!base) {
          base = BASE;
          e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
          s = s / LOG_BASE | 0;
        }

        // Result exponent may be one less then the current value of e.
        // The coefficients of the BigNumbers from convertBase may have trailing zeros.
        for (i = 0; yc[i] == (xc[i] || 0); i++);

        if (yc[i] > (xc[i] || 0)) e--;

        if (s < 0) {
          qc.push(1);
          more = true;
        } else {
          xL = xc.length;
          yL = yc.length;
          i = 0;
          s += 2;

          // Normalise xc and yc so highest order digit of yc is >= base / 2.

          n = mathfloor(base / (yc[0] + 1));

          // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
          // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
          if (n > 1) {
            yc = multiply(yc, n, base);
            xc = multiply(xc, n, base);
            yL = yc.length;
            xL = xc.length;
          }

          xi = yL;
          rem = xc.slice(0, yL);
          remL = rem.length;

          // Add zeros to make remainder as long as divisor.
          for (; remL < yL; rem[remL++] = 0);
          yz = yc.slice();
          yz = [0].concat(yz);
          yc0 = yc[0];
          if (yc[1] >= base / 2) yc0++;
          // Not necessary, but to prevent trial digit n > base, when using base 3.
          // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;

          do {
            n = 0;

            // Compare divisor and remainder.
            cmp = compare(yc, rem, yL, remL);

            // If divisor < remainder.
            if (cmp < 0) {

              // Calculate trial digit, n.

              rem0 = rem[0];
              if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

              // n is how many times the divisor goes into the current remainder.
              n = mathfloor(rem0 / yc0);

              //  Algorithm:
              //  product = divisor multiplied by trial digit (n).
              //  Compare product and remainder.
              //  If product is greater than remainder:
              //    Subtract divisor from product, decrement trial digit.
              //  Subtract product from remainder.
              //  If product was less than remainder at the last compare:
              //    Compare new remainder and divisor.
              //    If remainder is greater than divisor:
              //      Subtract divisor from remainder, increment trial digit.

              if (n > 1) {

                // n may be > base only when base is 3.
                if (n >= base) n = base - 1;

                // product = divisor * trial digit.
                prod = multiply(yc, n, base);
                prodL = prod.length;
                remL = rem.length;

                // Compare product and remainder.
                // If product > remainder then trial digit n too high.
                // n is 1 too high about 5% of the time, and is not known to have
                // ever been more than 1 too high.
                while (compare(prod, rem, prodL, remL) == 1) {
                  n--;

                  // Subtract divisor from product.
                  subtract(prod, yL < prodL ? yz : yc, prodL, base);
                  prodL = prod.length;
                  cmp = 1;
                }
              } else {

                // n is 0 or 1, cmp is -1.
                // If n is 0, there is no need to compare yc and rem again below,
                // so change cmp to 1 to avoid it.
                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                if (n == 0) {

                  // divisor < remainder, so n must be at least 1.
                  cmp = n = 1;
                }

                // product = divisor
                prod = yc.slice();
                prodL = prod.length;
              }

              if (prodL < remL) prod = [0].concat(prod);

              // Subtract product from remainder.
              subtract(rem, prod, remL, base);
              remL = rem.length;

               // If product was < remainder.
              if (cmp == -1) {

                // Compare divisor and new remainder.
                // If divisor < new remainder, subtract divisor from remainder.
                // Trial digit n too low.
                // n is 1 too low about 5% of the time, and very rarely 2 too low.
                while (compare(yc, rem, yL, remL) < 1) {
                  n++;

                  // Subtract divisor from remainder.
                  subtract(rem, yL < remL ? yz : yc, remL, base);
                  remL = rem.length;
                }
              }
            } else if (cmp === 0) {
              n++;
              rem = [0];
            } // else cmp === 1 and n will be 0

            // Add the next digit, n, to the result array.
            qc[i++] = n;

            // Update the remainder.
            if (rem[0]) {
              rem[remL++] = xc[xi] || 0;
            } else {
              rem = [xc[xi]];
              remL = 1;
            }
          } while ((xi++ < xL || rem[0] != null) && s--);

          more = rem[0] != null;

          // Leading zero?
          if (!qc[0]) qc.splice(0, 1);
        }

        if (base == BASE) {

          // To calculate q.e, first get the number of digits of qc[0].
          for (i = 1, s = qc[0]; s >= 10; s /= 10, i++);

          round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);

        // Caller is convertBase.
        } else {
          q.e = e;
          q.r = +more;
        }

        return q;
      };
    })();


    /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */
    function format(n, i, rm, id) {
      var c0, e, ne, len, str;

      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      if (!n.c) return n.toString();

      c0 = n.c[0];
      ne = n.e;

      if (i == null) {
        str = coeffToString(n.c);
        str = id == 1 || id == 2 && ne <= TO_EXP_NEG
         ? toExponential(str, ne)
         : toFixedPoint(str, ne, '0');
      } else {
        n = round(new BigNumber(n), i, rm);

        // n.e may have changed if the value was rounded up.
        e = n.e;

        str = coeffToString(n.c);
        len = str.length;

        // toPrecision returns exponential notation if the number of significant digits
        // specified is less than the number of digits necessary to represent the integer
        // part of the value in fixed-point notation.

        // Exponential notation.
        if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {

          // Append zeros?
          for (; len < i; str += '0', len++);
          str = toExponential(str, e);

        // Fixed-point notation.
        } else {
          i -= ne;
          str = toFixedPoint(str, e, '0');

          // Append zeros?
          if (e + 1 > len) {
            if (--i > 0) for (str += '.'; i--; str += '0');
          } else {
            i += e - len;
            if (i > 0) {
              if (e + 1 == len) str += '.';
              for (; i--; str += '0');
            }
          }
        }
      }

      return n.s < 0 && c0 ? '-' + str : str;
    }


    // Handle BigNumber.max and BigNumber.min.
    function maxOrMin(args, method) {
      var m, n,
        i = 0;

      if (isArray(args[0])) args = args[0];
      m = new BigNumber(args[0]);

      for (; ++i < args.length;) {
        n = new BigNumber(args[i]);

        // If any number is NaN, return NaN.
        if (!n.s) {
          m = n;
          break;
        } else if (method.call(m, n)) {
          m = n;
        }
      }

      return m;
    }


    /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */
    function normalise(n, c, e) {
      var i = 1,
        j = c.length;

       // Remove trailing zeros.
      for (; !c[--j]; c.pop());

      // Calculate the base 10 exponent. First get the number of digits of c[0].
      for (j = c[0]; j >= 10; j /= 10, i++);

      // Overflow?
      if ((e = i + e * LOG_BASE - 1) > MAX_EXP) {

        // Infinity.
        n.c = n.e = null;

      // Underflow?
      } else if (e < MIN_EXP) {

        // Zero.
        n.c = [n.e = 0];
      } else {
        n.e = e;
        n.c = c;
      }

      return n;
    }


    // Handle values that fail the validity test in BigNumber.
    parseNumeric = (function () {
      var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
        dotAfter = /^([^.]+)\.$/,
        dotBefore = /^\.([^.]+)$/,
        isInfinityOrNaN = /^-?(Infinity|NaN)$/,
        whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;

      return function (x, str, isNum, b) {
        var base,
          s = isNum ? str : str.replace(whitespaceOrPlus, '');

        // No exception on ±Infinity or NaN.
        if (isInfinityOrNaN.test(s)) {
          x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
          x.c = x.e = null;
        } else {
          if (!isNum) {

            // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
            s = s.replace(basePrefix, function (m, p1, p2) {
              base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
              return !b || b == base ? p1 : m;
            });

            if (b) {
              base = b;

              // E.g. '1.' to '1', '.1' to '0.1'
              s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
            }

            if (str != s) return new BigNumber(s, base);
          }

          // '[BigNumber Error] Not a number: {n}'
          // '[BigNumber Error] Not a base {b} number: {n}'
          if (BigNumber.DEBUG) {
            throw Error
              (bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
          }

          // NaN
          x.c = x.e = x.s = null;
        }
      }
    })();


    /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */
    function round(x, sd, rm, r) {
      var d, i, j, k, n, ni, rd,
        xc = x.c,
        pows10 = POWS_TEN;

      // if x is not Infinity or NaN...
      if (xc) {

        // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
        // n is a base 1e14 number, the value of the element of array x.c containing rd.
        // ni is the index of n within x.c.
        // d is the number of digits of n.
        // i is the index of rd within n including leading zeros.
        // j is the actual index of rd within n (if < 0, rd is a leading zero).
        out: {

          // Get the number of digits of the first element of xc.
          for (d = 1, k = xc[0]; k >= 10; k /= 10, d++);
          i = sd - d;

          // If the rounding digit is in the first element of xc...
          if (i < 0) {
            i += LOG_BASE;
            j = sd;
            n = xc[ni = 0];

            // Get the rounding digit at index j of n.
            rd = n / pows10[d - j - 1] % 10 | 0;
          } else {
            ni = mathceil((i + 1) / LOG_BASE);

            if (ni >= xc.length) {

              if (r) {

                // Needed by sqrt.
                for (; xc.length <= ni; xc.push(0));
                n = rd = 0;
                d = 1;
                i %= LOG_BASE;
                j = i - LOG_BASE + 1;
              } else {
                break out;
              }
            } else {
              n = k = xc[ni];

              // Get the number of digits of n.
              for (d = 1; k >= 10; k /= 10, d++);

              // Get the index of rd within n.
              i %= LOG_BASE;

              // Get the index of rd within n, adjusted for leading zeros.
              // The number of leading zeros of n is given by LOG_BASE - d.
              j = i - LOG_BASE + d;

              // Get the rounding digit at index j of n.
              rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
            }
          }

          r = r || sd < 0 ||

          // Are there any non-zero digits after the rounding digit?
          // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
          // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
           xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);

          r = rm < 4
           ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
           : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 &&

            // Check whether the digit to the left of the rounding digit is odd.
            ((i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10) & 1 ||
             rm == (x.s < 0 ? 8 : 7));

          if (sd < 1 || !xc[0]) {
            xc.length = 0;

            if (r) {

              // Convert sd to decimal places.
              sd -= x.e + 1;

              // 1, 0.1, 0.01, 0.001, 0.0001 etc.
              xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
              x.e = -sd || 0;
            } else {

              // Zero.
              xc[0] = x.e = 0;
            }

            return x;
          }

          // Remove excess digits.
          if (i == 0) {
            xc.length = ni;
            k = 1;
            ni--;
          } else {
            xc.length = ni + 1;
            k = pows10[LOG_BASE - i];

            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of n.
            xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
          }

          // Round up?
          if (r) {

            for (; ;) {

              // If the digit to be rounded up is in the first element of xc...
              if (ni == 0) {

                // i will be the length of xc[0] before k is added.
                for (i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                j = xc[0] += k;
                for (k = 1; j >= 10; j /= 10, k++);

                // if i != k the length has increased.
                if (i != k) {
                  x.e++;
                  if (xc[0] == BASE) xc[0] = 1;
                }

                break;
              } else {
                xc[ni] += k;
                if (xc[ni] != BASE) break;
                xc[ni--] = 0;
                k = 1;
              }
            }
          }

          // Remove trailing zeros.
          for (i = xc.length; xc[--i] === 0; xc.pop());
        }

        // Overflow? Infinity.
        if (x.e > MAX_EXP) {
          x.c = x.e = null;

        // Underflow? Zero.
        } else if (x.e < MIN_EXP) {
          x.c = [x.e = 0];
        }
      }

      return x;
    }


    // PROTOTYPE/INSTANCE METHODS


    /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */
    P.absoluteValue = P.abs = function () {
      var x = new BigNumber(this);
      if (x.s < 0) x.s = 1;
      return x;
    };


    /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */
    P.comparedTo = function (y, b) {
      return compare(this, new BigNumber(y, b));
    };


    /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.decimalPlaces = P.dp = function (dp, rm) {
      var c, n, v,
        x = this;

      if (dp != null) {
        intCheck(dp, 0, MAX);
        if (rm == null) rm = ROUNDING_MODE;
        else intCheck(rm, 0, 8);

        return round(new BigNumber(x), dp + x.e + 1, rm);
      }

      if (!(c = x.c)) return null;
      n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;

      // Subtract the number of trailing zeros of the last number.
      if (v = c[v]) for (; v % 10 == 0; v /= 10, n--);
      if (n < 0) n = 0;

      return n;
    };


    /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */
    P.dividedBy = P.div = function (y, b) {
      return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };


    /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */
    P.dividedToIntegerBy = P.idiv = function (y, b) {
      return div(this, new BigNumber(y, b), 0, 1);
    };


    /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */
    P.exponentiatedBy = P.pow = function (n, m) {
      var half, isModExp, k, more, nIsBig, nIsNeg, nIsOdd, y,
        x = this;

      n = new BigNumber(n);

      // Allow NaN and ±Infinity, but not other non-integers.
      if (n.c && !n.isInteger()) {
        throw Error
          (bignumberError + 'Exponent not an integer: ' + n);
      }

      if (m != null) m = new BigNumber(m);

      // Exponent of MAX_SAFE_INTEGER is 15.
      nIsBig = n.e > 14;

      // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
      if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {

        // The sign of the result of pow when x is negative depends on the evenness of n.
        // If +n overflows to ±Infinity, the evenness of n would be not be known.
        y = new BigNumber(Math.pow(+x.valueOf(), nIsBig ? 2 - isOdd(n) : +n));
        return m ? y.mod(m) : y;
      }

      nIsNeg = n.s < 0;

      if (m) {

        // x % m returns NaN if abs(m) is zero, or m is NaN.
        if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);

        isModExp = !nIsNeg && x.isInteger() && m.isInteger();

        if (isModExp) x = x.mod(m);

      // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
      // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
      } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0
        // [1, 240000000]
        ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7
        // [80000000000000]  [99999750000000]
        : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {

        // If x is negative and n is odd, k = -0, else k = 0.
        k = x.s < 0 && isOdd(n) ? -0 : 0;

        // If x >= 1, k = ±Infinity.
        if (x.e > -1) k = 1 / k;

        // If n is negative return ±0, else return ±Infinity.
        return new BigNumber(nIsNeg ? 1 / k : k);

      } else if (POW_PRECISION) {

        // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = mathceil(POW_PRECISION / LOG_BASE + 2);
      }

      if (nIsBig) {
        half = new BigNumber(0.5);
        nIsOdd = isOdd(n);
      } else {
        nIsOdd = n % 2;
      }

      if (nIsNeg) n.s = 1;

      y = new BigNumber(ONE);

      // Performs 54 loop iterations for n of 9007199254740991.
      for (; ;) {

        if (nIsOdd) {
          y = y.times(x);
          if (!y.c) break;

          if (k) {
            if (y.c.length > k) y.c.length = k;
          } else if (isModExp) {
            y = y.mod(m);    //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
          }
        }

        if (nIsBig) {
          n = n.times(half);
          round(n, n.e + 1, 1);
          if (!n.c[0]) break;
          nIsBig = n.e > 14;
          nIsOdd = isOdd(n);
        } else {
          n = mathfloor(n / 2);
          if (!n) break;
          nIsOdd = n % 2;
        }

        x = x.times(x);

        if (k) {
          if (x.c && x.c.length > k) x.c.length = k;
        } else if (isModExp) {
          x = x.mod(m);    //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
      }

      if (isModExp) return y;
      if (nIsNeg) y = ONE.div(y);

      return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */
    P.integerValue = function (rm) {
      var n = new BigNumber(this);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);
      return round(n, n.e + 1, rm);
    };


    /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isEqualTo = P.eq = function (y, b) {
      return compare(this, new BigNumber(y, b)) === 0;
    };


    /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */
    P.isFinite = function () {
      return !!this.c;
    };


    /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isGreaterThan = P.gt = function (y, b) {
      return compare(this, new BigNumber(y, b)) > 0;
    };


    /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */
    P.isGreaterThanOrEqualTo = P.gte = function (y, b) {
      return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;

    };


    /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */
    P.isInteger = function () {
      return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
    };


    /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isLessThan = P.lt = function (y, b) {
      return compare(this, new BigNumber(y, b)) < 0;
    };


    /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */
    P.isLessThanOrEqualTo = P.lte = function (y, b) {
      return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };


    /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */
    P.isNaN = function () {
      return !this.s;
    };


    /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */
    P.isNegative = function () {
      return this.s < 0;
    };


    /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */
    P.isPositive = function () {
      return this.s > 0;
    };


    /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */
    P.isZero = function () {
      return !!this.c && this.c[0] == 0;
    };


    /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */
    P.minus = function (y, b) {
      var i, j, t, xLTy,
        x = this,
        a = x.s;

      y = new BigNumber(y, b);
      b = y.s;

      // Either NaN?
      if (!a || !b) return new BigNumber(NaN);

      // Signs differ?
      if (a != b) {
        y.s = -b;
        return x.plus(y);
      }

      var xe = x.e / LOG_BASE,
        ye = y.e / LOG_BASE,
        xc = x.c,
        yc = y.c;

      if (!xe || !ye) {

        // Either Infinity?
        if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);

        // Either zero?
        if (!xc[0] || !yc[0]) {

          // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
          return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x :

           // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
           ROUNDING_MODE == 3 ? -0 : 0);
        }
      }

      xe = bitFloor(xe);
      ye = bitFloor(ye);
      xc = xc.slice();

      // Determine which is the bigger number.
      if (a = xe - ye) {

        if (xLTy = a < 0) {
          a = -a;
          t = xc;
        } else {
          ye = xe;
          t = yc;
        }

        t.reverse();

        // Prepend zeros to equalise exponents.
        for (b = a; b--; t.push(0));
        t.reverse();
      } else {

        // Exponents equal. Check digit by digit.
        j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;

        for (a = b = 0; b < j; b++) {

          if (xc[b] != yc[b]) {
            xLTy = xc[b] < yc[b];
            break;
          }
        }
      }

      // x < y? Point xc to the array of the bigger number.
      if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;

      b = (j = yc.length) - (i = xc.length);

      // Append zeros to xc if shorter.
      // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
      if (b > 0) for (; b--; xc[i++] = 0);
      b = BASE - 1;

      // Subtract yc from xc.
      for (; j > a;) {

        if (xc[--j] < yc[j]) {
          for (i = j; i && !xc[--i]; xc[i] = b);
          --xc[i];
          xc[j] += BASE;
        }

        xc[j] -= yc[j];
      }

      // Remove leading zeros and adjust exponent accordingly.
      for (; xc[0] == 0; xc.splice(0, 1), --ye);

      // Zero?
      if (!xc[0]) {

        // Following IEEE 754 (2008) 6.3,
        // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
        y.s = ROUNDING_MODE == 3 ? -1 : 1;
        y.c = [y.e = 0];
        return y;
      }

      // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
      // for finite x and y.
      return normalise(y, xc, ye);
    };


    /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */
    P.modulo = P.mod = function (y, b) {
      var q, s,
        x = this;

      y = new BigNumber(y, b);

      // Return NaN if x is Infinity or NaN, or y is NaN or zero.
      if (!x.c || !y.s || y.c && !y.c[0]) {
        return new BigNumber(NaN);

      // Return x if y is Infinity or x is zero.
      } else if (!y.c || x.c && !x.c[0]) {
        return new BigNumber(x);
      }

      if (MODULO_MODE == 9) {

        // Euclidian division: q = sign(y) * floor(x / abs(y))
        // r = x - qy    where  0 <= r < abs(y)
        s = y.s;
        y.s = 1;
        q = div(x, y, 0, 3);
        y.s = s;
        q.s *= s;
      } else {
        q = div(x, y, 0, MODULO_MODE);
      }

      y = x.minus(q.times(y));

      // To match JavaScript %, ensure sign of zero is sign of dividend.
      if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;

      return y;
    };


    /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */
    P.multipliedBy = P.times = function (y, b) {
      var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
        base, sqrtBase,
        x = this,
        xc = x.c,
        yc = (y = new BigNumber(y, b)).c;

      // Either NaN, ±Infinity or ±0?
      if (!xc || !yc || !xc[0] || !yc[0]) {

        // Return NaN if either is NaN, or one is 0 and the other is Infinity.
        if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
          y.c = y.e = y.s = null;
        } else {
          y.s *= x.s;

          // Return ±Infinity if either is ±Infinity.
          if (!xc || !yc) {
            y.c = y.e = null;

          // Return ±0 if either is ±0.
          } else {
            y.c = [0];
            y.e = 0;
          }
        }

        return y;
      }

      e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
      y.s *= x.s;
      xcL = xc.length;
      ycL = yc.length;

      // Ensure xc points to longer array and xcL to its length.
      if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;

      // Initialise the result array with zeros.
      for (i = xcL + ycL, zc = []; i--; zc.push(0));

      base = BASE;
      sqrtBase = SQRT_BASE;

      for (i = ycL; --i >= 0;) {
        c = 0;
        ylo = yc[i] % sqrtBase;
        yhi = yc[i] / sqrtBase | 0;

        for (k = xcL, j = i + k; j > i;) {
          xlo = xc[--k] % sqrtBase;
          xhi = xc[k] / sqrtBase | 0;
          m = yhi * xlo + xhi * ylo;
          xlo = ylo * xlo + ((m % sqrtBase) * sqrtBase) + zc[j] + c;
          c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
          zc[j--] = xlo % base;
        }

        zc[j] = c;
      }

      if (c) {
        ++e;
      } else {
        zc.splice(0, 1);
      }

      return normalise(y, zc, e);
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */
    P.negated = function () {
      var x = new BigNumber(this);
      x.s = -x.s || null;
      return x;
    };


    /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */
    P.plus = function (y, b) {
      var t,
        x = this,
        a = x.s;

      y = new BigNumber(y, b);
      b = y.s;

      // Either NaN?
      if (!a || !b) return new BigNumber(NaN);

      // Signs differ?
       if (a != b) {
        y.s = -b;
        return x.minus(y);
      }

      var xe = x.e / LOG_BASE,
        ye = y.e / LOG_BASE,
        xc = x.c,
        yc = y.c;

      if (!xe || !ye) {

        // Return ±Infinity if either ±Infinity.
        if (!xc || !yc) return new BigNumber(a / 0);

        // Either zero?
        // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
        if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
      }

      xe = bitFloor(xe);
      ye = bitFloor(ye);
      xc = xc.slice();

      // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
      if (a = xe - ye) {
        if (a > 0) {
          ye = xe;
          t = yc;
        } else {
          a = -a;
          t = xc;
        }

        t.reverse();
        for (; a--; t.push(0));
        t.reverse();
      }

      a = xc.length;
      b = yc.length;

      // Point xc to the longer array, and b to the shorter length.
      if (a - b < 0) t = yc, yc = xc, xc = t, b = a;

      // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
      for (a = 0; b;) {
        a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
        xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
      }

      if (a) {
        xc = [a].concat(xc);
        ++ye;
      }

      // No need to check for zero, as +x + +y != 0 && -x + -y != 0
      // ye = MAX_EXP + 1 possible
      return normalise(y, xc, ye);
    };


    /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */
    P.precision = P.sd = function (sd, rm) {
      var c, n, v,
        x = this;

      if (sd != null && sd !== !!sd) {
        intCheck(sd, 1, MAX);
        if (rm == null) rm = ROUNDING_MODE;
        else intCheck(rm, 0, 8);

        return round(new BigNumber(x), sd, rm);
      }

      if (!(c = x.c)) return null;
      v = c.length - 1;
      n = v * LOG_BASE + 1;

      if (v = c[v]) {

        // Subtract the number of trailing zeros of the last element.
        for (; v % 10 == 0; v /= 10, n--);

        // Add the number of digits of the first element.
        for (v = c[0]; v >= 10; v /= 10, n++);
      }

      if (sd && x.e + 1 > n) n = x.e + 1;

      return n;
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */
    P.shiftedBy = function (k) {
      intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
      return this.times('1e' + k);
    };


    /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */
    P.squareRoot = P.sqrt = function () {
      var m, n, r, rep, t,
        x = this,
        c = x.c,
        s = x.s,
        e = x.e,
        dp = DECIMAL_PLACES + 4,
        half = new BigNumber('0.5');

      // Negative/NaN/Infinity/zero?
      if (s !== 1 || !c || !c[0]) {
        return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
      }

      // Initial estimate.
      s = Math.sqrt(+x);

      // Math.sqrt underflow/overflow?
      // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
      if (s == 0 || s == 1 / 0) {
        n = coeffToString(c);
        if ((n.length + e) % 2 == 0) n += '0';
        s = Math.sqrt(n);
        e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);

        if (s == 1 / 0) {
          n = '1e' + e;
        } else {
          n = s.toExponential();
          n = n.slice(0, n.indexOf('e') + 1) + e;
        }

        r = new BigNumber(n);
      } else {
        r = new BigNumber(s + '');
      }

      // Check for zero.
      // r could be zero if MIN_EXP is changed after the this value was created.
      // This would cause a division by zero (x/t) and hence Infinity below, which would cause
      // coeffToString to throw.
      if (r.c[0]) {
        e = r.e;
        s = e + dp;
        if (s < 3) s = 0;

        // Newton-Raphson iteration.
        for (; ;) {
          t = r;
          r = half.times(t.plus(div(x, t, dp, 1)));

          if (coeffToString(t.c  ).slice(0, s) === (n =
             coeffToString(r.c)).slice(0, s)) {

            // The exponent of r may here be one less than the final result exponent,
            // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
            // are indexed correctly.
            if (r.e < e) --s;
            n = n.slice(s - 3, s + 1);

            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
            // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
            // iteration.
            if (n == '9999' || !rep && n == '4999') {

              // On the first iteration only, check to see if rounding up gives the
              // exact result as the nines may infinitely repeat.
              if (!rep) {
                round(t, t.e + DECIMAL_PLACES + 2, 0);

                if (t.times(t).eq(x)) {
                  r = t;
                  break;
                }
              }

              dp += 4;
              s += 4;
              rep = 1;
            } else {

              // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
              // result. If not, then there are further digits and m will be truthy.
              if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

                // Truncate to the first rounding digit.
                round(r, r.e + DECIMAL_PLACES + 2, 1);
                m = !r.times(r).eq(x);
              }

              break;
            }
          }
        }
      }

      return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };


    /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.toExponential = function (dp, rm) {
      if (dp != null) {
        intCheck(dp, 0, MAX);
        dp++;
      }
      return format(this, dp, rm, 1);
    };


    /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.toFixed = function (dp, rm) {
      if (dp != null) {
        intCheck(dp, 0, MAX);
        dp = dp + this.e + 1;
      }
      return format(this, dp, rm);
    };


    /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the FORMAT object (see BigNumber.set).
     *
     * FORMAT = {
     *      decimalSeparator : '.',
     *      groupSeparator : ',',
     *      groupSize : 3,
     *      secondaryGroupSize : 0,
     *      fractionGroupSeparator : '\xA0',    // non-breaking space
     *      fractionGroupSize : 0
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.toFormat = function (dp, rm) {
      var str = this.toFixed(dp, rm);

      if (this.c) {
        var i,
          arr = str.split('.'),
          g1 = +FORMAT.groupSize,
          g2 = +FORMAT.secondaryGroupSize,
          groupSeparator = FORMAT.groupSeparator,
          intPart = arr[0],
          fractionPart = arr[1],
          isNeg = this.s < 0,
          intDigits = isNeg ? intPart.slice(1) : intPart,
          len = intDigits.length;

        if (g2) i = g1, g1 = g2, g2 = i, len -= i;

        if (g1 > 0 && len > 0) {
          i = len % g1 || g1;
          intPart = intDigits.substr(0, i);

          for (; i < len; i += g1) {
            intPart += groupSeparator + intDigits.substr(i, g1);
          }

          if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
          if (isNeg) intPart = '-' + intPart;
        }

        str = fractionPart
         ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize)
          ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'),
           '$&' + FORMAT.fractionGroupSeparator)
          : fractionPart)
         : intPart;
      }

      return str;
    };


    /*
     * Return a string array representing the value of this BigNumber as a simple fraction with
     * an integer numerator and an integer denominator. The denominator will be a positive
     * non-zero value less than or equal to the specified maximum denominator. If a maximum
     * denominator is not specified, the denominator will be the lowest value necessary to
     * represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */
    P.toFraction = function (md) {
      var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s,
        x = this,
        xc = x.c;

      if (md != null) {
        n = new BigNumber(md);

        // Throw if md is less than one or is not an integer, unless it is Infinity.
        if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
          throw Error
            (bignumberError + 'Argument ' +
              (n.isInteger() ? 'out of range: ' : 'not an integer: ') + md);
        }
      }

      if (!xc) return x.toString();

      d = new BigNumber(ONE);
      n1 = d0 = new BigNumber(ONE);
      d1 = n0 = new BigNumber(ONE);
      s = coeffToString(xc);

      // Determine initial denominator.
      // d is a power of 10 and the minimum max denominator that specifies the value exactly.
      e = d.e = s.length - x.e - 1;
      d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
      md = !md || n.comparedTo(d) > 0 ? (e > 0 ? d : n1) : n;

      exp = MAX_EXP;
      MAX_EXP = 1 / 0;
      n = new BigNumber(s);

      // n0 = d1 = 0
      n0.c[0] = 0;

      for (; ;)  {
        q = div(n, d, 0, 1);
        d2 = d0.plus(q.times(d1));
        if (d2.comparedTo(md) == 1) break;
        d0 = d1;
        d1 = d2;
        n1 = n0.plus(q.times(d2 = n1));
        n0 = d2;
        d = n.minus(q.times(d2 = d));
        n = d2;
      }

      d2 = div(md.minus(d0), d1, 0, 1);
      n0 = n0.plus(d2.times(n1));
      d0 = d0.plus(d2.times(d1));
      n0.s = n1.s = x.s;
      e *= 2;

      // Determine which fraction is closer to x, n0/d0 or n1/d1
      arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(
         div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1
          ? [n1.toString(), d1.toString()]
          : [n0.toString(), d0.toString()];

      MAX_EXP = exp;
      return arr;
    };


    /*
     * Return the value of this BigNumber converted to a number primitive.
     */
    P.toNumber = function () {
      return +this;
    };


    /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */
    P.toPrecision = function (sd, rm) {
      if (sd != null) intCheck(sd, 1, MAX);
      return format(this, sd, rm, 2);
    };


    /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */
    P.toString = function (b) {
      var str,
        n = this,
        s = n.s,
        e = n.e;

      // Infinity or NaN?
      if (e === null) {

        if (s) {
          str = 'Infinity';
          if (s < 0) str = '-' + str;
        } else {
          str = 'NaN';
        }
      } else {
        str = coeffToString(n.c);

        if (b == null) {
          str = e <= TO_EXP_NEG || e >= TO_EXP_POS
           ? toExponential(str, e)
           : toFixedPoint(str, e, '0');
        } else {
          intCheck(b, 2, ALPHABET.length, 'Base');
          str = convertBase(toFixedPoint(str, e, '0'), 10, b, s, true);
        }

        if (s < 0 && n.c[0]) str = '-' + str;
      }

      return str;
    };


    /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */
    P.valueOf = P.toJSON = function () {
      var str,
        n = this,
        e = n.e;

      if (e === null) return n.toString();

      str = coeffToString(n.c);

      str = e <= TO_EXP_NEG || e >= TO_EXP_POS
        ? toExponential(str, e)
        : toFixedPoint(str, e, '0');

      return n.s < 0 ? '-' + str : str;
    };


    P._isBigNumber = true;

    if (configObject != null) BigNumber.set(configObject);

    return BigNumber;
  }


  // PRIVATE HELPER FUNCTIONS


  function bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
  }


  // Return a coefficient array as a string of base 10 digits.
  function coeffToString(a) {
    var s, z,
      i = 1,
      j = a.length,
      r = a[0] + '';

    for (; i < j;) {
      s = a[i++] + '';
      z = LOG_BASE - s.length;
      for (; z--; s = '0' + s);
      r += s;
    }

    // Determine trailing zeros.
    for (j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
  }


  // Compare the value of BigNumbers x and y.
  function compare(x, y) {
    var a, b,
      xc = x.c,
      yc = y.c,
      i = x.s,
      j = y.s,
      k = x.e,
      l = y.e;

    // Either NaN?
    if (!i || !j) return null;

    a = xc && !xc[0];
    b = yc && !yc[0];

    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;

    // Signs differ?
    if (i != j) return i;

    a = i < 0;
    b = k == l;

    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;

    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;

    j = (k = xc.length) < (l = yc.length) ? k : l;

    // Compare digit by digit.
    for (i = 0; i < j; i++) if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;

    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
  }


  /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */
  function intCheck(n, min, max, name) {
    if (n < min || n > max || n !== (n < 0 ? mathceil(n) : mathfloor(n))) {
      throw Error
       (bignumberError + (name || 'Argument') + (typeof n == 'number'
         ? n < min || n > max ? ' out of range: ' : ' not an integer: '
         : ' not a primitive number: ') + n);
    }
  }


  function isArray(obj) {
    return Object.prototype.toString.call(obj) == '[object Array]';
  }


  // Assumes finite n.
  function isOdd(n) {
    var k = n.c.length - 1;
    return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
  }


  function toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) +
     (e < 0 ? 'e' : 'e+') + e;
  }


  function toFixedPoint(str, e, z) {
    var len, zs;

    // Negative exponent?
    if (e < 0) {

      // Prepend zeros.
      for (zs = z + '.'; ++e; zs += z);
      str = zs + str;

    // Positive exponent
    } else {
      len = str.length;

      // Append zeros.
      if (++e > len) {
        for (zs = z, e -= len; --e; zs += z);
        str += zs;
      } else if (e < len) {
        str = str.slice(0, e) + '.' + str.slice(e);
      }
    }

    return str;
  }


  // EXPORT


  BigNumber = clone();
  BigNumber['default'] = BigNumber.BigNumber = BigNumber;

  // AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return BigNumber; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Node.js and other environments that support module.exports.
  } else if (typeof module != 'undefined' && module.exports) {
    module.exports = BigNumber;

  // Browser.
  } else {
    if (!globalObject) {
      globalObject = typeof self != 'undefined' && self ? self : window;
    }

    globalObject.BigNumber = BigNumber;
  }
})(this);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PageFooterComponent_css__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PageFooterComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PageFooterComponent_css__);









var pageFooterClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('page-footer');

var PageFooterComponent = function PageFooterComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'footer',
    { className: pageFooterClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: pageFooterClasses('footer-left-content') },
      context.t('{n}™ {y}. All Rights Reserved.', {
        n: __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].Footer.siteName || __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].global.siteName,
        y: new Date().getFullYear()
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: pageFooterClasses('footer-right-content') },
      __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */], 'Footer.links', []).map(function (column, idx) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: idx, className: pageFooterClasses('text') },
          column.map(function (item, innerIdx) {
            var openInNewWindow = __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].Footer.openInNewWindowGlobal || true;
            if ('openInNewWindow' in item) {
              openInNewWindow = item.openInNewWindow;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                target: openInNewWindow ? '_blank' : '',
                rel: openInNewWindow ? 'noopener noreferrer' : '',
                key: '' + idx + innerIdx,
                href: item.link },
              context.t(item.text)
            );
          })
        );
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: pageFooterClasses('icon') },
        !__WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].Footer.powerOff && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'logo-powered' })
      )
    )
  );
};

PageFooterComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["default"] = (PageFooterComponent);

/***/ }),
/* 62 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBalanceWithProductSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProductFullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAvailableProductBalance; });
/* unused harmony export getDailyPercentageChangeClassModifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__numberFormatter__ = __webpack_require__(7);


var getBalanceWithProductSymbol = function getBalanceWithProductSymbol(productSymbol, productBalance) {
  var applyToUSDOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (productSymbol === 'USD') {
    return '$' + productBalance;
  } else {
    if (applyToUSDOnly) {
      return '' + productBalance;
    } else {
      return productBalance + ' ' + productSymbol;
    }
  }
};

var getProductFullName = function getProductFullName(product) {
  return product ? product.ProductFullName : '';
};

var getAvailableProductBalance = function getAvailableProductBalance(product) {
  var negativeIsNaN = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return product && product.AvailableBalance ? Object(__WEBPACK_IMPORTED_MODULE_0__numberFormatter__["g" /* parseNumberToLocale */])(product.AvailableBalance, undefined, negativeIsNaN) : '';
};

var getDailyPercentageChangeClassModifier = function getDailyPercentageChangeClassModifier(change) {
  if (change < 0) {
    return '24h-negative';
  } else if (change > 0) {
    return '24h-positive';
  } else {
    return '';
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(494);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUS_CHARS = exports.VALID_PUNCTUATION = exports.WHITESPACE = exports.VALID_DIGITS = exports.MAX_LENGTH_COUNTRY_CODE = exports.MAX_LENGTH_FOR_NSN = exports.MIN_LENGTH_FOR_NSN = void 0;
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

exports.MIN_LENGTH_FOR_NSN = MIN_LENGTH_FOR_NSN;
var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

exports.MAX_LENGTH_FOR_NSN = MAX_LENGTH_FOR_NSN;
var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

exports.MAX_LENGTH_COUNTRY_CODE = MAX_LENGTH_COUNTRY_CODE;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

exports.VALID_DIGITS = VALID_DIGITS;
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
exports.WHITESPACE = WHITESPACE;
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
exports.VALID_PUNCTUATION = VALID_PUNCTUATION;
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

exports.PLUS_CHARS = PLUS_CHARS;
//# sourceMappingURL=constants.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var jsSHA = __webpack_require__(1463);
var Blake256 = __webpack_require__(1464);
var _keccak = __webpack_require__(1465)['keccak256'];
var Blake2B = __webpack_require__(1466);
var base58 = __webpack_require__(370);
var base32 = __webpack_require__(1467);
var BigNum = __webpack_require__(1468);

function numberToHex(number) {
    var hex = Math.round(number).toString(16);
    if (hex.length === 1) {
        hex = '0' + hex;
    }
    return hex;
}

function isHexChar(c) {
    if (c >= 'A' && c <= 'F' || c >= 'a' && c <= 'f' || c >= '0' && c <= '9') {
        return 1;
    }
    return 0;
}

/* Convert a hex char to value */
function hexChar2byte(c) {
    var d = 0;
    if (c >= 'A' && c <= 'F') {
        d = c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
    } else if (c >= 'a' && c <= 'f') {
        d = c.charCodeAt(0) - 'a'.charCodeAt(0) + 10;
    } else if (c >= '0' && c <= '9') {
        d = c.charCodeAt(0) - '0'.charCodeAt(0);
    }
    return d;
}

/* Convert a byte to string */
function byte2hexStr(byte) {
    var hexByteMap = "0123456789ABCDEF";
    var str = "";
    str += hexByteMap.charAt(byte >> 4);
    str += hexByteMap.charAt(byte & 0x0f);
    return str;
}

function byteArray2hexStr(byteArray) {
    var str = "";
    for (var i = 0; i < byteArray.length - 1; i++) {
        str += byte2hexStr(byteArray[i]);
    }
    str += byte2hexStr(byteArray[i]);
    return str;
}

function hexStr2byteArray(str) {
    var byteArray = Array();
    var d = 0;
    var i = 0;
    var j = 0;
    var k = 0;

    for (i = 0; i < str.length; i++) {
        var c = str.charAt(i);
        if (isHexChar(c)) {
            d <<= 4;
            d += hexChar2byte(c);
            j++;
            if (0 === j % 2) {
                byteArray[k++] = d;
                d = 0;
            }
        }
    }
    return byteArray;
}

module.exports = {
    toHex: function toHex(arrayOfBytes) {
        var hex = '';
        for (var i = 0; i < arrayOfBytes.length; i++) {
            hex += numberToHex(arrayOfBytes[i]);
        }
        return hex;
    },
    sha256: function sha256(hexString) {
        var sha = new jsSHA('SHA-256', 'HEX');
        sha.update(hexString);
        return sha.getHash('HEX');
    },
    sha256Checksum: function sha256Checksum(payload) {
        return this.sha256(this.sha256(payload)).substr(0, 8);
    },
    blake256: function blake256(hexString) {
        return new Blake256().update(hexString, 'hex').digest('hex');
    },
    blake256Checksum: function blake256Checksum(payload) {
        return this.blake256(this.blake256(payload)).substr(0, 8);
    },
    blake2b: function blake2b(hexString, outlen) {
        return new Blake2B(outlen).update(Buffer.from(hexString, 'hex')).digest('hex');
    },
    keccak256: function keccak256(hexString) {
        return _keccak(hexString);
    },
    keccak256Checksum: function keccak256Checksum(payload) {
        return _keccak(payload).toString().substr(0, 8);
    },
    blake2b256: function blake2b256(hexString) {
        return new Blake2B(32).update(Buffer.from(hexString, 'hex'), 32).digest('hex');
    },
    base58: base58.decode,
    byteArray2hexStr: byteArray2hexStr,
    hexStr2byteArray: hexStr2byteArray,
    bigNumberToBuffer: function bigNumberToBuffer(bignumber, size) {
        return new BigNum(bignumber).toBuffer({ size: size, endian: 'big' });
    },
    base32: base32
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).Buffer))

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);


var createBuffer = __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from && __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].alloc && __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].allocUnsafe && __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].allocUnsafeSlow ? __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from : // support for Node < 5.10
function (val) {
  return new __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"](val);
};

/* harmony default export */ __webpack_exports__["a"] = (createBuffer);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (model, calc) {
  var fn = function fn(buf, previous) {
    return calc(buf, previous) >>> 0;
  };
  fn.signed = calc;
  fn.unsigned = fn;
  fn.model = model;

  return fn;
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function resize(WrappedComponent) {
  var ModifiedComponent = function (_React$Component) {
    _inherits(ModifiedComponent, _React$Component);

    function ModifiedComponent(props) {
      _classCallCheck(this, ModifiedComponent);

      var _this = _possibleConstructorReturn(this, (ModifiedComponent.__proto__ || Object.getPrototypeOf(ModifiedComponent)).call(this, props));

      _this.handleWindowSizeChange = function () {
        _this.setState({ width: window.innerWidth, height: window.innerHeight });
      };

      _this.state = {
        width: window.innerWidth,
        height: window.innerHeight
      };
      _this.throttle = __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(_this.handleWindowSizeChange, 100);
      return _this;
    }

    _createClass(ModifiedComponent, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        window.addEventListener('resize', this.throttle);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.throttle);
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            width = _state.width,
            height = _state.height;


        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, Object.assign({ width: width, height: height }, this.props));
      }
    }]);

    return ModifiedComponent;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  return ModifiedComponent;
}

/* harmony default export */ __webpack_exports__["a"] = (resize);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(446);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* unused harmony export __HistoryContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var historyContext =
/*#__PURE__*/
createNamedContext("Router-History");

// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext$1 = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext$1("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(historyContext);
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(1108)
var isDate = __webpack_require__(137)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_PRODUCT_WITHDRAW_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_PRODUCT_WITHDRAW_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_WITHDRAW_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_WITHDRAW_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECEIVE_WITHDRAW_TEMPLATES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RECEIVE_WITHDRAW_TEMPLATE_ERROR; });
/* unused harmony export SUBMITTING_WITHDRAW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECEIVE_WITHDRAW_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RECEIVE_WITHDRAW_TICKETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RECEIVE_WITHDRAW_WORKFLOW_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_WITHDRAW_FEE; });
/* unused harmony export RETAIL_FIAT_CONFIRM_WITHDRAW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_WITHDRAWAL_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchProductWithdrawTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchProductWithdrawTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return createWithdrawTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getWithdrawFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return cancelWithdrawTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return subscribeToWithdrawalTickets; });
/* unused harmony export addWithdrawalTicket */
/* unused harmony export fetchingWithdrawTemplates */
/* unused harmony export fetchingWithdrawTemplate */
/* unused harmony export receiveWithdrawTemplates */
/* unused harmony export receiveWithdrawTemplate */
/* unused harmony export withdrawTemplatesError */
/* unused harmony export withdrawTemplateError */
/* unused harmony export submittingWithdraw */
/* unused harmony export receiveWithdrawTicket */
/* unused harmony export receiveWithdrawFee */
/* unused harmony export receiveWithdrawTickets */
/* unused harmony export receiveWithdrawWorkflowInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getWithdrawTickets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_withdrawSubscriptionService__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_errorTextFormatter__ = __webpack_require__(119);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _this = this;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var FETCH_PRODUCT_WITHDRAW_TEMPLATES = 'FETCH_PRODUCT_WITHDRAW_TEMPLATES';
var FETCH_PRODUCT_WITHDRAW_TEMPLATE = 'FETCH_PRODUCT_WITHDRAW_TEMPLATE';
var RECEIVE_WITHDRAW_TEMPLATES = 'RECEIVE_WITHDRAW_TEMPLATES';
var RECEIVE_WITHDRAW_TEMPLATE = 'RECEIVE_WITHDRAW_TEMPLATE';
var RECEIVE_WITHDRAW_TEMPLATES_ERROR = 'RECEIVE_WITHDRAW_TEMPLATE_ERROR';
var RECEIVE_WITHDRAW_TEMPLATE_ERROR = 'RECEIVE_WITHDRAW_TEMPLATE_ERROR';
var SUBMITTING_WITHDRAW = 'SUBMITTING_WITHDRAW';
var RECEIVE_WITHDRAW_TICKET = 'RECEIVE_WITHDRAW_TICKET';
var RECEIVE_WITHDRAW_TICKETS = 'RECEIVE_WITHDRAW_TICKETS';
var RECEIVE_WITHDRAW_WORKFLOW_INFO = 'RECEIVE_WITHDRAW_WORKFLOW_INFO';
var RECEIVE_WITHDRAW_FEE = 'RECEIVE_WITHDRAW_FEE';
var RETAIL_FIAT_CONFIRM_WITHDRAW = 'RETAIL_FIAT_CONFIRM_DEPOSIT';
var ADD_WITHDRAWAL_TICKET = 'ADD_WITHDRAWAL_TICKET';

var fetchProductWithdrawTemplates = function fetchProductWithdrawTemplates(productId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var payload, data, _data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(fetchingWithdrawTemplates);
              payload = {
                ProductId: productId,
                OMSId: getState().user.userInfo.OMSId,
                AccountId: getState().user.selectedAccountId
              };
              _context.prev = 2;
              _context.next = 5;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetWithdrawFormTemplateTypes', payload));

            case 5:
              data = _context.sent;

              if (!data.result) {
                _context.next = 12;
                break;
              }

              if (data.TemplateTypes.length) {
                _context.next = 9;
                break;
              }

              return _context.abrupt('return', dispatch(withdrawTemplatesError('There are no providers configured for this product')));

            case 9:
              dispatch(receiveWithdrawTemplates(data.TemplateTypes));
              if (data.TemplateTypes.length === 1) {
                dispatch(fetchProductWithdrawTemplate(productId, data.TemplateTypes[0].TemplateName));
              }
              return _context.abrupt('return', true);

            case 12:
              return _context.abrupt('return', dispatch(withdrawTemplatesError(data.errormsg)));

            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](2);
              _context.next = 19;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetWithdrawTemplateTypes', payload));

            case 19:
              _data = _context.sent;

              if (_data.result) {
                dispatch(fetchProductWithdrawTemplate(productId, _data.TemplateTypes[0]));
              }
              dispatch(withdrawTemplatesError(_data.errormsg));

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 15]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var fetchProductWithdrawTemplate = function fetchProductWithdrawTemplate(productId, templateType) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var templateTypeObj, payload, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fetchingWithdrawTemplate(productId, templateType));
              templateTypeObj = getState().withdraw.templateTypes.find(function (type) {
                return type.TemplateName === templateType;
              });
              payload = Object.assign({
                OMSId: getState().user.userInfo.OMSId,
                AccountId: getState().user.selectedAccountId,
                ProductId: productId,
                TemplateType: templateType
              }, options);

              if (templateTypeObj) {
                payload.AccountProviderId = templateTypeObj.AccountProviderId;
              }
              _context2.next = 6;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetWithdrawTemplate', payload));

            case 6:
              data = _context2.sent;

              if (!(data.result && data.Template)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt('return', dispatch(receiveWithdrawTemplate(data)));

            case 9:
              return _context2.abrupt('return', dispatch(withdrawTemplateError(data.errormsg)));

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var createWithdrawTicket = function createWithdrawTicket(_ref3) {
  var ProductId = _ref3.ProductId,
      amount = _ref3.amount,
      iconFileName = _ref3.iconFileName,
      ProductSymbol = _ref3.ProductSymbol,
      ProductFullName = _ref3.ProductFullName,
      TemplateType = _ref3.TemplateType,
      info = _objectWithoutProperties(_ref3, ['ProductId', 'amount', 'iconFileName', 'ProductSymbol', 'ProductFullName', 'TemplateType']);

  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var OMSId, AccountId, templateForm, templateType, templateTypeObj, payload, withdrawStatus, workflowDetail;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(submittingWithdraw);
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              templateForm = info.TemplateForm || info;
              templateType = TemplateType || getState().withdraw.templateType;
              templateTypeObj = getState().withdraw.templateTypes.find(function (template) {
                return template.TemplateName === templateType;
              });
              // Since undefined is not serializable we default every prop to an empty string to avoid missing fields

              Object.keys(templateForm).forEach(function (prop) {
                return templateForm[prop] = templateForm[prop] || '';
              });

              payload = {
                OMSId: OMSId,
                AccountId: AccountId,
                ProductId: +ProductId,
                Amount: +info.Amount,
                TemplateForm: JSON.stringify(templateForm),
                TemplateType: templateType
              };


              if (templateTypeObj) {
                payload.AccountProviderId = templateTypeObj.AccountProviderId;
              }

              _context3.next = 11;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CreateWithdrawTicket', payload));

            case 11:
              withdrawStatus = _context3.sent;

              if (!(withdrawStatus.result === false)) {
                _context3.next = 14;
                break;
              }

              return _context3.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'withdrawRejectSnack',
                text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_errorTextFormatter__["a" /* formatErrorText */])(withdrawStatus),
                type: 'warning'
              })));

            case 14:
              _context3.prev = 14;
              workflowDetail = JSON.parse(withdrawStatus.detail);

              if (!((typeof workflowDetail === 'undefined' ? 'undefined' : _typeof(workflowDetail)) === 'object' && workflowDetail.ReplyObject && workflowDetail.ReplyObject !== '0')) {
                _context3.next = 18;
                break;
              }

              return _context3.abrupt('return', dispatch(receiveWithdrawWorkflowInfo(workflowDetail)));

            case 18:
              _context3.next = 22;
              break;

            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3['catch'](14);

            case 22:

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__sidePaneActions__["k" /* closeWithdrawSidePane */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'withdrawSuccessSnack',
                // context.t("Your withdraw has been successfully added, please check email for instructions.")
                text: 'Your withdraw has been successfully added, please check email for instructions.',
                type: 'success'
              }));

              dispatch(receiveWithdrawTicket(withdrawStatus));
              return _context3.abrupt('return', dispatch(getWithdrawTickets(AccountId, OMSId)));

            case 26:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[14, 20]]);
    }));

    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};


var getWithdrawFee = function getWithdrawFee(ProductId, Amount) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var OMSId, AccountId, payload, withdrawFee;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              payload = {
                OMSId: OMSId,
                ProductId: ProductId,
                AccountId: AccountId,
                Amount: Amount
              };
              _context4.next = 5;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetWithdrawFee', payload));

            case 5:
              withdrawFee = _context4.sent;

              if (!(withdrawFee.result === false)) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'withdrawRejectSnack',
                text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_errorTextFormatter__["a" /* formatErrorText */])(withdrawFee),
                type: 'warning'
              })));

            case 8:
              dispatch(receiveWithdrawFee(withdrawFee));

            case 9:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var cancelWithdrawTicket = function cancelWithdrawTicket(_ref6) {
  var RequestCode = _ref6.RequestCode;
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      var _getState$user$userIn, OMSId, UserId, AccountId, payload, withdrawStatus;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _getState$user$userIn = getState().user.userInfo, OMSId = _getState$user$userIn.OMSId, UserId = _getState$user$userIn.UserId;
              AccountId = getState().user.selectedAccountId;
              payload = {
                OMSId: OMSId,
                UserId: UserId,
                AccountId: AccountId,
                RequestCode: RequestCode
              };
              _context5.next = 5;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CancelWithdraw', payload));

            case 5:
              withdrawStatus = _context5.sent;

              if (!(withdrawStatus.result === false)) {
                _context5.next = 8;
                break;
              }

              return _context5.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'cancelWithdrawSnack',
                text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_errorTextFormatter__["a" /* formatErrorText */])(withdrawStatus),
                type: 'warning'
              })));

            case 8:
              // context.t('Your withdraw has been successfully canceled')
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'cancelWithdrawSuccessSnack',
                text: 'Your withdraw has been successfully canceled',
                type: 'success'
              }));
              dispatch(getWithdrawTickets(AccountId, OMSId));

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x10, _x11) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var subscribeToWithdrawalTickets = function subscribeToWithdrawalTickets() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_withdrawSubscriptionService__["a" /* default */].subscribe(function (updates) {
      dispatch(addWithdrawalTicket(updates));
    });
  };
};

var addWithdrawalTicket = function addWithdrawalTicket(payload) {
  return {
    type: ADD_WITHDRAWAL_TICKET,
    payload: payload
  };
};

var fetchingWithdrawTemplates = {
  type: FETCH_PRODUCT_WITHDRAW_TEMPLATES
};
var fetchingWithdrawTemplate = function fetchingWithdrawTemplate(product, templateType) {
  return {
    type: FETCH_PRODUCT_WITHDRAW_TEMPLATE,
    payload: { product: product, templateType: templateType }
  };
};
var receiveWithdrawTemplates = function receiveWithdrawTemplates(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATES,
    payload: payload
  };
};
var receiveWithdrawTemplate = function receiveWithdrawTemplate(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATE,
    payload: payload
  };
};
var withdrawTemplatesError = function withdrawTemplatesError(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATES_ERROR,
    payload: payload
  };
};
var withdrawTemplateError = function withdrawTemplateError(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATE_ERROR,
    payload: payload
  };
};
var submittingWithdraw = { type: SUBMITTING_WITHDRAW };

var receiveWithdrawTicket = function receiveWithdrawTicket(payload) {
  return {
    type: RECEIVE_WITHDRAW_TICKET,
    payload: payload
  };
};

var receiveWithdrawFee = function receiveWithdrawFee(payload) {
  return {
    type: RECEIVE_WITHDRAW_FEE,
    payload: payload
  };
};

var receiveWithdrawTickets = function receiveWithdrawTickets(payload) {
  return {
    type: RECEIVE_WITHDRAW_TICKETS,
    payload: payload
  };
};

var receiveWithdrawWorkflowInfo = function receiveWithdrawWorkflowInfo(payload) {
  return {
    type: RECEIVE_WITHDRAW_WORKFLOW_INFO,
    payload: payload
  };
};

var getWithdrawTickets = function getWithdrawTickets(AccountId, OMSId) {
  return function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch) {
      var withdrawTickets;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetWithdrawTickets', {
                AccountId: AccountId,
                OMSId: OMSId
              }));

            case 2:
              withdrawTickets = _context6.sent;

              dispatch(receiveWithdrawTickets(withdrawTickets));

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function (_x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchInstruments; });
/* unused harmony export SELECT_INSTRUMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectInstrument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_INSTRUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setInstrument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REQUEST_INSTRUMENTS; });
/* unused harmony export requestInstruments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_INSTRUMENTS; });
/* unused harmony export receiveInstruments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__level1Actions__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__level2Actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recentTradesActions__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_filterSortSupportedInstruments__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_marginActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tickersActions__ = __webpack_require__(99);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










var fetchInstruments = function fetchInstruments() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var selectedInstrumentId, instruments, filteredInstruments, instrumentId, store;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedInstrumentId = options.selectedInstrumentId;
              _context.prev = 1;

              dispatch(requestInstruments());

              _context.next = 5;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetInstruments', { OMSId: 1 }));

            case 5:
              instruments = _context.sent;
              filteredInstruments = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_filterSortSupportedInstruments__["a" /* default */])(instruments);


              dispatch(receiveInstruments(filteredInstruments));

              if (filteredInstruments.length) {
                _context.next = 10;
                break;
              }

              return _context.abrupt('return');

            case 10:
              instrumentId = filteredInstruments.some(function (i) {
                return i.InstrumentId === selectedInstrumentId;
              }) ? selectedInstrumentId : filteredInstruments[0].InstrumentId;


              dispatch(setInstrument(instrumentId));
              store = getState();


              if (store.apexCore.level2.fetching) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__level2Actions__["e" /* getLevel2Data */])(instrumentId));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__level2Actions__["f" /* subscribeToLevel2 */])());
              }

              if (!__WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].global.privateMarketData) {
                if (Object.keys(store.apexCore.level1).length == 0) {
                  filteredInstruments.forEach(function (_ref2) {
                    var InstrumentId = _ref2.InstrumentId;

                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__level1Actions__["b" /* getLevel1Data */])(InstrumentId));
                  });
                }

                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__level1Actions__["c" /* subscribeToLevel1 */])(selectedInstrumentId));
                if (store.recentTrades.fetching) {
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__recentTradesActions__["e" /* getRecentTrades */])(instrumentId));
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__recentTradesActions__["f" /* subscribeToRecentTrades */])());
                }
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__tickersActions__["f" /* fetchTickers */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__tickersActions__["g" /* subscribeToTickers */])());
              }
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](1);

              console.error(_context.t0);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 17]]);
    }));

    return function (_x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

var SELECT_INSTRUMENT = 'SELECT_INSTRUMENT';
var selectInstrument = function selectInstrument(instrumentId) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var selectedInstrumentId, tradingStyleFormObj;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
              tradingStyleFormObj = getState().form.tradingStyle;

              if (tradingStyleFormObj) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_marginActions__["s" /* setMarginInstrument */])(instrumentId));
                dispatch(setInstrument(instrumentId));
              } else {
                dispatch(setInstrument(instrumentId));
              }

              localStorage.setItem('selectedInstrumentId', instrumentId);

              // resubscribe to level2
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__level1Actions__["c" /* subscribeToLevel1 */])(instrumentId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__level2Actions__["g" /* unsubscribeLevel2 */])(selectedInstrumentId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__level2Actions__["e" /* getLevel2Data */])(instrumentId));

              if (!__WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].global.privateMarketData) {
                // resubscribe to trades
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__recentTradesActions__["g" /* unsubscribeRecentTrades */])(selectedInstrumentId));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__recentTradesActions__["e" /* getRecentTrades */])(instrumentId));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__recentTradesActions__["f" /* subscribeToRecentTrades */])());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__tickersActions__["h" /* unsubscribeTicker */])(selectedInstrumentId)).then(function () {
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__tickersActions__["f" /* fetchTickers */])());
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__tickersActions__["g" /* subscribeToTickers */])());
                });
              }

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var SET_INSTRUMENT = 'SET_INSTRUMENT';
var setInstrument = function setInstrument(instrumentId) {
  return {
    type: SET_INSTRUMENT,
    payload: instrumentId
  };
};

var REQUEST_INSTRUMENTS = 'REQUEST_INSTRUMENTS';
var requestInstruments = function requestInstruments() {
  return {
    type: REQUEST_INSTRUMENTS,
    payload: ''
  };
};

var RECEIVE_INSTRUMENTS = 'RECEIVE_INSTRUMENTS';
var receiveInstruments = function receiveInstruments(instruments) {
  return {
    type: RECEIVE_INSTRUMENTS,
    payload: instruments
  };
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMarginProductById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return marginProductSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productsTotalAmountSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__positionSelectors__ = __webpack_require__(52);





var getMarginProductById = function getMarginProductById(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
    return state.margin.product.products;
  }], function (products) {
    return products.find(function (p) {
      return p.AccountPosition.ProductId === id;
    });
  });
};

var marginProductSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.margin.product.products;
}, __WEBPACK_IMPORTED_MODULE_3__positionSelectors__["b" /* positionSelector */], function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return state.productManifest.manifest;
}, function (state) {
  return state.user.userConfig;
}, function () {
  return __WEBPACK_IMPORTED_MODULE_1__config__["b" /* default */];
}, function (marginProducts, positions, products, manifest, userConfig, apexWebConfig) {
  var BaseCurrency = (userConfig.find(function (config) {
    return config.Key === 'BaseCurrency';
  }) || {}).Value || 'USD';

  var supportedProducts = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(apexWebConfig, 'global.products', []);
  var standardProducts = Object.values(products);

  return marginProducts.filter(function (product) {
    var stdProduct = standardProducts.find(function (i) {
      return i.ProductId === product.AccountPosition.ProductId;
    });
    if (!stdProduct || __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(stdProduct, 'IsDisabled', true)) return false;
    if (!supportedProducts.length) return true;
    return supportedProducts.includes(product.AccountPosition.ProductSymbol);
  }).map(function (product) {
    var position = product.AccountPosition;
    var standardProduct = Object.values(products).find(function (standardProduct) {
      return standardProduct.ProductId === position.ProductId;
    });
    var standardPosition = positions[standardProduct.ProductId];
    var StandardAmount = standardPosition ? standardPosition.Amount : 0;

    var ProductSymbol = standardPosition ? standardPosition.ProductSymbol : product.AccountPosition.ProductSymbol;
    var iconFileName = manifest[ProductSymbol] ? manifest[ProductSymbol].iconFileName : ProductSymbol + 'DEFAULT_ICON';

    var ProductFullName = standardProduct ? standardProduct.ProductFullName : '';

    return {
      ProductId: position.ProductId,
      MarginAmount: position.Amount,
      BorrowingPower: product.BorrowingPower,
      ProductPrice: product.ProductPrice,
      BaseCurrency: BaseCurrency,
      StandardAmount: StandardAmount,
      iconFileName: iconFileName,
      ProductFullName: ProductFullName,
      ProductSymbol: ProductSymbol,
      Hold: product.AccountPosition.Hold
    };
  });
});

var productsTotalAmountSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(marginProductSelector, function (state) {
  return state.user.userConfig;
}, function (products, userConfig) {
  var baseCurrency = (userConfig.find(function (config) {
    return config.Key === 'BaseCurrency';
  }) || {}).Value || 'USD';

  var standardTotalValue = 0;
  var marginTotalValue = 0;
  var borrowingTotalValue = 0;
  products.forEach(function (product) {
    standardTotalValue += product.StandardAmount * product.ProductPrice;
    marginTotalValue += product.MarginAmount * product.ProductPrice;
  });
  if (products.length > 0) {
    borrowingTotalValue = products[0].BorrowingPower * products[0].ProductPrice;
  }

  return {
    StandardTotalValue: standardTotalValue,
    MarginTotalValue: marginTotalValue,
    BorrowingTotalValue: borrowingTotalValue,
    BaseCurrency: baseCurrency
  };
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MIN_LENGTH_FOR_NSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_LENGTH_FOR_NSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_LENGTH_COUNTRY_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VALID_DIGITS; });
/* unused harmony export WHITESPACE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALID_PUNCTUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PLUS_CHARS; });
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
//# sourceMappingURL=constants.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_positionActions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BalancesMenuComponent__ = __webpack_require__(1972);





var mapStateToProps = function mapStateToProps(state) {
  var positions = Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state);
  var position = state.apexCore.position;
  var selectedProductId = position.selectedProductId;

  return { positions: positions, selectedProductId: selectedProductId };
};

var mapDispatchToProps = {
  selectPositionAndSave: __WEBPACK_IMPORTED_MODULE_2__redux_actions_positionActions__["f" /* selectPositionAndSave */]
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__BalancesMenuComponent__["a" /* default */]));

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_FullPageSpinner_FullPageSpinner__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_path__ = __webpack_require__(27);







function withAuthentication(WrappedComponent) {
  var ModifiedComponent = function ModifiedComponent(props) {
    var isAuthenticated = props.isAuthenticated,
        location = props.location,
        pendingAuth = props.pendingAuth,
        redirectFromLogin = props.redirectFromLogin;

    if (pendingAuth) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_FullPageSpinner_FullPageSpinner__["a" /* default */], null);
    }
    if (!isAuthenticated) {
      redirectFromLogin(location);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */], { to: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])('/login') });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      pendingAuth: state.auth.pending
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      redirectFromLogin: function redirectFromLogin(location) {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["k" /* redirectFromLogin */])(location));
      }
    };
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ModifiedComponent);
}

/* harmony default export */ __webpack_exports__["a"] = (withAuthentication);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_ACCOUNT_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_ACCOUNT_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_POSITION_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELECT_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAccountPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return subscribeToAccountPositionEvents; });
/* unused harmony export receivePositionsEvent */
/* unused harmony export requestingAccountPositions */
/* unused harmony export receiveAccountPositions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectPositionAndSave; });
/* unused harmony export selectPosition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_filterSortSupportedProducts__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_subscriptions_accountPositionSubscriptionService__ = __webpack_require__(1112);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var REQUEST_ACCOUNT_POSITIONS = 'REQUEST_ACCOUNT_POSITIONS';
var RECEIVE_ACCOUNT_POSITIONS = 'RECEIVE_ACCOUNT_POSITIONS';
var RECEIVE_POSITION_EVENT = 'RECEIVE_POSITION_EVENT';
var SELECT_POSITION = 'SELECT_POSITION';

var getAccountPositions = function getAccountPositions(params) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var positions, filteredSortedPositions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestingAccountPositions);
              _context.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetAccountPositions', params));

            case 3:
              positions = _context.sent;

              if (!(positions instanceof Array)) {
                _context.next = 10;
                break;
              }

              filteredSortedPositions = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_filterSortSupportedProducts__["a" /* default */])(positions);

              dispatch(receiveAccountPositions({
                AccountId: params.accountId,
                data: filteredSortedPositions
              }));

              return _context.abrupt('return', filteredSortedPositions);

            case 10:
              console.log(positions);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var subscribeToAccountPositionEvents = function subscribeToAccountPositionEvents(AccountId) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : receivePositionsEvent;
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_3__services_subscriptions_accountPositionSubscriptionService__["a" /* default */].subscribe(function (update) {
      if (update.AccountId === AccountId) {
        dispatch(callback(update));
      }
    });
  };
};

var receivePositionsEvent = function receivePositionsEvent(payload) {
  return {
    type: RECEIVE_POSITION_EVENT,
    payload: payload
  };
};

var requestingAccountPositions = {
  type: REQUEST_ACCOUNT_POSITIONS,
  payload: {}
};

var receiveAccountPositions = function receiveAccountPositions(payload) {
  return {
    type: RECEIVE_ACCOUNT_POSITIONS,
    payload: payload
  };
};

var selectPositionAndSave = function selectPositionAndSave(payload) {
  return function (dispatch) {
    localStorage.setItem('selectedPositionId', payload);
    dispatch(selectPosition(payload));
  };
};

var selectPosition = function selectPosition(payload) {
  return {
    type: SELECT_POSITION,
    payload: payload
  };
};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_i18n__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_thunk__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_authMiddleware__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middlewares_languageMiddleware__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middlewares_placeOrderMiddleware__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_startupMiddleware__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__middlewares_wsConnectionMiddleware__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__middlewares_orderFeeMiddleware__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__middlewares_marginEnableMiddleware__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__middlewares_priceQuantityIncrementMiddleware__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__middlewares_level2monitorMiddleware__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducers_affiliateReducer__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_apiReducer__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reducers_apiKeyReducer__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducers_apiProcessingReducer__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__reducers_authReducer__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reducers_confirmWithdrawReducer__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers_eotcReducer__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reducers_eotcWithdrawReducer__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__reducers_eotcSettlementReducer__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducers_eotcPriceReducer__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reducers_depositReducer__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__reducers_loyaltyFeeReducer__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducers_modalReducer__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__reducers_paginationReducer__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__reducers_productAttributesReducer__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__reducers_productManifestReducer__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducers_recentTradesReducer__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__reducers_resetPasswordReducer__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reducers_reportReducer__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducers_sidePaneReducer__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reducers_signupReducer__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducers_snackbarReducer__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__reducers_tickersReducer__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__reducers_transferReducer__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__reducers_transferRequestReducer__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__reducers_transferRequestRequestedReducer__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__reducers_userReducer__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__reducers_verifyEmailReducer__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__reducers_withdrawReducer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__reducers_wsConnectionReducer__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__reducers_interestBearingAccountsReducer__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__apexCore__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__reducers_marginReducers_marginReducer__ = __webpack_require__(581);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };














// reducers (sort by name)



































var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  actionsBlacklist: ['LEVEL1_LOADED', 'LEVEL_2_UPDATES', 'REGISTER_FIELD', 'ADD_TICKERS', 'ADD_RECENT_TRADE']
}) : __WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];

var rootReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
  api: __WEBPACK_IMPORTED_MODULE_14__reducers_apiReducer__["a" /* default */],
  apiKey: __WEBPACK_IMPORTED_MODULE_15__reducers_apiKeyReducer__["a" /* default */],
  apexCore: __WEBPACK_IMPORTED_MODULE_44__apexCore__["a" /* default */],
  affiliate: __WEBPACK_IMPORTED_MODULE_13__reducers_affiliateReducer__["a" /* default */],
  auth: __WEBPACK_IMPORTED_MODULE_17__reducers_authReducer__["a" /* default */],
  form: __WEBPACK_IMPORTED_MODULE_1_redux_form__["i" /* reducer */],
  eotc: __WEBPACK_IMPORTED_MODULE_19__reducers_eotcReducer__["a" /* default */],
  eotcWithdraw: __WEBPACK_IMPORTED_MODULE_20__reducers_eotcWithdrawReducer__["a" /* default */],
  eotcSettlement: __WEBPACK_IMPORTED_MODULE_21__reducers_eotcSettlementReducer__["a" /* default */],
  eotcPrices: __WEBPACK_IMPORTED_MODULE_22__reducers_eotcPriceReducer__["a" /* default */],
  i18nState: __WEBPACK_IMPORTED_MODULE_2_redux_i18n__["i18nState"],
  margin: __WEBPACK_IMPORTED_MODULE_45__reducers_marginReducers_marginReducer__["a" /* marginReducer */],
  modal: __WEBPACK_IMPORTED_MODULE_25__reducers_modalReducer__["a" /* default */],
  productAttributes: __WEBPACK_IMPORTED_MODULE_27__reducers_productAttributesReducer__["a" /* default */],
  productManifest: __WEBPACK_IMPORTED_MODULE_28__reducers_productManifestReducer__["a" /* default */],
  recentTrades: __WEBPACK_IMPORTED_MODULE_29__reducers_recentTradesReducer__["a" /* default */],
  report: __WEBPACK_IMPORTED_MODULE_31__reducers_reportReducer__["a" /* default */],
  sidePane: __WEBPACK_IMPORTED_MODULE_32__reducers_sidePaneReducer__["a" /* default */],
  signup: __WEBPACK_IMPORTED_MODULE_33__reducers_signupReducer__["a" /* default */],
  snackbar: __WEBPACK_IMPORTED_MODULE_34__reducers_snackbarReducer__["a" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_39__reducers_userReducer__["a" /* default */],
  apiProcessing: __WEBPACK_IMPORTED_MODULE_16__reducers_apiProcessingReducer__["a" /* default */],
  deposit: __WEBPACK_IMPORTED_MODULE_23__reducers_depositReducer__["a" /* default */],
  withdraw: __WEBPACK_IMPORTED_MODULE_41__reducers_withdrawReducer__["a" /* default */],
  wsConnection: __WEBPACK_IMPORTED_MODULE_42__reducers_wsConnectionReducer__["a" /* default */],
  tickers: __WEBPACK_IMPORTED_MODULE_35__reducers_tickersReducer__["a" /* default */],
  transfer: __WEBPACK_IMPORTED_MODULE_36__reducers_transferReducer__["a" /* default */],
  transferRequest: __WEBPACK_IMPORTED_MODULE_37__reducers_transferRequestReducer__["a" /* default */],
  paginationMemory: __WEBPACK_IMPORTED_MODULE_26__reducers_paginationReducer__["a" /* default */],
  verifyEmail: __WEBPACK_IMPORTED_MODULE_40__reducers_verifyEmailReducer__["a" /* default */],
  confirmWithdraw: __WEBPACK_IMPORTED_MODULE_18__reducers_confirmWithdrawReducer__["a" /* default */],
  resetPassword: __WEBPACK_IMPORTED_MODULE_30__reducers_resetPasswordReducer__["a" /* default */],
  loyaltyFee: __WEBPACK_IMPORTED_MODULE_24__reducers_loyaltyFeeReducer__["a" /* default */],
  transferRequestRequested: __WEBPACK_IMPORTED_MODULE_38__reducers_transferRequestRequestedReducer__["a" /* default */],
  interestBearingAccounts: __WEBPACK_IMPORTED_MODULE_43__reducers_interestBearingAccountsReducer__["a" /* default */]
});

var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(rootReducer, undefined, composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_12__middlewares_level2monitorMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__middlewares_priceQuantityIncrementMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__middlewares_marginEnableMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__middlewares_languageMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__middlewares_placeOrderMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__middlewares_startupMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__middlewares_orderFeeMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__middlewares_authMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__middlewares_wsConnectionMiddleware__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_redux_thunk__["a" /* default */])));

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderFormTypes; });
var orderFormTypes = {
  default: 'default',
  advanced: 'advanced',
  block: 'block',
  buySell: 'buySell'
};

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export appendEach */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return distinct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findIndexOfObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateObjectInArray; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var appendEach = function appendEach(arr, suffix) {
  return arr.filter(function (c) {
    return c;
  }).map(function (text) {
    return text + suffix;
  });
};

var distinct = function distinct(array) {
  var keySelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item) {
    return item;
  };

  var unique = new Map();
  var distinctArray = [];
  array.forEach(function (item) {
    var itemKey = keySelector(item);
    if (!unique.has(itemKey)) {
      distinctArray.push(item);
      unique.set(itemKey, item);
    }
  });

  return distinctArray;
};

var findIndexOfObject = function findIndexOfObject(array, key, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][key] === value) {
      return i;
    }
  }
  return undefined;
};

var updateObjectInArray = function updateObjectInArray(array, action) {
  if (typeof action.index !== 'number') {
    return [].concat(_toConsumableArray(array), [action.item]);
  }
  return array.map(function (item, index) {
    if (index !== action.index) {
      return item;
    }
    return Object.assign({}, item, action.item);
  });
};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_2FA_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FORCED_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ENABLE_2FA_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return login; });
/* unused harmony export enforceEnable2FA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return authSuccess; });
/* unused harmony export authError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return subscribeToLogoutEvent; });
/* unused harmony export require2FA */
/* unused harmony export setUserNotAuthenticated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return redirectFromLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return validateSessionToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sendTwoFactorAuthCode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_subscriptions_LogoutEventSubscriptionService__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userActions__ = __webpack_require__(37);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = 'AUTH_ERROR';
var AUTH_NONE = 'AUTH_NONE';
var AUTH_REDIRECT = 'AUTH_REDIRECT';
var AUTH_2FA_REQUIRED = 'AUTH_2FA_REQUIRED';
var FORCED_LOGOUT = 'FORCED_LOGOUT';
var ENABLE_2FA_REQUIRED = 'ENABLE_2FA_REQUIRED';

var login = function login(creds) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var auth;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.WebAuthenticateUser(creds);

            case 2:
              auth = _context.sent;

              if (!(auth.Authenticated && auth.Requires2FA)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt('return', dispatch(require2FA(auth)));

            case 7:
              if (!auth.Authenticated) {
                _context.next = 13;
                break;
              }

              if (!auth.EnforceEnable2FA) {
                _context.next = 10;
                break;
              }

              return _context.abrupt('return', dispatch(forceEnable2FA(creds)));

            case 10:
              return _context.abrupt('return', dispatch(authSuccess(auth)));

            case 13:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* change */])('login', 'password', ''));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["l" /* untouch */])('login', 'password'));
              return _context.abrupt('return', dispatch(authError(auth)));

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var forceEnable2FA = function forceEnable2FA(creds) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__userActions__["k" /* getGoogleQrCode */])());
              return _context2.abrupt('return', dispatch(enforceEnable2FA(creds)));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var enforceEnable2FA = function enforceEnable2FA(creds) {
  return {
    type: ENABLE_2FA_REQUIRED,
    payload: {
      creds: creds,
      enable2FARequired: true
    }
  };
};

var logout = function logout() {
  return function (dispatch, getState) {
    var wasAuthenticatedBefore = getState().auth.isAuthenticated;
    var action = setUserNotAuthenticated(wasAuthenticatedBefore);
    __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCPromise('LogOut', {}).then(function (res) {
      console.log('logged out');
    }).catch(function (err) {
      console.warn(err);
    });

    localStorage.removeItem('tradingServer');
    dispatch(action);
  };
};

var authSuccess = function authSuccess(payload) {
  return {
    type: AUTH_SUCCESS,
    payload: {
      isAuthenticated: payload.Authenticated,
      userId: payload.UserId,
      token: payload.SessionToken,
      pending: false,
      is2FARequired: false
    }
  };
};

var authError = function authError(payload) {
  return {
    type: AUTH_ERROR,
    payload: {
      isAuthenticated: payload.Authenticated,
      errorMsg: payload.errormsg,
      pending: false
    }
  };
};

var subscribeToLogoutEvent = function subscribeToLogoutEvent() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_4__services_subscriptions_LogoutEventSubscriptionService__["a" /* default */].subscribe(function (message) {
      dispatch(forcedLogOut(message));
    });
  };
};

var forcedLogOut = function forcedLogOut(message) {
  return {
    type: FORCED_LOGOUT,
    payload: message
  };
};

var require2FA = function require2FA(payload) {
  return {
    type: AUTH_2FA_REQUIRED,
    payload: {
      userId: payload.UserId,
      is2FARequired: true
    }
  };
};

var setUserNotAuthenticated = function setUserNotAuthenticated() {
  var wasAuthenticatedBefore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: AUTH_NONE,
    payload: {
      isAuthenticated: false,
      userId: null,
      token: null,
      pending: false,
      wasAuthenticatedBefore: wasAuthenticatedBefore
    }
  };
};

var redirectFromLogin = function redirectFromLogin(location) {
  return {
    type: AUTH_REDIRECT,
    payload: {
      shouldRedirect: !!location,
      location: location
    }
  };
};

var validateSessionToken = function validateSessionToken(token) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch) {
      var authTimeout, timeoutID, auth;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              authTimeout = __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].global.authTimeout;
              timeoutID = authTimeout ? setTimeout(function () {
                localStorage.removeItem('token');
                window.location.reload();
              }, authTimeout) : 0;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.WebAuthenticateUser({
                SessionToken: token
              });

            case 4:
              auth = _context3.sent;


              clearTimeout(timeoutID);

              if (!auth.Authenticated) {
                _context3.next = 10;
                break;
              }

              dispatch(authSuccess(auth));
              _context3.next = 12;
              break;

            case 10:
              _context3.next = 12;
              return dispatch(logout());

            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var sendTwoFactorAuthCode = function sendTwoFactorAuthCode(Code) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch) {
      var auth;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.Authenticate2FA({ Code: Code });

            case 2:
              auth = _context4.sent;

              if (!auth.Authenticated) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt('return', dispatch(authSuccess(auth)));

            case 5:
              return _context4.abrupt('return', dispatch(authError(auth)));

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VerificationRequiredComponent__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableTrading = _kycVerificationLevel.disableTrading,
      isUnderReview = _kycVerificationLevel.isUnderReview;

  return Object.assign({
    verificationRequired: true,
    verificationLevelPageUrl: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].KYC.verificationRequiredUrl,
    enableVerificationLinkOnClick: false,
    disabled: disableTrading,
    isUnderReview: isUnderReview
  }, ownProps);
};

var mapDispatchToProps = {};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VerificationRequiredComponent__["a" /* default */]));

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return productsListSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filteredDepositsByProductSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filteredWithdrawalsByProductSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return depositProductSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return withdrawProductSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return depositAddressSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_orderHistoryFilters__ = __webpack_require__(499);





var formSelector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('order-history-filter');
var products = function products(state) {
  return state.apexCore.product.products;
};
var depositProductId = function depositProductId(state) {
  return state.deposit.product;
};
var withdrawProductId = function withdrawProductId(state) {
  return state.withdraw.product;
};

var productsListSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.apexCore.product.products;
}, function (products) {
  return products.map(function (_ref) {
    var Product = _ref.Product,
        ProductFullName = _ref.ProductFullName,
        ProductId = _ref.ProductId,
        DecimalPlaces = _ref.DecimalPlaces;
    return {
      Product: Product,
      ProductFullName: ProductFullName,
      ProductId: ProductId,
      DecimalPlaces: DecimalPlaces
    };
  });
});

var filteredDepositsByProductSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_2__instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], function (state) {
  return state.deposit.depositsStatus;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return formSelector(state, 'startDate', 'endDate');
}, function (state, props) {
  return props.filterMode;
}], function (instrument, deposits, selectedProductId, formValues, filterMode) {
  if (filterMode === 'selectedProduct') {
    return deposits.filter(function (deposit) {
      return selectedProductId ? deposit.AssetId === selectedProductId : true;
    }).filter(function (deposit) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHistoryFilters__["a" /* dateFilter */])(deposit, formValues.startDate, formValues.endDate, 'CreatedTimestamp');
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  } else {
    return deposits.filter(function (deposit) {
      return deposit.AssetId === instrument.Product1 || deposit.AssetId === instrument.Product2;
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  }
});

var filteredWithdrawalsByProductSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_2__instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], function (state) {
  return state.withdraw.withdrawTickets;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return formSelector(state, 'startDate', 'endDate');
}, function (state, props) {
  return props.filterMode;
}], function (instrument, withdrawals, selectedProductId, formValues, filterMode) {
  if (filterMode === 'selectedProduct') {
    return withdrawals.filter(function (withdrawal) {
      return selectedProductId ? withdrawal.AssetId === selectedProductId : true;
    }).filter(function (withdrawal) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHistoryFilters__["a" /* dateFilter */])(withdrawal, formValues.startDate, formValues.endDate, 'CreatedTimestamp');
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  } else {
    return withdrawals.filter(function (withdrawal) {
      return withdrawal.AssetId === instrument.Product1 || withdrawal.AssetId === instrument.Product2;
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  }
});

var depositProductSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([products, depositProductId], function (products, depositProductId) {
  return products.find(function (prod) {
    return prod.ProductId === depositProductId;
  });
});

var withdrawProductSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([products, withdrawProductId], function (products, withdrawProductId) {
  return products.find(function (prod) {
    return prod.ProductId === withdrawProductId;
  });
});

var depositAddressSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.deposit;
}, function (deposit) {
  var addressList = deposit.depositInfo,
      isLoading = deposit.isLoading;

  var selectedAddress = void 0;
  if (!isLoading && addressList.length) {
    selectedAddress = addressList[addressList.length - 1];
  }

  return selectedAddress;
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tab_css__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tab_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tab_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Tab = function (_Component) {
  _inherits(Tab, _Component);

  function Tab(props) {
    _classCallCheck(this, Tab);

    var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this, props));

    _this.state = {
      activeIndex: _this.props.defaultActiveIndex
    };
    return _this;
  }

  _createClass(Tab, [{
    key: 'handleTabChange',
    value: function handleTabChange(e, index) {
      e.preventDefault();
      this.props.onTabChange(index);
      this.setState({ activeIndex: index });
    }
  }, {
    key: 'getClasses',
    value: function getClasses() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['ap-tab', this.props.customClass]);
    }
  }, {
    key: '_renderMenu',
    value: function _renderMenu() {
      var classes = this.getClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('menu', this.props.classModifiers) },
        this._renderMenuItems()
      );
    }
  }, {
    key: '_renderMenuItems',
    value: function _renderMenuItems() {
      var _this2 = this;

      var _props = this.props,
          panes = _props.panes,
          classModifiers = _props.classModifiers;

      var classes = this.getClasses();

      return panes.map(function (pane, index) {
        var activeClassName = _this2.state.activeIndex === index ? classes('menu-item', ['active'].concat(classModifiers.map(function (i) {
          return i + '-active';
        }))) : '';
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(activeClassName, classes('menu-item', classModifiers)),
            onClick: function onClick(e) {
              if (pane.onSelect) {
                pane.onSelect();
              }
              _this2.handleTabChange(e, index);
            },
            key: pane.menuItem,
            'data-test': pane.menuItem },
          _this2.context.t(pane.menuItem)
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          panes = _props2.panes,
          classModifiers = _props2.classModifiers;

      var currentPane = panes[this.state.activeIndex];
      var classes = this.getClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '' + classes('tab', classModifiers) },
        this._renderMenu(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('tab-content', classModifiers) },
          currentPane.render()
        )
      );
    }
  }]);

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Tab.propTypes = {
  onTabChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  panes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    menuItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })).isRequired,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Tab.defaultProps = {
  customClass: 'custom-tab',
  classModifiers: [],
  defaultActiveIndex: 0,
  onTabChange: function onTabChange() {}
};
Tab.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_OPEN_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RECEIVE_OPEN_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return REQUEST_OPEN_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOUNT_TRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_ACCOUNT_TRADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REQUEST_ACCOUNT_TRADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_INACTIVE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECEIVE_INACTIVE_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REQUEST_INACTIVE_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RECEIVE_TRADE_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return REQUEST_TRADE_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECEIVE_TRADE_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return REMOVE_ACTIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return initOrderHistorySubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getOpenOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return subscribeToOrderHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getAccountTrades; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FetchAccountTradesForOrderId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getInactiveOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getOrders; });
/* unused harmony export removeActiveRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getOpenTradeReports; });
/* unused harmony export receiveOpenOrders */
/* unused harmony export requestOpenOrders */
/* unused harmony export addOpenOrder */
/* unused harmony export addInactiveOrder */
/* unused harmony export receiveAccountTrades */
/* unused harmony export receiveAccountTradesForOrderId */
/* unused harmony export requestAccountTrades */
/* unused harmony export addAccountTrade */
/* unused harmony export receiveInactiveOrders */
/* unused harmony export requestInactiveOrders */
/* unused harmony export receiveTradeReports */
/* unused harmony export requestTradeReports */
/* unused harmony export receiveTradeHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return cancelAllOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return cancelSellOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return cancelBuyOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return cancelOrders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_orderStateSubscriptionService__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_subscriptions_orderTradesSuscriptionService__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_placeOrderHelper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__snackbarActions__ = __webpack_require__(20);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var ADD_OPEN_ORDER = 'ADD_OPEN_ORDER';
var RECEIVE_OPEN_ORDERS = 'RECEIVE_OPEN_ORDERS';
var REQUEST_OPEN_ORDERS = 'REQUEST_OPEN_ORDERS';
var ADD_ACCOUNT_TRADE = 'ADD_ACCOUNT_TRADE';
var RECEIVE_ACCOUNT_TRADES = 'RECEIVE_ACCOUNT_TRADES';
var REQUEST_ACCOUNT_TRADES = 'REQUEST_ACCOUNT_TRADES';
var ADD_INACTIVE_ORDER = 'ADD_INACTIVE_ORDER';
var RECEIVE_INACTIVE_ORDERS = 'RECEIVE_INACTIVE_ORDERS';
var REQUEST_INACTIVE_ORDERS = 'REQUEST_INACTIVE_ORDERS';
var RECEIVE_TRADE_REPORTS = 'RECEIVE_TRADE_REPORTS';
var REQUEST_TRADE_REPORTS = 'REQUEST_TRADE_REPORTS';
var RECEIVE_TRADE_HISTORY = 'RECEIVE_TRADE_HISTORY';
var RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID = 'RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID';
var REMOVE_ACTIVE_REQUEST = 'REMOVE_ACTIVE_REQUEST';

var initOrderHistorySubscription = function initOrderHistorySubscription(AccountId, OMSId) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_orderStateSubscriptionService__["a" /* default */].initSubscribtion({ AccountId: AccountId, OMSId: OMSId });
    __WEBPACK_IMPORTED_MODULE_3__services_subscriptions_orderTradesSuscriptionService__["a" /* default */].initSubscribtion({ AccountId: AccountId, OMSId: OMSId });
  };
};

var getOpenOrders = function getOpenOrders(AccountId, OMSID) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var openOrders;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestOpenOrders());
              _context.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetOpenOrders', { AccountId: AccountId, OMSID: OMSID }));

            case 3:
              openOrders = _context.sent;

              dispatch(receiveOpenOrders(openOrders));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var subscribeToOrderHistory = function subscribeToOrderHistory() {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_orderStateSubscriptionService__["a" /* default */].subscribe(function (x) {
      if (['Working'].some(function (i) {
        return x.OrderState === i;
      })) {
        dispatch(addOpenOrder(x));
        if (getState().form.buySell) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__orderEntryActions__["j" /* showBuySellSuccessMessage */])());
        }
      } else if (['Rejected', 'Canceled', 'FullyExecuted'].some(function (i) {
        return x.OrderState === i;
      })) {
        dispatch(addInactiveOrder(x));
        if (getState().form.buySell) {
          if (x.OrderState === 'FullyExecuted') {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__orderEntryActions__["j" /* showBuySellSuccessMessage */])());
          } else {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__orderEntryActions__["i" /* showBuySellFailMessage */])());
          }
        }
      }
      var snackBar = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_placeOrderHelper__["b" /* getOrderEventSnackbar */])(x);
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__snackbarActions__["e" /* showSnack */])({
        id: 'OrderStateEventSnackbar',
        text: snackBar.text,
        type: snackBar.type,
        textVars: snackBar.textVars
      }));
    });

    __WEBPACK_IMPORTED_MODULE_3__services_subscriptions_orderTradesSuscriptionService__["a" /* default */].subscribe(function (x) {
      dispatch(addAccountTrade(x));
    });
  };
};

var getAccountTrades = function getAccountTrades(AccountId, OMSId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      var trades;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(requestAccountTrades());
              _context2.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetAccountTrades', {
                AccountId: AccountId,
                OMSId: OMSId,
                Count: 200
              }));

            case 3:
              trades = _context2.sent;

              dispatch(receiveAccountTrades(trades));
              dispatch(receiveTradeHistory(trades));

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var FetchAccountTradesForOrderId = function FetchAccountTradesForOrderId(OrderId) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var _getState, user, AccountId, trades;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState = getState(), user = _getState.user;
              AccountId = user.accounts[0].AccountId;
              _context3.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetAccountTrades', {
                AccountId: AccountId,
                OrderId: OrderId,
                OMSID: 1
              }));

            case 4:
              trades = _context3.sent;


              dispatch(receiveAccountTradesForOrderId(trades));

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var getInactiveOrders = function getInactiveOrders(AccountId, OMSId) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch) {
      var Depth, orders;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(requestInactiveOrders());
              Depth = 1000;
              _context4.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetOrderHistory', {
                AccountId: AccountId,
                OMSId: OMSId,
                Depth: Depth
              }));

            case 4:
              orders = _context4.sent;

              dispatch(receiveInactiveOrders(orders));

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var getOrders = function getOrders(AccountId, OMSId) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch) {
      var Depth, orders;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch(requestInactiveOrders());
              Depth = 1000;
              _context5.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetOrders', {
                AccountId: AccountId,
                OMSId: OMSId,
                Depth: Depth
              }));

            case 4:
              orders = _context5.sent;

              dispatch(receiveInactiveOrders(orders));

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x6) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var removeActiveRequest = function removeActiveRequest() {
  return {
    type: REMOVE_ACTIVE_REQUEST
  };
};

var getOpenTradeReports = function getOpenTradeReports(AccountId, OMSId) {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch) {
      var tradeReports;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch(requestTradeReports());
              _context6.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetOpenTradeReports', {
                AccountId: AccountId,
                OMSId: OMSId
              }));

            case 3:
              tradeReports = _context6.sent;

              dispatch(receiveTradeReports(tradeReports));

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function (_x7) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var receiveOpenOrders = function receiveOpenOrders(payload) {
  return {
    type: RECEIVE_OPEN_ORDERS,
    payload: payload
  };
};

var requestOpenOrders = function requestOpenOrders() {
  return {
    type: REQUEST_OPEN_ORDERS
  };
};

var addOpenOrder = function addOpenOrder(payload) {
  return {
    type: ADD_OPEN_ORDER,
    payload: payload
  };
};

var addInactiveOrder = function addInactiveOrder(payload) {
  return {
    type: ADD_INACTIVE_ORDER,
    payload: payload
  };
};

var receiveAccountTrades = function receiveAccountTrades(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES,
    payload: payload
  };
};

var receiveAccountTradesForOrderId = function receiveAccountTradesForOrderId(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID,
    payload: payload
  };
};

var requestAccountTrades = function requestAccountTrades() {
  return {
    type: REQUEST_ACCOUNT_TRADES
  };
};

var addAccountTrade = function addAccountTrade(payload) {
  return {
    type: ADD_ACCOUNT_TRADE,
    payload: payload
  };
};

var receiveInactiveOrders = function receiveInactiveOrders(payload) {
  return {
    type: RECEIVE_INACTIVE_ORDERS,
    payload: payload
  };
};

var requestInactiveOrders = function requestInactiveOrders() {
  return {
    type: REQUEST_INACTIVE_ORDERS
  };
};

var receiveTradeReports = function receiveTradeReports(payload) {
  return {
    type: RECEIVE_TRADE_REPORTS,
    payload: payload
  };
};

var requestTradeReports = function requestTradeReports() {
  return {
    type: REQUEST_TRADE_REPORTS
  };
};

var receiveTradeHistory = function receiveTradeHistory(payload) {
  return {
    type: RECEIVE_TRADE_HISTORY,
    payload: payload
  };
};

var cancelAllOrders = function cancelAllOrders() {
  return function (dispatch, getState) {
    var OMSId = getState().user.userInfo.OMSId;
    var selectedAccountId = getState().user.selectedAccountId;
    var selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CancelAllOrders', {
      OMSId: OMSId,
      AccountId: selectedAccountId,
      InstrumentId: selectedInstrumentId
    })).then(function () {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__snackbarActions__["e" /* showSnack */])({
        id: 'cancelAllOrdersSuccessSnack',
        text: 'All orders cancelled',
        type: 'success'
      }));
    });
  };
};

var cancelSellOrders = function cancelSellOrders() {
  return function (dispatch, getState) {
    cancelSideOrders(dispatch, getState, 'Sell');
  };
};

var cancelBuyOrders = function cancelBuyOrders() {
  return function (dispatch, getState) {
    cancelSideOrders(dispatch, getState, 'Buy');
  };
};

var cancelOrders = function cancelOrders(OrderIds) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch, getState) {
      var OMSId, selectedAccountId, cancelOrderPromises;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              selectedAccountId = getState().user.selectedAccountId;

              if (!(OrderIds.length > 1)) {
                _context7.next = 13;
                break;
              }

              cancelOrderPromises = OrderIds.map(function (orderId) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CancelOrder', {
                  OrderId: orderId,
                  AccountId: selectedAccountId,
                  OMSId: OMSId
                }));
              });
              _context7.next = 6;
              return Promise.all(cancelOrderPromises);

            case 6:
              _context7.next = 8;
              return dispatch(getOpenOrders(selectedAccountId, OMSId));

            case 8:
              _context7.next = 10;
              return dispatch(getOpenTradeReports(selectedAccountId, OMSId));

            case 10:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__snackbarActions__["e" /* showSnack */])({
                id: 'cancelOrderSuccessSnack',
                // context.t('Orders {n} cancelled')
                text: 'Orders {n} cancelled',
                textVars: { n: OrderIds.toString() },
                type: 'success'
              }));
              _context7.next = 20;
              break;

            case 13:
              _context7.next = 15;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CancelOrder', {
                OrderId: OrderIds[0],
                AccountId: selectedAccountId,
                OMSId: OMSId
              }));

            case 15:
              _context7.next = 17;
              return dispatch(getOpenOrders(selectedAccountId, OMSId));

            case 17:
              _context7.next = 19;
              return dispatch(getOpenTradeReports(selectedAccountId, OMSId));

            case 19:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__snackbarActions__["e" /* showSnack */])({
                id: 'cancelOrderSuccessSnack',
                // context.t('Order {n} cancelled')
                text: 'Order {n} cancelled',
                textVars: { n: OrderIds[0] },
                type: 'success'
              }));

            case 20:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function (_x8, _x9) {
      return _ref7.apply(this, arguments);
    };
  }();
};

function cancelSideOrders(dispatch, getState, side) {
  var openOrders = getState().apexCore.orderHistory.openOrders;
  var OMSId = getState().user.userInfo.OMSId;
  var selectedAccountId = getState().user.selectedAccountId;

  var sideOrderIds = openOrders.filter(function (order) {
    return order.Side === side;
  }).map(function (order) {
    return order.OrderId;
  });

  sideOrderIds.forEach(function (OrderId) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CancelOrder', {
      OrderId: OrderId,
      AccountId: selectedAccountId,
      OMSId: OMSId
    }));
  });

  if (side === 'Buy') {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__snackbarActions__["e" /* showSnack */])({
      id: 'cancelBuyOrdersSuccessSnack',
      text: 'Buy orders cancelled',
      type: 'success'
    }));
  } else {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__snackbarActions__["e" /* showSnack */])({
      id: 'cancelSellOrdersSuccessSnack',
      text: 'Sell orders cancelled',
      type: 'success'
    }));
  }
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_PRODUCT_DEPOSIT_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_PRODUCT_DEPOSIT_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RECEIVE_DEPOSIT_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECEIVE_DEPOSIT_TEMPLATES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECEIVE_DEPOSIT_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RECEIVE_DEPOSIT_TEMPLATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_DEPOSIT_INFO_ERROR; });
/* unused harmony export SUBMITTING_DEPOSIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_DEPOSIT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_DEPOSIT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RECEIVE_DEPOSIT_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RECEIVE_DEPOSIT_TICKETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RESET_DEPOSIT_INFO; });
/* unused harmony export RETAIL_FIAT_CONFIRM_DEPOSIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_DEPOSIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchAllProductDepositTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchProductDepositTemplate; });
/* unused harmony export getDepositInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getDepositTickets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return createDepositTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return subscribeToDeposits; });
/* unused harmony export addDeposit */
/* unused harmony export fetchingDepositTemplates */
/* unused harmony export fetchingDepositTemplate */
/* unused harmony export fetchingDepositInfo */
/* unused harmony export receiveDepositTemplates */
/* unused harmony export receiveDepositTemplate */
/* unused harmony export depositTemplatesError */
/* unused harmony export depositTemplateError */
/* unused harmony export depositInfoError */
/* unused harmony export submittingDeposit */
/* unused harmony export receiveDepositInfo */
/* unused harmony export receiveDepositTicket */
/* unused harmony export receiveDepositTickets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_depositSubscriptionService__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_errorTextFormatter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);


var _this = this;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var FETCH_PRODUCT_DEPOSIT_TEMPLATES = 'FETCH_PRODUCT_DEPOSIT_TEMPLATES';
var FETCH_PRODUCT_DEPOSIT_TEMPLATE = 'FETCH_PRODUCT_DEPOSIT_TEMPLATE';
var RECEIVE_DEPOSIT_TEMPLATES = 'RECEIVE_DEPOSIT_TEMPLATES';
var RECEIVE_DEPOSIT_TEMPLATES_ERROR = 'RECEIVE_DEPOSIT_TEMPLATES_ERROR';
var RECEIVE_DEPOSIT_TEMPLATE = 'RECEIVE_DEPOSIT_TEMPLATE';
var RECEIVE_DEPOSIT_TEMPLATE_ERROR = 'RECEIVE_DEPOSIT_TEMPLATE_ERROR';
var RECEIVE_DEPOSIT_INFO_ERROR = 'RECEIVE_DEPOSIT_INFO_ERROR';
var SUBMITTING_DEPOSIT = 'SUBMITTING_DEPOSIT';
var FETCH_DEPOSIT_INFO = 'FETCH_DEPOSIT_INFO';
var RECEIVE_DEPOSIT_INFO = 'RECEIVE_DEPOSIT_INFO';
var RECEIVE_DEPOSIT_TICKET = 'RECEIVE_DEPOSIT_TICKET';
var RECEIVE_DEPOSIT_TICKETS = 'RECEIVE_DEPOSIT_TICKETS';
var RESET_DEPOSIT_INFO = 'RESET_DEPOSIT_INFO';
var RETAIL_FIAT_CONFIRM_DEPOSIT = 'RETAIL_FIAT_CONFIRM_DEPOSIT';
var ADD_DEPOSIT = 'ADD_DEPOSIT';

var fetchAllProductDepositTemplates = function fetchAllProductDepositTemplates(ProductId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var product, payload, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isNaN(ProductId)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', dispatch({ type: RESET_DEPOSIT_INFO }));

            case 2:
              // Follow previous deposit workflow for cryptos
              product = getState().apexCore.product.products.find(function (prod) {
                return prod.ProductId === ProductId;
              });

              if (!(product.ProductType === 'CryptoCurrency')) {
                _context.next = 5;
                break;
              }

              return _context.abrupt('return', dispatch(fetchProductDepositTemplate(ProductId)));

            case 5:

              dispatch(fetchingDepositTemplates(ProductId));
              payload = {
                ProductId: ProductId,
                OMSId: getState().user.userInfo.OMSId,
                AccountId: getState().user.selectedAccountId
              };
              _context.next = 9;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetDepositTemplateTypes', payload)).catch(function () {
                return dispatch(fetchProductDepositTemplate(ProductId));
              });

            case 9:
              data = _context.sent;
              _context.prev = 10;

              if (!data.result) {
                _context.next = 17;
                break;
              }

              if (!(data.TemplateTypes && !data.TemplateTypes.length)) {
                _context.next = 14;
                break;
              }

              return _context.abrupt('return', dispatch(depositTemplatesError('There are no providers configured for this product')));

            case 14:
              dispatch(receiveDepositTemplates(data.TemplateTypes));
              if (data.TemplateTypes && data.TemplateTypes.length === 1) {
                dispatch(fetchProductDepositTemplate(ProductId, data.TemplateTypes[0].TemplateName));
              }
              return _context.abrupt('return', true);

            case 17:
              return _context.abrupt('return', dispatch(depositTemplatesError(data.errormsg)));

            case 20:
              _context.prev = 20;
              _context.t0 = _context['catch'](10);

              dispatch(fetchProductDepositTemplate(ProductId));

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[10, 20]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var fetchProductDepositTemplate = function fetchProductDepositTemplate(ProductId, TemplateType) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var templateTypeObj, payload, data, _data$Template, UseGetDepositWorkflow, Template, DepositWorkflow;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!isNaN(ProductId)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return', dispatch({ type: RESET_DEPOSIT_INFO }));

            case 2:

              dispatch(fetchingDepositTemplate(ProductId, TemplateType));
              templateTypeObj = getState().deposit.templateTypes.find(function (template) {
                return template.TemplateName === TemplateType;
              });
              payload = {
                OMSId: getState().user.userInfo.OMSId,
                AccountId: getState().user.selectedAccountId,
                ProductId: ProductId,
                TemplateType: TemplateType
              };

              if (templateTypeObj) {
                payload.AccountProviderId = templateTypeObj.AccountProviderId;
              }
              _context2.next = 8;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetDepositRequestInfoTemplate', payload));

            case 8:
              data = _context2.sent;

              if (!data.result) {
                _context2.next = 15;
                break;
              }

              _data$Template = data.Template, UseGetDepositWorkflow = _data$Template.UseGetDepositWorkflow, Template = _data$Template.Template, DepositWorkflow = _data$Template.DepositWorkflow;

              if (Template === '{}' && (UseGetDepositWorkflow || DepositWorkflow === 'CryptoWallet')) {
                dispatch(getDepositInfo(ProductId));
              } else {
                dispatch(depositInfoError('Failed to load'));
              }

              if (Template) {
                _context2.next = 14;
                break;
              }

              return _context2.abrupt('return', dispatch(depositTemplateError('Server provided an unexpected response')));

            case 14:
              return _context2.abrupt('return', dispatch(receiveDepositTemplate(data)));

            case 15:
              return _context2.abrupt('return', dispatch(depositTemplateError(data.errormsg)));

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var getDepositInfo = function getDepositInfo(ProductId, template) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var OMSId, AccountId, templateType, templateTypeObj, payload, depositInfo;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              templateType = getState().deposit.templateType;
              templateTypeObj = getState().deposit.templateTypes.find(function (template) {
                return template.TemplateName === templateType;
              });
              payload = {
                OMSId: OMSId,
                AccountId: AccountId,
                ProductId: +ProductId,
                GenerateNewKey: __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].Deposit.generateNewKey
              };


              if (templateTypeObj) {
                payload.AccountProviderId = templateTypeObj.AccountProviderId;
              }
              if (template) {
                payload.DepositInfo = template;
              }
              dispatch(fetchingDepositInfo(ProductId));

              _context3.next = 10;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetDepositInfo', payload));

            case 10:
              depositInfo = _context3.sent;

              if (!depositInfo.result) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt('return', dispatch(receiveDepositInfo(JSON.parse(depositInfo.DepositInfo))));

            case 13:
              return _context3.abrupt('return', dispatch(depositInfoError(depositInfo.errormsg)));

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var getDepositTickets = function getDepositTickets() {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var OMSId, AccountId, depositTickets;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              _context4.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetDepositTickets', {
                OMSId: OMSId,
                AccountId: AccountId,
                OperatorId: 1
              }));

            case 4:
              depositTickets = _context4.sent;
              return _context4.abrupt('return', dispatch(receiveDepositTickets(depositTickets)));

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var createDepositTicket = function createDepositTicket(_ref5) {
  var ProductId = _ref5.ProductId,
      amount = _ref5.amount,
      TemplateType = _ref5.TemplateType,
      info = _objectWithoutProperties(_ref5, ['ProductId', 'amount', 'TemplateType']);

  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      var OMSId, AccountId, UseGetDepositWorkflow, DepositInfo, payload, depositStatus;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              UseGetDepositWorkflow = getState().deposit.templateInfo.UseGetDepositWorkflow;
              DepositInfo = JSON.stringify(info);
              payload = {
                OMSId: OMSId,
                OperatorId: 1,
                AccountId: AccountId,
                RequestUser: AccountId,
                AssetId: +ProductId,
                Amount: amount ? amount : +info.Amount,
                DepositInfo: DepositInfo,
                Status: 'New'
              };


              dispatch(submittingDeposit);

              if (!UseGetDepositWorkflow) {
                _context5.next = 8;
                break;
              }

              return _context5.abrupt('return', dispatch(getDepositInfo(ProductId, DepositInfo)));

            case 8:
              _context5.next = 10;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CreateDepositTicket', payload));

            case 10:
              depositStatus = _context5.sent;

              if (!(depositStatus.result === false)) {
                _context5.next = 13;
                break;
              }

              return _context5.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'depositRejectSnack',
                text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_errorTextFormatter__["a" /* formatErrorText */])(depositStatus),
                type: 'warning'
              })));

            case 13:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__sidePaneActions__["e" /* closeDepositSidePane */])());
              // context.t('Your deposit has been successfully added')
              dispatch(getDepositTickets());
              if (!__WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].Deposit.showDepositIdModal) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                  id: 'depositSuccessSnack',
                  text: 'Your deposit has been successfully added',
                  type: 'success'
                }));
              }
              return _context5.abrupt('return', dispatch(receiveDepositTicket(depositStatus)));

            case 17:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x9, _x10) {
      return _ref6.apply(this, arguments);
    };
  }();
};


var subscribeToDeposits = function subscribeToDeposits() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_depositSubscriptionService__["a" /* default */].subscribe(function (updates) {
      dispatch(addDeposit(updates));
    });
  };
};

var addDeposit = function addDeposit(payload) {
  return {
    type: ADD_DEPOSIT,
    payload: payload
  };
};

var fetchingDepositTemplates = function fetchingDepositTemplates(product) {
  return {
    type: FETCH_PRODUCT_DEPOSIT_TEMPLATES,
    payload: { product: product }
  };
};

var fetchingDepositTemplate = function fetchingDepositTemplate(product, templateType) {
  return {
    type: FETCH_PRODUCT_DEPOSIT_TEMPLATE,
    payload: { product: product, templateType: templateType }
  };
};

var fetchingDepositInfo = function fetchingDepositInfo(product) {
  return {
    type: FETCH_DEPOSIT_INFO,
    payload: { product: product }
  };
};

var receiveDepositTemplates = function receiveDepositTemplates(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATES,
    payload: payload
  };
};

var receiveDepositTemplate = function receiveDepositTemplate(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATE,
    payload: payload
  };
};

var depositTemplatesError = function depositTemplatesError(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATES_ERROR,
    payload: payload
  };
};

var depositTemplateError = function depositTemplateError(payload) {
  return {
    type: RECEIVE_DEPOSIT_TEMPLATE_ERROR,
    payload: payload
  };
};

var depositInfoError = function depositInfoError(payload) {
  return {
    type: RECEIVE_DEPOSIT_INFO_ERROR,
    payload: payload
  };
};

var submittingDeposit = { type: SUBMITTING_DEPOSIT };

var receiveDepositInfo = function receiveDepositInfo(payload) {
  return {
    type: RECEIVE_DEPOSIT_INFO,
    payload: payload
  };
};

var receiveDepositTicket = function receiveDepositTicket(payload) {
  return {
    type: RECEIVE_DEPOSIT_TICKET,
    payload: payload
  };
};

var receiveDepositTickets = function receiveDepositTickets(payload) {
  return {
    type: RECEIVE_DEPOSIT_TICKETS,
    payload: payload
  };
};

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSFER_REQUESTS_RECEIVED_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRANSFER_REQUESTS_RECEIVED_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRANSFER_REQUESTS_REQUESTED_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSFER_REQUESTS_REQUESTED_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRANSFER_REQUEST_CONFIRMATION_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TRANSFER_REQUEST_CONFIRMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRANSFER_REQUEST_CONFIRMATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getTransferRequestsReceived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTransferRequestsRequested; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return approveTransferRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return rejectTransferRequest; });
/* unused harmony export transferRequestsReceivedRequested */
/* unused harmony export transferRequestsReceivedReceived */
/* unused harmony export transferRequestsRequestedRequested */
/* unused harmony export transferRequestsRequestedReceived */
/* unused harmony export transferRequestConfirmationSent */
/* unused harmony export transferRequestConfirmationSuccess */
/* unused harmony export transferRequestConfirmationFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__snackbarActions__ = __webpack_require__(20);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var TRANSFER_REQUESTS_RECEIVED_REQUESTED = 'TRANSFER_REQUESTS_RECEIVED_REQUESTED';
var TRANSFER_REQUESTS_RECEIVED_RECEIVED = 'TRANSFER_REQUESTS_RECEIVED_RECEIVED';
var TRANSFER_REQUESTS_REQUESTED_REQUESTED = 'TRANSFER_REQUESTS_REQUESTED_REQUESTED';
var TRANSFER_REQUESTS_REQUESTED_RECEIVED = 'TRANSFER_REQUESTS_REQUESTED_RECEIVED';
var TRANSFER_REQUEST_CONFIRMATION_SENT = 'TRANSFER_REQUEST_CONFIRMATION_SENT';
var TRANSFER_REQUEST_CONFIRMATION_SUCCESS = 'TRANSFER_REQUEST_CONFIRMATION_SUCCESS';
var TRANSFER_REQUEST_CONFIRMATION_FAILED = 'TRANSFER_REQUEST_CONFIRMATION_FAILED';

// this.context.t('Transfer Approved');
var approveSnackText = 'Transfer Approved';
// this.context.t('Transfer Rejected');
var rejectSnackText = 'Transfer Rejected';

var getTransferRequestsReceived = function getTransferRequestsReceived(PayerAccountId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var OMSId, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(transferRequestsReceivedRequested());
              OMSId = getState().user.userInfo.OMSId;
              _context.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetRequestTransferRequestsReceived', {
                PayerAccountId: PayerAccountId,
                OMSId: OMSId
              }));

            case 4:
              response = _context.sent;


              dispatch(transferRequestsReceivedReceived(response));

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getTransferRequestsRequested = function getTransferRequestsRequested(RequestorAccountId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var OMSId, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(transferRequestsRequestedRequested());
              OMSId = getState().user.userInfo.OMSId;
              _context2.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetRequestTransferRequestsRequested', {
                RequestorAccountId: RequestorAccountId,
                OMSId: OMSId,
                OperatorId: 1
              }));

            case 4:
              response = _context2.sent;


              dispatch(transferRequestsRequestedReceived(response));

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var approveTransferRequest = function approveTransferRequest(requestCode) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var response, approved;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(transferRequestConfirmationSent(requestCode));
              _context3.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('ConfirmRequestTransferFunds', {
                OMSId: 1,
                OperatorId: 1,
                requestCode: requestCode
              }));

            case 3:
              response = _context3.sent;
              approved = true;

              handleResponse(response, requestCode, approved, dispatch, getState);

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var rejectTransferRequest = function rejectTransferRequest(requestCode) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var response, approved;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(transferRequestConfirmationSent(requestCode));
              _context4.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('RejectRequestTransferFunds', {
                OMSId: 1,
                OperatorId: 1,
                requestCode: requestCode
              }));

            case 3:
              response = _context4.sent;
              approved = false;

              handleResponse(response, requestCode, approved, dispatch, getState);

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var handleResponse = function handleResponse(response, requestCode, approved, dispatch, getState) {
  if (response.result) {
    dispatch(transferRequestConfirmationSuccess(response));

    var snackbarPayload = {
      id: 'confirmTransferRequestSuccess',
      text: approved ? approveSnackText : rejectSnackText,
      type: 'success'
    };

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])(snackbarPayload));

    var accountId = getState().user.selectedAccountId;
    dispatch(getTransferRequestsReceived(accountId, 1));
  } else {
    dispatch(transferRequestConfirmationFailed(requestCode));

    var _snackbarPayload = {
      id: 'confirmTransferRequestFailed',
      // this.context.t('Failed to confirm transfer request');
      text: (response.detail ? response.detail : 'Failed to confirm transfer request') + '!',
      type: 'warning'
    };

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])(_snackbarPayload));
  }
};

var transferRequestsReceivedRequested = function transferRequestsReceivedRequested() {
  return {
    type: TRANSFER_REQUESTS_RECEIVED_REQUESTED
  };
};

var transferRequestsReceivedReceived = function transferRequestsReceivedReceived(payload) {
  return {
    type: TRANSFER_REQUESTS_RECEIVED_RECEIVED,
    payload: payload
  };
};

var transferRequestsRequestedRequested = function transferRequestsRequestedRequested() {
  return {
    type: TRANSFER_REQUESTS_REQUESTED_REQUESTED
  };
};

var transferRequestsRequestedReceived = function transferRequestsRequestedReceived(payload) {
  return {
    type: TRANSFER_REQUESTS_REQUESTED_RECEIVED,
    payload: payload
  };
};

var transferRequestConfirmationSent = function transferRequestConfirmationSent(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_SENT,
    payload: payload
  };
};

var transferRequestConfirmationSuccess = function transferRequestConfirmationSuccess(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_SUCCESS,
    payload: payload
  };
};

var transferRequestConfirmationFailed = function transferRequestConfirmationFailed(payload) {
  return {
    type: TRANSFER_REQUEST_CONFIRMATION_FAILED,
    payload: payload
  };
};

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_TICKERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TICKERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_TICKERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_TICKERS_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchTickers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return subscribeToTickers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeTickersInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return unsubscribeTicker; });
/* unused harmony export unsubscribeAllTickers */
/* unused harmony export receiveTickers */
/* unused harmony export addTickers */
/* unused harmony export requestTickers */
/* unused harmony export setTickersInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_tickersSubscriptionService__ = __webpack_require__(1125);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var RECEIVE_TICKERS = 'RECEIVE_TICKERS';
var ADD_TICKERS = 'ADD_TICKERS';
var REQUEST_TICKERS = 'REQUEST_TICKERS';
var SET_TICKERS_INTERVAL = 'SET_TICKERS_INTERVAL';

var fetchTickers = function fetchTickers() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var selectedInstrumentId, interval, tickersConfig, tickers;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
              interval = getState().tickers.interval;


              dispatch(requestTickers());

              tickersConfig = {
                OMSId: 1,
                InstrumentId: selectedInstrumentId,
                Interval: interval,
                IncludeLastCount: 1000
              };
              _context.next = 6;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('SubscribeTicker', tickersConfig));

            case 6:
              tickers = _context.sent;


              dispatch(receiveTickers(tickers));

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var subscribeToTickers = function subscribeToTickers() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_tickersSubscriptionService__["a" /* default */].subscribe(function (updates) {
      dispatch(addTickers(updates));
    });
  };
};

var changeTickersInterval = function changeTickersInterval(interval) {
  return function (dispatch) {
    dispatch(setTickersInterval(interval));
    return dispatch(fetchTickers());
  };
};

var unsubscribeTicker = function unsubscribeTicker(instrumentId) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_tickersSubscriptionService__["a" /* default */].stopOne(instrumentId);
  };
};

var unsubscribeAllTickers = function unsubscribeAllTickers() {
  return function () {
    __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_tickersSubscriptionService__["a" /* default */].stopAll();
  };
};

var receiveTickers = function receiveTickers(payload) {
  return {
    type: RECEIVE_TICKERS,
    payload: payload
  };
};

var addTickers = function addTickers(payload) {
  return {
    type: ADD_TICKERS,
    payload: payload
  };
};

var requestTickers = function requestTickers() {
  return {
    type: REQUEST_TICKERS
  };
};

var setTickersInterval = function setTickersInterval(payload) {
  return {
    type: SET_TICKERS_INTERVAL,
    payload: payload
  };
};

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_FullPageSpinner_FullPageSpinner__ = __webpack_require__(644);



/* harmony default export */ __webpack_exports__["a"] = (function (loader) {
  return __WEBPACK_IMPORTED_MODULE_0_react_loadable___default()({ loader: loader, loading: __WEBPACK_IMPORTED_MODULE_1__components_common_FullPageSpinner_FullPageSpinner__["a" /* default */], delay: 300 });
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APInlineButton__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__ = __webpack_require__(55);






var CancelAPButton = function CancelAPButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APInlineButton__["a" /* default */], Object.assign({
    styleName: __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__["b" /* styleNames */].subtractive,
    icon: 'cancel',
    iconModifier: 'danger'
  }, props));
};

CancelAPButton.propTypes = {
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  textClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

CancelAPButton.defaultProps = {
  text: 'Cancel'
};

/* harmony default export */ __webpack_exports__["a"] = (CancelAPButton);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FixedLeftFluidLayout_css__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FixedLeftFluidLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FixedLeftFluidLayout_css__);





var layoutClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fix-left-fluid-layout');

var FixedLeftFluidLayout = function FixedLeftFluidLayout(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    props.showAccent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: layoutClasses('accent-bar') }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: layoutClasses('container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: layoutClasses('side-bar') },
        props.left
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: layoutClasses('main') },
        props.children
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: layoutClasses('footer') },
      props.footer
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (FixedLeftFluidLayout);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TradingLayout__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





var mapStateToProps = function mapStateToProps(state) {
  var MarginBorrowerEnabled = state.user.userInfo.MarginBorrowerEnabled;


  return {
    MarginBorrowerEnabled: MarginBorrowerEnabled,
    isMarginActive: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state),
    isMarginEnabledSelector: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_marginSelectors__["d" /* isMarginEnabledSelector */])(state),
    config: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */]
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__TradingLayout__["a" /* default */]));

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var ScalarObservable_1 = __webpack_require__(385);
var EmptyObservable_1 = __webpack_require__(106);
var isScheduler_1 = __webpack_require__(72);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable = (function (_super) {
    __extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function (array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */
    ArrayObservable.of = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len > 1) {
            return new ArrayObservable(array, scheduler);
        }
        else if (len === 1) {
            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
        }
        else {
            return new EmptyObservable_1.EmptyObservable(scheduler);
        }
    };
    ArrayObservable.dispatch = function (state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ArrayObservable.dispatch, 0, {
                array: array, index: index, count: count, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < count && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayObservable;
}(Observable_1.Observable));
exports.ArrayObservable = ArrayObservable;
//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var EmptyObservable = (function (_super) {
    __extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */
    EmptyObservable.create = function (scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function (arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function (subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
        }
        else {
            subscriber.complete();
        }
    };
    return EmptyObservable;
}(Observable_1.Observable));
exports.EmptyObservable = EmptyObservable;
//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIconButton_css__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIconButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__APIconButton_css__);






var APIconButton = function APIconButton(props) {
  var tooltipText = props.tooltipText,
      iconName = props.iconName,
      customClass = props.customClass,
      action = props.action,
      showLabel = props.showLabel,
      tooltipPosition = props.tooltipPosition,
      label = props.label,
      isDisabled = props.isDisabled;

  var baseClass = 'icon-button';
  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        tooltip: tooltipText ? tooltipText : null,
        'tooltip-position': tooltipPosition,
        onClick: action,
        className: '' + bemClasses(null, isDisabled ? 'disabled' : '') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__APIcon__["a" /* default */], { name: iconName, customClass: bemClasses('icon') }),
      showLabel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: bemClasses('label') },
        label || iconName
      )
    )
  );
};

APIconButton.defaultProps = {
  showLabel: true,
  tooltipPosition: 'top'
};

APIconButton.protoTypes = {
  iconName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  parentClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  tooltipPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tooltipText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (APIconButton);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WalletCardGridComponent__ = __webpack_require__(2016);




var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    fetching: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__["a" /* fetchingSelector */])(state),
    products: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__["b" /* fundedPositionsSelector */])(state),
    detailsLink: ownProps.detailsLink
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__WalletCardGridComponent__["a" /* default */]));

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WalletRowListComponent__ = __webpack_require__(2023);




var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    fetching: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__["a" /* fetchingSelector */])(state),
    products: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__["e" /* unfundedPositionsSelector */])(state),
    detailsLink: ownProps.detailsLink
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__WalletRowListComponent__["a" /* default */]));

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentRowSingle_css__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentRowSingle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ComponentRowSingle_css__);






var ComponentRowSingle = function ComponentRowSingle(props, context) {
  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('component-row-single', props.customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    props.header && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('header') },
      context.t(props.header)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses() },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('component-container-100') },
        props.component
      )
    )
  );
};

ComponentRowSingle.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

ComponentRowSingle.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["default"] = (ComponentRowSingle);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InnerSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APSelect_css__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__APSelect_css__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var InnerSelect = function InnerSelect(props) {
  var input = props.input,
      meta = props.meta,
      classModifiers = props.classModifiers,
      customClass = props.customClass,
      info = props.info,
      label = props.label,
      onSelect = props.onSelect,
      showTriangles = props.showTriangles,
      options = props.options,
      passedProps = _objectWithoutProperties(props, ['input', 'meta', 'classModifiers', 'customClass', 'info', 'label', 'onSelect', 'showTriangles', 'options']);

  var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['ap-select', customClass]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'form-group ' + baseClasses('select-wrapper', classModifiers) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { className: 'ap--label ' + baseClasses('select-label') },
      label
    ),
    showTriangles ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('triangles-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'triangle-up' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'triangle-down' })
    ) : '',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'select',
      Object.assign({
        className: 'form-control ' + baseClasses('select')
      }, input, passedProps, {
        onChange: function onChange(e) {
          if (onSelect) onSelect(e.target.value);
          input && input.onChange(e);
        } }),
      options.map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { key: i.value, value: i.value },
          i.label
        );
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'small',
      { className: 'form-text-muted ' + baseClasses('select-info') },
      info
    ),
    meta && meta.dirty && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: baseClasses('select-error') },
      meta.error
    )
  );
};


var APSelect = function APSelect(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: InnerSelect }, props));
};

APSelect.defaultProps = {
  name: '',
  label: '',
  classes: 'input',
  customClass: 'custom-select',
  classModifiers: '',
  info: '',
  autoFocus: '',
  disabled: false,
  multiple: false,
  required: false,
  options: []
};

APSelect.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["b"] = (APSelect);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = APDatePicker;
/* unused harmony export DatePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pikaday_no_moment__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pikaday_no_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pikaday_no_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bem_helper__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bem_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bem_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_same_day__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_is_same_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_is_date__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_is_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_is_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pikaday_no_moment_css_pikaday_css__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pikaday_no_moment_css_pikaday_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pikaday_no_moment_css_pikaday_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__APDatePicker_css__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__APDatePicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__APDatePicker_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var baseClasses = new __WEBPACK_IMPORTED_MODULE_4_react_bem_helper___default.a({
  name: 'ap-datepicker',
  outputIsString: true
});

var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _this.handleChange = function (value) {
      _this.props.input.onChange(value);
      if (_this.props.customChange) {
        _this.props.customChange(value);
      }
    };

    _this.datepickerRef = null;
    _this.inputMaskRef = null;
    _this._picker = null;
    _this.state = { inputMask: '', formatMask: '' };
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.input.value === undefined) {
        this.inputMaskRef.value = '';
      }

      if (!__WEBPACK_IMPORTED_MODULE_7_date_fns_is_same_day___default()(prevProps.input.value, this.props.input.value) && (__WEBPACK_IMPORTED_MODULE_9_date_fns_is_date___default()(this.props.input.value) || this.props.input.value === null)) {
        this._picker.setDate(this.props.input.value);

        if (this.props.input.value === null) {
          this.inputMaskRef.value = '';
        } else {
          this.inputMaskRef.value = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["b" /* formatDate */])(this.props.input.value, this.state.formatMask);
        }
      }

      if ((__WEBPACK_IMPORTED_MODULE_9_date_fns_is_date___default()(this.props.minDate) || this.props.minDate === null) && !__WEBPACK_IMPORTED_MODULE_7_date_fns_is_same_day___default()(prevProps.minDate, this.props.minDate)) {
        this._picker.setMinDate(this.props.minDate);
      }

      if ((__WEBPACK_IMPORTED_MODULE_9_date_fns_is_date___default()(this.props.maxDate) || this.props.maxDate === null) && !__WEBPACK_IMPORTED_MODULE_7_date_fns_is_same_day___default()(prevProps.maxDate, this.props.maxDate)) {
        this._picker.setMaxDate(this.props.maxDate);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _createInputDateMask = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["a" /* createInputDateMask */])(),
          inputMask = _createInputDateMask.inputMask,
          formatMask = _createInputDateMask.formatMask;

      this.setState({ inputMask: inputMask, formatMask: formatMask });
      var el = this.datepickerRef;
      var _props = this.props,
          customFormat = _props.customFormat,
          customParse = _props.customParse,
          minDate = _props.minDate,
          maxDate = _props.maxDate;


      this._picker = new __WEBPACK_IMPORTED_MODULE_2_pikaday_no_moment___default.a(Object.assign({
        field: el,
        yearRange: [1900, new Date().getFullYear()],
        format: formatMask,
        toString: customFormat,
        parse: customParse,
        minDate: minDate,
        maxDate: maxDate,
        onSelect: this.handleChange
      }, this.props.initialOptions));

      this.addClassNames();

      if (__WEBPACK_IMPORTED_MODULE_9_date_fns_is_date___default()(this.props.input.value)) {
        this._picker.setDate(this.props.input.value);
        this.inputMaskRef.value = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["b" /* formatDate */])(this.props.input.value, formatMask);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._picker.destroy();
      this._picker = null;
    }
  }, {
    key: 'getCustomClasses',
    value: function getCustomClasses() {
      return new __WEBPACK_IMPORTED_MODULE_4_react_bem_helper___default.a({
        name: this.props.customClass,
        outputIsString: true
      });
    }
  }, {
    key: 'addClassNames',
    value: function addClassNames() {
      var _this2 = this;

      var customClasses = this.getCustomClasses();
      this._picker.el.classList.add(baseClasses('calendar'));
      customClasses('calendar').split(' ').forEach(function (customClass) {
        return _this2._picker.el.classList.add(customClass);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          label = _props2.label,
          meta = _props2.meta,
          info = _props2.info,
          input = _props2.input,
          disabled = _props2.disabled,
          required = _props2.required,
          showIcon = _props2.showIcon,
          iconClick = _props2.iconClick;

      var onChange = input.onChange,
          _onBlur = input.onBlur,
          value = input.value,
          otherInputProps = _objectWithoutProperties(input, ['onChange', 'onBlur', 'value']);

      var customClasses = this.getCustomClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'form-group ' + baseClasses('input-wrapper') + ' ' + customClasses('dpk-wrapper') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          {
            className: 'ap--label ' + baseClasses('label') + ' ' + customClasses('dpk-label') },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_input_mask___default.a,
          Object.assign({
            ref: function ref(_ref2) {
              return _this3.inputMaskRef = _ref2;
            },
            mask: this.state.inputMask,
            placeholder: this.state.formatMask
          }, { disabled: disabled, required: required }, otherInputProps, {
            onChange: function onChange(e) {
              return _this3.handleChange(e.target.value);
            },
            onBlur: function onBlur(e) {
              return _onBlur(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["e" /* parseDate */])(e.target.value));
            } }),
          function (inputProps) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', Object.assign({
              ref: function ref(_ref) {
                return _this3.datepickerRef = _ref;
              },
              className: 'form-control ' + baseClasses('input') + ' ' + customClasses('dpk-input')
            }, inputProps, {
              autoComplete: 'off'
            }));
          }
        ),
        showIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('icon-container'), onClick: iconClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__APIcon__["a" /* default */], { name: 'calendar', customClass: baseClasses('icon') })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'small',
          {
            className: 'form-text-muted ' + baseClasses('info') + '  ' + customClasses('dpk-info') },
          info
        ),
        meta.dirty && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: baseClasses('error', 'dpk-error') },
          meta.error
        )
      );
    }
  }]);

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  // For custom format visit `toString` section of https://github.com/dbushell/Pikaday#formatting
  customFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  customParse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    touched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  initialOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  showIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  iconClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
DatePicker.defaultProps = {
  label: 'Date',
  customClass: 'custom-datepicker',
  info: '',
  disabled: false,
  required: false,
  initialOptions: {},
  customFormat: __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["b" /* formatDate */],
  customParse: __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["e" /* parseDate */],
  showIcon: false
};


function APDatePicker(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: DatePicker }, props));
}



/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentWithHeaderLayoutTemplate_css__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentWithHeaderLayoutTemplate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContentWithHeaderLayoutTemplate_css__);






/**
 * This is layout for following case:
 *  ___________________________
 * | {header}                  |
 * |___________________________|
 * |                           |
 * | {content}                 |
 * |                           |
 * |___________________________|
 */
var ContentWithHeaderLayoutTemplate = function ContentWithHeaderLayoutTemplate(props) {
  var children = props.children,
      customClass = props.customClass,
      classModifiers = props.classModifiers,
      header = props.header;


  var baseLayoutTemplateClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('base-lt', customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: baseLayoutTemplateClasses('layout-template', classModifiers) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseLayoutTemplateClasses('header', classModifiers) },
      header
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseLayoutTemplateClasses('body', classModifiers) },
      children
    )
  );
};

ContentWithHeaderLayoutTemplate.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired
};

ContentWithHeaderLayoutTemplate.defaultProps = {
  customClass: 'custom-retail-widget'
};

/* harmony default export */ __webpack_exports__["a"] = (ContentWithHeaderLayoutTemplate);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(925);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134),
    getRawTag = __webpack_require__(1081),
    objectToString = __webpack_require__(1082);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1089),
    getValue = __webpack_require__(1092);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatErrorText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return preprocessErrorTextForReduxForm; });
var formatErrorText = function formatErrorText(errorResponse) {
  var result = errorResponse.errorcode + ': ' + errorResponse.errormsg;

  if (errorResponse.detail) {
    result = result + ': ' + errorResponse.detail;
  }

  return result;
};

/**
 * The point of this function is to:
 *  1. Relate a generalized server errormsg to a specific form-field.
 *  2. Return formatted errormsg in a form that redux-form expects.
 *  3. Use `_error` for non-field-specific messages.
 *
 * @param {String} _error : This is the server response, `response.errormsg`.
 * @param {Object} formValues : Form values.
 */
var preprocessErrorTextForReduxForm = function preprocessErrorTextForReduxForm(_error, formValues) {
  return Object.keys(formValues).reduce(function (acc, key) {
    if (_error.toLowerCase().includes(key.toLowerCase())) {
      acc._error = '';
      acc[key] = _error;
    }
    return acc;
  }, { _error: _error });
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_CONFIG_UPDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROCESSING_VALIDATE_USER_REGISTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINISHED_VALIDATE_USER_REGISTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return processingValidateUserRegistration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return finishedValidateUserRegistration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateAccount; });
/* unused harmony export userConfigUpdated */
/* unused harmony export updateUserConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return subscribeToVerificationLevelUpdateEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return temporarilySetLevelIncreaseStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_subscriptions_verificationLevelUpdateService__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_arrayHelper__ = __webpack_require__(88);





var UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
var USER_CONFIG_UPDATED = 'USER_CONFIG_UPDATED';
var PROCESSING_VALIDATE_USER_REGISTRATION = 'PROCESSING_VALIDATE_USER_REGISTRATION';
var FINISHED_VALIDATE_USER_REGISTRATION = 'FINISHED_VALIDATE_USER_REGISTRATION';

var processingValidateUserRegistration = {
  type: PROCESSING_VALIDATE_USER_REGISTRATION
};
var finishedValidateUserRegistration = {
  type: FINISHED_VALIDATE_USER_REGISTRATION
};

var updateAccount = function updateAccount(payload) {
  return {
    type: UPDATE_ACCOUNT,
    payload: payload
  };
};

var userConfigUpdated = function userConfigUpdated(payload) {
  return {
    type: USER_CONFIG_UPDATED,
    payload: payload
  };
};

var updateUserConfig = function updateUserConfig(userConfigUpdatedPayload) {
  var closeSidePane = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch(userConfigUpdated(userConfigUpdatedPayload));
    if (closeSidePane) dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__sidePaneActions__["f" /* closeKYCSidePane */])());
  };
};

var subscribeToVerificationLevelUpdateEvents = function subscribeToVerificationLevelUpdateEvents(state) {
  return function (dispatch) {
    var stateItem = Object.assign({}, state);
    __WEBPACK_IMPORTED_MODULE_0__services_subscriptions_verificationLevelUpdateService__["a" /* default */].subscribe(function (update) {
      stateItem.VerificationLevel = update.VerificationLevel;
      var payload = {
        index: 0,
        item: stateItem
      };
      dispatch(updateAccount(payload));
    });
  };
};

var temporarilySetLevelIncreaseStatus = function temporarilySetLevelIncreaseStatus(_ref) {
  var levelIncreaseStatus = _ref.levelIncreaseStatus;
  return function (dispatch, getState) {
    var _kycLevelFormSelector = Object(__WEBPACK_IMPORTED_MODULE_2__selectors_kycLevelsSelectors__["a" /* kycLevelFormSelector */])(getState()),
        userConfig = _kycLevelFormSelector.userConfig;

    var levelIncreaseStatusIndex = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_arrayHelper__["b" /* findIndexOfObject */])(userConfig, 'Key', 'levelIncreaseStatus');
    var setLevelIncreaseStatusPayload = {
      index: levelIncreaseStatusIndex,
      item: { Key: 'levelIncreaseStatus', Value: levelIncreaseStatus }
    };

    dispatch(updateUserConfig(setLevelIncreaseStatusPayload, false));
  };
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_AFFILIATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_AFFILIATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_AFFILIATE_COUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateAffiliate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAffiliate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAffiliateCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return openAffiliateModal; });
/* unused harmony export updateAffiliateSuccess */
/* unused harmony export getAffiliateSuccess */
/* unused harmony export getAffiliateCountSuccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarActions__ = __webpack_require__(20);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var UPDATE_AFFILIATE_SUCCESS = 'UPDATE_AFFILIATE_SUCCESS';
var GET_AFFILIATE_SUCCESS = 'GET_AFFILIATE_SUCCESS';
var GET_AFFILIATE_COUNT_SUCCESS = 'GET_AFFILIATE_COUNT_SUCCESS';

var updateAffiliate = function updateAffiliate(formValues) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var AffiliateTag, _getState$user$userIn, UserId, OMSId, AffiliateId;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              AffiliateTag = formValues.tag;
              _getState$user$userIn = getState().user.userInfo, UserId = _getState$user$userIn.UserId, OMSId = _getState$user$userIn.OMSId, AffiliateId = _getState$user$userIn.AffiliateId;
              _context.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('AddUserAffiliateTag', {
                OMSId: OMSId,
                UserId: UserId,
                AffiliateId: AffiliateId,
                AffiliateTag: AffiliateTag
              })).then(function (res) {
                if (res.result) {
                  dispatch(updateAffiliateSuccess(AffiliateTag));
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_2__modalActions__["b" /* MODAL_TYPES */].NEW_AFFILIATE_KEY));
                } else {
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                    id: 'createAffiliateError',
                    // context.t('Could not create tag or tag already in use')
                    text: 'Could not create tag or tag already in use',
                    type: 'warning'
                  }));
                }
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getAffiliate = function getAffiliate(OMSId, UserId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserAffiliateTag', {
                OMSId: OMSId,
                UserId: UserId
              })).then(function (res) {
                dispatch(getAffiliateSuccess(res));
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var getAffiliateCount = function getAffiliateCount() {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserAffiliateCount', {})).then(function (res) {
                return dispatch(getAffiliateCountSuccess(res));
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var openAffiliateModal = function openAffiliateModal() {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_2__modalActions__["b" /* MODAL_TYPES */].NEW_AFFILIATE_KEY));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var updateAffiliateSuccess = function updateAffiliateSuccess(payload) {
  return {
    type: UPDATE_AFFILIATE_SUCCESS,
    payload: payload
  };
};

var getAffiliateSuccess = function getAffiliateSuccess(payload) {
  return {
    type: GET_AFFILIATE_SUCCESS,
    payload: payload
  };
};

var getAffiliateCountSuccess = function getAffiliateCountSuccess(payload) {
  return {
    type: GET_AFFILIATE_COUNT_SUCCESS,
    payload: payload
  };
};

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderTotalSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bignumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_placeOrderHelper__ = __webpack_require__(132);








var orderTotalSelector = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([function (state) {
  return state.apexCore.level1;
}, function (state) {
  return state.apexCore.level2;
}, function (state, options) {
  return options.form;
}], function (level1, level2, form) {
  var orderType = form.orderType,
      quantity = form.quantity,
      side = form.side,
      stopPrice = form.stopPrice,
      limitPrice = form.limitPrice,
      trailingAmount = form.trailingAmount,
      limitOffset = form.limitOffset;


  if (orderType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].market.displayName) {
    var _config$OrderCalcBuff = __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].OrderCalcBuffer;
    _config$OrderCalcBuff = _config$OrderCalcBuff === undefined ? {} : _config$OrderCalcBuff;
    var priceBuffer = _config$OrderCalcBuff.priceBuffer;


    var orders = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_orderHelper__["h" /* getOrdersBySide */])(side, level2);

    var _price = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_orderHelper__["i" /* getPriceForQuantity */])(quantity, priceBuffer, orders, true, side);

    return _price.Price;
  }

  if (orderType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName) {
    var _price2 = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(stopPrice);
    var _parsedQuantity = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(quantity);

    return _price2.times(_parsedQuantity);
  }

  if (orderType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopLimit.displayName) {
    var _price3 = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(limitPrice);
    var _parsedQuantity2 = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(quantity);

    return _price3.times(_parsedQuantity2);
  }

  if (orderType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopMarket.displayName) {
    var pegPrice = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_placeOrderHelper__["d" /* getPegPriceByType */])(level1, form));

    var _price4 = side === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? pegPrice.plus(trailingAmount) : pegPrice.minus(trailingAmount);

    var _parsedQuantity3 = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(quantity);

    return _price4.times(_parsedQuantity3);
  }

  if (orderType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopLimit.displayName) {
    var _pegPrice = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_placeOrderHelper__["d" /* getPegPriceByType */])(level1, form));

    var _price5 = side === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? _pegPrice.plus(trailingAmount).plus(limitOffset) : _pegPrice.minus(trailingAmount).minus(limitOffset);

    var _parsedQuantity4 = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(quantity);

    return _price5.times(_parsedQuantity4);
  }

  if (orderType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].reportBlockTrade.displayName) {
    var _price6 = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(form.price || '0');
    var _parsedQuantity5 = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(quantity);
    return side === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? _price6 : _parsedQuantity5;
  }

  // Default:
  var price = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(limitPrice);
  var parsedQuantity = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(quantity);

  return price.times(parsedQuantity);
});

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parse;
exports.extractFormattedPhoneNumber = extractFormattedPhoneNumber;

var _constants = __webpack_require__(68);

var _ParseError = _interopRequireDefault(__webpack_require__(343));

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(180));

var _extractExtension = _interopRequireDefault(__webpack_require__(1342));

var _parseIncompletePhoneNumber = _interopRequireDefault(__webpack_require__(344));

var _getCountryCallingCode = _interopRequireDefault(__webpack_require__(345));

var _isPossibleNumber_ = __webpack_require__(346);

var _RFC = __webpack_require__(253);

var _PhoneNumber = _interopRequireDefault(__webpack_require__(254));

var _matchesEntirely = _interopRequireDefault(__webpack_require__(146));

var _extractCountryCallingCode = _interopRequireDefault(__webpack_require__(600));

var _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign = _interopRequireDefault(__webpack_require__(349));

var _extractNationalNumber = _interopRequireDefault(__webpack_require__(601));

var _stripIddPrefix = _interopRequireDefault(__webpack_require__(348));

var _getCountryByCallingCode = _interopRequireDefault(__webpack_require__(603));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.
var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + _constants.PLUS_CHARS + _constants.VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + _constants.VALID_DIGITS + '#' + ']+$');
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // `options`:
//  {
//    country:
//    {
//      restrict - (a two-letter country code)
//                 the phone number must be in this country
//
//      default - (a two-letter country code)
//                default country to use for phone number parsing and validation
//                (if no country code could be derived from the phone number)
//    }
//  }
//
// Returns `{ country, number }`
//
// Example use cases:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new _metadata["default"](metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new _ParseError["default"]('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      throw new _ParseError["default"]('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new _ParseError["default"]('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < _constants.MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new _ParseError["default"]('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > _constants.MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new _ParseError["default"]('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new _PhoneNumber["default"](countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, _matchesEntirely["default"])(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, _isPossibleNumber_.isPossibleNumber)(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} throwOnError — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */


function extractFormattedPhoneNumber(text, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new _ParseError["default"]('TOO_LONG');
    }

    return;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return (0, _RFC.parseRFC3966)(text);
  }

  var number = extractFormattedPhoneNumber(text, v2); // If the phone number is not viable, then abort.

  if (!number || !(0, _isViablePhoneNumber["default"])(number)) {
    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = (0, _extractExtension["default"])(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = (0, _extractCountryCallingCode["default"])((0, _parseIncompletePhoneNumber["default"])(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
      metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

      if (defaultCountry) {
        country = defaultCountry;
      } else {
        /* istanbul ignore if */
        if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
          if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
            country = '001';
          }
        }
      }

      countryCallingCode = defaultCallingCode || (0, _getCountryCallingCode["default"])(defaultCountry, metadata.metadata);
    } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = (0, _extractNationalNumber["default"])((0, _parseIncompletePhoneNumber["default"])(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = (0, _getCountryByCallingCode["default"])(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
//# sourceMappingURL=parse_.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDigit = parseDigit;
exports["default"] = parseDigits;
exports.DIGITS = void 0;
// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
exports.DIGITS = DIGITS;

function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */


function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=parseDigits.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ConnectableObservable_1 = __webpack_require__(722);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') {
            subjectFactory = subjectOrSubjectFactory;
        }
        else {
            subjectFactory = function subjectFactory() {
                return subjectOrSubjectFactory;
            };
        }
        if (typeof selector === 'function') {
            return source.lift(new MulticastOperator(subjectFactory, selector));
        }
        var connectable = Object.create(source, ConnectableObservable_1.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
exports.multicast = multicast;
var MulticastOperator = (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());
exports.MulticastOperator = MulticastOperator;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MenuItem_MenuItemComponent__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routeTemplates__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WalletDetailsBackButton_css__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WalletDetailsBackButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__WalletDetailsBackButton_css__);











var baseClass = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-details-back-button');

var WalletDetailsBackButtonComponent = function WalletDetailsBackButtonComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__MenuItem_MenuItemComponent__["a" /* default */],
    {
      customClass: baseClass(),
      onItemClick: function onItemClick() {
        return props.history.push(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_path__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__routeTemplates__["d" /* walletsPath */].path));
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APIcon__["a" /* default */], { name: 'arrowPrevious', customClass: baseClass() }),
    ' ',
    context.t('Back to Overview')
  );
};

WalletDetailsBackButtonComponent.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};

WalletDetailsBackButtonComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* withRouter */])(WalletDetailsBackButtonComponent));

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarketDataCardsComponent__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);





var mapStateToProps = function mapStateToProps(state) {
  var level1 = state.apexCore.level1;

  var instruments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);

  var products = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state);

  return { level1: level1, instruments: instruments, products: products };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MarketDataCardsComponent__["a" /* default */]));

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WalletDetails_WalletDetailsContainer__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RecentActivityWithFilter__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Transfers_TransfersContainer__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Transfers_TransfersFilters__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WalletDetailsLayout_css__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WalletDetailsLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__WalletDetailsLayout_css__);











var walletDetailsLayoutClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-details-layout');

var WalletDetailsLayout = function WalletDetailsLayout(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: walletDetailsLayoutClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletDetailsLayoutClasses('wallet-details') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_WalletDetails_WalletDetailsContainer__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_7__config__["b" /* default */].global.allowTransfer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletDetailsLayoutClasses('transfers') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: walletDetailsLayoutClasses('transfers-header') },
        context.t('Transfers')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Transfers_TransfersFilters__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Transfers_TransfersContainer__["a" /* default */], null)
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletDetailsLayoutClasses('recent-activity') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_RecentActivityWithFilter__["default"], { filterForSelected: true })
    )
  );
};

WalletDetailsLayout.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["default"] = (WalletDetailsLayout);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mainNavOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return subNavOptions; });
/* unused harmony export settingsNav */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return walletsPath; });
/* unused harmony export walletDetailPath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultPath; });
/* unused harmony export routeTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__advancedTemplate__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__retailTemplate__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__londonTemplate__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__milanAltTemplate__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EotcTemplate__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__basicTradingTemplate__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__v3standardTemplate__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__settingsRoutes__ = __webpack_require__(2163);













var mainNavOptions = { mainNavItems: [], settingsPath: '' };
var subNavOptions = { subNavItems: [] };
var settingsNav = { items: [] };
var walletsPath = { path: '' };
var walletDetailPath = { path: '' };
var defaultPath = { path: '' };
var routeTemplate = { routes: function routes() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      ' Loading '
    );
  } };

var AssignRoutes = function AssignRoutes() {
  switch (__WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].global.template) {
    case 'MILAN':
    case 'RETAIL':
      AssignRouteValues(__WEBPACK_IMPORTED_MODULE_5__retailTemplate__);
      break;
    case 'MILAN-ALT':
      AssignRouteValues(__WEBPACK_IMPORTED_MODULE_7__milanAltTemplate__);
      break;
    case 'NEWYORK':
    case 'ADVANCED':
      AssignRouteValues(__WEBPACK_IMPORTED_MODULE_4__advancedTemplate__);
      break;
    case 'CAPETOWN':
    case 'BASICTRADING':
      AssignRouteValues(__WEBPACK_IMPORTED_MODULE_9__basicTradingTemplate__);
      break;
    case 'LONDON':
      AssignRouteValues(__WEBPACK_IMPORTED_MODULE_6__londonTemplate__);
      break;
    case 'GALAXY':
    case 'EOTC':
      AssignRouteValues(__WEBPACK_IMPORTED_MODULE_8__EotcTemplate__);
      break;
    case 'STANDARD':
      AssignRouteValues(__WEBPACK_IMPORTED_MODULE_10__v3standardTemplate__);
      break;
    default:
      AssignRouteValues(__WEBPACK_IMPORTED_MODULE_5__retailTemplate__);
      break;
  }
};

var AssignRouteValues = function AssignRouteValues(source) {
  mainNavOptions.mainNavItems = source.mainNavOptions.mainNavItems;
  mainNavOptions.settingsPath = source.mainNavOptions.settingsPath;
  subNavOptions.subNavItems = source.subNavItems;
  settingsNav.items = __WEBPACK_IMPORTED_MODULE_11__settingsRoutes__["a" /* settingsNavItems */];
  walletsPath.path = source.walletsPath;
  walletDetailPath.path = source.walletDetailPath;
  defaultPath.path = source.routesArray[0].path;
  routeTemplate.routes = SetupRoutes(source.routesArray);
};

var SetupRoutes = function SetupRoutes(routesArray) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    routesArray.concat(__WEBPACK_IMPORTED_MODULE_11__settingsRoutes__["b" /* settingsRoutesArray */]).filter(function (i) {
      return i.show === undefined || i.show;
    }).map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], {
        exact: item.exact,
        path: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])(item.path),
        key: item.path,
        render: item.render
      });
    })
  );
};

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(879);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormValuesForSubmittingOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOrderEventSnackbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isLimitPriceFieldInForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isTimeInForceFieldInForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isStopPriceFieldInForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isLimitOffsetFieldInForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDisplayQuantityFieldInForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isTrailingAmountFieldInForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isPegPriceFieldInForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOrderTypeByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPegPriceByType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bignumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_timeInForceConstants__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_pegPriceTypeConstants__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_selectors_buySellSelectors__ = __webpack_require__(44);










var getFormValuesForSubmittingOrder = function getFormValuesForSubmittingOrder(orderFormType, options) {
  var instrument = options.instrument,
      userInfo = options.userInfo,
      selectedAccountId = options.selectedAccountId;


  var baseOptions = {
    InstrumentId: instrument.selectedInstrumentId,
    OMSId: userInfo.OMSId,
    AccountId: selectedAccountId,
    TimeInForce: 1,
    ClientOrderId: 0,
    OrderIdOCO: 0,
    UseDisplayQuantity: false
  };

  if (orderFormType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].default) {
    return getFormValuesForDefaultForm(baseOptions, options);
  } else if (orderFormType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].advanced) {
    return getFormValuesForAdvancedForm(baseOptions, options);
  } else if (orderFormType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].block) {
    return getFormValuesForReportBlockTradeForm(baseOptions, options);
  } else if (orderFormType === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].buySell) {
    return getFormValuesForBuySellForm(baseOptions, options);
  } else {
    console.error('order form type ' + orderFormType + ' does not exists');
    return {};
  }
};

var getOrderEventSnackbar = function getOrderEventSnackbar(order) {
  var type = void 0,
      text = void 0,
      textVars = void 0;
  var isCancelled = order.OrderState === 'Canceled';

  if (['Working', 'FullyExecuted'].some(function (i) {
    return order.OrderState === i;
  })) {
    // context.t('Your order has been successfully added')
    text = 'Your order has been successfully added';
    type = 'success';
  } else if (order.OrderState === 'Rejected' || isCancelled) {
    if (order.RejectReason || order.CancelReason || order.ChangeReason) {
      text = order.RejectReason || order.CancelReason || order.ChangeReason;
      type = 'warning';
    } else {
      // context.t('Your Order has been {n}')
      text = 'Your Order has been {n}';
      textVars = { n: order.OrderState };
      type = isCancelled ? 'success' : 'warning';
    }
  }

  return { type: type, text: text, textVars: textVars };
};

var isLimitPriceFieldInForm = function isLimitPriceFieldInForm(orderType) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopLimit.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].fillOrKill.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].immediateOrCancel.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].reserveOrder.displayName].some(function (i) {
    return i === orderType;
  });
};

var isTimeInForceFieldInForm = function isTimeInForceFieldInForm(orderType) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopLimit.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopLimit.displayName].some(function (i) {
    return i === orderType;
  });
};

var isStopPriceFieldInForm = function isStopPriceFieldInForm(orderType) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopLimit.displayName].some(function (i) {
    return i === orderType;
  });
};

var isLimitOffsetFieldInForm = function isLimitOffsetFieldInForm(orderType) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopLimit.displayName].some(function (i) {
    return i === orderType;
  });
};

var isDisplayQuantityFieldInForm = function isDisplayQuantityFieldInForm(orderType) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].reserveOrder.displayName].some(function (i) {
    return i === orderType;
  });
};

var isTrailingAmountFieldInForm = function isTrailingAmountFieldInForm(orderType) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopLimit.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopMarket.displayName].some(function (i) {
    return i === orderType;
  });
};

var isPegPriceFieldInForm = function isPegPriceFieldInForm(orderType) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopLimit.displayName, __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].trailingStopMarket.displayName].some(function (i) {
    return i === orderType;
  });
};

var getOrderTypeByName = function getOrderTypeByName(displayName) {
  var key = Object.keys(__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */]).find(function (key) {
    return __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */][key].displayName === displayName;
  });

  return __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */][key].orderType;
};

var getFormValuesForDefaultForm = function getFormValuesForDefaultForm(baseOptions, options) {
  var form = options.form;

  var formValues = form;

  var defaultForm = Object.assign({}, baseOptions, {
    Side: Number(formValues.side),
    Quantity: formValues.quantity,
    OrderType: Number(getOrderTypeByName(formValues.orderType)),
    PegPriceType: getPegPriceTypeBySide(formValues.side)
  });

  if (isLimitPriceFieldInForm(formValues.orderType)) {
    defaultForm.LimitPrice = formValues.limitPrice;
  }

  if (isTimeInForceFieldInForm(formValues.orderType)) {
    defaultForm.TimeInForce = Number(formValues.timeInForce);
  }

  if (isStopPriceFieldInForm(formValues.orderType)) {
    defaultForm.StopPrice = formValues.stopPrice;
  }

  return defaultForm;
};

var getFormValuesForAdvancedForm = function getFormValuesForAdvancedForm(baseOptions, options) {
  var form = options.form;

  var formValues = form;

  var advancedForm = Object.assign({}, baseOptions, {
    Side: Number(formValues.side),
    Quantity: formValues.quantity,
    OrderType: Number(getOrderTypeByName(formValues.orderType)),
    TimeInForce: getTimeInForceValue(formValues.orderType),
    PegPriceType: getPegPriceTypeBySide(formValues.side)
  });

  if (isLimitPriceFieldInForm(formValues.orderType)) {
    advancedForm.LimitPrice = formValues.limitPrice;
  }
  if (isTimeInForceFieldInForm(formValues.orderType)) {
    advancedForm.TimeInForce = Number(formValues.timeInForce);
  }
  if (isStopPriceFieldInForm(formValues.orderType)) {
    advancedForm.StopPrice = formValues.stopPrice;
  }
  if (isTrailingAmountFieldInForm(formValues.orderType)) {
    advancedForm.TrailingAmount = formValues.trailingAmount;
  }
  if (isPegPriceFieldInForm(formValues.orderType)) {
    advancedForm.PegPriceType = formValues.pegPriceType;
  }
  if (isDisplayQuantityFieldInForm(formValues.orderType)) {
    advancedForm.DisplayQuantity = formValues.displayQuantity;
    advancedForm.UseDisplayQuantity = true;
  }
  if (isLimitOffsetFieldInForm(formValues.orderType)) {
    advancedForm.LimitOffset = formValues.limitOffset;
  }
  return advancedForm;
};

var getFormValuesForReportBlockTradeForm = function getFormValuesForReportBlockTradeForm(baseOptions, options) {
  var form = options.form;

  var formValues = form;

  var price = form.side === __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(formValues.price) : new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(formValues.quantity);
  var quantity = form.side === __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(formValues.quantity) : new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(formValues.price);

  var LimitPrice = price.toFixed(options.priceDecimalPlaces).toString();
  if (!options.useNewForm) {
    LimitPrice = price.div(quantity).toFixed(options.priceDecimalPlaces).toString();
  }

  return {
    LimitPrice: LimitPrice,
    InstrumentId: baseOptions.InstrumentId,
    AccountId: baseOptions.AccountId,
    Side: parseInt(formValues.side, 10),
    counterPartyId: formValues.counterparty.toString(),
    Quantity: quantity,
    OMSId: baseOptions.OMSId,
    LockedIn: formValues.lockedIn,
    Timestamp: Date.now()
  };
};

var getFormValuesForBuySellForm = function getFormValuesForBuySellForm(baseOptions, options) {
  var form = options.form,
      level2 = options.level2,
      state = options.state;
  var roundBuyLimitPrices = __WEBPACK_IMPORTED_MODULE_7__config__["b" /* default */].RetailBuySell.roundBuyLimitPrices;

  var formValues = form;
  var selectedValues = Object(__WEBPACK_IMPORTED_MODULE_8__redux_selectors_buySellSelectors__["a" /* getOrderFormInfoSelector */])(state);

  var orders = Object(__WEBPACK_IMPORTED_MODULE_1__orderHelper__["h" /* getOrdersBySide */])(formValues.side, level2);
  var _config$OrderCalcPadd = __WEBPACK_IMPORTED_MODULE_7__config__["b" /* default */].OrderCalcPadding;
  _config$OrderCalcPadd = _config$OrderCalcPadd === undefined ? {} : _config$OrderCalcPadd;
  var quantityPadding = _config$OrderCalcPadd.quantityPadding;

  var LimitPrice = Object(__WEBPACK_IMPORTED_MODULE_1__orderHelper__["j" /* getQuantityForPrice */])(selectedValues.price, quantityPadding, orders, false, formValues.side).LimitPrice;
  var buy = !Number(formValues.side);
  LimitPrice = Object(__WEBPACK_IMPORTED_MODULE_6__numberFormatter__["i" /* truncateToDecimals */])(LimitPrice, options.priceDecimalPlaces, roundBuyLimitPrices && buy ? __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a.ROUND_CEIL : null).toNumber();

  return Object.assign({}, baseOptions, {
    TimeInForce: __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_timeInForceConstants__["a" /* timeInForceForOrderType */]['Fill Or Kill'],
    Side: Number(formValues.side),
    Quantity: selectedValues.quantity,
    OrderType: Number(__WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.orderType),
    LimitPrice: LimitPrice
  });
};

var getTimeInForceValue = function getTimeInForceValue(orderType) {
  var timeInForceValue = 1;
  if (__WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_timeInForceConstants__["a" /* timeInForceForOrderType */][orderType] !== undefined) {
    timeInForceValue = __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_timeInForceConstants__["a" /* timeInForceForOrderType */][orderType];
  }
  return timeInForceValue;
};

var getPegPriceByType = function getPegPriceByType(level1, form) {
  var level1ForInstrument = level1[form.instrument];

  if (form.pegPriceType === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_pegPriceTypeConstants__["a" /* pegPriceType */].ask) {
    return level1ForInstrument.BestOffer;
  } else if (form.pegPriceType === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_pegPriceTypeConstants__["a" /* pegPriceType */].bid) {
    return level1ForInstrument.BestBid;
  } else if (form.pegPriceType === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_pegPriceTypeConstants__["a" /* pegPriceType */].last) {
    return level1ForInstrument.LastTradedPx;
  }
};

var getPegPriceTypeBySide = function getPegPriceTypeBySide(side) {
  return side === __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_pegPriceTypeConstants__["a" /* pegPriceType */].ask : __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_pegPriceTypeConstants__["a" /* pegPriceType */].bid;
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(63),
    isKey = __webpack_require__(308),
    stringToPath = __webpack_require__(1083),
    toString = __webpack_require__(497);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(231);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export openOrdersSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openOrdersSelectorFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buyOpenOrdersSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sellOpenOrdersSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filledOrdersSelectorFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inactiveOrdersSelectorFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tradeReportsSelectorFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_orderHistoryFilters__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instrumentPositionSelectors__ = __webpack_require__(8);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var formSelector = Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["g" /* formValueSelector */])('order-history-filter');

var openOrdersCurrencySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.orderHistory.openOrders;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.apexCore.orderHistory.tradeReports;
}], convertOrderNumbersToCurrency);

var trailingOrdersSelectorFactory = function trailingOrdersSelectorFactory(ordersSelector) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(ordersSelector, function (orders) {
    return orders.map(function (order) {
      if (order.OrderType === 'TrailingStopLimit' || order.OrderType === 'TrailingStopMarket') {
        return Object.assign({}, order, {
          trailingPrice: 'TRL'
        });
      }

      return order;
    });
  });
};

var openOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(openOrdersCurrencySelector, function (orders) {
  return orders.filter(function (order) {
    return order.OrderState !== 'FullyExecuted' && order.OrderState === 'Working';
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  });
});

var openOrdersSelectorFactory = function openOrdersSelectorFactory() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([trailingOrdersSelectorFactory(openOrdersSelector), function (state) {
    return state.apexCore.position.selectedProductId;
  }, __WEBPACK_IMPORTED_MODULE_4__instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return formSelector(state, 'startDate', 'endDate');
  }, function (state, props) {
    return props.filterMode;
  }], function (orders, selectedProductId, selectedInstrument, instruments, formValues, filterMode) {
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    if (filterMode === 'selectedProduct') {
      var filteredOrders = orders;
      if (selectedProductId) {
        filteredOrders = filterOrdersByProductId(orders, selectedProductId, instruments);
      }
      return filterOrdersByDate(filteredOrders, formValues, 'ReceiveTime');
    } else {
      // else filterMode == 'selectedInstrument'
      return orders.filter(function (order) {
        return order.Instrument === selectedInstrumentId;
      });
    }
  });
};

var buyOpenOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(openOrdersSelectorFactory(), function (orders) {
  return orders.filter(function (order) {
    return order.Side === 'Buy' && order.OrderType !== 'BlockTrade';
  });
});

var sellOpenOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(openOrdersSelectorFactory(), function (orders) {
  return orders.filter(function (order) {
    return order.Side === 'Sell' && order.OrderType !== 'BlockTrade';
  });
});

var accountTradesCurrencySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.orderHistory.accountTrades;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.apexCore.product.products;
}], function (trades, instruments, products) {
  return trades.map(function (trade) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === trade.InstrumentId;
    });
    if (!instrument) return {};
    var Product1Symbol = instrument.Product1Symbol,
        Product2Symbol = instrument.Product2Symbol;

    var quantity = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(trade.Quantity, Product1Symbol);
    var price = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(trade.Price, Product2Symbol);
    var symbol = trade.Side === 'Buy' ? Product1Symbol : Product2Symbol;
    var value = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(trade.Value, symbol);
    var feeProduct = products.find(function (p) {
      return p.ProductId === trade.FeeProductId;
    });
    var fee = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(trade.Fee, feeProduct ? feeProduct.Product : symbol);

    return Object.assign({}, trade, {
      Quantity: quantity,
      Price: price,
      Value: value,
      Fee: fee
    });
  });
});

var filledOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(accountTradesCurrencySelector, function (trades) {
  return trades.filter(function (trade) {
    return !trade.IsBlockTrade;
  }).sort(function (a, b) {
    if (a.TradeTime < b.TradeTime) return 1;
    if (a.TradeTime > b.TradeTime) return -1;
    return 0;
  });
});

var filledOrdersSelectorFactory = function filledOrdersSelectorFactory() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([trailingOrdersSelectorFactory(filledOrdersSelector), function (state) {
    return state.apexCore.position.selectedProductId;
  }, __WEBPACK_IMPORTED_MODULE_4__instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return formSelector(state, 'startDate', 'endDate');
  }, function (state, props) {
    return props.filterMode;
  }], function (orders, selectedProductId, selectedInstrument, instruments, formValues, filterMode) {
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    if (filterMode === 'selectedProduct') {
      var filteredOrders = orders;
      if (selectedProductId) {
        filteredOrders = filterOrdersByProductId(orders, selectedProductId, instruments);
      }
      return filterOrdersByDate(filteredOrders, formValues, 'TradeTimeMS');
    } else {
      // else filterMode == 'selectedInstrument'
      return orders.filter(function (order) {
        return order.InstrumentId === selectedInstrumentId;
      });
    }
  });
};

var inactiveOrdersCurrencySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.orderHistory.inactiveOrders;
}, function (state) {
  return state.apexCore.instrument.instruments;
}], convertOrderNumbersToCurrency);

var inactiveOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(inactiveOrdersCurrencySelector, function (orders) {
  return orders.filter(function (order) {
    return order.OrderState !== 'FullyExecuted' && order.OrderState !== 'Working';
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  });
});

var inactiveOrdersSelectorFactory = function inactiveOrdersSelectorFactory() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([trailingOrdersSelectorFactory(inactiveOrdersSelector), function (state) {
    return state.apexCore.position.selectedProductId;
  }, __WEBPACK_IMPORTED_MODULE_4__instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return formSelector(state, 'startDate', 'endDate');
  }, function (state, props) {
    return props.filterMode;
  }], function (orders, selectedProductId, selectedInstrument, instruments, formValues, filterMode) {
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    if (filterMode === 'selectedProduct') {
      var filteredOrders = orders;
      if (selectedProductId) {
        filteredOrders = filterOrdersByProductId(orders, selectedProductId, instruments);
      }
      return filterOrdersByDate(filteredOrders, formValues, 'ReceiveTime');
    } else {
      // else filterMode == 'selectedInstrument'
      return orders.filter(function (order) {
        return order.Instrument === selectedInstrumentId;
      });
    }
  });
};

function convertOrderNumbersToCurrency(orders, instruments) {
  var tradeReports = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var allOrders = [].concat(_toConsumableArray(orders), _toConsumableArray(tradeReports));
  return allOrders.filter(function (order) {
    return !!order;
  }).map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument;
    });

    if (!instrument) {
      return order;
    }

    var Product1Symbol = instrument.Product1Symbol,
        Product2Symbol = instrument.Product2Symbol;

    var quantity = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(order.Quantity, Product1Symbol);
    var origQuantity = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(order.OrigQuantity, Product1Symbol);
    var price = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(order.Price, Product2Symbol);

    return Object.assign({}, order, {
      quantity: quantity,
      OrigQuantity: origQuantity,
      Price: price
    });
  });
}

var tradeReportsCurrecnySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.orderHistory.tradeReports;
}, function (state) {
  return state.apexCore.instrument.instruments;
}], function (tradeReports, instruments) {
  var trades = tradeReports.filter(function (order) {
    return order.OrderState !== 'Working';
  });
  trades.map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.InstrumentId || order.Instrument;
    });
    var Product1Symbol = instrument.Product1Symbol,
        Product2Symbol = instrument.Product2Symbol;

    var quantity = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(order.Quantity, Product1Symbol);
    var price = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(order.Price, Product2Symbol);
    var symbol = order.Side === 'Buy' ? Product1Symbol : Product2Symbol;
    var fee = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(order.Fee, symbol);

    return Object.assign({}, order, {
      Quantity: quantity,
      Price: price,
      Fee: fee
    });
  });

  return trades;
});

var tradeReportsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([tradeReportsCurrecnySelector, accountTradesCurrencySelector], function (tradeReports, accountTrades) {
  var blockTrades = accountTrades.filter(function (trade) {
    return trade.IsBlockTrade;
  });

  return tradeReports.concat(blockTrades).map(function (order) {
    return Object.assign({}, order, {
      SortingTime: order.ReceiveTimeTicks ? order.ReceiveTimeTicks : order.TradeTime
    });
  }).sort(function (a, b) {
    if (a.SortingTime < b.SortingTime) return 1;
    if (a.SortingTime > b.SortingTime) return -1;
    return 0;
  });
});

var tradeReportsSelectorFactory = function tradeReportsSelectorFactory() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([trailingOrdersSelectorFactory(tradeReportsSelector), function (state) {
    return state.apexCore.position.selectedProductId;
  }, __WEBPACK_IMPORTED_MODULE_4__instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return formSelector(state, 'startDate', 'endDate');
  }, function (state, props) {
    return props.filterMode;
  }], function (orders, selectedProductId, selectedInstrument, instruments, formValues, filterMode) {
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    if (filterMode === 'selectedProduct') {
      var filteredOrders = orders;
      if (selectedProductId) {
        filteredOrders = filterOrdersByProductId(orders, selectedProductId, instruments);
      }
      return filterOrdersByDate(filteredOrders, formValues, 'TradeTimeMS');
    } else {
      // else filterMode == 'selectedInstrument'
      return orders.filter(function (order) {
        return order.InstrumentId === selectedInstrumentId || order.Instrument === selectedInstrumentId;
      });
    }
  });
};

function filterOrdersByProductId(orders, selectedProductId, instruments) {
  var ordersWithProductIds = orders.map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument || item.InstrumentId === order.InstrumentId;
    });

    return Object.assign({}, order, {
      product1Id: instrument ? instrument.Product1 : null,
      product2Id: instrument ? instrument.Product2 : null
    });
  });

  return ordersWithProductIds.filter(function (order) {
    return order.product1Id === selectedProductId || order.product2Id === selectedProductId;
  });
}

function filterOrdersByDate(orders, formValues, timeStamp) {
  return orders.filter(function (item) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_orderHistoryFilters__["a" /* dateFilter */])(item, formValues.startDate, formValues.endDate, timeStamp);
  });
}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_USER_REPORTS_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_USER_REPORTS_SUCCESS; });
/* unused harmony export GET_USER_REPORTS_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_USER_REPORT_WRITER_RESULTS_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_USER_REPORT_WRITER_RESULTS_SUCCESS; });
/* unused harmony export GET_USER_REPORT_WRITER_RESULTS_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getUserReports; });
/* unused harmony export getUserReportsRequested */
/* unused harmony export getUserReportsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUserReportWriterResults; });
/* unused harmony export getUserReportWriterResultsRequested */
/* unused harmony export getUserReportWriterResultsSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return generateReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return scheduleReport; });
/* unused harmony export addReport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancelReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_add_days__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_add_days__);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var GET_USER_REPORTS_REQUESTED = 'GET_USER_REPORTS_REQUESTED';
var GET_USER_REPORTS_SUCCESS = 'GET_USER_REPORTS_SUCCESS';
var GET_USER_REPORTS_ERROR = 'GET_USER_REPORTS_ERROR';
var GET_USER_REPORT_WRITER_RESULTS_REQUESTED = 'GET_USER_REPORT_WRITER_RESULTS_REQUESTED';
var GET_USER_REPORT_WRITER_RESULTS_SUCCESS = 'GET_USER_REPORT_WRITER_RESULTS_SUCCESS';
var GET_USER_REPORT_WRITER_RESULTS_ERROR = 'GET_USER_REPORT_WRITER_RESULTS_ERROR';
var ADD_REPORT = 'ADD_REPORT';

var getUserReports = function getUserReports(UserId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var reports;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(getUserReportsRequested());

              _context.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserReportTickets', { UserId: UserId }));

            case 3:
              reports = _context.sent;

              dispatch(getUserReportsSuccess(reports));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getUserReportsRequested = function getUserReportsRequested() {
  return {
    type: GET_USER_REPORTS_REQUESTED
  };
};

var getUserReportsSuccess = function getUserReportsSuccess(payload) {
  return {
    type: GET_USER_REPORTS_SUCCESS,
    payload: payload
  };
};

var getUserReportWriterResults = function getUserReportWriterResults() {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var UserId, reports;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              UserId = getState().user.userInfo.UserId;


              dispatch(getUserReportWriterResultsRequested());

              _context2.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserReportWriterResultRecords', { UserId: UserId }));

            case 4:
              reports = _context2.sent;

              dispatch(getUserReportWriterResultsSuccess(reports));

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var getUserReportWriterResultsRequested = function getUserReportWriterResultsRequested() {
  return {
    type: GET_USER_REPORT_WRITER_RESULTS_REQUESTED
  };
};

var getUserReportWriterResultsSuccess = function getUserReportWriterResultsSuccess(payload) {
  return {
    type: GET_USER_REPORT_WRITER_RESULTS_SUCCESS,
    payload: payload
  };
};

var createParamsForOneOffReport = function createParamsForOneOffReport(getState, formValues) {
  var OMSId = getState().user.userInfo.OMSId;

  return {
    OMSId: OMSId,
    startTime: __WEBPACK_IMPORTED_MODULE_5_date_fns_add_days___default()(formValues.startDate, 1),
    endTime: __WEBPACK_IMPORTED_MODULE_5_date_fns_add_days___default()(formValues.endDate, 1),
    accountIdList: formValues.accountIdList
  };
};

var generateReport = function generateReport(formValues) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var params, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              params = createParamsForOneOffReport(getState, formValues);
              response = void 0;
              _context3.t0 = formValues.type;
              _context3.next = _context3.t0 === 'TradeActivity' ? 5 : _context3.t0 === 'Transaction' ? 9 : _context3.t0 === 'Treasury' ? 13 : 17;
              break;

            case 5:
              _context3.next = 7;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GenerateTradeActivityReport', params));

            case 7:
              response = _context3.sent;
              return _context3.abrupt('break', 19);

            case 9:
              _context3.next = 11;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GenerateTransactionActivityReport', params));

            case 11:
              response = _context3.sent;
              return _context3.abrupt('break', 19);

            case 13:
              _context3.next = 15;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GenerateTreasuryActivityReport', params));

            case 15:
              response = _context3.sent;
              return _context3.abrupt('break', 19);

            case 17:
              console.error('Unsupported \'' + formValues.type + '\' report type');
              return _context3.abrupt('return');

            case 19:
              if (!(response.bAccepted === false)) {
                _context3.next = 21;
                break;
              }

              return _context3.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                id: 'REPORT_WARNING',
                type: 'warning',
                text: response.rejectMessage
              })));

            case 21:

              dispatch(addReport(response));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__sidePaneActions__["i" /* closeReportsSidePane */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                id: 'SINGLE_REPORT_SUCCESS',
                type: 'success',
                // context.t('Single report was successfully created')
                text: 'Single report was successfully created'
              }));

            case 24:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var createParamsForScheduledReport = function createParamsForScheduledReport(getState, formValues) {
  var OMSId = getState().user.userInfo.OMSId;

  return {
    OMSId: OMSId,
    frequency: formValues.frequency,
    beginTime: formValues.startDate,
    accountIdList: formValues.accountIdList
  };
};

var scheduleReport = function scheduleReport(formValues) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var params, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              params = createParamsForScheduledReport(getState, formValues);
              response = void 0;
              _context4.t0 = formValues.type;
              _context4.next = _context4.t0 === 'TradeActivity' ? 5 : _context4.t0 === 'Transaction' ? 9 : _context4.t0 === 'Treasury' ? 13 : 17;
              break;

            case 5:
              _context4.next = 7;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('ScheduleTradeActivityReport', params));

            case 7:
              response = _context4.sent;
              return _context4.abrupt('break', 19);

            case 9:
              _context4.next = 11;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('ScheduleTransactionActivityReport', params));

            case 11:
              response = _context4.sent;
              return _context4.abrupt('break', 19);

            case 13:
              _context4.next = 15;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('ScheduleTreasuryActivityReport', params));

            case 15:
              response = _context4.sent;
              return _context4.abrupt('break', 19);

            case 17:
              console.error('Unsupported \'' + formValues.type + '\' report type');
              return _context4.abrupt('return');

            case 19:
              if (!(response.bAccepted === false)) {
                _context4.next = 21;
                break;
              }

              return _context4.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                id: 'CYCLICAL_REPORT_ERROR',
                type: 'warning',
                text: response.rejectMessage
              })));

            case 21:

              dispatch(addReport(response));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__sidePaneActions__["i" /* closeReportsSidePane */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                id: 'CYCLICAL_REPORT_SUCCESS',
                type: 'success',
                // context.t('Cyclical report was successfully created')
                text: 'Cyclical report was successfully created'
              }));

            case 24:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var addReport = function addReport(payload) {
  return {
    type: ADD_REPORT,
    payload: payload
  };
};

var cancelReport = function cancelReport(UserReportId) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      var UserId, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              UserId = getState().user.userInfo.UserId;
              _context5.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CancelUserReport', { UserReportId: UserReportId }));

            case 3:
              response = _context5.sent;

              if (response.result) {
                dispatch(getUserReports(UserId));
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                  id: 'CANCEL_REPORT_ERROR',
                  text: Object(__WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__["a" /* formatErrorText */])(response),
                  type: 'warning'
                }));
              }

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONNECTION_CLOSED_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONNECTION_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONNECTION_OPENED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return connectionOpened; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return connectionClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return connectionClosedCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pingBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeServer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apex__ = __webpack_require__(21);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var CONNECTION_CLOSED_COUNT = 'CONNECTION_CLOSED_COUNT';
var CONNECTION_CLOSED = 'CONNECTION_CLOSED';
var CONNECTION_OPENED = 'CONNECTION_OPENED';

var connectionOpened = function connectionOpened() {
  return {
    type: CONNECTION_OPENED,
    payload: { isConnected: true }
  };
};

var connectionClosed = function connectionClosed() {
  return {
    type: CONNECTION_CLOSED,
    payload: { isConnected: false }
  };
};

var connectionClosedCount = function connectionClosedCount(attemptNumber) {
  return {
    type: CONNECTION_CLOSED_COUNT,
    payload: attemptNumber
  };
};

var pingBackend = function pingBackend() {
  return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.Ping();

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));
};

var changeServer = function changeServer(value) {
  var socket = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */], 'connection.ws.socket');
  if (socket) socket.close();
  if (value !== 'CUSTOM') {
    Object(__WEBPACK_IMPORTED_MODULE_2__apex__["d" /* setGateway */])(value);
    localStorage.setItem('tradingServer', value);
  }
};

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNSUBSCRIBE_LEVEL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ALL_LEVEL_2_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEVEL_2_UPDATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_LEVEL_2_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLevel2Data; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return subscribeToLevel2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return unsubscribeLevel2; });
/* unused harmony export unsubscribeAllLevel2 */
/* unused harmony export getAllLevel2 */
/* unused harmony export requestLevel2Data */
/* unused harmony export level2Updates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level2SubscriptionService__ = __webpack_require__(1122);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var UNSUBSCRIBE_LEVEL2 = 'UNSUBSCRIBE_LEVEL2';
var GET_ALL_LEVEL_2_DATA = 'GET_ALL_LEVEL_2_DATA';
var LEVEL_2_UPDATES = 'LEVEL_2_UPDATES';
var REQUEST_LEVEL_2_DATA = 'REQUEST_LEVEL_2_DATA';

/**
 * Singleton for level2 subscription 'visibilitychange' listeners.
 * Named function required for removeEventListener.
 */
var mountedVisibilityListener = void 0;

/**
 * 1) Tell server to subscribe to level2 data for passed `instrumentId`
 * 2) Get first portion of data
 */
var getLevel2Data = function getLevel2Data(instrumentId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var updates;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestLevel2Data(instrumentId));
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level2SubscriptionService__["a" /* default */].initSubscribtion(instrumentId);

            case 3:
              updates = _context.sent;


              mountedVisibilityListener = function mountedVisibilityListener() {
                return focusOutListener(instrumentId, dispatch);
              };

              document.addEventListener('visibilitychange', mountedVisibilityListener);

              if (updates.result !== false) {
                dispatch(getAllLevel2(updates));
              }

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var unsubbed = void 0;
function focusInListener(instrumentId, dispatch) {
  if (!document.hidden && unsubbed) {
    unsubbed = false;
    dispatch(getLevel2Data(instrumentId));
    document.removeEventListener('visibilitychange', mountedVisibilityListener);
  }
}

function focusOutListener(instrumentId, dispatch) {
  if (document.hidden && !unsubbed) {
    unsubbed = true;

    // Stop subscription while in other tab.
    dispatch(unsubscribeLevel2(instrumentId));

    document.removeEventListener('visibilitychange', mountedVisibilityListener);

    mountedVisibilityListener = function mountedVisibilityListener() {
      return focusInListener(instrumentId, dispatch);
    };

    document.addEventListener('visibilitychange', mountedVisibilityListener);
  }
}

/**
 * Add listener for level2 updates
 */
var subscribeToLevel2 = function subscribeToLevel2() {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level2SubscriptionService__["a" /* default */].subscribe(function (updates) {
      if (updates && updates[0] && updates[0].ProductPairCode === getState().apexCore.instrument.selectedInstrumentId) {
        dispatch(level2Updates(updates));
      }
    });
  };
};

/**
 * Stop getting updates from server for passed `insrtumentId`
 */
var unsubscribeLevel2 = function unsubscribeLevel2(instrumentId) {
  return function (dispatch) {
    document.removeEventListener('visibilitychange', mountedVisibilityListener);
    __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level2SubscriptionService__["a" /* default */].stopOne(instrumentId);
    dispatch({ type: UNSUBSCRIBE_LEVEL2 });
  };
};

var unsubscribeAllLevel2 = function unsubscribeAllLevel2() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level2SubscriptionService__["a" /* default */].stopAll();
  };
};

function getAllLevel2(updates) {
  return {
    type: GET_ALL_LEVEL_2_DATA,
    payload: updates
  };
}

var requestLevel2Data = function requestLevel2Data(instrumentId) {
  return {
    type: REQUEST_LEVEL_2_DATA,
    payload: instrumentId
  };
};

function level2Updates(updates) {
  return {
    type: LEVEL_2_UPDATES,
    payload: updates
  };
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(495),
    isLength = __webpack_require__(315);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignConfigWithLocal", function() { return assignConfigWithLocal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configDefault_json__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configDefault_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__configDefault_json__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var config={};var configLocal=window.APEXWebConfig||{};// Reliably confirms that x is an Object, but not a Function, Array, etc.
var isObject=function isObject(x){return Object.prototype.toString.call(x)==='[object Object]';};for(var key in __WEBPACK_IMPORTED_MODULE_0__configDefault_json___default.a){if(isObject(__WEBPACK_IMPORTED_MODULE_0__configDefault_json___default.a[key])&&isObject(configLocal[key])){config[key]=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__configDefault_json___default.a[key],configLocal[key]);}else{config[key]=__WEBPACK_IMPORTED_MODULE_0__configDefault_json___default.a[key];}}var _ref=JSON.parse(localStorage.getItem('apexTemplate'))||{},localChart=_ref.chart,localConfig=_objectWithoutProperties(_ref,['chart']);var assignConfigWithLocal=function assignConfigWithLocal(){config.global=Object.assign({},config.global,localConfig);config.TradingLayout.chart=localChart||config.TradingLayout.chart;};assignConfigWithLocal();/* harmony default export */ __webpack_exports__["default"] = (config);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__APLogo_css__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__APLogo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__APLogo_css__);










var APLogo = function APLogo(props) {
  var customClass = props.customClass,
      linkTo = props.linkTo,
      onClick = props.onClick;

  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('ap-logo', customClass);
  var renderSiteLogo = function renderSiteLogo() {
    if (__WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].global.siteLogo.match(/.svg$/) && !__WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].Logo.DoNotInLineSVG) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__["a" /* default */], {
        alt: 'Site logo',
        src: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])('/local/logos/' + __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].global.siteLogo),
        className: bemClasses('img')
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        alt: 'Site logo',
        src: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])('/local/logos/' + __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].global.siteLogo),
        className: bemClasses('img')
      });
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses() },
    linkTo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
      {
        className: bemClasses('link'),
        to: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])(linkTo),
        onClick: onClick },
      renderSiteLogo()
    ) : renderSiteLogo()
  );
};

APLogo.defaultProps = {
  customClass: '',
  linkTo: ''
};

APLogo.propTypes = {
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  linkTo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (APLogo);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(path){return""+""+path;});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parsePhoneNumber;
exports.normalizeArguments = normalizeArguments;

var _parsePhoneNumber_ = _interopRequireDefault(__webpack_require__(596));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function parsePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _parsePhoneNumber_["default"])(text, options, metadata);
}

function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
      if (arg_3) {
        options = arg_2;
        metadata = arg_3;
      } else {
        metadata = arg_2;
      }
    } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
} // Otherwise istanbul would show this as "branch not covered".

/* istanbul ignore next */


var isObject = function isObject(_) {
  return _typeof(_) === 'object';
};
//# sourceMappingURL=parsePhoneNumber.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = matchesEntirely;

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderFormInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateOptionsFromNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_padStart__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_padStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_padStart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_APDatePicker_APDatePicker__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_APPhoneInput__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_APDocumentUpload_APDocumentUpload__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_APImageUpload_APImageUpload__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_APUpload_APUpload__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_APTimePickerDropdown_APTimePickerDropdown__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_APDatePickerDropdown_APDatePickerDropdown__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__formValidations__ = __webpack_require__(31);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

















var renderFormInputs = function renderFormInputs() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var customClass = arguments[1];
  var context = arguments[2];
  var change = arguments[3];

  var inputTypes = {
    text: renderInput,
    email: renderInput,
    number: renderNumberInput,
    select: renderSelect,
    date: renderDatePicker,
    timeDropdown: renderDatePickerDropdown,
    dateDropdown: renderTimePickerDropdown,
    phone: renderPhoneInput,
    image: renderImageUpload,
    document: renderDocumentUpload,
    country: renderCountry,
    upload: renderUpload
  };
  return fields.filter(function (field) {
    if (!inputTypes[field.type]) console.error('Unsupported ' + field.type + ' input type on field: ' + field.name);
    return inputTypes[field.type];
  }).map(function (field) {
    return inputTypes[field.type](field, customClass, context, change);
  });
};

var renderInput = function renderInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_common_APInput__["b" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    placeholder: context.t(field.placeholder),
    validate: validators,
    info: context.t(field.info),
    customClass: customClass
  });
};

var renderNumberInput = function renderNumberInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_APNumberInput__["a" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    placeholder: context.t(field.placeholder),
    validate: validators,
    info: context.t(field.info),
    customClass: customClass
  });
};

var renderSelect = function renderSelect(field, customClass, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_common_APSelect__["b" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    customClass: customClass,
    options: Array.isArray(field.options) ? field.options.map(function (item) {
      return { value: item, label: context.t(item) };
    }) : Object.keys(field.options).map(function (prop) {
      return {
        value: prop,
        label: context.t(field.options[prop])
      };
    })
  });
};

var renderCountry = function renderCountry(field, customClass, context) {
  var options = __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].Countries;
  var keys = Object.keys(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].Countries);

  if (field.whiteList) {
    options = keys.filter(function (country) {
      return field.whiteList.includes(options[country]);
    });
  } else if (field.blackList) {
    options = keys.filter(function (country) {
      return !field.blackList.includes(options[country]);
    });
  }

  field.options = options;

  return renderSelect(field, customClass, context);
};

var renderImageUpload = function renderImageUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_APImageUpload_APImageUpload__["a" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    alt: field.alt ? context.t(field.alt) : context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    onChange: change
  });
};

var renderDocumentUpload = function renderDocumentUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_APDocumentUpload_APDocumentUpload__["a" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    onChange: change
  });
};

var renderUpload = function renderUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_APUpload_APUpload__["a" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    acceptedFiles: field.acceptedFiles,
    customChange: change
  });
};

var renderDatePicker = function renderDatePicker(field, customClass, context) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_common_APDatePicker_APDatePicker__["a" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    maxDate: new Date()
  });
};

var renderDatePickerDropdown = function renderDatePickerDropdown(field, customClass, context) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_APDatePickerDropdown_APDatePickerDropdown__["a" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    maxDate: new Date(),
    leadingZero: field.leadingZero
  });
};

var renderTimePickerDropdown = function renderTimePickerDropdown(field, customClass, context) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_APTimePickerDropdown_APTimePickerDropdown__["a" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    leadingZero: field.leadingZero
  });
};

var renderPhoneInput = function renderPhoneInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_common_APPhoneInput__["a" /* default */], {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    validate: validators,
    customClass: customClass
  });
};

var mapStringToValidators = {
  required: __WEBPACK_IMPORTED_MODULE_13__formValidations__["p" /* required */],
  email: __WEBPACK_IMPORTED_MODULE_13__formValidations__["d" /* email */],
  alphanumeric: __WEBPACK_IMPORTED_MODULE_13__formValidations__["a" /* alphanumeric */],
  isDate: __WEBPACK_IMPORTED_MODULE_13__formValidations__["e" /* isDate */],
  maxLength: __WEBPACK_IMPORTED_MODULE_13__formValidations__["k" /* maxLength */],
  isValidPhone: __WEBPACK_IMPORTED_MODULE_13__formValidations__["f" /* isValidPhone */],
  numeric: __WEBPACK_IMPORTED_MODULE_13__formValidations__["o" /* numeric */]
};

var getInputValidators = function getInputValidators(field) {
  if (!field.validators) return;

  var result = field.validators && field.validators.map(function (validator) {
    var _validator$split = validator.split(':'),
        _validator$split2 = _slicedToArray(_validator$split, 2),
        validatorName = _validator$split2[0],
        validatorArgs = _validator$split2[1];

    if (validatorArgs) {
      var passedArgs = validatorArgs.split(',');
      return mapStringToValidators[validatorName].apply(mapStringToValidators, _toConsumableArray(passedArgs));
    } else {
      return mapStringToValidators[validatorName];
    }
  });

  return result.filter(function (item) {
    return item;
  });
};

var generateOptionsFromNumber = function generateOptionsFromNumber() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments[1];
  var pad = arguments[2];

  var options = [];

  for (var i = min; i < max; i++) {
    options.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'option',
      { key: i, value: i },
      __WEBPACK_IMPORTED_MODULE_1_lodash_padStart___default()(i, pad, '0')
    ));
  }

  return options;
};

/* unused harmony default export */ var _unused_webpack_default_export = (renderFormInputs);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIGITS */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseDigit;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseDigits;
// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=parseDigits.js.map

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchesEntirely;
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fieldToLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return templateFormRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return templateConfirmRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_APCryptoAddressInput_APCryptoAddressInputContainer__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formValidations__ = __webpack_require__(31);








var fieldToLabel = function fieldToLabel(field) {
  return field.replace(/([a-z])([A-Z])/g, '$1 $2');
};

var noValidationFields = ['DestinationTagNumber', 'Comment', 'TemplateType'];

var templateFormRenderer = function templateFormRenderer(template, customClass, context) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      Product = _ref.Product,
      ProductSymbol = _ref.ProductSymbol,
      DecimalPlaces = _ref.DecimalPlaces;

  return Object.keys(template).map(function (field) {
    var label = field === 'BankAccountName' ? context.t('Bank Name') : context.t(fieldToLabel(field));
    var validate = noValidationFields.includes(field) ? null : __WEBPACK_IMPORTED_MODULE_6__formValidations__["p" /* required */];
    var type = field === 'TemplateType' ? 'hidden' : 'text';

    if (template[field] && template[field].indexOf('[') === 0) {
      var options = template[field].split(',').map(function (el) {
        var value = el.trim().replace(/[[\]]/g, '');
        return { value: value, label: value };
      });

      if (field === 'Country') {
        try {
          var parsedArray = JSON.parse(template[field]);
          options = parsedArray.map(function (el) {
            return {
              value: el.Code,
              label: el.Name
            };
          });
        } catch (e) {
          // do nothing
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_common_APSelect__["b" /* default */], {
        key: field,
        name: field,
        customClass: customClass,
        'data-test': field,
        label: label,
        validate: [__WEBPACK_IMPORTED_MODULE_6__formValidations__["p" /* required */]],
        options: options
      });
    }

    if (field === 'ExternalAddress') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_common_APCryptoAddressInput_APCryptoAddressInputContainer__["a" /* default */], {
        productSymbol: Product || ProductSymbol,
        key: field,
        name: field,
        'data-test': field,
        customClass: customClass,
        label: label
      });
    }
    if (template[field] && field !== 'TemplateType') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_APLabelWithText__["a" /* default */], {
        key: field,
        'data-test': field,
        label: context.t(label) + ':',
        text: template[field],
        customClass: customClass,
        classModifiers: 'template-info'
      });
    } else {
      var info = void 0;

      if (field === 'DestinationTagNumber') {
        info = context.t('Please note that a destination tag may be required if you are withdrawing to an exchange or online wallet.');
      }

      if (field.toLowerCase() === 'amount') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_APNumberInput__["a" /* default */], {
          key: field,
          type: 'text',
          name: 'Amount',
          labelInInput: Product || ProductSymbol,
          label: context.t('Amount of ' + (Product || ProductSymbol)),
          decimalPlaces: DecimalPlaces,
          customClass: customClass,
          validate: [__WEBPACK_IMPORTED_MODULE_6__formValidations__["p" /* required */], __WEBPACK_IMPORTED_MODULE_6__formValidations__["c" /* biggerThanZero */]]
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_common_APInput__["b" /* default */], {
        key: field,
        name: field,
        'data-test': label,
        customClass: customClass,
        label: label,
        type: type,
        info: info,
        validate: validate
      });
    }
  });
};

var templateConfirmRenderer = function templateConfirmRenderer(template, values, classNames, context) {
  return Object.keys(template || {}).map(function (field) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_APLabelWithText__["a" /* default */], {
      label: field === 'BankAccountName' ? context.t('Bank Name') : context.t(fieldToLabel(field)),
      key: field,
      'data-test': field,
      text: values[field],
      customClass: classNames()
    });
  });
};

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderHistoryComponent__ = __webpack_require__(1539);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__OrderHistoryComponent__["a" /* default */]);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCSSVar; });
/* unused harmony export getCssVariable */
/* unused harmony export isCssVarsSupported */
/* unused harmony export getCssVariableFromDocumentBody */
var getVariableFn = null;

var getCSSVar = function getCSSVar() {
  if (!getVariableFn) {
    if (isCssVarsSupported()) {
      getVariableFn = getCssVariableFromDocumentBody;
    } else {
      getVariableFn = getCssVariable;
    }
  }

  return getVariableFn;
};

var parseCssVariable = function parseCssVariable(cssVarValue, rgbName, rgbModifier) {
  if (cssVarValue.includes('rgb') || cssVarValue.includes('rgba')) {
    if (cssVarValue.includes(',')) {
      var nestedCssVar = cssVarValue.match(/(.*?)\(.*?\((.*?)\),(.*?)\)/); // extract value from "rgba(var(--nested-css-var), 0.75)"
      var _rgbModifier = nestedCssVar[3];
      var _rgbName = nestedCssVar[1];
      return getCssVariable(nestedCssVar[2], _rgbName, _rgbModifier);
    } else {
      var _nestedCssVar = cssVarValue.match(/(.*?)\(.*?\((.*?)\)\)/); // extract value from "rgb(var(--nested-css-var))"
      var _rgbName2 = _nestedCssVar[1];
      return getCssVariable(_nestedCssVar[2], _rgbName2);
    }
  } else if (cssVarValue.includes('var')) {
    var _nestedCssVar2 = cssVarValue.match(/\((.*?)\)/)[1]; // extract value from "var(--nested-css-var)"
    if (rgbName || rgbModifier) {
      return getCssVariable(_nestedCssVar2, rgbName, rgbModifier);
    }
    return getCssVariable(_nestedCssVar2);
  }
};

var getCssVariable = function getCssVariable(value) {
  var rgbName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var rgbModifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var _window = window,
      cssVariables = _window.cssVariables;

  var supportedVars = ['rgb', 'rgba', 'var'];
  var cssVariable = cssVariables[value];

  var isSupportedVariable = supportedVars.some(function (item) {
    return cssVariable.indexOf(item) !== -1;
  });

  if (isSupportedVariable) {
    return parseCssVariable(cssVariable, rgbName, rgbModifier);
  }

  if (rgbName && rgbModifier) {
    return rgbName + '(' + cssVariable + ',' + rgbModifier + ')';
  } else if (rgbName) {
    return rgbName + '(' + cssVariable + ')';
  } else {
    return cssVariable;
  }
};

var isCssVarsSupported = function isCssVarsSupported() {
  return window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)');
};

var getCssVariableFromDocumentBody = function getCssVariableFromDocumentBody(value) {
  return getComputedStyle(document.body).getPropertyValue(value).trim();
};

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGateway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLoginFormGateway; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);


var getGateway = function getGateway() {
  if (true) {
    return "wss://api.coinext.com.br/WSGateway/";
  }

  var configGateway = __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.gateway;
  var currentGateway = localStorage.getItem('tradingServer');

  if (Array.isArray(configGateway)) {
    if (currentGateway && configGateway.includes(currentGateway)) {
      return currentGateway;
    } else {
      /**
       * This means the current gateway was entered via custom box.
       */
      return localStorage.getItem('tradingServer');
    }
  } else {
    if (configGateway && currentGateway !== configGateway) {
      localStorage.setItem('tradingServer', configGateway);
      return configGateway;
    } else {
      return currentGateway;
    }
  }
};

var getLoginFormGateway = function getLoginFormGateway() {
  if (true) {
    return "wss://api.coinext.com.br/WSGateway/";
  }
  return __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.gateway;
};

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferRequestNotificationListContainer__ = __webpack_require__(1978);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__TransferRequestNotificationListContainer__["a" /* default */]);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BalancesList__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BalancesListLayout_css__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BalancesListLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BalancesListLayout_css__);






var balancesListLayoutClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('balances-list-layout');

var BalancesListLayout = function BalancesListLayout(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: balancesListLayoutClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: balancesListLayoutClasses('header') },
      context.t('Balances')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_BalancesList__["a" /* default */], null)
  );
};

BalancesListLayout.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["default"] = (BalancesListLayout);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kycConfigLevelShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var kycConfigLevelShape = {
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  levels: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    level: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    button: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      benefits: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
      requirements: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }),
    verifiedMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    underReviewMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    form: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
      type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }))
  }))
};

/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIcon_css__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIcon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__APIcon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_icon_nav_buy_sell_svg__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_icon_nav_buy_sell_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_icon_nav_buy_sell_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_icon_nav_dashboard_on_svg__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_icon_nav_dashboard_on_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_icon_nav_dashboard_on_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_icon_nav_trading_svg__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_icon_nav_trading_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_icon_nav_trading_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_icon_nav_user_svg__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_icon_nav_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_icon_nav_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_icon_nav_settings_svg__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_icon_nav_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_icon_nav_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_icon_nav_wallet_svg__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_icon_nav_wallet_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_icon_nav_wallet_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_icon_balance_svg__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_icon_balance_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_icon_balance_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_icon_activity_svg__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_icon_activity_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_icon_activity_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_icon_contacts_svg__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_icon_contacts_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_icons_icon_contacts_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_icon_key_svg__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_icon_key_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_icons_icon_key_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_icon_reports_svg__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_icon_reports_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_icons_icon_reports_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_icon_security_svg__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_icon_security_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_icons_icon_security_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_icons_icon_tasks_svg__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_icons_icon_tasks_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_icons_icon_tasks_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_icons_icon_heart_svg__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_icons_icon_heart_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_icons_icon_heart_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_icons_icon_friends_svg__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_icons_icon_friends_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_icons_icon_friends_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_icons_icon_paint_svg__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_icons_icon_paint_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_icons_icon_paint_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_icons_icon_send_with_border_svg__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_icons_icon_send_with_border_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_icons_icon_send_with_border_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_icons_icon_receive_with_border_svg__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_icons_icon_receive_with_border_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_icons_icon_receive_with_border_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_icons_icon_deposit_with_border_svg__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_icons_icon_deposit_with_border_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__images_icons_icon_deposit_with_border_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_icons_icon_withdraw_with_border_svg__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_icons_icon_withdraw_with_border_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__images_icons_icon_withdraw_with_border_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_icons_icon_open_buy_big_svg__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_icons_icon_open_buy_big_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__images_icons_icon_open_buy_big_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_icons_icon_open_sell_big_svg__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_icons_icon_open_sell_big_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__images_icons_icon_open_sell_big_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__images_icons_icon_caret_prev_svg__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__images_icons_icon_caret_prev_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__images_icons_icon_caret_prev_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__images_icons_icon_caret_next_svg__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__images_icons_icon_caret_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__images_icons_icon_caret_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_icons_icon_double_caret_prev_svg__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_icons_icon_double_caret_prev_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__images_icons_icon_double_caret_prev_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__images_icons_icon_double_caret_next_svg__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__images_icons_icon_double_caret_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__images_icons_icon_double_caret_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__images_icons_icon_dropdown_svg__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__images_icons_icon_dropdown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__images_icons_icon_dropdown_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__images_icons_icon_barcode_svg__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__images_icons_icon_barcode_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__images_icons_icon_barcode_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__images_icons_icon_calendar_svg__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__images_icons_icon_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__images_icons_icon_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__images_icons_icon_eye_svg__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__images_icons_icon_eye_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__images_icons_icon_eye_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__images_icons_icon_info_svg__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__images_icons_icon_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__images_icons_icon_info_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__images_icons_icon_cancel_svg__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__images_icons_icon_cancel_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__images_icons_icon_cancel_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__images_icons_icon_download_svg__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__images_icons_icon_download_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__images_icons_icon_download_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__images_icons_icon_check_svg__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__images_icons_icon_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__images_icons_icon_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__images_icons_icon_simple_check_svg__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__images_icons_icon_simple_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__images_icons_icon_simple_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__images_icons_icon_refresh_svg__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__images_icons_icon_refresh_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__images_icons_icon_refresh_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__images_icons_icon_close_svg__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__images_icons_icon_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__images_icons_icon_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__images_icons_icon_buy_svg__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__images_icons_icon_buy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__images_icons_icon_buy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__images_icons_icon_sell_svg__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__images_icons_icon_sell_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__images_icons_icon_sell_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__images_icons_icon_send_svg__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__images_icons_icon_send_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__images_icons_icon_send_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__images_icons_icon_receive_svg__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__images_icons_icon_receive_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__images_icons_icon_receive_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__images_icons_icon_deposit_svg__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__images_icons_icon_deposit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__images_icons_icon_deposit_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__images_icons_icon_withdraw_svg__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__images_icons_icon_withdraw_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__images_icons_icon_withdraw_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__images_icons_icon_copy_svg__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__images_icons_icon_copy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__images_icons_icon_copy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__images_icons_icon_star_svg__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__images_icons_icon_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__images_icons_icon_star_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__images_icons_icon_stop_svg__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__images_icons_icon_stop_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__images_icons_icon_stop_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__images_icons_logo_powered_svg__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__images_icons_logo_powered_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__images_icons_logo_powered_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__images_icons_icon_nav_notification_svg__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__images_icons_icon_nav_notification_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__images_icons_icon_nav_notification_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__images_icons_icon_center_svg__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__images_icons_icon_center_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__images_icons_icon_center_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__images_icons_icon_checkbox_svg__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__images_icons_icon_checkbox_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__images_icons_icon_checkbox_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__images_icons_icon_menu_toggle_svg__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__images_icons_icon_menu_toggle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__images_icons_icon_menu_toggle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__images_icons_icon_key_big_svg__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__images_icons_icon_key_big_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__images_icons_icon_key_big_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__images_icons_icon_arrow_prev_svg__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__images_icons_icon_arrow_prev_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__images_icons_icon_arrow_prev_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__images_icons_icon_arrow_next_svg__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__images_icons_icon_arrow_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__images_icons_icon_arrow_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__images_icons_icon_pending_svg__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__images_icons_icon_pending_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__images_icons_icon_pending_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__images_icons_icon_settings_svg__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__images_icons_icon_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__images_icons_icon_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__images_icons_icon_alert_svg__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__images_icons_icon_alert_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__images_icons_icon_alert_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__images_icons_icon_menu_svg__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__images_icons_icon_menu_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__images_icons_icon_menu_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__images_icons_icon_plus_minus_svg__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__images_icons_icon_plus_minus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__images_icons_icon_plus_minus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__images_icons_icon_arrow_up_svg__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__images_icons_icon_arrow_up_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__images_icons_icon_arrow_up_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__images_icons_icon_arrow_down_svg__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__images_icons_icon_arrow_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__images_icons_icon_arrow_down_svg__);







// navigation








// user settings








// tables






//pagination




//forms




















//ap

//misc















var baseClass = 'ap-icon';

var icons = {
  // navigation
  'buy-sell': __WEBPACK_IMPORTED_MODULE_5__images_icons_icon_nav_buy_sell_svg___default.a,
  dashboard: __WEBPACK_IMPORTED_MODULE_6__images_icons_icon_nav_dashboard_on_svg___default.a,
  trading: __WEBPACK_IMPORTED_MODULE_7__images_icons_icon_nav_trading_svg___default.a,
  user: __WEBPACK_IMPORTED_MODULE_8__images_icons_icon_nav_user_svg___default.a,
  'user-settings': __WEBPACK_IMPORTED_MODULE_9__images_icons_icon_nav_settings_svg___default.a,
  wallet: __WEBPACK_IMPORTED_MODULE_10__images_icons_icon_nav_wallet_svg___default.a,
  balance: __WEBPACK_IMPORTED_MODULE_11__images_icons_icon_balance_svg___default.a,
  activity: __WEBPACK_IMPORTED_MODULE_12__images_icons_icon_activity_svg___default.a,
  // user-settings
  contacts: __WEBPACK_IMPORTED_MODULE_13__images_icons_icon_contacts_svg___default.a,
  key: __WEBPACK_IMPORTED_MODULE_14__images_icons_icon_key_svg___default.a,
  reports: __WEBPACK_IMPORTED_MODULE_15__images_icons_icon_reports_svg___default.a,
  security: __WEBPACK_IMPORTED_MODULE_16__images_icons_icon_security_svg___default.a,
  tasks: __WEBPACK_IMPORTED_MODULE_17__images_icons_icon_tasks_svg___default.a,
  heart: __WEBPACK_IMPORTED_MODULE_18__images_icons_icon_heart_svg___default.a,
  paint: __WEBPACK_IMPORTED_MODULE_20__images_icons_icon_paint_svg___default.a,
  friends: __WEBPACK_IMPORTED_MODULE_19__images_icons_icon_friends_svg___default.a,
  // table
  sendWithBorder: __WEBPACK_IMPORTED_MODULE_21__images_icons_icon_send_with_border_svg___default.a,
  receiveWithBorder: __WEBPACK_IMPORTED_MODULE_22__images_icons_icon_receive_with_border_svg___default.a,
  depositWithBorder: __WEBPACK_IMPORTED_MODULE_23__images_icons_icon_deposit_with_border_svg___default.a,
  withdrawWithBorder: __WEBPACK_IMPORTED_MODULE_24__images_icons_icon_withdraw_with_border_svg___default.a,
  'open-buy': __WEBPACK_IMPORTED_MODULE_25__images_icons_icon_open_buy_big_svg___default.a,
  'open-sell': __WEBPACK_IMPORTED_MODULE_26__images_icons_icon_open_sell_big_svg___default.a,
  //pagination
  caretPrevious: __WEBPACK_IMPORTED_MODULE_27__images_icons_icon_caret_prev_svg___default.a,
  caretNext: __WEBPACK_IMPORTED_MODULE_28__images_icons_icon_caret_next_svg___default.a,
  doubleCaretPrevious: __WEBPACK_IMPORTED_MODULE_29__images_icons_icon_double_caret_prev_svg___default.a,
  doubleCaretNext: __WEBPACK_IMPORTED_MODULE_30__images_icons_icon_double_caret_next_svg___default.a,
  // forms
  dropdown: __WEBPACK_IMPORTED_MODULE_31__images_icons_icon_dropdown_svg___default.a,
  barcode: __WEBPACK_IMPORTED_MODULE_32__images_icons_icon_barcode_svg___default.a,
  calendar: __WEBPACK_IMPORTED_MODULE_33__images_icons_icon_calendar_svg___default.a,
  eye: __WEBPACK_IMPORTED_MODULE_34__images_icons_icon_eye_svg___default.a,
  info: __WEBPACK_IMPORTED_MODULE_35__images_icons_icon_info_svg___default.a,
  cancel: __WEBPACK_IMPORTED_MODULE_36__images_icons_icon_cancel_svg___default.a,
  download: __WEBPACK_IMPORTED_MODULE_37__images_icons_icon_download_svg___default.a,
  check: __WEBPACK_IMPORTED_MODULE_38__images_icons_icon_check_svg___default.a,
  'simple-check': __WEBPACK_IMPORTED_MODULE_39__images_icons_icon_simple_check_svg___default.a,
  refresh: __WEBPACK_IMPORTED_MODULE_40__images_icons_icon_refresh_svg___default.a,
  close: __WEBPACK_IMPORTED_MODULE_41__images_icons_icon_close_svg___default.a,
  buy: __WEBPACK_IMPORTED_MODULE_42__images_icons_icon_buy_svg___default.a,
  sell: __WEBPACK_IMPORTED_MODULE_43__images_icons_icon_sell_svg___default.a,
  receive: __WEBPACK_IMPORTED_MODULE_45__images_icons_icon_receive_svg___default.a,
  send: __WEBPACK_IMPORTED_MODULE_44__images_icons_icon_send_svg___default.a,
  deposit: __WEBPACK_IMPORTED_MODULE_46__images_icons_icon_deposit_svg___default.a,
  withdraw: __WEBPACK_IMPORTED_MODULE_47__images_icons_icon_withdraw_svg___default.a,
  copy: __WEBPACK_IMPORTED_MODULE_48__images_icons_icon_copy_svg___default.a,
  star: __WEBPACK_IMPORTED_MODULE_49__images_icons_icon_star_svg___default.a,
  stop: __WEBPACK_IMPORTED_MODULE_50__images_icons_icon_stop_svg___default.a,
  arrowPrevious: __WEBPACK_IMPORTED_MODULE_57__images_icons_icon_arrow_prev_svg___default.a,
  arrowNext: __WEBPACK_IMPORTED_MODULE_58__images_icons_icon_arrow_next_svg___default.a,
  //ap
  'logo-powered': __WEBPACK_IMPORTED_MODULE_51__images_icons_logo_powered_svg___default.a,
  //misc and possibly unused
  notification: __WEBPACK_IMPORTED_MODULE_52__images_icons_icon_nav_notification_svg___default.a,
  center: __WEBPACK_IMPORTED_MODULE_53__images_icons_icon_center_svg___default.a,
  checkbox: __WEBPACK_IMPORTED_MODULE_54__images_icons_icon_checkbox_svg___default.a,
  'menu-toggle': __WEBPACK_IMPORTED_MODULE_55__images_icons_icon_menu_toggle_svg___default.a,
  bigKey: __WEBPACK_IMPORTED_MODULE_56__images_icons_icon_key_big_svg___default.a,
  pending: __WEBPACK_IMPORTED_MODULE_59__images_icons_icon_pending_svg___default.a,
  settings: __WEBPACK_IMPORTED_MODULE_60__images_icons_icon_settings_svg___default.a,
  alert: __WEBPACK_IMPORTED_MODULE_61__images_icons_icon_alert_svg___default.a,
  menu: __WEBPACK_IMPORTED_MODULE_62__images_icons_icon_menu_svg___default.a,
  plusMinus: __WEBPACK_IMPORTED_MODULE_63__images_icons_icon_plus_minus_svg___default.a,
  arrowUp: __WEBPACK_IMPORTED_MODULE_64__images_icons_icon_arrow_up_svg___default.a,
  arrowDown: __WEBPACK_IMPORTED_MODULE_65__images_icons_icon_arrow_down_svg___default.a
};

var APIcon = function APIcon(props) {
  var name = props.name,
      customClass = props.customClass,
      classModifiers = props.classModifiers;

  var modifiers = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["a" /* addModifier */])(classModifiers, name);
  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])([baseClass, customClass]);
  var icon = icons[name];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__["a" /* default */], { src: icon, className: bemClasses(null, modifiers) });
};

APIcon.defaultProps = {
  name: '',
  customClass: 'custom-icon',
  classModifiers: '',
  disabled: false
};

APIcon.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (APIcon);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(873);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});exports.getTranslateFunction=exports.localize=exports.setTranslations=exports.setFallbackLanguage=exports.setLanguage=exports.i18nState=exports.default=undefined;var _reducer=__webpack_require__(896);Object.defineProperty(exports,'i18nState',{enumerable:true,get:function get(){return _reducer.i18nState}});var _actions=__webpack_require__(453);Object.defineProperty(exports,'setLanguage',{enumerable:true,get:function get(){return _actions.setLanguage}});Object.defineProperty(exports,'setFallbackLanguage',{enumerable:true,get:function get(){return _actions.setFallbackLanguage}});Object.defineProperty(exports,'setTranslations',{enumerable:true,get:function get(){return _actions.setTranslations}});var _component=__webpack_require__(897);var _component2=_interopRequireDefault(_component);var _hoc=__webpack_require__(900);var _hoc2=_interopRequireDefault(_hoc);var _getTranslateFunction2=__webpack_require__(454);var _getTranslateFunction3=_interopRequireDefault(_getTranslateFunction2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}exports.default=_component2.default;exports.localize=_hoc2.default;exports.getTranslateFunction=_getTranslateFunction3.default;

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(217);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(302);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marginTrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return standardTrade; });
var marginTrade = 'Margin';
var standardTrade = 'Standard';

/***/ }),
/* 169 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_TRANSFERS_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_TRANSFERS_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_INCOMING_TRANSFERS; });
/* unused harmony export TRANSFER_REQUEST_SUCCEEDED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTransfers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIncomingTransfers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestTransferFunds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return transferFunds; });
/* unused harmony export receiveIncomingTransfers */
/* unused harmony export receiveTransfers */
/* unused harmony export requestTransfers */
/* unused harmony export requestTransferSucceeded */
/* unused harmony export sendTwoFactorAuthCodeForTransfers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sidePaneActions__ = __webpack_require__(23);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var GET_TRANSFERS_REQUESTED = 'GET_TRANSFERS_REQUESTED';
var GET_TRANSFERS_RECEIVED = 'GET_TRANSFERS_RECEIVED';
var GET_INCOMING_TRANSFERS = 'GET_INCOMING_TRANSFERS';
var TRANSFER_REQUEST_SUCCEEDED = 'TRANSFER_REQUEST_SUCCEEDED';

var getTransfers = function getTransfers(AccountId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var OMSId;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestTransfers());
              OMSId = getState().user.userInfo.OMSId;
              _context.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('GetTransfers', { OMSId: OMSId, AccountId: AccountId })).then(function (res) {
                dispatch(receiveTransfers(res));
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getIncomingTransfers = function getIncomingTransfers(OMSId, AccountId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('GetTransfersReceived', {
                OMSId: OMSId,
                AccountId: AccountId
              })).then(function (res) {
                return dispatch(receiveIncomingTransfers(res));
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var requestTransferFunds = function requestTransferFunds(payload) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var OMSId, response, snackbarPayload;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              _context3.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('RequestTransferFunds', Object.assign({
                OMSId: OMSId
              }, payload)));

            case 3:
              response = _context3.sent;
              snackbarPayload = response.result ? {
                id: 'requestTransferSuccess',
                // context.t('Request transfer succeeded');
                text: 'Request transfer succeeded',
                type: 'success'
              } : {
                id: 'requestTransferError',
                text: Object(__WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__["a" /* formatErrorText */])(response),
                type: 'warning'
              };


              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])(snackbarPayload));

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var transferFunds = function transferFunds(payload, pane) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var _getState$user, SenderAccountId, OMSId, response, snackbarPayload;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _getState$user = getState().user, SenderAccountId = _getState$user.selectedAccountId, OMSId = _getState$user.userInfo.OMSId;
              _context4.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__apiActions__["b" /* callAPI */])('TransferFunds', Object.assign({
                OMSId: OMSId,
                SenderAccountId: SenderAccountId
              }, payload)));

            case 3:
              response = _context4.sent;
              snackbarPayload = response.result ? {
                id: 'transferSuccess',
                // context.t('Transfer succeeded');
                text: 'Transfer succeeded',
                type: 'success'
              } : {
                id: 'transferError',
                text: Object(__WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__["a" /* formatErrorText */])(response),
                type: 'warning'
              };


              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__sidePaneActions__["j" /* closeSidePane */])(pane));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])(snackbarPayload));

            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var receiveIncomingTransfers = function receiveIncomingTransfers(payload) {
  return {
    type: GET_INCOMING_TRANSFERS,
    payload: payload
  };
};

var receiveTransfers = function receiveTransfers(payload) {
  return {
    type: GET_TRANSFERS_RECEIVED,
    payload: payload
  };
};

var requestTransfers = function requestTransfers() {
  return {
    type: GET_TRANSFERS_REQUESTED
  };
};

var requestTransferSucceeded = function requestTransferSucceeded(payload) {
  return {
    type: TRANSFER_REQUEST_SUCCEEDED,
    payload: payload
  };
};

var sendTwoFactorAuthCodeForTransfers = function sendTwoFactorAuthCodeForTransfers(code) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      var auth;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.Authenticate2FA({
                Code: code
              });

            case 2:
              auth = _context5.sent;

              if (auth.Authenticated) {
                _context5.next = 5;
                break;
              }

              return _context5.abrupt('return', auth);

            case 5:

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_5__modalActions__["b" /* MODAL_TYPES */].SEND_REQUEST_2FA));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__sidePaneActions__["j" /* closeSidePane */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'transferSuccess',
                // context.t('Transfer succeeded');
                text: 'Transfer succeeded',
                type: 'success'
              }));

            case 8:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_API_KEYS_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_API_KEYS_SUCCESS; });
/* unused harmony export GET_API_KEYS_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_API_KEY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createApiKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUserApiKeys; });
/* unused harmony export getApiKeysRequested */
/* unused harmony export getApiKeysSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addApiKey; });
/* unused harmony export removeApiKeySuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeApiKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modalActions__ = __webpack_require__(9);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var GET_API_KEYS_REQUESTED = 'GET_API_KEYS_REQUESTED';
var GET_API_KEYS_SUCCESS = 'GET_API_KEYS_SUCCESS';
var GET_API_KEYS_ERROR = 'GET_API_KEYS_ERROR';
var ADD_API_KEY = 'ADD_API_KEY';
var REMOVE_API_KEY_SUCCESS = 'REMOVE_API_KEY_SUCCESS';

var createApiKey = function createApiKey(formValues) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var UserId, Permissions, apiKey;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              UserId = getState().user.userInfo.UserId;
              Permissions = [];


              if (formValues.trading) Permissions.push('Trading');
              if (formValues.withdraw) Permissions.push('Withdraw');
              if (formValues.deposit) Permissions.push('Deposit');
              if (formValues.accountReadOnly) Permissions.push('AccountReadOnly');

              _context.next = 8;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('AddUserAPIKey', { UserId: UserId, Permissions: Permissions }));

            case 8:
              apiKey = _context.sent;

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_2__modalActions__["b" /* MODAL_TYPES */].NEW_API_KEY, { apiKey: apiKey }));

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getUserApiKeys = function getUserApiKeys(UserId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      var keys;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(getApiKeysRequested());
              _context2.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetUserAPIKeys', { UserId: UserId }));

            case 3:
              keys = _context2.sent;

              if (Array.isArray(keys)) {
                dispatch(getApiKeysSuccess(keys));
              }

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var getApiKeysRequested = function getApiKeysRequested() {
  return {
    type: GET_API_KEYS_REQUESTED
  };
};

var getApiKeysSuccess = function getApiKeysSuccess(payload) {
  return {
    type: GET_API_KEYS_SUCCESS,
    payload: payload
  };
};

var addApiKey = function addApiKey(payload) {
  return {
    type: ADD_API_KEY,
    payload: payload
  };
};

var removeApiKeySuccess = function removeApiKeySuccess(payload) {
  return {
    type: REMOVE_API_KEY_SUCCESS,
    payload: payload
  };
};

var removeApiKey = function removeApiKey(APIKey) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var UserId, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              UserId = getState().user.userInfo.UserId;
              _context3.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('RemoveUserAPIKey', {
                UserId: UserId,
                APIKey: APIKey
              }));

            case 3:
              response = _context3.sent;

              if (response.result) {
                dispatch(removeApiKeySuccess(APIKey));
              }

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(513),
    baseKeys = __webpack_require__(514),
    isArrayLike = __webpack_require__(141);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProducts; });
/* unused harmony export receiveProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_PRODUCT_ATTRIBUTES; });
/* unused harmony export receiveProductAttributes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProductAttributes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_filterSortSupportedProducts__ = __webpack_require__(502);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
var getProducts = function getProducts() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var products, filteredSortedProducts;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetProducts', {
                OMSId: getState().user.userInfo.OMSId || 1
              }));

            case 2:
              products = _context.sent;
              filteredSortedProducts = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_filterSortSupportedProducts__["a" /* default */])(products);


              dispatch(receiveProducts(filteredSortedProducts));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var receiveProducts = function receiveProducts(payload) {
  return {
    type: RECEIVE_PRODUCTS,
    payload: payload
  };
};

var RECEIVE_PRODUCT_ATTRIBUTES = 'RECEIVE_PRODUCT_ATTRIBUTES';
var receiveProductAttributes = function receiveProductAttributes(data, ProductId) {
  return {
    type: RECEIVE_PRODUCT_ATTRIBUTES,
    payload: {
      ProductId: ProductId,
      data: data
    }
  };
};

var getProductAttributes = function getProductAttributes(products) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              products.map(function (product) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetProductAttributes', {
                  OMSId: getState().user.userInfo.OMSId || 1,
                  ProductId: product.ProductId
                })).then(function (res) {
                  if (res.length) {
                    dispatch(receiveProductAttributes(res, product.ProductId));
                  }
                });
              });

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ACTIVE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setActivePage; });
var SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';

var setActivePage = function setActivePage(payload) {
  return {
    type: SET_ACTIVE_PAGE,
    payload: payload
  };
};

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQueryParam; });
var getQueryParam = function getQueryParam(name) {
  var url = window.location.href;
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1161),
    Map = __webpack_require__(310),
    Promise = __webpack_require__(1162),
    Set = __webpack_require__(561),
    WeakMap = __webpack_require__(1163),
    baseGetTag = __webpack_require__(117),
    toSource = __webpack_require__(496);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APIcon_js__ = __webpack_require__(1211);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__APIcon_js__["a" /* default */]);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_redirectIfAuthorizedHelper__ = __webpack_require__(1270);






function redirectIfAuthorized(WrappedComponent, defaultPath) {
  var ModifiedComponent = function ModifiedComponent(props) {
    var shouldRedirect = props.shouldRedirect,
        redirectLocation = props.redirectLocation,
        isAuthenticated = props.isAuthenticated;


    if (isAuthenticated) {
      if (Object(__WEBPACK_IMPORTED_MODULE_4__helpers_redirectIfAuthorizedHelper__["a" /* redirectExceptions */])()) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
      }
      if (shouldRedirect) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */], {
          to: {
            pathname: redirectLocation.pathname,
            search: redirectLocation.search
          }
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */], { to: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])(defaultPath + '?default=redirect') });
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      shouldRedirect: state.auth.shouldRedirect,
      redirectLocation: state.auth.location
    };
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, null)(ModifiedComponent);
}

/* harmony default export */ __webpack_exports__["a"] = (redirectIfAuthorized);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isViablePhoneNumber;
exports.VALID_PHONE_NUMBER_WITH_EXTENSION = exports.VALID_PHONE_NUMBER = void 0;

var _constants = __webpack_require__(68);

var _createExtensionPattern = _interopRequireDefault(__webpack_require__(251));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + _constants.VALID_DIGITS + ']{' + _constants.MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + _constants.PLUS_CHARS + ']{0,1}' + '(?:' + '[' + _constants.VALID_PUNCTUATION + ']*' + '[' + _constants.VALID_DIGITS + ']' + '){3,}' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']*';
exports.VALID_PHONE_NUMBER = VALID_PHONE_NUMBER;
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + (0, _createExtensionPattern["default"])() + ')?'; // The combined regular expression for valid phone numbers:
//

exports.VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER_WITH_EXTENSION;
var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= _constants.MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTotalWithdrawValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFinalBalanceWithdrawValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalRender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showTemplateSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAvailableBalance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bignumber_js__);

var getTotalWithdrawValue = function getTotalWithdrawValue(balance, amount, fee) {
  return amount + fee >= balance ? balance - fee : amount;
};

var getFinalBalanceWithdrawValue = function getFinalBalanceWithdrawValue(balance, amount, fee) {
  return amount + fee <= balance ? balance - (amount + fee) : balance;
};

var getTotalRender = function getTotalRender(balance, amount, fee) {
  amount = parseFloat(amount);

  if (!amount) return 0;

  if (amount === balance) return amount;

  var total = getTotalWithdrawValue(balance, amount, fee);
  var totalBigNumber = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(total);
  var feeBigNumber = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(fee);

  return Number(totalBigNumber.plus(feeBigNumber));
};

var showTemplateSelect = function showTemplateSelect(_ref) {
  var templateTypes = _ref.templateTypes,
      templateInfo = _ref.templateInfo,
      isLoading = _ref.isLoading;
  return templateTypes.length > 1 && !Object.keys(templateInfo).length && !isLoading;
};

var getAvailableBalance = function getAvailableBalance(balance, hold) {
  return balance ? balance - hold : 0;
};

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InstrumentRowComponent__ = __webpack_require__(1568);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InstrumentRowComponent__["a" /* default */]);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instrumentPropType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var instrumentPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  OMSId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  InstrumentId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  Symbol: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  Product1: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  Product1Symbol: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  Product2: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  Product2Symbol: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  InstrumentType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  VenueInstrumentId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  VenueId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  SortIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  SessionStatus: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  PreviousSessionStatus: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  SessionStatusDateTime: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  SelfTradePrevention: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  QuantityIncrement: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstrumentTableComponent__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);





var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var _ref = state.apexCore ? state.apexCore : {},
      level1 = _ref.level1;

  var selectedInstrumentId = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(selectedInstrument, 'InstrumentId', '');

  return {
    level1: level1[selectedInstrumentId],
    selectedInstrument: selectedInstrument
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_2__InstrumentTableComponent__["a" /* default */]));

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApexChartContainer__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TVChartContainer__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LightWeightCharts_LightWeightChartContainer__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);






var chartOptions = {
  APEX: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ApexChartContainer__["a" /* default */], null),
  TradingView: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TVChartContainer__["a" /* default */], null),
  LightWeight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LightWeightCharts_LightWeightChartContainer__["a" /* default */], null)
};

var PriceChartContainer = function PriceChartContainer(props) {
  var chart = __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].TradingLayout.chart;
  if (props.chart) chart = props.chart;
  return chartOptions[chart];
};

/* harmony default export */ __webpack_exports__["a"] = (PriceChartContainer);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
function symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) {
            Symbol.iterator = Symbol('iterator polyfill');
        }
        return Symbol.iterator;
    }
    else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
            return '@@iterator';
        }
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                    return key;
                }
            }
        }
        return '@@iterator';
    }
}
exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
exports.iterator = symbolIteratorPonyfill(root_1.root);
/**
 * @deprecated use iterator instead
 */
exports.$$iterator = exports.iterator;
//# sourceMappingURL=iterator.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isScheduler_1 = __webpack_require__(72);
var of_1 = __webpack_require__(676);
var from_1 = __webpack_require__(677);
var concatAll_1 = __webpack_require__(386);
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    if (observables.length === 1 || (observables.length === 2 && isScheduler_1.isScheduler(observables[1]))) {
        return from_1.from(observables[0]);
    }
    return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Observable_1.Observable.of(this.value);
            case 'E':
                return Observable_1.Observable.throw(this.error);
            case 'C':
                return Observable_1.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var subscribeToResult_1 = __webpack_require__(18);
var OuterSubscriber_1 = __webpack_require__(17);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
    };
}
exports.mergeMap = mergeMap;
var MergeMapOperator = (function () {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}());
exports.MergeMapOperator = MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapSubscriber = MergeMapSubscriber;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(82);
function isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
exports.isNumeric = isNumeric;
;
//# sourceMappingURL=isNumeric.js.map

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(56);
var Action_1 = __webpack_require__(1628);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return root_1.root.clearInterval(id) && undefined || undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            // Dequeue if the action didn't reschedule itself. Don't call
            // unsubscribe(), because the action could reschedule later.
            // For example:
            // ```
            // scheduler.schedule(function doWork(counter) {
            //   /* ... I'm a busy worker bee ... */
            //   var originalAction = this;
            //   /* wait 100ms before rescheduling the action */
            //   setTimeout(function () {
            //     originalAction.schedule(counter + 1);
            //   }, 100);
            // }, 1000);
            // ```
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action_1.Action));
exports.AsyncAction = AsyncAction;
//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Scheduler_1 = __webpack_require__(1629);
var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */
        this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */
        this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler_1.Scheduler));
exports.AsyncScheduler = AsyncScheduler;
//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
exports.map = map;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
exports.MapOperator = MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=map.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */
var ArgumentOutOfRangeError = (function (_super) {
    __extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error));
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var scan_1 = __webpack_require__(395);
var takeLast_1 = __webpack_require__(396);
var defaultIfEmpty_1 = __webpack_require__(390);
var pipe_1 = __webpack_require__(383);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */
function reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        return function reduceOperatorFunctionWithSeed(source) {
            return pipe_1.pipe(scan_1.scan(accumulator, seed), takeLast_1.takeLast(1), defaultIfEmpty_1.defaultIfEmpty(seed))(source);
        };
    }
    return function reduceOperatorFunction(source) {
        return pipe_1.pipe(scan_1.scan(function (acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), takeLast_1.takeLast(1))(source);
    };
}
exports.reduce = reduce;
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepthChartComponent__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_store__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);







var DepthChart = __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].DepthChart;


var mapStateToProps = function mapStateToProps(state) {
  var level2 = state.apexCore.level2;
  var fetching = level2.fetching;


  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  return {
    level2: level2,
    store: __WEBPACK_IMPORTED_MODULE_2__redux_store__["a" /* default */],
    fetching: fetching,
    DepthChart: DepthChart,
    selectedInstrument: selectedInstrument
  };
};

var mapDispatchToProps = {
  buyPriceClicked: __WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__["a" /* buyPriceClicked */],
  sellPriceClicked: __WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__["g" /* sellPriceClicked */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DepthChartComponent__["a" /* default */]));

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginToggleButtonContainer__ = __webpack_require__(1964);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginToggleButtonContainer__["a" /* default */]);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecentActivityContainer__ = __webpack_require__(431);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__RecentActivityContainer__["a" /* default */]);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return product; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var product = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  iconFileName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  ProductFullName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  ProductSymbol: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  ProductId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerRadioInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var baseClass = 'ap-radio';

var InnerRadioInput = function InnerRadioInput(props) {
  var input = props.input,
      customClass = props.customClass,
      meta = props.meta,
      inline = props.inline,
      label = props.label,
      info = props.info,
      id = props.id,
      passedProps = _objectWithoutProperties(props, ['input', 'customClass', 'meta', 'inline', 'label', 'info', 'id']);

  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])([baseClass, customClass]);

  delete passedProps.meta;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses(null, { inline: inline }) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', Object.assign({
      className: bemClasses('input'),
      type: 'radio'
    }, input, passedProps, {
      id: id
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { className: bemClasses('label'), htmlFor: id },
      label,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: bemClasses('check') }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: bemClasses('checked') })
    ),
    info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'small',
      { className: 'form-text-muted ' + bemClasses('radio-info') },
      info
    ),
    meta.dirty && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: bemClasses('radio-error') },
      meta.error
    )
  );
};


var APRadio = function APRadio(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({
    name: props.name,
    component: InnerRadioInput,
    type: 'radio'
  }, props));
};

APRadio.defaultProps = {
  name: '',
  label: '',
  autoFocus: false,
  required: false,
  readOnly: false,
  inline: false,
  info: ''
};

APRadio.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (APRadio);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecentActivityWithFilterContainer__ = __webpack_require__(2109);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__RecentActivityWithFilterContainer__["a" /* default */]);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInterestAccountStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInterestAccountRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getInterestBalances; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return disableInterestAccountRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__snackbarActions__ = __webpack_require__(20);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var PORT = 8887;

function getUrl() {
  var port = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PORT;

  var URL = localStorage.getItem('tradingServer');
  URL = URL.split('/')[2];

  return 'https://' + URL + ':' + port;
}

var getRates = function getRates() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var rates;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetGeneralKVP', {
                Key: 'IBARates'
              }));

            case 2:
              rates = _context.sent;


              if (rates && rates.result !== false) {
                dispatch({
                  type: 'GET_INTEREST_RATES',
                  payload: JSON.parse(rates.Value)
                });
              }

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getInterestAccountStatus = function getInterestAccountStatus() {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetAccountConfig', {
                AccountId: getState().user.selectedAccountId
              })).then(function (res) {
                var data = res.find(function (i) {
                  return i.Key === 'IBAOptedIn';
                });
                if (data && data.Value === 'true') {
                  dispatch({
                    type: 'UPDATE_INTEREST_ACCOUNT_STATUS',
                    payload: true
                  });
                }
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var createInterestAccountRequest = function createInterestAccountRequest() {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('SetAccountConfig', {
                AccountId: getState().user.selectedAccountId,
                Config: [{
                  Key: 'IBAOptedIn',
                  Value: 'true'
                }]
              })).then(function (res) {
                if (res.result) {
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                    id: 'CreateInterestAccountRequestSuccess',
                    text: res.detail || 'Successfully enrolled',
                    type: 'success'
                  }));
                  dispatch({
                    type: 'UPDATE_INTEREST_ACCOUNT_STATUS',
                    payload: true
                  });
                  return true;
                } else {
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                    id: 'CreateInterestAccountRequestError',
                    text: res.errormsg,
                    type: 'warning'
                  }));
                  return false;
                }
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x6, _x7) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var getInterestBalances = function getInterestBalances() {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetAccountTransactions', {
                AccountId: getState().user.selectedAccountId,
                OMSId: 1,
                TransactionTypes: ['15']
              })).then(function (payload) {
                return dispatch({
                  type: 'RECEIVE_INTEREST_PAYMENTS',
                  payload: payload
                });
              }).catch(function (e) {
                return console.log(e);
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var disableInterestAccountRequest = function disableInterestAccountRequest() {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('SetAccountConfig', {
                AccountId: getState().user.selectedAccountId,
                Config: [{
                  Key: 'IBAOptedIn',
                  Value: 'false'
                }]
              })).then(function (res) {
                if (res.result) {
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                    id: 'CreateInterestAccountRequestSuccess',
                    text: res.detail || 'Successfully disenrolled Interest Bearning Account',
                    type: 'success'
                  }));
                  dispatch({
                    type: 'UPDATE_INTEREST_ACCOUNT_STATUS',
                    payload: false
                  });
                  return true;
                } else {
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__snackbarActions__["e" /* showSnack */])({
                    id: 'CreateInterestAccountRequestError',
                    text: res.msg,
                    type: 'warning'
                  }));
                  return false;
                }
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x10, _x11) {
      return _ref5.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APAutoTabInput_css__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APAutoTabInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__APAutoTabInput_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var baseClass = 'ap-auto-tab-input';

var InnerInput = function (_React$Component) {
  _inherits(InnerInput, _React$Component);

  function InnerInput(props) {
    _classCallCheck(this, InnerInput);

    var _this = _possibleConstructorReturn(this, (InnerInput.__proto__ || Object.getPrototypeOf(InnerInput)).call(this, props));

    _this.handleChange = function (e, index) {
      var target = e.target;
      var value = target.value;
      var maxLength = _this.props.maxLength;

      var newValues = _this.state.values.slice();

      if (value.length <= maxLength) {
        newValues[index] = value;
        _this.setNewValues(newValues);
      } else if (value.length > maxLength && index < _this.props.numberOfInputs - 1) {
        newValues[index + 1] = value.substr(value.length - 1, 1);
        _this.setNewValues(newValues);
      }
    };

    _this.handleKeyUp = function (e, index) {
      var backspaceCode = 8;
      if (e.keyCode === backspaceCode && e.target.value.length === 0) {
        var prev = e.target.previousElementSibling;
        while (prev) {
          if (prev === null) break;
          if (prev.tagName.toLowerCase() === 'input') {
            prev.focus();
            break;
          }
          prev = prev.previousElementSibling;
        }
      } else if (e.target.value.length === _this.props.maxLength) {
        var next = e.target.nextElementSibling;

        while (next) {
          if (next === null) break;
          if (next.tagName.toLowerCase() === 'input') {
            next.focus();
            break;
          }
          next = next.nextElementSibling;
        }
      }
    };

    _this.state = {
      values: Array(props.numberOfInputs).fill('')
    };
    return _this;
  }

  _createClass(InnerInput, [{
    key: 'setNewValues',
    value: function setNewValues(newValues) {
      var _this2 = this;

      this.setState({ values: newValues }, function () {
        _this2.props.input.onChange(_this2.state.values.join(''));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          info = _props.info,
          meta = _props.meta,
          label = _props.label,
          customClass = _props.customClass;

      var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);

      var inputs = this.state.values.map(function (value, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          key: index,
          className: bemClasses(),
          onKeyUp: function onKeyUp(e) {
            return _this3.handleKeyUp(e, index);
          },
          onChange: function onChange(e) {
            return _this3.handleChange(e, index);
          },
          value: _this3.state.values[index]
        });
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group' },
        this.props.type !== 'hidden' && label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { className: bemClasses('label') },
          label
        ),
        inputs,
        info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'small',
          { className: 'form-text-muted' },
          info
        ),
        meta.touched && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: '' + bemClasses('error') },
          meta.error
        )
      );
    }
  }]);

  return InnerInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var APAutoTabInput = function APAutoTabInput(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: InnerInput }, props));
};

APAutoTabInput.defaultProps = {
  maxLength: 1
};

APAutoTabInput.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  numberOfInputs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  maxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (APAutoTabInput);

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(336),
    baseAssignValue = __webpack_require__(587);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentWithFooterLayoutTemplate_css__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentWithFooterLayoutTemplate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContentWithFooterLayoutTemplate_css__);






/**
 * This is layout for following case:
 *  ___________________________
 * |                           |
 * | {content}                 |
 * |                           |
 * |___________________________|
 * | {footer}                  |
 * |___________________________|
 *
 * Note: footer is always attached to bottom
 */
var ContentWithFooterLayoutTemplate = function ContentWithFooterLayoutTemplate(props) {
  var children = props.children,
      customClass = props.customClass,
      classModifiers = props.classModifiers,
      footer = props.footer;


  var classes = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('content-with-footer-lt', customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes('layout-template', classModifiers) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('content', classModifiers) },
      children
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('footer', classModifiers) },
      footer
    )
  );
};

ContentWithFooterLayoutTemplate.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};

ContentWithFooterLayoutTemplate.defaultProps = {
  customClass: 'custom-retail-widget'
};

/* harmony default export */ __webpack_exports__["a"] = (ContentWithFooterLayoutTemplate);

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(865);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(74);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(294);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(471);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(116);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(934);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(165);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(936);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(966);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(162)(module)))

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(969);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(479);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onInit; });
var APP_INIT = 'APP_INIT';

var onInit = function onInit() {
  return {
    type: APP_INIT
  };
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(1075)):"function"==typeof define&&define.amd?define("alphapoint",["universal-websocket-client"],e):"object"==typeof exports?exports.alphapoint=e(require("universal-websocket-client")):t.alphapoint=e(t.WebSocket)}(this,function(t){return function(t){function e(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var r={};return e.m=t,e.c=r,e.d=function(t,r,n){e.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:n})},e.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(r,"a",r),r},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=64)}([function(t,e){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,e,r){var n=r(43)("wks"),o=r(44),i=r(0).Symbol,s="function"==typeof i;(t.exports=function(t){return n[t]||(n[t]=s&&i[t]||(s?i:o)("Symbol."+t))}).store=n},function(t,e,r){"use strict";e.__esModule=!0,e.default=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(58),i=r(14),s=r(60),u=r(34),c=function(t){function e(r,n,o){switch(t.call(this),this.syncErrorValue=null,this.syncErrorThrown=!1,this.syncErrorThrowable=!1,this.isStopped=!1,arguments.length){case 0:this.destination=s.empty;break;case 1:if(!r){this.destination=s.empty;break}if("object"==typeof r){r instanceof e?(this.destination=r,this.destination.add(this)):(this.syncErrorThrowable=!0,this.destination=new a(this,r));break}default:this.syncErrorThrowable=!0,this.destination=new a(this,r,n,o)}}return n(e,t),e.prototype[u.rxSubscriber]=function(){return this},e.create=function(t,r,n){var o=new e(t,r,n);return o.syncErrorThrowable=!1,o},e.prototype.next=function(t){this.isStopped||this._next(t)},e.prototype.error=function(t){this.isStopped||(this.isStopped=!0,this._error(t))},e.prototype.complete=function(){this.isStopped||(this.isStopped=!0,this._complete())},e.prototype.unsubscribe=function(){this.closed||(this.isStopped=!0,t.prototype.unsubscribe.call(this))},e.prototype._next=function(t){this.destination.next(t)},e.prototype._error=function(t){this.destination.error(t),this.unsubscribe()},e.prototype._complete=function(){this.destination.complete(),this.unsubscribe()},e.prototype._unsubscribeAndRecycle=function(){var t=this,e=t._parent,r=t._parents;return this._parent=null,this._parents=null,this.unsubscribe(),this.closed=!1,this.isStopped=!1,this._parent=e,this._parents=r,this},e}(i.Subscription);e.Subscriber=c;var a=function(t){function e(e,r,n,i){t.call(this),this._parentSubscriber=e;var u,c=this;o.isFunction(r)?u=r:r&&(u=r.next,n=r.error,i=r.complete,r!==s.empty&&(c=Object.create(r),o.isFunction(c.unsubscribe)&&this.add(c.unsubscribe.bind(c)),c.unsubscribe=this.unsubscribe.bind(this))),this._context=c,this._next=u,this._error=n,this._complete=i}return n(e,t),e.prototype.next=function(t){if(!this.isStopped&&this._next){var e=this._parentSubscriber;e.syncErrorThrowable?this.__tryOrSetError(e,this._next,t)&&this.unsubscribe():this.__tryOrUnsub(this._next,t)}},e.prototype.error=function(t){if(!this.isStopped){var e=this._parentSubscriber;if(this._error)e.syncErrorThrowable?(this.__tryOrSetError(e,this._error,t),this.unsubscribe()):(this.__tryOrUnsub(this._error,t),this.unsubscribe());else{if(!e.syncErrorThrowable)throw this.unsubscribe(),t;e.syncErrorValue=t,e.syncErrorThrown=!0,this.unsubscribe()}}},e.prototype.complete=function(){var t=this;if(!this.isStopped){var e=this._parentSubscriber;if(this._complete){var r=function(){return t._complete.call(t._context)};e.syncErrorThrowable?(this.__tryOrSetError(e,r),this.unsubscribe()):(this.__tryOrUnsub(r),this.unsubscribe())}else this.unsubscribe()}},e.prototype.__tryOrUnsub=function(t,e){try{t.call(this._context,e)}catch(t){throw this.unsubscribe(),t}},e.prototype.__tryOrSetError=function(t,e,r){try{e.call(this._context,r)}catch(e){return t.syncErrorValue=e,t.syncErrorThrown=!0,!0}return!1},e.prototype._unsubscribe=function(){var t=this._parentSubscriber;this._context=null,this._parentSubscriber=null,t.unsubscribe()},e}(c)},function(t,e){var r=t.exports={version:"2.5.1"};"number"==typeof __e&&(__e=r)},function(t,e,r){"use strict";var n=r(13),o=r(98),i=r(102),s=function(){function t(t){this._isScalar=!1,t&&(this._subscribe=t)}return t.prototype.lift=function(e){var r=new t;return r.source=this,r.operator=e,r},t.prototype.subscribe=function(t,e,r){var n=this.operator,i=o.toSubscriber(t,e,r);if(n?n.call(i,this.source):i.add(this.source?this._subscribe(i):this._trySubscribe(i)),i.syncErrorThrowable&&(i.syncErrorThrowable=!1,i.syncErrorThrown))throw i.syncErrorValue;return i},t.prototype._trySubscribe=function(t){try{return this._subscribe(t)}catch(e){t.syncErrorThrown=!0,t.syncErrorValue=e,t.error(e)}},t.prototype.forEach=function(t,e){var r=this;if(e||(n.root.Rx&&n.root.Rx.config&&n.root.Rx.config.Promise?e=n.root.Rx.config.Promise:n.root.Promise&&(e=n.root.Promise)),!e)throw new Error("no Promise impl found");return new e(function(e,n){var o;o=r.subscribe(function(e){if(o)try{t(e)}catch(t){n(t),o.unsubscribe()}else t(e)},n,e)})},t.prototype._subscribe=function(t){return this.source.subscribe(t)},t.prototype[i.observable]=function(){return this},t.create=function(e){return new t(e)},t}();e.Observable=s},function(t,e,r){var n=r(0),o=r(4),i=r(16),s=r(10),u=function(t,e,r){var c,a,l,f=t&u.F,d=t&u.G,h=t&u.S,p=t&u.P,v=t&u.B,b=t&u.W,y=d?o:o[e]||(o[e]={}),_=y.prototype,O=d?n:h?n[e]:(n[e]||{}).prototype;d&&(r=e);for(c in r)(a=!f&&O&&void 0!==O[c])&&c in y||(l=a?O[c]:r[c],y[c]=d&&"function"!=typeof O[c]?r[c]:v&&a?i(l,n):b&&O[c]==l?function(t){var e=function(e,r,n){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,r)}return new t(e,r,n)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(l):p&&"function"==typeof l?i(Function.call,l):l,p&&((y.virtual||(y.virtual={}))[c]=l,t&u.R&&_&&!_[c]&&s(_,c,l)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,t.exports=u},function(t,e,r){var n=r(17);t.exports=function(t){if(!n(t))throw TypeError(t+" is not an object!");return t}},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(5),i=r(3),s=r(14),u=r(61),c=r(62),a=r(34),l=function(t){function e(e){t.call(this,e),this.destination=e}return n(e,t),e}(i.Subscriber);e.SubjectSubscriber=l;var f=function(t){function e(){t.call(this),this.observers=[],this.closed=!1,this.isStopped=!1,this.hasError=!1,this.thrownError=null}return n(e,t),e.prototype[a.rxSubscriber]=function(){return new l(this)},e.prototype.lift=function(t){var e=new d(this,this);return e.operator=t,e},e.prototype.next=function(t){if(this.closed)throw new u.ObjectUnsubscribedError;if(!this.isStopped)for(var e=this.observers,r=e.length,n=e.slice(),o=0;o<r;o++)n[o].next(t)},e.prototype.error=function(t){if(this.closed)throw new u.ObjectUnsubscribedError;this.hasError=!0,this.thrownError=t,this.isStopped=!0;for(var e=this.observers,r=e.length,n=e.slice(),o=0;o<r;o++)n[o].error(t);this.observers.length=0},e.prototype.complete=function(){if(this.closed)throw new u.ObjectUnsubscribedError;this.isStopped=!0;for(var t=this.observers,e=t.length,r=t.slice(),n=0;n<e;n++)r[n].complete();this.observers.length=0},e.prototype.unsubscribe=function(){this.isStopped=!0,this.closed=!0,this.observers=null},e.prototype._trySubscribe=function(e){if(this.closed)throw new u.ObjectUnsubscribedError;return t.prototype._trySubscribe.call(this,e)},e.prototype._subscribe=function(t){if(this.closed)throw new u.ObjectUnsubscribedError;return this.hasError?(t.error(this.thrownError),s.Subscription.EMPTY):this.isStopped?(t.complete(),s.Subscription.EMPTY):(this.observers.push(t),new c.SubjectSubscription(this,t))},e.prototype.asObservable=function(){var t=new o.Observable;return t.source=this,t},e.create=function(t,e){return new d(t,e)},e}(o.Observable);e.Subject=f;var d=function(t){function e(e,r){t.call(this),this.destination=e,this.source=r}return n(e,t),e.prototype.next=function(t){var e=this.destination;e&&e.next&&e.next(t)},e.prototype.error=function(t){var e=this.destination;e&&e.error&&this.destination.error(t)},e.prototype.complete=function(){var t=this.destination;t&&t.complete&&this.destination.complete()},e.prototype._subscribe=function(t){return this.source?this.source.subscribe(t):s.Subscription.EMPTY},e}(f);e.AnonymousSubject=d},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.Order=e.Trade=e.Level2=e.Level1=void 0;var o=r(117),i=n(o),s=r(123),u=n(s),c=r(124),a=n(c),l=r(125),f=n(l);e.Level1=i.default,e.Level2=u.default,e.Trade=a.default,e.Order=f.default},function(t,e,r){var n=r(11),o=r(26);t.exports=r(12)?function(t,e,r){return n.f(t,e,o(1,r))}:function(t,e,r){return t[e]=r,t}},function(t,e,r){var n=r(7),o=r(70),i=r(71),s=Object.defineProperty;e.f=r(12)?Object.defineProperty:function(t,e,r){if(n(t),e=i(e,!0),n(r),o)try{return s(t,e,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[e]=r.value),t}},function(t,e,r){t.exports=!r(24)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,r){"use strict";(function(t){var r="undefined"!=typeof window&&window,n="undefined"!=typeof self&&"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope&&self,o=void 0!==t&&t,i=r||o||n;e.root=i,function(){if(!i)throw new Error("RxJS could not find any global context (window, self, global)")}()}).call(e,r(97))},function(t,e,r){"use strict";function n(t){return t.reduce(function(t,e){return t.concat(e instanceof a.UnsubscriptionError?e.errors:e)},[])}var o=r(99),i=r(100),s=r(58),u=r(59),c=r(33),a=r(101),l=function(){function t(t){this.closed=!1,this._parent=null,this._parents=null,this._subscriptions=null,t&&(this._unsubscribe=t)}return t.prototype.unsubscribe=function(){var t,e=!1;if(!this.closed){var r=this,l=r._parent,f=r._parents,d=r._unsubscribe,h=r._subscriptions;this.closed=!0,this._parent=null,this._parents=null,this._subscriptions=null;for(var p=-1,v=f?f.length:0;l;)l.remove(this),l=++p<v&&f[p]||null;if(s.isFunction(d)){var b=u.tryCatch(d).call(this);b===c.errorObject&&(e=!0,t=t||(c.errorObject.e instanceof a.UnsubscriptionError?n(c.errorObject.e.errors):[c.errorObject.e]))}if(o.isArray(h))for(p=-1,v=h.length;++p<v;){var y=h[p];if(i.isObject(y)){var b=u.tryCatch(y.unsubscribe).call(y);if(b===c.errorObject){e=!0,t=t||[];var _=c.errorObject.e;_ instanceof a.UnsubscriptionError?t=t.concat(n(_.errors)):t.push(_)}}}if(e)throw new a.UnsubscriptionError(t)}},t.prototype.add=function(e){if(!e||e===t.EMPTY)return t.EMPTY;if(e===this)return this;var r=e;switch(typeof e){case"function":r=new t(e);case"object":if(r.closed||"function"!=typeof r.unsubscribe)return r;if(this.closed)return r.unsubscribe(),r;if("function"!=typeof r._addParent){var n=r;r=new t,r._subscriptions=[n]}break;default:throw new Error("unrecognized teardown "+e+" added to Subscription.")}return(this._subscriptions||(this._subscriptions=[])).push(r),r._addParent(this),r},t.prototype.remove=function(t){var e=this._subscriptions;if(e){var r=e.indexOf(t);-1!==r&&e.splice(r,1)}},t.prototype._addParent=function(t){var e=this,r=e._parent,n=e._parents;r&&r!==t?n?-1===n.indexOf(t)&&n.push(t):this._parents=[t]:this._parent=t},t.EMPTY=function(t){return t.closed=!0,t}(new t),t}();e.Subscription=l},function(t,e,r){"use strict";var n=r(5),o=r(116);n.Observable.prototype.filter=o.filter},function(t,e,r){var n=r(19);t.exports=function(t,e,r){if(n(t),void 0===e)return t;switch(r){case 1:return function(r){return t.call(e,r)};case 2:return function(r,n){return t.call(e,r,n)};case 3:return function(r,n,o){return t.call(e,r,n,o)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){var r={}.hasOwnProperty;t.exports=function(t,e){return r.call(t,e)}},function(t,e){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,e){var r=Math.ceil,n=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?n:r)(t)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,r){var n=r(17),o=r(0).document,i=n(o)&&n(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,r){var n=r(42),o=r(23);t.exports=function(t){return n(o(t))}},function(t,e,r){var n=r(22),o=Math.min;t.exports=function(t){return t>0?o(n(t),9007199254740991):0}},function(t,e,r){var n=r(43)("keys"),o=r(44);t.exports=function(t){return n[t]||(n[t]=o(t))}},function(t,e,r){var n=r(11).f,o=r(20),i=r(1)("toStringTag");t.exports=function(t,e,r){t&&!o(t=r?t:t.prototype,i)&&n(t,i,{configurable:!0,value:e})}},function(t,e,r){var n=r(23);t.exports=function(t){return Object(n(t))}},function(t,e,r){"use strict";function n(t){var e,r;this.promise=new t(function(t,n){if(void 0!==e||void 0!==r)throw TypeError("Bad Promise constructor");e=t,r=n}),this.resolve=o(e),this.reject=o(r)}var o=r(19);t.exports.f=function(t){return new n(t)}},function(t,e,r){"use strict";e.errorObject={e:{}}},function(t,e,r){"use strict";var n=r(13),o=n.root.Symbol;e.rxSubscriber="function"==typeof o&&"function"==typeof o.for?o.for("rxSubscriber"):"@@rxSubscriber",e.$$rxSubscriber=e.rxSubscriber},function(t,e,r){t.exports={default:r(118),__esModule:!0}},function(t,e,r){t.exports={default:r(66),__esModule:!0}},function(t,e,r){t.exports={default:r(67),__esModule:!0}},function(t,e,r){"use strict";var n=r(69)(!0);r(39)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,r=this._i;return r>=e.length?{value:void 0,done:!0}:(t=n(e,r),this._i+=t.length,{value:t,done:!1})})},function(t,e,r){"use strict";var n=r(40),o=r(6),i=r(72),s=r(10),u=r(20),c=r(18),a=r(73),l=r(30),f=r(79),d=r(1)("iterator"),h=!([].keys&&"next"in[].keys()),p=function(){return this};t.exports=function(t,e,r,v,b,y,_){a(r,e,v);var O,S,m,g=function(t){if(!h&&t in x)return x[t];switch(t){case"keys":case"values":return function(){return new r(this,t)}}return function(){return new r(this,t)}},A=e+" Iterator",w="values"==b,P=!1,x=t.prototype,I=x[d]||x["@@iterator"]||b&&x[b],C=I||g(b),M=b?w?g("entries"):C:void 0,T="Array"==e?x.entries||I:I;if(T&&(m=f(T.call(new t)))!==Object.prototype&&m.next&&(l(m,A,!0),n||u(m,d)||s(m,d,p)),w&&I&&"values"!==I.name&&(P=!0,C=function(){return I.call(this)}),n&&!_||!h&&!P&&x[d]||s(x,d,C),c[e]=C,c[A]=p,b)if(O={values:w?C:g("values"),keys:y?C:g("keys"),entries:M},_)for(S in O)S in x||i(x,S,O[S]);else o(o.P+o.F*(h||P),e,O);return O}},function(t,e){t.exports=!0},function(t,e,r){var n=r(76),o=r(45);t.exports=Object.keys||function(t){return n(t,o)}},function(t,e,r){var n=r(21);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==n(t)?t.split(""):Object(t)}},function(t,e,r){var n=r(0),o=n["__core-js_shared__"]||(n["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,e){var r=0,n=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+n).toString(36))}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,r){var n=r(0).document;t.exports=n&&n.documentElement},function(t,e,r){var n=r(21),o=r(1)("toStringTag"),i="Arguments"==n(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,r,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(r=s(e=Object(t),o))?r:i?n(e):"Object"==(u=n(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,r){var n=r(7);t.exports=function(t,e,r,o){try{return o?e(n(r)[0],r[1]):e(r)}catch(e){var i=t.return;throw void 0!==i&&n(i.call(t)),e}}},function(t,e,r){var n=r(18),o=r(1)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(n.Array===t||i[o]===t)}},function(t,e,r){var n=r(47),o=r(1)("iterator"),i=r(18);t.exports=r(4).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[n(t)]}},function(t,e,r){var n=r(7),o=r(19),i=r(1)("species");t.exports=function(t,e){var r,s=n(t).constructor;return void 0===s||void 0==(r=n(s)[i])?e:o(r)}},function(t,e,r){var n,o,i,s=r(16),u=r(87),c=r(46),a=r(25),l=r(0),f=l.process,d=l.setImmediate,h=l.clearImmediate,p=l.MessageChannel,v=l.Dispatch,b=0,y={},_=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},O=function(t){_.call(t.data)};d&&h||(d=function(t){for(var e=[],r=1;arguments.length>r;)e.push(arguments[r++]);return y[++b]=function(){u("function"==typeof t?t:Function(t),e)},n(b),b},h=function(t){delete y[t]},"process"==r(21)(f)?n=function(t){f.nextTick(s(_,t,1))}:v&&v.now?n=function(t){v.now(s(_,t,1))}:p?(o=new p,i=o.port2,o.port1.onmessage=O,n=s(i.postMessage,i,1)):l.addEventListener&&"function"==typeof postMessage&&!l.importScripts?(n=function(t){l.postMessage(t+"","*")},l.addEventListener("message",O,!1)):n="onreadystatechange"in a("script")?function(t){c.appendChild(a("script")).onreadystatechange=function(){c.removeChild(this),_.call(t)}}:function(t){setTimeout(s(_,t,1),0)}),t.exports={set:d,clear:h}},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,r){var n=r(7),o=r(17),i=r(32);t.exports=function(t,e){if(n(t),o(e)&&e.constructor===t)return e;var r=i.f(t);return(0,r.resolve)(e),r.promise}},function(t,e,r){var n=r(1)("iterator"),o=!1;try{var i=[7][n]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var r=!1;try{var i=[7],s=i[n]();s.next=function(){return{done:r=!0}},i[n]=function(){return s},t(i)}catch(t){}return r}},function(t,e,r){"use strict";e.__esModule=!0;var n=r(93),o=function(t){return t&&t.__esModule?t:{default:t}}(n);e.default=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),(0,o.default)(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}()},function(t,e,r){"use strict";var n=r(96);e.webSocket=n.WebSocketSubject.create},function(t,e,r){"use strict";function n(t){return"function"==typeof t}e.isFunction=n},function(t,e,r){"use strict";function n(){try{return i.apply(this,arguments)}catch(t){return s.errorObject.e=t,s.errorObject}}function o(t){return i=t,n}var i,s=r(33);e.tryCatch=o},function(t,e,r){"use strict";e.empty={closed:!0,next:function(t){},error:function(t){throw t},complete:function(){}}},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=function(t){function e(){var e=t.call(this,"object unsubscribed");this.name=e.name="ObjectUnsubscribedError",this.stack=e.stack,this.message=e.message}return n(e,t),e}(Error);e.ObjectUnsubscribedError=o},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(14),i=function(t){function e(e,r){t.call(this),this.subject=e,this.subscriber=r,this.closed=!1}return n(e,t),e.prototype.unsubscribe=function(){if(!this.closed){this.closed=!0;var t=this.subject,e=t.observers;if(this.subject=null,e&&0!==e.length&&!t.isStopped&&!t.closed){var r=e.indexOf(this.subscriber);-1!==r&&e.splice(r,1)}}},e}(o.Subscription);e.SubjectSubscription=i},function(e,r){e.exports=t},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.Order=e.Trade=e.Level2=e.Level1=e.APAD=e.APEX=void 0;var n=r(65),o=r(170),i=r(9),s={APEX:n.APEX,APAD:o.APAD};e.default=s,e.APEX=n.APEX,e.APAD=o.APAD,e.Level1=i.Level1,e.Level2=i.Level2,e.Trade=i.Trade,e.Order=i.Order},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.APEX=void 0;var o=r(36),i=n(o),s=r(37),u=n(s),c=r(2),a=n(c),l=r(56),f=n(l),d=r(57),h=r(114),p=r(132),v=r(138),b=r(63),y=function(){function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"ws://demo.alphapoint.com:8086/WSGateway/",n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{onopen:function(){},onclose:function(){}};(0,a.default)(this,t),this.getProducts=v.getProducts,this.getInstruments=v.getInstruments,this.authenticateUser=v.authenticateUser,this.webAuthenticateUser=v.webAuthenticateUser,this.sendOrder=v.sendOrder,this.cancelOrder=v.cancelOrder,this.cancelAllOrders=v.cancelAllOrders,this.getOMSs=v.getOMSs,this.getUserInfo=v.getUserInfo,this.getUserPermissions=v.getUserPermissions,this.getUserAccounts=v.getUserAccounts,this.getAccountInfo=v.getAccountInfo,this.getAccountTransactions=v.getAccountTransactions,this.getRequestTransfers=v.getRequestTransfers,this.getWithdrawTickets=v.getWithdrawTickets,this.getOpenTradeReports=v.getOpenTradeReports,this.getOpenOrders=v.getOpenOrders,this.getOpenQuotes=v.getOpenQuotes,this.getAccountPositions=v.getAccountPositions,this.getOrderHistory=v.getOrderHistory,this.getAccountTrades=v.getAccountTrades,this.getUserAPIKeys=v.getUserAPIKeys,this.getUserConfig=v.getUserConfig,this.getOrderFee=v.getOrderFee,this.subscribeLevel1=v.subscribeLevel1,this.unsubscribeLevel1=v.unsubscribeLevel1,this.subscribeLevel2=v.subscribeLevel2,this.unsubscribeLevel2=v.unsubscribeLevel2,this.subscribeTrades=v.subscribeTrades,this.unsubscribeTrades=v.unsubscribeTrades,this.subscribeAccountEvents=v.subscribeAccountEvents,this.seq=0,this.ws=(0,d.webSocket)({url:r,WebSocketCtor:b,openObserver:{next:function(t){return n.onopen(t)}},closeObserver:{next:function(t){return n.onclose(t)}}}),this.ws.subscribe(function(t){e.callbacks[t.i]&&(e.callbacks[t.i](t),delete e.callbacks[t.i])},function(t){return console.log(t)},function(){return console.log("completes")}),this.standardCallback=function(t){return console.log(t)},this.omsId=1,this.accountId,this.callbacks={},this.isAuthenticated=!1,this.level1=new h.Level1Subject(this),this.level2=new h.Level2Subject(this),this.trades=new h.TradesSubject(this),this.accountEvents=new h.AccountEventsSubject(this),this.orderEvents=new h.OrderEventSubject(this),p.endpoints.forEach(function(t){e[t]=function(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{OMSId:1};return new u.default(function(n,o){e.RPCCall(t,r,function(t){if(5===t.m)o(t);else try{var e=JSON.parse(t.o);n(e)}catch(e){n(t.o?t.o:t)}})})}})}return(0,f.default)(t,[{key:"RPCCall",value:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.standardCallback,n={m:0,i:this.seq,n:t,o:(0,i.default)(e)};this.callbacks[this.seq]=r,this.seq+=2,this.ws.next((0,i.default)(n))}},{key:"RPCPromise",value:function(t,e){var r=this;return new u.default(function(n,o){r.RPCCall(t,e,function(t){5===t.m?o(t):n(t)})})}},{key:"closeConnection",value:function(){this.ws.socket.close()}}]),t}();e.APEX=y},function(t,e,r){var n=r(4),o=n.JSON||(n.JSON={stringify:JSON.stringify});t.exports=function(t){return o.stringify.apply(o,arguments)}},function(t,e,r){r(68),r(38),r(80),r(84),r(91),r(92),t.exports=r(4).Promise},function(t,e){},function(t,e,r){var n=r(22),o=r(23);t.exports=function(t){return function(e,r){var i,s,u=String(o(e)),c=n(r),a=u.length;return c<0||c>=a?t?"":void 0:(i=u.charCodeAt(c),i<55296||i>56319||c+1===a||(s=u.charCodeAt(c+1))<56320||s>57343?t?u.charAt(c):i:t?u.slice(c,c+2):s-56320+(i-55296<<10)+65536)}}},function(t,e,r){t.exports=!r(12)&&!r(24)(function(){return 7!=Object.defineProperty(r(25)("div"),"a",{get:function(){return 7}}).a})},function(t,e,r){var n=r(17);t.exports=function(t,e){if(!n(t))return t;var r,o;if(e&&"function"==typeof(r=t.toString)&&!n(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!n(o=r.call(t)))return o;if(!e&&"function"==typeof(r=t.toString)&&!n(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,r){t.exports=r(10)},function(t,e,r){"use strict";var n=r(74),o=r(26),i=r(30),s={};r(10)(s,r(1)("iterator"),function(){return this}),t.exports=function(t,e,r){t.prototype=n(s,{next:o(1,r)}),i(t,e+" Iterator")}},function(t,e,r){var n=r(7),o=r(75),i=r(45),s=r(29)("IE_PROTO"),u=function(){},c=function(){var t,e=r(25)("iframe"),n=i.length;for(e.style.display="none",r(46).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),c=t.F;n--;)delete c.prototype[i[n]];return c()};t.exports=Object.create||function(t,e){var r;return null!==t?(u.prototype=n(t),r=new u,u.prototype=null,r[s]=t):r=c(),void 0===e?r:o(r,e)}},function(t,e,r){var n=r(11),o=r(7),i=r(41);t.exports=r(12)?Object.defineProperties:function(t,e){o(t);for(var r,s=i(e),u=s.length,c=0;u>c;)n.f(t,r=s[c++],e[r]);return t}},function(t,e,r){var n=r(20),o=r(27),i=r(77)(!1),s=r(29)("IE_PROTO");t.exports=function(t,e){var r,u=o(t),c=0,a=[];for(r in u)r!=s&&n(u,r)&&a.push(r);for(;e.length>c;)n(u,r=e[c++])&&(~i(a,r)||a.push(r));return a}},function(t,e,r){var n=r(27),o=r(28),i=r(78);t.exports=function(t){return function(e,r,s){var u,c=n(e),a=o(c.length),l=i(s,a);if(t&&r!=r){for(;a>l;)if((u=c[l++])!=u)return!0}else for(;a>l;l++)if((t||l in c)&&c[l]===r)return t||l||0;return!t&&-1}}},function(t,e,r){var n=r(22),o=Math.max,i=Math.min;t.exports=function(t,e){return t=n(t),t<0?o(t+e,0):i(t,e)}},function(t,e,r){var n=r(20),o=r(31),i=r(29)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),n(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e,r){r(81);for(var n=r(0),o=r(10),i=r(18),s=r(1)("toStringTag"),u="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),c=0;c<u.length;c++){var a=u[c],l=n[a],f=l&&l.prototype;f&&!f[s]&&o(f,s,a),i[a]=i.Array}},function(t,e,r){"use strict";var n=r(82),o=r(83),i=r(18),s=r(27);t.exports=r(39)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,r=this._i++;return!t||r>=t.length?(this._t=void 0,o(1)):"keys"==e?o(0,r):"values"==e?o(0,t[r]):o(0,[r,t[r]])},"values"),i.Arguments=i.Array,n("keys"),n("values"),n("entries")},function(t,e){t.exports=function(){}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,r){"use strict";var n,o,i,s,u=r(40),c=r(0),a=r(16),l=r(47),f=r(6),d=r(17),h=r(19),p=r(85),v=r(86),b=r(51),y=r(52).set,_=r(88)(),O=r(32),S=r(53),m=r(54),g=c.TypeError,A=c.process,w=c.Promise,P="process"==l(A),x=function(){},I=o=O.f,C=!!function(){try{var t=w.resolve(1),e=(t.constructor={})[r(1)("species")]=function(t){t(x,x)};return(P||"function"==typeof PromiseRejectionEvent)&&t.then(x)instanceof e}catch(t){}}(),M=function(t){var e;return!(!d(t)||"function"!=typeof(e=t.then))&&e},T=function(t,e){if(!t._n){t._n=!0;var r=t._c;_(function(){for(var n=t._v,o=1==t._s,i=0;r.length>i;)!function(e){var r,i,s=o?e.ok:e.fail,u=e.resolve,c=e.reject,a=e.domain;try{s?(o||(2==t._h&&E(t),t._h=1),!0===s?r=n:(a&&a.enter(),r=s(n),a&&a.exit()),r===e.promise?c(g("Promise-chain cycle")):(i=M(r))?i.call(r,u,c):u(r)):c(n)}catch(t){c(t)}}(r[i++]);t._c=[],t._n=!1,e&&!t._h&&G(t)})}},G=function(t){y.call(c,function(){var e,r,n,o=t._v,i=j(t);if(i&&(e=S(function(){P?A.emit("unhandledRejection",o,t):(r=c.onunhandledrejection)?r({promise:t,reason:o}):(n=c.console)&&n.error&&n.error("Unhandled promise rejection",o)}),t._h=P||j(t)?2:1),t._a=void 0,i&&e.e)throw e.v})},j=function(t){if(1==t._h)return!1;for(var e,r=t._a||t._c,n=0;r.length>n;)if(e=r[n++],e.fail||!j(e.promise))return!1;return!0},E=function(t){y.call(c,function(){var e;P?A.emit("rejectionHandled",t):(e=c.onrejectionhandled)&&e({promise:t,reason:t._v})})},R=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),T(e,!0))},k=function(t){var e,r=this;if(!r._d){r._d=!0,r=r._w||r;try{if(r===t)throw g("Promise can't be resolved itself");(e=M(t))?_(function(){var n={_w:r,_d:!1};try{e.call(t,a(k,n,1),a(R,n,1))}catch(t){R.call(n,t)}}):(r._v=t,r._s=1,T(r,!1))}catch(t){R.call({_w:r,_d:!1},t)}}};C||(w=function(t){p(this,w,"Promise","_h"),h(t),n.call(this);try{t(a(k,this,1),a(R,this,1))}catch(t){R.call(this,t)}},n=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},n.prototype=r(89)(w.prototype,{then:function(t,e){var r=I(b(this,w));return r.ok="function"!=typeof t||t,r.fail="function"==typeof e&&e,r.domain=P?A.domain:void 0,this._c.push(r),this._a&&this._a.push(r),this._s&&T(this,!1),r.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new n;this.promise=t,this.resolve=a(k,t,1),this.reject=a(R,t,1)},O.f=I=function(t){return t===w||t===s?new i(t):o(t)}),f(f.G+f.W+f.F*!C,{Promise:w}),r(30)(w,"Promise"),r(90)("Promise"),s=r(4).Promise,f(f.S+f.F*!C,"Promise",{reject:function(t){var e=I(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!C),"Promise",{resolve:function(t){return m(u&&this===s?w:this,t)}}),f(f.S+f.F*!(C&&r(55)(function(t){w.all(t).catch(x)})),"Promise",{all:function(t){var e=this,r=I(e),n=r.resolve,o=r.reject,i=S(function(){var r=[],i=0,s=1;v(t,!1,function(t){var u=i++,c=!1;r.push(void 0),s++,e.resolve(t).then(function(t){c||(c=!0,r[u]=t,--s||n(r))},o)}),--s||n(r)});return i.e&&o(i.v),r.promise},race:function(t){var e=this,r=I(e),n=r.reject,o=S(function(){v(t,!1,function(t){e.resolve(t).then(r.resolve,n)})});return o.e&&n(o.v),r.promise}})},function(t,e){t.exports=function(t,e,r,n){if(!(t instanceof e)||void 0!==n&&n in t)throw TypeError(r+": incorrect invocation!");return t}},function(t,e,r){var n=r(16),o=r(48),i=r(49),s=r(7),u=r(28),c=r(50),a={},l={},e=t.exports=function(t,e,r,f,d){var h,p,v,b,y=d?function(){return t}:c(t),_=n(r,f,e?2:1),O=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(i(y)){for(h=u(t.length);h>O;O++)if((b=e?_(s(p=t[O])[0],p[1]):_(t[O]))===a||b===l)return b}else for(v=y.call(t);!(p=v.next()).done;)if((b=o(v,_,p.value,e))===a||b===l)return b};e.BREAK=a,e.RETURN=l},function(t,e){t.exports=function(t,e,r){var n=void 0===r;switch(e.length){case 0:return n?t():t.call(r);case 1:return n?t(e[0]):t.call(r,e[0]);case 2:return n?t(e[0],e[1]):t.call(r,e[0],e[1]);case 3:return n?t(e[0],e[1],e[2]):t.call(r,e[0],e[1],e[2]);case 4:return n?t(e[0],e[1],e[2],e[3]):t.call(r,e[0],e[1],e[2],e[3])}return t.apply(r,e)}},function(t,e,r){var n=r(0),o=r(52).set,i=n.MutationObserver||n.WebKitMutationObserver,s=n.process,u=n.Promise,c="process"==r(21)(s);t.exports=function(){var t,e,r,a=function(){var n,o;for(c&&(n=s.domain)&&n.exit();t;){o=t.fn,t=t.next;try{o()}catch(n){throw t?r():e=void 0,n}}e=void 0,n&&n.enter()};if(c)r=function(){s.nextTick(a)};else if(i){var l=!0,f=document.createTextNode("");new i(a).observe(f,{characterData:!0}),r=function(){f.data=l=!l}}else if(u&&u.resolve){var d=u.resolve();r=function(){d.then(a)}}else r=function(){o.call(n,a)};return function(n){var o={fn:n,next:void 0};e&&(e.next=o),t||(t=o,r()),e=o}}},function(t,e,r){var n=r(10);t.exports=function(t,e,r){for(var o in e)r&&t[o]?t[o]=e[o]:n(t,o,e[o]);return t}},function(t,e,r){"use strict";var n=r(0),o=r(4),i=r(11),s=r(12),u=r(1)("species");t.exports=function(t){var e="function"==typeof o[t]?o[t]:n[t];s&&e&&!e[u]&&i.f(e,u,{configurable:!0,get:function(){return this}})}},function(t,e,r){"use strict";var n=r(6),o=r(4),i=r(0),s=r(51),u=r(54);n(n.P+n.R,"Promise",{finally:function(t){var e=s(this,o.Promise||i.Promise),r="function"==typeof t;return this.then(r?function(r){return u(e,t()).then(function(){return r})}:t,r?function(r){return u(e,t()).then(function(){throw r})}:t)}})},function(t,e,r){"use strict";var n=r(6),o=r(32),i=r(53);n(n.S,"Promise",{try:function(t){var e=o.f(this),r=i(t);return(r.e?e.reject:e.resolve)(r.v),e.promise}})},function(t,e,r){t.exports={default:r(94),__esModule:!0}},function(t,e,r){r(95);var n=r(4).Object;t.exports=function(t,e,r){return n.defineProperty(t,e,r)}},function(t,e,r){var n=r(6);n(n.S+n.F*!r(12),"Object",{defineProperty:r(11).f})},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(8),i=r(3),s=r(5),u=r(14),c=r(13),a=r(103),l=r(59),f=r(33),d=r(113),h=function(t){function e(e,r){if(e instanceof s.Observable)t.call(this,r,e);else{if(t.call(this),this.WebSocketCtor=c.root.WebSocket,this._output=new o.Subject,"string"==typeof e?this.url=e:d.assign(this,e),!this.WebSocketCtor)throw new Error("no WebSocket constructor can be found");this.destination=new a.ReplaySubject}}return n(e,t),e.prototype.resultSelector=function(t){return JSON.parse(t.data)},e.create=function(t){return new e(t)},e.prototype.lift=function(t){var r=new e(this,this.destination);return r.operator=t,r},e.prototype._resetState=function(){this.socket=null,this.source||(this.destination=new a.ReplaySubject),this._output=new o.Subject},e.prototype.multiplex=function(t,e,r){var n=this;return new s.Observable(function(o){var i=l.tryCatch(t)();i===f.errorObject?o.error(f.errorObject.e):n.next(i);var s=n.subscribe(function(t){var e=l.tryCatch(r)(t);e===f.errorObject?o.error(f.errorObject.e):e&&o.next(t)},function(t){return o.error(t)},function(){return o.complete()});return function(){var t=l.tryCatch(e)();t===f.errorObject?o.error(f.errorObject.e):n.next(t),s.unsubscribe()}})},e.prototype._connectSocket=function(){var t=this,e=this.WebSocketCtor,r=this._output,n=null;try{n=this.protocol?new e(this.url,this.protocol):new e(this.url),this.socket=n,this.binaryType&&(this.socket.binaryType=this.binaryType)}catch(t){return void r.error(t)}var o=new u.Subscription(function(){t.socket=null,n&&1===n.readyState&&n.close()});n.onopen=function(e){var s=t.openObserver;s&&s.next(e);var u=t.destination;t.destination=i.Subscriber.create(function(t){return 1===n.readyState&&n.send(t)},function(e){var o=t.closingObserver;o&&o.next(void 0),e&&e.code?n.close(e.code,e.reason):r.error(new TypeError("WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }")),t._resetState()},function(){var e=t.closingObserver;e&&e.next(void 0),n.close(),t._resetState()}),u&&u instanceof a.ReplaySubject&&o.add(u.subscribe(t.destination))},n.onerror=function(e){t._resetState(),r.error(e)},n.onclose=function(e){t._resetState();var n=t.closeObserver;n&&n.next(e),e.wasClean?r.complete():r.error(e)},n.onmessage=function(e){var n=l.tryCatch(t.resultSelector)(e);n===f.errorObject?r.error(f.errorObject.e):r.next(n)}},e.prototype._subscribe=function(t){var e=this,r=this.source;if(r)return r.subscribe(t);this.socket||this._connectSocket();var n=new u.Subscription;return n.add(this._output.subscribe(t)),n.add(function(){var t=e.socket;0===e._output.observers.length&&(t&&1===t.readyState&&t.close(),e._resetState())}),n},e.prototype.unsubscribe=function(){var e=this,r=e.source,n=e.socket;n&&1===n.readyState&&(n.close(),this._resetState()),t.prototype.unsubscribe.call(this),r||(this.destination=new a.ReplaySubject)},e}(o.AnonymousSubject);e.WebSocketSubject=h},function(t,e){var r;r=function(){return this}();try{r=r||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(r=window)}t.exports=r},function(t,e,r){"use strict";function n(t,e,r){if(t){if(t instanceof o.Subscriber)return t;if(t[i.rxSubscriber])return t[i.rxSubscriber]()}return t||e||r?new o.Subscriber(t,e,r):new o.Subscriber(s.empty)}var o=r(3),i=r(34),s=r(60);e.toSubscriber=n},function(t,e,r){"use strict";e.isArray=Array.isArray||function(t){return t&&"number"==typeof t.length}},function(t,e,r){"use strict";function n(t){return null!=t&&"object"==typeof t}e.isObject=n},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=function(t){function e(e){t.call(this),this.errors=e;var r=Error.call(this,e?e.length+" errors occurred during unsubscription:\n  "+e.map(function(t,e){return e+1+") "+t.toString()}).join("\n  "):"");this.name=r.name="UnsubscriptionError",this.stack=r.stack,this.message=r.message}return n(e,t),e}(Error);e.UnsubscriptionError=o},function(t,e,r){"use strict";function n(t){var e,r=t.Symbol;return"function"==typeof r?r.observable?e=r.observable:(e=r("observable"),r.observable=e):e="@@observable",e}var o=r(13);e.getSymbolObservable=n,e.observable=n(o.root),e.$$observable=e.observable},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(8),i=r(104),s=r(14),u=r(111),c=r(61),a=r(62),l=function(t){function e(e,r,n){void 0===e&&(e=Number.POSITIVE_INFINITY),void 0===r&&(r=Number.POSITIVE_INFINITY),t.call(this),this.scheduler=n,this._events=[],this._bufferSize=e<1?1:e,this._windowTime=r<1?1:r}return n(e,t),e.prototype.next=function(e){var r=this._getNow();this._events.push(new f(r,e)),this._trimBufferThenGetEvents(),t.prototype.next.call(this,e)},e.prototype._subscribe=function(t){var e,r=this._trimBufferThenGetEvents(),n=this.scheduler;if(this.closed)throw new c.ObjectUnsubscribedError;this.hasError?e=s.Subscription.EMPTY:this.isStopped?e=s.Subscription.EMPTY:(this.observers.push(t),e=new a.SubjectSubscription(this,t)),n&&t.add(t=new u.ObserveOnSubscriber(t,n));for(var o=r.length,i=0;i<o&&!t.closed;i++)t.next(r[i].value);return this.hasError?t.error(this.thrownError):this.isStopped&&t.complete(),e},e.prototype._getNow=function(){return(this.scheduler||i.queue).now()},e.prototype._trimBufferThenGetEvents=function(){for(var t=this._getNow(),e=this._bufferSize,r=this._windowTime,n=this._events,o=n.length,i=0;i<o&&!(t-n[i].time<r);)i++;return o>e&&(i=Math.max(i,o-e)),i>0&&n.splice(0,i),n},e}(o.Subject);e.ReplaySubject=l;var f=function(){function t(t,e){this.time=t,this.value=e}return t}()},function(t,e,r){"use strict";var n=r(105),o=r(108);e.queue=new o.QueueScheduler(n.QueueAction)},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(106),i=function(t){function e(e,r){t.call(this,e,r),this.scheduler=e,this.work=r}return n(e,t),e.prototype.schedule=function(e,r){return void 0===r&&(r=0),r>0?t.prototype.schedule.call(this,e,r):(this.delay=r,this.state=e,this.scheduler.flush(this),this)},e.prototype.execute=function(e,r){return r>0||this.closed?t.prototype.execute.call(this,e,r):this._execute(e,r)},e.prototype.requestAsyncId=function(e,r,n){return void 0===n&&(n=0),null!==n&&n>0||null===n&&this.delay>0?t.prototype.requestAsyncId.call(this,e,r,n):e.flush(this)},e}(o.AsyncAction);e.QueueAction=i},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(13),i=r(107),s=function(t){function e(e,r){t.call(this,e,r),this.scheduler=e,this.work=r,this.pending=!1}return n(e,t),e.prototype.schedule=function(t,e){if(void 0===e&&(e=0),this.closed)return this;this.state=t,this.pending=!0;var r=this.id,n=this.scheduler;return null!=r&&(this.id=this.recycleAsyncId(n,r,e)),this.delay=e,this.id=this.id||this.requestAsyncId(n,this.id,e),this},e.prototype.requestAsyncId=function(t,e,r){return void 0===r&&(r=0),o.root.setInterval(t.flush.bind(t,this),r)},e.prototype.recycleAsyncId=function(t,e,r){return void 0===r&&(r=0),null!==r&&this.delay===r&&!1===this.pending?e:o.root.clearInterval(e)&&void 0||void 0},e.prototype.execute=function(t,e){if(this.closed)return new Error("executing a cancelled action");this.pending=!1;var r=this._execute(t,e);if(r)return r;!1===this.pending&&null!=this.id&&(this.id=this.recycleAsyncId(this.scheduler,this.id,null))},e.prototype._execute=function(t,e){var r=!1,n=void 0;try{this.work(t)}catch(t){r=!0,n=!!t&&t||new Error(t)}if(r)return this.unsubscribe(),n},e.prototype._unsubscribe=function(){var t=this.id,e=this.scheduler,r=e.actions,n=r.indexOf(this);this.work=null,this.state=null,this.pending=!1,this.scheduler=null,-1!==n&&r.splice(n,1),null!=t&&(this.id=this.recycleAsyncId(e,t,null)),this.delay=null},e}(i.Action);e.AsyncAction=s},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(14),i=function(t){function e(e,r){t.call(this)}return n(e,t),e.prototype.schedule=function(t,e){return void 0===e&&(e=0),this},e}(o.Subscription);e.Action=i},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(109),i=function(t){function e(){t.apply(this,arguments)}return n(e,t),e}(o.AsyncScheduler);e.QueueScheduler=i},function(t,e,r){"use strict";var n=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},o=r(110),i=function(t){function e(){t.apply(this,arguments),this.actions=[],this.active=!1,this.scheduled=void 0}return n(e,t),e.prototype.flush=function(t){var e=this.actions;if(this.active)return void e.push(t);var r;this.active=!0;do{if(r=t.execute(t.state,t.delay))break}while(t=e.shift());if(this.active=!1,r){for(;t=e.shift();)t.unsubscribe();throw r}},e}(o.Scheduler);e.AsyncScheduler=i},function(t,e,r){"use strict";var n=function(){function t(e,r){void 0===r&&(r=t.now),this.SchedulerAction=e,this.now=r}return t.prototype.schedule=function(t,e,r){return void 0===e&&(e=0),new this.SchedulerAction(this,t).schedule(r,e)},t.now=Date.now?Date.now:function(){return+new Date},t}();e.Scheduler=n},function(t,e,r){"use strict";function n(t,e){return void 0===e&&(e=0),this.lift(new u(t,e))}var o=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},i=r(3),s=r(112);e.observeOn=n;var u=function(){function t(t,e){void 0===e&&(e=0),this.scheduler=t,this.delay=e}return t.prototype.call=function(t,e){return e.subscribe(new c(t,this.scheduler,this.delay))},t}();e.ObserveOnOperator=u;var c=function(t){function e(e,r,n){void 0===n&&(n=0),t.call(this,e),this.scheduler=r,this.delay=n}return o(e,t),e.dispatch=function(t){var e=t.notification,r=t.destination;e.observe(r),this.unsubscribe()},e.prototype.scheduleMessage=function(t){this.add(this.scheduler.schedule(e.dispatch,this.delay,new a(t,this.destination)))},e.prototype._next=function(t){this.scheduleMessage(s.Notification.createNext(t))},e.prototype._error=function(t){this.scheduleMessage(s.Notification.createError(t))},e.prototype._complete=function(){this.scheduleMessage(s.Notification.createComplete())},e}(i.Subscriber);e.ObserveOnSubscriber=c;var a=function(){function t(t,e){this.notification=t,this.destination=e}return t}();e.ObserveOnMessage=a},function(t,e,r){"use strict";var n=r(5),o=function(){function t(t,e,r){this.kind=t,this.value=e,this.error=r,this.hasValue="N"===t}return t.prototype.observe=function(t){switch(this.kind){case"N":return t.next&&t.next(this.value);case"E":return t.error&&t.error(this.error);case"C":return t.complete&&t.complete()}},t.prototype.do=function(t,e,r){switch(this.kind){case"N":return t&&t(this.value);case"E":return e&&e(this.error);case"C":return r&&r()}},t.prototype.accept=function(t,e,r){return t&&"function"==typeof t.next?this.observe(t):this.do(t,e,r)},t.prototype.toObservable=function(){switch(this.kind){case"N":return n.Observable.of(this.value);case"E":return n.Observable.throw(this.error);case"C":return n.Observable.empty()}throw new Error("unexpected notification kind value")},t.createNext=function(e){return void 0!==e?new t("N",e):t.undefinedValueNotification},t.createError=function(e){return new t("E",void 0,e)},t.createComplete=function(){return t.completeNotification},t.completeNotification=new t("C"),t.undefinedValueNotification=new t("N",void 0),t}();e.Notification=o},function(t,e,r){"use strict";function n(t){for(var e=[],r=1;r<arguments.length;r++)e[r-1]=arguments[r];for(var n=e.length,o=0;o<n;o++){var i=e[o];for(var s in i)i.hasOwnProperty(s)&&(t[s]=i[s])}return t}function o(t){return t.Object.assign||n}var i=r(13);e.assignImpl=n,e.getAssign=o,e.assign=o(i.root)},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.OrderEventSubject=e.AccountEventsSubject=e.TradesSubject=e.Level2Subject=e.Level1Subject=void 0;var o=r(115),i=n(o),s=r(126),u=n(s),c=r(127),a=n(c),l=r(128),f=n(l),d=r(129),h=n(d);e.Level1Subject=i.default,e.Level2Subject=u.default,e.TradesSubject=a.default,e.AccountEventsSubject=f.default,e.OrderEventSubject=h.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(2),o=function(t){return t&&t.__esModule?t:{default:t}}(n),i=r(8),s=r(3),u=r(5);r(15);var c=r(9),a=function t(e){var r=this;(0,o.default)(this,t),this.level1InternalIds=[],this.observer=s.Subscriber.create(function(t){r.level1InternalIds.push(t.instrumentId),e.subscribeLevel1(t.instrumentId,t.callback)},function(t){return console.log(t)},function(){return console.log("complete")}),this.observable=u.Observable.create(function(t){return e.ws.filter(function(t){return"Level1UpdateEvent"===t.n}).subscribe(function(e){var r=JSON.parse(e.o);t.next(new c.Level1(r))}),function(t){e.level1.level1InternalIds.forEach(function(t){return e.unsubscribeLevel1(t)})}});var n=i.Subject.create(this.observer,this.observable);return n.level1InternalIds=this.level1InternalIds,n};e.default=a,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){return this.lift(new s(t,e))}var o=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},i=r(3);e.filter=n;var s=function(){function t(t,e){this.predicate=t,this.thisArg=e}return t.prototype.call=function(t,e){return e.subscribe(new u(t,this.predicate,this.thisArg))},t}(),u=function(t){function e(e,r,n){t.call(this,e),this.predicate=r,this.thisArg=n,this.count=0}return o(e,t),e.prototype._next=function(t){var e;try{e=this.predicate.call(this.thisArg,t,this.count++)}catch(t){return void this.destination.error(t)}e&&this.destination.next(t)},e}(i.Subscriber)},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=r(35),i=n(o),s=r(2),u=n(s),c=function t(e){(0,u.default)(this,t),(0,i.default)(this,e)};e.default=c,t.exports=e.default},function(t,e,r){r(119),t.exports=r(4).Object.assign},function(t,e,r){var n=r(6);n(n.S+n.F,"Object",{assign:r(120)})},function(t,e,r){"use strict";var n=r(41),o=r(121),i=r(122),s=r(31),u=r(42),c=Object.assign;t.exports=!c||r(24)(function(){var t={},e={},r=Symbol(),n="abcdefghijklmnopqrst";return t[r]=7,n.split("").forEach(function(t){e[t]=t}),7!=c({},t)[r]||Object.keys(c({},e)).join("")!=n})?function(t,e){for(var r=s(t),c=arguments.length,a=1,l=o.f,f=i.f;c>a;)for(var d,h=u(arguments[a++]),p=l?n(h).concat(l(h)):n(h),v=p.length,b=0;v>b;)f.call(h,d=p[b++])&&(r[d]=h[d]);return r}:c},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(2),o=function(t){return t&&t.__esModule?t:{default:t}}(n),i=function t(e){(0,o.default)(this,t),this.UpdateId=e[0],this.NumberOfAccounts=e[1],this.UpdateDateTime=e[2],this.ActionType=e[3],this.LastTradePrice=e[4],this.NumberOfOrders=e[5],this.Price=e[6],this.ProductPairCode=e[7],this.Quantity=e[8],this.Side=e[9]};e.default=i,t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(2),o=function(t){return t&&t.__esModule?t:{default:t}}(n),i=function t(e){(0,o.default)(this,t),this.TradeId=e[0],this.InstrumentId=e[1],this.Quantity=e[2],this.Price=e[3],this.Order1Id=e[4],this.Order2Id=e[5],this.Timestamp=e[6],this.Direction=e[7],this.TakerSide=e[8]};e.default=i,t.exports=e.default},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=r(35),i=n(o),s=r(2),u=n(s),c=function t(e){(0,u.default)(this,t),(0,i.default)(this,e)};e.default=c,t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(2),o=function(t){return t&&t.__esModule?t:{default:t}}(n),i=r(8),s=r(3),u=r(5);r(15);var c=r(9),a=function t(e){var r=this;(0,o.default)(this,t),this.level2InternalIds=[],this.observer=s.Subscriber.create(function(t){r.level2InternalIds.push(t.instrumentId),e.subscribeLevel2(t.instrumentId,t.depth,t.callback)},function(t){return console.log(t)},function(){return console.log("complete")}),this.observable=u.Observable.create(function(t){return e.ws.filter(function(t){return"Level2UpdateEvent"===t.n}).subscribe(function(e){var r=JSON.parse(e.o),n=Array.isArray(r)?r.map(function(t){return new c.Level2(t)}):[];t.next(n)}),function(t){e.level2.level2InternalIds.forEach(function(t){return e.unsubscribeLevel2(t)})}});var n=i.Subject.create(this.observer,this.observable);return n.level2InternalIds=this.level2InternalIds,n};e.default=a,t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(2),o=function(t){return t&&t.__esModule?t:{default:t}}(n),i=r(8),s=r(3),u=r(5);r(15);var c=r(9),a=function t(e){var r=this;(0,o.default)(this,t),this.tradesInternalId=[],this.observer=s.Subscriber.create(function(t){r.tradesInternalId.push(t.instrumentId),e.subscribeTrades(t.instrumentId,t.history,t.callback)},function(t){return console.log(t)},function(){return console.log("complete")}),this.observable=u.Observable.create(function(t){return e.ws.filter(function(t){return"TradeDataUpdateEvent"===t.n}).subscribe(function(e){JSON.parse(e.o).forEach(function(e){return t.next(new c.Trade(e))})}),function(t){e.trades.tradesInternalId.forEach(function(t){return e.unsubscribeTrades(t)})}});var n=i.Subject.create(this.observer,this.observable);return n.tradesInternalId=this.tradesInternalId,n};e.default=a,t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(2),o=function(t){return t&&t.__esModule?t:{default:t}}(n),i=r(8),s=r(3),u=r(5);r(15);var c=function t(e){return(0,o.default)(this,t),this.observer=s.Subscriber.create(function(t){},function(t){return console.log(t)},function(){return console.log("complete")}),this.observable=u.Observable.create(function(t){e.ws.filter(function(t){return"AccountEvent"===t.n}).subscribe(function(e){t.next(e)})}),i.Subject.create(this.observer,this.observable)};e.default=c,t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(2),o=function(t){return t&&t.__esModule?t:{default:t}}(n),i=r(8),s=r(3),u=r(5);r(15),r(130);var c=r(9),a=function t(e){return(0,o.default)(this,t),this.observer=s.Subscriber.create(function(t){},function(t){return console.log(t)},function(){return console.log("complete")}),this.observable=u.Observable.create(function(t){e.ws.filter(function(t){return"OrderStateEvent"===t.n}).subscribe(function(e){var r=JSON.parse(e.o);t.next(new c.Order(r))})}),i.Subject.create(this.observer,this.observable)};e.default=a,t.exports=e.default},function(t,e,r){"use strict";var n=r(5),o=r(131);n.Observable.prototype.do=o._do,n.Observable.prototype._do=o._do},function(t,e,r){"use strict";function n(t,e,r){return this.lift(new s(t,e,r))}var o=this&&this.__extends||function(t,e){function r(){this.constructor=t}for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)},i=r(3);e._do=n;var s=function(){function t(t,e,r){this.nextOrObserver=t,this.error=e,this.complete=r}return t.prototype.call=function(t,e){return e.subscribe(new u(t,this.nextOrObserver,this.error,this.complete))},t}(),u=function(t){function e(e,r,n,o){t.call(this,e);var s=new i.Subscriber(r,n,o);s.syncErrorThrowable=!0,this.add(s),this.safeSubscriber=s}return o(e,t),e.prototype._next=function(t){var e=this.safeSubscriber;e.next(t),e.syncErrorThrown?this.destination.error(e.syncErrorValue):this.destination.next(t)},e.prototype._error=function(t){var e=this.safeSubscriber;e.error(t),e.syncErrorThrown?this.destination.error(e.syncErrorValue):this.destination.error(t)},e.prototype._complete=function(){var t=this.safeSubscriber;t.complete(),t.syncErrorThrown?this.destination.error(t.syncErrorValue):this.destination.complete()},e}(i.Subscriber)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.endpoints=void 0;var n=r(133),o=function(t){return t&&t.__esModule?t:{default:t}}(n),i=["AccountOperator","AccountReadOnly","Activate2FA","AddAccount","AddAccountHold","AddBalanceReconciliationInfo","AddDepositTicketAttachment","AddEditAccountBadge","AddEditExchange","AddEditExchangeInstrument","AddEditOMS","AddEditOperatorEmail","AddEditXPSubscriptionKey","AddInstrument","AddInstrumentAttributes","AddOperator","AddOperatorConfig","AddOperatorOMS","AddProduct","AddProductAttributes","AddUserAccount","AddUserAffiliateTag","AddUserAPIKey","AddUserAPIKeyPermission","AddUserInstrumentPermissions","AddUserMarketDataPermission","AddUserPermission","AddUserProductPermissions","AddUserReportTicket","AddVerificationLevelConfig","AddWithdrawTicketAttachment","AdminUI","AM_AddEditAccountAssetInfo","AM_AddEditAccountProviderInfo","AM_AddEditAssetInfo","AM_AddEditUser","AM_GetAccountAssetDepositInfo","AM_GetAccountIdByDepositInfo","AM_GetAccountInfo","AM_GetAccountProvidersInfoList","AM_GetAccountProvidersTypeList","AM_GetAccountTransactions","AM_GetAllAccountDepositInfo","AM_GetAllAccounts","AM_GetAllPending","AM_GetAssetInfo","AM_GetAssetInfoList","AM_GetCurrentSequenceNumber","AM_GetDefaultAccountProviderInfo","AM_GetHoldInfo","AM_GetTransactionsReplay","AM_GetWithdrawFormTemplate","AM_GetWithdrawFormTemplateTypes","AM_SubmitWithdrawForm","AM_SubscribeToActions","AM_TransactionSetRequest","Authenticate2FA","AuthenticateUser","CallAccountProviderAdminFunction","CancelAllOrders","CancelFailedWithdrawTicket","CancelOrder","CancelQuote","CancelReplaceOrder","CancelTransferFunds","CancelUserReport","CancelWithdraw","CoinsOAuthAuthenticateUser","Company","ConfirmRequestTransferFunds","ConfirmTransferFunds","ConfirmUserEmail","ConfirmWithdraw","CreateAmlProviderConfig","CreateAssetManagerWalletTicket","CreateDepositTicket","CreateOperatorLoyaltyFeeConfig","CreateQuote","CreateServiceInfo","CreateUser","CreateValidatorConfig","CreateWithdrawTicket","DeleteAmlProviderConfig","DeleteOperatorLoyaltyFeeConfig","DeleteServiceInfo","DeleteValidatorConfig","DeleteVerificationLevelConfig","Deposit","Disable2FA","DownloadDocument","DownloadDocumentSlice","EditInstrumentVerificationLevelConfig","EditOperatorConfig","EditVerificationLevelConfig","EnableGoogle2FA","EnableXP2FA","ForceUserLogoff","General_AddEditAssetManager","General_GetAssetManagers","GenerateTradeActivityReport","GenerateTransactionActivityReport","GenerateTreasuryActivityReport","GetAccountBadges","GetAccountConfig","GetAccountDepositTransactions","GetAccountFees","GetAccountInfo","GetAccountPositions","GetAccountProviderAdminFunctions","GetAccountProviderDetails","GetAccounts","GetAccountTrades","GetAccountTransactions","GetAccountWithdrawTransactions","GetAllAccountPositions","GetAllAssetManagerWalletTickets","GetAllBadges","GetAllBalanceReconciliationInfo","GetAllDepositRequestInfoTemplates","GetAllDepositTickets","GetAllOperatorConfigs","GetAllOperatorLoyaltyFeeConfigs","GetAllUserGroupPermissions","GetAllUserGroups","GetAllUserInstrumentPermissions","GetAllUserProductPermissions","GetAllWithdrawTickets","GetAmlProviderConfig","GetAmlProviderConfigsForOms","GetAssetManagerWalletTicket","GetAvailablePermissionList","GetBadgeAccount","GetBalanceReconciliationInfo","GetBook","GetDepositInfo","GetDepositRequestInfoTemplate","GetDeposits","GetDepositTicket","GetDepositTicketAttachment","GetDepositTickets","GetDistributions","GetEarliestTickTime","GetEmailSenderParams","GetExchanges","GetExchangeServiceIds","GetExchangeStopOrders","GetExchangeWorkingOrders","GetInstrument","GetInstrumentAttributes","GetInstruments","GetInstrumentVerificationLevelConfigs","GetL2Snapshot","GetLevel1","GetLoggedInUserBySessionToken","GetMarketSyncState","GetOMS","GetOMSAccountConfigKeys","GetOMSFees","GetOMSs","GetOMSStatistics","GetOMSUserConfigKeys","GetOMSUsers","GetOMSUsersWithPermission","GetOMSWithdrawFees","GetOpenHolds","GetOpenOrders","GetOpenQuotes","GetOpenTradeReports","GetOpenWithdrawHolds","GetOperator","GetOperator2FAConfig","GetOperator2FAConfigs","GetOperatorById","GetOperatorConfig","GetOperatorEmail","GetOperatorEmails","GetOperatorLoyaltyFeeConfig","GetOperatorLoyaltyFeeConfigs","GetOperatorLoyaltyFeeConfigsForOms","GetOperatorOMSList","GetOperators","GetOperatorUsers","GetOrderFee","GetOrderHistory","GetOrderHistoryByOrderId","GetOrdersHistory","GetOrderStatus","GetProduct","GetProductAttributes","GetProducts","GetRecentAffiliateRegistrations","GetRequestTransfer","GetRequestTransferRequestsReceived","GetRequestTransferRequestsRequested","GetRequestTransfers","GetServerKVPStats","GetServerStats","GetServiceInfo","GetServiceInfos","GetTickerHistory","GetTradesHistory","GetTransfer","GetTransfers","GetTransfersReceived","GetTreasuryProductsForAccount","GetUnderReviewManualKYCUsers","GetUserAccountInfos","GetUserAccounts","GetUserAffiliateCount","GetUserAffiliates","GetUserAffiliateTag","GetUserAPIKeys","GetUserConfig","GetUserGroupPermissions","GetUserInfo","GetUserMarketDataPermissions","GetUserPermissions","GetUserReportTickets","GetUserReportTicketsByStatus","GetUserReportWriterResultRecords","GetValidatorConfig","GetValidatorConfigs","GetVenueInstruments","GetVerificationLevelConfigs","GetWithdrawFee","GetWithdraws","GetWithdrawTemplate","GetWithdrawTemplateTypes","GetWithdrawTicket","GetWithdrawTicketAttachment","GetWithdrawTickets","GetXPSubscriptionKey","Level1MarketData","Level2MarketData","MarketHalt","MarketMaker","MarketPause","MarketReopen","MarketResume","MarketReSync","MigrateUser","ModifyOrder","NoOperation","NoOperationFromGW","Operator","Ping","public","Public","QueryRemoteServices","RegisterUser","RejectRequestTransferFunds","Remarketer","RemoveAccountConfig","RemoveInstrumentAttributes","RemoveOperatorConfig","RemoveOperatorEmail","RemoveOperatorOMS","RemoveOperatorUser","RemoveProductAttributes","RemoveUserAccount","RemoveUserAPIKey","RemoveUserAPIKeyPermission","RemoveUserConfig","RemoveUserInstrumentPermissions","RemoveUserMarketDataPermission","RemoveUserProductPermissions","RemoveUserReportTicket","RemoveXPSubscriptionKey","RequestTransferFunds","ResetAllMarketDatas","ResetHolds","ResetMarketData","ResetPassword","ResetPassword2","ResetTradingLimits","ResetTreasuryLimits","ResubmitFailedWithdrawTicket","ReverseAccountHold","ReverseWithdrawHold","RevokeUserPermission","ScheduleTradeActivityReport","ScheduleTransactionActivityReport","ScheduleTreasuryActivityReport","SendAssetManagerSequenceReset","SendEmail","SendEndOfDay","SendExchangeOrderStateEvent","SendOrder","SetAccountConfig","SetAccountPendingDeposit","SetDefaultOperatorOMS","SetDistribution","SetOMSAccountConfigKey","SetOMSFee","SetOMSUserConfigKey","SetOMSWithdrawFee","SetOperator2FAConfig","SetOperatorEmail","SetUserConfig","SetUserGroupPermission","SetUserInfo","SetUserVerificationLevel","SubmitAccountLedgerEntry","SubmitBlockTrade","SubmitDepositTicketComment","SubmitWithdrawTicketComment","SubscribeAccountEvents","SubscribeLevel1","SubscribeLevel2","SubscribeTicker","SubscribeTrades","SUPERUSER","TakeSnapshot","TakeSnapshotAssetManager","TakeSnapshotMarketData","TakeSnapshotMatchingEngine","TestMatchingEngineSleep","Trading","TransferFunds","UnSubscribeLevel1","UnsubscribeLevel2","UnSubscribeTicker","UnSubscribeTrades","UpdateAccount","UpdateAmlProviderConfig","UpdateAssetManagerWalletTicket","UpdateDepositTicket","UpdateInstrument","UpdateOperator","UpdateOperatorLoyaltyFeeConfig","UpdateProduct","UpdateQuote","UpdateServiceInfo","UpdateUserAffiliateTag","UpdateValidatorConfig","UpdateWithdrawTicket","UserOperator","ValidateUserRegistration","WebAuthenticateUser","Withdraw"],s=["SUPERUSER","AdminUI","UserOperator","Trading","Withdraw","Deposit","AccountOperator","Remarketer"],u=["RegisterNewUser","ResendVerificationEmail"];e.endpoints=[].concat((0,o.default)(i.filter(function(t){return!s.includes(t)})),u)},function(t,e,r){"use strict";e.__esModule=!0;var n=r(134),o=function(t){return t&&t.__esModule?t:{default:t}}(n);e.default=function(t){if(Array.isArray(t)){for(var e=0,r=Array(t.length);e<t.length;e++)r[e]=t[e];return r}return(0,o.default)(t)}},function(t,e,r){t.exports={default:r(135),__esModule:!0}},function(t,e,r){r(38),r(136),t.exports=r(4).Array.from},function(t,e,r){"use strict";var n=r(16),o=r(6),i=r(31),s=r(48),u=r(49),c=r(28),a=r(137),l=r(50);o(o.S+o.F*!r(55)(function(t){Array.from(t)}),"Array",{from:function(t){var e,r,o,f,d=i(t),h="function"==typeof this?this:Array,p=arguments.length,v=p>1?arguments[1]:void 0,b=void 0!==v,y=0,_=l(d);if(b&&(v=n(v,p>2?arguments[2]:void 0,2)),void 0==_||h==Array&&u(_))for(e=c(d.length),r=new h(e);e>y;y++)a(r,y,b?v(d[y],y):d[y]);else for(f=_.call(d),r=new h;!(o=f.next()).done;y++)a(r,y,b?s(f,v,[o.value,y],!0):o.value);return r.length=y,r}})},function(t,e,r){"use strict";var n=r(11),o=r(26);t.exports=function(t,e,r){e in t?n.f(t,e,o(0,r)):t[e]=r}},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=r(139),i=n(o),s=r(140),u=n(s),c=r(141),a=n(c),l=r(142),f=n(l),d=r(143),h=n(d),p=r(144),v=n(p),b=r(145),y=n(b),_=r(146),O=n(_),S=r(147),m=n(S),g=r(148),A=n(g),w=r(149),P=n(w),x=r(150),I=n(x),C=r(151),M=n(C),T=r(152),G=n(T),j=r(153),E=n(j),R=r(154),k=n(R),U=r(155),L=n(U),F=r(156),D=n(F),N=r(157),W=n(N),q=r(158),V=n(q),B=r(159),K=n(B),H=r(160),Q=n(H),J=r(161),X=n(J),Y=r(162),z=n(Y),$=r(163),Z=n($),tt=r(164),et=n(tt),rt=r(165),nt=n(rt),ot=r(166),it=n(ot),st=r(167),ut=n(st),ct=r(168),at=n(ct),lt=r(169),ft=n(lt);e.default={getOMSs:i.default,getProducts:u.default,getInstruments:a.default,authenticateUser:f.default,webAuthenticateUser:h.default,subscribeLevel1:v.default,subscribeLevel2:y.default,getUserInfo:O.default,getUserAccounts:m.default,getAccountInfo:A.default,getAccountTransactions:P.default,getRequestTransfers:I.default,getWithdrawTickets:M.default,getOpenOrders:G.default,getOpenTradeReports:E.default,getOpenQuotes:k.default,getAccountPositions:L.default,getOrderHistory:D.default,getAccountTrades:W.default,unsubscribeLevel1:V.default,unsubscribeLevel2:K.default,subscribeTrades:Q.default,unsubscribeTrades:X.default,subscribeAccountEvents:z.default,sendOrder:Z.default,cancelOrder:et.default,cancelAllOrders:nt.default,getUserPermissions:it.default,getUserAPIKeys:ut.default,getUserConfig:at.default,getOrderFee:ft.default},t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments[1];this.RPCCall("GetOMSs",{OperatorId:t},e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t){this.RPCCall("GetProducts",{OMSId:this.omsId},t)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t){this.RPCCall("GetInstruments",{OMSId:this.omsId},t)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e,r){var n=this,o={UserName:t,Password:e};return this.isAuthenticated?console.log("Already authenticated"):this.RPCCall("AuthenticateUser",o,function(t){var e=JSON.parse(t.o);e.Authenticated&&(n.isAuthenticated=!0,n.accountId=e.User.AccountId),r(e)})}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){var r=this,n=t.SessionToken,o=t.username,i=t.password,s=t.authCode,u={};return n?u.SessionToken=n:(u.UserName=o,u.Password=i),s&&(u.authCode=s),this.RPCCall("WebAuthenticateUser",u,function(t){r.userId=t.UserId,e(t)})}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){var r={OMSId:1,InstrumentId:t};this.RPCCall("SubscribeLevel1",r,e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e,r){var n={OMSId:1,InstrumentId:t,Depth:e};this.RPCCall("SubscribeLevel2",n,function(t){var e=JSON.parse(t.o),n=Array.isArray(e)?e.map(function(t){return new o.Level2(t)}):[];r(n)})}Object.defineProperty(e,"__esModule",{value:!0});var o=r(9);e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.userId,e=arguments[1];this.RPCCall("GetUserInfo",{UserId:t},e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){this.RPCCall("GetUserAccounts",{OMSId:t},e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){var r=t.AccountId,n=t.OMSId;this.RPCCall("GetAccountInfo",{AccountId:r,OMSId:n},e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments[2],n=arguments[3],o=arguments[4];this.RPCCall("GetAccountTransactions",{AccountId:t,OMSId:e,StartIndex:r,Count:n},o)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments[1],r=arguments[2],n=arguments[3],o=arguments[4];this.RPCCall("GetRequestTransfers",{OMSId:t,OperatorId:e,PayerAccountId:r,Status:n},o)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e,r){this.RPCCall("GetWithdrawTickets",{OMSId:t,AccountId:e},r)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.accountId,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments[2];this.RPCCall("GetOpenOrders",{OMSId:e,AccountId:t},r)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments[2];this.RPCCall("GetOpenTradeReports",{AccountId:t,OMSId:e},r)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,n=arguments[3];this.RPCCall("GetOpenQuotes",{AccountId:t,InstrumentId:e,OMSId:r},n)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.accountId,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments[2];this.RPCCall("GetAccountPositions",{OMSId:e,AccountId:t},r)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.accountId,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1e3,n=arguments[3];this.RPCCall("GetOrderHistory",{OMSId:e,AccountId:t,Depth:r},n)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.accountId,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments[2];this.RPCCall("GetAccountTrades",{OMSId:e,AccountId:t},r)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){var r={OMSId:1,InstrumentId:t};this.RPCCall("UnsubscribeLevel1",r)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){var r={OMSId:1,InstrumentId:t};this.RPCCall("UnsubscribeLevel2",r)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e,r){var n={OMSId:1,InstrumentId:t,IncludeLastCount:e};this.RPCCall("SubscribeTrades",n,function(t){var e=JSON.parse(t.o),n=e.map(function(t){return new o.Trade(t)});r(n)})}Object.defineProperty(e,"__esModule",{value:!0});var o=r(9);e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){var r={OMSId:1,InstrumentId:t};this.RPCCall("UnsubscribeTrades",r)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.accountId,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.omsId;arguments[2];this.RPCCall("SubscribeAccountEvents",{OMSId:e,AccountId:t})}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){this.RPCCall("SendOrder",t,e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.accountId,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,n=arguments[3],o={OMSId:r,OrderId:t,AccountId:e};this.RPCCall("CancelOrder",o,n)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.accountId,r=arguments[2],n=arguments[3];this.RPCCall("CancelAllOrders",{OMSId:t,AccountId:e,InstrumentId:r},n)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.userId,e=arguments[1];this.RPCCall("GetUserPermissions",{UserId:t},e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){this.RPCCall("GetUserAPIKeys",{UserId:t},e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t,e){this.RPCCall("GetUserConfig",{UserId:t},e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=arguments[1];this.RPCCall("GetOrderFee",t,e)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,r){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.APAD=void 0;var o=r(37),i=n(o),s=r(36),u=n(s),c=r(35),a=n(c),l=r(2),f=n(l),d=r(56),h=n(d),p=r(57);r(15);var v=r(171),b=r(63),y=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"ws://apad-staging-server1.ezx.io:15001",r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{onopen:function(t){return console.log(t)},onclose:function(t){return console.log(t)},onerror:function(t){return console.log(t)},oncomplete:function(){return console.log("complete")}};(0,f.default)(this,t),this.meshUri=e,this.sessionId=null,this.serverAppKey="@LVSE",this.serviceName="LVSE",this.adminSessionId=null,this.callbacks={},this.RPCRegistrations={},this.onopen=r.onopen,this.onclose=r.onclose,this.onerror=r.onerror,this.oncomplete=r.oncomplete,this.connect()}return(0,h.default)(t,[{key:"connect",value:function(t){var e=this;this.ws&&this.ws.isConnected||(this.ws=(0,p.webSocket)({url:this.meshUri?this.meshUri:t,WebSocketCtor:b,openObserver:{next:function(t){return e.onopen(t)}},closeObserver:{next:function(t){return e.onclose(t)}}}),this.ws.binaryType="arraybuffer",this.ws.filter(function(t){return"RPCReply"===t.MessageType}).subscribe(function(t){e.callbacks[t.RequestUniqueId]&&(e.callbacks[t.RequestUniqueId](t),delete e.callbacks[t.RequestUniqueId])},this.onerror,this.oncomplete))}},{key:"RPCCall",value:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:console.log,n={},o=void 0;o=this.sessionId?(0,a.default)({},e,{sessionId:this.sessionId}):e,n.MessageType="RPCCall",n.DestPubKey=this.serverAppKey,n.ServiceName=this.serviceName,n.FunctionName=t,n.Parameter=(0,u.default)(o),n.RequestUniqueId=v.UUID.generate(),this.callbacks[n.RequestUniqueId]=r,this.ws.next((0,u.default)(n))}},{key:"RPCPromise",value:function(t,e){var r=this;return new i.default(function(n,o){r.RPCCall(t,e,function(t){n(t)})})}},{key:"RegisterRPC",value:function(t,e,r){this.RPCRegistrations[t+"->"+e]=r}},{key:"login",value:function(t,e){var r=this;this.RPCCall("Login",t,function(t){var n=JSON.parse(t.Parameter).payload.SessionId;r.sessionId=n,e?e(t):console.log(t)})}},{key:"version",value:function(t){this.RPCCall("Version",{},t)}},{key:"eightBall",value:function(t,e){this.RPCCall("EightBall",{question:t},e)}},{key:"createAsset",value:function(t,e){this.RPCCall("CreateAsset",t,e)}},{key:"issueAsset",value:function(t,e){this.RPCCall("IssueAsset",t,e)}},{key:"transferAsset",value:function(t,e){this.RPCCall("TransferAsset",t,e)}},{key:"getAssets",value:function(t){this.RPCCall("GetAssets",{},t)}},{key:"updateAccountAddAsset",value:function(t,e){this.RPCCall("UpdateAccountAddAsset",t,e)}},{key:"getSessionStatus",value:function(){}},{key:"createCompany",value:function(t,e,r){this.RPCCall("CreateCompany",{companyName:t,assetNames:e},r)}},{key:"createUser",value:function(t,e){this.RPCCall("CreateUser",t,e)}},{key:"getUsers",value:function(t){this.RPCCall("GetUsers",{},t)}},{key:"getCompanies",value:function(t){this.RPCCall("GetCompanies",{},t)}},{key:"createUserAccount",value:function(){}},{key:"getBlockchainEvents",value:function(t){this.RPCCall("ExploreBlockchain",{},t)}},{key:"sendSMS",value:function(){}},{key:"sendEmail",value:function(){}},{key:"getAccounts",value:function(t){this.RPCCall("GetAccounts",{},t)}},{key:"userGetAccountInfo",value:function(){}},{key:"userGetTransactions",value:function(){}},{key:"userLogin",value:function(){}}]),t}();e.APAD=y},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/
e.UUID=function(){for(var t={},e=[],r=0;r<256;r++)e[r]=(r<16?"0":"")+r.toString(16);return t.generate=function(){var t=4294967295*Math.random()|0,r=4294967295*Math.random()|0,n=4294967295*Math.random()|0,o=4294967295*Math.random()|0;return e[255&t]+e[t>>8&255]+e[t>>16&255]+e[t>>24&255]+"-"+e[255&r]+e[r>>8&255]+"-"+e[r>>16&15|64]+e[r>>24&255]+"-"+e[63&n|128]+e[n>>8&255]+"-"+e[n>>16&255]+e[n>>24&255]+e[255&o]+e[o>>8&255]+e[o>>16&255]+e[o>>24&255]},t}()}])});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(133),
    toKey = __webpack_require__(135);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(117),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(118);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1097),
    listCacheDelete = __webpack_require__(1098),
    listCacheGet = __webpack_require__(1099),
    listCacheHas = __webpack_require__(1100),
    listCacheSet = __webpack_require__(1101);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(235);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1103);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUY_SELL_LAYOUTS; });
var BUY_SELL_LAYOUTS = {
  PRICE_PER_UNIT: 'PRICE_PER_UNIT',
  AMOUNT_FOR_PRICE: 'AMOUNT_FOR_PRICE'
};

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LANGUAGE_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeLanguage; });
/* unused harmony export languageChanged */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_i18n__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_i18n__);


var LANGUAGE_CHANGED = 'LANGUAGE_CHANGED';

var retrieveLanguage = function retrieveLanguage() {
  return function (dispatch, getState) {
    var storedLang = localStorage.getItem('language');
    var browserLang = navigator.language || window.userNavigator.language;
    var translations = getState().i18nState.translations;


    var lang = storedLang ? storedLang : browserLang;

    // Fall back lang i.e. 'en-US' -> 'en'
    if (translations[lang] === undefined && lang.indexOf('-') > -1) {
      var langFallback = lang.split('-')[0];
      if (translations[langFallback]) {
        lang = langFallback;
      } else {
        lang = 'en';
      }
    }

    dispatch(changeLanguage(lang));
  };
};

var changeLanguage = function changeLanguage(lang) {
  return function (dispatch) {
    // Use setTimeout to dispatch language change due to an issue related with component being wrapped in redux connect function
    // https://github.com/APSL/redux-i18n/issues/73
    setTimeout(function () {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_redux_i18n__["setLanguage"])(lang));
    });
    dispatch(languageChanged(lang));
  };
};

var languageChanged = function languageChanged(lang) {
  return {
    type: LANGUAGE_CHANGED,
    payload: { lang: lang }
  };
};

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return REQUEST_OPEN_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REQUEST_CLOSED_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REQUEST_MARGIN_POSITIONS_PAYMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECEIVE_OPEN_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_CLOSED_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_OPEN_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_CLOSED_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_MARGIN_POSITIONS_PAYMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getOpenPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getClosedPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getMarginPositionPayments; });
/* unused harmony export removeMarginHistoryActiveRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return subscribeToMarginPositionStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return subscribeToMarginPositionPayments; });
/* unused harmony export receiveMarginPositionPaymentsEvent */
/* unused harmony export receiveMarginPositionState */
/* unused harmony export addOpenPosition */
/* unused harmony export addClosedPosition */
/* unused harmony export requestOpenPositions */
/* unused harmony export requestClosedPositions */
/* unused harmony export requestMarginPositionPayments */
/* unused harmony export receiveOpenPositions */
/* unused harmony export receiveClosedPositions */
/* unused harmony export receiveMarginPositionsPayments */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return closeMarginPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GetEstimatedAmountForClosePositionBySettlement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_marginPositionStatesSubscriptionService__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_subscriptions_marginPositionPaymentsSubscriptionService__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_marginConstants__ = __webpack_require__(313);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var REQUEST_OPEN_POSITIONS = 'REQUEST_OPEN_POSITIONS';
var REQUEST_CLOSED_POSITIONS = 'REQUEST_CLOSED_POSITIONS';
var REQUEST_MARGIN_POSITIONS_PAYMENTS = 'REQUEST_MARGIN_POSITIONS_PAYMENTS';
var RECEIVE_OPEN_POSITIONS = 'RECEIVE_OPEN_POSITIONS';
var RECEIVE_CLOSED_POSITIONS = 'RECEIVE_CLOSED_POSITIONS';
var ADD_OPEN_POSITION = 'ADD_OPEN_POSITION';
var ADD_CLOSED_POSITION = 'ADD_CLOSED_POSITION';
var RECEIVE_MARGIN_POSITIONS_PAYMENTS = 'RECEIVE_MARGIN_POSITIONS_PAYMENTS';
var REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST = 'REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST';
var RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT = 'RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT';

var getOpenPositions = function getOpenPositions(AccountId, OMSId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var positions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch(requestOpenPositions());
              _context.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetMarginPositionStates', {
                omsId: OMSId,
                accountId: AccountId,
                status: __WEBPACK_IMPORTED_MODULE_6__constants_marginConstants__["b" /* POSITION_STATUSES */].NotClose
              }));

            case 4:
              positions = _context.sent;

              if (positions.length === 0 || positions.length > 0) {
                dispatch(receiveOpenPositions(positions));
              } else {
                dispatch(removeMarginHistoryActiveRequest());
                console.error('GetMarginPositionStates error: ', positions.errormsg);
              }
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              dispatch(removeMarginHistoryActiveRequest());
              console.error('GetMarginPositionStates error: ', _context.t0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getClosedPositions = function getClosedPositions(AccountId, OMSId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      var positions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              dispatch(requestClosedPositions());
              _context2.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetMarginPositionStates', {
                omsId: OMSId,
                accountId: AccountId,
                status: __WEBPACK_IMPORTED_MODULE_6__constants_marginConstants__["b" /* POSITION_STATUSES */].Close
              }));

            case 4:
              positions = _context2.sent;

              if (positions.length === 0 || positions.length > 0) {
                dispatch(receiveClosedPositions(positions));
              } else {
                dispatch(removeMarginHistoryActiveRequest());
                console.error('GetMarginPositionStates error: ', positions.errormsg);
              }
              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);

              dispatch(removeMarginHistoryActiveRequest());
              console.error('GetMarginPositionStates error: ', _context2.t0);

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var getMarginPositionPayments = function getMarginPositionPayments(AccountId, OMSId) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch) {
      var positions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              dispatch(requestMarginPositionPayments());
              _context3.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetMarginPositionPayments', {
                omsId: OMSId,
                accountId: AccountId
              }));

            case 4:
              positions = _context3.sent;

              if (positions.length === 0 || positions.length > 0) {
                dispatch(receiveMarginPositionsPayments(positions));
              } else {
                dispatch(removeMarginHistoryActiveRequest());
                console.error('GetMarginPositionPayments error: ', positions.errormsg);
              }
              _context3.next = 12;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3['catch'](0);

              dispatch(removeMarginHistoryActiveRequest());
              console.error('GetMarginPositionPayments error: ', _context3.t0);

            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var removeMarginHistoryActiveRequest = function removeMarginHistoryActiveRequest() {
  return {
    type: REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST
  };
};

var subscribeToMarginPositionStates = function subscribeToMarginPositionStates(AccountId, OMSId) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_marginPositionStatesSubscriptionService__["a" /* default */].subscribe(function (updates) {
      if (updates.AccountId === AccountId) {
        dispatch(receiveMarginPositionState(updates));
      }
    });
  };
};

var subscribeToMarginPositionPayments = function subscribeToMarginPositionPayments() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_3__services_subscriptions_marginPositionPaymentsSubscriptionService__["a" /* default */].subscribe(function (updates) {
      dispatch(receiveMarginPositionPaymentsEvent(updates));
    });
  };
};

var receiveMarginPositionPaymentsEvent = function receiveMarginPositionPaymentsEvent(updates) {
  return {
    type: RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT,
    payload: updates
  };
};

var receiveMarginPositionState = function receiveMarginPositionState(updates) {
  return function (dispatch) {
    if (updates.Status === 'Open' || updates.Status === 'InClosing') {
      dispatch(addOpenPosition(updates));
    } else if (updates.Status === 'Close') {
      dispatch(addClosedPosition(updates));
    } else {
      // console.error('unsupported marginPosition status'); // InClosingWithSettlementOnly.
    }
  };
};

var addOpenPosition = function addOpenPosition(payload) {
  return {
    type: ADD_OPEN_POSITION,
    payload: payload
  };
};

var addClosedPosition = function addClosedPosition(payload) {
  return {
    type: ADD_CLOSED_POSITION,
    payload: payload
  };
};

var requestOpenPositions = function requestOpenPositions() {
  return {
    type: REQUEST_OPEN_POSITIONS
  };
};

var requestClosedPositions = function requestClosedPositions() {
  return {
    type: REQUEST_CLOSED_POSITIONS
  };
};

var requestMarginPositionPayments = function requestMarginPositionPayments() {
  return {
    type: REQUEST_MARGIN_POSITIONS_PAYMENTS
  };
};

var receiveOpenPositions = function receiveOpenPositions(payload) {
  return {
    type: RECEIVE_OPEN_POSITIONS,
    payload: payload
  };
};

var receiveClosedPositions = function receiveClosedPositions(payload) {
  return {
    type: RECEIVE_CLOSED_POSITIONS,
    payload: payload
  };
};

var receiveMarginPositionsPayments = function receiveMarginPositionsPayments(payload) {
  return {
    type: RECEIVE_MARGIN_POSITIONS_PAYMENTS,
    payload: payload
  };
};

var closeMarginPosition = function closeMarginPosition(_ref4, CloseType) {
  var AccountId = _ref4.AccountId,
      PositionId = _ref4.PositionId,
      InstrumentId = _ref4.InstrumentId,
      OMSId = _ref4.OMSId;
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('CloseMarginPosition', {
                OMSId: OMSId,
                AccountId: AccountId,
                CloseType: CloseType,
                InstrumentId: InstrumentId
              })).then(function (res) {
                if (res.result) {
                  dispatch(getOpenPositions(AccountId, OMSId));
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__snackbarActions__["e" /* showSnack */])({
                    id: 'cancelOpenPositionsSuccessSnack',
                    text: 'Position ' + PositionId + ' closed',
                    type: 'success'
                  }));
                } else {
                  dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__snackbarActions__["e" /* showSnack */])({
                    id: 'cancelOpenPositionsErrorSnack',
                    text: res.errormsg + ': ' + res.detail,
                    type: 'warning'
                  }));
                }
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var GetEstimatedAmountForClosePositionBySettlement = function GetEstimatedAmountForClosePositionBySettlement(OrderId, InstrumentId) {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      var OMSId, _marginAccountSelecto, AccountId;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              _marginAccountSelecto = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_marginSelectors__["e" /* marginAccountSelector */])(getState()), AccountId = _marginAccountSelecto.AccountId;
              _context5.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetEstimatedAmountForClosePositionBySettlement', {
                OMSId: OMSId,
                AccountId: AccountId,
                OrderId: OrderId,
                InstrumentId: InstrumentId
              }));

            case 4:
              return _context5.abrupt('return', _context5.sent);

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_STARTUP_DATA; });
/* unused harmony export STARTUP_DATA_LOADED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadStartupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return startupDataLoaded; });
var LOAD_STARTUP_DATA = 'LOAD_STARTUP_DATA';
var STARTUP_DATA_LOADED = 'STARTUP_DATA_LOADED';

var loadStartupData = function loadStartupData() {
  return {
    type: LOAD_STARTUP_DATA
  };
};

var startupDataLoaded = function startupDataLoaded() {
  return {
    type: STARTUP_DATA_LOADED
  };
};

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEVEL1_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLevel1Data; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return subscribeToLevel1; });
/* unused harmony export unsubscribeAllLevel1 */
/* unused harmony export addLevel1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level1SubscriptionService__ = __webpack_require__(1121);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


var LEVEL1_LOADED = 'LEVEL1_LOADED';

/**
 * 1) Tell server to subscribe to level1 data for passed `instrumentId`
 * 2) Get first portion of data
 */
var getLevel1Data = function getLevel1Data(instrumentId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level1SubscriptionService__["a" /* default */].initSubscribtion(instrumentId).then(function (updates) {
                return dispatch(addLevel1(instrumentId, updates));
              }).catch(function () {});

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var subscribeToLevel1 = function subscribeToLevel1(selectedInstrumentId) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level1SubscriptionService__["a" /* default */].subscribe(function (updates) {
      dispatch(addLevel1(updates.InstrumentId, updates));
    });
  };
};

var unsubscribeAllLevel1 = function unsubscribeAllLevel1() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_level1SubscriptionService__["a" /* default */].stopAll();
  };
};

var addLevel1 = function addLevel1(instrumentId, level1Data) {
  return {
    type: LEVEL1_LOADED,
    payload: {
      instrumentId: instrumentId,
      level1Data: level1Data
    }
  };
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1134),
    isObjectLike = __webpack_require__(76);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(66),
    stubFalse = __webpack_require__(1135);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(244)(module)))

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 245 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROCESSING_RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FINISHED_RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_RESET_PASSWORD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_RESET_PASSWORD_ERROR; });
/* unused harmony export processingResetPassword */
/* unused harmony export finishedResetPassword */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setResetPasswordError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearResetPasswordError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchResetPassword; });
var PROCESSING_RESET_PASSWORD = 'PROCESSING_NEW_PASSWORD';
var FINISHED_RESET_PASSWORD = 'FINISHED_VERIFY_NEW_PASSWORD';
var SET_RESET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR';
var CLEAR_RESET_PASSWORD_ERROR = 'CLEAR_RESET_PASSWORD_ERROR';

var processingResetPassword = {
  type: PROCESSING_RESET_PASSWORD
};

var finishedResetPassword = function finishedResetPassword(payload) {
  return {
    type: FINISHED_RESET_PASSWORD,
    payload: payload
  };
};

var setResetPasswordError = function setResetPasswordError(payload) {
  return {
    type: SET_RESET_PASSWORD_ERROR,
    payload: payload
  };
};

var clearResetPasswordError = function clearResetPasswordError() {
  return {
    type: CLEAR_RESET_PASSWORD_ERROR
  };
};

var fetchResetPassword = function fetchResetPassword(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
        userid = payload.userid,
        d1 = payload.d1,
        password = payload.formValues.password;


    dispatch(processingResetPassword);

    var fetchUrl = atob(d1);
    var fetchPayload = {
      PendingCode: verifycode,
      Password: password,
      UserId: userid
    };

    fetch(fetchUrl + 'ResetPassword2', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (response) {
      response.text().then(function (text) {
        var parsedResponse = JSON.parse(text);
        if (response.ok && parsedResponse.result) {
          return dispatch(finishedResetPassword({
            error: false,
            message:
            // context.t('You successfully reset your password. You can now login with your new password.')
            'You successfully reset your password. You can now login with your new password.'
          }));
        }
        dispatch(finishedResetPassword({
          error: true,
          message:
          // context.t('Your attempt to reset your password has failed. Contact the exchange admin if the problem persists.')
          'Your attempt to reset your password has failed. Contact the exchange admin if the problem persists.'
        }));
      });
    });
  };
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1146),
    baseMatchesProperty = __webpack_require__(1165),
    identity = __webpack_require__(321),
    isArray = __webpack_require__(63),
    property = __webpack_require__(1168);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var assign = __webpack_require__(211);

function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || (type === 'object' && !!obj);
}

function isString(string) {
  return typeof string === 'string';
}

function isFunction(func) {
  return typeof func === 'function';
}

function stringToArray(string) {
  return string.split(/\s+/g).filter(function(c) {return c.length !== 0});
}

function objectToArray(object) {
  return Object.keys(object).reduce(function(array, key) {
    var predicate = object[key];

    if (isFunction(predicate)) {
      predicate = predicate();
    }

    if (predicate) {
      return array.concat(stringToArray(key));
    } else {
      return array;
    }
  }, []);
}

function listToArray(list) {
  if (isString(list) && list !== '') {
    return stringToArray(list);
  } else if (list && list.length) {
    return list.reduce(function (array, string) {
      return !!string ? array.concat(stringToArray(string)) : array;
    }, []);
  } else if (isObject(list)) {
    return objectToArray(list);
  } else {
    return [];
  }
}

function withDefaults(defaults) {
  return function(options) {
    if (isString(options)) {
      options = { name: options };
    }

    var rootDefaults = {
      prefix: '',
      modifierDelimiter: '--',
      outputIsString: false,
    };

    // Copy options on top of defaults
    options = assign(rootDefaults, defaults, options);

    var blockName         = options.prefix + options.name;
    var modifierDelimiter = options.modifierDelimiter;
    var outputIsString    = options.outputIsString;

    return function(first, modifiers, extraClassNames) {
      var element;

      // This means the first parameter is not the element, but a configuration variable
      if (isObject(first)) {
        element = first.element;
        modifiers = first.modifiers || first.modifier;
        extraClassNames = first.extra;
      } else {
        element = first;
      }

      var rootName = element ? blockName + '__' + element : blockName;
      var className = [rootName]
        .concat(listToArray(modifiers).map(function(modifier) {
          return rootName + modifierDelimiter + modifier;
        }))
        .concat(listToArray(extraClassNames))
        .join(' ')
        .trim();

      if (outputIsString) {
        return className;
      } else {
        return { className: className };
      }
    };
  };
}

var BEMHelper = withDefaults({});

BEMHelper.withDefaults = withDefaults;
module.exports = BEMHelper;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createExtensionPattern;

var _constants = __webpack_require__(68);

// The RFC 3966 format for extensions.
var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(_constants.VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
//# sourceMappingURL=createExtensionPattern.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = checkNumberLength;
exports.checkNumberLengthForType = checkNumberLengthForType;

var _mergeArrays = _interopRequireDefault(__webpack_require__(1343));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".


function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = (0, _mergeArrays["default"])(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
      return 'INVALID_LENGTH';
    }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=checkNumberLength.js.map

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseRFC3966 = parseRFC3966;
exports.formatRFC3966 = formatRFC3966;

var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(180));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */
function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var part = _ref;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!(0, _isViablePhoneNumber["default"])(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */


function formatRFC3966(_ref2) {
  var number = _ref2.number,
      ext = _ref2.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _metadata2 = _interopRequireDefault(__webpack_require__(41));

var _isPossibleNumber_ = _interopRequireDefault(__webpack_require__(346));

var _validate_ = _interopRequireDefault(__webpack_require__(255));

var _isValidNumberForRegion_ = _interopRequireDefault(__webpack_require__(597));

var _getNumberType = _interopRequireDefault(__webpack_require__(256));

var _format_ = _interopRequireDefault(__webpack_require__(598));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var PhoneNumber =
/*#__PURE__*/
function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    _classCallCheck(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    var _metadata = new _metadata2["default"](metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    } else {
      /* istanbul ignore if */
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (_metadata.isNonGeographicCallingCode(countryCallingCode)) {
          this.country = '001';
        }
      }
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  _createClass(PhoneNumber, [{
    key: "isPossible",
    value: function isPossible() {
      return (0, _isPossibleNumber_["default"])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return (0, _validate_["default"])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new _metadata2["default"](this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return (0, _getNumberType["default"])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return (0, _format_["default"])(this, _format, options ? _objectSpread({}, options, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

exports["default"] = PhoneNumber;

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};
//# sourceMappingURL=PhoneNumber.js.map

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidNumber;

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _matchesEntirely = _interopRequireDefault(__webpack_require__(146));

var _getNumberType = _interopRequireDefault(__webpack_require__(256));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */
function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new _metadata["default"](metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return (0, _getNumberType["default"])(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return (0, _matchesEntirely["default"])(national_number, metadata.nationalNumberPattern());
}
//# sourceMappingURL=validate_.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNumberType;
exports.isNumberTypeEqualTo = isNumberTypeEqualTo;

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _matchesEntirely = _interopRequireDefault(__webpack_require__(146));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new _metadata["default"](metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!(0, _matchesEntirely["default"])(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // v1 metadata.
    // Legacy.
    // Deprecated.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
    var type = _NON_FIXED_LINE_PHONE[_i];

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}

function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return (0, _matchesEntirely["default"])(nationalNumber, type.pattern());
}
//# sourceMappingURL=getNumberType.js.map

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.limit = limit;
exports.trimAfterFirstMatch = trimAfterFirstMatch;
exports.startsWith = startsWith;
exports.endsWith = endsWith;

/** Returns a regular expression quantifier with an upper and lower limit. */
function limit(lower, upper) {
  if (lower < 0 || upper <= 0 || upper < lower) {
    throw new TypeError();
  }

  return "{".concat(lower, ",").concat(upper, "}");
}
/**
 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
 * returning the trimmed version.
 */


function trimAfterFirstMatch(regexp, string) {
  var index = string.search(regexp);

  if (index >= 0) {
    return string.slice(0, index);
  }

  return string;
}

function startsWith(string, substring) {
  return string.indexOf(substring) === 0;
}

function endsWith(string, substring) {
  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es6_ParseError__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParseError", function() { return __WEBPACK_IMPORTED_MODULE_0__es6_ParseError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_parsePhoneNumber__ = __webpack_require__(259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumberWithError", function() { return __WEBPACK_IMPORTED_MODULE_1__es6_parsePhoneNumber__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_1__es6_parsePhoneNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es6_parsePhoneNumberFromString__ = __webpack_require__(1404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__es6_parsePhoneNumberFromString__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumberFromString", function() { return __WEBPACK_IMPORTED_MODULE_2__es6_parsePhoneNumberFromString__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__es6_findNumbers__ = __webpack_require__(632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findNumbers", function() { return __WEBPACK_IMPORTED_MODULE_3__es6_findNumbers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es6_searchNumbers__ = __webpack_require__(634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "searchNumbers", function() { return __WEBPACK_IMPORTED_MODULE_4__es6_searchNumbers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es6_findPhoneNumbersInText__ = __webpack_require__(635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findPhoneNumbersInText", function() { return __WEBPACK_IMPORTED_MODULE_5__es6_findPhoneNumbersInText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es6_searchPhoneNumbersInText__ = __webpack_require__(1413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "searchPhoneNumbersInText", function() { return __WEBPACK_IMPORTED_MODULE_6__es6_searchPhoneNumbersInText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__es6_PhoneNumberMatcher__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PhoneNumberMatcher", function() { return __WEBPACK_IMPORTED_MODULE_7__es6_PhoneNumberMatcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__es6_AsYouType__ = __webpack_require__(636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AsYouType", function() { return __WEBPACK_IMPORTED_MODULE_8__es6_AsYouType__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__es6_AsYouTypeFormatter__ = __webpack_require__(637);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DIGIT_PLACEHOLDER", function() { return __WEBPACK_IMPORTED_MODULE_9__es6_AsYouTypeFormatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__es6_getCountries__ = __webpack_require__(1417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCountries", function() { return __WEBPACK_IMPORTED_MODULE_10__es6_getCountries__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__es6_metadata__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Metadata", function() { return __WEBPACK_IMPORTED_MODULE_11__es6_metadata__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSupportedCountry", function() { return __WEBPACK_IMPORTED_MODULE_11__es6_metadata__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCountryCallingCode", function() { return __WEBPACK_IMPORTED_MODULE_11__es6_metadata__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getExtPrefix", function() { return __WEBPACK_IMPORTED_MODULE_11__es6_metadata__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__es6_getExampleNumber__ = __webpack_require__(1418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getExampleNumber", function() { return __WEBPACK_IMPORTED_MODULE_12__es6_getExampleNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__es6_formatIncompletePhoneNumber__ = __webpack_require__(1419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatIncompletePhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_13__es6_formatIncompletePhoneNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__es6_parseIncompletePhoneNumber__ = __webpack_require__(624);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseIncompletePhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_14__es6_parseIncompletePhoneNumber__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumberCharacter", function() { return __WEBPACK_IMPORTED_MODULE_14__es6_parseIncompletePhoneNumber__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__es6_helpers_parseDigits__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseDigits", function() { return __WEBPACK_IMPORTED_MODULE_15__es6_helpers_parseDigits__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__es6_helpers_RFC3966__ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseRFC3966", function() { return __WEBPACK_IMPORTED_MODULE_16__es6_helpers_RFC3966__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatRFC3966", function() { return __WEBPACK_IMPORTED_MODULE_16__es6_helpers_RFC3966__["a"]; });

// `parsePhoneNumber()` named export has been renamed to `parsePhoneNumberWithError()`.


// `parsePhoneNumberFromString()` named export is now considered legacy:
// it has been promoted to a default export due to being too verbose.


// Deprecated.

// Deprecated.




















/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeArguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber___ = __webpack_require__(621);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function parsePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber___["a" /* default */])(text, options, metadata);
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
      if (arg_3) {
        options = arg_2;
        metadata = arg_3;
      } else {
        metadata = arg_2;
      }
    } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
} // Otherwise istanbul would show this as "branch not covered".

/* istanbul ignore next */

var isObject = function isObject(_) {
  return _typeof(_) === 'object';
};
//# sourceMappingURL=parsePhoneNumber.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkNumberLength;
/* unused harmony export checkNumberLengthForType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeArrays__ = __webpack_require__(1400);

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = Object(__WEBPACK_IMPORTED_MODULE_0__mergeArrays__["a" /* default */])(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
      return 'INVALID_LENGTH';
    }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=checkNumberLength.js.map

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPossibleNumber___ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validate___ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isValidNumberForRegion___ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_getNumberType__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__format___ = __webpack_require__(1402);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }







var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var PhoneNumber =
/*#__PURE__*/
function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    _classCallCheck(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    var _metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    } else {
      /* istanbul ignore if */
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (_metadata.isNonGeographicCallingCode(countryCallingCode)) {
          this.country = '001';
        }
      }
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  _createClass(PhoneNumber, [{
    key: "isPossible",
    value: function isPossible() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__isPossibleNumber___["a" /* default */])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__validate___["a" /* default */])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_getNumberType__["a" /* default */])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__format___["a" /* default */])(this, _format, options ? _objectSpread({}, options, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();



var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};
//# sourceMappingURL=PhoneNumber.js.map

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = limit;
/* harmony export (immutable) */ __webpack_exports__["d"] = trimAfterFirstMatch;
/* harmony export (immutable) */ __webpack_exports__["c"] = startsWith;
/* harmony export (immutable) */ __webpack_exports__["a"] = endsWith;
/** Returns a regular expression quantifier with an upper and lower limit. */
function limit(lower, upper) {
  if (lower < 0 || upper <= 0 || upper < lower) {
    throw new TypeError();
  }

  return "{".concat(lower, ",").concat(upper, "}");
}
/**
 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
 * returning the trimmed version.
 */

function trimAfterFirstMatch(regexp, string) {
  var index = string.search(regexp);

  if (index >= 0) {
    return string.slice(0, index);
  }

  return string;
}
function startsWith(string, substring) {
  return string.indexOf(substring) === 0;
}
function endsWith(string, substring) {
  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_react__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qrcode_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APQRCode_css__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APQRCode_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__APQRCode_css__);






var APQRCode = function APQRCode(props) {
  var value = props.value,
      customClass = props.customClass,
      size = props.size;

  var baseClass = 'qr-code';
  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_qrcode_react___default.a, { value: value, size: size, className: bemClasses() });
};

APQRCode.defaultProps = {
  size: 280,
  customClass: ''
};

APQRCode.protoTypes = {
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (APQRCode);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var copyToClipboard = function copyToClipboard(text) {
  var textField = document.createElement('textarea');
  textField.innerText = text;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
};

/* harmony default export */ __webpack_exports__["a"] = (copyToClipboard);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APInlineButton_js__ = __webpack_require__(1547);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__APInlineButton_js__["a" /* default */]);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOrderPriceToDisplay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__numberFormatter__ = __webpack_require__(7);


var getOrderPriceToDisplay = function getOrderPriceToDisplay(order, decimalPlaces) {
  return order.trailingPrice ? order.trailingPrice : order.Price ? Object(__WEBPACK_IMPORTED_MODULE_0__numberFormatter__["b" /* formatNumberToLocale */])(order.Price, decimalPlaces || order.Price.symbol) : '';
};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderBookComponent__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_orderHistoryActions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_level2Selectors__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_orderHistorySelectors__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);










var makeMapStateToProps = function makeMapStateToProps() {
  var openOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_orderHistorySelectors__["d" /* openOrdersSelectorFactory */])();

  return function (state) {
    var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    var fetching = state.apexCore.level2.fetching;
    var decimalPlaces = state.apexCore.product.decimalPlaces;

    var filter = { filterMode: 'selectedInstrument' };
    var level2 = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_level2Selectors__["b" /* level2Selector */])(state, filter);
    var openOrders = openOrdersSelector(state, filter);
    var buyOpenOrders = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_orderHistorySelectors__["a" /* buyOpenOrdersSelector */])(state, filter);
    var sellOpenOrders = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_orderHistorySelectors__["e" /* sellOpenOrdersSelector */])(state, filter);
    var spread = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_level2Selectors__["d" /* spreadSelector */])(state, filter);

    var convertedQuantityIncrement = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement);
    var convertedPriceIncrement = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement);

    return {
      level2: level2,
      spread: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(spread, Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)),
      decimalPlaces: decimalPlaces,
      fetching: fetching,
      selectedInstrumentId: selectedInstrumentId,
      openOrders: openOrders,
      buyOpenOrders: buyOpenOrders,
      sellOpenOrders: sellOpenOrders,
      selectedInstrument: selectedInstrument,
      convertedQuantityIncrement: convertedQuantityIncrement,
      convertedPriceIncrement: convertedPriceIncrement
    };
  };
};

var mapDispatchToProps = {
  cancelAllOrders: __WEBPACK_IMPORTED_MODULE_2__redux_actions_orderHistoryActions__["p" /* cancelAllOrders */],
  cancelBuyOrders: __WEBPACK_IMPORTED_MODULE_2__redux_actions_orderHistoryActions__["q" /* cancelBuyOrders */],
  cancelSellOrders: __WEBPACK_IMPORTED_MODULE_2__redux_actions_orderHistoryActions__["s" /* cancelSellOrders */],
  cancelOrders: __WEBPACK_IMPORTED_MODULE_2__redux_actions_orderHistoryActions__["r" /* cancelOrders */],
  buyQuantityClicked: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["b" /* buyQuantityClicked */],
  buyPriceClicked: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["a" /* buyPriceClicked */],
  sellQuantityClicked: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["h" /* sellQuantityClicked */],
  sellPriceClicked: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["g" /* sellPriceClicked */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__OrderBookComponent__["a" /* default */]));

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = (function (_super) {
    __extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error));
exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var Subscription_1 = __webpack_require__(46);
/**
 * @class AsyncSubject<T>
 */
var AsyncSubject = (function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(Subject_1.Subject));
exports.AsyncSubject = AsyncSubject;
//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ArrayObservable_1 = __webpack_require__(105);
var isArray_1 = __webpack_require__(82);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
var none = {};
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0].slice();
    }
    return function (source) { return source.lift.call(new ArrayObservable_1.ArrayObservable([source].concat(observables)), new CombineLatestOperator(project)); };
}
exports.combineLatest = combineLatest;
var CombineLatestOperator = (function () {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}());
exports.CombineLatestOperator = CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CombineLatestSubscriber = (function (_super) {
    __extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) {
                this._tryProject(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function (values) {
        var result;
        try {
            result = this.project.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.CombineLatestSubscriber = CombineLatestSubscriber;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var Notification_1 = __webpack_require__(188);
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
exports.observeOn = observeOn;
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
exports.ObserveOnOperator = ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification_1.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}(Subscriber_1.Subscriber));
exports.ObserveOnSubscriber = ObserveOnSubscriber;
var ObserveOnMessage = (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
exports.ObserveOnMessage = ObserveOnMessage;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(189);
var identity_1 = __webpack_require__(680);
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
}
exports.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var ArrayObservable_1 = __webpack_require__(105);
var isScheduler_1 = __webpack_require__(72);
var mergeAll_1 = __webpack_require__(275);
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler_1.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
    }
    return mergeAll_1.mergeAll(concurrent)(new ArrayObservable_1.ArrayObservable(observables, scheduler));
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
exports.isDate = isDate;
//# sourceMappingURL=isDate.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ArrayObservable_1 = __webpack_require__(105);
var isArray_1 = __webpack_require__(82);
var Subscriber_1 = __webpack_require__(11);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
var iterator_1 = __webpack_require__(186);
/* tslint:enable:max-line-length */
/**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */
function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function zipOperatorFunction(source) {
        return source.lift.call(zipStatic.apply(void 0, [source].concat(observables)));
    };
}
exports.zip = zip;
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */
function zipStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = observables[observables.length - 1];
    if (typeof project === 'function') {
        observables.pop();
    }
    return new ArrayObservable_1.ArrayObservable(observables).lift(new ZipOperator(project));
}
exports.zipStatic = zipStatic;
var ZipOperator = (function () {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}());
exports.ZipOperator = ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ZipSubscriber = (function (_super) {
    __extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) { values = Object.create(null); }
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = (typeof project === 'function') ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (isArray_1.isArray(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[iterator_1.iterator] === 'function') {
            iterators.push(new StaticIterator(value[iterator_1.iterator]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                this.add(iterator.subscribe(iterator, i));
            }
            else {
                this.active--; // not an observable
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) {
            this._tryProject(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(Subscriber_1.Subscriber));
exports.ZipSubscriber = ZipSubscriber;
var StaticIterator = (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}());
var StaticArrayIterator = (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[iterator_1.iterator] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ZipBufferIterator = (function (_super) {
    __extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[iterator_1.iterator] = function () {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function (value, index) {
        return subscribeToResult_1.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=zip.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var queue_1 = __webpack_require__(683);
var Subscription_1 = __webpack_require__(46);
var observeOn_1 = __webpack_require__(274);
var ObjectUnsubscribedError_1 = __webpack_require__(271);
var SubjectSubscription_1 = __webpack_require__(673);
/**
 * @class ReplaySubject<T>
 */
var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function (value) {
        var now = this._getNow();
        this._events.push(new ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function (subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
        }
        var len = _events.length;
        for (var i = 0; i < len && !subscriber.closed; i++) {
            subscriber.next(_events[i].value);
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue_1.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject_1.Subject));
exports.ReplaySubject = ReplaySubject;
var ReplayEvent = (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */
var EmptyError = (function (_super) {
    __extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error));
exports.EmptyError = EmptyError;
//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */
function throttle(durationSelector, config) {
    if (config === void 0) { config = exports.defaultThrottleConfig; }
    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
}
exports.throttle = throttle;
var ThrottleOperator = (function () {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */
var ThrottleSubscriber = (function (_super) {
    __extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        }
        else {
            var duration = this.tryDurationSelector(value);
            if (duration) {
                this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
            }
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        try {
            return this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function () {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function () {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarginClosePositionModal_css__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarginClosePositionModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__MarginClosePositionModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_marginHistoryActions__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_marginConstants__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__redux_actions_snackbarActions__ = __webpack_require__(20);
















var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('confirm-order-modal');

var MarginClosePositionModal = function MarginClosePositionModal(props, context) {
  var isOpen = props.isOpen,
      close = props.close,
      position = props.position,
      previewSettlement = props.previewSettlement,
      closeMarginPosition = props.closeMarginPosition,
      baseAsset = props.baseAsset;


  if (!isOpen || !position) return null;

  /**
   * @TODO
   *  this formatting routine should only be defined in one place, rather than in component.
   */
  var formatInProduct = function formatInProduct(number, product) {
    return Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["b" /* formatNumberToLocale */])(number, product) + ' ' + product;
  };

  var items = [{
    label: context.t('Position:'),
    text: position.PositionDirection
  }, {
    label: context.t('Borrowed:'),
    text: formatInProduct(position.BorrowedAmount, position.BorrowedProductSymbol)
  }, {
    label: context.t('Interest Accrued:'),
    text: formatInProduct(position.InterestAccrued, position.BorrowedProductSymbol)
  }, {
    label: context.t('Interest Paid:'),
    text: formatInProduct(position.InterestPaid, position.BorrowedProductSymbol)
  }, {
    label: context.t('Margin Used:'),
    text: formatInProduct(position.MarginUsed, baseAsset.Product)
  }, {
    label: context.t('Position Value:'),
    text: formatInProduct(position.PositionValue, baseAsset.Product)
  }, {
    label: context.t('Remaining Amount:'),
    text: formatInProduct(position.RemainingAmount, position.BorrowedProductSymbol)
  }, {
    label: context.t('Unrealized P&L:'),
    text: formatInProduct(position.UnrealizedPnL, baseAsset.Product)
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Confirm Close Position'),
      onCancel: close,
      close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses() },
      items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
          key: item.label,
          label: item.label,
          text: item.text,
          customClass: bemClasses()
        });
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('buttons') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__common_APButton__["a" /* default */],
        {
          type: 'button',
          styleName: 'subtractive',
          onClick: function onClick() {
            return closeMarginPosition(__WEBPACK_IMPORTED_MODULE_11__constants_marginConstants__["a" /* CLOSE_TYPES */].CloseByMarket);
          } },
        'Close by Market'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__common_APButton__["a" /* default */],
        {
          type: 'button',
          styleName: 'subtractive',
          onClick: function onClick() {
            return previewSettlement();
          } },
        'Close by Settlement'
      )
    )
  );
};

MarginClosePositionModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

MarginClosePositionModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

MarginClosePositionModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    closeMarginPosition: function closeMarginPosition(CloseType) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_marginHistoryActions__["l" /* closeMarginPosition */])(ownProps.position, CloseType));
    },
    previewSettlement: function previewSettlement() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_marginHistoryActions__["c" /* GetEstimatedAmountForClosePositionBySettlement */])(ownProps.position.OrderId, ownProps.position.InstrumentId)).then(function (EstimatedSettlement) {
        if (EstimatedSettlement.errormsg) {
          return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__redux_actions_snackbarActions__["e" /* showSnack */])({
            id: 'EstimatedSettlementError',
            text: EstimatedSettlement.errormsg + ': ' + EstimatedSettlement.detail,
            type: 'warning'
          }));
        }
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__["b" /* MODAL_TYPES */].PREVIEW_CLOSE_BY_SETTLEMENT, {
          position: ownProps.position,
          data: EstimatedSettlement
        }));
      });
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    baseAsset: Object(__WEBPACK_IMPORTED_MODULE_13__redux_selectors_marginSelectors__["f" /* marginBaseAssetSelector */])(state)
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(MarginClosePositionModal);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_CLOSE_POSITION
})(container));

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginTransferAssetsFormContainer__ = __webpack_require__(1967);







var MarginTransferAssetsModalComponent = function MarginTransferAssetsModalComponent(_ref, context) {
  var close = _ref.close,
      isOpen = _ref.isOpen,
      productId = _ref.productId;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__common_Modal_Modal__["a" /* default */],
    { isOpen: isOpen, title: context.t('Transfer Assets'), close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MarginTransferAssetsFormContainer__["a" /* default */], { defaultProductId: productId })
  );
};

MarginTransferAssetsModalComponent.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

MarginTransferAssetsModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_TRANSFER_ASSETS
})(MarginTransferAssetsModalComponent));

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarginClosePositionModal_css__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarginClosePositionModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__MarginClosePositionModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_marginHistoryActions__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_marginConstants__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_get__);
















var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('confirm-order-modal');

var EstimatedSettlement = function EstimatedSettlement(props, context) {
  var isOpen = props.isOpen,
      close = props.close,
      data = props.data,
      settle = props.settle,
      position = props.position,
      getMarginProduct = props.getMarginProduct;


  if (!isOpen || !position) return null;

  var renderData = function renderData() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      data.EstimatedPaymentAmounts.map(function (amt) {
        var OwedPaymentProduct = getMarginProduct(amt.OwedPaymentProductId);
        var OwedPaymentProductSymbol = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(OwedPaymentProduct, 'AccountPosition.ProductSymbol');

        var PayingWithProduct = getMarginProduct(amt.PayingWithProductId);
        var PayingWithProductSymbol = __WEBPACK_IMPORTED_MODULE_14_lodash_get___default()(PayingWithProduct, 'AccountPosition.ProductSymbol');
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
            key: 'OwedPaymentAmount',
            customClass: bemClasses(),
            label: context.t('Owed Payment Amount:'),
            text: Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["b" /* formatNumberToLocale */])(amt.OwedPaymentAmount, OwedPaymentProductSymbol) + ' ' + OwedPaymentProductSymbol
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            key: 'EstimatedPaymentQuantity',
            label: context.t('Estimated Payment Quantity:'),
            text: Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["b" /* formatNumberToLocale */])(amt.EstimatedPaymentQuantity, PayingWithProductSymbol) + ' ' + PayingWithProductSymbol
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
            key: 'SettlementPrice',
            customClass: bemClasses(),
            label: context.t('Settlement Price:'),
            text: Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["b" /* formatNumberToLocale */])(amt.SettlementPrice, PayingWithProductSymbol) + ' ' + PayingWithProductSymbol
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
            key: 'OwedAmountForInterest',
            label: context.t('Owed Amount For Interest:'),
            text: Boolean(amt.OwedAmountForInterest).toString(),
            customClass: bemClasses()
          })
        );
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
        customClass: bemClasses(),
        label: context.t('Remaining Amount:'),
        text: Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["b" /* formatNumberToLocale */])(data.RemainingAmount, position.BorrowedProductSymbol) + ' ' + [position.BorrowedProductSymbol]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
        customClass: bemClasses(),
        label: context.t('Interest Remaining:'),
        text: Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["b" /* formatNumberToLocale */])(data.InterestRemaining, position.BorrowedProductSymbol) + ' ' + [position.BorrowedProductSymbol]
      })
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Estimated Settlement'),
      onCancel: close,
      close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses() },
      data.result !== false ? renderData() : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: bemClasses('error') },
        data.errormsg + ': ' + data.detail
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('buttons') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__common_APButton__["a" /* default */],
        { styleName: 'subtractive', onClick: settle },
        context.t('Close Position')
      )
    )
  );
};

EstimatedSettlement.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

EstimatedSettlement.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

EstimatedSettlement.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    settle: function settle() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_marginHistoryActions__["l" /* closeMarginPosition */])(ownProps.position, __WEBPACK_IMPORTED_MODULE_11__constants_marginConstants__["a" /* CLOSE_TYPES */].CloseBySettlement)).then(function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_CLOSE_POSITION));
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__["b" /* MODAL_TYPES */].PREVIEW_CLOSE_BY_SETTLEMENT));
      });
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    getMarginProduct: function getMarginProduct(id) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__redux_selectors_marginProductSelectors__["a" /* getMarginProductById */])(id)(state);
    }
  };
}, mapDispatchToProps)(EstimatedSettlement);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_10__redux_actions_modalActions__["b" /* MODAL_TYPES */].PREVIEW_CLOSE_BY_SETTLEMENT
})(container));

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chartEnums; });
var chartEnums = {
  // APEX: 'APEX',
  TradingView: 'Trading View',
  LightWeight: 'Trading View Light Weight'
};

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYCBaseContainer__ = __webpack_require__(2212);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYCBaseContainer__["a" /* default */]);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYCLevelComponent__ = __webpack_require__(2216);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYCLevelComponent__["a" /* default */]);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIMLevel1VerificationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIMLevel2VerificationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIMLevelVerificationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getManualLevel1VerificationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getManualLevel2VerificationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getManualLevel3VerificationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getManualLevel4VerificationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getJumioLevel1VerificationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getJumioLevel2VerificationProps; });
var getIMLevel1VerificationProps = function getIMLevel1VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    currentLevel: verificationLevel === 0 && levelIncreaseStatus !== 'pass' || verificationLevel === 1 && levelIncreaseStatus === 'underReview'
  };
};

var getIMLevel2VerificationProps = function getIMLevel2VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 0 && levelIncreaseStatus === 'underReview',
    verified: verificationLevel > 0 || verificationLevel === 0 && levelIncreaseStatus === 'pass',
    canIncrease: verificationLevel === 0 && levelIncreaseStatus !== 'pass' && levelIncreaseStatus !== 'underReview',
    currentLevel: verificationLevel === 1 && levelIncreaseStatus !== 'pass' || verificationLevel === 0 && levelIncreaseStatus === 'pass'
  };
};

var getIMLevelVerificationProps = function getIMLevelVerificationProps(level, verificationLevel, levelIncreaseStatus) {
  var previousLevel = level - 2; // 0-index.

  return {
    underReview: verificationLevel === previousLevel && levelIncreaseStatus === 'underReview',
    verified: verificationLevel > previousLevel || verificationLevel === previousLevel && levelIncreaseStatus === 'pass',
    canIncrease: verificationLevel === previousLevel - 1 && levelIncreaseStatus === 'pass' || verificationLevel === previousLevel && levelIncreaseStatus !== 'pass' && levelIncreaseStatus !== 'underReview',
    currentLevel: verificationLevel === previousLevel + 1 || verificationLevel === previousLevel && levelIncreaseStatus === 'pass'
  };
};

var getManualLevel1VerificationProps = function getManualLevel1VerificationProps(verificationLevel) {
  return {
    currentLevel: verificationLevel === 0
  };
};

var getManualLevel2VerificationProps = function getManualLevel2VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 0 && levelIncreaseStatus === 1,
    verified: verificationLevel >= 1,
    canIncrease: verificationLevel === 0 && levelIncreaseStatus !== 1,
    currentLevel: verificationLevel === 1
  };
};

var getManualLevel3VerificationProps = function getManualLevel3VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 1 && levelIncreaseStatus === 2,
    verified: verificationLevel >= 2,
    canIncrease: verificationLevel === 1 && levelIncreaseStatus !== 2,
    currentLevel: verificationLevel === 2
  };
};

var getManualLevel4VerificationProps = function getManualLevel4VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 2 && levelIncreaseStatus === 3,
    verified: verificationLevel === 3,
    canIncrease: verificationLevel === 2 && levelIncreaseStatus !== 3,
    currentLevel: verificationLevel === 3
  };
};

var getJumioLevel1VerificationProps = function getJumioLevel1VerificationProps(verificationLevel) {
  return {
    currentLevel: verificationLevel === 0
  };
};

var getJumioLevel2VerificationProps = function getJumioLevel2VerificationProps(verificationLevel, levelIncreaseStatus) {
  return {
    underReview: verificationLevel === 1 && levelIncreaseStatus === 'underReview',
    verified: verificationLevel > 0,
    canIncrease: verificationLevel === 0 && levelIncreaseStatus !== 'underReview',
    currentLevel: verificationLevel === 1
  };
};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerCheckboxInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIcon__ = __webpack_require__(13);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var baseClass = 'ap-checkbox';

var InnerCheckboxInput = function InnerCheckboxInput(props) {
  var input = props.input,
      customClass = props.customClass,
      meta = props.meta,
      inline = props.inline,
      label = props.label,
      info = props.info,
      id = props.id,
      passedProps = _objectWithoutProperties(props, ['input', 'customClass', 'meta', 'inline', 'label', 'info', 'id']);

  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])([baseClass, customClass]);

  delete passedProps.meta;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses('checkbox', inline && 'inline') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', Object.assign({
      className: bemClasses('checkbox'),
      type: 'checkbox'
    }, input, passedProps, {
      id: id
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { htmlFor: id },
      label,
      input && input.value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__APIcon__["a" /* default */], { name: 'checkbox', customClass: bemClasses('icon') })
    ),
    info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'small',
      { className: 'form-text-muted ' + bemClasses('checkbox-info') },
      info
    ),
    meta.dirty && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: '' + bemClasses('checkbox-error') },
      meta.error
    )
  );
};


var APCheckbox = function APCheckbox(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({
    name: props.name,
    component: InnerCheckboxInput
  }, props, {
    type: 'checkbox'
  }));
};

APCheckbox.defaultProps = {
  name: '',
  label: '',
  autoFocus: false,
  required: false,
  readOnly: false,
  inline: false,
  info: ''
};

APCheckbox.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (APCheckbox);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FiatDepositFormContainer__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FiatDepositModalContainer__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiatDepositDetailsComponent__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DepositReferenceIdModalContainer__ = __webpack_require__(1536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__FiatDepositFormContainer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__FiatDepositModalContainer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__FiatDepositDetailsComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__DepositReferenceIdModalContainer__["a"]; });







/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var APSteps = function (_React$Component) {
  _inherits(APSteps, _React$Component);

  function APSteps() {
    _classCallCheck(this, APSteps);

    var _this = _possibleConstructorReturn(this, (APSteps.__proto__ || Object.getPrototypeOf(APSteps)).call(this));

    _this.goToStep = function (currentStep) {
      return _this.setState({ currentStep: currentStep });
    };

    _this.goToNextStep = function () {
      return _this.setState({ currentStep: _this.state.currentStep + 1 });
    };

    _this.goToPreviousStep = function () {
      return _this.setState({ currentStep: _this.state.currentStep - 1 });
    };

    _this.state = {
      currentStep: 0
    };
    return _this;
  }

  _createClass(APSteps, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          childComponents = _props.childComponents,
          otherProps = _objectWithoutProperties(_props, ['childComponents']);

      var currentStep = this.state.currentStep;

      var Component = childComponents[currentStep];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, Object.assign({}, otherProps, {
        goToStep: this.goToStep,
        goToNextStep: this.goToNextStep,
        goToPreviousStep: this.goToPreviousStep,
        currentStep: currentStep
      }));
    }
  }]);

  return APSteps;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

APSteps.defaultProps = {
  childComponents: []
};

APSteps.propTypes = {
  childComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

APSteps.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (APSteps);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(115);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SECTION", function() { return RESET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(939);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(96);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(74);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(948);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(167);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(985);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(217);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(1028);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(63),
    isSymbol = __webpack_require__(231);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1086),
    mapCacheDelete = __webpack_require__(1102),
    mapCacheGet = __webpack_require__(1104),
    mapCacheHas = __webpack_require__(1105),
    mapCacheSet = __webpack_require__(1106);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(118),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertLevel2SideDataToCurrency */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return level2BuySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return level2SellSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return level2Selector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return spreadSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bignumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orderHistorySelectors__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instrumentPositionSelectors__ = __webpack_require__(8);







var convertLevel2SideDataToCurrency = function convertLevel2SideDataToCurrency() {
  return function (data, instrument, orders) {
    if (!instrument) {
      return data;
    }

    var Product1Symbol = instrument.Product1Symbol,
        Product2Symbol = instrument.Product2Symbol;


    var uniqOrders = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_orderHelper__["n" /* mergeOpenOrders */])(orders);
    var userOrders = uniqOrders.map(function (order) {
      var quantity = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["a" /* currency */])(order.DisplayQuantity, Product1Symbol);

      return Object.assign({}, order, {
        Quantity: quantity,
        MySize: order.Quantity
      });
    });

    var level2Orders = data.map(function (order) {
      var price = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["a" /* currency */])(order.Price, Product2Symbol);
      var quantity = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["a" /* currency */])(order.Quantity, Product1Symbol);
      var userOrderIndex = userOrders.findIndex(function (item) {
        return item.Price.isEqualTo(price);
      });

      if (userOrderIndex !== -1) {
        var result = Object.assign({}, userOrders[userOrderIndex], {
          Quantity: quantity,
          MySize: userOrders[userOrderIndex].Quantity
        });

        userOrders.splice(userOrderIndex, 1);
        return result;
      }

      return Object.assign({}, order, {
        Price: price,
        Quantity: quantity
      });
    });

    return level2Orders.sort(function (a, b) {
      return b.Price.minus(a.Price);
    });
  };
};

var level2BuySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.level2.buy;
}, __WEBPACK_IMPORTED_MODULE_5__instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], __WEBPACK_IMPORTED_MODULE_4__orderHistorySelectors__["a" /* buyOpenOrdersSelector */]], convertLevel2SideDataToCurrency());

var level2SellSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.level2.sell;
}, __WEBPACK_IMPORTED_MODULE_5__instrumentPositionSelectors__["d" /* selectedInstrumentSelector */], __WEBPACK_IMPORTED_MODULE_4__orderHistorySelectors__["e" /* sellOpenOrdersSelector */]], convertLevel2SideDataToCurrency());

var level2Selector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([level2BuySelector, level2SellSelector], function (buy, sell) {
  return {
    buy: buy,
    sell: sell
  };
});

var spreadSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([level2BuySelector, level2SellSelector], function (buy, sell) {
  var bestBuy = buy.reduce(function (acc, i) {
    if (i.Price.gt(acc)) return i.Price;
    return acc;
  }, 0);

  var bestSell = sell.reduce(function (acc, i) {
    if (i.Price.lt(acc)) return i.Price;
    return acc;
  }, Infinity);

  if (bestSell !== Infinity) {
    return bestSell.minus(bestBuy);
  }

  if (bestBuy !== 0) {
    return bestBuy.times(-1);
  }

  return new __WEBPACK_IMPORTED_MODULE_1_bignumber_js___default.a(0);
});

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POSITION_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_TYPES; });
var POSITION_STATUSES = {
  NotClose: 1,
  Close: 2
};

var CLOSE_TYPES = {
  NormalClose: 0,
  CloseByMarket: 1,
  CloseBySettlement: 2
};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOYALTY_FEES_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOYALTY_FEES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOYALTY_FEES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOperatorLoyaltyFeeConfigs; });
/* unused harmony export loyaltyFeesRequested */
/* unused harmony export loyaltyFeesSuccess */
/* unused harmony export loyaltyFeesError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


var LOYALTY_FEES_REQUESTED = 'LOYALTY_FEES_REQUESTED';
var LOYALTY_FEES_SUCCESS = 'LOYALTY_FEES_SUCCESS';
var LOYALTY_FEES_ERROR = 'LOYALTY_FEES_ERROR';

var getOperatorLoyaltyFeeConfigs = function getOperatorLoyaltyFeeConfigs(omsId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var OMSId, loyaltyFeeConfigs;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId || omsId;


              dispatch(loyaltyFeesRequested());

              loyaltyFeeConfigs = void 0;
              _context.prev = 3;
              _context.next = 6;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetOperatorLoyaltyFeeConfigsForOms', { OMSId: OMSId }));

            case 6:
              loyaltyFeeConfigs = _context.sent;


              if (loyaltyFeeConfigs.length > 0) {
                dispatch(loyaltyFeesSuccess(loyaltyFeeConfigs));
              } else {
                dispatch(loyaltyFeesError(loyaltyFeeConfigs));
              }
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](3);

              dispatch(loyaltyFeesError(loyaltyFeeConfigs));

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 10]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var loyaltyFeesRequested = function loyaltyFeesRequested() {
  return {
    type: LOYALTY_FEES_REQUESTED
  };
};

var loyaltyFeesSuccess = function loyaltyFeesSuccess(payload) {
  return {
    type: LOYALTY_FEES_SUCCESS,
    payload: payload
  };
};

var loyaltyFeesError = function loyaltyFeesError(payload) {
  return {
    type: LOYALTY_FEES_ERROR,
    payload: payload
  };
};

/***/ }),
/* 315 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1130);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67),
    isSymbol = __webpack_require__(231);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1136),
    baseUnary = __webpack_require__(246),
    nodeUtil = __webpack_require__(319);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(494);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(244)(module)))

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(321),
    overRest = __webpack_require__(519),
    setToString = __webpack_require__(520);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 321 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROCESSING_VERIFY_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINISHED_VERIFY_EMAIL; });
/* unused harmony export processingVerifyEmail */
/* unused harmony export finishedVerifyEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchConfirmEmail; });
var PROCESSING_VERIFY_EMAIL = 'PROCESSING_VERIFY_EMAIL';
var FINISHED_VERIFY_EMAIL = 'FINISHED_VERIFY_EMAIL';

var processingVerifyEmail = {
  type: PROCESSING_VERIFY_EMAIL
};

var finishedVerifyEmail = function finishedVerifyEmail(payload) {
  return {
    type: FINISHED_VERIFY_EMAIL,
    payload: payload
  };
};

var fetchConfirmEmail = function fetchConfirmEmail(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
        userid = payload.userid,
        d1 = payload.d1;

    dispatch(processingVerifyEmail);

    var fetchUrl = atob(d1);
    var fetchPayload = {
      VerifyEmailCode: verifycode,
      UserId: Number(userid)
    };

    fetch(fetchUrl + 'confirmemail', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (response) {
      response.json().then(function (res) {
        if (res.result) {
          return dispatch(finishedVerifyEmail({
            error: false,
            message: 'Your email has been verified successfully. You can now login to the exchange.'
          }));
        }
        return dispatch(finishedVerifyEmail({
          error: true,
          message: res.errormsg
        }));
      }).catch(function (e) {
        console.error(e);
        return dispatch(finishedVerifyEmail({
          error: true,
          message: 'Your email verification has failed. Follow the instructions after clicking the button below. Contact the exchange admin if the problem persists.'
        }));
      });
    });
  };
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROCESSING_CONFIRM_WITHDRAW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINISHED_CONFIRM_WITHDRAW; });
/* unused harmony export processingConfirmWithdraw */
/* unused harmony export finishedConfirmWithdraw */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchConfirmWithdraw; });
var PROCESSING_CONFIRM_WITHDRAW = 'PROCESSING_CONFIRM_WITHDRAW';
var FINISHED_CONFIRM_WITHDRAW = 'FINISHED_CONFIRM_WITHDRAW';

var processingConfirmWithdraw = {
  type: PROCESSING_CONFIRM_WITHDRAW
};

var finishedConfirmWithdraw = function finishedConfirmWithdraw(payload) {
  return {
    type: FINISHED_CONFIRM_WITHDRAW,
    payload: payload
  };
};

var fetchConfirmWithdraw = function fetchConfirmWithdraw(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
        userid = payload.userid,
        d1 = payload.d1;

    dispatch(processingConfirmWithdraw);

    var fetchUrl = atob(d1);
    var fetchPayload = {
      verifycode: verifycode,
      UserId: Number(userid)
    };

    fetch(fetchUrl + 'confirmwithdraw', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (response) {
      if (response.ok) {
        return dispatch(finishedConfirmWithdraw({
          error: false,
          message:
          // context.t('Your withdrawal has been confirmed successfully and has started processing.')
          'Your withdrawal has been confirmed successfully and has started processing.'
        }));
      }
      dispatch(finishedConfirmWithdraw({
        error: true,
        message:
        // context.t('Your withdrawal confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your withdrawal confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    });
  };
};

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SIGNUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIGNUP_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SIGNUP_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SIGNUP_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return signup; });
/* unused harmony export signupRequested */
/* unused harmony export signupSuccess */
/* unused harmony export signupError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearSignupError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_queryParamsHelper__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarActions__ = __webpack_require__(20);


var _this = this;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
var SIGNUP_ERROR = 'SIGNUP_ERROR';
var SIGNUP_REQUESTED = 'SIGNUP_REQUESTED';
var CLEAR_SIGNUP_ERROR = 'CLEAR_SIGNUP_ERROR';

var signup = function signup(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var username, email, password, matchingPassword, additionalFields, AffiliateTag, userConfig, field, apex, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              username = payload.username, email = payload.email, password = payload.password, matchingPassword = payload.matchingPassword, additionalFields = _objectWithoutProperties(payload, ['username', 'email', 'password', 'matchingPassword']);
              AffiliateTag = payload.AffiliateTag;


              dispatch(signupRequested);

              if (window.location.search) {
                AffiliateTag = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_queryParamsHelper__["a" /* getQueryParam */])('aff');
              } else {
                AffiliateTag = window.localStorage.getItem('affiliateTag');
              }

              userConfig = [];


              for (field in additionalFields) {
                userConfig.push({
                  Name: field,
                  Value: additionalFields[field]
                });
              }

              apex = void 0;
              _context.prev = 7;

              apex = Object(__WEBPACK_IMPORTED_MODULE_1__apex__["b" /* getApex */])();
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](7);
              return _context.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'signupError',
                text: _context.t0.message,
                type: 'warning'
              })));

            case 14:
              _context.next = 16;
              return apex.connection.RegisterNewUser({
                UserInfo: {
                  UserName: username || email,
                  passwordHash: password,
                  Email: email
                },
                UserConfig: userConfig,
                AffiliateTag: AffiliateTag,
                OperatorId: 1
              });

            case 16:
              response = _context.sent;

              if (!response.UserId) {
                _context.next = 21;
                break;
              }

              dispatch(signupSuccess(response.UserId));
              _context.next = 22;
              break;

            case 21:
              return _context.abrupt('return', response);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[7, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};


var signupRequested = {
  type: SIGNUP_REQUESTED,
  payload: {
    requesting: true
  }
};

var signupSuccess = function signupSuccess(userId) {
  return {
    type: SIGNUP_SUCCESS,
    payload: {
      userId: userId,
      requesting: false
    }
  };
};

var signupError = function signupError(payload) {
  return {
    type: SIGNUP_ERROR,
    payload: {
      errorMsg: payload.errormsg,
      requesting: false
    }
  };
};

var clearSignupError = function clearSignupError() {
  return {
    type: CLEAR_SIGNUP_ERROR
  };
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(233),
    stackClear = __webpack_require__(1148),
    stackDelete = __webpack_require__(1149),
    stackGet = __webpack_require__(1150),
    stackHas = __webpack_require__(1151),
    stackSet = __webpack_require__(1152);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1153),
    isObjectLike = __webpack_require__(76);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(309),
    setCacheAdd = __webpack_require__(1154),
    setCacheHas = __webpack_require__(1155);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1160),
    stubArray = __webpack_require__(560);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_KYC; });
/* unused harmony export receiveKYC */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return validateUserRegistrationIdentityMind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validateUserRegistrationMitek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return confirmMitek; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kycActions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userActions__ = __webpack_require__(37);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var snackBarWarningSettings = {
  id: 'validateUserRegistrationError',
  timeout: 20000,
  type: 'warning'
};
var snackBarSuccessSettings = {
  id: 'validateUserRegistrationSuccess',
  timeout: 20000,
  type: 'success'
};

var RECEIVE_KYC = 'RECEIVE_KYC';

var receiveKYC = function receiveKYC(payload) {
  return {
    type: RECEIVE_KYC,
    payload: payload
  };
};

var validateUserRegistrationIdentityMind = function validateUserRegistrationIdentityMind(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var validateUserRegistrationPayload, setUserConfigPayload, response, result, showWarningSnack;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(__WEBPACK_IMPORTED_MODULE_4__kycActions__["f" /* processingValidateUserRegistration */]);

              validateUserRegistrationPayload = payload.validateUserRegistrationPayload, setUserConfigPayload = payload.setUserConfigPayload;
              _context.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('ValidateUserRegistration', validateUserRegistrationPayload));

            case 4:
              response = _context.sent;
              result = void 0;


              try {
                result = JSON.parse(response.result);
              } catch (error) {
                result = response.result;
              }

              showWarningSnack = function showWarningSnack(text) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])(Object.assign({}, snackBarWarningSettings, {
                  text: text
                })));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sidePaneActions__["f" /* closeKYCSidePane */])());
              };

              if (result === false || result === null) {
                showWarningSnack("Validator isn't setup for the exchange. Please contact the exchange admin for help.");
              } else if (result === 'Unknown Validator Request' || result === 'Validator Not Connected') {
                showWarningSnack(result);
              } else if (result === 'Unable to validate') {
                showWarningSnack(result + '. Please contact the exchange admin for help.');
              } else if (result === 'Validator Call failed: The remote server returned an error: (500) Internal Server Error.') {
                showWarningSnack('There was a 500 Internal Server Error. Please contact the exchange admin for help.');
              } else if (result === 'Validator Call failed: Unable to connect to the remote server') {
                showWarningSnack('Our server-side verification service is currently unconfigured or down. Please contact the exchange admin for help.');
              } else if (result.ErrorMessage) {
                showWarningSnack('There was an error in processing your information. Be sure you are including all information required.');
              } else if (!result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.ApiError) {
                showWarningSnack(result.ValidationAnswerData.ApiErrorDescription || result.ValidationAnswerData.ApiError);
              } else if (result.ValidationAnswerData) {
                handleSuccess(result, setUserConfigPayload, dispatch);
              }
              return _context.abrupt('return', dispatch(__WEBPACK_IMPORTED_MODULE_4__kycActions__["e" /* finishedValidateUserRegistration */]));

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

function handleSuccess(result, setUserConfigPayload, dispatch) {
  var snackbarText = void 0;
  if (result.ValidationAnswerData.IsAccepted) {
    snackbarText = 'Your information has been accepted and is currently under review. Your verification status will be updated within 24-48 hours.';
  } else if (!result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.NeedsManualReview) {
    snackbarText = 'Your information has been accepted and is currently under review.';
  } else {
    snackbarText = 'Your information has been accepted and is currently under review.';
  }

  dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])(Object.assign({}, snackBarSuccessSettings, {
    text: snackbarText
  })));
  dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sidePaneActions__["f" /* closeKYCSidePane */])());
}

var validateUserRegistrationMitek = function validateUserRegistrationMitek(payload) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      var response, result, rawData, kycPayload;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(__WEBPACK_IMPORTED_MODULE_4__kycActions__["f" /* processingValidateUserRegistration */]);

              _context2.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('ValidateUserRegistration', payload));

            case 3:
              response = _context2.sent;
              result = void 0;
              rawData = void 0;


              try {
                result = JSON.parse(response.result);
                rawData = JSON.parse(result.ValidationAnswerData.RawData);
              } catch (error) {
                result = response.result;
              }

              if (result.ValidationAnswerData) {
                if (result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.RedirectUrl) {
                  kycPayload = {
                    urlParams: result.ValidationAnswerData.RedirectUrl
                  };

                  dispatch(receiveKYC(kycPayload));
                } else {
                  handleError(result, rawData, dispatch);
                }
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])(Object.assign({}, snackBarWarningSettings, {
                  text: 'Something went wrong. Please contact the Exchange Admin'
                })));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sidePaneActions__["f" /* closeKYCSidePane */])());
              }
              dispatch(__WEBPACK_IMPORTED_MODULE_4__kycActions__["e" /* finishedValidateUserRegistration */]);

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var confirmMitek = function confirmMitek(setUserConfigPayload) {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__kycActions__["h" /* temporarilySetLevelIncreaseStatus */])({ levelIncreaseStatus: 'underReview' }));
    // may not need submitUserConfig, but callback to setUserConfig from backend doesn't seem to be configured on apexqa(2)
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__userActions__["r" /* setUserConfig */])(setUserConfigPayload.UserId, setUserConfigPayload.UserName, [{ Key: 'levelIncreaseStatus', Value: 'underReview' }], false));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sidePaneActions__["f" /* closeKYCSidePane */])());
  };
};

function handleError(result, rawData, dispatch) {
  var snackbarText = void 0;
  if (result.ValidationAnswerData.IsAccepted && !result.ValidationAnswerData.RedirectUrl) {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin and alert them of this Error: "No redirect url (params)"';
  } else if (rawData.frd.includes('[Fired] No remaining queries')) {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin and alert them of this Error: "[Fired] No remaining queries..."';
  } else {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin';
  }

  dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])(Object.assign({}, snackBarWarningSettings, {
    text: snackbarText
  })));
  dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__sidePaneActions__["f" /* closeKYCSidePane */])());
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(330),
    isFlattenable = __webpack_require__(1173);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_common_APLogo_APLogo__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StandAloneLayout_css__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StandAloneLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StandAloneLayout_css__);
var layoutClasses=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-layout');var StandAloneLayout=function StandAloneLayout(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('wrapper')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_common_APLogo_APLogo__["a" /* default */],{customClass:layoutClasses('logo'),linkTo:'/'}),props.children);};/* harmony default export */ __webpack_exports__["a"] = (StandAloneLayout);

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(587),
    eq = __webpack_require__(235);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(559),
    getSymbolsIn = __webpack_require__(588),
    keysIn = __webpack_require__(339);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(515);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(513),
    baseKeysIn = __webpack_require__(1196),
    isArrayLike = __webpack_require__(141);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_httpplease__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_httpplease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_httpplease__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1205);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var http = __WEBPACK_IMPORTED_MODULE_2_httpplease___default.a.use(__WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain___default.a);

var Status = {
  PENDING: 'pending',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed',
  UNSUPPORTED: 'unsupported'
};

var getRequestsByUrl = {};
var loadedIcons = {};

var InlineSVG = function (_React$PureComponent) {
  _inherits(InlineSVG, _React$PureComponent);

  function InlineSVG(props) {
    _classCallCheck(this, InlineSVG);

    var _this = _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).call(this, props));

    _this.handleLoad = function (err, res) {
      var isCached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = _this.props,
          onLoad = _this$props.onLoad,
          src = _this$props.src;

      if (err) {
        _this.fail(err);
        return;
      }

      if (_this.isActive) {
        _this.setState({
          loadedText: res.text,
          status: Status.LOADED
        }, function () {
          onLoad(src, isCached);
        });
      }
    };

    _this.state = {
      status: Status.PENDING
    };

    _this.isActive = false;
    return _this;
  }

  _createClass(InlineSVG, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isActive = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var status = this.state.status;
      var _props = this.props,
          src = _props.src,
          supportTest = _props.supportTest;

      /* istanbul ignore else */

      if (status === Status.PENDING) {
        if (supportTest()) {
          if (src) {
            this.startLoad();
            return;
          }

          this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* configurationError */])('Missing source'));
          return;
        }

        this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* unsupportedBrowserError */])());
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var src = this.props.src;


      if (prevProps.src !== src) {
        if (src) {
          this.startLoad();
          return;
        }

        this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* configurationError */])('Missing source'));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isActive = false;
    }
  }, {
    key: 'getFile',
    value: function getFile(callback) {
      var _this2 = this;

      var _props2 = this.props,
          cacheGetRequests = _props2.cacheGetRequests,
          src = _props2.src;


      if (cacheGetRequests) {
        if (loadedIcons[src]) {
          var _loadedIcons$src = _slicedToArray(loadedIcons[src], 2),
              err = _loadedIcons$src[0],
              res = _loadedIcons$src[1];

          callback(err, res, true);
        }

        if (!getRequestsByUrl[src]) {
          getRequestsByUrl[src] = [];

          http.get(src, function (err, res) {
            getRequestsByUrl[src].forEach(function (cb) {
              var currentSrc = _this2.props.src;

              loadedIcons[src] = [err, res];

              if (src === currentSrc) {
                cb(err, res);
              }
            });
          });
        }

        getRequestsByUrl[src].push(callback);
      } else {
        http.get(src, function (err, res) {
          var currentSrc = _this2.props.src;


          if (src === currentSrc) {
            callback(err, res);
          }
        });
      }
    }
  }, {
    key: 'fail',
    value: function fail(error) {
      var onError = this.props.onError;

      var status = error.isUnsupportedBrowserError ? Status.UNSUPPORTED : Status.FAILED;

      /* istanbul ignore else */
      if (this.isActive) {
        this.setState({ status: status }, function () {
          if (typeof onError === 'function') {
            onError(error);
          }
        });
      }
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      /* istanbul ignore else */
      if (this.isActive) {
        this.setState({
          status: Status.LOADING
        }, this.load);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var src = this.props.src;

      var match = src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);

      if (match) {
        return this.handleLoad(null, {
          text: match[1] ? atob(match[2]) : decodeURIComponent(match[2])
        });
      }

      return this.getFile(this.handleLoad);
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var status = this.state.status;
      var className = this.props.className;

      var nextClassName = 'isvg ' + status;

      if (className) {
        nextClassName += ' ' + className;
      }

      return nextClassName;
    }
  }, {
    key: 'processSVG',
    value: function processSVG(text) {
      var _props3 = this.props,
          uniquifyIDs = _props3.uniquifyIDs,
          uniqueHash = _props3.uniqueHash,
          baseURL = _props3.baseURL,
          processSVG = _props3.processSVG;


      var svgText = text;
      if (processSVG) {
        svgText = processSVG(svgText);
      }

      if (uniquifyIDs) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* uniquifySVGIDs */])(svgText, uniqueHash || Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* randomString */])(), baseURL);
      }

      return svgText;
    }
  }, {
    key: 'renderContents',
    value: function renderContents() {
      var status = this.state.status;
      var _props4 = this.props,
          children = _props4.children,
          preloader = _props4.preloader;


      switch (status) {
        case Status.UNSUPPORTED:
        case Status.FAILED:
          return children;
        default:
          return preloader;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var loadedText = this.state.loadedText;
      var _props5 = this.props,
          style = _props5.style,
          wrapper = _props5.wrapper;

      var content = void 0;
      var html = void 0;

      if (loadedText) {
        html = {
          __html: this.processSVG(loadedText)
        };
      } else {
        content = this.renderContents();
      }

      return wrapper({
        style: style,
        className: this.getClassName(),
        dangerouslySetInnerHTML: html
      }, content);
    }
  }]);

  return InlineSVG;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InlineSVG.propTypes = {
  baseURL: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cacheGetRequests: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preloader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  processSVG: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  supportTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  uniqueHash: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  uniquifyIDs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  wrapper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
InlineSVG.defaultProps = {
  baseURL: '',
  cacheGetRequests: false,
  onLoad: function onLoad() {},
  supportTest: __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* isSupportedEnvironment */],
  uniquifyIDs: true,
  wrapper: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createFactory('span')
};
/* harmony default export */ __webpack_exports__["a"] = (InlineSVG);

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = extend

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDataTestAttribute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringHelper__ = __webpack_require__(1275);


var getDataTestAttribute = function getDataTestAttribute(props, fieldName) {
  return props.dataTest || (Object(__WEBPACK_IMPORTED_MODULE_0__stringHelper__["a" /* isString */])(props[fieldName]) ? props[fieldName] : '');
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://stackoverflow.com/a/46971044/970769
var ParseError = function ParseError(code) {
  _classCallCheck(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};

exports["default"] = ParseError;
ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;
//# sourceMappingURL=ParseError.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseIncompletePhoneNumber;
exports.parsePhoneNumberCharacter = parsePhoneNumberCharacter;

var _parseDigits = __webpack_require__(124);

/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */
function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */


function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }

    return '+';
  } // Allow digits.


  return (0, _parseDigits.parseDigit)(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _metadata.getCountryCallingCode;
  }
});

var _metadata = __webpack_require__(41);
//# sourceMappingURL=getCountryCallingCode.js.map

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPossiblePhoneNumber;
exports.isPossibleNumber = isPossibleNumber;

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _checkNumberLength = _interopRequireDefault(__webpack_require__(252));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new _metadata["default"](metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }

  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}

function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch ((0, _checkNumberLength["default"])(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
//# sourceMappingURL=isPossibleNumber_.js.map

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatNationalNumberUsingFormat;
exports.FIRST_GROUP_PATTERN = void 0;

var _applyInternationalSeparatorStyle = _interopRequireDefault(__webpack_require__(599));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.
var FIRST_GROUP_PATTERN = /(\$\d)/;
exports.FIRST_GROUP_PATTERN = FIRST_GROUP_PATTERN;

function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return (0, _applyInternationalSeparatorStyle["default"])(formattedNumber);
  }

  return formattedNumber;
}
//# sourceMappingURL=formatNationalNumberUsingFormat.js.map

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stripIddPrefix;

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _constants = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + _constants.VALID_DIGITS + '])');

function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new _metadata["default"](metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
//# sourceMappingURL=stripIddPrefix.js.map

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign;

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _matchesEntirely = _interopRequireDefault(__webpack_require__(146));

var _extractNationalNumber = _interopRequireDefault(__webpack_require__(601));

var _checkNumberLength = _interopRequireDefault(__webpack_require__(252));

var _getCountryCallingCode = _interopRequireDefault(__webpack_require__(345));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? (0, _getCountryCallingCode["default"])(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new _metadata["default"](metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = (0, _extractNationalNumber["default"])(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = (0, _extractNationalNumber["default"])(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!(0, _matchesEntirely["default"])(nationalNumber, metadata.nationalNumberPattern()) && (0, _matchesEntirely["default"])(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, _checkNumberLength["default"])(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNumberType;
exports.normalizeArguments = normalizeArguments;

var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(180));

var _getNumberType2 = _interopRequireDefault(__webpack_require__(256));

var _parse_ = _interopRequireDefault(__webpack_require__(123));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Finds out national phone number type (fixed line, mobile, etc)
function getNumberType() {
  var _normalizeArguments = normalizeArguments(arguments),
      input = _normalizeArguments.input,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _getNumberType2["default"])(input, options, metadata);
} // Sort out arguments


function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var input;
  var options = {};
  var metadata; // If the phone number is passed as a string.
  // `getNumberType('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    // If "default country" argument is being passed
    // then convert it to an `options` object.
    // `getNumberType('88005553535', 'RU', metadata)`.
    if (_typeof(arg_2) !== 'object') {
      if (arg_4) {
        options = arg_3;
        metadata = arg_4;
      } else {
        metadata = arg_3;
      } // `parse` extracts phone numbers from raw text,
      // therefore it will cut off all "garbage" characters,
      // while this `validate` function needs to verify
      // that the phone number contains no "garbage"
      // therefore the explicit `isViablePhoneNumber` check.


      if ((0, _isViablePhoneNumber["default"])(arg_1)) {
        input = (0, _parse_["default"])(arg_1, {
          defaultCountry: arg_2
        }, metadata);
      } else {
        input = {};
      }
    } // No "resrict country" argument is being passed.
    // International phone number is passed.
    // `getNumberType('+78005553535', metadata)`.
    else {
        if (arg_3) {
          options = arg_2;
          metadata = arg_3;
        } else {
          metadata = arg_2;
        } // `parse` extracts phone numbers from raw text,
        // therefore it will cut off all "garbage" characters,
        // while this `validate` function needs to verify
        // that the phone number contains no "garbage"
        // therefore the explicit `isViablePhoneNumber` check.


        if ((0, _isViablePhoneNumber["default"])(arg_1)) {
          input = (0, _parse_["default"])(arg_1, undefined, metadata);
        } else {
          input = {};
        }
      }
  } // If the phone number is passed as a parsed phone number.
  // `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
  else if (is_object(arg_1)) {
      input = arg_1;

      if (arg_3) {
        options = arg_2;
        metadata = arg_3;
      } else {
        metadata = arg_2;
      }
    } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');

  return {
    input: input,
    options: options,
    metadata: metadata
  };
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var is_object = function is_object(_) {
  return _typeof(_) === 'object';
};
//# sourceMappingURL=getNumberType.js.map

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PhoneNumber = _interopRequireDefault(__webpack_require__(254));

var _constants = __webpack_require__(68);

var _createExtensionPattern = _interopRequireDefault(__webpack_require__(251));

var _RegExpCache = _interopRequireDefault(__webpack_require__(1351));

var _util = __webpack_require__(257);

var _utf = __webpack_require__(607);

var _Leniency = _interopRequireDefault(__webpack_require__(1353));

var _parsePreCandidate = _interopRequireDefault(__webpack_require__(608));

var _isValidPreCandidate = _interopRequireDefault(__webpack_require__(609));

var _isValidCandidate = _interopRequireWildcard(__webpack_require__(610));

var _metadata = __webpack_require__(41);

var _parse_ = _interopRequireDefault(__webpack_require__(123));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EXTN_PATTERNS_FOR_MATCHING = (0, _createExtensionPattern["default"])('matching');
/**
 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
 * ordered according to specificity. For example, white-space is last since that is frequently
 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
 * want to break up the phone-number-like text on more than one different kind of symbol at one
 * time, although symbols of the same type (e.g. space) can be safely grouped together.
 *
 * Note that if there is a match, we will always check any text found up to the first match as
 * well.
 */

var INNER_MATCHES = [// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
'\\/+(.*)/', // Note that the bracket here is inside the capturing group, since we consider it part of the
// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
// We require a space on either side of the hyphen for it to be considered a separator.
"(?:".concat(_utf.pZ, "-|-").concat(_utf.pZ, ")").concat(_utf.pZ, "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
// possible that it's supposed to be used to break two numbers without spaces, and we haven't
// seen many instances of it used within a number.
"[\u2012-\u2015\uFF0D]".concat(_utf.pZ, "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
"\\.+".concat(_utf.pZ, "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
"".concat(_utf.pZ, "+(").concat(_utf.PZ, "+)")]; // Limit on the number of leading (plus) characters.

var leadLimit = (0, _util.limit)(0, 2); // Limit on the number of consecutive punctuation characters.

var punctuationLimit = (0, _util.limit)(0, 4);
/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
 * single block, set high enough to accommodate the entire national number and the international
 * country code. */

var digitBlockLimit = _constants.MAX_LENGTH_FOR_NSN + _constants.MAX_LENGTH_COUNTRY_CODE; // Limit on the number of blocks separated by punctuation.
// Uses digitBlockLimit since some formats use spaces to separate each digit.

var blockLimit = (0, _util.limit)(0, digitBlockLimit);
/* A punctuation sequence allowing white space. */

var punctuation = "[".concat(_constants.VALID_PUNCTUATION, "]") + punctuationLimit; // A digits block without punctuation.

var digitSequence = _utf.pNd + (0, _util.limit)(1, digitBlockLimit);
/**
 * Phone number pattern allowing optional punctuation.
 * The phone number pattern used by `find()`, similar to
 * VALID_PHONE_NUMBER, but with the following differences:
 * <ul>
 *   <li>All captures are limited in order to place an upper bound to the text matched by the
 *       pattern.
 * <ul>
 *   <li>Leading punctuation / plus signs are limited.
 *   <li>Consecutive occurrences of punctuation are limited.
 *   <li>Number of digits is limited.
 * </ul>
 *   <li>No whitespace is allowed at the start or end.
 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
 * </ul>
 */

var PATTERN = '(?:' + _isValidCandidate.LEAD_CLASS + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + EXTN_PATTERNS_FOR_MATCHING + ')?'; // Regular expression of trailing characters that we want to remove.
// We remove all characters that are not alpha or numerical characters.
// The hash character is retained here, as it may signify
// the previous block was an extension.
//
// // Don't know what does '&&' mean here.
// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
//

var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(_utf._pN).concat(_utf._pL, "#]+$"));
var NON_DIGITS_PATTERN = /(\D+)/;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
 * {@link PhoneNumberUtil}.
 *
 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
 * not found.
 *
 * <p>This class is not thread-safe.
 */

var PhoneNumberMatcher =
/*#__PURE__*/
function () {
  /** The iteration tristate. */

  /** The next index to start searching at. Undefined in {@link State#DONE}. */
  // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
  // countries being used for the same doc with ~10 patterns for each country. Some pages will have
  // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
  // that use-case won't have a lot of benefit.

  /**
   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
   * new instance.
   *
   * @param util  the phone number util to use
   * @param text  the character sequence that we will search, null for no text
   * @param country  the country to assume for phone numbers not written in international format
   *     (with a leading plus, or with the international dialing prefix of the specified region).
   *     May be null or "ZZ" if only numbers with a leading plus should be
   *     considered.
   * @param leniency  the leniency to use when evaluating candidate phone numbers
   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
   *     be {@code >= 0}.
   */
  function PhoneNumberMatcher() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metadata = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, PhoneNumberMatcher);

    _defineProperty(this, "state", 'NOT_READY');

    _defineProperty(this, "searchIndex", 0);

    _defineProperty(this, "regExpCache", new _RegExpCache["default"](32));

    options = _objectSpread({}, options, {
      defaultCallingCode: options.defaultCallingCode,
      defaultCountry: options.defaultCountry && (0, _metadata.isSupportedCountry)(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
      maxTries: options.maxTries || MAX_SAFE_INTEGER
    });

    if (!options.leniency) {
      throw new TypeError('`Leniency` not supplied');
    }

    if (options.maxTries < 0) {
      throw new TypeError('`maxTries` not supplied');
    }

    this.text = text;
    this.options = options;
    this.metadata = metadata;
    /** The degree of validation requested. */

    this.leniency = _Leniency["default"][options.leniency];

    if (!this.leniency) {
      throw new TypeError("Unknown leniency: ".concat(options.leniency, "."));
    }
    /** The maximum number of retries after matching an invalid number. */


    this.maxTries = options.maxTries;
    this.PATTERN = new RegExp(PATTERN, 'ig');
  }
  /**
   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
   * that represents a phone number. Returns the next match, null if none was found.
   *
   * @param index  the search index to start searching at
   * @return  the phone number match found, null if none can be found
   */


  _createClass(PhoneNumberMatcher, [{
    key: "find",
    value: function find() // (index)
    {
      // // Reset the regular expression.
      // this.PATTERN.lastIndex = index
      var matches;

      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
        var candidate = matches[0];
        var offset = matches.index;
        candidate = (0, _parsePreCandidate["default"])(candidate);

        if ((0, _isValidPreCandidate["default"])(candidate, offset, this.text)) {
          var match = // Try to come up with a valid match given the entire candidate.
          this.parseAndVerify(candidate, offset, this.text) // If that failed, try to find an "inner match" -
          // there might be a phone number within this candidate.
          || this.extractInnerMatch(candidate, offset, this.text);

          if (match) {
            if (this.options.v2) {
              var phoneNumber = new _PhoneNumber["default"](match.country || match.countryCallingCode, match.phone, this.metadata);

              if (match.ext) {
                phoneNumber.ext = match.ext;
              }

              return {
                startsAt: match.startsAt,
                endsAt: match.endsAt,
                number: phoneNumber
              };
            }

            return match;
          }
        }

        this.maxTries--;
      }
    }
    /**
     * Attempts to extract a match from `candidate`
     * if the whole candidate does not qualify as a match.
     */

  }, {
    key: "extractInnerMatch",
    value: function extractInnerMatch(candidate, offset, text) {
      for (var _i = 0, _INNER_MATCHES = INNER_MATCHES; _i < _INNER_MATCHES.length; _i++) {
        var innerMatchPattern = _INNER_MATCHES[_i];
        var isFirstMatch = true;
        var matches = void 0;
        var possibleInnerMatch = new RegExp(innerMatchPattern, 'g');

        while ((matches = possibleInnerMatch.exec(candidate)) !== null && this.maxTries > 0) {
          if (isFirstMatch) {
            // We should handle any group before this one too.
            var _group = (0, _util.trimAfterFirstMatch)(UNWANTED_END_CHAR_PATTERN, candidate.slice(0, matches.index));

            var _match = this.parseAndVerify(_group, offset, text);

            if (_match) {
              return _match;
            }

            this.maxTries--;
            isFirstMatch = false;
          }

          var group = (0, _util.trimAfterFirstMatch)(UNWANTED_END_CHAR_PATTERN, matches[1]); // Java code does `groupMatcher.start(1)` here,
          // but there's no way in javascript to get a group match start index,
          // therefore using the overall match start index `matches.index`.

          var match = this.parseAndVerify(group, offset + matches.index, text);

          if (match) {
            return match;
          }

          this.maxTries--;
        }
      }
    }
    /**
     * Parses a phone number from the `candidate` using `parseNumber` and
     * verifies it matches the requested `leniency`. If parsing and verification succeed,
     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
     *
     * @param candidate  the candidate match
     * @param offset  the offset of {@code candidate} within {@link #text}
     * @return  the parsed and validated phone number match, or null
     */

  }, {
    key: "parseAndVerify",
    value: function parseAndVerify(candidate, offset, text) {
      if (!(0, _isValidCandidate["default"])(candidate, offset, text, this.options.leniency)) {
        return;
      }

      var number = (0, _parse_["default"])(candidate, {
        extended: true,
        defaultCountry: this.options.defaultCountry,
        defaultCallingCode: this.options.defaultCallingCode
      }, this.metadata);

      if (!number.possible) {
        return;
      }

      if (this.leniency(number, candidate, this.metadata, this.regExpCache)) {
        // // We used parseAndKeepRawInput to create this number,
        // // but for now we don't return the extra values parsed.
        // // TODO: stop clearing all values here and switch all users over
        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
        // number.clearCountryCodeSource()
        // number.clearRawInput()
        // number.clearPreferredDomesticCarrierCode()
        var result = {
          startsAt: offset,
          endsAt: offset + candidate.length,
          phone: number.phone
        };

        if (number.country && number.country !== '001') {
          result.country = number.country;
        } else {
          result.countryCallingCode = number.countryCallingCode;
        }

        if (number.ext) {
          result.ext = number.ext;
        }

        return result;
      }
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.lastMatch = this.find(); // (this.searchIndex)

        if (this.lastMatch) {
          // this.searchIndex = this.lastMatch.endsAt
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      } // Don't retain that memory any longer than necessary.


      var result = this.lastMatch;
      this.lastMatch = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberMatcher;
}();

exports["default"] = PhoneNumberMatcher;
//# sourceMappingURL=PhoneNumberMatcher.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = {"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","11\\d{8}|(?:[2368]|9\\d)\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365|46","1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246"],"BD":["880","00","1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:[2689]\\d|51)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25689]"]]]],"BL":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","90\\d{5}|(?:[2-6]|7\\d)\\d{6}",[7,8],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}",[10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"],0,0,0,["600[2-9]\\d{6}"]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[02-9]"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","(?:[26]\\d\\d|88)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:1\\d|[36])\\d{9}|[124-8]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1 $2",["[146][2-9]|[2578]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[05]\\d{10}|[46][1-8]\\d{4,9})|49(?:[0-25]\\d|3[1-689]|7[1-7])\\d{4,8}|49(?:[0-2579]\\d|[34][1-9]|6[0-8])\\d{3}|49\\d{3,4}|(?:1|[368]\\d|4[0-8])\\d{3,13}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-59]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","(?:[2-8]\\d|90)\\d{4}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],0,0,"0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|(?:4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[02]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","[256]\\d{7}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-689]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|69\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|(?:[2689]\\d|70)\\d{8}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([5-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1[4679]|[38]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","(?:18|[2569]\\d\\d)\\d{5}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[25]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345"],"KZ":["7","810","33622\\d{5}|(?:7\\d|80)\\d{8}",[10],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[7-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758"],"LI":["423","00","90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]","5(?:29|38)[89]0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[0-36-8]|6[1267]|7[0-37]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","870\\d{5}|(?:[349]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[57-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","(?:28|[68]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670"],"MQ":["596","00","69\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[2-468]|5\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9])|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","[2-57-9]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",[5,6,7,8,9,10],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|5[89]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["83"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[0367]|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|8007\\d{4,5}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,0," Anexo "],"PF":["689","00","[48]\\d{7}|4\\d{5}",[6,8],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[48]"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]]],"RE":["262","00","9769\\d{5}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]"],"RO":["40","00","(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","[347-9]\\d{9}",[10],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"],"8 ($1)",1]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","8000\\d{3}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-3]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[4589]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[2378]\\d|66|99)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d{4}|93330)\\d{4}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[1-35-9]|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:[02]0|11|[3-57-9]\\d)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"],0,1],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"],0,1],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3"],0,1],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02457-9]|11"],0,1]],"8",0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|[5-8]\\d{3})\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-8]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[0589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]","4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["[3-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}",[10],[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","(?:(?:4\\d{3}|9)\\d|80)\\d{5}|[249]\\d{7}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[24]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","55501\\d{4}|(?:33|[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","(?:[23]\\d|[48]8)\\d{3}|(?:[57]\\d|90)\\d{5}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","00","(?:[45]0|68|72|8\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[4-8]"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,["[1-9]\\d{7}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"[35-7]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]\\d|7[6-8])\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|[19]\\d{7}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}",[7,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"51\\d{7}(?:\\d{3})?",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["510"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["5"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["51[013]0\\d{8}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(1366)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParseError; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://stackoverflow.com/a/46971044/970769
var ParseError = function ParseError(code) {
  _classCallCheck(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};


ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;
//# sourceMappingURL=ParseError.js.map

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createExtensionPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
 // The RFC 3966 format for extensions.

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */], "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
//# sourceMappingURL=createExtensionPattern.js.map

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRFC3966;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRFC3966;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isViablePhoneNumber__ = __webpack_require__(623);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var part = _ref;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isViablePhoneNumber__["a" /* default */])(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref2) {
  var number = _ref2.number,
      ext = _ref2.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_matchesEntirely__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_getNumberType__ = __webpack_require__(360);



/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_getNumberType__["a" /* default */])(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_matchesEntirely__["a" /* default */])(national_number, metadata.nationalNumberPattern());
}
//# sourceMappingURL=validate_.js.map

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNumberType;
/* unused harmony export isNumberTypeEqualTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchesEntirely__ = __webpack_require__(149);


var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely__["a" /* default */])(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // v1 metadata.
    // Legacy.
    // Deprecated.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
    var type = _NON_FIXED_LINE_PHONE[_i];

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely__["a" /* default */])(nationalNumber, type.pattern());
}
//# sourceMappingURL=getNumberType.js.map

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIRST_GROUP_PATTERN; });
/* harmony export (immutable) */ __webpack_exports__["b"] = formatNationalNumberUsingFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyInternationalSeparatorStyle__ = __webpack_require__(627);
 // This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__applyInternationalSeparatorStyle__["a" /* default */])(formattedNumber);
  }

  return formattedNumber;
}
//# sourceMappingURL=formatNationalNumberUsingFormat.js.map

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stripIddPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(81);


var CAPTURING_DIGIT_PATTERN = new RegExp('([' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* VALID_DIGITS */] + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
//# sourceMappingURL=stripIddPrefix.js.map

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchesEntirely__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extractNationalNumber__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkNumberLength__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getCountryCallingCode__ = __webpack_require__(625);





/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? Object(__WEBPACK_IMPORTED_MODULE_4__getCountryCallingCode__["a" /* default */])(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = Object(__WEBPACK_IMPORTED_MODULE_2__extractNationalNumber__["a" /* default */])(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = Object(__WEBPACK_IMPORTED_MODULE_2__extractNationalNumber__["a" /* default */])(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely__["a" /* default */])(nationalNumber, metadata.nationalNumberPattern()) && Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely__["a" /* default */])(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || Object(__WEBPACK_IMPORTED_MODULE_3__checkNumberLength__["a" /* default */])(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumberMatcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_extension_createExtensionPattern__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__findNumbers_RegExpCache__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__findNumbers_util__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findNumbers_Leniency__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__findNumbers_parsePreCandidate__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__findNumbers_isValidPreCandidate__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__findNumbers_isValidCandidate__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parse___ = __webpack_require__(622);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A port of Google's `PhoneNumberMatcher.java`.
 * https://github.com/googlei18n/libphonenumber/blob/master/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberMatcher.java
 * Date: 08.03.2018.
 */












var EXTN_PATTERNS_FOR_MATCHING = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_extension_createExtensionPattern__["a" /* default */])('matching');
/**
 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
 * ordered according to specificity. For example, white-space is last since that is frequently
 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
 * want to break up the phone-number-like text on more than one different kind of symbol at one
 * time, although symbols of the same type (e.g. space) can be safely grouped together.
 *
 * Note that if there is a match, we will always check any text found up to the first match as
 * well.
 */

var INNER_MATCHES = [// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
'\\/+(.*)/', // Note that the bracket here is inside the capturing group, since we consider it part of the
// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
// We require a space on either side of the hyphen for it to be considered a separator.
"(?:".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "-|-").concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], ")").concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
// possible that it's supposed to be used to break two numbers without spaces, and we haven't
// seen many instances of it used within a number.
"[\u2012-\u2015\uFF0D]".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
"\\.+".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
"".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "+(").concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["a" /* PZ */], "+)")]; // Limit on the number of leading (plus) characters.

var leadLimit = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["b" /* limit */])(0, 2); // Limit on the number of consecutive punctuation characters.

var punctuationLimit = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["b" /* limit */])(0, 4);
/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
 * single block, set high enough to accommodate the entire national number and the international
 * country code. */

var digitBlockLimit = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* MAX_LENGTH_FOR_NSN */] + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* MAX_LENGTH_COUNTRY_CODE */]; // Limit on the number of blocks separated by punctuation.
// Uses digitBlockLimit since some formats use spaces to separate each digit.

var blockLimit = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["b" /* limit */])(0, digitBlockLimit);
/* A punctuation sequence allowing white space. */

var punctuation = "[".concat(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* VALID_PUNCTUATION */], "]") + punctuationLimit; // A digits block without punctuation.

var digitSequence = __WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["f" /* pNd */] + Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["b" /* limit */])(1, digitBlockLimit);
/**
 * Phone number pattern allowing optional punctuation.
 * The phone number pattern used by `find()`, similar to
 * VALID_PHONE_NUMBER, but with the following differences:
 * <ul>
 *   <li>All captures are limited in order to place an upper bound to the text matched by the
 *       pattern.
 * <ul>
 *   <li>Leading punctuation / plus signs are limited.
 *   <li>Consecutive occurrences of punctuation are limited.
 *   <li>Number of digits is limited.
 * </ul>
 *   <li>No whitespace is allowed at the start or end.
 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
 * </ul>
 */

var PATTERN = '(?:' + __WEBPACK_IMPORTED_MODULE_9__findNumbers_isValidCandidate__["a" /* LEAD_CLASS */] + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + EXTN_PATTERNS_FOR_MATCHING + ')?'; // Regular expression of trailing characters that we want to remove.
// We remove all characters that are not alpha or numerical characters.
// The hash character is retained here, as it may signify
// the previous block was an extension.
//
// // Don't know what does '&&' mean here.
// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
//

var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["c" /* _pN */]).concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["b" /* _pL */], "#]+$"));
var NON_DIGITS_PATTERN = /(\D+)/;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
 * {@link PhoneNumberUtil}.
 *
 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
 * not found.
 *
 * <p>This class is not thread-safe.
 */

var PhoneNumberMatcher =
/*#__PURE__*/
function () {
  /** The iteration tristate. */

  /** The next index to start searching at. Undefined in {@link State#DONE}. */
  // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
  // countries being used for the same doc with ~10 patterns for each country. Some pages will have
  // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
  // that use-case won't have a lot of benefit.

  /**
   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
   * new instance.
   *
   * @param util  the phone number util to use
   * @param text  the character sequence that we will search, null for no text
   * @param country  the country to assume for phone numbers not written in international format
   *     (with a leading plus, or with the international dialing prefix of the specified region).
   *     May be null or "ZZ" if only numbers with a leading plus should be
   *     considered.
   * @param leniency  the leniency to use when evaluating candidate phone numbers
   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
   *     be {@code >= 0}.
   */
  function PhoneNumberMatcher() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metadata = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, PhoneNumberMatcher);

    _defineProperty(this, "state", 'NOT_READY');

    _defineProperty(this, "searchIndex", 0);

    _defineProperty(this, "regExpCache", new __WEBPACK_IMPORTED_MODULE_3__findNumbers_RegExpCache__["a" /* default */](32));

    options = _objectSpread({}, options, {
      defaultCallingCode: options.defaultCallingCode,
      defaultCountry: options.defaultCountry && Object(__WEBPACK_IMPORTED_MODULE_10__metadata__["d" /* isSupportedCountry */])(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
      maxTries: options.maxTries || MAX_SAFE_INTEGER
    });

    if (!options.leniency) {
      throw new TypeError('`Leniency` not supplied');
    }

    if (options.maxTries < 0) {
      throw new TypeError('`maxTries` not supplied');
    }

    this.text = text;
    this.options = options;
    this.metadata = metadata;
    /** The degree of validation requested. */

    this.leniency = __WEBPACK_IMPORTED_MODULE_6__findNumbers_Leniency__["a" /* default */][options.leniency];

    if (!this.leniency) {
      throw new TypeError("Unknown leniency: ".concat(options.leniency, "."));
    }
    /** The maximum number of retries after matching an invalid number. */


    this.maxTries = options.maxTries;
    this.PATTERN = new RegExp(PATTERN, 'ig');
  }
  /**
   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
   * that represents a phone number. Returns the next match, null if none was found.
   *
   * @param index  the search index to start searching at
   * @return  the phone number match found, null if none can be found
   */


  _createClass(PhoneNumberMatcher, [{
    key: "find",
    value: function find() // (index)
    {
      // // Reset the regular expression.
      // this.PATTERN.lastIndex = index
      var matches;

      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
        var candidate = matches[0];
        var offset = matches.index;
        candidate = Object(__WEBPACK_IMPORTED_MODULE_7__findNumbers_parsePreCandidate__["a" /* default */])(candidate);

        if (Object(__WEBPACK_IMPORTED_MODULE_8__findNumbers_isValidPreCandidate__["a" /* default */])(candidate, offset, this.text)) {
          var match = // Try to come up with a valid match given the entire candidate.
          this.parseAndVerify(candidate, offset, this.text) // If that failed, try to find an "inner match" -
          // there might be a phone number within this candidate.
          || this.extractInnerMatch(candidate, offset, this.text);

          if (match) {
            if (this.options.v2) {
              var phoneNumber = new __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__["a" /* default */](match.country || match.countryCallingCode, match.phone, this.metadata);

              if (match.ext) {
                phoneNumber.ext = match.ext;
              }

              return {
                startsAt: match.startsAt,
                endsAt: match.endsAt,
                number: phoneNumber
              };
            }

            return match;
          }
        }

        this.maxTries--;
      }
    }
    /**
     * Attempts to extract a match from `candidate`
     * if the whole candidate does not qualify as a match.
     */

  }, {
    key: "extractInnerMatch",
    value: function extractInnerMatch(candidate, offset, text) {
      for (var _i = 0, _INNER_MATCHES = INNER_MATCHES; _i < _INNER_MATCHES.length; _i++) {
        var innerMatchPattern = _INNER_MATCHES[_i];
        var isFirstMatch = true;
        var matches = void 0;
        var possibleInnerMatch = new RegExp(innerMatchPattern, 'g');

        while ((matches = possibleInnerMatch.exec(candidate)) !== null && this.maxTries > 0) {
          if (isFirstMatch) {
            // We should handle any group before this one too.
            var _group = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["d" /* trimAfterFirstMatch */])(UNWANTED_END_CHAR_PATTERN, candidate.slice(0, matches.index));

            var _match = this.parseAndVerify(_group, offset, text);

            if (_match) {
              return _match;
            }

            this.maxTries--;
            isFirstMatch = false;
          }

          var group = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["d" /* trimAfterFirstMatch */])(UNWANTED_END_CHAR_PATTERN, matches[1]); // Java code does `groupMatcher.start(1)` here,
          // but there's no way in javascript to get a group match start index,
          // therefore using the overall match start index `matches.index`.

          var match = this.parseAndVerify(group, offset + matches.index, text);

          if (match) {
            return match;
          }

          this.maxTries--;
        }
      }
    }
    /**
     * Parses a phone number from the `candidate` using `parseNumber` and
     * verifies it matches the requested `leniency`. If parsing and verification succeed,
     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
     *
     * @param candidate  the candidate match
     * @param offset  the offset of {@code candidate} within {@link #text}
     * @return  the parsed and validated phone number match, or null
     */

  }, {
    key: "parseAndVerify",
    value: function parseAndVerify(candidate, offset, text) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__findNumbers_isValidCandidate__["b" /* default */])(candidate, offset, text, this.options.leniency)) {
        return;
      }

      var number = Object(__WEBPACK_IMPORTED_MODULE_11__parse___["a" /* default */])(candidate, {
        extended: true,
        defaultCountry: this.options.defaultCountry,
        defaultCallingCode: this.options.defaultCallingCode
      }, this.metadata);

      if (!number.possible) {
        return;
      }

      if (this.leniency(number, candidate, this.metadata, this.regExpCache)) {
        // // We used parseAndKeepRawInput to create this number,
        // // but for now we don't return the extra values parsed.
        // // TODO: stop clearing all values here and switch all users over
        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
        // number.clearCountryCodeSource()
        // number.clearRawInput()
        // number.clearPreferredDomesticCarrierCode()
        var result = {
          startsAt: offset,
          endsAt: offset + candidate.length,
          phone: number.phone
        };

        if (number.country && number.country !== '001') {
          result.country = number.country;
        } else {
          result.countryCallingCode = number.countryCallingCode;
        }

        if (number.ext) {
          result.ext = number.ext;
        }

        return result;
      }
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.lastMatch = this.find(); // (this.searchIndex)

        if (this.lastMatch) {
          // this.searchIndex = this.lastMatch.endsAt
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      } // Don't retain that memory any longer than necessary.


      var result = this.lastMatch;
      this.lastMatch = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberMatcher;
}();


//# sourceMappingURL=PhoneNumberMatcher.js.map

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.count_occurences = count_occurences;
// Counts all occurences of a symbol in a string
function count_occurences(symbol, string) {
	var count = 0;
	// Using `.split('')` here instead of normal `for ... of`
	// because the importing application doesn't neccessarily include an ES6 polyfill.
	// The `.split('')` approach discards "exotic" UTF-8 characters
	// (the ones consisting of four bytes)
	// but template placeholder characters don't fall into that range
	// so skipping such miscellaneous "exotic" characters
	// won't matter here for just counting placeholder character occurrences.
	for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var character = _ref;

		if (character === symbol) {
			count++;
		}
	}
	return count;
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = parse;
// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function parse(text, caret_position, parse_character) {
	var value = '';

	var focused_input_character_index = 0;

	var index = 0;
	while (index < text.length) {
		var character = parse_character(text[index], value);

		if (character !== undefined) {
			value += character;

			if (caret_position !== undefined) {
				if (caret_position === index) {
					focused_input_character_index = value.length - 1;
				} else if (caret_position > index) {
					focused_input_character_index = value.length;
				}
			}
		}

		index++;
	}

	// If caret position wasn't specified
	if (caret_position === undefined) {
		// Then set caret position to "after the last input character"
		focused_input_character_index = value.length;
	}

	var result = {
		value: value,
		caret: focused_input_character_index
	};

	return result;
}
//# sourceMappingURL=parse.js.map

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__APUpload_css__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__APUpload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__APUpload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_fileHelpers__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__ = __webpack_require__(31);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var baseClass = 'ap-upload';

var APUploadInner = function (_React$Component) {
  _inherits(APUploadInner, _React$Component);

  function APUploadInner() {
    _classCallCheck(this, APUploadInner);

    var _this = _possibleConstructorReturn(this, (APUploadInner.__proto__ || Object.getPrototypeOf(APUploadInner)).call(this));

    _this.onChange = function (e) {
      var _this$props = _this.props,
          name = _this$props.input.name,
          customChange = _this$props.customChange;


      var file = e.target.files[0];

      if (file) {
        Object(__WEBPACK_IMPORTED_MODULE_7__helpers_fileHelpers__["a" /* readFile */])(file, function (imgSrc) {
          customChange(name, { file: file, imgSrc: imgSrc });
          setTimeout(function () {
            return _this.setState({ file: file, imgSrc: imgSrc, hasFile: true });
          });
        });
      } else {
        _this.setState({ file: null, imgSrc: null, hasFile: false });
        customChange(name, null);
      }
    };

    _this.clearField = function () {
      var onChange = _this.props.input.onChange;


      _this.setState({ file: null, imgSrc: null });
      onChange(null);
    };

    _this.onFocus = function () {
      _this.setState({ focused: true, hasFocused: true });
    };

    _this.onBlur = function () {
      _this.setState({ focused: false });
    };

    _this.isImage = function (fileName) {
      var parts = fileName.split('.');
      var ext = parts[parts.length - 1];

      return ['jpg', 'jpeg', 'png', 'gif'].includes(ext);
    };

    _this.state = {
      file: null,
      hasFocused: false,
      focused: false,
      hasFile: false
    };
    return _this;
  }

  _createClass(APUploadInner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classModifiers = _props.classModifiers,
          customClass = _props.customClass,
          info = _props.info,
          placeholder = _props.placeholder,
          label = _props.label,
          acceptedFiles = _props.acceptedFiles,
          error = _props.meta.error,
          alt = _props.alt;
      var _state = this.state,
          file = _state.file,
          hasFocused = _state.hasFocused,
          focused = _state.focused,
          hasFile = _state.hasFile,
          imgSrc = _state.imgSrc;

      var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-group ' + bemClasses('wrapper', classModifiers) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('children', classModifiers) },
            file && this.isImage(file.name) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: bemClasses('img-wrapper') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                src: imgSrc,
                className: bemClasses('preview'),
                alt: alt
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('label', classModifiers) },
            file ? file.name : placeholder,
            file && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                className: bemClasses('cancel-btn', classModifiers),
                onClick: this.clearField },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__APIcon__["a" /* default */], {
                name: 'cancel',
                classModifiers: 'danger',
                customClass: bemClasses('image')
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { className: bemClasses('input-box') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__APButton__["a" /* default */],
              { customClass: bemClasses('btn'), type: 'button' },
              label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              type: 'file',
              onChange: this.onChange,
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              className: bemClasses('input'),
              value: '',
              accept: acceptedFiles
            })
          )
        ),
        info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-text-muted ' + bemClasses('info') },
          info
        ),
        (hasFocused || focused) && hasFile && !file && error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('error') },
          this.context.t(error)
        )
      );
    }
  }]);

  return APUploadInner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

APUploadInner.defaultProps = {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: ''
};
APUploadInner.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
APUploadInner.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


var APUpload = function APUpload(props) {
  var maxSize = function maxSize(value) {
    var maxSize = props.maxSize;

    if (maxSize) return Object(__WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__["j" /* maxFileSize */])(value, maxSize);
  };

  var validators = props.validate ? [].concat(_toConsumableArray(props.validate), [maxSize]) : [maxSize];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({
    component: APUploadInner
  }, props, {
    validate: validators,
    name: props.name
  }));
};

APUpload.defaultProps = {
  name: '',
  label: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  maxSize: null
};

APUpload.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (APUpload);

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// Base58 encoding/decoding
// Originally written by Mike Hearn for BitcoinJ
// Copyright (c) 2011 Google Inc
// Ported to JavaScript by Stefan Thomas
// Merged Buffer refactorings from base58-native by Stephen Pair
// Copyright (c) 2013 BitPay Inc

var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
var ALPHABET_MAP = {};
for (var i = 0; i < ALPHABET.length; ++i) {
    ALPHABET_MAP[ALPHABET.charAt(i)] = i;
}
var BASE = ALPHABET.length;

module.exports = {
    decode: function decode(string) {
        if (string.length === 0) return [];

        var i,
            j,
            bytes = [0];
        for (i = 0; i < string.length; ++i) {
            var c = string[i];
            if (!(c in ALPHABET_MAP)) throw new Error('Non-base58 character');

            for (j = 0; j < bytes.length; ++j) {
                bytes[j] *= BASE;
            }bytes[0] += ALPHABET_MAP[c];

            var carry = 0;
            for (j = 0; j < bytes.length; ++j) {
                bytes[j] += carry;
                carry = bytes[j] >> 8;
                bytes[j] &= 0xff;
            }

            while (carry) {
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for (i = 0; string[i] === '1' && i < string.length - 1; ++i) {
            bytes.push(0);
        }

        return bytes.reverse();
    }
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
// @ts-ignore
var _Buffer = __webpack_require__(1469).Buffer
function base (ALPHABET) {
  if (ALPHABET.length >= 255) { throw new TypeError('Alphabet too long') }
  var BASE_MAP = new Uint8Array(256)
  for (var j = 0; j < BASE_MAP.length; j++) {
    BASE_MAP[j] = 255
  }
  for (var i = 0; i < ALPHABET.length; i++) {
    var x = ALPHABET.charAt(i)
    var xc = x.charCodeAt(0)
    if (BASE_MAP[xc] !== 255) { throw new TypeError(x + ' is ambiguous') }
    BASE_MAP[xc] = i
  }
  var BASE = ALPHABET.length
  var LEADER = ALPHABET.charAt(0)
  var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
  var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
  function encode (source) {
    if (Array.isArray(source) || source instanceof Uint8Array) { source = _Buffer.from(source) }
    if (!_Buffer.isBuffer(source)) { throw new TypeError('Expected Buffer') }
    if (source.length === 0) { return '' }
        // Skip & count leading zeroes.
    var zeroes = 0
    var length = 0
    var pbegin = 0
    var pend = source.length
    while (pbegin !== pend && source[pbegin] === 0) {
      pbegin++
      zeroes++
    }
        // Allocate enough space in big-endian base58 representation.
    var size = ((pend - pbegin) * iFACTOR + 1) >>> 0
    var b58 = new Uint8Array(size)
        // Process the bytes.
    while (pbegin !== pend) {
      var carry = source[pbegin]
            // Apply "b58 = b58 * 256 + ch".
      var i = 0
      for (var it1 = size - 1; (carry !== 0 || i < length) && (it1 !== -1); it1--, i++) {
        carry += (256 * b58[it1]) >>> 0
        b58[it1] = (carry % BASE) >>> 0
        carry = (carry / BASE) >>> 0
      }
      if (carry !== 0) { throw new Error('Non-zero carry') }
      length = i
      pbegin++
    }
        // Skip leading zeroes in base58 result.
    var it2 = size - length
    while (it2 !== size && b58[it2] === 0) {
      it2++
    }
        // Translate the result into a string.
    var str = LEADER.repeat(zeroes)
    for (; it2 < size; ++it2) { str += ALPHABET.charAt(b58[it2]) }
    return str
  }
  function decodeUnsafe (source) {
    if (typeof source !== 'string') { throw new TypeError('Expected String') }
    if (source.length === 0) { return _Buffer.alloc(0) }
    var psz = 0
        // Skip leading spaces.
    if (source[psz] === ' ') { return }
        // Skip and count leading '1's.
    var zeroes = 0
    var length = 0
    while (source[psz] === LEADER) {
      zeroes++
      psz++
    }
        // Allocate enough space in big-endian base256 representation.
    var size = (((source.length - psz) * FACTOR) + 1) >>> 0 // log(58) / log(256), rounded up.
    var b256 = new Uint8Array(size)
        // Process the characters.
    while (source[psz]) {
            // Decode character
      var carry = BASE_MAP[source.charCodeAt(psz)]
            // Invalid character
      if (carry === 255) { return }
      var i = 0
      for (var it3 = size - 1; (carry !== 0 || i < length) && (it3 !== -1); it3--, i++) {
        carry += (BASE * b256[it3]) >>> 0
        b256[it3] = (carry % 256) >>> 0
        carry = (carry / 256) >>> 0
      }
      if (carry !== 0) { throw new Error('Non-zero carry') }
      length = i
      psz++
    }
        // Skip trailing spaces.
    if (source[psz] === ' ') { return }
        // Skip leading zeroes in b256.
    var it4 = size - length
    while (it4 !== size && b256[it4] === 0) {
      it4++
    }
    var vch = _Buffer.allocUnsafe(zeroes + (size - it4))
    vch.fill(0x00, 0, zeroes)
    var j = zeroes
    while (it4 !== size) {
      vch[j++] = b256[it4++]
    }
    return vch
  }
  function decode (string) {
    var buffer = decodeUnsafe(string)
    if (buffer) { return buffer }
    throw new Error('Non-base' + BASE + ' character')
  }
  return {
    encode: encode,
    decodeUnsafe: decodeUnsafe,
    decode: decode
  }
}
module.exports = base


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ScriptLoader = function (_React$Component) {
  _inherits(ScriptLoader, _React$Component);

  function ScriptLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScriptLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScriptLoader.__proto__ || Object.getPrototypeOf(ScriptLoader)).call.apply(_ref, [this].concat(args))), _this), _this.createScript = function () {
      var script = document.createElement('script');

      document.body.appendChild(script);
      script.onload = _this.props.onLoadCallback;
      // script.async = 1;
      script.src = _this.props.url;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScriptLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createScript();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return ScriptLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ScriptLoader.defaultProps = {
  url: '',
  onLoadCallback: function onLoadCallback() {}
};

ScriptLoader.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onLoadCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (ScriptLoader);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1524);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(1529);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidePaneDetails_css__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidePaneDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SidePaneDetails_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('sidepane-details');

var SidePaneDetailsComponent = function (_React$Component) {
  _inherits(SidePaneDetailsComponent, _React$Component);

  function SidePaneDetailsComponent() {
    _classCallCheck(this, SidePaneDetailsComponent);

    return _possibleConstructorReturn(this, (SidePaneDetailsComponent.__proto__ || Object.getPrototypeOf(SidePaneDetailsComponent)).apply(this, arguments));
  }

  _createClass(SidePaneDetailsComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          items = _props.items,
          info = _props.info,
          infoHeader = _props.infoHeader,
          classModifiers = _props.classModifiers,
          link = _props.link;

      var isHtmlString = typeof info === 'string';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          { className: bemClasses('header', classModifiers) },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: bemClasses('body') },
          items && items.map(function (_ref) {
            var label = _ref.label,
                text = _ref.text;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__APLabelWithText__["a" /* default */], {
              key: label,
              label: label,
              text: text,
              customClass: bemClasses()
            });
          })
        ),
        items === undefined || items.length === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: bemClasses('divider') }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: bemClasses('information', classModifiers) },
          infoHeader && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('information-header') },
            infoHeader
          ),
          info && (isHtmlString ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: info } }) : info.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: bemClasses('information-text', classModifiers),
                key: index },
              item
            );
          })),
          link && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: link.url },
            ' ',
            this.context.t(link.text),
            ' '
          )
        )
      );
    }
  }]);

  return SidePaneDetailsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SidePaneDetailsComponent.defaultProps = {
  link: {
    text: '',
    url: ''
  }
};

SidePaneDetailsComponent.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  infoHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

SidePaneDetailsComponent.getItem = function (label, text) {
  return { label: label, text: text };
};

SidePaneDetailsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SidePaneDetailsComponent);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OpenOrdersContainer__ = __webpack_require__(1541);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__OpenOrdersContainer__["a" /* default */]);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilledOrdersContainer__ = __webpack_require__(1549);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FilledOrdersContainer__["a" /* default */]);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InactiveOrdersContainer__ = __webpack_require__(1551);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InactiveOrdersContainer__["a" /* default */]);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderWithFilterContainer__ = __webpack_require__(1561);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__HeaderWithFilterContainer__["a" /* default */]);

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return type; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var type = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  LastTradedPx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  Rolling24HrPxChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  BestBid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  BestOffer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  Rolling24HrVolume: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  SessionLow: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  SessionHigh: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

var defaultProps = {
  LastTradedPx: 0,
  Rolling24HrPxChange: 0,
  BestBid: 0,
  BestOffer: 0,
  Rolling24HrVolume: 0,
  SessionLow: 0,
  SessionHigh: 0
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var noop_1 = __webpack_require__(384);
/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i - 0] = arguments[_i];
    }
    return pipeFromArray(fns);
}
exports.pipe = pipe;
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return noop_1.noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
exports.pipeFromArray = pipeFromArray;
//# sourceMappingURL=pipe.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable = (function (_super) {
    __extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) {
            this._isScalar = false;
        }
    }
    ScalarObservable.create = function (value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function (state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function (subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ScalarObservable.dispatch, 0, {
                done: false, value: value, subscriber: subscriber
            });
        }
        else {
            subscriber.next(value);
            if (!subscriber.closed) {
                subscriber.complete();
            }
        }
    };
    return ScalarObservable;
}(Observable_1.Observable));
exports.ScalarObservable = ScalarObservable;
//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeAll_1 = __webpack_require__(275);
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return mergeAll_1.mergeAll(1);
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(82);
var ArrayObservable_1 = __webpack_require__(105);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if (isArray_1.isArray(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
}
exports.race = race;
var RaceOperator = (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());
exports.RaceOperator = RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RaceSubscriber = (function (_super) {
    __extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.RaceSubscriber = RaceSubscriber;
//# sourceMappingURL=race.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var FromObservable_1 = __webpack_require__(678);
var isArray_1 = __webpack_require__(82);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/* tslint:enable:max-line-length */
/**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */
function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
}
exports.onErrorResumeNext = onErrorResumeNext;
/* tslint:enable:max-line-length */
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    var source = null;
    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
}
exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
var OnErrorResumeNextOperator = (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var OnErrorResumeNextSubscriber = (function (_super) {
    __extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (next) {
            this.add(subscribeToResult_1.subscribeToResult(this, next));
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(189);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return mergeMap_1.mergeMap(project, resultSelector, 1);
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/* tslint:enable:max-line-length */
/**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
}
exports.defaultIfEmpty = defaultIfEmpty;
var DefaultIfEmptyOperator = (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DefaultIfEmptySubscriber = (function (_super) {
    __extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
}
exports.distinctUntilChanged = distinctUntilChanged;
var DistinctUntilChangedOperator = (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctUntilChangedSubscriber = (function (_super) {
    __extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') {
            this.compare = compare;
        }
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = tryCatch_1.tryCatch(this.keySelector)(value);
            if (key === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        var result = false;
        if (this.hasKey) {
            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
            if (result === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        else {
            this.hasKey = true;
        }
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
exports.filter = filter;
var FilterOperator = (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FilterSubscriber = (function (_super) {
    __extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=filter.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */
function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
}
exports.find = find;
var FindValueOperator = (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());
exports.FindValueOperator = FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FindValueSubscriber = (function (_super) {
    __extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(Subscriber_1.Subscriber));
exports.FindValueSubscriber = FindValueSubscriber;
//# sourceMappingURL=find.js.map

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */
function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
exports.audit = audit;
var AuditOperator = (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AuditSubscriber = (function (_super) {
    __extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
            if (duration === errorObject_1.errorObject) {
                this.destination.error(errorObject_1.errorObject.e);
            }
            else {
                var innerSubscription = subscribeToResult_1.subscribeToResult(this, duration);
                if (innerSubscription.closed) {
                    this.clearThrottle();
                }
                else {
                    this.add(this.throttled = innerSubscription);
                }
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=audit.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */
function scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
exports.scan = scan;
var ScanOperator = (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) { hasSeed = false; }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ScanSubscriber = (function (_super) {
    __extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=scan.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var ArgumentOutOfRangeError_1 = __webpack_require__(194);
var EmptyObservable_1 = __webpack_require__(106);
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */
function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else {
            return source.lift(new TakeLastOperator(count));
        }
    };
}
exports.takeLast = takeLast;
var TakeLastOperator = (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeLastSubscriber = (function (_super) {
    __extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
exports.refCount = refCount;
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=refCount.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new SwitchMapOperator(project, resultSelector));
    };
}
exports.switchMap = switchMap;
var SwitchMapOperator = (function () {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapSubscriber = (function (_super) {
    __extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var map_1 = __webpack_require__(193);
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return map_1.map(function (value) { return new Timestamp(value, scheduler.now()); });
    // return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());
exports.Timestamp = Timestamp;
;
//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecentTradesComponent__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_recentTradesSelectors__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);





var mapStateToProps = function mapStateToProps(state) {
  var recentTrades = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_recentTradesSelectors__["a" /* recentTradesSelector */])(state);
  var fetching = state.recentTrades.fetching;

  return {
    recentTrades: recentTrades,
    fetching: fetching,
    selectedInstrument: Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__RecentTradesComponent__["a" /* default */]));

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APSegmentedButton_js__ = __webpack_require__(1901);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__APSegmentedButton_js__["a" /* default */]);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export productOptionsSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseCurrencyPriceSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return baseCurrencySelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);



var productOptionsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.product.products;
}], function (products) {
  var isMisconfigured = false;

  var productsOptions = (__WEBPACK_IMPORTED_MODULE_1__config__["b" /* default */].BaseCurrencies || []).map(function (currency) {
    var product = products.find(function (p) {
      return p.Product === currency;
    });

    isMisconfigured = isMisconfigured || !product;

    return isMisconfigured ? null : {
      value: currency,
      label: product.ProductFullName
    };
  });

  return {
    productsOptions: productsOptions,
    isMisconfigured: isMisconfigured
  };
});

var instrumentHasProductId = function instrumentHasProductId(prodId) {
  return function (ins) {
    return ins.Product1 === prodId || ins.Product2 === prodId;
  };
};

var getInstrumentsById = function getInstrumentsById(instruments, id) {
  return instruments.filter(instrumentHasProductId(id));
};

var findInstrumentsById = function findInstrumentsById(instruments, id) {
  return instruments.find(instrumentHasProductId(id));
};

var findInstrumentLevel = function findInstrumentLevel(instruments, level1, id) {
  var instrument = findInstrumentsById(instruments, id);

  if (instrument) {
    var level = level1[instrument.InstrumentId];
    return level && { instrument: instrument, level: level };
  }
};

var getValueById = function getValueById(inst, level, id) {
  return inst.Product1 === id ? level.LastTradedPx : 1 / level.LastTradedPx;
};

var baseCurrencyPriceSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.level1;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return state.user.userConfig;
}, function (state, productId) {
  return productId;
}], function (level1, instruments, products, userConfig, productId) {
  var baseCurrency = userConfig.find(function (config) {
    return config.Key === 'BaseCurrency';
  });

  if (!baseCurrency || !baseCurrency.Value) return;

  baseCurrency = baseCurrency.Value;

  // Case:
  // * BaseCurrency is the same as the productId
  var product = products.find(function (p) {
    return p.ProductId === productId;
  });
  var baseProduct = products.find(function (p) {
    return p.Product === baseCurrency;
  });
  if (product === baseProduct) return;

  var baseProductId = baseProduct && baseProduct.ProductId;

  var productInstruments = getInstrumentsById(instruments, productId);

  // Case:
  // * BaseCurrency is on level 1 on the same instrument as the productId
  var sharedInstrument = findInstrumentsById(productInstruments, baseProductId);

  if (sharedInstrument) {
    var level = level1[sharedInstrument.InstrumentId];

    if (!level) return;

    var _value = getValueById(sharedInstrument, level, productId);
    return Object.assign({}, baseProduct, { value: _value });
  }

  /* Case:
  ** BaseCurrency is on level1 but on another instrument **
  For this we need two instruments these should have a product that is paired with the current
  product and the baseCurrency but also these instruments need to exist on level1
   */
  var baseCurrencyInstruments = getInstrumentsById(instruments, baseProductId);

  var result = void 0;
  products.forEach(function (_ref) {
    var ProductId = _ref.ProductId;

    if (result) return;

    var baseObj = findInstrumentLevel(baseCurrencyInstruments, level1, ProductId);
    var prodOb = findInstrumentLevel(productInstruments, level1, ProductId);

    if (baseObj && prodOb) {
      result = {
        id: ProductId,
        base: baseObj,
        product: prodOb
      };
    }
  });
  // This means there's no level available for either of product or baseCurrency
  if (!result) return;

  var proxyProductValue = getValueById(result.product.instrument, result.product.level, result.id);
  var proxyBaseCurrencyValue = getValueById(result.base.instrument, result.base.level, result.id);

  var value = proxyBaseCurrencyValue / proxyProductValue;
  return Object.assign({}, baseProduct, { value: value });
});

var baseCurrencySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.user.userConfig;
}, function (userConfig) {
  return (userConfig.find(function (config) {
    return config.Key === 'BaseCurrency';
  }) || {}).Value || 'USD';
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmLimitOrderModalComponent__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);









var mapStateToProps = function mapStateToProps(state, modalProps) {
  var form = state.form;
  var level1 = state.apexCore.level1;

  var orderFormType = modalProps.orderFormType || __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].default;
  var formObj = {};
  if (orderFormType === __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].advanced) {
    formObj = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(form, 'advancedOrderEntry.values', {});
  } else if (orderFormType === __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].default) {
    formObj = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(form, 'orderEntry.values', {});
  }

  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var marketPrice = Object.keys(level1).length && __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(level1, ['' + selectedInstrument.InstrumentId], false) ? __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(level1, [selectedInstrument.InstrumentId.toString(), 'BestOffer'], '0') : '0';

  return {
    orderFormType: orderFormType,
    formObj: formObj,
    limitPrice: formObj.limitPrice ? formObj.limitPrice.toString() : '',
    marketPrice: marketPrice,
    priceSymbol: selectedInstrument.Product2Symbol
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    confirmOrder: function confirmOrder(orderFormType, form) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["e" /* placeOrder */])(orderFormType, form)).then(function () {
        if (orderFormType === __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].advanced) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["d" /* clearOrderForm */])('advancedOrderEntry'));
        } else {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["d" /* clearOrderForm */])('orderEntry'));
        }
      });
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__ConfirmLimitOrderModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].SUBMIT_LIMIT_ORDER
})(container));

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginOrderHistoryComponent__ = __webpack_require__(1954);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginOrderHistoryComponent__["a" /* default */]);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closedPositionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openPositionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return positionPaymentsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var closedPositionsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.margin.history.closedPositions;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return state.margin.instrument.selectedInstrumentId;
}, function (state) {
  return state.margin.instrument.instruments;
}, function (state, props) {
  return props.filterMode;
}, function (positions, productId, instrumentId, instruments, filterMode) {
  if (filterMode === 'selectedProduct') {
    if (productId) {
      return filterPositionsByProductId(positions, productId, instruments);
    }
    return positions;
  }
  return positions.filter(function (position) {
    return position.InstrumentId === instrumentId;
  });
});

var openPositionsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.margin.history.openPositions;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return state.margin.instrument.selectedInstrumentId;
}, function (state) {
  return state.margin.instrument.instruments;
}, function (state, props) {
  return props.filterMode;
}, function (positions, productId, instrumentId, instruments, filterMode) {
  if (filterMode === 'selectedProduct') {
    if (productId) {
      return filterPositionsByProductId(positions, productId, instruments);
    }
    return positions;
  }
  return positions.filter(function (position) {
    return position.InstrumentId === instrumentId;
  });
});

var positionPaymentsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.margin.history.positionPayments;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return state.margin.instrument.selectedInstrumentId;
}, function (state, props) {
  return props.filterMode;
}, function (positionPayments, selectedProductId, selectedInstrumentId, filterMode) {
  if (filterMode === 'selectedProduct') {
    if (selectedProductId) {
      return positionPayments.filter(function (position) {
        return position.PaymentFromProductId === selectedProductId;
      });
    }
    return positionPayments;
  }
  return positionPayments.filter(function (position) {
    return position.PaymentFromProductId === selectedInstrumentId;
  });
});

function filterPositionsByProductId(positions, selectedProductId, instruments) {
  var ordersWithProductIds = positions.map(function (position) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === position.InstrumentId || item.InstrumentId === position.InstrumentId;
    });

    return Object.assign({}, position, {
      product1Id: instrument ? instrument.Product1 : null,
      product2Id: instrument ? instrument.Product2 : null
    });
  });

  return ordersWithProductIds.filter(function (position) {
    return position.product1Id === selectedProductId || position.product2Id === selectedProductId;
  });
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);






var tradingLayoutClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trading-layout');

var TradingLayoutCharts1280Px = function TradingLayoutCharts1280Px(props, context) {
  var PriceChart = props.PriceChart,
      DepthChart = props.DepthChart,
      showDepthChart = props.showDepthChart;


  var _getPanes = function _getPanes() {
    var chartsArray = [{
      menuItem: context.t('Price Chart'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceChart, null);
      }
    }, {
      menuItem: context.t('Depth Chart'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DepthChart, { smallScreen: true });
      }
    }];

    if (!showDepthChart) {
      return chartsArray.filter(function (item) {
        return item.menuItem !== 'Depth Chart';
      });
    }

    return chartsArray;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: tradingLayoutClasses('chart-tabs-container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_Tab_Tab__["a" /* default */], { panes: _getPanes(), customClass: 'trading-layout' })
  );
};

TradingLayoutCharts1280Px.propTypes = {
  PriceChart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  DepthChart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showDepthChart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

TradingLayoutCharts1280Px.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TradingLayoutCharts1280Px);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BalancesListContainer__ = __webpack_require__(2006);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BalancesListContainer__["a" /* default */]);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRecentActivity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RecentActivity_ActivityCellComponents__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_recentActivitySelector__ = __webpack_require__(410);




var formatActivity = function formatActivity(activity, context) {
  return activity.map(function (item) {
    var Type = item.Type;

    switch (Type) {
      case 'deposit':
      case 'withdraw':
        {
          var _item$Action$params = item.Action.params,
              Product = _item$Action$params.Product,
              ProductType = _item$Action$params.ProductType,
              _Status = _item$Action$params.Status;

          item.Action = Object.assign({}, item.Action, {
            primaryText: Type === 'deposit' ? context.t('Deposited {a}', { a: Product }) : context.t('Withdrew {a}', { a: Product }),
            secondaryText: ProductType === 'CryptoCurrency' ? Type === 'deposit' ? context.t('from External Address') : context.t('to External Address') : Type === 'deposit' ? context.t('from Bank') : context.t('to Bank')
          });
          item.Status = Object.assign({}, item.Status, {
            status: context.t('{a}', { a: _Status })
          });
          return item;
        }
      case 'send':
      case 'receive':
        {
          var _item$Action$params2 = item.Action.params,
              _Product = _item$Action$params2.Product,
              ReceiverUserName = _item$Action$params2.ReceiverUserName,
              SenderUserName = _item$Action$params2.SenderUserName;

          item.Action = Object.assign({}, item.Action, {
            primaryText: Type === 'send' ? context.t('Sent {a}', { a: _Product }) : context.t('Received {a}', { a: _Product }),
            secondaryText: Type === 'send' ? context.t('to ' + ReceiverUserName) : context.t('to ' + SenderUserName)
          });
          item.Status = Object.assign({}, item.Status, {
            status: context.t('Complete')
          });
          return item;
        }
      case 'trades':
        {
          var _item$Action$params3 = item.Action.params,
              Product1Symbol = _item$Action$params3.Product1Symbol,
              Product2Symbol = _item$Action$params3.Product2Symbol,
              Side = _item$Action$params3.Side;

          item.Action = Object.assign({}, item.Action, {
            primaryText: Side === 'Buy' ? context.t('Bought {a}', { a: Product1Symbol }) : context.t('Sold {a}', { a: Product1Symbol }),
            secondaryText: Side === 'Buy' ? context.t('with {a}', { a: Product2Symbol }) : context.t('for {a}', { a: Product2Symbol })
          });
          item.Status = Object.assign({}, item.Status, {
            status: context.t('Complete')
          });
          return item;
        }
      default:
        return item;
    }
  });
};

var getColumns = function getColumns(width, themeModifier, context) {
  var columns = [{
    header: context.t('Action'),
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_RecentActivity_ActivityCellComponents__["a" /* Action */], {
        value: row.Action,
        showProductIcon: true,
        themeModifier: themeModifier
      });
    }
  }, {
    header: context.t('Amount'),
    width: '20rem',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_RecentActivity_ActivityCellComponents__["b" /* Amount */], { value: row.Amount });
    }
  }, {
    header: context.t('Status / ID'),
    width: '40rem',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_RecentActivity_ActivityCellComponents__["d" /* Status */], { value: row.Status });
    }
  }, {
    header: context.t('Time & Date'),
    width: '15rem',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_RecentActivity_ActivityCellComponents__["c" /* DateTime */], { value: row.TimeStamp });
    }
  }];

  return columns;
};

var getRecentActivity = function getRecentActivity(state, filter) {
  if (filter) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_recentActivitySelector__["c" /* selectedRecentActivitySelector */])(state);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_recentActivitySelector__["b" /* recentActivitySelector */])(state);
};

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return recentActivitySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectedRecentActivitySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFilteredActivity; });
/* unused harmony export getDepositWithdrawActivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_get_time__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_get_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_get_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_activityFilters__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_recentActivityHelper__ = __webpack_require__(409);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










var formattedTradesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.apexCore.orderHistory.accountTrades;
}, __WEBPACK_IMPORTED_MODULE_5__instrumentPositionSelectors__["c" /* instrumentsWithProductFullNamesAndProductSymbols */], function (_ref) {
  var manifest = _ref.productManifest.manifest;
  return manifest;
}], function (accountTrades, instruments, manifest) {
  var formattedTrades = accountTrades.reduce(function (acc, _ref2) {
    var Quantity = _ref2.Quantity,
        TradeTimeMS = _ref2.TradeTimeMS,
        Side = _ref2.Side,
        InstrumentId = _ref2.InstrumentId,
        ExecutionId = _ref2.ExecutionId,
        Value = _ref2.Value;

    var instrument = instruments.find(function (instrument) {
      return instrument.InstrumentId === InstrumentId;
    });
    var Product1Symbol = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(instrument, 'Product1Symbol');
    var Product2Symbol = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(instrument, 'Product2Symbol');

    if (!Product1Symbol || !Product2Symbol) return acc;
    return acc.concat([{
      Type: 'trades',
      Action: {
        typeIcon: Side === 'Buy' ? 'deposit' : 'withdraw',
        productIcon: {
          productManifest: {
            fetching: false
          },
          iconFileName: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(manifest, [Product1Symbol, 'iconFileName'], Product1Symbol + 'DEFAULT_ICON'),
          size: 24
        },
        params: { Product1Symbol: Product1Symbol, Product2Symbol: Product2Symbol, Side: Side }
      },
      Amount: { Quantity: Quantity, Value: Value, Product1Symbol: Product1Symbol, Product2Symbol: Product2Symbol },
      Status: { id: ExecutionId },
      TimeStamp: {
        raw: TradeTimeMS
      }
    }]);
  }, []);

  return formattedTrades;
});

var formattedDepositTicketsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (_ref3) {
  var depositsStatus = _ref3.deposit.depositsStatus;
  return depositsStatus;
}, function (_ref4) {
  var product = _ref4.apexCore.product;
  return product;
}, function (_ref5) {
  var manifest = _ref5.productManifest.manifest;
  return manifest;
}], function (depositTickets, product, manifest) {
  var products = product.products;

  var formattedDepositTickets = depositTickets.reduce(function (acc, _ref6) {
    var Amount = _ref6.Amount,
        AssetId = _ref6.AssetId,
        RequestCode = _ref6.RequestCode,
        LastUpdateTimeStamp = _ref6.LastUpdateTimeStamp,
        Status = _ref6.Status;

    var _ref7 = products.find(function (product) {
      return product.ProductId === AssetId;
    }) || {},
        Product = _ref7.Product,
        ProductType = _ref7.ProductType;

    var Value = Amount;

    if (!Product) return acc;
    return acc.concat([{
      Type: 'deposit',
      Action: {
        typeIcon: 'deposit',
        productIcon: {
          productManifest: {
            fetching: false
          },
          iconFileName: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(manifest, [Product, 'iconFileName'], Product + 'DEFAULT_ICON'),
          size: 24
        },
        params: { Product: Product, ProductType: ProductType, Status: Status }
      },
      Amount: {
        Quantity: Amount,
        Value: Value,
        Product1Symbol: Product,
        Product2Symbol: Product
      },
      Status: { id: RequestCode },
      TimeStamp: {
        raw: __WEBPACK_IMPORTED_MODULE_4_date_fns_get_time___default()(LastUpdateTimeStamp)
      },
      AssetId: AssetId
    }]);
  }, []);

  return formattedDepositTickets;
});

var formattedWithdrawalsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (_ref8) {
  var withdrawTickets = _ref8.withdraw.withdrawTickets;
  return withdrawTickets;
}, function (_ref9) {
  var product = _ref9.apexCore.product;
  return product;
}, function (_ref10) {
  var manifest = _ref10.productManifest.manifest;
  return manifest;
}], function (withdrawTickets, product, manifest) {
  var products = product.products;

  var formattedWithdrawals = withdrawTickets.reduce(function (acc, _ref11) {
    var Amount = _ref11.Amount,
        AssetId = _ref11.AssetId,
        RequestCode = _ref11.RequestCode,
        LastUpdateTimestamp = _ref11.LastUpdateTimestamp,
        Status = _ref11.Status;

    var _ref12 = products.find(function (product) {
      return product.ProductId === AssetId;
    }) || {},
        Product = _ref12.Product,
        ProductType = _ref12.ProductType;

    var Value = Amount;

    if (!Product) return acc;
    return acc.concat([{
      Type: 'withdraw',
      Action: {
        typeIcon: 'withdraw',
        productIcon: {
          productManifest: {
            fetching: false
          },
          iconFileName: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(manifest, [Product, 'iconFileName'], Product + 'DEFAULT_ICON'),
          size: 24
        },
        params: { Product: Product, ProductType: ProductType, Status: Status }
      },
      Amount: {
        Quantity: Amount,
        Value: Value,
        Product1Symbol: Product,
        Product2Symbol: Product
      },
      Status: { id: RequestCode },
      TimeStamp: {
        raw: __WEBPACK_IMPORTED_MODULE_4_date_fns_get_time___default()(LastUpdateTimestamp)
      },
      AssetId: AssetId
    }]);
  }, []);
  return formattedWithdrawals;
});

var formattedTransfersSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (_ref13) {
  var _ref13$transfer = _ref13.transfer,
      transfers = _ref13$transfer.transfers,
      transfersReceived = _ref13$transfer.transfersReceived;
  return {
    transfersSent: transfers,
    transfersReceived: transfersReceived
  };
}, function (_ref14) {
  var products = _ref14.apexCore.product.products;
  return products;
}, function (_ref15) {
  var manifest = _ref15.productManifest.manifest;
  return manifest;
}], function (transfers, products, manifest) {
  var transfersSent = transfers.transfersSent,
      transfersReceived = transfers.transfersReceived;


  var formattedTransfers = transfersSent.reduce(function (acc, el) {
    var ReceiverUserName = el.ReceiverUserName,
        ProductId = el.ProductId,
        Amount = el.Amount;

    var _ref16 = products.find(function (product) {
      return ProductId === product.ProductId;
    }) || {},
        Product = _ref16.Product;

    if (!Product) return acc;
    return acc.concat([{
      Type: 'send',
      Action: {
        typeIcon: 'withdraw',
        productIcon: {
          productManifest: {
            fetching: false
          },
          iconFileName: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(manifest, [Product, 'iconFileName'], Product + 'DEFAULT_ICON'),
          size: 24
        },
        params: { Product: Product, ReceiverUserName: ReceiverUserName }
      },
      Amount: {
        Quantity: Amount,
        Product1Symbol: Product,
        Value: Amount,
        Product2Symbol: Product
      },
      Status: { id: 0 },
      TimeStamp: {
        raw: 0
      }
    }]);
  }, []);

  var formattedIncomingTransfers = transfersReceived.map(function (_ref17) {
    var SenderUserName = _ref17.SenderUserName,
        ProductId = _ref17.ProductId,
        Amount = _ref17.Amount;

    var _ref18 = products.find(function (product) {
      return ProductId === product.ProductId;
    }) || {},
        Product = _ref18.Product;

    return {
      Type: 'receive',
      Action: {
        typeIcon: 'withdraw',
        productIcon: {
          productManifest: {
            fetching: false
          },
          iconFileName: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(manifest, [Product, 'iconFileName'], Product + 'DEFAULT_ICON'),
          size: 24
        },
        params: { Product: Product, SenderUserName: SenderUserName }
      },
      Amount: {
        Quantity: Amount,
        Product1Symbol: Product,
        Value: Amount,
        Product2Symbol: Product
      },
      Status: { id: 0 },
      TimeStamp: {
        raw: 0
      }
    };
  });
  return [].concat(_toConsumableArray(formattedTransfers), _toConsumableArray(formattedIncomingTransfers));
});

var recentActivitySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([
// This is where we will gather the information
formattedDepositTicketsSelector, formattedWithdrawalsSelector, formattedTradesSelector, formattedTransfersSelector], function (formattedDepositTickets, formattedWithdrawals, formattedTrades, formattedTransfers) {
  var results = [].concat(_toConsumableArray(formattedDepositTickets), _toConsumableArray(formattedWithdrawals), _toConsumableArray(formattedTrades));
  if (__WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].RecentActivity.showTransfers && __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].global.allowTransfer) {
    results = [].concat(_toConsumableArray(results), _toConsumableArray(formattedTransfers));
  }
  return results.sort(function (a, b) {
    var firstTimestamp = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(a, 'TimeStamp.raw');
    var secondTimestamp = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(b, 'TimeStamp.raw');
    if (firstTimestamp > secondTimestamp) {
      return -1;
    } else if (firstTimestamp < secondTimestamp) {
      return 1;
    } else {
      return 0;
    }
  });
});

var selectedRecentActivitySelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([recentActivitySelector, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return state.apexCore.product.products;
}], function (recentActivity, selectedProductId, products) {
  var selectedProduct = products.find(function (item) {
    return item.ProductId === selectedProductId;
  }) || {};

  return recentActivity.filter(function (item) {
    return item.Amount.Product1Symbol === selectedProduct.Product || item.Amount.Product2Symbol === selectedProduct.Product;
  });
});

var getFilteredActivity = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, function (state, filter) {
  return filter;
}], function (state, filter) {
  var formValue = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["g" /* formValueSelector */])('recent-activity');
  var recentActivity = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_recentActivityHelper__["c" /* getRecentActivity */])(state, filter);
  var type = formValue(state, 'type');
  var startDate = formValue(state, 'startDate');
  var endDate = formValue(state, 'endDate');

  return recentActivity.filter(function (item) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_activityFilters__["c" /* typeFilter */])(item, type);
  }).filter(function (item) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_activityFilters__["a" /* dateFilter */])(item, startDate, endDate);
  });
});

var getDepositWithdrawActivity = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([formattedDepositTicketsSelector, formattedWithdrawalsSelector, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state, props) {
  return props.filterMode;
}], function (formattedDepositTickets, formattedWithdrawals, selectedProductId, filterMode) {
  var results = [].concat(_toConsumableArray(formattedDepositTickets), _toConsumableArray(formattedWithdrawals));
  var filteredResults = filterMode === 'selectedProduct' ? results.filter(function (item) {
    return item.AssetId === selectedProductId;
  }) : results;

  return filteredResults.sort(function (a, b) {
    var firstTimestamp = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(a, 'TimeStamp.raw');
    var secondTimestamp = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(b, 'TimeStamp.raw');
    if (firstTimestamp > secondTimestamp) {
      return -1;
    } else if (firstTimestamp < secondTimestamp) {
      return 1;
    } else {
      return 0;
    }
  });
});

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CryptoNavItemsComponent__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_positionSelectors__ = __webpack_require__(52);





var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openSendReceiveSidePane: function openSendReceiveSidePane(isSend, product) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_sidePaneActions__["t" /* openRetailSendReceiveSidePane */])(isSend, product));
    }
  };
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var productPosition = Object.values(Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_positionSelectors__["b" /* positionSelector */])(state)).find(function (p) {
    return p.ProductId === ownProps.product.ProductId;
  });

  var Amount = 0;
  if (productPosition) Amount = productPosition.Amount;

  return {
    isWithdrawDisabled: Amount < 0
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__CryptoNavItemsComponent__["a" /* default */]));

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiatNavItemsComponent__ = __webpack_require__(2020);




var mapDispatchToProps = {
  openRetailFiatSidePane: __WEBPACK_IMPORTED_MODULE_1__redux_actions_sidePaneActions__["s" /* openRetailFiatSidePane */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__FiatNavItemsComponent__["a" /* default */]));

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RetailPriceChartComponent__ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_tickersActions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);







var locale = __WEBPACK_IMPORTED_MODULE_1__config__["b" /* default */].global.locale;


var mapStateToProps = function mapStateToProps(state) {
  var tickers = state.tickers,
      _state$apexCore = state.apexCore,
      level1 = _state$apexCore.level1,
      level2 = _state$apexCore.level2;

  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var marketPrice = selectedInstrument && level1[selectedInstrument.InstrumentId] ? level1[selectedInstrument.InstrumentId].LastTradedPx : 0;

  return {
    selectedInstrument: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
    precision: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement),
    locale: locale,
    chartData: { level2: level2, tickers: tickers, marketPrice: marketPrice }
  };
};

var mapDispatchToProps = {
  changeTickersInterval: __WEBPACK_IMPORTED_MODULE_3__redux_actions_tickersActions__["e" /* changeTickersInterval */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__RetailPriceChartComponent__["a" /* default */]));

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WalletDetailsComponent__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_baseCurrenciesSelectors__ = __webpack_require__(403);





var mapStateToProps = function mapStateToProps(state) {
  var position = state.apexCore.position;

  var fetching = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["a" /* fetchingSelector */])(state);
  var positionDetails = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state).find(function (i) {
    return i.ProductId === position.selectedProductId;
  });
  var baseCurrency = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_baseCurrenciesSelectors__["a" /* baseCurrencyPriceSelector */])(state, positionDetails.ProductId);

  return { positionDetails: positionDetails, fetching: fetching, baseCurrency: baseCurrency };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__WalletDetailsComponent__["a" /* default */]));

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransfersComponent__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_transferRequestActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_transfersTableSelectors__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);







var mapStateToProps = function mapStateToProps(state) {
  var _transfersByProductId = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_transfersTableSelectors__["b" /* transfersByProductIdSelector */])(state),
      receivedRequests = _transfersByProductId.receivedRequests,
      sentRequests = _transfersByProductId.sentRequests,
      sentTransfers = _transfersByProductId.sentTransfers,
      receivedTransfers = _transfersByProductId.receivedTransfers;

  var formSelector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('transfers-filters-form');
  var selectedFilter = formSelector(state, 'transfersFilters');

  var products = state.apexCore.product.products;
  var usePagination = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].OrderHistoryData.usePagination;


  var addProduct = function addProduct(item) {
    return item.product = products.find(function (p) {
      return item.ProductId === p.ProductId;
    });
  };

  receivedRequests.forEach(addProduct);
  sentRequests.forEach(addProduct);
  sentTransfers.forEach(addProduct);
  receivedTransfers.forEach(addProduct);

  return {
    receivedRequests: receivedRequests,
    sentRequests: sentRequests,
    sentTransfers: sentTransfers,
    receivedTransfers: receivedTransfers,
    usePagination: usePagination,
    selectedFilter: selectedFilter ? selectedFilter : 'sentTransfers'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    approveTransferRequest: function approveTransferRequest(requestCode) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_transferRequestActions__["h" /* approveTransferRequest */])(requestCode));
    },
    rejectTransferRequest: function rejectTransferRequest(requestCode) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_transferRequestActions__["k" /* rejectTransferRequest */])(requestCode));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__TransfersComponent__["a" /* default */]));

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interestBalancesSelector; });
/* unused harmony export interestPaymentsSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return totalInterestPaymentsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return totaledInterestPaymentsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filteredInterestPaymentsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_activityFilters__ = __webpack_require__(797);





var interestBalancesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__productPositionSelectors__["d" /* productPositionAssetsSelector */], function (productPositionAssets) {
  return productPositionAssets;
});

var interestPaymentsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.interestBearingAccounts.interestPayments;
}, __WEBPACK_IMPORTED_MODULE_2__productPositionSelectors__["d" /* productPositionAssetsSelector */]], function (payments, productPositionAssets) {
  return payments.map(function (i) {
    var productPos = productPositionAssets.find(function (j) {
      return j.ProductId === i.ProductId;
    });

    return Object.assign({}, productPos, i, {
      ConvertedCrAmount: productPos.NotionalRate * i.CR
    });
  });
});

var totalInterestPaymentsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(interestPaymentsSelector, function (interestPayments) {
  return interestPayments.reduce(function (acc, i) {
    acc += i.ConvertedCrAmount;
    return acc;
  }, 0);
});

var totaledInterestPaymentsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(interestPaymentsSelector, function (payments) {
  return payments.reduce(function (acc, i) {
    if (!acc[i.ProductId]) acc[i.ProductId] = {};

    var now = new Date();
    var sevenDay = now.setDate(now.getDate() - 10);

    if (i.TimeStamp > sevenDay) {
      acc[i.ProductId]['7DayEarnings'] = (acc[i.ProductId]['7DayEarnings'] || 0) + i.CR;
    }
    acc[i.ProductId]['Total'] = (acc[i.ProductId]['Total'] || 0) + i.CR;

    return acc;
  }, {});
});

var filteredInterestPaymentsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, interestPaymentsSelector], function (state, payments) {
  var formValue = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('interest-payments');
  var product = formValue(state, 'product');
  var startDate = formValue(state, 'startDate');
  var endDate = formValue(state, 'endDate');

  return payments.filter(function (i) {
    if (product && product !== 'all') {
      return i.ProductId === parseInt(product);
    }
    return true;
  }).filter(function (i) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_activityFilters__["b" /* rawDateFilter */])(i, startDate, endDate);
  });
});

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TradeSettingsContainer__ = __webpack_require__(2250);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__TradeSettingsContainer__["a" /* default */]);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APCheckbox_js__ = __webpack_require__(289);
/* unused harmony reexport InnerCheckboxInput */




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__APCheckbox_js__["a" /* default */]);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDropdownsDefaultValue; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var setDropdownsDefaultValue = function setDropdownsDefaultValue(sections, change, values) {
  var selectFields = sections.reduce(function (result, section) {
    if (!Array.isArray(section.form)) return result;
    return [].concat(_toConsumableArray(result), _toConsumableArray(section.form.filter(function (field) {
      return ['select', 'country'].includes(field.type);
    })));
  }, []);

  // Set the default value
  selectFields.forEach(function (field) {
    if (!values || !values[field.name]) {
      change(field.name, Array.isArray(field.options) ? field.options[0] : Object.keys(field.options)[0]);
    }
  });
};

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYCConfirmLevelModalComponent__ = __webpack_require__(2382);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYCConfirmLevelModalComponent__["a" /* default */]);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(557);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDisplayLevel; });
var getDisplayLevel = function getDisplayLevel(kycConfig, currentLevel) {
  if (!kycConfig) return null;
  return kycConfig.levels.filter(function (kycLevel) {
    return kycLevel.level === currentLevel;
  })[0];
};

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APIFrame_css__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APIFrame_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__APIFrame_css__);






var APIFrame = function APIFrame(props) {
  var children = props.children,
      customClass = props.customClass,
      id = props.id,
      src = props.src,
      title = props.title,
      onLoad = props.onLoad;


  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-iframe');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'iframe',
    {
      allow: 'camera',
      title: title,
      className: bemClasses(customClass),
      id: id,
      src: src,
      onLoad: onLoad },
    children
  );
};

APIFrame.defaultProps = {
  id: '',
  src: '',
  onLoad: function onLoad() {},
  title: 'kyc-iframe',
  customClass: ''
};

APIFrame.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (APIFrame);

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return digitalAssetsListSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return digitalAssetSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectedDigitalAssetInstrumentSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);



var products = function products(state) {
  return state.apexCore.product.products;
};
var productAttributes = function productAttributes(state) {
  return state.productAttributes;
};

var digitalAssetsListSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([products, productAttributes], function (products, productAttributes) {
  return Object.values(Object.values(productAttributes || {}).filter(function (i) {
    return i.Type === 'DigitalAsset';
  }).reduce(function (acc, curr) {
    var prod = products.find(function (i) {
      return i.ProductId === curr.ProductId;
    }) || {};
    acc[curr.ProductId] = Object.assign({}, prod, curr);

    return acc;
  }, {}));
});

var digitalAssetSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([products, productAttributes, function (state, config) {
  return config;
}], function (products, productAttributes, config) {
  if (!products.length || !productAttributes) {
    return false;
  }
  var product = products.find(function (i) {
    return i.ProductId === config.ProductId;
  }) || {};
  var attributes = productAttributes[config.ProductId];

  if (product && attributes) {
    return Object.assign({}, product, attributes);
  }

  return false;
});

var selectedDigitalAssetInstrumentSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_1__redux_selectors_instrumentPositionSelectors__["e" /* standardInstrumentsWithProductFullNamesAndProductSymbols */], function (state, config) {
  return config;
}], function (instruments, _ref) {
  var ProductId = _ref.ProductId;
  return instruments.find(function (i) {
    return i.Product1 === ProductId || i.Product2 === ProductId;
  });
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySell__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EotcBuySell__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuySellChartOverview__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuySellChartOverviewAlt__ = __webpack_require__(2070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellMakeTransaction__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellBalances__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BuySellOrderOverview__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BuySellInstrumentSelect__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BuySellChartIntervalSelector__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EotcBuySellChartOverviewContainer_EotcBuySellChartOverviewContainer__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EotcBuySellOrderOverview__ = __webpack_require__(2101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__BuySell__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__EotcBuySell__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__BuySellMakeTransaction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__BuySellBalances__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__BuySellOrderOverview__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__BuySellInstrumentSelect__["a"]; });
/* unused harmony reexport BuySellChartIntervalSelectorContainer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__BuySellChartOverview__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__BuySellChartOverviewAlt__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__EotcBuySellChartOverviewContainer_EotcBuySellChartOverviewContainer__["a"]; });
/* unused harmony reexport EotcBuySellOrderOverviewContainer */














/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_paginationActions__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaginationComponent__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    setActivePage: function setActivePage(activePage) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_paginationActions__["b" /* setActivePage */])({ componentName: ownProps.componentName, activePage: activePage }));
    }
  };
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    activePage: state.paginationMemory[ownProps.componentName],
    maxPages: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].Pagination.maxPages
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__PaginationComponent__["a" /* default */]));

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecentActivityComponent__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_resize__ = __webpack_require__(73);





var RecentActivityComponentForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'recent-activity',
  destroyOnUnmount: false,
  initialValues: {
    type: 'all',
    startDate: undefined,
    endDate: undefined
  }
})(__WEBPACK_IMPORTED_MODULE_2__RecentActivityComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])()(Object(__WEBPACK_IMPORTED_MODULE_3__hocs_resize__["a" /* default */])(RecentActivityComponentForm)));

/***/ }),
/* 432 */,
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarketOverviewComponent__ = __webpack_require__(2104);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarketOverviewComponent__["a" /* default */]);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApiKeysSidePaneButton__ = __webpack_require__(2230);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ApiKeysSidePaneButton__["a" /* default */]);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApiKeyListComponent__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__ = __webpack_require__(9);




var mapStateToProps = function mapStateToProps(state) {
  var apiKeys = state.apiKey.apiKeys;


  return {
    apiKeys: apiKeys
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    removeApiKey: function removeApiKey(apiKey) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["b" /* MODAL_TYPES */].REMOVE_API_KEY, { apiKey: apiKey }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ApiKeyListComponent__["a" /* default */]));

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AffiliateActiveTagComponent__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_affiliateActions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__ = __webpack_require__(20);





var mapStateToProps = function mapStateToProps(state, ownProps) {
  var route = ownProps.route;
  return {
    route: route,
    affiliate: state.affiliate
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openAffiliateModal: function openAffiliateModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_affiliateActions__["f" /* openAffiliateModal */])());
    },
    showSnack: function showSnack(text) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__["e" /* showSnack */])({ id: 'affiliateCopyTage', text: text, type: 'success' }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__AffiliateActiveTagComponent__["a" /* default */]));

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AffiliateCountComponent__ = __webpack_require__(2246);



var mapStateToProps = function mapStateToProps(state) {
  return {
    affiliate: state.affiliate
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__AffiliateCountComponent__["a" /* default */]));

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoyaltyTokenComponent__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_loyaltyFeeActions__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_loyaltyTokenSelectors__ = __webpack_require__(2249);








var mapStateToProps = function mapStateToProps(state) {
  var _loyaltyTokenSelector = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_loyaltyTokenSelectors__["b" /* loyaltyTokenSelector */])(state),
      loyaltyOMSEnabled = _loyaltyTokenSelector.loyaltyOMSEnabled,
      loyaltyOMSProducts = _loyaltyTokenSelector.loyaltyOMSProducts;

  var currentAccount = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_loyaltyTokenSelectors__["a" /* currentAccountloyaltyTokenSelector */])(state);
  return { loyaltyOMSEnabled: loyaltyOMSEnabled, loyaltyOMSProducts: loyaltyOMSProducts, currentAccount: currentAccount };
};

var mapDispatchToProps = {
  getOperatorLoyaltyFeeConfigs: __WEBPACK_IMPORTED_MODULE_3__redux_actions_loyaltyFeeActions__["d" /* getOperatorLoyaltyFeeConfigs */],
  updateAccount: __WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__["t" /* updateAccount */]
};

var LoyaltyTokenContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__LoyaltyTokenComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'loyaltyTokenForm',
  onSubmit: function onSubmit() {}
})(LoyaltyTokenContainer));

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivityReportingButtons__ = __webpack_require__(2273);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ActivityReportingButtons__["a" /* default */]);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduledReportsTableContainer__ = __webpack_require__(2277);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ScheduledReportsTableContainer__["a" /* default */]);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DownloadReportContainer__ = __webpack_require__(2281);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DownloadReportContainer__["a" /* default */]);

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(860);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(443);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(880);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(62)))

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(448);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(452);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(292);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key]}}}return target};exports.setLanguage=setLanguage;exports.setFallbackLanguage=setFallbackLanguage;exports.setTranslations=setTranslations;exports.setForceRefresh=setForceRefresh;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true})}else{obj[key]=value}return obj}function setLanguage(lang){return{type:'REDUX_I18N_SET_LANGUAGE',lang:lang}}function setFallbackLanguage(newFallbackLang){return{type:'REDUX_I18N_SET_FALLBACK_LANGUAGE',newFallbackLang:newFallbackLang}}function updateTranslations(translations){return{type:'REDUX_I18N_SET_TRANSLATIONS',translations:translations}}function setTranslations(translations,languageOrOptions){return function(dispatch,getState){var options=typeof languageOrOptions==='string'?{language:languageOrOptions}:languageOrOptions||{};var language=options.language,preserveExisting=options.preserveExisting;var state=getState();var trans=null;if(state.i18nState===undefined){trans=state.getIn(['i18nState','translations'])}else{trans=_extends({},state.i18nState.translations)}var newTranslations=language===undefined?translations:_extends({},trans,_defineProperty({},language,translations));dispatch(updateTranslations(preserveExisting?Object.keys(newTranslations).reduce(function(allTranslations,lang){return _extends({},allTranslations,_defineProperty({},lang,_extends({},allTranslations[lang],newTranslations[lang])))},trans):newTranslations));dispatch(setForceRefresh(true))}}function setForceRefresh(force){return{type:'REDUX_I18N_SET_FORCE_REFRESH',force:force}}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});var _typeof=typeof Symbol==='function'&&typeof Symbol.iterator==='symbol'?function(obj){return typeof obj}:function(obj){return obj&&typeof Symbol==='function'&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i]}return arr2}else{return Array.from(arr)}}var interpolateParams=function interpolateParams(text,params){if(!params){return text}var children=text.split(/({[^}]+})/g).map(function(child){var match=/{(.+)}/g.exec(child);if(match){var param=params[match[1]];return param?param:String(param)}return child});return children.some(function(child){return child&&(typeof child==='undefined'?'undefined':_typeof(child))==='object'})?_react2.default.createElement.apply(_react2.default,['span',null].concat(_toConsumableArray(children))):children.join('')};var getLangMessages=function getLangMessages(translations,lang){var langMessages=translations[lang];if(langMessages===undefined&&lang.indexOf('-')>-1){langMessages=translations[lang.split('-')[0]]}return langMessages};var getOptionValue=function getOptionValue(options,key,defaultValue){if(options===undefined){return defaultValue||null}return options[key]===undefined?defaultValue||null:options[key]};exports.default=function(translations,lang,fallbackLang){var langMessages=getLangMessages(translations,lang);var fallbackLangMessages=fallbackLang?getLangMessages(translations,fallbackLang):undefined;var plural_rule=getOptionValue(translations.options,'plural_rule','n != 1');var plural_number=parseInt(getOptionValue(translations.options,'plural_number','2'),10);var suppress_warnings=getOptionValue(translations.options,'suppress_warnings',false);return function(textKey,params,comment){if((typeof textKey==='undefined'?'undefined':_typeof(textKey))==='object'){textKey=textKey[Number(new Function('n','return '+plural_rule)(params[textKey[plural_number]]))]}if(!langMessages&&!fallbackLangMessages){return interpolateParams(textKey,params)}var message=langMessages?langMessages[textKey]:undefined;if(message===undefined||message===''){if(!suppress_warnings){console.warn('Missing translation for id '+textKey+' in language '+lang)}if(fallbackLangMessages){var literal=fallbackLangMessages[textKey];if(literal!==undefined&&literal!==''){return interpolateParams(literal,params)}}return interpolateParams(textKey,params)}return interpolateParams(message,params)}};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(295);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"],
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"],
    meta: { form: form, sections: sections }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(908);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(466);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(917);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(940);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(222);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(953);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(74);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(225);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(970);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(470);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(472);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer);
  var stateEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(116);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(984);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(96);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(166);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(471);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      if (fields && fields.length) {
        return fields.every(function (field) {
          var fieldInitial = getIn(formState, form + '.initial.' + field);
          var fieldValue = getIn(formState, form + '.values.' + field);
          return deepEqual(fieldInitial, fieldValue);
        });
      }
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(165);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(167);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(465);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkAuth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_lifeCycleActions__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_apiKeyActions__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_affiliateActions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_reportActions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_wsConnectionActions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_authActions__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_appActions__ = __webpack_require__(240);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











var authMiddleware = function authMiddleware(store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch;


      if (action.type === __WEBPACK_IMPORTED_MODULE_7__actions_authActions__["c" /* AUTH_NONE */]) {
        onLogout(action);
      } else if (action.type === __WEBPACK_IMPORTED_MODULE_7__actions_authActions__["e" /* AUTH_SUCCESS */]) {
        onLogin(dispatch, action);
      } else if (action.type === __WEBPACK_IMPORTED_MODULE_1__actions_lifeCycleActions__["a" /* APP_INIT */]) {
        onAppInit(dispatch);
      } else if (action.type === __WEBPACK_IMPORTED_MODULE_7__actions_authActions__["g" /* FORCED_LOGOUT */]) {
        onLogout(action);
      }

      return next(action);
    };
  };
};

var setOnConnectionChange = function setOnConnectionChange(dispatch) {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || navigator.msConnection;
  if (connection) {
    connection.onchange = function () {
      if (navigator.onLine) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_wsConnectionActions__["h" /* pingBackend */])());
      }
    };
  }
};

var onAppInit = function onAppInit(dispatch) {
  setOnConnectionChange(dispatch);
  dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_authActions__["m" /* subscribeToLogoutEvent */])());

  var token = localStorage.getItem('token');
  if (token) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_authActions__["n" /* validateSessionToken */])(token));
  }

  // (!oldValue) If we are creating the token key in localStorage, we want to log in on any tabs
  // (!newValue) If we are removing the token key in localStorage, we want to log out on any tabs
  window.addEventListener('storage', function (event) {
    var key = event.key,
        oldValue = event.oldValue,
        newValue = event.newValue;

    if (key === 'token') {
      if (!newValue || !oldValue) {
        window.location.reload();
      }
    }
  });
};

var onLogin = function onLogin(dispatch, action) {
  localStorage.setItem('token', action.payload.token);
  dispatch(initDataAfterLogin(action.payload.userId));
};

var onLogout = function onLogout(action) {
  localStorage.removeItem('token');

  if (action.type === __WEBPACK_IMPORTED_MODULE_7__actions_authActions__["g" /* FORCED_LOGOUT */] || action.payload.wasAuthenticatedBefore) {
    window.location.reload();
  }
};

var checkAuth = function checkAuth(dispatch) {
  var token = localStorage.getItem('token');

  if (token) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_authActions__["n" /* validateSessionToken */])(token));
  } else {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_authActions__["j" /* logout */])());
  }
};

var initDataAfterLogin = function initDataAfterLogin(userId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_appActions__["b" /* loadStartupData */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_userActions__["m" /* getUserInfo */])(userId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_apiKeyActions__["g" /* getUserApiKeys */])(userId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_affiliateActions__["e" /* getAffiliateCount */])());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_reportActions__["i" /* getUserReports */])(userId));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_reportActions__["h" /* getUserReportWriterResults */])());

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

/* harmony default export */ __webpack_exports__["a"] = (authMiddleware);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pegPriceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pegPriceTypesNames; });
var _pegPriceTypesNames;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pegPriceType = {
  last: '1',
  bid: '2',
  ask: '3'
};

/**
 * context.t('Last')
 * context.t('Bid')
 * context.t('Ask')
 */

var pegPriceTypesNames = (_pegPriceTypesNames = {}, _defineProperty(_pegPriceTypesNames, pegPriceType.last, 'Last'), _defineProperty(_pegPriceTypesNames, pegPriceType.bid, 'Bid'), _defineProperty(_pegPriceTypesNames, pegPriceType.ask, 'Ask'), _pegPriceTypesNames);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bignumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberFormatter__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (function (position, symbol) {
  var formattedPosition = Object.assign({}, position);

  formattedPosition.Hold = formatValue(position.Hold, symbol);
  formattedPosition.PendingDeposits = formatValue(position.PendingDeposits, symbol);
  formattedPosition.Amount = formatValue(position.Amount, symbol);
  formattedPosition.rawAmount = position.Amount;
  formattedPosition.AvailableBalance = formattedPosition.Amount;

  if (position.Amount !== 0 && position.Hold !== 0) {
    var amount = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(position.Amount);
    var availableBalance = amount.minus(new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(position.Hold));
    formattedPosition.AvailableBalance = Object(__WEBPACK_IMPORTED_MODULE_1__numberFormatter__["b" /* formatNumberToLocale */])(availableBalance, symbol);
  }

  return formattedPosition;
});

var formatValue = function formatValue(value, symbol) {
  if (value === 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__numberFormatter__["h" /* replaceZeroWithDash */])(value);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__numberFormatter__["b" /* formatNumberToLocale */])(value, symbol);
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(117),
    isObject = __webpack_require__(67);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 496 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(498);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134),
    arrayMap = __webpack_require__(169),
    isArray = __webpack_require__(63),
    isSymbol = __webpack_require__(231);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_get_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_is_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_add_days__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_add_days__);






var dateFilter = function dateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var timeStamp = arguments[3];

  var rawTimeStamp = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(item, timeStamp);

  if (!rawTimeStamp) {
    console.warn('order history item does not have a ' + timeStamp + ' property:', item);
    return false;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default()(startDate) && __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default()(endDate)) {
    return __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range___default()(rawTimeStamp, __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time___default()(startDate), __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time___default()(__WEBPACK_IMPORTED_MODULE_4_date_fns_add_days___default()(endDate, 1)));
  }

  return __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range___default()(rawTimeStamp, 0, Date.now());
};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIDE_PANES; });
var SIDE_PANES = {
  REPORTS: 'Reports',
  API_KEYS: 'ApiKeys',
  DEPOSITS: 'Deposits',
  WITHDRAWS: 'Withdraws',
  ADVANCED_ORDER: 'AdvancedOrder',
  KYC: 'KYCForm',
  KYC_IM: 'KYC_IMForm',
  KYC_IMLegacy: 'KYC_IMLegacyForm',
  KYC_Jumio: 'KYC_JumioForm',
  KYC_Manual: 'KYC_ManualForm',
  REPORT_BLOCK_TRADE: 'ReportBlockTrade',
  RETAIL_SEND_RECEIVE: 'SendReceive',
  RETAIL_FIAT: 'RetailFiat'
};

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);


// do to the backend sending non-supported products in an undesirably ordered fashion
// we have to do the filtering and sorting on the front end
var filterSortSupportedProducts = function filterSortSupportedProducts(itemsArray) {
  if (!__WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.products || __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.products.length === 0) {
    return itemsArray;
  }

  var filteredSortedProducts = [];

  __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.products.forEach(function (symbol) {
    var product = itemsArray.find(function (item) {
      return item.Product === symbol || item.ProductSymbol === symbol;
    });

    if (product) {
      filteredSortedProducts.push(product);
    }
  });

  return filteredSortedProducts;
};

/* harmony default export */ __webpack_exports__["a"] = (filterSortSupportedProducts);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initMarketTradeSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscribeToMarketTradeUpdated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_subscriptions_marketTradeSubscriptionService__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__snackbarActions__ = __webpack_require__(20);



var initMarketTradeSubscription = function initMarketTradeSubscription() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_0__services_subscriptions_marketTradeSubscriptionService__["a" /* default */].initSubscribtion();
  };
};

// Responsible for showing snackbar messages if instrument paused/resumed/halted/started
var subscribeToMarketTradeUpdated = function subscribeToMarketTradeUpdated() {
  return function (dispatch, getState) {
    // Actually instrumentReducer already store SessionStatus of instrument which should be source of truth BUT
    // for some reason after capturing event that Instrument is paused server still returns this Instrument with
    // previous status. Looks like server sends an event while pausing/resuming is in progress.
    // This is why we store local copy of statuses here, another case is that server sends ~50 same events if SessionStatus
    // is changed, but we don't want to show 50 snackbars.
    var instruments = getState().apexCore.instrument.instruments.map(function (instrument) {
      return {
        InstrumentId: instrument.InstrumentId,
        Symbol: instrument.Symbol,
        SessionStatus: instrument.SessionStatus
      };
    });

    __WEBPACK_IMPORTED_MODULE_0__services_subscriptions_marketTradeSubscriptionService__["a" /* default */].subscribe(function (updates) {
      instruments.map(function (instrument) {
        if (instrument.InstrumentId === updates.VenueInstrumentId && instrument.SessionStatus !== updates.NewStatus) {
          instrument.SessionStatus = updates.NewStatus;

          var snackBar = getMarketUpdateSnackbar(instrument, updates);

          dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__snackbarActions__["e" /* showSnack */])({
            id: snackBar.id,
            text: snackBar.text,
            type: snackBar.type
          }));
        }

        return instrument;
      });
    });
  };
};

var getMarketUpdateSnackbar = function getMarketUpdateSnackbar(instument, update) {
  var id = 'OrderStateEventSnackbar-' + update.VenueInstrumentId + '-' + update.NewStatus;
  var type = 'info';
  var text = 'Market for ' + instument.Symbol + ' is ' + update.NewStatus;

  return { id: id, type: type, text: text };
};

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCHING_ACCOUNT_SETTLEMENT_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ACCOUNT_SETTLEMENT_POSITIONS_ERROR; });
/* unused harmony export fetchingAccountSettlementPositions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_ACCOUNT_SETTLEMENT_POSITIONS; });
/* unused harmony export fetchAccountSettlementPositionsError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return subscribeToAccountSettlements; });
/* unused harmony export receiveAccountSettlementPositions */
/* unused harmony export getAccountSettlementPositions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_settlementSubscriptionService__ = __webpack_require__(1114);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var FETCHING_ACCOUNT_SETTLEMENT_POSITIONS = 'FETCHING_ACCOUNT_SETTLEMENT_POSITIONS';
var FETCH_ACCOUNT_SETTLEMENT_POSITIONS_ERROR = 'FETCH_ACCOUNT_SETTLEMENT_POSITIONS_ERROR';

var fetchingAccountSettlementPositions = {
  type: FETCHING_ACCOUNT_SETTLEMENT_POSITIONS
};
var RECEIVE_ACCOUNT_SETTLEMENT_POSITIONS = 'RECEIVE_ACCOUNT_SETTLEMENT_POSITIONS';

var fetchAccountSettlementPositionsError = function fetchAccountSettlementPositionsError(payload) {
  return {
    type: FETCH_ACCOUNT_SETTLEMENT_POSITIONS_ERROR,
    payload: payload
  };
};

var subscribeToAccountSettlements = function subscribeToAccountSettlements() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_settlementSubscriptionService__["a" /* default */].subscribe(function (updates) {
      dispatch(receiveAccountSettlementPositions(updates));
    });
  };
};

var receiveAccountSettlementPositions = function receiveAccountSettlementPositions(payload) {
  return {
    type: RECEIVE_ACCOUNT_SETTLEMENT_POSITIONS,
    payload: payload
  };
};
var getAccountSettlementPositions = function getAccountSettlementPositions() {
  var AccountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var payload, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(fetchingAccountSettlementPositions);

              payload = {
                OMSId: getState().user.userInfo.OMSId,
                AccountId: AccountId
              };
              _context.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetAccountSettlementPositions', payload));

            case 4:
              data = _context.sent;

              if (!data) {
                _context.next = 7;
                break;
              }

              return _context.abrupt('return', dispatch(receiveAccountSettlementPositions(data)));

            case 7:
              return _context.abrupt('return', dispatch(fetchAccountSettlementPositionsError(data.errormsg)));

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apex__ = __webpack_require__(21);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AccountEventsSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(AccountEventsSubscriptionService, _BaseSubscriptionServ);

  function AccountEventsSubscriptionService() {
    _classCallCheck(this, AccountEventsSubscriptionService);

    return _possibleConstructorReturn(this, (AccountEventsSubscriptionService.__proto__ || Object.getPrototypeOf(AccountEventsSubscriptionService)).apply(this, arguments));
  }

  _createClass(AccountEventsSubscriptionService, [{
    key: 'initSubscription',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(options) {
        var AccountId, OMSId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                AccountId = options.AccountId, OMSId = options.OMSId;


                __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.subscribeAccountEvents(AccountId, OMSId);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initSubscription(_x) {
        return _ref.apply(this, arguments);
      }

      return initSubscription;
    }()
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.ws.filter(function (i) {
        return i.n === 'AccountInfoUpdateEvent';
      }).subscribe(function (res) {
        var update = JSON.parse(res.o);
        callback(update);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return AccountEventsSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_1__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new AccountEventsSubscriptionService());

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_MARGIN_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_MARGIN_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_MARGIN_PRODUCT_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMarginProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return subscribeToMarginAccountProducts; });
/* unused harmony export receiveMarginProductEvent */
/* unused harmony export requestingMarginProducts */
/* unused harmony export receiveMarginProducts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_marginAccountProductStateSubscriptionService__ = __webpack_require__(1119);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var REQUEST_MARGIN_PRODUCTS = 'REQUEST_MARGIN_PRODUCTS';
var RECEIVE_MARGIN_PRODUCTS = 'RECEIVE_MARGIN_PRODUCTS';
var RECEIVE_MARGIN_PRODUCT_EVENT = 'RECEIVE_MARGIN_PRODUCT_EVENT';

var getMarginProducts = function getMarginProducts(AccountId, OMSId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var responseObj;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch(requestingMarginProducts);
              _context.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetMarginAccountPositions', {
                OMSId: OMSId,
                AccountId: AccountId
              }));

            case 4:
              responseObj = _context.sent;


              if (responseObj && responseObj.result === false) {
                console.error('getMarginProducts error: ', responseObj.errormsg);
              } else {
                dispatch(receiveMarginProducts(responseObj));
              }
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              console.error('getMarginProducts error: ', _context.t0);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var subscribeToMarginAccountProducts = function subscribeToMarginAccountProducts(AccountId, OMSId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_marginAccountProductStateSubscriptionService__["a" /* default */].subscribe(function (update) {
                dispatch(receiveMarginProductEvent(update));
              });

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var receiveMarginProductEvent = function receiveMarginProductEvent(payload) {
  return {
    type: RECEIVE_MARGIN_PRODUCT_EVENT,
    payload: payload
  };
};

var requestingMarginProducts = {
  type: REQUEST_MARGIN_PRODUCTS
};

var receiveMarginProducts = function receiveMarginProducts(payload) {
  return {
    type: RECEIVE_MARGIN_PRODUCTS,
    payload: payload
  };
};

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_languageActions__ = __webpack_require__(238);


var languageMiddleware = function languageMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actions_languageActions__["a" /* LANGUAGE_CHANGED */]) {
        var lang = action.payload.lang;

        if (localStorage.getItem('language') !== lang) {
          localStorage.setItem('language', lang);
        }
      }
      return next(action);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (languageMiddleware);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_instrumentActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_recalculateOrderHelper__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_orderHelper__ = __webpack_require__(35);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 * Responsible for recalculate order fee and total amount when order entry form values are changed (default and advanced)
 */
var placeOrderMiddleware = function placeOrderMiddleware(store) {
  return function (next) {
    return function (action) {
      var _store$getState = store.getState(),
          form = _store$getState.form,
          level2 = _store$getState.apexCore.level2;

      var advancedOrderEntryFormIsInitialized = !!form.advancedOrderEntry;
      var reportBlockTradeFromIsInitialized = !!form.reportBlockTrade;

      if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers_recalculateOrderHelper__["a" /* isOrderEntryFormChanged */])(action)) {
        if (action.meta.field === 'instrument') {
          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions_instrumentActions__["e" /* selectInstrument */])(parseInt(action.payload, 10)));
          return next(action);
        }

        var orderEntryForm = form.orderEntry;
        if (advancedOrderEntryFormIsInitialized) {
          orderEntryForm = form.advancedOrderEntry;
        } else if (reportBlockTradeFromIsInitialized) {
          orderEntryForm = form.reportBlockTrade;
        }

        var updatedForm = Object.assign({}, orderEntryForm.values, _defineProperty({}, action.meta.field, action.payload));

        Object(__WEBPACK_IMPORTED_MODULE_1__helpers_recalculateOrderHelper__["b" /* recalculateOrderFormValues */])(store, {
          form: updatedForm,
          formName: action.meta.form,
          orders: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_orderHelper__["h" /* getOrdersBySide */])(updatedForm.side, level2)
        });

        return next(action);
      }

      return next(action);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (placeOrderMiddleware);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REQUEST_RECENT_TRADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_RECENT_TRADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_RECENT_TRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_RECENT_TRADES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRecentTrades; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return subscribeToRecentTrades; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return unsubscribeRecentTrades; });
/* unused harmony export unsubscribeAllRecentTrades */
/* unused harmony export receiveRecentTrades */
/* unused harmony export receiveRecentTradesError */
/* unused harmony export requestRecentTrades */
/* unused harmony export addRecentTrade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_tradesSubscriptionService__ = __webpack_require__(1123);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var REQUEST_RECENT_TRADES = 'REQUEST_RECENT_TRADES';
var RECEIVE_RECENT_TRADES = 'RECEIVE_RECENT_TRADES';
var ADD_RECENT_TRADE = 'ADD_RECENT_TRADE';
var RECEIVE_RECENT_TRADES_ERROR = 'RECEIVE_RECENT_TRADES_ERROR';

/**
 * 1) Tell server to subscribe to trades data for passed `instrumentId`
 * 2) Get first portion of data
 */
var getRecentTrades = function getRecentTrades(instrumentId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestRecentTrades());
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_tradesSubscriptionService__["a" /* default */].initSubscribtion(instrumentId).then(function (res) {
                return dispatch(receiveRecentTrades(instrumentId, res));
              }).catch(function (e) {
                console.error(e);
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var subscribeToRecentTrades = function subscribeToRecentTrades() {
  return function (dispatch, getState) {
    var instrumentId = getState().apexCore.instrument.selectedInstrumentId;
    __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_tradesSubscriptionService__["a" /* default */].subscribe(function (updates) {
      dispatch(addRecentTrade(instrumentId, updates));
    }, instrumentId);
  };
};

var unsubscribeRecentTrades = function unsubscribeRecentTrades(instrumentId) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_tradesSubscriptionService__["a" /* default */].stopOne(instrumentId);
  };
};

var unsubscribeAllRecentTrades = function unsubscribeAllRecentTrades() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1__services_subscriptions_tradesSubscriptionService__["a" /* default */].stopAll();
  };
};

var receiveRecentTrades = function receiveRecentTrades(instrumentId, data) {
  return {
    type: RECEIVE_RECENT_TRADES,
    payload: {
      instrumentId: instrumentId,
      data: data
    }
  };
};

var receiveRecentTradesError = function receiveRecentTradesError(instrumentId, error) {
  return {
    type: RECEIVE_RECENT_TRADES_ERROR,
    payload: {
      instrumentId: instrumentId,
      error: error
    }
  };
};

var requestRecentTrades = function requestRecentTrades() {
  return {
    type: REQUEST_RECENT_TRADES
  };
};

var addRecentTrade = function addRecentTrade(instrumentId, data) {
  return {
    type: ADD_RECENT_TRADE,
    payload: {
      instrumentId: instrumentId,
      data: data
    }
  };
};

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return recalculateOrderFormValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isOrderEntryFormChanged; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placeOrderHelper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_orderTotalSelector__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_selectors_marginSelectors__ = __webpack_require__(34);


var _this = this;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











/**
 * Recalculate `order fee` and `total amount` for default order entry form
 */
var recalculateOrderFormValues = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(store, options) {
    var state, apexCore, level1, form, formName, initOrders, orders, selectedInstrument, totalAmount, isMarginActive, fee;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = store.getState();
            apexCore = state.apexCore;
            level1 = apexCore.level1;
            form = options.form, formName = options.formName, initOrders = options.orders;
            orders = [].concat(_toConsumableArray(initOrders));
            selectedInstrument = level1[Object(__WEBPACK_IMPORTED_MODULE_8__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state).InstrumentId] || {};

            form.side === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? orders.sort(function (a, b) {
              if (a.Price > b.Price) return 1;
              if (a.Price < b.Price) return -1;
              return 0;
            }) : orders.sort(function (a, b) {
              if (a.Price < b.Price) return 1;
              if (a.Price > b.Price) return -1;
              return 0;
            });

            totalAmount = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_orderTotalSelector__["a" /* orderTotalSelector */])(state, { form: form });

            if (totalAmount.toString() === 'NaN') totalAmount = 0;

            isMarginActive = Object(__WEBPACK_IMPORTED_MODULE_9__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state);
            fee = void 0;

            if (!isMarginActive) {
              _context.next = 24;
              break;
            }

            _context.prev = 12;
            _context.next = 15;
            return getMarginOrderFeeForDefaultForm(store, form, totalAmount, selectedInstrument);

          case 15:
            fee = _context.sent;


            store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(formName, 'fee', fee));
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context['catch'](12);

            console.error('gerMarginOrderFee error: ', _context.t0);

          case 22:
            _context.next = 28;
            break;

          case 24:
            _context.next = 26;
            return getOrderFeeForDefaultForm(store, form, totalAmount, selectedInstrument);

          case 26:
            fee = _context.sent;


            store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(formName, 'fee', fee));

          case 28:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[12, 19]]);
  }));

  return function recalculateOrderFormValues(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var isOrderEntryFormChanged = function isOrderEntryFormChanged(_ref2) {
  var type = _ref2.type,
      meta = _ref2.meta;

  return type === __WEBPACK_IMPORTED_MODULE_1_redux_form__["d" /* actionTypes */].CHANGE && !__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(['fee'], meta.field) && __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(['orderEntry', 'advancedOrderEntry', 'reportBlockTrade'], meta.form);
};

var getOrderFeeForDefaultForm = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(store, orderEntryForm, totalAmount, selectedInstrument) {
    var price, side, quantity, amount, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            price = getPriceForGetOrderFeeRequest(orderEntryForm, selectedInstrument);
            side = parseInt(orderEntryForm.side, 10);
            quantity = getQuantityForGetOrderFeeRequest(orderEntryForm, totalAmount);
            amount = getAmountForGetOrderFeeRequest(orderEntryForm);
            _context2.next = 6;
            return __WEBPACK_IMPORTED_MODULE_3__apex__["a" /* default */].connection.GetOrderFee(Object.assign({}, getBaseOptionsForGetOrderFeeRequest(store), {
              InstrumentId: selectedInstrument.InstrumentId,
              Amount: amount,
              Quantity: quantity,
              Side: side,
              Price: price,
              OrderType: parseInt(Object(__WEBPACK_IMPORTED_MODULE_5__placeOrderHelper__["c" /* getOrderTypeByName */])(orderEntryForm.orderType), 10),
              MakerTaker: Object(__WEBPACK_IMPORTED_MODULE_4__orderHelper__["m" /* isMakerOrTaker */])(orderEntryForm.side, price, selectedInstrument.BestBid, selectedInstrument.BestOffer, orderEntryForm.orderType)
            }));

          case 6:
            response = _context2.sent;
            return _context2.abrupt('return', response);

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function getOrderFeeForDefaultForm(_x3, _x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var getMarginOrderFeeForDefaultForm = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(store, orderEntryForm, totalAmount, selectedInstrument) {
    var state, price, side, amount, marginAccount, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            state = store.getState();
            price = getPriceForGetOrderFeeRequest(orderEntryForm, selectedInstrument);
            side = parseInt(orderEntryForm.side, 10);
            amount = side === 1 ? totalAmount : orderEntryForm.quantity;
            marginAccount = Object(__WEBPACK_IMPORTED_MODULE_9__redux_selectors_marginSelectors__["e" /* marginAccountSelector */])(state);
            _context3.next = 7;
            return __WEBPACK_IMPORTED_MODULE_3__apex__["a" /* default */].connection.RPCPromise('GetMarginOrderFee', {
              OMSId: 1,
              AccountId: marginAccount.AccountId,
              InstrumentId: selectedInstrument.InstrumentId,
              Amount: amount,
              Quantity: orderEntryForm.quantity,
              Side: side,
              Price: price,
              OrderType: parseInt(Object(__WEBPACK_IMPORTED_MODULE_5__placeOrderHelper__["c" /* getOrderTypeByName */])(orderEntryForm.orderType), 10),
              MakerTaker: Object(__WEBPACK_IMPORTED_MODULE_4__orderHelper__["m" /* isMakerOrTaker */])(orderEntryForm.side, price, selectedInstrument.BestBid, selectedInstrument.BestOffer, orderEntryForm.orderType)
            });

          case 7:
            response = _context3.sent;
            return _context3.abrupt('return', JSON.parse(response.o));

          case 9:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function getMarginOrderFeeForDefaultForm(_x7, _x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();

var getBaseOptionsForGetOrderFeeRequest = function getBaseOptionsForGetOrderFeeRequest(store) {
  var _store$getState = store.getState(),
      user = _store$getState.user;

  return {
    OMSId: user.userInfo.OMSId,
    AccountId: user.selectedAccountId
  };
};

var getPriceForGetOrderFeeRequest = function getPriceForGetOrderFeeRequest(formValues, selectedInstrument) {
  if (formValues.orderType === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].market.displayName) {
    if (formValues.side === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]) {
      return selectedInstrument.BestOffer;
    }
    return selectedInstrument.BestBid;
  }

  if (formValues.orderType === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName) {
    return formValues.stopPrice;
  }

  if (formValues.orderType === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].reportBlockTrade.displayName) {
    var quantity = formValues.quantity,
        price = formValues.price;

    if (!quantity || !price) return undefined;
    if (formValues.side === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]) {
      if (formValues.quantity <= 0) {
        formValues.quantity = 1;
      }

      if (formValues.useNewForm) {
        // "useNewForm" indicates that we are treating the BlockTrade form
        // like a standard order entry, where user inputs the intended price.
        return formValues.price;
      }

      return formValues.price / formValues.quantity;
    } else {
      if (formValues.price <= 0) {
        formValues.price = 1;
      }

      return formValues.quantity / formValues.price;
    }
  }

  return formValues.limitPrice ? formValues.limitPrice : undefined;
};

var getQuantityForGetOrderFeeRequest = function getQuantityForGetOrderFeeRequest(formValues) {
  if (formValues.orderType === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].reportBlockTrade.displayName) {
    var price = formValues.price;

    if (!price) {
      formValues.quantity = 0;
      return undefined;
    }

    if (formValues.side === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */]) {
      return formValues.price;
    }
  }

  return formValues.quantity;
};

var getAmountForGetOrderFeeRequest = function getAmountForGetOrderFeeRequest(formValues, totalAmount) {
  if (formValues.orderType === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].reportBlockTrade.displayName) {
    return 0;
  }

  return formValues.side === 1 ? totalAmount : formValues.quantity;
};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(512),
    isArrayLike = __webpack_require__(141),
    isString = __webpack_require__(1129),
    toInteger = __webpack_require__(316),
    values = __webpack_require__(1131);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1126),
    baseIsNaN = __webpack_require__(1127),
    strictIndexOf = __webpack_require__(1128);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1133),
    isArguments = __webpack_require__(242),
    isArray = __webpack_require__(63),
    isBuffer = __webpack_require__(243),
    isIndex = __webpack_require__(245),
    isTypedArray = __webpack_require__(318);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(247),
    nativeKeys = __webpack_require__(1137);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export startupMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_appActions__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_i18n__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_productActions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_instrumentActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_productManifestActions__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_languageActions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_apiActions__ = __webpack_require__(26);








var startupMiddleware = function startupMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actions_appActions__["a" /* LOAD_STARTUP_DATA */]) {
        var selectedInstrumentId = Number(localStorage.getItem('selectedInstrumentId'));

        Promise.all([store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_i18n__["setTranslations"])(window.APEXTranslations)), store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_productActions__["d" /* getProducts */])()), store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_instrumentActions__["d" /* fetchInstruments */])({ selectedInstrumentId: selectedInstrumentId })), store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_productManifestActions__["d" /* getProductManifest */])())]).then(function () {
          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_languageActions__["c" /* retrieveLanguage */])());
          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions_appActions__["c" /* startupDataLoaded */])());
        }).catch(function (err) {
          return console.error(err);
        });

        store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_apiActions__["c" /* getApiInfo */])());
      }

      return next(action);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (startupMiddleware);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_PRODUCT_MANIFEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_PRODUCT_MANIFEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_PRODUCT_MANIFEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductManifest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_path__ = __webpack_require__(27);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var REQUEST_PRODUCT_MANIFEST = 'REQUEST_PRODUCT_MANIFEST';
var RECEIVE_PRODUCT_MANIFEST = 'RECEIVE_PRODUCT_MANIFEST';
var ERROR_PRODUCT_MANIFEST = 'ERROR_PRODUCT_MANIFEST';

var getProductManifest = function getProductManifest() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestingProductManifest);
              fetch(Object(__WEBPACK_IMPORTED_MODULE_1__helpers_path__["a" /* default */])('/local/product-manifest.json')).then(function (res) {
                return res.json();
              }).then(function (json) {
                dispatch(receiveProductManifest(json));
              }).catch(function (error) {
                dispatch(errorProductManifest(error));
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var requestingProductManifest = {
  type: REQUEST_PRODUCT_MANIFEST,
  payload: {}
};

var receiveProductManifest = function receiveProductManifest(payload) {
  return {
    type: RECEIVE_PRODUCT_MANIFEST,
    payload: payload
  };
};

var errorProductManifest = function errorProductManifest(payload) {
  return {
    type: ERROR_PRODUCT_MANIFEST,
    payload: payload
  };
};

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_appActions__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_wsConnectionActions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_lifeCycleActions__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_delay__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_delay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_snackbarActions__ = __webpack_require__(20);








// delays[0] will never be used,
// but it gets the rest of the value's indexes to align with wsCloseCount
var delays = [0, 10000, 10000, 10000, 30000, 30000, 30000, 60000, 60000, 60000, 120000];

/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  return function (next) {
    return function (action) {
      switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1__actions_wsConnectionActions__["c" /* CONNECTION_OPENED */]:
          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_wsConnectionActions__["f" /* connectionClosedCount */])(0));
          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions_appActions__["b" /* loadStartupData */])());
          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_lifeCycleActions__["b" /* onInit */])());
          break;
        case __WEBPACK_IMPORTED_MODULE_1__actions_wsConnectionActions__["a" /* CONNECTION_CLOSED */]:
          var wsCloseCount = store.getState().wsConnection.tries + 1;
          var delayTimer = wsCloseCount >= delays.length ? delays[delays.length - 1] : delays[wsCloseCount];

          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_wsConnectionActions__["f" /* connectionClosedCount */])(wsCloseCount));
          store.dispatch(connectionWarningSnackbar(wsCloseCount, delayTimer));

          var open = Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_1__actions_wsConnectionActions__["g" /* connectionOpened */], store.dispatch);
          var close = Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_1__actions_wsConnectionActions__["e" /* connectionClosed */], store.dispatch);
          __WEBPACK_IMPORTED_MODULE_3_lodash_delay___default()(__WEBPACK_IMPORTED_MODULE_5__apex__["c" /* initApex */], delayTimer, open, close);
          break;
        default:
          break;
      }

      return next(action);
    };
  };
});

var connectionWarningSnackbar = function connectionWarningSnackbar(attemptCount, delayTimer) {
  // context.t('Connection with server lost. Attempting reconnect...')
  var snackText = 'Connection with server lost. Attempting reconnect...';
  if (attemptCount > 1) {
    // context.t('Still unable to connect after {attemptCount} attempts, trying again...')
    snackText = 'Still unable to connect after {attemptCount} attempts, trying again...';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_6__actions_snackbarActions__["e" /* showSnack */])({
    id: 'websocketConnectionLost',
    text: snackText,
    textVars: { attemptCount: attemptCount },
    type: 'warning',
    timeout: delayTimer
  });
};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1140);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1141),
    shortOut = __webpack_require__(1143);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(118);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPriceAndQuantityForRequest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_recalculateOrderHelper__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Retail_RetailBuySell_BuySell_BuySellLayoutTypes__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








/**
 * Middleware for calculating order fee for 'RetailOrderOverviewComponent.js'
 */
var orderFeeMiddleware = function orderFeeMiddleware(store) {
  return function (next) {
    return function (action) {
      var _store$getState = store.getState(),
          form = _store$getState.form,
          level2 = _store$getState.apexCore.level2;

      if (isFeeShouldBeRecalculated(action)) {
        var buySellFormIsInitialized = !!form.buySell;
        var entryForm = {};

        if (buySellFormIsInitialized) {
          entryForm = form.buySell;

          var selectedValue = getPriceAndQuantityForRequest(entryForm, store.getState(), action);

          // This calculation is duplicated in RetailOrderOverviewContainer
          var _config$OrderCalcBuff = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].OrderCalcBuffer;
          _config$OrderCalcBuff = _config$OrderCalcBuff === undefined ? {} : _config$OrderCalcBuff;
          var quantityBuffer = _config$OrderCalcBuff.quantityBuffer;
          var side = entryForm.values.side;

          var orders = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_orderHelper__["h" /* getOrdersBySide */])(side, level2);
          var limitPrice = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_orderHelper__["j" /* getQuantityForPrice */])(0, quantityBuffer, orders, false, side).LimitPrice;

          var updatedForm = Object.assign({}, entryForm.values, _defineProperty({
            limitPrice: limitPrice
          }, action.meta.field, action.payload));

          updatedForm.quantity = selectedValue.quantity;

          Object(__WEBPACK_IMPORTED_MODULE_0__helpers_recalculateOrderHelper__["b" /* recalculateOrderFormValues */])(store, {
            form: updatedForm,
            formName: 'buySell',
            orders: orders
          });
        }
      }

      return next(action);
    };
  };
};

var getPriceAndQuantityForRequest = function getPriceAndQuantityForRequest(form, state) {
  var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { meta: {} };

  var isPricePerUnitForm = form.values.layoutType === __WEBPACK_IMPORTED_MODULE_4__components_Retail_RetailBuySell_BuySell_BuySellLayoutTypes__["a" /* BUY_SELL_LAYOUTS */].PRICE_PER_UNIT;

  var dealValues = isPricePerUnitForm ? Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["e" /* getQuantityDataForPresetAndCustomValuesSelector */])(state, form.values.side) : Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["b" /* getPriceDataForPresetAndCustomValuesSelector */])(state, form.values.side);

  var selectedValue = { price: '0', quantity: '0' };

  if (action.meta.field === 'instrument') {
    selectedValue = getValuesFromCustomChange(form, action);
  }

  // switch to `deal values` radio position
  else if (action.meta.field === 'amountRadio' && action.payload !== 'custom') {
      var fieldToSearch = isPricePerUnitForm ? 'quantity' : 'price';
      selectedValue = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_orderHelper__["l" /* getValuesFromDealValues */])(dealValues, action.payload, fieldToSearch);
    }

    // switch to `custom` radio position
    else if (action.meta.field === 'amountRadio' && action.payload === 'custom') {
        selectedValue = getValuesFromCustomChange(form, action);
      }

      // sync `price` and `quantity` if `price` or `quantity` is changed
      else if (action.meta.field === 'price' || action.meta.field === 'quantity') {
          selectedValue = getValuesFromCustomChange(form, action);
        }

  return selectedValue;
};

var getValuesFromCustomChange = function getValuesFromCustomChange(_ref, action) {
  var values = _ref.values;
  var field = action.meta.field;


  return {
    price: field === 'price' ? action.payload : values.price,
    quantity: field === 'quantity' ? action.payload : values.quantity
  };
};

var isFeeShouldBeRecalculated = function isFeeShouldBeRecalculated(action) {
  return action.type === __WEBPACK_IMPORTED_MODULE_2_redux_form__["d" /* actionTypes */].CHANGE && action.meta.field !== 'fee' && action.meta.field !== 'responseMessage' && action.meta.form === 'buySell';
};

/* harmony default export */ __webpack_exports__["a"] = (orderFeeMiddleware);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_marginActions__ = __webpack_require__(57);



var initializedFromForm = function initializedFromForm(action) {
  return action.type === '@@redux-form/INITIALIZE' && action.meta.form === 'tradingStyle';
};

var marginCheck = false;

var authMiddleware = function authMiddleware(store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch,
          getState = store.getState;

      var _getState = getState(),
          _getState$user$userIn = _getState.user.userInfo,
          MarginBorrowerEnabled = _getState$user$userIn.MarginBorrowerEnabled,
          OMSId = _getState$user$userIn.OMSId,
          margin = _getState.margin;

      if (MarginBorrowerEnabled && (initializedFromForm(action) || action.type === 'RECEIVE_ACCOUNT')) {
        if (localStorage.getItem('tradingStyle') === 'Margin') {
          next(action);
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_marginActions__["n" /* enableMargin */])());
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["e" /* change */])('tradingStyle', 'tradingStyle', 'Margin'));
          return;
        }
      }

      /**
       * Only call this once to check if the endpoint exists on Gateway.
       * This is a decent proxy for if Margin is enabled by operator.
       */
      if (MarginBorrowerEnabled && !marginCheck && margin.accountState.settings.BasedAssetId === undefined) {
        marginCheck = true;
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_marginActions__["p" /* getMarginSettings */])(OMSId));
      }

      return next(action);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (authMiddleware);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);





/**
 * Fields which *should* be incremented via Instrument.PriceIncrement
 *  + QuantityIncrement settings.
 */
var fieldMap = {
  limitPrice: true,
  stopPrice: true,
  quantity: true,
  trailingAmount: true,
  limitOffset: true
};

var validForms = {
  orderEntry: true,
  advancedOrderEntry: true,
  reportBlockTrade: true
};

/**
 * Snap form values to Instrument.PriceIncrement.
 */
var priceQuantityIncrementMiddleware = function priceQuantityIncrementMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === '@@redux-form/BLUR' && validForms[__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(action, 'meta.form')] && fieldMap[__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(action, 'meta.field')]) {
        var state = store.getState();

        var _selectedInstrumentSe = Object(__WEBPACK_IMPORTED_MODULE_1__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
            PriceIncrement = _selectedInstrumentSe.PriceIncrement,
            QuantityIncrement = _selectedInstrumentSe.QuantityIncrement;

        var Increment = action.meta.field === 'quantity' ? QuantityIncrement : PriceIncrement;

        var val = Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["g" /* formValueSelector */])(action.meta.form)(state, action.meta.field);
        var incrementedVal = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_decimalPlaces_decimalPlacesHelper__["b" /* incrementUiValue */])(val, Increment);

        if (val !== incrementedVal) {
          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["e" /* change */])(action.meta.form, action.meta.field, incrementedVal));
        }
      }

      return next(action);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (priceQuantityIncrementMiddleware);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors_level2Selectors__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);





var level2MonitorInterval = __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].Middleware.level2MonitorInterval;


var intervalSingleton = void 0;

var orderBookSanityCheck = function orderBookSanityCheck(state) {
  var buy = Object(__WEBPACK_IMPORTED_MODULE_1__selectors_level2Selectors__["a" /* level2BuySelector */])(state, {});
  var sell = Object(__WEBPACK_IMPORTED_MODULE_1__selectors_level2Selectors__["c" /* level2SellSelector */])(state, {});

  var InsideBid = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(buy, [buy.length - 1, 'Price'], 0);
  var InsideAsk = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(sell, [0, 'Price'], Number.MAX_VALUE);

  return InsideBid > InsideAsk;
};

var level2monitor = function level2monitor(store) {
  return function (next) {
    return function (action) {
      if (action.type === __WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__["c" /* REQUEST_LEVEL_2_DATA */]) {
        intervalSingleton = setInterval(function () {
          var state = store.getState();
          if (orderBookSanityCheck(state)) {
            var _selectedInstrumentSe = Object(__WEBPACK_IMPORTED_MODULE_3__selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
                InstrumentId = _selectedInstrumentSe.InstrumentId;

            store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__["g" /* unsubscribeLevel2 */])(InstrumentId));
            store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__["e" /* getLevel2Data */])(InstrumentId));
          }
        }, level2MonitorInterval);
      }

      if (action.type === __WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__["d" /* UNSUBSCRIBE_LEVEL2 */]) {
        window.clearInterval(intervalSingleton);
      }

      return next(action);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (level2monitor);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_affiliateActions__ = __webpack_require__(121);




var initialState = {
  affiliateTag: '',
  affiliateCount: 0
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_affiliateActions__["c" /* UPDATE_AFFILIATE_SUCCESS */]:
      return Object.assign({}, state, {
        affiliateTag: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_affiliateActions__["b" /* GET_AFFILIATE_SUCCESS */]:
      return Object.assign({}, state, {
        affiliateTag: payload.AffiliateTag
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_affiliateActions__["a" /* GET_AFFILIATE_COUNT_SUCCESS */]:
      return Object.assign({}, state, {
        affiliateCount: payload.Count
      });
    default:
      return state;
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = api;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_apiActions__ = __webpack_require__(26);


function api() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    validate2FARequiredEndpoints: {}
  };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_apiActions__["a" /* RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS */]:
      return Object.assign({}, state, {
        validate2FARequiredEndpoints: action.payload.reduce(makeObjFromArray, {})
      });
    default:
      return state;
  }
}

var makeObjFromArray = function makeObjFromArray(acc, el) {
  acc[el] = true;
  return acc;
};

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_apiKeyActions__ = __webpack_require__(172);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  apiKeys: [],
  isLoading: false
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_apiKeyActions__["c" /* GET_API_KEYS_SUCCESS */]:
      return Object.assign({}, state, {
        apiKeys: payload,
        isLoading: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_apiKeyActions__["b" /* GET_API_KEYS_REQUESTED */]:
      {
        return Object.assign({}, state, {
          isLoading: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_apiKeyActions__["a" /* ADD_API_KEY */]:
      return Object.assign({}, state, {
        apiKeys: [].concat(_toConsumableArray(state.apiKeys), [payload])
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_apiKeyActions__["d" /* REMOVE_API_KEY_SUCCESS */]:
      return Object.assign({}, state, {
        apiKeys: state.apiKeys.filter(function (key) {
          return key.APIKey !== payload;
        })
      });
    default:
      return state;
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_kycActions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_kycManualActions__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_verifyEmailActions__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_resetPasswordActions__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_confirmWithdrawActions__ = __webpack_require__(323);






var initialState = {
  processingValidateUserRegistration: false,
  processingSetUserConfig: false,
  processingVerifyEmail: false,
  processingResetPassword: false,
  processingConfirmWithdraw: false
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_kycActions__["b" /* PROCESSING_VALIDATE_USER_REGISTRATION */]:
      return Object.assign({}, state, {
        processingValidateUserRegistration: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_kycActions__["a" /* FINISHED_VALIDATE_USER_REGISTRATION */]:
      return Object.assign({}, state, {
        processingValidateUserRegistration: false
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_kycManualActions__["b" /* PROCESSING_SET_USER_CONFIG */]:
      return Object.assign({}, state, {
        processingSetUserConfig: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_kycManualActions__["a" /* FINISHED_SET_USER_CONFIG */]:
      return Object.assign({}, state, {
        processingSetUserConfig: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_verifyEmailActions__["b" /* PROCESSING_VERIFY_EMAIL */]:
      return Object.assign({}, state, {
        processingVerifyEmail: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_verifyEmailActions__["a" /* FINISHED_VERIFY_EMAIL */]:
      return Object.assign({}, state, {
        processingVerifyEmail: false
      });
    case __WEBPACK_IMPORTED_MODULE_3__actions_resetPasswordActions__["c" /* PROCESSING_RESET_PASSWORD */]:
      return Object.assign({}, state, {
        processingResetPassword: true
      });
    case __WEBPACK_IMPORTED_MODULE_3__actions_resetPasswordActions__["b" /* FINISHED_RESET_PASSWORD */]:
      return Object.assign({}, state, {
        processingResetPassword: false
      });
    case __WEBPACK_IMPORTED_MODULE_4__actions_confirmWithdrawActions__["b" /* PROCESSING_CONFIRM_WITHDRAW */]:
      return Object.assign({}, state, {
        processingConfirmWithdraw: true
      });
    case __WEBPACK_IMPORTED_MODULE_4__actions_confirmWithdrawActions__["a" /* FINISHED_CONFIRM_WITHDRAW */]:
      return Object.assign({}, state, {
        processingConfirmWithdraw: false
      });
    default:
      return state;
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROCESSING_SET_USER_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINISHED_SET_USER_CONFIG; });
/* unused harmony export processingSetUserConfig */
/* unused harmony export finishedSetUserConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setUserConfigForManualKYC; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kycActions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__snackbarActions__ = __webpack_require__(20);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var PROCESSING_SET_USER_CONFIG = 'PROCESSING_SET_USER_CONFIG';
var FINISHED_SET_USER_CONFIG = 'FINISHED_SET_USER_CONFIG';

var processingSetUserConfig = {
  type: PROCESSING_SET_USER_CONFIG
};
var finishedSetUserConfig = {
  type: FINISHED_SET_USER_CONFIG
};

var setUserConfigForManualKYC = function setUserConfigForManualKYC(UserId, UserName, underReviewLevel, Config) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var userConfig;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(processingSetUserConfig);

              _context.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('SetUserConfig', {
                UserId: UserId,
                UserName: UserName,
                Config: Config
              }));

            case 3:
              userConfig = _context.sent;

              if (userConfig.result !== false) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__kycActions__["h" /* temporarilySetLevelIncreaseStatus */])({ underReviewLevel: underReviewLevel }));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__snackbarActions__["e" /* showSnack */])({
                  id: 'setUserConfigForKYCSuccess',
                  // context.t('Your information has been submitted and is under review. Your verification status will be updated 24-48 hours from the time of submission.')
                  text: 'Your information has been submitted and is under review. Your verification status will be updated 24-48 hours from the time of submission.',
                  type: 'success'
                }));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__sidePaneActions__["f" /* closeKYCSidePane */])());
              } else {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__snackbarActions__["e" /* showSnack */])({
                  id: 'setUserConfigForKYCError',
                  // context.t('There was an error in submitting your information. Please try again.')
                  text: 'There was an error in submitting your information. Please try again.',
                  type: 'warning'
                }));
              }
              dispatch(finishedSetUserConfig);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = auth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_authActions__ = __webpack_require__(89);


var initialState = {
  isAuthenticated: false,
  userId: null,
  token: null,
  errorMsg: null,
  pending: false,
  is2FARequired: false,
  shouldRedirect: false,
  location: {}
};

function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_authActions__["e" /* AUTH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_authActions__["b" /* AUTH_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_authActions__["c" /* AUTH_NONE */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_authActions__["d" /* AUTH_REDIRECT */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_authActions__["a" /* AUTH_2FA_REQUIRED */]:
      return Object.assign({}, state, action.payload);
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_confirmWithdrawActions__ = __webpack_require__(323);


var initialState = {
  error: false,
  message: ''
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_confirmWithdrawActions__["a" /* FINISHED_CONFIRM_WITHDRAW */]:
      return Object.assign({}, state, {
        error: payload.error,
        message: payload.message
      });
    default:
      {
        return state;
      }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eotc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_eotcActions__ = __webpack_require__(534);


var initialState = {
  isLoading: false,
  error: '',
  creditTiers: []
};

function eotc() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcActions__["b" /* FETCHING_ACCOUNT_CREDIT_TIERS */]:
      return Object.assign({}, state, {
        isLoading: true
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcActions__["d" /* RECEIVE_ACCOUNT_CREDIT_TIERS */]:
      return Object.assign({}, state, {
        creditTiers: payload,
        error: '',
        isLoading: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcActions__["c" /* FETCH_ACCOUNT_CREDIT_TIERS_ERROR */]:
      return Object.assign({}, state, {
        error: payload,
        isLoading: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initSubscribePrices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PRICE; });
/* unused harmony export addPrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCHING_ACCOUNT_CREDIT_TIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ACCOUNT_CREDIT_TIERS_ERROR; });
/* unused harmony export fetchingAccountCreditTiers */
/* unused harmony export fetchAccountCreditTiersError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_ACCOUNT_CREDIT_TIERS; });
/* unused harmony export receiveAccountCreditTiers */
/* unused harmony export getCreditTiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_PriceUpdateSubscriptionService__ = __webpack_require__(1144);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var initSubscribePrices = function initSubscribePrices(callback, instrumentId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var _getState, instrument, user;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), instrument = _getState.apexCore.instrument, user = _getState.user;


              __WEBPACK_IMPORTED_MODULE_2__services_subscriptions_PriceUpdateSubscriptionService__["a" /* default */].initSubscription({
                InstrumentId: instrumentId ? instrumentId : instrument.selectedInstrumentId,
                OMSId: user.userInfo.OMSId
              }, callback);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var ADD_PRICE = 'ADD_PRICE';
var addPrice = function addPrice(payload) {
  return {
    type: ADD_PRICE,
    payload: payload
  };
};

var FETCHING_ACCOUNT_CREDIT_TIERS = 'FETCHING_ACCOUNT_CREDIT_TIERS';

var FETCH_ACCOUNT_CREDIT_TIERS_ERROR = 'FETCH_ACCOUNT_CREDIT_TIERS_ERROR';

var fetchingAccountCreditTiers = {
  type: FETCHING_ACCOUNT_CREDIT_TIERS
};

var fetchAccountCreditTiersError = function fetchAccountCreditTiersError(payload) {
  return {
    type: FETCH_ACCOUNT_CREDIT_TIERS_ERROR,
    payload: payload
  };
};

var RECEIVE_ACCOUNT_CREDIT_TIERS = 'RECEIVE_ACCOUNT_CREDIT_TIERS';

var receiveAccountCreditTiers = function receiveAccountCreditTiers(payload) {
  return {
    type: RECEIVE_ACCOUNT_CREDIT_TIERS,
    payload: payload
  };
};

var getCreditTiers = function getCreditTiers() {
  var AccountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var Level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var payload, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fetchingAccountCreditTiers);

              payload = {
                OMSId: getState().user.userInfo.OMSId,
                Level: Level,
                AccountId: AccountId
              };
              _context2.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetCreditTiers', payload));

            case 4:
              data = _context2.sent;

              if (!data) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt('return', dispatch(receiveAccountCreditTiers(data)));

            case 7:
              return _context2.abrupt('return', dispatch(fetchAccountCreditTiersError(data.errormsg)));

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eotcWithdraw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_eotcWithdrawActions__ = __webpack_require__(536);


var initialState = {
  isLoading: false,
  error: '',
  withdrawInfos: []
};

function eotcWithdraw() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcWithdrawActions__["b" /* FETCHING_ACCOUNT_WITHDRAW_INFOS */]:
      return Object.assign({}, state, {
        isLoading: true
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcWithdrawActions__["c" /* RECEIVE_ACCOUNT_WITHDRAW_INFOS */]:
      return Object.assign({}, state, {
        withdrawInfos: payload,
        error: '',
        isLoading: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcWithdrawActions__["a" /* ACCOUNT_WITHDRAW_INFOS_ERROR */]:
      return Object.assign({}, state, {
        error: payload,
        isLoading: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCHING_ACCOUNT_WITHDRAW_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_ACCOUNT_WITHDRAW_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_WITHDRAW_INFOS_ERROR; });
/* unused harmony export SELECT_WITHDRAW_BANK */
/* unused harmony export fetchingAccountWithdrawInfos */
/* unused harmony export receiveAccountWithdrawInfos */
/* unused harmony export accountWithdrawInfosError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectWithdrawBank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchAccountWithdrawInfos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var FETCHING_ACCOUNT_WITHDRAW_INFOS = 'FETCHING_ACCOUNT_WITHDRAW_INFOS';
var RECEIVE_ACCOUNT_WITHDRAW_INFOS = 'RECEIVE_ACCOUNT_WITHDRAW_INFOS';
var ACCOUNT_WITHDRAW_INFOS_ERROR = 'ACCOUNT_WITHDRAW_INFOS_ERROR';
var SELECT_WITHDRAW_BANK = 'SELECT_WITHDRAW_BANK';

var fetchingAccountWithdrawInfos = {
  type: FETCHING_ACCOUNT_WITHDRAW_INFOS
};

var receiveAccountWithdrawInfos = function receiveAccountWithdrawInfos(payload) {
  return {
    type: RECEIVE_ACCOUNT_WITHDRAW_INFOS,
    payload: payload
  };
};

var accountWithdrawInfosError = function accountWithdrawInfosError(payload) {
  return {
    type: ACCOUNT_WITHDRAW_INFOS_ERROR,
    payload: payload
  };
};

var selectWithdrawBank = function selectWithdrawBank(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var withdrawInfos, bank;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              withdrawInfos = getState().eotcWithdraw.withdrawInfos;
              bank = withdrawInfos.find(function (i) {
                return i.AccountWithdrawInfoId === payload;
              });


              if (bank) {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('createFiatWithdraw', 'Name', bank['Name']));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('createFiatWithdraw', 'AccountIdentifier', bank['AccountIdentifier']));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('createFiatWithdraw', 'AccountWithdrawInfoId', bank['AccountWithdrawInfoId']));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('createFiatWithdraw', 'BankAccountNumber', bank['Name'] + ' - *' + bank['AccountIdentifier']));
              } else if (payload === 'default') {
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('createFiatWithdraw', 'Name', ''));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('createFiatWithdraw', 'AccountIdentifier', ''));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('createFiatWithdraw', 'AccountWithdrawInfoId', ''));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('createFiatWithdraw', 'BankAccountNumber', ''));
              }

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var fetchAccountWithdrawInfos = function fetchAccountWithdrawInfos() {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var payload, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fetchingAccountWithdrawInfos);
              payload = {
                AccountId: getState().user.selectedAccountId,
                OMSId: getState().user.userInfo.OMSId
              };
              _context2.next = 4;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('GetAccountWithdrawInfos', payload));

            case 4:
              data = _context2.sent;

              if (!(data && !data.hasOwnProperty('errormsg'))) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt('return', dispatch(receiveAccountWithdrawInfos(data)));

            case 7:
              return _context2.abrupt('return', dispatch(accountWithdrawInfosError(data.errormsg)));

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eotc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_eotcSettlementActions__ = __webpack_require__(504);


var initialState = {
  isLoading: false,
  error: '',
  accountSettlementPositions: []
};

function eotc() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcSettlementActions__["a" /* FETCHING_ACCOUNT_SETTLEMENT_POSITIONS */]:
      return Object.assign({}, state, {
        isLoading: true
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcSettlementActions__["c" /* RECEIVE_ACCOUNT_SETTLEMENT_POSITIONS */]:
      return Object.assign({}, state, {
        accountSettlementPositions: payload,
        error: '',
        isLoading: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcSettlementActions__["b" /* FETCH_ACCOUNT_SETTLEMENT_POSITIONS_ERROR */]:
      return Object.assign({}, state, {
        error: payload,
        isLoading: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eotcPriceReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_eotcActions__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__ = __webpack_require__(88);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var initialState = {
  priceUpdates: {},
  lastPrices: {}
};

var formatPrice = function formatPrice(priceUpdate) {
  return {
    Time: priceUpdate[0],
    Bid: priceUpdate[2],
    Ask: priceUpdate[3],
    Mid: priceUpdate[4]
  };
};

var isPriceNewer = function isPriceNewer(lastPrice, newPrice) {
  if (!lastPrice) return true;
  if (lastPrice.Time < newPrice[0]) return true;
  return false;
};

function eotcPriceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_eotcActions__["a" /* ADD_PRICE */]:
      var InstrumentId = payload[1];

      var stateUpdate = Object.assign({}, state, {
        priceUpdates: _defineProperty({}, InstrumentId, Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])([formatPrice(payload)].concat(_toConsumableArray(state.priceUpdates[InstrumentId] || [])),
        /**
         * Treat timestamp as unique ID.
         */
        function (price) {
          return price.Time;
        }))
      });

      if (isPriceNewer(state.lastPrices[InstrumentId], payload)) {
        /**
         * Save as last price in state.
         */
        stateUpdate.lastPrices[InstrumentId] = formatPrice(payload);
      }

      return stateUpdate;

    default:
      return state;
  }
}

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deposit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_arrayHelper__ = __webpack_require__(88);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var initialState = {
  templateInfo: {},
  template: {},
  templateTypes: [],
  error: '',
  isLoading: false,
  depositInfo: [],
  depositStatus: {},
  depositsStatus: [],
  product: 0
};

function deposit() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["d" /* FETCH_PRODUCT_DEPOSIT_TEMPLATES */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["c" /* FETCH_PRODUCT_DEPOSIT_TEMPLATE */]:
      return Object.assign({}, state, {
        error: '',
        isLoading: true,
        product: payload.product,
        templateType: payload.templateType
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["b" /* FETCH_DEPOSIT_INFO */]:
      return Object.assign({}, state, {
        error: '',
        isLoading: true,
        product: payload.product
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["h" /* RECEIVE_DEPOSIT_TEMPLATES */]:
      {
        return Object.assign({}, state, {
          error: '',
          product: state.product,
          templateTypes: payload,
          isLoading: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["g" /* RECEIVE_DEPOSIT_TEMPLATE */]:
      {
        return Object.assign({}, state, {
          error: '',
          product: state.product,
          templateInfo: payload.Template,
          template: JSON.parse(payload.Template.Template),
          isLoading: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["i" /* RECEIVE_DEPOSIT_TEMPLATES_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["j" /* RECEIVE_DEPOSIT_TEMPLATE_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["f" /* RECEIVE_DEPOSIT_INFO_ERROR */]:
      {
        return Object.assign({}, state, {
          error: payload,
          isLoading: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["e" /* RECEIVE_DEPOSIT_INFO */]:
      {
        return Object.assign({}, state, {
          error: '',
          isLoading: false,
          depositInfo: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["k" /* RECEIVE_DEPOSIT_TICKET */]:
      {
        return Object.assign({}, state, {
          error: '',
          depositStatus: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["a" /* ADD_DEPOSIT */]:
      {
        return Object.assign({}, state, {
          depositsStatus: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_arrayHelper__["a" /* distinct */])([payload].concat(_toConsumableArray(state.depositsStatus)), function (deposit) {
            return deposit.ReferenceId;
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["l" /* RECEIVE_DEPOSIT_TICKETS */]:
      {
        return Object.assign({}, state, {
          error: '',
          depositsStatus: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__actions_sidePaneActions__["a" /* CLOSE_SIDE_PANE */]:
      {
        return Object.assign({}, initialState, {
          depositsStatus: state.depositsStatus
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_depositActions__["m" /* RESET_DEPOSIT_INFO */]:
      {
        return state;
      }
    default:
      return state;
  }
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_loyaltyFeeActions__ = __webpack_require__(314);


var initialState = {
  requested: false,
  error: '',
  loyaltyFees: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_loyaltyFeeActions__["a" /* LOYALTY_FEES_ERROR */]:
      return Object.assign({}, initialState, {
        error: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_loyaltyFeeActions__["b" /* LOYALTY_FEES_REQUESTED */]:
      return Object.assign({}, state, {
        requested: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_loyaltyFeeActions__["c" /* LOYALTY_FEES_SUCCESS */]:
      return Object.assign({}, initialState, {
        loyaltyFees: payload
      });
    default:
      return state;
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = modalReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_modalActions__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {};

function modalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_modalActions__["c" /* OPEN_MODAL */]:
      return Object.assign({}, state, _defineProperty({}, payload.name, {
        isOpen: true,
        modalProps: payload.modalProps
      }));
    case __WEBPACK_IMPORTED_MODULE_0__actions_modalActions__["a" /* CLOSE_MODAL */]:
      return Object.assign({}, state, _defineProperty({}, payload.name, {
        isOpen: false
      }));
    default:
      return state;
  }
}

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_paginationActions__ = __webpack_require__(175);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_paginationActions__["a" /* SET_ACTIVE_PAGE */]:
      var componentName = payload.componentName,
          activePage = payload.activePage;

      return Object.assign({}, state, _defineProperty({}, componentName, activePage));
    default:
      return Object.assign({}, state);
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_productActions__ = __webpack_require__(174);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_productActions__["b" /* RECEIVE_PRODUCT_ATTRIBUTES */]:
      return Object.assign({}, state, _defineProperty({}, payload.ProductId, Object.assign({
        ProductId: payload.ProductId
      }, objectFromArray(payload.data))));
    default:
      return state;
  }
});

function objectFromArray(dataArray) {
  return dataArray.reduce(function (acc, current) {
    acc[current.KeyName] = current.KeyValue;
    return acc;
  }, {});
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_productManifestActions__ = __webpack_require__(517);


var initialState = {
  manifest: {},
  fetching: true,
  error: {}
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_productManifestActions__["c" /* REQUEST_PRODUCT_MANIFEST */]:
      return Object.assign({}, state, { fetching: true });
    case __WEBPACK_IMPORTED_MODULE_0__actions_productManifestActions__["b" /* RECEIVE_PRODUCT_MANIFEST */]:
      return Object.assign({}, state, { manifest: payload, fetching: false });
    case __WEBPACK_IMPORTED_MODULE_0__actions_productManifestActions__["a" /* ERROR_PRODUCT_MANIFEST */]:
      return Object.assign({}, state, { fetching: false, error: payload });
    default:
      return state;
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = recentTrades;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_recentTradesActions__ = __webpack_require__(509);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 * state of format:
 * {
 *    [instrumentId1]: [],
 *    [instrumentId2]: [],
 * }
 */
var initalState = {
  fetching: true
};

function recentTrades() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
  var action = arguments[1];
  var payload = action.payload,
      type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_recentTradesActions__["b" /* RECEIVE_RECENT_TRADES */]:
      return handleReceiveRecentTrades(state, payload);
    case __WEBPACK_IMPORTED_MODULE_0__actions_recentTradesActions__["d" /* REQUEST_RECENT_TRADES */]:
      return Object.assign({}, state, {
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_recentTradesActions__["c" /* RECEIVE_RECENT_TRADES_ERROR */]:
      return Object.assign({}, state, {
        fetching: false,
        error: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_recentTradesActions__["a" /* ADD_RECENT_TRADE */]:
      return handleAddRecentTrades(state, payload);
    default:
      return state;
  }
}

var handleReceiveRecentTrades = function handleReceiveRecentTrades(state, _ref) {
  var instrumentId = _ref.instrumentId,
      data = _ref.data;

  return Object.assign({}, state, _defineProperty({
    fetching: false
  }, instrumentId, data.reverse()));
};

var handleAddRecentTrades = function handleAddRecentTrades(state, _ref2) {
  var instrumentId = _ref2.instrumentId,
      data = _ref2.data;

  var prevValue = state[instrumentId];
  var prevState = prevValue ? prevValue.slice(0, -data.length) : [];
  var newState = [].concat(_toConsumableArray(data), _toConsumableArray(prevState));
  return Object.assign({}, state, _defineProperty({}, instrumentId, newState));
};

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_resetPasswordActions__ = __webpack_require__(248);


var initialState = {
  error: false,
  message: '',
  validateError: ''
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_resetPasswordActions__["b" /* FINISHED_RESET_PASSWORD */]:
      return Object.assign({}, state, {
        error: payload.error,
        message: payload.message
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_resetPasswordActions__["d" /* SET_RESET_PASSWORD_ERROR */]:
      return Object.assign({}, state, {
        validateError: payload.errorMessage
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_resetPasswordActions__["a" /* CLEAR_RESET_PASSWORD_ERROR */]:
      return Object.assign({}, state, {
        validateError: ''
      });
    default:
      {
        return state;
      }
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reports;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_reportActions__ = __webpack_require__(138);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  reports: [],
  reportWriterResults: [],
  isLoading: false
};

function reports() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_reportActions__["c" /* GET_USER_REPORTS_SUCCESS */]:
      return Object.assign({}, state, {
        reports: payload,
        isLoading: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_reportActions__["b" /* GET_USER_REPORTS_REQUESTED */]:
      {
        return Object.assign({}, state, {
          isLoading: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_reportActions__["e" /* GET_USER_REPORT_WRITER_RESULTS_SUCCESS */]:
      return Object.assign({}, state, {
        reportWriterResults: payload,
        isLoading: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_reportActions__["d" /* GET_USER_REPORT_WRITER_RESULTS_REQUESTED */]:
      {
        return Object.assign({}, state, {
          isLoading: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_reportActions__["a" /* ADD_REPORT */]:
      return Object.assign({}, state, {
        reports: [].concat(_toConsumableArray(state.reports), [payload])
      });
    default:
      return state;
  }
}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sidePane;
/* unused harmony export getDefaultState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_sidePaneActions__ = __webpack_require__(23);


var initialState = getDefaultState();

function sidePane() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_sidePaneActions__["a" /* CLOSE_SIDE_PANE */]:
      return getDefaultState();
    case __WEBPACK_IMPORTED_MODULE_0__actions_sidePaneActions__["b" /* OPEN_SIDE_PANE */]:
      return {
        isOpen: true,
        name: payload.pane,
        data: payload.sidePaneProps
      };
    default:
      return state;
  }
}

function getDefaultState() {
  return {
    isOpen: false,
    name: '',
    data: {}
  };
}

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = signup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_signupActions__ = __webpack_require__(324);


var initialState = {
  userId: null,
  errorMsg: '',
  requesting: false
};

function signup() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_signupActions__["c" /* SIGNUP_REQUESTED */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_signupActions__["d" /* SIGNUP_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_signupActions__["b" /* SIGNUP_ERROR */]:
      return Object.assign({}, state, action.payload);
    case __WEBPACK_IMPORTED_MODULE_0__actions_signupActions__["a" /* CLEAR_SIGNUP_ERROR */]:
      return Object.assign({}, state, { errorMsg: '' });
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sidePane;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_snackbarActions__ = __webpack_require__(20);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initalState = { snacks: [] };

function sidePane() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
  var _ref = arguments[1];
  var payload = _ref.payload,
      type = _ref.type;
  var snacks = state.snacks;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_snackbarActions__["a" /* ADD_SNACK */]:
      return { snacks: [].concat(_toConsumableArray(snacks), [payload]) };
    case __WEBPACK_IMPORTED_MODULE_0__actions_snackbarActions__["c" /* REMOVE_SNACK_BY_UNIQUE_ID */]:
      return { snacks: snacks.filter(function (snack) {
          return snack.uniqueId !== payload;
        }) };
    case __WEBPACK_IMPORTED_MODULE_0__actions_snackbarActions__["b" /* REMOVE_SNACK */]:
      var alreadyRemoved = false;
      return {
        snacks: snacks.filter(function (snack) {
          if (alreadyRemoved || snack.id !== payload) return true;
          if (snack.id === payload) {
            alreadyRemoved = true;
          }

          return false;
        })
      };
    default:
      return state;
  }
}

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_tickersActions__ = __webpack_require__(99);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  tickers: [],
  interval: 86400,
  fetching: true
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_tickersActions__["b" /* RECEIVE_TICKERS */]:
      return Object.assign({}, state, {
        fetching: false,
        tickers: [].concat(_toConsumableArray(payload))
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_tickersActions__["a" /* ADD_TICKERS */]:
      return Object.assign({}, state, {
        tickers: state.tickers.concat(payload)
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_tickersActions__["c" /* REQUEST_TICKERS */]:
      return Object.assign({}, state, {
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_tickersActions__["d" /* SET_TICKERS_INTERVAL */]:
      return Object.assign({}, state, {
        interval: payload
      });
    default:
      return state;
  }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_transferActions__ = __webpack_require__(171);


var initialState = {
  transfers: [],
  transfersReceived: [],
  fetching: true,
  twoFactorAuth: {
    isAuthenticated: true
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferActions__["a" /* GET_INCOMING_TRANSFERS */]:
      return Object.assign({}, state, {
        transfersReceived: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferActions__["b" /* GET_TRANSFERS_RECEIVED */]:
      return Object.assign({}, state, {
        transfers: payload,
        fetching: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferActions__["c" /* GET_TRANSFERS_REQUESTED */]:
      return Object.assign({}, state, {
        fetching: true
      });
    default:
      return state;
  }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__ = __webpack_require__(98);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  fetching: true,
  items: [],
  itemRequestStatuses: {}
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__["b" /* TRANSFER_REQUESTS_RECEIVED_REQUESTED */]:
      return Object.assign({}, state, {
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__["a" /* TRANSFER_REQUESTS_RECEIVED_RECEIVED */]:
      return Object.assign({}, state, {
        fetching: false,
        items: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__["f" /* TRANSFER_REQUEST_CONFIRMATION_SENT */]:
      return Object.assign({}, state, {
        itemRequestStatuses: Object.assign({}, state.itemRequestStatuses, _defineProperty({}, payload, 'fetching'))
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__["g" /* TRANSFER_REQUEST_CONFIRMATION_SUCCESS */]:
      return Object.assign({}, state, {
        itemRequestStatuses: Object.assign({}, state.itemRequestStatuses, _defineProperty({}, payload.requestcode, 'success'))
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__["e" /* TRANSFER_REQUEST_CONFIRMATION_FAILED */]:
      return Object.assign({}, state, {
        itemRequestStatuses: Object.assign({}, state.itemRequestStatuses, _defineProperty({}, payload, 'failed'))
      });
    default:
      return state;
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__ = __webpack_require__(98);


var initialState = {
  fetching: true,
  items: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__["d" /* TRANSFER_REQUESTS_REQUESTED_REQUESTED */]:
      return Object.assign({}, state, {
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_transferRequestActions__["c" /* TRANSFER_REQUESTS_REQUESTED_RECEIVED */]:
      return Object.assign({}, state, {
        fetching: false,
        items: payload
      });
    default:
      return state;
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = user;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqBy__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_kycActions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_kycIdentityMindActions__ = __webpack_require__(332);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var initialState = {
  userInfo: {},
  permissions: [],
  accounts: [],
  userConfig: [],
  selectedAccountId: undefined,
  kyc: { urlParams: null },
  qrCode: ''
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_userActions__["g" /* USER_INFO_FETCHED */]:
      return Object.assign({}, state, {
        userInfo: payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_userActions__["f" /* USER_CONFIG_FETCHED */]:
      return Object.assign({}, state, {
        userConfig: payload
      });
    case __WEBPACK_IMPORTED_MODULE_3__actions_kycActions__["d" /* USER_CONFIG_UPDATED */]:
      return Object.assign({}, state, {
        userConfig: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["c" /* updateObjectInArray */])(state.userConfig, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_userActions__["c" /* RECEIVE_USER_PERMISSIONS */]:
      return Object.assign({}, state, {
        permissions: payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_userActions__["b" /* RECEIVE_ACCOUNT */]:
      return Object.assign({}, state, {
        accounts: __WEBPACK_IMPORTED_MODULE_0_lodash_uniqBy___default()([].concat(_toConsumableArray(state.accounts), _toConsumableArray(payload)), 'AccountId')
      });
    case __WEBPACK_IMPORTED_MODULE_3__actions_kycActions__["c" /* UPDATE_ACCOUNT */]:
      return Object.assign({}, state, {
        accounts: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["c" /* updateObjectInArray */])(state.accounts, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_4__actions_kycIdentityMindActions__["a" /* RECEIVE_KYC */]:
      return Object.assign({}, state, {
        kyc: payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_userActions__["d" /* SET_ACCOUNT */]:
      return Object.assign({}, state, {
        selectedAccountId: payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_userActions__["e" /* SET_GOOGLE_QRCODE */]:
      return Object.assign({}, state, {
        qrCode: payload
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_userActions__["a" /* CLEAR_GOOGLE_QRCODE */]:
      return Object.assign({}, state, {
        qrCode: ''
      });
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(327),
    arraySome = __webpack_require__(1156),
    cacheHas = __webpack_require__(328);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(559),
    getSymbols = __webpack_require__(331),
    keys = __webpack_require__(173);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(330),
    isArray = __webpack_require__(63);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 560 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(118),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1166),
    hasPath = __webpack_require__(1167);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(327),
    arrayIncludes = __webpack_require__(567),
    arrayIncludesWith = __webpack_require__(568),
    cacheHas = __webpack_require__(328),
    createSet = __webpack_require__(1170),
    setToArray = __webpack_require__(329);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(512);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_verifyEmailActions__ = __webpack_require__(322);


var initialState = {
  error: false,
  message: ''
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_verifyEmailActions__["a" /* FINISHED_VERIFY_EMAIL */]:
      return Object.assign({}, state, {
        error: payload.error,
        message: payload.message
      });
    default:
      {
        return state;
      }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withdraw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_arrayHelper__ = __webpack_require__(88);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var initialState = {
  templateInfo: {},
  template: {},
  templateTypes: [],
  error: '',
  isLoading: false,
  withdrawStatus: {},
  withdrawTickets: [],
  withdrawWorkflowInfo: [],
  withdrawFee: 0
};

function withdraw() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["c" /* FETCH_PRODUCT_WITHDRAW_TEMPLATES */]:
      return Object.assign({}, state, {
        isLoading: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["b" /* FETCH_PRODUCT_WITHDRAW_TEMPLATE */]:
      return Object.assign({}, state, {
        isLoading: true,
        product: payload.product,
        templateType: payload.templateType
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["f" /* RECEIVE_WITHDRAW_TEMPLATES */]:
      {
        return Object.assign({}, state, {
          isLoading: false,
          templateTypes: payload,
          error: ''
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["e" /* RECEIVE_WITHDRAW_TEMPLATE */]:
      {
        return Object.assign({}, state, {
          isLoading: false,
          templateInfo: payload,
          template: JSON.parse(payload.Template),
          error: ''
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["g" /* RECEIVE_WITHDRAW_TEMPLATES_ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["h" /* RECEIVE_WITHDRAW_TEMPLATE_ERROR */]:
      {
        return Object.assign({}, state, {
          error: payload,
          isLoading: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["i" /* RECEIVE_WITHDRAW_TICKET */]:
      {
        return Object.assign({}, state, {
          withdrawStatus: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["d" /* RECEIVE_WITHDRAW_FEE */]:
      {
        return Object.assign({}, state, {
          TicketAmount: payload.TicketAmount,
          withdrawFee: payload.FeeAmount
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["j" /* RECEIVE_WITHDRAW_TICKETS */]:
      {
        return Object.assign({}, state, {
          withdrawTickets: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["k" /* RECEIVE_WITHDRAW_WORKFLOW_INFO */]:
      {
        return Object.assign({}, state, {
          withdrawWorkflowInfo: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_withdrawActions__["a" /* ADD_WITHDRAWAL_TICKET */]:
      {
        return Object.assign({}, state, {
          withdrawTickets: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_arrayHelper__["a" /* distinct */])([payload].concat(_toConsumableArray(state.withdrawTickets)), function (ticket) {
            return ticket.TicketNumber;
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__actions_sidePaneActions__["a" /* CLOSE_SIDE_PANE */]:
      {
        return Object.assign({}, initialState, {
          withdrawTickets: state.withdrawTickets
        });
      }
    default:
      return state;
  }
}

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wsConnectionReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_wsConnectionActions__ = __webpack_require__(139);


var initialState = {
  tries: 0,
  isConnected: false
};

function wsConnectionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_wsConnectionActions__["b" /* CONNECTION_CLOSED_COUNT */]:
      return Object.assign({}, state, { tries: payload });
    case __WEBPACK_IMPORTED_MODULE_0__actions_wsConnectionActions__["a" /* CONNECTION_CLOSED */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_wsConnectionActions__["c" /* CONNECTION_OPENED */]:
      return Object.assign({}, state, payload);
    default:
      return state;
  }
}

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState = {
  accountStatus: false,
  interestPayments: [],
  conversionRates: {},
  interestRates: {}
};

var parseRates = function parseRates(obj) {
  return Object.values(obj).reduce(function (acc, el) {
    acc[el.ProductId] = el;
    return acc;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'UPDATE_INTEREST_ACCOUNT_STATUS':
      return Object.assign({}, state, {
        accountStatus: payload
      });

    case 'RECEIVE_INTEREST_PAYMENTS':
      return Object.assign({}, state, {
        interestPayments: payload
      });

    case 'GET_CONVERSION_RATES':
      return Object.assign({}, state, {
        conversionRates: payload
      });

    case 'GET_INTEREST_RATES':
      return Object.assign({}, state, {
        interestRates: parseRates(payload)
      });

    default:
      return state;
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_level1Reducer__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_level2Reducer__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_positionReducer__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_instrumentReducer__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_productReducer__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_orderHistoryReducer__ = __webpack_require__(580);









var apexCore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
  level1: __WEBPACK_IMPORTED_MODULE_1__reducers_level1Reducer__["a" /* default */],
  level2: __WEBPACK_IMPORTED_MODULE_2__reducers_level2Reducer__["a" /* default */],
  position: __WEBPACK_IMPORTED_MODULE_3__reducers_positionReducer__["a" /* default */],
  instrument: __WEBPACK_IMPORTED_MODULE_4__reducers_instrumentReducer__["a" /* default */],
  product: __WEBPACK_IMPORTED_MODULE_5__reducers_productReducer__["a" /* default */],
  orderHistory: __WEBPACK_IMPORTED_MODULE_6__reducers_orderHistoryReducer__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (apexCore);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = level1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_level1Actions__ = __webpack_require__(241);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 * state of format
 * {
 *    [instrumentId]: {},
 *    [instrumentId]: {},
 *    ...
 * }
 */
var initialState = {};

function level1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_level1Actions__["a" /* LEVEL1_LOADED */]:
      return handleLevel1Loaded(state, payload);

    default:
      return state;
  }
}

function handleLevel1Loaded(state, _ref2) {
  var instrumentId = _ref2.instrumentId,
      level1Data = _ref2.level1Data;

  return Object.assign({}, state, _defineProperty({}, instrumentId, level1Data));
}

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = level2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_unionBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_differenceBy__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_differenceBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_differenceBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__ = __webpack_require__(140);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var initialState = getDefaultState();

var descendingPrice = function descendingPrice(a, b) {
  return b.Price - a.Price;
};

function level2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__["c" /* REQUEST_LEVEL_2_DATA */]:
      return Object.assign({}, state, {
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__["a" /* GET_ALL_LEVEL_2_DATA */]:
      return handleGetAllLevel2Data(state, payload);
    case __WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__["b" /* LEVEL_2_UPDATES */]:
      return handleLevel2Updates(state, payload);
    case __WEBPACK_IMPORTED_MODULE_2__actions_level2Actions__["d" /* UNSUBSCRIBE_LEVEL2 */]:
      return getDefaultState();
    default:
      {
        return state;
      }
  }
}

var handleGetAllLevel2Data = function handleGetAllLevel2Data(state, payload) {
  var data = mapOrders(payload);
  return Object.assign({}, state, {
    sell: data.sell.sort(descendingPrice),
    buy: data.buy.sort(descendingPrice),
    fetching: false
  });
};

function handleLevel2Updates(state, payload) {
  var updates = mapOrders(payload);
  return Object.assign({}, state, {
    buy: mergeOrders(state.buy, updates.buy),
    sell: mergeOrders(state.sell, updates.sell),
    short: [].concat(_toConsumableArray(state.short), _toConsumableArray(updates.short)),
    unknown: [].concat(_toConsumableArray(state.unknown), _toConsumableArray(updates.unknown))
  });
}

var deleteType = 2;

var mergeOrders = function mergeOrders(state, updates) {
  var updatesToDelete = [];
  var updatesToMerge = [];

  updates.forEach(function (update) {
    if (update.ActionType === deleteType) {
      var position = updatesToMerge.findIndex(function (item) {
        return item.Price === update.Price;
      });
      if (position !== -1) {
        updatesToMerge = updatesToMerge.filter(function (i) {
          return i.Price !== update.Price;
        });
      }
      updatesToDelete.push(update);
    } else {
      updatesToMerge.push(update);
    }
  });

  var filteredState = __WEBPACK_IMPORTED_MODULE_1_lodash_differenceBy___default()(state, updatesToDelete, function (x) {
    return x.Price;
  });

  return __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy___default()(
  /**
   * @NOTE
   *  this sorting is needed to give precedence to newer updates,
   *  when Level2UpdateEvent contains multiple ActionType=Update entries for same price level.
   */
  updatesToMerge.sort(function (a, b) {
    return b.UpdateId - a.UpdateId;
  }), filteredState, function (x) {
    return x.Price;
  }).sort(descendingPrice);
};

function getDefaultState() {
  return {
    buy: [],
    sell: [],
    short: [],
    unknown: [],
    fetching: true
  };
}

function mapOrders(data) {
  var result = {
    buy: [],
    sell: [],
    short: [],
    unknown: []
  };

  data.forEach(function (update) {
    switch (update.Side) {
      case 0:
        result.buy.push(update);
        break;
      case 1:
        result.sell.push(update);
        break;
      case 2:
        result.short.push(update);
        break;
      default:
        result.unknown.push(update);
        break;
    }
  });

  return result;
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(141),
    isObjectLike = __webpack_require__(76);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_positionActions__ = __webpack_require__(85);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  positions: {},
  fetching: true,
  selectedProductId: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_positionActions__["c" /* REQUEST_ACCOUNT_POSITIONS */]:
      return Object.assign({}, state, { fetching: true });
    case __WEBPACK_IMPORTED_MODULE_0__actions_positionActions__["a" /* RECEIVE_ACCOUNT_POSITIONS */]:
      return Object.assign({}, state, {
        fetching: false,
        positions: Object.assign({}, state.positions, _defineProperty({}, payload.AccountId, createPositionsMap(payload.data)))
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_positionActions__["d" /* SELECT_POSITION */]:
      return Object.assign({}, state, { selectedProductId: payload });
    case __WEBPACK_IMPORTED_MODULE_0__actions_positionActions__["b" /* RECEIVE_POSITION_EVENT */]:
      return Object.assign({}, state, {
        positions: Object.assign({}, state.positions, _defineProperty({}, payload.AccountId, Object.assign({}, state.positions[payload.AccountId], _defineProperty({}, payload.ProductId, payload))))
      });
    default:
      return state;
  }
});

var createPositionsMap = function createPositionsMap(payload) {
  return payload.reduce(function (obj, item) {
    obj[item.ProductId] = item;
    return obj;
  }, {});
};

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intsrumentReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_instrumentActions__ = __webpack_require__(79);


var initialState = {
  instruments: [],
  selectedInstrumentId: undefined,
  fetching: true
};

function intsrumentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_instrumentActions__["c" /* SET_INSTRUMENT */]:
      return handleSeInstrument(state, payload);
    case __WEBPACK_IMPORTED_MODULE_0__actions_instrumentActions__["b" /* REQUEST_INSTRUMENTS */]:
      return Object.assign({}, state, { fetching: true });
    case __WEBPACK_IMPORTED_MODULE_0__actions_instrumentActions__["a" /* RECEIVE_INSTRUMENTS */]:
      return handleReceiveInstruments(state, payload);
    default:
      return state;
  }
}

function handleSeInstrument(state, selectedInstrumentId) {
  return Object.assign({}, state, { selectedInstrumentId: selectedInstrumentId });
}

function handleReceiveInstruments(state, instruments) {
  var update = { fetching: false, instruments: instruments };
  return Object.assign({}, state, update);
}

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_productActions__ = __webpack_require__(174);


var initialState = {
  products: [],
  decimalPlaces: {}
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_productActions__["a" /* RECEIVE_PRODUCTS */]:
      return handleReceiveProducts(state, payload);

    default:
      return state;
  }
});

function handleReceiveProducts(state, products) {
  var decimalPlaces = {};
  products.forEach(function (product) {
    decimalPlaces[product.Product] = product.DecimalPlaces;
  });

  return Object.assign({}, state, {
    products: products,
    decimalPlaces: decimalPlaces
  });
}

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__ = __webpack_require__(88);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var initialState = {
  openOrders: [],
  inactiveOrders: [],
  accountTrades: [],
  tradeReports: [],
  activeRequests: 0
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["i" /* RECEIVE_TRADE_HISTORY */]:
      return Object.assign({}, state, {
        accountTrades: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])(payload, function (trade) {
          return trade.TradeId;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["n" /* REQUEST_OPEN_ORDERS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["l" /* REQUEST_ACCOUNT_TRADES */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["m" /* REQUEST_INACTIVE_ORDERS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["o" /* REQUEST_TRADE_REPORTS */]:
      return Object.assign({}, state, {
        activeRequests: ++state.activeRequests
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["e" /* RECEIVE_ACCOUNT_TRADES */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        accountTrades: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])(payload, function (trade) {
          return trade.TradeId;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["a" /* ADD_ACCOUNT_TRADE */]:
      return Object.assign({}, state, {
        accountTrades: [payload].concat(_toConsumableArray(state.accountTrades))
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["h" /* RECEIVE_OPEN_ORDERS */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        openOrders: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["c" /* ADD_OPEN_ORDER */]:
      return Object.assign({}, state, {
        openOrders: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])([payload].concat(_toConsumableArray(state.openOrders)), function (order) {
          return order.OrderId;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["g" /* RECEIVE_INACTIVE_ORDERS */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        inactiveOrders: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["b" /* ADD_INACTIVE_ORDER */]:
      return Object.assign({}, state, {
        inactiveOrders: [payload].concat(_toConsumableArray(state.inactiveOrders)),
        openOrders: filterOpenOrders(state.openOrders, payload)
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["j" /* RECEIVE_TRADE_REPORTS */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        tradeReports: payload
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["f" /* RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID */]:
      return Object.assign({}, state, {
        accountTrades: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])([].concat(_toConsumableArray(payload), _toConsumableArray(state.accountTrades)), function (trade) {
          return trade.TradeId;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_orderHistoryActions__["k" /* REMOVE_ACTIVE_REQUEST */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests
      });
    default:
      return state;
  }
});

var filterOpenOrders = function filterOpenOrders(openOrders, order) {
  return openOrders ? openOrders.filter(function (_ref2) {
    var OrderId = _ref2.OrderId;
    return OrderId !== order.OrderId;
  }) : [];
};

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marginReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marginAccountStateReducer__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__marginHistoryReducer__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marginInstrumentReducer__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__marginProductReducer__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__marginTransferReducer__ = __webpack_require__(1180);








var marginReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
  accountState: __WEBPACK_IMPORTED_MODULE_1__marginAccountStateReducer__["a" /* marginAccountStateReducer */],
  history: __WEBPACK_IMPORTED_MODULE_2__marginHistoryReducer__["a" /* marginHistoryReducer */],
  instrument: __WEBPACK_IMPORTED_MODULE_3__marginInstrumentReducer__["a" /* marginInstrumentReducer */],
  product: __WEBPACK_IMPORTED_MODULE_4__marginProductReducer__["a" /* marginProductReducer */],
  transfer: __WEBPACK_IMPORTED_MODULE_5__marginTransferReducer__["a" /* marginTransfersReducer */]
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSFER_ASSETS_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSFER_ASSETS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRANSFER_ASSETS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setMaxValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return transferAssets; });
/* unused harmony export requestTransferAssets */
/* unused harmony export receiveTransferAssets */
/* unused harmony export receiveTransferAssetsError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bignumber_js__);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











var TRANSFER_ASSETS_REQUESTED = 'TRANSFER_ASSETS_REQUESTED';
var TRANSFER_ASSETS_SUCCESS = 'TRANSFER_ASSETS_SUCCESS';
var TRANSFER_ASSETS_ERROR = 'TRANSFER_ASSETS_ERROR';

var setMaxValue = function setMaxValue() {
  return function (dispatch, getState) {
    var state = getState();
    var form = state.form;

    var formObj = form.marginTransferAssets || { values: {} };
    var marginAccount = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_marginSelectors__["e" /* marginAccountSelector */])(state);

    var isMarginContext = marginAccount.AccountId === Number(formObj.values.accountFrom);

    var products = void 0;
    var selectedAsset = void 0;
    if (isMarginContext) {
      products = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_marginProductSelectors__["b" /* marginProductSelector */])(state);
      selectedAsset = products.find(function (product) {
        return product.ProductId === Number(formObj.values.asset);
      });
    } else {
      products = Object(__WEBPACK_IMPORTED_MODULE_6__selectors_positionSelectors__["b" /* positionSelector */])(state);
      selectedAsset = products[formObj.values.asset];
    }

    var amount = 0;
    if (selectedAsset) {
      if (isMarginContext) {
        amount = marginAccount.AccountId === Number(formObj.values.accountFrom) ? selectedAsset.MarginAmount : selectedAsset.StandardAmount;

        amount = amount - selectedAsset.Hold;
      } else {
        amount = new __WEBPACK_IMPORTED_MODULE_8_bignumber_js___default.a(selectedAsset.Amount).minus(selectedAsset.Hold).toNumber();
      }
      if (amount < 0) amount = 0;
    }

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_redux_form__["e" /* change */])('marginTransferAssets', 'amount', amount));
  };
};

var transferAssets = function transferAssets(data) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var state, _state$user$userInfo, OMSId, UserId, accounts, accountFrom, accountTo, AssetAccountId, TransferToMarginAccount, payload, responseObj;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestTransferAssets());

              state = getState();
              _state$user$userInfo = state.user.userInfo, OMSId = _state$user$userInfo.OMSId, UserId = _state$user$userInfo.UserId;
              accounts = state.user.accounts;
              accountFrom = accounts.find(function (acc) {
                return acc.AccountId === Number(data.accountFrom);
              });
              accountTo = accounts.find(function (acc) {
                return acc.AccountId === Number(data.accountTo);
              });
              AssetAccountId = void 0;


              if (accountFrom.AccountType === 'Asset') {
                AssetAccountId = accountFrom.AccountId;
              } else if (accountTo.AccountType === 'Asset') {
                AssetAccountId = accountTo.AccountId;
              }

              TransferToMarginAccount = void 0;


              if (accountFrom.AccountType === 'Asset' && accountTo.AccountType === 'MarginAsset') {
                TransferToMarginAccount = true;
              } else if (accountFrom.AccountType === 'MarginAsset' && accountTo.AccountType === 'Asset') {
                TransferToMarginAccount = false;
              }

              payload = {
                OMSId: OMSId,
                UserId: UserId,
                Amount: data.amount,
                AssetAccountId: AssetAccountId,
                TransferToMarginAccount: TransferToMarginAccount,
                ProductId: Number(data.asset)
              };
              _context.prev = 11;
              _context.next = 14;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('TransferAssetsBetweenUserAssetAndMarginAccounts', payload));

            case 14:
              responseObj = _context.sent;


              if (responseObj.result) {
                dispatch(receiveTransferAssets());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_3__modalActions__["b" /* MODAL_TYPES */].MARGIN_TRANSFER_ASSETS));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_snackbarActions__["e" /* showSnack */])({
                  id: 'transferAssetsSuccess',
                  text: 'You made a Transfer',
                  type: 'success'
                }));
              } else {
                dispatch(receiveTransferAssetsError());
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_snackbarActions__["e" /* showSnack */])({
                  id: 'transferAssetsError',
                  text: responseObj.errormsg + ': ' + responseObj.detail,
                  type: 'warning'
                }));
              }
              _context.next = 23;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context['catch'](11);

              console.error('TransferAssetsBetweenUserAssetAndMarginAccounts error: ', _context.t0);
              dispatch(receiveTransferAssetsError());
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_snackbarActions__["e" /* showSnack */])({
                id: 'transferAssetsError',
                text: _context.t0.o,
                type: 'warning'
              }));

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[11, 18]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var requestTransferAssets = function requestTransferAssets() {
  return {
    type: TRANSFER_ASSETS_REQUESTED
  };
};

var receiveTransferAssets = function receiveTransferAssets() {
  return {
    type: TRANSFER_ASSETS_SUCCESS
  };
};

var receiveTransferAssetsError = function receiveTransferAssetsError() {
  return {
    type: TRANSFER_ASSETS_ERROR
  };
};

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(169),
    baseIteratee = __webpack_require__(249),
    basePickBy = __webpack_require__(586),
    getAllKeysIn = __webpack_require__(337);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(230),
    baseSet = __webpack_require__(1195),
    castPath = __webpack_require__(133);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(521);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(330),
    getPrototype = __webpack_require__(338),
    getSymbols = __webpack_require__(331),
    stubArray = __webpack_require__(560);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Request = __webpack_require__(590);
var extractResponseProps = __webpack_require__(591);

function Response(props) {
  this.request = props.request;
  this.xhr = props.xhr;
  this.headers = props.headers || {};
  this.status = props.status || 0;
  this.text = props.text;
  this.body = props.body;
  this.contentType = props.contentType;
  this.isHttpError = props.status >= 400;
}

Response.prototype.header = Request.prototype.header;

Response.fromRequest = function(req) {
  return new Response(extractResponseProps(req));
};


module.exports = Response;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function Request(optsOrUrl) {
  var opts = typeof optsOrUrl === 'string' ? {url: optsOrUrl} : optsOrUrl || {};
  this.method = opts.method ? opts.method.toUpperCase() : 'GET';
  this.url = opts.url;
  this.headers = opts.headers || {};
  this.body = opts.body;
  this.timeout = opts.timeout || 0;
  this.errorOn404 = opts.errorOn404 != null ? opts.errorOn404 : true;
  this.onload = opts.onload;
  this.onerror = opts.onerror;
}

Request.prototype.abort = function() {
  if (this.aborted) return;
  this.aborted = true;
  this.xhr.abort();
  return this;
};

Request.prototype.header = function(name, value) {
  var k;
  for (k in this.headers) {
    if (this.headers.hasOwnProperty(k)) {
      if (name.toLowerCase() === k.toLowerCase()) {
        if (arguments.length === 1) {
          return this.headers[k];
        }

        delete this.headers[k];
        break;
      }
    }
  }
  if (value != null) {
    this.headers[name] = value;
    return value;
  }
};


module.exports = Request;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend = __webpack_require__(341);

module.exports = function(req) {
  var xhr = req.xhr;
  var props = {request: req, xhr: xhr};

  // Try to create the response from the request. If the request was aborted,
  // accesssing properties of the XHR may throw an error, so we wrap in a
  // try/catch.
  try {
    var lines, i, m, headers = {};
    if (xhr.getAllResponseHeaders) {
      lines = xhr.getAllResponseHeaders().split('\n');
      for (i = 0; i < lines.length; i++) {
        if ((m = lines[i].match(/\s*([^\s]+):\s+([^\s]+)/))) {
          headers[m[1]] = m[2];
        }
      }
    }

    props = extend(props, {
      status: xhr.status,
      contentType: xhr.contentType || (xhr.getResponseHeader && xhr.getResponseHeader('Content-Type')),
      headers: headers,
      text: xhr.responseText,
      body: xhr.response || xhr.responseText
    });
  } catch (err) {}

  return props;
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// A "once" utility.
module.exports = function(fn) {
  var result, called = false;
  return function() {
    if (!called) {
      called = true;
      result = fn.apply(this, arguments);
    }
    return result;
  };
};


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InnerInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dataTestAttributeHelper__ = __webpack_require__(342);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var baseClass = 'ap-input';

var InnerInput = function InnerInput(props, context) {
  var input = props.input,
      customClass = props.customClass,
      classModifiers = props.classModifiers,
      meta = props.meta,
      rows = props.rows,
      info = props.info,
      label = props.label,
      labelInInput = props.labelInInput,
      rightLabelText = props.rightLabelText,
      iconComponent = props.iconComponent,
      passedProps = _objectWithoutProperties(props, ['input', 'customClass', 'classModifiers', 'meta', 'rows', 'info', 'label', 'labelInInput', 'rightLabelText', 'iconComponent']);

  var isTextArea = rows > 1;

  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])([baseClass, customClass]);

  var inputProps = Object.assign({
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-control', _defineProperty({}, bemClasses('with-label'), labelInInput), _defineProperty({}, bemClasses('input', 'error', ''), meta.dirty && meta.error), _defineProperty({}, bemClasses('text-area'), isTextArea), rightLabelText ? bemClasses('input', 'with-right-label') : bemClasses('input', classModifiers))
  }, input, passedProps);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'form-group ' + bemClasses('input-wrapper', classModifiers) },
    props.type !== 'hidden' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { className: 'ap--label ' + bemClasses('label', classModifiers) },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(rightLabelText && bemClasses('input-with-right-label-container'), bemClasses('input-box')) },
      labelInInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'label-in-input ' + bemClasses('label-in-input') },
        labelInInput
      ),
      isTextArea ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', Object.assign({}, inputProps, {
        'data-test': Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dataTestAttributeHelper__["a" /* getDataTestAttribute */])(props, 'label')
      })) : !iconComponent ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', Object.assign({
        'data-test': Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dataTestAttributeHelper__["a" /* getDataTestAttribute */])(props, 'label')
      }, inputProps)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('input-with-icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', Object.assign({
          'data-test': Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dataTestAttributeHelper__["a" /* getDataTestAttribute */])(props, 'label')
        }, inputProps)),
        iconComponent
      ),
      rightLabelText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('right-label') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: bemClasses('right-label-span') },
          rightLabelText
        )
      ) : null,
      info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-text-muted ' + bemClasses('info') },
        info
      ),
      meta.touched && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('error') },
        context.t(meta.error)
      )
    )
  );
};


InnerInput.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var APInput = function APInput(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: InnerInput }, props));
};

APInput.defaultProps = {
  name: '',
  label: '',
  labelInInput: '',
  type: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  rows: 1
};

APInput.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelInInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rightLabelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

APInput.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["b"] = (APInput);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APPasswordInput_css__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APPasswordInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__APPasswordInput_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var baseClass = 'ap-password-input';

var PasswordInput = function (_React$Component) {
  _inherits(PasswordInput, _React$Component);

  function PasswordInput(props) {
    _classCallCheck(this, PasswordInput);

    var _this = _possibleConstructorReturn(this, (PasswordInput.__proto__ || Object.getPrototypeOf(PasswordInput)).call(this, props));

    _this.handleClick = function () {
      _this.setState({ reveal: !_this.state.reveal });
    };

    _this.renderIcon = function (bemClasses) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          onClick: _this.handleClick,
          className: bemClasses('icon', { active: _this.state.reveal }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__APIcon__["a" /* default */], { name: 'eye' })
      );
    };

    _this.state = {
      value: '',
      reveal: false
    };
    return _this;
  }

  _createClass(PasswordInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          customClass = _props.customClass,
          passedProps = _objectWithoutProperties(_props, ['customClass']);

      var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);
      var iconComponent = this.renderIcon(bemClasses);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__APInput__["a" /* InnerInput */], Object.assign({
          customClass: customClass
        }, passedProps, {
          type: this.state.reveal ? 'text' : 'password',
          iconComponent: iconComponent
        }))
      );
    }
  }]);

  return PasswordInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var APPasswordInput = function APPasswordInput(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: PasswordInput }, props));
};

APPasswordInput.propTypes = {
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (APPasswordInput);

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Deprecated.
// Use `libphonenumber-js/min` or `libphonenumber-js/max` or `libphonenumber-js/core` instead.



var parsePhoneNumberFromString = __webpack_require__(1340).default

// ES5 `require()` "default" "interoperability" hack.
// https://github.com/babel/babel/issues/2212#issuecomment-131827986
// An alternative approach:
// https://www.npmjs.com/package/babel-plugin-add-module-exports
exports = module.exports = parsePhoneNumberFromString
exports['default'] = parsePhoneNumberFromString

exports.ParseError = __webpack_require__(343).default
var parsePhoneNumberWithError = __webpack_require__(145).default
// `parsePhoneNumber()` named export has been renamed to `parsePhoneNumberWithError()`.
exports.parsePhoneNumber = parsePhoneNumberWithError
exports.parsePhoneNumberWithError = parsePhoneNumberWithError

// `parsePhoneNumberFromString()` named export is now considered legacy:
// it has been promoted to a default export due to being too verbose.
exports.parsePhoneNumberFromString = parsePhoneNumberFromString

// Deprecated: remove `parse()` export in 2.0.0.
// (renamed to `parseNumber()`)
exports.parse              = __webpack_require__(604).default
exports.parseNumber        = __webpack_require__(604).default
// Deprecated: remove `format()` export in 2.0.0.
// (renamed to `formatNumber()`)
exports.format             = __webpack_require__(605).default
exports.formatNumber       = __webpack_require__(605).default
exports.getNumberType      = __webpack_require__(350).default
exports.getExampleNumber   = __webpack_require__(1346).default
exports.isPossibleNumber   = __webpack_require__(1347).default
exports.isValidNumber      = __webpack_require__(1348).default
exports.isValidNumberForRegion = __webpack_require__(1349).default

exports.findNumbers        = __webpack_require__(606).default
exports.searchNumbers      = __webpack_require__(611).default
exports.findPhoneNumbersInText = __webpack_require__(612).default
exports.searchPhoneNumbersInText = __webpack_require__(1354).default
exports.PhoneNumberMatcher = __webpack_require__(351).default

// Deprecated.
exports.findPhoneNumbers   = __webpack_require__(613).default
exports.searchPhoneNumbers = __webpack_require__(613).searchPhoneNumbers
exports.PhoneNumberSearch  = __webpack_require__(614).PhoneNumberSearch

exports.AsYouType = __webpack_require__(615).default

exports.formatIncompletePhoneNumber = __webpack_require__(1359).default
exports.parseIncompletePhoneNumber  = __webpack_require__(344).default
exports.parsePhoneNumberCharacter   = __webpack_require__(344).parsePhoneNumberCharacter
exports.parseDigits   = __webpack_require__(124).default

// Deprecated: `DIGITS` were used by `react-phone-number-input`.
// Replaced by `parseDigits()`.
//
// Deprecated: `DIGIT_PLACEHOLDER` was used by `react-phone-number-input`.
// Not used anymore.
//
exports.DIGITS            = __webpack_require__(124).DIGITS
exports.DIGIT_PLACEHOLDER = __webpack_require__(616).DIGIT_PLACEHOLDER

exports.getCountries = __webpack_require__(1360).default
exports.getCountryCallingCode = __webpack_require__(345).default
// `getPhoneCode` name is deprecated, use `getCountryCallingCode` instead.
exports.getPhoneCode = exports.getCountryCallingCode

exports.Metadata = __webpack_require__(41).default
exports.isSupportedCountry = __webpack_require__(41).isSupportedCountry
exports.getExtPrefix = __webpack_require__(41).getExtPrefix

exports.parseRFC3966 = __webpack_require__(253).parseRFC3966
exports.formatRFC3966 = __webpack_require__(253).formatRFC3966

// exports['default'] = ...

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parsePhoneNumber;

var _parse_ = _interopRequireDefault(__webpack_require__(123));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function parsePhoneNumber(text, options, metadata) {
  return (0, _parse_["default"])(text, _objectSpread({}, options, {
    v2: true
  }), metadata);
}
//# sourceMappingURL=parsePhoneNumber_.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidNumberForRegion;

var _validate_ = _interopRequireDefault(__webpack_require__(255));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Checks if a given phone number is valid within a given region.
 * Is just an alias for `phoneNumber.isValid() && phoneNumber.country === country`.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 */
function isValidNumberForRegion(input, country, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  return input.country === country && (0, _validate_["default"])(input, options, metadata);
}
//# sourceMappingURL=isValidNumberForRegion_.js.map

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatNumber;

var _matchesEntirely = _interopRequireDefault(__webpack_require__(146));

var _formatNationalNumberUsingFormat = _interopRequireDefault(__webpack_require__(347));

var _metadata = _interopRequireWildcard(__webpack_require__(41));

var _getIddPrefix = _interopRequireDefault(__webpack_require__(1344));

var _RFC = __webpack_require__(253);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  } // Formats a phone number
  //
  // Example use cases:
  //
  // ```js
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
  // formatNumber('+78005553535', 'NATIONAL')
  // formatNumber('+78005553535', 'NATIONAL', metadata)
  // ```
  //

};

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new _metadata["default"](metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return (0, _RFC.formatRFC3966)({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return (0, _formatNationalNumberUsingFormat["default"])(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var format = _ref;

    // Validate leading digits
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if ((0, _matchesEntirely["default"])(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = (0, _metadata.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = (0, _getIddPrefix["default"])(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
//# sourceMappingURL=format_.js.map

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = applyInternationalSeparatorStyle;

var _constants = __webpack_require__(68);

// Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(_constants.VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}
//# sourceMappingURL=applyInternationalSeparatorStyle.js.map

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = extractCountryCallingCode;

var _stripIddPrefix = _interopRequireDefault(__webpack_require__(348));

var _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign = _interopRequireDefault(__webpack_require__(349));

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _constants = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */
function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = (0, _stripIddPrefix["default"])(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = (0, _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign["default"])(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new _metadata["default"](metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= _constants.MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}
//# sourceMappingURL=extractCountryCallingCode.js.map

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = extractNationalNumber;

var _extractNationalNumberFromPossiblyIncompleteNumber = _interopRequireDefault(__webpack_require__(602));

var _matchesEntirely = _interopRequireDefault(__webpack_require__(146));

var _checkNumberLength = _interopRequireDefault(__webpack_require__(252));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */
function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = (0, _extractNationalNumberFromPossiblyIncompleteNumber["default"])(number, metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode;

  if (!shouldExtractNationalPrefix(number, nationalNumber, metadata)) {
    // Don't strip the national prefix.
    return {
      nationalNumber: number
    };
  } // If a national prefix has been extracted, check to see
  // if the resultant number isn't too short.
  // Same code in Google's `libphonenumber`:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3291-L3302
  // For some reason, they do this check right after the `national_number_pattern` check
  // this library does in `shouldExtractNationalPrefix()` function.
  // Why is there a second "resultant" number validity check?
  // They don't provide an explanation.
  // This library just copies the behavior.


  if (number.length !== nationalNumber.length + (carrierCode ? carrierCode.length : 0)) {
    // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    if (metadata.possibleLengths()) {
      // "We require that the NSN remaining after stripping the national prefix and
      // carrier code be long enough to be a possible length for the region.
      // Otherwise, we don't do the stripping, since the original number could be
      // a valid short number."
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      switch ((0, _checkNumberLength["default"])(nationalNumber, metadata)) {
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
          // case 'IS_POSSIBLE_LOCAL_ONLY':
          // Don't strip the national prefix.
          return {
            nationalNumber: number
          };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.


function shouldExtractNationalPrefix(number, nationalSignificantNumber, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if ((0, _matchesEntirely["default"])(number, metadata.nationalNumberPattern()) && !(0, _matchesEntirely["default"])(nationalSignificantNumber, metadata.nationalNumberPattern())) {
    return false;
  } // Just "possible" number check would be more relaxed, so it's not used.
  // if (isPossibleNumber(number, metadata) &&
  // 	!isPossibleNumber(numberWithNationalPrefixExtracted, metadata)) {
  // 	return false
  // }


  return true;
}
//# sourceMappingURL=extractNationalNumber.js.map

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = extractNationalNumberFromPossiblyIncompleteNumber;

/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
          // `prefixBeforeNationalNumber` is the whole substring matched by
          // the `national_prefix_for_parsing` regular expression.
          // There seem to be no guarantees that it's just a national prefix.
          // For example, if there's a carrier code, it's gonna be a
          // part of `prefixBeforeNationalNumber` too.
          var prefixBeforeNationalNumber = prefixMatch[0];
          nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
          // then carrier code is the first one.

          if (hasCapturedGroups) {
            carrierCode = prefixMatch[1];
          }
        } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}
//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCountryByCallingCode;

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _getNumberType = _interopRequireDefault(__webpack_require__(256));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {
  /* istanbul ignore if */
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  } // Is always non-empty, because `callingCode` is always valid


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}

function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new _metadata["default"](metadata);

  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var country = _ref;
    metadata.country(country); // Leading digits check would be the simplest one

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if ((0, _getNumberType["default"])({
        phone: nationalPhoneNumber,
        country: country
      }, undefined, metadata.metadata)) {
        return country;
      }
  }
}
//# sourceMappingURL=getCountryByCallingCode.js.map

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseNumber;

var _parse_ = _interopRequireDefault(__webpack_require__(123));

var _parsePhoneNumber = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// `options`:
//  {
//    country:
//    {
//      restrict - (a two-letter country code)
//                 the phone number must be in this country
//
//      default - (a two-letter country code)
//                default country to use for phone number parsing and validation
//                (if no country code could be derived from the phone number)
//    }
//  }
//
// Returns `{ country, number }`
//
// Example use cases:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//
function parseNumber() {
  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _parse_["default"])(text, options, metadata);
}
//# sourceMappingURL=parse.js.map

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatNumber;

var _format_ = _interopRequireDefault(__webpack_require__(598));

var _parse_ = _interopRequireDefault(__webpack_require__(123));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function formatNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      input = _normalizeArguments.input,
      format = _normalizeArguments.format,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _format_["default"])(input, format, options, metadata);
} // Sort out arguments


function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 5),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3],
      arg_5 = _Array$prototype$slic2[4];

  var input;
  var format;
  var options;
  var metadata; // Sort out arguments.
  // If the phone number is passed as a string.
  // `format('8005553535', ...)`.

  if (typeof arg_1 === 'string') {
    // If country code is supplied.
    // `format('8005553535', 'RU', 'NATIONAL', [options], metadata)`.
    if (typeof arg_3 === 'string') {
      format = arg_3;

      if (arg_5) {
        options = arg_4;
        metadata = arg_5;
      } else {
        metadata = arg_4;
      }

      input = (0, _parse_["default"])(arg_1, {
        defaultCountry: arg_2,
        extended: true
      }, metadata);
    } // Just an international phone number is supplied
    // `format('+78005553535', 'NATIONAL', [options], metadata)`.
    else {
        if (typeof arg_2 !== 'string') {
          throw new Error('`format` argument not passed to `formatNumber(number, format)`');
        }

        format = arg_2;

        if (arg_4) {
          options = arg_3;
          metadata = arg_4;
        } else {
          metadata = arg_3;
        }

        input = (0, _parse_["default"])(arg_1, {
          extended: true
        }, metadata);
      }
  } // If the phone number is passed as a parsed number object.
  // `format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', [options], metadata)`.
  else if (is_object(arg_1)) {
      input = arg_1;
      format = arg_2;

      if (arg_4) {
        options = arg_3;
        metadata = arg_4;
      } else {
        metadata = arg_3;
      }
    } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.'); // Legacy lowercase formats.


  if (format === 'International') {
    format = 'INTERNATIONAL';
  } else if (format === 'National') {
    format = 'NATIONAL';
  }

  return {
    input: input,
    format: format,
    options: options,
    metadata: metadata
  };
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var is_object = function is_object(_) {
  return _typeof(_) === 'object';
};
//# sourceMappingURL=format.js.map

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = findNumbers;

var _findNumbers_ = _interopRequireDefault(__webpack_require__(1350));

var _parsePhoneNumber = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function findNumbers() {
  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _findNumbers_["default"])(text, options, metadata);
}
//# sourceMappingURL=findNumbers.js.map

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLatinLetter = isLatinLetter;
exports.isInvalidPunctuationSymbol = isInvalidPunctuationSymbol;
exports._pL = exports.pNd = exports._pN = exports.PZ = exports.pZ = void 0;
// Javascript doesn't support UTF-8 regular expressions.
// So mimicking them here.
// Copy-pasted from `PhoneNumberMatcher.js`.

/**
 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
 * http://www.regular-expressions.info/unicode.html
 * "\P{Z}" is the reverse of "\p{Z}".
 * "\p{N}" is any kind of numeric character in any script ("Number").
 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
 * "\p{L}" is any kind of letter from any language ("Letter").
 * "\p{Mn}" is "non-spacing mark".
 *
 * Javascript doesn't support Unicode Regular Expressions
 * so substituting it with this explicit set of characters.
 *
 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
 */
var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
var pZ = "[".concat(_pZ, "]");
exports.pZ = pZ;
var PZ = "[^".concat(_pZ, "]");
exports.PZ = PZ;
var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19"; // const pN = `[${_pN}]`

exports._pN = _pN;
var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
var pNd = "[".concat(_pNd, "]");
exports.pNd = pNd;
var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
exports._pL = _pL;
var pL = "[".concat(_pL, "]");
var pL_regexp = new RegExp(pL);
var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
var pSc = "[".concat(_pSc, "]");
var pSc_regexp = new RegExp(pSc);
var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
var pMn = "[".concat(_pMn, "]");
var pMn_regexp = new RegExp(pMn);
var _InBasic_Latin = "\0-\x7F";
var _InLatin_1_Supplement = "\x80-\xFF";
var _InLatin_Extended_A = "\u0100-\u017F";
var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
var _InLatin_Extended_B = "\u0180-\u024F";
var _InCombining_Diacritical_Marks = "\u0300-\u036F";
var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
/**
 * Helper method to determine if a character is a Latin-script letter or not.
 * For our purposes, combining marks should also return true since we assume
 * they have been added to a preceding Latin character.
 */

function isLatinLetter(letter) {
  // Combining marks are a subset of non-spacing-mark.
  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
    return false;
  }

  return latinLetterRegexp.test(letter);
}

function isInvalidPunctuationSymbol(character) {
  return character === '%' || pSc_regexp.test(character);
}
//# sourceMappingURL=utf-8.js.map

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parsePreCandidate;

var _util = __webpack_require__(257);

// Regular expression of characters typically used to start a second phone number for the purposes
// of parsing. This allows us to strip off parts of the number that are actually the start of
// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
// extension so that the first number is parsed correctly.
//
// Matches a slash (\ or /) followed by a space followed by an `x`.
//
var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;

function parsePreCandidate(candidate) {
  // Check for extra numbers at the end.
  // TODO: This is the place to start when trying to support extraction of multiple phone number
  // from split notations (+41 79 123 45 67 / 68).
  return (0, _util.trimAfterFirstMatch)(SECOND_NUMBER_START_PATTERN, candidate);
}
//# sourceMappingURL=parsePreCandidate.js.map

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidPreCandidate;
// Matches strings that look like dates using "/" as a separator.
// Examples: 3/10/2011, 31/10/96 or 08/31/95.
var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/; // Matches timestamps.
// Examples: "2012-01-02 08:00".
// Note that the reg-ex does not include the
// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.

var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;

function isValidPreCandidate(candidate, offset, text) {
  // Skip a match that is more likely to be a date.
  if (SLASH_SEPARATED_DATES.test(candidate)) {
    return false;
  } // Skip potential time-stamps.


  if (TIME_STAMPS.test(candidate)) {
    var followingText = text.slice(offset + candidate.length);

    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
      return false;
    }
  }

  return true;
}
//# sourceMappingURL=isValidPreCandidate.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidCandidate;
exports.LEAD_CLASS = void 0;

var _constants = __webpack_require__(68);

var _util = __webpack_require__(257);

var _utf = __webpack_require__(607);

// Copy-pasted from `PhoneNumberMatcher.js`.
var OPENING_PARENS = "(\\[\uFF08\uFF3B";
var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(_constants.PLUS_CHARS, "]"); // Punctuation that may be at the start of a phone number - brackets and plus signs.

exports.LEAD_CLASS = LEAD_CLASS;
var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS); // Limit on the number of pairs of brackets in a phone number.

var BRACKET_PAIR_LIMIT = (0, _util.limit)(0, 3);
/**
 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
 * This also checks that there is something inside the brackets. Having no brackets at all is also
 * fine.
 *
 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
 * closing bracket first. We limit the sets of brackets in a phone number to four.
 */

var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
/**
 * Matches strings that look like publication pages. Example:
 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
 *
 * The string "211-227 (2003)" is not a telephone number.
 */

var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;

function isValidCandidate(candidate, offset, text, leniency) {
  // Check the candidate doesn't contain any formatting
  // which would indicate that it really isn't a phone number.
  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
    return;
  } // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.


  if (leniency !== 'POSSIBLE') {
    // If the candidate is not at the start of the text,
    // and does not start with phone-number punctuation,
    // check the previous character.
    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
      var previousChar = text[offset - 1]; // We return null if it is a latin letter or an invalid punctuation symbol.

      if ((0, _utf.isInvalidPunctuationSymbol)(previousChar) || (0, _utf.isLatinLetter)(previousChar)) {
        return false;
      }
    }

    var lastCharIndex = offset + candidate.length;

    if (lastCharIndex < text.length) {
      var nextChar = text[lastCharIndex];

      if ((0, _utf.isInvalidPunctuationSymbol)(nextChar) || (0, _utf.isLatinLetter)(nextChar)) {
        return false;
      }
    }
  }

  return true;
}
//# sourceMappingURL=isValidCandidate.js.map

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = searchNumbers;

var _parsePhoneNumber = __webpack_require__(145);

var _PhoneNumberMatcher = _interopRequireDefault(__webpack_require__(351));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @return ES6 `for ... of` iterator.
 */
function searchNumbers() {
  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  var matcher = new _PhoneNumberMatcher["default"](text, options, metadata);
  return _defineProperty({}, Symbol.iterator, function () {
    return {
      next: function next() {
        if (matcher.hasNext()) {
          return {
            done: false,
            value: matcher.next()
          };
        }

        return {
          done: true
        };
      }
    };
  });
}
//# sourceMappingURL=searchNumbers.js.map

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = findPhoneNumbersInText;
exports.getArguments = getArguments;

var _findNumbers = _interopRequireDefault(__webpack_require__(606));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function findPhoneNumbersInText(text, defaultCountry, options, metadata) {
  var args = getArguments(defaultCountry, options, metadata);
  return (0, _findNumbers["default"])(text, args.options, args.metadata);
}

function getArguments(defaultCountry, options, metadata) {
  if (metadata) {
    if (defaultCountry) {
      options = _objectSpread({}, options, {
        defaultCountry: defaultCountry
      });
    }
  } else {
    if (options) {
      metadata = options;

      if (defaultCountry) {
        if (is_object(defaultCountry)) {
          options = defaultCountry;
        } else {
          options = {
            defaultCountry: defaultCountry
          };
        }
      } else {
        options = undefined;
      }
    } else {
      metadata = defaultCountry;
      options = undefined;
    }
  }

  return {
    options: _objectSpread({}, options, {
      v2: true
    }),
    metadata: metadata
  };
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var is_object = function is_object(_) {
  return _typeof(_) === 'object';
};
//# sourceMappingURL=findPhoneNumbersInText.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = findPhoneNumbers;
exports.searchPhoneNumbers = searchPhoneNumbers;

var _findPhoneNumbers_ = _interopRequireWildcard(__webpack_require__(614));

var _parsePhoneNumber = __webpack_require__(145);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

// This is a legacy function.
// Use `findNumbers()` instead.
function findPhoneNumbers() {
  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _findPhoneNumbers_["default"])(text, options, metadata);
}
/**
 * @return ES6 `for ... of` iterator.
 */


function searchPhoneNumbers() {
  var _normalizeArguments2 = (0, _parsePhoneNumber.normalizeArguments)(arguments),
      text = _normalizeArguments2.text,
      options = _normalizeArguments2.options,
      metadata = _normalizeArguments2.metadata;

  return (0, _findPhoneNumbers_.searchPhoneNumbers)(text, options, metadata);
}
//# sourceMappingURL=findPhoneNumbers.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = findPhoneNumbers;
exports.searchPhoneNumbers = searchPhoneNumbers;
exports.PhoneNumberSearch = exports.EXTN_PATTERNS_FOR_PARSING = void 0;

var _constants = __webpack_require__(68);

var _parse_ = _interopRequireDefault(__webpack_require__(123));

var _isViablePhoneNumber = __webpack_require__(180);

var _createExtensionPattern = _interopRequireDefault(__webpack_require__(251));

var _parsePreCandidate = _interopRequireDefault(__webpack_require__(608));

var _isValidPreCandidate = _interopRequireDefault(__webpack_require__(609));

var _isValidCandidate = _interopRequireDefault(__webpack_require__(610));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Regexp of all possible ways to write extensions, for use when parsing. This
 * will be run as a case-insensitive regexp match. Wide character versions are
 * also provided after each ASCII version. There are three regular expressions
 * here. The first covers RFC 3966 format, where the extension is added using
 * ';ext='. The second more generic one starts with optional white space and
 * ends with an optional full stop (.), followed by zero or more spaces/tabs
 * /commas and then the numbers themselves. The other one covers the special
 * case of American numbers where the extension is written with a hash at the
 * end, such as '- 503#'. Note that the only capturing groups should be around
 * the digits that you want to capture as part of the extension, or else parsing
 * will fail! We allow two options for representing the accented o - the
 * character itself, and one in the unicode decomposed form with the combining
 * acute accent.
 */
var EXTN_PATTERNS_FOR_PARSING = (0, _createExtensionPattern["default"])('parsing');
exports.EXTN_PATTERNS_FOR_PARSING = EXTN_PATTERNS_FOR_PARSING;
var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + _constants.WHITESPACE + ']+');
var PUNCTUATION_IN_THE_END_PATTERN = new RegExp('[' + _constants.VALID_PUNCTUATION + ']+$'); // // Regular expression for getting opening brackets for a valid number
// // found using `PHONE_NUMBER_START_PATTERN` for prepending those brackets to the number.
// const BEFORE_NUMBER_DIGITS_PUNCTUATION = new RegExp('[' + OPENING_BRACKETS + ']+' + '[' + WHITESPACE + ']*' + '$')

var VALID_PRECEDING_CHARACTER_PATTERN = /[^a-zA-Z0-9]/;

function findPhoneNumbers(text, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  var search = new PhoneNumberSearch(text, options, metadata);
  var phones = [];

  while (search.hasNext()) {
    phones.push(search.next());
  }

  return phones;
}
/**
 * @return ES6 `for ... of` iterator.
 */


function searchPhoneNumbers(text, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  var search = new PhoneNumberSearch(text, options, metadata);
  return _defineProperty({}, Symbol.iterator, function () {
    return {
      next: function next() {
        if (search.hasNext()) {
          return {
            done: false,
            value: search.next()
          };
        }

        return {
          done: true
        };
      }
    };
  });
}
/**
 * Extracts a parseable phone number including any opening brackets, etc.
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
 */


var PhoneNumberSearch =
/*#__PURE__*/
function () {
  // Iteration tristate.
  function PhoneNumberSearch(text, options, metadata) {
    _classCallCheck(this, PhoneNumberSearch);

    _defineProperty(this, "state", 'NOT_READY');

    this.text = text; // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.

    this.options = options || {};
    this.metadata = metadata;
    this.regexp = new RegExp(_isViablePhoneNumber.VALID_PHONE_NUMBER_WITH_EXTENSION, 'ig');
  }

  _createClass(PhoneNumberSearch, [{
    key: "find",
    value: function find() {
      var matches = this.regexp.exec(this.text);

      if (!matches) {
        return;
      }

      var number = matches[0];
      var startsAt = matches.index;
      number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
      startsAt += matches[0].length - number.length; // Fixes not parsing numbers with whitespace in the end.
      // Also fixes not parsing numbers with opening parentheses in the end.
      // https://github.com/catamphetamine/libphonenumber-js/issues/252

      number = number.replace(PUNCTUATION_IN_THE_END_PATTERN, '');
      number = (0, _parsePreCandidate["default"])(number);
      var result = this.parseCandidate(number, startsAt);

      if (result) {
        return result;
      } // Tail recursion.
      // Try the next one if this one is not a valid phone number.


      return this.find();
    }
  }, {
    key: "parseCandidate",
    value: function parseCandidate(number, startsAt) {
      if (!(0, _isValidPreCandidate["default"])(number, startsAt, this.text)) {
        return;
      } // Don't parse phone numbers which are non-phone numbers
      // due to being part of something else (e.g. a UUID).
      // https://github.com/catamphetamine/libphonenumber-js/issues/213
      // Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).


      if (!(0, _isValidCandidate["default"])(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
        return;
      } // // Prepend any opening brackets left behind by the
      // // `PHONE_NUMBER_START_PATTERN` regexp.
      // const text_before_number = text.slice(this.searching_from, startsAt)
      // const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
      // if (full_number_starts_at >= 0)
      // {
      // 	number   = text_before_number.slice(full_number_starts_at) + number
      // 	startsAt = full_number_starts_at
      // }
      //
      // this.searching_from = matches.lastIndex


      var result = (0, _parse_["default"])(number, this.options, this.metadata);

      if (!result.phone) {
        return;
      }

      result.startsAt = startsAt;
      result.endsAt = startsAt + number.length;
      return result;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.last_match = this.find();

        if (this.last_match) {
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      } // Don't retain that memory any longer than necessary.


      var result = this.last_match;
      this.last_match = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberSearch;
}();

exports.PhoneNumberSearch = PhoneNumberSearch;
//# sourceMappingURL=findPhoneNumbers_.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _metadata = _interopRequireDefault(__webpack_require__(41));

var _PhoneNumber = _interopRequireDefault(__webpack_require__(254));

var _AsYouTypeState = _interopRequireDefault(__webpack_require__(1355));

var _AsYouTypeFormatter = _interopRequireWildcard(__webpack_require__(616));

var _AsYouTypeParser = _interopRequireWildcard(__webpack_require__(1358));

var _getCountryByCallingCode = _interopRequireDefault(__webpack_require__(603));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var AsYouType =
/*#__PURE__*/
function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck(this, AsYouType);

    this.metadata = new _metadata["default"](metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = _slicedToArray(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1];

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  _createClass(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (_typeof(optionsOrDefaultCountry) === 'object') {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      if (defaultCallingCode) {
        /* istanbul ignore if */
        if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
          if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) {
            defaultCountry = '001';
          }
        }
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new _AsYouTypeState["default"]({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new _AsYouTypeFormatter["default"]({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new _AsYouTypeParser["default"]({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset(this.defaultCountry, this.defaultCallingCode);
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "country calling code" part of the phone number.
     * Returns `undefined` if the number is not being input in international format.
     * Returns "country calling code" for "non-geographic" phone numbering plans too.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      return this.state.callingCode;
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var _this$state = this.state,
          digits = _this$state.digits,
          country = _this$state.country; // If no digits have been input yet,
      // then `this.country` is the `defaultCountry`.
      // Won't return the `defaultCountry` in such case.

      if (!digits) {
        return;
      }

      var countryCode = country;
      /* istanbul ignore if */

      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        // `AsYouType.getCountry()` returns `undefined`
        // for "non-geographic" phone numbering plans.
        if (countryCode === '001') {
          countryCode = undefined;
        }
      }

      return countryCode;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state2 = this.state,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state2.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state2.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, _AsYouTypeFormatter.DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry((0, _getCountryByCallingCode["default"])(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode;

      if (this.isInternational()) {
        if (!this.state.callingCode) {
          return;
        }
      } else {
        if (!this.state.country && !this.defaultCallingCode) {
          return;
        }
      }

      if (!nationalSignificantNumber) {
        return;
      }

      var countryCode = this.getCountry();
      var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
      var phoneNumber = new _PhoneNumber["default"](countryCode || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();

exports["default"] = AsYouType;
//# sourceMappingURL=AsYouType.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DIGIT_PLACEHOLDER", {
  enumerable: true,
  get: function get() {
    return _AsYouTypeFormatter.DIGIT_PLACEHOLDER;
  }
});
exports["default"] = void 0;

var _AsYouTypeFormatter = __webpack_require__(1356);

var _AsYouTypeFormatter2 = _interopRequireWildcard(__webpack_require__(1357));

var _parseDigits = _interopRequireDefault(__webpack_require__(124));

var _formatNationalNumberUsingFormat = __webpack_require__(347);

var _constants = __webpack_require__(68);

var _applyInternationalSeparatorStyle = _interopRequireDefault(__webpack_require__(599));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Used in phone number format template creation.
// Could be any digit, I guess.
var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = (0, _AsYouTypeFormatter.repeat)(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.

var SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('^' + '[' + _constants.VALID_PUNCTUATION + ']*' + '(\\$\\d[' + _constants.VALID_PUNCTUATION + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter =
/*#__PURE__*/
function () {
  function AsYouTypeFormatter(_ref) {
    var _this = this;

    var state = _ref.state,
        metadata = _ref.metadata;

    _classCallCheck(this, AsYouTypeFormatter);

    _defineProperty(this, "getSeparatorAfterNationalPrefix", function (format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (_this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    });

    _defineProperty(this, "shouldTryNationalPrefixFormattingRule", function (format, _ref2) {
      var international = _ref2.international,
          nationalPrefix = _ref2.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    });

    this.metadata = metadata;
    this.resetFormat();
  }

  _createClass(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this2 = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if ((0, _AsYouTypeFormatter2.canFormatCompleteNumber)(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref3 = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref3 = _i.value;
          }

          var format = _ref3;
          var formattedCompleteNumber = (0, _AsYouTypeFormatter2["default"])(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this2.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, _AsYouTypeFormatter.DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(_AsYouTypeFormatter.DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref4) {
      var _this3 = this;

      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          nationalPrefix = _ref4.nationalPrefix,
          international = _ref4.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this3.formatSuits(format, international, nationalPrefix) && _this3.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.


      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        return true;
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
      // then format matching starts narrowing down the list of possible formats
      // (only previously matched formats are considered for next digits).


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
      // all or-ed (`|`) parts, not just the first one.

      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this4 = this;

      var _loop2 = function _loop2() {
        if (_isArray2) {
          if (_i2 >= _iterator2.length) return "break";
          _ref5 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) return "break";
          _ref5 = _i2.value;
        }

        var format = _ref5;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this4.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this4.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this4.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this4.matchingFormats = _this4.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this4.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      _loop: for (var _iterator2 = this.matchingFormats.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref5;

        var _ret = _loop2();

        switch (_ret) {
          case "break":
            break _loop;

          case "continue":
            continue;
        }
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref6, options) {
      var IDDPrefix = _ref6.IDDPrefix,
          missingPlus = _ref6.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(_AsYouTypeFormatter.DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return (0, _AsYouTypeFormatter.cutAndStripNonPairedParens)(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, _AsYouTypeFormatter.DIGIT_PLACEHOLDER) + (0, _AsYouTypeFormatter.repeat)(_AsYouTypeFormatter.DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref7) {
      var nationalSignificantNumber = _ref7.nationalSignificantNumber,
          international = _ref7.international,
          nationalPrefix = _ref7.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref7.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      if (SUPPORT_LEGACY_FORMATTING_PATTERNS) {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(_formatNationalNumberUsingFormat.FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if ((0, _parseDigits["default"])(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, _parseDigits["default"])('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, _AsYouTypeFormatter.DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), _AsYouTypeFormatter.DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = (0, _AsYouTypeFormatter.repeat)(_AsYouTypeFormatter.DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = (0, _AsYouTypeFormatter.repeat)(_AsYouTypeFormatter.DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = (0, _applyInternationalSeparatorStyle["default"])(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = (0, _AsYouTypeFormatter.populateTemplateWithDigits)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return (0, _AsYouTypeFormatter.cutAndStripNonPairedParens)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }]);

  return AsYouTypeFormatter;
}();

exports["default"] = AsYouTypeFormatter;
//# sourceMappingURL=AsYouTypeFormatter.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)
var startOfISOWeek = __webpack_require__(353)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(1377),
    hasUnicode = __webpack_require__(355),
    unicodeSize = __webpack_require__(1378);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.labels = exports.metadata = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var metadata = exports.metadata = _propTypes2.default.shape({
	country_calling_codes: _propTypes2.default.object.isRequired,
	countries: _propTypes2.default.object.isRequired
});

var labels = exports.labels = _propTypes2.default.objectOf(_propTypes2.default.string);
//# sourceMappingURL=PropTypes.js.map

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse___ = __webpack_require__(622);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function parsePhoneNumber(text, options, metadata) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__parse___["a" /* default */])(text, _objectSpread({}, options, {
    v2: true
  }), metadata);
}
//# sourceMappingURL=parsePhoneNumber_.js.map

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* unused harmony export extractFormattedPhoneNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ParseError__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_isViablePhoneNumber__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_extension_extractExtension__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parseIncompletePhoneNumber__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getCountryCallingCode__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isPossibleNumber___ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_RFC3966__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PhoneNumber__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_matchesEntirely__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_extractCountryCallingCode__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_extractCountryCallingCodeFromInternationalNumberWithoutPlusSign__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_extractNationalNumber__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_stripIddPrefix__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_getCountryByCallingCode__ = __webpack_require__(631);
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js















 // We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PLUS_CHARS */] + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + '#' + ']+$');
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // `options`:
//  {
//    country:
//    {
//      restrict - (a two-letter country code)
//                 the phone number must be in this country
//
//      default - (a two-letter country code)
//                default country to use for phone number parsing and validation
//                (if no country code could be derived from the phone number)
//    }
//  }
//
// Returns `{ country, number }`
//
// Example use cases:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata__["a" /* default */](metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError__["a" /* default */]('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError__["a" /* default */]('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError__["a" /* default */]('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MIN_LENGTH_FOR_NSN */]) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError__["a" /* default */]('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* MAX_LENGTH_FOR_NSN */]) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError__["a" /* default */]('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new __WEBPACK_IMPORTED_MODULE_9__PhoneNumber__["a" /* default */](countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? Object(__WEBPACK_IMPORTED_MODULE_10__helpers_matchesEntirely__["a" /* default */])(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && Object(__WEBPACK_IMPORTED_MODULE_7__isPossibleNumber___["b" /* isPossibleNumber */])(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} throwOnError — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function extractFormattedPhoneNumber(text, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new __WEBPACK_IMPORTED_MODULE_1__ParseError__["a" /* default */]('TOO_LONG');
    }

    return;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?ext }`.
 */

function parseInput(text, v2) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__helpers_RFC3966__["b" /* parseRFC3966 */])(text);
  }

  var number = extractFormattedPhoneNumber(text, v2); // If the phone number is not viable, then abort.

  if (!number || !Object(__WEBPACK_IMPORTED_MODULE_3__helpers_isViablePhoneNumber__["a" /* default */])(number)) {
    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_extension_extractExtension__["a" /* default */])(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_extractCountryCallingCode__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__parseIncompletePhoneNumber__["a" /* default */])(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
      metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

      if (defaultCountry) {
        country = defaultCountry;
      } else {
        /* istanbul ignore if */
        if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
          if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
            country = '001';
          }
        }
      }

      countryCallingCode = defaultCallingCode || Object(__WEBPACK_IMPORTED_MODULE_6__getCountryCallingCode__["a" /* default */])(defaultCountry, metadata.metadata);
    } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = Object(__WEBPACK_IMPORTED_MODULE_13__helpers_extractNationalNumber__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__parseIncompletePhoneNumber__["a" /* default */])(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = Object(__WEBPACK_IMPORTED_MODULE_15__helpers_getCountryByCallingCode__["a" /* default */])(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
//# sourceMappingURL=parse_.js.map

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VALID_PHONE_NUMBER */
/* unused harmony export VALID_PHONE_NUMBER_WITH_EXTENSION */
/* harmony export (immutable) */ __webpack_exports__["a"] = isViablePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extension_createExtensionPattern__ = __webpack_require__(357);

 //  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']{' + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MIN_LENGTH_FOR_NSN */] + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PLUS_CHARS */] + ']{0,1}' + '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* VALID_PUNCTUATION */] + ']*' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']' + '){3,}' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']*';
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + Object(__WEBPACK_IMPORTED_MODULE_1__extension_createExtensionPattern__["a" /* default */])() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MIN_LENGTH_FOR_NSN */] && VALID_PHONE_NUMBER_PATTERN.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseIncompletePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = parsePhoneNumberCharacter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_parseDigits__ = __webpack_require__(148);

/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }

    return '+';
  } // Allow digits.


  return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_parseDigits__["b" /* parseDigit */])(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["b"]; });
// Deprecated. Import from 'metadata.js' directly instead.

//# sourceMappingURL=getCountryCallingCode.js.map

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPossiblePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = isPossibleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_checkNumberLength__ = __webpack_require__(260);


function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }

  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (Object(__WEBPACK_IMPORTED_MODULE_1__helpers_checkNumberLength__["a" /* default */])(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
//# sourceMappingURL=isPossibleNumber_.js.map

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyInternationalSeparatorStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
 // Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* VALID_PUNCTUATION */], "]+"), 'g'), ' ').trim();
}
//# sourceMappingURL=applyInternationalSeparatorStyle.js.map

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractCountryCallingCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stripIddPrefix__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extractCountryCallingCodeFromInternationalNumberWithoutPlusSign__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(81);




/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = Object(__WEBPACK_IMPORTED_MODULE_0__stripIddPrefix__["a" /* default */])(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_1__extractCountryCallingCodeFromInternationalNumberWithoutPlusSign__["a" /* default */])(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata__["a" /* default */](metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* MAX_LENGTH_COUNTRY_CODE */] && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}
//# sourceMappingURL=extractCountryCallingCode.js.map

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractNationalNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractNationalNumberFromPossiblyIncompleteNumber__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchesEntirely__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkNumberLength__ = __webpack_require__(260);



/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = Object(__WEBPACK_IMPORTED_MODULE_0__extractNationalNumberFromPossiblyIncompleteNumber__["a" /* default */])(number, metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode;

  if (!shouldExtractNationalPrefix(number, nationalNumber, metadata)) {
    // Don't strip the national prefix.
    return {
      nationalNumber: number
    };
  } // If a national prefix has been extracted, check to see
  // if the resultant number isn't too short.
  // Same code in Google's `libphonenumber`:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3291-L3302
  // For some reason, they do this check right after the `national_number_pattern` check
  // this library does in `shouldExtractNationalPrefix()` function.
  // Why is there a second "resultant" number validity check?
  // They don't provide an explanation.
  // This library just copies the behavior.


  if (number.length !== nationalNumber.length + (carrierCode ? carrierCode.length : 0)) {
    // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    if (metadata.possibleLengths()) {
      // "We require that the NSN remaining after stripping the national prefix and
      // carrier code be long enough to be a possible length for the region.
      // Otherwise, we don't do the stripping, since the original number could be
      // a valid short number."
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      switch (Object(__WEBPACK_IMPORTED_MODULE_2__checkNumberLength__["a" /* default */])(nationalNumber, metadata)) {
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
          // case 'IS_POSSIBLE_LOCAL_ONLY':
          // Don't strip the national prefix.
          return {
            nationalNumber: number
          };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldExtractNationalPrefix(number, nationalSignificantNumber, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely__["a" /* default */])(number, metadata.nationalNumberPattern()) && !Object(__WEBPACK_IMPORTED_MODULE_1__matchesEntirely__["a" /* default */])(nationalSignificantNumber, metadata.nationalNumberPattern())) {
    return false;
  } // Just "possible" number check would be more relaxed, so it's not used.
  // if (isPossibleNumber(number, metadata) &&
  // 	!isPossibleNumber(numberWithNationalPrefixExtracted, metadata)) {
  // 	return false
  // }


  return true;
}
//# sourceMappingURL=extractNationalNumber.js.map

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractNationalNumberFromPossiblyIncompleteNumber;
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
          // `prefixBeforeNationalNumber` is the whole substring matched by
          // the `national_prefix_for_parsing` regular expression.
          // There seem to be no guarantees that it's just a national prefix.
          // For example, if there's a carrier code, it's gonna be a
          // part of `prefixBeforeNationalNumber` too.
          var prefixBeforeNationalNumber = prefixMatch[0];
          nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
          // then carrier code is the first one.

          if (hasCapturedGroups) {
            carrierCode = prefixMatch[1];
          }
        } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}
//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountryByCallingCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNumberType__ = __webpack_require__(360);


var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {
  /* istanbul ignore if */
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  } // Is always non-empty, because `callingCode` is always valid


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}

function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);

  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var country = _ref;
    metadata.country(country); // Leading digits check would be the simplest one

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__getNumberType__["a" /* default */])({
        phone: nationalPhoneNumber,
        country: country
      }, undefined, metadata.metadata)) {
        return country;
      }
  }
}
//# sourceMappingURL=getCountryByCallingCode.js.map

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findNumbers___ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber__ = __webpack_require__(259);


function findNumbers() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber__["b" /* normalizeArguments */])(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return Object(__WEBPACK_IMPORTED_MODULE_0__findNumbers___["a" /* default */])(text, options, metadata);
}
//# sourceMappingURL=findNumbers.js.map

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _pN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pNd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _pL; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isLatinLetter;
/* harmony export (immutable) */ __webpack_exports__["d"] = isInvalidPunctuationSymbol;
// Javascript doesn't support UTF-8 regular expressions.
// So mimicking them here.
// Copy-pasted from `PhoneNumberMatcher.js`.

/**
 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
 * http://www.regular-expressions.info/unicode.html
 * "\P{Z}" is the reverse of "\p{Z}".
 * "\p{N}" is any kind of numeric character in any script ("Number").
 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
 * "\p{L}" is any kind of letter from any language ("Letter").
 * "\p{Mn}" is "non-spacing mark".
 *
 * Javascript doesn't support Unicode Regular Expressions
 * so substituting it with this explicit set of characters.
 *
 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
 */
var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
var pZ = "[".concat(_pZ, "]");
var PZ = "[^".concat(_pZ, "]");
var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19"; // const pN = `[${_pN}]`

var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
var pNd = "[".concat(_pNd, "]");
var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var pL = "[".concat(_pL, "]");
var pL_regexp = new RegExp(pL);
var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
var pSc = "[".concat(_pSc, "]");
var pSc_regexp = new RegExp(pSc);
var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
var pMn = "[".concat(_pMn, "]");
var pMn_regexp = new RegExp(pMn);
var _InBasic_Latin = "\0-\x7F";
var _InLatin_1_Supplement = "\x80-\xFF";
var _InLatin_Extended_A = "\u0100-\u017F";
var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
var _InLatin_Extended_B = "\u0180-\u024F";
var _InCombining_Diacritical_Marks = "\u0300-\u036F";
var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
/**
 * Helper method to determine if a character is a Latin-script letter or not.
 * For our purposes, combining marks should also return true since we assume
 * they have been added to a preceding Latin character.
 */

function isLatinLetter(letter) {
  // Combining marks are a subset of non-spacing-mark.
  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
    return false;
  }

  return latinLetterRegexp.test(letter);
}
function isInvalidPunctuationSymbol(character) {
  return character === '%' || pSc_regexp.test(character);
}
//# sourceMappingURL=utf-8.js.map

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher__ = __webpack_require__(364);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 * @return ES6 `for ... of` iterator.
 */

function searchNumbers() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber__["b" /* normalizeArguments */])(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  var matcher = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher__["a" /* default */](text, options, metadata);
  return _defineProperty({}, Symbol.iterator, function () {
    return {
      next: function next() {
        if (matcher.hasNext()) {
          return {
            done: false,
            value: matcher.next()
          };
        }

        return {
          done: true
        };
      }
    };
  });
}
//# sourceMappingURL=searchNumbers.js.map

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findPhoneNumbersInText;
/* harmony export (immutable) */ __webpack_exports__["b"] = getArguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findNumbers__ = __webpack_require__(632);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function findPhoneNumbersInText(text, defaultCountry, options, metadata) {
  var args = getArguments(defaultCountry, options, metadata);
  return Object(__WEBPACK_IMPORTED_MODULE_0__findNumbers__["a" /* default */])(text, args.options, args.metadata);
}
function getArguments(defaultCountry, options, metadata) {
  if (metadata) {
    if (defaultCountry) {
      options = _objectSpread({}, options, {
        defaultCountry: defaultCountry
      });
    }
  } else {
    if (options) {
      metadata = options;

      if (defaultCountry) {
        if (is_object(defaultCountry)) {
          options = defaultCountry;
        } else {
          options = {
            defaultCountry: defaultCountry
          };
        }
      } else {
        options = undefined;
      }
    } else {
      metadata = defaultCountry;
      options = undefined;
    }
  }

  return {
    options: _objectSpread({}, options, {
      v2: true
    }),
    metadata: metadata
  };
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof(_) === 'object';
};
//# sourceMappingURL=findPhoneNumbersInText.js.map

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsYouType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumber__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AsYouTypeState__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AsYouTypeFormatter__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AsYouTypeParser__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_getCountryByCallingCode__ = __webpack_require__(631);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }







var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var AsYouType =
/*#__PURE__*/
function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck(this, AsYouType);

    this.metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = _slicedToArray(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1];

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  _createClass(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (_typeof(optionsOrDefaultCountry) === 'object') {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      if (defaultCallingCode) {
        /* istanbul ignore if */
        if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
          if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) {
            defaultCountry = '001';
          }
        }
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new __WEBPACK_IMPORTED_MODULE_2__AsYouTypeState__["a" /* default */]({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new __WEBPACK_IMPORTED_MODULE_3__AsYouTypeFormatter__["b" /* default */]({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new __WEBPACK_IMPORTED_MODULE_4__AsYouTypeParser__["a" /* default */]({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset(this.defaultCountry, this.defaultCallingCode);
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "country calling code" part of the phone number.
     * Returns `undefined` if the number is not being input in international format.
     * Returns "country calling code" for "non-geographic" phone numbering plans too.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      return this.state.callingCode;
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var _this$state = this.state,
          digits = _this$state.digits,
          country = _this$state.country; // If no digits have been input yet,
      // then `this.country` is the `defaultCountry`.
      // Won't return the `defaultCountry` in such case.

      if (!digits) {
        return;
      }

      var countryCode = country;
      /* istanbul ignore if */

      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        // `AsYouType.getCountry()` returns `undefined`
        // for "non-geographic" phone numbering plans.
        if (countryCode === '001') {
          countryCode = undefined;
        }
      }

      return countryCode;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state2 = this.state,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state2.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state2.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, __WEBPACK_IMPORTED_MODULE_3__AsYouTypeFormatter__["a" /* DIGIT_PLACEHOLDER */]);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_getCountryByCallingCode__["a" /* default */])(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode;

      if (this.isInternational()) {
        if (!this.state.callingCode) {
          return;
        }
      } else {
        if (!this.state.country && !this.defaultCallingCode) {
          return;
        }
      }

      if (!nationalSignificantNumber) {
        return;
      }

      var countryCode = this.getCountry();
      var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
      var phoneNumber = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumber__["a" /* default */](countryCode || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();


//# sourceMappingURL=AsYouType.js.map

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AsYouTypeFormatter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsYouTypeFormatter_complete__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_parseDigits__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_formatNationalNumberUsingFormat__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_applyInternationalSeparatorStyle__ = __webpack_require__(627);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // Used in phone number format template creation.
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["d" /* repeat */])(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.

var SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('^' + '[' + __WEBPACK_IMPORTED_MODULE_4__constants__["f" /* VALID_PUNCTUATION */] + ']*' + '(\\$\\d[' + __WEBPACK_IMPORTED_MODULE_4__constants__["f" /* VALID_PUNCTUATION */] + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter =
/*#__PURE__*/
function () {
  function AsYouTypeFormatter(_ref) {
    var _this = this;

    var state = _ref.state,
        metadata = _ref.metadata;

    _classCallCheck(this, AsYouTypeFormatter);

    _defineProperty(this, "getSeparatorAfterNationalPrefix", function (format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (_this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    });

    _defineProperty(this, "shouldTryNationalPrefixFormattingRule", function (format, _ref2) {
      var international = _ref2.international,
          nationalPrefix = _ref2.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    });

    this.metadata = metadata;
    this.resetFormat();
  }

  _createClass(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this2 = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (Object(__WEBPACK_IMPORTED_MODULE_1__AsYouTypeFormatter_complete__["a" /* canFormatCompleteNumber */])(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref3 = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref3 = _i.value;
          }

          var format = _ref3;
          var formattedCompleteNumber = Object(__WEBPACK_IMPORTED_MODULE_1__AsYouTypeFormatter_complete__["b" /* default */])(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this2.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */]), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */]);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref4) {
      var _this3 = this;

      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          nationalPrefix = _ref4.nationalPrefix,
          international = _ref4.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this3.formatSuits(format, international, nationalPrefix) && _this3.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.


      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        return true;
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
      // then format matching starts narrowing down the list of possible formats
      // (only previously matched formats are considered for next digits).


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
      // all or-ed (`|`) parts, not just the first one.

      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this4 = this;

      var _loop2 = function _loop2() {
        if (_isArray2) {
          if (_i2 >= _iterator2.length) return "break";
          _ref5 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) return "break";
          _ref5 = _i2.value;
        }

        var format = _ref5;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this4.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this4.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this4.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this4.matchingFormats = _this4.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this4.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      _loop: for (var _iterator2 = this.matchingFormats.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref5;

        var _ret = _loop2();

        switch (_ret) {
          case "break":
            break _loop;

          case "continue":
            continue;
        }
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref6, options) {
      var IDDPrefix = _ref6.IDDPrefix,
          missingPlus = _ref6.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */], index + 1);
        i++;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["b" /* cutAndStripNonPairedParens */])(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */]) + Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["d" /* repeat */])(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */], state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref7) {
      var nationalSignificantNumber = _ref7.nationalSignificantNumber,
          international = _ref7.international,
          nationalPrefix = _ref7.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref7.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      if (SUPPORT_LEGACY_FORMATTING_PATTERNS) {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(__WEBPACK_IMPORTED_MODULE_3__helpers_formatNationalNumberUsingFormat__["a" /* FIRST_GROUP_PATTERN */], format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_parseDigits__["a" /* default */])(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + Object(__WEBPACK_IMPORTED_MODULE_2__helpers_parseDigits__["a" /* default */])('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */]);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), __WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */]); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["d" /* repeat */])(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */], complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["d" /* repeat */])(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["a" /* DIGIT_PLACEHOLDER */], nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_applyInternationalSeparatorStyle__["a" /* default */])(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["c" /* populateTemplateWithDigits */])(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return Object(__WEBPACK_IMPORTED_MODULE_0__AsYouTypeFormatter_util__["b" /* cutAndStripNonPairedParens */])(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }]);

  return AsYouTypeFormatter;
}();


//# sourceMappingURL=AsYouTypeFormatter.js.map

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIGIT_PLACEHOLDER; });
/* unused harmony export countOccurences */
/* harmony export (immutable) */ __webpack_exports__["d"] = repeat;
/* harmony export (immutable) */ __webpack_exports__["b"] = cutAndStripNonPairedParens;
/* unused harmony export closeNonPairedParens */
/* unused harmony export stripNonPairedParens */
/* harmony export (immutable) */ __webpack_exports__["c"] = populateTemplateWithDigits;
// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// Unicode-unsafe (because using `.split()`).

function countOccurences(symbol, string) {
  var count = 0; // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for counting brackets it is safe.
  // for (const character of string)

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;

    if (character === symbol) {
      count++;
    }
  }

  return count;
} // Repeats a string (or a symbol) N times.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function closeNonPairedParens(template, cut_before) {
  var retained_template = template.slice(0, cut_before);
  var opening_braces = countOccurences('(', retained_template);
  var closing_braces = countOccurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return template.slice(0, cut_before);
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i2 = 0, _dangling_braces = dangling_braces; _i2 < _dangling_braces.length; _i2++) {
    var index = _dangling_braces[_i2];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = digits.split(''), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i3 >= _iterator2.length) break;
      _ref2 = _iterator2[_i3++];
    } else {
      _i3 = _iterator2.next();
      if (_i3.done) break;
      _ref2 = _i3.value;
    }

    var digit = _ref2;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}
//# sourceMappingURL=AsYouTypeFormatter.util.js.map

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (template) {
	var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
	var should_close_braces = arguments[2];

	if (!template) {
		return function (value) {
			return { text: value };
		};
	}

	var characters_in_template = (0, _helpers.count_occurences)(placeholder, template);

	return function (value) {
		if (!value) {
			return { text: '', template: template };
		}

		var value_character_index = 0;
		var filled_in_template = '';

		// Using `.split('')` here instead of normal `for ... of`
		// because the importing application doesn't neccessarily include an ES6 polyfill.
		// The `.split('')` approach discards "exotic" UTF-8 characters
		// (the ones consisting of four bytes)
		// but template placeholder characters don't fall into that range
		// and appending UTF-8 characters to a string in parts still works.
		for (var _iterator = template.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;

			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}

			var character = _ref;

			if (character !== placeholder) {
				filled_in_template += character;
				continue;
			}

			filled_in_template += value[value_character_index];
			value_character_index++;

			// If the last available value character has been filled in,
			// then return the filled in template
			// (either trim the right part or retain it,
			//  if no more character placeholders in there)
			if (value_character_index === value.length) {
				// If there are more character placeholders
				// in the right part of the template
				// then simply trim it.
				if (value.length < characters_in_template) {
					break;
				}
			}
		}

		if (should_close_braces) {
			filled_in_template = (0, _closeBraces2.default)(filled_in_template, template);
		}

		return { text: filled_in_template, template: template };
	};
};

var _helpers = __webpack_require__(365);

var _closeBraces = __webpack_require__(1423);

var _closeBraces2 = _interopRequireDefault(_closeBraces);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=template formatter.js.map

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.onCut = onCut;
exports.onPaste = onPaste;
exports.onChange = onChange;
exports.onKeyDown = onKeyDown;

var _edit = __webpack_require__(1425);

var _edit2 = _interopRequireDefault(_edit);

var _parse3 = __webpack_require__(366);

var _parse4 = _interopRequireDefault(_parse3);

var _format2 = __webpack_require__(641);

var _format3 = _interopRequireDefault(_format2);

var _dom = __webpack_require__(1426);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onCut(event, input, _parse, _format, on_change) {
	// The actual cut hasn't happened just yet hence the timeout.
	setTimeout(function () {
		return format_input_text(input, _parse, _format, undefined, on_change);
	}, 0);
}

function onPaste(event, input, _parse, _format, on_change) {
	var selection = (0, _dom.getSelection)(input);

	// If selection is made,
	// just erase the selected text
	// prior to pasting
	if (selection) {
		erase_selection(input, selection);
	}

	format_input_text(input, _parse, _format, undefined, on_change);
}

function onChange(event, input, _parse, _format, on_change) {
	format_input_text(input, _parse, _format, undefined, on_change);
}

// Intercepts "Delete" and "Backspace" keys.
// (hitting "Delete" or "Backspace" at any caret
//  position should always result in rasing a digit)
function onKeyDown(event, input, _parse, _format, on_change) {
	var operation = (0, _dom.getOperation)(event);

	switch (operation) {
		case 'Delete':
		case 'Backspace':
			// Intercept this operation and perform it manually.
			event.preventDefault();

			var selection = (0, _dom.getSelection)(input);

			// If selection is made,
			// just erase the selected text,
			// and don't apply any more operations to it.
			if (selection) {
				erase_selection(input, selection);
				return format_input_text(input, _parse, _format, undefined, on_change);
			}

			// Else, perform the (character erasing) operation manually
			return format_input_text(input, _parse, _format, operation, on_change);

		default:
		// Will be handled when `onChange` fires.
	}
}

/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */
function erase_selection(input, selection) {
	var text = input.value;
	text = text.slice(0, selection.start) + text.slice(selection.end);

	input.value = text;
	(0, _dom.setCaretPosition)(input, selection.start);
}

/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */
function format_input_text(input, _parse, _format, operation, on_change) {
	// Parse `<input/>` textual value.
	// Get `value` and `caret` position.
	var _parse2 = (0, _parse4.default)(input.value, (0, _dom.getCaretPosition)(input), _parse),
	    value = _parse2.value,
	    caret = _parse2.caret;

	// If a user performed an operation (e.g. "Backspace", "Delete")
	// then apply that operation and get new `value` and `caret` position.


	if (operation) {
		var operation_applied = (0, _edit2.default)(value, caret, operation);

		value = operation_applied.value;
		caret = operation_applied.caret;
	}

	// Format the `value`.
	// (and reposition the caret accordingly)
	var formatted = (0, _format3.default)(value, caret, _format);

	var text = formatted.text;
	caret = formatted.caret;

	// Set `<input/>` textual value manually
	// to prevent React from resetting the caret position
	// later inside subsequent `render()`.
	// Doesn't work for custom `inputComponent`s for some reason.
	input.value = text;
	// Position the caret properly.
	(0, _dom.setCaretPosition)(input, caret);

	// `<input/>` textual value may have changed,
	// so the parsed `value` may have changed too.
	// The `value` didn't neccessarily change
	// but it might have.
	on_change(value);
}
//# sourceMappingURL=input control.js.map

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = format;

var _templateFormatter = __webpack_require__(639);

var _templateFormatter2 = _interopRequireDefault(_templateFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Formats `value` value preserving `caret` at the same character.
//
// `{ value, caret }` attribute is the result of `parse()` function call.
//
// Returns `{ text, caret }` where the new `caret` is the caret position
// inside `text` text corresponding to the original `caret` position inside `value`.
//
// `formatter(value)` is a function returning `{ text, template }`.
//
// `text` is the `value` value formatted using `template`.
// It may either cut off the non-filled right part of the `template`
// or it may fill the non-filled character placeholders
// in the right part of the `template` with `spacer`
// which is a space (' ') character by default.
//
// `template` is the template used to format the `value`.
// It can be either a full-length template or a partial template.
//
// `formatter` can also be a string — a `template`
// where character placeholders are denoted by 'x'es.
// In this case `formatter` function is automatically created.
//
// Example:
//
// `value` is '880',
// `caret` is `2` (before the first `0`)
//
// `formatter` is `'880' =>
//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
//
// The result is `{ text: '8 (80 )', caret: 4 }`.
//
function format(value, caret, formatter) {
	if (typeof formatter === 'string') {
		formatter = (0, _templateFormatter2.default)(formatter);
	}

	var _ref = formatter(value) || {},
	    text = _ref.text,
	    template = _ref.template;

	if (text === undefined) {
		text = value;
	}

	if (template) {
		if (caret === undefined) {
			caret = text.length;
		} else {
			var index = 0;
			var found = false;

			var possibly_last_input_character_index = -1;

			while (index < text.length && index < template.length) {
				// Character placeholder found
				if (text[index] !== template[index]) {
					if (caret === 0) {
						found = true;
						caret = index;
						break;
					}

					possibly_last_input_character_index = index;

					caret--;
				}

				index++;
			}

			// If the caret was positioned after last input character,
			// then the text caret index is just after the last input character.
			if (!found) {
				caret = possibly_last_input_character_index + 1;
			}
		}
	}

	return { text: text, caret: caret };
}
//# sourceMappingURL=format.js.map

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getCountryCodes = getCountryCodes;
exports.getCountryCodeForFlag = getCountryCodeForFlag;
// See the table of officially assigned ISO 3166-1 alpha-2 country codes:
// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Current_codes
var SKIP_COUNTRIES = exports.SKIP_COUNTRIES = [
// "001" means "Non-Geographical Entity" ("No country", "International").
'001'];

function getCountryCodes(labels) {
	// Includes all country codes (excluding "ZZ" for "International").
	//
	// From ISO 3166-1:2006(E/F):
	//
	// 8.1.3   User-assigned code elements
	//
	// If users need code elements to represent country names not included
	// in this part of ISO 3166, the series of letters AA, QM to QZ, XA
	// to XZ, and ZZ, and the series AAA to AAZ, QMA to QZZ, XAA to XZZ,
	// and ZZA to ZZZ respectively, and the series of numbers 900 to 999
	// are available. These users should inform the ISO 3166/MA of such use.
	//
	return Object.keys(labels).filter(function (key) {
		return key.length === 2 && key.toUpperCase() === key && key !== 'ZZ' && SKIP_COUNTRIES.indexOf(key) < 0;
	});
}

function getCountryCodeForFlag(country) {
	switch (country) {
		// "Ascension Island".
		// The flag is missing for it:
		// https://lipis.github.io/flag-icon-css/flags/4x3/ac.svg
		// GitHub issue:
		// https://github.com/lipis/flag-icon-css/issues/537
		// Using "SH" flag as a temporary substitute
		// because previously "AC" and "TA" were parts of "SH".
		case 'AC':
			return 'SH';

		// "Tristan da Cunha".
		// The flag is missing for it:
		// https://lipis.github.io/flag-icon-css/flags/4x3/ta.svg
		// GitHub issue:
		// https://github.com/lipis/flag-icon-css/issues/537
		// Using "SH" flag as a temporary substitute
		// because previously "AC" and "TA" were parts of "SH".
		case 'TA':
			return 'SH';

		default:
			return country;
	}
}
//# sourceMappingURL=countries.js.map

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scorePassword;
// Based on https://stackoverflow.com/a/11268104
function scorePassword(pass) {
  var score = 0;
  if (!pass || pass.length < 5) return score;

  // award every unique letter until 5 repetitions
  var letters = {};
  for (var i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }

  // bonus points for mixing it up
  var variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  };

  var variationCount = 0;
  for (var check in variations) {
    variationCount += variations[check];
  }
  score += (variationCount - 1) * 10;

  return Math.min(4, parseInt(score / 20, 10));
}

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FullPageSpinner_css__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FullPageSpinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FullPageSpinner_css__);






var spinnerClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('full-page-spinner');

var FullPageSpinner = function FullPageSpinner(props, context) {
  if (props.pastDelay) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      props.isVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: spinnerClasses('overlay') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: spinnerClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: spinnerClasses('spinner') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: spinnerClasses('text') },
            context.t('Loading ...')
          )
        )
      )
    );
  } else {
    return null;
  }
};

FullPageSpinner.propTypes = {
  isVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

FullPageSpinner.defaultProps = {
  isVisible: true
};

FullPageSpinner.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FullPageSpinner);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiatDepositFormComponent__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_depositActions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_createFiatDepositHelper__ = __webpack_require__(1521);









var mapStateToProps = function mapStateToProps(state) {
  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableDeposit = _kycVerificationLevel.disableDeposit;

  return {
    disableDeposit: disableDeposit,
    depositInfo: state.deposit,
    products: state.apexCore.product
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    confirmDeposit: __WEBPACK_IMPORTED_MODULE_3__redux_actions_depositActions__["n" /* createDepositTicket */],
    verificationOnClick: function verificationOnClick() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_sidePaneActions__["j" /* closeSidePane */])());
    },
    selectDepositProduct: function selectDepositProduct(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_depositActions__["o" /* fetchAllProductDepositTemplates */])(productId));
    },
    selectDepositTemplate: function selectDepositTemplate(productId, templateType) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_depositActions__["p" /* fetchProductDepositTemplate */])(productId, templateType));
    }
  };
};

var FiatDepositForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'createFiatDeposit',
  onSubmit: function onSubmit(payload, dispatch, _ref) {
    var _ref$depositInfo = _ref.depositInfo,
        template = _ref$depositInfo.template,
        templateInfo = _ref$depositInfo.templateInfo,
        registeredFields = _ref.registeredFields;
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_FIAT_DEPOSIT, {
      payload: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_createFiatDepositHelper__["a" /* validateDepositTicketPayload */])(payload, registeredFields),
      template: template,
      templateInfo: templateInfo
    }));
  }
})(__WEBPACK_IMPORTED_MODULE_2__FiatDepositFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(FiatDepositForm));

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_formTemplateHelper__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);






var DepositTemplateFormComponent = function DepositTemplateFormComponent(_ref, context) {
  var template = _ref.template,
      submitting = _ref.submitting,
      baseClasses = _ref.baseClasses,
      product = _ref.product;

  if (Object.keys(template).length) {
    var viewOnlyForm = Object.values(template).every(function (val) {
      return !!val;
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('fields') },
      viewOnlyForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('Please use the following information to make a deposit:')
      ),
      Object(__WEBPACK_IMPORTED_MODULE_2__helpers_formTemplateHelper__["b" /* templateFormRenderer */])(template, baseClasses(), context, product),
      !viewOnlyForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
          {
            type: 'submit',
            disabled: submitting,
            customClass: baseClasses(),
            styleName: 'additive' },
          submitting ? context.t('Submitting...') : context.t('Place Deposit Ticket')
        )
      )
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
};

DepositTemplateFormComponent.defaultProps = {
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  template: {},
  submitting: false,
  baseClasses: function baseClasses() {}
};

DepositTemplateFormComponent.propTypes = {
  template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  baseClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

DepositTemplateFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DepositTemplateFormComponent);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bem_helper__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bem_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bem_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dataTestAttributeHelper__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__APLabelWithText_css__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__APLabelWithText_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__APLabelWithText_css__);








var baseClasses = new __WEBPACK_IMPORTED_MODULE_3_react_bem_helper___default.a({
  name: 'ap-label-with-text',
  outputIsString: true
});

var LabelWithText = function LabelWithText(props) {
  var label = props.label,
      text = props.text,
      customClass = props.customClass,
      classModifiers = props.classModifiers;

  var customClasses = new __WEBPACK_IMPORTED_MODULE_3_react_bem_helper___default.a({
    name: customClass,
    outputIsString: true
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses(), customClasses('lwt-container', classModifiers)) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ap--label', baseClasses('label'), customClasses('lwt-label', classModifiers)) },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('text'), customClasses('lwt-text', classModifiers)),
        'data-test': Object(__WEBPACK_IMPORTED_MODULE_4__helpers_dataTestAttributeHelper__["a" /* getDataTestAttribute */])(props, 'label') },
      text
    )
  );
};

LabelWithText.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool)]),
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

LabelWithText.defaultProps = {
  customClass: 'custom-label-with-text'
};

/* harmony default export */ __webpack_exports__["a"] = (LabelWithText);

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var base58 = __webpack_require__(370);
var segwit = __webpack_require__(1471);
var cryptoUtils = __webpack_require__(69);

var DEFAULT_NETWORK_TYPE = 'prod';

function getDecoded(address) {
    try {
        return base58.decode(address);
    } catch (e) {
        // if decoding fails, assume invalid address
        return null;
    }
}

function getChecksum(hashFunction, payload) {
    // Each currency may implement different hashing algorithm
    switch (hashFunction) {
        // blake then keccak hash chain
        case 'blake256keccak256':
            var blake = cryptoUtils.blake2b256(payload);
            return cryptoUtils.keccak256Checksum(Buffer.from(blake, 'hex'));
        case 'blake256':
            return cryptoUtils.blake256Checksum(payload);
        case 'keccak256':
            return cryptoUtils.keccak256Checksum(payload);
        case 'sha256':
        default:
            return cryptoUtils.sha256Checksum(payload);
    }
}

function getAddressType(address, currency) {
    currency = currency || {};
    // should be 25 bytes per btc address spec and 26 decred
    var expectedLength = currency.expectedLength || 25;
    var hashFunction = currency.hashFunction || 'sha256';
    var decoded = getDecoded(address);

    if (decoded) {
        var length = decoded.length;

        if (length !== expectedLength) {
            return null;
        }

        if (currency.regex) {
            if (!currency.regex.test(address)) {
                return false;
            }
        }

        var checksum = cryptoUtils.toHex(decoded.slice(length - 4, length)),
            body = cryptoUtils.toHex(decoded.slice(0, length - 4)),
            goodChecksum = getChecksum(hashFunction, body);

        return checksum === goodChecksum ? cryptoUtils.toHex(decoded.slice(0, expectedLength - 24)) : null;
    }

    return null;
}

function isValidP2PKHandP2SHAddress(address, currency, networkType) {
    networkType = networkType || DEFAULT_NETWORK_TYPE;

    var correctAddressTypes;
    var addressType = getAddressType(address, currency);

    if (addressType) {
        if (networkType === 'prod' || networkType === 'testnet') {
            correctAddressTypes = currency.addressTypes[networkType];
        } else {
            correctAddressTypes = currency.addressTypes.prod.concat(currency.addressTypes.testnet);
        }

        return correctAddressTypes.indexOf(addressType) >= 0;
    }

    return false;
}

module.exports = {
    isValidAddress: function isValidAddress(address, currency, networkType) {
        return isValidP2PKHandP2SHAddress(address, currency, networkType) || segwit.isValidAddress(address);
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).Buffer))

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// Copyright (c) 2017 Pieter Wuille
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var CHARSET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';
var GENERATOR = [0x3b6a57b2, 0x26508e6d, 0x1ea119fa, 0x3d4233dd, 0x2a1462b3];

module.exports = {
  decode: decode,
  encode: encode,
  verifyChecksum: verifyChecksum
};

function polymod(values) {
  var chk = 1;
  for (var p = 0; p < values.length; ++p) {
    var top = chk >> 25;
    chk = (chk & 0x1ffffff) << 5 ^ values[p];
    for (var i = 0; i < 5; ++i) {
      if (top >> i & 1) {
        chk ^= GENERATOR[i];
      }
    }
  }
  return chk;
}

function hrpExpand(hrp) {
  var ret = [];
  var p;
  for (p = 0; p < hrp.length; ++p) {
    ret.push(hrp.charCodeAt(p) >> 5);
  }
  ret.push(0);
  for (p = 0; p < hrp.length; ++p) {
    ret.push(hrp.charCodeAt(p) & 31);
  }
  return ret;
}

function verifyChecksum(hrp, data) {
  return polymod(hrpExpand(hrp).concat(data)) === 1;
}

function createChecksum(hrp, data) {
  var values = hrpExpand(hrp).concat(data).concat([0, 0, 0, 0, 0, 0]);
  var mod = polymod(values) ^ 1;
  var ret = [];
  for (var p = 0; p < 6; ++p) {
    ret.push(mod >> 5 * (5 - p) & 31);
  }
  return ret;
}

function encode(hrp, data) {
  var combined = data.concat(createChecksum(hrp, data));
  var ret = hrp + '1';
  for (var p = 0; p < combined.length; ++p) {
    ret += CHARSET.charAt(combined[p]);
  }
  return ret;
}

function decode(bechString) {
  var p;
  var has_lower = false;
  var has_upper = false;
  for (p = 0; p < bechString.length; ++p) {
    if (bechString.charCodeAt(p) < 33 || bechString.charCodeAt(p) > 126) {
      return null;
    }
    if (bechString.charCodeAt(p) >= 97 && bechString.charCodeAt(p) <= 122) {
      has_lower = true;
    }
    if (bechString.charCodeAt(p) >= 65 && bechString.charCodeAt(p) <= 90) {
      has_upper = true;
    }
  }
  if (has_lower && has_upper) {
    return null;
  }
  bechString = bechString.toLowerCase();
  var pos = bechString.lastIndexOf('1');
  if (pos < 1 || pos + 7 > bechString.length || bechString.length > 90) {
    return null;
  }
  var hrp = bechString.substring(0, pos);
  var data = [];
  for (p = pos + 1; p < bechString.length; ++p) {
    var d = CHARSET.indexOf(bechString.charAt(p));
    if (d === -1) {
      return null;
    }
    data.push(d);
  }
  if (!verifyChecksum(hrp, data)) {
    return null;
  }
  return { hrp: hrp, data: data.slice(0, data.length - 6) };
}

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__crc1__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crc8__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crc81wire__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crc16__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__crc16ccitt__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crc16modbus__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__crc16xmodem__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crc16kermit__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crc24__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__crc32__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__crcjam__ = __webpack_require__(1484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc1", function() { return __WEBPACK_IMPORTED_MODULE_0__crc1__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc8", function() { return __WEBPACK_IMPORTED_MODULE_1__crc8__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc81wire", function() { return __WEBPACK_IMPORTED_MODULE_2__crc81wire__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc16", function() { return __WEBPACK_IMPORTED_MODULE_3__crc16__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc16ccitt", function() { return __WEBPACK_IMPORTED_MODULE_4__crc16ccitt__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc16modbus", function() { return __WEBPACK_IMPORTED_MODULE_5__crc16modbus__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc16xmodem", function() { return __WEBPACK_IMPORTED_MODULE_6__crc16xmodem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc16kermit", function() { return __WEBPACK_IMPORTED_MODULE_7__crc16kermit__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc24", function() { return __WEBPACK_IMPORTED_MODULE_8__crc24__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crc32", function() { return __WEBPACK_IMPORTED_MODULE_9__crc32__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "crcjam", function() { return __WEBPACK_IMPORTED_MODULE_10__crcjam__["a"]; });
























/* harmony default export */ __webpack_exports__["default"] = ({
  crc1: __WEBPACK_IMPORTED_MODULE_0__crc1__["a" /* default */],
  crc8: __WEBPACK_IMPORTED_MODULE_1__crc8__["a" /* default */],
  crc81wire: __WEBPACK_IMPORTED_MODULE_2__crc81wire__["a" /* default */],
  crc16: __WEBPACK_IMPORTED_MODULE_3__crc16__["a" /* default */],
  crc16ccitt: __WEBPACK_IMPORTED_MODULE_4__crc16ccitt__["a" /* default */],
  crc16modbus: __WEBPACK_IMPORTED_MODULE_5__crc16modbus__["a" /* default */],
  crc16xmodem: __WEBPACK_IMPORTED_MODULE_6__crc16xmodem__["a" /* default */],
  crc16kermit: __WEBPACK_IMPORTED_MODULE_7__crc16kermit__["a" /* default */],
  crc24: __WEBPACK_IMPORTED_MODULE_8__crc24__["a" /* default */],
  crc32: __WEBPACK_IMPORTED_MODULE_9__crc32__["a" /* default */],
  crcjam: __WEBPACK_IMPORTED_MODULE_10__crcjam__["a" /* default */]
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepositWorkflowsComponent__ = __webpack_require__(1497);



var mapStateToProps = function mapStateToProps(state, _ref) {
  var submitting = _ref.submitting,
      onSubmit = _ref.onSubmit;

  return {
    templateInfo: state.deposit.templateInfo,
    submitting: submitting,
    isLoading: state.deposit.isLoading,
    onSubmit: onSubmit
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__DepositWorkflowsComponent__["a" /* default */]));

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(655);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (compositAddress) {
  return compositAddress ? compositAddress.split('?dt=') : [''];
});

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(1528);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(374);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(214);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])());

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TradeReportsContainer__ = __webpack_require__(1553);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TradeReportsContainer__["a" /* default */]);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decimalsByProductId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var decimalsByProductId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.apexCore.product.products;
}, function (products) {
  return products.reduce(function (decimalPlaces, product) {
    decimalPlaces[product.ProductId] = product.DecimalPlaces;
    return decimalPlaces;
  }, {});
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InstrumentSelectorComponent__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_instrumentActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginSelectors__ = __webpack_require__(34);






var mapStateToProps = function mapStateToProps(state) {
  var isMarginActive = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state);
  var instrument = {};
  if (isMarginActive && !state.margin.instrument.fetching) {
    instrument = state.margin.instrument;
  } else {
    instrument = state.apexCore.instrument;
  }
  var _instrument = instrument,
      fetching = _instrument.fetching;

  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  return {
    level1: state.apexCore.level1,
    instruments: Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state),
    selectedInstrument: selectedInstrument,
    selectedRow: {
      key: 'InstrumentId',
      value: selectedInstrument.InstrumentId
    },
    fetching: fetching
  };
};

var mapDispatchToProps = {
  selectInstrument: __WEBPACK_IMPORTED_MODULE_2__redux_actions_instrumentActions__["e" /* selectInstrument */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__InstrumentSelectorComponent__["a" /* default */]));

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popover_css__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Popover_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TriggerWrapper = function TriggerWrapper(TriggerComponent, onClick) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TriggerComponent, { onClick: onClick });
};

var baseClass = 'ap-popover';

var Popover = function (_React$Component) {
  _inherits(Popover, _React$Component);

  function Popover(props) {
    _classCallCheck(this, Popover);

    var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.componentWillUnmount = function () {
      _this.removeListeners();
    };

    _this.handleClickOutside = function (e) {
      if (_this.popupRef.contains(e.target)) {
        return;
      }
      _this.toggleShow();
    };

    _this.handleKeyDown = function (e) {
      if (e.code === 'Escape') {
        _this.toggleShow();
        e.target.blur();
      }
    };

    _this.toggleShow = function () {
      _this.setState({ show: !_this.state.show, popoverLeftOffset: 0 }, function () {
        // add offset to popover content if it is out of screen
        if (_this.state.show && _this.contentRef && _this.isOutOfScreen()) {
          var popoverLeftOffset = _this.getLeftOffset();
          _this.setState({ popoverLeftOffset: popoverLeftOffset });
        }

        if (_this.state.show) {
          _this.addListeners();
        } else {
          _this.removeListeners();
        }
      });
    };

    _this.isOutOfScreen = function () {
      var rect = _this.contentRef.getBoundingClientRect();
      return rect.x + rect.width > window.innerWidth;
    };

    _this.getLeftOffset = function () {
      var rect = _this.contentRef.getBoundingClientRect();
      var scrollWidth = 17;
      var leftOffset = window.innerWidth - (rect.x + rect.width);

      var hasVerticalScroll = document.body.scrollHeight > window.innerHeight;
      return hasVerticalScroll ? leftOffset - scrollWidth : leftOffset;
    };

    _this.getBEMClasses = function () {
      var classes = [baseClass, _this.props.customClass, _this.props.isMenu && 'popover-menu'];
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(classes);
    };

    _this.popupRef = null;
    _this.contentRef = null;
    _this.state = {
      show: false,
      popoverLeftOffset: 0
    };
    return _this;
  }

  _createClass(Popover, [{
    key: 'addListeners',
    value: function addListeners() {
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          trigger = _props.trigger,
          content = _props.content,
          drawArrow = _props.drawArrow;
      var show = this.state.show;


      var Trigger = TriggerWrapper(trigger, this.toggleShow);
      var bemClasses = this.getBEMClasses();

      var isVisible = bemClasses(show ? 'visible' : 'hidden');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', bemClasses('popover')),
          ref: function ref(_ref2) {
            return _this2.popupRef = _ref2;
          } },
        Trigger,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: function ref(_ref) {
              return _this2.contentRef = _ref;
            },
            className: isVisible + ' ' + bemClasses('content', drawArrow && 'with-arrow') },
          show && content
        )
      );
    }
  }]);

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  drawArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Popover.defaultProps = {
  drawArrow: false
};
/* harmony default export */ __webpack_exports__["a"] = (Popover);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var INSTRUMENT_TABLE_ITEMS = {
  lastPrice: 'lastPrice',
  dailyPercentageChange: 'dailyPercentageChange',
  bid: 'bid',
  ask: 'ask',
  dailyVolume: 'dailyVolume',
  dailyMin: 'dailyMin',
  dailyMax: 'dailyMax'
};

/* harmony default export */ __webpack_exports__["a"] = (INSTRUMENT_TABLE_ITEMS);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFirefox; });
/* 
    navigator.userAgent in Firefox = Mozilla/5.0 (X11; [Your OS Version]) Gecko/20100101 Firefox/63.0
    navigator.userAgent in Chrome = Mozilla/5.0 (X11; [Your OS Version]) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36
    That's why `navigator.userAgent.indexOf('Chrome') === -1` should be checked for Firefox browser
*/

var isFirefox = function isFirefox() {
  return !!navigator.userAgent.indexOf('Firefox') && navigator.userAgent.indexOf('Chrome') === -1;
};

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaddedDecimal_css__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaddedDecimal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PaddedDecimal_css__);






var PaddedDecimal = function PaddedDecimal(props) {
  var suffix = props.bemMod && props.bemMod.length ? '--' + props.bemMod : '';
  var parsed = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["e" /* getParsedDecimal */])(props.value, props.decimals);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    { className: 'ap-padded-decimal' + suffix },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'ap-padded-decimal__units' + suffix },
      parsed.units
    ),
    parsed.decimals && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'ap-padded-decimal__decimal-separator' + suffix },
        parsed.decimalSeparator
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'ap-padded-decimal__decimals' + suffix },
        parsed.decimals
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'ap-padded-decimal__padding' + suffix },
        parsed.padding
      )
    )
  );
};

PaddedDecimal.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  decimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  bemMod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

PaddedDecimal.defaultProps = {
  value: 0,
  decimals: 2,
  bemMod: null
};

/* harmony default export */ __webpack_exports__["a"] = (PaddedDecimal);

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("apex-chart-react",[],e):"object"==typeof exports?exports["apex-chart-react"]=e():t["apex-chart-react"]=e()}("undefined"!=typeof self?self:this,function(){return function(t){function e(n){if(i[n])return i[n].exports;var o=i[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var i={};return e.m=t,e.c=i,e.d=function(t,i,n){e.o(t,i)||Object.defineProperty(t,i,{configurable:!1,enumerable:!0,get:n})},e.n=function(t){var i=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(i,"a",i),i},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=7)}([function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(8),u=n(h),l=i(1),_=n(l),c=i(10),d=n(c),f=i(13),p=n(f),g=i(14),m=n(g),v=i(17),y=n(v),b=i(18),w=n(b),x=i(19),k=n(x),D=i(20),C=n(D),E=i(3),P=n(E),M=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return n._configuration=null,n._containerElement=document.createElement("div"),n._containerElement.id="apex-chart-container",t.append(n._containerElement),n._loadingElement=null,n._noChartDataElement=null,n._controlsElement=null,n._chartsElement=null,n._width=0,n._height=0,n._historyData=null,n._orderBookData=null,n._priceHistory=null,n._volumeHistory=null,n._macdHistory=null,n._rangeSelector=null,n._orderBookDepth=null,n._marketPrice=0,n._loadConfiguration(i),n.setNoChartData(!0),n}return a(e,t),s(e,[{key:"_loadConfiguration",value:function(t){e.configuration=t,this._configuration=t,this._initialize(),this.dispatchEvent("configurationLoaded")}},{key:"_initialize",value:function(){this._initializeData(),this._build(),this._registerListeners()}},{key:"_initializeData",value:function(){this._historyData=new u.default,this._orderBookData=new d.default}},{key:"_build",value:function(){var t=this;this._loadingElement=document.createElement("div"),this._loadingElement.classList.add("loading"),this._containerElement.append(this._loadingElement),this._loadingElement.innerText=this._configuration.loading_text,this._noChartDataElement=document.createElement("div"),this._noChartDataElement.classList.add("no-chart-data"),this._containerElement.append(this._noChartDataElement),this._noChartDataElement.innerText="⦸ No Chart data",this._controlsElement=document.createElement("div"),this._controlsElement.classList.add("controls"),this._containerElement.append(this._controlsElement),this._chartsElement=document.createElement("div"),this._chartsElement.classList.add("charts"),this._containerElement.append(this._chartsElement),this._chartControls=new p.default(this._controlsElement),this._priceHistory=new m.default(this._chartsElement,this._historyData),this._volumeHistory=new y.default(this._chartsElement,this._historyData),this._macdHistory=new w.default(this._chartsElement,this._historyData),this._rangeSelector=new k.default(this._chartsElement,this._historyData),this._orderBookDepth=new C.default(this._chartsElement,this._orderBookData),setTimeout(function(){return t._layout()},100)}},{key:"_removeChartElement",value:function(){this._containerElement.remove(),this._unregisterListeners()}},{key:"_layout",value:function(){this._width=this._containerElement.offsetWidth,this._height=this._containerElement.offsetHeight,this._priceHistory.invalidateDimensions(),this._volumeHistory.invalidateDimensions(),this._macdHistory.invalidateDimensions(),this._rangeSelector.invalidateDimensions(),this._orderBookDepth.invalidateDimensions()}},{key:"_registerListeners",value:function(){var t=this;this._onResize=P.default.debounce(this,function(){this._width===this._containerElement.offsetWidth&&this._height===this._containerElement.offsetHeight||this._layout()},1e3/e.configuration.max_fps),window.addEventListener("resize",this._onResize,!0),this._chartControls.addEventListener("stateChanged",function(){t._onControlStateChange()}),this._priceHistory.addEventListener("indicesChanged",function(e,i){t._volumeHistory.setIndices(e,i),t._macdHistory.setIndices(e,i),t._rangeSelector.setRange(e,i)}),this._volumeHistory.addEventListener("indicesChanged",function(e,i){t._priceHistory.setIndices(e,i),t._macdHistory.setIndices(e,i),t._rangeSelector.setRange(e,i)}),this._macdHistory.addEventListener("indicesChanged",function(e,i){t._priceHistory.setIndices(e,i),t._volumeHistory.setIndices(e,i),t._rangeSelector.setRange(e,i)}),this._rangeSelector.addEventListener("rangeChanged",function(e,i){t._priceHistory.setIndices(e,i),t._volumeHistory.setIndices(e,i),t._macdHistory.setIndices(e,i)})}},{key:"_unregisterListeners",value:function(){window.removeEventListener("resize",this._onResize,!0),this._rangeSelector._unregisterListeners(),this._priceHistory._unregisterListeners(),this._volumeHistory._unregisterListeners(),this._macdHistory._unregisterListeners(),this._rangeSelector._unregisterListeners(),this._orderBookDepth._unregisterListeners()}},{key:"registerAPI",value:function(t){var e=this;t.addEventListener("historyDataLoad",function(i){e._chartControls.historyInterval=t.interval,e._historyData.parse(t.interval,i),e.setLoadingState(!1),e.setNoChartData(0===i.length)}),t.addEventListener("loadingStateChanged",function(t){e.setLoadingState(t)}),t.addEventListener("historyDataUpdate",function(t){}),t.addEventListener("orderBookDataLoad",function(t){e._orderBookData.parse(t)}),t.addEventListener("orderBookDataUpdate",function(t,i,n){e._orderBookData.add(t,i,n)}),t.addEventListener("marketPriceDataUpdate",function(t){e.marketPrice=t})}},{key:"_onControlStateChange",value:function(){this._priceHistory.interval!==this._chartControls.historyInterval&&this.dispatchEvent("historyIntervalChange",this._chartControls.historyInterval),this._priceHistory.drawSimpleMovingAverage!==this._chartControls.drawSimpleMovingAverage&&(this._priceHistory.drawSimpleMovingAverage=this._chartControls.drawSimpleMovingAverage),this._priceHistory.drawExponentialMovingAverage!==this._chartControls.drawExponentialMovingAverage&&(this._priceHistory.drawExponentialMovingAverage=this._chartControls.drawExponentialMovingAverage),this._priceHistory.drawBollingerBands!==this._chartControls.drawBollingerBands&&(this._priceHistory.drawBollingerBands=this._chartControls.drawBollingerBands),this._priceHistory.chartType!==this._chartControls.chartType&&(this._priceHistory.chartType=this._chartControls.chartType)}},{key:"setLoadingState",value:function(t){t?(this._containerElement.style.pointerEvents="none",this._loadingElement.style.opacity="1"):(this._containerElement.style.pointerEvents="",this._loadingElement.style.opacity="0")}},{key:"setNoChartData",value:function(t){t?(this._containerElement.style.pointerEvents="none",this._noChartDataElement.style.opacity="1"):(this._containerElement.style.pointerEvents="",this._noChartDataElement.style.opacity="0")}},{key:"configuration",get:function(){return this._configuration}},{key:"marketPrice",get:function(){return this._marketPrice},set:function(t){this._marketPrice=t,this._priceHistory&&(this._priceHistory.marketPrice=t),this._orderBookDepth&&(this._orderBookDepth.marketPrice=t)}}]),e}(_.default);e.default=M,t.exports=e.default},function(t,e,i){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),r=function(){function t(){n(this,t)}return o(t,[{key:"addEventListener",value:function(t,e){this.listeners||(this.listeners={}),this.listeners[t]=this.listeners[t]||[],this.listeners[t].push(e)}},{key:"removeEventListener",value:function(t,e){if(this.listeners){var i=this.listeners[t];i&&i.splice(i.indexOf(e),1)}}},{key:"dispatchEvent",value:function(t){for(var e=arguments.length,i=Array(e>1?e-1:0),n=1;n<e;n++)i[n-1]=arguments[n];if(this.listeners){var o=this.listeners[t];o&&o.forEach(function(t){t.apply(null,i)})}}},{key:"removeAllEventListeners",value:function(t){t&&(this.listeners[t]=[])}},{key:"removeAllListeners",value:function(){this.listeners={}}}]),t}();e.default=r,t.exports=e.default},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.AxisLabelingOrientation={VERTICAL:"1",HORIZONTAL:"2"},e.AxisLabelingType={NUMBER:"1",CURRENCY:"2",DATETIME:"3"},e.ChartType={CANDLESTICK:"1",LINE:"2",BAR:"3"},e.OrderType={ASK:"1",BID:"2"},e.RangeSelectorDragMode={PAN:"1",RESIZE_LEFT:"2",RESIZE_RIGHT:"3"}},function(t,e,i){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),r=i(0),a=function(t){return t&&t.__esModule?t:{default:t}}(r),s=function(){function t(){n(this,t)}return o(t,null,[{key:"drawPath",value:function(t,e,i,n,o){null!==i&&(t.fillStyle=i),null!==n&&null!==o&&(t.lineWidth=o,t.strokeStyle=n),t.beginPath();var r=void 0,a=void 0,s=void 0;e.forEach(function(e,i){0===i?(r=a=e[0],s=e[1],t.moveTo(e[0],.5+(0|e[1]))):(r=e[0]>r?e[0]:r,a=e[0]<a?e[0]:a,s=e[1]>s?e[1]:s,t.lineTo(e[0],.5+(0|e[1])))}),null!==n&&null!==o&&t.stroke(),t.lineTo(r,s),t.lineTo(a,s),null!==i&&t.fill()}},{key:"drawAliasedLine",value:function(t,e,i,n,o,r){var a=Math.abs(o-i),s=i<o?1:-1,h=-Math.abs(r-n),u=n<r?1:-1,l=a+h,_=void 0;for(t.fillStyle=e;t.fillRect(i,n,1,1),i!==o||n!==r;)_=2*l,_>=h&&(l+=h,i+=s),_<=a&&(l+=a,n+=u)}},{key:"debounce",value:function(t,e,i,n){var o;return function(){var r=t,a=arguments,s=function(){o=null,n||e.apply(r,a)},h=n&&!o;clearTimeout(o),o=setTimeout(s,i),h&&e.apply(r,a)}}},{key:"throttle",value:function(t,e,i){i||(i=250);var n=void 0,o=void 0;return function(){var r=t||this,a=Date.now(),s=arguments;n&&a<n+i?(clearTimeout(o),o=setTimeout(function(){n=a,e.apply(r,s)},i)):(n=a,e.apply(r,s))}}},{key:"abbreviateNumber",value:function(t){var e=Math.log10(t)/3|0;if(0===e)return t;var i=a.default.configuration.number_suffixes[e];return(0|t/Math.pow(10,3*e))+i}},{key:"formatNumberToLocale",value:function(t,e){var i=a.default.configuration.locale||"en-US",n=Math.pow(10,e);return isNaN(t)?"":0===e?parseInt(t,10).toLocaleString(i):(Math.floor(t*n)/n).toLocaleString(i,{minimumFractionDigits:e,maximumFractionDigits:e})}},{key:"formatUSD",value:function(t,e){var i="\\d(?=(\\d{3})+"+(e>0?"\\.":"$")+")";return t.toFixed(Math.max(0,~~e)).replace(new RegExp(i,"g"),"$&,")}}]),t}();e.default=s,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=function t(e,i,n){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,i);if(void 0===o){var r=Object.getPrototypeOf(e);return null===r?void 0:t(r,i,n)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(n)},u=i(5),l=n(u),_=i(0),c=n(_),d=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n._data=i,n._itemWidth=0,n._itemMargin=0,n._drawStartIndex=Number.MAX_SAFE_INTEGER,n._drawEndIndex=0,n._dragStartIndex=0,n._interval=null,n}return a(e,t),s(e,[{key:"_computeIndices",value:function(){var t=this._itemWidth+this._itemMargin,e=this._chartDimensions.width/t|0,i=this._drawStartIndex,n=0;if(0!==this._mouseDragXDistance){var o=-(this._mouseDragXDistance/t|0),r=this._data.length-1-e;i=Math.max(Math.min(this._dragStartIndex+o,r),0)}return n=i+e,e>this._data.length&&(i=0,n=this._data.length-1),n>this._data.length-1&&(n=this._data.length-1,i=n-e),(this._drawStartIndex!==i||this._drawEndIndex!==n)&&(this._drawStartIndex=i,this._drawEndIndex=n,this.dispatchEvent("indicesChanged",i,n),!0)}},{key:"_computeBounds",value:function(){}},{key:"_registerListeners",value:function(){var t=this;h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_registerListeners",this).call(this),this._data.addEventListener("parseComplete",function(){t._onParseComplete()})}},{key:"_unregisterListeners",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_unregisterListeners",this).call(this)}},{key:"_onParseComplete",value:function(){this._interval=this._data.interval,this._itemWidth=c.default.configuration.defaults.history_item_width,this._itemMargin=c.default.configuration.defaults.history_item_margin;var t=this._chartDimensions.width/(this._itemWidth+this._itemMargin)|0;this._drawEndIndex=this._data.length-1,this._drawStartIndex=Math.max(this._drawEndIndex-t,0),this.dispatchEvent("indicesChanged",this._drawStartIndex,this._drawEndIndex),this._draw(!0)}},{key:"_onMouseLeave",value:function(t){t.target===this._element&&h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseLeave",this).call(this,t)}},{key:"_onMouseDown",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseDown",this).call(this,t),this._dragStartIndex=this._drawStartIndex}},{key:"_onMouseUp",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseUp",this).call(this,t),this._draw(!0)}},{key:"_onMouseMove",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseMove",this).call(this,t),this._mouseIsDown&&this._draw(!0)}},{key:"_onMouseWheel",value:function(t){if(h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseWheel",this).call(this,t),!this._mouseIsDown){var i=this._itemWidth,n=this._itemMargin;t.deltaY<0?i+=.1*i:i-=.1*i,i=Math.max(i,.05),n=0;var o=this._itemWidth+this._itemMargin,r=i+n,a=this._chartDimensions.width/o|0,s=Math.min(this._chartDimensions.width/r|0,this._data.length),u=(this._data.length,(this._mouseX-this._chartDimensions.x)/this._chartDimensions.width),l=a-s,_=u*l|0;s>this._data.length&&(_=-this._drawStartIndex),this._drawStartIndex=Math.max(this._drawStartIndex+_,0),this._itemWidth=i,this._itemMargin=n,this._draw(!0)}}},{key:"setIndices",value:function(t,e){t=Math.max(t,0),e=Math.min(e,this._data.length-1);var i=e-t,n=this._chartDimensions.width/i;this._itemWidth===n&&0===this._itemMargin&&this._drawStartIndex===t&&this._drawEndIndex===e||(this._itemWidth=n,this._itemMargin=0,this._drawStartIndex=t,this._drawEndIndex=e,this._draw(!0))}},{key:"drawStartIndex",get:function(){return this._drawStartIndex}},{key:"drawEndIndex",get:function(){return this._drawEndIndex}},{key:"interval",get:function(){return this._interval}}]),e}(l.default);e.default=d,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(1),u=n(h),l=i(0),_=n(l),c=i(6),d=n(c),f=i(15),p=n(f),g=i(2),m=i(3),v=n(m),y=function(t){function e(t){o(this,e);var i=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return i._containerElement=t,i._element=null,i._drawingCanvas=null,i._drawingContext=null,i._renderingCanvas=null,i._renderingContext=null,i._xLabels=null,i._yLabels=null,i._x=0,i._y=0,i._width=0,i._height=0,i._mouseIsDown=!1,i._mouseDownX=0,i._mouseDownY=0,i._mouseUpX=0,i._mouseUpY=0,i._mouseDragXDistance=0,i._mouseDragYDistance=0,i._currentMouseCursor="default",i._currentTouchID=null,i._chartDimensions=null,i._xLabelDimensions=null,i._yLabelDimensions=null,i._dimensionsInvalidated=!1,i._elementBoundingRect=null,i._configuration=null,i._pixelRatio=window.devicePixelRatio,i._fontSize=_.default.configuration.defaults.font_size*i._pixelRatio,i._fontFace=_.default.configuration.defaults.font_face,i._font=i._fontSize+"px "+i._fontFace,i._onMouseMove=i._onMouseMove.bind(i),i._onMouseUp=i._onMouseUp.bind(i),i}return a(e,t),s(e,[{key:"_build",value:function(){this._pixelRatio=window.devicePixelRatio,this._fontSize=this._configuration.font_size*this._pixelRatio,this._fontFace=this._configuration.font_face,this._font=this._fontSize+"px "+this._fontFace,this._chartDimensions=new d.default,this._xLabelDimensions=new d.default,this._yLabelDimensions=new d.default,this._element=document.createElement("div"),this._element.classList.add("chart"),this._drawingCanvas=document.createElement("canvas"),this._drawingContext=this._drawingCanvas.getContext("2d",{antialias:!1,alpha:!1}),this._drawingContext.imageSmoothingEnabled=!1,this._drawingContext.imageSmoothingQuality="low",this._drawingContext.font=this._font,this._renderingCanvas=document.createElement("canvas"),this._renderingContext=this._renderingCanvas.getContext("2d",{antialias:!1,alpha:!1}),this._renderingContext.imageSmoothingEnabled=!1,this._renderingContext.imageSmoothingQuality="low",this._renderingCanvas.classList.add("chart-canvas"),this._containerElement.append(this._element),this._element.append(this._renderingCanvas),this._elementBoundingRect=this._element.getBoundingClientRect(),this._xLabels=new p.default,this._xLabels.dimensions=this._xLabelDimensions,this._xLabels.type=g.AxisLabelingType.NUMBER,this._xLabels.orientation=g.AxisLabelingOrientation.HORIZONTAL,this._xLabels.precision=this._configuration.x_label_precision,this._xLabels.font=this._font,this._yLabels=new p.default,this._yLabels.dimensions=this._yLabelDimensions,this._yLabels.type=g.AxisLabelingType.NUMBER,this._yLabels.orientation=g.AxisLabelingOrientation.VERTICAL,this._yLabels.precision=this._configuration.y_label_precision,this._yLabels.fontFace=this._fontFace,this._yLabels.fontSize=this._fontSize}},{key:"invalidateDimensions",value:function(){this._computeDimensions()}},{key:"_computeDimensions",value:function(){if(null!==this._configuration){this._dimensionsInvalidated=!1;var t=this._element.offsetWidth*this._pixelRatio,e=this._element.offsetHeight*this._pixelRatio;if(0!==this._x||0!==this._y||this._width!==t||this._height!==e){this._x=0,this._y=0,this._width=t,this._height=e,this._drawingCanvas.width=this._width,this._drawingCanvas.height=this._height,this._renderingCanvas.width=this._width,this._renderingCanvas.height=this._height;var i=void 0;i=this._configuration.x_label_height%1==0?this._configuration.x_label_height:this._height*this._configuration.x_label_height;var n=void 0;n=this._configuration.x_label_height%1==0?this._configuration.y_label_width:this._height*this._configuration.y_label_width,this._chartDimensions.x=0,this._chartDimensions.y=0,this._chartDimensions.width=this._width-n*this._pixelRatio,this._chartDimensions.height=this._height-i*this._pixelRatio,this._xLabelDimensions.x=0,this._xLabelDimensions.y=this._height-i*this._pixelRatio,this._xLabelDimensions.width=this._width-n*this._pixelRatio,this._xLabelDimensions.height=i*this._pixelRatio,this._yLabelDimensions.x=this._width-n*this._pixelRatio,this._yLabelDimensions.y=0,this._yLabelDimensions.width=n*this._pixelRatio,this._yLabelDimensions.height=this._height-i*this._pixelRatio,this._elementBoundingRect=this._element.getBoundingClientRect(),this._dimensionsInvalidated=!0}}}},{key:"_draw",value:function(t){var e=this;requestAnimationFrame(function(i){e._drawBackground(t),e._drawLabels(t),e._drawChart(t),e._drawBorders(t),e._render(t),e._dimensionsInvalidated=!1})}},{key:"_drawBackground",value:function(t){null!==this._configuration&&(this._drawingContext.fillStyle=this._configuration.background_color,this._drawingContext.fillRect(0,0,this._width,this._height))}},{key:"_drawChart",value:function(t){}},{key:"_drawLabels",value:function(t){this._xLabels.draw(this._drawingContext),this._yLabels.draw(this._drawingContext)}},{key:"_drawBorders",value:function(t){}},{key:"_render",value:function(t){this._renderingContext.clearRect(0,0,this._width,this._height),this._drawingCanvas.width&&this._drawingCanvas.height&&this._renderingContext.drawImage(this._drawingCanvas,0,0)}},{key:"_registerListeners",value:function(){var t=this;this._element.addEventListener("mouseleave",function(e){return t._onMouseLeave(e)},!0),this._element.addEventListener("mouseenter",function(e){return t._onMouseEnter(e)},!0),window.addEventListener("mousemove",this._onMouseMove,!0),this._element.addEventListener("mousedown",function(e){return t._onMouseDown(e)}),window.addEventListener("mouseup",this._onMouseUp),this._element.addEventListener("wheel",v.default.throttle(this,function(t){this._onMouseWheel(t)},_.default.configuration.mouse_wheel_throttle_rate),!0),this._element.addEventListener("touchstart",function(e){return t._onTouchStart(e)}),this._element.addEventListener("touchend",function(e){return t._onTouchEnd(e)}),this._element.addEventListener("touchcancel",function(e){return t._onTouchCancel(e)}),this._element.addEventListener("touchmove",function(e){return t._onTouchMove(e)})}},{key:"_unregisterListeners",value:function(){window.removeEventListener("mousemove",this._onMouseMove,!0),window.removeEventListener("mouseup",this._onMouseUp)}},{key:"_onMouseEnter",value:function(t){void 0!==t.preventDefault&&t.preventDefault()}},{key:"_onMouseLeave",value:function(t){void 0!==t.preventDefault&&t.preventDefault()}},{key:"_onMouseMove",value:function(t){void 0!==t.preventDefault&&t.preventDefault(),this._mouseX=t.clientX*this._pixelRatio-this._elementBoundingRect.left*this._pixelRatio,this._mouseY=t.clientY*this._pixelRatio-this._elementBoundingRect.top*this._pixelRatio,this._mouseIsDown&&(this._mouseDragXDistance=this._mouseX-this._mouseDownX,this._mouseDragYDistance=this._mouseY-this._mouseDownY)}},{key:"_onMouseDown",value:function(t){void 0!==t.preventDefault&&t.preventDefault(),this._mouseIsDown=!0,this._mouseDownX=t.clientX*this._pixelRatio-this._elementBoundingRect.left*this._pixelRatio,this._mouseDownY=t.clientY*this._pixelRatio-this._elementBoundingRect.top*this._pixelRatio,this._mouseDragXDistance=0,this._mouseDragYDistance=0}},{key:"_onMouseUp",value:function(t){void 0!==t.preventDefault&&t.preventDefault(),this._mouseIsDown&&(this._mouseIsDown=!1,this._mouseUpX=t.clientX*this._pixelRatio-this._elementBoundingRect.left*this._pixelRatio,this._mouseUpY=t.clientY*this._pixelRatio-this._elementBoundingRect.top*this._pixelRatio),this._mouseDragXDistance=0,this._mouseDragYDistance=0}},{key:"_onMouseWheel",value:function(t){void 0!==t.preventDefault&&t.preventDefault(),this._onMouseMove(t)}},{key:"_onTouchStart",value:function(t){if(void 0!==t.preventDefault&&t.preventDefault(),t.changedTouches.length>0){var e=t.changedTouches[0];this._currentTouchID=e.identifier,this._onMouseDown(e)}}},{key:"_onTouchEnd",value:function(t){if(void 0!==t.preventDefault&&t.preventDefault(),t.changedTouches.length>0)for(var e=0;e<t.changedTouches.length;e++){var i=t.changedTouches[e];if(this._currentTouchID===i.identifier){this._onMouseUp(i),this._currentTouchID=null;break}}}},{key:"_onTouchMove",value:function(t){if(void 0!==t.preventDefault&&t.preventDefault(),t.changedTouches.length>0)for(var e=0;e<t.changedTouches.length;e++){var i=t.changedTouches[e];if(this._currentTouchID===i.identifier){this._onMouseMove(i);break}}}},{key:"_onTouchCancel",value:function(t){void 0!==t.preventDefault&&t.preventDefault()}},{key:"data",get:function(){return this._data}},{key:"x",get:function(){return this._x/this._pixelRatio}},{key:"y",get:function(){return this._y/this._pixelRatio}},{key:"width",get:function(){return this._width/this._pixelRatio}},{key:"height",get:function(){return this._height/this._pixelRatio}},{key:"containerElement",get:function(){return this._containerElement}}]),e}(u.default);e.default=y,t.exports=e.default},function(t,e,i){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),r=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;n(this,t),this._x=e,this._y=i,this._width=o,this._height=r}return o(t,[{key:"setDimensions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;this._x===t&&this._y===e&&this._width===i&&this._height===n||(this._x=t,this._y=e,this._width=i,this._height=n)}},{key:"x",get:function(){return this._x},set:function(t){this._x!==t&&(this._x=t)}},{key:"y",get:function(){return this._y},set:function(t){this._y!==t&&(this._y=t)}},{key:"width",get:function(){return this._width},set:function(t){this._width!==t&&(this._width=t)}},{key:"height",get:function(){return this._height},set:function(t){this._height!==t&&(this._height=t)}}]),t}();e.default=r,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),a=i(0),s=n(a),h=i(21),u=n(h),l=i(23),_=n(l),c=i(24),d=n(c),f=i(26),p=n(f),g=i(27),m=function(){function t(e,i){o(this,t),this.chartContainer=document.getElementById(e),this.config=Object.assign({},g.DefaultConfig,i)}return r(t,[{key:"DrawChart",value:function(){var t=this;this.chart=new s.default(this.chartContainer,this.config),this._alphaPointAPI=this.createAlphaPointAPI(),this.chart.registerAPI(this._alphaPointAPI),this._alphaPointAPI.connect(),this.chart.addEventListener("historyIntervalChange",function(e){t.chart.setLoadingState(!0),t._alphaPointAPI.interval=e})}},{key:"UpdateLevel2Data",value:function(t){this._alphaPointAPI.UpdateLevel2Data(t)}},{key:"UpdateTickersData",value:function(t){this._alphaPointAPI.UpdateTickersData(t)}},{key:"OnLoadingStateChange",value:function(t){this._alphaPointAPI.OnLoadingStateChange(t)}},{key:"UpdateMarketPrice",value:function(t){this._alphaPointAPI.UpdateMarketPrice(t)}},{key:"DestroyChart",value:function(){this.chart&&(this._alphaPointAPI.disconnect(),this.chart._removeChartElement())}},{key:"createAlphaPointAPI",value:function(){return this.config.store?new d.default(this.config.store,this.config.changeTickersInterval):this.config.chartDataSubject?new p.default(this.config.chartDataSubject,this.config.changeTickersInterval):this.config.chartData?new _.default(this.config.chartData,this.config.changeTickersInterval):new u.default}}]),t}();e.default=m,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(1),u=n(h),l=i(0),_=n(l),c=i(9),d=n(c),f=function(t){function e(){o(this,e);var t=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t._data=[],t._configuration=_.default.configuration.history_data,t._simpleMovingAverageWindow=t._configuration.simple_moving_average_window,t._exponentialMovingAverageWindow=t._configuration.exponential_moving_average_window,t._macdShortWindow=t._configuration.convergence_divergence_short_window,t._macdLongWindow=t._configuration.convergence_divergence_long_window,t._macdSignalWindow=t._configuration.convergence_divergence_signal_window,t._lowerPriceBound=Number.MAX_SAFE_INTEGER,t._upperPriceBound=0,t._priceBoundsSpan=0,t._lowerVolumeBound=Number.MAX_SAFE_INTEGER,t._upperVolumeBound=0,t._lowerTimeBound=Number.MAX_SAFE_INTEGER,t._upperTimeBound=0,t._lowerMACDIndicatorBound=Number.MAX_SAFE_INTEGER,t._upperMACDIndicatorBound=0,t._lowerMACDSignalBound=Number.MAX_SAFE_INTEGER,t._upperMACDSignalBound=0,t._lowerMACDDisparityBound=Number.MAX_SAFE_INTEGER,t._upperMACDDisparityBound=0,t._interval=_.default.configuration.defaults.history_interval,t}return a(e,t),s(e,[{key:"calcMovingAvg",value:function(t,e,i){return i*e+(1-i)*t}},{key:"_append",value:function(t,e,i,n,o,r){var a=void 0,s=void 0,h=void 0,u=void 0,l=void 0,_=void 0;if(this._data.length>0&&this._data[this._data.length-1].timestamp,this._data.length>0){var c=this._data[this._data.length-1],f=1/this._simpleMovingAverageWindow,p=2/this._exponentialMovingAverageWindow,g=2/this._macdShortWindow,m=2/this._macdLongWindow,v=2/this._macdSignalWindow;a=this.calcMovingAvg(c.simpleMovingAverage,i,f),s=this.calcMovingAvg(c.exponentialMovingAverage,i,p),h=this.calcMovingAvg(Math.pow(c.standardDeviation,2),Math.pow(Math.abs(i-a),2),f),u=this.calcMovingAvg(c.macdShortAverage,i,g),l=this.calcMovingAvg(c.macdLongAverage,i,m),_=this.calcMovingAvg(c.macdSignalAverage,u-l,v)}else a=i,s=i,h=0,u=i,l=i,_=0;var y=new d.default(t,e,i,n,o,r);y.simpleMovingAverage=a,y.exponentialMovingAverage=s,y.standardDeviation=Math.sqrt(h),y.macdShortAverage=u,y.macdLongAverage=l,y.macdSignalAverage=_,this._adjustBounds(y),this._data.push(y)}},{key:"_adjustBounds",value:function(t){t.close<this._lowerPriceBound&&(this._lowerPriceBound=t.close),t.close>this._upperPriceBound&&(this._upperPriceBound=t.close),this._priceBoundsSpan=this._upperPriceBound-this._lowerPriceBound,t.volume<this._lowerVolumeBound&&(this._lowerVolumeBound=t.volume),t.volume>this._upperVolumeBound&&(this._upperVolumeBound=t.volume),t.timestamp<this._lowerTimeBound&&(this._lowerTimeBound=t.timestamp),t.timestamp>this._upperTimeBound&&(this._upperTimeBound=t.timestamp),t.macd<this._lowerMACDIndicatorBound&&(this._lowerMACDIndicatorBound=t.macd),t.macd>this._upperMACDIndicatorBound&&(this._upperMACDIndicatorBound=t.macd),t.macdSignal<this._lowerMACDSignalBound&&(this._lowerMACDSignalBound=t.macdSignal),t.macdSignal>this._upperMACDSignalBound&&(this._upperMACDSignalBound=t.macdSignal),t.macdDisparity<this._lowerMACDDisparityBound&&(this._lowerMACDDisparityBound=t.macdDisparity),t.macdDisparity>this._upperMACDDisparityBound&&(this._upperMACDDisparityBound=t.macdDisparity)}},{key:"parse",value:function(t,e){var i=this;this._lowerPriceBound=Number.MAX_SAFE_INTEGER,this._upperPriceBound=0,this._priceBoundsSpan=0,this._lowerVolumeBound=Number.MAX_SAFE_INTEGER,this._upperVolumeBound=0,this._lowerTimeBound=Number.MAX_SAFE_INTEGER,this._upperTimeBound=0,this._lowerMACDBound=Number.MAX_SAFE_INTEGER,this._upperMACDBound=0,this._lowerSignalBound=Number.MAX_SAFE_INTEGER,this._upperSignalBound=0,this._data=[],this._iterator=1,this._interval=t,e.forEach(function(t){i._append(t[0],t[1],t[2],t[3],t[4],t[5])}),this.dispatchEvent("parseComplete")}},{key:"append",value:function(t,e,i,n,o,r){this._append(t,e,i,n,o,r),this.dispatchEvent("appendComplete")}},{key:"getItemAt",value:function(t){return this._data[t]}},{key:"hasData",get:function(){return this._data.length>0}},{key:"lowerPriceBound",get:function(){return this._lowerPriceBound}},{key:"upperPriceBound",get:function(){return this._upperPriceBound}},{key:"priceBoundsSpan",get:function(){return this._priceBoundsSpan}},{key:"lowerVolumeBound",get:function(){return this._lowerVolumeBound}},{key:"upperVolumeBound",get:function(){return this._upperVolumeBound}},{key:"lowerTimeBound",get:function(){return this._lowerTimeBound}},{key:"upperTimeBound",get:function(){return this._upperTimeBound}},{key:"lowerMACDIndicatorBound",get:function(){return this._lowerMACDIndicatorBound}},{key:"upperMACDIndicatorBound",get:function(){return this._upperMACDIndicatorBound}},{key:"lowerMACDSignalBound",get:function(){return this._lowerMACDSignalBound}},{key:"upperMACDSignalBound",get:function(){return this._upperMACDSignalBound}},{key:"interval",get:function(){return this._interval}},{key:"length",get:function(){return this._data.length}}]),e}(u.default);e.default=f,t.exports=e.default},function(t,e,i){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),r=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,s=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,h=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0,u=arguments.length>7&&void 0!==arguments[7]?arguments[7]:0,l=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,_=arguments.length>9&&void 0!==arguments[9]?arguments[9]:0,c=arguments.length>10&&void 0!==arguments[10]?arguments[10]:0,d=arguments.length>11&&void 0!==arguments[11]?arguments[11]:0;n(this,t),this._timestamp=e,this._open=i,this._close=o,this._low=a,this._high=r,this._highLowSpan=r-a,this._volume=s,this._bullish=o>=i,this._simpleMovingAverage=h,this._exponentialMovingAverage=u,this._standardDeviation=l,this._macdShortAverage=_,this._macdLongAverage=c,this._macdSignalAverage=d}return o(t,[{key:"timestamp",get:function(){return this._timestamp},set:function(t){this._timestamp=t}},{key:"bullish",get:function(){return this._bullish}},{key:"open",get:function(){return this._open},set:function(t){this._open!==t&&(this._open=t,this._bullish=this._close>=this._open)}},{key:"close",get:function(){return this._close},set:function(t){this._close!==t&&(this._close=t,this._bullish=this._close>=this._open)}},{key:"high",get:function(){return this._high},set:function(t){this._high!==t&&(this._high=t,this._highLowSpan=this._high-this._low)}},{key:"low",get:function(){return this._low},set:function(t){this._low!==t&&(this._low=t,this._highLowSpan=this._high-this._low)}},{key:"volume",get:function(){return this._volume},set:function(t){this._volume!==t&&(this._volume=t)}},{key:"simpleMovingAverage",get:function(){return this._simpleMovingAverage},set:function(t){this._simpleMovingAverage=t}},{key:"exponentialMovingAverage",get:function(){return this._exponentialMovingAverage},set:function(t){this._exponentialMovingAverage=t}},{key:"standardDeviation",get:function(){return this._standardDeviation},set:function(t){this._standardDeviation=t}},{key:"macdShortAverage",get:function(){return this._macdShortAverage},set:function(t){this._macdShortAverage=t}},{key:"macdLongAverage",get:function(){return this._macdLongAverage},set:function(t){this._macdLongAverage=t}},{key:"macdSignalAverage",get:function(){return this._macdSignalAverage},set:function(t){this._macdSignalAverage=t}},{key:"macdIndicator",get:function(){return this._macdShortAverage-this._macdLongAverage}},{key:"macdSignal",get:function(){return this.macdIndicator-this._macdSignalAverage}},{key:"macdDisparity",get:function(){return this.macdIndicator-this.macdSignal}}]),t}();e.default=r,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(1),u=n(h),l=i(11),_=n(l),c=function(t){function e(){o(this,e);var t=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t._askData=new _.default("ascending"),t._bidData=new _.default("descending"),t._marketPrice=0,t}return a(e,t),s(e,[{key:"parse",value:function(t){var e=this;t.asks.constructor===Array&&t.asks.length>0&&t.asks.forEach(function(t){e._askData.add(t[0],t[1])}),t.bids.constructor===Array&&t.bids.length>0&&t.bids.forEach(function(t){e._bidData.add(t[0],t[1])}),this.dispatchEvent("parseComplete")}},{key:"add",value:function(t,e,i){"ask"===t?this._askData.add(e,i):"bid"===t&&this._bidData.add(e,i),this.dispatchEvent("addComplete")}},{key:"remove",value:function(t,e,i){"ask"===t?this._askData.remove(e):"bid"===t&&this._bidData.remove(e),this.dispatchEvent("removeComplete")}},{key:"getClosestItem",value:function(t,e){return"ask"===t?this._askData.getClosestItem(e):"bid"===t?this._bidData.getClosestItem(e):null}},{key:"hasData",get:function(){return this._askData.length>0&&this._bidData.length>0}},{key:"askData",get:function(){return this._askData}},{key:"bidData",get:function(){return this._bidData}},{key:"lowerPriceBound",get:function(){return this._bidData.lowerPriceBound}},{key:"upperPriceBound",get:function(){return this._askData.upperPriceBound}},{key:"upperCountBound",get:function(){return Math.max(this._askData.upperCountBound,this._bidData.upperCountBound)}}]),e}(u.default);e.default=c,t.exports=e.default},function(t,e,i){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),r=i(12),a=function(t){return t&&t.__esModule?t:{default:t}}(r),s=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"ascending";n(this,t),this._data=new Map,this._lowerPriceBound=Number.MAX_SAFE_INTEGER,this._upperPriceBound=0,this._upperCountBound=0,this._firstItem=null,this._lastItem=null,this._currentItem=null,this._cumulativeTotalDirection=e}return o(t,[{key:"_updateItem",value:function(t,e){t.count=e,this._currentItem=t}},{key:"_insertItem",value:function(t){for(var e=this._currentItem;e!==t;){if(t.price<e.price){if(null!==e.previous){if(t.price<e.previous.price){e=e.previous;continue}return t.previous=e.previous,t.next=e,e.previous.next=t,e.previous=t,void(this._currentItem=t)}return e.previous=t,t.next=e,this._firstItem=t,void(this._currentItem=t)}if(t.price>e.price){if(null!==e.next){if(t.price>e.next.price){e=e.next;continue}return t.previous=e,t.next=e.next,e.next.previous=t,e.next=t,void(this._currentItem=t)}return e.next=t,t.previous=e,this._lastItem=t,void(this._currentItem=t)}}}},{key:"_deleteItem",value:function(t){var e=t.price.toString();if(this._data.has(e)){var i=t.previous,n=t.next;null!==i&&null!==n?(i.next=n,n.previous=i,this._currentItem=i):null!==n?(n.previous=null,this._firstItem=n,this._currentItem=n):null!==i&&(i.next=null,this._lastItem=i,this._currentItem=i)}t.next=null,t.previous=null,this._data.delete(e),0===this._data.size?(this._currentItem=null,this._firstItem=null,this._lastItem=null,this._lowerPriceBound=Number.MAX_SAFE_INTEGER,this._upperPriceBound=0,this._upperCountBound=0):(this._computeCumulatives(),this._computeBounds())}},{key:"_computeBounds",value:function(){this._lowerPriceBound=this._firstItem.price,this._upperPriceBound=this._lastItem.price,this._upperCountBound="ascending"===this._cumulativeTotalDirection?this._lastItem.cumulativeCount:this._firstItem.cumulativeCount}},{key:"_computeCumulatives",value:function(){for(var t="ascending"===this._cumulativeTotalDirection?this._firstItem:this._lastItem;null!==t;){var e="ascending"===this._cumulativeTotalDirection?t.previous:t.next;null!==e?(t.cumulativeCount=e.cumulativeCount+t.count,t.cumulativeCost=e.cumulativeCost+t.count*t.price):(t.cumulativeCount=t.count,t.cumulativeCost=t.count*t.price),this._cumulativeTotalDirection,t="ascending"===this._cumulativeTotalDirection?t.next:t.previous}}},{key:"add",value:function(t,e){var i=t.toString();if(0===this._data.size){var n=new a.default(t,e,e);this._firstItem=n,this._lastItem=n,this._data.set(i,n),this._currentItem=n}else if(this._data.has(i)){var o=this._data.get(i);if(e>0){if(o.count!==e){o.count;this._updateItem(o,e)}}else this._deleteItem(o)}else if(e>0){var r=new a.default(t,e,e);this._data.set(i,r),this._insertItem(r)}this._computeCumulatives(),this._computeBounds()}},{key:"getClosestItem",value:function(t){if(!this._data.has(t.toString())){if(null!==this._firstItem&&this._firstItem.price>t)return this._firstItem;if(null!==this._lastItem&&this._lastItem.price<t)return this._lastItem;for(var e=this._firstItem,i=this._lastItem;null!==e&&null!==i;){if(null!==e.next){if(!(t>e.next.price))return Math.abs(e.next.price-t)>Math.abs(e.price-t)?e:e.next;e=e.next}else e=null;if(null!==i.previous){if(!(t<i.previous.price))return Math.abs(i.previous.price-t)>Math.abs(i.price-t)?i:i.previous;i=i.previous}else i=null}return null}this._data.get(t.toString())}},{key:Symbol.iterator,value:function(){var t=this._cumulativeTotalDirection,e="ascending"===t?this._firstItem:this._lastItem;return{next:function(){if(null!==e){var i={value:e.valueOf(),done:!1};return e="ascending"===t?e.next:e.previous,i}return{value:void 0,done:!0}}}}},{key:"length",get:function(){return this._data.size}},{key:"firstItem",get:function(){return this._firstItem}},{key:"lastItem",get:function(){return this._lastItem}},{key:"lowerPriceBound",get:function(){return this._lowerPriceBound}},{key:"upperPriceBound",get:function(){return this._upperPriceBound}},{key:"upperCountBound",get:function(){return this._upperCountBound}}]),t}();e.default=s,t.exports=e.default},function(t,e,i){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),r=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;n(this,t),this._previous=null,this._next=null,this._price=e,this._count=i,this._cumulativeCount=o,this._cumulativeCost=r}return o(t,[{key:"previous",get:function(){return this._previous},set:function(t){this._previous=t}},{key:"next",get:function(){return this._next},set:function(t){this._next=t}},{key:"price",get:function(){return this._price},set:function(t){this._price=t}},{key:"count",get:function(){return this._count},set:function(t){this._count=t}},{key:"cumulativeCount",get:function(){return this._cumulativeCount},set:function(t){this._cumulativeCount=t}},{key:"cumulativeCost",get:function(){return this._cumulativeCost},set:function(t){this._cumulativeCost=t}}]),t}();e.default=r,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(1),u=n(h),l=i(0),_=n(l),c=function(t){function e(t){o(this,e);var i=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return i._containerElement=t,i._timeIntervalGroup=null,i._chartLineGroup=null,i._chartTypeGroup=null,i._timeIntervals=_.default.configuration.time_intervals,i._historyInterval=_.default.configuration.defaults.history_interval,i._drawSimpleMovingAverage=_.default.configuration.defaults.draw_simple_moving_average,i._drawExponentialMovingAverage=_.default.configuration.defaults.draw_exponential_moving_average,i._drawBollingerBands=_.default.configuration.defaults.draw_bollinger_bands,i._chartType=_.default.configuration.defaults.chart_type,i._build(),i._registerListeners(),i._updateState(),i}return a(e,t),s(e,[{key:"_buildSelectGroup",value:function(t){var e=document.createElement("div");e.classList.add("select-group"),this._containerElement.appendChild(e);var i=document.createElement("button");i.setAttribute("data-group",t),e.appendChild(i);var n=document.createElement("ul");return e.appendChild(n),e}},{key:"_buildButtonGroup",value:function(t){var e=document.createElement("div");return e.classList.add("button-group"),this._containerElement.appendChild(e),e}},{key:"_addItemToSelectGroup",value:function(t,e,i,n){var o=t.getElementsByTagName("ul")[0];if(o){var r=document.createElement("li");r.setAttribute("data-group",e),r.setAttribute("data-value",i),r.innerHTML=n,o.appendChild(r)}}},{key:"_addItemToButtonGroup",value:function(t,e,i,n){var o=document.createElement("button");o.setAttribute("data-group",e),o.setAttribute("data-value",i),o.innerHTML=n,t.appendChild(o)}},{key:"_build",value:function(){var t=this;this._timeIntervalGroup=this._buildSelectGroup("time-interval"),this._timeIntervals.forEach(function(e){t._addItemToSelectGroup(t._timeIntervalGroup,"time-interval",e.seconds.toString(),e.label)}),this._chartLineGroup=this._buildButtonGroup("chart-line"),this._addItemToButtonGroup(this._chartLineGroup,"chart-line","sma","SMA"),this._addItemToButtonGroup(this._chartLineGroup,"chart-line","ema","EMA"),this._addItemToButtonGroup(this._chartLineGroup,"chart-line","bb","BB"),this._chartTypeGroup=this._buildButtonGroup("chart-type"),this._addItemToButtonGroup(this._chartTypeGroup,"chart-type","candlestick","candle"),this._addItemToButtonGroup(this._chartTypeGroup,"chart-type","line","line"),this._addItemToButtonGroup(this._chartTypeGroup,"chart-type","bar","bar")}},{key:"_updateState",value:function(){var t=this,e=this._timeIntervalGroup.getElementsByTagName("button")[0],i=this._timeIntervalGroup.getElementsByTagName("ul")[0];i.classList.remove("active"),i.childNodes.forEach(function(i){parseInt(i.dataset.value,10)===t._historyInterval?(i.classList.add("active"),e.innerHTML=i.innerHTML+"&nbsp;&#9660;"):i.classList.remove("active")}),this._chartLineGroup.childNodes.forEach(function(e){"sma"===e.dataset.value?t._drawSimpleMovingAverage?e.classList.add("active"):e.classList.remove("active"):"ema"===e.dataset.value?t._drawExponentialMovingAverage?e.classList.add("active"):e.classList.remove("active"):"bb"===e.dataset.value&&(t._drawBollingerBands?e.classList.add("active"):e.classList.remove("active"))}),this._chartTypeGroup.childNodes.forEach(function(e){e.dataset.value===t._chartType?e.classList.add("active"):e.classList.remove("active")})}},{key:"_registerListeners",value:function(){var t=this;this._containerElement.addEventListener("click",function(e){"BUTTON"===e.target.nodeName?t._onButtonClick(e):"LI"===e.target.nodeName&&t._onListItemClick(e)})}},{key:"_onTimeIntervalButtonClick",value:function(t){var e=this._timeIntervalGroup.getElementsByTagName("ul")[0];e.classList.contains("active")?e.classList.remove("active"):e.classList.add("active")}},{key:"_onTimeIntervalListItemClick",value:function(t){var e=parseInt(t.target.dataset.value,10);this.historyInterval!==e&&(this.historyInterval=e,this.dispatchEvent("stateChanged"))}},{key:"_onChartLineButtonClick",value:function(t){"sma"===t.target.dataset.value?this.drawSimpleMovingAverage=!t.target.classList.contains("active"):"ema"===t.target.dataset.value?this.drawExponentialMovingAverage=!t.target.classList.contains("active"):"bb"===t.target.dataset.value&&(this.drawBollingerBands=!t.target.classList.contains("active")),this.dispatchEvent("stateChanged")}},{key:"_onChartTypeButtonClick",value:function(t){this.chartType=t.target.dataset.value,this.dispatchEvent("stateChanged")}},{key:"_onListItemClick",value:function(t){"time-interval"===t.target.dataset.group&&this._onTimeIntervalListItemClick(t)}},{key:"_onButtonClick",value:function(t){"time-interval"===t.target.dataset.group?this._onTimeIntervalButtonClick(t):"chart-line"===t.target.dataset.group?this._onChartLineButtonClick(t):"chart-type"===t.target.dataset.group&&this._onChartTypeButtonClick(t)}},{key:"containerElement",get:function(){return this._containerElement}},{key:"historyInterval",get:function(){return this._historyInterval},set:function(t){this._historyInterval=t,this._updateState()}},{key:"drawSimpleMovingAverage",get:function(){return this._drawSimpleMovingAverage},set:function(t){this._drawSimpleMovingAverage=t,this._updateState()}},{key:"drawExponentialMovingAverage",get:function(){return this._drawExponentialMovingAverage},set:function(t){this._drawExponentialMovingAverage=t,this._updateState()}},{key:"drawBollingerBands",get:function(){return this._drawBollingerBands},set:function(t){this._drawBollingerBands=t,this._updateState()}},{key:"chartType",get:function(){return this._chartType},set:function(t){this._chartType=t,this._updateState()}}]),e}(u.default);e.default=c,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=function t(e,i,n){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,i);if(void 0===o){var r=Object.getPrototypeOf(e);return null===r?void 0:t(r,i,n)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(n)},u=i(4),l=n(u),_=i(0),c=n(_),d=i(6),f=n(d),p=i(2),g=i(3),m=n(g),v=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,i));return n._infoElement=null,n._itemWidth=c.default.configuration.defaults.price_volume_history_item_width,n._itemMargin=0,n._drawSimpleMovingAverage=c.default.configuration.defaults.draw_simple_moving_average,n._drawExponentialMovingAverage=c.default.configuration.defaults.draw_exponential_moving_average,n._drawBollingerBands=c.default.configuration.defaults.draw_bollinger_bands,n._useGradient=c.default.configuration.price_history.use_gradient,n._useGridLines=c.default.configuration.price_history.use_grid_lines,n._lowerPriceBound=Number.MAX_SAFE_INTEGER,n._upperPriceBound=0,n._priceBoundsSpan=0,n._marketPrice=0,n._chartType=c.default.configuration.defaults.chart_type,n._configuration=Object.assign({},c.default.configuration.price_history),n._infoDimensions=new f.default,n._priceChartDimensions=new f.default,n._build(),n._registerListeners(),n}return a(e,t),s(e,[{key:"_build",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_build",this).call(this),this._element.classList.add("price-history"),this._infoElement=document.createElement("div"),this._infoElement.classList.add("info"),this._infoLabels=this._configuration.info_labels?this._configuration.info_labels:["P","O","C","H","L","V"],this._element.append(this._infoElement),this._infoElement.append(document.createElement("span")),this._infoElement.append(document.createElement("span")),this._infoElement.append(document.createElement("span")),this._infoElement.append(document.createElement("span")),this._infoElement.append(document.createElement("span")),this._infoElement.append(document.createElement("span")),this._xLabels.type=p.AxisLabelingType.DATETIME,this._xLabels.fontFace=this._fontFace,this._xLabels.fontSize=this._fontSize,this._xLabels.fontColor=this._configuration.x_label_color,this._yLabels.type=p.AxisLabelingType.CURRENCY,this._yLabels.fontFace=this._fontFace,this._yLabels.fontSize=this._fontSize,this._yLabels.fontColor=this._configuration.y_label_color,this._yLabels.tickPrefix=c.default.configuration.currency_character,this._yLabels.precision=this._configuration.y_label_precision}},{key:"_computeDimensions",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_computeDimensions",this).call(this),this._configuration.info_height%1==0?this._infoDimensions.height=this._configuration.info_height*this._pixelRatio:this._infoDimensions.height=this._chartDimensions.height*this._configuration.info_height|0,this._infoDimensions.width=this._chartDimensions.width,this._infoDimensions.x=this._chartDimensions.x,this._infoDimensions.y=this._chartDimensions.y,this._priceChartDimensions.x=this._chartDimensions.x,this._priceChartDimensions.y=this._chartDimensions.y+this._infoDimensions.height,this._priceChartDimensions.width=this._chartDimensions.width,this._priceChartDimensions.height=this._chartDimensions.height-this._infoDimensions.height-1;var t=this._infoElement.style;t.top=this._infoDimensions.y/this._pixelRatio+"px",t.left=this._infoDimensions.x/this._pixelRatio+"px",t.width=this._infoDimensions.width/this._pixelRatio+"px",t.height=this._infoDimensions.height/this._pixelRatio+"px",this._yLabelDimensions.y=this._priceChartDimensions.y,this._yLabelDimensions.height=this._priceChartDimensions.height,this._draw()}},{key:"_computeBounds",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_computeBounds",this).call(this);for(var t=Number.MAX_SAFE_INTEGER,i=0,n=this._drawStartIndex;n<this._drawEndIndex;n++){var o=this._data.getItemAt(n);o.low<t&&(t=o.low),this._drawSimpleMovingAverage&&o.simpleMovingAverage<t&&(t=o.simpleMovingAverage.toFixed(6)),this._drawExponentialMovingAverage&&o.exponentialMovingAverage<t&&(t=o.exponentialMovingAverage),this._drawBollingerBands&&Math.max(o.simpleMovingAverage-o.standardDeviation*this._configuration.bollinger_standard_deviation_offset,0)<t&&(t=Math.max(o.simpleMovingAverage-o.standardDeviation*this._configuration.bollinger_standard_deviation_offset,0)),o.high>i&&(i=o.high),this._drawSimpleMovingAverage&&o.simpleMovingAverage>i&&(i=o.simpleMovingAverage),this._drawExponentialMovingAverage&&o.exponentialMovingAverage>i&&(i=o.exponentialMovingAverage),this._drawBollingerBands&&o.simpleMovingAverage+o.standardDeviation*this._configuration.bollinger_standard_deviation_offset>i&&(i=o.simpleMovingAverage+o.standardDeviation*this._configuration.bollinger_standard_deviation_offset)}return(this._lowerPriceBound!==t||this._upperPriceBound!==i)&&(this._lowerPriceBound=t,this._upperPriceBound=i,this._priceBoundsSpan=this._upperPriceBound-this._lowerPriceBound,!0)}},{key:"_drawCandlestick",value:function(t,e){var i=this._itemWidth/2||.5,n=this._itemWidth>1?1:.5,o=n/2;this._drawingContext.fillStyle=t.bullish?this._configuration.bullish_color:this._configuration.bearish_color;var r=Math.max(t.high,t.low),a=Math.min(t.high,t.low),s=Math.max(t.open,t.close),h=Math.min(t.open,t.close),u=1-(r-this._lowerPriceBound)/this._priceBoundsSpan,l=1-(a-this._lowerPriceBound)/this._priceBoundsSpan,_=1-(s-this._lowerPriceBound)/this._priceBoundsSpan,c=1-(h-this._lowerPriceBound)/this._priceBoundsSpan,d=this._priceChartDimensions.y+u*this._priceChartDimensions.height,f=this._priceChartDimensions.y+l*this._priceChartDimensions.height,p=this._priceChartDimensions.y+_*this._priceChartDimensions.height,g=this._priceChartDimensions.y+c*this._priceChartDimensions.height;this._drawingContext.fillRect(e+i-o,.5+(0|d),n,f-d),this._itemWidth>1&&this._drawingContext.fillRect(e,.5+(0|p),this._itemWidth,Math.max(g-p,.5))}},{key:"_drawBar",value:function(t,e){var i=this._itemWidth/2||.5,n=this._itemWidth>1?1:.5,o=n/2;this._drawingContext.fillStyle=t.bullish?this._configuration.bullish_color:this._configuration.bearish_color;var r=Math.max(t.high,t.low),a=Math.min(t.high,t.low),s=1-(r-this._lowerPriceBound)/this._priceBoundsSpan,h=1-(a-this._lowerPriceBound)/this._priceBoundsSpan,u=1-(t.open-this._lowerPriceBound)/this._priceBoundsSpan,l=1-(t.close-this._lowerPriceBound)/this._priceBoundsSpan,_=this._priceChartDimensions.y+s*this._priceChartDimensions.height,c=this._priceChartDimensions.y+h*this._priceChartDimensions.height,d=this._priceChartDimensions.y+u*this._priceChartDimensions.height,f=this._priceChartDimensions.y+l*this._priceChartDimensions.height;this._drawingContext.fillRect(e+i-o,.5+(0|_),n,c-_),this._itemWidth>1&&(this._drawingContext.fillRect(e,.5+(0|d),i,n),this._drawingContext.fillRect(e+i,.5+(0|f),i,n))}},{key:"_drawBackground",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawBackground",this).call(this,t)}},{key:"_drawChart",value:function(t){if(h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawChart",this).call(this,t),this._data.hasData&&(t||this.indicesInvalidated||this.boundsInvalidated||this._dimensionsInvalidated)){var i=this._itemWidth+this._itemMargin,n=this._drawEndIndex-this._drawStartIndex,o=this._priceChartDimensions.width/i|0,r=this._priceChartDimensions.x,a=[],s=[],u=[],l=[],_=[];o>n&&(r+=(o-n)*i|0);for(var c=this._drawStartIndex;c<this._drawEndIndex;c++){var d=this._data.getItemAt(c),f=r+(c-this._drawStartIndex)*i,p=f+(this._itemWidth/2|0);if("candlestick"===this._chartType)this._drawCandlestick(d,f);else if("bar"===this._chartType)this._drawBar(d,f);else{var g=this._priceChartDimensions.y+(1-(d.close-this._lowerPriceBound)/this._priceBoundsSpan)*this._priceChartDimensions.height;a.push([p,g])}if(this._drawSimpleMovingAverage||this._drawBollingerBands){var v=this._priceChartDimensions.y+(1-(d.simpleMovingAverage-this._lowerPriceBound)/this._priceBoundsSpan)*this._priceChartDimensions.height;s.push([p,v])}if(this._drawExponentialMovingAverage){var y=this._priceChartDimensions.y+(1-(d.exponentialMovingAverage-this._lowerPriceBound)/this._priceBoundsSpan)*this._priceChartDimensions.height;u.push([p,y])}if(this._drawBollingerBands){var b=this._priceChartDimensions.y+(1-(d.simpleMovingAverage+d.standardDeviation*this._configuration.bollinger_standard_deviation_offset-this._lowerPriceBound)/this._priceBoundsSpan)*this._priceChartDimensions.height,w=this._priceChartDimensions.y+(1-(d.simpleMovingAverage-d.standardDeviation*this._configuration.bollinger_standard_deviation_offset-this._lowerPriceBound)/this._priceBoundsSpan)*this._priceChartDimensions.height;l.push([p,b]),_.push([p,w])}}if("line"===this._chartType){var x=this._useGradient&&a.length>0?this._createGradient(a):null;m.default.drawPath(this._drawingContext,a,x,this._configuration.price_line_color,1)}if((this._drawSimpleMovingAverage||this._drawBollingerBands)&&m.default.drawPath(this._drawingContext,s,null,this._configuration.sma_line_color,1),this._drawExponentialMovingAverage&&m.default.drawPath(this._drawingContext,u,null,this._configuration.ema_line_color,1),this._drawBollingerBands&&(m.default.drawPath(this._drawingContext,l,null,this._configuration.bollinger_band_upper_line_color,1),m.default.drawPath(this._drawingContext,_,null,this._configuration.bollinger_band_lower_line_color,1)),this._marketPrice>=this._lowerPriceBound&&this._marketPrice<=this._upperPriceBound){var k=.5+(this._priceChartDimensions.y+(1-(this._marketPrice-this._lowerPriceBound)/this._priceBoundsSpan)*this._priceChartDimensions.height|0);this._drawingContext.beginPath(),this._drawingContext.strokeStyle=this._configuration.market_price_line_color,this._drawingContext.lineWidth=.5,this._drawingContext.setLineDash([6,4]),this._drawingContext.moveTo(this._priceChartDimensions.x,k),this._drawingContext.lineTo(this._priceChartDimensions.x+this._priceChartDimensions.width,k),this._drawingContext.stroke(),this._drawingContext.setLineDash([])}}}},{key:"_createGradient",value:function(t){var e=this._configuration.first_gradient_color,i=this._configuration.second_gradient_color,n=t.reduce(function(t,e){return e[1]>t?e[1]:t},t[0][1]),o=t.reduce(function(t,e){return e[1]<t?e[1]:t},t[0][1]),r=t.reduce(function(t,e){return e[0]>t?e[0]:t},t[0][0]),a=r/2,s=o,h=r/2,u=n;if(!(isNaN(a)||isNaN(s)||isNaN(h)||isNaN(u))){var l=this._drawingContext.createLinearGradient(a,s,h,u);return l.addColorStop(0,e),l.addColorStop(1,i),l}}},{key:"_drawLabels",value:function(t){if(this._data.hasData&&(this.indicesInvalidated=this._computeIndices(),this.boundsInvalidated=this._computeBounds(),this._xLabels.minimum=this._data.getItemAt(this._drawStartIndex).timestamp,this._xLabels.maximum=this._data.getItemAt(this._drawEndIndex).timestamp,this._yLabels.minimum=this._lowerPriceBound,this._yLabels.maximum=this._upperPriceBound,h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawLabels",this).call(this,t),this._useGridLines&&this._drawGridLines(t),this._marketPrice>=this._lowerPriceBound&&this._marketPrice<=this._upperPriceBound)){var i=m.default.formatNumberToLocale(this._marketPrice,this._yLabels.precision),n=this._yLabelDimensions.y+(1-(this._marketPrice-this._lowerPriceBound)/this._priceBoundsSpan)*this._yLabelDimensions.height|0;this._drawingContext.fillStyle=this._configuration.market_price_background_color,this._drawingContext.fillRect(this._yLabelDimensions.x,n-.75*this._fontSize,this._yLabelDimensions.width,1.5*this._fontSize),this._drawingContext.fillStyle=this._configuration.market_price_label_color,this._drawingContext.fillText("- "+c.default.configuration.currency_character+i,this._yLabelDimensions.x,n+this._fontSize/4)}}},{key:"_drawGridLines",value:function(t){var e=this,i=c.default.configuration.price_history.grid_lines_color,n=c.default.configuration.price_history.grid_lines_dashed?[5,3]:[];this._drawingContext.setLineDash(n),this._drawingContext.lineWidth=1,this._drawingContext.beginPath(),this._yLabels.tickPoints.forEach(function(t){e._drawingContext.moveTo(e._xLabelDimensions.width,t-2.5),e._drawingContext.lineTo(0,t-2.5)}),this._xLabels.tickPoints.forEach(function(t){e._drawingContext.moveTo(t+.5,e._yLabelDimensions.y+e._yLabelDimensions.height),e._drawingContext.lineTo(t+.5,e._yLabelDimensions.y)}),this._drawingContext.strokeStyle=i,this._drawingContext.stroke(),this._drawingContext.setLineDash([])}},{key:"_drawBorders",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawBorders",this).call(this,t),this._drawingContext.fillStyle=this._configuration.border_secondary_color,this._drawingContext.fillRect(this._infoDimensions.x,this._infoDimensions.y+this._infoDimensions.height-1,this._infoDimensions.width,1),this._drawingContext.fillRect(this._xLabelDimensions.x,this._xLabelDimensions.y,this._xLabelDimensions.width,1),this._drawingContext.fillRect(this._yLabelDimensions.x,this._yLabelDimensions.y,1,this._yLabelDimensions.height)}},{key:"_updateInfo",value:function(t){var e=(this._mouseX-this._priceChartDimensions.x)/this._priceChartDimensions.width,i=this._drawEndIndex-this._drawStartIndex+1,n=Math.floor(i*e);n=Math.min(Math.max(n,0),i);var o=this._drawStartIndex+n,r=this._data.getItemAt(o),a=[],s=m.default.formatNumberToLocale(this._marketPrice,this._configuration.info_precision);if(r&&void 0===t){var h=m.default.formatNumberToLocale(r.open,this._configuration.info_precision),u=m.default.formatNumberToLocale(r.close,this._configuration.info_precision),l=m.default.formatNumberToLocale(r.high,this._configuration.info_precision),_=m.default.formatNumberToLocale(r.low,this._configuration.info_precision),d=m.default.formatNumberToLocale(r.volume,this._configuration.info_precision),f=c.default.configuration.currency_character;a.push('<label class="ac-price">'+this._infoLabels[0]+"</label> "+f+s),a.push('<label class="ac-open">'+this._infoLabels[1]+"</label> "+f+h),a.push('<label class="ac-close">'+this._infoLabels[2]+"</label> "+f+u),a.push('<label class="ac-high">'+this._infoLabels[3]+"</label> "+f+l),a.push('<label class="ac-low">'+this._infoLabels[4]+"</label> "+f+_),a.push('<label class="ac-volume">'+this._infoLabels[5]+"</label> "+d)}else a=['<label class="ac-price">'+this._infoLabels[0]+"</label> "+c.default.configuration.currency_character+s,"","","","",""];if(this._infoElement.hasChildNodes())for(var p=this._infoElement.childNodes,g=0;g<p.length;g++)p[g].innerHTML=a[g]}},{key:"_onMouseLeave",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseLeave",this).call(this,t),t.target===this._element&&this._updateInfo("")}},{key:"_onMouseDown",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseDown",this).call(this,t),this._updateInfo()}},{key:"_onMouseMove",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseMove",this).call(this,t);var i=t.target.offsetParent&&t.target.offsetParent.classList.contains("price-history");!this._mouseIsDown&&i&&this._updateInfo()}},{key:"_unregisterListeners",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_unregisterListeners",this).call(this)}},{key:"marketPrice",get:function(){return this._marketPrice},set:function(t){this._marketPrice!==t&&(this._marketPrice=t,this._updateInfo(),this._draw(!0))}},{key:"drawSimpleMovingAverage",get:function(){return this._drawSimpleMovingAverage},set:function(t){this._drawSimpleMovingAverage!==t&&(this._drawSimpleMovingAverage=t,this._draw(!0))}},{key:"drawExponentialMovingAverage",get:function(){return this._drawExponentialMovingAverage},set:function(t){this._drawExponentialMovingAverage!==t&&(this._drawExponentialMovingAverage=t,this._draw(!0))}},{key:"drawBollingerBands",get:function(){return this._drawBollingerBands},set:function(t){this._drawBollingerBands!==t&&(this._drawBollingerBands=t,this._draw(!0))}},{key:"chartType",get:function(){return this._chartType},set:function(t){this._chartType=t,this._draw(!0)}}]),e}(l.default);e.default=v,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(1),u=n(h),l=i(2),_=i(0),c=n(_),d=i(16),f=n(d),p=i(3),g=n(p),m=function(t){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"sans-serif",h=arguments.length>5&&void 0!==arguments[5]?arguments[5]:12,u=arguments.length>6&&void 0!==arguments[6]?arguments[6]:"#ffffff",l=arguments.length>7&&void 0!==arguments[7]?arguments[7]:"",_=arguments.length>8&&void 0!==arguments[8]&&arguments[8];o(this,e);var c=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return null!==t&&(c._dimensions=t),c._type=i,c._orientation=n,c._precision=a,c._fontFace=s,c._fontSize=h,c._fontColor=u,c._tickPrefix=l,c._abbreviate=_,c._minimum=0,c._maximum=0,c._span=0,c._tickPoints=[],c}return a(e,t),s(e,[{key:"_drawHorizontal",value:function(t){var e=this,i=this._dimensions.width/(10*this._fontSize)|0;if(this._tickPoints=[],this._type===l.AxisLabelingType.DATETIME)for(var n=this._span/i|0,o=this._maximum;o>this._minimum&&o-n>this._minimum;){o-=n;var r=(o-this._minimum)/this._span,a=this._dimensions.x+r*this._dimensions.width,s=this._dimensions.y;this._tickPoints.push(a);var h=new Date(1e3*o),u=(h.getUTCDate(),c.default.configuration.date_format_months[h.getMonth()]+" "+h.getDate()),_=t.measureText(u).width/2|0;t.fillRect(a,s,1,5),t.fillText(u,a-_,s+this._fontSize+5)}else{f.default.generate(this._minimum,this._maximum,i,!1).forEach(function(i){var n=(i-e._minimum)/e._span,o=e._dimensions.x+n*e._dimensions.width,r=e._dimensions.y,a=void 0;if(e._tickPoints.push(o),e._type===l.AxisLabelingType.DATETIME){var s=new Date(1e3*i);s.getUTCDate(),c.default.configuration.date_format_months[s.getMonth()],s.getDate();console.log(i)}else a=e._abbreviate?g.default.abbreviateNumber(i):g.default.formatNumberToLocale(i,e._precision),""!==e._tickPrefix&&(a=e._tickPrefix+a);var h=t.measureText(a).width/2|0;t.fillRect(o,r,1,5),t.fillText(a,o-h,r+e._fontSize+5)})}}},{key:"_drawVertical",value:function(t){var e=this,i=this._dimensions.height/(2*this._fontSize)|0,n=f.default.generate(this._minimum,this._maximum,i,!1);this._tickPoints=[],n.forEach(function(i){var n=1-(i-e._minimum)/e._span,o=e._dimensions.x,r=e._dimensions.y+2+n*e._dimensions.height;e._tickPoints.push(r),i%1!=0&&e._precision>0&&(i=i.toFixed(e._precision));var a=void 0;a=e._abbreviate?g.default.abbreviateNumber(i):g.default.formatNumberToLocale(i,e._precision),""!==e._tickPrefix&&(a=e._tickPrefix+a),a="- "+a,t.fillText(a,o,r)})}},{key:"draw",value:function(t){void 0!==t&&null!==this._dimensions&&0!==this._type&&0!==this._span&&0!==this._dimensions.width&&0!==this._dimensions.height&&(t.font=this._font,t.fillStyle=this._fontColor,this._orientation===l.AxisLabelingOrientation.HORIZONTAL?this._drawHorizontal(t):this._orientation===l.AxisLabelingOrientation.VERTICAL&&this._drawVertical(t))}},{key:"dimensions",get:function(){return this._dimensions},set:function(t){this._dimensions!==t&&(this._dimensions=t)}},{key:"type",get:function(){return this._type},set:function(t){this._type!==t&&(this._type=t)}},{key:"orientation",get:function(){return this._orientation},set:function(t){this._orientation!==t&&(this._orientation=t)}},{key:"precision",get:function(){return this._precision},set:function(t){this._precision!==t&&(this._precision=t)}},{key:"fontFace",get:function(){return this._fontFace},set:function(t){this._fontFace!==t&&(this._fontFace=t)}},{key:"fontSize",get:function(){return this._fontSize},set:function(t){this._fontSize!==t&&(this._fontSize=t)}},{key:"fontColor",get:function(){return this._fontColor},set:function(t){this._fontColor!==t&&(this._fontColor=t)}},{key:"font",get:function(){return this._font},set:function(t){this._font!==t&&(this._font=t)}},{key:"tickPrefix",get:function(){return this._tickPrefix},set:function(t){this._tickPrefix!==t&&(this._tickPrefix=t)}},{key:"abbreviate",get:function(){return this._abbreviate},set:function(t){this._abbreviate!==t&&(this._abbreviate=t)}},{key:"minimum",get:function(){return this._minimum},set:function(t){this._minimum!==t&&(this._minimum=t,this._span=this._maximum-this._minimum)}},{key:"maximum",get:function(){return this._maximum},set:function(t){this._maximum!==t&&(this._maximum=t,this._span=this._maximum-this._minimum)}},{key:"tickPoints",get:function(){return this._tickPoints}}]),e}(u.default);e.default=m,t.exports=e.default},function(t,e,i){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),r=function(){function t(){n(this,t)}return o(t,null,[{key:"getBases",value:function(){return[1,2,2.5,5]}},{key:"getNiceInterval",value:function(e,i,n){var o=(i-e)/n,r=Math.log10(o),a=[Math.floor(r),Math.ceil(r)],s=1/0;return t.getBases().forEach(function(t){a.forEach(function(e){var i=t*Math.pow(10,e);Math.abs(o-i)<Math.abs(o-s)&&(s=i)})}),s}},{key:"generate",value:function(e,i,n,o){var r=e<10&&i<10;r&&(e*=1e3,i*=1e3);for(var a=t.getNiceInterval(e,i,n),s=Math.ceil(e/a)*a,h=[s];s<i&&s+a<i;)s+=a,h.push(s);var u=Math.pow(10,Math.ceil(Math.log10(a))+1);return h=h.map(function(t){var e=Math.round(t*u)/u;return r&&(e/=1e3),e}),o&&(r&&(e/=1e3,i/=1e3),h[0]=e,h[h.length-1]=i),h}}]),t}();e.default=r,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=function t(e,i,n){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,i);if(void 0===o){var r=Object.getPrototypeOf(e);return null===r?void 0:t(r,i,n)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(n)},u=i(4),l=n(u),_=i(0),c=n(_),d=i(2),f=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,i));return n._upperVolumeBound=0,n._configuration=Object.assign({},c.default.configuration.volume_history),n._build(),n._registerListeners(),n}return a(e,t),s(e,[{key:"_build",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_build",this).call(this),this._element.classList.add("volume-history"),this._yLabels.type=d.AxisLabelingType.NUMBER,this._yLabels.fontFace=this._fontFace,this._yLabels.fontSize=this._fontSize,this._yLabels.fontColor=this._configuration.y_label_color,this._yLabels.abbreviate=!0}},{key:"_computeDimensions",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_computeDimensions",this).call(this),this._draw()}},{key:"_computeBounds",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_computeBounds",this).call(this);for(var t=0,i=this._drawStartIndex;i<this._drawEndIndex;i++){var n=this._data.getItemAt(i);n.volume>t&&(t=n.volume)}return this._upperVolumeBound!==t&&(this._upperVolumeBound=t,!0)}},{key:"_drawVolumeItem",value:function(t,e){this._drawingContext.fillStyle=t.bullish?this._configuration.bullish_color:this._configuration.bearish_color;var i=this._chartDimensions.y+(1-t.volume/this._upperVolumeBound)*this._chartDimensions.height,n=this._chartDimensions.y+this._chartDimensions.height-i;this._drawingContext.fillRect(e,i,this._itemWidth,n)}},{key:"_drawChart",value:function(t){if(h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawChart",this).call(this,t),this._data.hasData){var i=this._computeIndices(),n=this._computeBounds();if(t||i||n||this._dimensionsInvalidated){var o=this._itemWidth+this._itemMargin,r=this._drawEndIndex-this._drawStartIndex,a=this._chartDimensions.width/o|0,s=this._chartDimensions.x;a>r&&(s+=(a-r)*o|0);for(var u=this._drawStartIndex;u<this._drawEndIndex;u++){var l=this._data.getItemAt(u),_=s+(u-this._drawStartIndex)*o;this._drawVolumeItem(l,_)}}}}},{key:"_drawLabels",value:function(t){this._data.hasData&&(this._yLabels.minimum=0,this._yLabels.maximum=this._upperVolumeBound,h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawLabels",this).call(this,t))}},{key:"_drawBorders",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawBorders",this).call(this,t),this._drawingContext.fillStyle=this._configuration.border_secondary_color,this._drawingContext.fillRect(this._yLabelDimensions.x,this._yLabelDimensions.y,1,this._yLabelDimensions.height)}},{key:"_unregisterListeners",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_unregisterListeners",this).call(this)}}]),e}(l.default);e.default=f,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=function t(e,i,n){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,i);if(void 0===o){var r=Object.getPrototypeOf(e);return null===r?void 0:t(r,i,n)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(n)},u=i(4),l=n(u),_=i(0),c=n(_),d=i(2),f=i(3),p=n(f),g=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,i));return n._upperMACDBound=0,n._configuration=Object.assign({},c.default.configuration.macd_history),n._build(),n._registerListeners(),n}return a(e,t),s(e,[{key:"_build",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_build",this).call(this),this._element.classList.add("macd-history"),this._yLabels.type=d.AxisLabelingType.NUMBER,this._yLabels.fontFace=this._fontFace,this._yLabels.fontSize=this._fontSize,this._yLabels.fontColor=this._configuration.y_label_color}},{key:"_computeDimensions",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_computeDimensions",this).call(this),this._draw()}},{key:"_computeBounds",value:function(){for(var t=(Number.MAX_SAFE_INTEGER,0),e=this._drawStartIndex;e<this._drawEndIndex;e++){var i=this._data.getItemAt(e);Math.abs(i.macdIndicator)>t&&(t=Math.abs(i.macdIndicator)),Math.abs(i.macdSignal)>t&&(t=Math.abs(i.macdIndicator)),Math.abs(i.macdDisparity)>t&&(t=Math.abs(i.macdDisparity))}return this._upperMACDBound!==t&&(this._upperMACDBound=t,!0)}},{key:"_drawMACD",value:function(t,e){var i=(this._chartDimensions,this._chartDimensions.y+this._chartDimensions.height/2),n=Math.abs(t.macdDisparity)/this._upperMACDBound*(this._chartDimensions.height/2);t.macdDisparity>=0?(this._drawingContext.fillStyle=this._configuration.histogram_positive_color,i-=n):this._drawingContext.fillStyle=this._configuration.histogram_negative_color,this._drawingContext.fillRect(e,i,this._itemWidth,n)}},{key:"_drawChart",value:function(t){if(h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawChart",this).call(this),this._data.hasData){var i=this._computeIndices(),n=this._computeBounds();if(t||i||n||this._dimensionsInvalidated){var o=this._itemWidth+this._itemMargin,r=this._drawEndIndex-this._drawStartIndex,a=this._chartDimensions.width/o|0,s=this._chartDimensions.x,u=[],l=[];a>r&&(s+=(a-r)*o|0);for(var _=this._drawStartIndex;_<this._drawEndIndex;_++){var c=this._data.getItemAt(_),d=s+(_-this._drawStartIndex)*o,f=d+(this._itemWidth/2|0),g=this._chartDimensions.y+(1-(this._upperMACDBound+c.macdIndicator)/(2*this._upperMACDBound))*this._chartDimensions.height,m=this._chartDimensions.y+(1-(this._upperMACDBound+c.macdSignal)/(2*this._upperMACDBound))*this._chartDimensions.height;u.push([f,g]),l.push([f,m]),this._drawMACD(c,d)}p.default.drawPath(this._drawingContext,u,null,this._configuration.indicator_line_color,1),p.default.drawPath(this._drawingContext,l,null,this._configuration.signal_line_color,1)}}}},{key:"_drawLabels",value:function(t){this._data.hasData&&(this._yLabels.minimum=-this._upperMACDBound,this._yLabels.maximum=this._upperMACDBound,h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawLabels",this).call(this,t))}},{key:"_drawBorders",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawBorders",this).call(this,t),this._drawingContext.fillStyle=this._configuration.border_secondary_color,this._drawingContext.fillRect(this._yLabelDimensions.x,this._yLabelDimensions.y,1,this._yLabelDimensions.height),this._drawingContext.fillStyle=this._configuration.zero_line_color,this._drawingContext.fillRect(this._chartDimensions.x,this._chartDimensions.y+this._chartDimensions.height/2,this._chartDimensions.width,1)}},{key:"_unregisterListeners",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_unregisterListeners",this).call(this)}}]),e}(l.default);e.default=g,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=function t(e,i,n){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,i);if(void 0===o){var r=Object.getPrototypeOf(e);return null===r?void 0:t(r,i,n)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(n)},u=i(5),l=n(u),_=i(0),c=n(_),d=i(2),f=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n._fullRangeCanvas=null,n._fullRangeContext=null,n._data=i,n._rangeStartIndex=0,n._rangeEndIndex=100,n._range=null,n._leftHandle=null,n._rightHandle=null,n._dragMode=null,n._dragStartIndex=0,n._dragStartSpan=0,n._configuration=Object.assign({},c.default.configuration.range_selector),n._build(),n._registerListeners(),n}return a(e,t),s(e,[{key:"_build",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_build",this).call(this),this._element.classList.add("range-selector"),this._fullRangeCanvas=document.createElement("canvas"),this._fullRangeContext=this._fullRangeCanvas.getContext("2d",{antialias:!1,alpha:!1}),this._fullRangeContext.imageSmoothingEnabled=!1,this._fullRangeContext.imageSmoothingQuality="low",this._range=document.createElement("div"),this._range.classList.add("range"),this._range.style.cursor="move",this._range.style.left="-5000px",this._leftHandle=document.createElement("button"),this._leftHandle.classList.add("handle"),this._leftHandle.style.cursor="col-resize",this._leftHandle.style.left="-5000px",this._rightHandle=document.createElement("button"),this._rightHandle.classList.add("handle"),this._rightHandle.style.cursor="col-resize",this._rightHandle.style.left="-5000px",this._element.append(this._range),this._element.append(this._leftHandle),this._element.append(this._rightHandle),this._xLabels.type=d.AxisLabelingType.DATETIME,this._xLabels.fontFace=this._fontFace,this._xLabels.fontSize=this._fontSize,this._xLabels.fontColor=this._configuration.x_label_color}},{key:"_computeDimensions",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_computeDimensions",this).call(this),this._draw()}},{key:"_drawFullRange",value:function(){var t=this._data.length-1;this._fullRangeCanvas.width=2*this._chartDimensions.width,this._fullRangeCanvas.height=2*this._chartDimensions.height,this._fullRangeContext.fillStyle=this._configuration.background_color,this._fullRangeContext.fillRect(0,0,this._fullRangeCanvas.width,this._fullRangeCanvas.height);Math.max(this._fullRangeCanvas.width/t,.05);if(this._data.hasData){this._fullRangeContext.strokeStyle=this._configuration.price_line_color,this._fullRangeContext.lineWidth=1,this._fullRangeContext.beginPath();for(var e=0;e<t;e++){var i=this._data.getItemAt(e),n=e/t*this._fullRangeCanvas.width,o=.5+((1-(i.close-this._data.lowerPriceBound)/this._data.priceBoundsSpan)*this._fullRangeCanvas.height|0);0===e?this._fullRangeContext.moveTo(n,o):this._fullRangeContext.lineTo(n,o)}this._fullRangeContext.stroke()}}},{key:"_drawBackground",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawBackground",this).call(this,t),this._dimensionsInvalidated&&this._drawFullRange(),this._fullRangeCanvas.width&&this._fullRangeCanvas.height&&this._drawingContext.drawImage(this._fullRangeCanvas,0,0,this._chartDimensions.width,this._chartDimensions.height)}},{key:"_drawChart",value:function(t){if(h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawChart",this).call(this,t),!this._data.hasData)return this._range.style.left="-5000px",this._leftHandle.style.left="-5000px",void(this._rightHandle.style.left="-5000px");var i=this._leftHandle.offsetWidth,n=this._leftHandle.offsetHeight,o=this._rangeStartIndex/(this._data.length-1),r=this._rangeEndIndex/(this._data.length-1),a=this._leftHandle.style;a.left=this._chartDimensions.x/this._pixelRatio+(o*(this._chartDimensions.width/this._pixelRatio)-i/2)+"px",a.top=(this._chartDimensions.height/this._pixelRatio-n)/2+"px";var s=this._rightHandle.style;s.left=this._chartDimensions.x/this._pixelRatio+(r*(this._chartDimensions.width/this._pixelRatio)-i/2)+"px",s.top=(this._chartDimensions.height/this._pixelRatio-n)/2+"px";var u=this._range.style;u.left=this._chartDimensions.x+o*(this._chartDimensions.width/this._pixelRatio)+"px",u.right=this._width/this._pixelRatio-(this._chartDimensions.x/this._pixelRatio+r*(this._chartDimensions.width/this._pixelRatio))+"px",u.top=this._chartDimensions.y/this._pixelRatio+"px",u.height=this._chartDimensions.height/this._pixelRatio+"px"}},{key:"_drawLabels",value:function(t){this._data.hasData&&(this._xLabels.minimum=this._data.getItemAt(0).timestamp,this._xLabels.maximum=this._data.getItemAt(this._data.length-1).timestamp,h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawLabels",this).call(this,t))}},{key:"_drawBorders",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawBorders",this).call(this,t),this._drawingContext.fillStyle=this._configuration.border_secondary_color,this._drawingContext.fillRect(this._xLabelDimensions.x,this._xLabelDimensions.y,this._xLabelDimensions.width,1)}},{key:"_registerListeners",value:function(){var t=this;h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_registerListeners",this).call(this),this._data.addEventListener("parseComplete",function(){t._drawFullRange(),t._draw()})}},{key:"_unregisterListeners",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_unregisterListeners",this).call(this)}},{key:"_onMouseLeave",value:function(t){t.target===this._element&&h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseLeave",this).call(this,t)}},{key:"_handleDragStart",value:function(t){this._dragMode=t,this._dragStartIndex=this._rangeStartIndex,this._dragStartSpan=this._rangeEndIndex-this._rangeStartIndex}},{key:"_handleDrag",value:function(){if(0!==this._mouseDragXDistance){var t=this._mouseDragXDistance/this._chartDimensions.width,e=Math.abs(t)*(this._data.length-1)|0,i=this._rangeStartIndex,n=this._rangeEndIndex;this._mouseDragXDistance<0&&(e=-e),this._dragMode===d.RangeSelectorDragMode.PAN?(i=Math.min(Math.max(this._dragStartIndex+e,0),this._data.length-1-this._dragStartSpan),n=i+this._dragStartSpan):this._dragMode===d.RangeSelectorDragMode.RESIZE_LEFT?i=Math.min(Math.max(this._dragStartIndex+e,0),n):this._dragMode===d.RangeSelectorDragMode.RESIZE_RIGHT&&(n=Math.min(Math.max(this._dragStartIndex+this._dragStartSpan+e,i),this._data.length-1)),this._rangeStartIndex===i&&this._rangeEndIndex===n||(this._rangeStartIndex=i,this._rangeEndIndex=n,this._draw(),this._dragMode===d.RangeSelectorDragMode.PAN&&this.dispatchEvent("rangeChanged",this._rangeStartIndex,this._rangeEndIndex))}}},{key:"_handleDragEnd",value:function(){this._dragMode!==d.RangeSelectorDragMode.PAN&&this._dragMode!==d.RangeSelectorDragMode.RESIZE_LEFT&&this._dragMode!==d.RangeSelectorDragMode.RESIZE_RIGHT||this.dispatchEvent("rangeChanged",this._rangeStartIndex,this._rangeEndIndex),this._dragMode=null}},{key:"_onMouseMove",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseMove",this).call(this,t),this._mouseIsDown&&this._handleDrag()}},{key:"_onMouseDown",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseDown",this).call(this,t),t.target===this._leftHandle?this._handleDragStart(d.RangeSelectorDragMode.RESIZE_LEFT):t.target===this._rightHandle?this._handleDragStart(d.RangeSelectorDragMode.RESIZE_RIGHT):t.target===this._range&&this._handleDragStart(d.RangeSelectorDragMode.PAN)}},{key:"_onMouseUp",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseUp",this).call(this,t),this._handleDragEnd()}},{key:"setRange",value:function(t,e){this._rangeStartIndex=t,this._rangeEndIndex=e,this._draw()}},{key:"rangeStartIndex",get:function(){return this._rangeStartIndex}},{key:"rangeEndIndex",get:function(){return this._rangeEndIndex}}]),e}(l.default);e.default=f,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=function t(e,i,n){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,i);if(void 0===o){var r=Object.getPrototypeOf(e);return null===r?void 0:t(r,i,n)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(n)},u=i(5),l=n(u),_=i(0),c=n(_),d=i(6),f=n(d),p=i(2),g=i(3),m=n(g),v=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n._data=i,n._infoElement=null,n._marketPrice=0,n._lowerPriceBound=Number.MAX_SAFE_INTEGER,n._upperPriceBound=0,n._upperCountBound=0,n._priceBoundsSpan=0,n._configuration=Object.assign({},c.default.configuration.order_book_depth),n._infoDimensions=new f.default,n._depthChartDimensions=new f.default,n._infoXOffset=-1,n._infoTargetPrice=-1,n._parseTimeout=null,n._build(),n._registerListeners(),n}return a(e,t),s(e,[{key:"_build",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_build",this).call(this),this._element.classList.add("order-book-depth"),this._infoElement=document.createElement("div"),this._infoElement.classList.add("info"),this._element.append(this._infoElement),this._xLabels.type=p.AxisLabelingType.CURRENCY,this._xLabels.fontFace=this._fontFace,this._xLabels.fontSize=this._fontSize,this._xLabels.fontColor=this._configuration.x_label_color,this._xLabels.tickPrefix="$",this._yLabels.type=p.AxisLabelingType.NUMBER,this._yLabels.fontFace=this._fontFace,this._yLabels.fontSize=this._fontSize,this._yLabels.fontColor=this._configuration.y_label_color}},{key:"_computeDimensions",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_computeDimensions",this).call(this),this._configuration.info_height%1==0?this._infoDimensions.height=this._configuration.info_height*this._pixelRatio:this._infoDimensions.height=this._chartDimensions.height*this._configuration.info_height|0,this._infoDimensions.width=this._chartDimensions.width,this._infoDimensions.x=this._chartDimensions.x,this._infoDimensions.y=this._chartDimensions.y,this._depthChartDimensions.x=this._chartDimensions.x,this._depthChartDimensions.y=this._chartDimensions.y+this._infoDimensions.height,this._depthChartDimensions.width=this._chartDimensions.width,this._depthChartDimensions.height=this._chartDimensions.height-this._infoDimensions.height-1;var t=this._infoElement.style;t.top=this._infoDimensions.y/this._pixelRatio+"px",t.left=this._infoDimensions.x/this._pixelRatio+"px",t.width=this._infoDimensions.width/this._pixelRatio+"px",t.height=this._infoDimensions.height/this._pixelRatio+"px",this._yLabelDimensions.y=this._depthChartDimensions.y,this._yLabelDimensions.height=this._depthChartDimensions.height,this._draw()}},{key:"_computeBounds",value:function(){var t=Math.abs(this._marketPrice-this._data.lowerPriceBound),e=Math.abs(this._marketPrice-this._data.upperPriceBound),i=Math.max(t,e),n=this._marketPrice-i,o=this._marketPrice+i,r=this._data.upperCountBound;return(this._lowerPriceBound!==n||this._upperPriceBound!==o||this._upperCountBound!==r)&&(this._lowerPriceBound=n,this._upperPriceBound=o,this._upperCountBound=r,this._priceBoundsSpan=this._upperPriceBound-this._lowerPriceBound,!0)}},{key:"_drawChart",value:function(t){if(h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawChart",this).call(this,t),this._data.hasData){var i=this._computeBounds();if(t||i||this._dimensionsInvalidated){var n=(this._marketPrice-this._lowerPriceBound)/this._priceBoundsSpan,o=1,r=this._depthChartDimensions.x+(this._depthChartDimensions.width*n|0),a=this._depthChartDimensions.y+(this._depthChartDimensions.height*o|0),s=[[r,a]],u=!0,l=!1,_=void 0;try{for(var c,d=this._data.askData[Symbol.iterator]();!(u=(c=d.next()).done);u=!0){var f=c.value;if(f.price>this._upperPriceBound)break;n=(f.price-this._lowerPriceBound)/this._priceBoundsSpan,o=1-f.cumulativeCount/this._upperCountBound,r=this._depthChartDimensions.x+(this._depthChartDimensions.width*n|0),a=this._depthChartDimensions.y+(this._depthChartDimensions.height*o|0),s.push([r,a])}}catch(t){l=!0,_=t}finally{try{!u&&d.return&&d.return()}finally{if(l)throw _}}r<this._depthChartDimensions.x+this._depthChartDimensions.width&&s.push([this._depthChartDimensions.x+this._depthChartDimensions.width,a]),s.push([this._depthChartDimensions.x+this._depthChartDimensions.width,this._depthChartDimensions.y+this._depthChartDimensions.height]),s.push([s[0][0],this._depthChartDimensions.y+this._depthChartDimensions.height]);var p=(this._marketPrice-this._lowerPriceBound)/this._priceBoundsSpan,g=1,v=this._depthChartDimensions.x+(this._depthChartDimensions.width*p|0),y=this._depthChartDimensions.y+(this._depthChartDimensions.height*g|0),b=[[v,y]],w=!0,x=!1,k=void 0;try{for(var D,C=this._data.bidData[Symbol.iterator]();!(w=(D=C.next()).done);w=!0){var E=D.value;if(E.price<this._lowerPriceBound)break;p=(E.price-this._lowerPriceBound)/this._priceBoundsSpan,g=1-E.cumulativeCount/this._upperCountBound,v=this._depthChartDimensions.x+(this._depthChartDimensions.width*p|0),y=this._depthChartDimensions.y+(this._depthChartDimensions.height*g|0),b.push([v,y])}}catch(t){x=!0,k=t}finally{try{!w&&C.return&&C.return()}finally{if(x)throw k}}v>this._depthChartDimensions.x&&b.push([this._depthChartDimensions.x,y]),b.push([this._depthChartDimensions.x,this._depthChartDimensions.y+this._depthChartDimensions.height]),b.push([b[0][0],this._depthChartDimensions.y+this._depthChartDimensions.height]),m.default.drawPath(this._drawingContext,s,this._configuration.ask_fill_color,this._configuration.ask_line_color,1),m.default.drawPath(this._drawingContext,b,this._configuration.bid_fill_color,this._configuration.bid_line_color,1)}}}},{key:"_drawLabels",value:function(t){if(this._data.hasData){this._xLabels.minimum=this._lowerPriceBound,this._xLabels.maximum=this._upperPriceBound,this._yLabels.minimum=0,this._yLabels.maximum=this._upperCountBound,h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawLabels",this).call(this,t);var i=(this._marketPrice-this._lowerPriceBound)/this._priceBoundsSpan,n=this._depthChartDimensions.x+(i*this._depthChartDimensions.width|0),o=this._marketPrice;o%1!=0&&(o=o.toFixed(this._configuration.x_label_precision)),o=c.default.configuration.currency_character+o;var r=this._drawingContext.measureText(o).width/2|0;this._drawingContext.fillStyle=this._configuration.market_price_color,this._drawingContext.fillText(o,n-r,this._infoDimensions.height+this._fontSize+4),this._drawingContext.fillRect(n,this._infoDimensions.height+2*this._fontSize,1,this._depthChartDimensions.height-2*this._fontSize)}}},{key:"_drawBorders",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_drawBorders",this).call(this),this._drawingContext.fillStyle=this._configuration.border_secondary_color,this._drawingContext.fillRect(this._infoDimensions.x,this._infoDimensions.y+this._infoDimensions.height-1,this._infoDimensions.width,1),this._drawingContext.fillRect(this._xLabelDimensions.x,this._xLabelDimensions.y,this._xLabelDimensions.width,1),this._drawingContext.fillRect(this._yLabelDimensions.x,this._yLabelDimensions.y,1,this._yLabelDimensions.height)}},{key:"_updateInfo",value:function(t){var e=this._infoXOffset/this._depthChartDimensions.width,i=this._lowerPriceBound+e*this._priceBoundsSpan,n=void 0;if(this._infoTargetPrice!==i){var o=null;if(e<.5?(n="bid",o=this._data.getClosestItem("bid",i)):(n="ask",o=this._data.getClosestItem("ask",i)),o){var r=m.default.formatUSD(o.cumulativeCost/o.cumulativeCount,this._configuration.info_precision),a=o.cumulativeCount;a%1!=0&&(a=a.toFixed(this._configuration.info_precision));var s=m.default.formatUSD(o.cumulativeCost,this._configuration.info_precision);this._infoElement.innerHTML="<em>avg:&nbsp;</em><strong>"+c.default.configuration.currency_character+r+"</strong>&nbsp;-&nbsp;<em>"+("bid"===n?"sell":"buy")+":&nbsp;</em><strong>"+a+"</strong><em>&nbsp;for:&nbsp;</em><strong>"+c.default.configuration.currency_character+s+"</strong>"}}}},{key:"_registerListeners",value:function(){var t=this;h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_registerListeners",this).call(this),this._data.addEventListener("parseComplete",function(){t._draw(!0)}),this._data.addEventListener("addComplete",function(){null===t._parseTimeout&&(t._parseTimeout=setTimeout(function(){t._draw(!0),t._parseTimeout=null},1e3))})}},{key:"_unregisterListeners",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_unregisterListeners",this).call(this)}},{key:"_onMouseMove",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseMove",this).call(this,t);var i=this._mouseX-this._depthChartDimensions.x;this._infoXOffset!==i&&(this._infoXOffset=this._mouseX-this._depthChartDimensions.x,this._updateInfo())}},{key:"_onMouseDown",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"_onMouseMove",this).call(this,t);var i=this._mouseX-this._depthChartDimensions.x;this._infoXOffset!==i&&(this._infoXOffset=this._mouseX-this._depthChartDimensions.x,this._updateInfo())}},{key:"marketPrice",get:function(){return this._marketPrice},set:function(t){this._marketPrice=t,this._draw(!0)}}]),e}(l.default);e.default=v,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=function t(e,i,n){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,i);if(void 0===o){var r=Object.getPrototypeOf(e);return null===r?void 0:t(r,i,n)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(n)},u=i(22),l=n(u),_=i(0),c=n(_),d=function(t){function e(){o(this,e);var t=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t._uri=c.default.configuration.alphapoint_api.uri,t._instrumentId=c.default.configuration.instrument_id,t._orderBookDepthCount=c.default.configuration.defaults.order_book_depth_count,t._interval=c.default.configuration.defaults.history_interval,t._marketPrice=0,t}return a(e,t),s(e,[{key:"connect",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"connect",this).call(this,this._uri)}},{key:"send",value:function(t){t=JSON.stringify(t),h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"send",this).call(this,t)}},{key:"disconnect",value:function(){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"disconnect",this).call(this)}},{key:"onMessage",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"onMessage",this).call(this,t);var i=void 0;try{i=JSON.parse(t.data),"SubscribeTicker"===i.n?this._onPriceVolumeHistoryLoad(JSON.parse(i.o)):"SubscribeLevel1"===i.n||"Level1UpdateEvent"===i.n?this._onMarketPriceLoad(JSON.parse(i.o)):"SubscribeLevel2"===i.n?this._onOrderBookDataLoad(JSON.parse(i.o)):"Level2UpdateEvent"===i.n&&this._onOrderBookDataUpdate(JSON.parse(i.o))}catch(t){return void console.log(t)}}},{key:"onOpen",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"onOpen",this).call(this,t),this.subscribeToPriceVolumeHistory(),this.subscribeToOrderBookDepth()}},{key:"onError",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"onError",this).call(this,t)}},{key:"onClose",value:function(t){h(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"onClose",this).call(this,t)}},{key:"subscribeToPriceVolumeHistory",value:function(){var t={m:0,i:6,n:"SubscribeTicker",o:'{"OMSId":1,"InstrumentId":'+this._instrumentId+',"Interval":'+this._interval+',"IncludeLastCount":1000}'};this.send(t)}},{key:"unsubscribeFromPriceVolumeHistory",value:function(){var t={m:0,i:8,n:"UnsubscribeTicker",o:'{"OMSId":1,"InstrumentId":'+this._instrumentId+"}"};this.send(t)}},{key:"subscribeToOrderBookDepth",value:function(){var t={m:0,i:6,n:"SubscribeLevel2",o:'{"OMSId":1,"InstrumentId":'+this._instrumentId+',"Depth":'+this._orderBookDepthCount+"}"};this.send(t)}},{key:"unsubscribeFromOrderBookDepth",value:function(){var t={m:0,i:8,n:"UnubscribeLevel2",o:'{"OMSId":1,"InstrumentId":'+this._instrumentId+"}"};this.send(t)}},{key:"_onMarketPriceLoad",value:function(t){this._marketPrice!==t&&(this._marketPrice=t,this.dispatchEvent("marketPriceDataUpdate",t))}},{key:"_onPriceVolumeHistoryLoad",value:function(t){var e=[];t.forEach(function(t){e.push([parseInt(t[0],10)/1e3|0,parseFloat(t[3]),parseFloat(t[4]),parseFloat(t[1]),parseFloat(t[2]),parseFloat(t[5])])}),this.dispatchEvent("historyDataLoad",e)}},{key:"_onOrderBookDataLoad",value:function(t){var e=this,i={asks:[],bids:[]};t.forEach(function(t){1===t[9]?i.asks.push([t[6],t[5]]):0===t[9]&&i.bids.push([t[6],t[5]]),e._onMarketPriceLoad(t[4])}),this.dispatchEvent("orderBookDataLoad",i)}},{key:"_onOrderBookDataUpdate",value:function(t){var e=this;t.forEach(function(t){1===t[9]?e.dispatchEvent("orderBookDataUpdate","ask",t[6],t[5]):0===t[9]&&e.dispatchEvent("orderBookDataUpdate","bid",t[6],t[5]),e._onMarketPriceLoad(t[4])})}},{key:"interval",get:function(){return this._interval},set:function(t){var e=this;this._interval!==t&&(this._interval=t,this.unsubscribeFromPriceVolumeHistory(),setTimeout(function(){return e.subscribeToPriceVolumeHistory()},250))}}]),e}(l.default);e.default=d,t.exports=e.default},function(t,e,i){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),s=i(1),h=function(t){return t&&t.__esModule?t:{default:t}}(s),u=function(t){function e(){n(this,e);var t=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t._socket=null,t._uri=null,t}return r(e,t),a(e,[{key:"connect",value:function(t){var e=this;this._uri=t,this._socket=new WebSocket(this._uri),this._socket.onopen=function(t){e.onOpen(t)},this._socket.onmessage=function(t){e.onMessage(t)},this._socket.onerror=function(t){e.onError(t)},this._socket.onclose=function(t){e.onClose(t)}}},{key:"send",value:function(t){this._socket.send(t)}},{key:"disconnect",value:function(){this._socket.onopen=null,this._socket.onmessage=null,this._socket.onerror=null,this._socket.onclose=null,this._socket.close()}},{key:"onMessage",value:function(t){}},{key:"onOpen",value:function(t){}},{key:"onError",value:function(t){}},{key:"onClose",value:function(t){}},{key:"connected",get:function(){return!(!this._socket||1!==this._socket.readyState)}},{key:"bufferedAmount",get:function(){return this._socket?this._socket.bufferedAmount:0}}]),e}(h.default);e.default=u,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(0),u=n(h),l=i(1),_=n(l),c=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return n.initialChartData=t,n._changeTickersInterval=i,n._interval=u.default.configuration.defaults.history_interval,n}return a(e,t),s(e,[{key:"connect",value:function(){this.UpdateLevel2Data(this.initialChartData.level2),this.UpdateTickersData(this.initialChartData.tickers.tickers),this.OnLoadingStateChange(this.initialChartData.tickers.fetching),this.UpdateMarketPrice(this.initialChartData.marketPrice)}},{key:"disconnect",value:function(){}},{key:"UpdateLevel2Data",value:function(t){var e={};e.asks=t.sell.map(function(t){return[t.Price,t.NumberOfOrders]}),e.bids=t.buy.map(function(t){return[t.Price,t.NumberOfOrders]}),this.dispatchEvent("orderBookDataLoad",e)}},{key:"UpdateTickersData",value:function(t){var e=[];t.forEach(function(t){e.push([parseInt(t[0],10)/1e3|0,parseFloat(t[3]),parseFloat(t[4]),parseFloat(t[1]),parseFloat(t[2]),parseFloat(t[5])])}),this.dispatchEvent("historyDataLoad",e)}},{key:"OnLoadingStateChange",value:function(t){this.dispatchEvent("loadingStateChanged",t)}},{key:"UpdateMarketPrice",value:function(t){this.dispatchEvent("marketPriceDataUpdate",t)}},{key:"interval",get:function(){return this._interval},set:function(t){this._interval!==t&&(this._interval=t,this._changeTickersInterval(this._interval))}}]),e}(_.default);e.default=c,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(0),u=n(h),l=i(1),_=n(l),c=i(25),d=n(c),f=function(t){return t.tickers.fetching},p=function(t){return t.tickers.tickers},g=function(t){return t.level2},m=function(t){var e=t.instrument.selectedInstrumentId;return e&&t.level1[e]?t.level1[e].LastTradedPx:0},v=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return n._store=t,n._changeTickersInterval=i,n._interval=u.default.configuration.defaults.history_interval,n._marketPrice=0,n}return a(e,t),s(e,[{key:"connect",value:function(){this.subscribeToPriceVolumeHistory(),this.subscribeToOrderBookDepth(),this.subscribeToMarketPrice(),this.subscribeToLoadingState()}},{key:"disconnect",value:function(){this.unsubscribePriceVolume(),this.unsubscribePriceVolume=null,this.unsubscribeOrderBook(),this.unsubscribeOrderBook=null,this.unsubscribeMarketPrice(),this.unsubscribeMarketPrice=null,this.unsubscribeToLoadingState(),this.unsubscribeToLoadingState=null}},{key:"subscribeToPriceVolumeHistory",value:function(){var t=this;this.unsubscribePriceVolume=(0,d.default)(this._store,p,function(e,i){t._onPriceVolumeHistoryLoad(e)})}},{key:"subscribeToLoadingState",value:function(){var t=this;this.unsubscribeToLoadingState=(0,d.default)(this._store,f,function(e,i){t._onLoadingStateChanged(e)})}},{key:"subscribeToOrderBookDepth",value:function(){var t=this;this.unsubscribeOrderBook=(0,d.default)(this._store,g,function(e,i){t._onOrderBookDataLoad(e)})}},{key:"subscribeToMarketPrice",value:function(){var t=this;this.unsubscribeMarketPrice=(0,d.default)(this._store,m,function(e,i){t._onMarketPriceLoad(e)})}},{key:"_onPriceVolumeHistoryLoad",value:function(t){var e=[];t.forEach(function(t){e.push([parseInt(t[0],10)/1e3|0,parseFloat(t[3]),parseFloat(t[4]),parseFloat(t[1]),parseFloat(t[2]),parseFloat(t[5])])}),this.dispatchEvent("historyDataLoad",e)}},{key:"_onOrderBookDataLoad",value:function(t){var e={};e.asks=t.sell.map(function(t){return[t.Price,t.NumberOfOrders]}),e.bids=t.buy.map(function(t){return[t.Price,t.NumberOfOrders]}),this.dispatchEvent("orderBookDataLoad",e)}},{key:"_onMarketPriceLoad",value:function(t){this._marketPrice!==t&&(this._marketPrice=t,this.dispatchEvent("marketPriceDataUpdate",t))}},{key:"_onLoadingStateChanged",value:function(t){this.dispatchEvent("loadingStateChanged",t)}},{key:"interval",get:function(){return this._interval},set:function(t){this._interval!==t&&(this._interval=t,this._changeTickersInterval(this._interval))}}]),e}(_.default);e.default=v,t.exports=e.default},function(t,e,i){"use strict";function n(t,e){return t===e}function o(t,e,i){var o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:n,r=e(t.getState());return i(r),t.subscribe(function(){var n=e(t.getState());if(!o(r,n)){var a=r;r=n,i(n,a)}})}Object.defineProperty(e,"__esModule",{value:!0}),e.default=o,t.exports=e.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,i,n){return i&&t(e.prototype,i),n&&t(e,n),e}}(),h=i(0),u=n(h),l=i(1),_=n(l),c=function(t){function e(t,i){o(this,e);var n=r(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return n.subject=t,n._changeTickersInterval=i,n._interval=u.default.configuration.defaults.history_interval,n.level2={},n.tickers={},n.fetching=!0,n.marketPrice=0,n}return a(e,t),s(e,[{key:"connect",value:function(){var t=this;this.subject.subscribe(function(e){t.level2!==e.level2&&(t.level2=e.level2,t.UpdateLevel2Data(e.level2)),t.tickers!==e.tickers.tickers&&(t.tickers=e.tickers.tickers,t.UpdateTickersData(e.tickers.tickers)),t.fetching!==e.tickers.fetching&&(t.fetching=e.tickers.fetching,t.OnLoadingStateChange(e.tickers.fetching)),t.marketPrice!==e.marketPrice&&t.UpdateMarketPrice(e.marketPrice)})}},{key:"disconnect",value:function(){this.subject.unsubscribe()}},{key:"UpdateLevel2Data",value:function(t){var e={};e.asks=t.sell.map(function(t){return[t.Price,t.NumberOfOrders]}),e.bids=t.buy.map(function(t){return[t.Price,t.NumberOfOrders]}),this.dispatchEvent("orderBookDataLoad",e)}},{key:"UpdateTickersData",value:function(t){var e=[];t.forEach(function(t){e.push([parseInt(t[0],10)/1e3|0,parseFloat(t[3]),parseFloat(t[4]),parseFloat(t[1]),parseFloat(t[2]),parseFloat(t[5])])}),this.dispatchEvent("historyDataLoad",e)}},{key:"OnLoadingStateChange",value:function(t){this.dispatchEvent("loadingStateChanged",t)}},{key:"UpdateMarketPrice",value:function(t){this.marketPrice=t,this.dispatchEvent("marketPriceDataUpdate",t)}},{key:"interval",get:function(){return this._interval},set:function(t){this._interval!==t&&(this._interval=t,this._changeTickersInterval(this._interval))}}]),e}(_.default);e.default=c,t.exports=e.default},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.DefaultConfig={instrument_id:1,max_fps:60,snap_mouse_x:!0,snap_mouse_y:!1,mouse_move_throttle_rate:33,mouse_wheel_throttle_rate:50,currency_character:"฿",locale:"en-US",loading_text:"loading",time_intervals:[{label:"5m",seconds:300},{label:"15m",seconds:900},{label:"30m",seconds:1800},{label:"1h",seconds:3600},{label:"2h",seconds:7200},{label:"4h",seconds:14400},{label:"1d",seconds:86400}],defaults:{font_size:12,font_face:"sans-serif",history_item_width:20,history_item_margin:0,history_interval:86400,draw_simple_moving_average:!0,draw_exponential_moving_average:!0,draw_bollinger_bands:!1,chart_type:"candlestick",order_book_depth_count:20},history_data:{simple_moving_average_window:20,exponential_moving_average_window:20,bollinger_standard_deviation_offset:2,convergence_divergence_short_window:12,convergence_divergence_long_window:26,convergence_divergence_signal_window:9},price_history:{font_size:12,font_face:"sans-serif",border_primary_color:"#3f4b6d",border_secondary_color:"#242a3b",background_color:"#1f2531",bullish_color:"rgba(63, 204, 124, 1)",bearish_color:"rgba(255, 71, 71, 1)",price_line_color:"rgba(83, 175, 224, 1)",sma_line_color:"rgba(128, 142, 166, 1)",ema_line_color:"rgba(209, 187, 111, 1)",bollinger_band_upper_line_color:"rgba(100, 200, 100, 1)",bollinger_band_lower_line_color:"rgba(200, 100, 100, 1)",market_price_line_color:"rgba(49, 149, 96, 1)",market_price_label_color:"rgba(255, 255, 255, 1)",market_price_background_color:"rgba(49, 149, 96, .5)",x_label_color:"#76809b",y_label_color:"#76809b",info_height:30,info_precision:5,y_label_width:60,y_label_precision:5,x_label_height:30,x_label_precision:5,info_labels:["Price","Open","Close","High","Low","Volume"],use_gradient:!1,first_gradient_color:"red",second_gradient_color:"blue",use_grid_lines:!1,grid_lines_dashed:!0,grid_lines_color:"white"},volume_history:{font_size:12,font_face:"sans-serif",border_primary_color:"#3f4b6d",border_secondary_color:"#242a3b",background_color:"#1f2531",bullish_color:"rgba(63, 204, 124, 1)",bearish_color:"rgba(255, 71, 71, 1)",x_label_color:"#76809b",y_label_color:"#76809b",y_label_width:60,y_label_precision:0,x_label_height:0,x_label_precision:0},macd_history:{font_size:12,font_face:"sans-serif",border_primary_color:"#3f4b6d",border_secondary_color:"#242a3b",background_color:"#1f2531",zero_line_color:"rgba(36, 42, 59, 1)",indicator_line_color:"rgba(71, 129, 255, 1)",signal_line_color:"rgba(255, 71, 71, 1)",histogram_positive_color:"rgba(63, 204, 124, .25)",histogram_negative_color:"rgba(255, 71, 71, .25)",x_label_color:"#76809b",y_label_color:"#76809b",y_label_width:60,y_label_precision:0,x_label_height:0,x_label_precision:0},range_selector:{font_size:12,font_face:"sans-serif",border_primary_color:"#3f4b6d",border_secondary_color:"#242a3b",background_color:"#1f2531",market_price_line_color:"rgba(232, 232, 92, 1)",market_price_label_color:"rgba(232, 232, 92, 1)",price_line_color:"rgba(83, 175, 224, 1)",range_selection_color:"rgba(255, 255, 255, .2)",x_label_color:"#76809b",y_label_color:"#76809b",y_label_width:0,y_label_precision:0,x_label_height:22,x_label_precision:0},order_book_depth:{font_size:12,font_face:"sans-serif",border_primary_color:"#3f4b6d",border_secondary_color:"#242a3b",background_color:"#1f2531",ask_line_color:"rgba(255, 71, 71, 1)",ask_fill_color:"rgba(255, 71, 71, .5)",bid_line_color:"rgba(63, 204, 124, 1)",bid_fill_color:"rgba(63, 204, 124, .5)",market_price_color:"#6f7faa",x_label_color:"#76809b",y_label_color:"#76809b",info_height:30,info_precision:2,y_label_width:60,y_label_precision:2,x_label_height:22,x_label_precision:5,update_interval:1e3,depth:10},number_suffixes:["","k","M","B","T","Q"],date_format_days:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],date_format_months:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],alphapoint_api:{uri:"wss://api_demo2.alphapoint.com/WSGateway/"}}}])});

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-unused-variable */
// Subject imported before Observable to bypass circular dependency issue since
// Subject extends Observable and Observable references Subject in it's
// definition
var Subject_1 = __webpack_require__(49);
exports.Subject = Subject_1.Subject;
exports.AnonymousSubject = Subject_1.AnonymousSubject;
/* tslint:enable:no-unused-variable */
var Observable_1 = __webpack_require__(4);
exports.Observable = Observable_1.Observable;
// statics
/* tslint:disable:no-use-before-declare */
__webpack_require__(1590);
__webpack_require__(1593);
__webpack_require__(1596);
__webpack_require__(1599);
__webpack_require__(1602);
__webpack_require__(1605);
__webpack_require__(1607);
__webpack_require__(1610);
__webpack_require__(1611);
__webpack_require__(1614);
__webpack_require__(1617);
__webpack_require__(1619);
__webpack_require__(1622);
__webpack_require__(1625);
__webpack_require__(1630);
__webpack_require__(1631);
__webpack_require__(1632);
__webpack_require__(1635);
__webpack_require__(1636);
__webpack_require__(1638);
__webpack_require__(1641);
__webpack_require__(1644);
__webpack_require__(1647);
__webpack_require__(1650);
__webpack_require__(1652);
//dom
__webpack_require__(1654);
__webpack_require__(1656);
//operators
__webpack_require__(1662);
__webpack_require__(1664);
__webpack_require__(1666);
__webpack_require__(1668);
__webpack_require__(1670);
__webpack_require__(1672);
__webpack_require__(1674);
__webpack_require__(1676);
__webpack_require__(1678);
__webpack_require__(1680);
__webpack_require__(1682);
__webpack_require__(1684);
__webpack_require__(1686);
__webpack_require__(1688);
__webpack_require__(1690);
__webpack_require__(1692);
__webpack_require__(1694);
__webpack_require__(1696);
__webpack_require__(1698);
__webpack_require__(1700);
__webpack_require__(1703);
__webpack_require__(1705);
__webpack_require__(1707);
__webpack_require__(1709);
__webpack_require__(1711);
__webpack_require__(1713);
__webpack_require__(1715);
__webpack_require__(1717);
__webpack_require__(1719);
__webpack_require__(1721);
__webpack_require__(1723);
__webpack_require__(1725);
__webpack_require__(1727);
__webpack_require__(1732);
__webpack_require__(1734);
__webpack_require__(1736);
__webpack_require__(1738);
__webpack_require__(1740);
__webpack_require__(1742);
__webpack_require__(1744);
__webpack_require__(1746);
__webpack_require__(1748);
__webpack_require__(1750);
__webpack_require__(1752);
__webpack_require__(1754);
__webpack_require__(1756);
__webpack_require__(1758);
__webpack_require__(1760);
__webpack_require__(1762);
__webpack_require__(1764);
__webpack_require__(1766);
__webpack_require__(1768);
__webpack_require__(1770);
__webpack_require__(1772);
__webpack_require__(1774);
__webpack_require__(1777);
__webpack_require__(1779);
__webpack_require__(1781);
__webpack_require__(1783);
__webpack_require__(1785);
__webpack_require__(1787);
__webpack_require__(1789);
__webpack_require__(1791);
__webpack_require__(1793);
__webpack_require__(1795);
__webpack_require__(1797);
__webpack_require__(1799);
__webpack_require__(1801);
__webpack_require__(1803);
__webpack_require__(1805);
__webpack_require__(1807);
__webpack_require__(1809);
__webpack_require__(1811);
__webpack_require__(1813);
__webpack_require__(1815);
__webpack_require__(1817);
__webpack_require__(1819);
__webpack_require__(1821);
__webpack_require__(1823);
__webpack_require__(1831);
__webpack_require__(1833);
__webpack_require__(1835);
__webpack_require__(1837);
__webpack_require__(1839);
__webpack_require__(1841);
__webpack_require__(1843);
__webpack_require__(1845);
__webpack_require__(1847);
__webpack_require__(1849);
__webpack_require__(1850);
__webpack_require__(1852);
__webpack_require__(1854);
__webpack_require__(1856);
__webpack_require__(1858);
__webpack_require__(1859);
__webpack_require__(1861);
__webpack_require__(1863);
__webpack_require__(1865);
__webpack_require__(1867);
__webpack_require__(1869);
__webpack_require__(1871);
__webpack_require__(1873);
/* tslint:disable:no-unused-variable */
var Subscription_1 = __webpack_require__(46);
exports.Subscription = Subscription_1.Subscription;
var Subscriber_1 = __webpack_require__(11);
exports.Subscriber = Subscriber_1.Subscriber;
var AsyncSubject_1 = __webpack_require__(272);
exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
var ReplaySubject_1 = __webpack_require__(279);
exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
var BehaviorSubject_1 = __webpack_require__(728);
exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
var ConnectableObservable_1 = __webpack_require__(722);
exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
var Notification_1 = __webpack_require__(188);
exports.Notification = Notification_1.Notification;
var EmptyError_1 = __webpack_require__(280);
exports.EmptyError = EmptyError_1.EmptyError;
var ArgumentOutOfRangeError_1 = __webpack_require__(194);
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
var ObjectUnsubscribedError_1 = __webpack_require__(271);
exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
var TimeoutError_1 = __webpack_require__(758);
exports.TimeoutError = TimeoutError_1.TimeoutError;
var UnsubscriptionError_1 = __webpack_require__(671);
exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
var timeInterval_1 = __webpack_require__(755);
exports.TimeInterval = timeInterval_1.TimeInterval;
var timestamp_1 = __webpack_require__(399);
exports.Timestamp = timestamp_1.Timestamp;
var TestScheduler_1 = __webpack_require__(1875);
exports.TestScheduler = TestScheduler_1.TestScheduler;
var VirtualTimeScheduler_1 = __webpack_require__(771);
exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
var AjaxObservable_1 = __webpack_require__(682);
exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
exports.AjaxError = AjaxObservable_1.AjaxError;
exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
var pipe_1 = __webpack_require__(383);
exports.pipe = pipe_1.pipe;
var asap_1 = __webpack_require__(747);
var async_1 = __webpack_require__(33);
var queue_1 = __webpack_require__(683);
var animationFrame_1 = __webpack_require__(1878);
var rxSubscriber_1 = __webpack_require__(269);
var iterator_1 = __webpack_require__(186);
var observable_1 = __webpack_require__(270);
var _operators = __webpack_require__(1882);
exports.operators = _operators;
/* tslint:enable:no-unused-variable */
/**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */
var Scheduler = {
    asap: asap_1.asap,
    queue: queue_1.queue,
    animationFrame: animationFrame_1.animationFrame,
    async: async_1.async
};
exports.Scheduler = Scheduler;
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */
var Symbol = {
    rxSubscriber: rxSubscriber_1.rxSubscriber,
    observable: observable_1.observable,
    iterator: iterator_1.iterator
};
exports.Symbol = Symbol;
//# sourceMappingURL=Rx.js.map

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(46);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription_1.Subscription));
exports.SubjectSubscription = SubjectSubscription;
//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__(105);
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromObservable_1 = __webpack_require__(678);
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(82);
var isArrayLike_1 = __webpack_require__(674);
var isPromise_1 = __webpack_require__(675);
var PromiseObservable_1 = __webpack_require__(679);
var IteratorObservable_1 = __webpack_require__(1600);
var ArrayObservable_1 = __webpack_require__(105);
var ArrayLikeObservable_1 = __webpack_require__(1601);
var iterator_1 = __webpack_require__(186);
var Observable_1 = __webpack_require__(4);
var observeOn_1 = __webpack_require__(274);
var observable_1 = __webpack_require__(270);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromObservable = (function (_super) {
    __extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */
    FromObservable.create = function (ish, scheduler) {
        if (ish != null) {
            if (typeof ish[observable_1.observable] === 'function') {
                if (ish instanceof Observable_1.Observable && !scheduler) {
                    return ish;
                }
                return new FromObservable(ish, scheduler);
            }
            else if (isArray_1.isArray(ish)) {
                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
            }
            else if (isPromise_1.isPromise(ish)) {
                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
            }
            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
            }
            else if (isArrayLike_1.isArrayLike(ish)) {
                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
            }
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function (subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            return ish[observable_1.observable]().subscribe(subscriber);
        }
        else {
            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
        }
    };
    return FromObservable;
}(Observable_1.Observable));
exports.FromObservable = FromObservable;
//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(56);
var Observable_1 = __webpack_require__(4);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable = (function (_super) {
    __extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */
    PromiseObservable.create = function (promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.error(err);
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
        else {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
    };
    return PromiseObservable;
}(Observable_1.Observable));
exports.PromiseObservable = PromiseObservable;
function dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.error(err);
    }
}
//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TimerObservable_1 = __webpack_require__(1651);
exports.timer = TimerObservable_1.TimerObservable.create;
//# sourceMappingURL=timer.js.map

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(56);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var Observable_1 = __webpack_require__(4);
var Subscriber_1 = __webpack_require__(11);
var map_1 = __webpack_require__(193);
function getCORSRequest() {
    if (root_1.root.XMLHttpRequest) {
        return new root_1.root.XMLHttpRequest();
    }
    else if (!!root_1.root.XDomainRequest) {
        return new root_1.root.XDomainRequest();
    }
    else {
        throw new Error('CORS is not supported by your browser');
    }
}
function getXMLHttpRequest() {
    if (root_1.root.XMLHttpRequest) {
        return new root_1.root.XMLHttpRequest();
    }
    else {
        var progId = void 0;
        try {
            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
            for (var i = 0; i < 3; i++) {
                try {
                    progId = progIds[i];
                    if (new root_1.root.ActiveXObject(progId)) {
                        break;
                    }
                }
                catch (e) {
                }
            }
            return new root_1.root.ActiveXObject(progId);
        }
        catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function ajaxGet(url, headers) {
    if (headers === void 0) { headers = null; }
    return new AjaxObservable({ method: 'GET', url: url, headers: headers });
}
exports.ajaxGet = ajaxGet;
;
function ajaxPost(url, body, headers) {
    return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
}
exports.ajaxPost = ajaxPost;
;
function ajaxDelete(url, headers) {
    return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
}
exports.ajaxDelete = ajaxDelete;
;
function ajaxPut(url, body, headers) {
    return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
}
exports.ajaxPut = ajaxPut;
;
function ajaxPatch(url, body, headers) {
    return new AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
}
exports.ajaxPatch = ajaxPatch;
;
var mapResponse = map_1.map(function (x, index) { return x.response; });
function ajaxGetJSON(url, headers) {
    return mapResponse(new AjaxObservable({
        method: 'GET',
        url: url,
        responseType: 'json',
        headers: headers
    }));
}
exports.ajaxGetJSON = ajaxGetJSON;
;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var AjaxObservable = (function (_super) {
    __extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function () {
                return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') {
            request.url = urlOrRequest;
        }
        else {
            for (var prop in urlOrRequest) {
                if (urlOrRequest.hasOwnProperty(prop)) {
                    request[prop] = urlOrRequest[prop];
                }
            }
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function (subscriber) {
        return new AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */
    AjaxObservable.create = (function () {
        var create = function (urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = ajaxGet;
        create.post = ajaxPost;
        create.delete = ajaxDelete;
        create.put = ajaxPut;
        create.patch = ajaxPatch;
        create.getJSON = ajaxGetJSON;
        return create;
    })();
    return AjaxObservable;
}(Observable_1.Observable));
exports.AjaxObservable = AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AjaxSubscriber = (function (_super) {
    __extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) {
            headers['X-Requested-With'] = 'XMLHttpRequest';
        }
        // ensure content type is set
        if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        }
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function (e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function () {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = tryCatch_1.tryCatch(createXHR).call(request);
        if (xhr === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) {
                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            }
            else {
                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
            }
            if (result === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) {
                xhr.withCredentials = !!request.withCredentials;
            }
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? tryCatch_1.tryCatch(xhr.send).call(xhr, body) : tryCatch_1.tryCatch(xhr.send).call(xhr);
            if (result === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
        if (!body || typeof body === 'string') {
            return body;
        }
        else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
            return body;
        }
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) {
                contentType = contentType.substring(0, splitIndex);
            }
        }
        switch (contentType) {
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function (key) { return (encodeURIComponent(key) + "=" + encodeURIComponent(body[key])); }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
        for (var key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    };
    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) {
                progressSubscriber.error(e);
            }
            subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        ;
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function (e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if (root_1.root.XDomainRequest) {
                    xhr.onprogress = xhrProgress_1;
                }
                else {
                    xhr.upload.onprogress = xhrProgress_1;
                }
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function (e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) {
                    progressSubscriber.error(e);
                }
                subscriber.error(new AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) {
                    status_1 = response ? 200 : 0;
                }
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) {
                        progressSubscriber.complete();
                    }
                    subscriber.next(e);
                    subscriber.complete();
                }
                else {
                    if (progressSubscriber) {
                        progressSubscriber.error(e);
                    }
                    subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        ;
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function () {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
            xhr.abort();
        }
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}(Subscriber_1.Subscriber));
exports.AjaxSubscriber = AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */
var AjaxResponse = (function () {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}());
exports.AjaxResponse = AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */
var AjaxError = (function (_super) {
    __extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error));
exports.AjaxError = AjaxError;
function parseXhrResponse(responseType, xhr) {
    switch (responseType) {
        case 'json':
            if ('response' in xhr) {
                //IE does not support json as responseType, parse it internally
                return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
            }
            else {
                // HACK(benlesh): TypeScript shennanigans
                // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
                return JSON.parse(xhr.responseText || 'null');
            }
        case 'xml':
            return xhr.responseXML;
        case 'text':
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return ('response' in xhr) ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */
var AjaxTimeoutError = (function (_super) {
    __extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}(AjaxError));
exports.AjaxTimeoutError = AjaxTimeoutError;
//# sourceMappingURL=AjaxObservable.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var QueueAction_1 = __webpack_require__(1659);
var QueueScheduler_1 = __webpack_require__(1660);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */
exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
//# sourceMappingURL=queue.js.map

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */
function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
exports.buffer = buffer;
var BufferOperator = (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSubscriber = (function (_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=buffer.js.map

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
exports.bufferCount = bufferCount;
var BufferCountOperator = (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = BufferCountSubscriber;
        }
        else {
            this.subscriberClass = BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferCountSubscriber = (function (_super) {
    __extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSkipCountSubscriber = (function (_super) {
    __extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(33);
var Subscriber_1 = __webpack_require__(11);
var isScheduler_1 = __webpack_require__(72);
/* tslint:enable:max-line-length */
/**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = async_1.async;
    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
exports.bufferTime = bufferTime;
var BufferTimeOperator = (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferTimeSubscriber = (function (_super) {
    __extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
            this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}
//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(46);
var subscribeToResult_1 = __webpack_require__(18);
var OuterSubscriber_1 = __webpack_require__(17);
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */
function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
exports.bufferToggle = bufferToggle;
var BufferToggleOperator = (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferToggleSubscriber = (function (_super) {
    __extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(subscribeToResult_1.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new Subscription_1.Subscription();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(46);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return function (source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
exports.bufferWhen = bufferWhen;
var BufferWhenOperator = (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferWhenSubscriber = (function (_super) {
    __extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            closingSubscription = new Subscription_1.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
exports.catchError = catchError;
var CatchOperator = (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CatchSubscriber = (function (_super) {
    __extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add(subscribeToResult_1.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=catchError.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var combineLatest_1 = __webpack_require__(273);
function combineAll(project) {
    return function (source) { return source.lift(new combineLatest_1.CombineLatestOperator(project)); };
}
exports.combineAll = combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concat_1 = __webpack_require__(187);
var concat_2 = __webpack_require__(187);
exports.concatStatic = concat_2.concat;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function (source) { return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables))); };
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMap_1 = __webpack_require__(389);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return concatMap_1.concatMap(function () { return innerObservable; }, resultSelector);
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */
function count(predicate) {
    return function (source) { return source.lift(new CountOperator(predicate, source)); };
}
exports.count = count;
var CountOperator = (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CountSubscriber = (function (_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=count.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */
function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
exports.dematerialize = dematerialize;
var DeMaterializeOperator = (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DeMaterializeSubscriber = (function (_super) {
    __extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */
function debounce(durationSelector) {
    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
}
exports.debounce = debounce;
var DebounceOperator = (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceSubscriber = (function (_super) {
    __extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = subscribeToResult_1.subscribeToResult(this, duration);
        if (!subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var async_1 = __webpack_require__(33);
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
}
exports.debounceTime = debounceTime;
var DebounceTimeOperator = (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceTimeSubscriber = (function (_super) {
    __extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(33);
var isDate_1 = __webpack_require__(277);
var Subscriber_1 = __webpack_require__(11);
var Notification_1 = __webpack_require__(188);
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteDelay = isDate_1.isDate(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
}
exports.delay = delay;
var DelayOperator = (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelaySubscriber = (function (_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(Notification_1.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(Notification_1.Notification.createComplete());
    };
    return DelaySubscriber;
}(Subscriber_1.Subscriber));
var DelayMessage = (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var Observable_1 = __webpack_require__(4);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return new SubscriptionDelayObservable(source, subscriptionDelay)
                .lift(new DelayWhenOperator(delayDurationSelector));
        };
    }
    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
}
exports.delayWhen = delayWhen;
var DelayWhenOperator = (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelayWhenSubscriber = (function (_super) {
    __extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelayObservable = (function (_super) {
    __extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(Observable_1.Observable));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelaySubscriber = (function (_super) {
    __extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
var Set_1 = __webpack_require__(1702);
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */
function distinct(keySelector, flushes) {
    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
}
exports.distinct = distinct;
var DistinctOperator = (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctSubscriber = (function (_super) {
    __extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new Set_1.Set();
        if (flushes) {
            this.add(subscribeToResult_1.subscribeToResult(this, flushes));
        }
    }
    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.DistinctSubscriber = DistinctSubscriber;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinctUntilChanged_1 = __webpack_require__(391);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */
function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
}
exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */
function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
exports.tap = tap;
var DoOperator = (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DoSubscriber = (function (_super) {
    __extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function (value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.next(value);
        }
    };
    DoSubscriber.prototype._error = function (err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.error(err);
        }
    };
    DoSubscriber.prototype._complete = function () {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.complete();
        }
    };
    return DoSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=tap.js.map

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */
function exhaust() {
    return function (source) { return source.lift(new SwitchFirstOperator()); };
}
exports.exhaust = exhaust;
var SwitchFirstOperator = (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchFirstSubscriber = (function (_super) {
    __extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(subscribeToResult_1.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */
function exhaustMap(project, resultSelector) {
    return function (source) { return source.lift(new SwitchFirstMapOperator(project, resultSelector)); };
}
exports.exhaustMap = exhaustMap;
var SwitchFirstMapOperator = (function () {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchFirstMapSubscriber = (function (_super) {
    __extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
        }
        catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        }
        catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/* tslint:enable:max-line-length */
/**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (scheduler === void 0) { scheduler = undefined; }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
}
exports.expand = expand;
var ExpandOperator = (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());
exports.ExpandOperator = ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ExpandSubscriber = (function (_super) {
    __extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            this.buffer = [];
        }
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = tryCatch_1.tryCatch(this.project)(value, index);
            if (result === errorObject_1.errorObject) {
                destination.error(errorObject_1.errorObject.e);
            }
            else if (!this.scheduler) {
                this.subscribeToProjection(result, value, index);
            }
            else {
                var state = { subscriber: this, result: result, value: value, index: index };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.ExpandSubscriber = ExpandSubscriber;
//# sourceMappingURL=expand.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var ArgumentOutOfRangeError_1 = __webpack_require__(194);
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */
function elementAt(index, defaultValue) {
    return function (source) { return source.lift(new ElementAtOperator(index, defaultValue)); };
}
exports.elementAt = elementAt;
var ElementAtOperator = (function () {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    ElementAtOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ElementAtSubscriber = (function (_super) {
    __extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function (x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') {
                destination.next(this.defaultValue);
            }
            else {
                destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError);
            }
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(46);
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */
function finalize(callback) {
    return function (source) { return source.lift(new FinallyOperator(callback)); };
}
exports.finalize = finalize;
var FinallyOperator = (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FinallySubscriber = (function (_super) {
    __extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new Subscription_1.Subscription(callback));
    }
    return FinallySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=finalize.js.map

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var find_1 = __webpack_require__(393);
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */
function findIndex(predicate, thisArg) {
    return function (source) { return source.lift(new find_1.FindValueOperator(predicate, source, true, thisArg)); };
}
exports.findIndex = findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var EmptyError_1 = __webpack_require__(280);
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first(predicate, resultSelector, defaultValue) {
    return function (source) { return source.lift(new FirstOperator(predicate, resultSelector, defaultValue, source)); };
}
exports.first = first;
var FirstOperator = (function () {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FirstSubscriber = (function (_super) {
    __extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._emit = function (value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function (value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        }
        else if (!this.hasCompleted) {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return FirstSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=first.js.map

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(46);
var Observable_1 = __webpack_require__(4);
var Subject_1 = __webpack_require__(49);
var Map_1 = __webpack_require__(1729);
var FastMap_1 = __webpack_require__(1731);
/* tslint:enable:max-line-length */
/**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function (source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
exports.groupBy = groupBy;
var GroupByOperator = (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupBySubscriber = (function (_super) {
    __extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupDurationSubscriber = (function (_super) {
    __extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(Subscriber_1.Subscriber));
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */
var GroupedObservable = (function (_super) {
    __extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new Subscription_1.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(Observable_1.Observable));
exports.GroupedObservable = GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerRefCountSubscription = (function (_super) {
    __extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(Subscription_1.Subscription));
//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var noop_1 = __webpack_require__(384);
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */
function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
exports.ignoreElements = ignoreElements;
var IgnoreElementsOperator = (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var IgnoreElementsSubscriber = (function (_super) {
    __extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
        noop_1.noop();
    };
    return IgnoreElementsSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
function isEmpty() {
    return function (source) { return source.lift(new IsEmptyOperator()); };
}
exports.isEmpty = isEmpty;
var IsEmptyOperator = (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var IsEmptySubscriber = (function (_super) {
    __extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var audit_1 = __webpack_require__(394);
var timer_1 = __webpack_require__(681);
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */
function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
}
exports.auditTime = auditTime;
//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var EmptyError_1 = __webpack_require__(280);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */
function last(predicate, resultSelector, defaultValue) {
    return function (source) { return source.lift(new LastOperator(predicate, resultSelector, defaultValue, source)); };
}
exports.last = last;
var LastOperator = (function () {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function (observer, source) {
        return source.subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var LastSubscriber = (function (_super) {
    __extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        }
        else {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return LastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=last.js.map

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */
function every(predicate, thisArg) {
    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
}
exports.every = every;
var EveryOperator = (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var EverySubscriber = (function (_super) {
    __extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=every.js.map

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
    return function (source) { return source.lift(new MapToOperator(value)); };
}
exports.mapTo = mapTo;
var MapToOperator = (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapToSubscriber = (function (_super) {
    __extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var Notification_1 = __webpack_require__(188);
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */
function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
exports.materialize = materialize;
var MaterializeOperator = (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MaterializeSubscriber = (function (_super) {
    __extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(Notification_1.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(Notification_1.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(Notification_1.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=materialize.js.map

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(195);
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */
function max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return reduce_1.reduce(max);
}
exports.max = max;
//# sourceMappingURL=max.js.map

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var merge_1 = __webpack_require__(276);
var merge_2 = __webpack_require__(276);
exports.mergeStatic = merge_2.merge;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function (source) { return source.lift.call(merge_1.merge.apply(void 0, [source].concat(observables))); };
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function (source) { return source.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent)); };
}
exports.mergeMapTo = mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var MergeMapToOperator = (function () {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}());
exports.MergeMapToOperator = MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapToSubscriber = (function (_super) {
    __extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapToSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapToSubscriber = MergeMapToSubscriber;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var subscribeToResult_1 = __webpack_require__(18);
var OuterSubscriber_1 = __webpack_require__(17);
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
}
exports.mergeScan = mergeScan;
var MergeScanOperator = (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());
exports.MergeScanOperator = MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeScanSubscriber = (function (_super) {
    __extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = tryCatch_1.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === errorObject_1.errorObject) {
                destination.error(errorObject_1.errorObject.e);
            }
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeScanSubscriber = MergeScanSubscriber;
//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(195);
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */
function min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return reduce_1.reduce(min);
}
exports.min = min;
//# sourceMappingURL=min.js.map

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var Observable_1 = __webpack_require__(4);
var Subscriber_1 = __webpack_require__(11);
var Subscription_1 = __webpack_require__(46);
var refCount_1 = __webpack_require__(397);
/**
 * @class ConnectableObservable<T>
 */
var ConnectableObservable = (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, 
        /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new Subscription_1.Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription_1.Subscription.EMPTY;
            }
            else {
                this._connection = connection;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount_1.refCount()(this);
    };
    return ConnectableObservable;
}(Observable_1.Observable));
exports.ConnectableObservable = ConnectableObservable;
var connectableProto = ConnectableObservable.prototype;
exports.connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: true },
    _subject: { value: null, writable: true },
    _connection: { value: null, writable: true },
    _subscribe: { value: connectableProto._subscribe },
    _isComplete: { value: connectableProto._isComplete, writable: true },
    getSubject: { value: connectableProto.getSubject },
    connect: { value: connectableProto.connect },
    refCount: { value: connectableProto.refCount }
};
var ConnectableSubscriber = (function (_super) {
    __extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(Subject_1.SubjectSubscriber));
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return function (source) { return source.lift(new PairwiseOperator()); };
}
exports.pairwise = pairwise;
var PairwiseOperator = (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var PairwiseSubscriber = (function (_super) {
    __extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        if (this.hasPrev) {
            this.destination.next([this.prev, value]);
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
    };
    return PairwiseSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var not_1 = __webpack_require__(1776);
var filter_1 = __webpack_require__(392);
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */
function partition(predicate, thisArg) {
    return function (source) { return [
        filter_1.filter(predicate, thisArg)(source),
        filter_1.filter(not_1.not(predicate, thisArg))(source)
    ]; };
}
exports.partition = partition;
//# sourceMappingURL=partition.js.map

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var map_1 = __webpack_require__(193);
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i - 0] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return function (source) { return map_1.map(plucker(properties, length))(source); };
}
exports.pluck = pluck;
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subject_1 = __webpack_require__(49);
var multicast_1 = __webpack_require__(125);
/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
function publish(selector) {
    return selector ?
        multicast_1.multicast(function () { return new Subject_1.Subject(); }, selector) :
        multicast_1.multicast(new Subject_1.Subject());
}
exports.publish = publish;
//# sourceMappingURL=publish.js.map

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BehaviorSubject_1 = __webpack_require__(728);
var multicast_1 = __webpack_require__(125);
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return function (source) { return multicast_1.multicast(new BehaviorSubject_1.BehaviorSubject(value))(source); };
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var ObjectUnsubscribedError_1 = __webpack_require__(271);
/**
 * @class BehaviorSubject<T>
 */
var BehaviorSubject = (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(Subject_1.Subject));
exports.BehaviorSubject = BehaviorSubject;
//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ReplaySubject_1 = __webpack_require__(279);
var multicast_1 = __webpack_require__(125);
/* tslint:enable:max-line-length */
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
        scheduler = selectorOrScheduler;
    }
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
    return function (source) { return multicast_1.multicast(function () { return subject; }, selector)(source); };
}
exports.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncSubject_1 = __webpack_require__(272);
var multicast_1 = __webpack_require__(125);
function publishLast() {
    return function (source) { return multicast_1.multicast(new AsyncSubject_1.AsyncSubject())(source); };
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(82);
var race_1 = __webpack_require__(387);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && isArray_1.isArray(observables[0])) {
            observables = observables[0];
        }
        return source.lift.call(race_1.race.apply(void 0, [source].concat(observables)));
    };
}
exports.race = race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var EmptyObservable_1 = __webpack_require__(106);
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */
function repeat(count) {
    if (count === void 0) { count = -1; }
    return function (source) {
        if (count === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (count < 0) {
            return source.lift(new RepeatOperator(-1, source));
        }
        else {
            return source.lift(new RepeatOperator(count - 1, source));
        }
    };
}
exports.repeat = repeat;
var RepeatOperator = (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RepeatSubscriber = (function (_super) {
    __extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=repeat.js.map

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
function repeatWhen(notifier) {
    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
}
exports.repeatWhen = repeatWhen;
var RepeatWhenOperator = (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RepeatWhenSubscriber = (function (_super) {
    __extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            if (!this.retriesSubscription || this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new Subject_1.Subject();
        var retries = tryCatch_1.tryCatch(this.notifier)(this.notifications);
        if (retries === errorObject_1.errorObject) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */
function retry(count) {
    if (count === void 0) { count = -1; }
    return function (source) { return source.lift(new RetryOperator(count, source)); };
}
exports.retry = retry;
var RetryOperator = (function () {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RetrySubscriber = (function (_super) {
    __extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.error.call(this, err);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=retry.js.map

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */
function retryWhen(notifier) {
    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
}
exports.retryWhen = retryWhen;
var RetryWhenOperator = (function () {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RetryWhenSubscriber = (function (_super) {
    __extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new Subject_1.Subject();
                retries = tryCatch_1.tryCatch(this.notifier)(errors);
                if (retries === errorObject_1.errorObject) {
                    return _super.prototype.error.call(this, errorObject_1.errorObject.e);
                }
                retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
            }
            else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */
function sample(notifier) {
    return function (source) { return source.lift(new SampleOperator(notifier)); };
}
exports.sample = sample;
var SampleOperator = (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(subscribeToResult_1.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleSubscriber = (function (_super) {
    __extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=sample.js.map

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var async_1 = __webpack_require__(33);
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
}
exports.sampleTime = sampleTime;
var SampleTimeOperator = (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleTimeSubscriber = (function (_super) {
    __extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */
function sequenceEqual(compareTo, comparor) {
    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparor)); };
}
exports.sequenceEqual = sequenceEqual;
var SequenceEqualOperator = (function () {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}());
exports.SequenceEqualOperator = SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SequenceEqualSubscriber = (function (_super) {
    __extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = tryCatch_1.tryCatch(comparor)(a, b);
                if (areEqual === errorObject_1.errorObject) {
                    this.destination.error(errorObject_1.errorObject.e);
                }
            }
            else {
                areEqual = a === b;
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}(Subscriber_1.Subscriber));
exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
var SequenceEqualCompareToSubscriber = (function (_super) {
    __extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var multicast_1 = __webpack_require__(125);
var refCount_1 = __webpack_require__(397);
var Subject_1 = __webpack_require__(49);
function shareSubjectFactory() {
    return new Subject_1.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */
function share() {
    return function (source) { return refCount_1.refCount()(multicast_1.multicast(shareSubjectFactory)(source)); };
}
exports.share = share;
;
//# sourceMappingURL=share.js.map

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ReplaySubject_1 = __webpack_require__(279);
/**
 * @method shareReplay
 * @owner Observable
 */
function shareReplay(bufferSize, windowTime, scheduler) {
    return function (source) { return source.lift(shareReplayOperator(bufferSize, windowTime, scheduler)); };
}
exports.shareReplay = shareReplay;
function shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function (value) { subject.next(value); },
                error: function (err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function () {
                    isComplete = true;
                    subject.complete();
                },
            });
        }
        var innerSub = subject.subscribe(this);
        return function () {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) {
                subscription.unsubscribe();
            }
        };
    };
}
;
//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var EmptyError_1 = __webpack_require__(280);
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */
function single(predicate) {
    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
}
exports.single = single;
var SingleOperator = (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SingleSubscriber = (function (_super) {
    __extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return SingleSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=single.js.map

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */
function skip(count) {
    return function (source) { return source.lift(new SkipOperator(count)); };
}
exports.skip = skip;
var SkipOperator = (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipSubscriber = (function (_super) {
    __extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skip.js.map

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var ArgumentOutOfRangeError_1 = __webpack_require__(194);
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */
function skipLast(count) {
    return function (source) { return source.lift(new SkipLastOperator(count)); };
}
exports.skipLast = skipLast;
var SkipLastOperator = (function () {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    SkipLastOperator.prototype.call = function (subscriber, source) {
        if (this._skipCount === 0) {
            // If we don't want to skip any values then just subscribe
            // to Subscriber without any further logic.
            return source.subscribe(new Subscriber_1.Subscriber(subscriber));
        }
        else {
            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
        }
    };
    return SkipLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipLastSubscriber = (function (_super) {
    __extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function (value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) {
            this._ring[count] = value;
        }
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
exports.skipUntil = skipUntil;
var SkipUntilOperator = (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipUntilSubscriber = (function (_super) {
    __extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype._complete = function () {
        if (this.isInnerStopped) {
            _super.prototype._complete.call(this);
        }
        else {
            this.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
        this.isInnerStopped = true;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    return SkipUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */
function skipWhile(predicate) {
    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
}
exports.skipWhile = skipWhile;
var SkipWhileOperator = (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipWhileSubscriber = (function (_super) {
    __extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__(105);
var ScalarObservable_1 = __webpack_require__(385);
var EmptyObservable_1 = __webpack_require__(106);
var concat_1 = __webpack_require__(187);
var isScheduler_1 = __webpack_require__(72);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i - 0] = arguments[_i];
    }
    return function (source) {
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len === 1) {
            return concat_1.concat(new ScalarObservable_1.ScalarObservable(array[0], scheduler), source);
        }
        else if (len > 1) {
            return concat_1.concat(new ArrayObservable_1.ArrayObservable(array, scheduler), source);
        }
        else {
            return concat_1.concat(new EmptyObservable_1.EmptyObservable(scheduler), source);
        }
    };
}
exports.startWith = startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsapAction_1 = __webpack_require__(1827);
var AsapScheduler_1 = __webpack_require__(1830);
/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */
exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
//# sourceMappingURL=asap.js.map

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1829);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchMap_1 = __webpack_require__(398);
var identity_1 = __webpack_require__(680);
function switchAll() {
    return switchMap_1.switchMap(identity_1.identity);
}
exports.switchAll = switchAll;
//# sourceMappingURL=switchAll.js.map

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */
function switchMapTo(innerObservable, resultSelector) {
    return function (source) { return source.lift(new SwitchMapToOperator(innerObservable, resultSelector)); };
}
exports.switchMapTo = switchMapTo;
var SwitchMapToOperator = (function () {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapToSubscriber = (function (_super) {
    __extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function (value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var ArgumentOutOfRangeError_1 = __webpack_require__(194);
var EmptyObservable_1 = __webpack_require__(106);
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    return function (source) {
        if (count === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else {
            return source.lift(new TakeOperator(count));
        }
    };
}
exports.take = take;
var TakeOperator = (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeSubscriber = (function (_super) {
    __extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=take.js.map

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
}
exports.takeUntil = takeUntil;
var TakeUntilOperator = (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeUntilSubscriber = (function (_super) {
    __extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    return TakeUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */
function takeWhile(predicate) {
    return function (source) { return source.lift(new TakeWhileOperator(predicate)); };
}
exports.takeWhile = takeWhile;
var TakeWhileOperator = (function () {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeWhileSubscriber = (function (_super) {
    __extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var async_1 = __webpack_require__(33);
var throttle_1 = __webpack_require__(281);
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
}
exports.throttleTime = throttleTime;
var ThrottleTimeOperator = (function () {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ThrottleTimeSubscriber = (function (_super) {
    __extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
        else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
            if (this.leading) {
                this.destination.next(value);
            }
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}
//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var timeInterval_1 = __webpack_require__(756);
exports.TimeInterval = timeInterval_1.TimeInterval;
/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */
function timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timeInterval_1.timeInterval(scheduler)(this);
}
exports.timeInterval = timeInterval;
//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var async_1 = __webpack_require__(33);
function timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return function (source) { return source.lift(new TimeIntervalOperator(scheduler)); };
}
exports.timeInterval = timeInterval;
var TimeInterval = (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());
exports.TimeInterval = TimeInterval;
;
var TimeIntervalOperator = (function () {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function (observer, source) {
        return source.subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeIntervalSubscriber = (function (_super) {
    __extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function (value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(33);
var isDate_1 = __webpack_require__(277);
var Subscriber_1 = __webpack_require__(11);
var TimeoutError_1 = __webpack_require__(758);
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */
function timeout(due, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteTimeout = isDate_1.isDate(due);
    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
    return function (source) { return source.lift(new TimeoutOperator(waitFor, absoluteTimeout, scheduler, new TimeoutError_1.TimeoutError())); };
}
exports.timeout = timeout;
var TimeoutOperator = (function () {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeoutSubscriber = (function (_super) {
    __extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function (subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */
var TimeoutError = (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error));
exports.TimeoutError = TimeoutError;
//# sourceMappingURL=TimeoutError.js.map

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(33);
var isDate_1 = __webpack_require__(277);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/* tslint:enable:max-line-length */
/**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return function (source) {
        var absoluteTimeout = isDate_1.isDate(due);
        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
exports.timeoutWith = timeoutWith;
var TimeoutWithOperator = (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeoutWithSubscriber = (function (_super) {
    __extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(subscribeToResult_1.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(195);
function toArrayReducer(arr, item, index) {
    if (index === 0) {
        return [item];
    }
    arr.push(item);
    return arr;
}
function toArray() {
    return reduce_1.reduce(toArrayReducer, []);
}
exports.toArray = toArray;
//# sourceMappingURL=toArray.js.map

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */
function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
exports.window = window;
var WindowOperator = (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowSubscriber = (function (_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new Subject_1.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new Subject_1.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=window.js.map

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
var Subject_1 = __webpack_require__(49);
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
exports.windowCount = windowCount;
var WindowCountOperator = (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowCountSubscriber = (function (_super) {
    __extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [new Subject_1.Subject()];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new Subject_1.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var async_1 = __webpack_require__(33);
var Subscriber_1 = __webpack_require__(11);
var isNumeric_1 = __webpack_require__(190);
var isScheduler_1 = __webpack_require__(72);
function windowTime(windowTimeSpan) {
    var scheduler = async_1.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (isScheduler_1.isScheduler(arguments[3])) {
        scheduler = arguments[3];
    }
    if (isScheduler_1.isScheduler(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (isNumeric_1.isNumeric(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (isScheduler_1.isScheduler(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (isNumeric_1.isNumeric(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
exports.windowTime = windowTime;
var WindowTimeOperator = (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var CountedSubject = (function (_super) {
    __extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(Subject_1.Subject));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowTimeSubscriber = (function (_super) {
    __extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
            this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: this, window: window, windowTimeSpan: windowTimeSpan };
            this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}
//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var Subscription_1 = __webpack_require__(46);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */
function windowToggle(openings, closingSelector) {
    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
}
exports.windowToggle = windowToggle;
var WindowToggleOperator = (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowToggleSubscriber = (function (_super) {
    __extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === errorObject_1.errorObject) {
                return this.error(errorObject_1.errorObject.e);
            }
            else {
                var window_1 = new Subject_1.Subject();
                var subscription = new Subscription_1.Subscription();
                var context = { window: window_1, subscription: subscription };
                this.contexts.push(context);
                var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) {
                    this.closeWindow(this.contexts.length - 1);
                }
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */
function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new WindowOperator(closingSelector));
    };
}
exports.windowWhen = windowWhen;
var WindowOperator = (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowSubscriber = (function (_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) { innerSub = null; }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new Subject_1.Subject();
        this.destination.next(window);
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            var err = errorObject_1.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        }
        else {
            this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
        }
    };
    return WindowSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(17);
var subscribeToResult_1 = __webpack_require__(18);
/* tslint:enable:max-line-length */
/**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */
function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i - 0] = arguments[_i];
    }
    return function (source) {
        var project;
        if (typeof args[args.length - 1] === 'function') {
            project = args.pop();
        }
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
exports.withLatestFrom = withLatestFrom;
var WithLatestFromOperator = (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WithLatestFromSubscriber = (function (_super) {
    __extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__(278);
function zipAll(project) {
    return function (source) { return source.lift(new zip_1.ZipOperator(project)); };
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscriptionLog_1 = __webpack_require__(769);
var SubscriptionLoggable = (function () {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
        this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}());
exports.SubscriptionLoggable = SubscriptionLoggable;
//# sourceMappingURL=SubscriptionLoggable.js.map

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscriptionLog = (function () {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) { unsubscribedFrame = Number.POSITIVE_INFINITY; }
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}());
exports.SubscriptionLog = SubscriptionLog;
//# sourceMappingURL=SubscriptionLog.js.map

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function applyMixins(derivedCtor, baseCtors) {
    for (var i = 0, len = baseCtors.length; i < len; i++) {
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
exports.applyMixins = applyMixins;
//# sourceMappingURL=applyMixins.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(191);
var AsyncScheduler_1 = __webpack_require__(192);
var VirtualTimeScheduler = (function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        var _this = this;
        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
        _super.call(this, SchedulerAction, function () { return _this.frame; });
        this.maxFrames = maxFrames;
        this.frame = 0;
        this.index = -1;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.VirtualTimeScheduler = VirtualTimeScheduler;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var VirtualAction = (function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) { index = scheduler.index += 1; }
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.index = index;
        this.active = true;
        this.index = scheduler.index = index;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction_1.AsyncAction));
exports.VirtualAction = VirtualAction;
//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* jstz.min.js Version: 1.0.6 Build date: 2019-09-09 */
!function(e){var a=function(){"use strict";var e="s",s={DAY:864e5,HOUR:36e5,MINUTE:6e4,SECOND:1e3,BASELINE_YEAR:2014,MAX_SCORE:864e6,AMBIGUITIES:{"America/Denver":["America/Mazatlan"],"America/Chicago":["America/Mexico_City"],"America/Asuncion":["America/Campo_Grande","America/Santiago"],"America/Montevideo":["America/Sao_Paulo","America/Santiago"],"Asia/Beirut":["Asia/Amman","Asia/Jerusalem","Europe/Helsinki","Asia/Damascus","Africa/Cairo","Asia/Gaza","Europe/Minsk","Africa/Windhoek"],"Pacific/Auckland":["Pacific/Fiji"],"America/Los_Angeles":["America/Santa_Isabel"],"America/New_York":["America/Havana"],"America/Halifax":["America/Goose_Bay"],"America/Godthab":["America/Miquelon"],"Asia/Dubai":["Asia/Yerevan"],"Asia/Jakarta":["Asia/Krasnoyarsk"],"Asia/Shanghai":["Asia/Irkutsk","Australia/Perth"],"Australia/Sydney":["Australia/Lord_Howe"],"Asia/Tokyo":["Asia/Yakutsk"],"Asia/Dhaka":["Asia/Omsk"],"Asia/Baku":["Asia/Yerevan"],"Australia/Brisbane":["Asia/Vladivostok"],"Pacific/Noumea":["Asia/Vladivostok"],"Pacific/Majuro":["Asia/Kamchatka","Pacific/Fiji"],"Pacific/Tongatapu":["Pacific/Apia"],"Asia/Baghdad":["Europe/Minsk","Europe/Moscow"],"Asia/Karachi":["Asia/Yekaterinburg"],"Africa/Johannesburg":["Asia/Gaza","Africa/Cairo"]}},i=function(e){var a=-e.getTimezoneOffset();return null!==a?a:0},r=function(){for(var e=[],a=0;a<=11;a++)for(var r=1;r<=28;r++){var n=i(new Date(s.BASELINE_YEAR,a,r));e?e&&e[e.length-1]!==n&&e.push(n):e.push()}return e},n=function(){var a=0,s=r();return s.length>1&&(a=s[0]-s[1]),s.length>3?s[0]+",1,weird":a<0?s[0]+",1":a>0?s[1]+",1,"+e:s[0]+",0"},o=function(){var e,a;if(Intl&&"undefined"!=typeof Intl&&"undefined"!=typeof Intl.DateTimeFormat&&(e=Intl.DateTimeFormat(),"undefined"!=typeof e&&"undefined"!=typeof e.resolvedOptions))return a=e.resolvedOptions().timeZone,a&&(a.indexOf("/")>-1||"UTC"===a)?a:void 0},t=function(e){for(var a=new Date(e,0,1,0,0,1,0).getTime(),s=new Date(e,12,31,23,59,59).getTime(),i=a,r=new Date(i).getTimezoneOffset(),n=null,o=null;i<s-864e5;){var t=new Date(i),A=t.getTimezoneOffset();A!==r&&(A<r&&(n=t),A>r&&(o=t),r=A),i+=864e5}return!(!n||!o)&&{s:u(n).getTime(),e:u(o).getTime()}},u=function f(e,a,i){"undefined"==typeof a&&(a=s.DAY,i=s.HOUR);for(var r=new Date(e.getTime()-a).getTime(),n=e.getTime()+a,o=new Date(r).getTimezoneOffset(),t=r,u=null;t<n-i;){var A=new Date(t),c=A.getTimezoneOffset();if(c!==o){u=A;break}t+=i}return a===s.DAY?f(u,s.HOUR,s.MINUTE):a===s.HOUR?f(u,s.MINUTE,s.SECOND):u},A=function(e,a,s,i){if("N/A"!==s)return s;if("Asia/Beirut"===a){if("Africa/Cairo"===i.name&&13983768e5===e[6].s&&14116788e5===e[6].e)return 0;if("Asia/Jerusalem"===i.name&&13959648e5===e[6].s&&14118588e5===e[6].e)return 0}else if("America/Santiago"===a){if("America/Asuncion"===i.name&&14124816e5===e[6].s&&1397358e6===e[6].e)return 0;if("America/Campo_Grande"===i.name&&14136912e5===e[6].s&&13925196e5===e[6].e)return 0}else if("America/Montevideo"===a){if("America/Sao_Paulo"===i.name&&14136876e5===e[6].s&&1392516e6===e[6].e)return 0}else if("Pacific/Auckland"===a&&"Pacific/Fiji"===i.name&&14142456e5===e[6].s&&13961016e5===e[6].e)return 0;return s},c=function(e,i){for(var r=function(a){for(var r=0,n=0;n<e.length;n++)if(a.rules[n]&&e[n]){if(!(e[n].s>=a.rules[n].s&&e[n].e<=a.rules[n].e)){r="N/A";break}if(r=0,r+=Math.abs(e[n].s-a.rules[n].s),r+=Math.abs(a.rules[n].e-e[n].e),r>s.MAX_SCORE){r="N/A";break}}return r=A(e,i,r,a)},n={},o=a.olson.dst_rules.zones,t=o.length,u=s.AMBIGUITIES[i],c=0;c<t;c++){var m=o[c],l=r(o[c]);"N/A"!==l&&(n[m.name]=l)}for(var f in n)if(n.hasOwnProperty(f))for(var d=0;d<u.length;d++)if(u[d]===f)return f;return i},m=function(e){var s=function(){for(var e=[],s=0;s<a.olson.dst_rules.years.length;s++){var i=t(a.olson.dst_rules.years[s]);e.push(i)}return e},i=function(e){for(var a=0;a<e.length;a++)if(e[a]!==!1)return!0;return!1},r=s(),n=i(r);return n?c(r,e):e},l=function(e){var i=!1,t=n();return(e||"undefined"==typeof e)&&(i=o()),i||(i=a.olson.timezones[t],"undefined"!=typeof s.AMBIGUITIES[i]&&(i=m(i))),{name:function(){return i},using_intl:e||"undefined"==typeof e,needle:t,offsets:r()}};return{determine:l}}();a.olson=a.olson||{},a.olson.timezones={"-720,0":"Etc/GMT+12","-660,0":"Pacific/Pago_Pago","-660,1,s":"Pacific/Apia","-600,1":"America/Adak","-600,0":"Pacific/Honolulu","-570,0":"Pacific/Marquesas","-540,0":"Pacific/Gambier","-540,1":"America/Anchorage","-480,1":"America/Los_Angeles","-480,0":"Pacific/Pitcairn","-420,0":"America/Phoenix","-420,1":"America/Denver","-360,0":"America/Guatemala","-360,1":"America/Chicago","-360,1,s":"Pacific/Easter","-300,0":"America/Bogota","-300,1":"America/New_York","-270,0":"America/Caracas","-240,1":"America/Halifax","-240,0":"America/Santo_Domingo","-240,1,s":"America/Asuncion","-210,1":"America/St_Johns","-180,1":"America/Godthab","-180,0":"America/Buenos_Aires","-180,1,s":"America/Montevideo","-120,0":"America/Noronha","-120,1":"America/Noronha","-60,1":"Atlantic/Azores","-60,0":"Atlantic/Cape_Verde","0,0":"UTC","0,1":"Europe/London","0,1,weird":"Africa/Casablanca","60,1":"Europe/Berlin","60,0":"Africa/Lagos","60,1,weird":"Africa/Casablanca","120,1":"Asia/Beirut","120,1,weird":"Africa/Cairo","120,0":"Africa/Johannesburg","180,0":"Asia/Baghdad","180,1":"Europe/Moscow","210,1":"Asia/Tehran","240,0":"Asia/Dubai","240,1":"Asia/Baku","270,0":"Asia/Kabul","300,1":"Asia/Yekaterinburg","300,0":"Asia/Karachi","330,0":"Asia/Calcutta","345,0":"Asia/Katmandu","360,0":"Asia/Dhaka","360,1":"Asia/Omsk","390,0":"Asia/Rangoon","420,1":"Asia/Krasnoyarsk","420,0":"Asia/Jakarta","480,0":"Asia/Shanghai","480,1":"Asia/Irkutsk","525,0":"Australia/Eucla","525,1,s":"Australia/Eucla","540,1":"Asia/Yakutsk","540,0":"Asia/Tokyo","570,0":"Australia/Darwin","570,1,s":"Australia/Adelaide","600,0":"Australia/Brisbane","600,1":"Asia/Vladivostok","600,1,s":"Australia/Sydney","630,1,s":"Australia/Lord_Howe","660,1":"Asia/Kamchatka","660,0":"Pacific/Noumea","690,0":"Pacific/Norfolk","720,1,s":"Pacific/Auckland","720,0":"Pacific/Majuro","765,1,s":"Pacific/Chatham","780,0":"Pacific/Tongatapu","780,1,s":"Pacific/Apia","840,0":"Pacific/Kiritimati"},a.olson.dst_rules={years:[2008,2009,2010,2011,2012,2013,2014],zones:[{name:"Africa/Cairo",rules:[{e:12199572e5,s:12090744e5},{e:1250802e6,s:1240524e6},{e:12858804e5,s:12840696e5},!1,!1,!1,{e:14116788e5,s:1406844e6}]},{name:"America/Asuncion",rules:[{e:12050316e5,s:12243888e5},{e:12364812e5,s:12558384e5},{e:12709548e5,s:12860784e5},{e:13024044e5,s:1317528e6},{e:1333854e6,s:13495824e5},{e:1364094e6,s:1381032e6},{e:13955436e5,s:14124816e5}]},{name:"America/Campo_Grande",rules:[{e:12032172e5,s:12243888e5},{e:12346668e5,s:12558384e5},{e:12667212e5,s:1287288e6},{e:12981708e5,s:13187376e5},{e:13302252e5,s:1350792e6},{e:136107e7,s:13822416e5},{e:13925196e5,s:14136912e5}]},{name:"America/Goose_Bay",rules:[{e:122559486e4,s:120503526e4},{e:125704446e4,s:123648486e4},{e:128909886e4,s:126853926e4},{e:13205556e5,s:129998886e4},{e:13520052e5,s:13314456e5},{e:13834548e5,s:13628952e5},{e:14149044e5,s:13943448e5}]},{name:"America/Havana",rules:[{e:12249972e5,s:12056436e5},{e:12564468e5,s:12364884e5},{e:12885012e5,s:12685428e5},{e:13211604e5,s:13005972e5},{e:13520052e5,s:13332564e5},{e:13834548e5,s:13628916e5},{e:14149044e5,s:13943412e5}]},{name:"America/Mazatlan",rules:[{e:1225008e6,s:12074724e5},{e:12564576e5,s:1238922e6},{e:1288512e6,s:12703716e5},{e:13199616e5,s:13018212e5},{e:13514112e5,s:13332708e5},{e:13828608e5,s:13653252e5},{e:14143104e5,s:13967748e5}]},{name:"America/Mexico_City",rules:[{e:12250044e5,s:12074688e5},{e:1256454e6,s:12389184e5},{e:12885084e5,s:1270368e6},{e:1319958e6,s:13018176e5},{e:13514076e5,s:13332672e5},{e:13828572e5,s:13653216e5},{e:14143068e5,s:13967712e5}]},{name:"America/Miquelon",rules:[{e:12255984e5,s:12050388e5},{e:1257048e6,s:12364884e5},{e:12891024e5,s:12685428e5},{e:1320552e6,s:12999924e5},{e:13520016e5,s:1331442e6},{e:13834512e5,s:13628916e5},{e:14149008e5,s:13943412e5}]},{name:"America/Santa_Isabel",rules:[{e:12250116e5,s:1207476e6},{e:12564612e5,s:12389256e5},{e:12891204e5,s:12685608e5},{e:132057e7,s:13000104e5},{e:13520196e5,s:133146e7},{e:13834692e5,s:13629096e5},{e:14149188e5,s:13943592e5}]},{name:"America/Santiago",rules:[{e:1206846e6,s:1223784e6},{e:1237086e6,s:12552336e5},{e:127035e7,s:12866832e5},{e:13048236e5,s:13138992e5},{e:13356684e5,s:13465584e5},{e:1367118e6,s:13786128e5},{e:13985676e5,s:14100624e5}]},{name:"America/Sao_Paulo",rules:[{e:12032136e5,s:12243852e5},{e:12346632e5,s:12558348e5},{e:12667176e5,s:12872844e5},{e:12981672e5,s:1318734e6},{e:13302216e5,s:13507884e5},{e:13610664e5,s:1382238e6},{e:1392516e6,s:14136876e5}]},{name:"Asia/Amman",rules:[{e:1225404e6,s:12066552e5},{e:12568536e5,s:12381048e5},{e:12883032e5,s:12695544e5},{e:13197528e5,s:13016088e5},!1,!1,{e:14147064e5,s:13959576e5}]},{name:"Asia/Damascus",rules:[{e:12254868e5,s:120726e7},{e:125685e7,s:12381048e5},{e:12882996e5,s:12701592e5},{e:13197492e5,s:13016088e5},{e:13511988e5,s:13330584e5},{e:13826484e5,s:1364508e6},{e:14147028e5,s:13959576e5}]},{name:"Asia/Dubai",rules:[!1,!1,!1,!1,!1,!1,!1]},{name:"Asia/Gaza",rules:[{e:12199572e5,s:12066552e5},{e:12520152e5,s:12381048e5},{e:1281474e6,s:126964086e4},{e:1312146e6,s:130160886e4},{e:13481784e5,s:13330584e5},{e:13802292e5,s:1364508e6},{e:1414098e6,s:13959576e5}]},{name:"Asia/Irkutsk",rules:[{e:12249576e5,s:12068136e5},{e:12564072e5,s:12382632e5},{e:12884616e5,s:12697128e5},!1,!1,!1,!1]},{name:"Asia/Jerusalem",rules:[{e:12231612e5,s:12066624e5},{e:1254006e6,s:1238112e6},{e:1284246e6,s:12695616e5},{e:131751e7,s:1301616e6},{e:13483548e5,s:13330656e5},{e:13828284e5,s:13645152e5},{e:1414278e6,s:13959648e5}]},{name:"Asia/Kamchatka",rules:[{e:12249432e5,s:12067992e5},{e:12563928e5,s:12382488e5},{e:12884508e5,s:12696984e5},!1,!1,!1,!1]},{name:"Asia/Krasnoyarsk",rules:[{e:12249612e5,s:12068172e5},{e:12564108e5,s:12382668e5},{e:12884652e5,s:12697164e5},!1,!1,!1,!1]},{name:"Asia/Omsk",rules:[{e:12249648e5,s:12068208e5},{e:12564144e5,s:12382704e5},{e:12884688e5,s:126972e7},!1,!1,!1,!1]},{name:"Asia/Vladivostok",rules:[{e:12249504e5,s:12068064e5},{e:12564e8,s:1238256e6},{e:12884544e5,s:12697056e5},!1,!1,!1,!1]},{name:"Asia/Yakutsk",rules:[{e:1224954e6,s:120681e7},{e:12564036e5,s:12382596e5},{e:1288458e6,s:12697092e5},!1,!1,!1,!1]},{name:"Asia/Yekaterinburg",rules:[{e:12249684e5,s:12068244e5},{e:1256418e6,s:1238274e6},{e:12884724e5,s:12697236e5},!1,!1,!1,!1]},{name:"Asia/Yerevan",rules:[{e:1224972e6,s:1206828e6},{e:12564216e5,s:12382776e5},{e:1288476e6,s:12697272e5},{e:13199256e5,s:13011768e5},!1,!1,!1]},{name:"Australia/Lord_Howe",rules:[{e:12074076e5,s:12231342e5},{e:12388572e5,s:12545838e5},{e:12703068e5,s:12860334e5},{e:13017564e5,s:1317483e6},{e:1333206e6,s:13495374e5},{e:13652604e5,s:1380987e6},{e:139671e7,s:14124366e5}]},{name:"Australia/Perth",rules:[{e:12068136e5,s:12249576e5},!1,!1,!1,!1,!1,!1]},{name:"Europe/Helsinki",rules:[{e:12249828e5,s:12068388e5},{e:12564324e5,s:12382884e5},{e:12884868e5,s:1269738e6},{e:13199364e5,s:13011876e5},{e:1351386e6,s:13326372e5},{e:13828356e5,s:13646916e5},{e:14142852e5,s:13961412e5}]},{name:"Europe/Minsk",rules:[{e:12249792e5,s:12068352e5},{e:12564288e5,s:12382848e5},{e:12884832e5,s:12697344e5},!1,!1,!1,!1]},{name:"Europe/Moscow",rules:[{e:12249756e5,s:12068316e5},{e:12564252e5,s:12382812e5},{e:12884796e5,s:12697308e5},!1,!1,!1,!1]},{name:"Pacific/Apia",rules:[!1,!1,!1,{e:13017528e5,s:13168728e5},{e:13332024e5,s:13489272e5},{e:13652568e5,s:13803768e5},{e:13967064e5,s:14118264e5}]},{name:"Pacific/Fiji",rules:[!1,!1,{e:12696984e5,s:12878424e5},{e:13271544e5,s:1319292e6},{e:1358604e6,s:13507416e5},{e:139005e7,s:1382796e6},{e:14215032e5,s:14148504e5}]},{name:"Europe/London",rules:[{e:12249828e5,s:12068388e5},{e:12564324e5,s:12382884e5},{e:12884868e5,s:1269738e6},{e:13199364e5,s:13011876e5},{e:1351386e6,s:13326372e5},{e:13828356e5,s:13646916e5},{e:14142852e5,s:13961412e5}]},{name:"Africa/Windhoek",rules:[{e:12207492e5,s:120744e7},{e:12521988e5,s:12388896e5},{e:12836484e5,s:12703392e5},{e:1315098e6,s:13017888e5},{e:13465476e5,s:13332384e5},{e:13779972e5,s:13652928e5},{e:14100516e5,s:13967424e5}]}]},"undefined"!=typeof module&&"undefined"!=typeof module.exports?module.exports=a:"undefined"!="function"&&null!==__webpack_require__(1887)&&null!=__webpack_require__(1888)?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return a}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"==typeof e?window.jstz=a:e.jstz=a}();

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return try_TickerColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return try_TickerScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUPPORTED_TICKER_INTERVALS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = convertLabelToTickerInterval;
// =============================================
// landing TICKER controls 7/16/18
// =============================================

var scrollSpeed = 1000 / 60; //"framerate": 60 is good. 20 was decent;
var ticker_DebugLog = false; //turns on console logs
var ticker_TickerColumns_running = false;
var ticker_TickerColumns_initialized = false;
var ticker_TickerScroll_running = false;
var timer_tickerScroll;
var falloff_generated = false;

var try_TickerColumns = function try_TickerColumns(detail) {
  if (!document.getElementsByClassName('ticker')[0]) return;

  var firstTicker = document.getElementsByClassName('ticker')[0],
      firstTicker_childCount = firstTicker.childNodes.length,
      firstTicker_childCount_fromID = Number(firstTicker.getAttribute('id'));

  if (falloff_generated === false) {
    generate_Falloff(firstTicker);
  }

  if (ticker_DebugLog === true) {
    console.log('TICKER COLUMNS: ' + firstTicker_childCount + ' of ' + firstTicker_childCount_fromID + ' ticker parts');
  }

  if (firstTicker_childCount === firstTicker_childCount_fromID && firstTicker_childCount !== 0 && ticker_TickerColumns_running === false) {
    Ticker_Columns();
  } else {
    if (detail === 'startup' && ticker_TickerColumns_initialized === false) {
      setTimeout(function () {
        try_TickerColumns('startup');
      }, 1000);
    }
  }
};

function Ticker_Columns() {
  //this function creates and removes...
  //...ticker "columns" that are used in the loop animation

  // if ticker-scrolling doesn't exist (if component is unmounted) then return;
  if (!document.getElementsByClassName('ticker-scrolling')[0]) return;

  ticker_TickerColumns_running = true;

  if (ticker_DebugLog === true) {
    console.log('Checking ticker columns');
  }

  //whats the width of 1 ticker?
  var tickers = document.getElementsByClassName('ticker'),
      base_ticker_width = tickers[0].offsetWidth;
  if (base_ticker_width < 0) {
    base_ticker_width = 0;
  }

  // how many tickers can fit inside the page width?
  var total_windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      countNeeded_tickers = 0,
      current_ticker_Count = 0;

  countNeeded_tickers = Math.ceil(total_windowWidth / base_ticker_width) + 1;
  if (countNeeded_tickers < 0 || countNeeded_tickers == null) {
    countNeeded_tickers = 0;
  }

  //how many tickers do we currently have?
  current_ticker_Count = tickers.length;
  if (current_ticker_Count < 0 || current_ticker_Count === null) {
    current_ticker_Count = 0;
  }

  if (ticker_DebugLog === true) {
    console.log(countNeeded_tickers + ' total would fit. We have ' + current_ticker_Count + ' currently');
  }

  //account for object pooling!
  var tickerScrolling_children = document.getElementsByClassName('ticker-scrolling')[0].children;
  for (var i = 0; i < tickerScrolling_children.length; i++) {
    var ticker_container = tickerScrolling_children[i],
        ticker_container_display = window.getComputedStyle(ticker_container, null).getPropertyValue('display').toLowerCase();

    if (ticker_container_display === 'none') {
      if (ticker_DebugLog === true) {
        console.log('subtracted 1 hidden ticker from COUNT!');
      }
      current_ticker_Count -= 1;
    }
  }

  //do we need to add or subtract tickers to equal countNeeded?
  if (current_ticker_Count < countNeeded_tickers) {
    //how many more do we need?
    countNeeded_tickers -= current_ticker_Count;

    if (countNeeded_tickers > 10) {
      countNeeded_tickers = 10;
    } //in case something goes horribly wrong, clamp this

    if (ticker_DebugLog === true) {
      console.log(countNeeded_tickers + ' more block(s) needed');
    }

    //loop through amount and add...
    //...keeping track of how many are needed (for pool calculations)
    var needed = countNeeded_tickers;

    //account for object pooling!
    for (var _i = 0; _i < tickerScrolling_children.length; _i++) {
      var _ticker_container = tickerScrolling_children[_i],
          _ticker_container_display = window.getComputedStyle(_ticker_container, null).getPropertyValue('display').toLowerCase();
      if (_ticker_container_display === 'none' && needed >= 1) {
        if (ticker_DebugLog === true) {
          console.log('Used pool to Create a ticker');
        }
        _ticker_container.style.display = '';
        needed -= 1;
      }
    }

    //after the pool has been checked...
    //...loop through remaining and create fresh
    for (var _i2 = 0; _i2 < needed; _i2++) {
      if (ticker_DebugLog === true) {
        console.log('Created # ' + (_i2 + 1));
      }

      var clone = tickers[0].cloneNode(true);
      tickers[0].parentNode.appendChild(clone);
    }
  } else if (current_ticker_Count > countNeeded_tickers) {
    //how many less do we need?
    current_ticker_Count -= countNeeded_tickers;

    if (ticker_DebugLog === true) {
      console.log(current_ticker_Count + ' less block(s) needed');
    }

    for (var j = 0; j < current_ticker_Count; j++) {
      if (ticker_DebugLog === true) {
        console.log('Removed # ' + (j + 1));
      }
      //move to object pool!
      tickerScrolling_children[tickerScrolling_children.length - 1].style.display = 'none';
    }
  }
  ticker_TickerColumns_running = false;
  ticker_TickerColumns_initialized = true;
}

var try_TickerScroll = function try_TickerScroll(detail) {
  if (!document.getElementsByClassName('ticker')[0]) return;

  var firstTicker = document.getElementsByClassName('ticker')[0],
      firstTicker_childCount = firstTicker.childNodes.length,
      firstTicker_childCount_fromID = Number(firstTicker.getAttribute('id'));

  if (ticker_DebugLog === true) {
    console.log('TICKER SCROLL: ' + firstTicker_childCount + ' of ' + firstTicker_childCount_fromID + ' ticker parts');
  }

  if (firstTicker_childCount === firstTicker_childCount_fromID && firstTicker_childCount !== 0 && ticker_TickerScroll_running === false && ticker_TickerColumns_initialized === true) {
    Ticker_Scroll();
  } else {
    if (detail === 'startup') {
      setTimeout(function () {
        try_TickerScroll('startup');
      }, 1000);
    }
  }
};

function Ticker_Scroll() {
  //we only need to scroll through one full ticker (plus offset into the next one)

  // if ticker-scrolling doesn't exist (if component is unmounted) then return;
  if (!document.getElementsByClassName('ticker-scrolling')[0]) return;

  if (ticker_DebugLog === true) {
    console.log('Attempting ticker scroll');
  }

  ticker_TickerScroll_running = true;

  clearInterval(timer_tickerScroll);

  var tickersInner = document.getElementsByClassName('ticker-scrolling')[0],
      ticker_base = document.getElementsByClassName('ticker')[0],
      tickersInner_AMT = ticker_base.offsetWidth;

  if (ticker_DebugLog === true) {
    console.log('moving backwards -' + convert_PX_to_REM(tickersInner_AMT) + ' rem (one ticker block width)');
  }

  var matrix = window.getComputedStyle(tickersInner, null).getPropertyValue('transform'),
      translate_val = matrix.match(/-?[\d]+/g),
      scroll_translateX = 0;
  if (translate_val != null) {
    scroll_translateX = translate_val[4];
  }

  timer_tickerScroll = setInterval(scroll, scrollSpeed);
  function scroll() {
    if (scroll_translateX * -1 >= tickersInner_AMT) {
      tickersInner.style.transform = 'translateX(0rem)';
      tickersInner.style.translateX = 0;
      clearInterval(timer_tickerScroll);

      Ticker_Scroll();
    } else {
      scroll_translateX--;
      tickersInner.style.transform = 'translateX(' + convert_PX_to_REM(scroll_translateX) + 'rem)';
    }
  }
  ticker_TickerScroll_running = false;
}

function convert_PX_to_REM(x) {
  return x * 0.1;
}

function generate_Falloff(firstTicker) {
  falloff_generated = true;
  var f = document.createElement('div');
  f.innerHTML = '<div class="falloffLeft"></div><div class="falloffRight"></div>';
  f.className = 'falloff';
  firstTicker.parentNode.parentNode.prepend(f);
}

var SUPPORTED_TICKER_INTERVALS = {
  '1m': 60,
  '5m': 300,
  '15m': 900,
  '30m': 1800,
  '1H': 3600,
  '2H': 7200,
  '4H': 14400,
  '6H': 21600,
  '12H': 43200,
  '1D': 86400,
  '1W': 604800,
  '4W': 2419200,
  '16W': 9676800
};

// 60, 300, 900, 1800, 3600, 7200, 14400, 21600, 43200, 86400, 604800, 2419200, 9676800, 125798400
function convertLabelToTickerInterval(i) {
  switch (i) {
    case '1m':
      return 60;
    case '5m':
      return 300;
    case '15m':
      return 900;
    case '30m':
      return 1800;
    case '1H':
      return 3600;
    case '2H':
      return 7200;
    case '4H':
      return 14400;
    case '6H':
      return 21600;
    case '12H':
      return 43200;
    case '1D':
      return 86400;
    case 'W':
    case '1W':
      return 604800;
    case '4W':
      return 2419200;
    case '16W':
      return 9676800;
    default:
      return 60;
  }
}

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderEntryComponent__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sidePanesConstants__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_orderHelper_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_selectors_orderTotalSelector__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__redux_selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__redux_selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);





















var OrderEntryComponentForm = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["j" /* reduxForm */])({
  form: 'orderEntry',
  enableReinitialize: false,
  destroyOnUnmount: false,
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_18__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_ORDER_REPORT));
  }
})(__WEBPACK_IMPORTED_MODULE_3__OrderEntryComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state) {
  var form = state.form,
      user = state.user;


  var isMarginActive = Object(__WEBPACK_IMPORTED_MODULE_15__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state);
  var marginProducts = Object(__WEBPACK_IMPORTED_MODULE_16__redux_selectors_marginProductSelectors__["b" /* marginProductSelector */])(state);
  var instrument = {};
  if (isMarginActive && !state.margin.instrument.fetching) {
    instrument = state.margin.instrument;
  } else {
    instrument = state.apexCore.instrument;
  }

  var _instrument = instrument,
      fetching = _instrument.fetching;

  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var selectedInstrumentId = selectedInstrument ? selectedInstrument.InstrumentId : 1;
  var orderEntryForm = form.orderEntry || { values: {} };

  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_9__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableTrading = _kycVerificationLevel.disableTrading;

  var orderTotal = form.orderEntry ? Object(__WEBPACK_IMPORTED_MODULE_13__redux_selectors_orderTotalSelector__["a" /* orderTotalSelector */])(state, {
    form: form.orderEntry.values
  }) : 0;

  return {
    authorizedUserPermissions: user.permissions,
    orderEntryForm: orderEntryForm,
    marketPrice: Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_buySellSelectors__["h" /* marketPriceOfSelectedInstrumentSelector */])(state, {
      side: orderEntryForm.values.side
    }),
    orderTotal: selectedInstrument.Product2Symbol + ' ' + Object(__WEBPACK_IMPORTED_MODULE_14__helpers_numberFormatter__["b" /* formatNumberToLocale */])(orderTotal, Object(__WEBPACK_IMPORTED_MODULE_19__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)),
    orderNet: Object(__WEBPACK_IMPORTED_MODULE_12__helpers_orderHelper_js__["e" /* getOrderNet */])(orderEntryForm, selectedInstrument, orderTotal),
    orderFee: Object(__WEBPACK_IMPORTED_MODULE_12__helpers_orderHelper_js__["c" /* getOrderFee */])(orderEntryForm, Object(__WEBPACK_IMPORTED_MODULE_17__redux_selectors_positionSelectors__["b" /* positionSelector */])(state)),
    initialValues: {
      side: orderEntryForm.values.side || __WEBPACK_IMPORTED_MODULE_8__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */],
      orderType: orderEntryForm.values.orderType || __WEBPACK_IMPORTED_MODULE_8__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName,
      quantity: '',
      limitPrice: '',
      stopPrice: '',
      fee: '0',
      totalAmount: '0',
      selectedInstrumentId: selectedInstrumentId,
      timeInForce: '1'
    },
    selectedInstrument: selectedInstrument,
    fetching: fetching,
    disableTrading: disableTrading,
    VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__VerificationRequired_VerificationRequiredContainer__["a" /* default */], null),
    hideFees: !!__WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].global.hideFees,
    isMarginActive: isMarginActive,
    marginProducts: marginProducts
  };
};

var mapDispatchToProps = {
  openAdvancedOrderSidePane: function openAdvancedOrderSidePane() {
    return Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_sidePaneActions__["u" /* openSidePane */])(__WEBPACK_IMPORTED_MODULE_5__constants_sidePanesConstants__["a" /* SIDE_PANES */].ADVANCED_ORDER);
  },
  openReportBlockTradeSidePane: function openReportBlockTradeSidePane() {
    return Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_sidePaneActions__["u" /* openSidePane */])(__WEBPACK_IMPORTED_MODULE_5__constants_sidePanesConstants__["a" /* SIDE_PANES */].REPORT_BLOCK_TRADE);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(OrderEntryComponentForm));

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RadioTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_dataTestAttributeHelper__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__APRadioTab_css__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__APRadioTab_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__APRadioTab_css__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var RadioTab = function RadioTab(props) {
  var items = props.items,
      input = props.input,
      baseClass = props.baseClass,
      customClass = props.customClass,
      styleName = props.styleName,
      onClick = props.onClick,
      defaultValue = props.defaultValue;


  var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass);
  var customClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('btn-group btn-group-toggle', baseClasses(), customClasses('rt-wrapper')),
      'data-toggle': 'buttons' },
    items.map(function (item, index) {
      var inputValueIsSet = input.value || typeof input.value === 'boolean';
      var checked = item.value === (inputValueIsSet ? input.value : defaultValue);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('btn', getLabelClass(baseClasses, 'label', item.styleName || styleName, checked), getLabelClass(customClasses, 'rt-label', item.styleName || styleName, checked)),
          key: item.value,
          onClick: onClick,
          'data-test': Object(__WEBPACK_IMPORTED_MODULE_6__helpers_dataTestAttributeHelper__["a" /* getDataTestAttribute */])(item, 'text') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', Object.assign({
          type: 'radio',
          id: item.value.toString()
        }, input, {
          checked: checked,
          value: item.value,
          onClick: item.onClick,
          onBlur: function onBlur(e) {
            return e.preventDefault();
          },
          onChange: function onChange(e) {
            var value = typeof item.value === 'boolean' ? e.target.value === 'true' : e.target.value;
            input.onChange(value);
          }
        })),
        item.text
      );
    })
  );
};

var getLabelClass = function getLabelClass(bem, element, styleName, isChecked) {
  return bem({
    element: element,
    modifiers: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styleName, _defineProperty({
      checked: isChecked
    }, 'checked-' + styleName, isChecked))
  });
};

var itemType = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]).isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

RadioTab.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(itemType).isRequired,
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  styleName: __WEBPACK_IMPORTED_MODULE_4__propTypes_commonComponent__["a" /* styleNamePropType */]
};

RadioTab.defaultProps = {
  baseClass: 'ap-radio-tab',
  styleName: __WEBPACK_IMPORTED_MODULE_4__propTypes_commonComponent__["b" /* styleNames */].general
};

var APRadioTab = function APRadioTab(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], Object.assign({ component: RadioTab }, props));
};

/* harmony default export */ __webpack_exports__["a"] = (APRadioTab);

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstrumentPositionsComponent__ = __webpack_require__(1914);




var mapStateToProps = function mapStateToProps(state) {
  var positions = Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_instrumentPositionSelectors__["a" /* default */])(state);
  var fetching = state.apexCore.position.fetching;


  return {
    positions: positions,
    fetching: fetching
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__InstrumentPositionsComponent__["a" /* default */]));

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginInstrumentPositions__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginInstrumentPosition__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarginOverview__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarginTransferBetweenAccounts__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarginInstrumentBalancesTable__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentSelectorTable__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarginDepositWithdraw__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MarginBalancesFooter__ = __webpack_require__(784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__MarginInstrumentPosition__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__MarginInstrumentPositions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__MarginTransferBetweenAccounts__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__MarginInstrumentBalancesTable__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentSelectorTable__["a"]; });
/* unused harmony reexport MarginDepositWithdrawContainer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__MarginBalancesFooter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__MarginOverview__["a"]; });











/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginInstrumentPositionsContainer__ = __webpack_require__(1918);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginInstrumentPositionsContainer__["a" /* default */]);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginInstrumentPositionContainer__ = __webpack_require__(1922);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginInstrumentPositionContainer__["a" /* default */]);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginOverviewContainer__ = __webpack_require__(1925);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginOverviewContainer__["a" /* default */]);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginInstrumentBalancesTableContainer__ = __webpack_require__(1932);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginInstrumentBalancesTableContainer__["a" /* default */]);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginInstrumentSelectorTableContainer__ = __webpack_require__(1938);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginInstrumentSelectorTableContainer__["a" /* default */]);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginBalancesFooterContainer__ = __webpack_require__(1948);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginBalancesFooterContainer__["a" /* default */]);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OpenPositionsContainer__ = __webpack_require__(1955);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__OpenPositionsContainer__["a" /* default */]);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClosedPositionsContainer__ = __webpack_require__(1958);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ClosedPositionsContainer__["a" /* default */]);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PositionPaymentsContainer__ = __webpack_require__(1960);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PositionPaymentsContainer__["a" /* default */]);

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_MenuComponent_css__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_MenuComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Menu_MenuComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var baseClass = 'menu-component';

var MenuItemComponent = function (_React$Component) {
  _inherits(MenuItemComponent, _React$Component);

  function MenuItemComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuItemComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItemComponent.__proto__ || Object.getPrototypeOf(MenuItemComponent)).call.apply(_ref, [this].concat(args))), _this), _this.getBEMClasses = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, _this.props.customClass);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuItemComponent, [{
    key: 'render',
    value: function render() {
      var bemClasses = this.getBEMClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        {
          className: bemClasses('item', this.props.selected && 'selected'),
          onClick: this.props.onItemClick },
        this.props.children
      );
    }
  }]);

  return MenuItemComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MenuItemComponent.propTypes = {
  onItemClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (MenuItemComponent);

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainNavOptions", function() { return mainNavOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subNavItems", function() { return subNavItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletsPath", function() { return walletsPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletDetailPath", function() { return walletDetailPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "marginBalancesPath", function() { return marginBalancesPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routesArray", function() { return routesArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_load__ = __webpack_require__(100);



var FixedLeftFluidLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 102));
});
var BalancesMenuContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 83));
});
var WalletDetailsBackButtonComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 126));
});
var DualHeaderDashboardLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 207));
});
var SubNavComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 208));
});
var TransferRequestNotificationList = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 154));
});
var TradingLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 103));
});
var AssetActivityDetailsLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 793));
});
var MarginBalancesLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 794));
});
var BalancesListLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 155));
});
var RecentActivityContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 198));
});
var SingleFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 157));
});
var ComponentRowSingle = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 110));
});
var WalletCardGridContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 108));
});
var WalletRowListContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 109));
});
var DualFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 206));
});
var MarketDataCardsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 127));
});
var RetailBuySellLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 432));
});
var MarketOverviewLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 209));
});

var PageFooterComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 61));
});

var WalletDetailsLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 128));
});

// this.context.t('Dashboard')
// this.context.t('Exchange')
// this.context.t('Buy & Sell')
// this.context.t('Wallets')
// this.context.t('User Settings')
var mainNavOptions = {
  mainNavItems: [{ text: 'Dashboard', icon: 'dashboard', path: '/dashboard' }, { text: 'Exchange', icon: 'trading', path: '/exchange' }, { text: 'Balances', icon: 'balance', path: '/margin-balances' }, { text: 'Buy & Sell', icon: 'buy-sell', path: '/buy-sell' }, { text: 'Wallets', icon: 'wallet', path: '/wallets' }, { text: 'Activity', icon: 'activity', path: '/asset-activity-details' }, { text: 'User Settings', icon: 'user-settings', path: '/settings/profile' }],
  settingsPath: '/settings/profile'
};
// this.context.t('Your Snapshot')
// this.context.t('Market Data')
var subNavItems = [{ text: 'Your Snapshot', path: '/dashboard' }, { text: 'Market Data', path: '/dashboard/market-data' }];

var walletsPath = '/wallets';
var walletDetailPath = '/wallets/wallet-detail';
var marginBalancesPath = '/margin-balances';

var routesArray = [{
  exact: true,
  path: '/dashboard',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DualHeaderDashboardLayout, {
      headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
      notificationComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransferRequestNotificationList, null),
      component1: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketOverviewLayout, null),
      component2: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesListLayout, null),
      component3: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentActivityContainer, { filterForSelected: false }),
      footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/buy-sell',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RetailBuySellLayout, { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) });
  }
}, {
  path: '/exchange',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingLayout, null);
  }
}, {
  path: '/margin-balances',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarginBalancesLayout, { detailsLink: walletDetailPath });
  }
}, {
  path: '/asset-activity-details',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AssetActivityDetailsLayout, null);
  }
}, {
  path: '/dashboard/market-data',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      DualFluidHeaderFixedContentLayout,
      {
        headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, { component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketDataCardsContainer, null) })
    );
  }
}, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      SingleFluidHeaderFixedContentLayout,
      { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        header: 'Funded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletCardGridContainer, { detailsLink: walletDetailPath })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        customClass: 'container-with-shadow',
        header: 'Unfunded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletRowListContainer, { detailsLink: walletDetailPath })
      })
    );
  }
  // this.context.t('Funded Accounts')
  // this.context.t('Unfunded Accounts')
}, {
  path: '/wallets/wallet-detail',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FixedLeftFluidLayout,
      {
        left: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsBackButtonComponent, { key: '1' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesMenuContainer, { key: '2' })] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsLayout, null)
    );
  }
}];

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return transfersByProductIdSelector; });
/* unused harmony export transfersRequestSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formattedTransfersRequestSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__productPositionSelectors__ = __webpack_require__(40);




var transfersByProductIdSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.transferRequest.items;
}, function (state) {
  return state.transferRequestRequested.items;
}, function (state) {
  return state.transfer.transfers;
}, function (state) {
  return state.transfer.transfersReceived;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}], function (receivedRequests, sentRequests, sentTransfers, receivedTransfers, selectedProductId) {
  var filterFn = function filterFn(item) {
    return item.ProductId === selectedProductId;
  };

  return {
    receivedRequests: sortTransfersByDate(receivedRequests.filter(filterFn)),
    sentRequests: sortTransfersByDate(sentRequests.filter(filterFn)),
    sentTransfers: sortTransfersByTransferId(sentTransfers.filter(filterFn)),
    receivedTransfers: sortTransfersByTransferId(receivedTransfers.filter(filterFn))
  };
});

var transfersRequestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.transferRequest.items;
}, function (transferRequestItems) {
  var filteredItems = Array.isArray(transferRequestItems) ? transferRequestItems.filter(function (item) {
    return item.Status === 'Requested';
  }) : [];

  return filteredItems;
});

var formattedTransfersRequestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(transfersRequestSelector, function (state) {
  return state;
}, function (items, state) {
  return items.map(function (i) {
    var RequestorUsername = i.RequestorUsername,
        Amount = i.Amount,
        RequestCode = i.RequestCode;

    var product = Object(__WEBPACK_IMPORTED_MODULE_2__productPositionSelectors__["c" /* getProductByIdSelector */])(state, i.ProductId);
    /**
     * Filter undefined products to prevent DOS attack [DEV-1082].
     */
    if (!product) return undefined;
    var iconFileName = product.iconFileName,
        ProductSymbol = product.ProductSymbol,
        ProductFullName = product.ProductFullName;


    return {
      RequestCode: RequestCode,
      iconFileName: iconFileName,
      ProductSymbol: ProductSymbol,
      ProductFullName: ProductFullName,
      RequestorUsername: RequestorUsername,
      Amount: Amount
    };
  }).filter(function (i) {
    return i;
  });
});

var sortTransfersByTransferId = function sortTransfersByTransferId(transfers) {
  return transfers.sort(function (a, b) {
    var firstTransferId = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(a, 'TransferId');
    var secondTransferId = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(b, 'TransferId');
    if (firstTransferId > secondTransferId) {
      return -1;
    } else if (firstTransferId < secondTransferId) {
      return 1;
    } else {
      return 0;
    }
  });
};

var sortTransfersByDate = function sortTransfersByDate(transfers) {
  return transfers.sort(function (a, b) {
    var firstTimestamp = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(a, 'CreatedTimestamp');
    var secondTimestamp = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(b, 'CreatedTimestamp');
    if (firstTimestamp > secondTimestamp) {
      return -1;
    } else if (firstTimestamp < secondTimestamp) {
      return 1;
    } else {
      return 0;
    }
  });
};

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AssetActivityDetails__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MarginClosePosition_EstimatedSettlementModal__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MarginClosePosition_MarginClosePositionModal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_positionActions__ = __webpack_require__(85);









var classes = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('asset-activity-details-layout');

var BuySellDesktopLayout = function BuySellDesktopLayout(_ref) {
  var MarginBorrowerEnabled = _ref.MarginBorrowerEnabled,
      selectPositionAndSave = _ref.selectPositionAndSave;

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    selectPositionAndSave(null);
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('content-wrapper') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_AssetActivityDetails__["a" /* default */], null)
    ),
    MarginBorrowerEnabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MarginClosePosition_MarginClosePositionModal__["a" /* default */], null),
    MarginBorrowerEnabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_MarginClosePosition_EstimatedSettlementModal__["a" /* default */], null)
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    MarginBorrowerEnabled: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(state, 'user.userInfo.MarginBorrowerEnabled', false)
  };
};

var mapDispatchToProps = {
  selectPositionAndSave: __WEBPACK_IMPORTED_MODULE_7__redux_actions_positionActions__["f" /* selectPositionAndSave */]
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(BuySellDesktopLayout));

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginBalancesLayout__ = __webpack_require__(1994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__ = __webpack_require__(57);





var mapStateToProps = function mapStateToProps(state) {
  var marginProductsFetching = state.margin.product.fetching;
  var isMarginActive = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state);
  var isMarginEnabled = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginSelectors__["d" /* isMarginEnabledSelector */])(state);

  return {
    marginProductsFetching: marginProductsFetching,
    isMarginActive: isMarginActive,
    isMarginEnabled: isMarginEnabled
  };
};

var mapDispatchToProps = {
  enableMargin: __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__["n" /* enableMargin */],
  disableMargin: __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__["l" /* disableMargin */],
  activateMarginTradingStyle: __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__["i" /* activateMarginTradingStyle */],
  deactivateMarginTradingStyle: __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__["k" /* deactivateMarginTradingStyle */]
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginBalancesLayout__["a" /* default */]));

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecentActivityHeaderComponent__ = __webpack_require__(2013);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RecentActivityHeaderComponent__["a" /* default */]);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APTable__ = __webpack_require__(45);




var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var RecentActivityTableComponent = function RecentActivityTableComponent(props) {
  var columns = props.columns,
      content = props.content,
      context = props.context,
      usePagination = props.usePagination,
      pageSize = props.pageSize,
      minRow = props.minRow;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APTable__["a" /* default */], {
    componentName: 'RecentActivityComponent',
    columns: columns,
    pageSize: pageSize,
    minRow: minRow,
    rows: content,
    baseClass: baseClasses,
    headerOutside: true,
    usePagination: usePagination,
    empty: context.t('No data is available')
  });
};

RecentActivityTableComponent.defaultProps = {
  usePagination: false,
  pageSize: 6,
  minRow: 6
};

/* harmony default export */ __webpack_exports__["a"] = (RecentActivityTableComponent);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return typeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rawDateFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_get_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_is_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_add_days__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_add_days__);






var typeFilter = function typeFilter(item, selectedType) {
  var value = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(item, 'Type');
  if (!value) {
    console.warn('recent activity item does not have a type:', item);
    return false;
  }

  if (selectedType !== 'all') {
    return value === selectedType;
  } else {
    return true;
  }
};

var dateFilter = function dateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();

  var rawTimeStamp = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(item, 'TimeStamp.raw');

  if (!rawTimeStamp) {
    console.warn('recent activity item does not have a TimeStamp.raw property:', item);
    return false;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default()(startDate) && __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default()(endDate)) {
    return __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range___default()(rawTimeStamp, __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time___default()(startDate), __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time___default()(__WEBPACK_IMPORTED_MODULE_4_date_fns_add_days___default()(endDate, 1)));
  }

  return __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range___default()(rawTimeStamp, 0, Date.now());
};

var rawDateFilter = function rawDateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();

  var rawTimeStamp = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(item, 'TimeStamp');

  if (!rawTimeStamp) {
    console.warn('recent activity item does not have a TimeStamp property:', item);
    return false;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default()(startDate) && __WEBPACK_IMPORTED_MODULE_2_date_fns_is_date___default()(endDate)) {
    return __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range___default()(rawTimeStamp, __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time___default()(startDate), __WEBPACK_IMPORTED_MODULE_0_date_fns_get_time___default()(__WEBPACK_IMPORTED_MODULE_4_date_fns_add_days___default()(endDate, 1)));
  }

  return __WEBPACK_IMPORTED_MODULE_1_date_fns_is_within_range___default()(rawTimeStamp, 0, Date.now());
};

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellTabsContainer__ = __webpack_require__(2041);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellTabsContainer__["a" /* default */]);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellInstrumentSelectorContainer__ = __webpack_require__(2043);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellInstrumentSelectorContainer__["a" /* default */]);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onInstrumentSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instrumentActions__ = __webpack_require__(79);



var onInstrumentSelect = function onInstrumentSelect(instrumentId) {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__instrumentActions__["e" /* selectInstrument */])(parseInt(instrumentId, 10)));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__orderEntryActions__["c" /* clearBuySellForm */])());
  };
};

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellOrderButtonContainer__ = __webpack_require__(2045);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellOrderButtonContainer__["a" /* default */]);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuySellAmountRow__ = __webpack_require__(2049);




var BuySellPresetValuesRows = function BuySellPresetValuesRows(props) {
  var baseClasses = props.baseClasses,
      dealValues = props.dealValues,
      setAmount = props.setAmount,
      activeAmount = props.activeAmount,
      isBuySide = props.isBuySide,
      invertArrows = props.invertArrows;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    dealValues.map(function (deal) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BuySellAmountRow__["a" /* default */], {
        key: deal.key,
        baseClasses: baseClasses,
        onClick: function onClick() {
          return setAmount(deal.amountRadio);
        },
        isActive: deal.price === +activeAmount,
        amountRadio: deal.amountRadio,
        isBuySide: isBuySide,
        value1: deal.value1,
        value2: deal.value2,
        invertArrows: invertArrows
      });
    })
  );
};

BuySellPresetValuesRows.propTypes = {
  baseClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  setAmount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  dealValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellPresetValuesRows);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EotcBuySellContainer__ = __webpack_require__(2053);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__EotcBuySellContainer__["a" /* default */]);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellChartIntervalSelectorContainer__ = __webpack_require__(2073);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellChartIntervalSelectorContainer__["a" /* default */]);

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PopoverMenu_css__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PopoverMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PopoverMenu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popover_Popover__ = __webpack_require__(664);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var PopoverMenu = function (_React$Component) {
  _inherits(PopoverMenu, _React$Component);

  function PopoverMenu(props) {
    _classCallCheck(this, PopoverMenu);

    var _this = _possibleConstructorReturn(this, (PopoverMenu.__proto__ || Object.getPrototypeOf(PopoverMenu)).call(this, props));

    _this.getLinkElement = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
        {
          key: item.label,
          className: _this.baseClasses('item', item.customClass),
          to: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])(item.linkTo),
          onClick: function onClick() {
            return _this.popoverRef.toggleShow();
          } },
        item.beforeLabelElement,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: _this.baseClasses('item-label') },
          item.label
        )
      );
    };

    _this.getOnClickElement = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          key: item.label,
          className: _this.baseClasses('item', item.customClass),
          onClick: _this.getOnItemClick(item) },
        item.beforeLabelElement,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: _this.baseClasses('item-label') },
          item.label
        )
      );
    };

    _this.getOnItemClick = function (item) {
      return function () {
        if (typeof item.onClick !== 'undefined') {
          item.onClick();
          _this.popoverRef.toggleShow();
        }
      };
    };

    _this.renderContent = function () {
      var items = _this.props.items;


      return items.map(function (item, index) {
        if (item.divider) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: _this.baseClasses('item-divider') });
        }

        if (item.linkTo) {
          return _this.getLinkElement(item);
        }

        return _this.getOnClickElement(item);
      });
    };

    _this.popoverRef = null;
    _this.baseClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['popover-menu', _this.props.customClass]);
    return _this;
  }

  _createClass(PopoverMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var popoverProps = this.props.popoverProps;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Popover_Popover__["a" /* default */], Object.assign({
        ref: function ref(_ref) {
          return _this2.popoverRef = _ref;
        },
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          this.renderContent()
        ),
        drawArrow: true,
        isMenu: 'true',
        customClass: this.baseClasses()
      }, popoverProps));
    }
  }]);

  return PopoverMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopoverMenu.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    beforeLabelElement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    linkTo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    customClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  }), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    divider: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([true]).isRequired
  })])).isRequired,
  customClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  popoverProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    trigger: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  }).isRequired
};
PopoverMenu.defaultProps = {
  items: [],
  customClass: ''
};
/* harmony default export */ __webpack_exports__["a"] = (PopoverMenu);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransfersFiltersContainer__ = __webpack_require__(2120);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TransfersFiltersContainer__["a" /* default */]);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_resize__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_InterestBalances__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InterestPayments__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageFooter_PageFooterComponent__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_interestAccountActions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RatesHeading__ = __webpack_require__(2149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RatesGrid__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IbaLayout_css__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IbaLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__IbaLayout_css__);















var customClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('iba-balances-layout');
var classes = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('asset-activity-details-layout');
var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var IBALayout = function IBALayout(_ref, context) {
  var selectedAccountId = _ref.selectedAccountId,
      productsList = _ref.productsList,
      getBalances = _ref.getInterestBalances,
      getAccountStatus = _ref.getInterestAccountStatus,
      getInterestRates = _ref.getRates,
      accountStatus = _ref.accountStatus,
      interestRates = _ref.interestRates;

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    getInterestRates();
  }, []);

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    getBalances();
    getAccountStatus();
  }, [selectedAccountId]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: customClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'iba-balances' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('header-bar') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('header-text') },
            context.t('Rates')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'earning' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__RatesHeading__["a" /* default */], {
            getAccountStatus: getAccountStatus,
            accountStatus: accountStatus
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RatesGrid__["a" /* default */], { productsList: productsList, rates: interestRates })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'iba-balances' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('content-wrapper') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_InterestBalances__["a" /* default */], { products: productsList, rates: interestRates })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'iba-balances', style: { marginBottom: '4rem' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('content-wrapper') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InterestPayments__["a" /* default */], null)
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_PageFooter_PageFooterComponent__["default"], null)
  );
};

IBALayout.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

function mapStateToProps(state) {
  return {
    selectedAccountId: state.user.selectedAccountId,
    selectedInstrument: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
    productsList: Object(__WEBPACK_IMPORTED_MODULE_9__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state),
    accountStatus: state.interestBearingAccounts.accountStatus,
    interestRates: state.interestBearingAccounts.interestRates
  };
}

var mapDispatchToProps = {
  getInterestBalances: __WEBPACK_IMPORTED_MODULE_10__redux_actions_interestAccountActions__["d" /* getInterestBalances */],
  getInterestAccountStatus: __WEBPACK_IMPORTED_MODULE_10__redux_actions_interestAccountActions__["c" /* getInterestAccountStatus */],
  getRates: __WEBPACK_IMPORTED_MODULE_10__redux_actions_interestAccountActions__["e" /* getRates */]
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hocs_resize__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(IBALayout)));

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentRow_ComponentRowDual8020__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentRow_ComponentRowSingle__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StreamingLayout_css__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StreamingLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__StreamingLayout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_withAuthentication__ = __webpack_require__(84);







var layoutClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('streaming-layout');

var StreamingLayout = function StreamingLayout(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: layoutClasses('fixed-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ComponentRow_ComponentRowDual8020__["a" /* default */], {
        customClass: layoutClasses('top-row'),
        component1: props.component1,
        component2: props.component2
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ComponentRow_ComponentRowSingle__["default"], {
        customClass: layoutClasses('bottom-row') + ' container-with-shadow',
        component: props.component3
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: layoutClasses('footer') },
      props.footer
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_5__hocs_withAuthentication__["a" /* default */])(StreamingLayout));

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_level1Actions__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_level2Actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_instrumentActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StreamingCardGridComponent__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var streamingForm = 'StreamingForm';
var StreamingInstruments = __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].StreamingInstruments;


var filterInstruments = function filterInstruments(allInstruments) {
  var displaySymbols = StreamingInstruments.Symbol;
  var filterInstruments = [];
  allInstruments.map(function (item) {
    if (displaySymbols.includes(item.Symbol)) {
      filterInstruments.push(item);
    }
  });

  return filterInstruments;
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return _defineProperty({
    fetching: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["a" /* fetchingSelector */])(state),
    state: state,
    products: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["b" /* fundedPositionsSelector */])(state),
    instruments: filterInstruments(Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__["e" /* standardInstrumentsWithProductFullNamesAndProductSymbols */])(state)),
    level1: state.apexCore.level1,
    productManifest: state.productManifest,
    formData: state.form[streamingForm],
    AccountId: state.user.selectedAccountId,
    selectedInstrumentId: state.apexCore.instrument.selectedInstrumentId,
    additionalSlipage: StreamingInstruments.additionalSlippage
  }, 'state', state);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setInstrument: function setInstrument(payload) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_instrumentActions__["f" /* setInstrument */])(payload.instrumentId));
      // resubscribe to level2
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_level1Actions__["c" /* subscribeToLevel1 */])(payload.instrumentId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_level2Actions__["g" /* unsubscribeLevel2 */])(payload.selectedInstrumentId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_level2Actions__["e" /* getLevel2Data */])(payload.instrumentId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_level2Actions__["f" /* subscribeToLevel2 */])(payload.instrumentId));
      localStorage.setItem('selectedInstrumentId', payload.instrumentId);
    },
    getLevel1Data: function getLevel1Data(InstrumentId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_level1Actions__["b" /* getLevel1Data */])(InstrumentId));
    },
    subscribeToLevel1: function subscribeToLevel1(InstrumentId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_level1Actions__["c" /* subscribeToLevel1 */])(InstrumentId));
    },
    changeReduxForm: function changeReduxForm(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(streamingForm, payload.field, payload.value));
    },
    showNotification: function showNotification(message) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__["e" /* showSnack */])({
        id: 'validationNotification',
        text: message,
        type: 'warning'
      }));
    }
  };
};

var StreamingCardGridContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_8__StreamingCardGridComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: streamingForm,
  enableReinitialize: true
})(StreamingCardGridContainer));

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProfileFormComponent__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_userSelectors__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_userProfileFormActions__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);







var useEmailAsUsername = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].SignupForm.useEmailAsUsername;


var ProfileForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'userProfileForm',
  enableReinitialize: true,
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_userProfileFormActions__["b" /* submitUserProfileForm */])(payload));
  }
})(__WEBPACK_IMPORTED_MODULE_2__ProfileFormComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state) {
  var form = state.form,
      userInfo = state.user.userInfo;


  var editIsDisabled = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_userSelectors__["a" /* isProfileSectionEditingDisabled */])(state);

  return {
    initialValues: {
      username: userInfo.UserName,
      email: userInfo.Email
    },
    formObj: form.userProfileForm ? form.userProfileForm.values : {},
    editIsDisabled: editIsDisabled,
    useEmailAsUsername: useEmailAsUsername
  };
};

var mapDispatchToProps = {
  goToStep: __WEBPACK_IMPORTED_MODULE_4__redux_actions_userProfileFormActions__["a" /* goToProfileFormStep */]
};

var ProfileFormContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ProfileForm);

/* harmony default export */ __webpack_exports__["a"] = (ProfileFormContainer);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isStatusLevelIncreased */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isProfileSectionEditingDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isRegionSectionEditingDisabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);



var isStatusLevelIncreased = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.user;
}, function (user) {
  var userConfig = user.userConfig,
      selectedAccountId = user.selectedAccountId,
      accounts = user.accounts;


  var areAccountsReady = !!selectedAccountId && accounts.length > 0;
  if (!areAccountsReady) return;

  var verificationLevel = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(accounts.find(function (i) {
    return i.AccountId === selectedAccountId;
  }), 'VerificationLevel', 0);

  var levelIncreaseStatus = userConfig.some(function (configOption) {
    return configOption.Key === 'levelIncreaseStatus';
  });

  return verificationLevel > 0 || levelIncreaseStatus && verificationLevel === 0;
});

var isProfileSectionEditingDisabled = isStatusLevelIncreased;
var isRegionSectionEditingDisabled = isStatusLevelIncreased;

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegionSettingsComponent__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_regionFormActions__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_userSelectors__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);







var RegionForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'userProfileRegion',
  enableReinitialize: true
})(__WEBPACK_IMPORTED_MODULE_2__RegionSettingsComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;

  var editIsDisabled = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_userSelectors__["b" /* isRegionSectionEditingDisabled */])(state);
  var languageNames = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].Language.languageNames;

  return {
    initialValues: {
      language: state.i18nState.lang
    },
    formObj: form.userProfileRegion ? form.userProfileRegion.values : {},
    translations: state.i18nState.translations,
    languageNames: languageNames,
    editIsDisabled: editIsDisabled,
    selectedLanguage: languageNames[state.i18nState.lang]
  };
};

var RegionSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, {
  setUserRegionConfig: __WEBPACK_IMPORTED_MODULE_3__redux_actions_regionFormActions__["a" /* setUserRegionConfig */]
})(RegionForm);

/* harmony default export */ __webpack_exports__["a"] = (RegionSettingsContainer);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThemeSettingsComponent__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChartEnums__ = __webpack_require__(285);






var ThemeForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'themeForm',
  enableReinitialize: true,
  onSubmit: function onSubmit() {}
})(__WEBPACK_IMPORTED_MODULE_2__ThemeSettingsComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state) {
  var theme = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].global.theme;
  var chart = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].TradingLayout.chart;

  var localConfig = JSON.parse(localStorage.getItem('apexTemplate')) || {};

  var currentTheme = localConfig.theme || theme;
  var currentChart = localConfig.chart || chart;

  return {
    initialValues: {
      theme: currentTheme.charAt(0).toUpperCase() + currentTheme.slice(1),
      chart: currentChart
    },
    formValues: Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["h" /* getFormValues */])('themeForm')(state) || {}
  };
};

var ThemeSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(ThemeForm);

/* harmony default export */ __webpack_exports__["a"] = (ThemeSettingsContainer);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResetPasswordConfirmComponent__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResetPasswordFormComponent_css__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResetPasswordFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ResetPasswordFormComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ResetPasswordRequestForm_ResetPasswordRequestFormContainerFactory__ = __webpack_require__(2190);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var classes = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('reset-password-form');

var ResetPasswordConfirmContainer = Object(__WEBPACK_IMPORTED_MODULE_7__ResetPasswordRequestForm_ResetPasswordRequestFormContainerFactory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__ResetPasswordConfirmComponent__["a" /* default */]);

var ResetPasswordComponent = function (_React$Component) {
  _inherits(ResetPasswordComponent, _React$Component);

  function ResetPasswordComponent() {
    _classCallCheck(this, ResetPasswordComponent);

    var _this = _possibleConstructorReturn(this, (ResetPasswordComponent.__proto__ || Object.getPrototypeOf(ResetPasswordComponent)).call(this));

    _this.toggleModal = function () {
      return _this.setState({ openModal: !_this.state.openModal });
    };

    _this.state = { openModal: false };
    return _this;
  }

  _createClass(ResetPasswordComponent, [{
    key: 'render',
    value: function render() {
      var openModal = this.state.openModal;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: classes('text-info') },
            this.context.t('To change your password, we will send you an email that will allow you to access the Reset Password feature. Click the button below to receive the email.')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: classes('button-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__common_APButton__["a" /* default */],
              {
                type: 'button',
                customClass: classes(),
                onClick: this.toggleModal },
              this.context.t('Reset Your Password')
            )
          )
        ),
        openModal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__common_Modal_Modal__["a" /* default */],
          {
            isOpen: openModal,
            title: this.context.t('Reset Password'),
            onCancel: this.toggleModal,
            close: this.toggleModal,
            customClass: classes('ap-modal') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResetPasswordConfirmContainer, this.props)
        )
      );
    }
  }]);

  return ResetPasswordComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ResetPasswordComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordComponent);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__ = __webpack_require__(37);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var selector = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["g" /* formValueSelector */])('enableTwoFactorAuth');

var mapStateToProps = function mapStateToProps(state) {
  return {
    initialValues: {
      use2FA: !!state.user.userInfo.Use2FA
    },
    use2FA: selector(state, 'use2FA'),
    use2FAOriginal: state.user.userInfo.Use2FA
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    enable2FA: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__["k" /* getGoogleQrCode */])());

              case 2:
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('enableTwoFactorAuth', 'use2FA', true));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].ENABLE_2FA));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      function enable2FA() {
        return _ref.apply(this, arguments);
      }

      return enable2FA;
    }(),
    disable2FA: function disable2FA() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('enableTwoFactorAuth', 'use2FA', false));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].DISABLE_2FA));
    },
    getGoogle2FARecoveryKey: function getGoogle2FARecoveryKey() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].GET_GOOGLE_2FA_RECOVERY_CODE));
    }
  };
};

var EnableTwoFactorAuthContainerFactory = function EnableTwoFactorAuthContainerFactory(Component) {
  var EnableTwoFactorAuthContainer = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["j" /* reduxForm */])({
    form: 'enableTwoFactorAuth',
    enableReinitialize: true
  })(Component);

  return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(EnableTwoFactorAuthContainer);
};

/* harmony default export */ __webpack_exports__["a"] = (EnableTwoFactorAuthContainerFactory);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSwitch_APSwitch__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EnableTwoFactorAuth_Enable2FAModalContainer__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnableTwoFactorAuth_Disable2FAModalContainer__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EnableTwoFactorAuth_GetGoogle2FARecoveryKeyModalContainer__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EnableTwoFactorAuthComponent_css__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EnableTwoFactorAuthComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__EnableTwoFactorAuthComponent_css__);











var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__["b" /* getBEMClasses */])('settings-enable-two-factor-auth');

var EnableTwoFactorAuthComponent = function EnableTwoFactorAuthComponent(props, context) {
  var handleClick = function handleClick(newValue) {
    if (newValue) {
      props.disable2FA();
    } else {
      props.enable2FA();
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('on-off-2fa-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('switch') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSwitch_APSwitch__["a" /* default */], { name: 'use2FA', onClick: handleClick })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('info') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          context.t('Two-Factor Authentication (2FA) adds another layer of protection to your account by requiring an additional passcode during the logging in process.')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          context.t('You will need to download Google Authenticator on your smartphone as part of the process to enable 2FA.')
        )
      )
    ),
    props.use2FAOriginal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
        {
          name: 'recovery2FA',
          customClass: bemClasses(),
          onClick: props.getGoogle2FARecoveryKey },
        context.t('Recovery')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EnableTwoFactorAuth_Enable2FAModalContainer__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EnableTwoFactorAuth_Disable2FAModalContainer__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EnableTwoFactorAuth_GetGoogle2FARecoveryKeyModalContainer__["a" /* default */], null)
  );
};

EnableTwoFactorAuthComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

EnableTwoFactorAuthComponent.propTypes = {
  getGoogle2FARecoveryKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disable2FA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  enable2FA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  use2FAOriginal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (EnableTwoFactorAuthComponent);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APQRCode_APQRCode__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APAutoTabInput_APAutoTabInput__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Enable2FAModal_css__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Enable2FAModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Enable2FAModal_css__);










var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('enable-2fa-modal');

var Enable2FAForm = function Enable2FAForm(props, context) {
  var GoogleQRCode = props.GoogleQRCode,
      handleSubmit = props.handleSubmit,
      userName = props.userName;
  var siteName = __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].global.siteName;


  var code = 'otpauth://totp/' + userName + '?secret=' + GoogleQRCode + '&issuer=' + encodeURI(siteName);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses() },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ol',
          { className: baseClasses('text-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: baseClasses('text-item') },
            context.t('Download a Two-Factor Authentication app to your phone such as Authy or Google Authenticator')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: baseClasses('text-item') },
            context.t('Use the app to scan QR code.')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: baseClasses('text-item') },
            context.t('Type in code from your phone.')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APAutoTabInput_APAutoTabInput__["a" /* default */], {
          name: 'code',
          type: 'input',
          numberOfInputs: 6,
          validate: [__WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__["p" /* required */]]
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('qr-code') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APQRCode_APQRCode__["a" /* default */], { value: code })
      )
    )
  );
};

Enable2FAForm.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

Enable2FAForm.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Enable2FAForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Enable2FAForm);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYCSettingsContainer__ = __webpack_require__(2205);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__KYCSettingsContainer__["a" /* default */]);

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DemoSettingsComponent__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





var DemoSettingsForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'demoSettings',
  enableReinitialize: true,
  onSubmit: function onSubmit(payload, dispatch) {}
})(__WEBPACK_IMPORTED_MODULE_2__DemoSettingsComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state) {
  var _config$global = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].global,
      template = _config$global.template,
      theme = _config$global.theme,
      chart = _config$global.chart;

  var localConfig = JSON.parse(localStorage.getItem('apexTemplate'));
  return {
    initialValues: Object.assign({
      template: template,
      theme: theme,
      chart: chart
    }, localConfig),
    formValues: Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["h" /* getFormValues */])('demoSettings')(state) || {}
  };
};

var DemoSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(DemoSettingsForm);

/* harmony default export */ __webpack_exports__["default"] = (DemoSettingsContainer);

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(170)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InterestSettingsContainer__ = __webpack_require__(2286);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__InterestSettingsContainer__["a" /* default */]);

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepositConfirmationModalComponent__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);





var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openModal: function openModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].DEPOSIT_STATUS));
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DepositConfirmationModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].DEPOSIT_STATUS
})(container));

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserBalanceComponent_css__ = __webpack_require__(2328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserBalanceComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UserBalanceComponent_css__);







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['user-balance']);

var UserBalanceComponent = function UserBalanceComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, 'with-small-padding') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        label: props.position1.ProductSymbol + ' ' + context.t('Balance') + ':',
        text: props.position1.Amount,
        customClass: bemClasses()
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: props.position2.ProductSymbol + ' ' + context.t('Balance') + ':',
      text: props.position2.Amount,
      customClass: bemClasses()
    })
  );
};

UserBalanceComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (UserBalanceComponent);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdvancedOrderFormComponent__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_store__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__redux_selectors_orderTotalSelector__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__redux_selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__redux_selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
























var closeSidePane = function closeSidePane() {
  return __WEBPACK_IMPORTED_MODULE_12__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_sidePaneActions__["c" /* closeAdvancedOrderSidePane */])());
};

var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;


  var isMarginActive = Object(__WEBPACK_IMPORTED_MODULE_15__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state);
  var marginProducts = Object(__WEBPACK_IMPORTED_MODULE_16__redux_selectors_marginProductSelectors__["b" /* marginProductSelector */])(state);
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var formObj = form.advancedOrderEntry || { values: {} };

  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_11__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableTrading = _kycVerificationLevel.disableTrading;

  var orderTotal = form.advancedOrderEntry ? Object(__WEBPACK_IMPORTED_MODULE_14__redux_selectors_orderTotalSelector__["a" /* orderTotalSelector */])(state, {
    form: form.advancedOrderEntry.values
  }) : 0;

  return Object.assign({
    formObj: formObj,
    selectedInstrument: selectedInstrument,
    instruments: Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state),
    marketPrice: Object(__WEBPACK_IMPORTED_MODULE_9__redux_selectors_buySellSelectors__["h" /* marketPriceOfSelectedInstrumentSelector */])(state, {
      side: formObj.values.side
    }),
    orderTotal: selectedInstrument.Product2Symbol + ' ' + Object(__WEBPACK_IMPORTED_MODULE_17__helpers_numberFormatter__["b" /* formatNumberToLocale */])(orderTotal, Object(__WEBPACK_IMPORTED_MODULE_21__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)),
    orderNet: Object(__WEBPACK_IMPORTED_MODULE_18__helpers_orderHelper__["e" /* getOrderNet */])(formObj, selectedInstrument, orderTotal),
    positions: Object(__WEBPACK_IMPORTED_MODULE_19__redux_selectors_positionSelectors__["b" /* positionSelector */])(state),
    initialValues: {
      side: formObj.values.side || __WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */],
      instrument: selectedInstrument.InstrumentId,
      quantity: '',
      limitPrice: '',
      stopPrice: '',
      trailingAmount: '',
      limitOffset: '',
      displayQuantity: '',
      fee: '0',
      totalAmount: '0',
      pegPriceType: '1',
      price: '',
      orderType: formObj.values.orderType || __WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderEntryFormConstants__["a" /* advancedOrderFormTypes */].market.displayName,
      timeInForce: '1'
    },
    disableTrading: disableTrading
  }, Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__["a" /* default */])(state), {
    VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__VerificationRequired_VerificationRequiredContainer__["a" /* default */], { onVerificationLinkClick: closeSidePane }),
    hideFees: !!__WEBPACK_IMPORTED_MODULE_13__config__["b" /* default */].global.hideFees,
    isMarginActive: isMarginActive,
    marginProducts: marginProducts
  });
};

var mapDispatchToProps = {
  clearAdvancedOrderEntryForm: function clearAdvancedOrderEntryForm() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["d" /* clearOrderForm */])('advancedOrderEntry');
  },
  synchronizeQuantityWithPrice: __WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["l" /* synchronizeQuantityWithPrice */],
  synchronizePriceWithQuantity: __WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["k" /* synchronizePriceWithQuantity */]
};

var Form = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["j" /* reduxForm */])({
  form: 'advancedOrderEntry',
  enableReinitialize: true,
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["f" /* placeOrderWithChecks */])(__WEBPACK_IMPORTED_MODULE_8__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].advanced, payload)).then(function (res) {
      if (res.result === false) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__redux_actions_snackbarActions__["e" /* showSnack */])({
          id: 'placeOrderError',
          text: res.errormsg || res.detail,
          type: 'warning'
        }));
      }
    });
  }
})(__WEBPACK_IMPORTED_MODULE_3__AdvancedOrderFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Form));

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SendReceiveSidePane_SendReceiveSidePaneComponent__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_withdrawActions__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_transferActions__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_transferRequestActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var mapStateToProps = function mapStateToProps(state, ownProps) {
  var productId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(ownProps, 'product.ProductId', null);
  var productSymbol = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(ownProps, 'product.ProductSymbol', null);
  var position = Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_positionSelectors__["a" /* positionByProductIdSelector */])(productId)(state);
  var decimalPlaces = state.apexCore.product.decimalPlaces[productSymbol];
  var product = Object.assign({}, ownProps.product, { decimalPlaces: decimalPlaces });
  var _config$global = __WEBPACK_IMPORTED_MODULE_7__config__["b" /* default */].global,
      allowTransfer = _config$global.allowTransfer,
      hideFees = _config$global.hideFees;
  var _state$withdraw = state.withdraw,
      fee = _state$withdraw.withdrawFee,
      template = _state$withdraw.template;
  var selectedAccountId = state.user.selectedAccountId;

  var TicketAmount = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(state, ['withdraw', 'TicketAmount'], 0);
  var withdrawFee = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(state, ['withdraw', 'withdrawFee'], 0);

  return {
    position: position,
    fee: fee,
    template: template,
    product: product,
    allowTransfer: allowTransfer,
    hideFees: hideFees,
    selectedAccountId: selectedAccountId,
    TicketAmount: TicketAmount
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    receiveFunds: function receiveFunds(_ref) {
      var selectedAccountId = _ref.selectedAccountId,
          rest = _objectWithoutProperties(_ref, ['selectedAccountId']);

      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_transferActions__["f" /* requestTransferFunds */])(rest, ownProps.name)).then(function () {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_transferRequestActions__["j" /* getTransferRequestsRequested */])(selectedAccountId));
      });
    },
    sendFunds: function sendFunds(_ref2) {
      var selectedAccountId = _ref2.selectedAccountId,
          rest = _objectWithoutProperties(_ref2, ['selectedAccountId']);

      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_transferActions__["g" /* transferFunds */])(rest, ownProps.name)).then(function () {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_transferActions__["e" /* getTransfers */])(selectedAccountId));
      });
    },
    sendToAddress: function sendToAddress(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_withdrawActions__["m" /* createWithdrawTicket */])(payload, ownProps.name));
    },
    getWithdrawFee: function getWithdrawFee(productId, amount) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_withdrawActions__["p" /* getWithdrawFee */])(productId, amount));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_SendReceiveSidePane_SendReceiveSidePaneComponent__["a" /* default */]));

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62), __webpack_require__(244)(module)))

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(354),
    isIterateeCall = __webpack_require__(2383),
    toInteger = __webpack_require__(316);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(2387),
    overRest = __webpack_require__(519),
    setToString = __webpack_require__(520);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_IMLegacyFormContainer__ = __webpack_require__(2414);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYC_IMLegacyFormContainer__["a" /* default */]);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitIdentityMindForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_dateHelper__ = __webpack_require__(29);

var getCurrentLevel = function getCurrentLevel(currentLevel, levelIncreaseStatus) {
  if (currentLevel === 1 && levelIncreaseStatus !== 'pass') {
    return 1;
  } else if (currentLevel === 1 && levelIncreaseStatus === 'pass') {
    return 2;
  } else if (currentLevel === 2) {
    return 2;
  } else if (currentLevel === 3) {
    return 3;
  } else {
    return 1;
  }
};

var submitIdentityMindForm = function submitIdentityMindForm(props) {
  var alphaPointSessiontoken = props.alphaPointSessiontoken,
      alphaPointUserID = props.alphaPointUserID,
      _props$kycConfig = props.kycConfig,
      type = _props$kycConfig.type,
      requestIdentifier = _props$kycConfig.requestIdentifier,
      submitInfoIdentityMind = props.submitInfoIdentityMind,
      formValues = props.formValues,
      userName = props.userName,
      email = props.email,
      reset = props.reset,
      onSubmit = props.onSubmit;


  var Config = Object.keys(formValues || {}).map(function (key) {
    return {
      Key: key,
      Value: formValues[key]
    };
  });

  Config.push({ Key: 'email', Value: email });

  var setUserConfigPayload = {
    UserId: Number(alphaPointUserID),
    UserName: userName,
    Config: Config
  };

  var dob = formValues.dob ? Object(__WEBPACK_IMPORTED_MODULE_0__helpers_dateHelper__["b" /* formatDate */])(formValues.dob, 'MM/DD/YYYY') : undefined;
  var userInfo = Object.assign({}, formValues, {
    accountName: alphaPointUserID,
    email: email,
    billingFlatNumber: '',
    salutation: '',
    dob: dob
  });

  var clientInfo = {
    alphaPointSessiontoken: alphaPointSessiontoken,
    alphaPointUserID: alphaPointUserID,
    validationStage: 1,
    validator: type
  };

  var validateUserRegistrationPayload = {
    requestIdentifier: requestIdentifier,
    clientInfo: clientInfo,
    userInfo: userInfo
  };

  var submitInfoIdentityMindPayload = {
    validateUserRegistrationPayload: validateUserRegistrationPayload,
    setUserConfigPayload: setUserConfigPayload
  };

  submitInfoIdentityMind(submitInfoIdentityMindPayload);
  reset();
  onSubmit && onSubmit();
};

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APCheckbox__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportFormComponent_css__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ReportFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('report-form');

var ReportAccountsComponent = function (_React$Component) {
  _inherits(ReportAccountsComponent, _React$Component);

  function ReportAccountsComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReportAccountsComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportAccountsComponent.__proto__ || Object.getPrototypeOf(ReportAccountsComponent)).call.apply(_ref, [this].concat(args))), _this), _this.renderCheckbox = function (account) {
      var id = account.AccountId.toString();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APCheckbox__["a" /* default */], {
        name: id,
        id: id,
        key: id,
        label: account.AccountName,
        customClass: baseClasses()
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReportAccountsComponent, [{
    key: 'render',
    value: function render() {
      var accounts = this.props.accounts;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('checkbox-wrapper') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { className: 'ap--label ' + baseClasses('checkbox-label') },
          this.context.t('Accounts')
        ),
        accounts && accounts.map(this.renderCheckbox)
      );
    }
  }]);

  return ReportAccountsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ReportAccountsComponent.propTypes = {
  accounts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

ReportAccountsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ReportAccountsComponent);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getReportsPayload; });
var getReportsPayload = function getReportsPayload(values, props) {
  var accounts = props.accounts.map(function (a) {
    return a.AccountId;
  });
  var accountIdList = accounts.filter(function (id) {
    return values[id];
  });
  var payload = { accountIdList: accountIdList };

  Object.keys(values).filter(function (prop) {
    return !accounts.includes(prop);
  }).forEach(function (prop) {
    return payload[prop] = values[prop];
  });

  return payload;
};

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WithdrawWorkflowsComponent__ = __webpack_require__(2453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var mapStateToProps = function mapStateToProps(state) {
  return {
    templateType: __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].Withdraw.Template || state.withdraw.templateType,
    loading: state.withdraw.isLoading
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__WithdrawWorkflowsComponent__["a" /* default */]));

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiatSidePaneComponent__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_withdrawActions__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);








var mapStateToProps = function mapStateToProps(state, ownProps) {
  var productSymbol = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(ownProps, 'product.ProductSymbol', null);
  var productConfig = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].Deposit[productSymbol] || {};
  var productId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(ownProps, 'product.ProductId', null);
  var position = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_positionSelectors__["a" /* positionByProductIdSelector */])(productId)(state);
  var _state$withdraw = state.withdraw,
      fee = _state$withdraw.withdrawFee,
      TemplateType = _state$withdraw.template.TemplateType;

  var TicketAmount = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(state, ['withdraw', 'TicketAmount'], null);
  var withdrawDetailsInfo = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].Withdraw.WithdrawDetails;
  var isDepositDisabled = ownProps.isDepositDisabled,
      isWithdrawDisabled = ownProps.isWithdrawDisabled;


  return {
    TicketAmount: TicketAmount,
    position: position,
    fee: fee,
    TemplateType: TemplateType,
    productConfig: productConfig,
    withdrawDetailsInfo: withdrawDetailsInfo,
    isDepositDisabled: isDepositDisabled,
    isWithdrawDisabled: isWithdrawDisabled
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendToAddress: function sendToAddress(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_withdrawActions__["m" /* createWithdrawTicket */])(payload));
    },
    getWithdrawFee: function getWithdrawFee(productId, amount) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_withdrawActions__["p" /* getWithdrawFee */])(productId, amount));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__FiatSidePaneComponent__["a" /* default */]));

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkForLoginParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return checkForVerifyEmailParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkForConfirmWithdrawParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return checkForResetPassParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkForDepositConfirmationParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return emailLinkRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





var checkForLoginParam = function checkForLoginParam() {
  var forceLogIn = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].LandingPage.forceLogIn;

  if (forceLogIn && checkForConfigLinks()) return false;
  if (window.location.href.includes(forceLogIn ? '' : 'login')) return true;
  return false;
};

var checkForConfigLinks = function checkForConfigLinks() {
  var hasLinks = false;
  var checkURL = [__WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].documentationLink, __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].SignupForm.termsAndServicesLink, __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].SignupForm.privacyPolicyLink];
  for (var urlNum = 0; urlNum < checkURL.length; urlNum++) {
    if (checkURL[urlNum] != '/' && window.location.href.includes(checkURL[urlNum])) {
      hasLinks = true;
    }
  }
  return hasLinks;
};

var checkForVerifyEmailParam = function checkForVerifyEmailParam() {
  if (window.location.href.includes('verifyEmail')) return true;
  return false;
};

var checkForConfirmWithdrawParam = function checkForConfirmWithdrawParam() {
  if (window.location.href.includes('confirmWithdraw')) return true;
  return false;
};

var checkForResetPassParam = function checkForResetPassParam() {
  if (window.location.href.includes('resetPass')) return true;
  return false;
};

var checkForDepositConfirmationParam = function checkForDepositConfirmationParam() {
  var href = window.location.href;

  var trustPayRedirect = href.includes('id') && href.includes('resourcePath');

  if (href.includes('txnState') || trustPayRedirect) return true;
  return false;
};

var emailLinkRoutes = function emailLinkRoutes(pathname, HomePage) {
  return (pathname.includes('.html') || pathname === Object(__WEBPACK_IMPORTED_MODULE_2__path__["a" /* default */])('/')) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: pathname, key: pathname, component: HomePage });
};

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_APLogo_APLogo__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StandAloneLayout_css__ = __webpack_require__(2483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StandAloneLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StandAloneLayout_css__);





var layoutClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-layout');

var StandAloneLayout = function StandAloneLayout(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: layoutClasses('wrapper') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_APLogo_APLogo__["a" /* default */], { customClass: layoutClasses('logo'), linkTo: '/' }),
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (StandAloneLayout);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_StandAloneLayout_StandAloneLayout__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginFormContainer__ = __webpack_require__(2487);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__layouts_StandAloneLayout_StandAloneLayout__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LoginFormContainer__["a" /* default */], null)
  );
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_path__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageSubHeaderLayout_css__ = __webpack_require__(2503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageSubHeaderLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PageSubHeaderLayout_css__);
var pageSubHeaderClasses=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('page-sub-header');var NavItems=[{text:'Your Snapshot',path:'/dashboard'},{text:'Market Data',path:'/dashboard/market-data'}];var PageSubHeaderComponent=function PageSubHeaderComponent(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageSubHeaderClasses('')},NavItems.map(function(link){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{exact:true,key:link.path,to:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_path__["a" /* default */])(link.path),className:pageSubHeaderClasses('item'),activeClassName:pageSubHeaderClasses('item','selected')},context.t(link.text));})));};PageSubHeaderComponent.contextTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PageSubHeaderComponent);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageFooterLayout_css__ = __webpack_require__(2506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageFooterLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PageFooterLayout_css__);
var pageFooterClasses=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('page-footer');var PageFooterLayout=function PageFooterLayout(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:pageFooterClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageFooterClasses('footer-left-content')},context.t('{n}™ {y}. All Rights Reserved.',{n:"Coinext",y:new Date().getFullYear()})));};PageFooterLayout.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PageFooterLayout);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APIcon__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APNavMenuVertical_css__ = __webpack_require__(2519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APNavMenuVertical_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__APNavMenuVertical_css__);
var baseClass='nav-menu-vertical';var APNavMenuVertical=function APNavMenuVertical(props,context){var bemClasses=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass,props.customClass);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:bemClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:bemClasses('list')},props.items.filter(function(i){return i.show===undefined||i.show;}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.path,'data-test':item.text},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{onClick:props.handleNavItemClick?props.handleNavItemClick:null,className:bemClasses('item',['hoverable']),to:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])(item.path)},item.icon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APIcon__["a" /* default */],{name:item.icon,customClass:bemClasses('item-icon')}),context.t(item.text)));})));};APNavMenuVertical.propTypes={customClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,handleNavItemClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};APNavMenuVertical.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (APNavMenuVertical);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apex_web_lib_components_BalancesList__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_TransferRequestsNotification__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_RecentActivity__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_Retail_RetailBuySell_EotcBuySell__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_Retail_RetailBuySell__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_WalletCards_WalletCardGridContainer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_components_MarketOverview__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_WalletRows_WalletRowListContainer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apex_web_lib_components_KYC_IMLegacy_KYC_IMLegacyForm__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apex_web_lib_components_WalletDetails_WalletDetailsContainer__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_apex_web_lib_components_RecentActivityWithFilter__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_apex_web_lib_components_Transfers_TransfersContainer__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apex_web_lib_components_BalancesMenu_BalanceMenuContainer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apex_web_lib_components_MarketDataCardsComponent_MarketDataCardsContainer__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apex_web_lib_components_OrderEntryComponents_OrderEntryContainer__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apex_web_lib_components_InstrumentPositions_InstrumentPositionsContainer__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_apex_web_lib_components_RecentTrades_RecentTradesContainer__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_apex_web_lib_components_OrderBookComponents_OrderBookContainer__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_apex_web_lib_components_OrderHistoryComponents__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_apex_web_lib_components_PriceChart_PriceChartContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_apex_web_lib_components_DepthChart_DepthChartContainer__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_apex_web_lib_components_InstrumentRow__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_apex_web_lib_components_Settings_ProfileAndSecurity_ProfileSettingsCard_ProfileForm_ProfileFormContainer__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_apex_web_lib_components_Settings_ProfileAndSecurity_RegionSettingsCard_RegionSettings_RegionSettingsContainer__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_apex_web_lib_components_Settings_ProfileAndSecurity_ThemeSettingsCard_ThemeForm_ThemeSettingsContainer__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_apex_web_lib_components_Settings_ProfileAndSecurity_PasswordSettingsCard_ResetPasswordForm_ResetPasswordFormComponent__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_apex_web_lib_components_EnableTwoFactorAuth_EnableTwoFactorAuthContainerFactory__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_apex_web_lib_components_Settings_ProfileAndSecurity_TwoFactorAuthSettingsCard_EnableTwoFactorAuth_EnableTwoFactorAuthComponent__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_apex_web_lib_components_ApiKeysSidePaneComponents_ApiKeyList_ApiKeyListContainer__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_apex_web_lib_components_Settings_ApiKeys__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_apex_web_lib_components_ActivityReportingComponents__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_apex_web_lib_components_ReportSidePaneComponents_ScheduledReportsTable__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_apex_web_lib_components_ReportSidePaneComponents_DownloadReportForm__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_apex_web_lib_components_LoyaltyToken_LoyaltyTokenContainer__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ComponentsWrappers_AffiliateActiveTagContainerWrapper__ = __webpack_require__(2520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_apex_web_lib_components_AffiliateComponents_AffiliateCountContainer__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_apex_web_lib_components_OrderEntryComponents_AdvancedOrderForm_AdvancedOrderFormContainer__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_apex_web_lib_components_Retail_RetailSidePanes_FiatSidePaneContainer__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_apex_web_lib_components_SendReceiveSidePane_SendReceiveSidePaneContainer__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_apex_web_lib_components_Settings_TradeSettings__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_apex_web_lib_components_MarginToggleButton__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_apex_web_lib_components_MarginBalances_MarginBalancesFooter__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_apex_web_lib_components_MarginBalances_MarginInstrumentBalancesTable__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_apex_web_lib_components_MarginBalances_MarginInstrumentPosition__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_apex_web_lib_components_MarginBalances_MarginInstrumentPositions__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_apex_web_lib_components_MarginBalances_MarginInstrumentSelectorTable__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_apex_web_lib_components_MarginBalances_MarginOverview__ = __webpack_require__(781);
/* harmony default export */ __webpack_exports__["a"] = ([{text:'Instrument Row',path:'/component/instrument-row',component:__WEBPACK_IMPORTED_MODULE_22_apex_web_lib_components_InstrumentRow__["a" /* default */]},{text:'Depth Chart',path:'/component/depth-chart',component:__WEBPACK_IMPORTED_MODULE_21_apex_web_lib_components_DepthChart_DepthChartContainer__["a" /* default */]},{text:'Price Chart',path:'/component/price-chart',component:__WEBPACK_IMPORTED_MODULE_20_apex_web_lib_components_PriceChart_PriceChartContainer__["a" /* default */]},{text:'Order History',path:'/component/order-history',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_apex_web_lib_components_OrderHistoryComponents__["default"],{config:{usePagination:true,maxLines:6,filterMode:'selectedInstrument'}});}},{text:'Order Book',path:'/component/order-book',component:__WEBPACK_IMPORTED_MODULE_18_apex_web_lib_components_OrderBookComponents_OrderBookContainer__["a" /* default */]},{text:'Order Entry',path:'/component/order-entry',component:__WEBPACK_IMPORTED_MODULE_15_apex_web_lib_components_OrderEntryComponents_OrderEntryContainer__["a" /* default */]},{text:'Order Entry - Advanced',path:'/component/order-entry-advanced',component:__WEBPACK_IMPORTED_MODULE_37_apex_web_lib_components_OrderEntryComponents_AdvancedOrderForm_AdvancedOrderFormContainer__["a" /* default */]},{text:'Instrument Position',path:'/component/instrument-position',component:__WEBPACK_IMPORTED_MODULE_16_apex_web_lib_components_InstrumentPositions_InstrumentPositionsContainer__["a" /* default */]},{text:'Recent Trades',path:'/component/recent-trades',component:__WEBPACK_IMPORTED_MODULE_17_apex_web_lib_components_RecentTrades_RecentTradesContainer__["a" /* default */]},{text:'Balance List Summary',path:'/component/balance-list-summary',component:__WEBPACK_IMPORTED_MODULE_1_apex_web_lib_components_BalancesList__["a" /* default */]},{text:'Transfer Notifications',path:'/component/transfer-notifications',component:__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_TransferRequestsNotification__["default"]},{text:'Market Overview Chart',path:'/component/market-overview-chart',component:__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_components_MarketOverview__["a" /* default */]},{text:'Recent Activity',path:'/component/recent-activity',component:__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_RecentActivity__["default"]},{text:'Market Data Cards',path:'/component/market-data-cards',component:__WEBPACK_IMPORTED_MODULE_14_apex_web_lib_components_MarketDataCardsComponent_MarketDataCardsContainer__["default"]},{text:'eOTC Buy/Sell',path:'/component/eotc-buy-sell',component:__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_Retail_RetailBuySell_EotcBuySell__["a" /* default */]},{text:'Buy/Sell Balances',path:'/component/buy-sell-balances',component:__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_Retail_RetailBuySell__["a" /* BuySellBalancesContainer */]},{text:'Wallet Card Grid',path:'/component/wallet-card-grid',component:__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_WalletCards_WalletCardGridContainer__["default"]},{text:'Wallet Row List',path:'/component/wallet-row-list',component:__WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_WalletRows_WalletRowListContainer__["default"]},{text:'KYC Form - IM Legacy',path:'/component/kyc-identity-mind-legacy',component:__WEBPACK_IMPORTED_MODULE_9_apex_web_lib_components_KYC_IMLegacy_KYC_IMLegacyForm__["a" /* default */]},{text:'Profile',path:'/component/profile',component:__WEBPACK_IMPORTED_MODULE_23_apex_web_lib_components_Settings_ProfileAndSecurity_ProfileSettingsCard_ProfileForm_ProfileFormContainer__["a" /* default */]},{text:'Region',path:'/component/region',component:__WEBPACK_IMPORTED_MODULE_24_apex_web_lib_components_Settings_ProfileAndSecurity_RegionSettingsCard_RegionSettings_RegionSettingsContainer__["a" /* default */]},{text:'Theme',path:'/component/theme',component:__WEBPACK_IMPORTED_MODULE_25_apex_web_lib_components_Settings_ProfileAndSecurity_ThemeSettingsCard_ThemeForm_ThemeSettingsContainer__["a" /* default */]},{text:'Password',path:'/component/password',component:__WEBPACK_IMPORTED_MODULE_26_apex_web_lib_components_Settings_ProfileAndSecurity_PasswordSettingsCard_ResetPasswordForm_ResetPasswordFormComponent__["a" /* default */]},{text:'Two Factor Auth',path:'/component/two-factor-auth',component:function component(){var EnableTwoFactorAuthContainer=Object(__WEBPACK_IMPORTED_MODULE_27_apex_web_lib_components_EnableTwoFactorAuth_EnableTwoFactorAuthContainerFactory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_28_apex_web_lib_components_Settings_ProfileAndSecurity_TwoFactorAuthSettingsCard_EnableTwoFactorAuth_EnableTwoFactorAuthComponent__["a" /* default */]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EnableTwoFactorAuthContainer,null);}},{text:'Api Key List',path:'/component/api-key-list',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_apex_web_lib_components_ApiKeysSidePaneComponents_ApiKeyList_ApiKeyListContainer__["a" /* default */],{customClass:'retail-api-key-list'});}},{text:'Create Api Key',path:'/component/create-api-key',component:__WEBPACK_IMPORTED_MODULE_30_apex_web_lib_components_Settings_ApiKeys__["a" /* default */]},{text:'Activity Reporting Buttons',path:'/component/activity-reporting-buttons',component:__WEBPACK_IMPORTED_MODULE_31_apex_web_lib_components_ActivityReportingComponents__["a" /* default */]},{text:'Scheduled Reports Table',path:'/component/scheduled-reports-table',component:__WEBPACK_IMPORTED_MODULE_32_apex_web_lib_components_ReportSidePaneComponents_ScheduledReportsTable__["a" /* default */]},{text:'Download Report',path:'/component/download-report',component:__WEBPACK_IMPORTED_MODULE_33_apex_web_lib_components_ReportSidePaneComponents_DownloadReportForm__["a" /* default */]},{text:'Loyalty Token',path:'/component/loyalty-token',component:__WEBPACK_IMPORTED_MODULE_34_apex_web_lib_components_LoyaltyToken_LoyaltyTokenContainer__["a" /* default */]},{text:'Affiliate Active Tag',path:'/component/affiliate-active-tag',component:__WEBPACK_IMPORTED_MODULE_35__ComponentsWrappers_AffiliateActiveTagContainerWrapper__["a" /* default */]},{text:'Affiliate Count',path:'/component/affiliate-count',component:__WEBPACK_IMPORTED_MODULE_36_apex_web_lib_components_AffiliateComponents_AffiliateCountContainer__["a" /* default */]},{text:'Wallet Details',path:'/component/wallet-details',component:__WEBPACK_IMPORTED_MODULE_10_apex_web_lib_components_WalletDetails_WalletDetailsContainer__["a" /* default */]},{text:'Wallet Details Activity',path:'/component/wallet-details-activity',component:__WEBPACK_IMPORTED_MODULE_11_apex_web_lib_components_RecentActivityWithFilter__["default"]},{text:'Wallet Details Transfers',path:'/component/wallet-details-transfers',component:__WEBPACK_IMPORTED_MODULE_12_apex_web_lib_components_Transfers_TransfersContainer__["a" /* default */]},{text:'Wallet Details Menu',path:'/component/wallet-details-menu',component:__WEBPACK_IMPORTED_MODULE_13_apex_web_lib_components_BalancesMenu_BalanceMenuContainer__["default"]},{text:'Retail Fiat SidePane',path:'/component/retail-fiat-sidepane',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38_apex_web_lib_components_Retail_RetailSidePanes_FiatSidePaneContainer__["a" /* default */],{product:{ProductId:1,ProductSymbol:'USD',ProductFullName:'US Dollar',iconFileName:'usd-48px.svg'}});}},{text:'Send Receive Sidepane',path:'/component/send-receive-sidepane',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39_apex_web_lib_components_SendReceiveSidePane_SendReceiveSidePaneContainer__["a" /* default */],{product:{ProductId:2,ProductSymbol:'BTC',ProductFullName:'Bitcoin',iconFileName:'btc-48px.svg'}});}},{text:'Trade Settings',path:'/component/trade-settings',component:__WEBPACK_IMPORTED_MODULE_40_apex_web_lib_components_Settings_TradeSettings__["default"]},{text:'Margin Toggle Button',path:'/component/margin-toggle-button',component:__WEBPACK_IMPORTED_MODULE_41_apex_web_lib_components_MarginToggleButton__["a" /* default */]},{text:'Margin Balances Footer',path:'/component/margin-balances-footer',component:__WEBPACK_IMPORTED_MODULE_42_apex_web_lib_components_MarginBalances_MarginBalancesFooter__["a" /* default */]},{text:'Margin Instrument Balances Table',path:'/component/margin-instrument-balances-table',component:__WEBPACK_IMPORTED_MODULE_43_apex_web_lib_components_MarginBalances_MarginInstrumentBalancesTable__["a" /* default */]},{text:'Margin Instrument Position',path:'/component/margin-instrument-position',component:__WEBPACK_IMPORTED_MODULE_44_apex_web_lib_components_MarginBalances_MarginInstrumentPosition__["a" /* default */]},{text:'Margin Instrument Positions',path:'/component/margin-instrument-positions',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45_apex_web_lib_components_MarginBalances_MarginInstrumentPositions__["a" /* default */],{showTitle:false});}},{text:'Margin Instrument Selector Table',path:'/component/margin-instrument-selector-table',component:__WEBPACK_IMPORTED_MODULE_46_apex_web_lib_components_MarginBalances_MarginInstrumentSelectorTable__["a" /* default */]},{text:'Margin Overview',path:'/component/margin-overview',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47_apex_web_lib_components_MarginBalances_MarginOverview__["a" /* default */],{showTitle:false});}}]);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedTotalTokens; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_digitalAssetsSelectors__ = __webpack_require__(428);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






var TotalTokensCount = function TotalTokensCount(props) {
  var InstrumentId = props.InstrumentId,
      ProductId = props.ProductId,
      getL2 = props.getL2;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState2 = _slicedToArray(_useState, 2),
      totalTokens = _useState2[0],
      setTotalTokens = _useState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (InstrumentId && ProductId) {
      getL2(InstrumentId).then(function (data) {
        setTotalTokens(data.reduce(function (acc, curr) {
          if (curr[9] === 1) {
            return acc + curr[8];
          }
          return acc;
        }, 0));
      });
    }
  }, [InstrumentId, ProductId]);
  return totalTokens;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getL2: function getL2(InstrumentId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_apiActions__["b" /* callAPI */])('GetL2Snapshot', {
        OMSId: 1,
        Depth: 250,
        InstrumentId: InstrumentId
      })).then(function (res) {
        if (!res) return [];
        return res;
      });
    }
  };
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var InstrumentId = void 0;
  if (ownProps.InstrumentId) {
    InstrumentId = ownProps.InstrumentId;
  } else {
    InstrumentId = (Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_digitalAssetsSelectors__["c" /* selectedDigitalAssetInstrumentSelector */])(state, {
      ProductId: ownProps.ProductId
    }) || {}).InstrumentId;
  }
  return Object.assign({
    InstrumentId: InstrumentId
  }, ownProps);
};

var ConnectedTotalTokens = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(TotalTokensCount);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Amount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DateTime; });
/* unused harmony export OrderType */
/* unused harmony export Quantity */
/* unused harmony export DepositWithdrawQuantity */
/* unused harmony export Price */
/* unused harmony export CancelAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_CancelAPButton__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_dateHelper__ = __webpack_require__(29);










var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var Action = function Action(props, context) {
  var _props$value = props.value,
      typeIcon = _props$value.typeIcon,
      primaryText = _props$value.primaryText,
      secondaryText = _props$value.secondaryText,
      params = _props$value.params;
  var showProductIcon = props.showProductIcon,
      themeModifier = props.themeModifier;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('action') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIcon__["a" /* default */], { name: typeIcon, customClass: baseClasses('type-icon') }),
    showProductIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__["a" /* default */], {
      customClass: baseClasses('product-icon', themeModifier),
      iconFileName: props.value.productIcon.iconFileName,
      size: 36
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('action-column') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('action-text', 'primary') },
        context.t(primaryText, params)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('action-text', 'secondary') },
        context.t(secondaryText, params)
      )
    )
  );
};

var Amount = function Amount(props) {
  var _props$value2 = props.value,
      Quantity = _props$value2.Quantity,
      Value = _props$value2.Value,
      Product1Symbol = _props$value2.Product1Symbol,
      Product2Symbol = _props$value2.Product2Symbol;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('amount') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('amount-quantity') },
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Quantity, Product1Symbol) + ' ' + Product1Symbol
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('amount-value') },
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Value, Product2Symbol) + ' ' + Product2Symbol
    )
  );
};

var Status = function Status(props, context) {
  var _props$value3 = props.value,
      status = _props$value3.status,
      id = _props$value3.id;
  var customClass = props.customClass;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: customClass + ' ' + baseClasses('status') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('status-id') },
      id
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('status-text') },
      context.t(status)
    )
  );
};

var DateTime = function DateTime(props) {
  var raw = props.value.raw;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('date') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('date-date') },
      Object(__WEBPACK_IMPORTED_MODULE_7__helpers_dateHelper__["b" /* formatDate */])(raw)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('date-time') },
      Object(__WEBPACK_IMPORTED_MODULE_7__helpers_dateHelper__["d" /* formatTime */])(raw)
    )
  );
};

var OrderType = function OrderType(props, context) {
  var orderType = props.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('order-type') },
    context.t(orderType)
  );
};

var Quantity = function Quantity(props) {
  var _props$value4 = props.value,
      OrigQuantity = _props$value4.OrigQuantity,
      Product1Symbol = _props$value4.Product1Symbol;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('quantity') },
    Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(OrigQuantity, OrigQuantity.symbol),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('quantity-text') },
      Product1Symbol
    )
  );
};

var DepositWithdrawQuantity = function DepositWithdrawQuantity(props) {
  return Quantity({
    value: {
      OrigQuantity: props.value.Quantity,
      Product1Symbol: props.value.Product1Symbol
    }
  });
};

var Price = function Price(props) {
  var _props$value5 = props.value,
      Price = _props$value5.Price,
      Product2Symbol = _props$value5.Product2Symbol;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('price') },
    Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Price, Price.symbol),
    ' ',
    Product2Symbol
  );
};

var CancelAction = function CancelAction(props, context) {
  var orderId = props.value;
  var cancelOrders = props.action;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_CancelAPButton__["a" /* default */], {
    text: context.t('Cancel Order'),
    customClass: baseClasses(),
    onClick: function onClick() {
      cancelOrders([orderId]);
    }
  });
};

Action.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

Status.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

Status.defaultProps = {
  customClass: ''
};

OrderType.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

CancelAction.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileSettingsCardComponent__ = __webpack_require__(2164);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ProfileSettingsCardComponent__["a" /* default */]);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegionSettingsCardComponent__ = __webpack_require__(2171);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RegionSettingsCardComponent__["a" /* default */]);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeSettingsCardComponent__ = __webpack_require__(2180);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ThemeSettingsCardComponent__["a" /* default */]);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PasswordSettingsCardComponent__ = __webpack_require__(2187);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PasswordSettingsCardComponent__["a" /* default */]);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TwoFactorAuthSettingsCardComponent__ = __webpack_require__(2191);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TwoFactorAuthSettingsCardComponent__["a" /* default */]);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferHistoryContainer__ = __webpack_require__(2239);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TransferHistoryContainer__["a" /* default */]);

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(858);
module.exports = __webpack_require__(863);


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(859).enable();
  window.Promise = __webpack_require__(861);
}

// fetch() polyfill for making API calls.
__webpack_require__(862);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(211);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(442);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(442);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 862 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_i18n__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_history__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_helpers_apexWebActions__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__registerServiceWorker__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_css_vars_ponyfill__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_base_Fonts_css__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_base_Fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_base_Fonts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_base_Base_css__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_base_Base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_base_Base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_theme_variables_css__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_theme_variables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_theme_variables_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_components_common_Divider_css__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_components_common_Divider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_components_common_Divider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_layout_Table_css__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_layout_Table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_layout_Table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_layout_app_css__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_layout_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_layout_app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_components_common_index_css__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_components_common_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_components_common_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__redux_store__ = __webpack_require__(2562);
/* eslint-disable import/first */new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 142)).then(function(config){return __webpack_require__(1191)("./"+config.default.global.theme+'.css');});Object(__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_helpers_apexWebActions__["a" /* default */])();__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_helpers_numberFormatter__["f" /* init */]({locale:__WEBPACK_IMPORTED_MODULE_9__config__["default"].global.locale,getDecimalPlaces:function getDecimalPlaces(){return __WEBPACK_IMPORTED_MODULE_19__redux_store__["a" /* default */].getState().product.decimalPlaces;}});window.cssVariables={};Object(__WEBPACK_IMPORTED_MODULE_10_css_vars_ponyfill__["a" /* default */])({watch:true,silent:true,onComplete:function onComplete(cssText,styleNode,cssVariables){window.cssVariables=cssVariables;}});__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_19__redux_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_5__helpers_history__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_i18n___default.a,{translations:window.APEXTranslations||{en:{}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__App__["a" /* default */],null)))),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_8__registerServiceWorker__["a" /* unregister */])();

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(211),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(211),r=__webpack_require__(866);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(867);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(292);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(870);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(161);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(888);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(451);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(213);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(881);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(62), __webpack_require__(162)(module)))

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(449);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(450);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(451);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(452);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(889);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(292);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(215);





var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

function getUniqueId() {
  var key = '__global_unique_id__';
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + getUniqueId() + '__';

  var Provider = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_Component2) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(62)))

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(894)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(161);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key]}}}return target};exports.i18nState=i18nState;var reduxI18nState={lang:'en',newFallbackLang:null,translations:{},forceRefresh:false};function i18nState(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:reduxI18nState;var action=arguments[1];switch(action.type){case'REDUX_I18N_SET_LANGUAGE':return _extends({},state,{lang:action.lang});case'REDUX_I18N_SET_FALLBACK_LANGUAGE':return _extends({},state,{newFallbackLang:action.newFallbackLang});case'REDUX_I18N_SET_TRANSLATIONS':return _extends({},state,{translations:action.translations});case'REDUX_I18N_SET_FORCE_REFRESH':return _extends({},state,{forceRefresh:action.force});default:return state;}}

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});var _reactRedux=__webpack_require__(3);var _component=__webpack_require__(898);var _component2=_interopRequireDefault(_component);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}exports.default=(0,_reactRedux.connect)(function(state){return{lang:state.i18nState.lang,newFallbackLang:state.i18nState.newFallbackLang,translations_reducer:state.i18nState.translations,forceRefresh:state.i18nState.forceRefresh}})(_component2.default);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if('value'in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(1);var _reactDeepForceUpdate=__webpack_require__(899);var _reactDeepForceUpdate2=_interopRequireDefault(_reactDeepForceUpdate);var _actions=__webpack_require__(453);var _getTranslateFunction=__webpack_require__(454);var _getTranslateFunction2=_interopRequireDefault(_getTranslateFunction);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call==='object'||typeof call==='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!=='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}var I18n=function(_React$Component){_inherits(I18n,_React$Component);function I18n(){_classCallCheck(this,I18n);return _possibleConstructorReturn(this,(I18n.__proto__||Object.getPrototypeOf(I18n)).apply(this,arguments))}_createClass(I18n,[{key:'getChildContext',value:function getChildContext(){var _props=this.props,lang=_props.lang,fallbackLang=_props.fallbackLang,useReducer=_props.useReducer,translations_reducer=_props.translations_reducer,translations=_props.translations,newFallbackLang=_props.newFallbackLang;return{t:(0,_getTranslateFunction2.default)(useReducer?translations_reducer:translations,lang,newFallbackLang?newFallbackLang:fallbackLang)}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(this.props.forceRefresh&&!nextProps.forceRefresh){return false}return true}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.lang!==this.props.lang||!prevProps.forceRefresh&&this.props.forceRefresh){(0,_reactDeepForceUpdate2.default)(this);if(this.props.forceRefresh){this.props.dispatch((0,_actions.setForceRefresh)(false))}}}},{key:'UNSAFE_componentWillMount',value:function UNSAFE_componentWillMount(){if(!this.props.initialized){this.props.dispatch((0,_actions.setLanguage)(this.props.initialLang))}}},{key:'render',value:function render(){return this.props.children}}]);return I18n}(_react2.default.Component);I18n.childContextTypes={t:_propTypes.PropTypes.func.isRequired};I18n.propTypes={translations:_propTypes.PropTypes.object.isRequired,useReducer:_propTypes.PropTypes.bool,initialLang:_propTypes.PropTypes.string,fallbackLang:_propTypes.PropTypes.string,initialized:_propTypes.PropTypes.bool};I18n.defaultProps={useReducer:false,initialLang:'en',fallbackLang:null};exports.default=I18n;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deepForceUpdate;
function traverseRenderedChildren(internalInstance, callback, argument) {
  callback(internalInstance, argument);

  if (internalInstance._renderedComponent) {
    traverseRenderedChildren(internalInstance._renderedComponent, callback, argument);
  } else {
    for (var key in internalInstance._renderedChildren) {
      if (internalInstance._renderedChildren.hasOwnProperty(key)) {
        traverseRenderedChildren(internalInstance._renderedChildren[key], callback, argument);
      }
    }
  }
}

function setPendingForceUpdate(internalInstance, shouldUpdate) {
  if (internalInstance._pendingForceUpdate === false && shouldUpdate(internalInstance)) {
    internalInstance._pendingForceUpdate = true;
  }
}

function forceUpdateIfPending(internalInstance, onUpdate) {
  if (internalInstance._pendingForceUpdate === true) {
    var publicInstance = internalInstance._instance;
    var updater = publicInstance.updater;


    if (typeof publicInstance.forceUpdate === 'function') {
      publicInstance.forceUpdate();
    } else if (updater && typeof updater.enqueueForceUpdate === 'function') {
      updater.enqueueForceUpdate(publicInstance);
    }
    onUpdate(internalInstance);
  }
}

function deepForceUpdateStack(instance, shouldUpdate, onUpdate) {
  var internalInstance = instance._reactInternalInstance;
  traverseRenderedChildren(internalInstance, setPendingForceUpdate, shouldUpdate);
  traverseRenderedChildren(internalInstance, forceUpdateIfPending, onUpdate);
}

function deepForceUpdate(instance) {
  // TODO: this is temporarily disabled because it's not in 2.x release line.
  // See https://github.com/gaearon/react-deep-force-update/issues/8
  var shouldUpdate = function shouldUpdate() {
    return true;
  };
  var onUpdate = function onUpdate() {};

  var root = instance._reactInternalFiber || instance._reactInternalInstance;
  if (typeof root.tag !== 'number') {
    // Traverse stack-based React tree.
    return deepForceUpdateStack(instance, shouldUpdate, onUpdate);
  }

  var node = root;
  while (true) {
    if (node.stateNode !== null && typeof node.type === 'function' && shouldUpdate(node)) {
      var publicInstance = node.stateNode;
      var updater = publicInstance.updater;

      if (typeof publicInstance.forceUpdate === 'function') {
        publicInstance.forceUpdate();
      } else if (updater && typeof updater.enqueueForceUpdate === 'function') {
        updater.enqueueForceUpdate(publicInstance);
      }
      onUpdate(node);
    }
    if (node.child) {
      node.child.return = node;
      node = node.child;
      continue;
    }
    if (node === root) {
      return undefined;
    }
    while (!node.sibling) {
      if (!node.return || node.return === root) {
        return undefined;
      }
      node = node.return;
    }
    node.sibling.return = node.return;
    node = node.sibling;
  }
}
module.exports = exports['default'];

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key]}}}return target};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if('value'in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();exports.default=localize;var _react=__webpack_require__(0);var _propTypes=__webpack_require__(1);var _propTypes2=_interopRequireDefault(_propTypes);var _hoistNonReactStatics=__webpack_require__(455);var _hoistNonReactStatics2=_interopRequireDefault(_hoistNonReactStatics);var _invariant=__webpack_require__(114);var _invariant2=_interopRequireDefault(_invariant);var _reactIs=__webpack_require__(161);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true})}else{obj[key]=value}return obj}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call==='object'||typeof call==='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!=='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function localize(){var propName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'t';return function wrapWithLocalized(WrappedComponent){(0,_invariant2.default)((0,_reactIs.isValidElementType)(WrappedComponent),'You must pass a component to the function returned by localize.\n      Instead received '+JSON.stringify(WrappedComponent));var Localized=function(_Component){_inherits(Localized,_Component);function Localized(){_classCallCheck(this,Localized);return _possibleConstructorReturn(this,(Localized.__proto__||Object.getPrototypeOf(Localized)).apply(this,arguments))}_createClass(Localized,[{key:'render',value:function render(){var t=this.context.t;return(0,_react.createElement)(WrappedComponent,_extends({},this.props,_defineProperty({},propName,t)))}}]);return Localized}(_react.Component);Localized.contextTypes={t:_propTypes2.default.func.isRequired};return(0,_hoistNonReactStatics2.default)(Localized,WrappedComponent)}}

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(214);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])());

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * locales : 2.0.6
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(456)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('./numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    
(function() {
        numeral.register('locale', 'bg', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: { // I found these here http://www.unicode.org/cldr/charts/28/verify/numbers/bg.html
            thousand: 'хил',
            million: 'млн',
            billion: 'млрд',
            trillion: 'трлн'
        },
        ordinal: function (number) {
            // google translate suggests:
            // 1st=1-ви; 2nd=2-ри; 7th=7-ми;
            // 8th=8-ми and many others end with -ти
            // for example 3rd=3-ти
            // However since I've seen suggestions that in
            // Bulgarian the ordinal can be taken in
            // different forms (masculine, feminine, neuter)
            // I've opted to wimp out on commiting that to code
            return '';
        },
        currency: {
            symbol: 'лв'
        }
    });
})();


(function() {
    
    numeral.register('locale', 'chs', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十亿',
            trillion: '兆'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '¥'
        }
    });
})();


(function() {
        numeral.register('locale', 'cs', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'Kč'
        }
    });
})();


(function() {
        numeral.register('locale', 'da-dk', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mio',
            billion: 'mia',
            trillion: 'b'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'DKK'
        }
    });
})();


(function() {
        numeral.register('locale', 'de-ch', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'CHF'
        }
    });
})();


(function() {
        numeral.register('locale', 'de', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'en-au', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
})();


(function() {
        numeral.register('locale', 'en-gb', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '£'
        }
    });
})();


(function() {
        numeral.register('locale', 'en-za', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                    (b === 2) ? 'nd' :
                        (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: 'R'
        }
    });
})();


(function() {
        numeral.register('locale', 'es-es', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'es', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                (b === 7 || b === 0) ? 'mo' :
		(b === 8) ? 'vo' :
		(b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$'
        }
    });
})();


(function() {
        numeral.register('locale', 'et', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tuh',
            million: ' mln',
            billion: ' mld',
            trillion: ' trl'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'fi', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'fr-ca', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: '$'
        }
    });
})();


(function() {
        numeral.register('locale', 'fr-ch', {
        delimiters: {
            thousands: '\'',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: 'CHF'
        }
    });
})();


(function() {
        numeral.register('locale', 'fr', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'hu', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'E',  // ezer
            million: 'M',   // millió
            billion: 'Mrd', // milliárd
            trillion: 'T'   // trillió
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: ' Ft'
        }
    });
})();


(function() {
        numeral.register('locale', 'it', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mila',
            million: 'mil',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'ja', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十億',
            trillion: '兆'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '¥'
        }
    });
})();


(function() {
        numeral.register('locale', 'lv', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tūkst.',
            million: ' milj.',
            billion: ' mljrd.',
            trillion: ' trilj.'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'nl-be', {
        delimiters: {
            thousands: ' ',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : ' mln',
            billion  : ' mld',
            trillion : ' bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;

            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€ '
        }
    });
})();


(function() {
        numeral.register('locale', 'nl-nl', {
        delimiters: {
            thousands: '.',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : 'mln',
            billion  : 'mrd',
            trillion : 'bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;
            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€ '
        }
    });
})();


(function() {
        numeral.register('locale', 'no', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'kr'
        }
    });
})();


(function() {
        numeral.register('locale', 'pl', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tys.',
            million: 'mln',
            billion: 'mld',
            trillion: 'bln'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'PLN'
        }
    });
})();


(function() {
        numeral.register('locale', 'pt-br', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mil',
            million: 'milhões',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: 'R$'
        }
    });
})();


(function() {
        numeral.register('locale', 'pt-pt', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'ru-ua', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: '\u20B4'
        }
    });
})();


(function() {
        numeral.register('locale', 'ru', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн.',
            billion: 'млрд.',
            trillion: 'трлн.'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: 'руб.'
        }
    });
})();


(function() {
        numeral.register('locale', 'sk', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'sl', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mio',
            billion: 'mrd',
            trillion: 'trilijon'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
    

    numeral.register('locale', 'th', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'พัน',
            million: 'ล้าน',
            billion: 'พันล้าน',
            trillion: 'ล้านล้าน'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '฿'
        }
    });
})();


(function() {
        var suffixes = {
            1: '\'inci',
            5: '\'inci',
            8: '\'inci',
            70: '\'inci',
            80: '\'inci',

            2: '\'nci',
            7: '\'nci',
            20: '\'nci',
            50: '\'nci',

            3: '\'üncü',
            4: '\'üncü',
            100: '\'üncü',

            6: '\'ncı',

            9: '\'uncu',
            10: '\'uncu',
            30: '\'uncu',

            60: '\'ıncı',
            90: '\'ıncı'
        };

    numeral.register('locale', 'tr', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'bin',
            million: 'milyon',
            billion: 'milyar',
            trillion: 'trilyon'
        },
        ordinal: function (number) {
            if (number === 0) {  // special case for zero
                return '\'ıncı';
            }

            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;

          return suffixes[a] || suffixes[b] || suffixes[c];
        },
        currency: {
            symbol: '\u20BA'
        }
    });
})();


(function() {
        numeral.register('locale', 'uk-ua', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тис.',
            million: 'млн',
            billion: 'млрд',
            trillion: 'блн'
        },
        ordinal: function () {
            // not ideal, but since in Ukrainian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '';
        },
        currency: {
            symbol: '\u20B4'
        }
    });
})();


(function() {
    
    numeral.register('locale', 'vi', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: ' nghìn',
            million: ' triệu',
            billion: ' tỷ',
            trillion: ' nghìn tỷ'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '₫'
        }
    });
})();


}));


/***/ }),
/* 903 */
/***/ (function(module, exports) {

(function() {
  var options, parseDecimalNumber, patterns;

  patterns = [];

  options = {};

  module.exports = parseDecimalNumber = function(value, inOptions, enforceGroupSize) {
    var decimal, fractionPart, groupMinSize, integerPart, number, pattern, patternIndex, result, thousands;
    if (enforceGroupSize == null) {
      enforceGroupSize = true;
    }
    if (typeof inOptions === 'string') {
      if (inOptions.length !== 2) {
        throw {
          name: 'ArgumentException',
          message: 'The format for string options is \'<thousands><decimal>\' (exactly two characters)'
        };
      }
      thousands = inOptions[0], decimal = inOptions[1];
    } else if (Array.isArray(inOptions)) {
      if (inOptions.length !== 2) {
        throw {
          name: 'ArgumentException',
          message: 'The format for array options is [\'<thousands>\',\'[<decimal>\'] (exactly two elements)'
        };
      }
      thousands = inOptions[0], decimal = inOptions[1];
    } else {
      thousands = (inOptions != null ? inOptions.thousands : void 0) || (inOptions != null ? inOptions.group : void 0) || options.thousands;
      decimal = (inOptions != null ? inOptions.decimal : void 0) || options.decimal;
    }
    patternIndex = "" + thousands + decimal + enforceGroupSize;
    pattern = patterns[patternIndex];
    if (pattern == null) {
      groupMinSize = enforceGroupSize ? 3 : 1;
      pattern = patterns[patternIndex] = new RegExp("^\\s*([+\-]?(?:(?:\\d{1,3}(?:\\" + thousands + "\\d{" + groupMinSize + ",3})+)|\\d*))(?:\\" + decimal + "(\\d*))?\\s*$");
    }
    result = value.match(pattern);
    if (!((result != null) && result.length === 3)) {
      return 0/0;
    }
    integerPart = result[1].replace(new RegExp("\\" + thousands, 'g'), '');
    fractionPart = result[2];
    number = parseFloat(integerPart + "." + fractionPart);
    return number;
  };

  module.exports.setOptions = function(newOptions) {
    var key, value;
    for (key in newOptions) {
      value = newOptions[key];
      options[key] = value;
    }
  };

  module.exports.factoryReset = function() {
    options = {
      thousands: ',',
      decimal: '.'
    };
  };

  module.exports.withOptions = function(options, enforceGroupSize) {
    if (enforceGroupSize == null) {
      enforceGroupSize = true;
    }
    return function(value) {
      return parseDecimalNumber(value, options, enforceGroupSize);
    };
  };

  module.exports.factoryReset();

}).call(this);


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAPEXWebActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_store__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_signupActions__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_authActions__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_resetPasswordActions__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_sidePaneActions__ = __webpack_require__(23);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var APEXWebActions = function APEXWebActions() {
  _classCallCheck(this, APEXWebActions);

  this.login = function (payload) {
    return __WEBPACK_IMPORTED_MODULE_0__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_authActions__["i" /* login */])(payload));
  };

  this.resetPassword = function (payload) {
    return __WEBPACK_IMPORTED_MODULE_0__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_resetPasswordActions__["f" /* fetchResetPassword */])(payload));
  };

  this.sendResetPasswordEmail = function (UserName) {
    return __WEBPACK_IMPORTED_MODULE_0__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__["q" /* sendResetPasswordEmail */])(UserName));
  };

  this.signup = function (payload) {
    return __WEBPACK_IMPORTED_MODULE_0__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_signupActions__["f" /* signup */])(payload));
  };

  this.setUserConfig = function (UserId, UserName, Config) {
    var getUserConfigAfterSetUserConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return __WEBPACK_IMPORTED_MODULE_0__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__["r" /* setUserConfig */])(UserId, UserName, Config, getUserConfigAfterSetUserConfig));
  };

  this.closeKYCSidePane = function () {
    return __WEBPACK_IMPORTED_MODULE_0__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_sidePaneActions__["f" /* closeKYCSidePane */])());
  };

  window.APEXWebActions = this;
};

function initAPEXWebActions() {
  new APEXWebActions();
}

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Form);
/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);




var FormName = function FormName(_ref, _ref2) {
  var children = _ref.children;
  var _reduxForm = _ref2._reduxForm;
  return children({ form: _reduxForm && _reduxForm.form });
};
FormName.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormName);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormSection);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formPropTypes */
/* unused harmony export fieldInputPropTypes */
/* unused harmony export fieldMetaPropTypes */
/* unused harmony export fieldArrayMetaPropTypes */
/* unused harmony export fieldArrayFieldsPropTypes */
/* unused harmony export fieldPropTypes */
/* unused harmony export fieldArrayPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  clearFields: func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (formPropTypes);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedField__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__structure_plain__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    immutableProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Field);
  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(466);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            immutableProps = _props.immutableProps,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop', 'immutableProps']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(465);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(216);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(918);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(296);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(298);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(929);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(218);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(470);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(924);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(74);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(218);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(218);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(218);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(220);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(220);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(220);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(220);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(221);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(221);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(221);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(221);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(217);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(216);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(225);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(219);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(296);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(951);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(956);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(958);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(300);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(64);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(963);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(115);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(446);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(162)(module)))

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(448);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(74);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(74);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(74);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(74);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(216);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFields__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_prefixName__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      var error = validateNameProp(props.names);
      if (error) {
        throw error;
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Fields);
  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(464);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_React$Component) {
    _inherits(ConnectedFields, _React$Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = this.saveRef;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(FieldArray);
  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(19);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_React$Component) {
    _inherits(ConnectedFieldArray, _React$Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(300);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(994);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(482);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(222);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(300);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(166);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(483);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(993);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(166);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(166);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(483);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      splice: arraySplice,
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(164);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__["a" /* default */])(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])(_this2._valuesMap, function (path) {
                return getIn(values, Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(_this2.context, path));
              });
            };
            this.Component = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);

              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(222);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(225);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsAsyncValidating);

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(485);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return !isPristine.apply(undefined, [state].concat(_toConsumableArray(fields)));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(306);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__asyncValidation__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generateValidator__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handleSubmit__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_isValid__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__structure_plain__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__ = __webpack_require__(1067);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_6_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _this.saveRef = function (ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldErrorOverridden = shouldError !== __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */];

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldWarnOverridden = shouldWarn !== __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */];

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                immutableProps = _props9.immutableProps,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                keepValues = _props9.keepValues,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'immutableProps', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'keepValues', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              ;propsToPass.ref = this.saveRef;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
        immutableProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
        initialValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(ReduxForm);
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(1053);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(487);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(1048);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(74);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(162)(module)))

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(1044);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(474);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(226);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(96);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(488);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(227);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(165);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(1052);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(1061);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(1057);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(1056);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(1060);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(305);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(96);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(489);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(19);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(462);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(162)(module)))

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(19);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (path.startsWith('values')) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;

    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */])(shouldDelete);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref4) {
    var field = _ref4.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref7) {
    var field = _ref7.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref8) {
    var field = _ref8.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref15) {
    var field = _ref15.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"], function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref17) {
    var field = _ref17.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"], function (state, _ref20) {
    var sections = _ref20.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref21) {
    var field = _ref21.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref23) {
    var payload = _ref23.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref25) {
    var fields = _ref25.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref27) {
    var fields = _ref27.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(216);



function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;


  return function () {
    var shouldDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDeleteDefault;

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);
          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }
      return result;
    };

    return deleteInWithCleanUp;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1074);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = WebSocket;


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apex__ = __webpack_require__(21);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var OrderStateSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(OrderStateSubscriptionService, _BaseSubscriptionServ);

  function OrderStateSubscriptionService() {
    _classCallCheck(this, OrderStateSubscriptionService);

    return _possibleConstructorReturn(this, (OrderStateSubscriptionService.__proto__ || Object.getPrototypeOf(OrderStateSubscriptionService)).apply(this, arguments));
  }

  _createClass(OrderStateSubscriptionService, [{
    key: 'initSubscribtion',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(options) {
        var AccountId, OMSId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                AccountId = options.AccountId, OMSId = options.OMSId;


                __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.subscribeAccountEvents(AccountId, OMSId);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initSubscribtion(_x) {
        return _ref.apply(this, arguments);
      }

      return initSubscribtion;
    }()
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'OrderStateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return OrderStateSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_1__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new OrderStateSubscriptionService());

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apex__ = __webpack_require__(21);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var OrderTradesSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(OrderTradesSubscriptionService, _BaseSubscriptionServ);

  function OrderTradesSubscriptionService() {
    _classCallCheck(this, OrderTradesSubscriptionService);

    return _possibleConstructorReturn(this, (OrderTradesSubscriptionService.__proto__ || Object.getPrototypeOf(OrderTradesSubscriptionService)).apply(this, arguments));
  }

  _createClass(OrderTradesSubscriptionService, [{
    key: 'initSubscribtion',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(options) {
        var AccountId, OMSId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                AccountId = options.AccountId, OMSId = options.OMSId;


                __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.subscribeAccountEvents(AccountId, OMSId);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initSubscribtion(_x) {
        return _ref.apply(this, arguments);
      }

      return initSubscribtion;
    }()
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'OrderTradeEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return OrderTradesSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_1__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new OrderTradesSubscriptionService());

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makerValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return takerValue; });
var makerValue = 'Maker';
var takerValue = 'Taker';

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports = {"global":{"template":"STANDARD","siteName":"AlphaPoint","theme":"dark","locale":"en-US","dateFormat":"M/D/YYYY","timeFormat":"HH:mm:ss","dateTimeFormat":"M-D-YYYY h:mma","phoneDefaultCountry":"US","siteLogo":"site-logo.svg","authTimeout":0,"allowTransfer":true,"privateMarketData":false,"WalletsDisabledMessage":false},"LightWeightCharts":{"dateFormat":"MM/DD/YYYY","chartType":"candlestick","showVolume":true},"Snackbar":{"timeout":2000,"type":"info","showMultiple":true,"showProgressBar":true},"ApiKeys":{"documentationLink":"https://alphapoint.github.io/slate/"},"BalancesLayout":{"usePagination":true,"maxLines":100},"BlockTrade":{"showLockedIn":true},"Middleware":{"level2MonitorInterval":60000},"CryptoAddressValidation":{"ValidateAsERC20":["USDT"],"DoNotValidate":["EOS"],"UseDeprecatedValidate":["UNOBTANIUM","UNO","IOTA"]},"DigitalAssets":{"DefaultProfileURL":"https://offering-profiles-samples.surge.sh/notfound.html"},"TickerData":{"show24HrVolume":false,"show24HrPxChange":false},"Deposit":{"hideDepositBankInfo":false,"generateNewKey":true,"bankName":"My Bank","bankWireNumber":"1234567890","bankAccountNumber":"123456","MinimumVerificationLevel":0,"showDepositIdModal":false,"useShortDepositId":false},"Logo":{"DoNotInLineSVG":false},"InstrumentSelector":{"instruments":[]},"Withdraw":{"MinimumVerificationLevel":0,"WithdrawDetails":[{"text":"Note - The withdrawal and transfer of these funds might take up to 7 business days, and it's subject to operator review.","useLink":false,"linkAddress":""}]},"MarginTrading":{"cardText":"Margin trading is the process by which a trader borrows money from the AlphaPoint Exchange in order to either buy or sell more stock than that trader would otherwise be able to afford.","modalText":"Margin trading is the process by which a trader borrows money from the AlphaPoint Exchange in order to either buy or sell more stock than that trader would otherwise be able to afford.","terms":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tristique pharetra tellus id lobortis. Sed finibus, lectus et volutpat varius, enim nisl consequat felis, vitae consequat nunc odio et eros. Aenean dapibus luctus mauris, in luctus arcu lacreet in. Cras augue leo, rutrum nec egestas id, efficitur ac sapien. Integer pellentesque dapibus sapien non tristique. Etiam cursus tincidunt massa, sit amet mollis nulla rutrum viverra. Praesent eget turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tristique pharetra tellus id lobortis. Sed finibus, lectus et volutpat varius, enim nisl consequat felis, vitae consequat nunc odio et eros. Aenean dapibus luctus mauris, in luctus arcu lacreet in. Cras augue leo, rutrum nec egestas id, efficitur ac sapien. Integer pellentesque dapibus sapien non tristique. Etiam cursus tincidunt massa, sit amet mollis nulla rutrum viverra. Praesent eget turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tristique pharetra tellus id lobortis. Sed finibus, lectus et volutpat varius, enim nisl consequat felis, vitae consequat nunc odio et eros. Aenean dapibus luctus mauris, in luctus arcu lacreet in. Cras augue leo, rutrum nec egestas id, efficitur ac sapien. Integer pellentesque dapibus sapien non tristique. Etiam cursus tincidunt massa, sit amet mollis nulla rutrum viverra. Praesent eget turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tristique pharetra tellus id lobortis. Sed finibus, lectus et volutpat varius, enim nisl consequat felis, vitae consequat nunc odio et eros. Aenean dapibus luctus mauris, in luctus arcu lacreet in. Cras augue leo, rutrum nec egestas id, efficitur ac sapien. Integer pellentesque dapibus sapien non tristique. Etiam cursus tincidunt massa, sit amet mollis nulla rutrum viverra. Praesent eget turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tristique pharetra tellus id lobortis. Sed finibus, lectus et volutpat varius, enim nisl consequat felis, vitae consequat nunc odio et eros. Aenean dapibus luctus mauris, in luctus arcu lacreet in. Cras augue leo, rutrum nec egestas id, efficitur ac sapien. Integer pellentesque dapibus sapien non tristique. Etiam cursus tincidunt massa, sit amet mollis nulla rutrum viverra. Praesent eget turpis."},"KYC":{"verificationRequiredUrl":"/settings/verification","UpfrontKYC":false,"HideUpfrontCloseButton":true,"KYCRedirectVerificationLevel":0,"MinimumVerificationLevel":1,"type":"IM","requestIdentifier":"","DisableIMRequiredFields":false,"levels":[{"level":1,"label":"Level 01","button":"Increase to Level 1","description":{"benefits":["$500 Limit on Deposits","$500 limit on Withdrawals"],"requirements":"Register as an exchange user and verify your email."},"verifiedMessage":"Verified for Level 01","underReviewMessage":"Application under review.","sections":[{"label":"Personal Information","form":[{"label":"First Name","name":"firstName","type":"text","validators":["required"]},{"label":"Middle Name","name":"middleName","type":"text","validators":["required"]},{"label":"Last Name","name":"lastName","type":"text","validators":["required"]},{"label":"Date of Birth","name":"dob","type":"date","validators":["required","isDate"]},{"label":"Phone","name":"phone","type":"phone","validators":["required"]}]},{"label":"Billing Address","form":[{"label":"Billing Country","name":"country","type":"country","validators":["required"]},{"label":"Billing Street Address","name":"billingStreetAddress","type":"text","info":"(100 Washington Way)","validators":["required"]},{"label":"Billing State","name":"state","type":"text","info":"Abbreviation only","validators":["required"]},{"label":"Billing City","name":"billingCity","type":"text","validators":["required"]},{"label":"Billing Zip","name":"billingZip","type":"text","validators":["required","alphanumeric"]}]}]},{"level":2,"label":"Level 02","button":"Increase to Level 2","description":{"benefits":["$2000 Deposits","$2000 Withdrawals","$10,000 buy limit","$10,000 sell limit"],"requirements":"Account and Billing Information"},"verifiedMessage":"Verified for Level 02","underReviewMessage":"Application under review.","sections":[{"label":""}]},{"level":3,"label":"Level 03","button":"Increase to Level 3","description":{"benefits":["Unlimited Deposits","Unlimited Withdrawals","$50,000 Buy Limit","$50,000 Sell Limit"],"requirements":"ID Verification"},"verifiedMessage":"Verified for Level 03","underReviewMessage":"Application under review.","sections":[{"label":""}]}],"highlightStyle":"star"},"LandingPage":{"forceLogIn":false},"Pagination":{"maxPages":5},"ProblemLoggingIn":{"showOptions":true},"RecentActivity":{"showTransfers":false},"RetailBuySell":{"roundBuyLimitPrices":false,"pricePerUnit":false,"dealPrices":{"DEFAULT":[100,200,500,1000],"BTCUSD":[100,200,500,1000],"ETHUSD":[100,200,500,1000],"LTCUSD":[100,200,500,1000],"BCHUSD":[100,200,500,1000],"LTCBTC":[0.1,0.5,1,2]}},"OrderCalcBuffer":{"priceBuffer":0,"quantityBuffer":0},"Settings":{"profile":true,"tradeSettings":true,"apiKeys":true,"tradeReports":true,"userContacts":false,"affiliate":true,"loyaltyToken":true,"kyc":true,"demoMode":false,"interestBearingAccountSettings":true},"SignupForm":{"useEmailAsUsername":false,"additionalFields":[],"privacyPolicyLink":"/","termsAndServicesLink":"/","active":true},"TradingLayout":{"chart":"TradingView","usePagination":true,"maxLines":6,"showDepthChart":true},"OrderHistoryData":{"usePagination":true},"DepthChart":{"depthchartzoom":5,"depthChartHeight":150,"depthChartTextColor":"rgb(200,200,200)","depthChartTextFont":"12px","depthChartTextBgColor":"rgb(26, 32, 41)","depthChartXAxisTextPadding":60,"depthChartYAxisTextPadding":20,"depthChartBottomPadding":20,"depthChartXAxisStepCnt":9},"TradingView":{"timezone":"America/New_York","locale":"en","disabled_features":["context_menus","control_bar","go_to_date","header_chart_type","header_compare","header_resolutions","header_screenshot","header_symbol_search","header_undo_redo","left_toolbar","show_chart_property_page","save_chart_properties_to_local_storage","use_localstorage_for_settings"]},"Language":{"languageNames":{"af":"Afrikaans","sq":"Albanian","ar":"Arabic","hy":"Armenian","az":"Azeerbaijani","eu":"Basque","be":"Belarusian","bn":"Bengali","bs":"Bosnian","bg":"Bulgarian","ca":"Catalan","zh":"Chinese","co":"Corsican","hr":"Croatian","cs":"Czech","da":"Danish","nl":"Dutch","en":"English","et":"Estonian","fi":"Finnish","fr":"French","fy":"Frisian","ka":"Georgian","de":"German","el":"Greek","hi":"Hindi","hu":"Hungarian","is":"Icelandic","id":"Indonesian","it":"Italian","ja":"Japanese","jw":"Javanese","ko":"Korean","ku":"Kurdish","ky":"Kyrgyz","lo":"Lao","lv":"Latvian","lt":"Lithuanian","lb":"Luxembourgish","mk":"Macedonian","mg":"Malagasy","ms":"Malay","ml":"Malayalam","mt":"Maltese","mi":"Maori","mn":"Mongolian","my":"Myanmar","ne":"Nepali","no":"Norwegian","ps":"Pashto","fa":"Persian","pl":"Polish","pt":"Portuguese","pa":"Punjabi","ro":"Romanian","ru":"Russian","sm":"Samoan","sr":"Serbian","sk":"Slovak","sl":"Slovenian","so":"Somali","es":"Spanish","su":"Sundanese","sw":"Swahili","sv":"Swedish","tl":"Tagalog","th":"Thai","tr":"Turkish","uk":"Ukrainian","uz":"Uzbek","vi":"Vietnamese"}},"Footer":{"openInNewWindowGlobal":true,"links":[[{"text":"Terms & Conditions","link":""},{"text":"Privacy Policy","link":""}],[{"text":"info@alphapoint.com","link":"mailto:info@alphapoint.com","openInNewWindow":true},{"text":"https://www.alphapoint.com","link":"https://www.alphapoint.com"}]]},"Countries":{"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, The Democratic Republic of the","CK":"Cook Islands","CR":"Costa Rica","CI":"Cote D'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and Mcdonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic Of","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Korea, Democratic People'S Republic of","KR":"Korea, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People'S Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libyan Arab Jamahiriya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, The Former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","AN":"Netherlands Antilles","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territory, Occupied","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","CS":"Serbia and Montenegro","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Surname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan, Province of China","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW ":"Zimbabwe"},"BaseCurrencies":["BTC","ETH","LTC","USD","XRP","XMR","DASH","EUR","EOS","ETC","DASC"],"SimpleExchange":{"active":false,"route":"/simple-exchange"},"StreamingInstruments":{"Symbol":["BTCUSD","ETHUSD","LTCUSD","ETHBTC","LTCBTC"],"additionalSlippage":0}}

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeInForceForOrderType; });
var timeInForceForOrderType = {
  'Reserve Order': 0,
  'Good till Cancel': 1,
  'Immediate or Cancel': 3,
  'Fill Or Kill': 4
};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1084);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1085);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(309);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1087),
    ListCache = __webpack_require__(233),
    Map = __webpack_require__(310);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1088),
    hashDelete = __webpack_require__(1093),
    hashGet = __webpack_require__(1094),
    hashHas = __webpack_require__(1095),
    hashSet = __webpack_require__(1096);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(232);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(495),
    isMasked = __webpack_require__(1090),
    isObject = __webpack_require__(67),
    toSource = __webpack_require__(496);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1091);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1093 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(232);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(232);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(232);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(234);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(234);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(234);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(234);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(236);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(236);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(236);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(236);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVerifiedToTradeStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);


var getVerifiedToTradeStatus = function getVerifiedToTradeStatus(verificationLevel, levelIncreaseStatus) {
  var minimumVerificationLevel = __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].KYC.MinimumVerificationLevel;
  var disableTrading = true;
  var isUnderReview = false;

  if (verificationLevel >= minimumVerificationLevel) disableTrading = false;
  if (levelIncreaseStatus === 'underReview') isUnderReview = true;
  if (verificationLevel === levelIncreaseStatus - 1) isUnderReview = true;

  return {
    disableTrading: disableTrading,
    isUnderReview: isUnderReview
  };
};

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DepositSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(DepositSubscriptionService, _BaseSubscriptionServ);

  function DepositSubscriptionService() {
    _classCallCheck(this, DepositSubscriptionService);

    return _possibleConstructorReturn(this, (DepositSubscriptionService.__proto__ || Object.getPrototypeOf(DepositSubscriptionService)).apply(this, arguments));
  }

  _createClass(DepositSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'DepositTicketUpdateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return DepositSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new DepositSubscriptionService());

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var WithdrawSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(WithdrawSubscriptionService, _BaseSubscriptionServ);

  function WithdrawSubscriptionService() {
    _classCallCheck(this, WithdrawSubscriptionService);

    return _possibleConstructorReturn(this, (WithdrawSubscriptionService.__proto__ || Object.getPrototypeOf(WithdrawSubscriptionService)).apply(this, arguments));
  }

  _createClass(WithdrawSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'WithdrawTicketUpdateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return WithdrawSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new WithdrawSubscriptionService());

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var verificationLevelUpdateService = function (_BaseSubscriptionServ) {
  _inherits(verificationLevelUpdateService, _BaseSubscriptionServ);

  function verificationLevelUpdateService() {
    _classCallCheck(this, verificationLevelUpdateService);

    return _possibleConstructorReturn(this, (verificationLevelUpdateService.__proto__ || Object.getPrototypeOf(verificationLevelUpdateService)).apply(this, arguments));
  }

  _createClass(verificationLevelUpdateService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'VerificationLevelUpdateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return verificationLevelUpdateService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new verificationLevelUpdateService());

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var accountPositionSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(accountPositionSubscriptionService, _BaseSubscriptionServ);

  function accountPositionSubscriptionService() {
    _classCallCheck(this, accountPositionSubscriptionService);

    return _possibleConstructorReturn(this, (accountPositionSubscriptionService.__proto__ || Object.getPrototypeOf(accountPositionSubscriptionService)).apply(this, arguments));
  }

  _createClass(accountPositionSubscriptionService, [{
    key: 'initSubscribtion',
    value: function initSubscribtion(options) {
      // get initial positions here?
      var AccountId = options.AccountId,
          OMSId = options.OMSId;


      __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.subscribeAccountEvents(AccountId, OMSId);
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'AccountPositionEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return accountPositionSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new accountPositionSubscriptionService());

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var marketTradeSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(marketTradeSubscriptionService, _BaseSubscriptionServ);

  function marketTradeSubscriptionService() {
    _classCallCheck(this, marketTradeSubscriptionService);

    return _possibleConstructorReturn(this, (marketTradeSubscriptionService.__proto__ || Object.getPrototypeOf(marketTradeSubscriptionService)).apply(this, arguments));
  }

  _createClass(marketTradeSubscriptionService, [{
    key: 'initSubscribtion',
    value: function initSubscribtion() {}
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'MarketStateUpdate';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return marketTradeSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new marketTradeSubscriptionService());

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SettlementSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(SettlementSubscriptionService, _BaseSubscriptionServ);

  function SettlementSubscriptionService() {
    _classCallCheck(this, SettlementSubscriptionService);

    return _possibleConstructorReturn(this, (SettlementSubscriptionService.__proto__ || Object.getPrototypeOf(SettlementSubscriptionService)).apply(this, arguments));
  }

  _createClass(SettlementSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'AccountSettlementEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return SettlementSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new SettlementSubscriptionService());

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MarginAccountStateSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(MarginAccountStateSubscriptionService, _BaseSubscriptionServ);

  function MarginAccountStateSubscriptionService() {
    _classCallCheck(this, MarginAccountStateSubscriptionService);

    return _possibleConstructorReturn(this, (MarginAccountStateSubscriptionService.__proto__ || Object.getPrototypeOf(MarginAccountStateSubscriptionService)).apply(this, arguments));
  }

  _createClass(MarginAccountStateSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'MarginAccountStateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return MarginAccountStateSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new MarginAccountStateSubscriptionService());

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var marginAccountPositionEventSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(marginAccountPositionEventSubscriptionService, _BaseSubscriptionServ);

  function marginAccountPositionEventSubscriptionService() {
    _classCallCheck(this, marginAccountPositionEventSubscriptionService);

    return _possibleConstructorReturn(this, (marginAccountPositionEventSubscriptionService.__proto__ || Object.getPrototypeOf(marginAccountPositionEventSubscriptionService)).apply(this, arguments));
  }

  _createClass(marginAccountPositionEventSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'AccountPositionEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return marginAccountPositionEventSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new marginAccountPositionEventSubscriptionService());

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MarginPositionStatesSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(MarginPositionStatesSubscriptionService, _BaseSubscriptionServ);

  function MarginPositionStatesSubscriptionService() {
    _classCallCheck(this, MarginPositionStatesSubscriptionService);

    return _possibleConstructorReturn(this, (MarginPositionStatesSubscriptionService.__proto__ || Object.getPrototypeOf(MarginPositionStatesSubscriptionService)).apply(this, arguments));
  }

  _createClass(MarginPositionStatesSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'MarginPositionEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return MarginPositionStatesSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new MarginPositionStatesSubscriptionService());

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MarginPositionPaymentsSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(MarginPositionPaymentsSubscriptionService, _BaseSubscriptionServ);

  function MarginPositionPaymentsSubscriptionService() {
    _classCallCheck(this, MarginPositionPaymentsSubscriptionService);

    return _possibleConstructorReturn(this, (MarginPositionPaymentsSubscriptionService.__proto__ || Object.getPrototypeOf(MarginPositionPaymentsSubscriptionService)).apply(this, arguments));
  }

  _createClass(MarginPositionPaymentsSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'MarginPositionPaymentEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return MarginPositionPaymentsSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new MarginPositionPaymentsSubscriptionService());

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var marginAccountProductStateSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(marginAccountProductStateSubscriptionService, _BaseSubscriptionServ);

  function marginAccountProductStateSubscriptionService() {
    _classCallCheck(this, marginAccountProductStateSubscriptionService);

    return _possibleConstructorReturn(this, (marginAccountProductStateSubscriptionService.__proto__ || Object.getPrototypeOf(marginAccountProductStateSubscriptionService)).apply(this, arguments));
  }

  _createClass(marginAccountProductStateSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'MarginAccountProductStateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return marginAccountProductStateSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new marginAccountProductStateSubscriptionService());

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LogoutEventSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(LogoutEventSubscriptionService, _BaseSubscriptionServ);

  function LogoutEventSubscriptionService() {
    _classCallCheck(this, LogoutEventSubscriptionService);

    return _possibleConstructorReturn(this, (LogoutEventSubscriptionService.__proto__ || Object.getPrototypeOf(LogoutEventSubscriptionService)).apply(this, arguments));
  }

  _createClass(LogoutEventSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'LogoutEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        callback(updates);
      });
    }
  }]);

  return LogoutEventSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new LogoutEventSubscriptionService());

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_store__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Level1SubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(Level1SubscriptionService, _BaseSubscriptionServ);

  function Level1SubscriptionService() {
    _classCallCheck(this, Level1SubscriptionService);

    return _possibleConstructorReturn(this, (Level1SubscriptionService.__proto__ || Object.getPrototypeOf(Level1SubscriptionService)).apply(this, arguments));
  }

  _createClass(Level1SubscriptionService, [{
    key: 'initSubscribtion',
    value: function initSubscribtion(instrumentId) {
      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCPromise('SubscribeLevel1', {
          instrumentId: instrumentId,
          OMSId: 1
        }).then(function (res) {
          var data = JSON.parse(res.o);
          if (data.result === false) return reject(data);
          return resolve(data);
        }).catch(function (e) {
          return reject(e);
        });
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'Level1UpdateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        callback(updates);
      });
    }

    /**
     * Stop getting updates from server for all instruments
     */

  }, {
    key: 'stop',
    value: function stop() {
      var instruments = __WEBPACK_IMPORTED_MODULE_2__redux_store__["a" /* default */].getState().apexCore.instrument.instruments;


      instruments.forEach(function (_ref) {
        var InstrumentId = _ref.InstrumentId;

        __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.unsubscribeLevel1(InstrumentId);
      });
    }
  }]);

  return Level1SubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new Level1SubscriptionService());

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_alphapoint__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_alphapoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_alphapoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_store__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Level2SubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(Level2SubscriptionService, _BaseSubscriptionServ);

  function Level2SubscriptionService() {
    _classCallCheck(this, Level2SubscriptionService);

    return _possibleConstructorReturn(this, (Level2SubscriptionService.__proto__ || Object.getPrototypeOf(Level2SubscriptionService)).apply(this, arguments));
  }

  _createClass(Level2SubscriptionService, [{
    key: 'initSubscribtion',
    value: function initSubscribtion(instrumentId) {
      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.RPCPromise('SubscribeLevel2', {
          OMSId: 1,
          instrumentId: instrumentId,
          depth: 250
        }).then(function (res) {
          var data = JSON.parse(res.o);
          if (data.result !== false) return resolve(data.map(function (x) {
            return new __WEBPACK_IMPORTED_MODULE_1_alphapoint__["Level2"](x);
          }));
          reject(data);
        }).catch(function (e) {
          return reject(e);
        });
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'Level2UpdateEvent';
      }).subscribe(function (response) {
        var data = JSON.parse(response.o);
        var updates = data.map(function (x) {
          return new __WEBPACK_IMPORTED_MODULE_1_alphapoint__["Level2"](x);
        });

        callback(updates);
      });
    }
  }, {
    key: 'stop',
    value: function stop() {
      var selectedInstrumentId = __WEBPACK_IMPORTED_MODULE_3__redux_store__["a" /* default */].getState().apexCore.instrument.selectedInstrumentId;


      this.stopOne(selectedInstrumentId);
    }
  }, {
    key: 'stopOne',
    value: function stopOne(instrumentId) {
      __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.unsubscribeLevel2(instrumentId);
    }
  }]);

  return Level2SubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new Level2SubscriptionService());

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_alphapoint__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_alphapoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_alphapoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_store__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var queue = [];
var interval = void 0;

var TradesSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(TradesSubscriptionService, _BaseSubscriptionServ);

  function TradesSubscriptionService() {
    _classCallCheck(this, TradesSubscriptionService);

    return _possibleConstructorReturn(this, (TradesSubscriptionService.__proto__ || Object.getPrototypeOf(TradesSubscriptionService)).apply(this, arguments));
  }

  _createClass(TradesSubscriptionService, [{
    key: 'initSubscribtion',
    value: function initSubscribtion(instrumentId) {
      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.RPCPromise('SubscribeTrades', {
          instrumentId: instrumentId,
          IncludeLastCount: 40, // history
          OMSId: 1
        }).then(function (res) {
          return JSON.parse(res.o);
        }).then(function (res) {
          if (res.result === false) {
            return reject(res);
          }

          return resolve(res.filter(function (i) {
            return i[1] === instrumentId;
          }).map(function (i) {
            return new __WEBPACK_IMPORTED_MODULE_1_alphapoint__["Trade"](i);
          }));
        }).catch(function (e) {
          return console.error(e);
        });
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback, instrumentId) {
      this.unsubscribe();
      queue = [];
      window.clearInterval(interval);

      this.subscription = __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'TradeDataUpdateEvent';
      }).subscribe(function (response) {
        var data = JSON.parse(response.o);
        queue = data.concat(queue);
      });

      interval = window.setInterval(function () {
        if (queue.length) {
          var data = queue.filter(function (i) {
            return i[1] === instrumentId;
          }).map(function (x) {
            return new __WEBPACK_IMPORTED_MODULE_1_alphapoint__["Trade"](x);
          });

          if (data.length) {
            callback(data);
          }
          queue = [];
        }
      }, 1000);
    }
  }, {
    key: 'stop',
    value: function stop() {
      var selectedInstrumentId = __WEBPACK_IMPORTED_MODULE_3__redux_store__["a" /* default */].getState().apexCore.instrument.selectedInstrumentId;

      this.stopOne(selectedInstrumentId);
    }
  }, {
    key: 'stopOne',
    value: function stopOne(instrumentId) {
      window.clearInterval(interval);
      queue = [];
      __WEBPACK_IMPORTED_MODULE_2__apex__["a" /* default */].connection.unsubscribeTrades(instrumentId);
    }
  }]);

  return TradesSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new TradesSubscriptionService());

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);


// do to the backend sending non-supported instruements in an undesirably ordered fashion
// we have to do the filtering and sorting on the front end
var filterSortSupportedInstruments = function filterSortSupportedInstruments(itemsArray) {
  if (!__WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.instruments || __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.instruments.length === 0) {
    return itemsArray;
  }

  var filteredSortedInstruments = [];

  __WEBPACK_IMPORTED_MODULE_0__config__["b" /* default */].global.instruments.forEach(function (symbol) {
    var instrument = itemsArray.find(function (item) {
      return item.Symbol === symbol;
    });

    if (instrument) {
      filteredSortedInstruments.push(instrument);
    }
  });

  return filteredSortedInstruments;
};

/* harmony default export */ __webpack_exports__["a"] = (filterSortSupportedInstruments);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_store__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var queue = [];
var interval = void 0;

var TickersSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(TickersSubscriptionService, _BaseSubscriptionServ);

  function TickersSubscriptionService() {
    _classCallCheck(this, TickersSubscriptionService);

    return _possibleConstructorReturn(this, (TickersSubscriptionService.__proto__ || Object.getPrototypeOf(TickersSubscriptionService)).apply(this, arguments));
  }

  _createClass(TickersSubscriptionService, [{
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();
      queue = [];
      window.clearInterval(interval);

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'TickerDataUpdateEvent';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);

        queue = queue.concat(updates);
      });

      interval = window.setInterval(function () {
        if (queue.length) {
          callback(queue);
          queue = [];
        }
      }, 1000);
    }
  }, {
    key: 'stop',
    value: function stop() {
      var instruments = __WEBPACK_IMPORTED_MODULE_2__redux_store__["a" /* default */].getState().apexCore.instrument.instruments;

      queue = [];
      window.clearInterval(interval);
      instruments.forEach(function (_ref) {
        var InstrumentId = _ref.InstrumentId;

        __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCPromise('UnsubscribeTicker', {
          OMSId: 1,
          InstrumentId: InstrumentId
        });
      });
    }
  }, {
    key: 'stopOne',
    value: function stopOne(InstrumentId) {
      queue = [];
      window.clearInterval(interval);
      return __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCPromise('UnsubscribeTicker', {
        OMSId: 1,
        InstrumentId: InstrumentId
      });
    }
  }]);

  return TickersSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new TickersSubscriptionService());

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1127 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(117),
    isArray = __webpack_require__(63),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(317);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1132),
    keys = __webpack_require__(173);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(169);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(117),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(117),
    isLength = __webpack_require__(315),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(515);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(1139),
    baseRest = __webpack_require__(320),
    toNumber = __webpack_require__(317);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1142),
    defineProperty = __webpack_require__(521),
    identity = __webpack_require__(321);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1142 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1143 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apex__ = __webpack_require__(21);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PriceSubscriptionService = function (_BaseSubscriptionServ) {
  _inherits(PriceSubscriptionService, _BaseSubscriptionServ);

  function PriceSubscriptionService() {
    _classCallCheck(this, PriceSubscriptionService);

    return _possibleConstructorReturn(this, (PriceSubscriptionService.__proto__ || Object.getPrototypeOf(PriceSubscriptionService)).apply(this, arguments));
  }

  _createClass(PriceSubscriptionService, [{
    key: 'initSubscription',
    value: function initSubscription(req, callback) {
      __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCCall('SubscribePrices', req, function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        try {
          data = JSON.parse(data.o);
          callback(data);
        } catch (e) {
          console.error('Price subscription parsing data error: ', e);
        }
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(callback) {
      this.unsubscribe();

      this.subscription = __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.ws.filter(function (x) {
        return x.n === 'PriceUpdate';
      }).subscribe(function (response) {
        var updates = JSON.parse(response.o);
        callback(updates);
      });
    }
  }, {
    key: 'stopOne',
    value: function stopOne(InstrumentId) {
      __WEBPACK_IMPORTED_MODULE_1__apex__["a" /* default */].connection.RPCCall('UnSubscribePrices', { InstrumentId: InstrumentId, OMSId: 1 });
    }
  }, {
    key: 'stop',
    value: function stop() {}
  }]);

  return PriceSubscriptionService;
}(__WEBPACK_IMPORTED_MODULE_0__BaseSubscriptionService__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new PriceSubscriptionService());

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(249),
    baseUniq = __webpack_require__(566);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1147),
    getMatchData = __webpack_require__(1164),
    matchesStrictComparable = __webpack_require__(563);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(325),
    baseIsEqual = __webpack_require__(326);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(233);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1149 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1150 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1151 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(233),
    Map = __webpack_require__(310),
    MapCache = __webpack_require__(309);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(325),
    equalArrays = __webpack_require__(556),
    equalByTag = __webpack_require__(1157),
    equalObjects = __webpack_require__(1159),
    getTag = __webpack_require__(177),
    isArray = __webpack_require__(63),
    isBuffer = __webpack_require__(243),
    isTypedArray = __webpack_require__(318);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1154 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1156 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134),
    Uint8Array = __webpack_require__(557),
    eq = __webpack_require__(235),
    equalArrays = __webpack_require__(556),
    mapToArray = __webpack_require__(1158),
    setToArray = __webpack_require__(329);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1158 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(558);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1160 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(118),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(118),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(118),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(562),
    keys = __webpack_require__(173);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(326),
    get = __webpack_require__(14),
    hasIn = __webpack_require__(564),
    isKey = __webpack_require__(308),
    isStrictComparable = __webpack_require__(562),
    matchesStrictComparable = __webpack_require__(563),
    toKey = __webpack_require__(135);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1166 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(133),
    isArguments = __webpack_require__(242),
    isArray = __webpack_require__(63),
    isIndex = __webpack_require__(245),
    isLength = __webpack_require__(315),
    toKey = __webpack_require__(135);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(565),
    basePropertyDeep = __webpack_require__(1169),
    isKey = __webpack_require__(308),
    toKey = __webpack_require__(135);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(230);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(561),
    noop = __webpack_require__(1171),
    setToArray = __webpack_require__(329);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(333),
    baseIteratee = __webpack_require__(249),
    baseRest = __webpack_require__(320),
    baseUniq = __webpack_require__(566),
    isArrayLikeObject = __webpack_require__(576),
    last = __webpack_require__(334);

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134),
    isArguments = __webpack_require__(242),
    isArray = __webpack_require__(63);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1175),
    baseFlatten = __webpack_require__(333),
    baseIteratee = __webpack_require__(249),
    baseRest = __webpack_require__(320),
    isArrayLikeObject = __webpack_require__(576),
    last = __webpack_require__(334);

/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = baseRest(function(array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2))
    : [];
});

module.exports = differenceBy;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(327),
    arrayIncludes = __webpack_require__(567),
    arrayIncludesWith = __webpack_require__(568),
    arrayMap = __webpack_require__(169),
    baseUnary = __webpack_require__(246),
    cacheHas = __webpack_require__(328);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marginAccountStateReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__ = __webpack_require__(57);


var initialState = {
  settings: {},
  accountState: {},
  marginStatus: null,
  fetching: true
};

var marginAccountStateReducer = function marginAccountStateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__["f" /* REQUEST_MARGIN_ACCOUNT_STATE */]:
      return Object.assign({}, state, {
        fetching: true
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__["a" /* RECEIVE_MARGIN_ACCOUNT_STATE */]:
      return Object.assign({}, state, {
        accountState: payload,
        fetching: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__["e" /* RECEIVE_MARGIN_STATUS */]:
      {
        return Object.assign({}, state, {
          marginStatus: payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__["d" /* RECEIVE_MARGIN_SETTINGS */]:
      {
        return Object.assign({}, state, {
          settings: payload
        });
      }
    default:
      return state;
  }
};

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marginHistoryReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__ = __webpack_require__(88);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var initialState = {
  openPositions: [],
  closedPositions: [],
  positionPayments: [],
  activeRequests: 0
};

var marginHistoryReducer = function marginHistoryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["k" /* REQUEST_OPEN_POSITIONS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["i" /* REQUEST_CLOSED_POSITIONS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["j" /* REQUEST_MARGIN_POSITIONS_PAYMENTS */]:
      return Object.assign({}, state, {
        activeRequests: ++state.activeRequests
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["g" /* RECEIVE_OPEN_POSITIONS */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        openPositions: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["d" /* RECEIVE_CLOSED_POSITIONS */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        closedPositions: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["e" /* RECEIVE_MARGIN_POSITIONS_PAYMENTS */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        positionPayments: payload
      });

    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["b" /* ADD_OPEN_POSITION */]:
      return Object.assign({}, state, {
        openPositions: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])([payload].concat(_toConsumableArray(state.openPositions)), function (position) {
          return position.PositionId;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["a" /* ADD_CLOSED_POSITION */]:
      return Object.assign({}, state, {
        closedPositions: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])([payload].concat(_toConsumableArray(state.closedPositions)), function (position) {
          return position.PositionId;
        }),
        /**
         * Note: back-end may temporarily set position.Status to e.g. `InClosingWithMarketOnly`.
         *  This is technically a `MarginPositionStatusQuery` = 1 (NotClose).
         */
        openPositions: state.openPositions.filter(function (i) {
          return i.PositionId !== payload.PositionId;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["f" /* RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT */]:
      return Object.assign({}, state, {
        positionPayments: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])([payload].concat(_toConsumableArray(state.positionPayments)), function (positionPayment) {
          return positionPayment.PositionPaymentId;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginHistoryActions__["h" /* REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST */]:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests
      });

    default:
      return state;
  }
};

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marginInstrumentReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__ = __webpack_require__(57);


var initialState = {
  instruments: [],
  selectedInstrumentId: undefined,
  fetching: true
};

var marginInstrumentReducer = function marginInstrumentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__["g" /* REQUEST_MARGIN_INSTRUMENTS */]:
      return Object.assign({}, state, { fetching: true });
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__["c" /* RECEIVE_MARGIN_INSTRUMENTS */]:
      return handleReceiveMarginInstruments(state, payload);
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginActions__["h" /* SET_MARGIN_INSTRUMENT */]:
      return Object.assign({}, state, {
        selectedInstrumentId: payload
      });
    default:
      return state;
  }
};

var handleReceiveMarginInstruments = function handleReceiveMarginInstruments(state, payload) {
  var instruments = payload.instruments,
      selectedInstrumentId = payload.selectedInstrumentId;

  var marginSelectedInstrument = instruments.find(function (instrument) {
    return instrument.InstrumentId === selectedInstrumentId;
  });

  return Object.assign({}, state, {
    instruments: instruments,
    selectedInstrumentId: marginSelectedInstrument ? selectedInstrumentId : instruments[0].InstrumentId,
    fetching: false
  });
};

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marginProductReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_marginProductActions__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_marginActions__ = __webpack_require__(57);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var initialState = {
  products: [],
  fetching: true
};

var marginProductReducer = function marginProductReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginProductActions__["c" /* REQUEST_MARGIN_PRODUCTS */]:
      return Object.assign({}, state, { fetching: true });

    case __WEBPACK_IMPORTED_MODULE_0__actions_marginProductActions__["a" /* RECEIVE_MARGIN_PRODUCTS */]:
      return Object.assign({}, state, {
        products: payload,
        fetching: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginProductActions__["b" /* RECEIVE_MARGIN_PRODUCT_EVENT */]:
      return handleReceiveMarginProductEvent(state, payload);
    case __WEBPACK_IMPORTED_MODULE_1__actions_marginActions__["b" /* RECEIVE_MARGIN_ACCT_POSITION */]:
      return handleReceiveAccountPositionEvent(state, payload);
    default:
      return state;
  }
};

var handleReceiveMarginProductEvent = function handleReceiveMarginProductEvent(state, payload) {
  var productIndex = state.products.findIndex(function (product) {
    return product.AccountPosition.ProductId === payload.AccountPosition.ProductId;
  });
  if (productIndex === -1) {
    return state;
  }
  var updatedProducts = [].concat(_toConsumableArray(state.products));
  updatedProducts[productIndex] = payload;
  return Object.assign({}, state, {
    products: updatedProducts
  });
};

var handleReceiveAccountPositionEvent = function handleReceiveAccountPositionEvent(state, payload) {
  var idx = state.products.findIndex(function (p) {
    return p.AccountPosition.ProductId === payload.ProductId;
  });
  var products = [].concat(_toConsumableArray(state.products));

  products.splice(idx, 1, Object.assign({}, state.products[idx], {
    AccountPosition: payload
  }));

  return Object.assign({}, state, {
    products: products
  });
};

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return marginTransfersReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_marginTransferActions__ = __webpack_require__(582);


var initialState = {
  loading: false
};

var marginTransfersReducer = function marginTransfersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_marginTransferActions__["b" /* TRANSFER_ASSETS_REQUESTED */]:
      return Object.assign({}, state, { loading: true });

    case __WEBPACK_IMPORTED_MODULE_0__actions_marginTransferActions__["c" /* TRANSFER_ASSETS_SUCCESS */]:
      return Object.assign({}, state, { loading: false });

    case __WEBPACK_IMPORTED_MODULE_0__actions_marginTransferActions__["a" /* TRANSFER_ASSETS_ERROR */]:
      return Object.assign({}, state, { loading: false });

    default:
      return state;
  }
};

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

module.exports = {"global":{"template":"MILAN","siteName":"AlphaPoint","gateway":["wss://api_apexqa.alphapoint.com/WSGateway/","wss://apiapexqa2.alphapoint.com/WSGateway","wss://apiqa4.alphapoint.com/WSGateway/"],"theme":"dark","locale":"en-US","dateFormat":"M/D/YYYY","timeFormat":"HH:mm:ss","dateTimeFormat":"M-D-YYYY h:mma","phoneDefaultCountry":"US","siteLogo":"site-logo.svg","authTimeout":0,"allowTransfer":true},"ApiKeys":{"documentationLink":"https://alphapoint.github.io/slate/"},"BalancesLayout":{"usePagination":true,"maxLines":100},"TickerData":{"show24HrVolume":false,"show24HrPxChange":false},"Deposit":{"hideDepositBankInfo":false,"generateNewKey":true,"bankName":"My Bank","bankWireNumber":"1234567890","bankAccountNumber":"123456","MinimumVerificationLevel":0,"showDepositIdModal":false},"InstrumentSelector":{"instruments":[]},"Withdraw":{"MinimumVerificationLevel":0,"WithdrawDetails":[{"text":"Note - The withdrawal and transfer of these funds might take up to 7 business days, and it's subject to operator review.","useLink":false,"linkAddress":""}]},"KYC":{"verificationRequiredUrl":"/settings/verification","UpfrontKYC":false,"HideUpfrontCloseButton":true,"KYCRedirectVerificationLevel":0,"MinimumVerificationLevel":1,"type":"IM","requestIdentifier":"","levels":[{"level":1,"label":"Level 01","button":"Increase to Level 1","description":{"benefits":["$500 Limit on Deposits","$500 limit on Withdrawals"],"requirements":"Register as an exchange user and verify your email."},"verifiedMessage":"Verified for Level 01","underReviewMessage":"Application under review.","sections":[{"label":"Personal Information","form":[{"label":"First Name","name":"firstName","type":"text","validators":["required"]},{"label":"Middle Name","name":"middleName","type":"text","validators":["required"]},{"label":"Last Name","name":"lastName","type":"text","validators":["required"]},{"label":"Date of Birth","name":"dob","type":"date","validators":["required","isDate"]},{"label":"Phone","name":"phone","type":"phone","validators":["required"]}]},{"label":"Billing Address","form":[{"label":"Billing Country","name":"country","type":"country","validators":["required"]},{"label":"Billing Street Address","name":"billingStreetAddress","type":"text","info":"(100 Washington Way)","validators":["required"]},{"label":"Billing State","name":"state","type":"text","info":"Abbreviation only","validators":["required"]},{"label":"Billing City","name":"billingCity","type":"text","validators":["required"]},{"label":"Billing Zip","name":"billingZip","type":"text","validators":["required","alphanumeric"]}]}]},{"level":2,"label":"Level 02","button":"Increase to Level 2","description":{"benefits":["$2000 Deposits","$2000 Withdrawals","$10,000 buy limit","$10,000 sell limit"],"requirements":"Account and Billing Information"},"verifiedMessage":"Verified for Level 02","underReviewMessage":"Application under review.","sections":[{"label":""}]},{"level":3,"label":"Level 03","button":"Increase to Level 3","description":{"benefits":["Unlimited Deposits","Unlimited Withdrawals","$50,000 Buy Limit","$50,000 Sell Limit"],"requirements":"ID Verification"},"verifiedMessage":"Verified for Level 03","underReviewMessage":"Application under review.","sections":[{"label":""}]}],"highlightStyle":"star"},"LandingPage":{"forceLogIn":false},"Pagination":{"maxPages":5},"ProblemLoggingIn":{"showOptions":true},"RecentActivity":{"showTransfers":false},"RetailBuySell":{"roundBuyLimitPrices":false,"dealPrices":{"BTCUSD":[100,200,500,1000],"ETHUSD":[100,200,500,1000],"LTCUSD":[100,200,500,1000],"BCHUSD":[100,200,500,1000],"LTCBTC":[0.1,0.5,1,2]}},"OrderCalcBuffer":{"priceBuffer":0,"quantityBuffer":0},"Settings":{"profile":true,"apiKeys":true,"tradeReports":true,"userContacts":false,"affiliate":true,"loyaltyToken":true,"kyc":true,"demoMode":false},"SignupForm":{"useEmailAsUsername":false,"additionalFields":[],"privacyPolicyLink":"/","termsAndServicesLink":"/","active":true},"TradingLayout":{"chart":"TradingView","usePagination":true,"maxLines":6,"showDepthChart":true},"OrderHistoryData":{"usePagination":true},"DepthChart":{"depthchartzoom":5,"depthChartHeight":150,"depthChartTextColor":"rgb(200,200,200)","depthChartTextFont":"12px","depthChartTextBgColor":"rgb(26, 32, 41)","depthChartXAxisTextPadding":60,"depthChartYAxisTextPadding":20,"depthChartBottomPadding":20,"depthChartXAxisStepCnt":9},"TradingView":{"timezone":"America/New_York","locale":"en","disabled_features":["context_menus","control_bar","go_to_date","header_chart_type","header_compare","header_resolutions","header_screenshot","header_symbol_search","header_undo_redo","left_toolbar","show_chart_property_page","save_chart_properties_to_local_storage","use_localstorage_for_settings"]},"Language":{"languageNames":{"af":"Afrikaans","sq":"Albanian","ar":"Arabic","hy":"Armenian","az":"Azeerbaijani","eu":"Basque","be":"Belarusian","bn":"Bengali","bs":"Bosnian","bg":"Bulgarian","ca":"Catalan","zh":"Chinese","co":"Corsican","hr":"Croatian","cs":"Czech","da":"Danish","nl":"Dutch","en":"English","et":"Estonian","fi":"Finnish","fr":"French","fy":"Frisian","ka":"Georgian","de":"German","el":"Greek","hi":"Hindi","hu":"Hungarian","is":"Icelandic","id":"Indonesian","it":"Italian","ja":"Japanese","jw":"Javanese","ko":"Korean","ku":"Kurdish","ky":"Kyrgyz","lo":"Lao","lv":"Latvian","lt":"Lithuanian","lb":"Luxembourgish","mk":"Macedonian","mg":"Malagasy","ms":"Malay","ml":"Malayalam","mt":"Maltese","mi":"Maori","mn":"Mongolian","my":"Myanmar","ne":"Nepali","no":"Norwegian","ps":"Pashto","fa":"Persian","pl":"Polish","pt":"Portuguese","pa":"Punjabi","ro":"Romanian","ru":"Russian","sm":"Samoan","sr":"Serbian","sk":"Slovak","sl":"Slovenian","so":"Somali","es":"Spanish","su":"Sundanese","sw":"Swahili","sv":"Swedish","tl":"Tagalog","th":"Thai","tr":"Turkish","uk":"Ukrainian","uz":"Uzbek","vi":"Vietnamese"}},"Footer":{"openInNewWindowGlobal":true,"links":[[{"text":"Terms & Conditions","link":""},{"text":"Privacy Policy","link":""}],[{"text":"info@alphapoint.com","link":"mailto:info@alphapoint.com","openInNewWindow":true},{"text":"https://www.alphapoint.com","link":"https://www.alphapoint.com"}]]},"Countries":{"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, The Democratic Republic of the","CK":"Cook Islands","CR":"Costa Rica","CI":"Cote D'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and Mcdonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic Of","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Korea, Democratic People'S Republic of","KR":"Korea, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People'S Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libyan Arab Jamahiriya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, The Former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","AN":"Netherlands Antilles","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territory, Occupied","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","CS":"Serbia and Montenegro","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Surname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan, Province of China","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW ":"Zimbabwe"},"BaseCurrencies":["BTC","ETH","LTC","USD","XRP","XMR","DASH","EUR","EOS","ETC","DASC"],"SimpleExchange":{"active":false,"route":"/simple-exchange"}}

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * css-vars-ponyfill
 * v1.17.2
 * https://github.com/jhildenbiddle/css-vars-ponyfill
 * (c) 2018-2019 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function _extends() {
    _extends = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
        return arr2;
    }
}

function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/*!
 * get-css-data
 * v1.6.3
 * https://github.com/jhildenbiddle/get-css-data
 * (c) 2018-2019 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */ function getUrls(urls) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var settings = {
        mimeType: options.mimeType || null,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var urlArray = Array.isArray(urls) ? urls : [ urls ];
    var urlQueue = Array.apply(null, Array(urlArray.length)).map(function(x) {
        return null;
    });
    function isValidCss() {
        var cssText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var isHTML = cssText.trim().charAt(0) === "<";
        return !isHTML;
    }
    function onError(xhr, urlIndex) {
        settings.onError(xhr, urlArray[urlIndex], urlIndex);
    }
    function onSuccess(responseText, urlIndex) {
        var returnVal = settings.onSuccess(responseText, urlArray[urlIndex], urlIndex);
        responseText = returnVal === false ? "" : returnVal || responseText;
        urlQueue[urlIndex] = responseText;
        if (urlQueue.indexOf(null) === -1) {
            settings.onComplete(urlQueue);
        }
    }
    var parser = document.createElement("a");
    urlArray.forEach(function(url, i) {
        parser.setAttribute("href", url);
        parser.href = String(parser.href);
        var isIElte9 = Boolean(document.all && !window.atob);
        var isIElte9CORS = isIElte9 && parser.host.split(":")[0] !== location.host.split(":")[0];
        if (isIElte9CORS) {
            var isSameProtocol = parser.protocol === location.protocol;
            if (isSameProtocol) {
                var xdr = new XDomainRequest();
                xdr.open("GET", url);
                xdr.timeout = 0;
                xdr.onprogress = Function.prototype;
                xdr.ontimeout = Function.prototype;
                xdr.onload = function() {
                    if (isValidCss(xdr.responseText)) {
                        onSuccess(xdr.responseText, i);
                    } else {
                        onError(xdr, i);
                    }
                };
                xdr.onerror = function(err) {
                    onError(xdr, i);
                };
                setTimeout(function() {
                    xdr.send();
                }, 0);
            } else {
                console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(url, ")"));
                onError(null, i);
            }
        } else {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url);
            if (settings.mimeType && xhr.overrideMimeType) {
                xhr.overrideMimeType(settings.mimeType);
            }
            settings.onBeforeSend(xhr, url, i);
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200 && isValidCss(xhr.responseText)) {
                        onSuccess(xhr.responseText, i);
                    } else {
                        onError(xhr, i);
                    }
                }
            };
            xhr.send();
        }
    });
}

/**
 * Gets CSS data from <style> and <link> nodes (including @imports), then
 * returns data in order processed by DOM. Allows specifying nodes to
 * include/exclude and filtering CSS data using RegEx.
 *
 * @preserve
 * @param {object}   [options] The options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes.
 * @param {string}   [options.include] CSS selector matching <link> and <style>
 *                   nodes to include
 * @param {string}   [options.exclude] CSS selector matching <link> and <style>
 *                   nodes to exclude
 * @param {object}   [options.filter] Regular expression used to filter node CSS
 *                   data. Each block of CSS data is tested against the filter,
 *                   and only matching data is included.
 * @param {object}   [options.useCSSOM=false] Determines if CSS data will be
 *                   collected from a stylesheet's runtime values instead of its
 *                   text content. This is required to get accurate CSS data
 *                   when a stylesheet has been modified using the deleteRule()
 *                   or insertRule() methods because these modifications will
 *                   not be reflected in the stylesheet's text content.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback on each CSS node read. Passes
 *                   1) CSS text, 2) source node reference, and 3) the source
 *                   URL as arguments.
 * @param {function} [options.onError] Callback on each error. Passes 1) the XHR
 *                   object for inspection, 2) soure node reference, and 3) the
 *                   source URL that failed (either a <link> href or an @import)
 *                   as arguments
 * @param {function} [options.onComplete] Callback after all nodes have been
 *                   processed. Passes 1) concatenated CSS text, 2) an array of
 *                   CSS text in DOM order, and 3) an array of nodes in DOM
 *                   order as arguments.
 *
 * @example
 *
 *   getCssData({
 *     rootElement: document,
 *     include    : 'style,link[rel="stylesheet"]',
 *     exclude    : '[href="skip.css"]',
 *     filter     : /red/,
 *     useCSSOM   : false,
 *     onBeforeSend(xhr, node, url) {
 *       // ...
 *     }
 *     onSuccess(cssText, node, url) {
 *       // ...
 *     }
 *     onError(xhr, node, url) {
 *       // ...
 *     },
 *     onComplete(cssText, cssArray, nodeArray) {
 *       // ...
 *     }
 *   });
 */ function getCssData(options) {
    var regex = {
        cssComments: /\/\*[\s\S]+?\*\//g,
        cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g
    };
    var settings = {
        rootElement: options.rootElement || document,
        include: options.include || 'style,link[rel="stylesheet"]',
        exclude: options.exclude || null,
        filter: options.filter || null,
        useCSSOM: options.useCSSOM || false,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var sourceNodes = Array.apply(null, settings.rootElement.querySelectorAll(settings.include)).filter(function(node) {
        return !matchesSelector(node, settings.exclude);
    });
    var cssArray = Array.apply(null, Array(sourceNodes.length)).map(function(x) {
        return null;
    });
    function handleComplete() {
        var isComplete = cssArray.indexOf(null) === -1;
        if (isComplete) {
            var cssText = cssArray.join("");
            settings.onComplete(cssText, cssArray, sourceNodes);
        }
    }
    function handleSuccess(cssText, cssIndex, node, sourceUrl) {
        var returnVal = settings.onSuccess(cssText, node, sourceUrl);
        cssText = returnVal !== undefined && Boolean(returnVal) === false ? "" : returnVal || cssText;
        resolveImports(cssText, node, sourceUrl, function(resolvedCssText, errorData) {
            if (cssArray[cssIndex] === null) {
                errorData.forEach(function(data) {
                    return settings.onError(data.xhr, node, data.url);
                });
                if (!settings.filter || settings.filter.test(resolvedCssText)) {
                    cssArray[cssIndex] = resolvedCssText;
                } else {
                    cssArray[cssIndex] = "";
                }
                handleComplete();
            }
        });
    }
    function parseImportData(cssText, baseUrl) {
        var ignoreRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var importData = {};
        importData.rules = (cssText.replace(regex.cssComments, "").match(regex.cssImports) || []).filter(function(rule) {
            return ignoreRules.indexOf(rule) === -1;
        });
        importData.urls = importData.rules.map(function(rule) {
            return rule.replace(regex.cssImports, "$1");
        });
        importData.absoluteUrls = importData.urls.map(function(url) {
            return getFullUrl(url, baseUrl);
        });
        importData.absoluteRules = importData.rules.map(function(rule, i) {
            var oldUrl = importData.urls[i];
            var newUrl = getFullUrl(importData.absoluteUrls[i], baseUrl);
            return rule.replace(oldUrl, newUrl);
        });
        return importData;
    }
    function resolveImports(cssText, node, baseUrl, callbackFn) {
        var __errorData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var __errorRules = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var importData = parseImportData(cssText, baseUrl, __errorRules);
        if (importData.rules.length) {
            getUrls(importData.absoluteUrls, {
                onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                    settings.onBeforeSend(xhr, node, url);
                },
                onSuccess: function onSuccess(cssText, url, urlIndex) {
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal === false ? "" : returnVal || cssText;
                    var responseImportData = parseImportData(cssText, url, __errorRules);
                    responseImportData.rules.forEach(function(rule, i) {
                        cssText = cssText.replace(rule, responseImportData.absoluteRules[i]);
                    });
                    return cssText;
                },
                onError: function onError(xhr, url, urlIndex) {
                    __errorData.push({
                        xhr: xhr,
                        url: url
                    });
                    __errorRules.push(importData.rules[urlIndex]);
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                },
                onComplete: function onComplete(responseArray) {
                    responseArray.forEach(function(importText, i) {
                        cssText = cssText.replace(importData.rules[i], importText);
                    });
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                }
            });
        } else {
            callbackFn(cssText, __errorData);
        }
    }
    if (sourceNodes.length) {
        sourceNodes.forEach(function(node, i) {
            var linkHref = node.getAttribute("href");
            var linkRel = node.getAttribute("rel");
            var isLink = node.nodeName === "LINK" && linkHref && linkRel && linkRel.toLowerCase() === "stylesheet";
            var isStyle = node.nodeName === "STYLE";
            if (isLink) {
                getUrls(linkHref, {
                    mimeType: "text/css",
                    onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                        settings.onBeforeSend(xhr, node, url);
                    },
                    onSuccess: function onSuccess(cssText, url, urlIndex) {
                        var sourceUrl = getFullUrl(linkHref, location.href);
                        handleSuccess(cssText, i, node, sourceUrl);
                    },
                    onError: function onError(xhr, url, urlIndex) {
                        cssArray[i] = "";
                        settings.onError(xhr, node, url);
                        handleComplete();
                    }
                });
            } else if (isStyle) {
                var cssText = node.textContent;
                if (settings.useCSSOM) {
                    cssText = Array.apply(null, node.sheet.cssRules).map(function(rule) {
                        return rule.cssText;
                    }).join("");
                }
                handleSuccess(cssText, i, node, location.href);
            } else {
                cssArray[i] = "";
                handleComplete();
            }
        });
    } else {
        settings.onComplete("", []);
    }
}

function getFullUrl(url) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base;
    a.href = url;
    return a.href;
}

function matchesSelector(elm, selector) {
    var matches = elm.matches || elm.matchesSelector || elm.webkitMatchesSelector || elm.mozMatchesSelector || elm.msMatchesSelector || elm.oMatchesSelector;
    return matches.call(elm, selector);
}

var balancedMatch = balanced;

function balanced(a, b, str) {
    if (a instanceof RegExp) a = maybeMatch(a, str);
    if (b instanceof RegExp) b = maybeMatch(b, str);
    var r = range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}

function maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}

balanced.range = range;

function range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        begs = [];
        left = str.length;
        while (i >= 0 && !result) {
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) {
                result = [ begs.pop(), bi ];
            } else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) {
            result = [ left, right ];
        }
    }
    return result;
}

function parseCss(css) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        onlyVars: false,
        removeComments: false
    };
    var settings = _extends({}, defaults, options);
    var errors = [];
    function error(msg) {
        throw new Error("CSS parse error: ".concat(msg));
    }
    function match(re) {
        var m = re.exec(css);
        if (m) {
            css = css.slice(m[0].length);
            return m;
        }
    }
    function open() {
        return match(/^{\s*/);
    }
    function close() {
        return match(/^}/);
    }
    function whitespace() {
        match(/^\s*/);
    }
    function comment() {
        whitespace();
        if (css[0] !== "/" || css[1] !== "*") {
            return;
        }
        var i = 2;
        while (css[i] && (css[i] !== "*" || css[i + 1] !== "/")) {
            i++;
        }
        if (!css[i]) {
            return error("end of comment is missing");
        }
        var str = css.slice(2, i);
        css = css.slice(i + 2);
        return {
            type: "comment",
            comment: str
        };
    }
    function comments() {
        var cmnts = [];
        var c;
        while (c = comment()) {
            cmnts.push(c);
        }
        return settings.removeComments ? [] : cmnts;
    }
    function selector() {
        whitespace();
        while (css[0] === "}") {
            error("extra closing bracket");
        }
        var m = match(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
        if (m) {
            return m[0].trim().replace(/\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(m) {
                return m.replace(/,/g, "‌");
            }).split(/\s*(?![^(]*\)),\s*/).map(function(s) {
                return s.replace(/\u200C/g, ",");
            });
        }
    }
    function declaration() {
        match(/^([;\s]*)+/);
        var comment_regexp = /\/\*[^*]*\*+([^\/*][^*]*\*+)*\//g;
        var prop = match(/^(\*?[-#\/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
        if (!prop) {
            return;
        }
        prop = prop[0].trim();
        if (!match(/^:\s*/)) {
            return error("property missing ':'");
        }
        var val = match(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/);
        var ret = {
            type: "declaration",
            property: prop.replace(comment_regexp, ""),
            value: val ? val[0].replace(comment_regexp, "").trim() : ""
        };
        match(/^[;\s]*/);
        return ret;
    }
    function declarations() {
        if (!open()) {
            return error("missing '{'");
        }
        var d;
        var decls = comments();
        while (d = declaration()) {
            decls.push(d);
            decls = decls.concat(comments());
        }
        if (!close()) {
            return error("missing '}'");
        }
        return decls;
    }
    function keyframe() {
        whitespace();
        var vals = [];
        var m;
        while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
            vals.push(m[1]);
            match(/^,\s*/);
        }
        if (vals.length) {
            return {
                type: "keyframe",
                values: vals,
                declarations: declarations()
            };
        }
    }
    function at_keyframes() {
        var m = match(/^@([-\w]+)?keyframes\s*/);
        if (!m) {
            return;
        }
        var vendor = m[1];
        m = match(/^([-\w]+)\s*/);
        if (!m) {
            return error("@keyframes missing name");
        }
        var name = m[1];
        if (!open()) {
            return error("@keyframes missing '{'");
        }
        var frame;
        var frames = comments();
        while (frame = keyframe()) {
            frames.push(frame);
            frames = frames.concat(comments());
        }
        if (!close()) {
            return error("@keyframes missing '}'");
        }
        return {
            type: "keyframes",
            name: name,
            vendor: vendor,
            keyframes: frames
        };
    }
    function at_page() {
        var m = match(/^@page */);
        if (m) {
            var sel = selector() || [];
            return {
                type: "page",
                selectors: sel,
                declarations: declarations()
            };
        }
    }
    function at_fontface() {
        var m = match(/^@font-face\s*/);
        if (m) {
            return {
                type: "font-face",
                declarations: declarations()
            };
        }
    }
    function at_supports() {
        var m = match(/^@supports *([^{]+)/);
        if (m) {
            return {
                type: "supports",
                supports: m[1].trim(),
                rules: rules()
            };
        }
    }
    function at_host() {
        var m = match(/^@host\s*/);
        if (m) {
            return {
                type: "host",
                rules: rules()
            };
        }
    }
    function at_media() {
        var m = match(/^@media *([^{]+)/);
        if (m) {
            return {
                type: "media",
                media: m[1].trim(),
                rules: rules()
            };
        }
    }
    function at_custom_m() {
        var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
        if (m) {
            return {
                type: "custom-media",
                name: m[1].trim(),
                media: m[2].trim()
            };
        }
    }
    function at_document() {
        var m = match(/^@([-\w]+)?document *([^{]+)/);
        if (m) {
            return {
                type: "document",
                document: m[2].trim(),
                vendor: m[1] ? m[1].trim() : null,
                rules: rules()
            };
        }
    }
    function at_x() {
        var m = match(/^@(import|charset|namespace)\s*([^;]+);/);
        if (m) {
            return {
                type: m[1],
                name: m[2].trim()
            };
        }
    }
    function at_rule() {
        whitespace();
        if (css[0] === "@") {
            var ret = at_keyframes() || at_supports() || at_host() || at_media() || at_custom_m() || at_page() || at_document() || at_fontface() || at_x();
            if (ret && settings.onlyVars) {
                var hasVarFunc = false;
                if (ret.declarations) {
                    hasVarFunc = ret.declarations.some(function(decl) {
                        return /var\(/.test(decl.value);
                    });
                } else {
                    var arr = ret.keyframes || ret.rules || [];
                    hasVarFunc = arr.some(function(obj) {
                        return (obj.declarations || []).some(function(decl) {
                            return /var\(/.test(decl.value);
                        });
                    });
                }
                return hasVarFunc ? ret : {};
            }
            return ret;
        }
    }
    function rule() {
        if (settings.onlyVars) {
            var balancedMatch$$1 = balancedMatch("{", "}", css);
            if (balancedMatch$$1) {
                var hasVarDecl = balancedMatch$$1.pre.indexOf(":root") !== -1 && /--\S*\s*:/.test(balancedMatch$$1.body);
                var hasVarFunc = /var\(/.test(balancedMatch$$1.body);
                if (!hasVarDecl && !hasVarFunc) {
                    css = css.slice(balancedMatch$$1.end + 1);
                    return {};
                }
            }
        }
        var sel = selector() || [];
        var decls = !settings.onlyVars ? declarations() : declarations().filter(function(decl) {
            var hasVarDecl = sel.some(function(s) {
                return s.indexOf(":root") !== -1;
            }) && /^--\S/.test(decl.property);
            var hasVarFunc = /var\(/.test(decl.value);
            return hasVarDecl || hasVarFunc;
        });
        if (!sel.length) {
            error("selector missing");
        }
        return {
            type: "rule",
            selectors: sel,
            declarations: decls
        };
    }
    function rules(core) {
        if (!core && !open()) {
            return error("missing '{'");
        }
        var node;
        var rules = comments();
        while (css.length && (core || css[0] !== "}") && (node = at_rule() || rule())) {
            if (node.type) {
                rules.push(node);
            }
            rules = rules.concat(comments());
        }
        if (!core && !close()) {
            return error("missing '}'");
        }
        return rules;
    }
    return {
        type: "stylesheet",
        stylesheet: {
            rules: rules(true),
            errors: errors
        }
    };
}

function stringifyCss(tree) {
    var delim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var renderMethods = {
        charset: function charset(node) {
            return "@charset " + node.name + ";";
        },
        comment: function comment(node) {
            return node.comment.indexOf("__CSSVARSPONYFILL") === 0 ? "/*" + node.comment + "*/" : "";
        },
        "custom-media": function customMedia(node) {
            return "@custom-media " + node.name + " " + node.media + ";";
        },
        declaration: function declaration(node) {
            return node.property + ":" + node.value + ";";
        },
        document: function document(node) {
            return "@" + (node.vendor || "") + "document " + node.document + "{" + visit(node.rules) + "}";
        },
        "font-face": function fontFace(node) {
            return "@font-face" + "{" + visit(node.declarations) + "}";
        },
        host: function host(node) {
            return "@host" + "{" + visit(node.rules) + "}";
        },
        import: function _import(node) {
            return "@import " + node.name + ";";
        },
        keyframe: function keyframe(node) {
            return node.values.join(",") + "{" + visit(node.declarations) + "}";
        },
        keyframes: function keyframes(node) {
            return "@" + (node.vendor || "") + "keyframes " + node.name + "{" + visit(node.keyframes) + "}";
        },
        media: function media(node) {
            return "@media " + node.media + "{" + visit(node.rules) + "}";
        },
        namespace: function namespace(node) {
            return "@namespace " + node.name + ";";
        },
        page: function page(node) {
            return "@page " + (node.selectors.length ? node.selectors.join(", ") : "") + "{" + visit(node.declarations) + "}";
        },
        rule: function rule(node) {
            var decls = node.declarations;
            if (decls.length) {
                return node.selectors.join(",") + "{" + visit(decls) + "}";
            }
        },
        supports: function supports(node) {
            return "@supports " + node.supports + "{" + visit(node.rules) + "}";
        }
    };
    function visit(nodes) {
        var buf = "";
        for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (cb) {
                cb(n);
            }
            var txt = renderMethods[n.type](n);
            if (txt) {
                buf += txt;
                if (txt.length && n.selectors) {
                    buf += delim;
                }
            }
        }
        return buf;
    }
    return visit(tree.stylesheet.rules);
}

function walkCss(node, fn) {
    node.rules.forEach(function(rule) {
        if (rule.rules) {
            walkCss(rule, fn);
            return;
        }
        if (rule.keyframes) {
            rule.keyframes.forEach(function(keyframe) {
                if (keyframe.type === "keyframe") {
                    fn(keyframe.declarations, rule);
                }
            });
            return;
        }
        if (!rule.declarations) {
            return;
        }
        fn(rule.declarations, node);
    });
}

var VAR_PROP_IDENTIFIER = "--";

var VAR_FUNC_IDENTIFIER = "var";

var variableStore = {
    dom: {},
    temp: {},
    user: {}
};

function transformVars(cssText) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        fixNestedCalc: true,
        onlyVars: false,
        persist: false,
        preserve: false,
        variables: {},
        onWarning: function onWarning() {}
    };
    var settings = _extends({}, defaults, options);
    var map = settings.persist ? variableStore.dom : variableStore.temp = JSON.parse(JSON.stringify(variableStore.dom));
    var cssTree = parseCss(cssText, {
        onlyVars: settings.onlyVars
    });
    cssTree.stylesheet.rules.forEach(function(rule) {
        var varNameIndices = [];
        if (rule.type !== "rule") {
            return;
        }
        if (rule.selectors.length !== 1 || rule.selectors[0] !== ":root") {
            return;
        }
        rule.declarations.forEach(function(decl, i) {
            var prop = decl.property;
            var value = decl.value;
            if (prop && prop.indexOf(VAR_PROP_IDENTIFIER) === 0) {
                map[prop] = value;
                varNameIndices.push(i);
            }
        });
        if (!settings.preserve) {
            for (var i = varNameIndices.length - 1; i >= 0; i--) {
                rule.declarations.splice(varNameIndices[i], 1);
            }
        }
    });
    Object.keys(variableStore.user).forEach(function(key) {
        map[key] = variableStore.user[key];
    });
    if (Object.keys(settings.variables).length) {
        var newRule = {
            declarations: [],
            selectors: [ ":root" ],
            type: "rule"
        };
        Object.keys(settings.variables).forEach(function(key) {
            var prop = "--".concat(key.replace(/^-+/, ""));
            var value = settings.variables[key];
            if (settings.persist) {
                variableStore.user[prop] = value;
            }
            if (map[prop] !== value) {
                map[prop] = value;
                newRule.declarations.push({
                    type: "declaration",
                    property: prop,
                    value: value
                });
            }
        });
        if (settings.preserve && newRule.declarations.length) {
            cssTree.stylesheet.rules.push(newRule);
        }
    }
    walkCss(cssTree.stylesheet, function(declarations, node) {
        var decl;
        var resolvedValue;
        var value;
        for (var i = 0; i < declarations.length; i++) {
            decl = declarations[i];
            value = decl.value;
            if (decl.type !== "declaration") {
                continue;
            }
            if (!value || value.indexOf(VAR_FUNC_IDENTIFIER + "(") === -1) {
                continue;
            }
            resolvedValue = resolveValue(value, map, settings);
            if (resolvedValue !== decl.value) {
                if (!settings.preserve) {
                    decl.value = resolvedValue;
                } else {
                    declarations.splice(i, 0, {
                        type: decl.type,
                        property: decl.property,
                        value: resolvedValue
                    });
                    i++;
                }
            }
        }
    });
    if (settings.fixNestedCalc) {
        fixNestedCalc(cssTree.stylesheet.rules);
    }
    return stringifyCss(cssTree);
}

function fixNestedCalc(rules) {
    var reCalcExp = /(-[a-z]+-)?calc\(/;
    rules.forEach(function(rule) {
        if (rule.declarations) {
            rule.declarations.forEach(function(decl) {
                var oldValue = decl.value;
                var newValue = "";
                while (reCalcExp.test(oldValue)) {
                    var rootCalc = balancedMatch("calc(", ")", oldValue || "");
                    oldValue = oldValue.slice(rootCalc.end);
                    while (reCalcExp.test(rootCalc.body)) {
                        var nestedCalc = balancedMatch(reCalcExp, ")", rootCalc.body);
                        rootCalc.body = "".concat(nestedCalc.pre, "(").concat(nestedCalc.body, ")").concat(nestedCalc.post);
                    }
                    newValue += "".concat(rootCalc.pre, "calc(").concat(rootCalc.body);
                    newValue += !reCalcExp.test(oldValue) ? ")".concat(rootCalc.post) : "";
                }
                decl.value = newValue || decl.value;
            });
        }
    });
}

function resolveValue(value, map) {
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var __recursiveFallback = arguments.length > 3 ? arguments[3] : undefined;
    if (value.indexOf("var(") === -1) {
        return value;
    }
    var valueData = balancedMatch("(", ")", value);
    function resolveFunc(value) {
        var name = value.split(",")[0].replace(/[\s\n\t]/g, "");
        var fallback = (value.match(/(?:\s*,\s*){1}(.*)?/) || [])[1];
        var match = map.hasOwnProperty(name) ? String(map[name]) : undefined;
        var replacement = match || (fallback ? String(fallback) : undefined);
        var unresolvedFallback = __recursiveFallback || value;
        if (!match) {
            settings.onWarning('variable "'.concat(name, '" is undefined'));
        }
        if (replacement && replacement !== "undefined" && replacement.length > 0) {
            return resolveValue(replacement, map, settings, unresolvedFallback);
        } else {
            return "var(".concat(unresolvedFallback, ")");
        }
    }
    if (!valueData) {
        if (value.indexOf("var(") !== -1) {
            settings.onWarning('missing closing ")" in the value "'.concat(value, '"'));
        }
        return value;
    } else if (valueData.pre.slice(-3) === "var") {
        var isEmptyVarFunc = valueData.body.trim().length === 0;
        if (isEmptyVarFunc) {
            settings.onWarning("var() must contain a non-whitespace string");
            return value;
        } else {
            return valueData.pre.slice(0, -3) + resolveFunc(valueData.body) + resolveValue(valueData.post, map, settings);
        }
    } else {
        return valueData.pre + "(".concat(resolveValue(valueData.body, map, settings), ")") + resolveValue(valueData.post, map, settings);
    }
}

var name = "css-vars-ponyfill";

var isBrowser = typeof window !== "undefined";

var isNativeSupport = isBrowser && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)");

var consoleMsgPrefix = "cssVars(): ";

var defaults = {
    rootElement: isBrowser ? document : null,
    shadowDOM: false,
    include: "style,link[rel=stylesheet]",
    exclude: "",
    variables: {},
    fixNestedCalc: true,
    onlyLegacy: true,
    onlyVars: false,
    preserve: false,
    silent: false,
    updateDOM: true,
    updateURLs: true,
    watch: null,
    onBeforeSend: function onBeforeSend() {},
    onSuccess: function onSuccess() {},
    onWarning: function onWarning() {},
    onError: function onError() {},
    onComplete: function onComplete() {}
};

var regex = {
    cssComments: /\/\*[\s\S]+?\*\//g,
    cssKeyframes: /@(?:-\w*-)?keyframes/,
    cssRootRules: /(?::root\s*{\s*[^}]*})/g,
    cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
    cssVars: /(?:(?::root\s*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
};

var cssVarsObserver = null;

var debounceTimer = null;

var isShadowDOMReady = false;

/**
 * Fetches, parses, and transforms CSS custom properties from specified
 * <style> and <link> elements into static values, then appends a new <style>
 * element with static values to the DOM to provide CSS custom property
 * compatibility for legacy browsers. Also provides a single interface for
 * live updates of runtime values in both modern and legacy browsers.
 *
 * @preserve
 * @param {object}   [options] Options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes.
 * @param {boolean}  [options.shadowDOM=false] Determines if shadow DOM <link>
 *                   and <style> nodes will be processed.
 * @param {string}   [options.include="style,link[rel=stylesheet]"] CSS selector
 *                   matching <link re="stylesheet"> and <style> nodes to
 *                   process
 * @param {string}   [options.exclude] CSS selector matching <link
 *                   rel="stylehseet"> and <style> nodes to exclude from those
 *                   matches by options.include
 * @param {object}   [options.variables] A map of custom property name/value
 *                   pairs. Property names can omit or include the leading
 *                   double-hyphen (—), and values specified will override
 *                   previous values.
 * @param {boolean}  [options.fixNestedCalc=true] Removes nested 'calc' keywords
 *                   for legacy browser compatibility.
 * @param {boolean}  [options.onlyLegacy=true] Determines if the ponyfill will
 *                   only generate legacy-compatible CSS in browsers that lack
 *                   native support (i.e., legacy browsers)
 * @param {boolean}  [options.onlyVars=false] Determines if CSS rulesets and
 *                   declarations without a custom property value should be
 *                   removed from the ponyfill-generated CSS
 * @param {boolean}  [options.preserve=false] Determines if the original CSS
 *                   custom property declaration will be retained in the
 *                   ponyfill-generated CSS.
 * @param {boolean}  [options.silent=false] Determines if warning and error
 *                   messages will be displayed on the console
 * @param {boolean}  [options.updateDOM=true] Determines if the ponyfill will
 *                   update the DOM after processing CSS custom properties
 * @param {boolean}  [options.updateURLs=true] Determines if the ponyfill will
 *                   convert relative url() paths to absolute urls.
 * @param {boolean}  [options.watch=false] Determines if a MutationObserver will
 *                   be created that will execute the ponyfill when a <link> or
 *                   <style> DOM mutation is observed.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback after CSS data has been
 *                   collected from each node and before CSS custom properties
 *                   have been transformed. Allows modifying the CSS data before
 *                   it is transformed by returning any string value (or false
 *                   to skip). Passes 1) CSS text, 2) source node reference, and
 *                   3) the source URL as arguments.
 * @param {function} [options.onWarning] Callback after each CSS parsing warning
 *                   has occurred. Passes 1) a warning message as an argument.
 * @param {function} [options.onError] Callback after a CSS parsing error has
 *                   occurred or an XHR request has failed. Passes 1) an error
 *                   message, and 2) source node reference, 3) xhr, and 4 url as
 *                   arguments.
 * @param {function} [options.onComplete] Callback after all CSS has been
 *                   processed, legacy-compatible CSS has been generated, and
 *                   (optionally) the DOM has been updated. Passes 1) a CSS
 *                   string with CSS variable values resolved, 2) a reference to
 *                   the appended <style> node, 3) an object containing all
 *                   custom properies names and values, and 4) the ponyfill
 *                   execution time in milliseconds.
 *
 * @example
 *
 *   cssVars({
 *     rootElement  : document,
 *     shadowDOM    : false,
 *     include      : 'style,link[rel="stylesheet"]',
 *     exclude      : '',
 *     variables    : {},
 *     fixNestedCalc: true,
 *     onlyLegacy   : true,
 *     onlyVars     : false,
 *     preserve     : false,
 *     silent       : false,
 *     updateDOM    : true,
 *     updateURLs   : true,
 *     watch        : false,
 *     onBeforeSend(xhr, node, url) {},
 *     onSuccess(cssText, node, url) {},
 *     onWarning(message) {},
 *     onError(message, node, xhr, url) {},
 *     onComplete(cssText, styleNode, cssVariables, benchmark) {}
 *   });
 */ function cssVars() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var settings = _extends({}, defaults, options);
    var styleNodeId = name;
    settings.exclude = "#".concat(styleNodeId) + (settings.exclude ? ",".concat(settings.exclude) : "");
    settings._benchmark = !settings._benchmark ? getTimeStamp() : settings._benchmark;
    function handleError(message, sourceNode, xhr, url) {
        if (!settings.silent) {
            console.error("".concat(consoleMsgPrefix).concat(message, "\n"), sourceNode);
        }
        settings.onError(message, sourceNode, xhr, url);
    }
    function handleWarning(message) {
        if (!settings.silent) {
            console.warn("".concat(consoleMsgPrefix).concat(message));
        }
        settings.onWarning(message);
    }
    if (!isBrowser) {
        return;
    }
    if (settings.watch === false && cssVarsObserver) {
        cssVarsObserver.disconnect();
    }
    if (settings.watch) {
        addMutationObserver(settings, styleNodeId);
        cssVarsDebounced(settings);
    } else if (document.readyState !== "loading") {
        var isShadowElm = settings.shadowDOM || settings.rootElement.shadowRoot || settings.rootElement.host;
        if (isNativeSupport && settings.onlyLegacy) {
            if (settings.updateDOM) {
                var targetElm = settings.rootElement.host || (settings.rootElement === document ? document.documentElement : settings.rootElement);
                Object.keys(settings.variables).forEach(function(key) {
                    var prop = "--".concat(key.replace(/^-+/, ""));
                    var value = settings.variables[key];
                    targetElm.style.setProperty(prop, value);
                });
            }
        } else if (isShadowElm && !isShadowDOMReady) {
            getCssData({
                rootElement: defaults.rootElement,
                include: defaults.include,
                exclude: settings.exclude,
                onSuccess: function onSuccess(cssText, node, url) {
                    var cssRootDecls = (cssText.match(regex.cssRootRules) || []).join("");
                    return cssRootDecls || false;
                },
                onComplete: function onComplete(cssText, cssArray, nodeArray) {
                    transformVars(cssText, {
                        persist: true
                    });
                    isShadowDOMReady = true;
                    cssVars(settings);
                }
            });
        } else {
            getCssData({
                rootElement: settings.rootElement,
                include: settings.include,
                exclude: settings.exclude,
                filter: settings.onlyVars ? regex.cssVars : null,
                onBeforeSend: settings.onBeforeSend,
                onSuccess: function onSuccess(cssText, node, url) {
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal !== undefined && Boolean(returnVal) === false ? "" : returnVal || cssText;
                    node.setAttribute("data-cssvars", "");
                    if (settings.updateURLs) {
                        var cssUrls = cssText.replace(regex.cssComments, "").match(regex.cssUrls) || [];
                        cssUrls.forEach(function(cssUrl) {
                            var oldUrl = cssUrl.replace(regex.cssUrls, "$1");
                            var newUrl = getFullUrl$1(oldUrl, url);
                            cssText = cssText.replace(cssUrl, cssUrl.replace(oldUrl, newUrl));
                        });
                    }
                    return cssText;
                },
                onError: function onError(xhr, node, url) {
                    var responseUrl = xhr.responseURL || getFullUrl$1(url, location.href);
                    var statusText = xhr.statusText ? "(".concat(xhr.statusText, ")") : "Unspecified Error" + (xhr.status === 0 ? " (possibly CORS related)" : "");
                    var errorMsg = "CSS XHR Error: ".concat(responseUrl, " ").concat(xhr.status, " ").concat(statusText);
                    handleError(errorMsg, node, xhr, responseUrl);
                },
                onComplete: function onComplete(cssText, cssArray, nodeArray) {
                    var cssMarker = /\/\*__CSSVARSPONYFILL-(\d+)__\*\//g;
                    var cssSettings = JSON.stringify({
                        include: settings.include,
                        exclude: settings.exclude,
                        variables: settings.variables,
                        fixNestedCalc: settings.fixNestedCalc,
                        onlyVars: settings.onlyVars,
                        preserve: settings.preserve,
                        silent: settings.silent,
                        updateURLs: settings.updateURLs
                    });
                    var styleNode = settings.rootElement.querySelector("#".concat(styleNodeId)) || document.createElement("style");
                    var prevData = styleNode.__cssVars || {};
                    var isSameData = prevData.cssText === cssText && prevData.settings === cssSettings;
                    var hasKeyframesWithVars;
                    if (isSameData) {
                        cssText = styleNode.textContent;
                        if (!settings.silent) {
                            console.info("".concat(consoleMsgPrefix, "No changes"), styleNode);
                        }
                    } else {
                        styleNode.__cssVars = {
                            cssText: cssText,
                            settings: cssSettings
                        };
                        cssText = cssArray.map(function(css, i) {
                            return regex.cssVars.test(css) ? css : "/*__CSSVARSPONYFILL-".concat(i, "__*/");
                        }).join("");
                        try {
                            cssText = transformVars(cssText, {
                                fixNestedCalc: settings.fixNestedCalc,
                                onlyVars: settings.onlyVars,
                                persist: settings.updateDOM,
                                preserve: settings.preserve,
                                variables: settings.variables,
                                onWarning: handleWarning
                            });
                            hasKeyframesWithVars = regex.cssKeyframes.test(cssText);
                            cssText = cssText.replace(cssMarker, function(match, group1) {
                                return cssArray[group1];
                            });
                        } catch (err) {
                            var errorThrown = false;
                            cssArray.forEach(function(cssText, i) {
                                try {
                                    cssText = transformVars(cssText, settings);
                                } catch (err) {
                                    var errorNode = nodeArray[i - 0];
                                    errorThrown = true;
                                    handleError(err.message, errorNode);
                                }
                            });
                            if (!errorThrown) {
                                handleError(err.message || err);
                            }
                        }
                    }
                    if (settings.shadowDOM) {
                        var elms = [ settings.rootElement ].concat(_toConsumableArray(settings.rootElement.querySelectorAll("*")));
                        for (var i = 0, elm; elm = elms[i]; ++i) {
                            if (elm.shadowRoot && elm.shadowRoot.querySelector("style")) {
                                var shadowSettings = _extends({}, settings, {
                                    rootElement: elm.shadowRoot,
                                    variables: variableStore.dom
                                });
                                cssVars(shadowSettings);
                            }
                        }
                    }
                    if (!isSameData && nodeArray && nodeArray.length) {
                        var cssNodes = settings.rootElement.querySelectorAll("link[data-cssvars],style[data-cssvars]") || settings.rootElement.querySelectorAll('link[rel+="stylesheet"],style');
                        var lastNode = cssNodes ? cssNodes[cssNodes.length - 1] : null;
                        if (lastNode) {
                            lastNode.parentNode.insertBefore(styleNode, lastNode.nextSibling);
                        } else {
                            var targetNode = settings.rootElement.head || settings.rootElement.body || settings.rootElement;
                            targetNode.appendChild(styleNode);
                        }
                        if (settings.updateDOM) {
                            styleNode.setAttribute("id", styleNodeId);
                            styleNode.textContent = cssText;
                            if (hasKeyframesWithVars) {
                                fixKeyframes(settings.rootElement);
                            }
                        }
                        settings.onComplete(cssText, styleNode, JSON.parse(JSON.stringify(settings.updateDOM ? variableStore.dom : variableStore.temp)), getTimeStamp() - settings._benchmark);
                    }
                }
            });
        }
    } else {
        document.addEventListener("DOMContentLoaded", function init(evt) {
            cssVars(options);
            document.removeEventListener("DOMContentLoaded", init);
        });
    }
}

function cssVarsDebounced(settings) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
        settings._benchmark = null;
        cssVars(settings);
    }, 100);
}

function addMutationObserver(settings, ignoreId) {
    if (!window.MutationObserver) {
        return;
    }
    var isLink = function isLink(node) {
        return node.tagName === "LINK" && (node.getAttribute("rel") || "").indexOf("stylesheet") !== -1;
    };
    var isStyle = function isStyle(node) {
        return node.tagName === "STYLE" && (ignoreId ? node.id !== ignoreId : true);
    };
    if (cssVarsObserver) {
        cssVarsObserver.disconnect();
    }
    settings.watch = defaults.watch;
    cssVarsObserver = new MutationObserver(function(mutations) {
        var hasCSSMutation = mutations.some(function(mutation) {
            var isCSSMutation = false;
            if (mutation.type === "attributes") {
                isCSSMutation = isLink(mutation.target) || isStyle(mutation.target);
            } else if (mutation.type === "childList") {
                var addedNodes = Array.apply(null, mutation.addedNodes);
                var removedNodes = Array.apply(null, mutation.removedNodes);
                isCSSMutation = [].concat(addedNodes, removedNodes).some(function(node) {
                    var isValidLink = isLink(node) && !node.disabled;
                    var isValidStyle = isStyle(node) && regex.cssVars.test(node.textContent);
                    return isValidLink || isValidStyle;
                });
            }
            return isCSSMutation;
        });
        if (hasCSSMutation) {
            cssVarsDebounced(settings);
        }
    });
    cssVarsObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [ "disabled", "href" ],
        childList: true,
        subtree: true
    });
}

function fixKeyframes(rootElement) {
    var animationNameProp = [ "animation-name", "-moz-animation-name", "-webkit-animation-name" ].filter(function(prop) {
        return getComputedStyle(document.body)[prop];
    })[0];
    if (animationNameProp) {
        var allNodes = rootElement.getElementsByTagName("*");
        var keyframeNodes = [];
        var nameMarker = "__CSSVARSPONYFILL-KEYFRAMES__";
        for (var i = 0, len = allNodes.length; i < len; i++) {
            var node = allNodes[i];
            var animationName = getComputedStyle(node)[animationNameProp];
            if (animationName !== "none") {
                node.style[animationNameProp] += nameMarker;
                keyframeNodes.push(node);
            }
        }
        void document.body.offsetHeight;
        for (var _i = 0, _len = keyframeNodes.length; _i < _len; _i++) {
            var nodeStyle = keyframeNodes[_i].style;
            nodeStyle[animationNameProp] = nodeStyle[animationNameProp].replace(nameMarker, "");
        }
    }
}

function getFullUrl$1(url) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base;
    a.href = url;
    return a.href;
}

function getTimeStamp() {
    return isBrowser && (window.performance || {}).now ? window.performance.now() : new Date().getTime();
}

/* harmony default export */ __webpack_exports__["a"] = (cssVars);
//# sourceMappingURL=css-vars-ponyfill.esm.js.map


/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dark.css": [
		584
	],
	"./light.css": [
		2566,
		18
	],
	"./variables.css": [
		583
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1191;
module.exports = webpackAsyncContext;

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_redux_actions_wsConnectionActions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_queryParamsHelper__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_redux_actions_lifeCycleActions__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layouts_StandAloneLayout_StandAloneLayout__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_theme_dark_css__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_theme_dark_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_theme_dark_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_SignupPage__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_ProblemLoggingInPage__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_apex_web_lib_components_DepositConfirmation_DepositConfirmationModalContainer__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apex_web_lib_components_APSnackbar_APSnackbarContainer__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apex_web_lib_components_TwoFactorAuthForm_TwoFactorAuthFormContainer__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apex_web_lib_components_common_SidePane_SidePaneContainer__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apex_web_lib_helpers_emailLinksHelper__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_apex_web_lib_layouts_EmailLinksLayout_js__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_InteriorPage__ = __webpack_require__(2492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_apex_web_lib_components_Login_StandaloneLoginFormContainer__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_apex_web_lib_helpers_wsHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_apex_web_lib_hocs_redirectIfAuthorized__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Exchange_SimpleExchangePage__ = __webpack_require__(2546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_apex_web_lib_components_2FA_TwoFactorAuthContainer__ = __webpack_require__(2548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_apex_web_lib_components_EnableTwoFactorAuth_StandaloneEnable2FAModalContainer__ = __webpack_require__(2551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_LandingPage_LandingPage__ = __webpack_require__(2552);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable import/first */var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));var gateway=Object(__WEBPACK_IMPORTED_MODULE_20_apex_web_lib_helpers_wsHelper__["a" /* getGateway */])();if(gateway){Object(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_apex__["d" /* setGateway */])(gateway);Object(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_apex__["c" /* initApex */])(_this.props.connectionOpened,_this.props.connectionClosed);}var AffiliateTag=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_queryParamsHelper__["a" /* getQueryParam */])('aff');if(AffiliateTag){window.localStorage.setItem('affiliateTag',AffiliateTag);}return _this;}_createClass(App,[{key:'render',value:function render(){var pathname=this.props.location.pathname;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App fluid container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/version',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'v3implementation-template: ',__WEBPACK_IMPORTED_MODULE_1__package_json___default.a.version),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'apex-web: ',__WEBPACK_IMPORTED_MODULE_1__package_json___default.a.dependencies['apex-web']));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_26__pages_LandingPage_LandingPage__["a" /* default */]}),Object(__WEBPACK_IMPORTED_MODULE_16_apex_web_lib_helpers_emailLinksHelper__["f" /* emailLinkRoutes */])(pathname,__WEBPACK_IMPORTED_MODULE_17_apex_web_lib_layouts_EmailLinksLayout_js__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/login',component:Object(__WEBPACK_IMPORTED_MODULE_21_apex_web_lib_hocs_redirectIfAuthorized__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_19_apex_web_lib_components_Login_StandaloneLoginFormContainer__["a" /* default */],"/dashboard")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/signup',component:__WEBPACK_IMPORTED_MODULE_10__pages_SignupPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/problem-logging-in',component:__WEBPACK_IMPORTED_MODULE_11__pages_ProblemLoggingInPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/twofactorauth',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__layouts_StandAloneLayout_StandAloneLayout__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_apex_web_lib_components_TwoFactorAuthForm_TwoFactorAuthFormContainer__["a" /* default */],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/enabletwofactorauth',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_apex_web_lib_components_EnableTwoFactorAuth_StandaloneEnable2FAModalContainer__["a" /* default */],null);}}),__WEBPACK_IMPORTED_MODULE_23__config__["default"].SimpleExchange.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__config__["default"].SimpleExchange.route,component:__WEBPACK_IMPORTED_MODULE_22__pages_Exchange_SimpleExchangePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_InteriorPage__["a" /* default */],{location:this.props.location}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_apex_web_lib_components_APSnackbar_APSnackbarContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_apex_web_lib_components_common_SidePane_SidePaneContainer__["a" /* default */],{options:{ReportBlockTrade:{useNewForm:true}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_apex_web_lib_components_DepositConfirmation_DepositConfirmationModalContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_apex_web_lib_components_2FA_TwoFactorAuthContainer__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps={onInit:__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_redux_actions_lifeCycleActions__["b" /* onInit */],connectionOpened:__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_redux_actions_wsConnectionActions__["g" /* connectionOpened */],connectionClosed:__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_redux_actions_wsConnectionActions__["e" /* connectionClosed */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(null,mapDispatchToProps)(App)));

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports = {"name":"apex-web-implementation-template","version":"0.0.165","dependencies":{"alphapoint":"3.2.16","apex-chart-react":"0.4.3","apex-web":"0.4.139","bignumber.js":"7.0.2","classnames":"^2.2.5","coinslot":"^1.1.0","cross-fetch":"^2.1.0","crypto-js":"^3.1.9-1","css-vars-ponyfill":"^1.15.3","date-fns":"^1.29.0","detect-emoji-support":"^0.1.5","husky":"^0.14.3","jstimezonedetect":"^1.0.6","libphonenumber-js":"^1.5.1","lint-staged":"^6.1.1","numeral":"^2.0.6","parse-decimal-number":"^1.0.0","qrcode.react":"^0.8.0","react":"^16.11.0","react-bem-helper":"^1.4.1","react-dom":"^16.11.0","react-inlinesvg":"^0.8.1","react-input-mask":"^2.0.4","react-loadable":"^5.4.0","react-modal":"^3.6.1","react-phone-number-input":"^2.2.14","react-redux":"^5.0.7","react-redux-snackbar":"^1.1.0","react-router-dom":"^5.1.2","react-scripts":"1.1.5","react-sliding-pane":"^2.1.1","react-table":"^6.8.6","redux":"^3.7.2","redux-form":"^7.3.0","redux-i18n":"^1.5.14","redux-logger":"^3.0.6","redux-thunk":"^2.2.0","reselect":"^3.0.1"},"lint-staged":{"src/**/*.{js,jsx,json}":["prettier --write --single-quote --jsx-bracket-same-line","git add"]},"scripts":{"precommit":"lint-staged","start":"react-scripts start","react-scripts-build":"react-scripts build && npm run write-version-file","build":"node ./scripts/build.js","build-static-ci":"node ./scripts/build.js&&npm run build-rename&&cp -R build/static ../npm","build-static":"GENERATE_SOURCEMAP=false PUBLIC_URL=/ node ./scripts/build.js&&npm run build-rename&&cp -R build/static ../npm","build-rename":"npm run build-rename-js&&npm run build-rename-css&&npm run build-fix-html&&npm run build-fix-web-config&&rehype build/index.html --output build/index.html --use rehype-format","build-rename-js":"renamer --find \"/main\\.[^\\.]+\\./\" --replace \"main.\" build/static/js/*","build-rename-css":"renamer --find \"/main\\.[^\\.]+\\./\" --replace \"main.\" build/static/css/*","build-fix-html":"replace \"main(\\.[^\\.]+)\" \"main\" --path-element name build/index.html","build-fix-web-config":"replace \"/web/\" \"/\" --path-element name build/Web.config","lib":"rm -rf lib && cross-env NODE_ENV=production babel src --out-dir lib --copy-files --ignore __tests__,spec.js,test.js,__snapshots__","test":"react-scripts test --env=jsdom","coverage":"npm test -- --coverage","eject":"react-scripts eject","extract":"i18n_extract","import":"i18n_import --translations=src/translations","analyze":"source-map-explorer build/static/js/main.*","prepublishOnly":"npm run lib","write-version-file":"node scripts/versionFileGenerator.js","upgrade-awt":"node scripts/upgrade-awt.js"},"devDependencies":{"babel-cli":"^6.26.0","cross-env":"^5.2.0","enzyme":"^3.7.0","enzyme-adapter-react-16":"^1.6.0","fs-extra":"^7.0.0","ftp-deploy":"^2.1.3","prettier":"1.13.7","redux-mock-store":"^1.5.1","rehype-cli":"^6.0.0","rehype-format":"^2.3.0","renamer":"^1.0.0","replace":"^1.0.0","shelljs":"^0.8.2","source-map-explorer":"^1.5.0"},"files":["lib"],"publishConfig":{"registry":"http://nexus.alphapoint.com:8087/repository/npm-private/"}}

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQueryParam; });
var getQueryParam=function getQueryParam(name){var url=window.location.href;var regex=new RegExp('[?&]'+name+'(=([^&#]*)|&|#|$)');var results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g,' '));};

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(336),
    castPath = __webpack_require__(133),
    isIndex = __webpack_require__(245),
    isObject = __webpack_require__(67),
    toKey = __webpack_require__(135);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67),
    isPrototype = __webpack_require__(247),
    nativeKeysIn = __webpack_require__(1197);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var
  cleanURL = __webpack_require__(1199),
  XHR = __webpack_require__(1200),
  delay = __webpack_require__(1201),
  RequestError = __webpack_require__(1202),
  Response = __webpack_require__(589),
  Request = __webpack_require__(590),
  extend = __webpack_require__(341),
  once = __webpack_require__(592);

var i,
    createError = RequestError.create;

function factory(defaults, plugins) {
  defaults = defaults || {};
  plugins = plugins || [];

  function http(req, cb) {
    var xhr, plugin, done, k, timeoutId, supportsLoadAndErrorEvents;

    req = new Request(extend(defaults, req));

    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.processRequest) {
        plugin.processRequest(req);
      }
    }

    // Give the plugins a chance to create the XHR object
    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.createXHR) {
        xhr = plugin.createXHR(req);
        break; // First come, first serve
      }
    }
    xhr = xhr || new XHR();

    req.xhr = xhr;

    // Use a single completion callback. This can be called with or without
    // an error. If no error is passed, the request will be examined to see
    // if it was successful.
    done = once(delay(function(rawError) {
      clearTimeout(timeoutId);
      xhr.onload = xhr.onerror = xhr.onabort = xhr.onreadystatechange = xhr.ontimeout = xhr.onprogress = null;

      var err = getError(req, rawError);

      var res = err || Response.fromRequest(req);
      for (i = 0; i < plugins.length; i++) {
        plugin = plugins[i];
        if (plugin.processResponse) {
          plugin.processResponse(res);
        }
      }

      // Invoke callbacks
      if (err && req.onerror) req.onerror(err);
      if (!err && req.onload) req.onload(res);
      if (cb) cb(err, err ? undefined : res);

    }));

    supportsLoadAndErrorEvents = ('onload' in xhr) && ('onerror' in xhr);
    xhr.onload = function() { done(); };
    xhr.onerror = done;
    xhr.onabort = function() { done(); };

    // We'd rather use `onload`, `onerror`, and `onabort` since they're the
    // only way to reliably detect successes and failures but, if they
    // aren't available, we fall back to using `onreadystatechange`.
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;

      if (req.aborted) return done();

      if (!supportsLoadAndErrorEvents) {
        // Assume a status of 0 is an error. This could be a false
        // positive, but there's no way to tell when using
        // `onreadystatechange` ):
        // See matthewwithanm/react-inlinesvg#10.

        // Some browsers don't like you reading XHR properties when the
        // XHR has been aborted. In case we've gotten here as a result
        // of that (either our calling `about()` in the timeout handler
        // or the user calling it directly even though they shouldn't),
        // be careful about accessing it.
        var status;
        try {
          status = xhr.status;
        } catch (err) {}
        var err = status === 0 ? new Error('Internal XHR Error') : null;
        return done(err);
      }
    };

    // IE sometimes fails if you don't specify every handler.
    // See http://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
    xhr.ontimeout = function() { /* noop */ };
    xhr.onprogress = function() { /* noop */ };

    xhr.open(req.method, req.url);

    if (req.timeout) {
      // If we use the normal XHR timeout mechanism (`xhr.timeout` and
      // `xhr.ontimeout`), `onreadystatechange` will be triggered before
      // `ontimeout`. There's no way to recognize that it was triggered by
      // a timeout, and we'd be unable to dispatch the right error.
      timeoutId = setTimeout(function() {
        req.timedOut = true;
        done();
        try {
          xhr.abort();
        } catch (err) {}
      }, req.timeout);
    }

    for (k in req.headers) {
      if (req.headers.hasOwnProperty(k)) {
        xhr.setRequestHeader(k, req.headers[k]);
      }
    }

    xhr.send(req.body);

    return req;
  }

  var method,
    methods = ['get', 'post', 'put', 'head', 'patch', 'delete'],
    verb = function(method) {
      return function(req, cb) {
        req = new Request(req);
        req.method = method;
        return http(req, cb);
      };
    };
  for (i = 0; i < methods.length; i++) {
    method = methods[i];
    http[method] = verb(method);
  }

  http.plugins = function() {
    return plugins;
  };

  http.defaults = function(newValues) {
    if (newValues) {
      return factory(extend(defaults, newValues), plugins);
    }
    return defaults;
  };

  http.use = function() {
    var newPlugins = Array.prototype.slice.call(arguments, 0);
    return factory(defaults, plugins.concat(newPlugins));
  };

  http.bare = function() {
    return factory();
  };

  http.Request = Request;
  http.Response = Response;
  http.RequestError = RequestError;

  return http;
}

module.exports = factory({}, [cleanURL]);

/**
 * Analyze the request to see if it represents an error. If so, return it! An
 * original error object can be passed as a hint.
 */
function getError(req, err) {
  if (req.aborted) return createError('Request aborted', req, {name: 'Abort'});

  if (req.timedOut) return createError('Request timeout', req, {name: 'Timeout'});

  var xhr = req.xhr;
  var type = Math.floor(xhr.status / 100);

  var kind;
  switch (type) {
    case 0:
    case 2:
      // These don't represent errors unless the function was passed an
      // error object explicitly.
      if (!err) return;
      return createError(err.message, req);
    case 4:
      // Sometimes 4XX statuses aren't errors.
      if (xhr.status === 404 && !req.errorOn404) return;
      kind = 'Client';
      break;
    case 5:
      kind = 'Server';
      break;
    default:
      kind = 'HTTP';
  }
  var msg = kind + ' Error: ' +
        'The server returned a status of ' + xhr.status +
        ' for the request "' +
        req.method.toUpperCase() + ' ' + req.url + '"';
  return createError(msg, req);
}


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  processRequest: function(req) {
    req.url = req.url.replace(/[^%]+/g, function(s) {
      return encodeURI(s);
    });
  }
};


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports = window.XMLHttpRequest;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Wrap a function in a `setTimeout` call. This is used to guarantee async
// behavior, which can avoid unexpected errors.

module.exports = function(fn) {
  return function() {
    var
      args = Array.prototype.slice.call(arguments, 0),
      newFunc = function() {
        return fn.apply(null, args);
      };
    setTimeout(newFunc, 0);
  };
};


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Response = __webpack_require__(589);
var extractResponseProps = __webpack_require__(591);
var extend = __webpack_require__(341);

function RequestError(message, props) {
  var err = new Error(message);
  err.name = 'RequestError';
  this.name = err.name;
  this.message = err.message;
  if (err.stack) {
    this.stack = err.stack;
  }

  this.toString = function() {
    return this.message;
  };

  for (var k in props) {
    if (props.hasOwnProperty(k)) {
      this[k] = props[k];
    }
  }
}

RequestError.prototype = extend(Error.prototype);
RequestError.prototype.constructor = RequestError;

RequestError.create = function(message, req, props) {
  var err = new RequestError(message, props);
  Response.call(err, extractResponseProps(req));
  return err;
};

module.exports = RequestError;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var
  urllite = __webpack_require__(1204),
  once = __webpack_require__(592);

var warningShown = false;

var supportsXHR = once(function() {
  return (
    typeof window !== 'undefined' &&
    window !== null &&
    window.XMLHttpRequest &&
    'withCredentials' in new window.XMLHttpRequest()
  );
});

// This plugin creates a Microsoft `XDomainRequest` in supporting browsers when
// the URL being requested is on a different domain. This is necessary to
// support IE9, which only supports CORS via its proprietary `XDomainRequest`
// object. We need to check the URL because `XDomainRequest` *doesn't* work for
// same domain requests (unless your server sends CORS headers).
// `XDomainRequest` also has other limitations (no custom headers), so we try to
// catch those and error.
module.exports = {
  createXHR: function(req) {
    var a, b, k;

    if (typeof window === 'undefined' || window === null) {
      return;
    }

    a = urllite(req.url);
    b = urllite(window.location.href);

    // Don't do anything for same-domain requests.
    if (!a.host) {
      return;
    }
    if (a.protocol === b.protocol && a.host === b.host && a.port === b.port) {
      return;
    }

    // Show a warning if there are custom headers. We do this even in
    // browsers that won't use XDomainRequest so that users know there's an
    // issue right away, instead of if/when they test in IE9.
    if (!warningShown && req.headers) {
      for (k in req.headers) {
        if (req.headers.hasOwnProperty(k)) {
          warningShown = true;
          if (window && window.console && window.console.warn) {
            window.console.warn('Request headers are ignored in old IE when using the oldiexdomain plugin.');
          }
          break;
        }
      }
    }

    // Don't do anything if we can't do anything (:
    // Don't do anything if the browser supports proper XHR.
    if (window.XDomainRequest && !supportsXHR()) {
      // We've come this far. Might as well make an XDomainRequest.
      var xdr = new window.XDomainRequest();
      xdr.setRequestHeader = function() {}; // Ignore request headers.
      return xdr;
    }
  }
};


/***/ }),
/* 1204 */
/***/ (function(module, exports) {

(function() {
  var URL, URL_PATTERN, defaults, urllite,
    __hasProp = {}.hasOwnProperty;

  URL_PATTERN = /^(?:(?:([^:\/?\#]+:)\/+|(\/\/))(?:([a-z0-9-\._~%]+)(?::([a-z0-9-\._~%]+))?@)?(([a-z0-9-\._~%!$&'()*+,;=]+)(?::([0-9]+))?)?)?([^?\#]*?)(\?[^\#]*)?(\#.*)?$/;

  urllite = function(raw, opts) {
    return urllite.URL.parse(raw, opts);
  };

  urllite.URL = URL = (function() {
    function URL(props) {
      var k, v, _ref;
      for (k in defaults) {
        if (!__hasProp.call(defaults, k)) continue;
        v = defaults[k];
        this[k] = (_ref = props[k]) != null ? _ref : v;
      }
      this.host || (this.host = this.hostname && this.port ? "" + this.hostname + ":" + this.port : this.hostname ? this.hostname : '');
      this.origin || (this.origin = this.protocol ? "" + this.protocol + "//" + this.host : '');
      this.isAbsolutePathRelative = !this.host && this.pathname.charAt(0) === '/';
      this.isPathRelative = !this.host && this.pathname.charAt(0) !== '/';
      this.isRelative = this.isSchemeRelative || this.isAbsolutePathRelative || this.isPathRelative;
      this.isAbsolute = !this.isRelative;
    }

    URL.parse = function(raw) {
      var m, pathname, protocol;
      m = raw.toString().match(URL_PATTERN);
      pathname = m[8] || '';
      protocol = m[1];
      return new urllite.URL({
        protocol: protocol,
        username: m[3],
        password: m[4],
        hostname: m[6],
        port: m[7],
        pathname: protocol && pathname.charAt(0) !== '/' ? "/" + pathname : pathname,
        search: m[9],
        hash: m[10],
        isSchemeRelative: m[2] != null
      });
    };

    return URL;

  })();

  defaults = {
    protocol: '',
    username: '',
    password: '',
    host: '',
    hostname: '',
    port: '',
    pathname: '',
    search: '',
    hash: '',
    origin: '',
    isSchemeRelative: false
  };

  module.exports = urllite;

}).call(this);


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsInlineSVG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSupportedEnvironment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return randomString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return uniquifySVGIDs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return unsupportedBrowserError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configurationError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_once__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_once__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var supportsInlineSVG = __WEBPACK_IMPORTED_MODULE_0_once___default()(function () {
  /* istanbul ignore next */
  if (!document) {
    return false;
  }

  var div = document.createElement('div');
  div.innerHTML = '<svg />';
  return div.firstChild && div.firstChild.namespaceURI === 'http://www.w3.org/2000/svg';
});

var isSupportedEnvironment = __WEBPACK_IMPORTED_MODULE_0_once___default()(function () {
  return supportsInlineSVG() && typeof window !== 'undefined' && window !== null ? window.XMLHttpRequest || window.XDomainRequest : false;
});

var randomString = function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  var letters = 'abcdefghijklmnopqrstuvwxyz';
  var numbers = '1234567890';
  var charset = letters + letters.toUpperCase() + numbers;

  var randomCharacter = function randomCharacter(array) {
    return array[Math.floor(Math.random() * array.length)];
  };

  var R = '';
  for (var i = 0; i < length; i++) {
    R += randomCharacter(charset);
  }
  return R;
};

var uniquifySVGIDs = function () {
  var mkAttributePattern = function mkAttributePattern(attr) {
    return '(?:(?:\\s|\\:)' + attr + ')';
  };

  var idPattern = new RegExp('(?:(' + mkAttributePattern('id') + ')="([^"]+)")|(?:(' + mkAttributePattern('href') + '|' + mkAttributePattern('role') + '|' + mkAttributePattern('arcrole') + ')="\\#([^"]+)")|(?:="url\\(\\#([^\\)]+)\\)")|(?:url\\(\\#([^\\)]+)\\))', 'g');

  return function (svgText, svgID, baseURL) {
    var uniquifyID = function uniquifyID(id) {
      return id + '___' + svgID;
    };

    return svgText.replace(idPattern, function (m, p1, p2, p3, p4, p5, p6) {
      //eslint-disable-line consistent-return
      /* istanbul ignore else */
      if (p2) {
        return p1 + '="' + uniquifyID(p2) + '"';
      }

      if (p4) {
        return p3 + '="' + baseURL + '#' + uniquifyID(p4) + '"';
      }

      if (p5) {
        return '="url(' + baseURL + '#' + uniquifyID(p5) + ')"';
      }

      if (p6) {
        return 'url(' + baseURL + '#' + uniquifyID(p6) + ')';
      }
    });
  };
}();

var InlineSVGError = function (_Error) {
  _inherits(InlineSVGError, _Error);

  function InlineSVGError(message) {
    var _ret;

    _classCallCheck(this, InlineSVGError);

    var _this = _possibleConstructorReturn(this, (InlineSVGError.__proto__ || Object.getPrototypeOf(InlineSVGError)).call(this));

    _this.name = 'InlineSVGError';
    _this.isSupportedBrowser = true;
    _this.isConfigurationError = false;
    _this.isUnsupportedBrowserError = false;
    _this.message = message;

    return _ret = _this, _possibleConstructorReturn(_this, _ret);
  }

  return InlineSVGError;
}(Error);

var createError = function createError(message, attrs) {
  var err = new InlineSVGError(message);

  return _extends({}, err, attrs);
};

var unsupportedBrowserError = function unsupportedBrowserError(message) {
  var newMessage = message;

  /* istanbul ignore else */
  if (!newMessage) {
    newMessage = 'Unsupported Browser';
  }

  return createError(newMessage, {
    isSupportedBrowser: false,
    isUnsupportedBrowserError: true
  });
};

var configurationError = function configurationError(message) {
  return createError(message, {
    isConfigurationError: true
  });
};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var wrappy = __webpack_require__(1207)
module.exports = wrappy(once)
module.exports.strict = wrappy(onceStrict)

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function () {
      return onceStrict(this)
    },
    configurable: true
  })
})

function once (fn) {
  var f = function () {
    if (f.called) return f.value
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  f.called = false
  return f
}

function onceStrict (fn) {
  var f = function () {
    if (f.called)
      throw new Error(f.onceError)
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  var name = fn.name || 'Function wrapped with `once`'
  f.onceError = name + " shouldn't be called more than once"
  f.called = false
  return f
}


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy
function wrappy (fn, cb) {
  if (fn && cb) return wrappy(fn)(cb)

  if (typeof fn !== 'function')
    throw new TypeError('need wrapper function')

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k]
  })

  return wrapper

  function wrapper() {
    var args = new Array(arguments.length)
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i]
    }
    var ret = fn.apply(this, args)
    var cb = args[args.length-1]
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k]
      })
    }
    return ret
  }
}


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SignupFormComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_APIcon__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_hocs_redirectIfAuthorized__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_path__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layouts_StandAloneLayout_StandAloneLayout__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_SimpleSignupForm__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SignupPage_css__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SignupPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SignupPage_css__);
var baseClasses=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-form');var signupPageClasses=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('signup-page');var SignupFormComponent=function SignupFormComponent(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__layouts_StandAloneLayout_StandAloneLayout__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:baseClasses('container')+' '+signupPageClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:baseClasses('header')+' '+signupPageClasses('header')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:baseClasses('header-text')+' '+signupPageClasses('header-text')},context.t('{n} Sign Up',{n:"Coinext"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])('/'),className:baseClasses('close-icon')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_common_APIcon__["a" /* default */],{name:'close',classModifiers:'big'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_SimpleSignupForm__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:baseClasses('footer')+' '+signupPageClasses('footer')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])('/login'),className:signupPageClasses('link'),disabled:true},context.t('Login')))));};SignupFormComponent.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_hocs_redirectIfAuthorized__["a" /* default */])(SignupFormComponent,"/dashboard"));

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIcon_css__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIcon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__APIcon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_icon_nav_buy_sell_svg__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_icon_nav_buy_sell_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_icon_nav_buy_sell_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_icon_nav_dashboard_on_svg__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_icon_nav_dashboard_on_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_icon_nav_dashboard_on_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_icon_nav_trading_svg__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_icon_nav_trading_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_icon_nav_trading_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_icon_nav_user_svg__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_icon_nav_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_icon_nav_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_icon_nav_settings_svg__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_icon_nav_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_icon_nav_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_icon_nav_wallet_svg__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_icon_nav_wallet_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_icon_nav_wallet_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_icon_balance_svg__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_icon_balance_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_icon_balance_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_icon_contacts_svg__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_icon_contacts_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_icon_contacts_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_icon_key_svg__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_icon_key_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_icons_icon_key_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_icon_reports_svg__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_icon_reports_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_icons_icon_reports_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_icon_security_svg__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_icon_security_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_icons_icon_security_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_icon_tasks_svg__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_icon_tasks_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_icons_icon_tasks_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_icons_icon_heart_svg__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_icons_icon_heart_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_icons_icon_heart_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_icons_icon_friends_svg__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_icons_icon_friends_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_icons_icon_friends_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_icons_icon_paint_svg__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_icons_icon_paint_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_icons_icon_paint_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_icons_icon_send_with_border_svg__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_icons_icon_send_with_border_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_icons_icon_send_with_border_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_icons_icon_receive_with_border_svg__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_icons_icon_receive_with_border_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_icons_icon_receive_with_border_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_icons_icon_deposit_with_border_svg__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_icons_icon_deposit_with_border_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_icons_icon_deposit_with_border_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_icons_icon_withdraw_with_border_svg__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_icons_icon_withdraw_with_border_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__images_icons_icon_withdraw_with_border_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_icons_icon_open_buy_big_svg__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_icons_icon_open_buy_big_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__images_icons_icon_open_buy_big_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_icons_icon_open_sell_big_svg__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_icons_icon_open_sell_big_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__images_icons_icon_open_sell_big_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_icons_icon_caret_prev_svg__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__images_icons_icon_caret_prev_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__images_icons_icon_caret_prev_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__images_icons_icon_caret_next_svg__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__images_icons_icon_caret_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__images_icons_icon_caret_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__images_icons_icon_double_caret_prev_svg__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__images_icons_icon_double_caret_prev_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__images_icons_icon_double_caret_prev_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_icons_icon_double_caret_next_svg__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_icons_icon_double_caret_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__images_icons_icon_double_caret_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__images_icons_icon_dropdown_svg__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__images_icons_icon_dropdown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__images_icons_icon_dropdown_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__images_icons_icon_barcode_svg__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__images_icons_icon_barcode_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__images_icons_icon_barcode_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__images_icons_icon_calendar_svg__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__images_icons_icon_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__images_icons_icon_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__images_icons_icon_eye_svg__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__images_icons_icon_eye_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__images_icons_icon_eye_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__images_icons_icon_info_svg__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__images_icons_icon_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__images_icons_icon_info_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__images_icons_icon_cancel_svg__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__images_icons_icon_cancel_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__images_icons_icon_cancel_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__images_icons_icon_download_svg__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__images_icons_icon_download_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__images_icons_icon_download_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__images_icons_icon_check_svg__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__images_icons_icon_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__images_icons_icon_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__images_icons_icon_simple_check_svg__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__images_icons_icon_simple_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__images_icons_icon_simple_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__images_icons_icon_refresh_svg__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__images_icons_icon_refresh_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__images_icons_icon_refresh_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__images_icons_icon_close_svg__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__images_icons_icon_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__images_icons_icon_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__images_icons_icon_buy_svg__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__images_icons_icon_buy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__images_icons_icon_buy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__images_icons_icon_sell_svg__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__images_icons_icon_sell_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__images_icons_icon_sell_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__images_icons_icon_send_svg__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__images_icons_icon_send_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__images_icons_icon_send_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__images_icons_icon_receive_svg__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__images_icons_icon_receive_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__images_icons_icon_receive_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__images_icons_icon_deposit_svg__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__images_icons_icon_deposit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__images_icons_icon_deposit_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__images_icons_icon_withdraw_svg__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__images_icons_icon_withdraw_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__images_icons_icon_withdraw_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__images_icons_icon_copy_svg__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__images_icons_icon_copy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__images_icons_icon_copy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__images_icons_icon_star_svg__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__images_icons_icon_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__images_icons_icon_star_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__images_icons_icon_stop_svg__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__images_icons_icon_stop_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__images_icons_icon_stop_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__images_icons_logo_powered_svg__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__images_icons_logo_powered_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__images_icons_logo_powered_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__images_icons_icon_nav_notification_svg__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__images_icons_icon_nav_notification_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__images_icons_icon_nav_notification_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__images_icons_icon_center_svg__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__images_icons_icon_center_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__images_icons_icon_center_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__images_icons_icon_checkbox_svg__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__images_icons_icon_checkbox_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__images_icons_icon_checkbox_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__images_icons_icon_menu_toggle_svg__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__images_icons_icon_menu_toggle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__images_icons_icon_menu_toggle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__images_icons_icon_key_big_svg__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__images_icons_icon_key_big_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__images_icons_icon_key_big_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__images_icons_icon_arrow_prev_svg__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__images_icons_icon_arrow_prev_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__images_icons_icon_arrow_prev_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__images_icons_icon_arrow_next_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__images_icons_icon_arrow_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__images_icons_icon_arrow_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__images_icons_icon_pending_svg__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__images_icons_icon_pending_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__images_icons_icon_pending_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__images_icons_icon_settings_svg__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__images_icons_icon_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__images_icons_icon_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__images_icons_icon_alert_svg__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__images_icons_icon_alert_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__images_icons_icon_alert_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__images_icons_icon_menu_svg__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__images_icons_icon_menu_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__images_icons_icon_menu_svg__);
// navigation
// user settings
// tables
//pagination
//forms
//ap
//misc
var baseClass='ap-icon';var icons={// navigation
'buy-sell':__WEBPACK_IMPORTED_MODULE_5__images_icons_icon_nav_buy_sell_svg___default.a,dashboard:__WEBPACK_IMPORTED_MODULE_6__images_icons_icon_nav_dashboard_on_svg___default.a,trading:__WEBPACK_IMPORTED_MODULE_7__images_icons_icon_nav_trading_svg___default.a,user:__WEBPACK_IMPORTED_MODULE_8__images_icons_icon_nav_user_svg___default.a,'user-settings':__WEBPACK_IMPORTED_MODULE_9__images_icons_icon_nav_settings_svg___default.a,wallet:__WEBPACK_IMPORTED_MODULE_10__images_icons_icon_nav_wallet_svg___default.a,balance:__WEBPACK_IMPORTED_MODULE_11__images_icons_icon_balance_svg___default.a,// user-settings
contacts:__WEBPACK_IMPORTED_MODULE_12__images_icons_icon_contacts_svg___default.a,key:__WEBPACK_IMPORTED_MODULE_13__images_icons_icon_key_svg___default.a,reports:__WEBPACK_IMPORTED_MODULE_14__images_icons_icon_reports_svg___default.a,security:__WEBPACK_IMPORTED_MODULE_15__images_icons_icon_security_svg___default.a,tasks:__WEBPACK_IMPORTED_MODULE_16__images_icons_icon_tasks_svg___default.a,heart:__WEBPACK_IMPORTED_MODULE_17__images_icons_icon_heart_svg___default.a,paint:__WEBPACK_IMPORTED_MODULE_19__images_icons_icon_paint_svg___default.a,friends:__WEBPACK_IMPORTED_MODULE_18__images_icons_icon_friends_svg___default.a,// table
sendWithBorder:__WEBPACK_IMPORTED_MODULE_20__images_icons_icon_send_with_border_svg___default.a,receiveWithBorder:__WEBPACK_IMPORTED_MODULE_21__images_icons_icon_receive_with_border_svg___default.a,depositWithBorder:__WEBPACK_IMPORTED_MODULE_22__images_icons_icon_deposit_with_border_svg___default.a,withdrawWithBorder:__WEBPACK_IMPORTED_MODULE_23__images_icons_icon_withdraw_with_border_svg___default.a,'open-buy':__WEBPACK_IMPORTED_MODULE_24__images_icons_icon_open_buy_big_svg___default.a,'open-sell':__WEBPACK_IMPORTED_MODULE_25__images_icons_icon_open_sell_big_svg___default.a,//pagination
caretPrevious:__WEBPACK_IMPORTED_MODULE_26__images_icons_icon_caret_prev_svg___default.a,caretNext:__WEBPACK_IMPORTED_MODULE_27__images_icons_icon_caret_next_svg___default.a,doubleCaretPrevious:__WEBPACK_IMPORTED_MODULE_28__images_icons_icon_double_caret_prev_svg___default.a,doubleCaretNext:__WEBPACK_IMPORTED_MODULE_29__images_icons_icon_double_caret_next_svg___default.a,// forms
dropdown:__WEBPACK_IMPORTED_MODULE_30__images_icons_icon_dropdown_svg___default.a,barcode:__WEBPACK_IMPORTED_MODULE_31__images_icons_icon_barcode_svg___default.a,calendar:__WEBPACK_IMPORTED_MODULE_32__images_icons_icon_calendar_svg___default.a,eye:__WEBPACK_IMPORTED_MODULE_33__images_icons_icon_eye_svg___default.a,info:__WEBPACK_IMPORTED_MODULE_34__images_icons_icon_info_svg___default.a,cancel:__WEBPACK_IMPORTED_MODULE_35__images_icons_icon_cancel_svg___default.a,download:__WEBPACK_IMPORTED_MODULE_36__images_icons_icon_download_svg___default.a,check:__WEBPACK_IMPORTED_MODULE_37__images_icons_icon_check_svg___default.a,'simple-check':__WEBPACK_IMPORTED_MODULE_38__images_icons_icon_simple_check_svg___default.a,refresh:__WEBPACK_IMPORTED_MODULE_39__images_icons_icon_refresh_svg___default.a,close:__WEBPACK_IMPORTED_MODULE_40__images_icons_icon_close_svg___default.a,buy:__WEBPACK_IMPORTED_MODULE_41__images_icons_icon_buy_svg___default.a,sell:__WEBPACK_IMPORTED_MODULE_42__images_icons_icon_sell_svg___default.a,receive:__WEBPACK_IMPORTED_MODULE_44__images_icons_icon_receive_svg___default.a,send:__WEBPACK_IMPORTED_MODULE_43__images_icons_icon_send_svg___default.a,deposit:__WEBPACK_IMPORTED_MODULE_45__images_icons_icon_deposit_svg___default.a,withdraw:__WEBPACK_IMPORTED_MODULE_46__images_icons_icon_withdraw_svg___default.a,copy:__WEBPACK_IMPORTED_MODULE_47__images_icons_icon_copy_svg___default.a,star:__WEBPACK_IMPORTED_MODULE_48__images_icons_icon_star_svg___default.a,stop:__WEBPACK_IMPORTED_MODULE_49__images_icons_icon_stop_svg___default.a,arrowPrevious:__WEBPACK_IMPORTED_MODULE_56__images_icons_icon_arrow_prev_svg___default.a,arrowNext:__WEBPACK_IMPORTED_MODULE_57__images_icons_icon_arrow_next_svg___default.a,//ap
'logo-powered':__WEBPACK_IMPORTED_MODULE_50__images_icons_logo_powered_svg___default.a,//misc and possibly unused
notification:__WEBPACK_IMPORTED_MODULE_51__images_icons_icon_nav_notification_svg___default.a,center:__WEBPACK_IMPORTED_MODULE_52__images_icons_icon_center_svg___default.a,checkbox:__WEBPACK_IMPORTED_MODULE_53__images_icons_icon_checkbox_svg___default.a,'menu-toggle':__WEBPACK_IMPORTED_MODULE_54__images_icons_icon_menu_toggle_svg___default.a,bigKey:__WEBPACK_IMPORTED_MODULE_55__images_icons_icon_key_big_svg___default.a,pending:__WEBPACK_IMPORTED_MODULE_58__images_icons_icon_pending_svg___default.a,settings:__WEBPACK_IMPORTED_MODULE_59__images_icons_icon_settings_svg___default.a,alert:__WEBPACK_IMPORTED_MODULE_60__images_icons_icon_alert_svg___default.a,menu:__WEBPACK_IMPORTED_MODULE_61__images_icons_icon_menu_svg___default.a};var APIcon=function APIcon(props){var name=props.name,customClass=props.customClass,classModifiers=props.classModifiers;var modifiers=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["a" /* addModifier */])(classModifiers,name);var bemClasses=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])([baseClass,customClass]);var icon=icons[name];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__["a" /* default */],{src:icon,className:bemClasses(null,modifiers)});};APIcon.defaultProps={name:'',customClass:'custom-icon',classModifiers:'',disabled:false};APIcon.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,customClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,classModifiers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (APIcon);

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-buy-sell.05bf1b3e.svg";

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-dashboard-on.e893058b.svg";

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-trading.3fcf73a2.svg";

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-user.46dcb523.svg";

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-settings.33a25eda.svg";

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-wallet.f94c3639.svg";

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-balance.25d500b4.svg";

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-contacts.cfe30a22.svg";

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-key.37149c1b.svg";

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-reports.a04feb44.svg";

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-security.0c2ef0a2.svg";

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-tasks.381b183c.svg";

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-heart.f603174e.svg";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-friends.46e7a462.svg";

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-paint.893369af.svg";

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-send-with-border.41bc43b8.svg";

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-receive-with-border.a28e2bb8.svg";

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-deposit-with-border.875719fd.svg";

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-withdraw-with-border.241ed288.svg";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-open-buy-big.fc624e53.svg";

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-open-sell-big.f913f6d7.svg";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-caret-prev.32253ec8.svg";

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-caret-next.110fecd7.svg";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-double-caret-prev.b8497d68.svg";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-double-caret-next.5056c1f7.svg";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-dropdown.45611a2a.svg";

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-barcode.f19ef28b.svg";

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-calendar.936d754e.svg";

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-eye.9068c8e6.svg";

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-info.6448a8d0.svg";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-cancel.c5ab6a82.svg";

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-download.a82b9322.svg";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-check.3daf24a9.svg";

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-simple-check.4db4903c.svg";

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-refresh.c4cc5dd3.svg";

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-close.56aba6b5.svg";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-buy.fab94b94.svg";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-sell.0f4f4688.svg";

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-send.6df667a8.svg";

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-receive.83db15a3.svg";

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-deposit.ee555dfc.svg";

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-withdraw.6b67e16d.svg";

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-copy.9dc9a9a7.svg";

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-star.9e54355c.svg";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-stop.e8187fdc.svg";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-powered.7f6a585c.svg";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-notification.e1c86986.svg";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-center.f91ec619.svg";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-checkbox.6ff75c6f.svg";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-menu-toggle.ad89aeb9.svg";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-key-big.0d56bc9b.svg";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-arrow-prev.ec3c7dc9.svg";

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-arrow-next.02ae871b.svg";

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-pending.e2938acc.svg";

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-settings.d15941a5.svg";

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-alert.b09e6a92.svg";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-menu.ff0128f9.svg";

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return redirectExceptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__homePageLayoutHelper__ = __webpack_require__(1271);


var redirectExceptions = function redirectExceptions() {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__homePageLayoutHelper__["a" /* checkForConfirmWithdrawParam */])()) return true;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__homePageLayoutHelper__["b" /* checkForResetPassParam */])()) return true;
};

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkForLoginParam */
/* unused harmony export checkForVerifyEmailParam */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkForConfirmWithdrawParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkForResetPassParam; });
/* unused harmony export checkForDepositConfirmationParam */
/* unused harmony export homePageRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





var checkForLoginParam = function checkForLoginParam() {
  var forceLogIn = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].LandingPage.forceLogIn;

  if (forceLogIn && checkForConfigLinks()) return false;
  if (window.location.href.includes(forceLogIn ? '' : 'login')) return true;
  return false;
};

var checkForConfigLinks = function checkForConfigLinks() {
  var hasLinks = false;
  var checkURL = [__WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].documentationLink, __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].SignupForm.termsAndServicesLink, __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].SignupForm.privacyPolicyLink];
  for (var urlNum = 0; urlNum < checkURL.length; urlNum++) {
    if (checkURL[urlNum] !== '/' && window.location.href.includes(checkURL[urlNum])) {
      hasLinks = true;
    }
  }
  return hasLinks;
};

var checkForVerifyEmailParam = function checkForVerifyEmailParam() {
  if (window.location.href.includes('verifyEmail')) return true;
  return false;
};

var checkForConfirmWithdrawParam = function checkForConfirmWithdrawParam() {
  if (window.location.href.includes('confirmWithdraw')) return true;
  return false;
};

var checkForResetPassParam = function checkForResetPassParam() {
  if (window.location.href.includes('resetPass')) return true;
  return false;
};

var checkForDepositConfirmationParam = function checkForDepositConfirmationParam() {
  var href = window.location.href;

  var trustPayRedirect = href.includes('id') && href.includes('resourcePath');

  if (href.includes('txnState') || trustPayRedirect) return true;
  return false;
};

var homePageRoutes = function homePageRoutes(pathname, HomePage) {
  return (pathname.includes('.html') || pathname === Object(__WEBPACK_IMPORTED_MODULE_2__path__["a" /* default */])('/')) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], { exact: true, path: pathname, key: pathname, component: HomePage });
};

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleSignupFormContainer__ = __webpack_require__(1273);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SimpleSignupFormContainer__["a" /* default */]);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimpleSignupFormComponent__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_signupActions__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);







var SimpleSignupFormForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'signup',
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_signupActions__["f" /* signup */])(payload)).then(function (response) {
      if (response && response.errormsg) {
        /**
         * To leverage `redux-form` field-specific error functionality,
         *  we must throw a `SubmissionError` from decorated component's `handleSubmit` prop.
         */
        throw new __WEBPACK_IMPORTED_MODULE_1_redux_form__["c" /* SubmissionError */](Object(__WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__["b" /* preprocessErrorTextForReduxForm */])(response.errormsg, payload));
      }
    });
  }
})(__WEBPACK_IMPORTED_MODULE_2__SimpleSignupFormComponent__["a" /* default */]);

var selector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('signup');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return Object.assign({
    passwordValue: selector(state, 'password'),
    errorMsg: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(state, 'form.signup.error', false),
    done: !!state.signup.userId
  }, ownProps);
};

var mapDispatchToProps = {
  clearSignupError: __WEBPACK_IMPORTED_MODULE_3__redux_actions_signupActions__["e" /* clearSignupError */]
};

var SimpleSignupFormContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(SimpleSignupFormForm);

/* harmony default export */ __webpack_exports__["a"] = (SimpleSignupFormContainer);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APPasswordInput_APPasswordInput__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_formGeneratorHelper__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_passwordScore__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routeTemplates__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_components_common_StandaloneForm_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_components_common_StandaloneForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_components_common_StandaloneForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SimpleSignupFormComponent_css__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SimpleSignupFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__SimpleSignupFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_10__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-form');
var signupFormClasses = Object(__WEBPACK_IMPORTED_MODULE_10__helpers_cssClassesHelper__["b" /* getBEMClasses */])('signup-form');

var SimpleSignupFormComponent = function (_Component) {
  _inherits(SimpleSignupFormComponent, _Component);

  function SimpleSignupFormComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SimpleSignupFormComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleSignupFormComponent.__proto__ || Object.getPrototypeOf(SimpleSignupFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.getPasswordStrength = function () {
      var _this2 = _this,
          context = _this2.context;

      var score = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_passwordScore__["a" /* default */])(_this.props.passwordValue);
      var passwordStrengthValues = {
        0: context.t('Very Weak'),
        1: context.t('Weak'),
        2: context.t('Medium'),
        3: context.t('Strong'),
        4: context.t('Very Strong')
      };

      return passwordStrengthValues[score];
    }, _this.handleChange = function () {
      if (_this.props.errorMsg) {
        _this.props.clearSignupError();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SimpleSignupFormComponent, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          errorMsg = _props.errorMsg,
          submitting = _props.submitting,
          pristine = _props.pristine,
          passwordValue = _props.passwordValue,
          invalid = _props.invalid,
          done = _props.done,
          useEmailAsUsername = _props.useEmailAsUsername,
          additionalFields = _props.additionalFields;


      if (done) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: '' + baseClasses('success') },
          context.t('Thanks for signing up, please check your inbox for a confirmation email')
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          {
            onSubmit: handleSubmit,
            className: baseClasses('form') + ' ' + signupFormClasses('form') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: signupFormClasses('wrapper') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: signupFormClasses('container') },
              !useEmailAsUsername && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APInput__["b" /* default */], {
                type: 'text',
                name: 'username',
                label: context.t('Username'),
                validate: [__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["p" /* required */]],
                customClass: signupFormClasses(),
                onChange: this.handleChange
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APInput__["b" /* default */], {
                type: 'text',
                name: 'email',
                label: context.t('Email'),
                validate: [__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["p" /* required */], __WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["d" /* email */]],
                customClass: signupFormClasses(),
                onChange: this.handleChange
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APPasswordInput_APPasswordInput__["a" /* default */], {
                type: 'password',
                name: 'password',
                label: context.t('Password'),
                validate: [__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["p" /* required */]],
                info: passwordValue && this.getPasswordStrength(),
                customClass: signupFormClasses(),
                onChange: this.handleChange
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APPasswordInput_APPasswordInput__["a" /* default */], {
                type: 'password',
                name: 'matchingPassword',
                label: context.t('Retype Password'),
                classes: 'signup',
                validate: [__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["p" /* required */], __WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["h" /* matchingPassword */], __WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["r" /* validatePassword */]],
                customClass: signupFormClasses(),
                onChange: this.handleChange
              }),
              Object(__WEBPACK_IMPORTED_MODULE_7__helpers_formGeneratorHelper__["b" /* renderFormInputs */])(additionalFields, signupFormClasses(), context),
              errorMsg && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                {
                  className: baseClasses('error') + ' ' + signupFormClasses('error') },
                errorMsg
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: signupFormClasses('footer') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__common_APButton__["a" /* default */],
              {
                type: 'submit',
                disabled: pristine || submitting || invalid,
                customClass: baseClasses() + ' ' + signupFormClasses(),
                styleName: __WEBPACK_IMPORTED_MODULE_12__propTypes_commonComponent__["b" /* styleNames */].additive },
              submitting ? context.t('Processing...') : context.t('Sign Up')
            )
          )
        );
      }
    }
  }]);

  return SimpleSignupFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SimpleSignupFormComponent.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

SimpleSignupFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  referrer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shouldRedirect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

SimpleSignupFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SimpleSignupFormComponent);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isString; });
var isString = function isString(str) {
  return typeof str === 'string' || str instanceof String;
};

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-buy-sell.05bf1b3e.svg";

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-dashboard-on.e893058b.svg";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-trading.3fcf73a2.svg";

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-user.46dcb523.svg";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-settings.33a25eda.svg";

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-wallet.f94c3639.svg";

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-balance.25d500b4.svg";

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-activity.a6f36e23.svg";

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-contacts.cfe30a22.svg";

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-key.37149c1b.svg";

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-reports.a04feb44.svg";

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-security.0c2ef0a2.svg";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-tasks.381b183c.svg";

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-heart.f603174e.svg";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-friends.46e7a462.svg";

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-paint.893369af.svg";

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-send-with-border.41bc43b8.svg";

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-receive-with-border.a28e2bb8.svg";

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-deposit-with-border.875719fd.svg";

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-withdraw-with-border.241ed288.svg";

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-open-buy-big.fc624e53.svg";

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-open-sell-big.f913f6d7.svg";

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-caret-prev.32253ec8.svg";

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-caret-next.110fecd7.svg";

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-double-caret-prev.b8497d68.svg";

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-double-caret-next.5056c1f7.svg";

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-dropdown.45611a2a.svg";

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-barcode.f19ef28b.svg";

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-calendar.936d754e.svg";

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-eye.9068c8e6.svg";

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-info.6448a8d0.svg";

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-cancel.c5ab6a82.svg";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-download.a82b9322.svg";

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-check.3daf24a9.svg";

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-simple-check.4db4903c.svg";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-refresh.c4cc5dd3.svg";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-close.56aba6b5.svg";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-buy.fab94b94.svg";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-sell.0f4f4688.svg";

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-send.6df667a8.svg";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-receive.83db15a3.svg";

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-deposit.ee555dfc.svg";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-withdraw.6b67e16d.svg";

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-copy.9dc9a9a7.svg";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-star.9e54355c.svg";

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-stop.e8187fdc.svg";

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-powered.7f6a585c.svg";

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-nav-notification.e1c86986.svg";

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-center.f91ec619.svg";

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-checkbox.6ff75c6f.svg";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-menu-toggle.ad89aeb9.svg";

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-key-big.0d56bc9b.svg";

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-arrow-prev.ec3c7dc9.svg";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-arrow-next.02ae871b.svg";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-pending.e2938acc.svg";

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-settings.d15941a5.svg";

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-alert.b09e6a92.svg";

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-menu.ff0128f9.svg";

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-plus-minus.e0d82ce6.svg";

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-arrow-up.fb49d74b.svg";

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-arrow-down.e00777bf.svg";

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parsePhoneNumberFromString;

var _parsePhoneNumber = __webpack_require__(145);

var _parsePhoneNumberFromString_ = _interopRequireDefault(__webpack_require__(1345));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function parsePhoneNumberFromString() {
  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _parsePhoneNumberFromString_["default"])(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumberFromString.js.map

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function _default(a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}
//# sourceMappingURL=semver-compare.js.map

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = extractExtension;

var _createExtensionPattern = _interopRequireDefault(__webpack_require__(251));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.
var EXTN_PATTERN = new RegExp('(?:' + (0, _createExtensionPattern["default"])() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}
//# sourceMappingURL=extractExtension.js.map

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mergeArrays;

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=mergeArrays.js.map

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getIddPrefix;

var _metadata = _interopRequireDefault(__webpack_require__(41));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new _metadata["default"](metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }

  return countryMetadata.defaultIDDPrefix();
}
//# sourceMappingURL=getIddPrefix.js.map

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parsePhoneNumberFromString;

var _parsePhoneNumber_ = _interopRequireDefault(__webpack_require__(596));

var _ParseError = _interopRequireDefault(__webpack_require__(343));

var _metadata = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function parsePhoneNumberFromString(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !(0, _metadata.isSupportedCountry)(options.defaultCountry, metadata)) {
    options = _objectSpread({}, options, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return (0, _parsePhoneNumber_["default"])(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof _ParseError["default"]) {//
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=parsePhoneNumberFromString_.js.map

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getExampleNumber;

var _PhoneNumber = _interopRequireDefault(__webpack_require__(254));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getExampleNumber(country, examples, metadata) {
  if (examples[country]) {
    return new _PhoneNumber["default"](country, examples[country], metadata);
  }
}
//# sourceMappingURL=getExampleNumber.js.map

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPossibleNumber;

var _getNumberType = __webpack_require__(350);

var _isPossibleNumber_ = _interopRequireDefault(__webpack_require__(346));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Checks if a given phone number is possible.
 * Which means it only checks phone number length
 * and doesn't test any regular expressions.
 *
 * Examples:
 *
 * ```js
 * isPossibleNumber('+78005553535', metadata)
 * isPossibleNumber('8005553535', 'RU', metadata)
 * isPossibleNumber('88005553535', 'RU', metadata)
 * isPossibleNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */
function isPossibleNumber() {
  var _normalizeArguments = (0, _getNumberType.normalizeArguments)(arguments),
      input = _normalizeArguments.input,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _isPossibleNumber_["default"])(input, options, metadata);
}
//# sourceMappingURL=isPossibleNumber.js.map

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidNumber;

var _validate_ = _interopRequireDefault(__webpack_require__(255));

var _getNumberType = __webpack_require__(350);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Finds out national phone number type (fixed line, mobile, etc)
function isValidNumber() {
  var _normalizeArguments = (0, _getNumberType.normalizeArguments)(arguments),
      input = _normalizeArguments.input,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return (0, _validate_["default"])(input, options, metadata);
}
//# sourceMappingURL=validate.js.map

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidNumberForRegion;

var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(180));

var _parse_ = _interopRequireDefault(__webpack_require__(123));

var _isValidNumberForRegion_ = _interopRequireDefault(__webpack_require__(597));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isValidNumberForRegion(number, country, metadata) {
  if (typeof number !== 'string') {
    throw new TypeError('number must be a string');
  }

  if (typeof country !== 'string') {
    throw new TypeError('country must be a string');
  } // `parse` extracts phone numbers from raw text,
  // therefore it will cut off all "garbage" characters,
  // while this `validate` function needs to verify
  // that the phone number contains no "garbage"
  // therefore the explicit `isViablePhoneNumber` check.


  var input;

  if ((0, _isViablePhoneNumber["default"])(number)) {
    input = (0, _parse_["default"])(number, {
      defaultCountry: country
    }, metadata);
  } else {
    input = {};
  }

  return (0, _isValidNumberForRegion_["default"])(input, country, undefined, metadata);
}
//# sourceMappingURL=isValidNumberForRegion.js.map

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = findNumbers;

var _PhoneNumberMatcher = _interopRequireDefault(__webpack_require__(351));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function findNumbers(text, options, metadata) {
  var matcher = new _PhoneNumberMatcher["default"](text, options, metadata);
  var results = [];

  while (matcher.hasNext()) {
    results.push(matcher.next());
  }

  return results;
}
//# sourceMappingURL=findNumbers_.js.map

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _LRUCache = _interopRequireDefault(__webpack_require__(1352));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
// countries being used for the same doc with ~10 patterns for each country. Some pages will have
// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
// that use-case won't have a lot of benefit.
var RegExpCache =
/*#__PURE__*/
function () {
  function RegExpCache(size) {
    _classCallCheck(this, RegExpCache);

    this.cache = new _LRUCache["default"](size);
  }

  _createClass(RegExpCache, [{
    key: "getPatternForRegExp",
    value: function getPatternForRegExp(pattern) {
      var regExp = this.cache.get(pattern);

      if (!regExp) {
        regExp = new RegExp('^' + pattern);
        this.cache.put(pattern, regExp);
      }

      return regExp;
    }
  }]);

  return RegExpCache;
}();

exports["default"] = RegExpCache;
//# sourceMappingURL=RegExpCache.js.map

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
var Node = function Node(key, value) {
  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  _classCallCheck(this, Node);

  this.key = key;
  this.value = value;
  this.next = next;
  this.prev = prev;
};

var LRUCache =
/*#__PURE__*/
function () {
  //set default limit of 10 if limit is not passed.
  function LRUCache() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    _classCallCheck(this, LRUCache);

    this.size = 0;
    this.limit = limit;
    this.head = null;
    this.tail = null;
    this.cache = {};
  } // Write Node to head of LinkedList
  // update cache with Node key and Node reference


  _createClass(LRUCache, [{
    key: "put",
    value: function put(key, value) {
      this.ensureLimit();

      if (!this.head) {
        this.head = this.tail = new Node(key, value);
      } else {
        var node = new Node(key, value, this.head);
        this.head.prev = node;
        this.head = node;
      } //Update the cache map


      this.cache[key] = this.head;
      this.size++;
    } // Read from cache map and make that node as new Head of LinkedList

  }, {
    key: "get",
    value: function get(key) {
      if (this.cache[key]) {
        var value = this.cache[key].value; // node removed from it's position and cache

        this.remove(key); // write node again to the head of LinkedList to make it most recently used

        this.put(key, value);
        return value;
      }

      console.log("Item not available in cache for key ".concat(key));
    }
  }, {
    key: "ensureLimit",
    value: function ensureLimit() {
      if (this.size === this.limit) {
        this.remove(this.tail.key);
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var node = this.cache[key];

      if (node.prev !== null) {
        node.prev.next = node.next;
      } else {
        this.head = node.next;
      }

      if (node.next !== null) {
        node.next.prev = node.prev;
      } else {
        this.tail = node.prev;
      }

      delete this.cache[key];
      this.size--;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = null;
      this.tail = null;
      this.size = 0;
      this.cache = {};
    } // // Invokes the callback function with every node of the chain and the index of the node.
    // forEach(fn) {
    //   let node = this.head;
    //   let counter = 0;
    //   while (node) {
    //     fn(node, counter);
    //     node = node.next;
    //     counter++;
    //   }
    // }
    // // To iterate over LRU with a 'for...of' loop
    // *[Symbol.iterator]() {
    //   let node = this.head;
    //   while (node) {
    //     yield node;
    //     node = node.next;
    //   }
    // }

  }]);

  return LRUCache;
}();

exports["default"] = LRUCache;
//# sourceMappingURL=LRUCache.js.map

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containsMoreThanOneSlashInNationalNumber = containsMoreThanOneSlashInNationalNumber;
exports["default"] = void 0;

var _validate_ = _interopRequireDefault(__webpack_require__(255));

var _parseDigits = _interopRequireDefault(__webpack_require__(124));

var _util = __webpack_require__(257);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Leniency when finding potential phone numbers in text segments
 * The levels here are ordered in increasing strictness.
 */
var _default = {
  /**
   * Phone numbers accepted are "possible", but not necessarily "valid".
   */
  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
    return true;
  },

  /**
   * Phone numbers accepted are "possible" and "valid".
   * Numbers written in national format must have their national-prefix
   * present if it is usually written for a number of this type.
   */
  VALID: function VALID(number, candidate, metadata) {
    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidate.toString(), metadata)) {
      return false;
    } // Skipped for simplicity.
    // return isNationalPrefixPresentIfRequired(number, metadata)


    return true;
  },

  /**
   * Phone numbers accepted are "valid" and
   * are grouped in a possible way for this locale. For example, a US number written as
   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
   * "650 253 0000", "650 2530000" or "6502530000" are.
   * Numbers with more than one '/' symbol in the national significant number
   * are also dropped at this level.
   *
   * Warning: This level might result in lower coverage especially for regions outside of
   * country code "+1". If you are not sure about which level to use,
   * email the discussion group libphonenumber-discuss@googlegroups.com.
   */
  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
  },

  /**
   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
   * are grouped in the same way that we would have formatted it, or as a single block. For
   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
   * "650 253 0000" or "6502530000" are.
   * Numbers with more than one '/' symbol are also dropped at this level.
   * <p>
   * Warning: This level might result in lower coverage especially for regions outside of country
   * code "+1". If you are not sure about which level to use, email the discussion group
   * libphonenumber-discuss@googlegroups.com.
   */
  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
  }
};
exports["default"] = _default;

function containsOnlyValidXChars(number, candidate, metadata) {
  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
  // national significant number or (2) an extension sign, in which case they always precede the
  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
  // or 'X'. We ignore the character if it appears as the last character of the string.
  for (var index = 0; index < candidate.length - 1; index++) {
    var charAtIndex = candidate.charAt(index);

    if (charAtIndex === 'x' || charAtIndex === 'X') {
      var charAtNextIndex = candidate.charAt(index + 1);

      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
        // This is the carrier code case, in which the 'X's always precede the national
        // significant number.
        index++;

        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
          return false;
        } // This is the extension sign case, in which the 'x' or 'X' should always precede the
        // extension number.

      } else if ((0, _parseDigits["default"])(candidate.substring(index)) !== number.ext) {
        return false;
      }
    }
  }

  return true;
}

function isNationalPrefixPresentIfRequired(number, _metadata) {
  // First, check how we deduced the country code. If it was written in international format, then
  // the national prefix is not required.
  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
    return true;
  }

  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());
  var metadata = util.getMetadataForRegion(phoneNumberRegion);

  if (metadata == null) {
    return true;
  } // Check if a national prefix should be present when formatting this number.


  var nationalNumber = util.getNationalSignificantNumber(number);
  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber); // To do this, we check that a national prefix formatting rule was present
  // and that it wasn't just the first-group symbol ($1) with punctuation.

  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
      // The national-prefix is optional in these cases, so we don't need to check if it was
      // present.
      return true;
    }

    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
      // National Prefix not needed for this number.
      return true;
    } // Normalize the remainder.


    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput()); // Check if we found a national prefix and/or carrier code at the start of the raw input, and
    // return the result.

    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
  }

  return true;
}

function containsMoreThanOneSlashInNationalNumber(number, candidate) {
  var firstSlashInBodyIndex = candidate.indexOf('/');

  if (firstSlashInBodyIndex < 0) {
    // No slashes, this is okay.
    return false;
  } // Now look for a second one.


  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);

  if (secondSlashInBodyIndex < 0) {
    // Only one slash, this is okay.
    return false;
  } // If the first slash is after the country calling code, this is permitted.


  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;

  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
    // Any more slashes and this is illegal.
    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
  }

  return true;
}

function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
  var normalizedCandidate = normalizeDigits(candidate, true
  /* keep non-digits */
  );
  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);

  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
    return true;
  } // If this didn't pass, see if there are any alternate formats that match, and try them instead.


  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
  var nationalSignificantNumber = util.getNationalSignificantNumber(number);

  if (alternateFormats) {
    for (var _iterator = alternateFormats.numberFormats(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var alternateFormat = _ref;

      if (alternateFormat.leadingDigitsPatterns().length > 0) {
        // There is only one leading digits pattern for alternate formats.
        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);

        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
          // Leading digits don't match; try another one.
          continue;
        }
      }

      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);

      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
        return true;
      }
    }
  }

  return false;
}
/**
 * Helper method to get the national-number part of a number, formatted without any national
 * prefix, and return it as a set of digit blocks that would be formatted together following
 * standard formatting rules.
 */


function getNationalNumberGroups(metadata, number, formattingPattern) {
  if (formattingPattern) {
    // We format the NSN only, and split that according to the separator.
    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
  } // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.


  var rfc3966Format = formatNumber(number, 'RFC3966', metadata); // We remove the extension part from the formatted string before splitting it into different
  // groups.

  var endIndex = rfc3966Format.indexOf(';');

  if (endIndex < 0) {
    endIndex = rfc3966Format.length;
  } // The country-code will have a '-' following it.


  var startIndex = rfc3966Format.indexOf('-') + 1;
  return rfc3966Format.slice(startIndex, endIndex).split('-');
}

function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN); // Set this to the last group, skipping it if the number has an extension.

  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1; // First we check if the national significant number is formatted as a block.
  // We use contains and not equals, since the national significant number may be present with
  // a prefix such as a national number prefix, or the country code itself.

  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
    return true;
  } // Starting from the end, go through in reverse, excluding the first group, and check the
  // candidate and number groups are the same.


  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;

  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
      return false;
    }

    formattedNumberGroupIndex--;
    candidateNumberGroupIndex--;
  } // Now check the first group. There may be a national prefix at the start, so we only check
  // that the candidate group ends with the formatted number group.


  return candidateNumberGroupIndex >= 0 && (0, _util.endsWith)(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
}

function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var fromIndex = 0;

  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    // First skip the country code if the normalized candidate contained it.
    var countryCode = String(number.getCountryCode());
    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
  } // Check each group of consecutive digits are not broken into separate groupings in the
  // {@code normalizedCandidate} string.


  for (var i = 0; i < formattedNumberGroups.length; i++) {
    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
    // doesn't contain the consecutive digits in formattedNumberGroups[i].
    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);

    if (fromIndex < 0) {
      return false;
    } // Moves {@code fromIndex} forward.


    fromIndex += formattedNumberGroups[i].length();

    if (i == 0 && fromIndex < normalizedCandidate.length()) {
      // We are at the position right after the NDC. We get the region used for formatting
      // information based on the country code in the phone number, rather than the number itself,
      // as we do not need to distinguish between different countries with the same country
      // calling code and this is faster.
      var region = util.getRegionCodeForCountryCode(number.getCountryCode());

      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
        // This means there is no formatting symbol after the NDC. In this case, we only
        // accept the number if there is no formatting symbol at all in the number, except
        // for extensions. This is only important for countries with national prefixes.
        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
        return (0, _util.startsWith)(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
      }
    }
  } // The check here makes sure that we haven't mistakenly already used the extension to
  // match the last group of the subscriber number. Note the extension cannot have
  // formatting in-between digits.


  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
}
//# sourceMappingURL=Leniency.js.map

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = searchPhoneNumbersInText;

var _searchNumbers = _interopRequireDefault(__webpack_require__(611));

var _findPhoneNumbersInText = __webpack_require__(612);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function searchPhoneNumbersInText(text, defaultCountry, options, metadata) {
  var args = (0, _findPhoneNumbersInText.getArguments)(defaultCountry, options, metadata);
  return (0, _searchNumbers["default"])(text, args.options, args.metadata);
}
//# sourceMappingURL=searchPhoneNumbersInText.js.map

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AsYouTypeState =
/*#__PURE__*/
function () {
  function AsYouTypeState(_ref) {
    var _this = this;

    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    _classCallCheck(this, AsYouTypeState);

    _defineProperty(this, "update", function (properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        _this[key] = properties[key];
      }
    });

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  _createClass(AsYouTypeState, [{
    key: "reset",
    value: function reset(defaultCountry, defaultCallingCode) {
      this.international = false;
      this.IDDPrefix = undefined;
      this.missingPlus = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      return this.onCallingCodeChange(this.country, callingCode);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber() {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode();
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();

exports["default"] = AsYouTypeState;
//# sourceMappingURL=AsYouTypeState.js.map

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countOccurences = countOccurences;
exports.repeat = repeat;
exports.cutAndStripNonPairedParens = cutAndStripNonPairedParens;
exports.closeNonPairedParens = closeNonPairedParens;
exports.stripNonPairedParens = stripNonPairedParens;
exports.populateTemplateWithDigits = populateTemplateWithDigits;
exports.DIGIT_PLACEHOLDER = void 0;
// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

exports.DIGIT_PLACEHOLDER = DIGIT_PLACEHOLDER;
var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// Unicode-unsafe (because using `.split()`).

function countOccurences(symbol, string) {
  var count = 0; // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for counting brackets it is safe.
  // for (const character of string)

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;

    if (character === symbol) {
      count++;
    }
  }

  return count;
} // Repeats a string (or a symbol) N times.
// http://stackoverflow.com/questions/202605/repeat-string-javascript


function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}

function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}

function closeNonPairedParens(template, cut_before) {
  var retained_template = template.slice(0, cut_before);
  var opening_braces = countOccurences('(', retained_template);
  var closing_braces = countOccurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return template.slice(0, cut_before);
}

function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i2 = 0, _dangling_braces = dangling_braces; _i2 < _dangling_braces.length; _i2++) {
    var index = _dangling_braces[_i2];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}

function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = digits.split(''), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i3 >= _iterator2.length) break;
      _ref2 = _iterator2[_i3++];
    } else {
      _i3 = _iterator2.next();
      if (_i3.done) break;
      _ref2 = _i3.value;
    }

    var digit = _ref2;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}
//# sourceMappingURL=AsYouTypeFormatter.util.js.map

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatCompleteNumber;
exports.canFormatCompleteNumber = canFormatCompleteNumber;

var _checkNumberLength = _interopRequireDefault(__webpack_require__(252));

var _parseDigits = _interopRequireDefault(__webpack_require__(124));

var _formatNationalNumberUsingFormat = _interopRequireDefault(__webpack_require__(347));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}

function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return (0, _checkNumberLength["default"])(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  var nationalSignificantNumber = state.nationalSignificantNumber,
      international = state.international,
      nationalPrefix = state.nationalPrefix,
      carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = (0, _formatNationalNumberUsingFormat["default"])(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return (0, _parseDigits["default"])(formattedNationalNumber) === state.getNationalDigits();
}
//# sourceMappingURL=AsYouTypeFormatter.complete.js.map

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractFormattedDigitsAndPlus = extractFormattedDigitsAndPlus;
exports["default"] = void 0;

var _extractCountryCallingCode2 = _interopRequireDefault(__webpack_require__(600));

var _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign = _interopRequireDefault(__webpack_require__(349));

var _extractNationalNumberFromPossiblyIncompleteNumber = _interopRequireDefault(__webpack_require__(602));

var _stripIddPrefix = _interopRequireDefault(__webpack_require__(348));

var _parseDigits = _interopRequireDefault(__webpack_require__(124));

var _constants = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VALID_FORMATTED_PHONE_NUMBER_PART = '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_PART + '$', 'i');
var VALID_PHONE_NUMBER = '(?:' + '[' + _constants.PLUS_CHARS + ']' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']*' + '|' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser =
/*#__PURE__*/
function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    _classCallCheck(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  _createClass(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = _slicedToArray(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = (0, _parseDigits["default"])(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode(state) {
      var _extractCountryCallin = (0, _extractCountryCallingCode2["default"])('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = (0, _extractNationalNumberFromPossiblyIncompleteNumber["default"])(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = (0, _extractNationalNumberFromPossiblyIncompleteNumber["default"])(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, state.update)) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits,
          nationalSignificantNumber = state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = (0, _stripIddPrefix["default"])(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state);
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = (0, _extractCountryCallingCodeFromInternationalNumberWithoutPlusSign["default"])(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode,
            number = _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state);
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state) {
      state.startInternationalNumber(); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
      }
    }
  }]);

  return AsYouTypeParser;
}();
/**
 * Extracts formatted phone number from text (if there's any).
 * @param  {string} text
 * @return {string} [formattedPhoneNumber]
 */


exports["default"] = AsYouTypeParser;

function extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_PHONE_NUMBER);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = _slicedToArray(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}
//# sourceMappingURL=AsYouTypeParser.js.map

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatIncompletePhoneNumber;

var _AsYouType = _interopRequireDefault(__webpack_require__(615));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
 * @return {string} Formatted (possibly incomplete) phone number.
 */
function formatIncompletePhoneNumber(value, country, metadata) {
  if (!metadata) {
    metadata = country;
    country = undefined;
  }

  return new _AsYouType["default"](country, metadata).input(value);
}
//# sourceMappingURL=formatIncompletePhoneNumber.js.map

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCountries;

var _metadata = _interopRequireDefault(__webpack_require__(41));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getCountries(metadata) {
  return new _metadata["default"](metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(1362)
var getISOWeek = __webpack_require__(1365)
var getISOYear = __webpack_require__(618)
var parse = __webpack_require__(77)
var isValid = __webpack_require__(1368)
var enLocale = __webpack_require__(1369)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)
var startOfYear = __webpack_require__(1363)
var differenceInCalendarDays = __webpack_require__(1364)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(617)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)
var startOfISOWeek = __webpack_require__(353)
var startOfISOYear = __webpack_require__(1367)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(77)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(618)
var startOfISOWeek = __webpack_require__(353)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(137)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(1370)
var buildFormatLocale = __webpack_require__(1371)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 1370 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(1372)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 1372 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var createPadding = __webpack_require__(1374),
    stringSize = __webpack_require__(619),
    toInteger = __webpack_require__(316),
    toString = __webpack_require__(497);

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (createPadding(length - strLength, chars) + string)
    : string;
}

module.exports = padStart;


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var baseRepeat = __webpack_require__(1375),
    baseToString = __webpack_require__(498),
    castSlice = __webpack_require__(1376),
    hasUnicode = __webpack_require__(355),
    stringSize = __webpack_require__(619),
    stringToArray = __webpack_require__(1379);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars)
    ? castSlice(stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

module.exports = createPadding;


/***/ }),
/* 1375 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

module.exports = baseRepeat;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(354);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(565);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 1378 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1380),
    hasUnicode = __webpack_require__(355),
    unicodeToArray = __webpack_require__(1381);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1380 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1381 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/Pikaday/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution lifted from date.js (MIT license): https://github.com/datejs/Datejs
        return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // data-attribute on the input field with an aria assistance tekst (only applied when `bound` is set)
        ariaLabel: 'Use the arrow keys to pick a date',

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect : true,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null,

        // Enable keyboard input
        keyboardInput: true
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if(!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }

            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    isoWeek = function(date) {
        // Ensure we're at the start of the day.
        date.setHours(0, 0, 0, 0);

        // Thursday in current week decides the year because January 4th
        // is always in the first week according to ISO8601.

        var yearDay        = date.getDate()
          , weekDay        = date.getDay()
          , dayInFirstWeek = 4 // January 4th
          , dayShift       = dayInFirstWeek - 1 // counting starts at 0
          , daysPerWeek    = 7
          , prevWeekDay    = function(day) { return (day + daysPerWeek - 1) % daysPerWeek; }
        ;

        // Adjust to Thursday in week 1 and count number of weeks from date to week 1.

        date.setDate(yearDay + dayShift - prevWeekDay(weekDay));

        var jan4th      = new Date(date.getFullYear(), 0, dayInFirstWeek)
          , msPerDay    = 24 * 60 * 60 * 1000
          , daysBetween = (date.getTime() - jan4th.getTime()) / msPerDay
          , weekNum     = 1 + Math.round((daysBetween - dayShift + prevWeekDay(jan4th.getDay())) / daysPerWeek)
        ;

        return weekNum;
    },

    renderWeek = function (d, m, y) {
        var date = new Date(y, m, d)
          , week = hasMoment ? moment(date).isoWeek() : isoWeek(date)
        ;

        return '<td class="pika-week">' + week + '</td>';
    },

    renderRow = function(days, isRTL, pickWholeWeek, isRowSelected)
    {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? ' disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                    case 8:
                    case 46:
                        self.setDate(null);
                        break;
                }
            }
        };

        self._parseFieldValue = function()
        {
            if (opts.parse) {
                return opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                var date = moment(opts.field.value, opts.format, opts.formatStrict);
                return (date && date.isValid()) ? date.toDate() : null;
            } else {
                return new Date(Date.parse(opts.field.value));
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            date = self._parseFieldValue();
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);

        if (opts.keyboardInput) {
            addEvent(document, 'keydown', self._onKeyChange);
        }

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                opts.defaultDate = self._parseFieldValue();
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
              return this._o.toString(this._d, format);
            }
            if (hasMoment) {
              return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * clear and reset the date
         */
        clear: function()
        {
            this.setDate(null);
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            for (var c = 0; c < opts.numberOfMonths; c++) {
                randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', opts.ariaLabel);
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect, leftAligned, bottomAligned;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
            leftAligned = true;
            bottomAligned = true;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
                leftAligned = false;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
                bottomAligned = false;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';

            addClass(this.el, leftAligned ? 'left-aligned' : 'right-aligned');
            addClass(this.el, bottomAligned ? 'bottom-aligned' : 'top-aligned');
            removeClass(this.el, !leftAligned ? 'left-aligned' : 'right-aligned');
            removeClass(this.el, !bottomAligned ? 'bottom-aligned' : 'top-aligned');
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            var opts = this._o;

            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (opts.keyboardInput) {
                removeEvent(document, 'keydown', this._onKeyChange);
            }
            if (opts.field) {
                removeEvent(opts.field, 'change', this._onInputChange);
                if (opts.bound) {
                    removeEvent(opts.trigger, 'click', this._onInputClick);
                    removeEvent(opts.trigger, 'focus', this._onInputFocus);
                    removeEvent(opts.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;
}));


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(617)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(1386);
} else {
  module.exports = require('./lib/react-input-mask.development.js');
}


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(__webpack_require__(0)),reactDom=__webpack_require__(212);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r)}return e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else{var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select()}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else{var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length))}return{start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return{maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1)}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return-1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return!1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return!u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return!0;if(++s>=l.length)return!1}var t,n,a,i;return!isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return!1;var t,n;return(isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h)}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return"function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return(!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e)}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop)},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop()},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null)},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e)},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t)},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t)}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)})},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e)},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return{mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return!0}catch(r){}return!f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized(_assertThisInitialized(f)).beforePasteState,n=_assertThisInitialized(_assertThisInitialized(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end)},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else{var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end)}f.runSaveSelectionLoop()}isFunction(f.props.onFocus)&&f.props.onFocus(e)},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e)}isFunction(f.props.onBlur)&&f.props.onBlur(e)},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd()}};document.addEventListener("mouseup",r)}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e)},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""))},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e)};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value))},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p))}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end)}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate())},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop()},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1)}else t=React.createElement("input",_extends({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);module.exports=InputElement;


/***/ }),
/* 1387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APPhoneInput__ = __webpack_require__(1390);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__APPhoneInput__["a" /* default */]);

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_phone_number_input_native__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_phone_number_input_native___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_phone_number_input_native__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_libphonenumber_js_custom__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_libphonenumber_js_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_libphonenumber_js_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libphonenumber_js_metadata_min_json__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libphonenumber_js_metadata_min_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_libphonenumber_js_metadata_min_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__APPhoneInputFlags__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_phone_number_input_style_css__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_phone_number_input_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_phone_number_input_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__APPhoneInput_css__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__APPhoneInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__APPhoneInput_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var baseClass = 'ap-phone-input';

var APPhoneInnerInput = function (_React$Component) {
  _inherits(APPhoneInnerInput, _React$Component);

  function APPhoneInnerInput(props) {
    _classCallCheck(this, APPhoneInnerInput);

    var _this = _possibleConstructorReturn(this, (APPhoneInnerInput.__proto__ || Object.getPrototypeOf(APPhoneInnerInput)).call(this, props));

    _this.onChange = function (value, phone) {
      var _this$props = _this.props,
          onChange = _this$props.input.onChange,
          name = _this$props.name;
      var _this$state = _this.state,
          countryPrefix = _this$state.countryPrefix,
          countryCode = _this$state.countryCode;


      var meta = {
        countryPrefix: countryPrefix,
        countryCode: countryCode,
        noPrefixPhone: phone && phone.replace('+' + countryPrefix, '')
      };

      onChange(value, phone, meta, name);
    };

    _this.onCountryChange = function (countryCode) {
      var countryPrefix = Object(__WEBPACK_IMPORTED_MODULE_5_libphonenumber_js_custom__["getCountryCallingCode"])(countryCode, __WEBPACK_IMPORTED_MODULE_6_libphonenumber_js_metadata_min_json___default.a);
      _this.setState({ countryPrefix: countryPrefix, countryCode: countryCode });
    };

    _this.onFocus = function () {
      _this.setState({ focused: true });
    };

    _this.onBlur = function () {
      _this.setState({ focused: false });
    };

    _this.state = {
      phone: props.value,
      focused: false,
      countryPrefix: null,
      countryCode: null
    };
    return _this;
  }

  _createClass(APPhoneInnerInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          customClass = _props.customClass,
          classModifiers = _props.classModifiers,
          info = _props.info,
          label = _props.label,
          rightLabelText = _props.rightLabelText,
          _props$meta = _props.meta,
          error = _props$meta.error,
          dirty = _props$meta.dirty;


      var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_cssClassesHelper__["b" /* getBEMClasses */])([baseClass, customClass]);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'form-group ' + bemClasses('input-wrapper', classModifiers),
          onFocus: this.onFocus,
          onBlur: this.onBlur },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { className: 'ap--label ' + bemClasses('label', classModifiers) },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(rightLabelText && bemClasses('input-with-right-label-container'), bemClasses('input-box')) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_phone_number_input_native___default.a, {
            name: 'telephone',
            value: this.state.phone,
            flagComponent: __WEBPACK_IMPORTED_MODULE_7__APPhoneInputFlags__["a" /* default */],
            international: false,
            displayInitialValueAsLocalNumber: true,
            country: this.props.country || __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].global.phoneDefaultCountry,
            countries: __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].global.phoneWhiteListCountries,
            placeholder: this.props.placeholder,
            inputClassName: bemClasses('input'),
            onChange: this.onChange,
            onCountryChange: this.onCountryChange,
            metadata: __WEBPACK_IMPORTED_MODULE_6_libphonenumber_js_metadata_min_json___default.a
          }),
          info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-text-muted ' + bemClasses('info') },
            info
          ),
          dirty && error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('error') },
            error
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      var phone = nextProps.value;

      if (phone) {
        var parsed = Object(__WEBPACK_IMPORTED_MODULE_5_libphonenumber_js_custom__["parseNumber"])(phone, __WEBPACK_IMPORTED_MODULE_6_libphonenumber_js_metadata_min_json___default.a);
        if (parsed.country) {
          var countryCode = parsed.country;
          var countryPrefix = countryCode && Object(__WEBPACK_IMPORTED_MODULE_5_libphonenumber_js_custom__["getCountryCallingCode"])(countryCode, __WEBPACK_IMPORTED_MODULE_6_libphonenumber_js_metadata_min_json___default.a);
          return { phone: phone, countryCode: countryCode, countryPrefix: countryPrefix };
        }
      }

      return { phone: phone };
    }
  }]);

  return APPhoneInnerInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

APPhoneInnerInput.defaultProps = {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: '',
  country: '',
  onChange: function onChange() {}
};

APPhoneInnerInput.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var APPhoneInput = function APPhoneInput(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: APPhoneInnerInput }, props));
};

APPhoneInput.defaultProps = {
  name: '',
  label: '',
  labelInInput: '',
  type: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  rows: 1
};

APPhoneInput.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelInInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rightLabelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (APPhoneInput);

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

// Deprecated.
// Use the default export instead.

var PhoneInput = __webpack_require__(1392).default

exports = module.exports = PhoneInput
exports['default']       = PhoneInput

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadataMin = __webpack_require__(352);

var _metadataMin2 = _interopRequireDefault(_metadataMin);

var _PhoneInputNativeDefaults = __webpack_require__(1393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Deprecated.
// This is a file used in legacy `/index.js` export entry.
// In some next major version this file will be removed
// and `/index.js` will be redirected to `/min/index.js`.

exports.default = (0, _PhoneInputNativeDefaults.createPhoneInput)(_metadataMin2.default);
//# sourceMappingURL=PhoneInputNativeDefaultMetadata.js.map

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createPhoneInput = createPhoneInput;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _en = __webpack_require__(1394);

var _en2 = _interopRequireDefault(_en);

var _InternationalIcon = __webpack_require__(1395);

var _InternationalIcon2 = _interopRequireDefault(_InternationalIcon);

var _PropTypes = __webpack_require__(620);

var _PhoneInputNative = __webpack_require__(1396);

var _PhoneInputNative2 = _interopRequireDefault(_PhoneInputNative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createPhoneInput(defaultMetadata) {
	var _class, _temp2;

	return _temp2 = _class = function (_Component) {
		_inherits(PhoneInputNativeDefaults, _Component);

		function PhoneInputNativeDefaults() {
			var _ref;

			var _temp, _this, _ret;

			_classCallCheck(this, PhoneInputNativeDefaults);

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputNativeDefaults.__proto__ || Object.getPrototypeOf(PhoneInputNativeDefaults)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
				return _this.input = ref;
			}, _this.render = function () {
				return _react2.default.createElement(_PhoneInputNative2.default, _extends({ ref: _this.storeInputRef }, _this.props));
			}, _this.focus = function () {
				return _this.input.focus();
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}

		return PhoneInputNativeDefaults;
	}(_react.Component), _class.propTypes = {
		metadata: _PropTypes.metadata.isRequired,
		labels: _PropTypes.labels.isRequired,
		internationalIcon: _propTypes2.default.elementType.isRequired
	}, _class.defaultProps = {
		metadata: defaultMetadata,
		labels: _en2.default,
		internationalIcon: _InternationalIcon2.default
	}, _temp2;
}

exports.default = createPhoneInput();
//# sourceMappingURL=PhoneInputNativeDefaults.js.map

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports = {"ext":"ext.","country":"Country","phone":"Phone","AB":"Abkhazia","AC":"Ascension Island","AD":"Andorra","AE":"United Arab Emirates","AF":"Afghanistan","AG":"Antigua and Barbuda","AI":"Anguilla","AL":"Albania","AM":"Armenia","AO":"Angola","AQ":"Antarctica","AR":"Argentina","AS":"American Samoa","AT":"Austria","AU":"Australia","AW":"Aruba","AX":"Åland Islands","AZ":"Azerbaijan","BA":"Bosnia and Herzegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgium","BF":"Burkina Faso","BG":"Bulgaria","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Saint Barthélemy","BM":"Bermuda","BN":"Brunei Darussalam","BO":"Bolivia, plurinational state of","BQ":"Bonaire, Sint Eustatius and Saba","BR":"Brazil","BS":"Bahamas","BT":"Bhutan","BV":"Bouvet Island","BW":"Botswana","BY":"Belarus","BZ":"Belize","CA":"Canada","CC":"Cocos (Keeling) Islands","CD":"Congo, Democratic Republic of the","CF":"Central African Republic","CG":"Congo","CH":"Switzerland","CI":"Cote d'Ivoire","CK":"Cook Islands","CL":"Chile","CM":"Cameroon","CN":"China","CO":"Colombia","CR":"Costa Rica","CU":"Cuba","CV":"Cape Verde","CW":"Curaçao","CX":"Christmas Island","CY":"Cyprus","CZ":"Czech Republic","DE":"Germany","DJ":"Djibouti","DK":"Denmark","DM":"Dominica","DO":"Dominican Republic","DZ":"Algeria","EC":"Ecuador","EE":"Estonia","EG":"Egypt","EH":"Western Sahara","ER":"Eritrea","ES":"Spain","ET":"Ethiopia","FI":"Finland","FJ":"Fiji","FK":"Falkland Islands (Malvinas)","FM":"Micronesia, Federated States of","FO":"Faroe Islands","FR":"France","GA":"Gabon","GB":"United Kingdom","GD":"Grenada","GE":"Georgia","GF":"French Guiana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Greenland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Equatorial Guinea","GR":"Greece","GS":"South Georgia and the South Sandwich Islands","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hong Kong","HM":"Heard Island and McDonald Islands","HN":"Honduras","HR":"Croatia","HT":"Haiti","HU":"Hungary","ID":"Indonesia","IE":"Ireland","IL":"Israel","IM":"Isle of Man","IN":"India","IO":"British Indian Ocean Territory","IQ":"Iraq","IR":"Iran, Islamic Republic of","IS":"Iceland","IT":"Italy","JE":"Jersey","JM":"Jamaica","JO":"Jordan","JP":"Japan","KE":"Kenya","KG":"Kyrgyzstan","KH":"Cambodia","KI":"Kiribati","KM":"Comoros","KN":"Saint Kitts and Nevis","KP":"Korea, Democratic People's republic of","KR":"Korea, Republic of","KW":"Kuwait","KY":"Cayman Islands","KZ":"Kazakhstan","LA":"Lao People's Democratic Republic","LB":"Lebanon","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Lithuania","LU":"Luxembourg","LV":"Latvia","LY":"Libyan Arab Jamahiriya","MA":"Morocco","MC":"Monaco","MD":"Moldova","ME":"Montenegro","MF":"Saint Martin (French Part)","MG":"Madagascar","MH":"Marshall Islands","MK":"Macedonia, The Former Yugoslav Republic Of","ML":"Mali","MM":"Burma","MN":"Mongolia","MO":"Macao","MP":"Northern Mariana Islands","MQ":"Martinique","MR":"Mauritania","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Maldives","MW":"Malawi","MX":"Mexico","MY":"Malaysia","MZ":"Mozambique","NA":"Namibia","NC":"New Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NI":"Nicaragua","NL":"Netherlands","NO":"Norway","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"New Zealand","OM":"Oman","OS":"South Ossetia","PA":"Panama","PE":"Peru","PF":"French Polynesia","PG":"Papua New Guinea","PH":"Philippines","PK":"Pakistan","PL":"Poland","PM":"Saint Pierre and Miquelon","PN":"Pitcairn","PR":"Puerto Rico","PS":"Palestinian Territory, Occupied","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"Reunion","RO":"Romania","RS":"Serbia","RU":"Russian Federation","RW":"Rwanda","SA":"Saudi Arabia","SB":"Solomon Islands","SC":"Seychelles","SD":"Sudan","SE":"Sweden","SG":"Singapore","SH":"Saint Helena, Ascension And Tristan Da Cunha","SI":"Slovenia","SJ":"Svalbard and Jan Mayen","SK":"Slovakia","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Suriname","SS":"South Sudan","ST":"Sao Tome and Principe","SV":"El Salvador","SX":"Sint Maarten","SY":"Syrian Arab Republic","SZ":"Swaziland","TA":"Tristan da Cunha","TC":"Turks and Caicos Islands","TD":"Chad","TF":"French Southern Territories","TG":"Togo","TH":"Thailand","TJ":"Tajikistan","TK":"Tokelau","TL":"Timor-Leste","TM":"Turkmenistan","TN":"Tunisia","TO":"Tonga","TR":"Turkey","TT":"Trinidad and Tobago","TV":"Tuvalu","TW":"Taiwan, Province of China","TZ":"Tanzania, United Republic Of","UA":"Ukraine","UG":"Uganda","UM":"United States Minor Outlying Islands","US":"United States","UY":"Uruguay","UZ":"Uzbekistan","VA":"Holy See (Vatican City State)","VC":"Saint Vincent and the Grenadines","VE":"Venezuela","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis and Futuna","WS":"Samoa","XK":"Kosovo","YE":"Yemen","YT":"Mayotte","ZA":"South Africa","ZM":"Zambia","ZW":"Zimbabwe","ZZ":"International"}

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = InternationalIcon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InternationalIcon() {
	return _react2.default.createElement(
		"svg",
		{ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50" },
		_react2.default.createElement("path", { stroke: "currentColor", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56" }),
		_react2.default.createElement("path", { stroke: "currentColor", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21" }),
		_react2.default.createElement("path", { stroke: "currentColor", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86" }),
		_react2.default.createElement("path", { stroke: "currentColor", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54" }),
		_react2.default.createElement("line", { stroke: "currentColor", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", x1: "27.8", y1: "0.85", x2: "27.8", y2: "34.61" }),
		_react2.default.createElement("line", { stroke: "currentColor", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", x1: "15.2", y1: "22.23", x2: "49.15", y2: "22.23" }),
		_react2.default.createElement("path", { stroke: "transparent", fill: "currentColor", d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z" })
	);
}
//# sourceMappingURL=InternationalIcon.js.map

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(39);

var _classnames2 = _interopRequireDefault(_classnames);

var _PhoneInput = __webpack_require__(1397);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _CountrySelectNative = __webpack_require__(1431);

var _CountrySelectNative2 = _interopRequireDefault(_CountrySelectNative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PhoneInputNative = (_temp2 = _class = function (_Component) {
	_inherits(PhoneInputNative, _Component);

	function PhoneInputNative() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, PhoneInputNative);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputNative.__proto__ || Object.getPrototypeOf(PhoneInputNative)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
			return _this.input = ref;
		}, _this.focus = function () {
			return _this.input.focus();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	// These two country-select-related properties are
	// implemented as `defaultProps` instead of passing them
	// directly to the `<PhoneInput/>` because `<PhoneInputNative/>`
	// is the default export of this library and therefore people pass
	// `countrySelectComponent` property to this `<PhoneInputNative/>` component
	// and when they don't see any changes they might get confused.
	// https://github.com/catamphetamine/react-phone-number-input/issues/229


	_createClass(PhoneInputNative, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(_PhoneInput2.default, _extends({ ref: this.storeInputRef }, this.props));
		}

		// Proxy `.focus()` method.

	}]);

	return PhoneInputNative;
}(_react.Component), _class.propTypes = {
	// (optional)
	// Replaces the default country select arrow.
	countrySelectArrowComponent: _propTypes2.default.elementType }, _class.defaultProps = {
	countrySelectComponent: _CountrySelectNative2.default,
	countrySelectProperties: COUNTRY_SELECT_PROPERTIES
}, _temp2);
exports.default = PhoneInputNative;


var COUNTRY_SELECT_PROPERTIES = {
	countrySelectArrowComponent: 'selectArrowComponent'
};
//# sourceMappingURL=PhoneInputNative.js.map

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp, _initialiseProps;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(39);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLifecyclesCompat = __webpack_require__(95);

var _core = __webpack_require__(258);

var _InputSmart = __webpack_require__(1420);

var _InputSmart2 = _interopRequireDefault(_InputSmart);

var _InputBasic = __webpack_require__(1428);

var _InputBasic2 = _interopRequireDefault(_InputBasic);

var _Flag = __webpack_require__(1429);

var _Flag2 = _interopRequireDefault(_Flag);

var _PropTypes = __webpack_require__(620);

var _inputControl = __webpack_require__(1430);

var _countries2 = __webpack_require__(642);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react2.default.PureComponent || _react2.default.Component;

var PhoneNumberInput = (0, _reactLifecyclesCompat.polyfill)(_class = (_temp = _class2 = function (_PureComponent) {
	_inherits(PhoneNumberInput, _PureComponent);

	function PhoneNumberInput(props) {
		_classCallCheck(this, PhoneNumberInput);

		var _this = _possibleConstructorReturn(this, (PhoneNumberInput.__proto__ || Object.getPrototypeOf(PhoneNumberInput)).call(this, props));

		_initialiseProps.call(_this);

		var _this$props = _this.props,
		    value = _this$props.value,
		    labels = _this$props.labels,
		    international = _this$props.international,
		    metadata = _this$props.metadata;
		var _this$props2 = _this.props,
		    country = _this$props2.country,
		    countries = _this$props2.countries,
		    countryOptions = _this$props2.countryOptions;

		// Validate `country`.

		if (country) {
			if (!_this.isCountrySupportedWithError(country)) {
				country = undefined;
			}
		}

		// Validate `countries`.
		countries = filterCountries(countries, metadata);

		// Validate `countryOptions`.
		countryOptions = filterCountryOptions(countryOptions, metadata);

		var phoneNumber = (0, _inputControl.parsePhoneNumber)(value, metadata);

		var pre_selected_country = (0, _inputControl.getPreSelectedCountry)(phoneNumber, country, countries || (0, _countries2.getCountryCodes)(labels).filter(function (_) {
			return _ === 'ZZ' || metadata.countries[_];
		}), international, metadata);

		_this.state = {
			// Workaround for `this.props` inside `getDerivedStateFromProps()`.
			props: _this.props,

			// The country selected.
			country: pre_selected_country,

			// `countries` are stored in `this.state` because they're filtered.
			// For example, a developer might theoretically pass some unsupported
			// countries as part of the `countries` property, and because of that
			// the component uses `this.state.countries` (which are filtered)
			// instead of `this.props.countries`
			// (which could potentially contain unsupported countries).
			countries: countries,

			// Generate country `<select/>` options.
			country_select_options: generateCountrySelectOptions(countries, countryOptions, _this.props),

			// `parsed_input` state property holds non-formatted user's input.
			// The reason is that there's no way of finding out
			// in which form should `value` be displayed: international or national.
			// E.g. if `value` is `+78005553535` then it could be input
			// by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
			// Hence storing just `value`is not sufficient for correct formatting.
			// E.g. if a user entered `8 (800) 555-35-35`
			// then value is `+78005553535` and `parsed_input` is `88005553535`
			// and if a user entered `+7 800 555 35 35`
			// then value is `+78005553535` and `parsed_input` is `+78005553535`.
			parsed_input: generateParsedInput(value, phoneNumber, _this.props),

			// `value` property is duplicated in state.
			// The reason is that `getDerivedStateFromProps()`
			// needs this `value` to compare to the new `value` property
			// to find out if `parsed_input` needs updating:
			// If the `value` property was changed externally
			// then it won't be equal to `state.value`
			// in which case `parsed_input` and `country` should be updated.
			value: value
		};
		return _this;
	}

	_createClass(PhoneNumberInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var onCountryChange = this.props.onCountryChange;
			var country = this.props.country;
			var selectedCountry = this.state.country;


			if (onCountryChange) {
				if (!country || !this.isCountrySupportedWithError(country)) {
					country = undefined;
				}
				if (selectedCountry !== country) {
					onCountryChange(selectedCountry);
				}
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _props = this.props,
			    onCountryChange = _props.onCountryChange,
			    onChange = _props.onChange,
			    reset = _props.reset;
			// Call `onCountryChange` when user selects another country.

			if (onCountryChange && this.state.country !== prevState.country) {
				onCountryChange(this.state.country);
			}
			// Some users requested a way to reset the component
			// (both number `<input/>` and country `<select/>`).
			// Whenever `reset` property changes both number `<input/>`
			// and country `<select/>` are reset.
			// It's not implemented as some instance `.reset()` method
			// because `ref` will likely be forwarded to `<input/>`
			// in some next major version.
			// https://github.com/catamphetamine/react-phone-number-input/issues/300
			if (reset !== prevProps.reset) {
				onChange();
				if (onCountryChange) {
					onCountryChange(this.state.country);
				}
			}
		}

		// A shorthand for not passing `metadata` as a second argument.


		// Country `<select/>` `onChange` handler.


		// Phone number `<input/>` `onKeyDown` handler.


		/**
   * `<input/>` `onChange()` handler.
   * Updates `value` property accordingly (so that they are kept in sync).
   * @param {string?} input — Either a parsed phone number or an empty string. Examples: `""`, `"+"`, `"+123"`, `"123"`.
   */


		// Toggles the `--focus` CSS class.


		// Toggles the `--focus` CSS class.


		// This `onBlur` interceptor is a workaround for `redux-form`
		// so that it gets the up-to-date `value` in its `onBlur` handler.
		// Without this fix it just gets the actual (raw) input field textual value.
		// E.g. `+7 800 555 35 35` instead of `+78005553535`.
		//
		// A developer is not supposed to pass this `onBlur` property manually.
		// Instead, `redux-form` passes `onBlur` to this component automatically
		// and this component patches that `onBlur` handler (a hacky way but works).
		//


		// When country `<select/>` is toggled.


		// Can be called externally.

	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    name = _props2.name,
			    disabled = _props2.disabled,
			    disablePhoneInput = _props2.disablePhoneInput,
			    autoComplete = _props2.autoComplete,
			    countrySelectTabIndex = _props2.countrySelectTabIndex,
			    showCountrySelect = _props2.showCountrySelect,
			    style = _props2.style,
			    className = _props2.className,
			    inputClassName = _props2.inputClassName,
			    getInputClassName = _props2.getInputClassName,
			    countrySelectAriaLabel = _props2.countrySelectAriaLabel,
			    countrySelectProperties = _props2.countrySelectProperties,
			    error = _props2.error,
			    indicateInvalid = _props2.indicateInvalid,
			    CountrySelectComponent = _props2.countrySelectComponent,
			    countrySelectProps = _props2.countrySelectProps,
			    inputStyleReset = _props2.inputStyleReset,
			    _InputComponent = _props2.inputComponent,
			    inputComponent = _props2.numberInputComponent,
			    numberInputProps = _props2.numberInputProps,
			    smartCaret = _props2.smartCaret,
			    ext = _props2.ext,
			    _ = _props2.country,
			    countries = _props2.countries,
			    countryOptions = _props2.countryOptions,
			    labels = _props2.labels,
			    flags = _props2.flags,
			    flagComponent = _props2.flagComponent,
			    flagsPath = _props2.flagsPath,
			    international = _props2.international,
			    internationalIcon = _props2.internationalIcon,
			    displayInitialValueAsLocalNumber = _props2.displayInitialValueAsLocalNumber,
			    onCountryChange = _props2.onCountryChange,
			    limitMaxLength = _props2.limitMaxLength,
			    metadata = _props2.metadata,
			    reset = _props2.reset,
			    phoneNumberInputProps = _objectWithoutProperties(_props2, ['name', 'disabled', 'disablePhoneInput', 'autoComplete', 'countrySelectTabIndex', 'showCountrySelect', 'style', 'className', 'inputClassName', 'getInputClassName', 'countrySelectAriaLabel', 'countrySelectProperties', 'error', 'indicateInvalid', 'countrySelectComponent', 'countrySelectProps', 'inputStyleReset', 'inputComponent', 'numberInputComponent', 'numberInputProps', 'smartCaret', 'ext', 'country', 'countries', 'countryOptions', 'labels', 'flags', 'flagComponent', 'flagsPath', 'international', 'internationalIcon', 'displayInitialValueAsLocalNumber', 'onCountryChange', 'limitMaxLength', 'metadata', 'reset']);

			var _state = this.state,
			    country = _state.country,
			    hidePhoneInputField = _state.hidePhoneInputField,
			    country_select_options = _state.country_select_options,
			    parsed_input = _state.parsed_input,
			    isFocused = _state.isFocused;


			var InputComponent = _InputComponent || (smartCaret ? _InputSmart2.default : _InputBasic2.default);

			// Extract `countrySelectProperties` from `this.props`
			// also removing them from `phoneNumberInputProps`.
			var _countrySelectProps = {};
			if (countrySelectProperties) {
				for (var key in countrySelectProperties) {
					if (this.props.hasOwnProperty(key)) {
						_countrySelectProps[countrySelectProperties[key]] = this.props[key];
						delete phoneNumberInputProps[key];
					}
				}
			}

			// Could use something like `aria-label={labels.phone}` on the `<InputComponent/>`,
			// however, some users may have already been using this component with one of:
			// * `<label/>` container
			// * `aria-labelledby`
			// * `id` and `<label for/>`
			// https://developers.google.com/web/fundamentals/accessibility/semantics-aria/aria-labels-and-relationships
			// Maybe in some future major version update.

			return _react2.default.createElement(
				'div',
				{
					style: style,
					className: (0, _classnames2.default)('react-phone-number-input', {
						'react-phone-number-input--focus': isFocused,
						'react-phone-number-input--invalid': error && indicateInvalid
					}, className) },
				_react2.default.createElement(
					'div',
					{ className: 'react-phone-number-input__row' },
					showCountrySelect && _react2.default.createElement(CountrySelectComponent, _extends({}, _countrySelectProps, {
						ref: this.storeCountrySelectInstance,
						name: name ? name + '__country' : undefined,
						'aria-label': countrySelectAriaLabel || labels.country,
						tabIndex: countrySelectTabIndex
					}, countrySelectProps, {
						value: country,
						options: country_select_options,
						onChange: this.onCountryChange,
						onFocus: this._onFocus,
						onBlur: this._onBlur,
						disabled: disabled,
						hidePhoneInputField: this.hidePhoneInputField,
						focusPhoneInputField: this.focus,
						className: 'react-phone-number-input__country' })),
					!hidePhoneInputField && _react2.default.createElement(InputComponent, _extends({
						type: 'tel',
						autoComplete: autoComplete
					}, numberInputProps, phoneNumberInputProps, {
						ref: this.storePhoneNumberInputInstance,
						name: name,
						metadata: metadata,
						country: country,
						value: parsed_input || '',
						onChange: this.onChange,
						onFocus: this.onFocus,
						onBlur: this.onBlur,
						onKeyDown: this.onPhoneNumberKeyDown,
						disabled: disabled || disablePhoneInput,
						inputComponent: inputComponent,
						className: (0, _classnames2.default)('react-phone-number-input__input', 'react-phone-number-input__phone', {
							'react-phone-number-input__input--style': !inputStyleReset,
							'react-phone-number-input__input--disabled': disabled || disablePhoneInput,
							'react-phone-number-input__input--style--disabled': (disabled || disablePhoneInput) && !inputStyleReset,
							'react-phone-number-input__input--invalid': error && indicateInvalid,
							'react-phone-number-input__input--style--invalid': error && indicateInvalid && !inputStyleReset
						}, inputClassName, getInputClassName && getInputClassName({
							disabled: disabled || disablePhoneInput,
							invalid: error && indicateInvalid
						})) })),
					ext && !hidePhoneInputField && _react2.default.createElement(
						'label',
						{ className: 'react-phone-number-input__ext' },
						labels.ext,
						_react2.default.cloneElement(ext, {
							onChange: ext.props.onChange ? function (event) {
								return ext.props.onChange(parseExtDigits(event));
							} : undefined,
							onFocus: this._onFocus,
							onBlur: this._onBlur,
							className: (0, _classnames2.default)('react-phone-number-input__input', 'react-phone-number-input__ext-input', {
								'react-phone-number-input__input--disabled': disabled || disablePhoneInput
							}, inputClassName, getInputClassName && getInputClassName({
								disabled: disabled || disablePhoneInput
							}), ext.props.className)
						})
					)
				),
				error && indicateInvalid && _react2.default.createElement(
					'div',
					{ className: 'react-phone-number-input__error' },
					error
				)
			);
		}
	}], [{
		key: 'getDerivedStateFromProps',


		// `state` holds previous props as `props`, and also:
		// * `country` — The currently selected country, e.g. `"RU"`.
		// * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
		// * `parsed_input` — The parsed `<input/>` value, e.g. `8005553535`.
		// (and a couple of other less significant properties)
		value: function getDerivedStateFromProps(props, state) {
			var country = state.country,
			    hasUserSelectedACountry = state.hasUserSelectedACountry,
			    value = state.value,
			    _state$props = state.props,
			    old_default_country = _state$props.country,
			    old_value = _state$props.value,
			    old_reset = _state$props.reset;
			var metadata = props.metadata,
			    countries = props.countries,
			    new_default_country = props.country,
			    new_value = props.value,
			    new_reset = props.reset;


			var new_state = {
				// Emulate `prevProps` via `state.props`.
				props: props,
				// If the user has already manually selected a country
				// then don't override that already selected country
				// if the default `country` property changes.
				// That's what `hasUserSelectedACountry` flag is for.
				hasUserSelectedACountry: hasUserSelectedACountry

				// If `countries` or `labels` or `international` changed
				// then re-generate country `<select/>` options.
			};if (props.countries !== state.props.countries || props.labels !== state.props.labels || props.international !== state.props.international) {
				// Re-generate country select options.
				new_state.country_select_options = generateCountrySelectOptions(filterCountries(props.countries, metadata), filterCountryOptions(props.countryOptions, metadata), props);
			}

			// Some users requested a way to reset the component
			// (both number `<input/>` and country `<select/>`).
			// Whenever `reset` property changes both number `<input/>`
			// and country `<select/>` are reset.
			// It's not implemented as some instance `.reset()` method
			// because `ref` will likely be forwarded to `<input/>`.
			// https://github.com/catamphetamine/react-phone-number-input/issues/300
			if (new_reset !== old_reset) {
				return _extends({}, new_state, {
					parsed_input: undefined,
					value: undefined,
					country: new_default_country
				});
			}

			// If the default country changed.
			// (e.g. in case of ajax GeoIP detection after page loaded)
			// then select it but only if the user hasn't already manually
			// selected a country and no phone number has been entered so far.
			// Because if the user has already started inputting a phone number
			// then he's okay with no country being selected at all ("International")
			// and doesn't want to be disturbed, doesn't want his input to be screwed, etc.
			if (new_default_country !== old_default_country && !hasUserSelectedACountry && !value && !new_value) {
				return _extends({}, new_state, {
					country: isCountrySupportedWithError(new_default_country, metadata) ? new_default_country : old_default_country
					// `value` is `undefined`.
					// `parsed_input` is `undefined` because `value` is `undefined`.
				});
			}
			// If a new `value` is set externally.
			// (e.g. as a result of an ajax API request
			//  to get user's phone after page loaded)
			// The first part — `new_value !== old_value` —
			// is basically `props.value !== prevProps.value`
			// so it means "if value property was changed externally".
			// The second part — `new_value !== value` —
			// is for ignoring the `getDerivedStateFromProps()` call
			// which happens in `this.onChange()` right after `this.setState()`.
			// If this `getDerivedStateFromProps()` call isn't ignored
			// then the country flag would reset on each input.
			else if (new_value !== old_value && new_value !== value) {
					var phoneNumber = (0, _inputControl.parsePhoneNumber)(new_value, metadata);
					var parsedCountry = void 0;
					if (phoneNumber) {
						var _countries = filterCountries(props.countries, metadata);
						if (!_countries || _countries.indexOf(phoneNumber.country) >= 0) {
							parsedCountry = phoneNumber.country;
						}
					}
					return _extends({}, new_state, {
						parsed_input: generateParsedInput(new_value, phoneNumber, props),
						value: new_value,
						country: new_value ? parsedCountry : country
					});
				}

			// `country` didn't change.
			// `value` didn't change.
			// `parsed_input` didn't change, because `value` didn't change.
			//
			// Maybe `new_state.country_select_options` changed.
			// In any case, update `prevProps`.
			return new_state;
		}
	}]);

	return PhoneNumberInput;
}(PureComponent), _class2.propTypes = {
	/**
  * Phone number in `E.164` format.
  *
  * Example:
  *
  * `"+12223333333"`
  */
	value: _propTypes2.default.string,

	/**
  * Updates the `value` as the user inputs the phone number.
  */
	onChange: _propTypes2.default.func.isRequired,

	/**
  * Toggles the `--focus` CSS class.
  * @ignore
  */
	onFocus: _propTypes2.default.func,

	/**
  * `onBlur` is usually passed by `redux-form`.
  * @ignore
  */
	onBlur: _propTypes2.default.func,

	/**
  * `onKeyDown` handler (e.g. to handle Enter key press).
  * @ignore
  */
	onKeyDown: _propTypes2.default.func,

	/**
  * Disables both the phone number `<input/>`
  * and the country `<select/>`.
  */
	// (is `false` by default)
	disabled: _propTypes2.default.bool.isRequired,

	/**
  * Sets `autoComplete` property for phone number `<input/>`.
  *
  * Web browser's "autocomplete" feature
  * remembers the phone number being input
  * and can also autofill the `<input/>`
  * with previously remembered phone numbers.
  *
  * https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
  *
  * For example, can be used to turn it off:
  *
  * "So when should you use `autocomplete="off"`?
  *  One example is when you've implemented your own version
  *  of autocomplete for search. Another example is any form field
  *  where users will input and submit different kinds of information
  *  where it would not be useful to have the browser remember
  *  what was submitted previously".
  */
	// (is `"tel"` by default)
	autoComplete: _propTypes2.default.string.isRequired,

	/**
  * Set to `true` to show the initial `value` in
  * "national" format rather than "international".
  *
  * For example, if this flag is set to `true`
  * and the initial `value="+12133734253"` is passed
  * then the `<input/>` value will be `"(213) 373-4253"`.
  *
  * By default, this flag is set to `false`,
  * meaning that if the initial `value="+12133734253"` is passed
  * then the `<input/>` value will be `"+1 213 373 4253"`.
  *
  * The reason for such default behaviour is that
  * the newer generation grows up when there are no stationary phones
  * and therefore everyone inputs phone numbers in international format
  * in their smartphones so people gradually get more accustomed to
  * writing phone numbers in international format rather than in local format.
  * Future people won't be using "national" format, only "international".
  */
	// (is `false` by default)
	displayInitialValueAsLocalNumber: _propTypes2.default.bool.isRequired,

	/**
  * The country to be selected by default.
  * For example, can be set after a GeoIP lookup.
  *
  * Example: `"US"`.
  */
	// A two-letter country code ("ISO 3166-1 alpha-2").
	country: _propTypes2.default.string,

	/**
  * If specified, only these countries will be available for selection.
  *
  * Example:
  *
  * `["RU", "UA", "KZ"]`
  */
	countries: _propTypes2.default.arrayOf(_propTypes2.default.string),

	/**
  * Custom country `<select/>` option names.
  * Also some labels like "ext" and country `<select/>` `aria-label`.
  *
  * Example:
  *
  * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
  *
  * See the `locales` directory for examples.
  */
	labels: _PropTypes.labels.isRequired,

	/**
  * The base URL path for country flag icons.
  * By default it loads country flag icons from
  * `flag-icon-css` repo github pages website.
  * I imagine someone might want to download
  * those country flag icons and host them
  * on their own servers instead.
  * Warning: in future new countries can be added
  * to the country select which would result in
  * "Image not found" errors when using custom `flagsPath`
  * due to the custom-hosted flags bundle being outdated
  * and missing the new flags.
  * So if using custom `flagsPath` always check `CHANGELOG.md`
  * for new country announcements before updating this library.
  */
	flagsPath: _propTypes2.default.string.isRequired,

	/**
  * Custom country flag icon components.
  * These flags replace the default ones.
  *
  * The shape is an object where keys are country codes
  * and values are flag icon components.
  * Flag icon components receive the same properties
  * as `flagComponent` (see below).
  *
  * Example:
  *
  * `{ "RU": () => <img src="..."/> }`
  *
  * Can be used to replace the default flags
  * with custom ones for certain (or all) countries.
  *
  * Can also be used to bundle `<svg/>` flags instead of `<img/>`s:
  *
  * By default flag icons are inserted as `<img/>`s
  * with their `src` pointed to `flag-icon-css` repo github pages website.
  *
  * There might be some cases
  * (e.g. a standalone "native" app, or an "intranet" web application)
  * when including the full set of `<svg/>` country flags (3 megabytes)
  * is more appropriate than downloading them individually at runtime only if needed.
  *
  * Example:
  *
  * `// Uses <svg/> flags (3 megabytes):`
  *
  * `import flags from 'react-phone-number-input/flags'`
  *
  * `import PhoneInput from 'react-phone-number-input'`
  *
  * `<PhoneInput flags={flags} .../>`
  */
	flags: _propTypes2.default.objectOf(_propTypes2.default.elementType),

	/**
  * Country flag icon component.
  *
  * Takes properties:
  *
  * * country : string — The country code.
  * * flagsPath : string — The `flagsPath` property (see above).
  * * flags : object — The `flags` property (see above).
  */
	flagComponent: _propTypes2.default.elementType.isRequired,

	/**
  * Set to `false` to drop the "International" option from country `<select/>`.
  */
	international: _propTypes2.default.bool.isRequired,

	/**
  * Custom "International" country `<select/>` option icon.
  */
	internationalIcon: _propTypes2.default.elementType.isRequired,

	/**
  * Set to `false` to hide country `<select/>`.
  */
	// (is `true` by default)
	showCountrySelect: _propTypes2.default.bool.isRequired,

	/**
  * HTML `tabindex` attribute for country `<select/>`.
  */
	countrySelectTabIndex: _propTypes2.default.number,

	/**
  * HTML `aria-label` attribute for country `<select/>`.
  * The default is `.country` of the `labels` property
  * which is `"Country"` for the default `labels`.
  */
	countrySelectAriaLabel: _propTypes2.default.string,

	/**
  * Can be used to place some countries on top of the list of country `<select/>` options.
  *
  * * `"|"` — inserts a separator.
  * * `"..."` — means "the rest of the countries" (can be omitted).
  *
  * Example:
  *
  * `["US", "CA", "AU", "|", "..."]`
  */
	countryOptions: _propTypes2.default.arrayOf(_propTypes2.default.string),

	/**
  * Some users requested a way to reset the component:
  * both number `<input/>` and country `<select/>`.
  * Whenever `reset` property changes both number `<input/>`
  * and country `<select/>` are reset.
  * It's not implemented as some instance `.reset()` method
  * because `ref` will likely be forwarded to `<input/>`.
  */
	// https://github.com/catamphetamine/react-phone-number-input/issues/300
	reset: _propTypes2.default.any,

	/**
  * `<Phone/>` component CSS style object.
  */
	style: _propTypes2.default.object,

	/**
  * `<Phone/>` component CSS class.
  */
	className: _propTypes2.default.string,

	/**
  * Phone number `<input/>` CSS class.
  */
	inputClassName: _propTypes2.default.string,

	/**
  * By default, there's some styling applied to the `<input/>` (for historical reasons). To prevent applying that styling to the `<input/>`, pass `inputStyleReset` property to the component.
  */
	inputStyleReset: _propTypes2.default.bool,

	/**
  * Returns phone number `<input/>` CSS class string.
  * Receives an object of shape `{ disabled : boolean?, invalid : boolean? }`.
  * @ignore
  */
	getInputClassName: _propTypes2.default.func,

	/**
  * Country `<select/>` component.
  *
  * Receives properties:
  *
  * * `name : string?` — HTML `name` attribute.
  * * `value : string?` — The currently selected country code.
  * * `onChange(value : string?)` — Updates the `value`.
  * * `onFocus()` — Is used to toggle the `--focus` CSS class.
  * * `onBlur()` — Is used to toggle the `--focus` CSS class.
  * * `options : object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value : string?, label : string, icon : React.Component }`.
  * * `disabled : boolean?` — HTML `disabled` attribute.
  * * `tabIndex : (number|string)?` — HTML `tabIndex` attribute.
  * * `className : string` — CSS class name.
  */
	//
	// (deprecated)
	// * `hidePhoneInputField(hide : boolean)` — Can be called to show/hide phone input field. Takes `hide : boolean` argument. E.g. `react-responsive-ui` `<Select/>` uses this to hide phone number input when country select is expanded.
	// * `focusPhoneInputField()` — Can be called to manually focus phone input field. E.g. `react-responsive-ui` `<Select/>` uses this to focus phone number input after country selection in a timeout (after the phone input field is no longer hidden).
	//
	countrySelectComponent: _propTypes2.default.elementType.isRequired,

	/**
  * Country `<select/>` arrow component. Renders a CSS triangle by default.
  */
	countrySelectArrowComponent: _propTypes2.default.elementType,

	/**
  * Country `<select/>` component props.
  */
	countrySelectProps: _propTypes2.default.object,

	/**
  * Phone number `<input/>` component.
  *
  * Receives properties:
  *
  * * `value: string` — The formatted `value`.
  * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
  * * `onFocus()` — Is used to toggle the `--focus` CSS class.
  * * `onBlur(event: Event)` — Is used to toggle the `--focus` CSS class.
  * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
  *
  * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
  */
	numberInputComponent: _propTypes2.default.elementType.isRequired,

	/**
  * Phone number `<input/>` component props.
  */
	numberInputProps: _propTypes2.default.object,

	/**
  * Phone number `<input/>` component (a higher-order one).
  *
  * Receives properties:
  *
  * * `value : string` — The parsed phone number. E.g.: `""`, `"+"`, `"+123"`, `"123"`.
  * * `onChange(value? : string)` — Updates the `value`.
  * * `onFocus()` — Is used to toggle the `--focus` CSS class.
  * * `onBlur()` — Is used to toggle the `--focus` CSS class.
  * * `country : string?` — The currently selected country. `undefined` means "International" (no country selected).
  * * `metadata : object` — `libphonenumber-js` metadata.
  * * `inputComponent : elementType` — Phone number `<input/>` component. This is basically the `numberInputComponent` property renamed to `inputComponent`.
  * * All other properties should be passed through to the underlying `<input/>`.
  *
  * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
  *
  * @ignore
  */
	inputComponent: _propTypes2.default.elementType,

	/**
  * By default, the caret position is being "intelligently" managed
  * while a user inputs a phone number.
  * This "smart" caret behavior can be turned off
  * by passing `smartCaret={false}` property.
  * This is just an "escape hatch" for any possible caret position issues.
  */
	// Is `true` by default.
	smartCaret: _propTypes2.default.bool.isRequired,

	/**
  * Phone number extension `<input/>` element.
  *
  * Example:
  *
  *	`ext={<input value={...} onChange={...}/>}`
  */
	ext: _propTypes2.default.node,

	/**
  * If set to `true` the phone number input will get trimmed
  * if it exceeds the maximum length for the country.
  */
	limitMaxLength: _propTypes2.default.bool.isRequired,

	/**
  * An error message to show below the phone number `<input/>`. For example, `"Required"`.
  */
	error: _propTypes2.default.string,

	/**
  * The `error` is shown only when `indicateInvalid` is `true`.
  * (which is the default).
  * @deprecated
  * @ignore
  */
	indicateInvalid: _propTypes2.default.bool,

	/**
  * `libphonenumber-js` metadata.
  *
  * Can be used to pass custom `libphonenumber-js` metadata
  * to reduce the overall bundle size for those who compile "custom" metadata.
  */
	metadata: _PropTypes.metadata.isRequired,

	/**
  * Is called every time the selected country changes:
  * either programmatically or when user selects it manually from the list.
  */
	// People have been asking for a way to get the selected country.
	// @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
	// For some it's just a "business requirement".
	// I guess it's about gathering as much info on the user as a website can
	// without introducing any addional fields that would complicate the form
	// therefore reducing "conversion" (that's a marketing term).
	// Assuming that the phone number's country is the user's country
	// is not 100% correct but in most cases I guess it's valid.
	onCountryChange: _propTypes2.default.func,

	/**
  * Disables only the phone number `<input/>`.
  *
  * Some users choose to implement a digital keyboard component for phone number input.
  * In such cases the phone number input field must be disabled in order for the default system keyboard to not show up on focus.
  * At the same time, country select should not be disabled in order for the user to be able to choose their country.
  */
	// (is `false` by default)
	// https://github.com/catamphetamine/react-phone-number-input/issues/215
	disablePhoneInput: _propTypes2.default.bool.isRequired
}, _class2.defaultProps = {
	/**
  * Not disabled.
  */
	disabled: false,
	disablePhoneInput: false,

	/**
  * Show `error` (if passed).
  * @deprecated
  */
	indicateInvalid: true,

	/**
  * Remember (and autofill) the value as a phone number.
  */
	autoComplete: 'tel',

	/**
  * Flag icon component.
  */
	flagComponent: _Flag2.default,

	/**
  * By default, use icons from `flag-icon-css` github repo.
  */
	flagsPath: 'https://lipis.github.io/flag-icon-css/flags/4x3/',

	/**
  * Default "International" country `<select/>` option icon (globe).
  */
	// internationalIcon: InternationalIcon,

	/**
  * Phone number `<input/>` component.
  */
	numberInputComponent: 'input',

	/**
  * Show country `<select/>`.
  */
	showCountrySelect: true,

	/**
  * Don't convert the initially passed phone number `value`
  * to a national phone number for its country.
  * The reason is that the newer generation grows up when
  * there are no stationary phones and therefore everyone inputs
  * phone numbers with a `+` in their smartphones
  * so phone numbers written in international form
  * are gradually being considered more natural than local ones.
  */
	displayInitialValueAsLocalNumber: false,

	/**
  * Set to `false` to use "basic" caret instead of the "smart" one.
  */
	smartCaret: true,

	/**
  * Whether to add the "International" option
  * to the list of countries.
  */
	international: true,

	/**
  * If set to `true` the phone number input will get trimmed
  * if it exceeds the maximum length for the country.
  */
	limitMaxLength: false
}, _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.isCountrySupportedWithError = function (country) {
		var metadata = _this2.props.metadata;

		return isCountrySupportedWithError(country, metadata);
	};

	this.onCountryChange = function (new_country) {
		var _props3 = _this2.props,
		    metadata = _props3.metadata,
		    onChange = _props3.onChange;
		var _state2 = _this2.state,
		    old_parsed_input = _state2.parsed_input,
		    old_country = _state2.country;

		// After the new `country` has been selected,
		// if the phone number `<input/>` holds any digits
		// then migrate those digits for the new `country`.

		var new_parsed_input = (0, _inputControl.migrateParsedInputForNewCountry)(old_parsed_input, old_country, new_country, metadata,
		// Convert the phone number to "national" format
		// when the user changes the selected country by hand.
		true);

		var new_value = (0, _inputControl.e164)(new_parsed_input, new_country, metadata);

		// Focus phone number `<input/>` upon country selection.
		_this2.focus();

		// If the user has already manually selected a country
		// then don't override that already selected country
		// if the default `country` property changes.
		// That's what `hasUserSelectedACountry` flag is for.

		_this2.setState({
			country: new_country,
			hasUserSelectedACountry: true,
			parsed_input: new_parsed_input,
			value: new_value
		}, function () {
			// Update the new `value` property.
			// Doing it after the `state` has been updated
			// because `onChange()` will trigger `getDerivedStateFromProps()`
			// with the new `value` which will be compared to `state.value` there.
			onChange(new_value);
		});
	};

	this.onPhoneNumberKeyDown = function (event) {
		var onKeyDown = _this2.props.onKeyDown;

		// Actually "Down arrow" key is used for showing "autocomplete" ("autofill") options.
		// (e.g. previously entered phone numbers for `autoComplete="tel"`)
		// so can't hijack "Down arrow" keypress here.
		// // Expand country `<select/>`` on "Down arrow" key press.
		// if (event.keyCode === 40) {
		// 	this.country_select.toggle()
		// }

		if (onKeyDown) {
			onKeyDown(event);
		}
	};

	this.onChange = function (_input) {
		var _props4 = _this2.props,
		    onChange = _props4.onChange,
		    international = _props4.international,
		    limitMaxLength = _props4.limitMaxLength,
		    metadata = _props4.metadata;

		var _parseInput = (0, _inputControl.parseInput)(_input, _this2.state.parsed_input, _this2.state.country, _this2.state.countries, international, limitMaxLength, metadata),
		    input = _parseInput.input,
		    country = _parseInput.country,
		    value = _parseInput.value;

		_this2.setState({
			parsed_input: input,
			value: value,
			country: country
		},
		// Update the new `value` property.
		// Doing it after the `state` has been updated
		// because `onChange()` will trigger `getDerivedStateFromProps()`
		// with the new `value` which will be compared to `state.value` there.
		function () {
			return onChange(value);
		});
	};

	this._onFocus = function () {
		return _this2.setState({ isFocused: true });
	};

	this._onBlur = function () {
		return _this2.setState({ isFocused: false });
	};

	this.onFocus = function (event) {
		var onFocus = _this2.props.onFocus;

		_this2._onFocus();
		if (onFocus) {
			onFocus(event);
		}
	};

	this.onBlur = function (event) {
		var onBlur = _this2.props.onBlur;
		var value = _this2.state.value;


		_this2._onBlur();

		if (!onBlur) {
			return;
		}

		// `event` is React's `SyntheticEvent`.
		// Its `.value` is read-only therefore cloning it.
		var _event = _extends({}, event, {
			target: _extends({}, event.target, {
				value: value
			})

			// For `redux-form` event detection.
			// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
		});_event.stopPropagation = event.stopPropagation;
		_event.preventDefault = event.preventDefault;

		return onBlur(_event);
	};

	this.hidePhoneInputField = function (hide) {
		_this2.setState({
			hidePhoneInputField: hide
		});
	};

	this.focus = function () {
		return _this2.number_input.focus();
	};

	this.storeCountrySelectInstance = function (_) {
		return _this2.country_select = _;
	};

	this.storePhoneNumberInputInstance = function (_) {
		return _this2.number_input = _;
	};
}, _temp)) || _class;

// Generates country `<select/>` options.


exports.default = PhoneNumberInput;
function generateCountrySelectOptions(countries, countryOptions, props) {
	var labels = props.labels,
	    international = props.international,
	    metadata = props.metadata;


	var CountrySelectOptionIcon = createCountrySelectOptionIconComponent(props);

	return transformCountryOptions((0, _inputControl.getCountrySelectOptions)(countries || (0, _countries2.getCountryCodes)(labels).filter(function (country) {
		return country === 'ZZ' || isCountrySupported(country, metadata);
	}), labels, international).map(function (_ref) {
		var value = _ref.value,
		    label = _ref.label;
		return {
			value: value,
			label: label,
			icon: CountrySelectOptionIcon
		};
	}), countryOptions);
}

function createCountrySelectOptionIconComponent(props) {
	var flags = props.flags,
	    flagsPath = props.flagsPath,
	    FlagComponent = props.flagComponent,
	    InternationalIcon = props.internationalIcon;


	return function (_ref2) {
		var value = _ref2.value;
		return _react2.default.createElement(
			'div',
			{
				className: (0, _classnames2.default)('react-phone-number-input__icon', {
					'react-phone-number-input__icon--international': value === undefined
				}) },
			value ? _react2.default.createElement(FlagComponent, {
				country: value,
				flags: flags,
				flagsPath: flagsPath }) : _react2.default.createElement(InternationalIcon, null)
		);
	};
}

// Can move some country `<select/>` options
// to the top of the list, for example.
// See `countryOptions` property.
function transformCountryOptions(options, transform) {
	if (!transform) {
		return options;
	}

	var optionsOnTop = [];
	var optionsOnBottom = [];
	var appendTo = optionsOnTop;

	var _loop = function _loop() {
		if (_isArray) {
			if (_i >= _iterator.length) return 'break';
			_ref3 = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) return 'break';
			_ref3 = _i.value;
		}

		var element = _ref3;

		if (element === '|') {
			appendTo.push({ divider: true });
		} else if (element === '...' || element === '…') {
			appendTo = optionsOnBottom;
		} else {
			// Find the position of the option.
			var index = options.indexOf(options.filter(function (option) {
				return option.value === element;
			})[0]);
			// Get the option.
			var option = options[index];
			// Remove the option from its default position.
			options.splice(index, 1);
			// Add the option on top.
			appendTo.push(option);
		}
	};

	for (var _iterator = transform, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref3;

		var _ret = _loop();

		if (_ret === 'break') break;
	}

	return optionsOnTop.concat(options).concat(optionsOnBottom);
}

function generateParsedInput(value, phoneNumber, props) {
	var displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber;

	// If the `value` (E.164 phone number)
	// belongs to the currently selected country
	// and `displayInitialValueAsLocalNumber` property is `true`
	// then convert `value` (E.164 phone number)
	// to a local phone number digits.
	// E.g. '+78005553535' -> '88005553535'.

	if (displayInitialValueAsLocalNumber && phoneNumber && phoneNumber.country) {
		return (0, _inputControl.generateNationalNumberDigits)(phoneNumber);
	}

	return value;
}

function isCountrySupported(country, metadata) {
	return metadata.countries.hasOwnProperty(country);
}

function isCountrySupportedWithError(country, metadata) {
	if (isCountrySupported(country, metadata)) {
		return true;
	} else {
		console.error('Country not found: ' + country);
		return false;
	}
}

function isCountryOptionSupportedWithError(countryOption, metadata) {
	switch (countryOption) {
		case '|':
		case '...':
		case '…':
			return true;
		default:
			return isCountrySupportedWithError(countryOption, metadata);
	}
}

function filterCountries(countries, metadata) {
	if (countries) {
		countries = countries.filter(function (country) {
			return isCountrySupportedWithError(country, metadata);
		});
		if (countries.length === 0) {
			countries = undefined;
		}
	}
	return countries;
}

function filterCountryOptions(countryOptions, metadata) {
	if (countryOptions) {
		countryOptions = countryOptions.filter(function (countryOption) {
			return isCountryOptionSupportedWithError(countryOption, metadata);
		});
		if (countryOptions.length === 0) {
			countryOptions = undefined;
		}
	}
	return countryOptions;
}

function parseExtDigits(event) {
	if (event) {
		if (typeof event === 'string') {
			event = (0, _core.parseDigits)(event);
		} else if (event.target && event.target.value) {
			event.target.value = (0, _core.parseDigits)(event.target.value);
		}
	}
	return event;
}
//# sourceMappingURL=PhoneInput.js.map

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
});
//# sourceMappingURL=semver-compare.js.map

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractExtension;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createExtensionPattern__ = __webpack_require__(357);
 // Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + Object(__WEBPACK_IMPORTED_MODULE_0__createExtensionPattern__["a" /* default */])() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}
//# sourceMappingURL=extractExtension.js.map

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeArrays;
/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=mergeArrays.js.map

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate___ = __webpack_require__(359);

/**
 * Checks if a given phone number is valid within a given region.
 * Is just an alias for `phoneNumber.isValid() && phoneNumber.country === country`.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 */

function isValidNumberForRegion(input, country, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  return input.country === country && Object(__WEBPACK_IMPORTED_MODULE_0__validate___["a" /* default */])(input, options, metadata);
}
//# sourceMappingURL=isValidNumberForRegion_.js.map

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_matchesEntirely__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_formatNationalNumberUsingFormat__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_getIddPrefix__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_RFC3966__ = __webpack_require__(358);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js





var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  } // Formats a phone number
  //
  // Example use cases:
  //
  // ```js
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
  // formatNumber('+78005553535', 'NATIONAL')
  // formatNumber('+78005553535', 'NATIONAL', metadata)
  // ```
  //

};
function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata__["a" /* default */](metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_RFC3966__["a" /* formatRFC3966 */])({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_formatNationalNumberUsingFormat__["b" /* default */])(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var format = _ref;

    // Validate leading digits
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_matchesEntirely__["a" /* default */])(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = Object(__WEBPACK_IMPORTED_MODULE_2__metadata__["b" /* getCountryCallingCode */])(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getIddPrefix__["a" /* default */])(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
//# sourceMappingURL=format_.js.map

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIddPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }

  return countryMetadata.defaultIDDPrefix();
}
//# sourceMappingURL=getIddPrefix.js.map

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsePhoneNumberFromString___ = __webpack_require__(1405);


function parsePhoneNumberFromString() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber__["b" /* normalizeArguments */])(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return Object(__WEBPACK_IMPORTED_MODULE_1__parsePhoneNumberFromString___["a" /* default */])(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumberFromString.js.map

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber___ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ParseError__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(48);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function parsePhoneNumberFromString(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !Object(__WEBPACK_IMPORTED_MODULE_2__metadata__["d" /* isSupportedCountry */])(options.defaultCountry, metadata)) {
    options = _objectSpread({}, options, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber___["a" /* default */])(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof __WEBPACK_IMPORTED_MODULE_1__ParseError__["a" /* default */]) {//
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=parsePhoneNumberFromString_.js.map

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher__ = __webpack_require__(364);

function findNumbers(text, options, metadata) {
  var matcher = new __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher__["a" /* default */](text, options, metadata);
  var results = [];

  while (matcher.hasNext()) {
    results.push(matcher.next());
  }

  return results;
}
//# sourceMappingURL=findNumbers_.js.map

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegExpCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LRUCache__ = __webpack_require__(1408);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

 // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
// countries being used for the same doc with ~10 patterns for each country. Some pages will have
// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
// that use-case won't have a lot of benefit.

var RegExpCache =
/*#__PURE__*/
function () {
  function RegExpCache(size) {
    _classCallCheck(this, RegExpCache);

    this.cache = new __WEBPACK_IMPORTED_MODULE_0__LRUCache__["a" /* default */](size);
  }

  _createClass(RegExpCache, [{
    key: "getPatternForRegExp",
    value: function getPatternForRegExp(pattern) {
      var regExp = this.cache.get(pattern);

      if (!regExp) {
        regExp = new RegExp('^' + pattern);
        this.cache.put(pattern, regExp);
      }

      return regExp;
    }
  }]);

  return RegExpCache;
}();


//# sourceMappingURL=RegExpCache.js.map

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LRUCache; });
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
var Node = function Node(key, value) {
  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  _classCallCheck(this, Node);

  this.key = key;
  this.value = value;
  this.next = next;
  this.prev = prev;
};

var LRUCache =
/*#__PURE__*/
function () {
  //set default limit of 10 if limit is not passed.
  function LRUCache() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    _classCallCheck(this, LRUCache);

    this.size = 0;
    this.limit = limit;
    this.head = null;
    this.tail = null;
    this.cache = {};
  } // Write Node to head of LinkedList
  // update cache with Node key and Node reference


  _createClass(LRUCache, [{
    key: "put",
    value: function put(key, value) {
      this.ensureLimit();

      if (!this.head) {
        this.head = this.tail = new Node(key, value);
      } else {
        var node = new Node(key, value, this.head);
        this.head.prev = node;
        this.head = node;
      } //Update the cache map


      this.cache[key] = this.head;
      this.size++;
    } // Read from cache map and make that node as new Head of LinkedList

  }, {
    key: "get",
    value: function get(key) {
      if (this.cache[key]) {
        var value = this.cache[key].value; // node removed from it's position and cache

        this.remove(key); // write node again to the head of LinkedList to make it most recently used

        this.put(key, value);
        return value;
      }

      console.log("Item not available in cache for key ".concat(key));
    }
  }, {
    key: "ensureLimit",
    value: function ensureLimit() {
      if (this.size === this.limit) {
        this.remove(this.tail.key);
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var node = this.cache[key];

      if (node.prev !== null) {
        node.prev.next = node.next;
      } else {
        this.head = node.next;
      }

      if (node.next !== null) {
        node.next.prev = node.prev;
      } else {
        this.tail = node.prev;
      }

      delete this.cache[key];
      this.size--;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = null;
      this.tail = null;
      this.size = 0;
      this.cache = {};
    } // // Invokes the callback function with every node of the chain and the index of the node.
    // forEach(fn) {
    //   let node = this.head;
    //   let counter = 0;
    //   while (node) {
    //     fn(node, counter);
    //     node = node.next;
    //     counter++;
    //   }
    // }
    // // To iterate over LRU with a 'for...of' loop
    // *[Symbol.iterator]() {
    //   let node = this.head;
    //   while (node) {
    //     yield node;
    //     node = node.next;
    //   }
    // }

  }]);

  return LRUCache;
}();


//# sourceMappingURL=LRUCache.js.map

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export containsMoreThanOneSlashInNationalNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate___ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_parseDigits__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(262);



/**
 * Leniency when finding potential phone numbers in text segments
 * The levels here are ordered in increasing strictness.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Phone numbers accepted are "possible", but not necessarily "valid".
   */
  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
    return true;
  },

  /**
   * Phone numbers accepted are "possible" and "valid".
   * Numbers written in national format must have their national-prefix
   * present if it is usually written for a number of this type.
   */
  VALID: function VALID(number, candidate, metadata) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate___["a" /* default */])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidate.toString(), metadata)) {
      return false;
    } // Skipped for simplicity.
    // return isNationalPrefixPresentIfRequired(number, metadata)


    return true;
  },

  /**
   * Phone numbers accepted are "valid" and
   * are grouped in a possible way for this locale. For example, a US number written as
   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
   * "650 253 0000", "650 2530000" or "6502530000" are.
   * Numbers with more than one '/' symbol in the national significant number
   * are also dropped at this level.
   *
   * Warning: This level might result in lower coverage especially for regions outside of
   * country code "+1". If you are not sure about which level to use,
   * email the discussion group libphonenumber-discuss@googlegroups.com.
   */
  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate___["a" /* default */])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
  },

  /**
   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
   * are grouped in the same way that we would have formatted it, or as a single block. For
   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
   * "650 253 0000" or "6502530000" are.
   * Numbers with more than one '/' symbol are also dropped at this level.
   * <p>
   * Warning: This level might result in lower coverage especially for regions outside of country
   * code "+1". If you are not sure about which level to use, email the discussion group
   * libphonenumber-discuss@googlegroups.com.
   */
  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate___["a" /* default */])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
  }
});

function containsOnlyValidXChars(number, candidate, metadata) {
  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
  // national significant number or (2) an extension sign, in which case they always precede the
  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
  // or 'X'. We ignore the character if it appears as the last character of the string.
  for (var index = 0; index < candidate.length - 1; index++) {
    var charAtIndex = candidate.charAt(index);

    if (charAtIndex === 'x' || charAtIndex === 'X') {
      var charAtNextIndex = candidate.charAt(index + 1);

      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
        // This is the carrier code case, in which the 'X's always precede the national
        // significant number.
        index++;

        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
          return false;
        } // This is the extension sign case, in which the 'x' or 'X' should always precede the
        // extension number.

      } else if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers_parseDigits__["a" /* default */])(candidate.substring(index)) !== number.ext) {
        return false;
      }
    }
  }

  return true;
}

function isNationalPrefixPresentIfRequired(number, _metadata) {
  // First, check how we deduced the country code. If it was written in international format, then
  // the national prefix is not required.
  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
    return true;
  }

  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());
  var metadata = util.getMetadataForRegion(phoneNumberRegion);

  if (metadata == null) {
    return true;
  } // Check if a national prefix should be present when formatting this number.


  var nationalNumber = util.getNationalSignificantNumber(number);
  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber); // To do this, we check that a national prefix formatting rule was present
  // and that it wasn't just the first-group symbol ($1) with punctuation.

  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
      // The national-prefix is optional in these cases, so we don't need to check if it was
      // present.
      return true;
    }

    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
      // National Prefix not needed for this number.
      return true;
    } // Normalize the remainder.


    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput()); // Check if we found a national prefix and/or carrier code at the start of the raw input, and
    // return the result.

    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
  }

  return true;
}

function containsMoreThanOneSlashInNationalNumber(number, candidate) {
  var firstSlashInBodyIndex = candidate.indexOf('/');

  if (firstSlashInBodyIndex < 0) {
    // No slashes, this is okay.
    return false;
  } // Now look for a second one.


  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);

  if (secondSlashInBodyIndex < 0) {
    // Only one slash, this is okay.
    return false;
  } // If the first slash is after the country calling code, this is permitted.


  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;

  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
    // Any more slashes and this is illegal.
    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
  }

  return true;
}

function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
  var normalizedCandidate = normalizeDigits(candidate, true
  /* keep non-digits */
  );
  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);

  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
    return true;
  } // If this didn't pass, see if there are any alternate formats that match, and try them instead.


  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
  var nationalSignificantNumber = util.getNationalSignificantNumber(number);

  if (alternateFormats) {
    for (var _iterator = alternateFormats.numberFormats(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var alternateFormat = _ref;

      if (alternateFormat.leadingDigitsPatterns().length > 0) {
        // There is only one leading digits pattern for alternate formats.
        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);

        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
          // Leading digits don't match; try another one.
          continue;
        }
      }

      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);

      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
        return true;
      }
    }
  }

  return false;
}
/**
 * Helper method to get the national-number part of a number, formatted without any national
 * prefix, and return it as a set of digit blocks that would be formatted together following
 * standard formatting rules.
 */


function getNationalNumberGroups(metadata, number, formattingPattern) {
  if (formattingPattern) {
    // We format the NSN only, and split that according to the separator.
    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
  } // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.


  var rfc3966Format = formatNumber(number, 'RFC3966', metadata); // We remove the extension part from the formatted string before splitting it into different
  // groups.

  var endIndex = rfc3966Format.indexOf(';');

  if (endIndex < 0) {
    endIndex = rfc3966Format.length;
  } // The country-code will have a '-' following it.


  var startIndex = rfc3966Format.indexOf('-') + 1;
  return rfc3966Format.slice(startIndex, endIndex).split('-');
}

function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN); // Set this to the last group, skipping it if the number has an extension.

  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1; // First we check if the national significant number is formatted as a block.
  // We use contains and not equals, since the national significant number may be present with
  // a prefix such as a national number prefix, or the country code itself.

  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
    return true;
  } // Starting from the end, go through in reverse, excluding the first group, and check the
  // candidate and number groups are the same.


  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;

  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
      return false;
    }

    formattedNumberGroupIndex--;
    candidateNumberGroupIndex--;
  } // Now check the first group. There may be a national prefix at the start, so we only check
  // that the candidate group ends with the formatted number group.


  return candidateNumberGroupIndex >= 0 && Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* endsWith */])(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
}

function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var fromIndex = 0;

  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    // First skip the country code if the normalized candidate contained it.
    var countryCode = String(number.getCountryCode());
    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
  } // Check each group of consecutive digits are not broken into separate groupings in the
  // {@code normalizedCandidate} string.


  for (var i = 0; i < formattedNumberGroups.length; i++) {
    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
    // doesn't contain the consecutive digits in formattedNumberGroups[i].
    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);

    if (fromIndex < 0) {
      return false;
    } // Moves {@code fromIndex} forward.


    fromIndex += formattedNumberGroups[i].length();

    if (i == 0 && fromIndex < normalizedCandidate.length()) {
      // We are at the position right after the NDC. We get the region used for formatting
      // information based on the country code in the phone number, rather than the number itself,
      // as we do not need to distinguish between different countries with the same country
      // calling code and this is faster.
      var region = util.getRegionCodeForCountryCode(number.getCountryCode());

      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
        // This means there is no formatting symbol after the NDC. In this case, we only
        // accept the number if there is no formatting symbol at all in the number, except
        // for extensions. This is only important for countries with national prefixes.
        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
        return Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* startsWith */])(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
      }
    }
  } // The check here makes sure that we haven't mistakenly already used the extension to
  // match the last group of the subscriber number. Note the extension cannot have
  // formatting in-between digits.


  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
}
//# sourceMappingURL=Leniency.js.map

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePreCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(262);
 // Regular expression of characters typically used to start a second phone number for the purposes
// of parsing. This allows us to strip off parts of the number that are actually the start of
// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
// extension so that the first number is parsed correctly.
//
// Matches a slash (\ or /) followed by a space followed by an `x`.
//

var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
function parsePreCandidate(candidate) {
  // Check for extra numbers at the end.
  // TODO: This is the place to start when trying to support extraction of multiple phone number
  // from split notations (+41 79 123 45 67 / 68).
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* trimAfterFirstMatch */])(SECOND_NUMBER_START_PATTERN, candidate);
}
//# sourceMappingURL=parsePreCandidate.js.map

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidPreCandidate;
// Matches strings that look like dates using "/" as a separator.
// Examples: 3/10/2011, 31/10/96 or 08/31/95.
var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/; // Matches timestamps.
// Examples: "2012-01-02 08:00".
// Note that the reg-ex does not include the
// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.

var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
function isValidPreCandidate(candidate, offset, text) {
  // Skip a match that is more likely to be a date.
  if (SLASH_SEPARATED_DATES.test(candidate)) {
    return false;
  } // Skip potential time-stamps.


  if (TIME_STAMPS.test(candidate)) {
    var followingText = text.slice(offset + candidate.length);

    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
      return false;
    }
  }

  return true;
}
//# sourceMappingURL=isValidPreCandidate.js.map

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEAD_CLASS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utf_8__ = __webpack_require__(633);
// Copy-pasted from `PhoneNumberMatcher.js`.



var OPENING_PARENS = "(\\[\uFF08\uFF3B";
var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PLUS_CHARS */], "]"); // Punctuation that may be at the start of a phone number - brackets and plus signs.

var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS); // Limit on the number of pairs of brackets in a phone number.

var BRACKET_PAIR_LIMIT = Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* limit */])(0, 3);
/**
 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
 * This also checks that there is something inside the brackets. Having no brackets at all is also
 * fine.
 *
 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
 * closing bracket first. We limit the sets of brackets in a phone number to four.
 */

var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
/**
 * Matches strings that look like publication pages. Example:
 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
 *
 * The string "211-227 (2003)" is not a telephone number.
 */

var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
function isValidCandidate(candidate, offset, text, leniency) {
  // Check the candidate doesn't contain any formatting
  // which would indicate that it really isn't a phone number.
  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
    return;
  } // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.


  if (leniency !== 'POSSIBLE') {
    // If the candidate is not at the start of the text,
    // and does not start with phone-number punctuation,
    // check the previous character.
    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
      var previousChar = text[offset - 1]; // We return null if it is a latin letter or an invalid punctuation symbol.

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["d" /* isInvalidPunctuationSymbol */])(previousChar) || Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["e" /* isLatinLetter */])(previousChar)) {
        return false;
      }
    }

    var lastCharIndex = offset + candidate.length;

    if (lastCharIndex < text.length) {
      var nextChar = text[lastCharIndex];

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["d" /* isInvalidPunctuationSymbol */])(nextChar) || Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["e" /* isLatinLetter */])(nextChar)) {
        return false;
      }
    }
  }

  return true;
}
//# sourceMappingURL=isValidCandidate.js.map

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchPhoneNumbersInText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__searchNumbers__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findPhoneNumbersInText__ = __webpack_require__(635);


function searchPhoneNumbersInText(text, defaultCountry, options, metadata) {
  var args = Object(__WEBPACK_IMPORTED_MODULE_1__findPhoneNumbersInText__["b" /* getArguments */])(defaultCountry, options, metadata);
  return Object(__WEBPACK_IMPORTED_MODULE_0__searchNumbers__["a" /* default */])(text, args.options, args.metadata);
}
//# sourceMappingURL=searchPhoneNumbersInText.js.map

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsYouTypeState; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AsYouTypeState =
/*#__PURE__*/
function () {
  function AsYouTypeState(_ref) {
    var _this = this;

    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    _classCallCheck(this, AsYouTypeState);

    _defineProperty(this, "update", function (properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        _this[key] = properties[key];
      }
    });

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  _createClass(AsYouTypeState, [{
    key: "reset",
    value: function reset(defaultCountry, defaultCallingCode) {
      this.international = false;
      this.IDDPrefix = undefined;
      this.missingPlus = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      return this.onCallingCodeChange(this.country, callingCode);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber() {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode();
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();


//# sourceMappingURL=AsYouTypeState.js.map

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatCompleteNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = canFormatCompleteNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_checkNumberLength__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_parseDigits__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_formatNationalNumberUsingFormat__ = __webpack_require__(361);



function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_checkNumberLength__["a" /* default */])(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  var nationalSignificantNumber = state.nationalSignificantNumber,
      international = state.international,
      nationalPrefix = state.nationalPrefix,
      carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_formatNationalNumberUsingFormat__["b" /* default */])(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_parseDigits__["a" /* default */])(formattedNationalNumber) === state.getNationalDigits();
}
//# sourceMappingURL=AsYouTypeFormatter.complete.js.map

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsYouTypeParser; });
/* unused harmony export extractFormattedDigitsAndPlus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_extractCountryCallingCode__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_extractCountryCallingCodeFromInternationalNumberWithoutPlusSign__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_extractNationalNumberFromPossiblyIncompleteNumber__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_stripIddPrefix__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_parseDigits__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(81);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }







var VALID_FORMATTED_PHONE_NUMBER_PART = '[' + __WEBPACK_IMPORTED_MODULE_5__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* VALID_DIGITS */] + ']+';
var VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_PART + '$', 'i');
var VALID_PHONE_NUMBER = '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* PLUS_CHARS */] + ']' + '[' + __WEBPACK_IMPORTED_MODULE_5__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* VALID_DIGITS */] + ']*' + '|' + '[' + __WEBPACK_IMPORTED_MODULE_5__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* VALID_DIGITS */] + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_5__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* VALID_DIGITS */] + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser =
/*#__PURE__*/
function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    _classCallCheck(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  _createClass(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = _slicedToArray(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_parseDigits__["a" /* default */])(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode(state) {
      var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_0__helpers_extractCountryCallingCode__["a" /* default */])('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_extractNationalNumberFromPossiblyIncompleteNumber__["a" /* default */])(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_extractNationalNumberFromPossiblyIncompleteNumber__["a" /* default */])(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, state.update)) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits,
          nationalSignificantNumber = state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_stripIddPrefix__["a" /* default */])(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state);
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_extractCountryCallingCodeFromInternationalNumberWithoutPlusSign__["a" /* default */])(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode,
            number = _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state);
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state) {
      state.startInternationalNumber(); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
      }
    }
  }]);

  return AsYouTypeParser;
}();
/**
 * Extracts formatted phone number from text (if there's any).
 * @param  {string} text
 * @return {string} [formattedPhoneNumber]
 */




function extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_PHONE_NUMBER);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = _slicedToArray(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}
//# sourceMappingURL=AsYouTypeParser.js.map

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(48);

function getCountries(metadata) {
  return new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getExampleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__ = __webpack_require__(261);

function getExampleNumber(country, examples, metadata) {
  if (examples[country]) {
    return new __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__["a" /* default */](country, examples[country], metadata);
  }
}
//# sourceMappingURL=getExampleNumber.js.map

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatIncompletePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsYouType__ = __webpack_require__(636);

/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
 * @return {string} Formatted (possibly incomplete) phone number.
 */

function formatIncompletePhoneNumber(value, country, metadata) {
  if (!metadata) {
    metadata = country;
    country = undefined;
  }

  return new __WEBPACK_IMPORTED_MODULE_0__AsYouType__["a" /* default */](country, metadata).input(value);
}
//# sourceMappingURL=formatIncompletePhoneNumber.js.map

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createInput = createInput;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inputFormat = __webpack_require__(1421);

var _core = __webpack_require__(258);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This input uses `input-format` library
 * for "smart" caret positioning.
 */
function createInput(defaultMetadata) {
	var _class, _temp2;

	return _temp2 = _class = function (_Component) {
		_inherits(InputSmart, _Component);

		function InputSmart() {
			var _ref;

			var _temp, _this, _ret;

			_classCallCheck(this, InputSmart);

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputSmart.__proto__ || Object.getPrototypeOf(InputSmart)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
				return _this.input.focus();
			}, _this.storeInput = function (ref) {
				return _this.input = ref;
			}, _this.format = function (value) {
				var _this$props = _this.props,
				    country = _this$props.country,
				    metadata = _this$props.metadata;

				// "As you type" formatter.

				var formatter = new _core.AsYouType(country, metadata);

				// Format the number.
				var text = formatter.input(value);

				return { text: text, template: formatter.getTemplate() };
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}

		_createClass(InputSmart, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    country = _props.country,
				    metadata = _props.metadata,
				    rest = _objectWithoutProperties(_props, ['country', 'metadata']);

				return _react2.default.createElement(_inputFormat.ReactInput, _extends({}, rest, {
					ref: this.storeInput,
					parse: _core.parsePhoneNumberCharacter,
					format: this.format }));
			}
		}]);

		return InputSmart;
	}(_react.Component), _class.defaultProps = {
		metadata: defaultMetadata
	}, _temp2;
}

exports.default = createInput();
//# sourceMappingURL=InputSmart.js.map

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_template_parser__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_template_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modules_template_parser__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "templateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__modules_template_parser___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_template_formatter__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_template_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modules_template_formatter__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "templateFormatter", function() { return __WEBPACK_IMPORTED_MODULE_1__modules_template_formatter___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_ReactInput__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_ReactInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__modules_ReactInput__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ReactInput", function() { return __WEBPACK_IMPORTED_MODULE_2__modules_ReactInput___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_parse_digit__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_parse_digit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modules_parse_digit__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "parseDigit", function() { return __WEBPACK_IMPORTED_MODULE_3__modules_parse_digit___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_parse__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_parse__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return __WEBPACK_IMPORTED_MODULE_4__modules_parse___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_format__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__modules_format__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_5__modules_format___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_input_control__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_input_control___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_input_control__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__modules_input_control__, "onChange")) __webpack_require__.d(__webpack_exports__, "onChange", function() { return __WEBPACK_IMPORTED_MODULE_6__modules_input_control__["onChange"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__modules_input_control__, "onPaste")) __webpack_require__.d(__webpack_exports__, "onPaste", function() { return __WEBPACK_IMPORTED_MODULE_6__modules_input_control__["onPaste"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__modules_input_control__, "onCut")) __webpack_require__.d(__webpack_exports__, "onCut", function() { return __WEBPACK_IMPORTED_MODULE_6__modules_input_control__["onCut"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__modules_input_control__, "onKeyDown")) __webpack_require__.d(__webpack_exports__, "onKeyDown", function() { return __WEBPACK_IMPORTED_MODULE_6__modules_input_control__["onKeyDown"]; });














/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (template, placeholder, parse) {
	if (typeof placeholder === 'function') {
		parse = placeholder;
		placeholder = 'x';
	}

	var max_characters = (0, _helpers.count_occurences)(placeholder, template);

	return function (character, value) {
		if (value.length < max_characters) {
			return parse(character, value);
		}
	};
};

var _helpers = __webpack_require__(365);
//# sourceMappingURL=template parser.js.map

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = close_braces;

var _helpers = __webpack_require__(365);

function close_braces(retained_template, template) {
	var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
	var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';

	var cut_before = retained_template.length;

	var opening_braces = (0, _helpers.count_occurences)('(', retained_template);
	var closing_braces = (0, _helpers.count_occurences)(')', retained_template);

	var dangling_braces = opening_braces - closing_braces;

	while (dangling_braces > 0 && cut_before < template.length) {
		retained_template += template[cut_before].replace(placeholder, empty_placeholder);

		if (template[cut_before] === ')') {
			dangling_braces--;
		}

		cut_before++;
	}

	return retained_template;
}
//# sourceMappingURL=close braces.js.map

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _parse2 = __webpack_require__(366);

var _parse3 = _interopRequireDefault(_parse2);

var _inputControl = __webpack_require__(640);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Usage:
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//
var ReactInput = (_temp2 = _class = function (_React$Component) {
	_inherits(ReactInput, _React$Component);

	function ReactInput() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ReactInput);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactInput.__proto__ || Object.getPrototypeOf(ReactInput)).call.apply(_ref, [this].concat(args))), _this), _this.storeInstance = function (instance) {
			_this.input = instance;
		}, _this.getInputElement = function () {
			return _this.input;
		}, _this.onChange = function (event) {
			var _this$props = _this.props,
			    parse = _this$props.parse,
			    format = _this$props.format;


			return (0, _inputControl.onChange)(event, _this.getInputElement(), parse, format, _this.props.onChange);
		}, _this.onPaste = function (event) {
			var _this$props2 = _this.props,
			    parse = _this$props2.parse,
			    format = _this$props2.format;


			return (0, _inputControl.onPaste)(event, _this.getInputElement(), parse, format, _this.props.onChange);
		}, _this.onCut = function (event) {
			var _this$props3 = _this.props,
			    parse = _this$props3.parse,
			    format = _this$props3.format;


			return (0, _inputControl.onCut)(event, _this.getInputElement(), parse, format, _this.props.onChange);
		}, _this.onBlur = function (event) {
			var _this$props4 = _this.props,
			    parse = _this$props4.parse,
			    onBlur = _this$props4.onBlur;

			// This `onBlur` interceptor is a workaround for `redux-form`,
			// so that it gets the right (parsed, not the formatted one)
			// `event.target.value` in its `onBlur` handler.

			if (onBlur) {
				var _event = _extends({}, event, {
					target: _extends({}, event.target, {
						value: (0, _parse3.default)(_this.getInputElement().value, undefined, parse).value
					})

					// For `redux-form` event detection.
					// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
				});_event.stopPropagation = event.stopPropagation;
				_event.preventDefault = event.preventDefault;

				onBlur(_event);
			}
		}, _this.onKeyDown = function (event) {
			var _this$props5 = _this.props,
			    parse = _this$props5.parse,
			    format = _this$props5.format;


			if (_this.props.onKeyDown) {
				_this.props.onKeyDown(event);
			}

			return (0, _inputControl.onKeyDown)(event, _this.getInputElement(), parse, format, _this.props.onChange);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ReactInput, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    value = _props.value,
			    parse = _props.parse,
			    format = _props.format,
			    inputComponent = _props.inputComponent,
			    rest = _objectWithoutProperties(_props, ['value', 'parse', 'format', 'inputComponent']);

			// Non-string `inputComponent`s would work in this case
			// but it would also introduce a caret reset bug:
			// the caret position would reset on each input.
			// The origins of this bug are unknown, they may be
			// somehow related to the `ref` property
			// being intercepted by React here.


			return _react2.default.createElement(inputComponent, _extends({}, rest, {
				ref: this.storeInstance,
				value: format(isEmpty(value) ? '' : value).text,
				onKeyDown: this.onKeyDown,
				onChange: this.onChange,
				onPaste: this.onPaste,
				onCut: this.onCut,
				onBlur: this.onBlur
			}));
		}

		/**
   * Returns `<input/>` DOM Element.
   * @return {DOMElement}
   */


		// This handler is a workaround for `redux-form`.

	}, {
		key: 'focus',


		/**
   * Focuses the `<input/>`.
   * Can be called manually.
   */
		value: function focus() {
			this.getInputElement().focus();
		}
	}]);

	return ReactInput;
}(_react2.default.Component), _class.propTypes = {
	// Parses a single characher of `<input/>` text.
	parse: _propTypes2.default.func.isRequired,

	// Formats `value` into `<input/>` text.
	format: _propTypes2.default.func.isRequired,

	// Renders `<input/>` by default.
	inputComponent: _propTypes2.default.elementType.isRequired,

	// `<input/>` `type` attribute.
	type: _propTypes2.default.string.isRequired,

	// Is parsed from <input/> text.
	value: _propTypes2.default.string,

	// This handler is called each time `<input/>` text is changed.
	onChange: _propTypes2.default.func.isRequired,

	// This `onBlur` interceptor is a workaround for `redux-form`,
	// so that it gets the parsed `value` in its `onBlur` handler,
	// not the formatted text.
	onBlur: _propTypes2.default.func,

	// Passthrough
	onKeyDown: _propTypes2.default.func
}, _class.defaultProps = {
	// Renders `<input/>` by default.
	inputComponent: 'input',

	// `<input/>` `type` attribute.
	type: 'text'
}, _temp2);
exports.default = ReactInput;


function isEmpty(value) {
	return value === undefined || value === null;
}
//# sourceMappingURL=ReactInput.js.map

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = edit;
// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function edit(value, caret, operation) {
	switch (operation) {
		case 'Backspace':
			// If there exists the previous character,
			// then erase it and reposition the caret.
			if (caret > 0) {
				// Remove the previous character
				value = value.slice(0, caret - 1) + value.slice(caret);
				// Position the caret where the previous (erased) character was
				caret--;
			}
			break;

		case 'Delete':
			// Remove current digit (if any)
			value = value.slice(0, caret) + value.slice(caret + 1);
			break;
	}

	return { value: value, caret: caret };
}
//# sourceMappingURL=edit.js.map

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getSelection = getSelection;
exports.getOperation = getOperation;
exports.getCaretPosition = getCaretPosition;
exports.setCaretPosition = setCaretPosition;
// Gets <input/> selection bounds
function getSelection(element) {
	// If no selection, return nothing
	if (element.selectionStart === element.selectionEnd) {
		return;
	}

	return { start: element.selectionStart, end: element.selectionEnd };
}

// Key codes
var Keys = exports.Keys = {
	Backspace: 8,
	Delete: 46

	// Finds out the operation to be intercepted and performed
	// based on the key down event `keyCode`.
};function getOperation(event) {
	switch (event.keyCode) {
		case Keys.Backspace:
			return 'Backspace';

		case Keys.Delete:
			return 'Delete';
	}
}

// Gets <input/> caret position
function getCaretPosition(element) {
	return element.selectionStart;
}

// Sets <input/> caret position
function setCaretPosition(element, caret_position) {
	// Sanity check
	if (caret_position === undefined) {
		return;
	}

	// Set caret position.
	// There has been an issue with caret positioning on Android devices.
	// https://github.com/catamphetamine/input-format/issues/2
	// I was revisiting this issue and looked for similar issues in other libraries.
	// For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
	// They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
	// The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
	// https://github.com/text-mask/text-mask/issues/300
	// They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
	// https://github.com/text-mask/text-mask/pull/400/files
	// I've implemented the same workaround here.
	if (isAndroid()) {
		setTimeout(function () {
			return element.setSelectionRange(caret_position, caret_position);
		}, 0);
	} else {
		element.setSelectionRange(caret_position, caret_position);
	}
}

function isAndroid() {
	// `navigator` is not defined when running mocha tests.
	if (typeof navigator !== 'undefined') {
		return ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
	}
}

var ANDROID_USER_AGENT_REG_EXP = /Android/i;
//# sourceMappingURL=dom.js.map

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (character, value) {
	return DIGITS[character];
};

// Copied from `libphonenumber-js`:
// https://github.com/catamphetamine/libphonenumber-js/blob/master/source/parse.js
//
// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = exports.DIGITS = {
	'0': '0',
	'1': '1',
	'2': '2',
	'3': '3',
	'4': '4',
	'5': '5',
	'6': '6',
	'7': '7',
	'8': '8',
	'9': '9',
	'\uFF10': '0', // Fullwidth digit 0
	'\uFF11': '1', // Fullwidth digit 1
	'\uFF12': '2', // Fullwidth digit 2
	'\uFF13': '3', // Fullwidth digit 3
	'\uFF14': '4', // Fullwidth digit 4
	'\uFF15': '5', // Fullwidth digit 5
	'\uFF16': '6', // Fullwidth digit 6
	'\uFF17': '7', // Fullwidth digit 7
	'\uFF18': '8', // Fullwidth digit 8
	'\uFF19': '9', // Fullwidth digit 9
	'\u0660': '0', // Arabic-indic digit 0
	'\u0661': '1', // Arabic-indic digit 1
	'\u0662': '2', // Arabic-indic digit 2
	'\u0663': '3', // Arabic-indic digit 3
	'\u0664': '4', // Arabic-indic digit 4
	'\u0665': '5', // Arabic-indic digit 5
	'\u0666': '6', // Arabic-indic digit 6
	'\u0667': '7', // Arabic-indic digit 7
	'\u0668': '8', // Arabic-indic digit 8
	'\u0669': '9', // Arabic-indic digit 9
	'\u06F0': '0', // Eastern-Arabic digit 0
	'\u06F1': '1', // Eastern-Arabic digit 1
	'\u06F2': '2', // Eastern-Arabic digit 2
	'\u06F3': '3', // Eastern-Arabic digit 3
	'\u06F4': '4', // Eastern-Arabic digit 4
	'\u06F5': '5', // Eastern-Arabic digit 5
	'\u06F6': '6', // Eastern-Arabic digit 6
	'\u06F7': '7', // Eastern-Arabic digit 7
	'\u06F8': '8', // Eastern-Arabic digit 8
	'\u06F9': '9' // Eastern-Arabic digit 9
};
//# sourceMappingURL=parse digit.js.map

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createInput = createInput;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = __webpack_require__(258);

var _reactLifecyclesCompat = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react2.default.PureComponent || _react2.default.Component;

function createInput(defaultMetadata) {
	/**
  * `InputBasic`'s caret is not as "smart" as the default `inputComponent`'s
  * but still works good enough. When erasing or inserting digits in the middle
  * of a phone number the caret usually jumps to the end: this is the expected
  * behaviour and it's the workaround for the [Samsung Galaxy smart caret positioning bug](https://github.com/catamphetamine/react-phone-number-input/issues/75).
  */
	var InputBasic = function (_PureComponent) {
		_inherits(InputBasic, _PureComponent);

		function InputBasic() {
			var _ref;

			var _temp, _this, _ret;

			_classCallCheck(this, InputBasic);

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputBasic.__proto__ || Object.getPrototypeOf(InputBasic)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onChange = function (event) {
				var onChange = _this.props.onChange;
				var value = _this.state.value;


				var newValue = (0, _core.parseIncompletePhoneNumber)(event.target.value);

				// By default, if a value is something like `"(123)"`
				// then Backspace would only erase the rightmost brace
				// becoming something like `"(123"`
				// which would give the same `"123"` value
				// which would then be formatted back to `"(123)"`
				// and so a user wouldn't be able to erase the phone number.
				// Working around this issue with this simple hack.
				if (newValue === value) {
					if (_this.format(newValue).indexOf(event.target.value) === 0) {
						// Trim the last digit (or plus sign).
						newValue = newValue.slice(0, -1);
					}
				}

				// Prevents React from resetting the `<input/>` caret position.
				// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
				// https://github.com/facebook/react/issues/955
				_this.setState({ value: newValue }, function () {
					return onChange(newValue);
				});
			}, _this.onBlur = function (event) {
				var onBlur = _this.props.onBlur;
				var value = _this.state.value;

				if (onBlur) {
					// `event` is React's `SyntheticEvent`.
					// Its `.value` is read-only therefore cloning it.
					var _event = _extends({}, event, {
						target: _extends({}, event.target, {
							value: value
						})
						// Workaround for `redux-form` event detection.
						// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
					});_event.stopPropagation = event.stopPropagation;
					_event.preventDefault = event.preventDefault;
					return onBlur(_event);
				}
			}, _this.focus = function () {
				return _this.input.focus();
			}, _this.storeInput = function (ref) {
				return _this.input = ref;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}

		_createClass(InputBasic, [{
			key: 'format',
			value: function format(value) {
				var _props = this.props,
				    country = _props.country,
				    metadata = _props.metadata;

				return (0, _core.formatIncompletePhoneNumber)(value, country, metadata);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    onChange = _props2.onChange,
				    onFocus = _props2.onFocus,
				    country = _props2.country,
				    metadata = _props2.metadata,
				    Input = _props2.inputComponent,
				    rest = _objectWithoutProperties(_props2, ['onChange', 'onFocus', 'country', 'metadata', 'inputComponent']);

				// Prevents React from resetting the `<input/>` caret position.
				// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
				// https://github.com/facebook/react/issues/955


				var value = this.state.value;

				// Deprecated. Should be removed in a future major version release.
				// `type="tel"` and `autoComplete="tel"` properties are here
				// just for the "Without country select" component exported from
				// `react-phone-number-input/basic-input` subpackage.
				// These two properties will be overwritten by `<PhoneInput/>` properties
				// when not used as a "Without country select" component.

				return _react2.default.createElement(Input, _extends({
					type: 'tel',
					autoComplete: 'tel'
				}, rest, {
					ref: this.storeInput,
					value: this.format(value),
					onChange: this.onChange,
					onFocus: onFocus,
					onBlur: this.onBlur }));
			}
		}], [{
			key: 'getDerivedStateFromProps',

			// Prevents React from resetting the `<input/>` caret position.
			// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
			// https://github.com/facebook/react/issues/955
			value: function getDerivedStateFromProps(_ref2) {
				var value = _ref2.value;

				return { value: value };
			}

			// This `onBlur` interceptor is a workaround for `redux-form`'s bug
			// so that it gets the up-to-date `value` in its `onBlur` handler.
			// Without this fix it just gets the actual (raw) input field textual value.
			// E.g. `+7 800 555 35 35` instead of `+78005553535`.
			//
			// New `value` is taken from `event` in `redux-form`'s `handleBlur()`.
			// https://github.com/erikras/redux-form/blob/785edf8aac3adc84aba2ab6898a4aa8c48687750/src/ConnectedField.js#L168
			// `redux-form` shouldn't have taken the new `value` from `event`.
			//
			// A developer is not supposed to pass this `onBlur` property manually.
			// Instead, `redux-form` passes `onBlur` to this component automatically
			// and this component patches that `onBlur` handler (a hacky way but works).
			//

		}]);

		return InputBasic;
	}(PureComponent);

	InputBasic.propTypes = {
		// The parsed phone number.
		// "Parsed" not in a sense of "E.164"
		// but rather in a sense of "having only
		// digits and possibly a leading plus character".
		// Examples: `""`, `"+"`, `"+123"`, `"123"`.
		value: _propTypes2.default.string.isRequired,

		// Updates the `value`.
		onChange: _propTypes2.default.func.isRequired,

		// Toggles the `--focus` CSS class.
		// https://github.com/catamphetamine/react-phone-number-input/issues/189
		onFocus: _propTypes2.default.func,

		// `onBlur` workaround for `redux-form`'s bug.
		onBlur: _propTypes2.default.func,

		// A two-letter country code for formatting `value`
		// as a national phone number (e.g. `(800) 555 35 35`).
		// E.g. "US", "RU", etc.
		// If no `country` is passed then `value`
		// is formatted as an international phone number.
		// (e.g. `+7 800 555 35 35`)
		country: _propTypes2.default.string,

		// `libphonenumber-js` metadata.
		metadata: _propTypes2.default.object.isRequired,

		// The `<input/>` component.
		inputComponent: _propTypes2.default.elementType.isRequired
	};

	InputBasic.defaultProps = {
		metadata: defaultMetadata,
		inputComponent: 'input'
	};

	return (0, _reactLifecyclesCompat.polyfill)(InputBasic);
}

exports.default = createInput();
//# sourceMappingURL=InputBasic.js.map

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(39);

var _classnames2 = _interopRequireDefault(_classnames);

var _countries = __webpack_require__(642);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Default country flag icon.
// `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size in IE 11.
// https://github.com/catamphetamine/react-phone-number-input/issues/111
var FlagComponent = function FlagComponent(_ref) {
	var country = _ref.country,
	    flags = _ref.flags,
	    flagsPath = _ref.flagsPath,
	    className = _ref.className;

	if (flags && flags[country]) {
		return flags[country]();
	}
	return _react2.default.createElement('img', {
		alt: country,
		className: 'react-phone-number-input__icon-image',
		src: '' + flagsPath + (0, _countries.getCountryCodeForFlag)(country).toLowerCase() + '.svg' });
};

FlagComponent.propTypes = {
	// The country to be selected by default.
	// Two-letter country code ("ISO 3166-1 alpha-2").
	country: _propTypes2.default.string.isRequired,

	// Country flag icon components.
	// By default flag icons are inserted as `<img/>`s
	// with their `src` pointed to `flag-icon-css` github repo.
	// There might be cases (e.g. an offline application)
	// where having a large (3 megabyte) `<svg/>` flags
	// bundle is more appropriate.
	// `import flags from 'react-phone-number-input/flags'`.
	flags: _propTypes2.default.objectOf(_propTypes2.default.elementType),

	// A base URL path for national flag SVG icons.
	// By default it uses the ones from `flag-icon-css` github repo.
	flagsPath: _propTypes2.default.string.isRequired
};

exports.default = FlagComponent;
//# sourceMappingURL=Flag.js.map

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getPreSelectedCountry = getPreSelectedCountry;
exports.getCountrySelectOptions = getCountrySelectOptions;
exports.parsePhoneNumber = parsePhoneNumber;
exports.generateNationalNumberDigits = generateNationalNumberDigits;
exports.migrateParsedInputForNewCountry = migrateParsedInputForNewCountry;
exports.e164 = e164;
exports.trimNumber = trimNumber;
exports.getCountryForPartialE164Number = getCountryForPartialE164Number;
exports.parseInput = parseInput;
exports.get_country_from_possibly_incomplete_international_phone_number = get_country_from_possibly_incomplete_international_phone_number;
exports.compare_strings = compare_strings;
exports.strip_country_calling_code = strip_country_calling_code;
exports.get_national_significant_number_part = get_national_significant_number_part;
exports.could_number_belong_to_country = could_number_belong_to_country;

var _core = __webpack_require__(258);

/**
 * Decides which country should be pre-selected
 * when the phone number input component is first mounted.
 * @param  {object?} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {string?} country - Pre-defined country (two-letter code).
 * @param  {string[]?} countries - A list of countries available.
 * @param  {boolean} includeInternationalOption - Whether "International" country option is available.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string?}
 */
function getPreSelectedCountry(phoneNumber, country, countries, includeInternationalOption, metadata) {
	// If can get country from E.164 phone number
	// then it overrides the `country` passed (or not passed).
	if (phoneNumber && phoneNumber.country) {
		// `country` will be left `undefined` in case of non-detection.
		country = phoneNumber.country;
	}

	// Only pre-select a country if it's in the available `countries` list.
	if (countries && countries.indexOf(country) < 0) {
		country = undefined;
	}

	// If there will be no "International" option
	// then some `country` must be selected.
	// It will still be the wrong country though.
	// But still country `<select/>` can't be left in a broken state.
	if (!country && !includeInternationalOption && countries && countries.length > 0) {
		country = countries[0];
	}

	return country;
}

/**
 * Generates a sorted list of country `<select/>` options.
 * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
 * @param  {object} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
 * @param  {boolean} includeInternationalOption - Whether should include "International" option at the top of the list.
 * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
 */
function getCountrySelectOptions(countries, country_names, includeInternationalOption) {
	// Generates a `<Select/>` option for each country.
	var country_select_options = countries.map(function (country) {
		return {
			value: country,
			label: country_names[country]
		};
	});

	// Sort the list of countries alphabetically.
	country_select_options.sort(function (a, b) {
		return compare_strings(a.label, b.label);
	});

	// Add the "International" option to the country list (if suitable)
	if (includeInternationalOption) {
		country_select_options.unshift({
			label: country_names.ZZ
		});
	}

	return country_select_options;
}

/**
 * Parses a E.164 phone number to an instance of `PhoneNumber` class.
 * @param {string?} value = E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @example
 * parsePhoneNumber('+78005553535')
 */
function parsePhoneNumber(value, metadata) {
	return (0, _core.parsePhoneNumberFromString)(value || '', metadata);
}

/**
 * Generates national number digits for a parsed phone.
 * May prepend national prefix.
 * The phone number must be a complete and valid phone number.
 * @param  {object} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string}
 * @example
 * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
 * // returns '88005553535'
 */
function generateNationalNumberDigits(phoneNumber) {
	return phoneNumber.formatNational().replace(/\D/g, '');
}

/**
 * Migrates parsed `<input/>` `value` for the newly selected `country`.
 * @param {string?} value - The `value` parsed from phone number `<input/>` (it's the `parsed_input` state property, not the `value` property).
 * @param {string?} previousCountry - Previously selected country.
 * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @param {boolean} preferNationalFormat - whether should attempt to convert from international to national number for the new country.
 * @return {string?}
 */
function migrateParsedInputForNewCountry(value, previous_country, new_country, metadata, preferNationalFormat) {
	// If `parsed_input` is empty
	// then no need to migrate anything.
	if (!value) {
		return value;
	}

	// If switching to some country.
	// (from "International" or another country)
	// If switching from "International" then `value` starts with a `+`.
	// Otherwise it may or may not start with a `+`.
	if (new_country) {
		// If the phone number was entered in international format
		// then migrate it to the newly selected country.
		// The phone number may be incomplete.
		// The phone number entered not necessarily starts with
		// the previously selected country phone prefix.
		if (value[0] === '+') {
			// If the international phone number is for the new country
			// then convert it to local if required.
			if (preferNationalFormat) {
				// // If a phone number is being input in international form
				// // and the country can already be derived from it,
				// // and if it is the new country, then format as a national number.
				// const derived_country = get_country_from_possibly_incomplete_international_phone_number(value, metadata)
				// if (derived_country === new_country)
				// {
				// 	return strip_country_calling_code(value, derived_country, metadata)
				// }

				// Actually, the two countries don't necessarily need to match:
				// the condition could be looser here, because several countries
				// might share the same international phone number format
				// (for example, "NANPA" countries like US, Canada, etc).
				// The looser condition would be just "same nternational phone number format"
				// which would mean "same country calling code" in the context of `libphonenumber-js`.
				if (value.indexOf('+' + (0, _core.getCountryCallingCode)(new_country, metadata)) === 0) {
					return strip_country_calling_code(value, new_country, metadata);
				}

				// Simply discard the previously entered international phone number,
				// because otherwise any "smart" transformation like getting the
				// "national (significant) number" part and then prepending the
				// newly selected country's "country calling code" to it
				// would just be confusing for a user without being actually useful.
				return '';

				// // Simply strip the leading `+` character
				// // therefore simply converting all digits into a "local" phone number.
				// // https://github.com/catamphetamine/react-phone-number-input/issues/287
				// return value.slice(1)
			}

			// If the international phone number already contains
			// any country calling code then trim the country calling code part.
			// (that could also be the newly selected country phone code prefix as well)
			// `value` doesn't neccessarily belong to `previous_country`.
			// (e.g. if a user enters an international number
			//  not belonging to any of the reduced `countries` list).
			value = strip_country_calling_code(value, previous_country, metadata);

			// Prepend country calling code prefix
			// for the newly selected country.
			return e164(value, new_country, metadata) || '+' + (0, _core.getCountryCallingCode)(new_country, metadata);
		}
	}
	// If switching to "International" from a country.
	else {
			// If the phone number was entered in national format.
			if (value[0] !== '+') {
				// Format the national phone number as an international one.
				// The phone number entered not necessarily even starts with
				// the previously selected country phone prefix.
				// Even if the phone number belongs to whole another country
				// it will still be parsed into some national phone number.
				return e164(value, previous_country, metadata) || '';
			}
		}

	return value;
}

/**
 * Converts phone number digits to a (possibly incomplete) E.164 phone number.
 * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string?} country
 * @param  {[object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */
function e164(number, country, metadata) {
	if (!number) {
		return;
	}

	// If the phone number is being input in international format.
	if (number[0] === '+') {
		// If it's just the `+` sign then return nothing.
		if (number === '+') {
			return;
		}

		// If there are any digits then the `value` is returned as is.
		return number;
	}

	// For non-international phone numbers
	// an accompanying country code is required.
	if (!country) {
		return;
	}

	var partial_national_significant_number = get_national_significant_number_part(number, country, metadata);

	if (partial_national_significant_number) {
		return '+' + (0, _core.getCountryCallingCode)(country, metadata) + partial_national_significant_number;
	}
}

/**
 * Trims phone number digits if they exceed the maximum possible length
 * for a national (significant) number for the country.
 * @param  {string} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string} country
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string} Can be empty.
 */
function trimNumber(number, country, metadata) {
	var nationalSignificantNumberPart = get_national_significant_number_part(number, country, metadata);
	var overflowDigitsCount = nationalSignificantNumberPart.length - getMaxNumberLength(country, metadata);
	if (overflowDigitsCount > 0) {
		return number.slice(0, number.length - overflowDigitsCount);
	}
	return number;
}

function getMaxNumberLength(country, metadata) {
	// Get "possible lengths" for a phone number of the country.
	metadata = new _core.Metadata(metadata);
	metadata.country(country);
	// Return the last "possible length".
	return metadata.possibleLengths()[metadata.possibleLengths().length - 1];
}

// If the phone number being input is an international one
// then tries to derive the country from the phone number.
// (regardless of whether there's any country currently selected)
/**
 * @param {string} parsedInput - A possibly incomplete E.164 phone number.
 * @param {string?} country - Currently selected country.
 * @param {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param {boolean} includeInternationalOption - Whether "International" country option is available.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */
function getCountryForPartialE164Number(partialE164Number, country, countries, includeInternationalOption, metadata) {
	if (partialE164Number === '+') {
		// Don't change the currently selected country yet.
		return country;
	}

	var derived_country = get_country_from_possibly_incomplete_international_phone_number(partialE164Number, metadata);

	// If a phone number is being input in international form
	// and the country can already be derived from it,
	// then select that country.
	if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) {
		return derived_country;
	}
	// If "International" country option has not been disabled
	// and the international phone number entered doesn't correspond
	// to the currently selected country then reset the currently selected country.
	else if (country && includeInternationalOption && !could_number_belong_to_country(partialE164Number, country, metadata)) {
			return undefined;
		}

	// Don't change the currently selected country.
	return country;
}

/**
 * Parses `<input/>` value. Derives `country` from `input`. Derives an E.164 `value`.
 * @param  {string?} input — Parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} prevInput — Previous parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} country - Currently selected country.
 * @param  {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {boolean} includeInternationalOption - Whether "International" country option is available.
 * @param  {boolean} limitMaxLength — Whether to enable limiting phone number max length.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {object} An object of shape `{ input, country, value }`.
 */
function parseInput(input, prevInput, country, countries, includeInternationalOption, limitMaxLength, metadata) {
	// Trim the input to not exceed the maximum possible number length.
	if (input && country && limitMaxLength) {
		input = trimNumber(input, country, metadata);
	}

	// If this `onChange()` event was triggered
	// as a result of selecting "International" country
	// then force-prepend a `+` sign if the phone number
	// `<input/>` value isn't in international format.
	if (input && !country && input[0] !== '+') {
		input = '+' + input;
	}

	// If the previously entered phone number
	// has been entered in international format
	// and the user decides to erase it,
	// then also reset the `country`
	// because it was most likely automatically selected
	// while the user was typing in the phone number
	// in international format.
	// This fixes the issue when a user is presented
	// with a phone number input with no country selected
	// and then types in their local phone number
	// then discovers that the input's messed up
	// (a `+` has been prepended at the start of their input
	//  and a random country has been selected),
	// decides to undo it all by erasing everything
	// and then types in their local phone number again
	// resulting in a seemingly correct phone number
	// but in reality that phone number has incorrect country.
	// https://github.com/catamphetamine/react-phone-number-input/issues/273
	if (!input && prevInput && prevInput[0] === '+') {
		country = undefined;
	}
	// Also resets such "randomly" selected country
	// as soon as the user erases the number
	// digit-by-digit up to the leading `+` sign.
	if (input === '+' && prevInput && prevInput[0] === '+' && prevInput.length > '+'.length) {
		country = undefined;
	}

	// Generate the new `value` property.
	var value = void 0;
	if (input) {
		if (input[0] === '+') {
			if (input !== '+') {
				value = input;
			}
		} else {
			value = e164(input, country, metadata);
		}
	}

	// Derive the country from the phone number.
	// (regardless of whether there's any country currently selected)
	if (value) {
		country = getCountryForPartialE164Number(value, country, countries, includeInternationalOption, metadata);
	}

	return {
		input: input,
		country: country,
		value: value
	};
}

/**
 * Determines the country for a given (possibly incomplete) E.164 phone number.
 * @param  {string} number - A possibly incomplete E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */
function get_country_from_possibly_incomplete_international_phone_number(number, metadata) {
	var formatter = new _core.AsYouType(null, metadata);
	formatter.input(number);
	// `001` is a special "non-geograpical entity" code
	// in Google's `libphonenumber` library.
	if (formatter.country === '001') {
		return;
	}
	return formatter.country;
}

/**
 * Compares two strings.
 * A helper for `Array.sort()`.
 */
function compare_strings(a, b) {
	// Use `String.localeCompare` if it's available.
	// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
	// Which means everyone except IE <= 10 and Safari <= 10.
	// `localeCompare()` is available in latest Node.js versions.
	/* istanbul ignore else */
	if (String.prototype.localeCompare) {
		return a.localeCompare(b);
	}
	/* istanbul ignore next */
	return a < b ? -1 : a > b ? 1 : 0;
}

/**
 * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
 * @param {string} number - (possibly incomplete) E.164 phone number.
 * @param {string?} country - A possible country for this phone number.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string}
 */
function strip_country_calling_code(number, country, metadata) {
	// Just an optimization, so that it
	// doesn't have to iterate through all country calling codes.
	if (country) {
		var country_calling_prefix = '+' + (0, _core.getCountryCallingCode)(country, metadata);

		// If `country` fits the actual `number`.
		if (number.length < country_calling_prefix.length) {
			if (country_calling_prefix.indexOf(number) === 0) {
				return '';
			}
		} else {
			if (number.indexOf(country_calling_prefix) === 0) {
				return number.slice(country_calling_prefix.length);
			}
		}
	}

	// If `country` doesn't fit the actual `number`.
	// Try all available country calling codes.
	for (var _iterator = Object.keys(metadata.country_calling_codes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var country_calling_code = _ref;

		if (number.indexOf(country_calling_code) === '+'.length) {
			return number.slice('+'.length + country_calling_code.length);
		}
	}

	return '';
}

/**
 * Parses a partially entered national phone number digits
 * (or a partially entered E.164 international phone number)
 * and returns the national significant number part.
 * National significant number returned doesn't come with a national prefix.
 * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
 * @param {string?} country
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string} Can be empty.
 */
function get_national_significant_number_part(number, country, metadata) {
	// Create "as you type" formatter.
	var formatter = new _core.AsYouType(country, metadata);

	// Input partial national phone number.
	formatter.input(number);

	// Return the parsed partial national phone number.
	return formatter.getNationalNumber();
}

/**
 * Checks if a partially entered E.164 phone number could belong to a country.
 * @param  {string} number
 * @param  {string} country
 * @return {boolean}
 */
function could_number_belong_to_country(number, country, metadata) {
	var country_calling_code = (0, _core.getCountryCallingCode)(country, metadata);

	var i = 0;
	while (i + 1 < number.length && i < country_calling_code.length) {
		if (number[i + 1] !== country_calling_code[i]) {
			return false;
		}
		i++;
	}

	return true;
}
//# sourceMappingURL=input-control.js.map

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(39);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CountrySelectNative = (_temp2 = _class = function (_Component) {
	_inherits(CountrySelectNative, _Component);

	function CountrySelectNative() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CountrySelectNative);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountrySelectNative.__proto__ || Object.getPrototypeOf(CountrySelectNative)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
			var onChange = _this.props.onChange;

			var value = event.target.value;
			onChange(value === 'ZZ' ? undefined : value);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CountrySelectNative, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    name = _props.name,
			    value = _props.value,
			    options = _props.options,
			    onFocus = _props.onFocus,
			    onBlur = _props.onBlur,
			    disabled = _props.disabled,
			    tabIndex = _props.tabIndex,
			    className = _props.className,
			    SelectArrow = _props.selectArrowComponent;


			var selectedOption = void 0;
			for (var _iterator = options, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
				var _ref2;

				if (_isArray) {
					if (_i >= _iterator.length) break;
					_ref2 = _iterator[_i++];
				} else {
					_i = _iterator.next();
					if (_i.done) break;
					_ref2 = _i.value;
				}

				var option = _ref2;

				if (!option.divider && option.value === value) {
					selectedOption = option;
				}
			}

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)(className, 'react-phone-number-input__country--native') },
				selectedOption && _react2.default.createElement(selectedOption.icon, { value: value }),
				_react2.default.createElement(
					'select',
					{
						name: name,
						value: value || 'ZZ',
						onChange: this.onChange,
						onFocus: onFocus,
						onBlur: onBlur,
						disabled: disabled,
						tabIndex: tabIndex,
						'aria-label': this.props['aria-label'],
						className: 'react-phone-number-input__country-select' },
					options.map(function (_ref3) {
						var value = _ref3.value,
						    label = _ref3.label,
						    divider = _ref3.divider;
						return _react2.default.createElement(
							'option',
							{
								key: divider ? '|' : value || 'ZZ',
								value: divider ? '|' : value || 'ZZ',
								disabled: divider ? true : false,
								className: divider ? 'react-phone-number-input__country-select-divider' : undefined },
							label
						);
					})
				),
				_react2.default.createElement(SelectArrow, null)
			);
		}
	}]);

	return CountrySelectNative;
}(_react.Component), _class.propTypes = {
	// A two-letter country code.
	// E.g. "US", "RU", etc.
	value: _propTypes2.default.string,

	// Updates the `value`.
	onChange: _propTypes2.default.func.isRequired,

	// `<select/>` options.
	options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		value: _propTypes2.default.string,
		label: _propTypes2.default.string,
		divider: _propTypes2.default.bool
	})).isRequired,

	// HTML `name` attribute.
	name: _propTypes2.default.string,

	// HTML `disabled` attribute.
	disabled: _propTypes2.default.bool,

	// HTML `tabIndex` attribute.
	tabIndex: _propTypes2.default.number,

	// Select arrow component.
	selectArrowComponent: _propTypes2.default.elementType.isRequired,

	// Toggles the `--focus` CSS class.
	// https://github.com/catamphetamine/react-phone-number-input/issues/189
	onFocus: _propTypes2.default.func,

	// Toggles the `--focus` CSS class.
	// https://github.com/catamphetamine/react-phone-number-input/issues/189
	onBlur: _propTypes2.default.func
}, _class.defaultProps = {
	selectArrowComponent: function selectArrowComponent() {
		return _react2.default.createElement('div', { className: 'react-phone-number-input__country-select-arrow' });
	}
}, _temp2);
exports.default = CountrySelectNative;
//# sourceMappingURL=CountrySelectNative.js.map

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_emoji_support__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_emoji_support___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_detect_emoji_support__);




var emojisSupported = __WEBPACK_IMPORTED_MODULE_2_detect_emoji_support___default()();

var APPhoneInputFlags = function APPhoneInputFlags(props) {
  var country = props.country;

  var flag = country.toUpperCase().replace(/./g, function (char) {
    return String.fromCodePoint(char.charCodeAt(0) + 127397);
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'react-phone-number-input__icon' },
    emojisSupported ? flag : country
  );
};
APPhoneInputFlags.defaultProps = {
  country: ''
};

APPhoneInputFlags.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (APPhoneInputFlags);

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function detect() {
    if (detect.cache !== null) {
        return detect.cache
    }

    if (typeof window === 'undefined') {
        return false;
    }

    var node = window.document.createElement('canvas');
    var ctx = node.getContext('2d');
    if (!ctx) {
        return false;
    }
    var backingStoreRatio =
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1;
    var offset = 12 * backingStoreRatio;

    ctx.fillStyle = '#f00';
    ctx.textBaseline = 'top';
    ctx.font = '32px Arial';
    ctx.fillText('\ud83d\udc28', 0, 0); // U+1F428 KOALA

    var support = ctx.getImageData(offset, offset, 1, 1).data[0] !== 0;

    detect.cache = support

    return support;
};

detect.cache = null;

module.exports = detect;


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APUpload_APUpload__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APUpload_APUpload_css__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APUpload_APUpload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__APUpload_APUpload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__ = __webpack_require__(31);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var baseClass = 'ap-image-upload';

var APDocumentUpload = function (_React$Component) {
  _inherits(APDocumentUpload, _React$Component);

  function APDocumentUpload() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, APDocumentUpload);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = APDocumentUpload.__proto__ || Object.getPrototypeOf(APDocumentUpload)).call.apply(_ref, [this].concat(args))), _this), _this.maxSize = function (value) {
      var maxSize = _this.props.maxSize;

      if (maxSize) return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__["j" /* maxFileSize */])(value, maxSize);
    }, _this.getValidators = function () {
      var validate = _this.props.validate;

      return validate ? [].concat(_toConsumableArray(validate), [_this.maxSize]) : [_this.maxSize];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(APDocumentUpload, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          customClass = _props.customClass,
          otherProps = _objectWithoutProperties(_props, ['customClass']);

      var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APUpload_APUpload__["a" /* default */], Object.assign({}, otherProps, {
        customClass: bemClasses(),
        acceptedFiles: '.pdf, .doc, .docx',
        validate: this.getValidators()
      }));
    }
  }]);

  return APDocumentUpload;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

APDocumentUpload.defaultProps = {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: ''
};
APDocumentUpload.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
APDocumentUpload.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


APDocumentUpload.defaultProps = {
  name: '',
  label: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  maxSize: null
};

APDocumentUpload.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (APDocumentUpload);

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return readFile; });
var readFile = function readFile(file, callback) {
  var reader = new FileReader();
  reader.onload = function (e) {
    return callback(e.target.result);
  };
  reader.readAsDataURL(file);
};

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APUpload_APUpload__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APUpload_APUpload_css__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APUpload_APUpload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__APUpload_APUpload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var baseClass = 'ap-image-upload';

var APImageUpload = function (_React$Component) {
  _inherits(APImageUpload, _React$Component);

  function APImageUpload() {
    _classCallCheck(this, APImageUpload);

    var _this = _possibleConstructorReturn(this, (APImageUpload.__proto__ || Object.getPrototypeOf(APImageUpload)).call(this));

    _this.onChange = function (e, _ref) {
      var file = _ref.file,
          imgSrc = _ref.imgSrc;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;

      var changeFn = onChange || function () {};

      if (file) {
        changeFn(name, { file: file, imgSrc: imgSrc });
        setTimeout(function () {
          return _this.setState({ imgSrc: imgSrc });
        });
      } else {
        _this.setState({ imgSrc: null });
        changeFn(name, null);
      }
    };

    _this.state = {
      imgSrc: null
    };
    return _this;
  }

  _createClass(APImageUpload, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          customClass = _props.customClass,
          otherProps = _objectWithoutProperties(_props, ['customClass']);

      var imgSrc = this.state.imgSrc;

      var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APUpload_APUpload__["a" /* default */], Object.assign({}, otherProps, {
        customChange: this.onChange,
        label: imgSrc ? this.context.t('Choose another image') : this.context.t('Place image'),
        customClass: bemClasses(),
        acceptedFiles: '.png, .jpg, .jpeg, .gif'
      }));
    }
  }]);

  return APImageUpload;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

APImageUpload.defaultProps = {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: ''
};
APImageUpload.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
APImageUpload.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


APImageUpload.defaultProps = {
  name: '',
  label: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  maxSize: null
};

APImageUpload.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (APImageUpload);

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = APTimePicker;
/* unused harmony export APTimePickerDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_formGeneratorHelper__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APTimePickerDropdown_css__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APTimePickerDropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__APTimePickerDropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_formValidations__ = __webpack_require__(31);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var APTimePickerDropdown = function (_React$Component) {
  _inherits(APTimePickerDropdown, _React$Component);

  function APTimePickerDropdown(props) {
    _classCallCheck(this, APTimePickerDropdown);

    var _this = _possibleConstructorReturn(this, (APTimePickerDropdown.__proto__ || Object.getPrototypeOf(APTimePickerDropdown)).call(this, props));

    _this.setIsAM = function (date) {
      _this.setState({ isAM: date.getHours() < 12 });
    };

    _this.handleChange = function (date) {
      _this.props.input.onChange(date);
      if (_this.props.customChange) {
        _this.props.customChange(date);
      }
      _this.setIsAM(date);
      _this.setState({ date: new Date(date) });
    };

    _this.getClasses = function () {
      var customClasses = _this.props.customClasses;

      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['ap-timepicker-dropdown', 'ap-select', customClasses]);
    };

    _this.getHours = function () {
      var _this$props = _this.props,
          isAMPM = _this$props.isAMPM,
          leadingZero = _this$props.leadingZero;


      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_formGeneratorHelper__["a" /* generateOptionsFromNumber */])(isAMPM ? 1 : 0, isAMPM ? 13 : 24, leadingZero ? 2 : 0);
    };

    _this.onHoursChange = function (e) {
      var value = e.target.value;
      var _this$state = _this.state,
          date = _this$state.date,
          isAM = _this$state.isAM;
      var isAMPM = _this.props.isAMPM;


      var hours = +value;

      if (hours === 12) {
        hours = isAM ? 0 : 12;
      } else {
        hours = isAMPM && !isAM ? +value + 12 : +value;
      }

      date.setHours(hours);
      _this.handleChange(date);
    };

    _this.onMinutesChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;


      date.setMinutes(value);
      _this.handleChange(date);
    };

    _this.getCurrentValue = function () {
      var _this$state2 = _this.state,
          date = _this$state2.date,
          isAM = _this$state2.isAM;
      var isAMPM = _this.props.isAMPM;

      var hours = date.getHours();

      if (isAMPM) {
        if (isAM) {
          hours = hours === 0 ? 12 : hours;
        } else {
          hours = hours === 12 ? hours : hours - 12;
        }
      }

      return {
        hours: hours,
        minutes: date.getMinutes()
      };
    };

    _this.onAmPmChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;

      var hours = date.getHours();

      hours = value === 'AM' ? hours - 12 : hours + 12;

      date.setHours(hours);
      _this.handleChange(date);
    };

    _this.state = {
      date: new Date(0, 0, 0, 0, 0, 0),
      isAM: true
    };
    return _this;
  }

  _createClass(APTimePickerDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.props.input.value;

      if (value) {
        var date = new Date(value);
        this.setState({ date: date });
        this.setIsAM(date);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          meta = _props.meta,
          info = _props.info,
          customClass = _props.customClass,
          leadingZero = _props.leadingZero,
          isAMPM = _props.isAMPM,
          otherProps = _objectWithoutProperties(_props, ['label', 'meta', 'info', 'customClass', 'leadingZero', 'isAMPM']);

      var isAM = this.state.isAM;

      var baseClasses = this.getClasses();
      var value = this.getCurrentValue();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group ' + baseClasses('select-wrapper') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { className: 'ap--label ' + baseClasses('label') },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('input') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            Object.assign({
              value: value.hours,
              className: baseClasses('select'),
              onChange: this.onHoursChange
            }, otherProps),
            this.getHours()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            Object.assign({
              value: value.minutes,
              className: baseClasses('select'),
              onChange: this.onMinutesChange
            }, otherProps),
            Object(__WEBPACK_IMPORTED_MODULE_4__helpers_formGeneratorHelper__["a" /* generateOptionsFromNumber */])(0, 60, leadingZero ? 2 : 0)
          ),
          isAMPM && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            Object.assign({
              value: isAM ? 'AM' : 'PM',
              className: baseClasses('select'),
              onChange: this.onAmPmChange
            }, otherProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              null,
              'PM'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              null,
              'AM'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-text-muted ' + baseClasses('info') },
          info
        ),
        meta.dirty && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('error', 'dpk-error') },
          meta.error
        )
      );
    }
  }]);

  return APTimePickerDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

APTimePickerDropdown.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    touched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  leadingZero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  minTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date)]),
  maxTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date)])
};
APTimePickerDropdown.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
APTimePickerDropdown.defaultProps = {
  label: 'Time',
  info: '',
  disabled: false,
  leadingZero: true
};


var minTimeProp = void 0;
var maxTimeProp = void 0;

var minTimeValidation = function minTimeValidation(value) {
  return minTimeProp && Object(__WEBPACK_IMPORTED_MODULE_7__helpers_formValidations__["n" /* minTime */])(value, Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["f" /* parseTime */])(minTimeProp));
};
var maxTimeValidation = function maxTimeValidation(value) {
  return maxTimeProp && Object(__WEBPACK_IMPORTED_MODULE_7__helpers_formValidations__["l" /* maxTime */])(value, Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["f" /* parseTime */])(maxTimeProp));
};

var maxMinValidations = [minTimeValidation, maxTimeValidation];

function APTimePicker(props) {
  var validate = props.validate,
      minTime = props.minTime,
      maxTime = props.maxTime,
      otherProps = _objectWithoutProperties(props, ['validate', 'minTime', 'maxTime']);

  minTimeProp = minTime;
  maxTimeProp = maxTime;

  var validators = validate ? [].concat(_toConsumableArray(validate), maxMinValidations) : maxMinValidations;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({}, otherProps, {
    name: props.name,
    component: APTimePickerDropdown,
    validate: validators
  }));
}



/***/ }),
/* 1440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = APDatePicker;
/* unused harmony export APDatePickerDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_formGeneratorHelper__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__APDatePickerDropdown_css__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__APDatePickerDropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__APDatePickerDropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__ = __webpack_require__(31);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var APDatePickerDropdown = function (_React$Component) {
  _inherits(APDatePickerDropdown, _React$Component);

  function APDatePickerDropdown(props) {
    _classCallCheck(this, APDatePickerDropdown);

    var _this = _possibleConstructorReturn(this, (APDatePickerDropdown.__proto__ || Object.getPrototypeOf(APDatePickerDropdown)).call(this, props));

    _this.handleChange = function (date) {
      _this.props.input.onChange(date);

      if (_this.props.customChange) {
        _this.props.customChange(date);
      }
      _this.setState({ date: new Date(date) });
    };

    _this.getClasses = function () {
      var customClasses = _this.props.customClasses;

      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['ap-datepicker-dropdown', 'ap-select', customClasses]);
    };

    _this.getDays = function () {
      var date = _this.state.date;
      var leadingZero = _this.props.leadingZero;

      var daysCount = _this.getDaysInMonth(date);

      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_formGeneratorHelper__["a" /* generateOptionsFromNumber */])(1, daysCount + 1, leadingZero ? 2 : 0);
    };

    _this.getMonths = function () {
      var months = [{ value: 0, text: _this.context.t('January') }, { value: 1, text: _this.context.t('February') }, { value: 2, text: _this.context.t('March') }, { value: 3, text: _this.context.t('April') }, { value: 4, text: _this.context.t('May') }, { value: 5, text: _this.context.t('June') }, { value: 6, text: _this.context.t('July') }, { value: 7, text: _this.context.t('August') }, { value: 8, text: _this.context.t('September') }, { value: 9, text: _this.context.t('October') }, { value: 10, text: _this.context.t('November') }, { value: 11, text: _this.context.t('December') }];

      return months.map(function (month) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { key: month.value, value: month.value },
          month.text
        );
      });
    };

    _this.getYears = function () {
      var _this$props = _this.props,
          minYear = _this$props.minYear,
          maxYear = _this$props.maxYear,
          leadingZero = _this$props.leadingZero;

      var today = new Date();

      minYear = minYear || 1900;
      maxYear = maxYear || today.getFullYear();

      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_formGeneratorHelper__["a" /* generateOptionsFromNumber */])(minYear, maxYear + 1, leadingZero ? 2 : 0).reverse();
    };

    _this.onDayChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;


      date.setDate(+value);
      _this.handleChange(date);
    };

    _this.onMonthChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;

      var currentDays = date.getDate();

      // If user's selected month has less days than the actual month we set the day to the latest in that given month
      // else month will change to next because of the days difference
      date.setDate(1);
      date.setMonth(value);

      var monthDays = _this.getDaysInMonth(date);

      if (currentDays > monthDays) date.setDate(monthDays);

      _this.handleChange(date);
    };

    _this.onYearChange = function (e) {
      var value = e.target.value;
      var date = _this.state.date;


      date.setFullYear(value);
      _this.handleChange(date);
    };

    _this.getCurrentValue = function () {
      var date = _this.state.date;


      return {
        day: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear()
      };
    };

    _this.state = {
      date: new Date()
    };
    return _this;
  }

  _createClass(APDatePickerDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.props.input.value;

      if (value) {
        var date = new Date(value);
        this.setState({ date: date });
      }
    }
  }, {
    key: 'getDaysInMonth',
    value: function getDaysInMonth(date) {
      return new Date(date.getYear(), date.getMonth() + 1, 0).getDate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          meta = _props.meta,
          info = _props.info,
          customClass = _props.customClass,
          leadingZero = _props.leadingZero,
          minYear = _props.minYear,
          maxYear = _props.maxYear,
          minDate = _props.minDate,
          maxDate = _props.maxDate,
          otherProps = _objectWithoutProperties(_props, ['label', 'meta', 'info', 'customClass', 'leadingZero', 'minYear', 'maxYear', 'minDate', 'maxDate']);

      var baseClasses = this.getClasses();
      var value = this.getCurrentValue();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'form-group ' + baseClasses('select-wrapper') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { className: 'ap--label ' + baseClasses('label') },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('input') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            Object.assign({
              value: value.day,
              className: baseClasses('select'),
              onChange: this.onDayChange
            }, otherProps),
            this.getDays()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            Object.assign({
              value: value.month,
              className: baseClasses('select'),
              onChange: this.onMonthChange
            }, otherProps),
            this.getMonths()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            Object.assign({
              value: value.year,
              className: baseClasses('select'),
              onChange: this.onYearChange
            }, otherProps),
            this.getYears()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-text-muted ' + baseClasses('info') },
          info
        ),
        meta.dirty && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('error', 'dpk-error') },
          meta.error
        )
      );
    }
  }]);

  return APDatePickerDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

APDatePickerDropdown.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    touched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  leadingZero: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  minYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  maxYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date)]),
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date)])
};
APDatePickerDropdown.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
APDatePickerDropdown.defaultProps = {
  label: 'Date',
  customClass: 'custom-datepicker',
  info: '',
  disabled: false,
  leadingZero: true
};


var minDateProp = void 0;
var maxDateProp = void 0;

var maxDateValidation = function maxDateValidation(value) {
  return maxDateProp && Object(__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["i" /* maxDate */])(value, new Date(maxDateProp));
};
var minDateValidation = function minDateValidation(value) {
  return minDateProp && Object(__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["m" /* minDate */])(value, new Date(minDateProp));
};

var maxMinValidations = [maxDateValidation, minDateValidation];

function APDatePicker(props) {
  minDateProp = props.minDate;
  maxDateProp = props.maxDate;

  var validate = props.validate,
      otherProps = _objectWithoutProperties(props, ['validate']);

  var validators = validate ? [].concat(_toConsumableArray(validate), maxMinValidations) : maxMinValidations;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({}, otherProps, {
    component: APDatePickerDropdown,
    validate: validators,
    name: props.name
  }));
}



/***/ }),
/* 1442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainNavOptions", function() { return mainNavOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routesArray", function() { return routesArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_load__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var ProductPositionDetailsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 2567));
});
var OrderHistoryComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 151));
});
var FixedLeftFluidLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 102));
});
var TradingLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 103));
});
var BalancesMenuContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 83));
});

// this.context.t('Trading')
// this.context.t('Balances')
// this.context.t('User Settings')
var mainNavOptions = {
  mainNavItems: [{ text: 'Trading', icon: 'trading', path: '/trading' }, { text: 'Balances', icon: 'balance', path: '/balances' }, { text: 'User Settings', icon: 'user-settings', path: '/settings/profile' }],
  settingsPath: '/settings/profile'
};

var routesArray = [{ path: '/trading', render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingLayout, null);
  } }, {
  path: '/balances',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FixedLeftFluidLayout,
      { left: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesMenuContainer, { key: '2' })] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPositionDetailsContainer, null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderHistoryComponent, {
        classModifiers: ['full-height'],
        useHeaderWithFilter: true,
        config: {
          maxLines: __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].BalancesLayout.maxLines,
          filterMode: 'selectedProduct',
          usePagination: false
        }
      })
    );
  }
}];

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error("react-loadable requires a `loading` component");
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === "function") {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true, timedOut: false });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === "number") {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === "number") {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== "function") {
    throw new Error("LoadableMap requires a `render(loaded, props)` function");
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};


Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductIcon_css__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductIcon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProductIcon_css__);







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('product-icon');

var ProductIcon = function ProductIcon(_ref) {
  var productManifest = _ref.productManifest,
      iconFileName = _ref.iconFileName,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 48 : _ref$size,
      customClass = _ref.customClass;

  if (productManifest.fetching) {
    return null;
  }

  if (iconFileName == null) {
    console.log(iconFileName);
  }

  if (iconFileName && iconFileName.includes('DEFAULT_ICON')) {
    return renderDefaultIcon(size, iconFileName, customClass);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
    alt: 'product icon',
    height: size + 'px',
    className: customClass,
    src: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_path__["a" /* default */])('/local/product-icons/' + iconFileName)
  });
};

var renderDefaultIcon = function renderDefaultIcon(size, iconFileName, customClass) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: customClass + ' ' + bemClasses(null, 'default'),
      style: {
        width: size,
        height: size,
        MozBorderRadius: size / 2,
        WebkitBorderRadius: size / 2,
        borderRadius: size / 2,
        textAlign: 'center',
        fontSize: size * 0.5,
        lineHeight: size + 'px'
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: { width: '100%' } },
      iconFileName.charAt(0)
    )
  );
};

ProductIcon.propTypes = {
  productManifest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  iconFileName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (ProductIcon);

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_withdrawHelper__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DepositSidePaneComponents_DepositTemplateFormContainer__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DepositSidePaneComponents_DepositWorkflows_DepositWorkflowsContainer__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FiatDepositFormComponent_css__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FiatDepositFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__FiatDepositFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-deposit-form');
var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-slide-pane');

var FiatDepositFormComponent = function (_React$Component) {
  _inherits(FiatDepositFormComponent, _React$Component);

  function FiatDepositFormComponent() {
    _classCallCheck(this, FiatDepositFormComponent);

    return _possibleConstructorReturn(this, (FiatDepositFormComponent.__proto__ || Object.getPrototypeOf(FiatDepositFormComponent)).apply(this, arguments));
  }

  _createClass(FiatDepositFormComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          ProductId = _props.product.ProductId,
          selectDepositProduct = _props.selectDepositProduct;

      selectDepositProduct(ProductId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.initialize(Object.assign({}, this.props.product));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          disableDeposit = _props2.disableDeposit,
          deposit = _props2.depositInfo,
          _props2$depositInfo = _props2.depositInfo,
          templateTypes = _props2$depositInfo.templateTypes,
          isLoading = _props2$depositInfo.isLoading,
          error = _props2$depositInfo.error,
          depositInfo = _props2$depositInfo.depositInfo,
          product = _props2.product,
          handleSubmit = _props2.handleSubmit,
          submitting = _props2.submitting,
          selectDepositTemplate = _props2.selectDepositTemplate,
          verificationOnClick = _props2.verificationOnClick;

      var showTemplateTypeSelect = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_withdrawHelper__["e" /* showTemplateSelect */])(deposit);
      var templateTypeOptions = [{ value: '', label: 'Select an option' }].concat(_toConsumableArray(templateTypes.map(function (template) {
        return {
          value: template.TemplateName,
          label: template.TemplateName
        };
      })));
      var useTemplateDepositWorkflow = depositInfo && !depositInfo.length;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DepositSidePaneComponents_DepositWorkflows_DepositWorkflowsContainer__["a" /* default */], {
          onSubmit: handleSubmit,
          submitting: submitting
        }),
        isLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], { customClass: baseClasses }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: baseClasses('error') },
            this.context.t(error)
          ),
          useTemplateDepositWorkflow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            {
              className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(slidePaneClasses('body'), baseClasses('body')),
              onSubmit: handleSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('form-body') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: baseClasses('frame') },
                disableDeposit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__VerificationRequired_VerificationRequiredContainer__["a" /* default */], {
                  disabled: disableDeposit,
                  onClick: verificationOnClick
                }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  showTemplateTypeSelect && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_APSelect__["b" /* default */], {
                    name: 'TemplateType',
                    customClass: baseClasses(),
                    label: this.context.t('Select an option to continue the deposit process'),
                    onSelect: function onSelect(value) {
                      return selectDepositTemplate(product.ProductId, value);
                    },
                    options: templateTypeOptions
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DepositSidePaneComponents_DepositTemplateFormContainer__["a" /* default */], {
                    submitting: submitting,
                    baseClasses: baseClasses
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FiatDepositFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiatDepositFormComponent.defaultProps = {
  deposit: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    depositInfo: {},
    depositStatus: {}
  }
};

FiatDepositFormComponent.propTypes = {
  disableDeposit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSnack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  deposit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    templateInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    depositInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    depositStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      success: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      RequestCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }).isRequired
  }),
  verificationOnClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

FiatDepositFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatDepositFormComponent);

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VerificationRequiredComponent_css__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VerificationRequiredComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__VerificationRequiredComponent_css__);









var VerificationRequiredComponent = function VerificationRequiredComponent(props, context) {
  var customClass = props.customClass,
      className = props.className,
      disabled = props.disabled,
      isUnderReview = props.isUnderReview,
      verificationLevelPageUrl = props.verificationLevelPageUrl,
      enableOnClick = props.enableOnClick,
      onVerificationLinkClick = props.onVerificationLinkClick,
      _onClick = props.onClick,
      customKYCmessage = props.customKYCmessage,
      history = props.history,
      disableKYCLinkUnderReview = props.disableKYCLinkUnderReview;


  var noLink = disableKYCLinkUnderReview ? isUnderReview : verificationLevelPageUrl === '';
  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['verification-required', customClass]);
  var handleOnVerificationLinkClick = function handleOnVerificationLinkClick() {
    if (verificationLevelPageUrl.match(/^http/)) {
      window.location.href = verificationLevelPageUrl;
    } else {
      history.push(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])(verificationLevelPageUrl));
      if (enableOnClick) onVerificationLinkClick();
    }
  };

  if (disabled) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: bemClasses(noLink ? 'no-link' : ''),
        onClick: function onClick() {
          if (noLink) return;
          handleOnVerificationLinkClick();
          _onClick && _onClick();
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], {
        name: 'alert',
        customClass: bemClasses('warning'),
        classModifiers: 'small'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          className: 'ap--label ' + bemClasses('not-verified') + ' ' + className },
        customKYCmessage ? customKYCmessage : getVerificationRequiredMessage(context, isUnderReview, noLink)
      )
    )
  );
  return null;
};

var getVerificationRequiredMessage = function getVerificationRequiredMessage(context, isUnderReview, noLink) {
  if (noLink && isUnderReview) return context.t('You are not yet verified. Verification under review.');else if (noLink) return context.t('You are not yet verified. Verify your identity to start trading.');else if (isUnderReview) return context.t('Verification under review. Click here to check your verification status.');else return context.t('Verify your identity to start trading. Click here to verify.');
};

VerificationRequiredComponent.defaultProps = {
  className: '',
  onVerificationLinkClick: function onVerificationLinkClick() {},
  isUnderReview: false,
  disabled: false,
  enableOnClick: true,
  disableKYCLinkUnderReview: false
};

VerificationRequiredComponent.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  verificationLevelPageUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onVerificationLinkClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isUnderReview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  enableOnClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customKYCmessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

VerificationRequiredComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(VerificationRequiredComponent));

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepositTemplateFormComponent__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);




var mapStateToProps = function mapStateToProps(state, _ref) {
  var submitting = _ref.submitting,
      baseClasses = _ref.baseClasses;
  return {
    template: state.deposit.template,
    product: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__["b" /* depositProductSelector */])(state),
    submitting: submitting,
    baseClasses: baseClasses
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__DepositTemplateFormComponent__["a" /* default */]));

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__APCryptoAddressInputComponent__ = __webpack_require__(1455);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])()(__WEBPACK_IMPORTED_MODULE_1__APCryptoAddressInputComponent__["a" /* default */]));

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cryptoAddressValidationHelper_cryptoAddressValidationHelper__ = __webpack_require__(1456);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var APCryptoAddressInputComponent = function APCryptoAddressInputComponent(props, context) {
  var productSymbol = props.productSymbol,
      otherProps = _objectWithoutProperties(props, ['productSymbol']);

  var errorMessage = context.t('Invalid {productSymbol} address', {
    productSymbol: productSymbol
  });

  var validator = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cryptoAddressValidationHelper_cryptoAddressValidationHelper__["a" /* default */])(productSymbol, errorMessage);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APInput__["b" /* default */], Object.assign({}, otherProps, { validate: validator }));
};

APCryptoAddressInputComponent.propTypes = Object.assign({
  productSymbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, __WEBPACK_IMPORTED_MODULE_2__APInput__["b" /* default */].propTypes);

APCryptoAddressInputComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (APCryptoAddressInputComponent);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_multicoin_address_validator__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_multicoin_address_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_multicoin_address_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_coinslot__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);




var _config$CryptoAddress = __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].CryptoAddressValidation,
    DoNotValidate = _config$CryptoAddress.DoNotValidate,
    ValidateAsERC20 = _config$CryptoAddress.ValidateAsERC20,
    UseDeprecatedValidate = _config$CryptoAddress.UseDeprecatedValidate;


var shouldNotValidate = function shouldNotValidate(productSymbol) {
  return DoNotValidate.includes(productSymbol);
};
var shouldValidateAsERC20 = function shouldValidateAsERC20(productSymbol) {
  return ValidateAsERC20.includes(productSymbol);
};
var shouldUseDeprecatedValidate = function shouldUseDeprecatedValidate(productSymbol) {
  return UseDeprecatedValidate.includes(productSymbol);
};

/* harmony default export */ __webpack_exports__["a"] = (function (productSymbol) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return function (address) {
    if (!productSymbol) return undefined;
    if (address === undefined) return undefined;
    if (shouldNotValidate(productSymbol)) return undefined;

    var format = function format(isValid) {
      return isValid ? undefined : errorMessage;
    };

    try {
      if (shouldUseDeprecatedValidate(productSymbol.toUpperCase())) {
        return format(Object(__WEBPACK_IMPORTED_MODULE_1_coinslot__["a" /* validate */])(address, productSymbol.toUpperCase()));
      }

      if (shouldValidateAsERC20(productSymbol)) {
        return format(Object(__WEBPACK_IMPORTED_MODULE_0_multicoin_address_validator__["validate"])(address, 'ETH', 'both'));
      }

      return format(Object(__WEBPACK_IMPORTED_MODULE_0_multicoin_address_validator__["validate"])(address, productSymbol, 'both'));
    } catch (e) {
      /**
       * Currency not supported.
       */
      return undefined;
    }
  };
});

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

var currencies = __webpack_require__(1458);

var DEFAULT_CURRENCY_NAME = 'bitcoin';

module.exports = {
    validate: function validate(address, currencyNameOrSymbol, networkType) {
        var currency = currencies.getByNameOrSymbol(currencyNameOrSymbol || DEFAULT_CURRENCY_NAME);

        if (currency && currency.validator) {
            return currency.validator.isValidAddress(address, currency, networkType);
        }

        throw new Error('Missing validator for currency: ' + currencyNameOrSymbol);
    },
    getCurrencies: function getCurrencies() {
        return currencies.getAll();
    },
    findCurrency: function findCurrency(symbol) {
        return currencies.getByNameOrSymbol(symbol) || null;
    }
};

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

var XRPValidator = __webpack_require__(1459);
var ETHValidator = __webpack_require__(1470);
var BTCValidator = __webpack_require__(648);
var ADAValidator = __webpack_require__(1472);
var XMRValidator = __webpack_require__(1485);
var NANOValidator = __webpack_require__(1488);
var SCValidator = __webpack_require__(1489);
var TRXValidator = __webpack_require__(1491);
var NEMValidator = __webpack_require__(1492);
var LSKValidator = __webpack_require__(1493);
var BCHValidator = __webpack_require__(1494);
var XLMValidator = __webpack_require__(1495);

// defines P2PKH and P2SH address types for standard (prod) and testnet networks
var CURRENCIES = [{
    name: 'Bitcoin',
    symbol: 'btc',
    addressTypes: { prod: ['00', '05'], testnet: ['6f', 'c4', '3c', '26'] },
    validator: BTCValidator
}, {
    name: 'BitcoinCash',
    symbol: 'bch',
    regexp: '^[qQpP]{1}[0-9a-zA-Z]{41}$',
    addressTypes: { prod: ['00', '05'], testnet: ['6f', 'c4'] },
    validator: BCHValidator
}, {
    name: 'Bitcoin SV',
    symbol: 'bsv',
    regexp: '^[qQ]{1}[0-9a-zA-Z]{41}$',
    addressTypes: { prod: ['00', '05'], testnet: ['6f', 'c4'] },
    validator: BCHValidator
}, {
    name: 'LiteCoin',
    symbol: 'ltc',
    addressTypes: { prod: ['30', '05', '32'], testnet: ['6f', 'c4', '3a'] },
    validator: BTCValidator
}, {
    name: 'PeerCoin',
    symbol: 'ppc',
    addressTypes: { prod: ['37', '75'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'DogeCoin',
    symbol: 'doge',
    addressTypes: { prod: ['1e', '16'], testnet: ['71', 'c4'] },
    validator: BTCValidator
}, {
    name: 'BeaverCoin',
    symbol: 'bvc',
    addressTypes: { prod: ['19', '05'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'FreiCoin',
    symbol: 'frc',
    addressTypes: { prod: ['00', '05'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'ProtoShares',
    symbol: 'pts',
    addressTypes: { prod: ['38', '05'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'MegaCoin',
    symbol: 'mec',
    addressTypes: { prod: ['32', '05'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'PrimeCoin',
    symbol: 'xpm',
    addressTypes: { prod: ['17', '53'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'AuroraCoin',
    symbol: 'aur',
    addressTypes: { prod: ['17', '05'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'NameCoin',
    symbol: 'nmc',
    addressTypes: { prod: ['34'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'BioCoin',
    symbol: 'bio',
    addressTypes: { prod: ['19', '14'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'GarliCoin',
    symbol: 'grlc',
    addressTypes: { prod: ['26', '05'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'VertCoin',
    symbol: 'vtc',
    addressTypes: { prod: ['0x', '47', '71', '05'], testnet: ['6f', 'c4'] },
    validator: BTCValidator

}, {
    name: 'BitcoinGold',
    symbol: 'btg',
    addressTypes: { prod: ['26', '17'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'Komodo',
    symbol: 'kmd',
    addressTypes: { prod: ['3c', '55'], testnet: ['0', '5'] },
    validator: BTCValidator
}, {
    name: 'BitcoinZ',
    symbol: 'btcz',
    expectedLength: 26,
    addressTypes: { prod: ['1cb8', '1cbd'], testnet: ['1d25', '1cba'] },
    validator: BTCValidator
}, {
    name: 'BitcoinPrivate',
    symbol: 'btcp',
    expectedLength: 26,
    addressTypes: { prod: ['1325', '13af'], testnet: ['1957', '19e0'] },
    validator: BTCValidator
}, {
    name: 'Hush',
    symbol: 'hush',
    expectedLength: 26,
    addressTypes: { prod: ['1cb8', '1cbd'], testnet: ['1d25', '1cba'] },
    validator: BTCValidator
}, {
    name: 'SnowGem',
    symbol: 'sng',
    expectedLength: 26,
    addressTypes: { prod: ['1c28', '1c2d'], testnet: ['1d25', '1cba'] },
    validator: BTCValidator
}, {
    name: 'ZCash',
    symbol: 'zec',
    expectedLength: 26,
    addressTypes: { prod: ['1cb8', '1cbd'], testnet: ['1d25', '1cba'] },
    validator: BTCValidator
}, {
    name: 'ZClassic',
    symbol: 'zcl',
    expectedLength: 26,
    addressTypes: { prod: ['1cb8', '1cbd'], testnet: ['1d25', '1cba'] },
    validator: BTCValidator
}, {
    name: 'ZenCash',
    symbol: 'zen',
    expectedLength: 26,
    addressTypes: { prod: ['2089', '2096'], testnet: ['2092', '2098'] },
    validator: BTCValidator
}, {
    name: 'VoteCoin',
    symbol: 'vot',
    expectedLength: 26,
    addressTypes: { prod: ['1cb8', '1cbd'], testnet: ['1d25', '1cba'] },
    validator: BTCValidator
}, {
    name: 'Decred',
    symbol: 'dcr',
    addressTypes: { prod: ['073f', '071a'], testnet: ['0f21', '0efc'] },
    hashFunction: 'blake256',
    expectedLength: 26,
    validator: BTCValidator
}, {
    name: 'GameCredits',
    symbol: 'game',
    addressTypes: { prod: ['26', '05'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'PIVX',
    symbol: 'pivx',
    addressTypes: { prod: ['1e', '0d'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'SolarCoin',
    symbol: 'slr',
    addressTypes: { prod: ['12', '05'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'MonaCoin',
    symbol: 'mona',
    addressTypes: { prod: ['32', '37'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'DigiByte',
    symbol: 'dgb',
    addressTypes: { prod: ['1e'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'Tether',
    symbol: 'usdt',
    addressTypes: { prod: ['00', '05'], testnet: ['6f', 'c4'] },
    validator: BTCValidator
}, {
    name: 'Ripple',
    symbol: 'xrp',
    validator: XRPValidator
}, {
    name: 'Dash',
    symbol: 'dash',
    addressTypes: { prod: ['4c', '10'], testnet: ['8c', '13'] },
    validator: BTCValidator
}, {
    name: 'Neo',
    symbol: 'neo',
    addressTypes: { prod: ['17'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'NeoGas',
    symbol: 'gas',
    addressTypes: { prod: ['17'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'Qtum',
    symbol: 'qtum',
    addressTypes: { prod: ['3a', '32'], testnet: ['78', '6e'] },
    validator: BTCValidator
}, {
    name: 'Waves',
    symbol: 'waves',
    addressTypes: { prod: ['0157'], testnet: ['0154'] },
    expectedLength: 26,
    hashFunction: 'blake256keccak256',
    regex: /^[a-zA-Z0-9]{35}$/,
    validator: BTCValidator
}, {
    name: 'Ethereum',
    symbol: 'eth',
    validator: ETHValidator
}, {
    name: 'EtherZero',
    symbol: 'etz',
    validator: ETHValidator
}, {
    name: 'EthereumClassic',
    symbol: 'etc',
    validator: ETHValidator
}, {
    name: 'Callisto',
    symbol: 'clo',
    validator: ETHValidator
}, {
    name: 'Bankex',
    symbol: 'bkx',
    validator: ETHValidator
}, {
    name: 'Cardano',
    symbol: 'ada',
    validator: ADAValidator
}, {
    name: 'Monero',
    symbol: 'xmr',
    addressTypes: { prod: ['18'], testnet: ['53'] },
    iAddressTypes: { prod: ['19'], testnet: ['54'] },
    validator: XMRValidator
}, {
    name: 'Aragon',
    symbol: 'ant',
    validator: ETHValidator
}, {
    name: 'Basic Attention Token',
    symbol: 'bat',
    validator: ETHValidator
}, {
    name: 'Bancor',
    symbol: 'bnt',
    validator: ETHValidator
}, {
    name: 'Civic',
    symbol: 'cvc',
    validator: ETHValidator
}, {
    name: 'District0x',
    symbol: 'dnt',
    validator: ETHValidator
}, {
    name: 'Gnosis',
    symbol: 'gno',
    validator: ETHValidator
}, {
    name: 'Golem',
    symbol: 'gnt',
    validator: ETHValidator
}, {
    name: 'Matchpool',
    symbol: 'gup',
    validator: ETHValidator
}, {
    name: 'Melon',
    symbol: 'mln',
    validator: ETHValidator
}, {
    name: 'Numeraire',
    symbol: 'nmr',
    validator: ETHValidator
}, {
    name: 'OmiseGO',
    symbol: 'omg',
    validator: ETHValidator
}, {
    name: 'TenX',
    symbol: 'pay',
    validator: ETHValidator
}, {
    name: 'Ripio Credit Network',
    symbol: 'rcn',
    validator: ETHValidator
}, {
    name: 'Augur',
    symbol: 'rep',
    validator: ETHValidator
}, {
    name: 'iExec RLC',
    symbol: 'rlc',
    validator: ETHValidator
}, {
    name: 'Salt',
    symbol: 'salt',
    validator: ETHValidator
}, {
    name: 'Status',
    symbol: 'snt',
    validator: ETHValidator
}, {
    name: 'Storj',
    symbol: 'storj',
    validator: ETHValidator
}, {
    name: 'Swarm City',
    symbol: 'swt',
    validator: ETHValidator
}, {
    name: 'TrueUSD',
    symbol: 'tusd',
    validator: ETHValidator
}, {
    name: 'Wings',
    symbol: 'wings',
    validator: ETHValidator
}, {
    name: '0x',
    symbol: 'zrx',
    validator: ETHValidator
}, {
    name: 'Expanse',
    symbol: 'exp',
    validator: ETHValidator
}, {
    name: 'Viberate',
    symbol: 'vib',
    validator: ETHValidator
}, {
    name: 'Odyssey',
    symbol: 'ocn',
    validator: ETHValidator
}, {
    name: 'Polymath',
    symbol: 'poly',
    validator: ETHValidator
}, {
    name: 'Storm',
    symbol: 'storm',
    validator: ETHValidator
}, {
    name: 'Nano',
    symbol: 'nano',
    validator: NANOValidator
}, {
    name: 'RaiBlocks',
    symbol: 'xrb',
    validator: NANOValidator
}, {
    name: 'Siacoin',
    symbol: 'sc',
    validator: SCValidator
}, {
    name: 'HyperSpace',
    symbol: 'xsc',
    validator: SCValidator
}, {
    name: 'loki',
    symbol: 'loki',
    addressTypes: { prod: ['114', '116'], testnet: [] },
    iAddressTypes: { prod: ['115'], testnet: [] },
    validator: XMRValidator
}, {
    name: 'LBRY Credits',
    symbol: 'lbc',
    addressTypes: { prod: ['55'], testnet: [] },
    validator: BTCValidator
}, {
    name: 'Tron',
    symbol: 'trx',
    addressTypes: { prod: [0x41], testnet: [0xa0] },
    validator: TRXValidator
}, {
    name: 'Nem',
    symbol: 'xem',
    validator: NEMValidator
}, {
    name: 'Lisk',
    symbol: 'lsk',
    validator: LSKValidator
}, {
    name: 'Stellar',
    symbol: 'xlm',
    validator: XLMValidator
}, {
    name: 'BTU Protocol',
    symbol: 'btu',
    validator: ETHValidator
}, {
    name: 'Crypto.com Coin',
    symbol: 'cro',
    validator: ETHValidator
}, {
    name: 'Multi-collateral DAI',
    symbol: 'dai',
    validator: ETHValidator
}, {
    name: 'Enjin Coin',
    symbol: 'enj',
    validator: ETHValidator
}, {
    name: 'HedgeTrade',
    symbol: 'hedg',
    validator: ETHValidator
}, {
    name: 'Cred',
    symbol: 'lba',
    validator: ETHValidator
}, {
    name: 'Chainlink',
    symbol: 'link',
    validator: ETHValidator
}, {
    name: 'Loom Network',
    symbol: 'loom',
    validator: ETHValidator
}, {
    name: 'Maker',
    symbol: 'mkr',
    validator: ETHValidator
}, {
    name: 'Metal',
    symbol: 'mtl',
    validator: ETHValidator
}, {
    name: 'Ocean Protocol',
    symbol: 'ocean',
    validator: ETHValidator
}, {
    name: 'Quant',
    symbol: 'qnt',
    validator: ETHValidator
}, {
    name: 'Synthetix Network',
    symbol: 'snx',
    validator: ETHValidator
}, {
    name: 'SOLVE',
    symbol: 'solve',
    validator: ETHValidator
}, {
    name: 'Spendcoin',
    symbol: 'spnd',
    validator: ETHValidator
}, {
    name: 'TEMCO',
    symbol: 'temco',
    validator: ETHValidator
}];

module.exports = {
    getByNameOrSymbol: function getByNameOrSymbol(currencyNameOrSymbol) {
        var nameOrSymbol = currencyNameOrSymbol.toLowerCase();
        return CURRENCIES.find(function (currency) {
            return currency.name.toLowerCase() === nameOrSymbol || currency.symbol.toLowerCase() === nameOrSymbol;
        });
    },
    getAll: function getAll() {
        return CURRENCIES;
    }
};

//spit out details for readme.md
// CURRENCIES
//     .sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
//     .forEach(c => console.log(`* ${c.name}/${c.symbol} \`'${c.name}'\` or \`'${c.symbol}'\` `));

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

var cryptoUtils = __webpack_require__(69);
var baseX = __webpack_require__(371);

var ALLOWED_CHARS = 'rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz';

var codec = baseX(ALLOWED_CHARS);
var regexp = new RegExp('^r[' + ALLOWED_CHARS + ']{27,35}$');

module.exports = {
    /**
     * ripple address validation
     */
    isValidAddress: function isValidAddress(address) {
        if (regexp.test(address)) {
            return this.verifyChecksum(address);
        }

        return false;
    },

    verifyChecksum: function verifyChecksum(address) {
        var bytes = codec.decode(address);
        var computedChecksum = cryptoUtils.sha256Checksum(cryptoUtils.toHex(bytes.slice(0, -4)));
        var checksum = cryptoUtils.toHex(bytes.slice(-4));

        return computedChecksum === checksum;
    }
};

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/*
 A JavaScript implementation of the SHA family of hashes, as
 defined in FIPS PUB 180-4 and FIPS PUB 202, as well as the corresponding
 HMAC implementation as defined in FIPS PUB 198a

 Copyright Brian Turek 2008-2017
 Distributed under the BSD License
 See http://caligatio.github.com/jsSHA/ for more information

 Several functions taken from Paul Johnston
*/


(function (I) {
  function w(c, a, d) {
    var l = 0,
        b = [],
        g = 0,
        f,
        n,
        k,
        e,
        h,
        q,
        y,
        p,
        m = !1,
        t = [],
        r = [],
        u,
        z = !1;d = d || {};f = d.encoding || "UTF8";u = d.numRounds || 1;if (u !== parseInt(u, 10) || 1 > u) throw Error("numRounds must a integer >= 1");if (0 === c.lastIndexOf("SHA-", 0)) {
      if (q = function q(b, a) {
        return A(b, a, c);
      }, y = function y(b, a, l, f) {
        var g, e;if ("SHA-224" === c || "SHA-256" === c) g = (a + 65 >>> 9 << 4) + 15, e = 16;else throw Error("Unexpected error in SHA-2 implementation");for (; b.length <= g;) {
          b.push(0);
        }b[a >>> 5] |= 128 << 24 - a % 32;a = a + l;b[g] = a & 4294967295;
        b[g - 1] = a / 4294967296 | 0;l = b.length;for (a = 0; a < l; a += e) {
          f = A(b.slice(a, a + e), f, c);
        }if ("SHA-224" === c) b = [f[0], f[1], f[2], f[3], f[4], f[5], f[6]];else if ("SHA-256" === c) b = f;else throw Error("Unexpected error in SHA-2 implementation");return b;
      }, p = function p(b) {
        return b.slice();
      }, "SHA-224" === c) h = 512, e = 224;else if ("SHA-256" === c) h = 512, e = 256;else throw Error("Chosen SHA variant is not supported");
    } else throw Error("Chosen SHA variant is not supported");k = B(a, f);n = x(c);this.setHMACKey = function (b, a, g) {
      var e;if (!0 === m) throw Error("HMAC key already set");
      if (!0 === z) throw Error("Cannot set HMAC key after calling update");f = (g || {}).encoding || "UTF8";a = B(a, f)(b);b = a.binLen;a = a.value;e = h >>> 3;g = e / 4 - 1;if (e < b / 8) {
        for (a = y(a, b, 0, x(c)); a.length <= g;) {
          a.push(0);
        }a[g] &= 4294967040;
      } else if (e > b / 8) {
        for (; a.length <= g;) {
          a.push(0);
        }a[g] &= 4294967040;
      }for (b = 0; b <= g; b += 1) {
        t[b] = a[b] ^ 909522486, r[b] = a[b] ^ 1549556828;
      }n = q(t, n);l = h;m = !0;
    };this.update = function (a) {
      var c,
          f,
          e,
          d = 0,
          p = h >>> 5;c = k(a, b, g);a = c.binLen;f = c.value;c = a >>> 5;for (e = 0; e < c; e += p) {
        d + h <= a && (n = q(f.slice(e, e + p), n), d += h);
      }l += d;b = f.slice(d >>> 5);g = a % h;z = !0;
    };this.getHash = function (a, f) {
      var d, h, k, q;if (!0 === m) throw Error("Cannot call getHash after setting HMAC key");k = C(f);switch (a) {case "HEX":
          d = function d(a) {
            return D(a, e, k);
          };break;case "B64":
          d = function d(a) {
            return E(a, e, k);
          };break;case "BYTES":
          d = function d(a) {
            return F(a, e);
          };break;case "ARRAYBUFFER":
          try {
            h = new ArrayBuffer(0);
          } catch (v) {
            throw Error("ARRAYBUFFER not supported by this environment");
          }d = function d(a) {
            return G(a, e);
          };break;default:
          throw Error("format must be HEX, B64, BYTES, or ARRAYBUFFER");
      }q = y(b.slice(), g, l, p(n));for (h = 1; h < u; h += 1) {
        q = y(q, e, 0, x(c));
      }return d(q);
    };this.getHMAC = function (a, f) {
      var d, k, t, u;if (!1 === m) throw Error("Cannot call getHMAC without first setting HMAC key");t = C(f);switch (a) {case "HEX":
          d = function d(a) {
            return D(a, e, t);
          };break;case "B64":
          d = function d(a) {
            return E(a, e, t);
          };break;case "BYTES":
          d = function d(a) {
            return F(a, e);
          };break;case "ARRAYBUFFER":
          try {
            d = new ArrayBuffer(0);
          } catch (v) {
            throw Error("ARRAYBUFFER not supported by this environment");
          }d = function d(a) {
            return G(a, e);
          };break;default:
          throw Error("outputFormat must be HEX, B64, BYTES, or ARRAYBUFFER");
      }k = y(b.slice(), g, l, p(n));u = q(r, x(c));u = y(k, e, h, u);return d(u);
    };
  }function m() {}function D(c, a, d) {
    var l = "";a /= 8;var b, g;for (b = 0; b < a; b += 1) {
      g = c[b >>> 2] >>> 8 * (3 + b % 4 * -1), l += "0123456789abcdef".charAt(g >>> 4 & 15) + "0123456789abcdef".charAt(g & 15);
    }return d.outputUpper ? l.toUpperCase() : l;
  }function E(c, a, d) {
    var l = "",
        b = a / 8,
        g,
        f,
        n;for (g = 0; g < b; g += 3) {
      for (f = g + 1 < b ? c[g + 1 >>> 2] : 0, n = g + 2 < b ? c[g + 2 >>> 2] : 0, n = (c[g >>> 2] >>> 8 * (3 + g % 4 * -1) & 255) << 16 | (f >>> 8 * (3 + (g + 1) % 4 * -1) & 255) << 8 | n >>> 8 * (3 + (g + 2) % 4 * -1) & 255, f = 0; 4 > f; f += 1) {
        8 * g + 6 * f <= a ? l += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(n >>> 6 * (3 - f) & 63) : l += d.b64Pad;
      }
    }return l;
  }function F(c, a) {
    var d = "",
        l = a / 8,
        b,
        g;for (b = 0; b < l; b += 1) {
      g = c[b >>> 2] >>> 8 * (3 + b % 4 * -1) & 255, d += String.fromCharCode(g);
    }return d;
  }function G(c, a) {
    var d = a / 8,
        l,
        b = new ArrayBuffer(d),
        g;g = new Uint8Array(b);for (l = 0; l < d; l += 1) {
      g[l] = c[l >>> 2] >>> 8 * (3 + l % 4 * -1) & 255;
    }return b;
  }function C(c) {
    var a = { outputUpper: !1, b64Pad: "=", shakeLen: -1 };c = c || {};a.outputUpper = c.outputUpper || !1;!0 === c.hasOwnProperty("b64Pad") && (a.b64Pad = c.b64Pad);if ("boolean" !== typeof a.outputUpper) throw Error("Invalid outputUpper formatting option");
    if ("string" !== typeof a.b64Pad) throw Error("Invalid b64Pad formatting option");return a;
  }function B(c, a) {
    var d;switch (a) {case "UTF8":case "UTF16BE":case "UTF16LE":
        break;default:
        throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");}switch (c) {case "HEX":
        d = function d(a, b, c) {
          var f = a.length,
              d,
              k,
              e,
              h,
              q;if (0 !== f % 2) throw Error("String of HEX type must be in byte increments");b = b || [0];c = c || 0;q = c >>> 3;for (d = 0; d < f; d += 2) {
            k = parseInt(a.substr(d, 2), 16);if (isNaN(k)) throw Error("String of HEX type contains invalid characters");
            h = (d >>> 1) + q;for (e = h >>> 2; b.length <= e;) {
              b.push(0);
            }b[e] |= k << 8 * (3 + h % 4 * -1);
          }return { value: b, binLen: 4 * f + c };
        };break;case "TEXT":
        d = function d(c, b, _d) {
          var f,
              n,
              k = 0,
              e,
              h,
              q,
              m,
              p,
              r;b = b || [0];_d = _d || 0;q = _d >>> 3;if ("UTF8" === a) for (r = 3, e = 0; e < c.length; e += 1) {
            for (f = c.charCodeAt(e), n = [], 128 > f ? n.push(f) : 2048 > f ? (n.push(192 | f >>> 6), n.push(128 | f & 63)) : 55296 > f || 57344 <= f ? n.push(224 | f >>> 12, 128 | f >>> 6 & 63, 128 | f & 63) : (e += 1, f = 65536 + ((f & 1023) << 10 | c.charCodeAt(e) & 1023), n.push(240 | f >>> 18, 128 | f >>> 12 & 63, 128 | f >>> 6 & 63, 128 | f & 63)), h = 0; h < n.length; h += 1) {
              p = k + q;for (m = p >>> 2; b.length <= m;) {
                b.push(0);
              }b[m] |= n[h] << 8 * (r + p % 4 * -1);k += 1;
            }
          } else if ("UTF16BE" === a || "UTF16LE" === a) for (r = 2, n = "UTF16LE" === a && !0 || "UTF16LE" !== a && !1, e = 0; e < c.length; e += 1) {
            f = c.charCodeAt(e);!0 === n && (h = f & 255, f = h << 8 | f >>> 8);p = k + q;for (m = p >>> 2; b.length <= m;) {
              b.push(0);
            }b[m] |= f << 8 * (r + p % 4 * -1);k += 2;
          }return { value: b, binLen: 8 * k + _d };
        };break;case "B64":
        d = function d(a, b, c) {
          var f = 0,
              d,
              k,
              e,
              h,
              q,
              m,
              p;if (-1 === a.search(/^[a-zA-Z0-9=+\/]+$/)) throw Error("Invalid character in base-64 string");k = a.indexOf("=");a = a.replace(/\=/g, "");if (-1 !== k && k < a.length) throw Error("Invalid '=' found in base-64 string");b = b || [0];c = c || 0;m = c >>> 3;for (k = 0; k < a.length; k += 4) {
            q = a.substr(k, 4);for (e = h = 0; e < q.length; e += 1) {
              d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(q[e]), h |= d << 18 - 6 * e;
            }for (e = 0; e < q.length - 1; e += 1) {
              p = f + m;for (d = p >>> 2; b.length <= d;) {
                b.push(0);
              }b[d] |= (h >>> 16 - 8 * e & 255) << 8 * (3 + p % 4 * -1);f += 1;
            }
          }return { value: b, binLen: 8 * f + c };
        };break;case "BYTES":
        d = function d(a, b, c) {
          var d, n, k, e, h;b = b || [0];c = c || 0;k = c >>> 3;for (n = 0; n < a.length; n += 1) {
            d = a.charCodeAt(n), h = n + k, e = h >>> 2, b.length <= e && b.push(0), b[e] |= d << 8 * (3 + h % 4 * -1);
          }return { value: b, binLen: 8 * a.length + c };
        };break;case "ARRAYBUFFER":
        try {
          d = new ArrayBuffer(0);
        } catch (l) {
          throw Error("ARRAYBUFFER not supported by this environment");
        }d = function d(a, b, c) {
          var d, n, k, e, h;b = b || [0];c = c || 0;n = c >>> 3;h = new Uint8Array(a);for (d = 0; d < a.byteLength; d += 1) {
            e = d + n, k = e >>> 2, b.length <= k && b.push(0), b[k] |= h[d] << 8 * (3 + e % 4 * -1);
          }return { value: b, binLen: 8 * a.byteLength + c };
        };break;default:
        throw Error("format must be HEX, TEXT, B64, BYTES, or ARRAYBUFFER");
    }return d;
  }function r(c, a) {
    return c >>> a | c << 32 - a;
  }function J(c, a, d) {
    return c & a ^ ~c & d;
  }function K(c, a, d) {
    return c & a ^ c & d ^ a & d;
  }function L(c) {
    return r(c, 2) ^ r(c, 13) ^ r(c, 22);
  }function M(c) {
    return r(c, 6) ^ r(c, 11) ^ r(c, 25);
  }function N(c) {
    return r(c, 7) ^ r(c, 18) ^ c >>> 3;
  }function O(c) {
    return r(c, 17) ^ r(c, 19) ^ c >>> 10;
  }function P(c, a) {
    var d = (c & 65535) + (a & 65535);return ((c >>> 16) + (a >>> 16) + (d >>> 16) & 65535) << 16 | d & 65535;
  }function Q(c, a, d, l) {
    var b = (c & 65535) + (a & 65535) + (d & 65535) + (l & 65535);return ((c >>> 16) + (a >>> 16) + (d >>> 16) + (l >>> 16) + (b >>> 16) & 65535) << 16 | b & 65535;
  }function R(c, a, d, l, b) {
    var g = (c & 65535) + (a & 65535) + (d & 65535) + (l & 65535) + (b & 65535);return ((c >>> 16) + (a >>> 16) + (d >>> 16) + (l >>> 16) + (b >>> 16) + (g >>> 16) & 65535) << 16 | g & 65535;
  }function x(c) {
    var a = [],
        d;if (0 === c.lastIndexOf("SHA-", 0)) switch (a = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428], d = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], c) {case "SHA-224":
        break;case "SHA-256":
        a = d;break;case "SHA-384":
        a = [new m(), new m(), new m(), new m(), new m(), new m(), new m(), new m()];break;case "SHA-512":
        a = [new m(), new m(), new m(), new m(), new m(), new m(), new m(), new m()];break;default:
        throw Error("Unknown SHA variant");} else throw Error("No SHA variants supported");return a;
  }function A(c, a, d) {
    var l,
        b,
        g,
        f,
        n,
        k,
        e,
        h,
        m,
        r,
        p,
        w,
        t,
        x,
        u,
        z,
        A,
        B,
        C,
        D,
        E,
        F,
        v = [],
        G;if ("SHA-224" === d || "SHA-256" === d) r = 64, w = 1, F = Number, t = P, x = Q, u = R, z = N, A = O, B = L, C = M, E = K, D = J, G = H;else throw Error("Unexpected error in SHA-2 implementation");d = a[0];l = a[1];b = a[2];g = a[3];f = a[4];n = a[5];k = a[6];e = a[7];for (p = 0; p < r; p += 1) {
      16 > p ? (m = p * w, h = c.length <= m ? 0 : c[m], m = c.length <= m + 1 ? 0 : c[m + 1], v[p] = new F(h, m)) : v[p] = x(A(v[p - 2]), v[p - 7], z(v[p - 15]), v[p - 16]), h = u(e, C(f), D(f, n, k), G[p], v[p]), m = t(B(d), E(d, l, b)), e = k, k = n, n = f, f = t(g, h), g = b, b = l, l = d, d = t(h, m);
    }a[0] = t(d, a[0]);a[1] = t(l, a[1]);a[2] = t(b, a[2]);a[3] = t(g, a[3]);a[4] = t(f, a[4]);a[5] = t(n, a[5]);a[6] = t(k, a[6]);a[7] = t(e, a[7]);return a;
  }var H;H = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]; true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return w;
  }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "undefined" !== typeof exports ? ("undefined" !== typeof module && module.exports && (module.exports = w), exports = w) : I.jsSHA = w;
})(this);

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

/**
 * Credits to https://github.com/cryptocoinjs/blake-hash
 */

Blake256.sigma = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3], [11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4], [7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8], [9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13], [2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9], [12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11], [13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10], [6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5], [10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0], [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3], [11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4], [7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8], [9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13], [2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9]];

Blake256.u256 = [0x243f6a88, 0x85a308d3, 0x13198a2e, 0x03707344, 0xa4093822, 0x299f31d0, 0x082efa98, 0xec4e6c89, 0x452821e6, 0x38d01377, 0xbe5466cf, 0x34e90c6c, 0xc0ac29b7, 0xc97c50dd, 0x3f84d5b5, 0xb5470917];

Blake256.padding = new Buffer([0x80, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

Blake256.prototype._length_carry = function (arr) {
    for (var j = 0; j < arr.length; ++j) {
        if (arr[j] < 0x0100000000) break;
        arr[j] -= 0x0100000000;
        arr[j + 1] += 1;
    }
};

Blake256.prototype.update = function (data, encoding) {
    data = new Buffer(data, encoding);
    var block = this._block;
    var offset = 0;

    while (this._blockOffset + data.length - offset >= block.length) {
        for (var i = this._blockOffset; i < block.length;) {
            block[i++] = data[offset++];
        }this._length[0] += block.length * 8;
        this._length_carry(this._length);

        this._compress();
        this._blockOffset = 0;
    }

    while (offset < data.length) {
        block[this._blockOffset++] = data[offset++];
    }return this;
};

var zo = new Buffer([0x01]);
var oo = new Buffer([0x81]);

function rot(x, n) {
    return (x << 32 - n | x >>> n) >>> 0;
}

function g(v, m, i, a, b, c, d, e) {
    var sigma = Blake256.sigma;
    var u256 = Blake256.u256;

    v[a] = v[a] + ((m[sigma[i][e]] ^ u256[sigma[i][e + 1]]) >>> 0) + v[b] >>> 0;
    v[d] = rot(v[d] ^ v[a], 16);
    v[c] = v[c] + v[d] >>> 0;
    v[b] = rot(v[b] ^ v[c], 12);
    v[a] = v[a] + ((m[sigma[i][e + 1]] ^ u256[sigma[i][e]]) >>> 0) + v[b] >>> 0;
    v[d] = rot(v[d] ^ v[a], 8);
    v[c] = v[c] + v[d] >>> 0;
    v[b] = rot(v[b] ^ v[c], 7);
}

function Blake256() {
    this._h = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];

    this._s = [0, 0, 0, 0];

    this._block = new Buffer(64);
    this._blockOffset = 0;
    this._length = [0, 0];

    this._nullt = false;

    this._zo = zo;
    this._oo = oo;
}

Blake256.prototype._compress = function () {
    var u256 = Blake256.u256;
    var v = new Array(16);
    var m = new Array(16);
    var i;

    for (i = 0; i < 16; ++i) {
        m[i] = this._block.readUInt32BE(i * 4);
    }for (i = 0; i < 8; ++i) {
        v[i] = this._h[i] >>> 0;
    }for (i = 8; i < 12; ++i) {
        v[i] = (this._s[i - 8] ^ u256[i - 8]) >>> 0;
    }for (i = 12; i < 16; ++i) {
        v[i] = u256[i - 8];
    }if (!this._nullt) {
        v[12] = (v[12] ^ this._length[0]) >>> 0;
        v[13] = (v[13] ^ this._length[0]) >>> 0;
        v[14] = (v[14] ^ this._length[1]) >>> 0;
        v[15] = (v[15] ^ this._length[1]) >>> 0;
    }

    for (i = 0; i < 14; ++i) {
        /* column step */
        g(v, m, i, 0, 4, 8, 12, 0);
        g(v, m, i, 1, 5, 9, 13, 2);
        g(v, m, i, 2, 6, 10, 14, 4);
        g(v, m, i, 3, 7, 11, 15, 6);
        /* diagonal step */
        g(v, m, i, 0, 5, 10, 15, 8);
        g(v, m, i, 1, 6, 11, 12, 10);
        g(v, m, i, 2, 7, 8, 13, 12);
        g(v, m, i, 3, 4, 9, 14, 14);
    }

    for (i = 0; i < 16; ++i) {
        this._h[i % 8] = (this._h[i % 8] ^ v[i]) >>> 0;
    }for (i = 0; i < 8; ++i) {
        this._h[i] = (this._h[i] ^ this._s[i % 4]) >>> 0;
    }
};

Blake256.prototype._padding = function () {
    var lo = this._length[0] + this._blockOffset * 8;
    var hi = this._length[1];
    if (lo >= 0x0100000000) {
        lo -= 0x0100000000;
        hi += 1;
    }

    var msglen = new Buffer(8);
    msglen.writeUInt32BE(hi, 0);
    msglen.writeUInt32BE(lo, 4);

    if (this._blockOffset === 55) {
        this._length[0] -= 8;
        this.update(this._oo);
    } else {
        if (this._blockOffset < 55) {
            if (this._blockOffset === 0) this._nullt = true;
            this._length[0] -= (55 - this._blockOffset) * 8;
            this.update(Blake256.padding.slice(0, 55 - this._blockOffset));
        } else {
            this._length[0] -= (64 - this._blockOffset) * 8;
            this.update(Blake256.padding.slice(0, 64 - this._blockOffset));
            this._length[0] -= 55 * 8;
            this.update(Blake256.padding.slice(1, 1 + 55));
            this._nullt = true;
        }

        this.update(this._zo);
        this._length[0] -= 8;
    }

    this._length[0] -= 64;
    this.update(msglen);
};

Blake256.prototype.digest = function (encoding) {
    this._padding();

    var buffer = new Buffer(32);
    for (var i = 0; i < 8; ++i) {
        buffer.writeUInt32BE(this._h[i], i * 4);
    }return buffer.toString(encoding);
};

module.exports = Blake256;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).Buffer))

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.7.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2017
 * @license MIT
 */
/*jslint bitwise: true */


var _typeof4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof3 = typeof Symbol === "function" && _typeof4(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof4(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof4(obj);
};

var _typeof2 = typeof Symbol === "function" && _typeof3(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof3(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof3(obj);
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var ERROR = 'input is invalid type';
var WINDOW = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object';
var root = WINDOW ? window : {};
if (root.JS_SHA3_NO_WINDOW) {
    WINDOW = false;
}
var WEB_WORKER = !WINDOW && (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object';
var NODE_JS = !root.JS_SHA3_NO_NODE_JS && (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process.versions && process.versions.node;
if (NODE_JS) {
    root = global;
} else if (WEB_WORKER) {
    root = self;
}
var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
var HEX_CHARS = '0123456789abcdef'.split('');
var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
var KECCAK_PADDING = [1, 256, 65536, 16777216];
var PADDING = [6, 1536, 393216, 100663296];
var SHIFT = [0, 8, 16, 24];
var RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
var BITS = [224, 256, 384, 512];
var SHAKE_BITS = [128, 256];
var OUTPUT_TYPES = ['hex', 'buffer', 'arrayBuffer', 'array', 'digest'];
var CSHAKE_BYTEPAD = {
    '128': 168,
    '256': 136
};

if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
}

if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
        return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
}

var createOutputMethod = function createOutputMethod(bits, padding, outputType) {
    return function (message) {
        return new Keccak(bits, padding, bits).update(message)[outputType]();
    };
};

var createShakeOutputMethod = function createShakeOutputMethod(bits, padding, outputType) {
    return function (message, outputBits) {
        return new Keccak(bits, padding, outputBits).update(message)[outputType]();
    };
};

var createCshakeOutputMethod = function createCshakeOutputMethod(bits, padding, outputType) {
    return function (message, outputBits, n, s) {
        return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
    };
};

var createKmacOutputMethod = function createKmacOutputMethod(bits, padding, outputType) {
    return function (key, message, outputBits, s) {
        return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
    };
};

var createOutputMethods = function createOutputMethods(method, createMethod, bits, padding) {
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
        var type = OUTPUT_TYPES[i];
        method[type] = createMethod(bits, padding, type);
    }
    return method;
};

var createMethod = function createMethod(bits, padding) {
    var method = createOutputMethod(bits, padding, 'hex');
    method.create = function () {
        return new Keccak(bits, padding, bits);
    };
    method.update = function (message) {
        return method.create().update(message);
    };
    return createOutputMethods(method, createOutputMethod, bits, padding);
};

var createShakeMethod = function createShakeMethod(bits, padding) {
    var method = createShakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits) {
        return new Keccak(bits, padding, outputBits);
    };
    method.update = function (message, outputBits) {
        return method.create(outputBits).update(message);
    };
    return createOutputMethods(method, createShakeOutputMethod, bits, padding);
};

var createCshakeMethod = function createCshakeMethod(bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createCshakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits, n, s) {
        if (!n && !s) {
            return methods['shake' + bits].create(outputBits);
        } else {
            return new Keccak(bits, padding, outputBits).bytepad([n, s], w);
        }
    };
    method.update = function (message, outputBits, n, s) {
        return method.create(outputBits, n, s).update(message);
    };
    return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
};

var createKmacMethod = function createKmacMethod(bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createKmacOutputMethod(bits, padding, 'hex');
    method.create = function (key, outputBits, s) {
        return new Kmac(bits, padding, outputBits).bytepad(['KMAC', s], w).bytepad([key], w);
    };
    method.update = function (key, message, outputBits, s) {
        return method.create(key, outputBits, s).update(message);
    };
    return createOutputMethods(method, createKmacOutputMethod, bits, padding);
};

var algorithms = [{ name: 'keccak', padding: KECCAK_PADDING, bits: BITS, createMethod: createMethod }, { name: 'sha3', padding: PADDING, bits: BITS, createMethod: createMethod }, { name: 'shake', padding: SHAKE_PADDING, bits: SHAKE_BITS, createMethod: createShakeMethod }, { name: 'cshake', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createCshakeMethod }, { name: 'kmac', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createKmacMethod }];

var methods = {},
    methodNames = [];

for (var i = 0; i < algorithms.length; ++i) {
    var algorithm = algorithms[i];
    var bits = algorithm.bits;
    for (var j = 0; j < bits.length; ++j) {
        var methodName = algorithm.name + '_' + bits[j];
        methodNames.push(methodName);
        methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
        if (algorithm.name !== 'sha3') {
            var newMethodName = algorithm.name + bits[j];
            methodNames.push(newMethodName);
            methods[newMethodName] = methods[methodName];
        }
    }
}

function Keccak(bits, padding, outputBits) {
    this.blocks = [];
    this.s = [];
    this.padding = padding;
    this.outputBits = outputBits;
    this.reset = true;
    this.finalized = false;
    this.block = 0;
    this.start = 0;
    this.blockCount = 1600 - (bits << 1) >> 5;
    this.byteCount = this.blockCount << 2;
    this.outputBlocks = outputBits >> 5;
    this.extraBytes = (outputBits & 31) >> 3;

    for (var i = 0; i < 50; ++i) {
        this.s[i] = 0;
    }
}

Keccak.prototype.update = function (message) {
    if (this.finalized) {
        return;
    }
    var notString,
        type = typeof message === 'undefined' ? 'undefined' : _typeof(message);
    if (type !== 'string') {
        if (type === 'object') {
            if (message === null) {
                throw ERROR;
            } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
                message = new Uint8Array(message);
            } else if (!Array.isArray(message)) {
                if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
                    throw ERROR;
                }
            }
        } else {
            throw ERROR;
        }
        notString = true;
    }
    var blocks = this.blocks,
        byteCount = this.byteCount,
        length = message.length,
        blockCount = this.blockCount,
        index = 0,
        s = this.s,
        i,
        code;

    while (index < length) {
        if (this.reset) {
            this.reset = false;
            blocks[0] = this.block;
            for (i = 1; i < blockCount + 1; ++i) {
                blocks[i] = 0;
            }
        }
        if (notString) {
            for (i = this.start; index < length && i < byteCount; ++index) {
                blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            }
        } else {
            for (i = this.start; index < length && i < byteCount; ++index) {
                code = message.charCodeAt(index);
                if (code < 0x80) {
                    blocks[i >> 2] |= code << SHIFT[i++ & 3];
                } else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
        }
        this.lastByteIndex = i;
        if (i >= byteCount) {
            this.start = i - byteCount;
            this.block = blocks[blockCount];
            for (i = 0; i < blockCount; ++i) {
                s[i] ^= blocks[i];
            }
            f(s);
            this.reset = true;
        } else {
            this.start = i;
        }
    }
    return this;
};

Keccak.prototype.encode = function (x, right) {
    var o = x & 255,
        n = 1;
    var bytes = [o];
    x = x >> 8;
    o = x & 255;
    while (o > 0) {
        bytes.unshift(o);
        x = x >> 8;
        o = x & 255;
        ++n;
    }
    if (right) {
        bytes.push(n);
    } else {
        bytes.unshift(n);
    }
    this.update(bytes);
    return bytes.length;
};

Keccak.prototype.encodeString = function (str) {
    var notString,
        type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
    if (type !== 'string') {
        if (type === 'object') {
            if (str === null) {
                throw ERROR;
            } else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) {
                str = new Uint8Array(str);
            } else if (!Array.isArray(str)) {
                if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) {
                    throw ERROR;
                }
            }
        } else {
            throw ERROR;
        }
        notString = true;
    }
    var bytes = 0,
        length = str.length;
    if (notString) {
        bytes = length;
    } else {
        for (var i = 0; i < str.length; ++i) {
            var code = str.charCodeAt(i);
            if (code < 0x80) {
                bytes += 1;
            } else if (code < 0x800) {
                bytes += 2;
            } else if (code < 0xd800 || code >= 0xe000) {
                bytes += 3;
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
    }
    bytes += this.encode(bytes * 8);
    this.update(str);
    return bytes;
};

Keccak.prototype.bytepad = function (strs, w) {
    var bytes = this.encode(w);
    for (var i = 0; i < strs.length; ++i) {
        bytes += this.encodeString(strs[i]);
    }
    var paddingBytes = w - bytes % w;
    var zeros = [];
    zeros.length = paddingBytes;
    this.update(zeros);
    return this;
};

Keccak.prototype.finalize = function () {
    if (this.finalized) {
        return;
    }
    this.finalized = true;
    var blocks = this.blocks,
        i = this.lastByteIndex,
        blockCount = this.blockCount,
        s = this.s;
    blocks[i >> 2] |= this.padding[i & 3];
    if (this.lastByteIndex === this.byteCount) {
        blocks[0] = blocks[blockCount];
        for (i = 1; i < blockCount + 1; ++i) {
            blocks[i] = 0;
        }
    }
    blocks[blockCount - 1] |= 0x80000000;
    for (i = 0; i < blockCount; ++i) {
        s[i] ^= blocks[i];
    }
    f(s);
};

Keccak.prototype.toString = Keccak.prototype.hex = function () {
    this.finalize();

    var blockCount = this.blockCount,
        s = this.s,
        outputBlocks = this.outputBlocks,
        extraBytes = this.extraBytes,
        i = 0,
        j = 0;
    var hex = '',
        block;
    while (j < outputBlocks) {
        for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
        }
        if (j % blockCount === 0) {
            f(s);
            i = 0;
        }
    }
    if (extraBytes) {
        block = s[i];
        hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
        if (extraBytes > 1) {
            hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
        }
        if (extraBytes > 2) {
            hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
    }
    return hex;
};

Keccak.prototype.arrayBuffer = function () {
    this.finalize();

    var blockCount = this.blockCount,
        s = this.s,
        outputBlocks = this.outputBlocks,
        extraBytes = this.extraBytes,
        i = 0,
        j = 0;
    var bytes = this.outputBits >> 3;
    var buffer;
    if (extraBytes) {
        buffer = new ArrayBuffer(outputBlocks + 1 << 2);
    } else {
        buffer = new ArrayBuffer(bytes);
    }
    var array = new Uint32Array(buffer);
    while (j < outputBlocks) {
        for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
            array[j] = s[i];
        }
        if (j % blockCount === 0) {
            f(s);
        }
    }
    if (extraBytes) {
        array[i] = s[i];
        buffer = buffer.slice(0, bytes);
    }
    return buffer;
};

Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;

Keccak.prototype.digest = Keccak.prototype.array = function () {
    this.finalize();

    var blockCount = this.blockCount,
        s = this.s,
        outputBlocks = this.outputBlocks,
        extraBytes = this.extraBytes,
        i = 0,
        j = 0;
    var array = [],
        offset,
        block;
    while (j < outputBlocks) {
        for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            array[offset + 1] = block >> 8 & 0xFF;
            array[offset + 2] = block >> 16 & 0xFF;
            array[offset + 3] = block >> 24 & 0xFF;
        }
        if (j % blockCount === 0) {
            f(s);
        }
    }
    if (extraBytes) {
        offset = j << 2;
        block = s[i];
        array[offset] = block & 0xFF;
        if (extraBytes > 1) {
            array[offset + 1] = block >> 8 & 0xFF;
        }
        if (extraBytes > 2) {
            array[offset + 2] = block >> 16 & 0xFF;
        }
    }
    return array;
};

function Kmac(bits, padding, outputBits) {
    Keccak.call(this, bits, padding, outputBits);
}

Kmac.prototype = new Keccak();

Kmac.prototype.finalize = function () {
    this.encode(this.outputBits, true);
    return Keccak.prototype.finalize.call(this);
};

var f = function f(s) {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for (n = 0; n < 48; n += 2) {
        c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];

        h = c8 ^ (c2 << 1 | c3 >>> 31);
        l = c9 ^ (c3 << 1 | c2 >>> 31);
        s[0] ^= h;
        s[1] ^= l;
        s[10] ^= h;
        s[11] ^= l;
        s[20] ^= h;
        s[21] ^= l;
        s[30] ^= h;
        s[31] ^= l;
        s[40] ^= h;
        s[41] ^= l;
        h = c0 ^ (c4 << 1 | c5 >>> 31);
        l = c1 ^ (c5 << 1 | c4 >>> 31);
        s[2] ^= h;
        s[3] ^= l;
        s[12] ^= h;
        s[13] ^= l;
        s[22] ^= h;
        s[23] ^= l;
        s[32] ^= h;
        s[33] ^= l;
        s[42] ^= h;
        s[43] ^= l;
        h = c2 ^ (c6 << 1 | c7 >>> 31);
        l = c3 ^ (c7 << 1 | c6 >>> 31);
        s[4] ^= h;
        s[5] ^= l;
        s[14] ^= h;
        s[15] ^= l;
        s[24] ^= h;
        s[25] ^= l;
        s[34] ^= h;
        s[35] ^= l;
        s[44] ^= h;
        s[45] ^= l;
        h = c4 ^ (c8 << 1 | c9 >>> 31);
        l = c5 ^ (c9 << 1 | c8 >>> 31);
        s[6] ^= h;
        s[7] ^= l;
        s[16] ^= h;
        s[17] ^= l;
        s[26] ^= h;
        s[27] ^= l;
        s[36] ^= h;
        s[37] ^= l;
        s[46] ^= h;
        s[47] ^= l;
        h = c6 ^ (c0 << 1 | c1 >>> 31);
        l = c7 ^ (c1 << 1 | c0 >>> 31);
        s[8] ^= h;
        s[9] ^= l;
        s[18] ^= h;
        s[19] ^= l;
        s[28] ^= h;
        s[29] ^= l;
        s[38] ^= h;
        s[39] ^= l;
        s[48] ^= h;
        s[49] ^= l;

        b0 = s[0];
        b1 = s[1];
        b32 = s[11] << 4 | s[10] >>> 28;
        b33 = s[10] << 4 | s[11] >>> 28;
        b14 = s[20] << 3 | s[21] >>> 29;
        b15 = s[21] << 3 | s[20] >>> 29;
        b46 = s[31] << 9 | s[30] >>> 23;
        b47 = s[30] << 9 | s[31] >>> 23;
        b28 = s[40] << 18 | s[41] >>> 14;
        b29 = s[41] << 18 | s[40] >>> 14;
        b20 = s[2] << 1 | s[3] >>> 31;
        b21 = s[3] << 1 | s[2] >>> 31;
        b2 = s[13] << 12 | s[12] >>> 20;
        b3 = s[12] << 12 | s[13] >>> 20;
        b34 = s[22] << 10 | s[23] >>> 22;
        b35 = s[23] << 10 | s[22] >>> 22;
        b16 = s[33] << 13 | s[32] >>> 19;
        b17 = s[32] << 13 | s[33] >>> 19;
        b48 = s[42] << 2 | s[43] >>> 30;
        b49 = s[43] << 2 | s[42] >>> 30;
        b40 = s[5] << 30 | s[4] >>> 2;
        b41 = s[4] << 30 | s[5] >>> 2;
        b22 = s[14] << 6 | s[15] >>> 26;
        b23 = s[15] << 6 | s[14] >>> 26;
        b4 = s[25] << 11 | s[24] >>> 21;
        b5 = s[24] << 11 | s[25] >>> 21;
        b36 = s[34] << 15 | s[35] >>> 17;
        b37 = s[35] << 15 | s[34] >>> 17;
        b18 = s[45] << 29 | s[44] >>> 3;
        b19 = s[44] << 29 | s[45] >>> 3;
        b10 = s[6] << 28 | s[7] >>> 4;
        b11 = s[7] << 28 | s[6] >>> 4;
        b42 = s[17] << 23 | s[16] >>> 9;
        b43 = s[16] << 23 | s[17] >>> 9;
        b24 = s[26] << 25 | s[27] >>> 7;
        b25 = s[27] << 25 | s[26] >>> 7;
        b6 = s[36] << 21 | s[37] >>> 11;
        b7 = s[37] << 21 | s[36] >>> 11;
        b38 = s[47] << 24 | s[46] >>> 8;
        b39 = s[46] << 24 | s[47] >>> 8;
        b30 = s[8] << 27 | s[9] >>> 5;
        b31 = s[9] << 27 | s[8] >>> 5;
        b12 = s[18] << 20 | s[19] >>> 12;
        b13 = s[19] << 20 | s[18] >>> 12;
        b44 = s[29] << 7 | s[28] >>> 25;
        b45 = s[28] << 7 | s[29] >>> 25;
        b26 = s[38] << 8 | s[39] >>> 24;
        b27 = s[39] << 8 | s[38] >>> 24;
        b8 = s[48] << 14 | s[49] >>> 18;
        b9 = s[49] << 14 | s[48] >>> 18;

        s[0] = b0 ^ ~b2 & b4;
        s[1] = b1 ^ ~b3 & b5;
        s[10] = b10 ^ ~b12 & b14;
        s[11] = b11 ^ ~b13 & b15;
        s[20] = b20 ^ ~b22 & b24;
        s[21] = b21 ^ ~b23 & b25;
        s[30] = b30 ^ ~b32 & b34;
        s[31] = b31 ^ ~b33 & b35;
        s[40] = b40 ^ ~b42 & b44;
        s[41] = b41 ^ ~b43 & b45;
        s[2] = b2 ^ ~b4 & b6;
        s[3] = b3 ^ ~b5 & b7;
        s[12] = b12 ^ ~b14 & b16;
        s[13] = b13 ^ ~b15 & b17;
        s[22] = b22 ^ ~b24 & b26;
        s[23] = b23 ^ ~b25 & b27;
        s[32] = b32 ^ ~b34 & b36;
        s[33] = b33 ^ ~b35 & b37;
        s[42] = b42 ^ ~b44 & b46;
        s[43] = b43 ^ ~b45 & b47;
        s[4] = b4 ^ ~b6 & b8;
        s[5] = b5 ^ ~b7 & b9;
        s[14] = b14 ^ ~b16 & b18;
        s[15] = b15 ^ ~b17 & b19;
        s[24] = b24 ^ ~b26 & b28;
        s[25] = b25 ^ ~b27 & b29;
        s[34] = b34 ^ ~b36 & b38;
        s[35] = b35 ^ ~b37 & b39;
        s[44] = b44 ^ ~b46 & b48;
        s[45] = b45 ^ ~b47 & b49;
        s[6] = b6 ^ ~b8 & b0;
        s[7] = b7 ^ ~b9 & b1;
        s[16] = b16 ^ ~b18 & b10;
        s[17] = b17 ^ ~b19 & b11;
        s[26] = b26 ^ ~b28 & b20;
        s[27] = b27 ^ ~b29 & b21;
        s[36] = b36 ^ ~b38 & b30;
        s[37] = b37 ^ ~b39 & b31;
        s[46] = b46 ^ ~b48 & b40;
        s[47] = b47 ^ ~b49 & b41;
        s[8] = b8 ^ ~b0 & b2;
        s[9] = b9 ^ ~b1 & b3;
        s[18] = b18 ^ ~b10 & b12;
        s[19] = b19 ^ ~b11 & b13;
        s[28] = b28 ^ ~b20 & b22;
        s[29] = b29 ^ ~b21 & b23;
        s[38] = b38 ^ ~b30 & b32;
        s[39] = b39 ^ ~b31 & b33;
        s[48] = b48 ^ ~b40 & b42;
        s[49] = b49 ^ ~b41 & b43;

        s[0] ^= RC[n];
        s[1] ^= RC[n + 1];
    }
};

module.exports = methods;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(369), __webpack_require__(62)))

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Credits to https://github.com/emilbayes/blake2b
 *
 * Copyright (c) 2017, Emil Bay github@tixz.dk
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

// 64-bit unsigned addition
// Sets v[a,a+1] += v[b,b+1]
// v should be a Uint32Array

function ADD64AA(v, a, b) {
  var o0 = v[a] + v[b];
  var o1 = v[a + 1] + v[b + 1];
  if (o0 >= 0x100000000) {
    o1++;
  }
  v[a] = o0;
  v[a + 1] = o1;
}

// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function ADD64AC(v, a, b0, b1) {
  var o0 = v[a] + b0;
  if (b0 < 0) {
    o0 += 0x100000000;
  }
  var o1 = v[a + 1] + b1;
  if (o0 >= 0x100000000) {
    o1++;
  }
  v[a] = o0;
  v[a + 1] = o1;
}

// Little-endian byte access
function B2B_GET32(arr, i) {
  return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
}

// G Mixing function
// The ROTRs are inlined for speed
function B2B_G(a, b, c, d, ix, iy) {
  var x0 = m[ix];
  var x1 = m[ix + 1];
  var y0 = m[iy];
  var y1 = m[iy + 1];

  ADD64AA(v, a, b); // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
  ADD64AC(v, a, x0, x1); // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits

  // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
  var xor0 = v[d] ^ v[a];
  var xor1 = v[d + 1] ^ v[a + 1];
  v[d] = xor1;
  v[d + 1] = xor0;

  ADD64AA(v, c, d);

  // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
  xor0 = v[b] ^ v[c];
  xor1 = v[b + 1] ^ v[c + 1];
  v[b] = xor0 >>> 24 ^ xor1 << 8;
  v[b + 1] = xor1 >>> 24 ^ xor0 << 8;

  ADD64AA(v, a, b);
  ADD64AC(v, a, y0, y1);

  // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
  xor0 = v[d] ^ v[a];
  xor1 = v[d + 1] ^ v[a + 1];
  v[d] = xor0 >>> 16 ^ xor1 << 16;
  v[d + 1] = xor1 >>> 16 ^ xor0 << 16;

  ADD64AA(v, c, d);

  // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
  xor0 = v[b] ^ v[c];
  xor1 = v[b + 1] ^ v[c + 1];
  v[b] = xor1 >>> 31 ^ xor0 << 1;
  v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
}

// Initialization Vector
var BLAKE2B_IV32 = new Uint32Array([0xF3BCC908, 0x6A09E667, 0x84CAA73B, 0xBB67AE85, 0xFE94F82B, 0x3C6EF372, 0x5F1D36F1, 0xA54FF53A, 0xADE682D1, 0x510E527F, 0x2B3E6C1F, 0x9B05688C, 0xFB41BD6B, 0x1F83D9AB, 0x137E2179, 0x5BE0CD19]);

var SIGMA8 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9, 12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11, 13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10, 6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5, 10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3];

// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
var SIGMA82 = new Uint8Array(SIGMA8.map(function (x) {
  return x * 2;
}));

// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
var v = new Uint32Array(32);
var m = new Uint32Array(32);
function blake2bCompress(ctx, last) {
  var i = 0;

  // init work variables
  for (i = 0; i < 16; i++) {
    v[i] = ctx.h[i];
    v[i + 16] = BLAKE2B_IV32[i];
  }

  // low 64 bits of offset
  v[24] = v[24] ^ ctx.t;
  v[25] = v[25] ^ ctx.t / 0x100000000;
  // high 64 bits not supported, offset may not be higher than 2**53-1

  // last block flag set ?
  if (last) {
    v[28] = ~v[28];
    v[29] = ~v[29];
  }

  // get little-endian words
  for (i = 0; i < 32; i++) {
    m[i] = B2B_GET32(ctx.b, 4 * i);
  }

  // twelve rounds of mixing
  for (i = 0; i < 12; i++) {
    B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
    B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
    B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
    B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
    B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
    B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
    B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
    B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
  }

  for (i = 0; i < 16; i++) {
    ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
  }
}

// reusable parameter_block
var parameter_block = new Uint8Array([0, 0, 0, 0, //  0: outlen, keylen, fanout, depth
0, 0, 0, 0, //  4: leaf length, sequential mode
0, 0, 0, 0, //  8: node offset
0, 0, 0, 0, // 12: node offset
0, 0, 0, 0, // 16: node depth, inner length, rfu
0, 0, 0, 0, // 20: rfu
0, 0, 0, 0, // 24: rfu
0, 0, 0, 0, // 28: rfu
0, 0, 0, 0, // 32: salt
0, 0, 0, 0, // 36: salt
0, 0, 0, 0, // 40: salt
0, 0, 0, 0, // 44: salt
0, 0, 0, 0, // 48: personal
0, 0, 0, 0, // 52: personal
0, 0, 0, 0, // 56: personal
0, 0, 0, 0 // 60: personal
]);

// Creates a BLAKE2b hashing context
// Requires an output length between 1 and 64 bytes
// Takes an optional Uint8Array key
function Blake2b(outlen, key, salt, personal) {
  // zero out parameter_block before usage
  parameter_block.fill(0);
  // state, 'param block'

  this.b = new Uint8Array(128);
  this.h = new Uint32Array(16);
  this.t = 0; // input count
  this.c = 0; // pointer within buffer
  this.outlen = outlen; // output length in bytes

  parameter_block[0] = outlen;
  if (key) parameter_block[1] = key.length;
  parameter_block[2] = 1; // fanout
  parameter_block[3] = 1; // depth

  if (salt) parameter_block.set(salt, 32);
  if (personal) parameter_block.set(personal, 48);

  // initialize hash state
  for (var i = 0; i < 16; i++) {
    this.h[i] = BLAKE2B_IV32[i] ^ B2B_GET32(parameter_block, i * 4);
  }

  // key the hash, if applicable
  if (key) {
    blake2bUpdate(this, key);
    // at the end
    this.c = 128;
  }
}

Blake2b.prototype.update = function (input) {
  blake2bUpdate(this, input);
  return this;
};

Blake2b.prototype.digest = function (out) {
  var buf = !out || out === 'binary' || out === 'hex' ? new Uint8Array(this.outlen) : out;
  blake2bFinal(this, buf);
  if (out === 'hex') return hexSlice(buf);
  return buf;
};

Blake2b.prototype.final = Blake2b.prototype.digest;

// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function blake2bUpdate(ctx, input) {
  for (var i = 0; i < input.length; i++) {
    if (ctx.c === 128) {
      // buffer full ?
      ctx.t += ctx.c; // add counters
      blake2bCompress(ctx, false); // compress (not last)
      ctx.c = 0; // counter to zero
    }
    ctx.b[ctx.c++] = input[i];
  }
}

// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function blake2bFinal(ctx, out) {
  ctx.t += ctx.c; // mark last block offset

  while (ctx.c < 128) {
    // fill up with zeros
    ctx.b[ctx.c++] = 0;
  }
  blake2bCompress(ctx, true); // final block flag = 1

  for (var i = 0; i < ctx.outlen; i++) {
    out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
  }
  return out;
}

function hexSlice(buf) {
  var str = '';
  for (var i = 0; i < buf.length; i++) {
    str += toHex(buf[i]);
  }return str;
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

module.exports = Blake2b;

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";

/**
* Encode a string to base32
*/
var b32encode = function b32encode(s) {
    var parts = [];
    var quanta = Math.floor(s.length / 5);
    var leftover = s.length % 5;

    if (leftover != 0) {
        for (var i = 0; i < 5 - leftover; i++) {
            s += '\x00';
        }
        quanta += 1;
    }

    for (var i = 0; i < quanta; i++) {
        parts.push(alphabet.charAt(s.charCodeAt(i * 5) >> 3));
        parts.push(alphabet.charAt((s.charCodeAt(i * 5) & 0x07) << 2 | s.charCodeAt(i * 5 + 1) >> 6));
        parts.push(alphabet.charAt((s.charCodeAt(i * 5 + 1) & 0x3F) >> 1));
        parts.push(alphabet.charAt((s.charCodeAt(i * 5 + 1) & 0x01) << 4 | s.charCodeAt(i * 5 + 2) >> 4));
        parts.push(alphabet.charAt((s.charCodeAt(i * 5 + 2) & 0x0F) << 1 | s.charCodeAt(i * 5 + 3) >> 7));
        parts.push(alphabet.charAt((s.charCodeAt(i * 5 + 3) & 0x7F) >> 2));
        parts.push(alphabet.charAt((s.charCodeAt(i * 5 + 3) & 0x03) << 3 | s.charCodeAt(i * 5 + 4) >> 5));
        parts.push(alphabet.charAt(s.charCodeAt(i * 5 + 4) & 0x1F));
    }

    var replace = 0;
    if (leftover == 1) replace = 6;else if (leftover == 2) replace = 4;else if (leftover == 3) replace = 3;else if (leftover == 4) replace = 1;

    for (var i = 0; i < replace; i++) {
        parts.pop();
    }for (var i = 0; i < replace; i++) {
        parts.push("=");
    }return parts.join("");
};

/**
* Decode a base32 string.
* This is made specifically for our use, deals only with proper strings
*/
var b32decode = function b32decode(s) {
    var r = new ArrayBuffer(s.length * 5 / 8);
    var b = new Uint8Array(r);
    for (var j = 0; j < s.length / 8; j++) {
        var v = [0, 0, 0, 0, 0, 0, 0, 0];
        for (var i = 0; i < 8; ++i) {
            v[i] = alphabet.indexOf(s[j * 8 + i]);
        }
        var i = 0;
        b[j * 5 + 0] = v[i + 0] << 3 | v[i + 1] >> 2;
        b[j * 5 + 1] = (v[i + 1] & 0x3) << 6 | v[i + 2] << 1 | v[i + 3] >> 4;
        b[j * 5 + 2] = (v[i + 3] & 0xf) << 4 | v[i + 4] >> 1;
        b[j * 5 + 3] = (v[i + 4] & 0x1) << 7 | v[i + 5] << 2 | v[i + 6] >> 3;
        b[j * 5 + 4] = (v[i + 6] & 0x7) << 5 | v[i + 7];
    }
    return b;
};

module.exports = {
    b32decode: b32decode,
    b32encode: b32encode
};

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* bignumber.js v1.3.0 https://github.com/MikeMcl/bignumber.js/LICENCE */

/*jslint bitwise: true, eqeq: true, plusplus: true, sub: true, white: true, maxerr: 500 */
/*global module */

/*
  bignumber.js v1.3.0
  A JavaScript library for arbitrary-precision arithmetic.
  https://github.com/MikeMcl/bignumber.js
  Copyright (c) 2012 Michael Mclaughlin <M8ch88l@gmail.com>
  MIT Expat Licence
*/

/*********************************** DEFAULTS ************************************/

/*
 * The default values below must be integers within the stated ranges (inclusive).
 * Most of these values can be changed during run-time using BigNumber.config().
 */

/*
 * The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP,
 * MAX_EXP, and the argument to toFixed, toPrecision and toExponential, beyond
 * which an exception is thrown (if ERRORS is true).
 */
var MAX = 1E9,                                   // 0 to 1e+9

    // Limit of magnitude of exponent argument to toPower.
    MAX_POWER = 1E6,                             // 1 to 1e+6

    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20,                         // 0 to MAX

    /*
     * The rounding mode used when rounding to the above decimal places, and when
     * using toFixed, toPrecision and toExponential, and round (default value).
     * UP         0 Away from zero.
     * DOWN       1 Towards zero.
     * CEIL       2 Towards +Infinity.
     * FLOOR      3 Towards -Infinity.
     * HALF_UP    4 Towards nearest neighbour. If equidistant, up.
     * HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
     * HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
     * HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
     * HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
     */
    ROUNDING_MODE = 4,                           // 0 to 8

    // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7,                             // 0 to -MAX

    // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21,                             // 0 to MAX

    // RANGE : [MIN_EXP, MAX_EXP]

    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -MAX,                              // -1 to -MAX

    // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    MAX_EXP = MAX,                               // 1 to MAX

    // Whether BigNumber Errors are ever thrown.
    // CHANGE parseInt to parseFloat if changing ERRORS to false.
    ERRORS = true,                               // true or false
    parse = parseInt,                            // parseInt or parseFloat

/***********************************************************************************/

    P = BigNumber.prototype,
    DIGITS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_',
    outOfRange,
    id = 0,
    isValid = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
    trim = String.prototype.trim || function () {return this.replace(/^\s+|\s+$/g, '')},
    ONE = BigNumber(1);


// CONSTRUCTOR


/*
 * The exported function.
 * Create and return a new instance of a BigNumber object.
 *
 * n {number|string|BigNumber} A numeric value.
 * [b] {number} The base of n. Integer, 2 to 64 inclusive.
 */
function BigNumber( n, b ) {
    var e, i, isNum, digits, valid, orig,
        x = this;

    // Enable constructor usage without new.
    if ( !(x instanceof BigNumber) ) {
        return new BigNumber( n, b )
    }

    // Duplicate.
    if ( n instanceof BigNumber ) {
        id = 0;

        // e is undefined.
        if ( b !== e ) {
            n += ''
        } else {
            x['s'] = n['s'];
            x['e'] = n['e'];
            x['c'] = ( n = n['c'] ) ? n.slice() : n;
            return;
        }
    }

    // If number, check if minus zero.
    if ( typeof n != 'string' ) {
        n = ( isNum = typeof n == 'number' ||
            Object.prototype.toString.call(n) == '[object Number]' ) &&
                n === 0 && 1 / n < 0 ? '-0' : n + '';
    }

    orig = n;

    if ( b === e && isValid.test(n) ) {

        // Determine sign.
        x['s'] = n.charAt(0) == '-' ? ( n = n.slice(1), -1 ) : 1;

    // Either n is not a valid BigNumber or a base has been specified.
    } else {

        // Enable exponential notation to be used with base 10 argument.
        // Ensure return value is rounded to DECIMAL_PLACES as with other bases.
        if ( b == 10 ) {

            return setMode( n, DECIMAL_PLACES, ROUNDING_MODE );
        }

        n = trim.call(n).replace( /^\+(?!-)/, '' );

        x['s'] = n.charAt(0) == '-' ? ( n = n.replace( /^-(?!-)/, '' ), -1 ) : 1;

        if ( b != null ) {

            if ( ( b == (b | 0) || !ERRORS ) &&
              !( outOfRange = !( b >= 2 && b < 65 ) ) ) {

                digits = '[' + DIGITS.slice( 0, b = b | 0 ) + ']+';

                // Before non-decimal number validity test and base conversion
                // remove the `.` from e.g. '1.', and replace e.g. '.1' with '0.1'.
                n = n.replace( /\.$/, '' ).replace( /^\./, '0.' );

                // Any number in exponential form will fail due to the e+/-.
                if ( valid = new RegExp(
                  '^' + digits + '(?:\\.' + digits + ')?$', b < 37 ? 'i' : '' ).test(n) ) {

                    if ( isNum ) {

                        if ( n.replace( /^0\.0*|\./, '' ).length > 15 ) {

                            // 'new BigNumber() number type has more than 15 significant digits: {n}'
                            ifExceptionsThrow( orig, 0 );
                        }

                        // Prevent later check for length on converted number.
                        isNum = !isNum;
                    }
                    n = convert( n, 10, b, x['s'] );

                } else if ( n != 'Infinity' && n != 'NaN' ) {

                    // 'new BigNumber() not a base {b} number: {n}'
                    ifExceptionsThrow( orig, 1, b );
                    n = 'NaN';
                }
            } else {

                // 'new BigNumber() base not an integer: {b}'
                // 'new BigNumber() base out of range: {b}'
                ifExceptionsThrow( b, 2 );

                // Ignore base.
                valid = isValid.test(n);
            }
        } else {
            valid = isValid.test(n);
        }

        if ( !valid ) {

            // Infinity/NaN
            x['c'] = x['e'] = null;

            // NaN
            if ( n != 'Infinity' ) {

                // No exception on NaN.
                if ( n != 'NaN' ) {

                    // 'new BigNumber() not a number: {n}'
                    ifExceptionsThrow( orig, 3 );
                }
                x['s'] = null;
            }
            id = 0;

            return;
        }
    }

    // Decimal point?
    if ( ( e = n.indexOf('.') ) > -1 ) {
        n = n.replace( '.', '' );
    }

    // Exponential form?
    if ( ( i = n.search( /e/i ) ) > 0 ) {

        // Determine exponent.
        if ( e < 0 ) {
            e = i;
        }
        e += +n.slice( i + 1 );
        n = n.substring( 0, i );

    } else if ( e < 0 ) {

        // Integer.
        e = n.length;
    }

    // Determine leading zeros.
    for ( i = 0; n.charAt(i) == '0'; i++ ) {
    }

    b = n.length;

    // Disallow numbers with over 15 significant digits if number type.
    if ( isNum && b > 15 && n.slice(i).length > 15 ) {

        // 'new BigNumber() number type has more than 15 significant digits: {n}'
        ifExceptionsThrow( orig, 0 );
    }
    id = 0;

    // Overflow?
    if ( ( e -= i + 1 ) > MAX_EXP ) {

        // Infinity.
        x['c'] = x['e'] = null;

    // Zero or underflow?
    } else if ( i == b || e < MIN_EXP ) {

        // Zero.
        x['c'] = [ x['e'] = 0 ];
    } else {

        // Determine trailing zeros.
        for ( ; n.charAt(--b) == '0'; ) {
        }

        x['e'] = e;
        x['c'] = [];

        // Convert string to array of digits (without leading and trailing zeros).
        for ( e = 0; i <= b; x['c'][e++] = +n.charAt(i++) ) {
        }
    }
}


// CONSTRUCTOR PROPERTIES/METHODS


BigNumber['ROUND_UP'] = 0;
BigNumber['ROUND_DOWN'] = 1;
BigNumber['ROUND_CEIL'] = 2;
BigNumber['ROUND_FLOOR'] = 3;
BigNumber['ROUND_HALF_UP'] = 4;
BigNumber['ROUND_HALF_DOWN'] = 5;
BigNumber['ROUND_HALF_EVEN'] = 6;
BigNumber['ROUND_HALF_CEIL'] = 7;
BigNumber['ROUND_HALF_FLOOR'] = 8;

/*
 * Create an instance from a Buffer
 */
BigNumber['fromBuffer'] = function (buf, opts) {

    if (!opts) opts = {};

    var endian = { 1 : 'big', '-1' : 'little' }[opts.endian]
        || opts.endian || 'big'
    ;

    var size = opts.size === 'auto' ? Math.ceil(buf.length) : (opts.size || 1);

    if (buf.length % size !== 0) {
        throw new RangeError('Buffer length (' + buf.length + ')'
            + ' must be a multiple of size (' + size + ')'
        );
    }

    var hex = [];
    for (var i = 0; i < buf.length; i += size) {
        var chunk = [];
        for (var j = 0; j < size; j++) {
            chunk.push(buf[
                i + (endian === 'big' ? j : (size - j - 1))
            ]);
        }

        hex.push(chunk
            .map(function (c) {
                return (c < 16 ? '0' : '') + c.toString(16);
            })
            .join('')
        );
    }

    return BigNumber(hex.join(''), 16);

};

/*
 * Configure infrequently-changing library-wide settings.
 *
 * Accept an object or an argument list, with one or many of the following
 * properties or parameters respectively:
 * [ DECIMAL_PLACES [, ROUNDING_MODE [, EXPONENTIAL_AT [, RANGE [, ERRORS ]]]]]
 *
 * E.g.
 * BigNumber.config(20, 4) is equivalent to
 * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
 * Ignore properties/parameters set to null or undefined.
 *
 * Return an object with the properties current values.
 */
BigNumber['config'] = function () {
    var v, p,
        i = 0,
        r = {},
        a = arguments,
        o = a[0],
        c = 'config',
        inRange = function ( n, lo, hi ) {
          return !( ( outOfRange = n < lo || n > hi ) ||
            parse(n) != n && n !== 0 );
        },
        has = o && typeof o == 'object'
          ? function () {if ( o.hasOwnProperty(p) ) return ( v = o[p] ) != null}
          : function () {if ( a.length > i ) return ( v = a[i++] ) != null};

    // [DECIMAL_PLACES] {number} Integer, 0 to MAX inclusive.
    if ( has( p = 'DECIMAL_PLACES' ) ) {

        if ( inRange( v, 0, MAX ) ) {
            DECIMAL_PLACES = v | 0;
        } else {

            // 'config() DECIMAL_PLACES not an integer: {v}'
            // 'config() DECIMAL_PLACES out of range: {v}'
            ifExceptionsThrow( v, p, c );
        }
    }
    r[p] = DECIMAL_PLACES;

    // [ROUNDING_MODE] {number} Integer, 0 to 8 inclusive.
    if ( has( p = 'ROUNDING_MODE' ) ) {

        if ( inRange( v, 0, 8 ) ) {
            ROUNDING_MODE = v | 0;
        } else {

            // 'config() ROUNDING_MODE not an integer: {v}'
            // 'config() ROUNDING_MODE out of range: {v}'
            ifExceptionsThrow( v, p, c );
        }
    }
    r[p] = ROUNDING_MODE;

    /*
     * [EXPONENTIAL_AT] {number|number[]} Integer, -MAX to MAX inclusive or
     * [ integer -MAX to 0 inclusive, 0 to MAX inclusive ].
     */
    if ( has( p = 'EXPONENTIAL_AT' ) ) {

        if ( inRange( v, -MAX, MAX ) ) {
            TO_EXP_NEG = -( TO_EXP_POS = ~~( v < 0 ? -v : +v ) );
        } else if ( !outOfRange && v && inRange( v[0], -MAX, 0 ) &&
          inRange( v[1], 0, MAX ) ) {
            TO_EXP_NEG = ~~v[0];
            TO_EXP_POS = ~~v[1];
        } else {

            // 'config() EXPONENTIAL_AT not an integer or not [integer, integer]: {v}'
            // 'config() EXPONENTIAL_AT out of range or not [negative, positive: {v}'
            ifExceptionsThrow( v, p, c, 1 );
        }
    }
    r[p] = [ TO_EXP_NEG, TO_EXP_POS ];

    /*
     * [RANGE][ {number|number[]} Non-zero integer, -MAX to MAX inclusive or
     * [ integer -MAX to -1 inclusive, integer 1 to MAX inclusive ].
     */
    if ( has( p = 'RANGE' ) ) {

        if ( inRange( v, -MAX, MAX ) && ~~v ) {
            MIN_EXP = -( MAX_EXP = ~~( v < 0 ? -v : +v ) );
        } else if ( !outOfRange && v && inRange( v[0], -MAX, -1 ) &&
          inRange( v[1], 1, MAX ) ) {
            MIN_EXP = ~~v[0], MAX_EXP = ~~v[1];
        } else {

            // 'config() RANGE not a non-zero integer or not [integer, integer]: {v}'
            // 'config() RANGE out of range or not [negative, positive: {v}'
            ifExceptionsThrow( v, p, c, 1, 1 );
        }
    }
    r[p] = [ MIN_EXP, MAX_EXP ];

    // [ERRORS] {boolean|number} true, false, 1 or 0.
    if ( has( p = 'ERRORS' ) ) {

        if ( v === !!v || v === 1 || v === 0 ) {
            parse = ( outOfRange = id = 0, ERRORS = !!v )
              ? parseInt
              : parseFloat;
        } else {

            // 'config() ERRORS not a boolean or binary digit: {v}'
            ifExceptionsThrow( v, p, c, 0, 0, 1 );
        }
    }
    r[p] = ERRORS;

    return r;
};


// PRIVATE FUNCTIONS


// Assemble error messages. Throw BigNumber Errors.
function ifExceptionsThrow( arg, i, j, isArray, isRange, isErrors) {

    if ( ERRORS ) {
        var error,
            method = ['new BigNumber', 'cmp', 'div', 'eq', 'gt', 'gte', 'lt',
                 'lte', 'minus', 'mod', 'plus', 'times', 'toFr'
                ][ id ? id < 0 ? -id : id : 1 / id < 0 ? 1 : 0 ] + '()',
            message = outOfRange ? ' out of range' : ' not a' +
              ( isRange ? ' non-zero' : 'n' ) + ' integer';

        message = ( [
            method + ' number type has more than 15 significant digits',
            method + ' not a base ' + j + ' number',
            method + ' base' + message,
            method + ' not a number' ][i] ||
              j + '() ' + i + ( isErrors
                ? ' not a boolean or binary digit'
                : message + ( isArray
                  ? ' or not [' + ( outOfRange
                    ? ' negative, positive'
                    : ' integer, integer' ) + ' ]'
                  : '' ) ) ) + ': ' + arg;

        outOfRange = id = 0;
        error = new Error(message);
        error['name'] = 'BigNumber Error';

        throw error;
    }
}


/*
 * Convert a numeric string of baseIn to a numeric string of baseOut.
 */
function convert( nStr, baseOut, baseIn, sign ) {
    var e, dvs, dvd, nArr, fracArr, fracBN;

    // Convert string of base bIn to an array of numbers of baseOut.
    // Eg. strToArr('255', 10) where baseOut is 16, returns [15, 15].
    // Eg. strToArr('ff', 16)  where baseOut is 10, returns [2, 5, 5].
    function strToArr( str, bIn ) {
        var j,
            i = 0,
            strL = str.length,
            arrL,
            arr = [0];

        for ( bIn = bIn || baseIn; i < strL; i++ ) {

            for ( arrL = arr.length, j = 0; j < arrL; arr[j] *= bIn, j++ ) {
            }

            for ( arr[0] += DIGITS.indexOf( str.charAt(i) ), j = 0;
                  j < arr.length;
                  j++ ) {

                if ( arr[j] > baseOut - 1 ) {

                    if ( arr[j + 1] == null ) {
                        arr[j + 1] = 0;
                    }
                    arr[j + 1] += arr[j] / baseOut ^ 0;
                    arr[j] %= baseOut;
                }
            }
        }

        return arr.reverse();
    }

    // Convert array to string.
    // E.g. arrToStr( [9, 10, 11] ) becomes '9ab' (in bases above 11).
    function arrToStr( arr ) {
        var i = 0,
            arrL = arr.length,
            str = '';

        for ( ; i < arrL; str += DIGITS.charAt( arr[i++] ) ) {
        }

        return str;
    }

    if ( baseIn < 37 ) {
        nStr = nStr.toLowerCase();
    }

    /*
     * If non-integer convert integer part and fraction part separately.
     * Convert the fraction part as if it is an integer than use division to
     * reduce it down again to a value less than one.
     */
    if ( ( e = nStr.indexOf( '.' ) ) > -1 ) {

        /*
         * Calculate the power to which to raise the base to get the number
         * to divide the fraction part by after it has been converted as an
         * integer to the required base.
         */
        e = nStr.length - e - 1;

        // Use toFixed to avoid possible exponential notation.
        dvs = strToArr( new BigNumber(baseIn)['pow'](e)['toF'](), 10 );

        nArr = nStr.split('.');

        // Convert the base of the fraction part (as integer).
        dvd = strToArr( nArr[1] );

        // Convert the base of the integer part.
        nArr = strToArr( nArr[0] );

        // Result will be a BigNumber with a value less than 1.
        fracBN = divide( dvd, dvs, dvd.length - dvs.length, sign, baseOut,
          // Is least significant digit of integer part an odd number?
          nArr[nArr.length - 1] & 1 );

        fracArr = fracBN['c'];

        // e can be <= 0  ( if e == 0, fracArr is [0] or [1] ).
        if ( e = fracBN['e'] ) {

            // Append zeros according to the exponent of the result.
            for ( ; ++e; fracArr.unshift(0) ) {
            }

            // Append the fraction part to the converted integer part.
            nStr = arrToStr(nArr) + '.' + arrToStr(fracArr);

        // fracArr is [1].
        // Fraction digits rounded up, so increment last digit of integer part.
        } else if ( fracArr[0] ) {

            if ( nArr[ e = nArr.length - 1 ] < baseOut - 1 ) {
                ++nArr[e];
                nStr = arrToStr(nArr);
            } else {
                nStr = new BigNumber( arrToStr(nArr),
                  baseOut )['plus'](ONE)['toS'](baseOut);
            }

        // fracArr is [0]. No fraction digits.
        } else {
            nStr = arrToStr(nArr);
        }
    } else {

        // Simple integer. Convert base.
        nStr = arrToStr( strToArr(nStr) );
    }

    return nStr;
}


// Perform division in the specified base. Called by div and convert.
function divide( dvd, dvs, exp, s, base, isOdd ) {
    var dvsL, dvsT, next, cmp, remI,
        dvsZ = dvs.slice(),
        dvdI = dvsL = dvs.length,
        dvdL = dvd.length,
        rem = dvd.slice( 0, dvsL ),
        remL = rem.length,
        quo = new BigNumber(ONE),
        qc = quo['c'] = [],
        qi = 0,
        dig = DECIMAL_PLACES + ( quo['e'] = exp ) + 1;

    quo['s'] = s;
    s = dig < 0 ? 0 : dig;

    // Add zeros to make remainder as long as divisor.
    for ( ; remL++ < dvsL; rem.push(0) ) {
    }

    // Create version of divisor with leading zero.
    dvsZ.unshift(0);

    do {

        // 'next' is how many times the divisor goes into the current remainder.
        for ( next = 0; next < base; next++ ) {

            // Compare divisor and remainder.
            if ( dvsL != ( remL = rem.length ) ) {
                cmp = dvsL > remL ? 1 : -1;
            } else {
                for ( remI = -1, cmp = 0; ++remI < dvsL; ) {

                    if ( dvs[remI] != rem[remI] ) {
                        cmp = dvs[remI] > rem[remI] ? 1 : -1;
                        break;
                    }
                }
            }

            // Subtract divisor from remainder (if divisor < remainder).
            if ( cmp < 0 ) {

                // Remainder cannot be more than one digit longer than divisor.
                // Equalise lengths using divisor with extra leading zero?
                for ( dvsT = remL == dvsL ? dvs : dvsZ; remL; ) {

                    if ( rem[--remL] < dvsT[remL] ) {

                        for ( remI = remL;
                          remI && !rem[--remI];
                            rem[remI] = base - 1 ) {
                        }
                        --rem[remI];
                        rem[remL] += base;
                    }
                    rem[remL] -= dvsT[remL];
                }
                for ( ; !rem[0]; rem.shift() ) {
                }
            } else {
                break;
            }
        }

        // Add the 'next' digit to the result array.
        qc[qi++] = cmp ? next : ++next;

        // Update the remainder.
        rem[0] && cmp
          ? ( rem[remL] = dvd[dvdI] || 0 )
          : ( rem = [ dvd[dvdI] ] );

    } while ( ( dvdI++ < dvdL || rem[0] != null ) && s-- );

    // Leading zero? Do not remove if result is simply zero (qi == 1).
    if ( !qc[0] && qi != 1 ) {

        // There can't be more than one zero.
        --quo['e'];
        qc.shift();
    }

    // Round?
    if ( qi > dig ) {
        rnd( quo, DECIMAL_PLACES, base, isOdd, rem[0] != null );
    }

    // Overflow?
    if ( quo['e'] > MAX_EXP ) {

        // Infinity.
        quo['c'] = quo['e'] = null;

    // Underflow?
    } else if ( quo['e'] < MIN_EXP ) {

        // Zero.
        quo['c'] = [quo['e'] = 0];
    }

    return quo;
}


/*
 * Return a string representing the value of BigNumber n in normal or
 * exponential notation rounded to the specified decimal places or
 * significant digits.
 * Called by toString, toExponential (exp 1), toFixed, and toPrecision (exp 2).
 * d is the index (with the value in normal notation) of the digit that may be
 * rounded up.
 */
function format( n, d, exp ) {

    // Initially, i is the number of decimal places required.
    var i = d - (n = new BigNumber(n))['e'],
        c = n['c'];

    // +-Infinity or NaN?
    if ( !c ) {
        return n['toS']();
    }

    // Round?
    if ( c.length > ++d ) {
        rnd( n, i, 10 );
    }

    // Recalculate d if toFixed as n['e'] may have changed if value rounded up.
    i = c[0] == 0 ? i + 1 : exp ? d : n['e'] + i + 1;

    // Append zeros?
    for ( ; c.length < i; c.push(0) ) {
    }
    i = n['e'];

    /*
     * toPrecision returns exponential notation if the number of significant
     * digits specified is less than the number of digits necessary to
     * represent the integer part of the value in normal notation.
     */
    return exp == 1 || exp == 2 && ( --d < i || i <= TO_EXP_NEG )

      // Exponential notation.
      ? ( n['s'] < 0 && c[0] ? '-' : '' ) + ( c.length > 1
        ? ( c.splice( 1, 0, '.' ), c.join('') )
        : c[0] ) + ( i < 0 ? 'e' : 'e+' ) + i

      // Normal notation.
      : n['toS']();
}


// Round if necessary.
// Called by divide, format, setMode and sqrt.
function rnd( x, dp, base, isOdd, r ) {
    var xc = x['c'],
        isNeg = x['s'] < 0,
        half = base / 2,
        i = x['e'] + dp + 1,

        // 'next' is the digit after the digit that may be rounded up.
        next = xc[i],

        /*
         * 'more' is whether there are digits after 'next'.
         * E.g.
         * 0.005 (e = -3) to be rounded to 0 decimal places (dp = 0) gives i = -2
         * The 'next' digit is zero, and there ARE 'more' digits after it.
         * 0.5 (e = -1) dp = 0 gives i = 0
         * The 'next' digit is 5 and there are no 'more' digits after it.
         */
        more = r || i < 0 || xc[i + 1] != null;

    r = ROUNDING_MODE < 4
      ? ( next != null || more ) &&
        ( ROUNDING_MODE == 0 ||
           ROUNDING_MODE == 2 && !isNeg ||
             ROUNDING_MODE == 3 && isNeg )
      : next > half || next == half &&
        ( ROUNDING_MODE == 4 || more ||

          /*
           * isOdd is used in base conversion and refers to the least significant
           * digit of the integer part of the value to be converted. The fraction
           * part is rounded by this method separately from the integer part.
           */
          ROUNDING_MODE == 6 && ( xc[i - 1] & 1 || !dp && isOdd ) ||
            ROUNDING_MODE == 7 && !isNeg ||
              ROUNDING_MODE == 8 && isNeg );

    if ( i < 1 || !xc[0] ) {
        xc.length = 0;
        xc.push(0);

        if ( r ) {

            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xc[0] = 1;
            x['e'] = -dp;
        } else {

            // Zero.
            x['e'] = 0;
        }

        return x;
    }

    // Remove any digits after the required decimal places.
    xc.length = i--;

    // Round up?
    if ( r ) {

        // Rounding up may mean the previous digit has to be rounded up and so on.
        for ( --base; ++xc[i] > base; ) {
            xc[i] = 0;

            if ( !i-- ) {
                ++x['e'];
                xc.unshift(1);
            }
        }
    }

    // Remove trailing zeros.
    for ( i = xc.length; !xc[--i]; xc.pop() ) {
    }

    return x;
}


// Round after setting the appropriate rounding mode.
// Handles ceil, floor and round.
function setMode( x, dp, rm ) {
    var r = ROUNDING_MODE;

    ROUNDING_MODE = rm;
    x = new BigNumber(x);
    x['c'] && rnd( x, dp, 10 );
    ROUNDING_MODE = r;

    return x;
}


// PROTOTYPE/INSTANCE METHODS


/*
 * Return a new BigNumber whose value is the absolute value of this BigNumber.
 */
P['abs'] = P['absoluteValue'] = function () {
    var x = new BigNumber(this);

    if ( x['s'] < 0 ) {
        x['s'] = 1;
    }

    return x;
};

/*
 * Return the bit length of the number.
 */
P['bitLength'] = function () {
    return this.toString(2).length;
};


/*
 * Return a new BigNumber whose value is the value of this BigNumber
 * rounded to a whole number in the direction of Infinity.
 */
P['ceil'] = function () {
    return setMode( this, 0, 2 );
};


/*
 * Return
 * 1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
 * -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
 * 0 if they have the same value,
 * or null if the value of either is NaN.
 */
P['comparedTo'] = P['cmp'] = function ( y, b ) {
    var a,
        x = this,
        xc = x['c'],
        yc = ( id = -id, y = new BigNumber( y, b ) )['c'],
        i = x['s'],
        j = y['s'],
        k = x['e'],
        l = y['e'];

    // Either NaN?
    if ( !i || !j ) {
        return null;
    }

    a = xc && !xc[0], b = yc && !yc[0];

    // Either zero?
    if ( a || b ) {
        return a ? b ? 0 : -j : i;
    }

    // Signs differ?
    if ( i != j ) {
        return i;
    }

    // Either Infinity?
    if ( a = i < 0, b = k == l, !xc || !yc ) {
        return b ? 0 : !xc ^ a ? 1 : -1;
    }

    // Compare exponents.
    if ( !b ) {
        return k > l ^ a ? 1 : -1;
    }

    // Compare digit by digit.
    for ( i = -1,
          j = ( k = xc.length ) < ( l = yc.length ) ? k : l;
          ++i < j; ) {

        if ( xc[i] != yc[i] ) {
            return xc[i] > yc[i] ^ a ? 1 : -1;
        }
    }
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
};


/*
 *  n / 0 = I
 *  n / N = N
 *  n / I = 0
 *  0 / n = 0
 *  0 / 0 = N
 *  0 / N = N
 *  0 / I = 0
 *  N / n = N
 *  N / 0 = N
 *  N / N = N
 *  N / I = N
 *  I / n = I
 *  I / 0 = I
 *  I / N = N
 *  I / I = N
 *
 * Return a new BigNumber whose value is the value of this BigNumber
 * divided by the value of BigNumber(y, b), rounded according to
 * DECIMAL_PLACES and ROUNDING_MODE.
 */
P['dividedBy'] = P['div'] = function ( y, b ) {
    var xc = this['c'],
        xe = this['e'],
        xs = this['s'],
        yc = ( id = 2, y = new BigNumber( y, b ) )['c'],
        ye = y['e'],
        ys = y['s'],
        s = xs == ys ? 1 : -1;

    // Either NaN/Infinity/0?
    return !xe && ( !xc || !xc[0] ) || !ye && ( !yc || !yc[0] )

      // Either NaN?
      ? new BigNumber( !xs || !ys ||

        // Both 0 or both Infinity?
        ( xc ? yc && xc[0] == yc[0] : !yc )

          // Return NaN.
          ? NaN

          // x is 0 or y is Infinity?
          : xc && xc[0] == 0 || !yc

            // Return +-0.
            ? s * 0

            // y is 0. Return +-Infinity.
            : s / 0 )

      : divide( xc, yc, xe - ye, s, 10 );
};


/*
 * Return true if the value of this BigNumber is equal to the value of
 * BigNumber(n, b), otherwise returns false.
 */
P['equals'] = P['eq'] = function ( n, b ) {
    id = 3;
    return this['cmp']( n, b ) === 0;
};


/*
 * Return a new BigNumber whose value is the value of this BigNumber
 * rounded to a whole number in the direction of -Infinity.
 */
P['floor'] = function () {
    return setMode( this, 0, 3 );
};


/*
 * Return true if the value of this BigNumber is greater than the value of
 * BigNumber(n, b), otherwise returns false.
 */
P['greaterThan'] = P['gt'] = function ( n, b ) {
    id = 4;
    return this['cmp']( n, b ) > 0;
};


/*
 * Return true if the value of this BigNumber is greater than or equal to
 * the value of BigNumber(n, b), otherwise returns false.
 */
P['greaterThanOrEqualTo'] = P['gte'] = P['gt'] = function ( n, b ) {
    id = 5;
    return ( b = this['cmp']( n, b ) ) == 1 || b === 0;
};


/*
 * Return true if the value of this BigNumber is a finite number, otherwise
 * returns false.
 */
P['isFinite'] = P['isF'] = function () {
    return !!this['c'];
};


/*
 * Return true if the value of this BigNumber is NaN, otherwise returns
 * false.
 */
P['isNaN'] = function () {
    return !this['s'];
};


/*
 * Return true if the value of this BigNumber is negative, otherwise
 * returns false.
 */
P['isNegative'] = P['isNeg'] = function () {
    return this['s'] < 0;
};


/*
 * Return true if the value of this BigNumber is 0 or -0, otherwise returns
 * false.
 */
P['isZero'] = P['isZ'] = function () {
    return !!this['c'] && this['c'][0] == 0;
};


/*
 * Return true if the value of this BigNumber is less than the value of
 * BigNumber(n, b), otherwise returns false.
 */
P['lessThan'] = P['lt'] = function ( n, b ) {
    id = 6;
    return this['cmp']( n, b ) < 0;
};


/*
 * Return true if the value of this BigNumber is less than or equal to the
 * value of BigNumber(n, b), otherwise returns false.
 */
P['lessThanOrEqualTo'] = P['lte'] = P['le'] = function ( n, b ) {
    id = 7;
    return ( b = this['cmp']( n, b ) ) == -1 || b === 0;
};


/*
 *  n - 0 = n
 *  n - N = N
 *  n - I = -I
 *  0 - n = -n
 *  0 - 0 = 0
 *  0 - N = N
 *  0 - I = -I
 *  N - n = N
 *  N - 0 = N
 *  N - N = N
 *  N - I = N
 *  I - n = I
 *  I - 0 = I
 *  I - N = N
 *  I - I = N
 *
 * Return a new BigNumber whose value is the value of this BigNumber minus
 * the value of BigNumber(y, b).
 */
P['minus'] = P['sub'] = function ( y, b ) {
    var d, i, j, xLTy,
        x = this,
        a = x['s'];

    b = ( id = 8, y = new BigNumber( y, b ) )['s'];

    // Either NaN?
    if ( !a || !b ) {
        return new BigNumber(NaN);
    }

    // Signs differ?
    if ( a != b ) {
        return y['s'] = -b, x['plus'](y);
    }

    var xc = x['c'],
        xe = x['e'],
        yc = y['c'],
        ye = y['e'];

    if ( !xe || !ye ) {

        // Either Infinity?
        if ( !xc || !yc ) {
            return xc ? ( y['s'] = -b, y ) : new BigNumber( yc ? x : NaN );
        }

        // Either zero?
        if ( !xc[0] || !yc[0] ) {

            // y is non-zero?
            return yc[0]
              ? ( y['s'] = -b, y )

              // x is non-zero?
              : new BigNumber( xc[0]
                ? x

                // Both are zero.
                // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                : ROUNDING_MODE == 3 ? -0 : 0 );
        }
    }

    // Determine which is the bigger number.
    // Prepend zeros to equalise exponents.
    if ( xc = xc.slice(), a = xe - ye ) {
        d = ( xLTy = a < 0 ) ? ( a = -a, xc ) : ( ye = xe, yc );

        for ( d.reverse(), b = a; b--; d.push(0) ) {
        }
        d.reverse();
    } else {

        // Exponents equal. Check digit by digit.
        j = ( ( xLTy = xc.length < yc.length ) ? xc : yc ).length;

        for ( a = b = 0; b < j; b++ ) {

            if ( xc[b] != yc[b] ) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
    }

    // x < y? Point xc to the array of the bigger number.
    if ( xLTy ) {
        d = xc, xc = yc, yc = d;
        y['s'] = -y['s'];
    }

    /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter
     * as subtraction only needs to start at yc.length.
     */
    if ( ( b = -( ( j = xc.length ) - yc.length ) ) > 0 ) {

        for ( ; b--; xc[j++] = 0 ) {
        }
    }

    // Subtract yc from xc.
    for ( b = yc.length; b > a; ){

        if ( xc[--b] < yc[b] ) {

            for ( i = b; i && !xc[--i]; xc[i] = 9 ) {
            }
            --xc[i];
            xc[b] += 10;
        }
        xc[b] -= yc[b];
    }

    // Remove trailing zeros.
    for ( ; xc[--j] == 0; xc.pop() ) {
    }

    // Remove leading zeros and adjust exponent accordingly.
    for ( ; xc[0] == 0; xc.shift(), --ye ) {
    }

    /*
     * No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
     * when neither x or y are Infinity.
     */

    // Underflow?
    if ( ye < MIN_EXP || !xc[0] ) {

        /*
         * Following IEEE 754 (2008) 6.3,
         * n - n = +0  but  n - n = -0 when rounding towards -Infinity.
         */
        if ( !xc[0] ) {
            y['s'] = ROUNDING_MODE == 3 ? -1 : 1;
        }

        // Result is zero.
        xc = [ye = 0];
    }

    return y['c'] = xc, y['e'] = ye, y;
};


/*
 *   n % 0 =  N
 *   n % N =  N
 *   0 % n =  0
 *  -0 % n = -0
 *   0 % 0 =  N
 *   0 % N =  N
 *   N % n =  N
 *   N % 0 =  N
 *   N % N =  N
 *
 * Return a new BigNumber whose value is the value of this BigNumber modulo
 * the value of BigNumber(y, b).
 */
P['modulo'] = P['mod'] = function ( y, b ) {
    var x = this,
        xc = x['c'],
        yc = ( id = 9, y = new BigNumber( y, b ) )['c'],
        i = x['s'],
        j = y['s'];

    // Is x or y NaN, or y zero?
    b = !i || !j || yc && !yc[0];

    if ( b || xc && !xc[0] ) {
        return new BigNumber( b ? NaN : x );
    }

    x['s'] = y['s'] = 1;
    b = y['cmp'](x) == 1;
    x['s'] = i, y['s'] = j;

    return b
      ? new BigNumber(x)
      : ( i = DECIMAL_PLACES, j = ROUNDING_MODE,
        DECIMAL_PLACES = 0, ROUNDING_MODE = 1,
          x = x['div'](y),
            DECIMAL_PLACES = i, ROUNDING_MODE = j,
              this['minus']( x['times'](y) ) );
};


/*
 * Return a new BigNumber whose value is the value of this BigNumber
 * negated, i.e. multiplied by -1.
 */
P['negated'] = P['neg'] = function () {
    var x = new BigNumber(this);

    return x['s'] = -x['s'] || null, x;
};


/*
 *  n + 0 = n
 *  n + N = N
 *  n + I = I
 *  0 + n = n
 *  0 + 0 = 0
 *  0 + N = N
 *  0 + I = I
 *  N + n = N
 *  N + 0 = N
 *  N + N = N
 *  N + I = N
 *  I + n = I
 *  I + 0 = I
 *  I + N = N
 *  I + I = I
 *
 * Return a new BigNumber whose value is the value of this BigNumber plus
 * the value of BigNumber(y, b).
 */
P['plus'] = P['add'] = function ( y, b ) {
    var d,
        x = this,
        a = x['s'];

    b = ( id = 10, y = new BigNumber( y, b ) )['s'];

    // Either NaN?
    if ( !a || !b ) {
        return new BigNumber(NaN);
    }

    // Signs differ?
    if ( a != b ) {
        return y['s'] = -b, x['minus'](y);
    }

    var xe = x['e'],
        xc = x['c'],
        ye = y['e'],
        yc = y['c'];

    if ( !xe || !ye ) {

        // Either Infinity?
        if ( !xc || !yc ) {

            // Return +-Infinity.
            return new BigNumber( a / 0 );
        }

        // Either zero?
        if ( !xc[0] || !yc[0] ) {

            // y is non-zero?
            return yc[0]
              ? y

              // x is non-zero?
              : new BigNumber( xc[0]
                ? x

                // Both are zero. Return zero.
                : a * 0 );
        }
    }

    // Prepend zeros to equalise exponents.
    // Note: Faster to use reverse then do unshifts.
    if ( xc = xc.slice(), a = xe - ye ) {
        d = a > 0 ? ( ye = xe, yc ) : ( a = -a, xc );

        for ( d.reverse(); a--; d.push(0) ) {
        }
        d.reverse();
    }

    // Point xc to the longer array.
    if ( xc.length - yc.length < 0 ) {
        d = yc, yc = xc, xc = d;
    }

    /*
     * Only start adding at yc.length - 1 as the
     * further digits of xc can be left as they are.
     */
    for ( a = yc.length, b = 0; a;
         b = ( xc[--a] = xc[a] + yc[a] + b ) / 10 ^ 0, xc[a] %= 10 ) {
    }

    // No need to check for zero, as +x + +y != 0 && -x + -y != 0

    if ( b ) {
        xc.unshift(b);

        // Overflow? (MAX_EXP + 1 possible)
        if ( ++ye > MAX_EXP ) {

            // Infinity.
            xc = ye = null;
        }
    }

     // Remove trailing zeros.
    for ( a = xc.length; xc[--a] == 0; xc.pop() ) {
    }

    return y['c'] = xc, y['e'] = ye, y;
};


/*
 * Return a BigNumber whose value is the value of this BigNumber raised to
 * the power e. If e is negative round according to DECIMAL_PLACES and
 * ROUNDING_MODE.
 *
 * e {number} Integer, -MAX_POWER to MAX_POWER inclusive.
 */
P['toPower'] = P['pow'] = function ( e ) {

    // e to integer, avoiding NaN or Infinity becoming 0.
    var i = e * 0 == 0 ? e | 0 : e,
        x = new BigNumber(this),
        y = new BigNumber(ONE);

    // Use Math.pow?
    // Pass +-Infinity for out of range exponents.
    if ( ( ( ( outOfRange = e < -MAX_POWER || e > MAX_POWER ) &&
      (i = e * 1 / 0) ) ||

         /*
          * Any exponent that fails the parse becomes NaN.
          *
          * Include 'e !== 0' because on Opera -0 == parseFloat(-0) is false,
          * despite -0 === parseFloat(-0) && -0 == parseFloat('-0') is true.
          */
         parse(e) != e && e !== 0 && !(i = NaN) ) &&

          // 'pow() exponent not an integer: {e}'
          // 'pow() exponent out of range: {e}'
          !ifExceptionsThrow( e, 'exponent', 'pow' ) ||

            // Pass zero to Math.pow, as any value to the power zero is 1.
            !i ) {

        // i is +-Infinity, NaN or 0.
        return new BigNumber( Math.pow( x['toS'](), i ) );
    }

    for ( i = i < 0 ? -i : i; ; ) {

        if ( i & 1 ) {
            y = y['times'](x);
        }
        i >>= 1;

        if ( !i ) {
            break;
        }
        x = x['times'](x);
    }

    return e < 0 ? ONE['div'](y) : y;
};


/*
 * Return a BigNumber whose value is the value of this BigNumber raised to
 * the power m modulo n.
 *
 * m {BigNumber} the value to take the power of
 * n {BigNumber} the value to modulo by
 */
P['powm'] = function ( m, n ) {
    return this.pow(m).mod(n);
};


/*
 * Return a new BigNumber whose value is the value of this BigNumber
 * rounded to a maximum of dp decimal places using rounding mode rm, or to
 * 0 and ROUNDING_MODE respectively if omitted.
 *
 * [dp] {number} Integer, 0 to MAX inclusive.
 * [rm] {number} Integer, 0 to 8 inclusive.
 */
P['round'] = function ( dp, rm ) {

    dp = dp == null || ( ( ( outOfRange = dp < 0 || dp > MAX ) ||
      parse(dp) != dp ) &&

        // 'round() decimal places out of range: {dp}'
        // 'round() decimal places not an integer: {dp}'
        !ifExceptionsThrow( dp, 'decimal places', 'round' ) )
          ? 0
          : dp | 0;

    rm = rm == null || ( ( ( outOfRange = rm < 0 || rm > 8 ) ||

      // Include '&& rm !== 0' because with Opera -0 == parseFloat(-0) is false.
      parse(rm) != rm && rm !== 0 ) &&

        // 'round() mode not an integer: {rm}'
        // 'round() mode out of range: {rm}'
        !ifExceptionsThrow( rm, 'mode', 'round' ) )
          ? ROUNDING_MODE
          : rm | 0;

    return setMode( this, dp, rm );
};


/*
 *  sqrt(-n) =  N
 *  sqrt( N) =  N
 *  sqrt(-I) =  N
 *  sqrt( I) =  I
 *  sqrt( 0) =  0
 *  sqrt(-0) = -0
 *
 * Return a new BigNumber whose value is the square root of the value of
 * this BigNumber, rounded according to DECIMAL_PLACES and ROUNDING_MODE.
 */
P['squareRoot'] = P['sqrt'] = function () {
    var n, r, re, t,
        x = this,
        c = x['c'],
        s = x['s'],
        e = x['e'],
        dp = DECIMAL_PLACES,
        rm = ROUNDING_MODE,
        half = new BigNumber('0.5');

    // Negative/NaN/Infinity/zero?
    if ( s !== 1 || !c || !c[0] ) {

        return new BigNumber( !s || s < 0 && ( !c || c[0] )
          ? NaN
          : c ? x : 1 / 0 );
    }

    // Initial estimate.
    s = Math.sqrt( x['toS']() );
    ROUNDING_MODE = 1;

    /*
      Math.sqrt underflow/overflow?
      Pass x to Math.sqrt as integer, then adjust the exponent of the result.
     */
    if ( s == 0 || s == 1 / 0 ) {
        n = c.join('');

        if ( !( n.length + e & 1 ) ) {
            n += '0';
        }
        r = new BigNumber( Math.sqrt(n) + '' );

        // r may still not be finite.
        if ( !r['c'] ) {
            r['c'] = [1];
        }
        r['e'] = ( ( ( e + 1 ) / 2 ) | 0 ) - ( e < 0 || e & 1 );
    } else {
        r = new BigNumber( n = s.toString() );
    }
    re = r['e'];
    s = re + ( DECIMAL_PLACES += 4 );

    if ( s < 3 ) {
        s = 0;
    }
    e = s;

    // Newton-Raphson iteration.
    for ( ; ; ) {
        t = r;
        r = half['times']( t['plus']( x['div'](t) ) );

        if ( t['c'].slice( 0, s ).join('') === r['c'].slice( 0, s ).join('') ) {
            c = r['c'];

            /*
              The exponent of r may here be one less than the final result
              exponent (re), e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust
              s so the rounding digits are indexed correctly.
             */
            s = s - ( n && r['e'] < re );

            /*
              The 4th rounding digit may be in error by -1 so if the 4 rounding
              digits are 9999 or 4999 (i.e. approaching a rounding boundary)
              continue the iteration.
             */
            if ( c[s] == 9 && c[s - 1] == 9 && c[s - 2] == 9 &&
                    ( c[s - 3] == 9 || n && c[s - 3] == 4 ) ) {

                /*
                  If 9999 on first run through, check to see if rounding up
                  gives the exact result as the nines may infinitely repeat.
                 */
                if ( n && c[s - 3] == 9 ) {
                    t = r['round']( dp, 0 );

                    if ( t['times'](t)['eq'](x) ) {
                        ROUNDING_MODE = rm;
                        DECIMAL_PLACES = dp;

                        return t;
                    }
                }
                DECIMAL_PLACES += 4;
                s += 4;
                n = '';
            } else {

                /*
                  If the rounding digits are null, 0000 or 5000, check for an
                  exact result. If not, then there are further digits so
                  increment the 1st rounding digit to ensure correct rounding.
                 */
                if ( !c[e] && !c[e - 1] && !c[e - 2] &&
                        ( !c[e - 3] || c[e - 3] == 5 ) ) {

                    // Truncate to the first rounding digit.
                    if ( c.length > e - 2 ) {
                        c.length = e - 2;
                    }

                    if ( !r['times'](r)['eq'](x) ) {

                        while ( c.length < e - 3 ) {
                            c.push(0);
                        }
                        c[e - 3]++;
                    }
                }
                ROUNDING_MODE = rm;
                rnd( r, DECIMAL_PLACES = dp, 10 );

                return r;
            }
        }
    }
};


/*
 *  n * 0 = 0
 *  n * N = N
 *  n * I = I
 *  0 * n = 0
 *  0 * 0 = 0
 *  0 * N = N
 *  0 * I = N
 *  N * n = N
 *  N * 0 = N
 *  N * N = N
 *  N * I = N
 *  I * n = I
 *  I * 0 = N
 *  I * N = N
 *  I * I = I
 *
 * Return a new BigNumber whose value is the value of this BigNumber times
 * the value of BigNumber(y, b).
 */
P['times'] = P['mul'] = function ( y, b ) {
    var c,
        x = this,
        xc = x['c'],
        yc = ( id = 11, y = new BigNumber( y, b ) )['c'],
        i = x['e'],
        j = y['e'],
        a = x['s'];

    y['s'] = a == ( b = y['s'] ) ? 1 : -1;

    // Either NaN/Infinity/0?
    if ( !i && ( !xc || !xc[0] ) || !j && ( !yc || !yc[0] ) ) {

        // Either NaN?
        return new BigNumber( !a || !b ||

          // x is 0 and y is Infinity  or  y is 0 and x is Infinity?
          xc && !xc[0] && !yc || yc && !yc[0] && !xc

            // Return NaN.
            ? NaN

            // Either Infinity?
            : !xc || !yc

              // Return +-Infinity.
              ? y['s'] / 0

              // x or y is 0. Return +-0.
              : y['s'] * 0 );
    }
    y['e'] = i + j;

    if ( ( a = xc.length ) < ( b = yc.length ) ) {
        c = xc, xc = yc, yc = c, j = a, a = b, b = j;
    }

    for ( j = a + b, c = []; j--; c.push(0) ) {
    }

    // Multiply!
    for ( i = b - 1; i > -1; i-- ) {

        for ( b = 0, j = a + i;
              j > i;
              b = c[j] + yc[i] * xc[j - i - 1] + b,
              c[j--] = b % 10 | 0,
              b = b / 10 | 0 ) {
        }

        if ( b ) {
            c[j] = ( c[j] + b ) % 10;
        }
    }

    b && ++y['e'];

    // Remove any leading zero.
    !c[0] && c.shift();

    // Remove trailing zeros.
    for ( j = c.length; !c[--j]; c.pop() ) {
    }

    // No zero check needed as only x * 0 == 0 etc.

    // Overflow?
    y['c'] = y['e'] > MAX_EXP

      // Infinity.
      ? ( y['e'] = null )

      // Underflow?
      : y['e'] < MIN_EXP

        // Zero.
        ? [ y['e'] = 0 ]

        // Neither.
        : c;

    return y;
};

/*
 * Return a buffer containing the 
 */
P['toBuffer'] = function ( opts ) {

    if (typeof opts === 'string') {
        if (opts !== 'mpint') return 'Unsupported Buffer representation';

        var abs = this.abs();
        var buf = abs.toBuffer({ size : 1, endian : 'big' });
        var len = buf.length === 1 && buf[0] === 0 ? 0 : buf.length;
        if (buf[0] & 0x80) len ++;

        var ret = new Buffer(4 + len);
        if (len > 0) buf.copy(ret, 4 + (buf[0] & 0x80 ? 1 : 0));
        if (buf[0] & 0x80) ret[4] = 0;

        ret[0] = len & (0xff << 24);
        ret[1] = len & (0xff << 16);
        ret[2] = len & (0xff << 8);
        ret[3] = len & (0xff << 0);

        // two's compliment for negative integers:
        var isNeg = this.lt(0);
        if (isNeg) {
            for (var i = 4; i < ret.length; i++) {
                ret[i] = 0xff - ret[i];
            }
        }
        ret[4] = (ret[4] & 0x7f) | (isNeg ? 0x80 : 0);
        if (isNeg) ret[ret.length - 1] ++;

        return ret;
    }

    if (!opts) opts = {};

    var endian = { 1 : 'big', '-1' : 'little' }[opts.endian]
        || opts.endian || 'big'
    ;

    var hex = this.toString(16);
    if (hex.charAt(0) === '-') throw new Error(
        'converting negative numbers to Buffers not supported yet'
    );

    var size = opts.size === 'auto' ? Math.ceil(hex.length / 2) : (opts.size || 1);

    var len = Math.ceil(hex.length / (2 * size)) * size;
    var buf = new Buffer(len);

    // zero-pad the hex string so the chunks are all `size` long
    while (hex.length < 2 * len) hex = '0' + hex;

    var hx = hex
        .split(new RegExp('(.{' + (2 * size) + '})'))
        .filter(function (s) { return s.length > 0 })
    ;

    hx.forEach(function (chunk, i) {
        for (var j = 0; j < size; j++) {
            var ix = i * size + (endian === 'big' ? j : size - j - 1);
            buf[ix] = parseInt(chunk.slice(j*2,j*2+2), 16);
        }
    });

    return buf;
};

/*
 * Return a string representing the value of this BigNumber in exponential
 * notation to dp fixed decimal places and rounded using ROUNDING_MODE if
 * necessary.
 *
 * [dp] {number} Integer, 0 to MAX inclusive.
 */
P['toExponential'] = P['toE'] = function ( dp ) {

    return format( this,
      ( dp == null || ( ( outOfRange = dp < 0 || dp > MAX ) ||

        /*
         * Include '&& dp !== 0' because with Opera -0 == parseFloat(-0) is
         * false, despite -0 == parseFloat('-0') && 0 == -0 being true.
         */
        parse(dp) != dp && dp !== 0 ) &&

          // 'toE() decimal places not an integer: {dp}'
          // 'toE() decimal places out of range: {dp}'
          !ifExceptionsThrow( dp, 'decimal places', 'toE' ) ) && this['c']
            ? this['c'].length - 1
            : dp | 0, 1 );
};


/*
 * Return a string representing the value of this BigNumber in normal
 * notation to dp fixed decimal places and rounded using ROUNDING_MODE if
 * necessary.
 *
 * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
 * but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Integer, 0 to MAX inclusive.
 */
P['toFixed'] = P['toF'] = function ( dp ) {
    var n, str, d,
        x = this;

    if ( !( dp == null || ( ( outOfRange = dp < 0 || dp > MAX ) ||
        parse(dp) != dp && dp !== 0 ) &&

        // 'toF() decimal places not an integer: {dp}'
        // 'toF() decimal places out of range: {dp}'
        !ifExceptionsThrow( dp, 'decimal places', 'toF' ) ) ) {
          d = x['e'] + ( dp | 0 );
    }

    n = TO_EXP_NEG, dp = TO_EXP_POS;
    TO_EXP_NEG = -( TO_EXP_POS = 1 / 0 );

    // Note: str is initially undefined.
    if ( d == str ) {
        str = x['toS']();
    } else {
        str = format( x, d );

        // (-0).toFixed() is '0', but (-0.1).toFixed() is '-0'.
        // (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
        if ( x['s'] < 0 && x['c'] ) {

            // As e.g. -0 toFixed(3), will wrongly be returned as -0.000 from toString.
            if ( !x['c'][0] ) {
                str = str.replace(/^-/, '');

            // As e.g. -0.5 if rounded to -0 will cause toString to omit the minus sign.
            } else if ( str.indexOf('-') < 0 ) {
                str = '-' + str;
            }
        }
    }
    TO_EXP_NEG = n, TO_EXP_POS = dp;

    return str;
};


/*
 * Return a string array representing the value of this BigNumber as a
 * simple fraction with an integer numerator and an integer denominator.
 * The denominator will be a positive non-zero value less than or equal to
 * the specified maximum denominator. If a maximum denominator is not
 * specified, the denominator will be the lowest value necessary to
 * represent the number exactly.
 *
 * [maxD] {number|string|BigNumber} Integer >= 1 and < Infinity.
 */
P['toFraction'] = P['toFr'] = function ( maxD ) {
    var q, frac, n0, d0, d2, n, e,
        n1 = d0 = new BigNumber(ONE),
        d1 = n0 = new BigNumber('0'),
        x = this,
        xc = x['c'],
        exp = MAX_EXP,
        dp = DECIMAL_PLACES,
        rm = ROUNDING_MODE,
        d = new BigNumber(ONE);

    // NaN, Infinity.
    if ( !xc ) {
        return x['toS']();
    }

    e = d['e'] = xc.length - x['e'] - 1;

    // If max denominator is undefined or null...
    if ( maxD == null ||

         // or NaN...
         ( !( id = 12, n = new BigNumber(maxD) )['s'] ||

           // or less than 1, or Infinity...
           ( outOfRange = n['cmp'](n1) < 0 || !n['c'] ) ||

             // or not an integer...
             ( ERRORS && n['e'] < n['c'].length - 1 ) ) &&

               // 'toFr() max denominator not an integer: {maxD}'
               // 'toFr() max denominator out of range: {maxD}'
               !ifExceptionsThrow( maxD, 'max denominator', 'toFr' ) ||

                 // or greater than the maxD needed to specify the value exactly...
                 ( maxD = n )['cmp'](d) > 0 ) {

        // d is e.g. 10, 100, 1000, 10000... , n1 is 1.
        maxD = e > 0 ? d : n1;
    }

    MAX_EXP = 1 / 0;
    n = new BigNumber( xc.join('') );

    for ( DECIMAL_PLACES = 0, ROUNDING_MODE = 1; ; )  {
        q = n['div'](d);
        d2 = d0['plus']( q['times'](d1) );

        if ( d2['cmp'](maxD) == 1 ) {
            break;
        }

        d0 = d1, d1 = d2;

        n1 = n0['plus']( q['times']( d2 = n1 ) );
        n0 = d2;

        d = n['minus']( q['times']( d2 = d ) );
        n = d2;
    }

    d2 = maxD['minus'](d0)['div'](d1);
    n0 = n0['plus']( d2['times'](n1) );
    d0 = d0['plus']( d2['times'](d1) );

    n0['s'] = n1['s'] = x['s'];

    DECIMAL_PLACES = e * 2;
    ROUNDING_MODE = rm;

    // Determine which fraction is closer to x, n0 / d0 or n1 / d1?
    frac = n1['div'](d1)['minus'](x)['abs']()['cmp'](
      n0['div'](d0)['minus'](x)['abs']() ) < 1
      ? [ n1['toS'](), d1['toS']() ]
      : [ n0['toS'](), d0['toS']() ];

    return MAX_EXP = exp, DECIMAL_PLACES = dp, frac;
};


/*
 * Return a string representing the value of this BigNumber to sd significant
 * digits and rounded using ROUNDING_MODE if necessary.
 * If sd is less than the number of digits necessary to represent the integer
 * part of the value in normal notation, then use exponential notation.
 *
 * sd {number} Integer, 1 to MAX inclusive.
 */
P['toPrecision'] = P['toP'] = function ( sd ) {

    /*
     * ERRORS true: Throw if sd not undefined, null or an integer in range.
     * ERRORS false: Ignore sd if not a number or not in range.
     * Truncate non-integers.
     */
    return sd == null || ( ( ( outOfRange = sd < 1 || sd > MAX ) ||
      parse(sd) != sd ) &&

        // 'toP() precision not an integer: {sd}'
        // 'toP() precision out of range: {sd}'
        !ifExceptionsThrow( sd, 'precision', 'toP' ) )
          ? this['toS']()
          : format( this, --sd | 0, 2 );
};


/*
 * Return a string representing the value of this BigNumber in base b, or
 * base 10 if b is omitted. If a base is specified, including base 10,
 * round according to DECIMAL_PLACES and ROUNDING_MODE.
 * If a base is not specified, and this BigNumber has a positive exponent
 * that is equal to or greater than TO_EXP_POS, or a negative exponent equal
 * to or less than TO_EXP_NEG, return exponential notation.
 *
 * [b] {number} Integer, 2 to 64 inclusive.
 */
P['toString'] = P['toS'] = function ( b ) {
    var u, str, strL,
        x = this,
        xe = x['e'];

    // Infinity or NaN?
    if ( xe === null ) {
        str = x['s'] ? 'Infinity' : 'NaN';

    // Exponential format?
    } else if ( b === u && ( xe <= TO_EXP_NEG || xe >= TO_EXP_POS ) ) {
        return format( x, x['c'].length - 1, 1 );
    } else {
        str = x['c'].join('');

        // Negative exponent?
        if ( xe < 0 ) {

            // Prepend zeros.
            for ( ; ++xe; str = '0' + str ) {
            }
            str = '0.' + str;

        // Positive exponent?
        } else if ( strL = str.length, xe > 0 ) {

            if ( ++xe > strL ) {

                // Append zeros.
                for ( xe -= strL; xe-- ; str += '0' ) {
                }
            } else if ( xe < strL ) {
                str = str.slice( 0, xe ) + '.' + str.slice(xe);
            }

        // Exponent zero.
        } else {
            if ( u = str.charAt(0), strL > 1 ) {
                str = u + '.' + str.slice(1);

            // Avoid '-0'
            } else if ( u == '0' ) {
                return u;
            }
        }

        if ( b != null ) {

            if ( !( outOfRange = !( b >= 2 && b < 65 ) ) &&
              ( b == (b | 0) || !ERRORS ) ) {
                str = convert( str, b | 0, 10, x['s'] );

                // Avoid '-0'
                if ( str == '0' ) {
                    return str;
                }
            } else {

                // 'toS() base not an integer: {b}'
                // 'toS() base out of range: {b}'
                ifExceptionsThrow( b, 'base', 'toS' );
            }
        }

    }

    return x['s'] < 0 ? '-' + str : str;
};


/*
 * Return as toString, but do not accept a base argument.
 */
P['valueOf'] = function () {
    return this['toS']();
};


// Add aliases for BigDecimal methods.
//P['add'] = P['plus'];
//P['subtract'] = P['minus'];
//P['multiply'] = P['times'];
//P['divide'] = P['div'];
//P['remainder'] = P['mod'];
//P['compareTo'] = P['cmp'];
//P['negate'] = P['neg'];


// EXPORT
module.exports = BigNumber;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).Buffer))

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(42)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

var cryptoUtils = __webpack_require__(69);

module.exports = {
    isValidAddress: function isValidAddress(address) {
        if (!/^0x[0-9a-fA-F]{40}$/.test(address)) {
            // Check if it has the basic requirements of an address
            return false;
        }

        if (/^0x[0-9a-f]{40}$/.test(address) || /^0x?[0-9A-F]{40}$/.test(address)) {
            // If it's all small caps or all all caps, return true
            return true;
        }

        // Otherwise check each case
        return this.verifyChecksum(address);
    },
    verifyChecksum: function verifyChecksum(address) {
        // Check each case
        address = address.replace('0x', '');

        var addressHash = cryptoUtils.keccak256(address.toLowerCase());

        for (var i = 0; i < 40; i++) {
            // The nth letter should be uppercase if the nth digit of casemap is 1
            if (parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i] || parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i]) {
                return false;
            }
        }

        return true;
    }
};

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright (c) 2017 Pieter Wuille
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var bech32 = __webpack_require__(649);

function convertbits(data, frombits, tobits, pad) {
  var acc = 0;
  var bits = 0;
  var ret = [];
  var maxv = (1 << tobits) - 1;
  for (var p = 0; p < data.length; ++p) {
    var value = data[p];
    if (value < 0 || value >> frombits !== 0) {
      return null;
    }
    acc = acc << frombits | value;
    bits += frombits;
    while (bits >= tobits) {
      bits -= tobits;
      ret.push(acc >> bits & maxv);
    }
  }
  if (pad) {
    if (bits > 0) {
      ret.push(acc << tobits - bits & maxv);
    }
  } else if (bits >= frombits || acc << tobits - bits & maxv) {
    return null;
  }
  return ret;
}

function decode(hrp, addr) {
  var dec = bech32.decode(addr);
  if (dec === null || dec.hrp !== hrp || dec.data.length < 1 || dec.data[0] > 16) {
    return null;
  }
  var res = convertbits(dec.data.slice(1), 5, 8, false);
  if (res === null || res.length < 2 || res.length > 40) {
    return null;
  }
  if (dec.data[0] === 0 && res.length !== 20 && res.length !== 32) {
    return null;
  }
  return { version: dec.data[0], program: res };
}

function encode(hrp, version, program) {
  var ret = bech32.encode(hrp, [version].concat(convertbits(program, 8, 5, true)));
  if (decode(hrp, ret) === null) {
    return null;
  }
  return ret;
}

function isValidAddress(address) {
  var hrp = 'bc';
  var ret = decode(hrp, address);

  if (ret === null) {
    hrp = 'tb';
    ret = decode(hrp, address);
  }

  if (ret === null) {
    return false;
  }

  var recreate = encode(hrp, ret.version, ret.program);
  return recreate === address.toLowerCase();
}

module.exports = {
  encode: encode,
  decode: decode,
  isValidAddress: isValidAddress
};

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

var cbor = __webpack_require__(1473);
var CRC = __webpack_require__(650);
var base58 = __webpack_require__(370);

function getDecoded(address) {
    try {
        var decoded = base58.decode(address);
        return cbor.decode(new Uint8Array(decoded).buffer);
    } catch (e) {
        // if decoding fails, assume invalid address
        return null;
    }
}

module.exports = {
    isValidAddress: function isValidAddress(address) {
        var decoded = getDecoded(address);

        if (!decoded || !Array.isArray(decoded) && decoded.length != 2) {
            return false;
        }

        var tagged = decoded[0];
        var validCrc = decoded[1];
        if (typeof validCrc != 'number') {
            return false;
        }

        // get crc of the payload
        var crc = CRC.crc32(tagged);

        return crc == validCrc;
    }
};

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Patrick Gansterer <paroga@paroga.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

(function(global, undefined) { "use strict";
var POW_2_24 = Math.pow(2, -24),
    POW_2_32 = Math.pow(2, 32),
    POW_2_53 = Math.pow(2, 53);

function encode(value) {
  var data = new ArrayBuffer(256);
  var dataView = new DataView(data);
  var lastLength;
  var offset = 0;

  function ensureSpace(length) {
    var newByteLength = data.byteLength;
    var requiredLength = offset + length;
    while (newByteLength < requiredLength)
      newByteLength *= 2;
    if (newByteLength !== data.byteLength) {
      var oldDataView = dataView;
      data = new ArrayBuffer(newByteLength);
      dataView = new DataView(data);
      var uint32count = (offset + 3) >> 2;
      for (var i = 0; i < uint32count; ++i)
        dataView.setUint32(i * 4, oldDataView.getUint32(i * 4));
    }

    lastLength = length;
    return dataView;
  }
  function write() {
    offset += lastLength;
  }
  function writeFloat64(value) {
    write(ensureSpace(8).setFloat64(offset, value));
  }
  function writeUint8(value) {
    write(ensureSpace(1).setUint8(offset, value));
  }
  function writeUint8Array(value) {
    var dataView = ensureSpace(value.length);
    for (var i = 0; i < value.length; ++i)
      dataView.setUint8(offset + i, value[i]);
    write();
  }
  function writeUint16(value) {
    write(ensureSpace(2).setUint16(offset, value));
  }
  function writeUint32(value) {
    write(ensureSpace(4).setUint32(offset, value));
  }
  function writeUint64(value) {
    var low = value % POW_2_32;
    var high = (value - low) / POW_2_32;
    var dataView = ensureSpace(8);
    dataView.setUint32(offset, high);
    dataView.setUint32(offset + 4, low);
    write();
  }
  function writeTypeAndLength(type, length) {
    if (length < 24) {
      writeUint8(type << 5 | length);
    } else if (length < 0x100) {
      writeUint8(type << 5 | 24);
      writeUint8(length);
    } else if (length < 0x10000) {
      writeUint8(type << 5 | 25);
      writeUint16(length);
    } else if (length < 0x100000000) {
      writeUint8(type << 5 | 26);
      writeUint32(length);
    } else {
      writeUint8(type << 5 | 27);
      writeUint64(length);
    }
  }
  
  function encodeItem(value) {
    var i;

    if (value === false)
      return writeUint8(0xf4);
    if (value === true)
      return writeUint8(0xf5);
    if (value === null)
      return writeUint8(0xf6);
    if (value === undefined)
      return writeUint8(0xf7);
  
    switch (typeof value) {
      case "number":
        if (Math.floor(value) === value) {
          if (0 <= value && value <= POW_2_53)
            return writeTypeAndLength(0, value);
          if (-POW_2_53 <= value && value < 0)
            return writeTypeAndLength(1, -(value + 1));
        }
        writeUint8(0xfb);
        return writeFloat64(value);

      case "string":
        var utf8data = [];
        for (i = 0; i < value.length; ++i) {
          var charCode = value.charCodeAt(i);
          if (charCode < 0x80) {
            utf8data.push(charCode);
          } else if (charCode < 0x800) {
            utf8data.push(0xc0 | charCode >> 6);
            utf8data.push(0x80 | charCode & 0x3f);
          } else if (charCode < 0xd800) {
            utf8data.push(0xe0 | charCode >> 12);
            utf8data.push(0x80 | (charCode >> 6)  & 0x3f);
            utf8data.push(0x80 | charCode & 0x3f);
          } else {
            charCode = (charCode & 0x3ff) << 10;
            charCode |= value.charCodeAt(++i) & 0x3ff;
            charCode += 0x10000;

            utf8data.push(0xf0 | charCode >> 18);
            utf8data.push(0x80 | (charCode >> 12)  & 0x3f);
            utf8data.push(0x80 | (charCode >> 6)  & 0x3f);
            utf8data.push(0x80 | charCode & 0x3f);
          }
        }

        writeTypeAndLength(3, utf8data.length);
        return writeUint8Array(utf8data);

      default:
        var length;
        if (Array.isArray(value)) {
          length = value.length;
          writeTypeAndLength(4, length);
          for (i = 0; i < length; ++i)
            encodeItem(value[i]);
        } else if (value instanceof Uint8Array) {
          writeTypeAndLength(2, value.length);
          writeUint8Array(value);
        } else {
          var keys = Object.keys(value);
          length = keys.length;
          writeTypeAndLength(5, length);
          for (i = 0; i < length; ++i) {
            var key = keys[i];
            encodeItem(key);
            encodeItem(value[key]);
          }
        }
    }
  }
  
  encodeItem(value);

  if ("slice" in data)
    return data.slice(0, offset);
  
  var ret = new ArrayBuffer(offset);
  var retView = new DataView(ret);
  for (var i = 0; i < offset; ++i)
    retView.setUint8(i, dataView.getUint8(i));
  return ret;
}

function decode(data, tagger, simpleValue) {
  var dataView = new DataView(data);
  var offset = 0;
  
  if (typeof tagger !== "function")
    tagger = function(value) { return value; };
  if (typeof simpleValue !== "function")
    simpleValue = function() { return undefined; };

  function read(value, length) {
    offset += length;
    return value;
  }
  function readArrayBuffer(length) {
    return read(new Uint8Array(data, offset, length), length);
  }
  function readFloat16() {
    var tempArrayBuffer = new ArrayBuffer(4);
    var tempDataView = new DataView(tempArrayBuffer);
    var value = readUint16();

    var sign = value & 0x8000;
    var exponent = value & 0x7c00;
    var fraction = value & 0x03ff;
    
    if (exponent === 0x7c00)
      exponent = 0xff << 10;
    else if (exponent !== 0)
      exponent += (127 - 15) << 10;
    else if (fraction !== 0)
      return fraction * POW_2_24;
    
    tempDataView.setUint32(0, sign << 16 | exponent << 13 | fraction << 13);
    return tempDataView.getFloat32(0);
  }
  function readFloat32() {
    return read(dataView.getFloat32(offset), 4);
  }
  function readFloat64() {
    return read(dataView.getFloat64(offset), 8);
  }
  function readUint8() {
    return read(dataView.getUint8(offset), 1);
  }
  function readUint16() {
    return read(dataView.getUint16(offset), 2);
  }
  function readUint32() {
    return read(dataView.getUint32(offset), 4);
  }
  function readUint64() {
    return readUint32() * POW_2_32 + readUint32();
  }
  function readBreak() {
    if (dataView.getUint8(offset) !== 0xff)
      return false;
    offset += 1;
    return true;
  }
  function readLength(additionalInformation) {
    if (additionalInformation < 24)
      return additionalInformation;
    if (additionalInformation === 24)
      return readUint8();
    if (additionalInformation === 25)
      return readUint16();
    if (additionalInformation === 26)
      return readUint32();
    if (additionalInformation === 27)
      return readUint64();
    if (additionalInformation === 31)
      return -1;
    throw "Invalid length encoding";
  }
  function readIndefiniteStringLength(majorType) {
    var initialByte = readUint8();
    if (initialByte === 0xff)
      return -1;
    var length = readLength(initialByte & 0x1f);
    if (length < 0 || (initialByte >> 5) !== majorType)
      throw "Invalid indefinite length element";
    return length;
  }

  function appendUtf16data(utf16data, length) {
    for (var i = 0; i < length; ++i) {
      var value = readUint8();
      if (value & 0x80) {
        if (value < 0xe0) {
          value = (value & 0x1f) <<  6
                | (readUint8() & 0x3f);
          length -= 1;
        } else if (value < 0xf0) {
          value = (value & 0x0f) << 12
                | (readUint8() & 0x3f) << 6
                | (readUint8() & 0x3f);
          length -= 2;
        } else {
          value = (value & 0x0f) << 18
                | (readUint8() & 0x3f) << 12
                | (readUint8() & 0x3f) << 6
                | (readUint8() & 0x3f);
          length -= 3;
        }
      }

      if (value < 0x10000) {
        utf16data.push(value);
      } else {
        value -= 0x10000;
        utf16data.push(0xd800 | (value >> 10));
        utf16data.push(0xdc00 | (value & 0x3ff));
      }
    }
  }

  function decodeItem() {
    var initialByte = readUint8();
    var majorType = initialByte >> 5;
    var additionalInformation = initialByte & 0x1f;
    var i;
    var length;

    if (majorType === 7) {
      switch (additionalInformation) {
        case 25:
          return readFloat16();
        case 26:
          return readFloat32();
        case 27:
          return readFloat64();
      }
    }

    length = readLength(additionalInformation);
    if (length < 0 && (majorType < 2 || 6 < majorType))
      throw "Invalid length";

    switch (majorType) {
      case 0:
        return length;
      case 1:
        return -1 - length;
      case 2:
        if (length < 0) {
          var elements = [];
          var fullArrayLength = 0;
          while ((length = readIndefiniteStringLength(majorType)) >= 0) {
            fullArrayLength += length;
            elements.push(readArrayBuffer(length));
          }
          var fullArray = new Uint8Array(fullArrayLength);
          var fullArrayOffset = 0;
          for (i = 0; i < elements.length; ++i) {
            fullArray.set(elements[i], fullArrayOffset);
            fullArrayOffset += elements[i].length;
          }
          return fullArray;
        }
        return readArrayBuffer(length);
      case 3:
        var utf16data = [];
        if (length < 0) {
          while ((length = readIndefiniteStringLength(majorType)) >= 0)
            appendUtf16data(utf16data, length);
        } else
          appendUtf16data(utf16data, length);
        return String.fromCharCode.apply(null, utf16data);
      case 4:
        var retArray;
        if (length < 0) {
          retArray = [];
          while (!readBreak())
            retArray.push(decodeItem());
        } else {
          retArray = new Array(length);
          for (i = 0; i < length; ++i)
            retArray[i] = decodeItem();
        }
        return retArray;
      case 5:
        var retObject = {};
        for (i = 0; i < length || length < 0 && !readBreak(); ++i) {
          var key = decodeItem();
          retObject[key] = decodeItem();
        }
        return retObject;
      case 6:
        return tagger(decodeItem(), length);
      case 7:
        switch (length) {
          case 20:
            return false;
          case 21:
            return true;
          case 22:
            return null;
          case 23:
            return undefined;
          default:
            return simpleValue(length);
        }
    }
  }

  var ret = decodeItem();
  if (offset !== data.byteLength)
    throw "Remaining bytes";
  return ret;
}

var obj = { encode: encode, decode: decode };

if (true)
  !(__WEBPACK_AMD_DEFINE_FACTORY__ = (obj),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
else if (typeof module !== 'undefined' && module.exports)
  module.exports = obj;
else if (!global.CBOR)
  global.CBOR = obj;

})(this);


/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




var crc1 = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('crc1', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = ~~previous;
  var accum = 0;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    accum += byte;
  }

  crc += accum % 256;
  return crc % 256;
});

/* harmony default export */ __webpack_exports__["a"] = (crc1);

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-driven --model=crc-8 --generate=c`
// prettier-ignore
var TABLE = [0x00, 0x07, 0x0e, 0x09, 0x1c, 0x1b, 0x12, 0x15, 0x38, 0x3f, 0x36, 0x31, 0x24, 0x23, 0x2a, 0x2d, 0x70, 0x77, 0x7e, 0x79, 0x6c, 0x6b, 0x62, 0x65, 0x48, 0x4f, 0x46, 0x41, 0x54, 0x53, 0x5a, 0x5d, 0xe0, 0xe7, 0xee, 0xe9, 0xfc, 0xfb, 0xf2, 0xf5, 0xd8, 0xdf, 0xd6, 0xd1, 0xc4, 0xc3, 0xca, 0xcd, 0x90, 0x97, 0x9e, 0x99, 0x8c, 0x8b, 0x82, 0x85, 0xa8, 0xaf, 0xa6, 0xa1, 0xb4, 0xb3, 0xba, 0xbd, 0xc7, 0xc0, 0xc9, 0xce, 0xdb, 0xdc, 0xd5, 0xd2, 0xff, 0xf8, 0xf1, 0xf6, 0xe3, 0xe4, 0xed, 0xea, 0xb7, 0xb0, 0xb9, 0xbe, 0xab, 0xac, 0xa5, 0xa2, 0x8f, 0x88, 0x81, 0x86, 0x93, 0x94, 0x9d, 0x9a, 0x27, 0x20, 0x29, 0x2e, 0x3b, 0x3c, 0x35, 0x32, 0x1f, 0x18, 0x11, 0x16, 0x03, 0x04, 0x0d, 0x0a, 0x57, 0x50, 0x59, 0x5e, 0x4b, 0x4c, 0x45, 0x42, 0x6f, 0x68, 0x61, 0x66, 0x73, 0x74, 0x7d, 0x7a, 0x89, 0x8e, 0x87, 0x80, 0x95, 0x92, 0x9b, 0x9c, 0xb1, 0xb6, 0xbf, 0xb8, 0xad, 0xaa, 0xa3, 0xa4, 0xf9, 0xfe, 0xf7, 0xf0, 0xe5, 0xe2, 0xeb, 0xec, 0xc1, 0xc6, 0xcf, 0xc8, 0xdd, 0xda, 0xd3, 0xd4, 0x69, 0x6e, 0x67, 0x60, 0x75, 0x72, 0x7b, 0x7c, 0x51, 0x56, 0x5f, 0x58, 0x4d, 0x4a, 0x43, 0x44, 0x19, 0x1e, 0x17, 0x10, 0x05, 0x02, 0x0b, 0x0c, 0x21, 0x26, 0x2f, 0x28, 0x3d, 0x3a, 0x33, 0x34, 0x4e, 0x49, 0x40, 0x47, 0x52, 0x55, 0x5c, 0x5b, 0x76, 0x71, 0x78, 0x7f, 0x6a, 0x6d, 0x64, 0x63, 0x3e, 0x39, 0x30, 0x37, 0x22, 0x25, 0x2c, 0x2b, 0x06, 0x01, 0x08, 0x0f, 0x1a, 0x1d, 0x14, 0x13, 0xae, 0xa9, 0xa0, 0xa7, 0xb2, 0xb5, 0xbc, 0xbb, 0x96, 0x91, 0x98, 0x9f, 0x8a, 0x8d, 0x84, 0x83, 0xde, 0xd9, 0xd0, 0xd7, 0xc2, 0xc5, 0xcc, 0xcb, 0xe6, 0xe1, 0xe8, 0xef, 0xfa, 0xfd, 0xf4, 0xf3];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crc8 = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('crc-8', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = ~~previous;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = TABLE[(crc ^ byte) & 0xff] & 0xff;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crc8);

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-driven --model=dallas-1-wire --generate=c`
// prettier-ignore
var TABLE = [0x00, 0x5e, 0xbc, 0xe2, 0x61, 0x3f, 0xdd, 0x83, 0xc2, 0x9c, 0x7e, 0x20, 0xa3, 0xfd, 0x1f, 0x41, 0x9d, 0xc3, 0x21, 0x7f, 0xfc, 0xa2, 0x40, 0x1e, 0x5f, 0x01, 0xe3, 0xbd, 0x3e, 0x60, 0x82, 0xdc, 0x23, 0x7d, 0x9f, 0xc1, 0x42, 0x1c, 0xfe, 0xa0, 0xe1, 0xbf, 0x5d, 0x03, 0x80, 0xde, 0x3c, 0x62, 0xbe, 0xe0, 0x02, 0x5c, 0xdf, 0x81, 0x63, 0x3d, 0x7c, 0x22, 0xc0, 0x9e, 0x1d, 0x43, 0xa1, 0xff, 0x46, 0x18, 0xfa, 0xa4, 0x27, 0x79, 0x9b, 0xc5, 0x84, 0xda, 0x38, 0x66, 0xe5, 0xbb, 0x59, 0x07, 0xdb, 0x85, 0x67, 0x39, 0xba, 0xe4, 0x06, 0x58, 0x19, 0x47, 0xa5, 0xfb, 0x78, 0x26, 0xc4, 0x9a, 0x65, 0x3b, 0xd9, 0x87, 0x04, 0x5a, 0xb8, 0xe6, 0xa7, 0xf9, 0x1b, 0x45, 0xc6, 0x98, 0x7a, 0x24, 0xf8, 0xa6, 0x44, 0x1a, 0x99, 0xc7, 0x25, 0x7b, 0x3a, 0x64, 0x86, 0xd8, 0x5b, 0x05, 0xe7, 0xb9, 0x8c, 0xd2, 0x30, 0x6e, 0xed, 0xb3, 0x51, 0x0f, 0x4e, 0x10, 0xf2, 0xac, 0x2f, 0x71, 0x93, 0xcd, 0x11, 0x4f, 0xad, 0xf3, 0x70, 0x2e, 0xcc, 0x92, 0xd3, 0x8d, 0x6f, 0x31, 0xb2, 0xec, 0x0e, 0x50, 0xaf, 0xf1, 0x13, 0x4d, 0xce, 0x90, 0x72, 0x2c, 0x6d, 0x33, 0xd1, 0x8f, 0x0c, 0x52, 0xb0, 0xee, 0x32, 0x6c, 0x8e, 0xd0, 0x53, 0x0d, 0xef, 0xb1, 0xf0, 0xae, 0x4c, 0x12, 0x91, 0xcf, 0x2d, 0x73, 0xca, 0x94, 0x76, 0x28, 0xab, 0xf5, 0x17, 0x49, 0x08, 0x56, 0xb4, 0xea, 0x69, 0x37, 0xd5, 0x8b, 0x57, 0x09, 0xeb, 0xb5, 0x36, 0x68, 0x8a, 0xd4, 0x95, 0xcb, 0x29, 0x77, 0xf4, 0xaa, 0x48, 0x16, 0xe9, 0xb7, 0x55, 0x0b, 0x88, 0xd6, 0x34, 0x6a, 0x2b, 0x75, 0x97, 0xc9, 0x4a, 0x14, 0xf6, 0xa8, 0x74, 0x2a, 0xc8, 0x96, 0x15, 0x4b, 0xa9, 0xf7, 0xb6, 0xe8, 0x0a, 0x54, 0xd7, 0x89, 0x6b, 0x35];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crc81wire = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('dallas-1-wire', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = ~~previous;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = TABLE[(crc ^ byte) & 0xff] & 0xff;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crc81wire);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-driven --model=crc-16 --generate=c`
// prettier-ignore
var TABLE = [0x0000, 0xc0c1, 0xc181, 0x0140, 0xc301, 0x03c0, 0x0280, 0xc241, 0xc601, 0x06c0, 0x0780, 0xc741, 0x0500, 0xc5c1, 0xc481, 0x0440, 0xcc01, 0x0cc0, 0x0d80, 0xcd41, 0x0f00, 0xcfc1, 0xce81, 0x0e40, 0x0a00, 0xcac1, 0xcb81, 0x0b40, 0xc901, 0x09c0, 0x0880, 0xc841, 0xd801, 0x18c0, 0x1980, 0xd941, 0x1b00, 0xdbc1, 0xda81, 0x1a40, 0x1e00, 0xdec1, 0xdf81, 0x1f40, 0xdd01, 0x1dc0, 0x1c80, 0xdc41, 0x1400, 0xd4c1, 0xd581, 0x1540, 0xd701, 0x17c0, 0x1680, 0xd641, 0xd201, 0x12c0, 0x1380, 0xd341, 0x1100, 0xd1c1, 0xd081, 0x1040, 0xf001, 0x30c0, 0x3180, 0xf141, 0x3300, 0xf3c1, 0xf281, 0x3240, 0x3600, 0xf6c1, 0xf781, 0x3740, 0xf501, 0x35c0, 0x3480, 0xf441, 0x3c00, 0xfcc1, 0xfd81, 0x3d40, 0xff01, 0x3fc0, 0x3e80, 0xfe41, 0xfa01, 0x3ac0, 0x3b80, 0xfb41, 0x3900, 0xf9c1, 0xf881, 0x3840, 0x2800, 0xe8c1, 0xe981, 0x2940, 0xeb01, 0x2bc0, 0x2a80, 0xea41, 0xee01, 0x2ec0, 0x2f80, 0xef41, 0x2d00, 0xedc1, 0xec81, 0x2c40, 0xe401, 0x24c0, 0x2580, 0xe541, 0x2700, 0xe7c1, 0xe681, 0x2640, 0x2200, 0xe2c1, 0xe381, 0x2340, 0xe101, 0x21c0, 0x2080, 0xe041, 0xa001, 0x60c0, 0x6180, 0xa141, 0x6300, 0xa3c1, 0xa281, 0x6240, 0x6600, 0xa6c1, 0xa781, 0x6740, 0xa501, 0x65c0, 0x6480, 0xa441, 0x6c00, 0xacc1, 0xad81, 0x6d40, 0xaf01, 0x6fc0, 0x6e80, 0xae41, 0xaa01, 0x6ac0, 0x6b80, 0xab41, 0x6900, 0xa9c1, 0xa881, 0x6840, 0x7800, 0xb8c1, 0xb981, 0x7940, 0xbb01, 0x7bc0, 0x7a80, 0xba41, 0xbe01, 0x7ec0, 0x7f80, 0xbf41, 0x7d00, 0xbdc1, 0xbc81, 0x7c40, 0xb401, 0x74c0, 0x7580, 0xb541, 0x7700, 0xb7c1, 0xb681, 0x7640, 0x7200, 0xb2c1, 0xb381, 0x7340, 0xb101, 0x71c0, 0x7080, 0xb041, 0x5000, 0x90c1, 0x9181, 0x5140, 0x9301, 0x53c0, 0x5280, 0x9241, 0x9601, 0x56c0, 0x5780, 0x9741, 0x5500, 0x95c1, 0x9481, 0x5440, 0x9c01, 0x5cc0, 0x5d80, 0x9d41, 0x5f00, 0x9fc1, 0x9e81, 0x5e40, 0x5a00, 0x9ac1, 0x9b81, 0x5b40, 0x9901, 0x59c0, 0x5880, 0x9841, 0x8801, 0x48c0, 0x4980, 0x8941, 0x4b00, 0x8bc1, 0x8a81, 0x4a40, 0x4e00, 0x8ec1, 0x8f81, 0x4f40, 0x8d01, 0x4dc0, 0x4c80, 0x8c41, 0x4400, 0x84c1, 0x8581, 0x4540, 0x8701, 0x47c0, 0x4680, 0x8641, 0x8201, 0x42c0, 0x4380, 0x8341, 0x4100, 0x81c1, 0x8081, 0x4040];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crc16 = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('crc-16', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = ~~previous;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = (TABLE[(crc ^ byte) & 0xff] ^ crc >> 8) & 0xffff;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crc16);

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-driven --model=ccitt --generate=c`
// prettier-ignore
var TABLE = [0x0000, 0x1021, 0x2042, 0x3063, 0x4084, 0x50a5, 0x60c6, 0x70e7, 0x8108, 0x9129, 0xa14a, 0xb16b, 0xc18c, 0xd1ad, 0xe1ce, 0xf1ef, 0x1231, 0x0210, 0x3273, 0x2252, 0x52b5, 0x4294, 0x72f7, 0x62d6, 0x9339, 0x8318, 0xb37b, 0xa35a, 0xd3bd, 0xc39c, 0xf3ff, 0xe3de, 0x2462, 0x3443, 0x0420, 0x1401, 0x64e6, 0x74c7, 0x44a4, 0x5485, 0xa56a, 0xb54b, 0x8528, 0x9509, 0xe5ee, 0xf5cf, 0xc5ac, 0xd58d, 0x3653, 0x2672, 0x1611, 0x0630, 0x76d7, 0x66f6, 0x5695, 0x46b4, 0xb75b, 0xa77a, 0x9719, 0x8738, 0xf7df, 0xe7fe, 0xd79d, 0xc7bc, 0x48c4, 0x58e5, 0x6886, 0x78a7, 0x0840, 0x1861, 0x2802, 0x3823, 0xc9cc, 0xd9ed, 0xe98e, 0xf9af, 0x8948, 0x9969, 0xa90a, 0xb92b, 0x5af5, 0x4ad4, 0x7ab7, 0x6a96, 0x1a71, 0x0a50, 0x3a33, 0x2a12, 0xdbfd, 0xcbdc, 0xfbbf, 0xeb9e, 0x9b79, 0x8b58, 0xbb3b, 0xab1a, 0x6ca6, 0x7c87, 0x4ce4, 0x5cc5, 0x2c22, 0x3c03, 0x0c60, 0x1c41, 0xedae, 0xfd8f, 0xcdec, 0xddcd, 0xad2a, 0xbd0b, 0x8d68, 0x9d49, 0x7e97, 0x6eb6, 0x5ed5, 0x4ef4, 0x3e13, 0x2e32, 0x1e51, 0x0e70, 0xff9f, 0xefbe, 0xdfdd, 0xcffc, 0xbf1b, 0xaf3a, 0x9f59, 0x8f78, 0x9188, 0x81a9, 0xb1ca, 0xa1eb, 0xd10c, 0xc12d, 0xf14e, 0xe16f, 0x1080, 0x00a1, 0x30c2, 0x20e3, 0x5004, 0x4025, 0x7046, 0x6067, 0x83b9, 0x9398, 0xa3fb, 0xb3da, 0xc33d, 0xd31c, 0xe37f, 0xf35e, 0x02b1, 0x1290, 0x22f3, 0x32d2, 0x4235, 0x5214, 0x6277, 0x7256, 0xb5ea, 0xa5cb, 0x95a8, 0x8589, 0xf56e, 0xe54f, 0xd52c, 0xc50d, 0x34e2, 0x24c3, 0x14a0, 0x0481, 0x7466, 0x6447, 0x5424, 0x4405, 0xa7db, 0xb7fa, 0x8799, 0x97b8, 0xe75f, 0xf77e, 0xc71d, 0xd73c, 0x26d3, 0x36f2, 0x0691, 0x16b0, 0x6657, 0x7676, 0x4615, 0x5634, 0xd94c, 0xc96d, 0xf90e, 0xe92f, 0x99c8, 0x89e9, 0xb98a, 0xa9ab, 0x5844, 0x4865, 0x7806, 0x6827, 0x18c0, 0x08e1, 0x3882, 0x28a3, 0xcb7d, 0xdb5c, 0xeb3f, 0xfb1e, 0x8bf9, 0x9bd8, 0xabbb, 0xbb9a, 0x4a75, 0x5a54, 0x6a37, 0x7a16, 0x0af1, 0x1ad0, 0x2ab3, 0x3a92, 0xfd2e, 0xed0f, 0xdd6c, 0xcd4d, 0xbdaa, 0xad8b, 0x9de8, 0x8dc9, 0x7c26, 0x6c07, 0x5c64, 0x4c45, 0x3ca2, 0x2c83, 0x1ce0, 0x0cc1, 0xef1f, 0xff3e, 0xcf5d, 0xdf7c, 0xaf9b, 0xbfba, 0x8fd9, 0x9ff8, 0x6e17, 0x7e36, 0x4e55, 0x5e74, 0x2e93, 0x3eb2, 0x0ed1, 0x1ef0];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crc16ccitt = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('ccitt', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = typeof previous !== 'undefined' ? ~~previous : 0xffff;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = (TABLE[(crc >> 8 ^ byte) & 0xff] ^ crc << 8) & 0xffff;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crc16ccitt);

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-driven --model=crc-16-modbus --generate=c`
// prettier-ignore
var TABLE = [0x0000, 0xc0c1, 0xc181, 0x0140, 0xc301, 0x03c0, 0x0280, 0xc241, 0xc601, 0x06c0, 0x0780, 0xc741, 0x0500, 0xc5c1, 0xc481, 0x0440, 0xcc01, 0x0cc0, 0x0d80, 0xcd41, 0x0f00, 0xcfc1, 0xce81, 0x0e40, 0x0a00, 0xcac1, 0xcb81, 0x0b40, 0xc901, 0x09c0, 0x0880, 0xc841, 0xd801, 0x18c0, 0x1980, 0xd941, 0x1b00, 0xdbc1, 0xda81, 0x1a40, 0x1e00, 0xdec1, 0xdf81, 0x1f40, 0xdd01, 0x1dc0, 0x1c80, 0xdc41, 0x1400, 0xd4c1, 0xd581, 0x1540, 0xd701, 0x17c0, 0x1680, 0xd641, 0xd201, 0x12c0, 0x1380, 0xd341, 0x1100, 0xd1c1, 0xd081, 0x1040, 0xf001, 0x30c0, 0x3180, 0xf141, 0x3300, 0xf3c1, 0xf281, 0x3240, 0x3600, 0xf6c1, 0xf781, 0x3740, 0xf501, 0x35c0, 0x3480, 0xf441, 0x3c00, 0xfcc1, 0xfd81, 0x3d40, 0xff01, 0x3fc0, 0x3e80, 0xfe41, 0xfa01, 0x3ac0, 0x3b80, 0xfb41, 0x3900, 0xf9c1, 0xf881, 0x3840, 0x2800, 0xe8c1, 0xe981, 0x2940, 0xeb01, 0x2bc0, 0x2a80, 0xea41, 0xee01, 0x2ec0, 0x2f80, 0xef41, 0x2d00, 0xedc1, 0xec81, 0x2c40, 0xe401, 0x24c0, 0x2580, 0xe541, 0x2700, 0xe7c1, 0xe681, 0x2640, 0x2200, 0xe2c1, 0xe381, 0x2340, 0xe101, 0x21c0, 0x2080, 0xe041, 0xa001, 0x60c0, 0x6180, 0xa141, 0x6300, 0xa3c1, 0xa281, 0x6240, 0x6600, 0xa6c1, 0xa781, 0x6740, 0xa501, 0x65c0, 0x6480, 0xa441, 0x6c00, 0xacc1, 0xad81, 0x6d40, 0xaf01, 0x6fc0, 0x6e80, 0xae41, 0xaa01, 0x6ac0, 0x6b80, 0xab41, 0x6900, 0xa9c1, 0xa881, 0x6840, 0x7800, 0xb8c1, 0xb981, 0x7940, 0xbb01, 0x7bc0, 0x7a80, 0xba41, 0xbe01, 0x7ec0, 0x7f80, 0xbf41, 0x7d00, 0xbdc1, 0xbc81, 0x7c40, 0xb401, 0x74c0, 0x7580, 0xb541, 0x7700, 0xb7c1, 0xb681, 0x7640, 0x7200, 0xb2c1, 0xb381, 0x7340, 0xb101, 0x71c0, 0x7080, 0xb041, 0x5000, 0x90c1, 0x9181, 0x5140, 0x9301, 0x53c0, 0x5280, 0x9241, 0x9601, 0x56c0, 0x5780, 0x9741, 0x5500, 0x95c1, 0x9481, 0x5440, 0x9c01, 0x5cc0, 0x5d80, 0x9d41, 0x5f00, 0x9fc1, 0x9e81, 0x5e40, 0x5a00, 0x9ac1, 0x9b81, 0x5b40, 0x9901, 0x59c0, 0x5880, 0x9841, 0x8801, 0x48c0, 0x4980, 0x8941, 0x4b00, 0x8bc1, 0x8a81, 0x4a40, 0x4e00, 0x8ec1, 0x8f81, 0x4f40, 0x8d01, 0x4dc0, 0x4c80, 0x8c41, 0x4400, 0x84c1, 0x8581, 0x4540, 0x8701, 0x47c0, 0x4680, 0x8641, 0x8201, 0x42c0, 0x4380, 0x8341, 0x4100, 0x81c1, 0x8081, 0x4040];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crc16modbus = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('crc-16-modbus', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = typeof previous !== 'undefined' ? ~~previous : 0xffff;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = (TABLE[(crc ^ byte) & 0xff] ^ crc >> 8) & 0xffff;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crc16modbus);

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




var crc16xmodem = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('xmodem', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = typeof previous !== 'undefined' ? ~~previous : 0x0;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    var code = crc >>> 8 & 0xff;

    code ^= byte & 0xff;
    code ^= code >>> 4;
    crc = crc << 8 & 0xffff;
    crc ^= code;
    code = code << 5 & 0xffff;
    crc ^= code;
    code = code << 7 & 0xffff;
    crc ^= code;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crc16xmodem);

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-driven --model=kermit --generate=c`
// prettier-ignore
var TABLE = [0x0000, 0x1189, 0x2312, 0x329b, 0x4624, 0x57ad, 0x6536, 0x74bf, 0x8c48, 0x9dc1, 0xaf5a, 0xbed3, 0xca6c, 0xdbe5, 0xe97e, 0xf8f7, 0x1081, 0x0108, 0x3393, 0x221a, 0x56a5, 0x472c, 0x75b7, 0x643e, 0x9cc9, 0x8d40, 0xbfdb, 0xae52, 0xdaed, 0xcb64, 0xf9ff, 0xe876, 0x2102, 0x308b, 0x0210, 0x1399, 0x6726, 0x76af, 0x4434, 0x55bd, 0xad4a, 0xbcc3, 0x8e58, 0x9fd1, 0xeb6e, 0xfae7, 0xc87c, 0xd9f5, 0x3183, 0x200a, 0x1291, 0x0318, 0x77a7, 0x662e, 0x54b5, 0x453c, 0xbdcb, 0xac42, 0x9ed9, 0x8f50, 0xfbef, 0xea66, 0xd8fd, 0xc974, 0x4204, 0x538d, 0x6116, 0x709f, 0x0420, 0x15a9, 0x2732, 0x36bb, 0xce4c, 0xdfc5, 0xed5e, 0xfcd7, 0x8868, 0x99e1, 0xab7a, 0xbaf3, 0x5285, 0x430c, 0x7197, 0x601e, 0x14a1, 0x0528, 0x37b3, 0x263a, 0xdecd, 0xcf44, 0xfddf, 0xec56, 0x98e9, 0x8960, 0xbbfb, 0xaa72, 0x6306, 0x728f, 0x4014, 0x519d, 0x2522, 0x34ab, 0x0630, 0x17b9, 0xef4e, 0xfec7, 0xcc5c, 0xddd5, 0xa96a, 0xb8e3, 0x8a78, 0x9bf1, 0x7387, 0x620e, 0x5095, 0x411c, 0x35a3, 0x242a, 0x16b1, 0x0738, 0xffcf, 0xee46, 0xdcdd, 0xcd54, 0xb9eb, 0xa862, 0x9af9, 0x8b70, 0x8408, 0x9581, 0xa71a, 0xb693, 0xc22c, 0xd3a5, 0xe13e, 0xf0b7, 0x0840, 0x19c9, 0x2b52, 0x3adb, 0x4e64, 0x5fed, 0x6d76, 0x7cff, 0x9489, 0x8500, 0xb79b, 0xa612, 0xd2ad, 0xc324, 0xf1bf, 0xe036, 0x18c1, 0x0948, 0x3bd3, 0x2a5a, 0x5ee5, 0x4f6c, 0x7df7, 0x6c7e, 0xa50a, 0xb483, 0x8618, 0x9791, 0xe32e, 0xf2a7, 0xc03c, 0xd1b5, 0x2942, 0x38cb, 0x0a50, 0x1bd9, 0x6f66, 0x7eef, 0x4c74, 0x5dfd, 0xb58b, 0xa402, 0x9699, 0x8710, 0xf3af, 0xe226, 0xd0bd, 0xc134, 0x39c3, 0x284a, 0x1ad1, 0x0b58, 0x7fe7, 0x6e6e, 0x5cf5, 0x4d7c, 0xc60c, 0xd785, 0xe51e, 0xf497, 0x8028, 0x91a1, 0xa33a, 0xb2b3, 0x4a44, 0x5bcd, 0x6956, 0x78df, 0x0c60, 0x1de9, 0x2f72, 0x3efb, 0xd68d, 0xc704, 0xf59f, 0xe416, 0x90a9, 0x8120, 0xb3bb, 0xa232, 0x5ac5, 0x4b4c, 0x79d7, 0x685e, 0x1ce1, 0x0d68, 0x3ff3, 0x2e7a, 0xe70e, 0xf687, 0xc41c, 0xd595, 0xa12a, 0xb0a3, 0x8238, 0x93b1, 0x6b46, 0x7acf, 0x4854, 0x59dd, 0x2d62, 0x3ceb, 0x0e70, 0x1ff9, 0xf78f, 0xe606, 0xd49d, 0xc514, 0xb1ab, 0xa022, 0x92b9, 0x8330, 0x7bc7, 0x6a4e, 0x58d5, 0x495c, 0x3de3, 0x2c6a, 0x1ef1, 0x0f78];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crc16kermit = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('kermit', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = typeof previous !== 'undefined' ? ~~previous : 0x0000;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = (TABLE[(crc ^ byte) & 0xff] ^ crc >> 8) & 0xffff;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crc16kermit);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-drive --model=crc-24 --generate=c`
// prettier-ignore
var TABLE = [0x000000, 0x864cfb, 0x8ad50d, 0x0c99f6, 0x93e6e1, 0x15aa1a, 0x1933ec, 0x9f7f17, 0xa18139, 0x27cdc2, 0x2b5434, 0xad18cf, 0x3267d8, 0xb42b23, 0xb8b2d5, 0x3efe2e, 0xc54e89, 0x430272, 0x4f9b84, 0xc9d77f, 0x56a868, 0xd0e493, 0xdc7d65, 0x5a319e, 0x64cfb0, 0xe2834b, 0xee1abd, 0x685646, 0xf72951, 0x7165aa, 0x7dfc5c, 0xfbb0a7, 0x0cd1e9, 0x8a9d12, 0x8604e4, 0x00481f, 0x9f3708, 0x197bf3, 0x15e205, 0x93aefe, 0xad50d0, 0x2b1c2b, 0x2785dd, 0xa1c926, 0x3eb631, 0xb8faca, 0xb4633c, 0x322fc7, 0xc99f60, 0x4fd39b, 0x434a6d, 0xc50696, 0x5a7981, 0xdc357a, 0xd0ac8c, 0x56e077, 0x681e59, 0xee52a2, 0xe2cb54, 0x6487af, 0xfbf8b8, 0x7db443, 0x712db5, 0xf7614e, 0x19a3d2, 0x9fef29, 0x9376df, 0x153a24, 0x8a4533, 0x0c09c8, 0x00903e, 0x86dcc5, 0xb822eb, 0x3e6e10, 0x32f7e6, 0xb4bb1d, 0x2bc40a, 0xad88f1, 0xa11107, 0x275dfc, 0xdced5b, 0x5aa1a0, 0x563856, 0xd074ad, 0x4f0bba, 0xc94741, 0xc5deb7, 0x43924c, 0x7d6c62, 0xfb2099, 0xf7b96f, 0x71f594, 0xee8a83, 0x68c678, 0x645f8e, 0xe21375, 0x15723b, 0x933ec0, 0x9fa736, 0x19ebcd, 0x8694da, 0x00d821, 0x0c41d7, 0x8a0d2c, 0xb4f302, 0x32bff9, 0x3e260f, 0xb86af4, 0x2715e3, 0xa15918, 0xadc0ee, 0x2b8c15, 0xd03cb2, 0x567049, 0x5ae9bf, 0xdca544, 0x43da53, 0xc596a8, 0xc90f5e, 0x4f43a5, 0x71bd8b, 0xf7f170, 0xfb6886, 0x7d247d, 0xe25b6a, 0x641791, 0x688e67, 0xeec29c, 0x3347a4, 0xb50b5f, 0xb992a9, 0x3fde52, 0xa0a145, 0x26edbe, 0x2a7448, 0xac38b3, 0x92c69d, 0x148a66, 0x181390, 0x9e5f6b, 0x01207c, 0x876c87, 0x8bf571, 0x0db98a, 0xf6092d, 0x7045d6, 0x7cdc20, 0xfa90db, 0x65efcc, 0xe3a337, 0xef3ac1, 0x69763a, 0x578814, 0xd1c4ef, 0xdd5d19, 0x5b11e2, 0xc46ef5, 0x42220e, 0x4ebbf8, 0xc8f703, 0x3f964d, 0xb9dab6, 0xb54340, 0x330fbb, 0xac70ac, 0x2a3c57, 0x26a5a1, 0xa0e95a, 0x9e1774, 0x185b8f, 0x14c279, 0x928e82, 0x0df195, 0x8bbd6e, 0x872498, 0x016863, 0xfad8c4, 0x7c943f, 0x700dc9, 0xf64132, 0x693e25, 0xef72de, 0xe3eb28, 0x65a7d3, 0x5b59fd, 0xdd1506, 0xd18cf0, 0x57c00b, 0xc8bf1c, 0x4ef3e7, 0x426a11, 0xc426ea, 0x2ae476, 0xaca88d, 0xa0317b, 0x267d80, 0xb90297, 0x3f4e6c, 0x33d79a, 0xb59b61, 0x8b654f, 0x0d29b4, 0x01b042, 0x87fcb9, 0x1883ae, 0x9ecf55, 0x9256a3, 0x141a58, 0xefaaff, 0x69e604, 0x657ff2, 0xe33309, 0x7c4c1e, 0xfa00e5, 0xf69913, 0x70d5e8, 0x4e2bc6, 0xc8673d, 0xc4fecb, 0x42b230, 0xddcd27, 0x5b81dc, 0x57182a, 0xd154d1, 0x26359f, 0xa07964, 0xace092, 0x2aac69, 0xb5d37e, 0x339f85, 0x3f0673, 0xb94a88, 0x87b4a6, 0x01f85d, 0x0d61ab, 0x8b2d50, 0x145247, 0x921ebc, 0x9e874a, 0x18cbb1, 0xe37b16, 0x6537ed, 0x69ae1b, 0xefe2e0, 0x709df7, 0xf6d10c, 0xfa48fa, 0x7c0401, 0x42fa2f, 0xc4b6d4, 0xc82f22, 0x4e63d9, 0xd11cce, 0x575035, 0x5bc9c3, 0xdd8538];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crc24 = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('crc-24', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = typeof previous !== 'undefined' ? ~~previous : 0xb704ce;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = (TABLE[(crc >> 16 ^ byte) & 0xff] ^ crc << 8) & 0xffffff;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crc24);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-driven --model=crc-32 --generate=c`
// prettier-ignore
var TABLE = [0x00000000, 0x77073096, 0xee0e612c, 0x990951ba, 0x076dc419, 0x706af48f, 0xe963a535, 0x9e6495a3, 0x0edb8832, 0x79dcb8a4, 0xe0d5e91e, 0x97d2d988, 0x09b64c2b, 0x7eb17cbd, 0xe7b82d07, 0x90bf1d91, 0x1db71064, 0x6ab020f2, 0xf3b97148, 0x84be41de, 0x1adad47d, 0x6ddde4eb, 0xf4d4b551, 0x83d385c7, 0x136c9856, 0x646ba8c0, 0xfd62f97a, 0x8a65c9ec, 0x14015c4f, 0x63066cd9, 0xfa0f3d63, 0x8d080df5, 0x3b6e20c8, 0x4c69105e, 0xd56041e4, 0xa2677172, 0x3c03e4d1, 0x4b04d447, 0xd20d85fd, 0xa50ab56b, 0x35b5a8fa, 0x42b2986c, 0xdbbbc9d6, 0xacbcf940, 0x32d86ce3, 0x45df5c75, 0xdcd60dcf, 0xabd13d59, 0x26d930ac, 0x51de003a, 0xc8d75180, 0xbfd06116, 0x21b4f4b5, 0x56b3c423, 0xcfba9599, 0xb8bda50f, 0x2802b89e, 0x5f058808, 0xc60cd9b2, 0xb10be924, 0x2f6f7c87, 0x58684c11, 0xc1611dab, 0xb6662d3d, 0x76dc4190, 0x01db7106, 0x98d220bc, 0xefd5102a, 0x71b18589, 0x06b6b51f, 0x9fbfe4a5, 0xe8b8d433, 0x7807c9a2, 0x0f00f934, 0x9609a88e, 0xe10e9818, 0x7f6a0dbb, 0x086d3d2d, 0x91646c97, 0xe6635c01, 0x6b6b51f4, 0x1c6c6162, 0x856530d8, 0xf262004e, 0x6c0695ed, 0x1b01a57b, 0x8208f4c1, 0xf50fc457, 0x65b0d9c6, 0x12b7e950, 0x8bbeb8ea, 0xfcb9887c, 0x62dd1ddf, 0x15da2d49, 0x8cd37cf3, 0xfbd44c65, 0x4db26158, 0x3ab551ce, 0xa3bc0074, 0xd4bb30e2, 0x4adfa541, 0x3dd895d7, 0xa4d1c46d, 0xd3d6f4fb, 0x4369e96a, 0x346ed9fc, 0xad678846, 0xda60b8d0, 0x44042d73, 0x33031de5, 0xaa0a4c5f, 0xdd0d7cc9, 0x5005713c, 0x270241aa, 0xbe0b1010, 0xc90c2086, 0x5768b525, 0x206f85b3, 0xb966d409, 0xce61e49f, 0x5edef90e, 0x29d9c998, 0xb0d09822, 0xc7d7a8b4, 0x59b33d17, 0x2eb40d81, 0xb7bd5c3b, 0xc0ba6cad, 0xedb88320, 0x9abfb3b6, 0x03b6e20c, 0x74b1d29a, 0xead54739, 0x9dd277af, 0x04db2615, 0x73dc1683, 0xe3630b12, 0x94643b84, 0x0d6d6a3e, 0x7a6a5aa8, 0xe40ecf0b, 0x9309ff9d, 0x0a00ae27, 0x7d079eb1, 0xf00f9344, 0x8708a3d2, 0x1e01f268, 0x6906c2fe, 0xf762575d, 0x806567cb, 0x196c3671, 0x6e6b06e7, 0xfed41b76, 0x89d32be0, 0x10da7a5a, 0x67dd4acc, 0xf9b9df6f, 0x8ebeeff9, 0x17b7be43, 0x60b08ed5, 0xd6d6a3e8, 0xa1d1937e, 0x38d8c2c4, 0x4fdff252, 0xd1bb67f1, 0xa6bc5767, 0x3fb506dd, 0x48b2364b, 0xd80d2bda, 0xaf0a1b4c, 0x36034af6, 0x41047a60, 0xdf60efc3, 0xa867df55, 0x316e8eef, 0x4669be79, 0xcb61b38c, 0xbc66831a, 0x256fd2a0, 0x5268e236, 0xcc0c7795, 0xbb0b4703, 0x220216b9, 0x5505262f, 0xc5ba3bbe, 0xb2bd0b28, 0x2bb45a92, 0x5cb36a04, 0xc2d7ffa7, 0xb5d0cf31, 0x2cd99e8b, 0x5bdeae1d, 0x9b64c2b0, 0xec63f226, 0x756aa39c, 0x026d930a, 0x9c0906a9, 0xeb0e363f, 0x72076785, 0x05005713, 0x95bf4a82, 0xe2b87a14, 0x7bb12bae, 0x0cb61b38, 0x92d28e9b, 0xe5d5be0d, 0x7cdcefb7, 0x0bdbdf21, 0x86d3d2d4, 0xf1d4e242, 0x68ddb3f8, 0x1fda836e, 0x81be16cd, 0xf6b9265b, 0x6fb077e1, 0x18b74777, 0x88085ae6, 0xff0f6a70, 0x66063bca, 0x11010b5c, 0x8f659eff, 0xf862ae69, 0x616bffd3, 0x166ccf45, 0xa00ae278, 0xd70dd2ee, 0x4e048354, 0x3903b3c2, 0xa7672661, 0xd06016f7, 0x4969474d, 0x3e6e77db, 0xaed16a4a, 0xd9d65adc, 0x40df0b66, 0x37d83bf0, 0xa9bcae53, 0xdebb9ec5, 0x47b2cf7f, 0x30b5ffe9, 0xbdbdf21c, 0xcabac28a, 0x53b39330, 0x24b4a3a6, 0xbad03605, 0xcdd70693, 0x54de5729, 0x23d967bf, 0xb3667a2e, 0xc4614ab8, 0x5d681b02, 0x2a6f2b94, 0xb40bbe37, 0xc30c8ea1, 0x5a05df1b, 0x2d02ef8d];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crc32 = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('crc-32', function (buf, previous) {
  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = previous === 0 ? 0 : ~~previous ^ -1;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = TABLE[(crc ^ byte) & 0xff] ^ crc >>> 8;
  }

  return crc ^ -1;
});

/* harmony default export */ __webpack_exports__["a"] = (crc32);

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_buffer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__define_crc__ = __webpack_require__(71);




// Generated by `./pycrc.py --algorithm=table-driven --model=jam --generate=c`
// prettier-ignore
var TABLE = [0x00000000, 0x77073096, 0xee0e612c, 0x990951ba, 0x076dc419, 0x706af48f, 0xe963a535, 0x9e6495a3, 0x0edb8832, 0x79dcb8a4, 0xe0d5e91e, 0x97d2d988, 0x09b64c2b, 0x7eb17cbd, 0xe7b82d07, 0x90bf1d91, 0x1db71064, 0x6ab020f2, 0xf3b97148, 0x84be41de, 0x1adad47d, 0x6ddde4eb, 0xf4d4b551, 0x83d385c7, 0x136c9856, 0x646ba8c0, 0xfd62f97a, 0x8a65c9ec, 0x14015c4f, 0x63066cd9, 0xfa0f3d63, 0x8d080df5, 0x3b6e20c8, 0x4c69105e, 0xd56041e4, 0xa2677172, 0x3c03e4d1, 0x4b04d447, 0xd20d85fd, 0xa50ab56b, 0x35b5a8fa, 0x42b2986c, 0xdbbbc9d6, 0xacbcf940, 0x32d86ce3, 0x45df5c75, 0xdcd60dcf, 0xabd13d59, 0x26d930ac, 0x51de003a, 0xc8d75180, 0xbfd06116, 0x21b4f4b5, 0x56b3c423, 0xcfba9599, 0xb8bda50f, 0x2802b89e, 0x5f058808, 0xc60cd9b2, 0xb10be924, 0x2f6f7c87, 0x58684c11, 0xc1611dab, 0xb6662d3d, 0x76dc4190, 0x01db7106, 0x98d220bc, 0xefd5102a, 0x71b18589, 0x06b6b51f, 0x9fbfe4a5, 0xe8b8d433, 0x7807c9a2, 0x0f00f934, 0x9609a88e, 0xe10e9818, 0x7f6a0dbb, 0x086d3d2d, 0x91646c97, 0xe6635c01, 0x6b6b51f4, 0x1c6c6162, 0x856530d8, 0xf262004e, 0x6c0695ed, 0x1b01a57b, 0x8208f4c1, 0xf50fc457, 0x65b0d9c6, 0x12b7e950, 0x8bbeb8ea, 0xfcb9887c, 0x62dd1ddf, 0x15da2d49, 0x8cd37cf3, 0xfbd44c65, 0x4db26158, 0x3ab551ce, 0xa3bc0074, 0xd4bb30e2, 0x4adfa541, 0x3dd895d7, 0xa4d1c46d, 0xd3d6f4fb, 0x4369e96a, 0x346ed9fc, 0xad678846, 0xda60b8d0, 0x44042d73, 0x33031de5, 0xaa0a4c5f, 0xdd0d7cc9, 0x5005713c, 0x270241aa, 0xbe0b1010, 0xc90c2086, 0x5768b525, 0x206f85b3, 0xb966d409, 0xce61e49f, 0x5edef90e, 0x29d9c998, 0xb0d09822, 0xc7d7a8b4, 0x59b33d17, 0x2eb40d81, 0xb7bd5c3b, 0xc0ba6cad, 0xedb88320, 0x9abfb3b6, 0x03b6e20c, 0x74b1d29a, 0xead54739, 0x9dd277af, 0x04db2615, 0x73dc1683, 0xe3630b12, 0x94643b84, 0x0d6d6a3e, 0x7a6a5aa8, 0xe40ecf0b, 0x9309ff9d, 0x0a00ae27, 0x7d079eb1, 0xf00f9344, 0x8708a3d2, 0x1e01f268, 0x6906c2fe, 0xf762575d, 0x806567cb, 0x196c3671, 0x6e6b06e7, 0xfed41b76, 0x89d32be0, 0x10da7a5a, 0x67dd4acc, 0xf9b9df6f, 0x8ebeeff9, 0x17b7be43, 0x60b08ed5, 0xd6d6a3e8, 0xa1d1937e, 0x38d8c2c4, 0x4fdff252, 0xd1bb67f1, 0xa6bc5767, 0x3fb506dd, 0x48b2364b, 0xd80d2bda, 0xaf0a1b4c, 0x36034af6, 0x41047a60, 0xdf60efc3, 0xa867df55, 0x316e8eef, 0x4669be79, 0xcb61b38c, 0xbc66831a, 0x256fd2a0, 0x5268e236, 0xcc0c7795, 0xbb0b4703, 0x220216b9, 0x5505262f, 0xc5ba3bbe, 0xb2bd0b28, 0x2bb45a92, 0x5cb36a04, 0xc2d7ffa7, 0xb5d0cf31, 0x2cd99e8b, 0x5bdeae1d, 0x9b64c2b0, 0xec63f226, 0x756aa39c, 0x026d930a, 0x9c0906a9, 0xeb0e363f, 0x72076785, 0x05005713, 0x95bf4a82, 0xe2b87a14, 0x7bb12bae, 0x0cb61b38, 0x92d28e9b, 0xe5d5be0d, 0x7cdcefb7, 0x0bdbdf21, 0x86d3d2d4, 0xf1d4e242, 0x68ddb3f8, 0x1fda836e, 0x81be16cd, 0xf6b9265b, 0x6fb077e1, 0x18b74777, 0x88085ae6, 0xff0f6a70, 0x66063bca, 0x11010b5c, 0x8f659eff, 0xf862ae69, 0x616bffd3, 0x166ccf45, 0xa00ae278, 0xd70dd2ee, 0x4e048354, 0x3903b3c2, 0xa7672661, 0xd06016f7, 0x4969474d, 0x3e6e77db, 0xaed16a4a, 0xd9d65adc, 0x40df0b66, 0x37d83bf0, 0xa9bcae53, 0xdebb9ec5, 0x47b2cf7f, 0x30b5ffe9, 0xbdbdf21c, 0xcabac28a, 0x53b39330, 0x24b4a3a6, 0xbad03605, 0xcdd70693, 0x54de5729, 0x23d967bf, 0xb3667a2e, 0xc4614ab8, 0x5d681b02, 0x2a6f2b94, 0xb40bbe37, 0xc30c8ea1, 0x5a05df1b, 0x2d02ef8d];

if (typeof Int32Array !== 'undefined') TABLE = new Int32Array(TABLE);

var crcjam = Object(__WEBPACK_IMPORTED_MODULE_2__define_crc__["a" /* default */])('jam', function (buf) {
  var previous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

  if (!__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].isBuffer(buf)) buf = Object(__WEBPACK_IMPORTED_MODULE_1__create_buffer__["a" /* default */])(buf);

  var crc = previous === 0 ? 0 : ~~previous;

  for (var index = 0; index < buf.length; index++) {
    var byte = buf[index];
    crc = TABLE[(crc ^ byte) & 0xff] ^ crc >>> 8;
  }

  return crc;
});

/* harmony default export */ __webpack_exports__["a"] = (crcjam);

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

var cryptoUtils = __webpack_require__(69);
var cnBase58 = __webpack_require__(1486);

var DEFAULT_NETWORK_TYPE = 'prod';
var addressRegTest = new RegExp('^[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{95}$');
var integratedAddressRegTest = new RegExp('^[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{106}$');

function validateNetwork(decoded, currency, networkType, addressType) {
  var network = currency.addressTypes;
  if (addressType == 'integrated') {
    network = currency.iAddressTypes;
  }
  var at = parseInt(decoded.substr(0, 2), 16).toString();

  switch (networkType) {
    case 'prod':
      return network.prod.indexOf(at) >= 0;
    case 'testnet':
      return network.testnet.indexOf(at) >= 0;
    case 'both':
      return network.prod.indexOf(at) >= 0 || network.testnet.indexOf(at) >= 0;
    default:
      return false;
  }
}

function hextobin(hex) {
  if (hex.length % 2 !== 0) return null;
  var res = new Uint8Array(hex.length / 2);
  for (var i = 0; i < hex.length / 2; ++i) {
    res[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  }
  return res;
}

module.exports = {
  isValidAddress: function isValidAddress(address, currency, networkType) {
    networkType = networkType || DEFAULT_NETWORK_TYPE;
    var addressType = 'standard';
    if (!addressRegTest.test(address)) {
      if (integratedAddressRegTest.test(address)) {
        addressType = 'integrated';
      } else {
        return false;
      }
    }

    var decodedAddrStr = cnBase58.decode(address);
    if (!decodedAddrStr) return false;

    if (!validateNetwork(decodedAddrStr, currency, networkType, addressType)) return false;

    var addrChecksum = decodedAddrStr.slice(-8);
    var hashChecksum = cryptoUtils.keccak256Checksum(hextobin(decodedAddrStr.slice(0, -8)));

    return addrChecksum === hashChecksum;
  }
};

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

var JSBigInt = __webpack_require__(1487)['JSBigInt'];

/**
Copyright (c) 2017, moneroexamples

All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice, this
list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice,
this list of conditions and the following disclaimer in the documentation
and/or other materials provided with the distribution.

3. Neither the name of the copyright holder nor the names of its contributors
may be used to endorse or promote products derived from this software without
specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

Parts of the project are originally copyright (c) 2014-2017, MyMonero.com
*/

var cnBase58 = function () {
    var b58 = {};

    var alphabet_str = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
    var alphabet = [];
    for (var i = 0; i < alphabet_str.length; i++) {
        alphabet.push(alphabet_str.charCodeAt(i));
    }
    var encoded_block_sizes = [0, 2, 3, 5, 6, 7, 9, 10, 11];

    var alphabet_size = alphabet.length;
    var full_block_size = 8;
    var full_encoded_block_size = 11;

    var UINT64_MAX = new JSBigInt(2).pow(64);

    function hextobin(hex) {
        if (hex.length % 2 !== 0) throw "Hex string has invalid length!";
        var res = new Uint8Array(hex.length / 2);
        for (var i = 0; i < hex.length / 2; ++i) {
            res[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
        }
        return res;
    }

    function bintohex(bin) {
        var out = [];
        for (var i = 0; i < bin.length; ++i) {
            out.push(("0" + bin[i].toString(16)).slice(-2));
        }
        return out.join("");
    }

    function strtobin(str) {
        var res = new Uint8Array(str.length);
        for (var i = 0; i < str.length; i++) {
            res[i] = str.charCodeAt(i);
        }
        return res;
    }

    function bintostr(bin) {
        var out = [];
        for (var i = 0; i < bin.length; i++) {
            out.push(String.fromCharCode(bin[i]));
        }
        return out.join("");
    }

    function uint8_be_to_64(data) {
        if (data.length < 1 || data.length > 8) {
            throw "Invalid input length";
        }
        var res = JSBigInt.ZERO;
        var twopow8 = new JSBigInt(2).pow(8);
        var i = 0;
        switch (9 - data.length) {
            case 1:
                res = res.add(data[i++]);
            case 2:
                res = res.multiply(twopow8).add(data[i++]);
            case 3:
                res = res.multiply(twopow8).add(data[i++]);
            case 4:
                res = res.multiply(twopow8).add(data[i++]);
            case 5:
                res = res.multiply(twopow8).add(data[i++]);
            case 6:
                res = res.multiply(twopow8).add(data[i++]);
            case 7:
                res = res.multiply(twopow8).add(data[i++]);
            case 8:
                res = res.multiply(twopow8).add(data[i++]);
                break;
            default:
                throw "Impossible condition";
        }
        return res;
    }

    function uint64_to_8be(num, size) {
        var res = new Uint8Array(size);
        if (size < 1 || size > 8) {
            throw "Invalid input length";
        }
        var twopow8 = new JSBigInt(2).pow(8);
        for (var i = size - 1; i >= 0; i--) {
            res[i] = num.remainder(twopow8).toJSValue();
            num = num.divide(twopow8);
        }
        return res;
    }

    b58.encode_block = function (data, buf, index) {
        if (data.length < 1 || data.length > full_encoded_block_size) {
            throw "Invalid block length: " + data.length;
        }
        var num = uint8_be_to_64(data);
        var i = encoded_block_sizes[data.length] - 1;
        // while num > 0
        while (num.compare(0) === 1) {
            var div = num.divRem(alphabet_size);
            // remainder = num % alphabet_size
            var remainder = div[1];
            // num = num / alphabet_size
            num = div[0];
            buf[index + i] = alphabet[remainder.toJSValue()];
            i--;
        }
        return buf;
    };

    b58.encode = function (hex) {
        var data = hextobin(hex);
        if (data.length === 0) {
            return "";
        }
        var full_block_count = Math.floor(data.length / full_block_size);
        var last_block_size = data.length % full_block_size;
        var res_size = full_block_count * full_encoded_block_size + encoded_block_sizes[last_block_size];

        var res = new Uint8Array(res_size);
        var i;
        for (i = 0; i < res_size; ++i) {
            res[i] = alphabet[0];
        }
        for (i = 0; i < full_block_count; i++) {
            res = b58.encode_block(data.subarray(i * full_block_size, i * full_block_size + full_block_size), res, i * full_encoded_block_size);
        }
        if (last_block_size > 0) {
            res = b58.encode_block(data.subarray(full_block_count * full_block_size, full_block_count * full_block_size + last_block_size), res, full_block_count * full_encoded_block_size);
        }
        return bintostr(res);
    };

    b58.decode_block = function (data, buf, index) {
        if (data.length < 1 || data.length > full_encoded_block_size) {
            throw "Invalid block length: " + data.length;
        }

        var res_size = encoded_block_sizes.indexOf(data.length);
        if (res_size <= 0) {
            throw "Invalid block size";
        }
        var res_num = new JSBigInt(0);
        var order = new JSBigInt(1);
        for (var i = data.length - 1; i >= 0; i--) {
            var digit = alphabet.indexOf(data[i]);
            if (digit < 0) {
                throw "Invalid symbol";
            }
            var product = order.multiply(digit).add(res_num);
            // if product > UINT64_MAX
            if (product.compare(UINT64_MAX) === 1) {
                throw "Overflow";
            }
            res_num = product;
            order = order.multiply(alphabet_size);
        }
        if (res_size < full_block_size && new JSBigInt(2).pow(8 * res_size).compare(res_num) <= 0) {
            throw "Overflow 2";
        }
        buf.set(uint64_to_8be(res_num, res_size), index);
        return buf;
    };

    b58.decode = function (enc) {
        enc = strtobin(enc);
        if (enc.length === 0) {
            return "";
        }
        var full_block_count = Math.floor(enc.length / full_encoded_block_size);
        var last_block_size = enc.length % full_encoded_block_size;
        var last_block_decoded_size = encoded_block_sizes.indexOf(last_block_size);
        if (last_block_decoded_size < 0) {
            throw "Invalid encoded length";
        }
        var data_size = full_block_count * full_block_size + last_block_decoded_size;
        var data = new Uint8Array(data_size);
        for (var i = 0; i < full_block_count; i++) {
            data = b58.decode_block(enc.subarray(i * full_encoded_block_size, i * full_encoded_block_size + full_encoded_block_size), data, i * full_block_size);
        }
        if (last_block_size > 0) {
            data = b58.decode_block(enc.subarray(full_block_count * full_encoded_block_size, full_block_count * full_encoded_block_size + last_block_size), data, full_block_count * full_block_size);
        }
        return bintohex(data);
    };

    return b58;
}();
module.exports = cnBase58;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

/*
	JavaScript BigInteger library version 0.9.1
	http://silentmatt.com/biginteger/
	Copyright (c) 2009 Matthew Crumley <email@matthewcrumley.com>
	Copyright (c) 2010,2011 by John Tobey <John.Tobey@gmail.com>
	Licensed under the MIT license.
	Support for arbitrary internal representation base was added by
	Vitaly Magerya.
*/

/*
	File: biginteger.js
	Exports:
		<BigInteger>
*/
(function (exports) {
    "use strict";
    /*
        Class: BigInteger
        An arbitrarily-large integer.
        <BigInteger> objects should be considered immutable. None of the "built-in"
        methods modify *this* or their arguments. All properties should be
        considered private.
        All the methods of <BigInteger> instances can be called "statically". The
        static versions are convenient if you don't already have a <BigInteger>
        object.
        As an example, these calls are equivalent.
        > BigInteger(4).multiply(5); // returns BigInteger(20);
        > BigInteger.multiply(4, 5); // returns BigInteger(20);
        > var a = 42;
        > var a = BigInteger.toJSValue("0b101010"); // Not completely useless...
    */

    var CONSTRUCT = {}; // Unique token to call "private" version of constructor

    /*
        Constructor: BigInteger()
        Convert a value to a <BigInteger>.
        Although <BigInteger()> is the constructor for <BigInteger> objects, it is
        best not to call it as a constructor. If *n* is a <BigInteger> object, it is
        simply returned as-is. Otherwise, <BigInteger()> is equivalent to <parse>
        without a radix argument.
        > var n0 = BigInteger();      // Same as <BigInteger.ZERO>
        > var n1 = BigInteger("123"); // Create a new <BigInteger> with value 123
        > var n2 = BigInteger(123);   // Create a new <BigInteger> with value 123
        > var n3 = BigInteger(n2);    // Return n2, unchanged
        The constructor form only takes an array and a sign. *n* must be an
        array of numbers in little-endian order, where each digit is between 0
        and BigInteger.base.  The second parameter sets the sign: -1 for
        negative, +1 for positive, or 0 for zero. The array is *not copied and
        may be modified*. If the array contains only zeros, the sign parameter
        is ignored and is forced to zero.
        > new BigInteger([5], -1): create a new BigInteger with value -5
        Parameters:
            n - Value to convert to a <BigInteger>.
        Returns:
            A <BigInteger> value.
        See Also:
            <parse>, <BigInteger>
    */
    function BigInteger(n, s, token) {

        if (token !== CONSTRUCT) {
            if (n instanceof BigInteger) {
                return n;
            } else if (typeof n === "undefined") {
                return ZERO;
            }
            return BigInteger.parse(n);
        }

        n = n || []; // Provide the nullary constructor for subclasses.
        while (n.length && !n[n.length - 1]) {
            --n.length;
        }
        this._d = n;
        this._s = n.length ? s || 1 : 0;
    }

    BigInteger._construct = function (n, s) {
        return new BigInteger(n, s, CONSTRUCT);
    };

    // Base-10 speedup hacks in parse, toString, exp10 and log functions
    // require base to be a power of 10. 10^7 is the largest such power
    // that won't cause a precision loss when digits are multiplied.
    var BigInteger_base = 10000000;
    var BigInteger_base_log10 = 7;

    BigInteger.base = BigInteger_base;
    BigInteger.base_log10 = BigInteger_base_log10;

    var ZERO = new BigInteger([], 0, CONSTRUCT);
    // Constant: ZERO
    // <BigInteger> 0.
    BigInteger.ZERO = ZERO;

    var ONE = new BigInteger([1], 1, CONSTRUCT);
    // Constant: ONE
    // <BigInteger> 1.
    BigInteger.ONE = ONE;

    var M_ONE = new BigInteger(ONE._d, -1, CONSTRUCT);
    // Constant: M_ONE
    // <BigInteger> -1.
    BigInteger.M_ONE = M_ONE;

    // Constant: _0
    // Shortcut for <ZERO>.
    BigInteger._0 = ZERO;

    // Constant: _1
    // Shortcut for <ONE>.
    BigInteger._1 = ONE;

    /*
        Constant: small
        Array of <BigIntegers> from 0 to 36.
        These are used internally for parsing, but useful when you need a "small"
        <BigInteger>.
        See Also:
            <ZERO>, <ONE>, <_0>, <_1>
    */
    BigInteger.small = [ZERO, ONE,
    /* Assuming BigInteger_base > 36 */
    new BigInteger([2], 1, CONSTRUCT), new BigInteger([3], 1, CONSTRUCT), new BigInteger([4], 1, CONSTRUCT), new BigInteger([5], 1, CONSTRUCT), new BigInteger([6], 1, CONSTRUCT), new BigInteger([7], 1, CONSTRUCT), new BigInteger([8], 1, CONSTRUCT), new BigInteger([9], 1, CONSTRUCT), new BigInteger([10], 1, CONSTRUCT), new BigInteger([11], 1, CONSTRUCT), new BigInteger([12], 1, CONSTRUCT), new BigInteger([13], 1, CONSTRUCT), new BigInteger([14], 1, CONSTRUCT), new BigInteger([15], 1, CONSTRUCT), new BigInteger([16], 1, CONSTRUCT), new BigInteger([17], 1, CONSTRUCT), new BigInteger([18], 1, CONSTRUCT), new BigInteger([19], 1, CONSTRUCT), new BigInteger([20], 1, CONSTRUCT), new BigInteger([21], 1, CONSTRUCT), new BigInteger([22], 1, CONSTRUCT), new BigInteger([23], 1, CONSTRUCT), new BigInteger([24], 1, CONSTRUCT), new BigInteger([25], 1, CONSTRUCT), new BigInteger([26], 1, CONSTRUCT), new BigInteger([27], 1, CONSTRUCT), new BigInteger([28], 1, CONSTRUCT), new BigInteger([29], 1, CONSTRUCT), new BigInteger([30], 1, CONSTRUCT), new BigInteger([31], 1, CONSTRUCT), new BigInteger([32], 1, CONSTRUCT), new BigInteger([33], 1, CONSTRUCT), new BigInteger([34], 1, CONSTRUCT), new BigInteger([35], 1, CONSTRUCT), new BigInteger([36], 1, CONSTRUCT)];

    // Used for parsing/radix conversion
    BigInteger.digits = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

    /*
        Method: toString
        Convert a <BigInteger> to a string.
        When *base* is greater than 10, letters are upper case.
        Parameters:
            base - Optional base to represent the number in (default is base 10).
                   Must be between 2 and 36 inclusive, or an Error will be thrown.
        Returns:
            The string representation of the <BigInteger>.
    */
    BigInteger.prototype.toString = function (base) {
        base = +base || 10;
        if (base < 2 || base > 36) {
            throw new Error("illegal radix " + base + ".");
        }
        if (this._s === 0) {
            return "0";
        }
        if (base === 10) {
            var str = this._s < 0 ? "-" : "";
            str += this._d[this._d.length - 1].toString();
            for (var i = this._d.length - 2; i >= 0; i--) {
                var group = this._d[i].toString();
                while (group.length < BigInteger_base_log10) {
                    group = '0' + group;
                }str += group;
            }
            return str;
        } else {
            var numerals = BigInteger.digits;
            base = BigInteger.small[base];
            var sign = this._s;

            var n = this.abs();
            var digits = [];
            var digit;

            while (n._s !== 0) {
                var divmod = n.divRem(base);
                n = divmod[0];
                digit = divmod[1];
                // TODO: This could be changed to unshift instead of reversing at the end.
                // Benchmark both to compare speeds.
                digits.push(numerals[digit.valueOf()]);
            }
            return (sign < 0 ? "-" : "") + digits.reverse().join("");
        }
    };

    // Verify strings for parsing
    BigInteger.radixRegex = [/^$/, /^$/, /^[01]*$/, /^[012]*$/, /^[0-3]*$/, /^[0-4]*$/, /^[0-5]*$/, /^[0-6]*$/, /^[0-7]*$/, /^[0-8]*$/, /^[0-9]*$/, /^[0-9aA]*$/, /^[0-9abAB]*$/, /^[0-9abcABC]*$/, /^[0-9a-dA-D]*$/, /^[0-9a-eA-E]*$/, /^[0-9a-fA-F]*$/, /^[0-9a-gA-G]*$/, /^[0-9a-hA-H]*$/, /^[0-9a-iA-I]*$/, /^[0-9a-jA-J]*$/, /^[0-9a-kA-K]*$/, /^[0-9a-lA-L]*$/, /^[0-9a-mA-M]*$/, /^[0-9a-nA-N]*$/, /^[0-9a-oA-O]*$/, /^[0-9a-pA-P]*$/, /^[0-9a-qA-Q]*$/, /^[0-9a-rA-R]*$/, /^[0-9a-sA-S]*$/, /^[0-9a-tA-T]*$/, /^[0-9a-uA-U]*$/, /^[0-9a-vA-V]*$/, /^[0-9a-wA-W]*$/, /^[0-9a-xA-X]*$/, /^[0-9a-yA-Y]*$/, /^[0-9a-zA-Z]*$/];

    /*
        Function: parse
        Parse a string into a <BigInteger>.
        *base* is optional but, if provided, must be from 2 to 36 inclusive. If
        *base* is not provided, it will be guessed based on the leading characters
        of *s* as follows:
        - "0x" or "0X": *base* = 16
        - "0c" or "0C": *base* = 8
        - "0b" or "0B": *base* = 2
        - else: *base* = 10
        If no base is provided, or *base* is 10, the number can be in exponential
        form. For example, these are all valid:
        > BigInteger.parse("1e9");              // Same as "1000000000"
        > BigInteger.parse("1.234*10^3");       // Same as 1234
        > BigInteger.parse("56789 * 10 ** -2"); // Same as 567
        If any characters fall outside the range defined by the radix, an exception
        will be thrown.
        Parameters:
            s - The string to parse.
            base - Optional radix (default is to guess based on *s*).
        Returns:
            a <BigInteger> instance.
    */
    BigInteger.parse = function (s, base) {
        // Expands a number in exponential form to decimal form.
        // expandExponential("-13.441*10^5") === "1344100";
        // expandExponential("1.12300e-1") === "0.112300";
        // expandExponential(1000000000000000000000000000000) === "1000000000000000000000000000000";
        function expandExponential(str) {
            str = str.replace(/\s*[*xX]\s*10\s*(\^|\*\*)\s*/, "e");

            return str.replace(/^([+\-])?(\d+)\.?(\d*)[eE]([+\-]?\d+)$/, function (x, s, n, f, c) {
                c = +c;
                var l = c < 0;
                var i = n.length + c;
                x = (l ? n : f).length;
                c = (c = Math.abs(c)) >= x ? c - x + l : 0;
                var z = new Array(c + 1).join("0");
                var r = n + f;
                return (s || "") + (l ? r = z + r : r += z).substr(0, i += l ? z.length : 0) + (i < r.length ? "." + r.substr(i) : "");
            });
        }

        s = s.toString();
        if (typeof base === "undefined" || +base === 10) {
            s = expandExponential(s);
        }

        var prefixRE;
        if (typeof base === "undefined") {
            prefixRE = '0[xcb]';
        } else if (base == 16) {
            prefixRE = '0x';
        } else if (base == 8) {
            prefixRE = '0c';
        } else if (base == 2) {
            prefixRE = '0b';
        } else {
            prefixRE = '';
        }
        var parts = new RegExp('^([+\\-]?)(' + prefixRE + ')?([0-9a-z]*)(?:\\.\\d*)?$', 'i').exec(s);
        if (parts) {
            var sign = parts[1] || "+";
            var baseSection = parts[2] || "";
            var digits = parts[3] || "";

            if (typeof base === "undefined") {
                // Guess base
                if (baseSection === "0x" || baseSection === "0X") {
                    // Hex
                    base = 16;
                } else if (baseSection === "0c" || baseSection === "0C") {
                    // Octal
                    base = 8;
                } else if (baseSection === "0b" || baseSection === "0B") {
                    // Binary
                    base = 2;
                } else {
                    base = 10;
                }
            } else if (base < 2 || base > 36) {
                throw new Error("Illegal radix " + base + ".");
            }

            base = +base;

            // Check for digits outside the range
            if (!BigInteger.radixRegex[base].test(digits)) {
                throw new Error("Bad digit for radix " + base);
            }

            // Strip leading zeros, and convert to array
            digits = digits.replace(/^0+/, "").split("");
            if (digits.length === 0) {
                return ZERO;
            }

            // Get the sign (we know it's not zero)
            sign = sign === "-" ? -1 : 1;

            // Optimize 10
            if (base == 10) {
                var d = [];
                while (digits.length >= BigInteger_base_log10) {
                    d.push(parseInt(digits.splice(digits.length - BigInteger.base_log10, BigInteger.base_log10).join(''), 10));
                }
                d.push(parseInt(digits.join(''), 10));
                return new BigInteger(d, sign, CONSTRUCT);
            }

            // Do the conversion
            var d = ZERO;
            base = BigInteger.small[base];
            var small = BigInteger.small;
            for (var i = 0; i < digits.length; i++) {
                d = d.multiply(base).add(small[parseInt(digits[i], 36)]);
            }
            return new BigInteger(d._d, sign, CONSTRUCT);
        } else {
            throw new Error("Invalid BigInteger format: " + s);
        }
    };

    /*
        Function: add
        Add two <BigIntegers>.
        Parameters:
            n - The number to add to *this*. Will be converted to a <BigInteger>.
        Returns:
            The numbers added together.
        See Also:
            <subtract>, <multiply>, <quotient>, <next>
    */
    BigInteger.prototype.add = function (n) {
        if (this._s === 0) {
            return BigInteger(n);
        }

        n = BigInteger(n);
        if (n._s === 0) {
            return this;
        }
        if (this._s !== n._s) {
            n = n.negate();
            return this.subtract(n);
        }

        var a = this._d;
        var b = n._d;
        var al = a.length;
        var bl = b.length;
        var sum = new Array(Math.max(al, bl) + 1);
        var size = Math.min(al, bl);
        var carry = 0;
        var digit;

        for (var i = 0; i < size; i++) {
            digit = a[i] + b[i] + carry;
            sum[i] = digit % BigInteger_base;
            carry = digit / BigInteger_base | 0;
        }
        if (bl > al) {
            a = b;
            al = bl;
        }
        for (i = size; carry && i < al; i++) {
            digit = a[i] + carry;
            sum[i] = digit % BigInteger_base;
            carry = digit / BigInteger_base | 0;
        }
        if (carry) {
            sum[i] = carry;
        }

        for (; i < al; i++) {
            sum[i] = a[i];
        }

        return new BigInteger(sum, this._s, CONSTRUCT);
    };

    /*
        Function: negate
        Get the additive inverse of a <BigInteger>.
        Returns:
            A <BigInteger> with the same magnatude, but with the opposite sign.
        See Also:
            <abs>
    */
    BigInteger.prototype.negate = function () {
        return new BigInteger(this._d, -this._s | 0, CONSTRUCT);
    };

    /*
        Function: abs
        Get the absolute value of a <BigInteger>.
        Returns:
            A <BigInteger> with the same magnatude, but always positive (or zero).
        See Also:
            <negate>
    */
    BigInteger.prototype.abs = function () {
        return this._s < 0 ? this.negate() : this;
    };

    /*
        Function: subtract
        Subtract two <BigIntegers>.
        Parameters:
            n - The number to subtract from *this*. Will be converted to a <BigInteger>.
        Returns:
            The *n* subtracted from *this*.
        See Also:
            <add>, <multiply>, <quotient>, <prev>
    */
    BigInteger.prototype.subtract = function (n) {
        if (this._s === 0) {
            return BigInteger(n).negate();
        }

        n = BigInteger(n);
        if (n._s === 0) {
            return this;
        }
        if (this._s !== n._s) {
            n = n.negate();
            return this.add(n);
        }

        var m = this;
        // negative - negative => -|a| - -|b| => -|a| + |b| => |b| - |a|
        if (this._s < 0) {
            m = new BigInteger(n._d, 1, CONSTRUCT);
            n = new BigInteger(this._d, 1, CONSTRUCT);
        }

        // Both are positive => a - b
        var sign = m.compareAbs(n);
        if (sign === 0) {
            return ZERO;
        } else if (sign < 0) {
            // swap m and n
            var t = n;
            n = m;
            m = t;
        }

        // a > b
        var a = m._d;
        var b = n._d;
        var al = a.length;
        var bl = b.length;
        var diff = new Array(al); // al >= bl since a > b
        var borrow = 0;
        var i;
        var digit;

        for (i = 0; i < bl; i++) {
            digit = a[i] - borrow - b[i];
            if (digit < 0) {
                digit += BigInteger_base;
                borrow = 1;
            } else {
                borrow = 0;
            }
            diff[i] = digit;
        }
        for (i = bl; i < al; i++) {
            digit = a[i] - borrow;
            if (digit < 0) {
                digit += BigInteger_base;
            } else {
                diff[i++] = digit;
                break;
            }
            diff[i] = digit;
        }
        for (; i < al; i++) {
            diff[i] = a[i];
        }

        return new BigInteger(diff, sign, CONSTRUCT);
    };

    (function () {
        function addOne(n, sign) {
            var a = n._d;
            var sum = a.slice();
            var carry = true;
            var i = 0;

            while (true) {
                var digit = (a[i] || 0) + 1;
                sum[i] = digit % BigInteger_base;
                if (digit <= BigInteger_base - 1) {
                    break;
                }
                ++i;
            }

            return new BigInteger(sum, sign, CONSTRUCT);
        }

        function subtractOne(n, sign) {
            var a = n._d;
            var sum = a.slice();
            var borrow = true;
            var i = 0;

            while (true) {
                var digit = (a[i] || 0) - 1;
                if (digit < 0) {
                    sum[i] = digit + BigInteger_base;
                } else {
                    sum[i] = digit;
                    break;
                }
                ++i;
            }

            return new BigInteger(sum, sign, CONSTRUCT);
        }

        /*
            Function: next
            Get the next <BigInteger> (add one).
            Returns:
                *this* + 1.
            See Also:
                <add>, <prev>
        */
        BigInteger.prototype.next = function () {
            switch (this._s) {
                case 0:
                    return ONE;
                case -1:
                    return subtractOne(this, -1);
                // case 1:
                default:
                    return addOne(this, 1);
            }
        };

        /*
            Function: prev
            Get the previous <BigInteger> (subtract one).
            Returns:
                *this* - 1.
            See Also:
                <next>, <subtract>
        */
        BigInteger.prototype.prev = function () {
            switch (this._s) {
                case 0:
                    return M_ONE;
                case -1:
                    return addOne(this, -1);
                // case 1:
                default:
                    return subtractOne(this, 1);
            }
        };
    })();

    /*
        Function: compareAbs
        Compare the absolute value of two <BigIntegers>.
        Calling <compareAbs> is faster than calling <abs> twice, then <compare>.
        Parameters:
            n - The number to compare to *this*. Will be converted to a <BigInteger>.
        Returns:
            -1, 0, or +1 if *|this|* is less than, equal to, or greater than *|n|*.
        See Also:
            <compare>, <abs>
    */
    BigInteger.prototype.compareAbs = function (n) {
        if (this === n) {
            return 0;
        }

        if (!(n instanceof BigInteger)) {
            if (!isFinite(n)) {
                return isNaN(n) ? n : -1;
            }
            n = BigInteger(n);
        }

        if (this._s === 0) {
            return n._s !== 0 ? -1 : 0;
        }
        if (n._s === 0) {
            return 1;
        }

        var l = this._d.length;
        var nl = n._d.length;
        if (l < nl) {
            return -1;
        } else if (l > nl) {
            return 1;
        }

        var a = this._d;
        var b = n._d;
        for (var i = l - 1; i >= 0; i--) {
            if (a[i] !== b[i]) {
                return a[i] < b[i] ? -1 : 1;
            }
        }

        return 0;
    };

    /*
        Function: compare
        Compare two <BigIntegers>.
        Parameters:
            n - The number to compare to *this*. Will be converted to a <BigInteger>.
        Returns:
            -1, 0, or +1 if *this* is less than, equal to, or greater than *n*.
        See Also:
            <compareAbs>, <isPositive>, <isNegative>, <isUnit>
    */
    BigInteger.prototype.compare = function (n) {
        if (this === n) {
            return 0;
        }

        n = BigInteger(n);

        if (this._s === 0) {
            return -n._s;
        }

        if (this._s === n._s) {
            // both positive or both negative
            var cmp = this.compareAbs(n);
            return cmp * this._s;
        } else {
            return this._s;
        }
    };

    /*
        Function: isUnit
        Return true iff *this* is either 1 or -1.
        Returns:
            true if *this* compares equal to <BigInteger.ONE> or <BigInteger.M_ONE>.
        See Also:
            <isZero>, <isNegative>, <isPositive>, <compareAbs>, <compare>,
            <BigInteger.ONE>, <BigInteger.M_ONE>
    */
    BigInteger.prototype.isUnit = function () {
        return this === ONE || this === M_ONE || this._d.length === 1 && this._d[0] === 1;
    };

    /*
        Function: multiply
        Multiply two <BigIntegers>.
        Parameters:
            n - The number to multiply *this* by. Will be converted to a
            <BigInteger>.
        Returns:
            The numbers multiplied together.
        See Also:
            <add>, <subtract>, <quotient>, <square>
    */
    BigInteger.prototype.multiply = function (n) {
        // TODO: Consider adding Karatsuba multiplication for large numbers
        if (this._s === 0) {
            return ZERO;
        }

        n = BigInteger(n);
        if (n._s === 0) {
            return ZERO;
        }
        if (this.isUnit()) {
            if (this._s < 0) {
                return n.negate();
            }
            return n;
        }
        if (n.isUnit()) {
            if (n._s < 0) {
                return this.negate();
            }
            return this;
        }
        if (this === n) {
            return this.square();
        }

        var r = this._d.length >= n._d.length;
        var a = (r ? this : n)._d; // a will be longer than b
        var b = (r ? n : this)._d;
        var al = a.length;
        var bl = b.length;

        var pl = al + bl;
        var partial = new Array(pl);
        var i;
        for (i = 0; i < pl; i++) {
            partial[i] = 0;
        }

        for (i = 0; i < bl; i++) {
            var carry = 0;
            var bi = b[i];
            var jlimit = al + i;
            var digit;
            for (var j = i; j < jlimit; j++) {
                digit = partial[j] + bi * a[j - i] + carry;
                carry = digit / BigInteger_base | 0;
                partial[j] = digit % BigInteger_base | 0;
            }
            if (carry) {
                digit = partial[j] + carry;
                carry = digit / BigInteger_base | 0;
                partial[j] = digit % BigInteger_base;
            }
        }
        return new BigInteger(partial, this._s * n._s, CONSTRUCT);
    };

    // Multiply a BigInteger by a single-digit native number
    // Assumes that this and n are >= 0
    // This is not really intended to be used outside the library itself
    BigInteger.prototype.multiplySingleDigit = function (n) {
        if (n === 0 || this._s === 0) {
            return ZERO;
        }
        if (n === 1) {
            return this;
        }

        var digit;
        if (this._d.length === 1) {
            digit = this._d[0] * n;
            if (digit >= BigInteger_base) {
                return new BigInteger([digit % BigInteger_base | 0, digit / BigInteger_base | 0], 1, CONSTRUCT);
            }
            return new BigInteger([digit], 1, CONSTRUCT);
        }

        if (n === 2) {
            return this.add(this);
        }
        if (this.isUnit()) {
            return new BigInteger([n], 1, CONSTRUCT);
        }

        var a = this._d;
        var al = a.length;

        var pl = al + 1;
        var partial = new Array(pl);
        for (var i = 0; i < pl; i++) {
            partial[i] = 0;
        }

        var carry = 0;
        for (var j = 0; j < al; j++) {
            digit = n * a[j] + carry;
            carry = digit / BigInteger_base | 0;
            partial[j] = digit % BigInteger_base | 0;
        }
        if (carry) {
            partial[j] = carry;
        }

        return new BigInteger(partial, 1, CONSTRUCT);
    };

    /*
        Function: square
        Multiply a <BigInteger> by itself.
        This is slightly faster than regular multiplication, since it removes the
        duplicated multiplcations.
        Returns:
            > this.multiply(this)
        See Also:
            <multiply>
    */
    BigInteger.prototype.square = function () {
        // Normally, squaring a 10-digit number would take 100 multiplications.
        // Of these 10 are unique diagonals, of the remaining 90 (100-10), 45 are repeated.
        // This procedure saves (N*(N-1))/2 multiplications, (e.g., 45 of 100 multiplies).
        // Based on code by Gary Darby, Intellitech Systems Inc., www.DelphiForFun.org

        if (this._s === 0) {
            return ZERO;
        }
        if (this.isUnit()) {
            return ONE;
        }

        var digits = this._d;
        var length = digits.length;
        var imult1 = new Array(length + length + 1);
        var product, carry, k;
        var i;

        // Calculate diagonal
        for (i = 0; i < length; i++) {
            k = i * 2;
            product = digits[i] * digits[i];
            carry = product / BigInteger_base | 0;
            imult1[k] = product % BigInteger_base;
            imult1[k + 1] = carry;
        }

        // Calculate repeating part
        for (i = 0; i < length; i++) {
            carry = 0;
            k = i * 2 + 1;
            for (var j = i + 1; j < length; j++, k++) {
                product = digits[j] * digits[i] * 2 + imult1[k] + carry;
                carry = product / BigInteger_base | 0;
                imult1[k] = product % BigInteger_base;
            }
            k = length + i;
            var digit = carry + imult1[k];
            carry = digit / BigInteger_base | 0;
            imult1[k] = digit % BigInteger_base;
            imult1[k + 1] += carry;
        }

        return new BigInteger(imult1, 1, CONSTRUCT);
    };

    /*
        Function: quotient
        Divide two <BigIntegers> and truncate towards zero.
        <quotient> throws an exception if *n* is zero.
        Parameters:
            n - The number to divide *this* by. Will be converted to a <BigInteger>.
        Returns:
            The *this* / *n*, truncated to an integer.
        See Also:
            <add>, <subtract>, <multiply>, <divRem>, <remainder>
    */
    BigInteger.prototype.quotient = function (n) {
        return this.divRem(n)[0];
    };

    /*
        Function: divide
        Deprecated synonym for <quotient>.
    */
    BigInteger.prototype.divide = BigInteger.prototype.quotient;

    /*
        Function: remainder
        Calculate the remainder of two <BigIntegers>.
        <remainder> throws an exception if *n* is zero.
        Parameters:
            n - The remainder after *this* is divided *this* by *n*. Will be
                converted to a <BigInteger>.
        Returns:
            *this* % *n*.
        See Also:
            <divRem>, <quotient>
    */
    BigInteger.prototype.remainder = function (n) {
        return this.divRem(n)[1];
    };

    /*
        Function: divRem
        Calculate the integer quotient and remainder of two <BigIntegers>.
        <divRem> throws an exception if *n* is zero.
        Parameters:
            n - The number to divide *this* by. Will be converted to a <BigInteger>.
        Returns:
            A two-element array containing the quotient and the remainder.
            > a.divRem(b)
            is exactly equivalent to
            > [a.quotient(b), a.remainder(b)]
            except it is faster, because they are calculated at the same time.
        See Also:
            <quotient>, <remainder>
    */
    BigInteger.prototype.divRem = function (n) {
        n = BigInteger(n);
        if (n._s === 0) {
            throw new Error("Divide by zero");
        }
        if (this._s === 0) {
            return [ZERO, ZERO];
        }
        if (n._d.length === 1) {
            return this.divRemSmall(n._s * n._d[0]);
        }

        // Test for easy cases -- |n1| <= |n2|
        switch (this.compareAbs(n)) {
            case 0:
                // n1 == n2
                return [this._s === n._s ? ONE : M_ONE, ZERO];
            case -1:
                // |n1| < |n2|
                return [ZERO, this];
        }

        var sign = this._s * n._s;
        var a = n.abs();
        var b_digits = this._d;
        var b_index = b_digits.length;
        var digits = n._d.length;
        var quot = [];
        var guess;

        var part = new BigInteger([], 0, CONSTRUCT);

        while (b_index) {
            part._d.unshift(b_digits[--b_index]);
            part = new BigInteger(part._d, 1, CONSTRUCT);

            if (part.compareAbs(n) < 0) {
                quot.push(0);
                continue;
            }
            if (part._s === 0) {
                guess = 0;
            } else {
                var xlen = part._d.length,
                    ylen = a._d.length;
                var highx = part._d[xlen - 1] * BigInteger_base + part._d[xlen - 2];
                var highy = a._d[ylen - 1] * BigInteger_base + a._d[ylen - 2];
                if (part._d.length > a._d.length) {
                    // The length of part._d can either match a._d length,
                    // or exceed it by one.
                    highx = (highx + 1) * BigInteger_base;
                }
                guess = Math.ceil(highx / highy);
            }
            do {
                var check = a.multiplySingleDigit(guess);
                if (check.compareAbs(part) <= 0) {
                    break;
                }
                guess--;
            } while (guess);

            quot.push(guess);
            if (!guess) {
                continue;
            }
            var diff = part.subtract(check);
            part._d = diff._d.slice();
        }

        return [new BigInteger(quot.reverse(), sign, CONSTRUCT), new BigInteger(part._d, this._s, CONSTRUCT)];
    };

    // Throws an exception if n is outside of (-BigInteger.base, -1] or
    // [1, BigInteger.base).  It's not necessary to call this, since the
    // other division functions will call it if they are able to.
    BigInteger.prototype.divRemSmall = function (n) {
        var r;
        n = +n;
        if (n === 0) {
            throw new Error("Divide by zero");
        }

        var n_s = n < 0 ? -1 : 1;
        var sign = this._s * n_s;
        n = Math.abs(n);

        if (n < 1 || n >= BigInteger_base) {
            throw new Error("Argument out of range");
        }

        if (this._s === 0) {
            return [ZERO, ZERO];
        }

        if (n === 1 || n === -1) {
            return [sign === 1 ? this.abs() : new BigInteger(this._d, sign, CONSTRUCT), ZERO];
        }

        // 2 <= n < BigInteger_base

        // divide a single digit by a single digit
        if (this._d.length === 1) {
            var q = new BigInteger([this._d[0] / n | 0], 1, CONSTRUCT);
            r = new BigInteger([this._d[0] % n | 0], 1, CONSTRUCT);
            if (sign < 0) {
                q = q.negate();
            }
            if (this._s < 0) {
                r = r.negate();
            }
            return [q, r];
        }

        var digits = this._d.slice();
        var quot = new Array(digits.length);
        var part = 0;
        var diff = 0;
        var i = 0;
        var guess;

        while (digits.length) {
            part = part * BigInteger_base + digits[digits.length - 1];
            if (part < n) {
                quot[i++] = 0;
                digits.pop();
                diff = BigInteger_base * diff + part;
                continue;
            }
            if (part === 0) {
                guess = 0;
            } else {
                guess = part / n | 0;
            }

            var check = n * guess;
            diff = part - check;
            quot[i++] = guess;
            if (!guess) {
                digits.pop();
                continue;
            }

            digits.pop();
            part = diff;
        }

        r = new BigInteger([diff], 1, CONSTRUCT);
        if (this._s < 0) {
            r = r.negate();
        }
        return [new BigInteger(quot.reverse(), sign, CONSTRUCT), r];
    };

    /*
        Function: isEven
        Return true iff *this* is divisible by two.
        Note that <BigInteger.ZERO> is even.
        Returns:
            true if *this* is even, false otherwise.
        See Also:
            <isOdd>
    */
    BigInteger.prototype.isEven = function () {
        var digits = this._d;
        return this._s === 0 || digits.length === 0 || digits[0] % 2 === 0;
    };

    /*
        Function: isOdd
        Return true iff *this* is not divisible by two.
        Returns:
            true if *this* is odd, false otherwise.
        See Also:
            <isEven>
    */
    BigInteger.prototype.isOdd = function () {
        return !this.isEven();
    };

    /*
        Function: sign
        Get the sign of a <BigInteger>.
        Returns:
            * -1 if *this* < 0
            * 0 if *this* == 0
            * +1 if *this* > 0
        See Also:
            <isZero>, <isPositive>, <isNegative>, <compare>, <BigInteger.ZERO>
    */
    BigInteger.prototype.sign = function () {
        return this._s;
    };

    /*
        Function: isPositive
        Return true iff *this* > 0.
        Returns:
            true if *this*.compare(<BigInteger.ZERO>) == 1.
        See Also:
            <sign>, <isZero>, <isNegative>, <isUnit>, <compare>, <BigInteger.ZERO>
    */
    BigInteger.prototype.isPositive = function () {
        return this._s > 0;
    };

    /*
        Function: isNegative
        Return true iff *this* < 0.
        Returns:
            true if *this*.compare(<BigInteger.ZERO>) == -1.
        See Also:
            <sign>, <isPositive>, <isZero>, <isUnit>, <compare>, <BigInteger.ZERO>
    */
    BigInteger.prototype.isNegative = function () {
        return this._s < 0;
    };

    /*
        Function: isZero
        Return true iff *this* == 0.
        Returns:
            true if *this*.compare(<BigInteger.ZERO>) == 0.
        See Also:
            <sign>, <isPositive>, <isNegative>, <isUnit>, <BigInteger.ZERO>
    */
    BigInteger.prototype.isZero = function () {
        return this._s === 0;
    };

    /*
        Function: exp10
        Multiply a <BigInteger> by a power of 10.
        This is equivalent to, but faster than
        > if (n >= 0) {
        >     return this.multiply(BigInteger("1e" + n));
        > }
        > else { // n <= 0
        >     return this.quotient(BigInteger("1e" + -n));
        > }
        Parameters:
            n - The power of 10 to multiply *this* by. *n* is converted to a
            javascipt number and must be no greater than <BigInteger.MAX_EXP>
            (0x7FFFFFFF), or an exception will be thrown.
        Returns:
            *this* * (10 ** *n*), truncated to an integer if necessary.
        See Also:
            <pow>, <multiply>
    */
    BigInteger.prototype.exp10 = function (n) {
        n = +n;
        if (n === 0) {
            return this;
        }
        if (Math.abs(n) > Number(MAX_EXP)) {
            throw new Error("exponent too large in BigInteger.exp10");
        }
        // Optimization for this == 0. This also keeps us from having to trim zeros in the positive n case
        if (this._s === 0) {
            return ZERO;
        }
        if (n > 0) {
            var k = new BigInteger(this._d.slice(), this._s, CONSTRUCT);

            for (; n >= BigInteger_base_log10; n -= BigInteger_base_log10) {
                k._d.unshift(0);
            }
            if (n == 0) return k;
            k._s = 1;
            k = k.multiplySingleDigit(Math.pow(10, n));
            return this._s < 0 ? k.negate() : k;
        } else if (-n >= this._d.length * BigInteger_base_log10) {
            return ZERO;
        } else {
            var k = new BigInteger(this._d.slice(), this._s, CONSTRUCT);

            for (n = -n; n >= BigInteger_base_log10; n -= BigInteger_base_log10) {
                k._d.shift();
            }
            return n == 0 ? k : k.divRemSmall(Math.pow(10, n))[0];
        }
    };

    /*
        Function: pow
        Raise a <BigInteger> to a power.
        In this implementation, 0**0 is 1.
        Parameters:
            n - The exponent to raise *this* by. *n* must be no greater than
            <BigInteger.MAX_EXP> (0x7FFFFFFF), or an exception will be thrown.
        Returns:
            *this* raised to the *nth* power.
        See Also:
            <modPow>
    */
    BigInteger.prototype.pow = function (n) {
        if (this.isUnit()) {
            if (this._s > 0) {
                return this;
            } else {
                return BigInteger(n).isOdd() ? this : this.negate();
            }
        }

        n = BigInteger(n);
        if (n._s === 0) {
            return ONE;
        } else if (n._s < 0) {
            if (this._s === 0) {
                throw new Error("Divide by zero");
            } else {
                return ZERO;
            }
        }
        if (this._s === 0) {
            return ZERO;
        }
        if (n.isUnit()) {
            return this;
        }

        if (n.compareAbs(MAX_EXP) > 0) {
            throw new Error("exponent too large in BigInteger.pow");
        }
        var x = this;
        var aux = ONE;
        var two = BigInteger.small[2];

        while (n.isPositive()) {
            if (n.isOdd()) {
                aux = aux.multiply(x);
                if (n.isUnit()) {
                    return aux;
                }
            }
            x = x.square();
            n = n.quotient(two);
        }

        return aux;
    };

    /*
        Function: modPow
        Raise a <BigInteger> to a power (mod m).
        Because it is reduced by a modulus, <modPow> is not limited by
        <BigInteger.MAX_EXP> like <pow>.
        Parameters:
            exponent - The exponent to raise *this* by. Must be positive.
            modulus - The modulus.
        Returns:
            *this* ^ *exponent* (mod *modulus*).
        See Also:
            <pow>, <mod>
    */
    BigInteger.prototype.modPow = function (exponent, modulus) {
        var result = ONE;
        var base = this;

        while (exponent.isPositive()) {
            if (exponent.isOdd()) {
                result = result.multiply(base).remainder(modulus);
            }

            exponent = exponent.quotient(BigInteger.small[2]);
            if (exponent.isPositive()) {
                base = base.square().remainder(modulus);
            }
        }

        return result;
    };

    /*
        Function: log
        Get the natural logarithm of a <BigInteger> as a native JavaScript number.
        This is equivalent to
        > Math.log(this.toJSValue())
        but handles values outside of the native number range.
        Returns:
            log( *this* )
        See Also:
            <toJSValue>
    */
    BigInteger.prototype.log = function () {
        switch (this._s) {
            case 0:
                return -Infinity;
            case -1:
                return NaN;
            default: // Fall through.
        }

        var l = this._d.length;

        if (l * BigInteger_base_log10 < 30) {
            return Math.log(this.valueOf());
        }

        var N = Math.ceil(30 / BigInteger_base_log10);
        var firstNdigits = this._d.slice(l - N);
        return Math.log(new BigInteger(firstNdigits, 1, CONSTRUCT).valueOf()) + (l - N) * Math.log(BigInteger_base);
    };

    /*
        Function: valueOf
        Convert a <BigInteger> to a native JavaScript integer.
        This is called automatically by JavaScipt to convert a <BigInteger> to a
        native value.
        Returns:
            > parseInt(this.toString(), 10)
        See Also:
            <toString>, <toJSValue>
    */
    BigInteger.prototype.valueOf = function () {
        return parseInt(this.toString(), 10);
    };

    /*
        Function: toJSValue
        Convert a <BigInteger> to a native JavaScript integer.
        This is the same as valueOf, but more explicitly named.
        Returns:
            > parseInt(this.toString(), 10)
        See Also:
            <toString>, <valueOf>
    */
    BigInteger.prototype.toJSValue = function () {
        return parseInt(this.toString(), 10);
    };

    /*
     Function: lowVal
     Author: Lucas Jones
     */
    BigInteger.prototype.lowVal = function () {
        return this._d[0] || 0;
    };

    var MAX_EXP = BigInteger(0x7FFFFFFF);
    // Constant: MAX_EXP
    // The largest exponent allowed in <pow> and <exp10> (0x7FFFFFFF or 2147483647).
    BigInteger.MAX_EXP = MAX_EXP;

    (function () {
        function makeUnary(fn) {
            return function (a) {
                return fn.call(BigInteger(a));
            };
        }

        function makeBinary(fn) {
            return function (a, b) {
                return fn.call(BigInteger(a), BigInteger(b));
            };
        }

        function makeTrinary(fn) {
            return function (a, b, c) {
                return fn.call(BigInteger(a), BigInteger(b), BigInteger(c));
            };
        }

        (function () {
            var i, fn;
            var unary = "toJSValue,isEven,isOdd,sign,isZero,isNegative,abs,isUnit,square,negate,isPositive,toString,next,prev,log".split(",");
            var binary = "compare,remainder,divRem,subtract,add,quotient,divide,multiply,pow,compareAbs".split(",");
            var trinary = ["modPow"];

            for (i = 0; i < unary.length; i++) {
                fn = unary[i];
                BigInteger[fn] = makeUnary(BigInteger.prototype[fn]);
            }

            for (i = 0; i < binary.length; i++) {
                fn = binary[i];
                BigInteger[fn] = makeBinary(BigInteger.prototype[fn]);
            }

            for (i = 0; i < trinary.length; i++) {
                fn = trinary[i];
                BigInteger[fn] = makeTrinary(BigInteger.prototype[fn]);
            }

            BigInteger.exp10 = function (x, n) {
                return BigInteger(x).exp10(n);
            };
        })();
    })();

    exports.JSBigInt = BigInteger; // exports.BigInteger changed to exports.JSBigInt
})( true ? exports : this);

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

var cryptoUtils = __webpack_require__(69);
var baseX = __webpack_require__(371);

var ALLOWED_CHARS = '13456789abcdefghijkmnopqrstuwxyz';

var codec = baseX(ALLOWED_CHARS);
// https://github.com/nanocurrency/raiblocks/wiki/Accounts,-Keys,-Seeds,-and-Wallet-Identifiers
var regexp = new RegExp('^(xrb|nano)_([' + ALLOWED_CHARS + ']{60})$');

module.exports = {
    isValidAddress: function isValidAddress(address) {
        if (regexp.test(address)) {
            return this.verifyChecksum(address);
        }

        return false;
    },

    verifyChecksum: function verifyChecksum(address) {
        var bytes = codec.decode(regexp.exec(address)[2]).slice(-37);
        // https://github.com/nanocurrency/raiblocks/blob/master/rai/lib/numbers.cpp#L73
        var computedChecksum = cryptoUtils.blake2b(cryptoUtils.toHex(bytes.slice(0, -5)), 5);
        var checksum = cryptoUtils.toHex(bytes.slice(-5).reverse());

        return computedChecksum === checksum;
    }
};

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

var cryptoUtils = __webpack_require__(69);
var isEqual = __webpack_require__(1490);

function hexToBytes(hex) {
  var bytes = [];
  for (var c = 0; c < hex.length; c += 2) {
    bytes.push(parseInt(hex.substr(c, 2), 16));
  }
  return bytes;
}

module.exports = {
  isValidAddress: function isValidAddress(address) {
    if (address.length !== 76) {
      // Check if it has the basic requirements of an address
      return false;
    }

    // Otherwise check each case
    return this.verifyChecksum(address);
  },
  verifyChecksum: function verifyChecksum(address) {
    var checksumBytes = address.slice(0, 32 * 2);
    var check = address.slice(32 * 2, 38 * 2);
    var blakeHash = cryptoUtils.blake2b(checksumBytes, 32).slice(0, 6 * 2);
    return !!isEqual(blakeHash, check);
  }
};

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(326);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var cryptoUtils = __webpack_require__(69);

function decodeBase58Address(base58Sting) {
    if (typeof base58Sting !== 'string') {
        return false;
    }
    if (base58Sting.length <= 4) {
        return false;
    }

    try {
        var address = cryptoUtils.base58(base58Sting);
    } catch (e) {
        return false;
    }

    /*if (base58Sting.length <= 4) {
        return false;
    }*/
    var len = address.length;
    var offset = len - 4;
    var checkSum = address.slice(offset);
    address = address.slice(0, offset);
    var hash0 = cryptoUtils.sha256(cryptoUtils.byteArray2hexStr(address));
    var hash1 = cryptoUtils.hexStr2byteArray(cryptoUtils.sha256(hash0));
    var checkSum1 = hash1.slice(0, 4);
    if (checkSum[0] === checkSum1[0] && checkSum[1] === checkSum1[1] && checkSum[2] === checkSum1[2] && checkSum[3] === checkSum1[3]) {
        return address;
    }

    return false;
}

function getEnv(currency, networkType) {
    var evn = networkType || 'prod';

    if (evn !== 'prod' && evn !== 'testnet') evn = 'prod';

    return currency.addressTypes[evn][0];
}

module.exports = {
    /**
     * tron address validation
     */
    isValidAddress: function isValidAddress(mainAddress, currency, networkType) {
        var address = decodeBase58Address(mainAddress);

        if (!address) {
            return false;
        }

        if (address.length !== 21) {
            return false;
        }

        return getEnv(currency, networkType) === address[0];
    }
};

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var cryptoUtils = __webpack_require__(69);

/**
* Check if an address is valid
*
* @param {string} _address - An address
*
* @return {boolean} - True if address is valid, false otherwise
*/
var isValidAddress = function isValidAddress(_address) {
    var address = _address.toString().toUpperCase().replace(/-/g, '');
    if (!address || address.length !== 40) {
        return false;
    }
    var decoded = cryptoUtils.toHex(cryptoUtils.base32.b32decode(address));
    var stepThreeChecksum = cryptoUtils.keccak256Checksum(Buffer.from(decoded.slice(0, 42), 'hex'));

    return stepThreeChecksum === decoded.slice(42);
};

module.exports = {
    isValidAddress: isValidAddress
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).Buffer))

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var cryptoUtils = __webpack_require__(69);

var regexp = new RegExp('^[0-9]{1,20}L$');

module.exports = {
    isValidAddress: function isValidAddress(address) {
        if (!regexp.test(address)) {
            return false;
        }
        return this.verifyAddress(address);
    },

    verifyAddress: function verifyAddress(address) {
        var BUFFER_SIZE = 8;
        var bigNumber = address.substring(0, address.length - 1);
        var addressBuffer = cryptoUtils.bigNumberToBuffer(bigNumber);
        return Buffer.from(addressBuffer).slice(0, BUFFER_SIZE).equals(addressBuffer);
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).Buffer))

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

var cryptoUtils = __webpack_require__(69);
var bech32 = __webpack_require__(649);
var BTCValidator = __webpack_require__(648);

function validateAddress(address, currency, networkType) {
    var prefix = 'bitcoincash';
    var regexp = new RegExp(currency.regexp);
    var raw_address;

    var res = address.split(':');
    if (res.length === 1) {
        raw_address = address;
    } else {
        if (res[0] !== 'bitcoincash') {
            return false;
        }
        raw_address = res[1];
    }

    if (!regexp.test(raw_address)) {
        return false;
    }

    if (raw_address.toLowerCase() != raw_address && raw_address.toUpperCase() != raw_address) {
        return false;
    }

    var decoded = cryptoUtils.base32.b32decode(raw_address);
    if (networkType === 'testnet') {
        prefix = 'bchtest';
    }

    try {
        if (bech32.verifyChecksum(prefix, decoded)) {
            return false;
        }
    } catch (e) {
        return false;
    }
    return true;
}

module.exports = {
    isValidAddress: function isValidAddress(address, currency, networkType) {
        return validateAddress(address, currency, networkType) || BTCValidator.isValidAddress(address, currency, networkType);
    }
};

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

var baseX = __webpack_require__(371);
var crc = __webpack_require__(650);
var cryptoUtils = __webpack_require__(69);

var ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

var base32 = baseX(ALPHABET);
var regexp = new RegExp('^[' + ALPHABET + ']{56}$');
var ed25519PublicKeyVersionByte = 6 << 3;

function swap16(number) {
  var lower = number & 0xFF;
  var upper = number >> 8 & 0xFF;
  return lower << 8 | upper;
}

function numberToHex(number) {
  var hex = number.toString(16);
  if (hex.length % 2 === 1) {
    hex = '0' + hex;
  }
  return hex;
}

module.exports = {
  isValidAddress: function isValidAddress(address) {
    if (regexp.test(address)) {
      return this.verifyChecksum(address);
    }

    return false;
  },

  verifyChecksum: function verifyChecksum(address) {
    // based on https://github.com/stellar/js-stellar-base/blob/master/src/strkey.js#L126
    var bytes = base32.decode(address);
    if (bytes[0] !== ed25519PublicKeyVersionByte) {
      return false;
    }

    var computedChecksum = numberToHex(swap16(crc.crc16xmodem(bytes.slice(0, -2))));
    var checksum = cryptoUtils.toHex(bytes.slice(-2));

    return computedChecksum === checksum;
  }
};

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validate$1; });
/* unused harmony export SUPPORTED_CURRENCIES */
var commonjsGlobal="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function createCommonjsModule(t,e){return t(e={exports:{}},e.exports),e.exports}var sha256=createCommonjsModule(function(t,e){!function(e){function r(t,e,r){var n,p,f,h,l,d,v,y,g,E=0,b=[],w=0,R=!1,C=[],A=[],_=!1;if(n=(r=r||{}).encoding||"UTF8",(g=r.numRounds||1)!==parseInt(g,10)||1>g)throw Error("numRounds must a integer >= 1");if(0!==t.lastIndexOf("SHA-",0))throw Error("Chosen SHA variant is not supported");if(d=function(e,r){return S(e,r,t)},v=function(e,r,n,o){var i,a;if("SHA-224"!==t&&"SHA-256"!==t)throw Error("Unexpected error in SHA-2 implementation");for(i=15+(r+65>>>9<<4),a=16;e.length<=i;)e.push(0);for(e[r>>>5]|=128<<24-r%32,r+=n,e[i]=4294967295&r,e[i-1]=r/4294967296|0,n=e.length,r=0;r<n;r+=a)o=S(e.slice(r,r+a),o,t);if("SHA-224"===t)e=[o[0],o[1],o[2],o[3],o[4],o[5],o[6]];else{if("SHA-256"!==t)throw Error("Unexpected error in SHA-2 implementation");e=o}return e},y=function(t){return t.slice()},"SHA-224"===t)l=512,h=224;else{if("SHA-256"!==t)throw Error("Chosen SHA variant is not supported");l=512,h=256}f=c(e,n),p=m(t),this.setHMACKey=function(e,r,o){var i;if(!0===R)throw Error("HMAC key already set");if(!0===_)throw Error("Cannot set HMAC key after calling update");if(e=(r=c(r,n=(o||{}).encoding||"UTF8")(e)).binLen,r=r.value,o=(i=l>>>3)/4-1,i<e/8){for(r=v(r,e,0,m(t));r.length<=o;)r.push(0);r[o]&=4294967040}else if(i>e/8){for(;r.length<=o;)r.push(0);r[o]&=4294967040}for(e=0;e<=o;e+=1)C[e]=909522486^r[e],A[e]=1549556828^r[e];p=d(C,p),E=l,R=!0},this.update=function(t){var e,r,n,o=0,i=l>>>5;for(t=(e=f(t,b,w)).binLen,r=e.value,e=t>>>5,n=0;n<e;n+=i)o+l<=t&&(p=d(r.slice(n,n+i),p),o+=l);E+=o,b=r.slice(o>>>5),w=t%l,_=!0},this.getHash=function(e,r){var n,c,f,l;if(!0===R)throw Error("Cannot call getHash after setting HMAC key");switch(f=s(r),e){case"HEX":n=function(t){return o(t,h,f)};break;case"B64":n=function(t){return i(t,h,f)};break;case"BYTES":n=function(t){return a(t,h)};break;case"ARRAYBUFFER":try{c=new ArrayBuffer(0)}catch(t){throw Error("ARRAYBUFFER not supported by this environment")}n=function(t){return u(t,h)};break;default:throw Error("format must be HEX, B64, BYTES, or ARRAYBUFFER")}for(l=v(b.slice(),w,E,y(p)),c=1;c<g;c+=1)l=v(l,h,0,m(t));return n(l)},this.getHMAC=function(e,r){var n,c,f,g;if(!1===R)throw Error("Cannot call getHMAC without first setting HMAC key");switch(f=s(r),e){case"HEX":n=function(t){return o(t,h,f)};break;case"B64":n=function(t){return i(t,h,f)};break;case"BYTES":n=function(t){return a(t,h)};break;case"ARRAYBUFFER":try{n=new ArrayBuffer(0)}catch(t){throw Error("ARRAYBUFFER not supported by this environment")}n=function(t){return u(t,h)};break;default:throw Error("outputFormat must be HEX, B64, BYTES, or ARRAYBUFFER")}return c=v(b.slice(),w,E,y(p)),g=d(A,m(t)),n(g=v(c,h,l,g))}}function n(){}function o(t,e,r){var n,o,i="";for(e/=8,n=0;n<e;n+=1)o=t[n>>>2]>>>8*(3+n%4*-1),i+="0123456789abcdef".charAt(o>>>4&15)+"0123456789abcdef".charAt(15&o);return r.outputUpper?i.toUpperCase():i}function i(t,e,r){var n,o,i,a="",u=e/8;for(n=0;n<u;n+=3)for(o=n+1<u?t[n+1>>>2]:0,i=n+2<u?t[n+2>>>2]:0,i=(t[n>>>2]>>>8*(3+n%4*-1)&255)<<16|(o>>>8*(3+(n+1)%4*-1)&255)<<8|i>>>8*(3+(n+2)%4*-1)&255,o=0;4>o;o+=1)a+=8*n+6*o<=e?"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(i>>>6*(3-o)&63):r.b64Pad;return a}function a(t,e){var r,n,o="",i=e/8;for(r=0;r<i;r+=1)n=t[r>>>2]>>>8*(3+r%4*-1)&255,o+=String.fromCharCode(n);return o}function u(t,e){var r,n,o=e/8,i=new ArrayBuffer(o);for(n=new Uint8Array(i),r=0;r<o;r+=1)n[r]=t[r>>>2]>>>8*(3+r%4*-1)&255;return i}function s(t){var e={outputUpper:!1,b64Pad:"=",shakeLen:-1};if(t=t||{},e.outputUpper=t.outputUpper||!1,!0===t.hasOwnProperty("b64Pad")&&(e.b64Pad=t.b64Pad),"boolean"!=typeof e.outputUpper)throw Error("Invalid outputUpper formatting option");if("string"!=typeof e.b64Pad)throw Error("Invalid b64Pad formatting option");return e}function c(t,e){var r;switch(e){case"UTF8":case"UTF16BE":case"UTF16LE":break;default:throw Error("encoding must be UTF8, UTF16BE, or UTF16LE")}switch(t){case"HEX":r=function(t,e,r){var n,o,i,a,u,s=t.length;if(0!=s%2)throw Error("String of HEX type must be in byte increments");for(e=e||[0],u=(r=r||0)>>>3,n=0;n<s;n+=2){if(o=parseInt(t.substr(n,2),16),isNaN(o))throw Error("String of HEX type contains invalid characters");for(i=(a=(n>>>1)+u)>>>2;e.length<=i;)e.push(0);e[i]|=o<<8*(3+a%4*-1)}return{value:e,binLen:4*s+r}};break;case"TEXT":r=function(t,r,n){var o,i,a,u,s,c,p,f,h=0;if(r=r||[0],s=(n=n||0)>>>3,"UTF8"===e)for(f=3,a=0;a<t.length;a+=1)for(i=[],128>(o=t.charCodeAt(a))?i.push(o):2048>o?(i.push(192|o>>>6),i.push(128|63&o)):55296>o||57344<=o?i.push(224|o>>>12,128|o>>>6&63,128|63&o):(a+=1,o=65536+((1023&o)<<10|1023&t.charCodeAt(a)),i.push(240|o>>>18,128|o>>>12&63,128|o>>>6&63,128|63&o)),u=0;u<i.length;u+=1){for(c=(p=h+s)>>>2;r.length<=c;)r.push(0);r[c]|=i[u]<<8*(f+p%4*-1),h+=1}else if("UTF16BE"===e||"UTF16LE"===e)for(f=2,i="UTF16LE"===e||"UTF16LE"!==e&&!1,a=0;a<t.length;a+=1){for(o=t.charCodeAt(a),!0===i&&(o=(u=255&o)<<8|o>>>8),c=(p=h+s)>>>2;r.length<=c;)r.push(0);r[c]|=o<<8*(f+p%4*-1),h+=2}return{value:r,binLen:8*h+n}};break;case"B64":r=function(t,e,r){var n,o,i,a,u,s,c,p=0;if(-1===t.search(/^[a-zA-Z0-9=+\/]+$/))throw Error("Invalid character in base-64 string");if(o=t.indexOf("="),t=t.replace(/\=/g,""),-1!==o&&o<t.length)throw Error("Invalid '=' found in base-64 string");for(e=e||[0],s=(r=r||0)>>>3,o=0;o<t.length;o+=4){for(u=t.substr(o,4),i=a=0;i<u.length;i+=1)a|=(n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(u[i]))<<18-6*i;for(i=0;i<u.length-1;i+=1){for(n=(c=p+s)>>>2;e.length<=n;)e.push(0);e[n]|=(a>>>16-8*i&255)<<8*(3+c%4*-1),p+=1}}return{value:e,binLen:8*p+r}};break;case"BYTES":r=function(t,e,r){var n,o,i,a,u;for(e=e||[0],i=(r=r||0)>>>3,o=0;o<t.length;o+=1)n=t.charCodeAt(o),a=(u=o+i)>>>2,e.length<=a&&e.push(0),e[a]|=n<<8*(3+u%4*-1);return{value:e,binLen:8*t.length+r}};break;case"ARRAYBUFFER":try{r=new ArrayBuffer(0)}catch(t){throw Error("ARRAYBUFFER not supported by this environment")}r=function(t,e,r){var n,o,i,a,u;for(e=e||[0],o=(r=r||0)>>>3,u=new Uint8Array(t),n=0;n<t.byteLength;n+=1)i=(a=n+o)>>>2,e.length<=i&&e.push(0),e[i]|=u[n]<<8*(3+a%4*-1);return{value:e,binLen:8*t.byteLength+r}};break;default:throw Error("format must be HEX, TEXT, B64, BYTES, or ARRAYBUFFER")}return r}function p(t,e){return t>>>e|t<<32-e}function f(t,e,r){return t&e^~t&r}function h(t,e,r){return t&e^t&r^e&r}function l(t){return p(t,2)^p(t,13)^p(t,22)}function d(t){return p(t,6)^p(t,11)^p(t,25)}function v(t){return p(t,7)^p(t,18)^t>>>3}function y(t){return p(t,17)^p(t,19)^t>>>10}function g(t,e){var r=(65535&t)+(65535&e);return((t>>>16)+(e>>>16)+(r>>>16)&65535)<<16|65535&r}function E(t,e,r,n){var o=(65535&t)+(65535&e)+(65535&r)+(65535&n);return((t>>>16)+(e>>>16)+(r>>>16)+(n>>>16)+(o>>>16)&65535)<<16|65535&o}function b(t,e,r,n,o){var i=(65535&t)+(65535&e)+(65535&r)+(65535&n)+(65535&o);return((t>>>16)+(e>>>16)+(r>>>16)+(n>>>16)+(o>>>16)+(i>>>16)&65535)<<16|65535&i}function m(t){var e,r=[];if(0!==t.lastIndexOf("SHA-",0))throw Error("No SHA variants supported");switch(r=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428],e=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],t){case"SHA-224":break;case"SHA-256":r=e;break;case"SHA-384":case"SHA-512":r=[new n,new n,new n,new n,new n,new n,new n,new n];break;default:throw Error("Unknown SHA variant")}return r}function S(t,e,r){var n,o,i,a,u,s,c,p,m,S,R,C,A,_,P,I,U,O,k,B,T,N,H,M=[];if("SHA-224"!==r&&"SHA-256"!==r)throw Error("Unexpected error in SHA-2 implementation");for(S=64,C=1,N=Number,A=g,_=E,P=b,I=v,U=y,O=l,k=d,T=h,B=f,H=w,r=e[0],n=e[1],o=e[2],i=e[3],a=e[4],u=e[5],s=e[6],c=e[7],R=0;R<S;R+=1)16>R?(m=R*C,p=t.length<=m?0:t[m],m=t.length<=m+1?0:t[m+1],M[R]=new N(p,m)):M[R]=_(U(M[R-2]),M[R-7],I(M[R-15]),M[R-16]),p=P(c,k(a),B(a,u,s),H[R],M[R]),m=A(O(r),T(r,n,o)),c=s,s=u,u=a,a=A(i,p),i=o,o=n,n=r,r=A(p,m);return e[0]=A(r,e[0]),e[1]=A(n,e[1]),e[2]=A(o,e[2]),e[3]=A(i,e[3]),e[4]=A(a,e[4]),e[5]=A(u,e[5]),e[6]=A(s,e[6]),e[7]=A(c,e[7]),e}var w;w=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],t.exports&&(t.exports=r),r}()}),_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},classCallCheck=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},createClass=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),defineProperty=function(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t},inherits=function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)},possibleConstructorReturn=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e},ERROR="input is invalid type",WINDOW="object"===("undefined"==typeof window?"undefined":_typeof(window)),root=WINDOW?window:{};root.JS_SHA3_NO_WINDOW&&(WINDOW=!1);var WEB_WORKER=!WINDOW&&"object"===("undefined"==typeof self?"undefined":_typeof(self)),NODE_JS=!root.JS_SHA3_NO_NODE_JS&&"object"===("undefined"==typeof process?"undefined":_typeof(process))&&process.versions&&process.versions.node;NODE_JS?root=commonjsGlobal:WEB_WORKER&&(root=self);var ARRAY_BUFFER=!root.JS_SHA3_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,HEX_CHARS="0123456789abcdef".split(""),SHAKE_PADDING=[31,7936,2031616,520093696],CSHAKE_PADDING=[4,1024,262144,67108864],KECCAK_PADDING=[1,256,65536,16777216],PADDING=[6,1536,393216,100663296],SHIFT=[0,8,16,24],RC=[1,0,32898,0,32906,2147483648,2147516416,2147483648,32907,0,2147483649,0,2147516545,2147483648,32777,2147483648,138,0,136,0,2147516425,0,2147483658,0,2147516555,0,139,2147483648,32905,2147483648,32771,2147483648,32770,2147483648,128,2147483648,32778,0,2147483658,2147483648,2147516545,2147483648,32896,2147483648,2147483649,0,2147516424,2147483648],BITS=[224,256,384,512],SHAKE_BITS=[128,256],OUTPUT_TYPES=["hex","buffer","arrayBuffer","array","digest"],CSHAKE_BYTEPAD={128:168,256:136};!root.JS_SHA3_NO_NODE_JS&&Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),!ARRAY_BUFFER||!root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(t){return"object"===(void 0===t?"undefined":_typeof(t))&&t.buffer&&t.buffer.constructor===ArrayBuffer});for(var createOutputMethod=function(t,e,r){return function(n){return new Keccak(t,e,t).update(n)[r]()}},createShakeOutputMethod=function(t,e,r){return function(n,o){return new Keccak(t,e,o).update(n)[r]()}},createCshakeOutputMethod=function(t,e,r){return function(e,n,o,i){return methods["cshake"+t].update(e,n,o,i)[r]()}},createKmacOutputMethod=function(t,e,r){return function(e,n,o,i){return methods["kmac"+t].update(e,n,o,i)[r]()}},createOutputMethods=function(t,e,r,n){for(var o=0;o<OUTPUT_TYPES.length;++o){var i=OUTPUT_TYPES[o];t[i]=e(r,n,i)}return t},createMethod=function(t,e){var r=createOutputMethod(t,e,"hex");return r.create=function(){return new Keccak(t,e,t)},r.update=function(t){return r.create().update(t)},createOutputMethods(r,createOutputMethod,t,e)},createShakeMethod=function(t,e){var r=createShakeOutputMethod(t,e,"hex");return r.create=function(r){return new Keccak(t,e,r)},r.update=function(t,e){return r.create(e).update(t)},createOutputMethods(r,createShakeOutputMethod,t,e)},createCshakeMethod=function(t,e){var r=CSHAKE_BYTEPAD[t],n=createCshakeOutputMethod(t,e,"hex");return n.create=function(n,o,i){return o||i?new Keccak(t,e,n).bytepad([o,i],r):methods["shake"+t].create(n)},n.update=function(t,e,r,o){return n.create(e,r,o).update(t)},createOutputMethods(n,createCshakeOutputMethod,t,e)},createKmacMethod=function(t,e){var r=CSHAKE_BYTEPAD[t],n=createKmacOutputMethod(t,e,"hex");return n.create=function(n,o,i){return new Kmac(t,e,o).bytepad(["KMAC",i],r).bytepad([n],r)},n.update=function(t,e,r,o){return n.create(t,r,o).update(e)},createOutputMethods(n,createKmacOutputMethod,t,e)},algorithms=[{name:"keccak",padding:KECCAK_PADDING,bits:BITS,createMethod:createMethod},{name:"sha3",padding:PADDING,bits:BITS,createMethod:createMethod},{name:"shake",padding:SHAKE_PADDING,bits:SHAKE_BITS,createMethod:createShakeMethod},{name:"cshake",padding:CSHAKE_PADDING,bits:SHAKE_BITS,createMethod:createCshakeMethod},{name:"kmac",padding:CSHAKE_PADDING,bits:SHAKE_BITS,createMethod:createKmacMethod}],methods={},i=0;i<algorithms.length;++i)for(var algorithm=algorithms[i],bits=algorithm.bits,j=0;j<bits.length;++j){var methodName=algorithm.name+"_"+bits[j];if(methods[methodName]=algorithm.createMethod(bits[j],algorithm.padding),"sha3"!==algorithm.name){var newMethodName=algorithm.name+bits[j];methods[newMethodName]=methods[methodName]}}function Keccak(t,e,r){this.blocks=[],this.s=[],this.padding=e,this.outputBits=r,this.reset=!0,this.finalized=!1,this.block=0,this.start=0,this.blockCount=1600-(t<<1)>>5,this.byteCount=this.blockCount<<2,this.outputBlocks=r>>5,this.extraBytes=(31&r)>>3;for(var n=0;n<50;++n)this.s[n]=0}function Kmac(t,e,r){Keccak.call(this,t,e,r)}Keccak.prototype.update=function(t){if(!this.finalized){var e,r=void 0===t?"undefined":_typeof(t);if("string"!==r){if("object"!==r)throw ERROR;if(null===t)throw ERROR;if(ARRAY_BUFFER&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||ARRAY_BUFFER&&ArrayBuffer.isView(t)))throw ERROR;e=!0}for(var n,o,i=this.blocks,a=this.byteCount,u=t.length,s=this.blockCount,c=0,p=this.s;c<u;){if(this.reset)for(this.reset=!1,i[0]=this.block,n=1;n<s+1;++n)i[n]=0;if(e)for(n=this.start;c<u&&n<a;++c)i[n>>2]|=t[c]<<SHIFT[3&n++];else for(n=this.start;c<u&&n<a;++c)(o=t.charCodeAt(c))<128?i[n>>2]|=o<<SHIFT[3&n++]:o<2048?(i[n>>2]|=(192|o>>6)<<SHIFT[3&n++],i[n>>2]|=(128|63&o)<<SHIFT[3&n++]):o<55296||o>=57344?(i[n>>2]|=(224|o>>12)<<SHIFT[3&n++],i[n>>2]|=(128|o>>6&63)<<SHIFT[3&n++],i[n>>2]|=(128|63&o)<<SHIFT[3&n++]):(o=65536+((1023&o)<<10|1023&t.charCodeAt(++c)),i[n>>2]|=(240|o>>18)<<SHIFT[3&n++],i[n>>2]|=(128|o>>12&63)<<SHIFT[3&n++],i[n>>2]|=(128|o>>6&63)<<SHIFT[3&n++],i[n>>2]|=(128|63&o)<<SHIFT[3&n++]);if(this.lastByteIndex=n,n>=a){for(this.start=n-a,this.block=i[s],n=0;n<s;++n)p[n]^=i[n];f(p),this.reset=!0}else this.start=n}return this}},Keccak.prototype.encode=function(t,e){var r=255&t,n=1,o=[r];for(r=255&(t>>=8);r>0;)o.unshift(r),r=255&(t>>=8),++n;return e?o.push(n):o.unshift(n),this.update(o),o.length},Keccak.prototype.encodeString=function(t){var e,r=void 0===t?"undefined":_typeof(t);if("string"!==r){if("object"!==r)throw ERROR;if(null===t)throw ERROR;if(ARRAY_BUFFER&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||ARRAY_BUFFER&&ArrayBuffer.isView(t)))throw ERROR;e=!0}var n=0,o=t.length;if(e)n=o;else for(var i=0;i<t.length;++i){var a=t.charCodeAt(i);a<128?n+=1:a<2048?n+=2:a<55296||a>=57344?n+=3:(a=65536+((1023&a)<<10|1023&t.charCodeAt(++i)),n+=4)}return n+=this.encode(8*n),this.update(t),n},Keccak.prototype.bytepad=function(t,e){for(var r=this.encode(e),n=0;n<t.length;++n)r+=this.encodeString(t[n]);var o=e-r%e,i=[];return i.length=o,this.update(i),this},Keccak.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var t=this.blocks,e=this.lastByteIndex,r=this.blockCount,n=this.s;if(t[e>>2]|=this.padding[3&e],this.lastByteIndex===this.byteCount)for(t[0]=t[r],e=1;e<r+1;++e)t[e]=0;for(t[r-1]|=2147483648,e=0;e<r;++e)n[e]^=t[e];f(n)}},Keccak.prototype.toString=Keccak.prototype.hex=function(){this.finalize();for(var t,e=this.blockCount,r=this.s,n=this.outputBlocks,o=this.extraBytes,i=0,a=0,u="";a<n;){for(i=0;i<e&&a<n;++i,++a)t=r[i],u+=HEX_CHARS[t>>4&15]+HEX_CHARS[15&t]+HEX_CHARS[t>>12&15]+HEX_CHARS[t>>8&15]+HEX_CHARS[t>>20&15]+HEX_CHARS[t>>16&15]+HEX_CHARS[t>>28&15]+HEX_CHARS[t>>24&15];a%e==0&&(f(r),i=0)}return o&&(t=r[i],u+=HEX_CHARS[t>>4&15]+HEX_CHARS[15&t],o>1&&(u+=HEX_CHARS[t>>12&15]+HEX_CHARS[t>>8&15]),o>2&&(u+=HEX_CHARS[t>>20&15]+HEX_CHARS[t>>16&15])),u},Keccak.prototype.arrayBuffer=function(){this.finalize();var t,e=this.blockCount,r=this.s,n=this.outputBlocks,o=this.extraBytes,i=0,a=0,u=this.outputBits>>3;t=o?new ArrayBuffer(n+1<<2):new ArrayBuffer(u);for(var s=new Uint32Array(t);a<n;){for(i=0;i<e&&a<n;++i,++a)s[a]=r[i];a%e==0&&f(r)}return o&&(s[i]=r[i],t=t.slice(0,u)),t},Keccak.prototype.buffer=Keccak.prototype.arrayBuffer,Keccak.prototype.digest=Keccak.prototype.array=function(){this.finalize();for(var t,e,r=this.blockCount,n=this.s,o=this.outputBlocks,i=this.extraBytes,a=0,u=0,s=[];u<o;){for(a=0;a<r&&u<o;++a,++u)t=u<<2,e=n[a],s[t]=255&e,s[t+1]=e>>8&255,s[t+2]=e>>16&255,s[t+3]=e>>24&255;u%r==0&&f(n)}return i&&(t=u<<2,e=n[a],s[t]=255&e,i>1&&(s[t+1]=e>>8&255),i>2&&(s[t+2]=e>>16&255)),s},Kmac.prototype=new Keccak,Kmac.prototype.finalize=function(){return this.encode(this.outputBits,!0),Keccak.prototype.finalize.call(this)};var f=function(t){var e,r,n,o,i,a,u,s,c,p,f,h,l,d,v,y,g,E,b,m,S,w,R,C,A,_,P,I,U,O,k,B,T,N,H,M,x,F,D,X,q,K,V,L,j,Y,z,$,J,Z,W,G,Q,tt,et,rt,nt,ot,it,at,ut,st,ct;for(n=0;n<48;n+=2)o=t[0]^t[10]^t[20]^t[30]^t[40],i=t[1]^t[11]^t[21]^t[31]^t[41],a=t[2]^t[12]^t[22]^t[32]^t[42],u=t[3]^t[13]^t[23]^t[33]^t[43],s=t[4]^t[14]^t[24]^t[34]^t[44],c=t[5]^t[15]^t[25]^t[35]^t[45],p=t[6]^t[16]^t[26]^t[36]^t[46],f=t[7]^t[17]^t[27]^t[37]^t[47],e=(h=t[8]^t[18]^t[28]^t[38]^t[48])^(a<<1|u>>>31),r=(l=t[9]^t[19]^t[29]^t[39]^t[49])^(u<<1|a>>>31),t[0]^=e,t[1]^=r,t[10]^=e,t[11]^=r,t[20]^=e,t[21]^=r,t[30]^=e,t[31]^=r,t[40]^=e,t[41]^=r,e=o^(s<<1|c>>>31),r=i^(c<<1|s>>>31),t[2]^=e,t[3]^=r,t[12]^=e,t[13]^=r,t[22]^=e,t[23]^=r,t[32]^=e,t[33]^=r,t[42]^=e,t[43]^=r,e=a^(p<<1|f>>>31),r=u^(f<<1|p>>>31),t[4]^=e,t[5]^=r,t[14]^=e,t[15]^=r,t[24]^=e,t[25]^=r,t[34]^=e,t[35]^=r,t[44]^=e,t[45]^=r,e=s^(h<<1|l>>>31),r=c^(l<<1|h>>>31),t[6]^=e,t[7]^=r,t[16]^=e,t[17]^=r,t[26]^=e,t[27]^=r,t[36]^=e,t[37]^=r,t[46]^=e,t[47]^=r,e=p^(o<<1|i>>>31),r=f^(i<<1|o>>>31),t[8]^=e,t[9]^=r,t[18]^=e,t[19]^=r,t[28]^=e,t[29]^=r,t[38]^=e,t[39]^=r,t[48]^=e,t[49]^=r,d=t[0],v=t[1],Y=t[11]<<4|t[10]>>>28,z=t[10]<<4|t[11]>>>28,I=t[20]<<3|t[21]>>>29,U=t[21]<<3|t[20]>>>29,at=t[31]<<9|t[30]>>>23,ut=t[30]<<9|t[31]>>>23,K=t[40]<<18|t[41]>>>14,V=t[41]<<18|t[40]>>>14,N=t[2]<<1|t[3]>>>31,H=t[3]<<1|t[2]>>>31,y=t[13]<<12|t[12]>>>20,g=t[12]<<12|t[13]>>>20,$=t[22]<<10|t[23]>>>22,J=t[23]<<10|t[22]>>>22,O=t[33]<<13|t[32]>>>19,k=t[32]<<13|t[33]>>>19,st=t[42]<<2|t[43]>>>30,ct=t[43]<<2|t[42]>>>30,tt=t[5]<<30|t[4]>>>2,et=t[4]<<30|t[5]>>>2,M=t[14]<<6|t[15]>>>26,x=t[15]<<6|t[14]>>>26,E=t[25]<<11|t[24]>>>21,b=t[24]<<11|t[25]>>>21,Z=t[34]<<15|t[35]>>>17,W=t[35]<<15|t[34]>>>17,B=t[45]<<29|t[44]>>>3,T=t[44]<<29|t[45]>>>3,C=t[6]<<28|t[7]>>>4,A=t[7]<<28|t[6]>>>4,rt=t[17]<<23|t[16]>>>9,nt=t[16]<<23|t[17]>>>9,F=t[26]<<25|t[27]>>>7,D=t[27]<<25|t[26]>>>7,m=t[36]<<21|t[37]>>>11,S=t[37]<<21|t[36]>>>11,G=t[47]<<24|t[46]>>>8,Q=t[46]<<24|t[47]>>>8,L=t[8]<<27|t[9]>>>5,j=t[9]<<27|t[8]>>>5,_=t[18]<<20|t[19]>>>12,P=t[19]<<20|t[18]>>>12,ot=t[29]<<7|t[28]>>>25,it=t[28]<<7|t[29]>>>25,X=t[38]<<8|t[39]>>>24,q=t[39]<<8|t[38]>>>24,w=t[48]<<14|t[49]>>>18,R=t[49]<<14|t[48]>>>18,t[0]=d^~y&E,t[1]=v^~g&b,t[10]=C^~_&I,t[11]=A^~P&U,t[20]=N^~M&F,t[21]=H^~x&D,t[30]=L^~Y&$,t[31]=j^~z&J,t[40]=tt^~rt&ot,t[41]=et^~nt&it,t[2]=y^~E&m,t[3]=g^~b&S,t[12]=_^~I&O,t[13]=P^~U&k,t[22]=M^~F&X,t[23]=x^~D&q,t[32]=Y^~$&Z,t[33]=z^~J&W,t[42]=rt^~ot&at,t[43]=nt^~it&ut,t[4]=E^~m&w,t[5]=b^~S&R,t[14]=I^~O&B,t[15]=U^~k&T,t[24]=F^~X&K,t[25]=D^~q&V,t[34]=$^~Z&G,t[35]=J^~W&Q,t[44]=ot^~at&st,t[45]=it^~ut&ct,t[6]=m^~w&d,t[7]=S^~R&v,t[16]=O^~B&C,t[17]=k^~T&A,t[26]=X^~K&N,t[27]=q^~V&H,t[36]=Z^~G&L,t[37]=W^~Q&j,t[46]=at^~st&tt,t[47]=ut^~ct&et,t[8]=w^~d&y,t[9]=R^~v&g,t[18]=B^~C&_,t[19]=T^~A&P,t[28]=K^~N&M,t[29]=V^~H&x,t[38]=G^~L&Y,t[39]=Q^~j&z,t[48]=st^~tt&rt,t[49]=ct^~et&nt,t[0]^=RC[n],t[1]^=RC[n+1]},sha3=methods,keccak256=sha3.keccak256;function numberToHex(t){var e=Math.round(t).toString(16);return 1===e.length&&(e="0"+e),e}var cryptoUtils={toHex:function(t){for(var e="",r=0;r<t.length;r++)e+=numberToHex(t[r]);return e},toByteArray:function(t){for(var e=t,r=[];e.length>=2;)r.push(parseInt(e.substring(0,2),16)),e=e.substring(2,e.length);return r},sha256:function(t){var e=new sha256("SHA-256","HEX");return e.update(t),e.getHash("HEX")},sha3:function(t){return keccak256(t)}};function base(t){for(var e={},r=t.length,n=t.charAt(0),o=0;o<t.length;o++){var i=t.charAt(o);if(void 0!==e[i])throw new TypeError(i+" is ambiguous");e[i]=o}function a(t){if("string"!=typeof t)throw new TypeError("Expected String");if(0===t.length)return[];for(var o=[0],i=0;i<t.length;i++){var a=e[t[i]];if(void 0===a)return;for(var u=a,s=0;s<o.length;++s)u+=o[s]*r,o[s]=255&u,u>>=8;for(;u>0;)o.push(255&u),u>>=8}for(var c=0;t[c]===n&&c<t.length-1;++c)o.push(0);return o.reverse()}return{encode:function(e){if(0===e.length)return"";for(var o=[0],i=0;i<e.length;++i){for(var a=e[i],u=0;u<o.length;++u)a+=o[u]<<8,o[u]=a%r,a=a/r|0;for(;a>0;)o.push(a%r),a=a/r|0}for(var s="",c=0;0===e[c]&&c<e.length-1;++c)s+=n;for(var p=o.length-1;p>=0;--p)s+=t[o[p]];return s},decodeUnsafe:a,decode:function(t){var e=a(t);if(e)return e;throw new Error("Non-base"+r+" character")}}}function baseXCheck(t){var e=base(t);return{encode:function(t){var r=cryptoUtils.sha256(cryptoUtils.sha256(t)).slice(0,8);return e.encode(cryptoUtils.toByteArray(t.concat(r)))},decode:function(t){var r=e.decode(t),n=r.length,o=cryptoUtils.toHex(r.slice(0,n-4)),i=cryptoUtils.sha256(cryptoUtils.sha256(o)).substr(0,8);return cryptoUtils.toHex(r.slice(n-4,n))===i?r.slice(0,n-4):null}}}var alphabet="123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";base(alphabet);var _PREFIXES,base58Check=baseXCheck(alphabet),BaseValidator=function(){function t(e){classCallCheck(this,t),this.supportedCurrencies=e}return createClass(t,[{key:"isAppliedFor",value:function(t){return this.supportedCurrencies.some(function(e){return e===t})}},{key:"getSupportedCurrencies",value:function(){return this.supportedCurrencies}}]),t}(),SUPPORTED_CURRENCIES={bitcoin:"BTC",litecoin:"LTC",dogecoin:"DOGE",dash:"DASH",bitcoin_cash:"BTH",bitcoin_gold:"BTG",ethereum:"ETH",omise_go:"OMG",augur:"REP",eos:"EOS",fuel:"FUEL",status:"SNT",singularDTV:"SNGLS",genesis_coin:"GEN",walton_chain:"WTC",ethereum_classic:"ETC",monero:"XMR",ripple:"XRP",zcash:"ZEC",tether:"USDT",unobtamium:"UNO",iota:"IOTA",stellar:"XLM",neo:"NEO",ubiq:"UBQ",qtum:"QTUM"},CHARSET="qpzry9x8gf2tvdw0s3jn54khce6mua7l",GENERATOR=[996825010,642813549,513874426,1027748829,705979059],polymod=function(t){for(var e=1,r=0;r<t.length;++r){var n=e>>25;e=(33554431&e)<<5^t[r];for(var o=0;o<5;++o)n>>o&1&&(e^=GENERATOR[o])}return e},hrpExpand=function(t){for(var e=[],r=0;r<t.length;++r)e.push(t.charCodeAt(r)>>5);e.push(0);for(var n=0;n<t.length;++n)e.push(31&t.charCodeAt(n));return e},verifyChecksum=function(t,e){return 1===polymod(hrpExpand(t).concat(e))},createChecksum=function(t,e){for(var r=hrpExpand(t).concat(e).concat([0,0,0,0,0,0]),n=1^polymod(r),o=[],i=0;i<6;++i)o.push(n>>5*(5-i)&31);return o},encode=function(t,e){for(var r=e.concat(createChecksum(t,e)),n=t+"1",o=0;o<r.length;++o)n+=CHARSET.charAt(r[o]);return n},decode=function(t){var e=void 0,r=!1,n=!1;for(e=0;e<t.length;++e){if(t.charCodeAt(e)<33||t.charCodeAt(e)>126)return null;t.charCodeAt(e)>=97&&t.charCodeAt(e)<=122&&(r=!0),t.charCodeAt(e)>=65&&t.charCodeAt(e)<=90&&(n=!0)}if(r&&n)return null;var o=(t=t.toLowerCase()).lastIndexOf("1");if(o<1||o+7>t.length||t.length>90)return null;var i=t.substring(0,o),a=[];for(e=o+1;e<t.length;++e){var u=CHARSET.indexOf(t.charAt(e));if(-1===u)return null;a.push(u)}return verifyChecksum(i,a)?{hrp:i,data:a.slice(0,a.length-6)}:null},convertbits=function(t,e,r,n){for(var o=0,i=0,a=[],u=(1<<r)-1,s=0;s<t.length;++s){var c=t[s];if(c<0||c>>e!=0)return null;for(o=o<<e|c,i+=e;i>=r;)i-=r,a.push(o>>i&u)}if(n)i>0&&a.push(o<<r-i&u);else if(i>=e||o<<r-i&u)return null;return a},decode$1=function(t,e){var r=decode(e);if(null===r||r.hrp!==t||r.data.length<1||r.data[0]>16)return null;var n=convertbits(r.data.slice(1),5,8,!1);return null===n||n.length<2||n.length>40?null:0===r.data[0]&&20!==n.length&&32!==n.length?null:{version:r.data[0],program:n}},encode$1=function(t,e,r){var n=encode(t,[e].concat(convertbits(r,8,5,!0)));return null===decode$1(t,n)?null:n},isValidAddress=function(t,e){if(!t)return!1;var r=e||"bc",n=decode$1(r,t);return null===n&&(n=decode$1(r="tb",t)),null!==n&&encode$1(r,n.version,n.program)===t.toLowerCase()},BITCOIN_PREFIXES={prod:["00","05"],testnet:["6f","c4"]},PREFIXES=(defineProperty(_PREFIXES={},SUPPORTED_CURRENCIES.bitcoin,BITCOIN_PREFIXES),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.tether,BITCOIN_PREFIXES),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.litecoin,{prod:["30","05","32"],testnet:["6f","c4","3a"]}),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.dogecoin,{prod:["1e","16"],testnet:["71","c4"]}),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.dash,{prod:["4c","10"],testnet:["8c","13"]}),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.bitcoin_gold,{prod:["26","17"]}),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.zcash,{prod:["1cb8","1cbd"],testnet:["1d25","1cba"]}),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.unobtamium,{prod:["82","1e"],testnet:["44","1e"]}),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.neo,{prod:["17"]}),defineProperty(_PREFIXES,SUPPORTED_CURRENCIES.qtum,{prod:["3a","32"],testnet:["78","6e"]}),_PREFIXES),DefaultValidator=function(t){function e(){return classCallCheck(this,e),possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,Object.keys(PREFIXES)))}return inherits(e,BaseValidator),createClass(e,[{key:"getAddressPrefix",value:function(t,e){var r=void 0;try{r=base58Check.decode(t)}catch(t){return null}return r?cryptoUtils.toHex(r.slice(0,e)):null}},{key:"validate",value:function(t,e){var r=this.getAddressTypes(e),n=this.getPrefixLength(r),o=this.getAddressPrefix(t,n);return r.indexOf(o)>=0||isValidAddress(t)}},{key:"getAddressTypes",value:function(t){var e=PREFIXES[t];return e.prod.concat(e.testnet)}},{key:"getPrefixLength",value:function(t){return t[0].length/2}}]),e}(),BigInteger=createCommonjsModule(function(t){var e=function(t){var r=1e7,n=7,o=9007199254740992,i=l(o),a="0123456789abcdefghijklmnopqrstuvwxyz",u="function"==typeof BigInt;function s(t,e,r,n){return void 0===t?s[0]:void 0!==e&&(10!=+e||r)?L(t,e,r,n):J(t)}function c(t,e){this.value=t,this.sign=e,this.isSmall=!1}function p(t){this.value=t,this.sign=t<0,this.isSmall=!0}function f(t){this.value=t}function h(t){return-o<t&&t<o}function l(t){return t<1e7?[t]:t<1e14?[t%1e7,Math.floor(t/1e7)]:[t%1e7,Math.floor(t/1e7)%1e7,Math.floor(t/1e14)]}function d(t){v(t);var e=t.length;if(e<4&&O(t,i)<0)switch(e){case 0:return 0;case 1:return t[0];case 2:return t[0]+t[1]*r;default:return t[0]+(t[1]+t[2]*r)*r}return t}function v(t){for(var e=t.length;0===t[--e];);t.length=e+1}function y(t){for(var e=new Array(t),r=-1;++r<t;)e[r]=0;return e}function g(t){return t>0?Math.floor(t):Math.ceil(t)}function E(t,e){var n,o,i=t.length,a=e.length,u=new Array(i),s=0,c=r;for(o=0;o<a;o++)s=(n=t[o]+e[o]+s)>=c?1:0,u[o]=n-s*c;for(;o<i;)s=(n=t[o]+s)===c?1:0,u[o++]=n-s*c;return s>0&&u.push(s),u}function b(t,e){return t.length>=e.length?E(t,e):E(e,t)}function m(t,e){var n,o,i=t.length,a=new Array(i),u=r;for(o=0;o<i;o++)n=t[o]-u+e,e=Math.floor(n/u),a[o]=n-e*u,e+=1;for(;e>0;)a[o++]=e%u,e=Math.floor(e/u);return a}function S(t,e){var n,o,i=t.length,a=e.length,u=new Array(i),s=0,c=r;for(n=0;n<a;n++)(o=t[n]-s-e[n])<0?(o+=c,s=1):s=0,u[n]=o;for(n=a;n<i;n++){if(!((o=t[n]-s)<0)){u[n++]=o;break}o+=c,u[n]=o}for(;n<i;n++)u[n]=t[n];return v(u),u}function w(t,e,n){var o,i,a=t.length,u=new Array(a),s=-e,f=r;for(o=0;o<a;o++)i=t[o]+s,s=Math.floor(i/f),i%=f,u[o]=i<0?i+f:i;return"number"==typeof(u=d(u))?(n&&(u=-u),new p(u)):new c(u,n)}function R(t,e){var n,o,i,a,u=t.length,s=e.length,c=y(u+s),p=r;for(i=0;i<u;++i){a=t[i];for(var f=0;f<s;++f)n=a*e[f]+c[i+f],o=Math.floor(n/p),c[i+f]=n-o*p,c[i+f+1]+=o}return v(c),c}function C(t,e){var n,o,i=t.length,a=new Array(i),u=r,s=0;for(o=0;o<i;o++)n=t[o]*e+s,s=Math.floor(n/u),a[o]=n-s*u;for(;s>0;)a[o++]=s%u,s=Math.floor(s/u);return a}function A(t,e){for(var r=[];e-- >0;)r.push(0);return r.concat(t)}function _(t,e,n){return new c(t<r?C(e,t):R(e,l(t)),n)}function P(t){var e,n,o,i,a=t.length,u=y(a+a),s=r;for(o=0;o<a;o++){n=0-(i=t[o])*i;for(var c=o;c<a;c++)e=i*t[c]*2+u[o+c]+n,n=Math.floor(e/s),u[o+c]=e-n*s;u[o+a]=n}return v(u),u}function I(t,e){var n,o,i,a,u=t.length,s=y(u),c=r;for(i=0,n=u-1;n>=0;--n)i=(a=i*c+t[n])-(o=g(a/e))*e,s[n]=0|o;return[s,0|i]}function U(t,e){var n,o=J(e);if(u)return[new f(t.value/o.value),new f(t.value%o.value)];var i,a=t.value,h=o.value;if(0===h)throw new Error("Cannot divide by zero");if(t.isSmall)return o.isSmall?[new p(g(a/h)),new p(a%h)]:[s[0],t];if(o.isSmall){if(1===h)return[t,s[0]];if(-1==h)return[t.negate(),s[0]];var E=Math.abs(h);if(E<r){i=d((n=I(a,E))[0]);var b=n[1];return t.sign&&(b=-b),"number"==typeof i?(t.sign!==o.sign&&(i=-i),[new p(i),new p(b)]):[new c(i,t.sign!==o.sign),new p(b)]}h=l(E)}var m=O(a,h);if(-1===m)return[s[0],t];if(0===m)return[s[t.sign===o.sign?1:-1],s[0]];i=(n=a.length+h.length<=200?function(t,e){var n,o,i,a,u,s,c,p=t.length,f=e.length,h=r,l=y(e.length),v=e[f-1],g=Math.ceil(h/(2*v)),E=C(t,g),b=C(e,g);for(E.length<=p&&E.push(0),b.push(0),v=b[f-1],o=p-f;o>=0;o--){for(n=h-1,E[o+f]!==v&&(n=Math.floor((E[o+f]*h+E[o+f-1])/v)),i=0,a=0,s=b.length,u=0;u<s;u++)i+=n*b[u],c=Math.floor(i/h),a+=E[o+u]-(i-c*h),i=c,a<0?(E[o+u]=a+h,a=-1):(E[o+u]=a,a=0);for(;0!==a;){for(n-=1,i=0,u=0;u<s;u++)(i+=E[o+u]-h+b[u])<0?(E[o+u]=i+h,i=0):(E[o+u]=i,i=1);a+=i}l[o]=n}return E=I(E,g)[0],[d(l),d(E)]}(a,h):function(t,e){for(var n,o,i,a,u,s=t.length,c=e.length,p=[],f=[],h=r;s;)if(f.unshift(t[--s]),v(f),O(f,e)<0)p.push(0);else{i=f[(o=f.length)-1]*h+f[o-2],a=e[c-1]*h+e[c-2],o>c&&(i=(i+1)*h),n=Math.ceil(i/a);do{if(O(u=C(e,n),f)<=0)break;n--}while(n);p.push(n),f=S(f,u)}return p.reverse(),[d(p),d(f)]}(a,h))[0];var w=t.sign!==o.sign,R=n[1],A=t.sign;return"number"==typeof i?(w&&(i=-i),i=new p(i)):i=new c(i,w),"number"==typeof R?(A&&(R=-R),R=new p(R)):R=new c(R,A),[i,R]}function O(t,e){if(t.length!==e.length)return t.length>e.length?1:-1;for(var r=t.length-1;r>=0;r--)if(t[r]!==e[r])return t[r]>e[r]?1:-1;return 0}function k(t){var e=t.abs();return!e.isUnit()&&(!!(e.equals(2)||e.equals(3)||e.equals(5))||!(e.isEven()||e.isDivisibleBy(3)||e.isDivisibleBy(5))&&(!!e.lesser(49)||void 0))}function B(t,r){for(var n,o,i,a=t.prev(),u=a,s=0;u.isEven();)u=u.divide(2),s++;t:for(o=0;o<r.length;o++)if(!t.lesser(r[o])&&!(i=e(r[o]).modPow(u,t)).isUnit()&&!i.equals(a)){for(n=s-1;0!=n;n--){if((i=i.square().mod(t)).isUnit())return!1;if(i.equals(a))continue t}return!1}return!0}c.prototype=Object.create(s.prototype),p.prototype=Object.create(s.prototype),f.prototype=Object.create(s.prototype),c.prototype.add=function(t){var e=J(t);if(this.sign!==e.sign)return this.subtract(e.negate());var r=this.value,n=e.value;return e.isSmall?new c(m(r,Math.abs(n)),this.sign):new c(b(r,n),this.sign)},c.prototype.plus=c.prototype.add,p.prototype.add=function(t){var e=J(t),r=this.value;if(r<0!==e.sign)return this.subtract(e.negate());var n=e.value;if(e.isSmall){if(h(r+n))return new p(r+n);n=l(Math.abs(n))}return new c(m(n,Math.abs(r)),r<0)},p.prototype.plus=p.prototype.add,f.prototype.add=function(t){return new f(this.value+J(t).value)},f.prototype.plus=f.prototype.add,c.prototype.subtract=function(t){var e=J(t);if(this.sign!==e.sign)return this.add(e.negate());var r=this.value,n=e.value;return e.isSmall?w(r,Math.abs(n),this.sign):function(t,e,r){var n;return O(t,e)>=0?n=S(t,e):(n=S(e,t),r=!r),"number"==typeof(n=d(n))?(r&&(n=-n),new p(n)):new c(n,r)}(r,n,this.sign)},c.prototype.minus=c.prototype.subtract,p.prototype.subtract=function(t){var e=J(t),r=this.value;if(r<0!==e.sign)return this.add(e.negate());var n=e.value;return e.isSmall?new p(r-n):w(n,Math.abs(r),r>=0)},p.prototype.minus=p.prototype.subtract,f.prototype.subtract=function(t){return new f(this.value-J(t).value)},f.prototype.minus=f.prototype.subtract,c.prototype.negate=function(){return new c(this.value,!this.sign)},p.prototype.negate=function(){var t=this.sign,e=new p(-this.value);return e.sign=!t,e},f.prototype.negate=function(){return new f(-this.value)},c.prototype.abs=function(){return new c(this.value,!1)},p.prototype.abs=function(){return new p(Math.abs(this.value))},f.prototype.abs=function(){return new f(this.value>=0?this.value:-this.value)},c.prototype.multiply=function(t){var e,n,o,i=J(t),a=this.value,u=i.value,p=this.sign!==i.sign;if(i.isSmall){if(0===u)return s[0];if(1===u)return this;if(-1===u)return this.negate();if((e=Math.abs(u))<r)return new c(C(a,e),p);u=l(e)}return n=a.length,o=u.length,new c(-.012*n-.012*o+15e-6*n*o>0?function t(e,r){var n=Math.max(e.length,r.length);if(n<=30)return R(e,r);n=Math.ceil(n/2);var o=e.slice(n),i=e.slice(0,n),a=r.slice(n),u=r.slice(0,n),s=t(i,u),c=t(o,a),p=b(b(s,A(S(S(t(b(i,o),b(u,a)),s),c),n)),A(c,2*n));return v(p),p}(a,u):R(a,u),p)},c.prototype.times=c.prototype.multiply,p.prototype._multiplyBySmall=function(t){return h(t.value*this.value)?new p(t.value*this.value):_(Math.abs(t.value),l(Math.abs(this.value)),this.sign!==t.sign)},c.prototype._multiplyBySmall=function(t){return 0===t.value?s[0]:1===t.value?this:-1===t.value?this.negate():_(Math.abs(t.value),this.value,this.sign!==t.sign)},p.prototype.multiply=function(t){return J(t)._multiplyBySmall(this)},p.prototype.times=p.prototype.multiply,f.prototype.multiply=function(t){return new f(this.value*J(t).value)},f.prototype.times=f.prototype.multiply,c.prototype.square=function(){return new c(P(this.value),!1)},p.prototype.square=function(){var t=this.value*this.value;return h(t)?new p(t):new c(P(l(Math.abs(this.value))),!1)},f.prototype.square=function(t){return new f(this.value*this.value)},c.prototype.divmod=function(t){var e=U(this,t);return{quotient:e[0],remainder:e[1]}},f.prototype.divmod=p.prototype.divmod=c.prototype.divmod,c.prototype.divide=function(t){return U(this,t)[0]},f.prototype.over=f.prototype.divide=function(t){return new f(this.value/J(t).value)},p.prototype.over=p.prototype.divide=c.prototype.over=c.prototype.divide,c.prototype.mod=function(t){return U(this,t)[1]},f.prototype.mod=f.prototype.remainder=function(t){return new f(this.value%J(t).value)},p.prototype.remainder=p.prototype.mod=c.prototype.remainder=c.prototype.mod,c.prototype.pow=function(t){var e,r,n,o=J(t),i=this.value,a=o.value;if(0===a)return s[1];if(0===i)return s[0];if(1===i)return s[1];if(-1===i)return o.isEven()?s[1]:s[-1];if(o.sign)return s[0];if(!o.isSmall)throw new Error("The exponent "+o.toString()+" is too large.");if(this.isSmall&&h(e=Math.pow(i,a)))return new p(g(e));for(r=this,n=s[1];!0&a&&(n=n.times(r),--a),0!==a;)a/=2,r=r.square();return n},p.prototype.pow=c.prototype.pow,f.prototype.pow=function(t){var e=J(t),r=this.value,n=e.value,o=BigInt(0),i=BigInt(1),a=BigInt(2);if(n===o)return s[1];if(r===o)return s[0];if(r===i)return s[1];if(r===BigInt(-1))return e.isEven()?s[1]:s[-1];if(e.isNegative())return new f(o);for(var u=this,c=s[1];(n&i)===i&&(c=c.times(u),--n),n!==o;)n/=a,u=u.square();return c},c.prototype.modPow=function(t,e){if(t=J(t),(e=J(e)).isZero())throw new Error("Cannot take modPow with modulus 0");for(var r=s[1],n=this.mod(e);t.isPositive();){if(n.isZero())return s[0];t.isOdd()&&(r=r.multiply(n).mod(e)),t=t.divide(2),n=n.square().mod(e)}return r},f.prototype.modPow=p.prototype.modPow=c.prototype.modPow,c.prototype.compareAbs=function(t){var e=J(t),r=this.value,n=e.value;return e.isSmall?1:O(r,n)},p.prototype.compareAbs=function(t){var e=J(t),r=Math.abs(this.value),n=e.value;return e.isSmall?r===(n=Math.abs(n))?0:r>n?1:-1:-1},f.prototype.compareAbs=function(t){var e=this.value,r=J(t).value;return(e=e>=0?e:-e)===(r=r>=0?r:-r)?0:e>r?1:-1},c.prototype.compare=function(t){if(t===1/0)return-1;if(t===-1/0)return 1;var e=J(t),r=this.value,n=e.value;return this.sign!==e.sign?e.sign?1:-1:e.isSmall?this.sign?-1:1:O(r,n)*(this.sign?-1:1)},c.prototype.compareTo=c.prototype.compare,p.prototype.compare=function(t){if(t===1/0)return-1;if(t===-1/0)return 1;var e=J(t),r=this.value,n=e.value;return e.isSmall?r==n?0:r>n?1:-1:r<0!==e.sign?r<0?-1:1:r<0?1:-1},p.prototype.compareTo=p.prototype.compare,f.prototype.compare=function(t){if(t===1/0)return-1;if(t===-1/0)return 1;var e=this.value,r=J(t).value;return e===r?0:e>r?1:-1},f.prototype.compareTo=f.prototype.compare,c.prototype.equals=function(t){return 0===this.compare(t)},f.prototype.eq=f.prototype.equals=p.prototype.eq=p.prototype.equals=c.prototype.eq=c.prototype.equals,c.prototype.notEquals=function(t){return 0!==this.compare(t)},f.prototype.neq=f.prototype.notEquals=p.prototype.neq=p.prototype.notEquals=c.prototype.neq=c.prototype.notEquals,c.prototype.greater=function(t){return this.compare(t)>0},f.prototype.gt=f.prototype.greater=p.prototype.gt=p.prototype.greater=c.prototype.gt=c.prototype.greater,c.prototype.lesser=function(t){return this.compare(t)<0},f.prototype.lt=f.prototype.lesser=p.prototype.lt=p.prototype.lesser=c.prototype.lt=c.prototype.lesser,c.prototype.greaterOrEquals=function(t){return this.compare(t)>=0},f.prototype.geq=f.prototype.greaterOrEquals=p.prototype.geq=p.prototype.greaterOrEquals=c.prototype.geq=c.prototype.greaterOrEquals,c.prototype.lesserOrEquals=function(t){return this.compare(t)<=0},f.prototype.leq=f.prototype.lesserOrEquals=p.prototype.leq=p.prototype.lesserOrEquals=c.prototype.leq=c.prototype.lesserOrEquals,c.prototype.isEven=function(){return 0==(1&this.value[0])},p.prototype.isEven=function(){return 0==(1&this.value)},f.prototype.isEven=function(){return(this.value&BigInt(1))===BigInt(0)},c.prototype.isOdd=function(){return 1==(1&this.value[0])},p.prototype.isOdd=function(){return 1==(1&this.value)},f.prototype.isOdd=function(){return(this.value&BigInt(1))===BigInt(1)},c.prototype.isPositive=function(){return!this.sign},p.prototype.isPositive=function(){return this.value>0},f.prototype.isPositive=p.prototype.isPositive,c.prototype.isNegative=function(){return this.sign},p.prototype.isNegative=function(){return this.value<0},f.prototype.isNegative=p.prototype.isNegative,c.prototype.isUnit=function(){return!1},p.prototype.isUnit=function(){return 1===Math.abs(this.value)},f.prototype.isUnit=function(){return this.abs().value===BigInt(1)},c.prototype.isZero=function(){return!1},p.prototype.isZero=function(){return 0===this.value},f.prototype.isZero=function(){return this.value===BigInt(0)},c.prototype.isDivisibleBy=function(t){var e=J(t);return!e.isZero()&&(!!e.isUnit()||(0===e.compareAbs(2)?this.isEven():this.mod(e).isZero()))},f.prototype.isDivisibleBy=p.prototype.isDivisibleBy=c.prototype.isDivisibleBy,c.prototype.isPrime=function(t){var r=k(this);if(void 0!==r)return r;var n=this.abs(),o=n.bitLength();if(o<=64)return B(n,[2,3,5,7,11,13,17,19,23,29,31,37]);for(var i=Math.log(2)*o.toJSNumber(),a=Math.ceil(!0===t?2*Math.pow(i,2):i),u=[],s=0;s<a;s++)u.push(e(s+2));return B(n,u)},f.prototype.isPrime=p.prototype.isPrime=c.prototype.isPrime,c.prototype.isProbablePrime=function(t){var r=k(this);if(void 0!==r)return r;for(var n=this.abs(),o=void 0===t?5:t,i=[],a=0;a<o;a++)i.push(e.randBetween(2,n.minus(2)));return B(n,i)},f.prototype.isProbablePrime=p.prototype.isProbablePrime=c.prototype.isProbablePrime,c.prototype.modInv=function(t){for(var r,n,o,i=e.zero,a=e.one,u=J(t),s=this.abs();!s.isZero();)r=u.divide(s),n=i,o=u,i=a,u=s,a=n.subtract(r.multiply(a)),s=o.subtract(r.multiply(s));if(!u.isUnit())throw new Error(this.toString()+" and "+t.toString()+" are not co-prime");return-1===i.compare(0)&&(i=i.add(t)),this.isNegative()?i.negate():i},f.prototype.modInv=p.prototype.modInv=c.prototype.modInv,c.prototype.next=function(){var t=this.value;return this.sign?w(t,1,this.sign):new c(m(t,1),this.sign)},p.prototype.next=function(){var t=this.value;return t+1<o?new p(t+1):new c(i,!1)},f.prototype.next=function(){return new f(this.value+BigInt(1))},c.prototype.prev=function(){var t=this.value;return this.sign?new c(m(t,1),!0):w(t,1,this.sign)},p.prototype.prev=function(){var t=this.value;return t-1>-o?new p(t-1):new c(i,!0)},f.prototype.prev=function(){return new f(this.value-BigInt(1))};for(var T=[1];2*T[T.length-1]<=r;)T.push(2*T[T.length-1]);var N=T.length,H=T[N-1];function M(t){return Math.abs(t)<=r}function x(t,r,n){r=J(r);for(var o=t.isNegative(),i=r.isNegative(),a=o?t.not():t,u=i?r.not():r,s=0,c=0,p=null,f=null,h=[];!a.isZero()||!u.isZero();)s=(p=U(a,H))[1].toJSNumber(),o&&(s=H-1-s),c=(f=U(u,H))[1].toJSNumber(),i&&(c=H-1-c),a=p[0],u=f[0],h.push(n(s,c));for(var l=0!==n(o?1:0,i?1:0)?e(-1):e(0),d=h.length-1;d>=0;d-=1)l=l.multiply(H).add(e(h[d]));return l}c.prototype.shiftLeft=function(t){var e=J(t).toJSNumber();if(!M(e))throw new Error(String(e)+" is too large for shifting.");if(e<0)return this.shiftRight(-e);var r=this;if(r.isZero())return r;for(;e>=N;)r=r.multiply(H),e-=N-1;return r.multiply(T[e])},f.prototype.shiftLeft=p.prototype.shiftLeft=c.prototype.shiftLeft,c.prototype.shiftRight=function(t){var e,r=J(t).toJSNumber();if(!M(r))throw new Error(String(r)+" is too large for shifting.");if(r<0)return this.shiftLeft(-r);for(var n=this;r>=N;){if(n.isZero()||n.isNegative()&&n.isUnit())return n;n=(e=U(n,H))[1].isNegative()?e[0].prev():e[0],r-=N-1}return(e=U(n,T[r]))[1].isNegative()?e[0].prev():e[0]},f.prototype.shiftRight=p.prototype.shiftRight=c.prototype.shiftRight,c.prototype.not=function(){return this.negate().prev()},f.prototype.not=p.prototype.not=c.prototype.not,c.prototype.and=function(t){return x(this,t,function(t,e){return t&e})},f.prototype.and=p.prototype.and=c.prototype.and,c.prototype.or=function(t){return x(this,t,function(t,e){return t|e})},f.prototype.or=p.prototype.or=c.prototype.or,c.prototype.xor=function(t){return x(this,t,function(t,e){return t^e})},f.prototype.xor=p.prototype.xor=c.prototype.xor;var F=1<<30,D=(r&-r)*(r&-r)|F;function X(t){var e=t.value,n="number"==typeof e?e|F:"bigint"==typeof e?e|BigInt(F):e[0]+e[1]*r|D;return n&-n}function q(t,e){return t=J(t),e=J(e),t.greater(e)?t:e}function K(t,e){return t=J(t),e=J(e),t.lesser(e)?t:e}function V(t,e){if(t=J(t).abs(),e=J(e).abs(),t.equals(e))return t;if(t.isZero())return e;if(e.isZero())return t;for(var r,n,o=s[1];t.isEven()&&e.isEven();)r=K(X(t),X(e)),t=t.divide(r),e=e.divide(r),o=o.multiply(r);for(;t.isEven();)t=t.divide(X(t));do{for(;e.isEven();)e=e.divide(X(e));t.greater(e)&&(n=e,e=t,t=n),e=e.subtract(t)}while(!e.isZero());return o.isUnit()?t:t.multiply(o)}c.prototype.bitLength=function(){var t=this;return t.compareTo(e(0))<0&&(t=t.negate().subtract(e(1))),0===t.compareTo(e(0))?e(0):e(function t(r,n){if(n.compareTo(r)<=0){var o=t(r,n.square(n)),i=o.p,a=o.e,u=i.multiply(n);return u.compareTo(r)<=0?{p:u,e:2*a+1}:{p:i,e:2*a}}return{p:e(1),e:0}}(t,e(2)).e).add(e(1))},f.prototype.bitLength=p.prototype.bitLength=c.prototype.bitLength;var L=function(t,e,r,n){r=r||a,t=String(t),n||(t=t.toLowerCase(),r=r.toLowerCase());var o,i=t.length,u=Math.abs(e),s={};for(o=0;o<r.length;o++)s[r[o]]=o;for(o=0;o<i;o++){if("-"!==(f=t[o])&&(f in s&&s[f]>=u)){if("1"===f&&1===u)continue;throw new Error(f+" is not a valid digit in base "+e+".")}}e=J(e);var c=[],p="-"===t[0];for(o=p?1:0;o<t.length;o++){var f;if((f=t[o])in s)c.push(J(s[f]));else{if("<"!==f)throw new Error(f+" is not a valid character");var h=o;do{o++}while(">"!==t[o]&&o<t.length);c.push(J(t.slice(h+1,o)))}}return j(c,e,p)};function j(t,e,r){var n,o=s[0],i=s[1];for(n=t.length-1;n>=0;n--)o=o.add(t[n].times(i)),i=i.times(e);return r?o.negate():o}function Y(t,r){if((r=e(r)).isZero()){if(t.isZero())return{value:[0],isNegative:!1};throw new Error("Cannot convert nonzero numbers to base 0.")}if(r.equals(-1)){if(t.isZero())return{value:[0],isNegative:!1};if(t.isNegative())return{value:[].concat.apply([],Array.apply(null,Array(-t.toJSNumber())).map(Array.prototype.valueOf,[1,0])),isNegative:!1};var n=Array.apply(null,Array(t.toJSNumber()-1)).map(Array.prototype.valueOf,[0,1]);return n.unshift([1]),{value:[].concat.apply([],n),isNegative:!1}}var o=!1;if(t.isNegative()&&r.isPositive()&&(o=!0,t=t.abs()),r.isUnit())return t.isZero()?{value:[0],isNegative:!1}:{value:Array.apply(null,Array(t.toJSNumber())).map(Number.prototype.valueOf,1),isNegative:o};for(var i,a=[],u=t;u.isNegative()||u.compareAbs(r)>=0;){u=(i=u.divmod(r)).quotient;var s=i.remainder;s.isNegative()&&(s=r.minus(s).abs(),u=u.next()),a.push(s.toJSNumber())}return a.push(u.toJSNumber()),{value:a.reverse(),isNegative:o}}function z(t,e,r){var n=Y(t,e);return(n.isNegative?"-":"")+n.value.map(function(t){return function(t,e){return t<(e=e||a).length?e[t]:"<"+t+">"}(t,r)}).join("")}function $(t){if(h(+t)){var e=+t;if(e===g(e))return u?new f(BigInt(e)):new p(e);throw new Error("Invalid integer: "+t)}var r="-"===t[0];r&&(t=t.slice(1));var o=t.split(/e/i);if(o.length>2)throw new Error("Invalid integer: "+o.join("e"));if(2===o.length){var i=o[1];if("+"===i[0]&&(i=i.slice(1)),(i=+i)!==g(i)||!h(i))throw new Error("Invalid integer: "+i+" is not a valid exponent.");var a=o[0],s=a.indexOf(".");if(s>=0&&(i-=a.length-s-1,a=a.slice(0,s)+a.slice(s+1)),i<0)throw new Error("Cannot include negative exponent part for integers");t=a+=new Array(i+1).join("0")}if(!/^([0-9][0-9]*)$/.test(t))throw new Error("Invalid integer: "+t);if(u)return new f(BigInt(r?"-"+t:t));for(var l=[],d=t.length,y=n,E=d-y;d>0;)l.push(+t.slice(E,d)),(E-=y)<0&&(E=0),d-=y;return v(l),new c(l,r)}function J(t){return"number"==typeof t?function(t){if(u)return new f(BigInt(t));if(h(t)){if(t!==g(t))throw new Error(t+" is not an integer.");return new p(t)}return $(t.toString())}(t):"string"==typeof t?$(t):"bigint"==typeof t?new f(t):t}c.prototype.toArray=function(t){return Y(this,t)},p.prototype.toArray=function(t){return Y(this,t)},f.prototype.toArray=function(t){return Y(this,t)},c.prototype.toString=function(t,e){if(void 0===t&&(t=10),10!==t)return z(this,t,e);for(var r,n=this.value,o=n.length,i=String(n[--o]);--o>=0;)r=String(n[o]),i+="0000000".slice(r.length)+r;return(this.sign?"-":"")+i},p.prototype.toString=function(t,e){return void 0===t&&(t=10),10!=t?z(this,t,e):String(this.value)},f.prototype.toString=p.prototype.toString,f.prototype.toJSON=c.prototype.toJSON=p.prototype.toJSON=function(){return this.toString()},c.prototype.valueOf=function(){return parseInt(this.toString(),10)},c.prototype.toJSNumber=c.prototype.valueOf,p.prototype.valueOf=function(){return this.value},p.prototype.toJSNumber=p.prototype.valueOf,f.prototype.valueOf=f.prototype.toJSNumber=function(){return parseInt(this.toString(),10)};for(var Z=0;Z<1e3;Z++)s[Z]=J(Z),Z>0&&(s[-Z]=J(-Z));return s.one=s[1],s.zero=s[0],s.minusOne=s[-1],s.max=q,s.min=K,s.gcd=V,s.lcm=function(t,e){return t=J(t).abs(),e=J(e).abs(),t.divide(V(t,e)).multiply(e)},s.isInstance=function(t){return t instanceof c||t instanceof p||t instanceof f},s.randBetween=function(t,e){var n=K(t=J(t),e=J(e)),o=q(t,e).subtract(n).add(1);if(o.isSmall)return n.add(Math.floor(Math.random()*o));for(var i=Y(o,r).value,a=[],u=!0,c=0;c<i.length;c++){var p=u?i[c]:r,f=g(Math.random()*p);a.push(f),f<p&&(u=!1)}return n.add(s.fromArray(a,r,!1))},s.fromArray=function(t,e,r){return j(t.map(J),J(e||10),r)},s}();t.hasOwnProperty("exports")&&(t.exports=e)}),BitcoinCashValidator=function(t){function e(){return classCallCheck(this,e),possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,[SUPPORTED_CURRENCIES.bitcoin_cash]))}return inherits(e,BaseValidator),createClass(e,[{key:"validate",value:function(t){var e=!0;try{e=detectAddressFormat(t)}catch(t){e=!1}return e}}]),e}(),VERSION_BYTE={testnet:[111,196],prod:[0,5,28,40]},PREFIXES$1=["bitcoincash","bchtest","regtest"];function detectAddressFormat(t){return decodeAddress(t)}function decodeAddress(t){try{return decodeBase58Address(t)}catch(e){return decodeCashAddress(t)}}function decodeBase58Address(t){var e=base58Check.decode(t)[0];return VERSION_BYTE.testnet.concat(VERSION_BYTE.prod).some(function(t){return t===e})}function decodeCashAddress(t){if(-1!==t.indexOf(":"))return decodeCashAddressWithPrefix(t);for(var e=0;e<PREFIXES$1.length;++e)try{return decodeCashAddressWithPrefix(PREFIXES$1[e]+": address")}catch(t){}throw new Error}var CHARSET_INVERSE_INDEX={q:0,p:1,z:2,r:3,y:4,9:5,x:6,8:7,g:8,f:9,2:10,t:11,v:12,d:13,w:14,0:15,s:16,3:17,j:18,n:19,5:20,4:21,k:22,h:23,c:24,e:25,6:26,m:27,u:28,a:29,7:30,l:31},base32={decode:function(t){validate("string"==typeof t,"Invalid base32-encoded string: "+t+".");for(var e=new Uint8Array(t.length),r=0;r<t.length;++r){var n=t[r];validate(n in CHARSET_INVERSE_INDEX,"Invalid value: "+n+"."),e[r]=CHARSET_INVERSE_INDEX[n]}return e}};function concat(t,e){var r=new Uint8Array(t.length+e.length);return r.set(t),r.set(e,t.length),r}function validChecksum(t,e){return polymod$1(concat(concat(prefixToUint5Array(t),new Uint8Array(1)),e)).equals(0)}function polymod$1(t){for(var e=[656907472481,522768456162,0xf33e5fb3c4,748107326120,130178868336],r=BigInteger(1),n=0;n<t.length;++n){var o=t[n],i=r.shiftRight(35);r=r.and(34359738367).shiftLeft(5).xor(o);for(var a=0;a<e.length;++a)i.shiftRight(a).and(1).equals(1)&&(r=r.xor(e[a]))}return r.xor(1)}function prefixToUint5Array(t){for(var e=new Uint8Array(t.length),r=0;r<t.length;++r)e[r]=31&t[r].charCodeAt(0);return e}var cashaddr={decode:function(t){validate("string"==typeof t&&hasSingleCase(t),"Invalid address: "+t+".");var e=t.toLowerCase().split(":");validate(2===e.length,"Missing prefix: "+t+".");var r=e[0],n=base32.decode(e[1]);validate(validChecksum(r,n),"Invalid checksum: "+t+".");var o=fromUint5Array(n.slice(0,-8)),i=o[0],a=o.slice(1);return validate(getHashSize(i)===8*a.length,"Invalid hash size: "+t+"."),{prefix:r}}};function hasSingleCase(t){return t===t.toLowerCase()||t===t.toUpperCase()}function fromUint5Array(t){return convertBits(t,5,8,!0)}function convertBits(t,e,r,n){for(var o=n?Math.floor(t.length*e/r):Math.ceil(t.length*e/r),i=(1<<r)-1,a=new Uint8Array(o),u=0,s=0,c=0,p=0;p<t.length;++p){var f=t[p];for(validate(f>=0&&f>>e==0,"Invalid value: "+f+"."),s=s<<e|f,c+=e;c>=r;)c-=r,a[u]=s>>c&i,++u}return n?validate(c<e&&0==(s<<r-c&i),"Input cannot be converted to "+r+" bits without padding, but strict mode was used."):c>0&&(a[u]=s<<r-c&i,++u),a}function getHashSize(t){switch(7&t){case 0:return 160;case 1:return 192;case 2:return 224;case 3:return 256;case 4:return 320;case 5:return 384;case 6:return 448;case 7:return 512}}function decodeCashAddressWithPrefix(t){var e=cashaddr.decode(t);return PREFIXES$1.some(function(t){return t===e.prefix})}function validate(t,e){if(!t)throw new Error(e)}var EthereumValidator=function(t){function e(){return classCallCheck(this,e),possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,[SUPPORTED_CURRENCIES.ethereum,SUPPORTED_CURRENCIES.omise_go,SUPPORTED_CURRENCIES.augur,SUPPORTED_CURRENCIES.eos,SUPPORTED_CURRENCIES.fuel,SUPPORTED_CURRENCIES.status,SUPPORTED_CURRENCIES.singularDTV,SUPPORTED_CURRENCIES.genesis_coin,SUPPORTED_CURRENCIES.walton_chain,SUPPORTED_CURRENCIES.ethereum_classic,SUPPORTED_CURRENCIES.ubiq]))}return inherits(e,BaseValidator),createClass(e,[{key:"validate",value:function(t,e){return isValidAddress$1(t)}}]),e}(),isValidAddress$1=function(t){return!!/^(0x)?[0-9a-f]{40}$/i.test(t)&&(!(!/^(0x)?[0-9a-f]{40}$/.test(t)&&!/^(0x)?[0-9A-F]{40}$/.test(t))||isChecksumAddress(t))},isChecksumAddress=function(t){for(var e=t.replace("0x",""),r=cryptoUtils.sha3(e.toLowerCase()),n=0;n<40;n++)if(parseInt(r[n],16)>7&&e[n].toUpperCase()!==e[n]||parseInt(r[n],16)<=7&&e[n].toLowerCase()!==e[n])return!1;return!0},RegExpValidator=function(t){function e(t,r){classCallCheck(this,e);var n=possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.regExp=r,n}return inherits(e,BaseValidator),createClass(e,[{key:"validate",value:function(t,e){return this.regExp.test(t)}}]),e}(),MoneroValidator=function(t){function e(){return classCallCheck(this,e),possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,[SUPPORTED_CURRENCIES.monero],/^4([0-9]|[A-B])([0-9a-zA-Z]){93}$|^4([0-9]|[A-B])([0-9a-zA-Z]){104}$/))}return inherits(e,RegExpValidator),e}(),alphabet$1="rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz",base58ripple=baseXCheck(alphabet$1),RippleValidator=function(t){function e(){return classCallCheck(this,e),possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,[SUPPORTED_CURRENCIES.ripple]))}return inherits(e,BaseValidator),createClass(e,[{key:"validate",value:function(t,e){try{var r=base58ripple.decode(t);return!!r&&this.isValidVersion(r)}catch(t){return!1}}},{key:"isValidVersion",value:function(t){return 0===t.shift()}}]),e}(),IotaValidator=function(t){function e(){classCallCheck(this,e);var t=possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,[SUPPORTED_CURRENCIES.iota]));return t.addressLength=81,t.regexTrytes=new RegExp("^[9A-Z]{"+t.addressLength+"}$"),t}return inherits(e,BaseValidator),createClass(e,[{key:"validate",value:function(t,e){var r=this.removeChecksum(t);return this.regexTrytes.test(r)}},{key:"removeChecksum",value:function(t){return t.slice(0,this.addressLength)}}]),e}(),StellarValidator=function(t){function e(){return classCallCheck(this,e),possibleConstructorReturn(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,[SUPPORTED_CURRENCIES.stellar]))}return inherits(e,BaseValidator),createClass(e,[{key:"validate",value:function(t,e){return isValid("ed25519PublicKey",t)}}]),e}(),versionBytes={ed25519PublicKey:48,ed25519SecretSeed:144,preAuthTx:152,sha256Hash:184};function isValid(t,e){if(e&&56!==e.length)return!1;try{if(32!==decodeCheck(t,e).length)return!1}catch(t){return!1}return!0}function decodeCheck(t,e){var r=decode$2(e),n=r[0],o=r.slice(0,-2),i=o.slice(1),a=r.slice(-2);if(e!==encode$2(r))throw new Error("invalid encoded string");var u=versionBytes[t];if(void 0===u)throw new Error(t+' is not a valid version byte name.  expected one of "accountId" or "seed"');if(n!==u)throw new Error("invalid version byte. expected "+u+", got "+n);if(!verifyChecksum$1(calculateChecksum(o),a))throw new Error("invalid checksum");return i}function calculateChecksum(t){return writeUInt16LE(crc16xmodem(t),0)}function verifyChecksum$1(t,e){if(t.length!==e.length)return!1;if(0===t.length)return!0;for(var r=0;r<t.length;r++)if(t[r]!==e[r])return!1;return!0}var crc16xmodem=function(t,e){for(var r=void 0!==e?~~e:0,n=0;n<t.length;n++){var o=r>>>8&255;o^=255&t[n],r=r<<8&65535,r^=o^=o>>>4,r^=o=o<<5&65535,r^=o=o<<7&65535}return r};function writeUInt16LE(t,e){var r=[];var n=converToByteArray(t=+t);return r.push(n[7]),r.push(t>>>8),r}function converToByteArray(t){var e=[],r=8;do{e[--r]=255&t,t>>=8}while(r);return e}var charmap=function(t,e){return e||(e={}),t.split("").forEach(function(t,r){t in e||(e[t]=r)}),e},rfc4648={alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",charmap:{0:14,1:8}};function Decoder(){this.buf=[],this.shift=8,this.carry=0}function decode$2(t){return(new Decoder).finalize(t)}function Encoder(){this.buf="",this.shift=3,this.carry=0}function encode$2(t){return(new Encoder).finalize(t)}rfc4648.charmap=charmap(rfc4648.alphabet,rfc4648.charmap),Decoder.prototype.charmap=rfc4648.charmap,Decoder.prototype.write=function(t){var e=this.charmap,r=this.buf,n=this.shift,o=this.carry;return t.toUpperCase().split("").forEach(function(t){if("="!=t){var i=255&e[t];(n-=5)>0?o|=i<<n:n<0?(r.push(o|i>>-n),o=i<<(n+=8)&255):(r.push(o|i),n=8,o=0)}}),this.shift=n,this.carry=o,this},Decoder.prototype.finalize=function(t){return t&&this.write(t),8!==this.shift&&0!==this.carry&&(this.buf.push(this.carry),this.shift=8,this.carry=0),this.buf},Encoder.prototype.alphabet=rfc4648.alphabet,Encoder.prototype.write=function(t){var e,r,n,o=this.shift,i=this.carry;for(n=0;n<t.length;n++)e=i|(r=t[n])>>o,this.buf+=this.alphabet[31&e],o>5&&(e=r>>(o-=5),this.buf+=this.alphabet[31&e]),i=r<<(o=5-o),o=8-o;return this.shift=o,this.carry=i,this},Encoder.prototype.finalize=function(t){return t&&this.write(t),3!==this.shift&&(this.buf+=this.alphabet[31&this.carry],this.shift=3,this.carry=0),this.buf};var supportedValidators=[new BitcoinCashValidator,new EthereumValidator,new MoneroValidator,new RippleValidator,new IotaValidator,new StellarValidator,new DefaultValidator],supportedCurrencies=Object.values(SUPPORTED_CURRENCIES);function validate$1(t,e){if(-1===supportedCurrencies.indexOf(e))throw Error(e+" is not supported");return supportedValidators.find(function(t){return t.isAppliedFor(e)}).validate(t,e)}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(62), __webpack_require__(369)))

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericPaymentWorkflow_GenericPaymentWorkflowContainer__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CryptoWalletDepositWorkflow_CryptoWalletDepositWorkflowContainer__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ManualDepositWorkflow_ManualDepositWorkflowContainer__ = __webpack_require__(1517);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DepositWorkflowsComponent = function (_React$Component) {
  _inherits(DepositWorkflowsComponent, _React$Component);

  function DepositWorkflowsComponent() {
    _classCallCheck(this, DepositWorkflowsComponent);

    return _possibleConstructorReturn(this, (DepositWorkflowsComponent.__proto__ || Object.getPrototypeOf(DepositWorkflowsComponent)).apply(this, arguments));
  }

  _createClass(DepositWorkflowsComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          DepositWorkflow = _props.templateInfo.DepositWorkflow,
          submitting = _props.submitting,
          isLoading = _props.isLoading,
          onSubmit = _props.onSubmit;

      var WorkflowComponent = null;

      if (isLoading) {
        return null;
      }

      switch (DepositWorkflow) {
        case 'CryptoWallet':
          {
            WorkflowComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CryptoWalletDepositWorkflow_CryptoWalletDepositWorkflowContainer__["a" /* default */], null);
            break;
          }
        case 'ManualDeposit':
          {
            WorkflowComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ManualDepositWorkflow_ManualDepositWorkflowContainer__["a" /* default */], {
              submitting: submitting,
              onSubmit: onSubmit
            });
            break;
          }
        case 'GenericPayment':
          {
            WorkflowComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GenericPaymentWorkflow_GenericPaymentWorkflowContainer__["a" /* default */], null);
            break;
          }
        default:
          {
            break;
          }
      }
      return WorkflowComponent;
    }
  }]);

  return DepositWorkflowsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DepositWorkflowsComponent.propTypes = {
  templateInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
DepositWorkflowsComponent.defaultProps = {
  templateInfo: {},
  onSubmit: function onSubmit() {},
  submitting: false
};


/* harmony default export */ __webpack_exports__["a"] = (DepositWorkflowsComponent);

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GenericPaymentWorkflowComponent__ = __webpack_require__(1499);



var mapStateToProps = function mapStateToProps(state) {
  return {
    depositInfo: state.deposit.depositInfo.reverse(),
    templateType: state.deposit.templateType
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__GenericPaymentWorkflowComponent__["a" /* default */]));

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentProcessors_TrustpayDepositWorkflowComponent__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentProcessors_RazorPayDepositWorkflowComponent__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentProcessors_PsigateDepositWorkflowComponent__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentProcessors_InterswitchDepositWorkflowComponent__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentProcessors_FennasDepositWorkflowComponent__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentProcessors_Hyphen_HyphenDepositWorkflowContainer__ = __webpack_require__(1505);










var GenericPaymentWorkflowComponent = function GenericPaymentWorkflowComponent(_ref, context) {
  var depositInfo = _ref.depositInfo,
      templateType = _ref.templateType;

  var _ref2 = depositInfo[0] ? JSON.parse(depositInfo[0]) : {},
      PaymentAPI = _ref2.PaymentAPI,
      URL = _ref2.URL,
      RedirectURL = _ref2.RedirectURL,
      SerializedPaymentTransactionObject = _ref2.SerializedPaymentTransactionObject;

  if (templateType === 'Hyphen') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PaymentProcessors_Hyphen_HyphenDepositWorkflowContainer__["a" /* default */], null);
  }

  if (RedirectURL) {
    window.location = RedirectURL;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Redirecting...'
    );
  }

  if (PaymentAPI === 'TrustPay') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PaymentProcessors_TrustpayDepositWorkflowComponent__["a" /* default */], { url: URL });
  }

  if (SerializedPaymentTransactionObject) {
    var options = JSON.parse(SerializedPaymentTransactionObject);

    if (PaymentAPI === 'Razorpay') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PaymentProcessors_RazorPayDepositWorkflowComponent__["a" /* default */], { options: options });
    }
    if (PaymentAPI === 'Psigate') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PaymentProcessors_PsigateDepositWorkflowComponent__["a" /* default */], { options: Object.assign({}, options, { Email: '' }) });
    }
    if (PaymentAPI === 'Interswitch') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PaymentProcessors_InterswitchDepositWorkflowComponent__["a" /* default */], { options: options });
    }
    if (PaymentAPI === 'Fennas') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PaymentProcessors_FennasDepositWorkflowComponent__["a" /* default */], { options: options });
    }
  }

  if (PaymentAPI === null) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      context.t('Server provided an unexpected response.')
    );
  }

  return null;
};

GenericPaymentWorkflowComponent.defaultProps = {
  depositInfo: []
};

GenericPaymentWorkflowComponent.propTypes = {
  depositInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

GenericPaymentWorkflowComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (GenericPaymentWorkflowComponent);

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_scriptLoader__ = __webpack_require__(372);
/* eslint-disable no-restricted-globals */





var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('deposit-form');

var TrustpayDepositWorkflowComponent = function TrustpayDepositWorkflowComponent(_ref) {
  var url = _ref.url;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('trustpay-form') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', {
      action: location.href,
      className: 'paymentWidgets',
      'data-brands': 'VISA MASTER AMEX'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_scriptLoader__["a" /* default */], { url: url })
  );
};

TrustpayDepositWorkflowComponent.defaultProps = {
  url: '',
  title: ''
};

TrustpayDepositWorkflowComponent.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (TrustpayDepositWorkflowComponent);

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_scriptLoader__ = __webpack_require__(372);




var RazorpayDepositWorkflowComponent = function RazorpayDepositWorkflowComponent(_ref) {
  var options = _ref.options;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__helpers_scriptLoader__["a" /* default */], {
    url: 'https://checkout.razorpay.com/v1/checkout.js',
    onLoadCallback: function onLoadCallback() {
      var optionsObj = Object.assign({}, options, {
        handler: function handler() {
          window.location.href = options.redirectUrl;
        }
      });
      var rzp = new Razorpay(optionsObj); // eslint-disable-line no-undef

      rzp.open();
    }
  });
};

RazorpayDepositWorkflowComponent.defaultProps = {
  options: {
    key: '',
    amount: '',
    order_id: '',
    handler: '',
    prefill: {
      contact: '',
      email: ''
    }
  }
};

RazorpayDepositWorkflowComponent.propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    order_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    handler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    prefill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })
  })
};

/* harmony default export */ __webpack_exports__["a"] = (RazorpayDepositWorkflowComponent);

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PsigateDepositWorkflowComponent = function (_React$Component) {
  _inherits(PsigateDepositWorkflowComponent, _React$Component);

  function PsigateDepositWorkflowComponent() {
    _classCallCheck(this, PsigateDepositWorkflowComponent);

    return _possibleConstructorReturn(this, (PsigateDepositWorkflowComponent.__proto__ || Object.getPrototypeOf(PsigateDepositWorkflowComponent)).apply(this, arguments));
  }

  _createClass(PsigateDepositWorkflowComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.form.submit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = this.props.options;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Redirecting to Psigate...'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          {
            id: 'psigateForm',
            style: { visibility: 'hidden' },
            action: options.APIAddress,
            method: 'post',
            ref: function ref(form) {
              return _this2.form = form;
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'MerchantID', type: 'text', value: options.MerchantID }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'PaymentType', type: 'text', value: options.PaymentType }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'OrderID', type: 'text', value: options.OrderID }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'UserID', type: 'text', value: options.UserID }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'SubTotal', type: 'text', value: options.SubTotal }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'CardAction', type: 'text', value: 0 }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'ResponseFormat',
            type: 'text',
            value: options.ResponseFormat
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'Email', type: 'text', value: options.Email }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'ThanksURL', type: 'text', value: options.ThanksURL }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'NoThanksURL', type: 'text', value: options.NoThanksURL })
        )
      );
    }
  }]);

  return PsigateDepositWorkflowComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PsigateDepositWorkflowComponent.defaultProps = {
  options: {
    MerchantID: '',
    PaymentType: '',
    OrderID: '',
    UserID: '',
    SubTotal: '',
    ResponseFormat: '',
    Email: ''
  }
};

PsigateDepositWorkflowComponent.propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    MerchantID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    PaymentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    OrderID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    UserID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    SubTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ResponseFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    Email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/* harmony default export */ __webpack_exports__["a"] = (PsigateDepositWorkflowComponent);

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var InterswitchDepositWorkflowComponent = function (_React$Component) {
  _inherits(InterswitchDepositWorkflowComponent, _React$Component);

  function InterswitchDepositWorkflowComponent() {
    _classCallCheck(this, InterswitchDepositWorkflowComponent);

    return _possibleConstructorReturn(this, (InterswitchDepositWorkflowComponent.__proto__ || Object.getPrototypeOf(InterswitchDepositWorkflowComponent)).apply(this, arguments));
  }

  _createClass(InterswitchDepositWorkflowComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.form.submit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = this.props.options;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Redirecting to Interswitch...'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          {
            id: 'interswitchForm',
            style: { visibility: 'hidden' },
            action: options.postUrl,
            method: 'post',
            ref: function ref(form) {
              return _this2.form = form;
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'product_id', type: 'text', value: options.productId }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'pay_item_id', type: 'text', value: options.itemId }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'amount', type: 'text', value: options.amount }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'currency', type: 'text', value: options.currency }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'site_redirect_url',
            type: 'text',
            value: options.siteRedirectUrl
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'txn_ref', type: 'text', value: options.transRef }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'cust_id', type: 'text', value: options.customerId }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'hash', type: 'text', value: options.hash })
        )
      );
    }
  }]);

  return InterswitchDepositWorkflowComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InterswitchDepositWorkflowComponent.defaultProps = {
  options: {
    postUrl: '',
    productId: '',
    itemId: '',
    amount: '',
    currency: '',
    siteRedirectUrl: '',
    transRef: '',
    customerId: '',
    hash: ''
  }
};

InterswitchDepositWorkflowComponent.propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    postUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    productId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    itemId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    currency: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    siteRedirectUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    transRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    customerId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    hash: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/* harmony default export */ __webpack_exports__["a"] = (InterswitchDepositWorkflowComponent);

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FennasDepositWorkflowComponent = function (_React$Component) {
  _inherits(FennasDepositWorkflowComponent, _React$Component);

  function FennasDepositWorkflowComponent() {
    _classCallCheck(this, FennasDepositWorkflowComponent);

    return _possibleConstructorReturn(this, (FennasDepositWorkflowComponent.__proto__ || Object.getPrototypeOf(FennasDepositWorkflowComponent)).apply(this, arguments));
  }

  _createClass(FennasDepositWorkflowComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.form.submit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = this.props.options;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Redirecting to Fennas...'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          {
            id: 'fennasForm',
            style: { visibility: 'hidden' },
            action: options.PostUrl,
            method: 'post',
            ref: function ref(form) {
              return _this2.form = form;
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'MerchantID', type: 'text', value: options.MerchantID }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'MerchantRefNo',
            type: 'text',
            value: options.MerchantRefNo
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'MerchantPaysFees',
            type: 'text',
            value: options.MerchantPaysFees
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'SendJSONCallBack',
            type: 'text',
            value: options.SendJSONCallBack
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'MerchantLanguage',
            type: 'text',
            value: options.MerchantLanguage
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'RequestHasCardOrder',
            type: 'text',
            value: options.RequestHasCardOrder
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'ResponseFormat',
            type: 'text',
            value: options.ResponseFormat
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'RedirectionURLOK',
            type: 'text',
            value: options.RedirectionURLOK
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'RedirectionURLFailed',
            type: 'text',
            value: options.RedirectionURLFailed
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'RedirectionURLCancelled',
            type: 'text',
            value: options.RedirectionURLCancelled
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'RedirectionURLError',
            type: 'text',
            value: options.RedirectionURLError
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'NormalAmount', type: 'text', value: options.NormalAmount }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'NormalCurrency',
            type: 'text',
            value: options.NormalCurrency
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            name: 'NormalDescription',
            type: 'text',
            value: options.NormalDescription
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'RequestType', type: 'text', value: options.RequestType }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'Version', type: 'text', value: options.Version }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'CheckSum', type: 'text', value: options.CheckSum })
        )
      );
    }
  }]);

  return FennasDepositWorkflowComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FennasDepositWorkflowComponent.defaultProps = {
  options: {
    MerchantID: '',
    MerchantRefNo: '',
    MerchantPaysFees: '',
    SendJSONCallBack: '',
    MerchantLanguage: '',
    RequestHasCardOrder: '',
    ResponseFormat: '',
    RedirectionURLOK: '',
    RedirectionURLFailed: '',
    RedirectionURLCancelled: '',
    RedirectionURLError: '',
    NormalAmount: '',
    NormalCurrency: '',
    NormalDescription: '',
    RequestType: '',
    Version: '',
    CheckSum: ''
  }
};

FennasDepositWorkflowComponent.propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    MerchantID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    MerchantRefNo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    MerchantPaysFees: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    SendJSONCallBack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    MerchantLanguage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    RequestHasCardOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ResponseFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    RedirectionURLOK: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    RedirectionURLFailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    RedirectionURLCancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    RedirectionURLError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    NormalAmount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    NormalCurrency: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    NormalDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    RequestType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    Version: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    CheckSum: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/* harmony default export */ __webpack_exports__["a"] = (FennasDepositWorkflowComponent);

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HyphenDepositWorkflowComponent__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





var mapStateToProps = function mapStateToProps(state) {
  var product = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__["b" /* depositProductSelector */])(state);
  return {
    product: product,
    bankInfo: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].Deposit[product.Product]
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__HyphenDepositWorkflowComponent__["a" /* default */]));

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HyphenDepositWorkflowComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__ = __webpack_require__(15);




var HyphenDepositWorkflowComponent = function HyphenDepositWorkflowComponent(_ref, context) {
  var Product = _ref.product.Product,
      bankInfo = _ref.bankInfo;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], { label: context.t('Bank Name:'), text: bankInfo.bankName }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: context.t('Wire Number:'),
      text: bankInfo.bankWireNumber
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: context.t('Account Number:'),
      text: bankInfo.bankAccountNumber
    })
  );
};

HyphenDepositWorkflowComponent.propTypes = {
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    Product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  bankInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

HyphenDepositWorkflowComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (HyphenDepositWorkflowComponent);

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CryptoWalletDepositWorkflowComponent__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__ = __webpack_require__(20);





var mapStateToProps = function mapStateToProps(state) {
  return {
    addressList: state.deposit.depositInfo,
    product: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__["b" /* depositProductSelector */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showSnack: function showSnack(text) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__["e" /* showSnack */])({ id: 'depositCopyAddress', text: text, type: 'success' }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__CryptoWalletDepositWorkflowComponent__["a" /* default */]));

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APQRCode_APQRCode__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_clipboardHelper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_destinationTagHelper__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CryptoWalletDepositWorkflowComponent_css__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CryptoWalletDepositWorkflowComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CryptoWalletDepositWorkflowComponent_css__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('cryptowallet-deposit');

var CryptoWalletDepositWorkflowComponent = function (_React$Component) {
  _inherits(CryptoWalletDepositWorkflowComponent, _React$Component);

  function CryptoWalletDepositWorkflowComponent() {
    _classCallCheck(this, CryptoWalletDepositWorkflowComponent);

    return _possibleConstructorReturn(this, (CryptoWalletDepositWorkflowComponent.__proto__ || Object.getPrototypeOf(CryptoWalletDepositWorkflowComponent)).apply(this, arguments));
  }

  _createClass(CryptoWalletDepositWorkflowComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var context = this.context,
          _props = this.props,
          addressList = _props.addressList,
          product = _props.product,
          showSnack = _props.showSnack;
      // Protocol prefix for the QR Code, lowercase name with no spaces.

      var depositType = product.ProductFullName.toLowerCase().replace(/\W/g, '');
      var selectedAddress = addressList.length ? addressList[addressList.length - 1] : '';

      var _destinationTagHelper = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_destinationTagHelper__["a" /* default */])(selectedAddress),
          _destinationTagHelper2 = _slicedToArray(_destinationTagHelper, 2),
          address = _destinationTagHelper2[0],
          destinationTag = _destinationTagHelper2[1];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('wrapper') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('title') },
          context.t('Please read the instructions below')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('description') },
          context.t('Depositing cryptocurrency into the exchange is safe and easy. The address below can always be used to deposit cryptocurrency into your account.')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('frame') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('qr-code') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APQRCode_APQRCode__["a" /* default */], {
              value: depositType + ':' + selectedAddress,
              className: baseClasses('qrcode')
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('title') },
              context.t('Address'),
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                'data-test': 'Address',
                onClick: function onClick() {
                  showSnack(_this2.context.t('The address has been copied to the clipboard.'));
                  Object(__WEBPACK_IMPORTED_MODULE_4__helpers_clipboardHelper__["a" /* default */])(address);
                },
                className: baseClasses('address') },
              address,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APIcon__["a" /* default */], { name: 'copy', customClass: baseClasses('copy-icon') })
            ),
            destinationTag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: baseClasses('title') },
                this.context.t('Be sure to include this destination tag:')
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  'data-test': 'Destination tag',
                  className: baseClasses('address'),
                  onClick: function onClick() {
                    showSnack(_this2.context.t('The destination tag has been copied to the clipboard.'));
                    Object(__WEBPACK_IMPORTED_MODULE_4__helpers_clipboardHelper__["a" /* default */])(destinationTag);
                  } },
                destinationTag,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APIcon__["a" /* default */], { name: 'copy', customClass: baseClasses('copy-icon') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('description') },
              context.t('Your account will automatically update after the cryptocurrency network confirms your transaction.')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('description') },
              context.t('The confirmation may take up to 1 hour.')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('description') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                context.t('1) Send cryptocurrency to this address')
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                context.t('2) Your deposit will automatically be processed')
              )
            )
          )
        )
      );
    }
  }]);

  return CryptoWalletDepositWorkflowComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CryptoWalletDepositWorkflowComponent.propTypes = {
  addressList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  showSnack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    Product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ProductId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    ProductFullName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ProductType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};
CryptoWalletDepositWorkflowComponent.defaultProps = {
  addressList: [],
  product: { Product: '', ProductId: 0, ProductFullName: '', ProductType: '' }
};
CryptoWalletDepositWorkflowComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (CryptoWalletDepositWorkflowComponent);

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var React = __webpack_require__(0);

var PropTypes = __webpack_require__(1); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = __webpack_require__(1510);

var ErrorCorrectLevel = __webpack_require__(653);

function getBackingStorePixelRatio(ctx) {
  return (// $FlowFixMe
    ctx.webkitBackingStorePixelRatio || // $FlowFixMe
    ctx.mozBackingStorePixelRatio || // $FlowFixMe
    ctx.msBackingStorePixelRatio || // $FlowFixMe
    ctx.oBackingStorePixelRatio || // $FlowFixMe
    ctx.backingStorePixelRatio || 1
  );
} // Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/


function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000'
};
var PROP_TYPES = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string
};

var QRCodeCanvas =
/*#__PURE__*/
function (_React$Component) {
  _inherits(QRCodeCanvas, _React$Component);

  function QRCodeCanvas() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = QRCodeCanvas.__proto__ || Object.getPrototypeOf(QRCodeCanvas)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "_canvas", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    }), _temp));
  }

  _createClass(QRCodeCanvas, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this2.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _props = this.props,
          value = _props.value,
          size = _props.size,
          level = _props.level,
          bgColor = _props.bgColor,
          fgColor = _props.fgColor; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var tileW = size / cells.length;
        var tileH = size / cells.length;
        var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
        canvas.height = canvas.width = size * scale;
        ctx.scale(scale, scale);
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            ctx && (ctx.fillStyle = cell ? fgColor : bgColor);
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
            ctx && ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          value = _props2.value,
          size = _props2.size,
          level = _props2.level,
          bgColor = _props2.bgColor,
          fgColor = _props2.fgColor,
          style = _props2.style,
          otherProps = _objectWithoutProperties(_props2, ["value", "size", "level", "bgColor", "fgColor", "style"]);

      var canvasStyle = _extends({
        height: size,
        width: size
      }, style);

      return React.createElement("canvas", _extends({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref2) {
          return _this3._canvas = _ref2;
        }
      }, otherProps));
    }
  }]);

  return QRCodeCanvas;
}(React.Component);

Object.defineProperty(QRCodeCanvas, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeCanvas, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCodeSVG =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(QRCodeSVG, _React$Component2);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _possibleConstructorReturn(this, (QRCodeSVG.__proto__ || Object.getPrototypeOf(QRCodeSVG)).apply(this, arguments));
  }

  _createClass(QRCodeSVG, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this4 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this4.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          value = _props3.value,
          size = _props3.size,
          level = _props3.level,
          bgColor = _props3.bgColor,
          fgColor = _props3.fgColor,
          otherProps = _objectWithoutProperties(_props3, ["value", "size", "level", "bgColor", "fgColor"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return;
      } // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2


      var ops = [];
      cells.forEach(function (row, y) {
        var lastIsDark = false;
        var start = null;
        row.forEach(function (cell, x) {
          if (!cell && start !== null) {
            // M0 0h7v1H0z injects the space with the move and dropd the comma,
            // saving a char per operation
            ops.push("M".concat(start, " ").concat(y, "h").concat(x - start, "v1H").concat(start, "z"));
            start = null;
            return;
          } // end of row, clean up or skip


          if (x === row.length - 1) {
            if (!cell) {
              // We would have closed the op above already so this can only mean
              // 2+ light modules in a row.
              return;
            }

            if (start === null) {
              // Just a single dark module.
              ops.push("M".concat(x, ",").concat(y, " h1v1H").concat(x, "z"));
            } else {
              // Otherwise finish the current line.
              ops.push("M".concat(start, ",").concat(y, " h").concat(x + 1 - start, "v1H").concat(start, "z"));
            }

            return;
          }

          if (cell && start === null) {
            start = x;
          }
        });
      });
      return React.createElement("svg", _extends({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(cells.length, " ").concat(cells.length)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(cells.length, "v").concat(cells.length, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: ops.join('')
      }));
    }
  }]);

  return QRCodeSVG;
}(React.Component);

Object.defineProperty(QRCodeSVG, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeSVG, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode.defaultProps = _extends({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
module.exports = QRCode;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(1511);
var RSBlock = __webpack_require__(1512);
var BitBuffer = __webpack_require__(1513);
var util = __webpack_require__(1514);
var Polynomial = __webpack_require__(654);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(652);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(653);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(652);
var Polynomial = __webpack_require__(654);
var math = __webpack_require__(655);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),
/* 1515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ManualDepositWorkflowComponent__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);




var mapStateToProps = function mapStateToProps(state, _ref) {
  var onSubmit = _ref.onSubmit,
      submitting = _ref.submitting;
  return {
    product: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__["b" /* depositProductSelector */])(state),
    onSubmit: onSubmit,
    submitting: submitting
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ManualDepositWorkflowComponent__["a" /* default */]));

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ManualDepositWorkflowComponent_css__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ManualDepositWorkflowComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ManualDepositWorkflowComponent_css__);












var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('manual-deposit');

var ManualDepositWorkflowComponent = function ManualDepositWorkflowComponent(props, context) {
  var _props$product = props.product,
      DecimalPlaces = _props$product.DecimalPlaces,
      Product = _props$product.Product;
  var Deposit = __WEBPACK_IMPORTED_MODULE_8__config__["b" /* default */].Deposit,
      hideDepositBankInfo = __WEBPACK_IMPORTED_MODULE_8__config__["b" /* default */].Deposit.hideDepositBankInfo;

  var bankInfo = Deposit[Product] || {};

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('container-with-footer') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('title') },
        context.t('Deposit Money')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('step-item') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: baseClasses('step') },
          context.t('Step 1:')
        ),
        context.t('Create the deposit ticket.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('step-item') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: baseClasses('step') },
          context.t('Step 2:')
        ),
        context.t('Process deposit instructions on the deposit receipt.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('frame') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APInput__["b" /* default */], {
          type: 'text',
          name: 'fullname',
          label: context.t('Full Name:'),
          customClass: baseClasses(),
          validate: [__WEBPACK_IMPORTED_MODULE_2__helpers_formValidations__["p" /* required */]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APNumberInput__["a" /* default */], {
          type: 'text',
          name: 'amount',
          label: context.t('Amount:'),
          decimalPlaces: DecimalPlaces,
          customClass: baseClasses(),
          validate: [__WEBPACK_IMPORTED_MODULE_2__helpers_formValidations__["p" /* required */], __WEBPACK_IMPORTED_MODULE_2__helpers_formValidations__["c" /* biggerThanZero */]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APInput__["b" /* default */], {
          name: 'comments',
          label: context.t('Comments:'),
          customClass: baseClasses(),
          info: context.t('The comment field is optional. Please use it for special instructions.')
        })
      ),
      !hideDepositBankInfo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('bank-info-label') },
          context.t('Bank Account to Wire the Funds')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('bank-info') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APLabelWithText__["a" /* default */], {
            label: context.t('Bank Name:'),
            text: bankInfo.bankName,
            customClass: baseClasses()
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APLabelWithText__["a" /* default */], {
            label: context.t('Wire Number:'),
            text: bankInfo.bankWireNumber,
            customClass: baseClasses()
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APLabelWithText__["a" /* default */], {
            label: context.t('Account Number:'),
            text: bankInfo.bankAccountNumber,
            customClass: baseClasses()
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('footer') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__common_APButton__["a" /* default */],
        {
          customClass: baseClasses(),
          type: 'submit',
          'data-test': 'Place Deposit Ticket',
          disabled: props.submitting,
          styleName: 'additive',
          onClick: props.onSubmit },
        props.submitting ? context.t('Submitting...') : context.t('Place Deposit Ticket')
      )
    )
  );
};

ManualDepositWorkflowComponent.defaultProps = {
  onSubmit: function onSubmit() {},
  submitting: false
};

ManualDepositWorkflowComponent.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

ManualDepositWorkflowComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ManualDepositWorkflowComponent);

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateDepositTicketPayload; });
var validateDepositTicketPayload = function validateDepositTicketPayload(payload,
/**
 * "registeredFields" is supplied by redux-form.
 * It contains all <Field /> components mounted as children of the form.
 */
registeredFields) {
  return Object.keys(payload).reduce(function (acc, key) {
    if (registeredFields.hasOwnProperty(key) || key === 'ProductSymbol' || key === 'ProductId') acc[key] = payload[key];
    return acc;
  }, {});
};

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FiatDepositModalComponent__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_depositActions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);







var mapStateToProps = function mapStateToProps(state, ownProps) {
  var bankInfo = {};
  if (ownProps.payload && __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].Deposit[ownProps.payload.ProductSymbol]) {
    var depositBankInfo = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].Deposit[ownProps.payload.ProductSymbol];
    bankInfo = {
      name: depositBankInfo.bankName,
      wireNumber: depositBankInfo.bankWireNumber,
      accountNumber: depositBankInfo.bankAccountNumber
    };
  }
  return {
    bankInfo: bankInfo,
    showDepositIdModal: __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].Deposit.showDepositIdModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    submitDeposit: function submitDeposit(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_depositActions__["n" /* createDepositTicket */])(payload));
    },
    openReferenceModal: function openReferenceModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].DEPOSIT_REFERENCE_ID, {
        ProductSymbol: ownProps.payload.ProductSymbol
      }));
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FiatDepositModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_FIAT_DEPOSIT
})(container));

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_formTemplateHelper__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiatDepositModalComponent_css__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiatDepositModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FiatDepositModalComponent_css__);











var fiatDepositModalClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-deposit-modal');

var shouldRenderBankInfo = function shouldRenderBankInfo(bankInfo) {
  return bankInfo.name && bankInfo.wireNumber && bankInfo.accountNumber;
};

var FiatDepositModalComponent = function FiatDepositModalComponent(props, context) {
  var _props$payload = props.payload,
      ProductSymbol = _props$payload.ProductSymbol,
      fullname = _props$payload.fullname,
      amount = _props$payload.amount,
      comments = _props$payload.comments,
      GivenName = _props$payload.GivenName,
      Amount = _props$payload.Amount,
      template = props.template,
      _props$templateInfo = props.templateInfo,
      templateInfo = _props$templateInfo === undefined ? {} : _props$templateInfo,
      payload = props.payload;


  var templateFields = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_formTemplateHelper__["a" /* templateConfirmRenderer */])(template, payload, fiatDepositModalClasses, context);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: props.isOpen,
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: fiatDepositModalClasses('header-content') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon__["a" /* default */], {
          name: 'depositWithBorder',
          size: 44,
          customClass: fiatDepositModalClasses('icon')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: fiatDepositModalClasses('header-title') },
          context.t('Deposit') + ' ' + ProductSymbol
        )
      ),
      close: props.close,
      footer: {
        buttonText: context.t('Confirm'),
        buttonStyle: 'additive',
        onClick: function onClick() {
          props.submitDeposit(payload);

          if (props.showDepositIdModal) {
            props.openReferenceModal();
          }
        }
      },
      customClass: fiatDepositModalClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: fiatDepositModalClasses('title') },
      context.t('Confirmation')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: fiatDepositModalClasses() },
      templateFields.length > 0 ? templateFields : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Full Name'),
          text: fullname || GivenName,
          customClass: fiatDepositModalClasses()
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Amount to Deposit'),
          text: amount || Amount,
          customClass: fiatDepositModalClasses()
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Note'),
          text: comments || '-',
          customClass: fiatDepositModalClasses()
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Time'),
          text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["c" /* formatDateTime */])(new Date()),
          customClass: fiatDepositModalClasses()
        })
      ),
      templateInfo.DepositWorkflow === 'ManualDeposit' && shouldRenderBankInfo(props.bankInfo) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: fiatDepositModalClasses('bank-info') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            label: context.t('Step 2: Wire the funds to this account'),
            customClass: fiatDepositModalClasses(),
            classModifiers: 'bank-info'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            label: context.t('Bank Name:'),
            text: props.bankInfo.name,
            customClass: fiatDepositModalClasses(),
            classModifiers: 'bank-info'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            label: context.t('Wire Number:'),
            text: props.bankInfo.wireNumber,
            customClass: fiatDepositModalClasses(),
            classModifiers: 'bank-info'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            label: context.t('Account Number:'),
            text: props.bankInfo.accountNumber,
            customClass: fiatDepositModalClasses(),
            classModifiers: 'bank-info'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: fiatDepositModalClasses('information') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: fiatDepositModalClasses('information-text') },
            context.t('Make sure the wire transfer matches the Name and Amount stated in this Deposit Ticket.')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: fiatDepositModalClasses('information-text') },
            context.t('A copy of this Deposit Ticket will be emailed to you')
          )
        )
      )
    )
  );
};

FiatDepositModalComponent.propTypes = {
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

FiatDepositModalComponent.defaultProps = {
  payload: {
    fullname: '',
    amount: '',
    comments: ''
  }
};

FiatDepositModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatDepositModalComponent);

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(212);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(1525);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(658);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(374);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(95);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(1526);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1527);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(658);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(1530);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(374);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(659);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(1531);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            id: id,
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(657);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(657);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _portalOpenInstances = __webpack_require__(659);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (false) {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_SidePaneDetailsComponent_SidePaneDetailsComponent__ = __webpack_require__(375);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FiatDepositDetailsComponent = function (_React$Component) {
  _inherits(FiatDepositDetailsComponent, _React$Component);

  function FiatDepositDetailsComponent() {
    _classCallCheck(this, FiatDepositDetailsComponent);

    return _possibleConstructorReturn(this, (FiatDepositDetailsComponent.__proto__ || Object.getPrototypeOf(FiatDepositDetailsComponent)).apply(this, arguments));
  }

  _createClass(FiatDepositDetailsComponent, [{
    key: 'render',
    value: function render() {
      var _props$info = this.props.info,
          info = _props$info === undefined ? {} : _props$info;

      var showCustomText = info && info.text && info.text.length > 0;
      var showLink = info && info.link;

      var defaultInfo = [this.context.t('Step 1: Create the deposit ticket. Sender’s bank details should match with the wallet account. Third party and/or anonymous payments cannot be accepted.'), this.context.t('Step 2: Please deposit the stated amount to the provided bank account details.'), this.context.t('Note - The information from the deposit ticket will be emailed to you.'), this.context.t('The deposit of these funds might take up to 7 business days, and it’s subject to operator review.')];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_SidePaneDetailsComponent_SidePaneDetailsComponent__["a" /* default */], {
        title: this.context.t('Instructions'),
        info: showCustomText ? info.text : defaultInfo,
        link: showLink ? { text: info.link } : { text: '' },
        classModifiers: 'deposit'
      });
    }
  }]);

  return FiatDepositDetailsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiatDepositDetailsComponent.propTypes = {
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

FiatDepositDetailsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatDepositDetailsComponent);

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepositReferenceIdModal__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);






var mapStateToProps = function mapStateToProps(state) {
  var _state$deposit$deposi = state.deposit.depositStatus,
      requestcode = _state$deposit$deposi.requestcode,
      referenceid = _state$deposit$deposi.referenceid;


  var referenceCode = __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].Deposit.useShortDepositId ? referenceid : requestcode;

  return {
    referenceCode: referenceCode
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_1__DepositReferenceIdModal__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].DEPOSIT_REFERENCE_ID
})(container));

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DepositReferenceIdModal_css__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DepositReferenceIdModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DepositReferenceIdModal_css__);







var depositReferenceIdModalClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('deposit-reference-id-modal');

var DepositReferenceIdModal = function DepositReferenceIdModal(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: !!(props.referenceCode && props.isOpen),
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: depositReferenceIdModalClasses('header-content') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], {
          name: 'depositWithBorder',
          size: 44,
          customClass: depositReferenceIdModalClasses('icon')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: depositReferenceIdModalClasses('header-title') },
          context.t('Deposit') + ' ' + props.ProductSymbol
        )
      ),
      close: props.close,
      footer: {
        buttonText: context.t('OK'),
        buttonStyle: 'additive',
        onClick: function onClick() {
          return props.close;
        }
      },
      customClass: depositReferenceIdModalClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: depositReferenceIdModalClasses('title') },
      context.t('Your deposit ticket has been created successfully.')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: depositReferenceIdModalClasses('reference-code-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: depositReferenceIdModalClasses('reference-code-title') },
        context.t('Please note the following deposit ticket ID for your reference:')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: depositReferenceIdModalClasses('reference-code') },
        props.referenceCode
      )
    )
  );
};

DepositReferenceIdModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

DepositReferenceIdModal.defaultProps = {
  referenceCode: ''
};

DepositReferenceIdModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DepositReferenceIdModal);

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OpenOrders__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilledOrders__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InactiveOrders__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TradeReports__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DepositsStatus__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WithdrawStatus__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HeaderWithFilter__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrderHistoryComponent_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrderHistoryComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__OrderHistoryComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OrderHistoryTables_css__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OrderHistoryTables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__OrderHistoryTables_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var OrderHistoryComponent = function (_Component) {
  _inherits(OrderHistoryComponent, _Component);

  function OrderHistoryComponent() {
    _classCallCheck(this, OrderHistoryComponent);

    return _possibleConstructorReturn(this, (OrderHistoryComponent.__proto__ || Object.getPrototypeOf(OrderHistoryComponent)).apply(this, arguments));
  }

  _createClass(OrderHistoryComponent, [{
    key: '_getPanes',
    value: function _getPanes() {
      var _props = this.props,
          config = _props.config,
          selectedInstrument = _props.selectedInstrument;


      var panes = [{
        menuItem: __WEBPACK_IMPORTED_MODULE_3__OpenOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OpenOrders__["a" /* default */], {
            config: config,
            selectedInstrument: selectedInstrument
          });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_4__FilledOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FilledOrders__["a" /* default */], {
            config: config,
            selectedInstrument: selectedInstrument
          });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_5__InactiveOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__InactiveOrders__["a" /* default */], {
            config: config,
            selectedInstrument: selectedInstrument
          });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_6__TradeReports__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TradeReports__["a" /* default */], {
            config: config,
            selectedInstrument: selectedInstrument
          });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_7__DepositsStatus__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DepositsStatus__["a" /* default */], {
            config: config,
            selectedInstrument: selectedInstrument
          });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_8__WithdrawStatus__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__WithdrawStatus__["a" /* default */], {
            config: config,
            selectedInstrument: selectedInstrument
          });
        }
      }];

      return panes;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        this.props.useHeaderWithFilter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__HeaderWithFilter__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Tab_Tab__["a" /* default */], {
          panes: this._getPanes(),
          classModifiers: this.props.classModifiers,
          customClass: 'order-history'
        })
      );
    }
  }]);

  return OrderHistoryComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, _ref) {
  var config = _ref.config;
  return {
    selectedInstrument: config.filterMode === 'selectedInstrument' ? Object(__WEBPACK_IMPORTED_MODULE_12__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state) : undefined
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(OrderHistoryComponent));

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenOrdersComponent__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_orderHistorySelectors__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderHistoryActions__ = __webpack_require__(93);






var makeMapStateToProps = function makeMapStateToProps() {
  var openOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_orderHistorySelectors__["d" /* openOrdersSelectorFactory */])();

  return function (state, _ref) {
    var config = _ref.config,
        selectedInstrument = _ref.selectedInstrument;

    var openOrders = openOrdersSelector(state, config);
    var instruments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);
    var activeRequests = state.apexCore.orderHistory.activeRequests;

    var fetching = activeRequests > 0;

    return {
      data: openOrders,
      instruments: instruments,
      fetching: fetching,
      selectedInstrument: selectedInstrument
    };
  };
};

var mapDispatchToProps = {
  cancelOrders: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderHistoryActions__["r" /* cancelOrders */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__OpenOrdersComponent__["a" /* default */]));

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CancelAPButton__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_orderHistoryHelper__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);










var baseClass = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var OpenOrdersComponent = function OpenOrdersComponent(_ref, context) {
  var data = _ref.data,
      instruments = _ref.instruments,
      cancelOrders = _ref.cancelOrders,
      fetching = _ref.fetching,
      config = _ref.config,
      selectedInstrument = _ref.selectedInstrument;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var columns = [{
    header: context.t('Pair'),
    dataTest: 'Pair',
    cell: function cell(row, _ref2) {
      var selectedInstrument = _ref2.selectedInstrument;
      return selectedInstrument ? selectedInstrument.Symbol : '';
    }
  }, {
    header: context.t('Side'),
    dataTest: 'Side',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass(row.Side === 'Buy' ? 'buy' : 'sell') },
        context.t(row.Side)
      );
    }
  }, {
    header: context.t('Type'),
    dataTest: 'Type',
    cell: function cell(row) {
      return row.IsQuote ? context.t('Quote') : context.t(row.OrderType);
    }
  }, {
    header: context.t('Size'),
    dataTest: 'Size',
    cell: function cell(row, _ref3) {
      var selectedInstrument = _ref3.selectedInstrument;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('size') },
        row.quantity && Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.quantity, Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement))
      );
    }
  }, {
    header: context.t('Price'),
    dataTest: 'Price',
    cell: function cell(row, _ref4) {
      var selectedInstrument = _ref4.selectedInstrument;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('price') },
        Object(__WEBPACK_IMPORTED_MODULE_6__helpers_orderHistoryHelper__["a" /* getOrderPriceToDisplay */])(row, Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement))
      );
    }
  }, {
    header: context.t('Date/Time'),
    dataTest: 'Date/Time',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_dateHelper__["c" /* formatDateTime */])(row.ReceiveTime);
    }
  }, {
    header: context.t('Status'),
    dataTest: 'Status',
    cell: function cell(row) {
      return context.t(row.OrderState);
    }
  }, {
    header: context.t('Action'),
    dataTest: 'Action',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_CancelAPButton__["a" /* default */], {
        text: context.t('Cancel'),
        customClass: baseClass(),
        dataTest: 'Cancel',
        onClick: function onClick() {
          cancelOrders([row.OrderId]);
        }
      });
    }
  }];

  var rowProps = function rowProps(row) {
    return {
      'data-tip': true,
      'data-for': 'orderInfo-' + row.OrderId,
      selectedInstrument: selectedInstrument || instruments.find(function (item) {
        return item.InstrumentId === row.Instrument;
      }) || {}
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APTable__["a" /* default */], {
    columns: columns,
    rows: data,
    baseClass: baseClass,
    fetching: fetching,
    rowProps: rowProps,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'OpenOrdersComponent'
  });
};

/*
 this.context.t('Open Orders');
 */
OpenOrdersComponent.title = 'Open Orders';

OpenOrdersComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  cancelOrders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

OpenOrdersComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (OpenOrdersComponent);

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_paginationHelper__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_css__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Pagination_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PaginationComponent = function (_Component) {
  _inherits(PaginationComponent, _Component);

  function PaginationComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaginationComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationComponent.__proto__ || Object.getPrototypeOf(PaginationComponent)).call.apply(_ref, [this].concat(args))), _this), _this.getClasses = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['pagination', _this.props.customClass + '-pagination']);
    }, _this.goToPage = function (event, page) {
      event.preventDefault();
      _this.props.setActivePage && _this.props.setActivePage(page);
    }, _this.renderNextButtons = function (page) {
      var paginationClasses = _this.getClasses();
      var disabled = _this.props.totalPages === 0 || page === _this.props.totalPages - 1;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: paginationClasses('next') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: paginationClasses('text', { disabled: disabled }),
            onClick: function onClick(e) {
              return !disabled && _this.goToPage(e, page + 1);
            } },
          _this.context.t('Next'),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APIcon__["a" /* default */], {
            name: 'caretNext',
            customClass: paginationClasses('arrow', 'next')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: paginationClasses('text', { disabled: disabled }),
            onClick: function onClick(e) {
              return !disabled && _this.goToPage(e, _this.props.totalPages - 1);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APIcon__["a" /* default */], {
            name: 'doubleCaretNext',
            customClass: paginationClasses('arrow', 'next')
          })
        )
      );
    }, _this.renderPreviousButtons = function (page) {
      var paginationClasses = _this.getClasses();
      var disabled = _this.props.totalPages === 0 || page === 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: paginationClasses('previous') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: paginationClasses('text', { disabled: disabled }),
            onClick: function onClick(e) {
              return !disabled && _this.goToPage(e, 0);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APIcon__["a" /* default */], {
            name: 'doubleCaretPrevious',
            customClass: paginationClasses('arrow', 'previous')
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: paginationClasses('text', { disabled: disabled }),
            onClick: function onClick(e) {
              return !disabled && _this.goToPage(e, page - 1);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APIcon__["a" /* default */], {
            name: 'caretPrevious',
            customClass: paginationClasses('arrow', 'previous')
          }),
          _this.context.t('Prev')
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaginationComponent, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          content = _props.content,
          activePage = _props.activePage,
          setActivePage = _props.setActivePage;

      var currentContent = content(activePage);

      if (activePage > 0 && currentContent.length === 0) {
        setActivePage(activePage - 1);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var paginationClasses = this.getClasses();
      var _props2 = this.props,
          activePage = _props2.activePage,
          totalPages = _props2.totalPages,
          maxPages = _props2.maxPages,
          showOnlyActivePage = _props2.showOnlyActivePage;

      var length = maxPages > totalPages ? totalPages : maxPages;

      var pages = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_paginationHelper__["a" /* generateNumberRangeArray */])(length, activePage, totalPages).map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            key: i,
            className: paginationClasses('page', activePage === i ? 'active' : null),
            onClick: function onClick(e) {
              return _this2.goToPage(e, i);
            } },
          i + 1
        );
      });

      var content = this.props.content(activePage);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: this.props.containerClassName },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: paginationClasses('content') },
          content
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: paginationClasses('container') },
          this.renderPreviousButtons(activePage),
          showOnlyActivePage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: paginationClasses('pages') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: paginationClasses('page') },
              activePage + 1
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: paginationClasses('pages') },
            pages
          ),
          this.renderNextButtons(activePage)
        )
      );
    }
  }]);

  return PaginationComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PaginationComponent.propTypes = {
  totalPages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  activePage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  containerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  componentName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
PaginationComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
PaginationComponent.defaultProps = {
  activePage: 0,
  containerClassName: '',
  customClass: ''
};
/* harmony default export */ __webpack_exports__["a"] = (PaginationComponent);

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateNumberRangeArray; });
// Generate an array of integers, centered on MiddleValue, not reaching limit.
var generateNumberRangeArray = function generateNumberRangeArray(length, middleValue, limit) {
  return Array.from({ length: length }, function (v, i) {
    var offset = Math.floor(length / 2);

    if (!middleValue || middleValue <= offset) {
      // Ascend starting at 0.
      return i;
    }

    if (limit && middleValue + offset >= limit) {
      // Descend starting at maximum.
      return limit - i - 1;
    }

    return middleValue + i - offset;
  }).sort(function (a, b) {
    return a - b;
  });
}; // Ensure numerical sorting (rather than default string).

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__APInlineButton_css__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__APInlineButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__APInlineButton_css__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var baseClass = 'ap-inline-btn';

var APInlineButton = function APInlineButton(props) {
  var icon = props.icon,
      text = props.text,
      customClass = props.customClass,
      iconModifier = props.iconModifier,
      otherProps = _objectWithoutProperties(props, ['icon', 'text', 'customClass', 'iconModifier']);

  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])([baseClass, customClass]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__APButton__["a" /* default */],
    Object.assign({ baseClass: baseClass, customClass: customClass }, otherProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__APIcon__["a" /* default */], {
      name: icon,
      classModifiers: iconModifier,
      customClass: bemClasses('image')
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: bemClasses('text') },
      text
    )
  );
};

APInlineButton.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  iconModifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

APInlineButton.defaultProps = {
  customClass: 'custom-inline-btn'
};

/* harmony default export */ __webpack_exports__["a"] = (APInlineButton);

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FilledOrdersComponent__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_orderHistorySelectors__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderHistoryActions__ = __webpack_require__(93);






var makeMapStateToProps = function makeMapStateToProps() {
  var filledOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_orderHistorySelectors__["b" /* filledOrdersSelectorFactory */])();

  return function (state, _ref) {
    var config = _ref.config,
        selectedInstrument = _ref.selectedInstrument;

    var filledOrders = filledOrdersSelector(state, config);
    var instruments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);
    var activeRequests = state.apexCore.orderHistory.activeRequests;

    var fetching = activeRequests > 0;

    return {
      data: filledOrders,
      instruments: instruments,
      fetching: fetching,
      selectedInstrument: selectedInstrument
    };
  };
};

var mapDispatchToProps = {
  cancelOrders: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderHistoryActions__["r" /* cancelOrders */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FilledOrdersComponent__["a" /* default */]));

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_orderHistoryHelper__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);









var baseClass = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var FilledOrdersComponent = function FilledOrdersComponent(_ref, context) {
  var data = _ref.data,
      instruments = _ref.instruments,
      config = _ref.config,
      fetching = _ref.fetching,
      selectedInstrument = _ref.selectedInstrument;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var rowProps = function rowProps(row) {
    return {
      selectedInstrument: selectedInstrument || instruments.find(function (item) {
        return item.InstrumentId === row.InstrumentId;
      }) || {}
    };
  };

  var columns = [{
    header: context.t('ID'),
    dataTest: 'ID',
    cell: function cell(row) {
      return row.TradeId;
    }
  }, {
    header: context.t('Pair'),
    dataTest: 'Pair',
    cell: function cell(row, _ref2) {
      var selectedInstrument = _ref2.selectedInstrument;
      return selectedInstrument ? selectedInstrument.Symbol : '';
    }
  }, {
    header: context.t('Side'),
    dataTest: 'Side',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass(row.Side === 'Buy' ? 'buy' : 'sell') },
        context.t(row.Side)
      );
    }
  }, {
    header: context.t('Size'),
    dataTest: 'Size',
    cell: function cell(row, _ref3) {
      var selectedInstrument = _ref3.selectedInstrument;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('size') },
        row.Quantity && Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.Quantity, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement))
      );
    }
  }, {
    header: context.t('Price'),
    dataTest: 'Price',
    cell: function cell(row, _ref4) {
      var selectedInstrument = _ref4.selectedInstrument;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('price') },
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers_orderHistoryHelper__["a" /* getOrderPriceToDisplay */])(row, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement))
      );
    }
  }, {
    header: context.t('Total'),
    dataTest: 'Total',
    cell: function cell(row, _ref5) {
      var selectedInstrument = _ref5.selectedInstrument;
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.Value, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement));
    }
  }, {
    header: context.t('Fee'),
    dataTest: 'Fee',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.Fee, row.Fee.symbol) + ' ' + row.Fee.symbol;
    }
  }, {
    header: context.t('Execution ID'),
    dataTest: 'Execution ID',
    cell: function cell(row) {
      return row.ExecutionId;
    }
  }, {
    header: context.t('Date/Time'),
    dataTest: 'Date/Time',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__["c" /* formatDateTime */])(new Date(row.TradeTimeMS));
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APTable__["a" /* default */], {
    columns: columns,
    rowProps: rowProps,
    rows: data,
    baseClass: baseClass,
    fetching: fetching,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'FilledOrdersComponent'
  });
};
/*
 this.context.t('Filled Orders');
 */
FilledOrdersComponent.title = 'Filled Orders';

FilledOrdersComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FilledOrdersComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FilledOrdersComponent);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InactiveOrdersComponent__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_orderHistorySelectors__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderHistoryActions__ = __webpack_require__(93);






var makeMapStateToProps = function makeMapStateToProps() {
  var inactiveOrdersSelector = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_orderHistorySelectors__["c" /* inactiveOrdersSelectorFactory */])();

  return function (state, _ref) {
    var config = _ref.config,
        selectedInstrument = _ref.selectedInstrument;

    var inactiveOrders = inactiveOrdersSelector(state, config);
    var instruments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);
    var activeRequests = state.apexCore.orderHistory.activeRequests;

    var fetching = activeRequests > 0;

    return {
      data: inactiveOrders,
      instruments: instruments,
      fetching: fetching,
      selectedInstrument: selectedInstrument
    };
  };
};

var mapDispatchToProps = {
  cancelOrders: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderHistoryActions__["r" /* cancelOrders */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__InactiveOrdersComponent__["a" /* default */]));

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_orderHistoryHelper__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);










var baseClass = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var InactiveOrdersComponent = function InactiveOrdersComponent(_ref, context) {
  var data = _ref.data,
      instruments = _ref.instruments,
      config = _ref.config,
      fetching = _ref.fetching,
      selectedInstrument = _ref.selectedInstrument;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var rowProps = function rowProps(row) {
    return {
      selectedInstrument: selectedInstrument || instruments.find(function (item) {
        return item.InstrumentId === row.Instrument;
      }) || {}
    };
  };

  var columns = [{
    header: context.t('Pair'),
    dataTest: 'Pair',
    cell: function cell(row, _ref2) {
      var selectedInstrument = _ref2.selectedInstrument;
      return selectedInstrument ? selectedInstrument.Symbol : '';
    }
  }, {
    header: context.t('Side'),
    dataTest: 'Side',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass(row.Side === 'Buy' ? 'buy' : 'sell') },
        context.t(row.Side)
      );
    }
  }, {
    header: context.t('Type'),
    dataTest: 'Type',
    cell: function cell(row) {
      return row.IsQuote ? context.t('Quote') : context.t(row.OrderType);
    }
  }, {
    header: context.t('Size'),
    dataTest: 'Size',
    cell: function cell(row, _ref3) {
      var selectedInstrument = _ref3.selectedInstrument;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('size') },
        row.OrigQuantity && Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.OrigQuantity, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement))
      );
    }
  }, {
    header: context.t('Price'),
    dataTest: 'Price',
    cell: function cell(row, _ref4) {
      var selectedInstrument = _ref4.selectedInstrument;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('price') },
        Object(__WEBPACK_IMPORTED_MODULE_6__helpers_orderHistoryHelper__["a" /* getOrderPriceToDisplay */])(row, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement))
      );
    }
  }, {
    header: context.t('Date/Time'),
    dataTest: 'Date/Time',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_dateHelper__["c" /* formatDateTime */])(row.ReceiveTime);
    }
  }, {
    header: context.t('Status'),
    dataTest: 'Status',
    cell: function cell(row) {
      return context.t(row.OrderState);
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APTable__["a" /* default */], {
    columns: columns,
    rowProps: rowProps,
    rows: data,
    baseClass: baseClass,
    fetching: fetching,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'InactiveOrdersComponent'
  });
};

InactiveOrdersComponent.title = 'Inactive Orders';

InactiveOrdersComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

InactiveOrdersComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (InactiveOrdersComponent);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TradeReportsComponent__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_orderHistorySelectors__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderHistoryActions__ = __webpack_require__(93);






var makeMapStateToProps = function makeMapStateToProps() {
  var tradeReportsSelector = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_orderHistorySelectors__["f" /* tradeReportsSelectorFactory */])();

  return function (state, _ref) {
    var config = _ref.config,
        selectedInstrument = _ref.selectedInstrument;

    var tradeReports = tradeReportsSelector(state, config);
    var instruments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);
    var activeRequests = state.apexCore.orderHistory.activeRequests;

    var fetching = activeRequests > 0;

    return {
      data: tradeReports,
      instruments: instruments,
      fetching: fetching,
      selectedInstrument: selectedInstrument
    };
  };
};

var mapDispatchToProps = {
  cancelOrders: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderHistoryActions__["r" /* cancelOrders */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TradeReportsComponent__["a" /* default */]));

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_orderHistoryHelper__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);









var baseClass = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var OrderHistoryTradeReportsComponent = function OrderHistoryTradeReportsComponent(_ref, context) {
  var data = _ref.data,
      instruments = _ref.instruments,
      config = _ref.config,
      fetching = _ref.fetching,
      selectedInstrument = _ref.selectedInstrument;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var rowProps = function rowProps(row) {
    return {
      'data-tip': true,
      'data-for': 'orderInfo-' + row.OrderId,
      selectedInstrument: selectedInstrument || instruments.find(function (i) {
        return i.InstrumentId === row.InstrumentId;
      }) || {}
    };
  };

  var columns = [{
    header: context.t('Pair'),
    dataTest: 'Pair',
    cell: function cell(row, _ref2) {
      var selectedInstrument = _ref2.selectedInstrument;
      return selectedInstrument ? selectedInstrument.Symbol : '';
    }
  }, {
    header: context.t('Side'),
    dataTest: 'Side',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass(row.Side === 'Buy' ? 'buy' : 'sell') },
        row.Side
      );
    }
  }, {
    header: context.t('Size'),
    dataTest: 'Size',
    cell: function cell(row, _ref3) {
      var selectedInstrument = _ref3.selectedInstrument;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('size') },
        row.Quantity && Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.Quantity, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement))
      );
    }
  }, {
    header: context.t('Price'),
    dataTest: 'Price',
    cell: function cell(row, _ref4) {
      var selectedInstrument = _ref4.selectedInstrument;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('price') },
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers_orderHistoryHelper__["a" /* getOrderPriceToDisplay */])(row, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement))
      );
    }
  }, {
    header: context.t('Fee'),
    dataTest: 'Fee',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.Fee, row.Fee.symbol);
    }
  }, {
    header: context.t('Date/Time'),
    dataTest: 'Date/Time',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__["c" /* formatDateTime */])(row.ReceiveTime || row.TradeTimeMS);
    }
  }, {
    header: context.t('Status'),
    dataTest: 'Status',
    cell: function cell() {
      return context.t('Complete');
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APTable__["a" /* default */], {
    columns: columns,
    rowProps: rowProps,
    rows: data,
    baseClass: baseClass,
    fetching: fetching,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'OrderHistoryTradeReportsComponent'
  });
};

/*
 this.context.t('Trade Reports');
 */
OrderHistoryTradeReportsComponent.title = 'Trade Reports';

OrderHistoryTradeReportsComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  cancelOrders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

OrderHistoryTradeReportsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (OrderHistoryTradeReportsComponent);

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DepositsStatusContainer__ = __webpack_require__(1556);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DepositsStatusContainer__["a" /* default */]);

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepositsStatusComponent__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_productsSelectors__ = __webpack_require__(662);






var mapStateToProps = function mapStateToProps(state, ownProps) {
  var depositsStatus = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__["c" /* filteredDepositsByProductSelector */])(state, ownProps.config);
  var instruments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);
  var decimalPlaces = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_productsSelectors__["a" /* decimalsByProductId */])(state);
  var activeRequests = state.apexCore.orderHistory.activeRequests;

  var fetching = activeRequests > 0;

  return {
    data: depositsStatus,
    instruments: instruments,
    fetching: fetching,
    decimalPlaces: decimalPlaces
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__DepositsStatusComponent__["a" /* default */]));

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);







var baseClass = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var DepositsStatusComponent = function DepositsStatusComponent(_ref, context) {
  var data = _ref.data,
      decimalPlaces = _ref.decimalPlaces,
      config = _ref.config;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var columns = [{
    header: context.t('Product'),
    dataTest: 'Product',
    cell: function cell(row) {
      return row.AssetName;
    }
  }, {
    header: context.t('Amount'),
    dataTest: 'Amount',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.Amount, decimalPlaces[row.AssetId]);
    }
  }, {
    header: context.t('Status'),
    dataTest: 'Status',
    cell: function cell(row) {
      return context.t(row.Status);
    }
  }, {
    header: context.t('Created'),
    dataTest: 'Created',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_dateHelper__["c" /* formatDateTime */])(row.CreatedTimestamp);
    }
  }, {
    header: context.t('Fee'),
    dataTest: 'Fee',
    cell: function cell(row) {
      return row.FeeAmt;
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APTable__["a" /* default */], {
    columns: columns,
    rows: data,
    baseClass: baseClass,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'DepositStatusComponent'
  });
};

/*
 this.context.t('Deposit Status');
 */
DepositsStatusComponent.title = 'Deposit Status';
DepositsStatusComponent.componentName = 'DepositsStatusComponent';

DepositsStatusComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  decimalPlaces: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

DepositsStatusComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DepositsStatusComponent);

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WithdrawStatusContainer__ = __webpack_require__(1559);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__WithdrawStatusContainer__["a" /* default */]);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WithdrawStatusComponent__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_productsSelectors__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_withdrawActions__ = __webpack_require__(78);







var mapStateToProps = function mapStateToProps(state, _ref) {
  var config = _ref.config;

  var withdrawTickets = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_depositWithdrawalSelectors__["d" /* filteredWithdrawalsByProductSelector */])(state, config);
  var instruments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);
  var decimalPlaces = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_productsSelectors__["a" /* decimalsByProductId */])(state);
  var activeRequests = state.apexCore.orderHistory.activeRequests;

  var fetching = activeRequests > 0;

  return {
    data: withdrawTickets,
    instruments: instruments,
    fetching: fetching,
    decimalPlaces: decimalPlaces
  };
};

var mapDispatchToProps = {
  cancelWithdrawTicket: __WEBPACK_IMPORTED_MODULE_5__redux_actions_withdrawActions__["l" /* cancelWithdrawTicket */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__WithdrawStatusComponent__["a" /* default */]));

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_CancelAPButton__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__ = __webpack_require__(7);









var baseClass = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var WithdrawStatusComponent = function WithdrawStatusComponent(_ref, context) {
  var data = _ref.data,
      decimalPlaces = _ref.decimalPlaces,
      config = _ref.config,
      cancelWithdrawTicket = _ref.cancelWithdrawTicket;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var columns = [{
    header: context.t('Product'),
    dataTest: 'Product',
    cell: function cell(row) {
      return row.AssetName;
    }
  }, {
    header: context.t('Amount'),
    dataTest: 'Amount',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.Amount, decimalPlaces[row.AssetId]);
    }
  }, {
    header: context.t('Status'),
    dataTest: 'Status',
    cell: function cell(row) {
      return context.t(row.Status);
    }
  }, {
    header: context.t('Created'),
    dataTest: 'Created',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_dateHelper__["c" /* formatDateTime */])(row.CreatedTimestamp);
    }
  }, {
    header: context.t('Fee'),
    dataTest: 'Fee',
    cell: function cell(row) {
      return row.FeeAmt;
    }
  }, {
    header: context.t('Actions'),
    dataTest: 'Actions',
    cell: function cell(row) {
      return ['Pending', 'Pending2Fa'].includes(row.Status) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_CancelAPButton__["a" /* default */], {
        customClass: baseClass(),
        text: context.t('Cancel'),
        onClick: function onClick() {
          return cancelWithdrawTicket(row);
        }
      }) : '';
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APTable__["a" /* default */], {
    columns: columns,
    rows: data,
    baseClass: baseClass,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'WithdrawStatusComponent'
  });
};

/*
 this.context.t('Withdraw Status');
 */
WithdrawStatusComponent.title = 'Withdraw Status';

WithdrawStatusComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  decimalPlaces: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  cancelWithdrawTicket: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

WithdrawStatusComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (WithdrawStatusComponent);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderWithFilterComponent__ = __webpack_require__(1562);




var formSelector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('order-history-filter');

var mapStateToProps = function mapStateToProps(state) {
  var startDate = formSelector(state, 'startDate');
  return {
    startDate: startDate
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearDate: function clearDate(fieldName) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('order-history-filter', fieldName, null));
    }
  };
};

var HeaderWithFilterContainerForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'order-history-filter',
  initialValues: {
    startDate: undefined,
    endDate: undefined
  }
})(__WEBPACK_IMPORTED_MODULE_2__HeaderWithFilterComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(HeaderWithFilterContainerForm));

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_APDatePicker_APDatePicker__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APButton__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history');

var HeaderWithFilterComponent = function (_React$Component) {
  _inherits(HeaderWithFilterComponent, _React$Component);

  function HeaderWithFilterComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HeaderWithFilterComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderWithFilterComponent.__proto__ || Object.getPrototypeOf(HeaderWithFilterComponent)).call.apply(_ref, [this].concat(args))), _this), _this.clearFilters = function () {
      var clearDate = _this.props.clearDate;

      clearDate('startDate');
      clearDate('endDate');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HeaderWithFilterComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          startDate = _props.startDate,
          clearDate = _props.clearDate;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-with-filter') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('header-with-filter-title') },
          this.context.t('Transaction History')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('header-with-filter-datapicker') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_APDatePicker_APDatePicker__["a" /* default */], {
            name: 'startDate',
            customClass: baseClasses('from'),
            label: this.context.t('Date Range:'),
            maxDate: new Date(),
            format: function format(value) {
              return value;
            },
            showIcon: true,
            iconClick: function iconClick() {
              return clearDate('startDate');
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_APDatePicker_APDatePicker__["a" /* default */], {
            name: 'endDate',
            customClass: baseClasses('to'),
            label: this.context.t('to'),
            minDate: startDate,
            maxDate: new Date(),
            format: function format(value) {
              return value;
            },
            showIcon: true,
            iconClick: function iconClick() {
              return clearDate('endDate');
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
            {
              customClass: baseClasses('clear'),
              classModifiers: 'clear-filters',
              type: 'button',
              onClick: this.clearFilters },
            this.context.t('Clear Filters')
          )
        )
      );
    }
  }]);

  return HeaderWithFilterComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HeaderWithFilterComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (HeaderWithFilterComponent);

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_resize__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_InstrumentRow__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_OrderBookComponents_OrderBookContainer__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PriceChart_PriceChartContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DepthChart_DepthChartContainer__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RecentTrades_RecentTradesContainer__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_OrderEntryComponents_OrderEntryContainer__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_InstrumentPositionsWrapper__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ConfirmLimitOrderModal_ConfirmLimitOrderModalContainer__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_OrderHistoryComponents__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_OrderHistoryComponents_MarginOrderHistory__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Responsive_TrandingLayout_TradingLayoutContent480Px__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Responsive_TrandingLayout_TradingLayoutContent1280Px__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Responsive_TrandingLayout_TradingLayoutContent1440Px__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Responsive_TrandingLayout_TradingLayoutCharts1280Px__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_MarginToggleButton__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_MarginClosePosition_MarginClosePositionModal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_MarginTransferAssetModal_MarginTransferAssetsModal__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__TradingLayout_css__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__TradingLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__TradingLayout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_MarginClosePosition_EstimatedSettlementModal__ = __webpack_require__(284);


























var tradingLayoutClasses = Object(__WEBPACK_IMPORTED_MODULE_21__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trading-layout');

var TradingLayout = function TradingLayout(props, context) {
  var height = props.height,
      width = props.width,
      isMarginEnabledSelector = props.isMarginEnabledSelector;


  var renderActivity = function renderActivity() {
    var config = props.config,
        isMarginActive = props.isMarginActive;
    var usePagination = config.OrderHistoryData.usePagination,
        maxLines = config.TradingLayout.maxLines;

    var orderHistoryConfig = {
      usePagination: usePagination,
      maxLines: maxLines,
      filterMode: 'selectedInstrument'
    };

    return isMarginActive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_OrderHistoryComponents_MarginOrderHistory__["a" /* default */], { config: orderHistoryConfig }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_OrderHistoryComponents__["default"], { config: orderHistoryConfig });
  };

  if (width > 968 && width <= 1280) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Responsive_TrandingLayout_TradingLayoutContent1280Px__["a" /* default */], Object.assign({
      short: height <= 1080
    }, {
      OrderBook: __WEBPACK_IMPORTED_MODULE_4__components_OrderBookComponents_OrderBookContainer__["a" /* default */],
      OrderEntry: __WEBPACK_IMPORTED_MODULE_8__components_OrderEntryComponents_OrderEntryContainer__["a" /* default */],
      InstrumentPositions: __WEBPACK_IMPORTED_MODULE_9__components_InstrumentPositionsWrapper__["a" /* default */],
      RecentTrades: __WEBPACK_IMPORTED_MODULE_7__components_RecentTrades_RecentTradesContainer__["a" /* default */]
    }, props));
  }

  if (width > 1280) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Responsive_TrandingLayout_TradingLayoutContent1440Px__["a" /* default */], Object.assign({
      short: height <= 1080
    }, {
      OrderBook: __WEBPACK_IMPORTED_MODULE_4__components_OrderBookComponents_OrderBookContainer__["a" /* default */],
      OrderEntry: __WEBPACK_IMPORTED_MODULE_8__components_OrderEntryComponents_OrderEntryContainer__["a" /* default */],
      InstrumentPositions: __WEBPACK_IMPORTED_MODULE_9__components_InstrumentPositionsWrapper__["a" /* default */],
      RecentTrades: __WEBPACK_IMPORTED_MODULE_7__components_RecentTrades_RecentTradesContainer__["a" /* default */]
    }, props));
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: tradingLayoutClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradingLayoutClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_InstrumentRow__["a" /* default */], null),
      isMarginEnabledSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_MarginToggleButton__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradingLayoutClasses('body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: tradingLayoutClasses('chart-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Responsive_TrandingLayout_TradingLayoutCharts1280Px__["a" /* default */], {
          PriceChart: __WEBPACK_IMPORTED_MODULE_5__components_PriceChart_PriceChartContainer__["a" /* default */],
          DepthChart: __WEBPACK_IMPORTED_MODULE_6__components_DepthChart_DepthChartContainer__["a" /* default */],
          showDepthChart: __WEBPACK_IMPORTED_MODULE_20__config__["b" /* default */].TradingLayout.showDepthChart
        }),
        renderActivity()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Responsive_TrandingLayout_TradingLayoutContent480Px__["a" /* default */], {
        OrderBook: __WEBPACK_IMPORTED_MODULE_4__components_OrderBookComponents_OrderBookContainer__["a" /* default */],
        OrderEntry: __WEBPACK_IMPORTED_MODULE_8__components_OrderEntryComponents_OrderEntryContainer__["a" /* default */],
        InstrumentPositions: __WEBPACK_IMPORTED_MODULE_9__components_InstrumentPositionsWrapper__["a" /* default */],
        RecentTrades: __WEBPACK_IMPORTED_MODULE_7__components_RecentTrades_RecentTradesContainer__["a" /* default */]
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ConfirmLimitOrderModal_ConfirmLimitOrderModalContainer__["a" /* default */], null),
    isMarginEnabledSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_MarginClosePosition_MarginClosePositionModal__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_MarginClosePosition_EstimatedSettlementModal__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_MarginTransferAssetModal_MarginTransferAssetsModal__["a" /* default */], null)
    )
  );
};

TradingLayout.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_resize__["a" /* default */])(TradingLayout));

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(1566),
    isObject = __webpack_require__(67);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67),
    now = __webpack_require__(1567),
    toNumber = __webpack_require__(317);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InstrumentSelector_InstrumentSelectorContainer__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InstrumentRowComponent_css__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InstrumentRowComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InstrumentRowComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('instrument-row');

var InstrumentRowComponent = function InstrumentRowComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InstrumentSelector_InstrumentSelectorContainer__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__["a" /* default */], null)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (InstrumentRowComponent);

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Popover_Popover__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InstrumentSelectorPopupComponent__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propTypes_instrumentPropTypes__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InstrumentSelectorComponent_css__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InstrumentSelectorComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InstrumentSelectorComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('instrument-selector');

var InstrumentSelectorComponent = function (_React$Component) {
  _inherits(InstrumentSelectorComponent, _React$Component);

  function InstrumentSelectorComponent(props) {
    _classCallCheck(this, InstrumentSelectorComponent);

    var _this = _possibleConstructorReturn(this, (InstrumentSelectorComponent.__proto__ || Object.getPrototypeOf(InstrumentSelectorComponent)).call(this, props));

    _this.runLevel1Updates = function () {
      return _this.updateLevel1 = true;
    };

    _this.stopLevel1Updates = function () {
      return _this.updateLevel1 = false;
    };

    _this.onRowClick = function (instrument) {
      _this.popoverRef.toggleShow();
      _this.props.selectInstrument(instrument.InstrumentId);
    };

    _this.popoverRef = null;
    _this.updateLevel1 = true;
    return _this;
  }

  _createClass(InstrumentSelectorComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (this.props.instruments.length === 0) return;

      var selectedInstrument = this.props.instruments.find(function (instrument) {
        return instrument.InstrumentId === _this2.props.selectedInstrument.InstrumentId;
      });

      if (selectedInstrument) return;

      var instrumentId = this.props.instruments[0].InstrumentId;
      this.props.selectInstrument(instrumentId);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.updateLevel1;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          fetching = _props.fetching,
          instruments = _props.instruments,
          selectedInstrument = _props.selectedInstrument,
          selectedRow = _props.selectedRow,
          level1 = _props.level1,
          customClass = _props.customClass,
          showFullNameInstrument = _props.showFullNameInstrument,
          showTriangles = _props.showTriangles;


      var instrumentSymbol = '';
      if (showFullNameInstrument && selectedInstrument.Product1FullName) {
        instrumentSymbol = this.context.t(selectedInstrument.Product1FullName + ' / ' + selectedInstrument.Product2FullName);
      } else {
        instrumentSymbol = selectedInstrument.Symbol;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Popover_Popover__["a" /* default */], {
        ref: function ref(_ref) {
          return _this3.popoverRef = _ref;
        },
        trigger: function trigger(props) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            Object.assign({
              className: baseClasses('trigger')
            }, props, {
              onMouseOver: _this3.stopLevel1Updates,
              onMouseOut: _this3.runLevel1Updates }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: baseClasses('symbol') },
              instrumentSymbol
            ),
            showTriangles ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('triangles-container') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'triangle-up' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'triangle-down' })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: baseClasses('triangle') })
          );
        },
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InstrumentSelectorPopupComponent__["a" /* default */], {
          onRowClick: this.onRowClick,
          fetching: fetching,
          instruments: instruments,
          selectedRow: selectedRow,
          level1: level1,
          customClass: customClass,
          showFullNameInstrument: showFullNameInstrument
        }),
        customClass: 'instrument-selector-popover',
        drawArrow: true
      });
    }
  }]);

  return InstrumentSelectorComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InstrumentSelectorComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

InstrumentSelectorComponent.propTypes = {
  level1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  fetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_4__propTypes_instrumentPropTypes__["a" /* instrumentPropType */],
  selectedRow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (InstrumentSelectorComponent);

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InstrumentSelectorPopupComponent_css__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InstrumentSelectorPopupComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InstrumentSelectorPopupComponent_css__);








var InstrumentSelectorPopupComponent = function InstrumentSelectorPopupComponent(props, context) {
  var onRowClick = props.onRowClick,
      level1 = props.level1,
      instruments = props.instruments,
      fetching = props.fetching,
      selectedRow = props.selectedRow,
      customClass = props.customClass,
      showFullNameInstrument = props.showFullNameInstrument;

  var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('instrument-selector-popup', customClass);

  var columns = [{
    header: context.t('Coin'),
    classModifier: 'coin',
    cell: function cell(instrument) {
      return showFullNameInstrument ? context.t(instrument.Product1FullName + ' / ' + instrument.Product2FullName) : instrument.Symbol;
    }
  }, {
    header: context.t('Price'),
    cell: function cell(instrument) {
      return instrument.lastTrade;
    }
  }, {
    header: context.t('24hr Chg'),
    cell: function cell(instrument) {
      return instrument.Rolling24HrPxChangePercent;
    }
  }, {
    header: context.t('Volume'),
    cell: function cell(instrument) {
      return instrument.Rolling24HrVolume;
    }
  }];

  var instrumentsRow = instruments.map(function (instrument) {
    var level1Data = level1[instrument.InstrumentId];
    return Object.assign({}, instrument, {
      lastTrade: level1Data && level1Data.LastTradedPx.toFixed(2),
      Rolling24HrPxChangePercent: level1Data && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          className: baseClasses(level1Data.Rolling24HrPxChangePercent >= 0 ? '24h-positive' : '24h-negative') },
        (level1Data.Rolling24HrPxChangePercent > 0 ? '+' : '') + Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["c" /* formatPercentageValue */])(level1Data.Rolling24HrPxChangePercent)
      ),
      Rolling24HrVolume: level1Data && Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["d" /* formatToThousands */])(level1Data.Rolling24HrVolume)
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APTable__["a" /* default */], {
    fetching: fetching,
    columns: columns,
    rows: instrumentsRow,
    baseClass: baseClasses,
    onRowClicked: function onRowClicked(instrument) {
      return onRowClick(instrument);
    },
    selectedRow: selectedRow,
    empty: context.t('No coin is available')
  });
};

InstrumentSelectorPopupComponent.propTypes = {
  level1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onRowClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  fetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  selectedRow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

InstrumentSelectorPopupComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (InstrumentSelectorPopupComponent);

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propTypes_level1Data__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propTypes_instrumentPropTypes__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InstrumentTableItem__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InstrumentTableComponent_css__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InstrumentTableComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__InstrumentTableComponent_css__);
var _level1ItemsData;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var getProductSymbol = function getProductSymbol(instrument) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(instrument, 'Product1Symbol', '');
};

var InstrumentTableComponent = function InstrumentTableComponent(props, context) {
  var t = context.t;
  var level1 = props.level1,
      selectedInstrument = props.selectedInstrument,
      items = props.items,
      customClass = props.customClass;


  var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['instrument-table', customClass]);

  var productSymbol = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(selectedInstrument, 'Product1Symbol', '');
  var priceSymbol = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(selectedInstrument, 'Product2Symbol', '');

  var instrumentTableItems = items.map(function (item) {
    return level1ItemsData[item.field](t, level1, selectedInstrument);
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    customClass === 'market-overview-instrument' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: baseClasses('title') },
        t('' + productSymbol + priceSymbol + ' Price Data:')
      )
    ),
    instrumentTableItems.map(function (_ref) {
      var key = _ref.key,
          value = _ref.value,
          label = _ref.label,
          classModifiers = _ref.classModifiers;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InstrumentTableItem__["a" /* default */], {
        key: key,
        value: value,
        label: label,
        baseClasses: baseClasses,
        classModifiers: classModifiers
      });
    })
  );
};

InstrumentTableComponent.propTypes = {
  level1: __WEBPACK_IMPORTED_MODULE_4__propTypes_level1Data__["b" /* type */].isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_6__propTypes_instrumentPropTypes__["a" /* instrumentPropType */],
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    field: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }))
};

InstrumentTableComponent.defaultProps = {
  level1: __WEBPACK_IMPORTED_MODULE_4__propTypes_level1Data__["a" /* defaultProps */],
  items: [{ field: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].lastPrice }, { field: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyPercentageChange }, { field: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].bid }, { field: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].ask }, { field: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyVolume }, { field: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyMin }, { field: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyMax }]
};

InstrumentTableComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (InstrumentTableComponent);

var level1ItemsData = (_level1ItemsData = {}, _defineProperty(_level1ItemsData, __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].lastPrice, function (t, _ref2, instrument) {
  var LastTradedPx = _ref2.LastTradedPx;
  return {
    key: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].lastPrice,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(LastTradedPx, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(instrument, 'PriceIncrement', 0))),
    label: t('Last Price'),
    classModifiers: ['last-price']
  };
}), _defineProperty(_level1ItemsData, __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyPercentageChange, function (t, _ref3, instrument) {
  var Rolling24HrPxChangePercent = _ref3.Rolling24HrPxChangePercent;
  return {
    key: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyPercentageChange,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["c" /* formatPercentageValue */])(Rolling24HrPxChangePercent),
    label: t('24 Hour Pct Chg'),
    classModifiers: [Rolling24HrPxChangePercent >= 0 ? '24h-positive' : '24h-negative']
  };
}), _defineProperty(_level1ItemsData, __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].bid, function (t, _ref4, instrument) {
  var BestBid = _ref4.BestBid;
  return {
    key: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].bid,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(BestBid, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
    label: t('Bid'),
    classModifiers: ['hideable', 'bid']
  };
}), _defineProperty(_level1ItemsData, __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].ask, function (t, _ref5, instrument) {
  var BestOffer = _ref5.BestOffer;
  return {
    key: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].ask,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(BestOffer, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
    label: t('Ask'),
    classModifiers: ['hideable', 'ask']
  };
}), _defineProperty(_level1ItemsData, __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyVolume, function (t, _ref6, instrument) {
  var Rolling24HrVolume = _ref6.Rolling24HrVolume;
  return {
    key: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyVolume,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Rolling24HrVolume, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.QuantityIncrement)) + ' ' + getProductSymbol(instrument),
    label: t('24 Hour Volume'),
    classModifiers: ['24h-volume']
  };
}), _defineProperty(_level1ItemsData, __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyMin, function (t, _ref7, instrument) {
  var SessionLow = _ref7.SessionLow;
  return {
    key: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyMin,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(SessionLow, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
    label: t('24 Hour Low'),
    classModifiers: ['hideable', '24h-low']
  };
}), _defineProperty(_level1ItemsData, __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyMax, function (t, _ref8, instrument) {
  var SessionHigh = _ref8.SessionHigh;
  return {
    key: __WEBPACK_IMPORTED_MODULE_8__InstrumentTableItems__["a" /* default */].dailyMax,
    value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(SessionHigh, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
    label: t('24 Hour High'),
    classModifiers: ['hideable', '24h-high']
  };
}), _level1ItemsData);

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InstrumentTableItem__ = __webpack_require__(1576);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InstrumentTableItem__["a" /* default */]);

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var InstrumentTableItem = function InstrumentTableItem(props) {
  var value = props.value,
      label = props.label,
      classModifiers = props.classModifiers,
      baseClasses = props.baseClasses;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('row', classModifiers) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: baseClasses('value', classModifiers) },
      value
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: baseClasses('title') },
      label
    )
  );
};

InstrumentTableItem.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  baseClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  classModifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};

InstrumentTableItem.defaultProps = {
  classModifiers: []
};

/* harmony default export */ __webpack_exports__["a"] = (InstrumentTableItem);

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APVerticalScroller_APVerticalScroller__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APInlineButton__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkCancelButtonsComponent_BulkCancelButtonsComponent__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_browserHelper__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Level2DataTableComponent__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_components_TradeComponent_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_components_TradeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_components_TradeComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderBookComponent_css__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderBookComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__OrderBookComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');
var orderBookClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('orderbook');
var flexTable = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('flex-table');

var OrderBookComponent = function (_React$Component) {
  _inherits(OrderBookComponent, _React$Component);

  function OrderBookComponent(props, context) {
    _classCallCheck(this, OrderBookComponent);

    // default state
    var _this = _possibleConstructorReturn(this, (OrderBookComponent.__proto__ || Object.getPrototypeOf(OrderBookComponent)).call(this, props, context));

    _this.resizeEventListener = function () {
      return _this.onClickCenter(true);
    };

    _this.state = {
      showCenterButton: false //  will change to true when user scrolls away from rest position
    };
    // event handler bindings
    _this.onClickCenter = _this.onClickCenter.bind(_this);
    _this.resizeEventListener = _this.resizeEventListener.bind(_this);
    _this.onScrollRestChange = _this.onScrollRestChange.bind(_this);
    _this.handleScrollRestChange = _this.handleScrollRestChange.bind(_this);

    _this.buyScroller = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.sellScroller = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this;
  }

  _createClass(OrderBookComponent, [{
    key: 'onClickCenter',
    value: function onClickCenter() {
      var _this2 = this;

      var overrideUserScrolled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.sellScroller && this.buyScroller) {
        var scrollToRest = function scrollToRest() {
          _this2.sellScroller.current.scrollToRest();
          _this2.buyScroller.current.scrollToRest();
        };

        if (overrideUserScrolled) return this.sellScroller.current.resetUserScrolled(function () {
          return _this2.buyScroller.current.resetUserScrolled(scrollToRest);
        });
        scrollToRest();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.onClickCenter(this.props.selectedInstrumentId !== prevProps.selectedInstrumentId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.resizeEventListener);
      this.onClickCenter();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeEventListener);
    }
  }, {
    key: 'onScrollRestChange',
    value: function onScrollRestChange(value) {
      // show "center" button when user scrolls away from rest position
      setTimeout(this.handleScrollRestChange, 230);
    }
  }, {
    key: 'handleScrollRestChange',
    value: function handleScrollRestChange() {
      if (!!this.sellScroller.current) {
        var sellIsAtRest = this.sellScroller.current.getIsAtRest();
        var buyIsAtRest = this.buyScroller.current.getIsAtRest();
        var showCenterButton = !sellIsAtRest || !buyIsAtRest;
        this.setState({
          showCenterButton: showCenterButton
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var context = this.context,
          onScrollRestChange = this.onScrollRestChange,
          _props = this.props,
          spread = _props.spread,
          cancelAllOrders = _props.cancelAllOrders,
          cancelBuyOrders = _props.cancelBuyOrders,
          cancelSellOrders = _props.cancelSellOrders,
          openOrders = _props.openOrders,
          buyOpenOrders = _props.buyOpenOrders,
          sellOpenOrders = _props.sellOpenOrders;
      var _props2 = this.props,
          selectedInstrument = _props2.selectedInstrument,
          cancelOrders = _props2.cancelOrders,
          _props2$level = _props2.level2,
          buy = _props2$level.buy,
          sell = _props2$level.sell,
          buyPriceClicked = _props2.buyPriceClicked,
          buyQuantityClicked = _props2.buyQuantityClicked,
          sellPriceClicked = _props2.sellPriceClicked,
          sellQuantityClicked = _props2.sellQuantityClicked,
          fetching = _props2.fetching,
          hideBulkCancelButtons = _props2.hideBulkCancelButtons;


      var CenterButton = function CenterButton(_ref) {
        var state = _ref.state,
            context = _ref.context,
            onClickCenter = _ref.onClickCenter,
            spread = _ref.spread;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: orderBookClasses('spread-row') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            context.t('Spread'),
            ' ',
            spread
          ),
          state && state.showCenterButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APInlineButton__["a" /* default */], {
            icon: 'center',
            iconModifier: 'small',
            text: context.t('Center'),
            onClick: function onClick() {
              return onClickCenter(true);
            },
            customClass: orderBookClasses('center-button')
          })
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: tradeComponentClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: flexTable() + ' ' + orderBookClasses() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: flexTable('body') + ' ' + orderBookClasses('body') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: flexTable('header', 'background') + ' ' + orderBookClasses('header') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: flexTable('column') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    className: flexTable('fixed') + ' ' + orderBookClasses('table-header', 'price') },
                  context.t('Price')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: flexTable('column') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    className: flexTable('fixed') + ' ' + orderBookClasses('table-header', 'qty') },
                  context.t('Qty')
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: flexTable('column') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    className: flexTable('fixed') + ' ' + orderBookClasses('table-header', 'my-size') },
                  context.t('My Size')
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: orderBookClasses('order-book-body') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__common_APVerticalScroller_APVerticalScroller__["a" /* default */],
                {
                  ref: this.sellScroller,
                  restPosition: 'bottom',
                  onScrollRestChange: onScrollRestChange,
                  customClass: orderBookClasses('vertical-scroller-body', Object(__WEBPACK_IMPORTED_MODULE_6__helpers_browserHelper__["a" /* isFirefox */])() ? 'firefox' : '') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'orderbook__table-filler' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Level2DataTableComponent__["a" /* default */], {
                    quantityDecimalPlaces: this.props.convertedQuantityIncrement,
                    priceDecimalPlaces: this.props.convertedPriceIncrement,
                    selectedInstrument: selectedInstrument,
                    cancelOrders: cancelOrders,
                    onPriceClick: sellPriceClicked,
                    onQuantityClick: sellQuantityClicked,
                    level2Data: sell,
                    classModifier: 'sell',
                    fetching: fetching
                  })
                )
              ),
              CenterButton(Object.assign(Object.assign({}, this, { context: context, spread: spread }))),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__common_APVerticalScroller_APVerticalScroller__["a" /* default */],
                {
                  ref: this.buyScroller,
                  restPosition: 'top',
                  onScrollRestChange: onScrollRestChange,
                  customClass: orderBookClasses('vertical-scroller-body', Object(__WEBPACK_IMPORTED_MODULE_6__helpers_browserHelper__["a" /* isFirefox */])() ? 'firefox' : '') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Level2DataTableComponent__["a" /* default */], {
                  quantityDecimalPlaces: this.props.convertedQuantityIncrement,
                  priceDecimalPlaces: this.props.convertedPriceIncrement,
                  selectedInstrument: selectedInstrument,
                  cancelOrders: cancelOrders,
                  onPriceClick: buyPriceClicked,
                  onQuantityClick: buyQuantityClicked,
                  level2Data: buy,
                  classModifier: 'buy',
                  fetching: fetching
                })
              ),
              !hideBulkCancelButtons && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BulkCancelButtonsComponent_BulkCancelButtonsComponent__["a" /* default */], {
                  openOrders: openOrders,
                  buyOpenOrders: buyOpenOrders,
                  sellOpenOrders: sellOpenOrders,
                  cancelAllOrders: cancelAllOrders,
                  cancelBuyOrders: cancelBuyOrders,
                  cancelSellOrders: cancelSellOrders
                })
              )
            )
          )
        )
      );
    }
  }]);

  return OrderBookComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (OrderBookComponent);


OrderBookComponent.defaultProps = {
  hideBulkCancelButtons: false,
  level2: {
    buy: [],
    sell: [],
    short: [],
    unknown: []
  }
};

OrderBookComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APVerticalScroller_css__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__APVerticalScroller_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__APVerticalScroller_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var scrollerClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('ap-vertical-scroller');

var APVerticalScroller = function (_React$Component) {
  _inherits(APVerticalScroller, _React$Component);

  function APVerticalScroller(props) {
    _classCallCheck(this, APVerticalScroller);

    var _this = _possibleConstructorReturn(this, (APVerticalScroller.__proto__ || Object.getPrototypeOf(APVerticalScroller)).call(this, props));

    _this.resetUserScrolled = function () {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      _this.userScrolled = false;
      callback();
    };

    _this.userScrolled = false;

    _this.handleUserScrolled = function () {
      if (_this.state.isAtRest) return _this.userScrolled = false;
      _this.userScrolled = true;
    };

    _this.state = {
      isAtRest: true
    };

    _this.handleOnScroll = _this.handleOnScroll.bind(_this);
    return _this;
  }

  _createClass(APVerticalScroller, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToRest();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var descendantCount = this.getDescendantCount(this, 4);
      if (descendantCount !== this.descendantCount) {
        // handle change
        this.descendantCount = descendantCount;
        if (this.state.isAtRest) {
          this.scrollToRest();
        }
      }
      if (this.state.isAtRest) {
        this.resetUserScrolled();
      }
    }
  }, {
    key: 'getDescendantCount',
    value: function getDescendantCount(item, levels) {
      var _this2 = this;

      if (levels <= 0 || !item || !item.props || !item.props.children) return 0;
      var children = item.props.children;
      if (Array.isArray(children)) {
        if (levels > 1) {
          return children.reduce(function (acc, curr) {
            return acc + 1 + _this2.getDescendantCount(curr, levels - 1);
          }, 0);
        } else {
          return children.length;
        }
      } else {
        if (levels > 1) {
          return 1 + this.getDescendantCount(children, levels - 1);
        } else {
          return 1;
        }
      }
    }
  }, {
    key: 'handleOnScroll',
    value: function handleOnScroll(event) {
      if (!this.el) {
        return;
      }

      this.handleUserScrolled();

      var clientHeight = this.el.clientHeight;
      var scrollHeight = this.el.scrollHeight;
      var newScroll = event.currentTarget.scrollTop;
      var scrollTop = newScroll;
      var scrollBottom = scrollHeight - clientHeight - newScroll;
      var isAtRestPrev = this.state.isAtRest;
      var isAtRest = this.props.restPosition === 'top' && scrollTop <= 0 || this.props.restPosition === 'bottom' && scrollBottom <= 0;

      this.setState({ isAtRest: isAtRest });

      if (isAtRestPrev !== isAtRest) {
        // call event handlers
        if (this.props.onScrollRestChange) {
          this.props.onScrollRestChange(isAtRest);
        }
      }
    }
  }, {
    key: 'getIsAtRest',
    value: function getIsAtRest() {
      return this.state.isAtRest;
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(value, animate) {
      if (this.el) {
        if (animate) {
          this.scrollToAnimate(this.el, value, 200);
        } else {
          this.el.scrollTop = value;
        }
      }
    }
  }, {
    key: 'scrollToRest',
    value: function scrollToRest(animate) {
      if (!this.userScrolled || this.state.isAtRest) {
        if (this.props.restPosition !== 'bottom') {
          // default to top
          this.scrollTo(0, animate);
        } else {
          // bottom
          if (this.el) {
            this.scrollTo(this.el.scrollHeight, animate);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          styleName = _props.styleName,
          restPosition = _props.restPosition,
          onScrollRestChange = _props.onScrollRestChange,
          customClass = _props.customClass,
          otherProps = _objectWithoutProperties(_props, ['children', 'styleName', 'restPosition', 'onScrollRestChange', 'customClass']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        Object.assign({
          ref: function ref(el) {
            return _this3.el = el;
          },
          className: scrollerClasses(null, this.state.isAtRest ? 'at-rest' : null) + ' ' + customClass,
          onScroll: this.handleOnScroll
        }, otherProps),
        children
      );
    }

    // animation from https://codepen.io/rebosante/pen/eENYBv

  }, {
    key: 'scrollToAnimate',
    value: function scrollToAnimate(element, to, duration) {
      var _this4 = this;

      var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
      var animateScroll = function animateScroll() {
        currentTime += increment;
        var val = _this4.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }

    //t = current time
    //b = start value
    //c = change in value
    //d = duration

  }, {
    key: 'easeInOutQuad',
    value: function easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }
  }]);

  return APVerticalScroller;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

APVerticalScroller.propTypes = {
  restPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onScrollRestChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (APVerticalScroller);

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_CancelAPButton__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkCancelButtonsComponent_css__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BulkCancelButtonsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BulkCancelButtonsComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('bulk-cancel-buttons');

var BulkCancelButtonsComponent = function BulkCancelButtonsComponent(props, context) {
  var openOrders = props.openOrders,
      buyOpenOrders = props.buyOpenOrders,
      sellOpenOrders = props.sellOpenOrders,
      cancelAllOrders = props.cancelAllOrders,
      cancelBuyOrders = props.cancelBuyOrders,
      cancelSellOrders = props.cancelSellOrders;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: baseClasses('label') },
      context.t('Cancel:')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_CancelAPButton__["a" /* default */], {
      customClass: baseClasses(),
      text: context.t('Sells'),
      disabled: sellOpenOrders.length === 0,
      onClick: cancelSellOrders
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_CancelAPButton__["a" /* default */], {
      customClass: baseClasses(),
      text: context.t('Buys'),
      disabled: buyOpenOrders.length === 0,
      onClick: cancelBuyOrders
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_CancelAPButton__["a" /* default */], {
      customClass: baseClasses(),
      text: context.t('All'),
      disabled: openOrders.length === 0,
      onClick: cancelAllOrders
    })
  );
};

BulkCancelButtonsComponent.propTypes = {
  cancelAllOrders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cancelBuyOrders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cancelSellOrders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

BulkCancelButtonsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BulkCancelButtonsComponent);

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_PaddedDecimal_PaddedDecimal__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_browserHelper__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CancelAPButton__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Spinner_Spinner__ = __webpack_require__(24);








var orderBookClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('orderbook');
var flexTable = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('flex-table');
var flexTableColumn = flexTable('column');
var cancelClassName = flexTableColumn + ' ' + orderBookClasses('cancel-btn');

var Level2DataTableComponent = function Level2DataTableComponent(props) {
  var cancelOrders = props.cancelOrders,
      onPriceClick = props.onPriceClick,
      onQuantityClick = props.onQuantityClick,
      level2Data = props.level2Data,
      classModifier = props.classModifier,
      fetching = props.fetching;


  var rowClassName = flexTable('row') + ' ' + orderBookClasses('order-row', classModifier);
  var priceClassName = flexTableColumn + ' ' + orderBookClasses('table-price', classModifier);
  var quantityClassName = flexTableColumn + ' ' + orderBookClasses('table-qty', classModifier);
  var mySizeClassName = flexTableColumn + ' ' + orderBookClasses('table-my-size', Object(__WEBPACK_IMPORTED_MODULE_3__helpers_browserHelper__["a" /* isFirefox */])() ? 'firefox' : '');

  if (fetching) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Spinner_Spinner__["a" /* default */], { customClass: orderBookClasses, classModifiers: classModifier });
  } else {
    return level2Data.map(function (data, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: data.Price, className: rowClassName },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            'data-price': data.Price,
            onClick: onPriceClick,
            className: priceClassName },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_PaddedDecimal_PaddedDecimal__["a" /* default */], {
            bemMod: classModifier,
            value: data.Price,
            decimals: props.priceDecimalPlaces
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            'data-quantity': data.Quantity,
            'data-index': index,
            onClick: onQuantityClick,
            className: quantityClassName },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_PaddedDecimal_PaddedDecimal__["a" /* default */], {
            value: data.Quantity,
            decimals: props.quantityDecimalPlaces
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: mySizeClassName },
          data.MySize && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_PaddedDecimal_PaddedDecimal__["a" /* default */], {
              value: data.MySize,
              decimals: props.quantityDecimalPlaces
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cancelClassName },
          data.MySize && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_CancelAPButton__["a" /* default */], {
            onClick: function onClick() {
              if (data.OrderIds.length) {
                cancelOrders(data.OrderIds);
              } else {
                cancelOrders([data.OrderId]);
              }
            },
            text: '',
            customClass: orderBookClasses()
          })
        )
      );
    });
  }
};

Level2DataTableComponent.propTypes = {
  cancelOrders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onPriceClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onQuantityClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  level2Data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  classModifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Level2DataTableComponent);

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApexChartComponent__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);







var locale = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].global.locale;


var mapStateToProps = function mapStateToProps(state) {
  var tickers = state.tickers,
      apexCore = state.apexCore;
  var level1 = apexCore.level1,
      level2 = apexCore.level2;


  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var selectedInstrumentId = selectedInstrument.InstrumentId;

  var marketPrice = selectedInstrumentId && level1[selectedInstrument.InstrumentId] ? level1[selectedInstrument.InstrumentId].LastTradedPx : 0;

  return {
    precision: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement),
    locale: locale,
    chartData: { level2: level2, tickers: tickers, marketPrice: marketPrice }
  };
};

var mapDispatchToProps = {
  changeTickersInterval: __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__["e" /* changeTickersInterval */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ApexChartComponent__["a" /* default */]));

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_chart_react__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_chart_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_apex_chart_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssVarHelper__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_chart_react_lib_chart_style_css__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_chart_react_lib_chart_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_apex_chart_react_lib_chart_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PriceChart_css__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PriceChart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__PriceChart_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');
var priceChartComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('price-chart');

var PriceChartComponent = function (_React$Component) {
  _inherits(PriceChartComponent, _React$Component);

  function PriceChartComponent() {
    _classCallCheck(this, PriceChartComponent);

    return _possibleConstructorReturn(this, (PriceChartComponent.__proto__ || Object.getPrototypeOf(PriceChartComponent)).apply(this, arguments));
  }

  _createClass(PriceChartComponent, [{
    key: 'renderChart',
    value: function renderChart() {
      var _props = this.props,
          chartData = _props.chartData,
          changeTickersInterval = _props.changeTickersInterval,
          locale = _props.locale;


      this.chartDataSubject = new __WEBPACK_IMPORTED_MODULE_3_rxjs__["BehaviorSubject"](chartData);

      var chartConfig = {
        chartDataSubject: this.chartDataSubject,
        changeTickersInterval: changeTickersInterval,
        currency_character: '',
        locale: locale,
        time_intervals: this.getTimeIntervalsConfig(),
        price_history: this.getPriceHistoryConfig(),
        volume_history: this.getVolumeHistoryConfig(),
        range_selector: this.getRangeSelectorConfig(),
        date_format_months: [this.context.t('Jan', {}, 'January'), this.context.t('Feb', {}, 'February'), this.context.t('Mar', {}, 'March'), this.context.t('Apr', {}, 'April'), this.context.t('May', {}, 'May (the month)'), this.context.t('Jun', {}, 'June'), this.context.t('Jul', {}, 'July'), this.context.t('Aug', {}, 'August'), this.context.t('Sep', {}, 'September'), this.context.t('Oct', {}, 'October'), this.context.t('Nov', {}, 'November'), this.context.t('Dec', {}, 'December')]
      };
      this.chart = new __WEBPACK_IMPORTED_MODULE_2_apex_chart_react___default.a('apex-chart', chartConfig);
      this.chart.DrawChart();
    }
  }, {
    key: 'getTimeIntervalsConfig',
    value: function getTimeIntervalsConfig() {
      return [{
        label: '5m',
        seconds: 300
      }, {
        label: '15m',
        seconds: 900
      }, {
        label: '30m',
        seconds: 1800
      }, {
        label: '1h',
        seconds: 3600
      }, {
        label: '1d',
        seconds: 86400
      }];
    }
  }, {
    key: 'getPriceHistoryConfig',
    value: function getPriceHistoryConfig() {
      return {
        font_size: 10,
        font_face: this.cssVariable('--font__typeface'),
        border_primary_color: this.cssVariable('--chart__border-color-primary'),
        border_secondary_color: this.cssVariable('--chart__border-color-secondary'),
        background_color: this.cssVariable('--secondary__bg-color'),
        bullish_color: this.cssVariable('--chart__bullish-color'),
        bearish_color: this.cssVariable('--chart__bearish-color'),
        price_line_color: this.cssVariable('--chart__price-line-color'),
        sma_line_color: this.cssVariable('--chart__sma-line'),
        ema_line_color: this.cssVariable('--chart__ema-line-color'),
        bollinger_band_upper_line_color: this.cssVariable('--chart__bollinger-band-upper-color'),
        bollinger_band_lower_line_color: this.cssVariable('--chart__bollinger-band-lower-color'),
        market_price_line_color: this.cssVariable('--chart__market-price-line-color'),
        market_price_label_color: this.cssVariable('--chart__market-price-label-color'),
        market_price_background_color: this.cssVariable('--chart__market-price-bg-color'),
        x_label_color: this.cssVariable('--font__color-secondary'),
        y_label_color: this.cssVariable('--font__color-secondary'),
        info_height: 30,
        info_precision: this.props.precision,
        y_label_width: 30,
        y_label_precision: this.props.precision,
        x_label_height: 30,
        x_label_precision: this.props.precision,
        info_labels: [this.context.t('Price'), this.context.t('Open'), this.context.t('Close'), this.context.t('High'), this.context.t('Low'), this.context.t('Volume')],
        use_bg_grid_lines: true,
        grid_lines_dashed: false,
        grid_lines_color: this.cssVariable('--table__row-separator-color')
      };
    }
  }, {
    key: 'getVolumeHistoryConfig',
    value: function getVolumeHistoryConfig() {
      return {
        font_size: 10,
        font_face: this.cssVariable('--font__typeface'),
        border_primary_color: this.cssVariable('--chart__border-color-primary'),
        border_secondary_color: this.cssVariable('--chart__row-separator-color'),
        background_color: this.cssVariable('--secondary__bg-color'),
        bullish_color: this.cssVariable('--chart__volume-bullish-color'),
        bearish_color: this.cssVariable('--chart__volume-bearish-color'),
        x_label_color: this.cssVariable('--font__color-secondary'),
        y_label_color: this.cssVariable('--font__color-secondary'),
        y_label_width: 30,
        y_label_precision: this.props.precision,
        x_label_height: 2,
        x_label_precision: this.props.precision
      };
    }
  }, {
    key: 'getRangeSelectorConfig',
    value: function getRangeSelectorConfig() {
      return {
        font_size: 10,
        font_face: this.cssVariable('--font__typeface'),
        border_primary_color: this.cssVariable('--chart__border-color-primary'),
        border_secondary_color: this.cssVariable('--chart__row-separator-color'),
        background_color: this.cssVariable('--secondary__bg-color'),
        market_price_line_color: this.cssVariable('--font__typeface'),
        market_price_label_color: this.cssVariable('--font__typeface'),
        price_line_color: this.cssVariable('--chart__price-line-color'),
        range_selection_color: this.cssVariable('--chart__range-selection-color'),
        x_label_color: this.cssVariable('--font__color-secondary'),
        y_label_color: this.cssVariable('--font__color-secondary'),
        y_label_width: 0,
        y_label_precision: this.props.precision,
        x_label_height: 22,
        x_label_precision: this.props.precision
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.cssVariable = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssVarHelper__["a" /* getCSSVar */])();
      this.renderChart();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.chartData !== this.props.chartData) {
        this.chartDataSubject.next(this.props.chartData);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.chart) {
        this.chart.DestroyChart();
        this.chart = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: tradeComponentClasses() + ' ' + priceChartComponentClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          id: 'apex-chart',
          className: '' + priceChartComponentClasses('chart')
        })
      );
    }
  }]);

  return PriceChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PriceChartComponent.propTypes = {
  precision: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

PriceChartComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PriceChartComponent);

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__(11);
var rxSubscriber_1 = __webpack_require__(269);
var Observer_1 = __webpack_require__(672);
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var bindCallback_1 = __webpack_require__(1591);
Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BoundCallbackObservable_1 = __webpack_require__(1592);
exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var AsyncSubject_1 = __webpack_require__(272);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var BoundCallbackObservable = (function (_super) {
    __extends(BoundCallbackObservable, _super);
    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */
    /**
     * Converts a callback API to a function that returns an Observable.
     *
     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
     * it will return a function `g` that when called as `g(x)` will output an
     * Observable.</span>
     *
     * `bindCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, the
     * last parameter must be a callback function that `func` calls when it is
     * done.
     *
     * The output of `bindCallback` is a function that takes the same parameters
     * as `func`, except the last one (the callback). When the output function
     * is called with arguments it will return an Observable. If function `func`
     * calls its callback with one argument the Observable will emit that value.
     * If on the other hand the callback is called with multiple values the resulting
     * Observable will emit an array with said values as arguments.
     *
     * It is very important to remember that input function `func` is not called
     * when the output function is, but rather when the Observable returned by the output
     * function is subscribed. This means if `func` makes an AJAX request, that request
     * will be made every time someone subscribes to the resulting Observable, but not before.
     *
     * Optionally, a selector function can be passed to `bindObservable`. The selector function
     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
     * Even though by default multiple arguments passed to callback appear in the stream as an array
     * the selector function will be called with arguments directly, just as the callback would.
     * This means you can imagine the default selector (when one is not provided explicitly)
     * as a function that aggregates all its arguments into an array, or simply returns first argument
     * if there is only one.
     *
     * The last optional parameter - {@link Scheduler} - can be used to control when the call
     * to `func` happens after someone subscribes to Observable, as well as when results
     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
     * and call `subscribe` on the output Observable all function calls that are currently executing
     * will end before `func` is invoked.
     *
     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
     * In particular, if the callback is called synchronously the subscription of the resulting Observable
     * will call the `next` function synchronously as well.  If you want to defer that call,
     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
     *
     * Note that the Observable created by the output function will always emit a single value
     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
     * calls will not appear in the stream. If you need to listen for multiple calls,
     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
     *
     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
     * will be the context that the output function has at call time. In particular, if `func`
     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
     * it is recommended that the context of the output function is set to that object as well.
     *
     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
     * provides convenient error handling and probably is a better choice.
     * `bindCallback` will treat such functions the same as any other and error parameters
     * (whether passed or not) will always be interpreted as regular callback argument.
     *
     *
     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
     * // Suppose we have jQuery.getJSON('/my/url', callback)
     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
     * var result = getJSONAsObservable('/my/url');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Receive an array of arguments passed to a callback</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 5
     *   console.log(b); // 'some string'
     *   console.log(c); // {someProperty: 'someValue'}
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
     * boundSomeFunction().subscribe(values => {
     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
     * });
     *
     *
     * @example <caption>Use bindCallback with a selector function</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 'a'
     *   console.log(b); // 'b'
     *   console.log(c); // 'c'
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
     * boundSomeFunction().subscribe(value => {
     *   console.log(value) // 'abc'
     * });
     *
     *
     * @example <caption>Compare behaviour with and without async Scheduler</caption>
     * function iCallMyCallbackSynchronously(cb) {
     *   cb();
     * }
     *
     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
     *
     * boundSyncFn().subscribe(() => console.log('I was sync!'));
     * boundAsyncFn().subscribe(() => console.log('I was async!'));
     * console.log('This happened...');
     *
     * // Logs:
     * // I was sync!
     * // This happened...
     * // I was async!
     *
     *
     * @example <caption>Use bindCallback on an object method</caption>
     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
     * .subscribe(subscriber);
     *
     *
     * @see {@link bindNodeCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func A function with a callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps them to a value that is emitted on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the callback would deliver.
     * @static true
     * @name bindCallback
     * @owner Observable
     */
    BoundCallbackObservable.create = function (func, selector, scheduler) {
        if (selector === void 0) { selector = undefined; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return new BoundCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundCallbackObservable.prototype._subscribe = function (subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    if (selector) {
                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === errorObject_1.errorObject) {
                            subject.error(errorObject_1.errorObject.e);
                        }
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    }
                    else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            return subject.subscribe(subscriber);
        }
        else {
            return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
        }
    };
    BoundCallbackObservable.dispatch = function (state) {
        var self = this;
        var source = state.source, subscriber = state.subscriber, context = state.context;
        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new AsyncSubject_1.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    innerArgs[_i - 0] = arguments[_i];
                }
                var source = handlerFn.source;
                var selector = source.selector, subject = source.subject;
                if (selector) {
                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === errorObject_1.errorObject) {
                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                    }
                    else {
                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                    }
                }
                else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === errorObject_1.errorObject) {
                subject.error(errorObject_1.errorObject.e);
            }
        }
        self.add(subject.subscribe(subscriber));
    };
    return BoundCallbackObservable;
}(Observable_1.Observable));
exports.BoundCallbackObservable = BoundCallbackObservable;
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=BoundCallbackObservable.js.map

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var bindNodeCallback_1 = __webpack_require__(1594);
Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BoundNodeCallbackObservable_1 = __webpack_require__(1595);
exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var AsyncSubject_1 = __webpack_require__(272);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var BoundNodeCallbackObservable = (function (_super) {
    __extends(BoundNodeCallbackObservable, _super);
    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */
    /**
     * Converts a Node.js-style callback API to a function that returns an
     * Observable.
     *
     * <span class="informal">It's just like {@link bindCallback}, but the
     * callback is expected to be of type `callback(error, result)`.</span>
     *
     * `bindNodeCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done. The callback function is expected to follow Node.js conventions,
     * where the first argument to the callback is an error object, signaling
     * whether call was successful. If that object is passed to callback, it means
     * something went wrong.
     *
     * The output of `bindNodeCallback` is a function that takes the same
     * parameters as `func`, except the last one (the callback). When the output
     * function is called with arguments, it will return an Observable.
     * If `func` calls its callback with error parameter present, Observable will
     * error with that value as well. If error parameter is not passed, Observable will emit
     * second parameter. If there are more parameters (third and so on),
     * Observable will emit an array with all arguments, except first error argument.
     *
     * Optionally `bindNodeCallback` accepts selector function, which allows you to
     * make resulting Observable emit value computed by selector, instead of regular
     * callback arguments. It works similarly to {@link bindCallback} selector, but
     * Node.js-style error argument will never be passed to that function.
     *
     * Note that `func` will not be called at the same time output function is,
     * but rather whenever resulting Observable is subscribed. By default call to
     * `func` will happen synchronously after subscription, but that can be changed
     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
     * can also control when values from callback will be emitted by Observable.
     * To find out more, check out documentation for {@link bindCallback}, where
     * Scheduler works exactly the same.
     *
     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
     * of returned function, when it is called.
     *
     * After Observable emits value, it will complete immediately. This means
     * even if `func` calls callback again, values from second and consecutive
     * calls will never appear on the stream. If you need to handle functions
     * that call callbacks multiple times, check out {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
     * "Node.js-style" callbacks are just a convention, so if you write for
     * browsers or any other environment and API you use implements that callback style,
     * `bindNodeCallback` can be safely used on that API functions as well.
     *
     * Remember that Error object passed to callback does not have to be an instance
     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
     * Error parameter of callback function is interpreted as "present", when value
     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
     * string or boolean `true`. In all of these cases resulting Observable would error
     * with that value. This means usually regular style callbacks will fail very often when
     * `bindNodeCallback` is used. If your Observable errors much more often then you
     * would expect, check if callback really is called in Node.js-style and, if not,
     * switch to {@link bindCallback} instead.
     *
     * Note that even if error parameter is technically present in callback, but its value
     * is falsy, it still won't appear in array emitted by Observable or in selector function.
     *
     *
     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
     * import * as fs from 'fs';
     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Use on function calling callback with multiple arguments</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // null
     *   console.log(a); // 5
     *   console.log(b); // "some string"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // [5, "some string"]
     * });
     *
     *
     * @example <caption>Use with selector function</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // undefined
     *   console.log(a); // "abc"
     *   console.log(b); // "DEF"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // "abcDEF"
     * });
     *
     *
     * @example <caption>Use on function calling callback in regular style</caption>
     * someFunction(a => {
     *   console.log(a); // 5
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(
     *   value => {}             // never gets called
     *   err => console.log(err) // 5
     *);
     *
     *
     * @see {@link bindCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a Node.js-style callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the Node.js callback would
     * deliver.
     * @static true
     * @name bindNodeCallback
     * @owner Observable
     */
    BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
        if (selector === void 0) { selector = undefined; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    var err = innerArgs.shift();
                    if (err) {
                        subject.error(err);
                    }
                    else if (selector) {
                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === errorObject_1.errorObject) {
                            subject.error(errorObject_1.errorObject.e);
                        }
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    }
                    else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            return subject.subscribe(subscriber);
        }
        else {
            return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
        }
    };
    return BoundNodeCallbackObservable;
}(Observable_1.Observable));
exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
function dispatch(state) {
    var self = this;
    var source = state.source, subscriber = state.subscriber, context = state.context;
    // XXX: cast to `any` to access to the private field in `source`.
    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
    var subject = source.subject;
    if (!subject) {
        subject = source.subject = new AsyncSubject_1.AsyncSubject();
        var handler = function handlerFn() {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i - 0] = arguments[_i];
            }
            var source = handlerFn.source;
            var selector = source.selector, subject = source.subject;
            var err = innerArgs.shift();
            if (err) {
                self.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else if (selector) {
                var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                if (result_2 === errorObject_1.errorObject) {
                    self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                }
                else {
                    self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                }
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        // use named function to pass values in without closure
        handler.source = source;
        var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
        if (result === errorObject_1.errorObject) {
            self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
        }
    }
    self.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=BoundNodeCallbackObservable.js.map

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var combineLatest_1 = __webpack_require__(1597);
Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isScheduler_1 = __webpack_require__(72);
var isArray_1 = __webpack_require__(82);
var ArrayObservable_1 = __webpack_require__(105);
var combineLatest_1 = __webpack_require__(273);
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @static true
 * @name combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = null;
    var scheduler = null;
    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
}
exports.combineLatest = combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(11);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
exports.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var concat_1 = __webpack_require__(187);
Observable_1.Observable.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(56);
var Observable_1 = __webpack_require__(4);
var iterator_1 = __webpack_require__(186);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable = (function (_super) {
    __extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) {
            throw new Error('iterator cannot be null.');
        }
        this.iterator = getIterator(iterator);
    }
    IteratorObservable.create = function (iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function (state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') {
                iterator.return();
            }
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) {
            return scheduler.schedule(IteratorObservable.dispatch, 0, {
                index: index, iterator: iterator, subscriber: subscriber
            });
        }
        else {
            do {
                var result = iterator.next();
                if (result.done) {
                    subscriber.complete();
                    break;
                }
                else {
                    subscriber.next(result.value);
                }
                if (subscriber.closed) {
                    if (typeof iterator.return === 'function') {
                        iterator.return();
                    }
                    break;
                }
            } while (true);
        }
    };
    return IteratorObservable;
}(Observable_1.Observable));
exports.IteratorObservable = IteratorObservable;
var StringIterator = (function () {
    function StringIterator(str, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = str.length; }
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
    StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}());
var ArrayIterator = (function () {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = toLength(arr); }
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
    ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}());
function getIterator(obj) {
    var i = obj[iterator_1.iterator];
    if (!i && typeof obj === 'string') {
        return new StringIterator(obj);
    }
    if (!i && obj.length !== undefined) {
        return new ArrayIterator(obj);
    }
    if (!i) {
        throw new TypeError('object is not iterable');
    }
    return obj[iterator_1.iterator]();
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) {
        return 0;
    }
    if (len === 0 || !numberIsFinite(len)) {
        return len;
    }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) {
        return 0;
    }
    if (len > maxSafeInteger) {
        return maxSafeInteger;
    }
    return len;
}
function numberIsFinite(value) {
    return typeof value === 'number' && root_1.root.isFinite(value);
}
function sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) {
        return valueAsNumber;
    }
    if (isNaN(valueAsNumber)) {
        return valueAsNumber;
    }
    return valueAsNumber < 0 ? -1 : 1;
}
//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var ScalarObservable_1 = __webpack_require__(385);
var EmptyObservable_1 = __webpack_require__(106);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable = (function (_super) {
    __extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function (arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (length === 1) {
            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
        }
        else {
            return new ArrayLikeObservable(arrayLike, scheduler);
        }
    };
    ArrayLikeObservable.dispatch = function (state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) {
            return;
        }
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) {
            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < length && !subscriber.closed; i++) {
                subscriber.next(arrayLike[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}(Observable_1.Observable));
exports.ArrayLikeObservable = ArrayLikeObservable;
//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var defer_1 = __webpack_require__(1603);
Observable_1.Observable.defer = defer_1.defer;
//# sourceMappingURL=defer.js.map

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DeferObservable_1 = __webpack_require__(1604);
exports.defer = DeferObservable_1.DeferObservable.create;
//# sourceMappingURL=defer.js.map

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var subscribeToResult_1 = __webpack_require__(18);
var OuterSubscriber_1 = __webpack_require__(17);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var DeferObservable = (function (_super) {
    __extends(DeferObservable, _super);
    function DeferObservable(observableFactory) {
        _super.call(this);
        this.observableFactory = observableFactory;
    }
    /**
     * Creates an Observable that, on subscribe, calls an Observable factory to
     * make an Observable for each new Observer.
     *
     * <span class="informal">Creates the Observable lazily, that is, only when it
     * is subscribed.
     * </span>
     *
     * <img src="./img/defer.png" width="100%">
     *
     * `defer` allows you to create the Observable only when the Observer
     * subscribes, and create a fresh Observable for each Observer. It waits until
     * an Observer subscribes to it, and then it generates an Observable,
     * typically with an Observable factory function. It does this afresh for each
     * subscriber, so although each subscriber may think it is subscribing to the
     * same Observable, in fact each subscriber gets its own individual
     * Observable.
     *
     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
     * var clicksOrInterval = Rx.Observable.defer(function () {
     *   if (Math.random() > 0.5) {
     *     return Rx.Observable.fromEvent(document, 'click');
     *   } else {
     *     return Rx.Observable.interval(1000);
     *   }
     * });
     * clicksOrInterval.subscribe(x => console.log(x));
     *
     * // Results in the following behavior:
     * // If the result of Math.random() is greater than 0.5 it will listen
     * // for clicks anywhere on the "document"; when document is clicked it
     * // will log a MouseEvent object to the console. If the result is less
     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
     *
     * @see {@link create}
     *
     * @param {function(): SubscribableOrPromise} observableFactory The Observable
     * factory function to invoke for each Observer that subscribes to the output
     * Observable. May also return a Promise, which will be converted on the fly
     * to an Observable.
     * @return {Observable} An Observable whose Observers' subscriptions trigger
     * an invocation of the given Observable factory function.
     * @static true
     * @name defer
     * @owner Observable
     */
    DeferObservable.create = function (observableFactory) {
        return new DeferObservable(observableFactory);
    };
    /** @deprecated internal use only */ DeferObservable.prototype._subscribe = function (subscriber) {
        return new DeferSubscriber(subscriber, this.observableFactory);
    };
    return DeferObservable;
}(Observable_1.Observable));
exports.DeferObservable = DeferObservable;
var DeferSubscriber = (function (_super) {
    __extends(DeferSubscriber, _super);
    function DeferSubscriber(destination, factory) {
        _super.call(this, destination);
        this.factory = factory;
        this.tryDefer();
    }
    DeferSubscriber.prototype.tryDefer = function () {
        try {
            this._callFactory();
        }
        catch (err) {
            this._error(err);
        }
    };
    DeferSubscriber.prototype._callFactory = function () {
        var result = this.factory();
        if (result) {
            this.add(subscribeToResult_1.subscribeToResult(this, result));
        }
    };
    return DeferSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=DeferObservable.js.map

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var empty_1 = __webpack_require__(1606);
Observable_1.Observable.empty = empty_1.empty;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var EmptyObservable_1 = __webpack_require__(106);
exports.empty = EmptyObservable_1.EmptyObservable.create;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var forkJoin_1 = __webpack_require__(1608);
Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ForkJoinObservable_1 = __webpack_require__(1609);
exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var EmptyObservable_1 = __webpack_require__(106);
var isArray_1 = __webpack_require__(82);
var subscribeToResult_1 = __webpack_require__(18);
var OuterSubscriber_1 = __webpack_require__(17);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ForkJoinObservable = (function (_super) {
    __extends(ForkJoinObservable, _super);
    function ForkJoinObservable(sources, resultSelector) {
        _super.call(this);
        this.sources = sources;
        this.resultSelector = resultSelector;
    }
    /* tslint:enable:max-line-length */
    /**
     * Joins last values emitted by passed Observables.
     *
     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
     *
     * <img src="./img/forkJoin.png" width="100%">
     *
     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
     * or directly as arguments. If no input Observables are provided, resulting stream will complete
     * immediately.
     *
     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
     * array will have `n` values, where first value is the last thing emitted by the first Observable,
     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
     * not emit more than once and it will complete after that. If you need to emit combined values not only
     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
     * or {@link zip} instead.
     *
     * In order for resulting array to have the same length as the number of input Observables, whenever any of
     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
     * and it will not emit anything either, even if it already has some last values from other Observables.
     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
     * unless at any point some other Observable completes without emitting value, which brings us back to
     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
     * have to emit something at least once and complete.
     *
     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
     * will be immediately unsubscribed.
     *
     * Optionally `forkJoin` accepts project function, that will be called with values which normally
     * would land in emitted array. Whatever is returned by project function, will appear in output
     * Observable instead. This means that default project can be thought of as a function that takes
     * all its arguments and puts them into an array. Note that project function will be called only
     * when output Observable is supposed to emit a result.
     *
     * @example <caption>Use forkJoin with operator emitting immediately</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.of(1, 2, 3, 4),
     *   Rx.Observable.of(5, 6, 7, 8)
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [4, 8]
     * // "This is how it ends!"
     *
     *
     * @example <caption>Use forkJoin with operator emitting after some time</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [2, 3] after 3 seconds
     * // "This is how it ends!" immediately after
     *
     *
     * @example <caption>Use forkJoin with project function</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
     *   (n, m) => n + m
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // 5 after 3 seconds
     * // "This is how it ends!" immediately after
     *
     * @see {@link combineLatest}
     * @see {@link zip}
     *
     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
     * passed directly to the operator.
     * @param {function} [project] Function that takes values emitted by input Observables and returns value
     * that will appear in resulting Observable instead of default array.
     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
     * or value from project function.
     * @static true
     * @name forkJoin
     * @owner Observable
     */
    ForkJoinObservable.create = function () {
        var sources = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            sources[_i - 0] = arguments[_i];
        }
        if (sources === null || arguments.length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        var resultSelector = null;
        if (typeof sources[sources.length - 1] === 'function') {
            resultSelector = sources.pop();
        }
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
        if (sources.length === 1 && isArray_1.isArray(sources[0])) {
            sources = sources[0];
        }
        if (sources.length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        return new ForkJoinObservable(sources, resultSelector);
    };
    /** @deprecated internal use only */ ForkJoinObservable.prototype._subscribe = function (subscriber) {
        return new ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
    };
    return ForkJoinObservable;
}(Observable_1.Observable));
exports.ForkJoinObservable = ForkJoinObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ForkJoinSubscriber = (function (_super) {
    __extends(ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources, resultSelector) {
        _super.call(this, destination);
        this.sources = sources;
        this.resultSelector = resultSelector;
        this.completed = 0;
        this.haveValues = 0;
        var len = sources.length;
        this.total = len;
        this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            var source = sources[i];
            var innerSubscription = subscribeToResult_1.subscribeToResult(this, source, null, i);
            if (innerSubscription) {
                innerSubscription.outerIndex = i;
                this.add(innerSubscription);
            }
        }
    }
    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
        var destination = this.destination;
        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) {
            return;
        }
        if (haveValues === len) {
            var value = resultSelector ? resultSelector.apply(this, values) : values;
            destination.next(value);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=ForkJoinObservable.js.map

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var from_1 = __webpack_require__(677);
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var fromEvent_1 = __webpack_require__(1612);
Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventObservable_1 = __webpack_require__(1613);
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var tryCatch_1 = __webpack_require__(54);
var isFunction_1 = __webpack_require__(268);
var errorObject_1 = __webpack_require__(50);
var Subscription_1 = __webpack_require__(46);
var toString = Object.prototype.toString;
function isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isNodeList(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
}
function isHTMLCollection(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
}
function isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventObservable = (function (_super) {
    __extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */
    /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node.js
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * `fromEvent` accepts as a first argument event target, which is an object with methods
     * for registering event handler functions. As a second argument it takes string that indicates
     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
     * which are described in detail below. If your event target does not match any of the ones listed,
     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
     * handler functions have different names, but they all accept a string describing event type
     * and function itself, which will be called whenever said event happens.
     *
     * Every time resulting Observable is subscribed, event handler function will be registered
     * to event target on given event type. When that event fires, value
     * passed as a first argument to registered function will be emitted by output Observable.
     * When Observable is unsubscribed, function will be unregistered from event target.
     *
     * Note that if event target calls registered function with more than one argument, second
     * and following arguments will not appear in resulting stream. In order to get access to them,
     * you can pass to `fromEvent` optional project function, which will be called with all arguments
     * passed to event handler. Output Observable will then emit value returned by project function,
     * instead of the usual value.
     *
     * Remember that event targets listed below are checked via duck typing. It means that
     * no matter what kind of object you have and no matter what environment you work in,
     * you can safely use `fromEvent` on that object if it exposes described methods (provided
     * of course they behave as was described above). So for example if Node.js library exposes
     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
     * a good choice.
     *
     * If the API you use is more callback then event handler oriented (subscribed
     * callback function fires only once and thus there is no need to manually
     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
     * instead.
     *
     * `fromEvent` supports following types of event targets:
     *
     * **DOM EventTarget**
     *
     * This is an object with `addEventListener` and `removeEventListener` methods.
     *
     * In the browser, `addEventListener` accepts - apart from event type string and event
     * handler function arguments - optional third parameter, which is either an object or boolean,
     * both used for additional configuration how and when passed function will be called. When
     * `fromEvent` is used with event target of that type, you can provide this values
     * as third parameter as well.
     *
     * **Node.js EventEmitter**
     *
     * An object with `addListener` and `removeListener` methods.
     *
     * **JQuery-style event target**
     *
     * An object with `on` and `off` methods
     *
     * **DOM NodeList**
     *
     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
     *
     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
     * it contains and install event handler function in every of them. When returned Observable
     * is unsubscribed, function will be removed from all Nodes.
     *
     * **DOM HtmlCollection**
     *
     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
     * installed and removed in each of elements.
     *
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console every time a click
     * // occurs on the document.
     *
     *
     * @example <caption>Use addEventListener with capture option</caption>
     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
     *                                                                          // which will be passed to addEventListener
     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
     *
     * clicksInDocument.subscribe(() => console.log('document'));
     * clicksInDiv.subscribe(() => console.log('div'));
     *
     * // By default events bubble UP in DOM tree, so normally
     * // when we would click on div in document
     * // "div" would be logged first and then "document".
     * // Since we specified optional `capture` option, document
     * // will catch event when it goes DOWN DOM tree, so console
     * // will log "document" and then "div".
     *
     * @see {@link bindCallback}
     * @see {@link bindNodeCallback}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOM EventTarget, Node.js
     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */
    FromEventObservable.create = function (target, eventName, options, selector) {
        if (isFunction_1.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
            for (var i = 0, len = sourceObj.length; i < len; i++) {
                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
            }
        }
        else if (isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
        }
        else if (isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function () { return source_2.off(eventName, handler); };
        }
        else if (isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
        }
        else {
            throw new TypeError('Invalid event target');
        }
        subscriber.add(new Subscription_1.Subscription(unsubscribe));
    };
    /** @deprecated internal use only */ FromEventObservable.prototype._subscribe = function (subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
            if (result === errorObject_1.errorObject) {
                subscriber.error(errorObject_1.errorObject.e);
            }
            else {
                subscriber.next(result);
            }
        } : function (e) { return subscriber.next(e); };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}(Observable_1.Observable));
exports.FromEventObservable = FromEventObservable;
//# sourceMappingURL=FromEventObservable.js.map

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var fromEventPattern_1 = __webpack_require__(1615);
Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventPatternObservable_1 = __webpack_require__(1616);
exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(268);
var Observable_1 = __webpack_require__(4);
var Subscription_1 = __webpack_require__(46);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventPatternObservable = (function (_super) {
    __extends(FromEventPatternObservable, _super);
    function FromEventPatternObservable(addHandler, removeHandler, selector) {
        _super.call(this);
        this.addHandler = addHandler;
        this.removeHandler = removeHandler;
        this.selector = selector;
    }
    /**
     * Creates an Observable from an API based on addHandler/removeHandler
     * functions.
     *
     * <span class="informal">Converts any addHandler/removeHandler API to an
     * Observable.</span>
     *
     * <img src="./img/fromEventPattern.png" width="100%">
     *
     * Creates an Observable by using the `addHandler` and `removeHandler`
     * functions to add and remove the handlers, with an optional selector
     * function to project the event arguments to a result. The `addHandler` is
     * called when the output Observable is subscribed, and `removeHandler` is
     * called when the Subscription is unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * function addClickHandler(handler) {
     *   document.addEventListener('click', handler);
     * }
     *
     * function removeClickHandler(handler) {
     *   document.removeEventListener('click', handler);
     * }
     *
     * var clicks = Rx.Observable.fromEventPattern(
     *   addClickHandler,
     *   removeClickHandler
     * );
     * clicks.subscribe(x => console.log(x));
     *
     * @see {@link from}
     * @see {@link fromEvent}
     *
     * @param {function(handler: Function): any} addHandler A function that takes
     * a `handler` function as argument and attaches it somehow to the actual
     * source of events.
     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
     * takes a `handler` function as argument and removes it in case it was
     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
     * removeHandler function will forward it.
     * @param {function(...args: any): T} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEventPattern
     * @owner Observable
     */
    FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
        return new FromEventPatternObservable(addHandler, removeHandler, selector);
    };
    /** @deprecated internal use only */ FromEventPatternObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var removeHandler = this.removeHandler;
        var handler = !!this.selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            _this._callSelector(subscriber, args);
        } : function (e) { subscriber.next(e); };
        var retValue = this._callAddHandler(handler, subscriber);
        if (!isFunction_1.isFunction(removeHandler)) {
            return;
        }
        subscriber.add(new Subscription_1.Subscription(function () {
            //TODO: determine whether or not to forward to error handler
            removeHandler(handler, retValue);
        }));
    };
    FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
        try {
            var result = this.selector.apply(this, args);
            subscriber.next(result);
        }
        catch (e) {
            subscriber.error(e);
        }
    };
    FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
        try {
            return this.addHandler(handler) || null;
        }
        catch (e) {
            errorSubscriber.error(e);
        }
    };
    return FromEventPatternObservable;
}(Observable_1.Observable));
exports.FromEventPatternObservable = FromEventPatternObservable;
//# sourceMappingURL=FromEventPatternObservable.js.map

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var fromPromise_1 = __webpack_require__(1618);
Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PromiseObservable_1 = __webpack_require__(679);
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var generate_1 = __webpack_require__(1620);
Observable_1.Observable.generate = generate_1.generate;
//# sourceMappingURL=generate.js.map

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var GenerateObservable_1 = __webpack_require__(1621);
exports.generate = GenerateObservable_1.GenerateObservable.create;
//# sourceMappingURL=generate.js.map

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var isScheduler_1 = __webpack_require__(72);
var selfSelector = function (value) { return value; };
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var GenerateObservable = (function (_super) {
    __extends(GenerateObservable, _super);
    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
        _super.call(this);
        this.initialState = initialState;
        this.condition = condition;
        this.iterate = iterate;
        this.resultSelector = resultSelector;
        this.scheduler = scheduler;
    }
    GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
        if (arguments.length == 1) {
            return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
        }
        if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
            return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
        }
        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
    };
    /** @deprecated internal use only */ GenerateObservable.prototype._subscribe = function (subscriber) {
        var state = this.initialState;
        if (this.scheduler) {
            return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
                subscriber: subscriber,
                iterate: this.iterate,
                condition: this.condition,
                resultSelector: this.resultSelector,
                state: state });
        }
        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
        } while (true);
    };
    GenerateObservable.dispatch = function (state) {
        var subscriber = state.subscriber, condition = state.condition;
        if (subscriber.closed) {
            return;
        }
        if (state.needIterate) {
            try {
                state.state = state.iterate(state.state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
        }
        else {
            state.needIterate = true;
        }
        if (condition) {
            var conditionResult = void 0;
            try {
                conditionResult = condition(state.state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
            if (!conditionResult) {
                subscriber.complete();
                return;
            }
            if (subscriber.closed) {
                return;
            }
        }
        var value;
        try {
            value = state.resultSelector(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return;
        }
        if (subscriber.closed) {
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        return this.schedule(state);
    };
    return GenerateObservable;
}(Observable_1.Observable));
exports.GenerateObservable = GenerateObservable;
//# sourceMappingURL=GenerateObservable.js.map

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var if_1 = __webpack_require__(1623);
Observable_1.Observable.if = if_1._if;
//# sourceMappingURL=if.js.map

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IfObservable_1 = __webpack_require__(1624);
exports._if = IfObservable_1.IfObservable.create;
//# sourceMappingURL=if.js.map

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var subscribeToResult_1 = __webpack_require__(18);
var OuterSubscriber_1 = __webpack_require__(17);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IfObservable = (function (_super) {
    __extends(IfObservable, _super);
    function IfObservable(condition, thenSource, elseSource) {
        _super.call(this);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
    }
    IfObservable.create = function (condition, thenSource, elseSource) {
        return new IfObservable(condition, thenSource, elseSource);
    };
    /** @deprecated internal use only */ IfObservable.prototype._subscribe = function (subscriber) {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        return new IfSubscriber(subscriber, condition, thenSource, elseSource);
    };
    return IfObservable;
}(Observable_1.Observable));
exports.IfObservable = IfObservable;
var IfSubscriber = (function (_super) {
    __extends(IfSubscriber, _super);
    function IfSubscriber(destination, condition, thenSource, elseSource) {
        _super.call(this, destination);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
        this.tryIf();
    }
    IfSubscriber.prototype.tryIf = function () {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        var result;
        try {
            result = condition();
            var source = result ? thenSource : elseSource;
            if (source) {
                this.add(subscribeToResult_1.subscribeToResult(this, source));
            }
            else {
                this._complete();
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    return IfSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=IfObservable.js.map

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var interval_1 = __webpack_require__(1626);
Observable_1.Observable.interval = interval_1.interval;
//# sourceMappingURL=interval.js.map

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IntervalObservable_1 = __webpack_require__(1627);
exports.interval = IntervalObservable_1.IntervalObservable.create;
//# sourceMappingURL=interval.js.map

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isNumeric_1 = __webpack_require__(190);
var Observable_1 = __webpack_require__(4);
var async_1 = __webpack_require__(33);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IntervalObservable = (function (_super) {
    __extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) { period = 0; }
        if (scheduler === void 0) { scheduler = async_1.async; }
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!isNumeric_1.isNumeric(period) || period < 0) {
            this.period = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            this.scheduler = async_1.async;
        }
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */
    IntervalObservable.create = function (period, scheduler) {
        if (period === void 0) { period = 0; }
        if (scheduler === void 0) { scheduler = async_1.async; }
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function (state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) {
            return;
        }
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index, subscriber: subscriber, period: period
        }));
    };
    return IntervalObservable;
}(Observable_1.Observable));
exports.IntervalObservable = IntervalObservable;
//# sourceMappingURL=IntervalObservable.js.map

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(46);
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */
var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(Subscription_1.Subscription));
exports.Action = Action;
//# sourceMappingURL=Action.js.map

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */
var Scheduler = (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var merge_1 = __webpack_require__(276);
Observable_1.Observable.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var race_1 = __webpack_require__(387);
Observable_1.Observable.race = race_1.race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var never_1 = __webpack_require__(1633);
Observable_1.Observable.never = never_1.never;
//# sourceMappingURL=never.js.map

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NeverObservable_1 = __webpack_require__(1634);
exports.never = NeverObservable_1.NeverObservable.create;
//# sourceMappingURL=never.js.map

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var noop_1 = __webpack_require__(384);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var NeverObservable = (function (_super) {
    __extends(NeverObservable, _super);
    function NeverObservable() {
        _super.call(this);
    }
    /**
     * Creates an Observable that emits no items to the Observer.
     *
     * <span class="informal">An Observable that never emits anything.</span>
     *
     * <img src="./img/never.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that emits
     * neither values nor errors nor the completion notification. It can be used
     * for testing purposes or for composing with other Observables. Please note
     * that by never emitting a complete notification, this Observable keeps the
     * subscription from being disposed automatically. Subscriptions need to be
     * manually disposed.
     *
     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
     * function info() {
     *   console.log('Will not be called');
     * }
     * var result = Rx.Observable.never().startWith(7);
     * result.subscribe(x => console.log(x), info, info);
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link of}
     * @see {@link throw}
     *
     * @return {Observable} A "never" Observable: never emits anything.
     * @static true
     * @name never
     * @owner Observable
     */
    NeverObservable.create = function () {
        return new NeverObservable();
    };
    /** @deprecated internal use only */ NeverObservable.prototype._subscribe = function (subscriber) {
        noop_1.noop();
    };
    return NeverObservable;
}(Observable_1.Observable));
exports.NeverObservable = NeverObservable;
//# sourceMappingURL=NeverObservable.js.map

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var of_1 = __webpack_require__(676);
Observable_1.Observable.of = of_1.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var onErrorResumeNext_1 = __webpack_require__(1637);
Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var onErrorResumeNext_1 = __webpack_require__(388);
exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var pairs_1 = __webpack_require__(1639);
Observable_1.Observable.pairs = pairs_1.pairs;
//# sourceMappingURL=pairs.js.map

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PairsObservable_1 = __webpack_require__(1640);
exports.pairs = PairsObservable_1.PairsObservable.create;
//# sourceMappingURL=pairs.js.map

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
function dispatch(state) {
    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
    if (index === length) {
        subscriber.complete();
        return;
    }
    var key = keys[index];
    subscriber.next([key, obj[key]]);
    state.index = index + 1;
    this.schedule(state);
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PairsObservable = (function (_super) {
    __extends(PairsObservable, _super);
    function PairsObservable(obj, scheduler) {
        _super.call(this);
        this.obj = obj;
        this.scheduler = scheduler;
        this.keys = Object.keys(obj);
    }
    /**
     * Convert an object into an observable sequence of [key, value] pairs
     * using an optional IScheduler to enumerate the object.
     *
     * @example <caption>Converts a javascript object to an Observable</caption>
     * var obj = {
     *   foo: 42,
     *   bar: 56,
     *   baz: 78
     * };
     *
     * var source = Rx.Observable.pairs(obj);
     *
     * var subscription = source.subscribe(
     *   function (x) {
     *     console.log('Next: %s', x);
     *   },
     *   function (err) {
     *     console.log('Error: %s', err);
     *   },
     *   function () {
     *     console.log('Completed');
     *   });
     *
     * @param {Object} obj The object to inspect and turn into an
     * Observable sequence.
     * @param {Scheduler} [scheduler] An optional IScheduler to run the
     * enumeration of the input sequence on.
     * @returns {(Observable<Array<string | T>>)} An observable sequence of
     * [key, value] pairs from the object.
     */
    PairsObservable.create = function (obj, scheduler) {
        return new PairsObservable(obj, scheduler);
    };
    /** @deprecated internal use only */ PairsObservable.prototype._subscribe = function (subscriber) {
        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
        var length = keys.length;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
            });
        }
        else {
            for (var idx = 0; idx < length; idx++) {
                var key = keys[idx];
                subscriber.next([key, this.obj[key]]);
            }
            subscriber.complete();
        }
    };
    return PairsObservable;
}(Observable_1.Observable));
exports.PairsObservable = PairsObservable;
//# sourceMappingURL=PairsObservable.js.map

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var range_1 = __webpack_require__(1642);
Observable_1.Observable.range = range_1.range;
//# sourceMappingURL=range.js.map

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var RangeObservable_1 = __webpack_require__(1643);
exports.range = RangeObservable_1.RangeObservable.create;
//# sourceMappingURL=range.js.map

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var RangeObservable = (function (_super) {
    __extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */
    RangeObservable.create = function (start, count, scheduler) {
        if (start === void 0) { start = 0; }
        if (count === void 0) { count = 0; }
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function (state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(RangeObservable.dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(start++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
    };
    return RangeObservable;
}(Observable_1.Observable));
exports.RangeObservable = RangeObservable;
//# sourceMappingURL=RangeObservable.js.map

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var using_1 = __webpack_require__(1645);
Observable_1.Observable.using = using_1.using;
//# sourceMappingURL=using.js.map

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UsingObservable_1 = __webpack_require__(1646);
exports.using = UsingObservable_1.UsingObservable.create;
//# sourceMappingURL=using.js.map

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var subscribeToResult_1 = __webpack_require__(18);
var OuterSubscriber_1 = __webpack_require__(17);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var UsingObservable = (function (_super) {
    __extends(UsingObservable, _super);
    function UsingObservable(resourceFactory, observableFactory) {
        _super.call(this);
        this.resourceFactory = resourceFactory;
        this.observableFactory = observableFactory;
    }
    UsingObservable.create = function (resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    /** @deprecated internal use only */ UsingObservable.prototype._subscribe = function (subscriber) {
        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
        var resource;
        try {
            resource = resourceFactory();
            return new UsingSubscriber(subscriber, resource, observableFactory);
        }
        catch (err) {
            subscriber.error(err);
        }
    };
    return UsingObservable;
}(Observable_1.Observable));
exports.UsingObservable = UsingObservable;
var UsingSubscriber = (function (_super) {
    __extends(UsingSubscriber, _super);
    function UsingSubscriber(destination, resource, observableFactory) {
        _super.call(this, destination);
        this.resource = resource;
        this.observableFactory = observableFactory;
        destination.add(resource);
        this.tryUse();
    }
    UsingSubscriber.prototype.tryUse = function () {
        try {
            var source = this.observableFactory.call(this, this.resource);
            if (source) {
                this.add(subscribeToResult_1.subscribeToResult(this, source));
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    return UsingSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=UsingObservable.js.map

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var throw_1 = __webpack_require__(1648);
Observable_1.Observable.throw = throw_1._throw;
//# sourceMappingURL=throw.js.map

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ErrorObservable_1 = __webpack_require__(1649);
exports._throw = ErrorObservable_1.ErrorObservable.create;
//# sourceMappingURL=throw.js.map

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ErrorObservable = (function (_super) {
    __extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */
    ErrorObservable.create = function (error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function (arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function (subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) {
            return scheduler.schedule(ErrorObservable.dispatch, 0, {
                error: error, subscriber: subscriber
            });
        }
        else {
            subscriber.error(error);
        }
    };
    return ErrorObservable;
}(Observable_1.Observable));
exports.ErrorObservable = ErrorObservable;
//# sourceMappingURL=ErrorObservable.js.map

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var timer_1 = __webpack_require__(681);
Observable_1.Observable.timer = timer_1.timer;
//# sourceMappingURL=timer.js.map

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isNumeric_1 = __webpack_require__(190);
var Observable_1 = __webpack_require__(4);
var async_1 = __webpack_require__(33);
var isScheduler_1 = __webpack_require__(72);
var isDate_1 = __webpack_require__(277);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var TimerObservable = (function (_super) {
    __extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) { dueTime = 0; }
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if (isNumeric_1.isNumeric(period)) {
            this.period = Number(period) < 1 && 1 || Number(period);
        }
        else if (isScheduler_1.isScheduler(period)) {
            scheduler = period;
        }
        if (!isScheduler_1.isScheduler(scheduler)) {
            scheduler = async_1.async;
        }
        this.scheduler = scheduler;
        this.dueTime = isDate_1.isDate(dueTime) ?
            (+dueTime - this.scheduler.now()) :
            dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */
    TimerObservable.create = function (initialDelay, period, scheduler) {
        if (initialDelay === void 0) { initialDelay = 0; }
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function (state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) {
            return;
        }
        else if (period === -1) {
            return subscriber.complete();
        }
        state.index = index + 1;
        action.schedule(state, period);
    };
    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index, period: period, subscriber: subscriber
        });
    };
    return TimerObservable;
}(Observable_1.Observable));
exports.TimerObservable = TimerObservable;
//# sourceMappingURL=TimerObservable.js.map

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var zip_1 = __webpack_require__(1653);
Observable_1.Observable.zip = zip_1.zip;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__(278);
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var ajax_1 = __webpack_require__(1655);
Observable_1.Observable.ajax = ajax_1.ajax;
//# sourceMappingURL=ajax.js.map

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AjaxObservable_1 = __webpack_require__(682);
exports.ajax = AjaxObservable_1.AjaxObservable.create;
//# sourceMappingURL=ajax.js.map

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var webSocket_1 = __webpack_require__(1657);
Observable_1.Observable.webSocket = webSocket_1.webSocket;
//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var WebSocketSubject_1 = __webpack_require__(1658);
exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var Subscriber_1 = __webpack_require__(11);
var Observable_1 = __webpack_require__(4);
var Subscription_1 = __webpack_require__(46);
var root_1 = __webpack_require__(56);
var ReplaySubject_1 = __webpack_require__(279);
var tryCatch_1 = __webpack_require__(54);
var errorObject_1 = __webpack_require__(50);
var assign_1 = __webpack_require__(1661);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var WebSocketSubject = (function (_super) {
    __extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        if (urlConfigOrSource instanceof Observable_1.Observable) {
            _super.call(this, destination, urlConfigOrSource);
        }
        else {
            _super.call(this);
            this.WebSocketCtor = root_1.root.WebSocket;
            this._output = new Subject_1.Subject();
            if (typeof urlConfigOrSource === 'string') {
                this.url = urlConfigOrSource;
            }
            else {
                // WARNING: config object could override important members here.
                assign_1.assign(this, urlConfigOrSource);
            }
            if (!this.WebSocketCtor) {
                throw new Error('no WebSocket constructor can be found');
            }
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
    }
    WebSocketSubject.prototype.resultSelector = function (e) {
        return JSON.parse(e.data);
    };
    /**
     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
     *
     * @example <caption>Wraps browser WebSocket</caption>
     *
     * let socket$ = Observable.webSocket('ws://localhost:8081');
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
     *
     * import { w3cwebsocket } from 'websocket';
     *
     * let socket$ = Observable.webSocket({
     *   url: 'ws://localhost:8081',
     *   WebSocketCtor: w3cwebsocket
     * });
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
     * @return {WebSocketSubject}
     * @static true
     * @name webSocket
     * @owner Observable
     */
    WebSocketSubject.create = function (urlConfigOrSource) {
        return new WebSocketSubject(urlConfigOrSource);
    };
    WebSocketSubject.prototype.lift = function (operator) {
        var sock = new WebSocketSubject(this, this.destination);
        sock.operator = operator;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function () {
        this.socket = null;
        if (!this.source) {
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
        this._output = new Subject_1.Subject();
    };
    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new Observable_1.Observable(function (observer) {
            var result = tryCatch_1.tryCatch(subMsg)();
            if (result === errorObject_1.errorObject) {
                observer.error(errorObject_1.errorObject.e);
            }
            else {
                self.next(result);
            }
            var subscription = self.subscribe(function (x) {
                var result = tryCatch_1.tryCatch(messageFilter)(x);
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                }
                else if (result) {
                    observer.next(x);
                }
            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
            return function () {
                var result = tryCatch_1.tryCatch(unsubMsg)();
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                }
                else {
                    self.next(result);
                }
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function () {
        var _this = this;
        var WebSocketCtor = this.WebSocketCtor;
        var observer = this._output;
        var socket = null;
        try {
            socket = this.protocol ?
                new WebSocketCtor(this.url, this.protocol) :
                new WebSocketCtor(this.url);
            this.socket = socket;
            if (this.binaryType) {
                this.socket.binaryType = this.binaryType;
            }
        }
        catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new Subscription_1.Subscription(function () {
            _this.socket = null;
            if (socket && socket.readyState === 1) {
                socket.close();
            }
        });
        socket.onopen = function (e) {
            var openObserver = _this.openObserver;
            if (openObserver) {
                openObserver.next(e);
            }
            var queue = _this.destination;
            _this.destination = Subscriber_1.Subscriber.create(function (x) { return socket.readyState === 1 && socket.send(x); }, function (e) {
                var closingObserver = _this.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                if (e && e.code) {
                    socket.close(e.code, e.reason);
                }
                else {
                    observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' +
                        'and an optional reason: { code: number, reason: string }'));
                }
                _this._resetState();
            }, function () {
                var closingObserver = _this.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
                subscription.add(queue.subscribe(_this.destination));
            }
        };
        socket.onerror = function (e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function (e) {
            _this._resetState();
            var closeObserver = _this.closeObserver;
            if (closeObserver) {
                closeObserver.next(e);
            }
            if (e.wasClean) {
                observer.complete();
            }
            else {
                observer.error(e);
            }
        };
        socket.onmessage = function (e) {
            var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
            if (result === errorObject_1.errorObject) {
                observer.error(errorObject_1.errorObject.e);
            }
            else {
                observer.next(result);
            }
        };
    };
    /** @deprecated internal use only */ WebSocketSubject.prototype._subscribe = function (subscriber) {
        var _this = this;
        var source = this.source;
        if (source) {
            return source.subscribe(subscriber);
        }
        if (!this.socket) {
            this._connectSocket();
        }
        var subscription = new Subscription_1.Subscription();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function () {
            var socket = _this.socket;
            if (_this._output.observers.length === 0) {
                if (socket && socket.readyState === 1) {
                    socket.close();
                }
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function () {
        var _a = this, source = _a.source, socket = _a.socket;
        if (socket && socket.readyState === 1) {
            socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) {
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
    };
    return WebSocketSubject;
}(Subject_1.AnonymousSubject));
exports.WebSocketSubject = WebSocketSubject;
//# sourceMappingURL=WebSocketSubject.js.map

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(191);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var QueueAction = (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction_1.AsyncAction));
exports.QueueAction = QueueAction;
//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(192);
var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.QueueScheduler = QueueScheduler;
//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
function assignImpl(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    var len = sources.length;
    for (var i = 0; i < len; i++) {
        var source = sources[i];
        for (var k in source) {
            if (source.hasOwnProperty(k)) {
                target[k] = source[k];
            }
        }
    }
    return target;
}
exports.assignImpl = assignImpl;
;
function getAssign(root) {
    return root.Object.assign || assignImpl;
}
exports.getAssign = getAssign;
exports.assign = getAssign(root_1.root);
//# sourceMappingURL=assign.js.map

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var buffer_1 = __webpack_require__(1663);
Observable_1.Observable.prototype.buffer = buffer_1.buffer;
//# sourceMappingURL=buffer.js.map

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var buffer_1 = __webpack_require__(684);
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */
function buffer(closingNotifier) {
    return buffer_1.buffer(closingNotifier)(this);
}
exports.buffer = buffer;
//# sourceMappingURL=buffer.js.map

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var bufferCount_1 = __webpack_require__(1665);
Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bufferCount_1 = __webpack_require__(685);
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    return bufferCount_1.bufferCount(bufferSize, startBufferEvery)(this);
}
exports.bufferCount = bufferCount;
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var bufferTime_1 = __webpack_require__(1667);
Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var isScheduler_1 = __webpack_require__(72);
var bufferTime_1 = __webpack_require__(686);
/* tslint:enable:max-line-length */
/**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = async_1.async;
    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return bufferTime_1.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
}
exports.bufferTime = bufferTime;
//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var bufferToggle_1 = __webpack_require__(1669);
Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bufferToggle_1 = __webpack_require__(687);
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */
function bufferToggle(openings, closingSelector) {
    return bufferToggle_1.bufferToggle(openings, closingSelector)(this);
}
exports.bufferToggle = bufferToggle;
//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var bufferWhen_1 = __webpack_require__(1671);
Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bufferWhen_1 = __webpack_require__(688);
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return bufferWhen_1.bufferWhen(closingSelector)(this);
}
exports.bufferWhen = bufferWhen;
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var catch_1 = __webpack_require__(1673);
Observable_1.Observable.prototype.catch = catch_1._catch;
Observable_1.Observable.prototype._catch = catch_1._catch;
//# sourceMappingURL=catch.js.map

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var catchError_1 = __webpack_require__(689);
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */
function _catch(selector) {
    return catchError_1.catchError(selector)(this);
}
exports._catch = _catch;
//# sourceMappingURL=catch.js.map

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var combineAll_1 = __webpack_require__(1675);
Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var combineAll_1 = __webpack_require__(690);
/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */
function combineAll(project) {
    return combineAll_1.combineAll(project)(this);
}
exports.combineAll = combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var combineLatest_1 = __webpack_require__(1677);
Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var combineLatest_1 = __webpack_require__(273);
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return combineLatest_1.combineLatest.apply(void 0, observables)(this);
}
exports.combineLatest = combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var concat_1 = __webpack_require__(1679);
Observable_1.Observable.prototype.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concat_1 = __webpack_require__(691);
var concat_2 = __webpack_require__(187);
exports.concatStatic = concat_2.concat;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return concat_1.concat.apply(void 0, observables)(this);
}
exports.concat = concat;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var concatAll_1 = __webpack_require__(1681);
Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatAll_1 = __webpack_require__(386);
/* tslint:enable:max-line-length */
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return concatAll_1.concatAll()(this);
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var concatMap_1 = __webpack_require__(1683);
Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMap_1 = __webpack_require__(389);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return concatMap_1.concatMap(project, resultSelector)(this);
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var concatMapTo_1 = __webpack_require__(1685);
Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concatMapTo_1 = __webpack_require__(692);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return concatMapTo_1.concatMapTo(innerObservable, resultSelector)(this);
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var count_1 = __webpack_require__(1687);
Observable_1.Observable.prototype.count = count_1.count;
//# sourceMappingURL=count.js.map

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var count_1 = __webpack_require__(693);
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */
function count(predicate) {
    return count_1.count(predicate)(this);
}
exports.count = count;
//# sourceMappingURL=count.js.map

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var dematerialize_1 = __webpack_require__(1689);
Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dematerialize_1 = __webpack_require__(694);
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */
function dematerialize() {
    return dematerialize_1.dematerialize()(this);
}
exports.dematerialize = dematerialize;
//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var debounce_1 = __webpack_require__(1691);
Observable_1.Observable.prototype.debounce = debounce_1.debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var debounce_1 = __webpack_require__(695);
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */
function debounce(durationSelector) {
    return debounce_1.debounce(durationSelector)(this);
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var debounceTime_1 = __webpack_require__(1693);
Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var debounceTime_1 = __webpack_require__(696);
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return debounceTime_1.debounceTime(dueTime, scheduler)(this);
}
exports.debounceTime = debounceTime;
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var defaultIfEmpty_1 = __webpack_require__(1695);
Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defaultIfEmpty_1 = __webpack_require__(390);
/* tslint:enable:max-line-length */
/**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return defaultIfEmpty_1.defaultIfEmpty(defaultValue)(this);
}
exports.defaultIfEmpty = defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var delay_1 = __webpack_require__(1697);
Observable_1.Observable.prototype.delay = delay_1.delay;
//# sourceMappingURL=delay.js.map

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var delay_1 = __webpack_require__(697);
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return delay_1.delay(delay, scheduler)(this);
}
exports.delay = delay;
//# sourceMappingURL=delay.js.map

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var delayWhen_1 = __webpack_require__(1699);
Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var delayWhen_1 = __webpack_require__(698);
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    return delayWhen_1.delayWhen(delayDurationSelector, subscriptionDelay)(this);
}
exports.delayWhen = delayWhen;
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var distinct_1 = __webpack_require__(1701);
Observable_1.Observable.prototype.distinct = distinct_1.distinct;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinct_1 = __webpack_require__(699);
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */
function distinct(keySelector, flushes) {
    return distinct_1.distinct(keySelector, flushes)(this);
}
exports.distinct = distinct;
//# sourceMappingURL=distinct.js.map

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
function minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return (function () {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function (value) {
            if (!this.has(value)) {
                this._values.push(value);
            }
        };
        MinimalSet.prototype.has = function (value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function () {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function () {
            this._values.length = 0;
        };
        return MinimalSet;
    }());
}
exports.minimalSetImpl = minimalSetImpl;
exports.Set = root_1.root.Set || minimalSetImpl();
//# sourceMappingURL=Set.js.map

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var distinctUntilChanged_1 = __webpack_require__(1704);
Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinctUntilChanged_1 = __webpack_require__(391);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return distinctUntilChanged_1.distinctUntilChanged(compare, keySelector)(this);
}
exports.distinctUntilChanged = distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var distinctUntilKeyChanged_1 = __webpack_require__(1706);
Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinctUntilKeyChanged_1 = __webpack_require__(700);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */
function distinctUntilKeyChanged(key, compare) {
    return distinctUntilKeyChanged_1.distinctUntilKeyChanged(key, compare)(this);
}
exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var do_1 = __webpack_require__(1708);
Observable_1.Observable.prototype.do = do_1._do;
Observable_1.Observable.prototype._do = do_1._do;
//# sourceMappingURL=do.js.map

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tap_1 = __webpack_require__(701);
/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */
function _do(nextOrObserver, error, complete) {
    return tap_1.tap(nextOrObserver, error, complete)(this);
}
exports._do = _do;
//# sourceMappingURL=do.js.map

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var exhaust_1 = __webpack_require__(1710);
Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var exhaust_1 = __webpack_require__(702);
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */
function exhaust() {
    return exhaust_1.exhaust()(this);
}
exports.exhaust = exhaust;
//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var exhaustMap_1 = __webpack_require__(1712);
Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var exhaustMap_1 = __webpack_require__(703);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */
function exhaustMap(project, resultSelector) {
    return exhaustMap_1.exhaustMap(project, resultSelector)(this);
}
exports.exhaustMap = exhaustMap;
//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var expand_1 = __webpack_require__(1714);
Observable_1.Observable.prototype.expand = expand_1.expand;
//# sourceMappingURL=expand.js.map

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var expand_1 = __webpack_require__(704);
/* tslint:enable:max-line-length */
/**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (scheduler === void 0) { scheduler = undefined; }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return expand_1.expand(project, concurrent, scheduler)(this);
}
exports.expand = expand;
//# sourceMappingURL=expand.js.map

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var elementAt_1 = __webpack_require__(1716);
Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var elementAt_1 = __webpack_require__(705);
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */
function elementAt(index, defaultValue) {
    return elementAt_1.elementAt(index, defaultValue)(this);
}
exports.elementAt = elementAt;
//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var filter_1 = __webpack_require__(1718);
Observable_1.Observable.prototype.filter = filter_1.filter;
//# sourceMappingURL=filter.js.map

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var filter_1 = __webpack_require__(392);
/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return filter_1.filter(predicate, thisArg)(this);
}
exports.filter = filter;
//# sourceMappingURL=filter.js.map

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var finally_1 = __webpack_require__(1720);
Observable_1.Observable.prototype.finally = finally_1._finally;
Observable_1.Observable.prototype._finally = finally_1._finally;
//# sourceMappingURL=finally.js.map

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var finalize_1 = __webpack_require__(706);
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */
function _finally(callback) {
    return finalize_1.finalize(callback)(this);
}
exports._finally = _finally;
//# sourceMappingURL=finally.js.map

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var find_1 = __webpack_require__(1722);
Observable_1.Observable.prototype.find = find_1.find;
//# sourceMappingURL=find.js.map

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var find_1 = __webpack_require__(393);
/* tslint:enable:max-line-length */
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */
function find(predicate, thisArg) {
    return find_1.find(predicate, thisArg)(this);
}
exports.find = find;
//# sourceMappingURL=find.js.map

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var findIndex_1 = __webpack_require__(1724);
Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var findIndex_1 = __webpack_require__(707);
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */
function findIndex(predicate, thisArg) {
    return findIndex_1.findIndex(predicate, thisArg)(this);
}
exports.findIndex = findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var first_1 = __webpack_require__(1726);
Observable_1.Observable.prototype.first = first_1.first;
//# sourceMappingURL=first.js.map

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var first_1 = __webpack_require__(708);
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first(predicate, resultSelector, defaultValue) {
    return first_1.first(predicate, resultSelector, defaultValue)(this);
}
exports.first = first;
//# sourceMappingURL=first.js.map

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var groupBy_1 = __webpack_require__(1728);
Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var groupBy_1 = __webpack_require__(709);
exports.GroupedObservable = groupBy_1.GroupedObservable;
/* tslint:enable:max-line-length */
/**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return groupBy_1.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
}
exports.groupBy = groupBy;
//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
var MapPolyfill_1 = __webpack_require__(1730);
exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
//# sourceMappingURL=Map.js.map

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var MapPolyfill = (function () {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function (key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function (key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        }
        else {
            this._values[i] = value;
        }
        return this;
    };
    MapPolyfill.prototype.delete = function (key) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            return false;
        }
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function () {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function (cb, thisArg) {
        for (var i = 0; i < this.size; i++) {
            cb.call(thisArg, this._values[i], this._keys[i]);
        }
    };
    return MapPolyfill;
}());
exports.MapPolyfill = MapPolyfill;
//# sourceMappingURL=MapPolyfill.js.map

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FastMap = (function () {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function (key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function (key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function (key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function (cb, thisArg) {
        var values = this.values;
        for (var key in values) {
            if (values.hasOwnProperty(key) && values[key] !== null) {
                cb.call(thisArg, values[key], key);
            }
        }
    };
    FastMap.prototype.clear = function () {
        this.values = {};
    };
    return FastMap;
}());
exports.FastMap = FastMap;
//# sourceMappingURL=FastMap.js.map

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var ignoreElements_1 = __webpack_require__(1733);
Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ignoreElements_1 = __webpack_require__(710);
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */
function ignoreElements() {
    return ignoreElements_1.ignoreElements()(this);
}
exports.ignoreElements = ignoreElements;
;
//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var isEmpty_1 = __webpack_require__(1735);
Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isEmpty_1 = __webpack_require__(711);
/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */
function isEmpty() {
    return isEmpty_1.isEmpty()(this);
}
exports.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var audit_1 = __webpack_require__(1737);
Observable_1.Observable.prototype.audit = audit_1.audit;
//# sourceMappingURL=audit.js.map

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var audit_1 = __webpack_require__(394);
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */
function audit(durationSelector) {
    return audit_1.audit(durationSelector)(this);
}
exports.audit = audit;
//# sourceMappingURL=audit.js.map

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var auditTime_1 = __webpack_require__(1739);
Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var auditTime_1 = __webpack_require__(712);
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */
function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return auditTime_1.auditTime(duration, scheduler)(this);
}
exports.auditTime = auditTime;
//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var last_1 = __webpack_require__(1741);
Observable_1.Observable.prototype.last = last_1.last;
//# sourceMappingURL=last.js.map

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var last_1 = __webpack_require__(713);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */
function last(predicate, resultSelector, defaultValue) {
    return last_1.last(predicate, resultSelector, defaultValue)(this);
}
exports.last = last;
//# sourceMappingURL=last.js.map

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var let_1 = __webpack_require__(1743);
Observable_1.Observable.prototype.let = let_1.letProto;
Observable_1.Observable.prototype.letBind = let_1.letProto;
//# sourceMappingURL=let.js.map

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
function letProto(func) {
    return func(this);
}
exports.letProto = letProto;
//# sourceMappingURL=let.js.map

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var every_1 = __webpack_require__(1745);
Observable_1.Observable.prototype.every = every_1.every;
//# sourceMappingURL=every.js.map

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var every_1 = __webpack_require__(714);
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */
function every(predicate, thisArg) {
    return every_1.every(predicate, thisArg)(this);
}
exports.every = every;
//# sourceMappingURL=every.js.map

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var map_1 = __webpack_require__(1747);
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var map_1 = __webpack_require__(193);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return map_1.map(project, thisArg)(this);
}
exports.map = map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var mapTo_1 = __webpack_require__(1749);
Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mapTo_1 = __webpack_require__(715);
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
    return mapTo_1.mapTo(value)(this);
}
exports.mapTo = mapTo;
//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var materialize_1 = __webpack_require__(1751);
Observable_1.Observable.prototype.materialize = materialize_1.materialize;
//# sourceMappingURL=materialize.js.map

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var materialize_1 = __webpack_require__(716);
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */
function materialize() {
    return materialize_1.materialize()(this);
}
exports.materialize = materialize;
//# sourceMappingURL=materialize.js.map

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var max_1 = __webpack_require__(1753);
Observable_1.Observable.prototype.max = max_1.max;
//# sourceMappingURL=max.js.map

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var max_1 = __webpack_require__(717);
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */
function max(comparer) {
    return max_1.max(comparer)(this);
}
exports.max = max;
//# sourceMappingURL=max.js.map

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var merge_1 = __webpack_require__(1755);
Observable_1.Observable.prototype.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var merge_1 = __webpack_require__(718);
var merge_2 = __webpack_require__(276);
exports.mergeStatic = merge_2.merge;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return merge_1.merge.apply(void 0, observables)(this);
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var mergeAll_1 = __webpack_require__(1757);
Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeAll_1 = __webpack_require__(275);
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeAll_1.mergeAll(concurrent)(this);
}
exports.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var mergeMap_1 = __webpack_require__(1759);
Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(189);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMap_1.mergeMap(project, resultSelector, concurrent)(this);
}
exports.mergeMap = mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var mergeMapTo_1 = __webpack_require__(1761);
Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMapTo_1 = __webpack_require__(719);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMapTo_1.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
}
exports.mergeMapTo = mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var mergeScan_1 = __webpack_require__(1763);
Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeScan_1 = __webpack_require__(720);
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeScan_1.mergeScan(accumulator, seed, concurrent)(this);
}
exports.mergeScan = mergeScan;
//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var min_1 = __webpack_require__(1765);
Observable_1.Observable.prototype.min = min_1.min;
//# sourceMappingURL=min.js.map

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var min_1 = __webpack_require__(721);
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */
function min(comparer) {
    return min_1.min(comparer)(this);
}
exports.min = min;
//# sourceMappingURL=min.js.map

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var multicast_1 = __webpack_require__(1767);
Observable_1.Observable.prototype.multicast = multicast_1.multicast;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var multicast_1 = __webpack_require__(125);
/* tslint:enable:max-line-length */
/**
 * Allows source Observable to be subscribed only once with a Subject of choice,
 * while still sharing its values between multiple subscribers.
 *
 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * `multicast` is an operator that works in two modes.
 *
 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
 *
 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
 * ConnectableObservable, use `refCount`.
 *
 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
 * as well, which should be the input stream modified by any operators you want. Note that in this
 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
 * but you want to subscribe to that Observable only once, this is the mode you would use.
 *
 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
 *
 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
 *
 * @example <caption>Use ConnectableObservable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const connectableSeconds = seconds.multicast(new Subject());
 *
 * connectableSeconds.subscribe(value => console.log('first: ' + value));
 * connectableSeconds.subscribe(value => console.log('second: ' + value));
 *
 * // At this point still nothing happens, even though we subscribed twice.
 *
 * connectableSeconds.connect();
 *
 * // From now on `seconds` are being logged to the console,
 * // twice per every second. `seconds` Observable was however only subscribed once,
 * // so under the hood Observable.interval had only one clock started.
 *
 * @example <caption>Use selector</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds
 *     .multicast(
 *         () => new Subject(),
 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
 *                                         // Because we are inside selector, `seconds` is subscribed once,
 *     )                                   // thus starting only one clock used internally by Observable.interval.
 *     .subscribe();
 *
 * @see {@link publish}
 * @see {@link publishLast}
 * @see {@link publishBehavior}
 * @see {@link publishReplay}
 * @see {@link share}
 * @see {@link shareReplay}
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
 * which the source sequence's elements will be multicast to the selector function input Observable or
 * ConnectableObservable returned by the operator.
 * @param {Function} [selector] - Optional selector function that can use the input stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the input source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
 *
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    return multicast_1.multicast(subjectOrSubjectFactory, selector)(this);
}
exports.multicast = multicast;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var observeOn_1 = __webpack_require__(1769);
Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var observeOn_1 = __webpack_require__(274);
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return observeOn_1.observeOn(scheduler, delay)(this);
}
exports.observeOn = observeOn;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var onErrorResumeNext_1 = __webpack_require__(1771);
Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var onErrorResumeNext_1 = __webpack_require__(388);
/* tslint:enable:max-line-length */
/**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */
function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    return onErrorResumeNext_1.onErrorResumeNext.apply(void 0, nextSources)(this);
}
exports.onErrorResumeNext = onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var pairwise_1 = __webpack_require__(1773);
Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var pairwise_1 = __webpack_require__(723);
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return pairwise_1.pairwise()(this);
}
exports.pairwise = pairwise;
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var partition_1 = __webpack_require__(1775);
Observable_1.Observable.prototype.partition = partition_1.partition;
//# sourceMappingURL=partition.js.map

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var partition_1 = __webpack_require__(724);
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */
function partition(predicate, thisArg) {
    return partition_1.partition(predicate, thisArg)(this);
}
exports.partition = partition;
//# sourceMappingURL=partition.js.map

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
exports.not = not;
//# sourceMappingURL=not.js.map

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var pluck_1 = __webpack_require__(1778);
Observable_1.Observable.prototype.pluck = pluck_1.pluck;
//# sourceMappingURL=pluck.js.map

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var pluck_1 = __webpack_require__(725);
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i - 0] = arguments[_i];
    }
    return pluck_1.pluck.apply(void 0, properties)(this);
}
exports.pluck = pluck;
//# sourceMappingURL=pluck.js.map

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var publish_1 = __webpack_require__(1780);
Observable_1.Observable.prototype.publish = publish_1.publish;
//# sourceMappingURL=publish.js.map

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var publish_1 = __webpack_require__(726);
/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
function publish(selector) {
    return publish_1.publish(selector)(this);
}
exports.publish = publish;
//# sourceMappingURL=publish.js.map

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var publishBehavior_1 = __webpack_require__(1782);
Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var publishBehavior_1 = __webpack_require__(727);
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return publishBehavior_1.publishBehavior(value)(this);
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var publishReplay_1 = __webpack_require__(1784);
Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var publishReplay_1 = __webpack_require__(729);
/* tslint:enable:max-line-length */
/**
 * @param bufferSize
 * @param windowTime
 * @param selectorOrScheduler
 * @param scheduler
 * @return {Observable<T> | ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return publishReplay_1.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
}
exports.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var publishLast_1 = __webpack_require__(1786);
Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var publishLast_1 = __webpack_require__(730);
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */
function publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return publishLast_1.publishLast()(this);
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var race_1 = __webpack_require__(1788);
Observable_1.Observable.prototype.race = race_1.race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var race_1 = __webpack_require__(731);
// NOTE: to support backwards compatability with 5.4.* and lower
var race_2 = __webpack_require__(387);
exports.raceStatic = race_2.race;
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return race_1.race.apply(void 0, observables)(this);
}
exports.race = race;
//# sourceMappingURL=race.js.map

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var reduce_1 = __webpack_require__(1790);
Observable_1.Observable.prototype.reduce = reduce_1.reduce;
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__(195);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */
function reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        return reduce_1.reduce(accumulator, seed)(this);
    }
    return reduce_1.reduce(accumulator)(this);
}
exports.reduce = reduce;
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var repeat_1 = __webpack_require__(1792);
Observable_1.Observable.prototype.repeat = repeat_1.repeat;
//# sourceMappingURL=repeat.js.map

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var repeat_1 = __webpack_require__(732);
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */
function repeat(count) {
    if (count === void 0) { count = -1; }
    return repeat_1.repeat(count)(this);
}
exports.repeat = repeat;
//# sourceMappingURL=repeat.js.map

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var repeatWhen_1 = __webpack_require__(1794);
Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var repeatWhen_1 = __webpack_require__(733);
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
function repeatWhen(notifier) {
    return repeatWhen_1.repeatWhen(notifier)(this);
}
exports.repeatWhen = repeatWhen;
//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var retry_1 = __webpack_require__(1796);
Observable_1.Observable.prototype.retry = retry_1.retry;
//# sourceMappingURL=retry.js.map

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var retry_1 = __webpack_require__(734);
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */
function retry(count) {
    if (count === void 0) { count = -1; }
    return retry_1.retry(count)(this);
}
exports.retry = retry;
//# sourceMappingURL=retry.js.map

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var retryWhen_1 = __webpack_require__(1798);
Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var retryWhen_1 = __webpack_require__(735);
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */
function retryWhen(notifier) {
    return retryWhen_1.retryWhen(notifier)(this);
}
exports.retryWhen = retryWhen;
//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var sample_1 = __webpack_require__(1800);
Observable_1.Observable.prototype.sample = sample_1.sample;
//# sourceMappingURL=sample.js.map

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var sample_1 = __webpack_require__(736);
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */
function sample(notifier) {
    return sample_1.sample(notifier)(this);
}
exports.sample = sample;
//# sourceMappingURL=sample.js.map

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var sampleTime_1 = __webpack_require__(1802);
Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var sampleTime_1 = __webpack_require__(737);
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return sampleTime_1.sampleTime(period, scheduler)(this);
}
exports.sampleTime = sampleTime;
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var scan_1 = __webpack_require__(1804);
Observable_1.Observable.prototype.scan = scan_1.scan;
//# sourceMappingURL=scan.js.map

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var scan_1 = __webpack_require__(395);
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */
function scan(accumulator, seed) {
    if (arguments.length >= 2) {
        return scan_1.scan(accumulator, seed)(this);
    }
    return scan_1.scan(accumulator)(this);
}
exports.scan = scan;
//# sourceMappingURL=scan.js.map

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var sequenceEqual_1 = __webpack_require__(1806);
Observable_1.Observable.prototype.sequenceEqual = sequenceEqual_1.sequenceEqual;
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var sequenceEqual_1 = __webpack_require__(738);
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */
function sequenceEqual(compareTo, comparor) {
    return sequenceEqual_1.sequenceEqual(compareTo, comparor)(this);
}
exports.sequenceEqual = sequenceEqual;
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var share_1 = __webpack_require__(1808);
Observable_1.Observable.prototype.share = share_1.share;
//# sourceMappingURL=share.js.map

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var share_1 = __webpack_require__(739);
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */
function share() {
    return share_1.share()(this);
}
exports.share = share;
;
//# sourceMappingURL=share.js.map

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var shareReplay_1 = __webpack_require__(1810);
Observable_1.Observable.prototype.shareReplay = shareReplay_1.shareReplay;
//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shareReplay_1 = __webpack_require__(740);
/**
 * @method shareReplay
 * @owner Observable
 */
function shareReplay(bufferSize, windowTime, scheduler) {
    return shareReplay_1.shareReplay(bufferSize, windowTime, scheduler)(this);
}
exports.shareReplay = shareReplay;
;
//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var single_1 = __webpack_require__(1812);
Observable_1.Observable.prototype.single = single_1.single;
//# sourceMappingURL=single.js.map

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var single_1 = __webpack_require__(741);
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */
function single(predicate) {
    return single_1.single(predicate)(this);
}
exports.single = single;
//# sourceMappingURL=single.js.map

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var skip_1 = __webpack_require__(1814);
Observable_1.Observable.prototype.skip = skip_1.skip;
//# sourceMappingURL=skip.js.map

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var skip_1 = __webpack_require__(742);
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */
function skip(count) {
    return skip_1.skip(count)(this);
}
exports.skip = skip;
//# sourceMappingURL=skip.js.map

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var skipLast_1 = __webpack_require__(1816);
Observable_1.Observable.prototype.skipLast = skipLast_1.skipLast;
//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var skipLast_1 = __webpack_require__(743);
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */
function skipLast(count) {
    return skipLast_1.skipLast(count)(this);
}
exports.skipLast = skipLast;
//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var skipUntil_1 = __webpack_require__(1818);
Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var skipUntil_1 = __webpack_require__(744);
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
    return skipUntil_1.skipUntil(notifier)(this);
}
exports.skipUntil = skipUntil;
//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var skipWhile_1 = __webpack_require__(1820);
Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var skipWhile_1 = __webpack_require__(745);
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */
function skipWhile(predicate) {
    return skipWhile_1.skipWhile(predicate)(this);
}
exports.skipWhile = skipWhile;
//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var startWith_1 = __webpack_require__(1822);
Observable_1.Observable.prototype.startWith = startWith_1.startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var startWith_1 = __webpack_require__(746);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i - 0] = arguments[_i];
    }
    return startWith_1.startWith.apply(void 0, array)(this);
}
exports.startWith = startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var subscribeOn_1 = __webpack_require__(1824);
Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var subscribeOn_1 = __webpack_require__(1825);
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return subscribeOn_1.subscribeOn(scheduler, delay)(this);
}
exports.subscribeOn = subscribeOn;
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscribeOnObservable_1 = __webpack_require__(1826);
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
exports.subscribeOn = subscribeOn;
var SubscribeOnOperator = (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var asap_1 = __webpack_require__(747);
var isNumeric_1 = __webpack_require__(190);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var SubscribeOnObservable = (function (_super) {
    __extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) { delayTime = 0; }
        if (scheduler === void 0) { scheduler = asap_1.asap; }
        _super.call(this);
        this.source = source;
        this.delayTime = delayTime;
        this.scheduler = scheduler;
        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
            this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            this.scheduler = asap_1.asap;
        }
    }
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) { delay = 0; }
        if (scheduler === void 0) { scheduler = asap_1.asap; }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    /** @deprecated internal use only */ SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(Observable_1.Observable));
exports.SubscribeOnObservable = SubscribeOnObservable;
//# sourceMappingURL=SubscribeOnObservable.js.map

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Immediate_1 = __webpack_require__(1828);
var AsyncAction_1 = __webpack_require__(191);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsapAction = (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            Immediate_1.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}(AsyncAction_1.AsyncAction));
exports.AsapAction = AsapAction;
//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {/**
Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
*/

var root_1 = __webpack_require__(56);
var ImmediateDefinition = (function () {
    function ImmediateDefinition(root) {
        this.root = root;
        if (root.setImmediate && typeof root.setImmediate === 'function') {
            this.setImmediate = root.setImmediate.bind(root);
            this.clearImmediate = root.clearImmediate.bind(root);
        }
        else {
            this.nextHandle = 1;
            this.tasksByHandle = {};
            this.currentlyRunningATask = false;
            // Don't get fooled by e.g. browserify environments.
            if (this.canUseProcessNextTick()) {
                // For Node.js before 0.9
                this.setImmediate = this.createProcessNextTickSetImmediate();
            }
            else if (this.canUsePostMessage()) {
                // For non-IE10 modern browsers
                this.setImmediate = this.createPostMessageSetImmediate();
            }
            else if (this.canUseMessageChannel()) {
                // For web workers, where supported
                this.setImmediate = this.createMessageChannelSetImmediate();
            }
            else if (this.canUseReadyStateChange()) {
                // For IE 6–8
                this.setImmediate = this.createReadyStateChangeSetImmediate();
            }
            else {
                // For older browsers
                this.setImmediate = this.createSetTimeoutSetImmediate();
            }
            var ci = function clearImmediate(handle) {
                delete clearImmediate.instance.tasksByHandle[handle];
            };
            ci.instance = this;
            this.clearImmediate = ci;
        }
    }
    ImmediateDefinition.prototype.identify = function (o) {
        return this.root.Object.prototype.toString.call(o);
    };
    ImmediateDefinition.prototype.canUseProcessNextTick = function () {
        return this.identify(this.root.process) === '[object process]';
    };
    ImmediateDefinition.prototype.canUseMessageChannel = function () {
        return Boolean(this.root.MessageChannel);
    };
    ImmediateDefinition.prototype.canUseReadyStateChange = function () {
        var document = this.root.document;
        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
    };
    ImmediateDefinition.prototype.canUsePostMessage = function () {
        var root = this.root;
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `root.postMessage` means something completely different and can't be used for this purpose.
        if (root.postMessage && !root.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = root.onmessage;
            root.onmessage = function () {
                postMessageIsAsynchronous_1 = false;
            };
            root.postMessage('', '*');
            root.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
        return false;
    };
    // This function accepts the same arguments as setImmediate, but
    // returns a function that requires no arguments.
    ImmediateDefinition.prototype.partiallyApplied = function (handler) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var fn = function result() {
            var _a = result, handler = _a.handler, args = _a.args;
            if (typeof handler === 'function') {
                handler.apply(undefined, args);
            }
            else {
                (new Function('' + handler))();
            }
        };
        fn.handler = handler;
        fn.args = args;
        return fn;
    };
    ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
        return this.nextHandle++;
    };
    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var root = this.root;
        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
        var onGlobalMessage = function globalMessageHandler(event) {
            var instance = globalMessageHandler.instance;
            if (event.source === root &&
                typeof event.data === 'string' &&
                event.data.indexOf(messagePrefix) === 0) {
                instance.runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };
        onGlobalMessage.instance = this;
        root.addEventListener('message', onGlobalMessage, false);
        var fn = function setImmediate() {
            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.postMessage(messagePrefix + handle, '*');
            return handle;
        };
        fn.instance = this;
        fn.messagePrefix = messagePrefix;
        return fn;
    };
    ImmediateDefinition.prototype.runIfPresent = function (handle) {
        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
        // So if we're currently running a task, we'll need to delay this invocation.
        if (this.currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // 'too much recursion' error.
            this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
        }
        else {
            var task = this.tasksByHandle[handle];
            if (task) {
                this.currentlyRunningATask = true;
                try {
                    task();
                }
                finally {
                    this.clearImmediate(handle);
                    this.currentlyRunningATask = false;
                }
            }
        }
    };
    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
        var _this = this;
        var channel = new this.root.MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            _this.runIfPresent(handle);
        };
        var fn = function setImmediate() {
            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            channel.port2.postMessage(handle);
            return handle;
        };
        fn.channel = channel;
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var root = instance.root;
            var doc = root.document;
            var html = doc.documentElement;
            var handle = instance.addFromSetImmediateArguments(arguments);
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function () {
                instance.runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    return ImmediateDefinition;
}());
exports.ImmediateDefinition = ImmediateDefinition;
exports.Immediate = new ImmediateDefinition(root_1.root);
//# sourceMappingURL=Immediate.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(748).clearImmediate, __webpack_require__(748).setImmediate))

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62), __webpack_require__(369)))

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(192);
var AsapScheduler = (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        _super.apply(this, arguments);
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AsapScheduler = AsapScheduler;
//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var switch_1 = __webpack_require__(1832);
Observable_1.Observable.prototype.switch = switch_1._switch;
Observable_1.Observable.prototype._switch = switch_1._switch;
//# sourceMappingURL=switch.js.map

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchAll_1 = __webpack_require__(749);
/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */
function _switch() {
    return switchAll_1.switchAll()(this);
}
exports._switch = _switch;
//# sourceMappingURL=switch.js.map

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var switchMap_1 = __webpack_require__(1834);
Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchMap_1 = __webpack_require__(398);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    return switchMap_1.switchMap(project, resultSelector)(this);
}
exports.switchMap = switchMap;
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var switchMapTo_1 = __webpack_require__(1836);
Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var switchMapTo_1 = __webpack_require__(750);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */
function switchMapTo(innerObservable, resultSelector) {
    return switchMapTo_1.switchMapTo(innerObservable, resultSelector)(this);
}
exports.switchMapTo = switchMapTo;
//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var take_1 = __webpack_require__(1838);
Observable_1.Observable.prototype.take = take_1.take;
//# sourceMappingURL=take.js.map

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var take_1 = __webpack_require__(751);
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    return take_1.take(count)(this);
}
exports.take = take;
//# sourceMappingURL=take.js.map

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var takeLast_1 = __webpack_require__(1840);
Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var takeLast_1 = __webpack_require__(396);
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */
function takeLast(count) {
    return takeLast_1.takeLast(count)(this);
}
exports.takeLast = takeLast;
//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var takeUntil_1 = __webpack_require__(1842);
Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var takeUntil_1 = __webpack_require__(752);
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value, the output Observable stops mirroring the source Observable
 * and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return takeUntil_1.takeUntil(notifier)(this);
}
exports.takeUntil = takeUntil;
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var takeWhile_1 = __webpack_require__(1844);
Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var takeWhile_1 = __webpack_require__(753);
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */
function takeWhile(predicate) {
    return takeWhile_1.takeWhile(predicate)(this);
}
exports.takeWhile = takeWhile;
//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var throttle_1 = __webpack_require__(1846);
Observable_1.Observable.prototype.throttle = throttle_1.throttle;
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var throttle_1 = __webpack_require__(281);
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */
function throttle(durationSelector, config) {
    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
    return throttle_1.throttle(durationSelector, config)(this);
}
exports.throttle = throttle;
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var throttleTime_1 = __webpack_require__(1848);
Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var throttle_1 = __webpack_require__(281);
var throttleTime_1 = __webpack_require__(754);
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
    return throttleTime_1.throttleTime(duration, scheduler, config)(this);
}
exports.throttleTime = throttleTime;
//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var timeInterval_1 = __webpack_require__(755);
Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var timeout_1 = __webpack_require__(1851);
Observable_1.Observable.prototype.timeout = timeout_1.timeout;
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var timeout_1 = __webpack_require__(757);
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */
function timeout(due, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timeout_1.timeout(due, scheduler)(this);
}
exports.timeout = timeout;
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var timeoutWith_1 = __webpack_require__(1853);
Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var timeoutWith_1 = __webpack_require__(759);
/* tslint:enable:max-line-length */
/**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timeoutWith_1.timeoutWith(due, withObservable, scheduler)(this);
}
exports.timeoutWith = timeoutWith;
//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var timestamp_1 = __webpack_require__(1855);
Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var timestamp_1 = __webpack_require__(399);
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timestamp_1.timestamp(scheduler)(this);
}
exports.timestamp = timestamp;
//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var toArray_1 = __webpack_require__(1857);
Observable_1.Observable.prototype.toArray = toArray_1.toArray;
//# sourceMappingURL=toArray.js.map

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toArray_1 = __webpack_require__(760);
/**
 * Collects all source emissions and emits them as an array when the source completes.
 *
 * <span class="informal">Get all values inside an array when the source completes</span>
 *
 * <img src="./img/toArray.png" width="100%">
 *
 * `toArray` will wait until the source Observable completes
 * before emitting the array containing all emissions.
 * When the source Observable errors no array will be emitted.
 *
 * @example <caption>Create array from input</caption>
 * const input = Rx.Observable.interval(100).take(4);
 *
 * input.toArray()
 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
 *
 * @see {@link buffer}
 *
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */
function toArray() {
    return toArray_1.toArray()(this);
}
exports.toArray = toArray;
//# sourceMappingURL=toArray.js.map

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.
//# sourceMappingURL=toPromise.js.map

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var window_1 = __webpack_require__(1860);
Observable_1.Observable.prototype.window = window_1.window;
//# sourceMappingURL=window.js.map

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var window_1 = __webpack_require__(761);
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */
function window(windowBoundaries) {
    return window_1.window(windowBoundaries)(this);
}
exports.window = window;
//# sourceMappingURL=window.js.map

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var windowCount_1 = __webpack_require__(1862);
Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var windowCount_1 = __webpack_require__(762);
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    return windowCount_1.windowCount(windowSize, startWindowEvery)(this);
}
exports.windowCount = windowCount;
//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var windowTime_1 = __webpack_require__(1864);
Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(33);
var isNumeric_1 = __webpack_require__(190);
var isScheduler_1 = __webpack_require__(72);
var windowTime_1 = __webpack_require__(763);
function windowTime(windowTimeSpan) {
    var scheduler = async_1.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (isScheduler_1.isScheduler(arguments[3])) {
        scheduler = arguments[3];
    }
    if (isScheduler_1.isScheduler(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (isNumeric_1.isNumeric(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (isScheduler_1.isScheduler(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (isNumeric_1.isNumeric(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return windowTime_1.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
}
exports.windowTime = windowTime;
//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var windowToggle_1 = __webpack_require__(1866);
Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var windowToggle_1 = __webpack_require__(764);
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */
function windowToggle(openings, closingSelector) {
    return windowToggle_1.windowToggle(openings, closingSelector)(this);
}
exports.windowToggle = windowToggle;
//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var windowWhen_1 = __webpack_require__(1868);
Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var windowWhen_1 = __webpack_require__(765);
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */
function windowWhen(closingSelector) {
    return windowWhen_1.windowWhen(closingSelector)(this);
}
exports.windowWhen = windowWhen;
//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var withLatestFrom_1 = __webpack_require__(1870);
Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var withLatestFrom_1 = __webpack_require__(766);
/* tslint:enable:max-line-length */
/**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */
function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i - 0] = arguments[_i];
    }
    return withLatestFrom_1.withLatestFrom.apply(void 0, args)(this);
}
exports.withLatestFrom = withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var zip_1 = __webpack_require__(1872);
Observable_1.Observable.prototype.zip = zip_1.zipProto;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__(278);
/* tslint:enable:max-line-length */
/**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */
function zipProto() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return zip_1.zip.apply(void 0, observables)(this);
}
exports.zipProto = zipProto;
//# sourceMappingURL=zip.js.map

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(4);
var zipAll_1 = __webpack_require__(1874);
Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zipAll_1 = __webpack_require__(767);
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */
function zipAll(project) {
    return zipAll_1.zipAll(project)(this);
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var Notification_1 = __webpack_require__(188);
var ColdObservable_1 = __webpack_require__(1876);
var HotObservable_1 = __webpack_require__(1877);
var SubscriptionLog_1 = __webpack_require__(769);
var VirtualTimeScheduler_1 = __webpack_require__(771);
var defaultMaxFrame = 750;
var TestScheduler = (function (_super) {
    __extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        _super.call(this, VirtualTimeScheduler_1.VirtualAction, defaultMaxFrame);
        this.assertDeepEqual = assertDeepEqual;
        this.hotObservables = [];
        this.coldObservables = [];
        this.flushTests = [];
    }
    TestScheduler.prototype.createTime = function (marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) {
            throw new Error('marble diagram for time should have a completion marker "|"');
        }
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
        if (marbles.indexOf('^') !== -1) {
            throw new Error('cold observable cannot have subscription offset "^"');
        }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('cold observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var cold = new ColdObservable_1.ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
        if (marbles.indexOf('!') !== -1) {
            throw new Error('hot observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var subject = new HotObservable_1.HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function (value) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
        }, function (err) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
        }, function () {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) { unsubscriptionMarbles = null; }
        var actual = [];
        var flushTest = { actual: actual, ready: false };
        var unsubscriptionFrame = TestScheduler
            .parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
        var subscription;
        this.schedule(function () {
            subscription = observable.subscribe(function (x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof Observable_1.Observable) {
                    value = _this.materializeInnerObservable(value, _this.frame);
                }
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
            }, function (err) {
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
            }, function () {
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
        }
        this.flushTests.push(flushTest);
        return {
            toBe: function (marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
        var flushTest = { actual: actualSubscriptionLogs, ready: false };
        this.flushTests.push(flushTest);
        return {
            toBe: function (marbles) {
                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function (marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function () {
        var hotObservables = this.hotObservables;
        while (hotObservables.length > 0) {
            hotObservables.shift().setup();
        }
        _super.prototype.flush.call(this);
        var readyFlushTests = this.flushTests.filter(function (test) { return test.ready; });
        while (readyFlushTests.length > 0) {
            var test = readyFlushTests.shift();
            this.assertDeepEqual(test.actual, test.expected);
        }
    };
    TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
        if (typeof marbles !== 'string') {
            return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
        }
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        for (var i = 0; i < len; i++) {
            var frame = i * this.frameTimeFactor;
            var c = marbles[i];
            switch (c) {
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
                        'subscription marble diagram. Found instead \'' + c + '\'.');
            }
        }
        if (unsubscriptionFrame < 0) {
            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
        }
        else {
            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
        }
    };
    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
        if (materializeInnerObservables === void 0) { materializeInnerObservables = false; }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('conventional marble diagrams cannot have the ' +
                'unsubscription marker "!"');
        }
        var len = marbles.length;
        var testMessages = [];
        var subIndex = marbles.indexOf('^');
        var frameOffset = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
        var getValue = typeof values !== 'object' ?
            function (x) { return x; } :
            function (x) {
                // Support Observable-of-Observables
                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
                    return values[x].messages;
                }
                return values[x];
            };
        var groupStart = -1;
        for (var i = 0; i < len; i++) {
            var frame = i * this.frameTimeFactor + frameOffset;
            var notification = void 0;
            var c = marbles[i];
            switch (c) {
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '|':
                    notification = Notification_1.Notification.createComplete();
                    break;
                case '^':
                    break;
                case '#':
                    notification = Notification_1.Notification.createError(errorValue || 'error');
                    break;
                default:
                    notification = Notification_1.Notification.createNext(getValue(c));
                    break;
            }
            if (notification) {
                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
            }
        }
        return testMessages;
    };
    return TestScheduler;
}(VirtualTimeScheduler_1.VirtualTimeScheduler));
exports.TestScheduler = TestScheduler;
//# sourceMappingURL=TestScheduler.js.map

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(4);
var Subscription_1 = __webpack_require__(46);
var SubscriptionLoggable_1 = __webpack_require__(768);
var applyMixins_1 = __webpack_require__(770);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ColdObservable = (function (_super) {
    __extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        _super.call(this, function (subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new Subscription_1.Subscription(function () {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        });
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    ColdObservable.prototype.scheduleMessages = function (subscriber) {
        var messagesLength = this.messages.length;
        for (var i = 0; i < messagesLength; i++) {
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function (_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, { message: message, subscriber: subscriber }));
        }
    };
    return ColdObservable;
}(Observable_1.Observable));
exports.ColdObservable = ColdObservable;
applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
//# sourceMappingURL=ColdObservable.js.map

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(49);
var Subscription_1 = __webpack_require__(46);
var SubscriptionLoggable_1 = __webpack_require__(768);
var applyMixins_1 = __webpack_require__(770);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var HotObservable = (function (_super) {
    __extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
        _super.call(this);
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    /** @deprecated internal use only */ HotObservable.prototype._subscribe = function (subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new Subscription_1.Subscription(function () {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function () {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */
        for (var i = 0; i < messagesLength; i++) {
            (function () {
                var message = subject.messages[i];
                /* tslint:enable */
                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
            })();
        }
    };
    return HotObservable;
}(Subject_1.Subject));
exports.HotObservable = HotObservable;
applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
//# sourceMappingURL=HotObservable.js.map

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AnimationFrameAction_1 = __webpack_require__(1879);
var AnimationFrameScheduler_1 = __webpack_require__(1881);
/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */
exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(191);
var AnimationFrame_1 = __webpack_require__(1880);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AnimationFrameAction = (function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction_1.AsyncAction));
exports.AnimationFrameAction = AnimationFrameAction;
//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(56);
var RequestAnimationFrameDefinition = (function () {
    function RequestAnimationFrameDefinition(root) {
        if (root.requestAnimationFrame) {
            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
        }
        else if (root.mozRequestAnimationFrame) {
            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        }
        else if (root.webkitRequestAnimationFrame) {
            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        }
        else if (root.msRequestAnimationFrame) {
            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        }
        else if (root.oRequestAnimationFrame) {
            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        }
        else {
            this.cancelAnimationFrame = root.clearTimeout.bind(root);
            this.requestAnimationFrame = function (cb) { return root.setTimeout(cb, 1000 / 60); };
        }
    }
    return RequestAnimationFrameDefinition;
}());
exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
//# sourceMappingURL=AnimationFrame.js.map

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(192);
var AnimationFrameScheduler = (function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        _super.apply(this, arguments);
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AnimationFrameScheduler = AnimationFrameScheduler;
//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var audit_1 = __webpack_require__(394);
exports.audit = audit_1.audit;
var auditTime_1 = __webpack_require__(712);
exports.auditTime = auditTime_1.auditTime;
var buffer_1 = __webpack_require__(684);
exports.buffer = buffer_1.buffer;
var bufferCount_1 = __webpack_require__(685);
exports.bufferCount = bufferCount_1.bufferCount;
var bufferTime_1 = __webpack_require__(686);
exports.bufferTime = bufferTime_1.bufferTime;
var bufferToggle_1 = __webpack_require__(687);
exports.bufferToggle = bufferToggle_1.bufferToggle;
var bufferWhen_1 = __webpack_require__(688);
exports.bufferWhen = bufferWhen_1.bufferWhen;
var catchError_1 = __webpack_require__(689);
exports.catchError = catchError_1.catchError;
var combineAll_1 = __webpack_require__(690);
exports.combineAll = combineAll_1.combineAll;
var combineLatest_1 = __webpack_require__(273);
exports.combineLatest = combineLatest_1.combineLatest;
var concat_1 = __webpack_require__(691);
exports.concat = concat_1.concat;
var concatAll_1 = __webpack_require__(386);
exports.concatAll = concatAll_1.concatAll;
var concatMap_1 = __webpack_require__(389);
exports.concatMap = concatMap_1.concatMap;
var concatMapTo_1 = __webpack_require__(692);
exports.concatMapTo = concatMapTo_1.concatMapTo;
var count_1 = __webpack_require__(693);
exports.count = count_1.count;
var debounce_1 = __webpack_require__(695);
exports.debounce = debounce_1.debounce;
var debounceTime_1 = __webpack_require__(696);
exports.debounceTime = debounceTime_1.debounceTime;
var defaultIfEmpty_1 = __webpack_require__(390);
exports.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
var delay_1 = __webpack_require__(697);
exports.delay = delay_1.delay;
var delayWhen_1 = __webpack_require__(698);
exports.delayWhen = delayWhen_1.delayWhen;
var dematerialize_1 = __webpack_require__(694);
exports.dematerialize = dematerialize_1.dematerialize;
var distinct_1 = __webpack_require__(699);
exports.distinct = distinct_1.distinct;
var distinctUntilChanged_1 = __webpack_require__(391);
exports.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
var distinctUntilKeyChanged_1 = __webpack_require__(700);
exports.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
var elementAt_1 = __webpack_require__(705);
exports.elementAt = elementAt_1.elementAt;
var every_1 = __webpack_require__(714);
exports.every = every_1.every;
var exhaust_1 = __webpack_require__(702);
exports.exhaust = exhaust_1.exhaust;
var exhaustMap_1 = __webpack_require__(703);
exports.exhaustMap = exhaustMap_1.exhaustMap;
var expand_1 = __webpack_require__(704);
exports.expand = expand_1.expand;
var filter_1 = __webpack_require__(392);
exports.filter = filter_1.filter;
var finalize_1 = __webpack_require__(706);
exports.finalize = finalize_1.finalize;
var find_1 = __webpack_require__(393);
exports.find = find_1.find;
var findIndex_1 = __webpack_require__(707);
exports.findIndex = findIndex_1.findIndex;
var first_1 = __webpack_require__(708);
exports.first = first_1.first;
var groupBy_1 = __webpack_require__(709);
exports.groupBy = groupBy_1.groupBy;
var ignoreElements_1 = __webpack_require__(710);
exports.ignoreElements = ignoreElements_1.ignoreElements;
var isEmpty_1 = __webpack_require__(711);
exports.isEmpty = isEmpty_1.isEmpty;
var last_1 = __webpack_require__(713);
exports.last = last_1.last;
var map_1 = __webpack_require__(193);
exports.map = map_1.map;
var mapTo_1 = __webpack_require__(715);
exports.mapTo = mapTo_1.mapTo;
var materialize_1 = __webpack_require__(716);
exports.materialize = materialize_1.materialize;
var max_1 = __webpack_require__(717);
exports.max = max_1.max;
var merge_1 = __webpack_require__(718);
exports.merge = merge_1.merge;
var mergeAll_1 = __webpack_require__(275);
exports.mergeAll = mergeAll_1.mergeAll;
var mergeMap_1 = __webpack_require__(189);
exports.mergeMap = mergeMap_1.mergeMap;
var mergeMap_2 = __webpack_require__(189);
exports.flatMap = mergeMap_2.mergeMap;
var mergeMapTo_1 = __webpack_require__(719);
exports.mergeMapTo = mergeMapTo_1.mergeMapTo;
var mergeScan_1 = __webpack_require__(720);
exports.mergeScan = mergeScan_1.mergeScan;
var min_1 = __webpack_require__(721);
exports.min = min_1.min;
var multicast_1 = __webpack_require__(125);
exports.multicast = multicast_1.multicast;
var observeOn_1 = __webpack_require__(274);
exports.observeOn = observeOn_1.observeOn;
var onErrorResumeNext_1 = __webpack_require__(388);
exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
var pairwise_1 = __webpack_require__(723);
exports.pairwise = pairwise_1.pairwise;
var partition_1 = __webpack_require__(724);
exports.partition = partition_1.partition;
var pluck_1 = __webpack_require__(725);
exports.pluck = pluck_1.pluck;
var publish_1 = __webpack_require__(726);
exports.publish = publish_1.publish;
var publishBehavior_1 = __webpack_require__(727);
exports.publishBehavior = publishBehavior_1.publishBehavior;
var publishLast_1 = __webpack_require__(730);
exports.publishLast = publishLast_1.publishLast;
var publishReplay_1 = __webpack_require__(729);
exports.publishReplay = publishReplay_1.publishReplay;
var race_1 = __webpack_require__(731);
exports.race = race_1.race;
var reduce_1 = __webpack_require__(195);
exports.reduce = reduce_1.reduce;
var repeat_1 = __webpack_require__(732);
exports.repeat = repeat_1.repeat;
var repeatWhen_1 = __webpack_require__(733);
exports.repeatWhen = repeatWhen_1.repeatWhen;
var retry_1 = __webpack_require__(734);
exports.retry = retry_1.retry;
var retryWhen_1 = __webpack_require__(735);
exports.retryWhen = retryWhen_1.retryWhen;
var refCount_1 = __webpack_require__(397);
exports.refCount = refCount_1.refCount;
var sample_1 = __webpack_require__(736);
exports.sample = sample_1.sample;
var sampleTime_1 = __webpack_require__(737);
exports.sampleTime = sampleTime_1.sampleTime;
var scan_1 = __webpack_require__(395);
exports.scan = scan_1.scan;
var sequenceEqual_1 = __webpack_require__(738);
exports.sequenceEqual = sequenceEqual_1.sequenceEqual;
var share_1 = __webpack_require__(739);
exports.share = share_1.share;
var shareReplay_1 = __webpack_require__(740);
exports.shareReplay = shareReplay_1.shareReplay;
var single_1 = __webpack_require__(741);
exports.single = single_1.single;
var skip_1 = __webpack_require__(742);
exports.skip = skip_1.skip;
var skipLast_1 = __webpack_require__(743);
exports.skipLast = skipLast_1.skipLast;
var skipUntil_1 = __webpack_require__(744);
exports.skipUntil = skipUntil_1.skipUntil;
var skipWhile_1 = __webpack_require__(745);
exports.skipWhile = skipWhile_1.skipWhile;
var startWith_1 = __webpack_require__(746);
exports.startWith = startWith_1.startWith;
/**
 * TODO(https://github.com/ReactiveX/rxjs/issues/2900): Add back subscribeOn once it can be
 * treeshaken. Currently if this export is added back, it
 * forces apps to bring in asap scheduler along with
 * Immediate, root, and other supporting code.
 */
// export { subscribeOn } from './operators/subscribeOn';
var switchAll_1 = __webpack_require__(749);
exports.switchAll = switchAll_1.switchAll;
var switchMap_1 = __webpack_require__(398);
exports.switchMap = switchMap_1.switchMap;
var switchMapTo_1 = __webpack_require__(750);
exports.switchMapTo = switchMapTo_1.switchMapTo;
var take_1 = __webpack_require__(751);
exports.take = take_1.take;
var takeLast_1 = __webpack_require__(396);
exports.takeLast = takeLast_1.takeLast;
var takeUntil_1 = __webpack_require__(752);
exports.takeUntil = takeUntil_1.takeUntil;
var takeWhile_1 = __webpack_require__(753);
exports.takeWhile = takeWhile_1.takeWhile;
var tap_1 = __webpack_require__(701);
exports.tap = tap_1.tap;
var throttle_1 = __webpack_require__(281);
exports.throttle = throttle_1.throttle;
var throttleTime_1 = __webpack_require__(754);
exports.throttleTime = throttleTime_1.throttleTime;
var timeInterval_1 = __webpack_require__(756);
exports.timeInterval = timeInterval_1.timeInterval;
var timeout_1 = __webpack_require__(757);
exports.timeout = timeout_1.timeout;
var timeoutWith_1 = __webpack_require__(759);
exports.timeoutWith = timeoutWith_1.timeoutWith;
var timestamp_1 = __webpack_require__(399);
exports.timestamp = timestamp_1.timestamp;
var toArray_1 = __webpack_require__(760);
exports.toArray = toArray_1.toArray;
var window_1 = __webpack_require__(761);
exports.window = window_1.window;
var windowCount_1 = __webpack_require__(762);
exports.windowCount = windowCount_1.windowCount;
var windowTime_1 = __webpack_require__(763);
exports.windowTime = windowTime_1.windowTime;
var windowToggle_1 = __webpack_require__(764);
exports.windowToggle = windowToggle_1.windowToggle;
var windowWhen_1 = __webpack_require__(765);
exports.windowWhen = windowWhen_1.windowWhen;
var withLatestFrom_1 = __webpack_require__(766);
exports.withLatestFrom = withLatestFrom_1.withLatestFrom;
var zip_1 = __webpack_require__(278);
exports.zip = zip_1.zip;
var zipAll_1 = __webpack_require__(767);
exports.zipAll = zipAll_1.zipAll;
//# sourceMappingURL=operators.js.map

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TVChartComponent__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);






var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var decimalPlaces = state.apexCore.product.decimalPlaces;
  var theme = __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].global.theme;

  var localConfig = JSON.parse(localStorage.getItem('apexTemplate')) || {};

  return {
    selectedInstrument: selectedInstrument,
    decimalPlaces: decimalPlaces,
    theme: localConfig.theme || theme
  };
};

var mapDispatchToProps = {
  changeTickersInterval: __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__["e" /* changeTickersInterval */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TVChartComponent__["a" /* default */]));

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_tradingView_ChartAPI__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jstimezonedetect__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jstimezonedetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jstimezonedetect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_wsHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_cssVarHelper__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TVChartComponent_css__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TVChartComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__TVChartComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global TradingView */














var tvChartClasses = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['tv-chart']);

/* These items were either non-working or buggy within our TradingView implementation,
and should stay disabled until they are fixed or reassessed. */
var disabledFeatures = ['header_settings', 'control_bar', 'context_menus', 'header_symbol_search', 'header_compare', 'use_localstorage_for_settings', 'save_chart_properties_to_local_storage', 'show_chart_property_page', 'header_resolutions', 'go_to_date'];

var TVChartComponent = function (_React$Component) {
  _inherits(TVChartComponent, _React$Component);

  function TVChartComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TVChartComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TVChartComponent.__proto__ || Object.getPrototypeOf(TVChartComponent)).call.apply(_ref, [this].concat(args))), _this), _this.script = function (location) {
      return new Promise(function (resolve) {
        _this.scripts[location] = document.createElement('script');
        _this.scripts[location].src = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])(location);
        _this.scripts[location].type = 'text/javascript';
        _this.scripts[location].async = true;
        _this.scripts[location].onload = resolve;
        document.body.appendChild(_this.scripts[location]);
      });
    }, _this.createChart = function (dataFeed) {
      var loading_BgColor = _this.cssVariable('--tv-chart__loading-screen-bg-color');
      var bgColor = _this.cssVariable('--tv-chart__bg-color');
      var gridColor = _this.cssVariable('--tv-chart__grid-color');
      var gridColorVertical = _this.cssVariable('--tv-chart__grid-vertical-color');
      var gridColorHorizontal = _this.cssVariable('--tv-chart__grid-horizontal-color');
      var scaleFontColor = _this.cssVariable('--tv-chart__scale-font-color');
      var scaleLineColor = _this.cssVariable('--tv-chart__scale-line-color');
      var scaleBgColor = _this.cssVariable('--tv-chart__scale-bg-color');
      var graphUpColor = _this.cssVariable('--tv-chart__graph-up-color');
      var graphDownColor = _this.cssVariable('--tv-chart__graph-down-color');
      var graphBorderUpColor = _this.cssVariable('--tv-chart__graph-border-up-color');
      var graphBorderDownColor = _this.cssVariable('--tv-chart__graph-border-down-color');
      var graphUpOpaqueColor = 'rgba(' + _this.cssVariable('--pc__accent-additive') + ', .3)';
      var graphDownOpaqueColor = 'rgba(' + _this.cssVariable('--pc__accent-subtractive') + ', .3)';

      var custom_css_url = _this.props.theme === 'light' ? '' : '/vendor/tradingView/charting_library-dark-theme.css';
      var chartOptions = {
        symbol: _this.props.selectedInstrument.Symbol,
        datafeed: dataFeed,
        library_path: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])('/vendor/tradingView/'),
        autosize: true,
        interval: '15',
        container_id: 'trading-view-chart',
        loading_screen: { backgroundColor: loading_BgColor },
        custom_css_url: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])(custom_css_url),
        overrides: {
          'paneProperties.background': bgColor,
          'paneProperties.gridProperties.color': gridColor,
          'paneProperties.vertGridProperties.color': gridColorVertical,
          'paneProperties.horzGridProperties.color': gridColorHorizontal,
          'paneProperties.topMargin': 15,
          'paneProperties.bottomMargin': 25,
          'scalesProperties.textColor': scaleFontColor,
          'scalesProperties.lineColor': scaleLineColor,
          'scalesProperties.showLeftScale': false,
          'scalesProperties.showRightScale': true,
          'scalesProperties.backgroundColor': scaleBgColor,
          volumePaneSize: 'large',
          'mainSeriesProperties.candleStyle.upColor': graphUpColor,
          'mainSeriesProperties.candleStyle.downColor': graphDownColor,
          'mainSeriesProperties.candleStyle.borderUpColor': graphBorderUpColor,
          'mainSeriesProperties.candleStyle.borderDownColor': graphBorderDownColor,
          'mainSeriesProperties.candleStyle.drawWick': true,
          'mainSeriesProperties.hollowCandleStyle.upColor': graphUpColor,
          'mainSeriesProperties.hollowCandleStyle.downColor': bgColor,
          'mainSeriesProperties.hollowCandleStyle.borderUpColor': graphBorderUpColor,
          'mainSeriesProperties.hollowCandleStyle.borderDownColor': graphBorderDownColor,
          'mainSeriesProperties.hollowCandleStyle.drawWick': false,
          'mainSeriesProperties.haStyle.upColor': graphUpColor,
          'mainSeriesProperties.haStyle.downColor': graphDownColor,
          'mainSeriesProperties.haStyle.borderUpColor': graphBorderUpColor,
          'mainSeriesProperties.haStyle.borderDownColor': graphBorderDownColor,
          'mainSeriesProperties.haStyle.drawWick': false,
          'mainSeriesProperties.barStyle.upColor': graphUpColor,
          'mainSeriesProperties.barStyle.downColor': graphDownColor,
          'mainSeriesProperties.lineStyle.color': graphUpColor,
          'mainSeriesProperties.lineStyle.linewidth': '4',
          'mainSeriesProperties.areaStyle.color1': graphUpColor,
          'mainSeriesProperties.areaStyle.color2': graphUpOpaqueColor,
          'mainSeriesProperties.areaStyle.linecolor': graphUpColor,
          'mainSeriesProperties.baselineStyle.topFillColor1': graphUpOpaqueColor,
          'mainSeriesProperties.baselineStyle.topFillColor2': graphUpOpaqueColor,
          'mainSeriesProperties.baselineStyle.bottomFillColor1': graphDownOpaqueColor,
          'mainSeriesProperties.baselineStyle.bottomFillColor2': graphDownOpaqueColor,
          'mainSeriesProperties.baselineStyle.topLineColor': graphUpColor,
          'mainSeriesProperties.baselineStyle.bottomLineColor': graphDownColor
        },
        studies_overrides: {
          'volume.volume.color.0': graphDownOpaqueColor,
          'volume.volume.color.1': graphUpOpaqueColor
        }
      };

      var localOverrides = __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].TradingView || {};

      var disabled_features = void 0;
      if ('disabled_features' in localOverrides) {
        disabled_features = [].concat(_toConsumableArray(new Set([].concat(disabledFeatures, _toConsumableArray(localOverrides.disabled_features)))));
      } else {
        disabled_features = disabledFeatures;
      }

      var enabled_features = [];
      if ('enabled_features' in localOverrides) {
        enabled_features = localOverrides.enabled_features.filter(function (item) {
          return !disabledFeatures.includes(item);
        });
      }

      // For some reasons TradingView.onready is not fired, timeout is used as fallback to initialize chart after 1.5 sec
      _this.timeout = setTimeout(function () {
        _this.chart = new TradingView.widget(Object.assign({}, chartOptions, localOverrides, {
          disabled_features: disabled_features,
          enabled_features: enabled_features
        }));
        _this.chart.onChartReady(function () {
          _this.setState({ chartInitialized: true });
        });
      }, 1500);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TVChartComponent, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.initChart();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (!this.props.selectedInstrument.InstrumentId && nextProps.selectedInstrument.InstrumentId) {
        return true;
      }
      return !!window.TradingView && !!nextState && !!nextState.chartInitialized;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.cssVariable = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_cssVarHelper__["a" /* getCSSVar */])();
      this.scripts = {};

      this.script('/vendor/jquery-3.3.1.min.js').then(function () {
        return _this2.script('/vendor/tradingView/charting_library.min.js');
      }).then(function () {
        _this2.initChart();
      });
    }
  }, {
    key: 'initChart',
    value: function initChart() {
      if (!this.props.selectedInstrument.InstrumentId) return;
      this.wsUri = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_wsHelper__["a" /* getGateway */])();
      var timezone = __WEBPACK_IMPORTED_MODULE_3_jstimezonedetect___default.a.determine().name();
      var currentTimezone = timezone ? timezone : __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].TradingView.timezone;

      if (!this.chart) {
        if (!window.tvChartDataFeed) {
          window.tvChartDataFeed = new __WEBPACK_IMPORTED_MODULE_2__services_tradingView_ChartAPI__["a" /* default */].UDFCompatibleDatafeed(this.wsUri, null, this.props.customGateway, currentTimezone, function (increment) {
            return Object(__WEBPACK_IMPORTED_MODULE_11__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(increment);
          });
        }

        this.createChart(window.tvChartDataFeed);
      } else {
        this.chart.setSymbol(this.props.selectedInstrument.Symbol, '15');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      if (this.chart) {
        try {
          this.chart.remove();
        } catch (e) {
          console.warn('silently handled chart error: ', e);
        }
        this.scripts['/vendor/tradingView/charting_library.min.js'].remove();
        this.scripts['/vendor/jquery-3.3.1.min.js'].remove();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: tvChartClasses('', {
            'with-depth-chart': __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].TradingLayout.showDepthChart && window.innerHeight >= 1080
          }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            id: 'trading-view-chart',
            className: tvChartClasses('chart-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], null)
        )
      );
    }
  }]);

  return TVChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TVChartComponent.propTypes = {
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

TVChartComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TVChartComponent);

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_alphapoint__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_alphapoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_alphapoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_wsHelper__ = __webpack_require__(153);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global $ */
/*
 This class implements interaction with UDF-compatible datafeed.

 See UDF protocol reference at
 https://github.com/tradingview/charting_library/wiki/UDF
 */



var ChartAPI = {};

var UDFCompatibleDatafeed = function UDFCompatibleDatafeed(datafeedURL, protocolVersion, customGateway, currentTimezone, getDecimalPlaces) {
  var _this = this;

  _classCallCheck(this, UDFCompatibleDatafeed);

  this.buildBar = function (barData) {
    var barValue = {
      time: barData[0],
      high: barData[1],
      low: barData[2],
      open: barData[3],
      close: barData[4],
      volume: barData[5]
    };
    return barValue;
  };

  this.getBars = function (symbolInfo, resolution, rangeStartDate, rangeEndDate, onDataCallback) {
    var that = _this;

    if (rangeStartDate > 0 && ('' + rangeStartDate).length > 10) {
      throw new Error('Got a JS time instead of Unix one. rangeStartDate: ' + rangeStartDate + ', rangeEndDate: ' + rangeEndDate);
    }

    var interval = 60;
    switch (resolution) {
      case '1':
        interval = 60;
        break;
      case '5':
        interval = 300;
        break;
      case '15':
        interval = 900;
        break;
      case '30':
        interval = 1800;
        break;
      case '60':
        interval = 3600;
        break;
      case '360':
        interval = 21600;
        break;
      case '720':
        interval = 43200;
        break;
      case 'D':
        interval = 86400;
        break;
      case 'W':
        interval = 604800;
        break;
      case 'M':
        interval = 2592000;
        break;
      default:
        interval = 60;
    }

    var newIntervalMs = interval * 1000;

    var req = {};
    req.OMSId = symbolInfo.omsId;
    req.InstrumentId = symbolInfo.instrumentId;
    req.Interval = interval; // interval is seconds
    req.IncludeLastCount = 5000;
    _this.subscriptionIntervalMs = newIntervalMs;
    that.ws.RPCCall('SubscribeTicker', req, function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      data = JSON.parse(data.o);
      var noData = !data.length;
      var bars = [];
      var barsCount = data.length;

      for (var i = 0; i < barsCount; ++i) {
        var barData = data[i];
        var barValue = that.buildBar(barData);
        bars.push(barValue);
      }
      if (barsCount > 0) {
        _this.gotBars = symbolInfo.name;
        _this.lastBar = bars[bars.length - 1];
      } else {
        _this.lastBar = null;
      }
      onDataCallback(bars, {
        version: that._protocolVersion,
        noData: noData,
        nextTime: data.nb || data.nextTime || null
      });

      // Prevent looping when exiting a specified period of time
      var filteredBars = bars.filter(function (item) {
        return item.time >= rangeStartDate * 1000 && item.time <= rangeEndDate * 1000;
      });
      if (filteredBars.length === 0) {
        onDataCallback([], {
          version: that._protocolVersion,
          noData: true,
          nextTime: null
        });
      }
    });
  };

  this.onMessage = function (event) {
    var synchroCallBack = _this._amsynchro[event.i];
    if (synchroCallBack === undefined) {
      if (event.n === 'TickerDataUpdateEvent') {
        var data = JSON.parse(event.o);
        if (_this.callback !== undefined && _this.callback !== null) {
          var newBar = _this.buildBar(data[0]);
          if (_this.lastBar !== null) {
            if (newBar.time - _this.subscriptionIntervalMs < _this.lastBar.time) {
              newBar.time = _this.lastBar.time;
            }
            _this.callback(newBar);
            _this.lastBar = newBar;
          }
        }
      }
    } else if (event.o === '') {
      synchroCallBack({});
    } else if (synchroCallBack != null) {
      synchroCallBack(JSON.parse(event.o));
    }
  };

  this.defaultConfiguration = function () {
    return {
      supports_search: true,
      supports_group_request: false,
      supported_resolutions: [1, 5, 15, 30, 60, 360, 720, 'D', 'W', 'M'],
      supports_marks: false,
      supports_timescale_marks: false
    };
  };

  this.getServerTime = function (callback) {
    if (_this._configuration.supports_time) {
      _this._send(_this._datafeedURL + '/time', {}).done(function (response) {
        callback(+response);
      }).fail(function () {});
    }
  };

  this.on = function (event, callback) {
    if (!Object.prototype.hasOwnProperty.call(_this._callbacks, event)) {
      _this._callbacks[event] = [];
    }

    _this._callbacks[event].push(callback);
    return _this;
  };

  this.onInitialized = function () {
    _this._initializationFinished = true;
    _this._fireEvent('initialized');
  };

  this.onReady = function (callback) {
    var that = _this;
    if (_this._configuration) {
      setTimeout(function () {
        callback(that._configuration);
      }, 0);
    } else {
      _this.on('configuration_ready', function () {
        callback(that._configuration);
      });
    }
  };

  this.resolveSymbol = function (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
    var symbol = {};
    var instrument = _this.instrumentsArray.filter(function (i) {
      return i.Symbol === symbolName;
    })[0];

    if (instrument) {
      // might be DEPRICATED, but anyway can help
      // https://github.com/alphapoint/charting_library_wiki
      var currentDecimalPlaces = _this._getDecimalPlaces(instrument.PriceIncrement) || 2;

      symbol.omsId = instrument.OMSId;
      symbol.name = instrument.Symbol;
      symbol.full_name = instrument.Symbol;
      symbol.description = instrument.Symbol;
      symbol.instrumentId = instrument.InstrumentId;
      symbol.ticker = instrument.Symbol;
      symbol.minmov = 1;
      symbol.pricescale = Math.pow(10, currentDecimalPlaces); // responsible for decimal places for axis`s numbers
      symbol.timezone = _this._timezone;
      symbol.session = '24x7';
      symbol.has_intraday = true;

      setTimeout(function () {
        onSymbolResolvedCallback(symbol);
      }, 0);
    } else if (_this._symbolRetries < 10) {
      _this._symbolRetries++;
      console.log('Symbol resolve retry #' + _this._symbolRetries);
      setTimeout(function () {
        _this.resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback);
      }, 100);
    } else {
      onResolveErrorCallback('Could not resolve ' + symbolName + ' after ' + _this._symbolRetries + ' retries');
    }
  };

  this.searchSymbolsByName = function () {};

  this.searchSymbols = function (searchString, exchange, type, onResultReadyCallback) {
    var MAX_SEARCH_RESULTS = 30;
    if (!_this._configuration) {
      onResultReadyCallback([]);
      return;
    }
    if (_this._configuration.supports_search) {
      _this._send(_this._datafeedURL + '/search', {
        limit: MAX_SEARCH_RESULTS,
        query: searchString.toUpperCase(),
        type: type,
        exchange: exchange
      }).done(function (response) {
        var data = JSON.parse(response);

        for (var i = 0; i < data.length; ++i) {
          if (!data[i].params) {
            data[i].params = [];
          }
        }

        if (typeof data.s === 'undefined' || data.s !== 'error') {
          onResultReadyCallback(data);
        } else {
          onResultReadyCallback([]);
        }
      }).fail(function (reason) {
        onResultReadyCallback([]);
        throw new Error(reason);
      });
    } else {
      if (!_this._symbolSearch) {
        throw new Error('Datafeed error: inconsistent configuration (symbol search)');
      }

      var searchArgument = {
        searchString: searchString,
        exchange: exchange,
        type: type,
        onResultReadyCallback: onResultReadyCallback
      };

      if (_this._initializationFinished) {
        _this._symbolSearch.searchSymbols(searchArgument, MAX_SEARCH_RESULTS);
      } else {
        var that = _this;

        _this.on('initialized', function () {
          that._symbolSearch.searchSymbols(searchArgument, MAX_SEARCH_RESULTS);
        });
      }
    }
  };

  this.subscribeBars = function (symbolInfo, resolution, onRealtimeCallback) {
    _this.callback = onRealtimeCallback;
    _this.unsubscribeReqObj.OMSId = symbolInfo.omsId;
    _this.unsubscribeReqObj.InstrumentId = symbolInfo.instrumentId;
  };

  this.unsubscribeBars = function () {
    var req = _this.unsubscribeReqObj;
    _this.ws.RPCCall('UnsubscribeTicker', req);
  };

  this._setupWithConfiguration = function (configurationData) {
    _this._configuration = configurationData;

    if (!_this._configuration.exchanges) {
      _this._configuration.exchanges = [];
    }

    // @obsolete; remove in 1.5
    var supportedResolutions = _this._configuration.supported_resolutions || _this._configuration.supportedResolutions;
    _this._configuration.supported_resolutions = supportedResolutions;

    // @obsolete; remove in 1.5
    var symbolsTypes = _this._configuration.symbols_types || _this._configuration.symbolsTypes;
    _this._configuration.symbols_types = symbolsTypes;

    if (!_this._configuration.supports_search && !_this._configuration.supports_group_request) {
      throw new Error('Unsupported datafeed configuration. Must either support search, or support group request');
    }
    if (!_this._configuration.supports_search) {
      _this._symbolSearch = new ChartAPI.SymbolSearchComponent(_this);
    }
    if (_this._configuration.supports_group_request) {
      // this component will call onInitialized() by itself
      // this._symbolsStorage = new ChartAPI.SymbolsStorage(this);
    } else {
      _this.onInitialized();
    }
    _this._fireEvent('configuration_ready');
    _this._logMessage('Initialized with ' + JSON.stringify(configurationData));
  };

  this._initialize = function () {
    _this._setupWithConfiguration(_this.defaultConfiguration());

    _this.ws.ws.filter(function (x) {
      return x.n === 'TickerDataUpdateEvent';
    }).subscribe(function (data) {
      data = data.o;
      if (_this.callback !== null) {
        var newBar = _this.buildBar(data[0]);

        if (_this.lastBar !== null && newBar && typeof newBar.time !== 'string') {
          if (newBar.time - _this.subscriptionIntervalMs < _this.lastBar.time) {
            newBar.time = _this.lastBar.time;
          }
          _this.callback(newBar);
          _this.lastBar = newBar;
        }
      }
    });
  };

  this._fireEvent = function (event, argument) {
    if (Object.prototype.hasOwnProperty.call(_this._callbacks, event)) {
      var callbacksChain = _this._callbacks[event];
      for (var i = 0; i < callbacksChain.length; ++i) {
        callbacksChain[i](argument);
      }
      _this._callbacks[event] = [];
    }
  };

  this._logMessage = function (message) {
    if (_this._enableLogging) {
      console.log(message, new Date());
    }
  };

  this._send = function (url, params) {
    var request = url;
    if (params) {
      for (var i = 0; i < Object.keys(params).length; ++i) {
        var key = Object.keys(params)[i];
        var value = encodeURIComponent(params[key]);
        request += (i === 0 ? '?' : '&') + key + '=' + value;
      }
    }

    _this._logMessage('New request: ' + request);

    return $.ajax({
      type: 'GET',
      url: request,
      contentType: 'text/plain'
    });
  };

  this._amsynchro = {};
  this._callbacks = {};
  this._configuration = undefined;
  this._datafeedURL = datafeedURL;
  this._enableLogging = false;
  this._initializationFinished = false;
  this._historyURL = '/history';
  this._protocolVersion = protocolVersion || 2;
  this._symbolSearch = null;
  this._symbolsStorage = null;
  this._symbolResolveURL = '/symbols';
  this._symbolRetries = 0;
  this._timezone = currentTimezone;
  this._getDecimalPlaces = getDecimalPlaces.bind(this);

  this.callback = null;
  this.connected = false;
  this.lastBar = null;
  this.unsubscribeReqObj = {};
  this.gotBars = '';

  this.subscriptionIntervalMs = 0;
  var onopen = this._initialize.bind(this);
  this.ws = new __WEBPACK_IMPORTED_MODULE_0_alphapoint__["APEX"](customGateway ? customGateway : Object(__WEBPACK_IMPORTED_MODULE_1__helpers_wsHelper__["a" /* getGateway */])(), {
    onopen: onopen
  });
  this.ws.getInstruments(function (data) {
    _this.instrumentsArray = JSON.parse(data.o);
  });
  this.ws.ws.filter(function (x) {
    return x.n === 'TickerDataUpdateEvent';
  }).subscribe(function (response) {
    _this.onMessage(response);
  });
}
// BEWARE: this function does not consider symbol's exchange
;

ChartAPI.UDFCompatibleDatafeed = UDFCompatibleDatafeed;
/* harmony default export */ __webpack_exports__["a"] = (ChartAPI);

/***/ }),
/* 1887 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 1888 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lightweight_charts__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_cssVarHelper__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IntervalButtons__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_numberFormatter__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var LightWeightCharts = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].LightWeightCharts,
    global = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].global;
var locale = global.locale;

var cssVar = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cssVarHelper__["a" /* getCSSVar */])();

var bullish = cssVar('--chart__bullish-color');
var bearish = cssVar('--chart__bearish-color');

function makeOHLC(frame) {
  return {
    time: frame[0] / 1000,
    high: frame[1],
    low: frame[2],
    open: frame[3],
    close: frame[4],
    volume: frame[5]
  };
}

function makeValueFrame(frame) {
  var targetIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return {
    time: frame[0] / 1000,
    value: frame[targetIndex]
  };
}

function getFrameFormatter(chartType) {
  if (chartType === 'candlestick') return makeOHLC;
  return function (frame) {
    return makeValueFrame(frame);
  };
}

function getChartConstructor(chartType) {
  if (chartType === 'candlestick') return 'addCandlestickSeries';
  return 'addAreaSeries';
}

function getChartConfig(chartType) {
  if (chartType === 'candlestick') {
    return {
      upColor: bullish,
      downColor: bearish,
      wickUpColor: bullish,
      wickDownColor: bearish,
      borderVisible: false
    };
  }
  return {
    bottomColor: cssVar('--default-price-line-color'),
    topColor: bullish,
    lineColor: bullish,
    lineStyle: 0,
    lineWidth: 2
  };
}

var LightWeightChart = function (_React$Component) {
  _inherits(LightWeightChart, _React$Component);

  function LightWeightChart() {
    _classCallCheck(this, LightWeightChart);

    var _this = _possibleConstructorReturn(this, (LightWeightChart.__proto__ || Object.getPrototypeOf(LightWeightChart)).call(this));

    _this.resizeHandler = function () {
      _this.chart.applyOptions({
        width: _this.chartContainerRef.current.offsetWidth,
        height: _this.chartContainerRef.current.offsetHeight
      });
    };

    _this.chart = null;
    _this.chartContainerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();
    _this.priceSeries = null;
    _this.volumeSeries = null;
    return _this;
  }

  _createClass(LightWeightChart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selectedInstrument = this.props.selectedInstrument;

      var decimals = Object(__WEBPACK_IMPORTED_MODULE_10__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement);

      this.chart = Object(__WEBPACK_IMPORTED_MODULE_2_lightweight_charts__["b" /* createChart */])(this.chartContainerRef.current, {
        height: this.chartContainerRef.current.offsetHeight,
        width: this.chartContainerRef.current.offsetWidth,
        layout: {
          fontFamily: cssVar('--font__typeface'),
          backgroundColor: cssVar('--secondary__bg-color'),
          textColor: cssVar('--font__color-secondary')
        },
        grid: {
          vertLines: {
            color: cssVar('--tv-chart__grid-vertical-color')
          },
          horzLines: {
            color: cssVar('--tv-chart__grid-horizontal-color')
          }
        },
        crosshair: {
          mode: __WEBPACK_IMPORTED_MODULE_2_lightweight_charts__["a" /* CrosshairMode */].Normal
        },
        priceScale: {
          borderColor: cssVar('--tv-chart__scale-font-color')
        },
        timeScale: {
          borderColor: cssVar('--tv-chart__scale-font-color'),
          rightBarStaysOnScroll: true,
          timeVisible: true
        },
        localization: {
          locale: locale,
          dateFormat: LightWeightCharts.dateFormat,
          timeFormatter: function timeFormatter(businessDayOrTimestamp) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lightweight_charts__["c" /* isBusinessDay */])(businessDayOrTimestamp)) {
              return '';
            }
            return Object(__WEBPACK_IMPORTED_MODULE_9__helpers_dateHelper__["d" /* formatTime */])(businessDayOrTimestamp);
          },
          priceFormatter: function priceFormatter(price) {
            return Object(__WEBPACK_IMPORTED_MODULE_11__helpers_numberFormatter__["b" /* formatNumberToLocale */])(price, decimals);
          }
        }
      });

      window.addEventListener('resize', this.resizeHandler);

      var func = getChartConstructor(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].LightWeightCharts.chartType);
      var chartConfig = getChartConfig(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].LightWeightCharts.chartType);

      this.priceSeries = this.chart[func](chartConfig);

      if (__WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].LightWeightCharts.showVolume) {
        this.volumeSeries = this.chart.addHistogramSeries({
          base: 0,
          color: 'rgba(238, 238, 238, 0.2)',
          priceFormat: {
            type: 'volume'
          },
          overlay: true,
          scaleMargins: {
            top: 0.8,
            bottom: 0
          }
        });
      }

      var priceData = [];
      var volData = [];
      this.props.priceData.forEach(function (el) {
        // if (el[8] === this.props.selectedInstrumentId) {
        priceData.push(getFrameFormatter(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].LightWeightCharts.chartType)(el));
        volData.push(makeValueFrame(el, 5));
        // }
      });

      this.priceSeries.setData(priceData);
      this.volumeSeries.setData(volData);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedInstrument !== this.props.selectedInstrument) {
        var decimalPlaces = Object(__WEBPACK_IMPORTED_MODULE_10__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(this.props.selectedInstrument.PriceIncrement);
        this.chart.applyOptions({
          localization: {
            priceFormatter: function priceFormatter(price) {
              return Object(__WEBPACK_IMPORTED_MODULE_11__helpers_numberFormatter__["b" /* formatNumberToLocale */])(price, decimalPlaces);
            }
          }
        });
      }

      if (prevProps.selectedInstrumentId !== this.props.selectedInstrumentId) {
        this.priceSeries.setData([]);
        this.volumeSeries.setData([]);
      }

      if (prevProps.priceData !== this.props.priceData) {
        var priceData = [];
        var volData = [];

        this.props.priceData.forEach(function (el) {
          // if (el[8] === this.props.selectedInstrumentId) {
          priceData.push(getFrameFormatter(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].LightWeightCharts.chartType)(el));
          volData.push(makeValueFrame(el, 5));
          // }
        });

        this.priceSeries.setData(priceData);
        this.volumeSeries.setData(volData);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
      this.chart.remove();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'lightweight-chart' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          id: 'lightweight-chart-container',
          className: 'lightweight-chart',
          ref: this.chartContainerRef
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__IntervalButtons__["a" /* IntervalButtons */], null)
      );
    }
  }]);

  return LightWeightChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  return {
    selectedInstrument: selectedInstrument,
    selectedInstrumentId: selectedInstrument.InstrumentId,
    priceData: __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(state, 'tickers.tickers', []),
    selectedInterval: state.tickers.interval
  };
};

LightWeightChart.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(LightWeightChart));

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return H; });
/* unused harmony export LineStyle */
/* unused harmony export LineType */
/* unused harmony export PriceLineSource */
/* unused harmony export PriceScaleMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Ts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Fi; });
/* unused harmony export isUTCTimestamp */
/* unused harmony export version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fancy_canvas_coordinate_space__ = __webpack_require__(1892);
/*!
 * @license
 * TradingView Lightweight Charts v2.0.0
 * Copyright (c) 2019 TradingView, Inc.
 * Licensed under Apache License 2.0 https://www.apache.org/licenses/LICENSE-2.0
 */
var i,n;function s(t,i){var n,s=((n={})[0]=[],n[1]=[t.lineWidth,t.lineWidth],n[2]=[2*t.lineWidth,2*t.lineWidth],n[3]=[6*t.lineWidth,6*t.lineWidth],n[4]=[t.lineWidth,4*t.lineWidth],n)[i];t.setLineDash(s)}function h(t,i,n,s){t.beginPath();var h=t.lineWidth%2?.5:0;t.moveTo(n,i+h),t.lineTo(s,i+h),t.stroke()}!function(t){t[t.Simple=0]="Simple",t[t.WithSteps=1]="WithSteps"}(i||(i={})),function(t){t[t.Solid=0]="Solid",t[t.Dotted=1]="Dotted",t[t.Dashed=2]="Dashed",t[t.LargeDashed=3]="LargeDashed",t[t.SparseDotted=4]="SparseDotted"}(n||(n={}));var r=function(t,i){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,i){t.__proto__=i}||function(t,i){for(var n in i)i.hasOwnProperty(n)&&(t[n]=i[n])})(t,i)};function u(t,i){function n(){this.constructor=t}r(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}var e=function(){return(e=Object.assign||function(t){for(var i,n=1,s=arguments.length;n<s;n++)for(var h in i=arguments[n])Object.prototype.hasOwnProperty.call(i,h)&&(t[h]=i[h]);return t}).apply(this,arguments)};function o(){for(var t=0,i=0,n=arguments.length;i<n;i++)t+=arguments[i].length;var s=Array(t),h=0;for(i=0;i<n;i++)for(var r=arguments[i],u=0,e=r.length;u<e;u++,h++)s[h]=r[u];return s}function f(t,i){if(!t)throw new Error("Assertion failed"+(i?": "+i:""))}function a(t){if(void 0===t)throw new Error("Value is undefined");return t}function c(t){if(null===t)throw new Error("Value is null");return t}function l(t){return c(a(t))}function v(t){for(var i=[],n=1;n<arguments.length;n++)i[n-1]=arguments[n];for(var s=0,h=i;s<h.length;s++){var r=h[s];for(var u in r)void 0!==r[u]&&("object"!=typeof r[u]||void 0===t[u]?t[u]=r[u]:v(t[u],r[u]))}return t}function d(t){return"number"==typeof t&&isFinite(t)}function M(t){return"number"==typeof t&&t%1==0}function w(t){return"string"==typeof t}function b(t){return!(t<=0||t>0)}function m(t){return"boolean"==typeof t}function p(t){var i,n,s,h=t;if(!h||"object"!=typeof h)return h;for(n in i=Array.isArray(h)?[]:{},h)h.hasOwnProperty(n)&&(s=h[n],i[n]=s&&"object"==typeof s?p(s):s);return i}function g(t){return null!==t}function y(t){return null===t?void 0:t}var k=function(){function t(){this.t=[]}return t.prototype.setRenderers=function(t){this.t=t},t.prototype.draw=function(t,i,n,s){this.t.forEach((function(h){t.save(),h.draw(t,i,n,s),t.restore()}))},t}(),N=function(){function t(){}return t.prototype.draw=function(t,i,n,s){t.save(),t.scale(i,i),this._drawImpl(t,n,s),t.restore()},t.prototype.drawBackground=function(t,i,n,s){t.save(),t.scale(i,i),this._drawBackgroundImpl(t,n,s),t.restore()},t.prototype._drawBackgroundImpl=function(t,i,n){},t}(),S=function(t){function i(){var i=null!==t&&t.apply(this,arguments)||this;return i._data=null,i}return u(i,t),i.prototype.setData=function(t){this._data=t},i.prototype._drawImpl=function(t){if(null!==this._data&&null!==this._data.visibleRange){var i=this._data.visibleRange,n=this._data,s=function(s){t.beginPath();for(var h=i.to-1;h>=i.from;--h){var r=n.items[h];t.moveTo(r.x,r.y),t.arc(r.x,r.y,s,0,2*Math.PI)}t.fill()};t.fillStyle=n.backColor,s(n.radius+2),t.fillStyle=n.lineColor,s(n.radius)}},i}(N);var x,D,C,T,E={from:0,to:1},L=function(){function t(t,i){this.i=new k,this.s=[],this.u=[],this.o=!0,this.l=t,this.v=i,this.i.setRenderers(this.s)}return t.prototype.update=function(t){var i=this,n=this.l.serieses();n.length!==this.s.length&&(this.u=n.map((function(){return{items:[{x:0,y:0,time:0,price:0}],lineColor:"",backColor:i.l.options().layout.backgroundColor,radius:0,visibleRange:null}})),this.s=this.u.map((function(t){var i=new S;return i.setData(t),i})),this.i.setRenderers(this.s)),this.o=!0},t.prototype.renderer=function(t,i,n){return this.o&&(this.M(),this.o=!1),this.i},t.prototype.M=function(){var t=this,i=this.l.serieses(),n=this.v.appliedIndex(),s=this.l.timeScale();i.forEach((function(i,h){var r=t.u[h],u=i.markerDataAtIndex(n);if(null!==u){var e=c(i.firstValue());r.lineColor=i.barColorer().barStyle(n).barColor,r.backColor=t.l.options().layout.backgroundColor,r.radius=u.radius,r.items[0].price=u.price,r.items[0].y=i.priceScale().priceToCoordinate(u.price,e.value),r.items[0].time=n,r.items[0].x=s.indexToCoordinate(n),r.visibleRange=E}else r.visibleRange=null}))},t}(),A=function(){function t(t){this.m=t}return t.prototype.draw=function(t,i,n,r){if(null!==this.m){var u=this.m.vertLine.visible,e=this.m.horzLine.visible;if(u||e){t.save();var o=Math.round(this.m.x*i),f=Math.round(this.m.y*i),a=Math.ceil(this.m.w*i),c=Math.ceil(this.m.h*i);t.lineCap="butt",u&&o>=0&&(t.lineWidth=Math.floor(this.m.vertLine.lineWidth*i),t.strokeStyle=this.m.vertLine.color,t.fillStyle=this.m.vertLine.color,s(t,this.m.vertLine.lineStyle),function(t,i,n,s){t.beginPath();var h=t.lineWidth%2?.5:0;t.moveTo(i+h,n),t.lineTo(i+h,s),t.stroke()}(t,o,0,c)),e&&f>=0&&(t.lineWidth=Math.floor(this.m.horzLine.lineWidth*i),t.strokeStyle=this.m.horzLine.color,t.fillStyle=this.m.horzLine.color,s(t,this.m.horzLine.lineStyle),h(t,f,0,a)),t.restore()}}},t}(),B=function(){function t(t){this.o=!0,this.p={vertLine:{lineWidth:1,lineStyle:0,color:"",visible:!1},horzLine:{lineWidth:1,lineStyle:0,color:"",visible:!1},w:0,h:0,x:0,y:0},this.g=new A(this.p),this.k=t}return t.prototype.update=function(){this.o=!0},t.prototype.renderer=function(t,i){return this.o&&this.M(),this.g},t.prototype.M=function(){var t=this.k.visible(),i=c(this.k.pane()),n=i.model().options().crosshair,s=this.p;s.horzLine.visible=t&&this.k.horzLineVisible(i),s.vertLine.visible=t&&this.k.vertLineVisible(),s.horzLine.lineWidth=n.horzLine.width,s.horzLine.lineStyle=n.horzLine.style,s.horzLine.color=n.horzLine.color,s.vertLine.lineWidth=n.vertLine.width,s.vertLine.lineStyle=n.vertLine.style,s.vertLine.color=n.vertLine.color,s.w=i.width(),s.h=i.height(),s.x=this.k.appliedX(),s.y=this.k.appliedY()},t}(),z={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",feldspar:"#d19275",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4",indianred:"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgreen:"#90ee90",lightgrey:"#d3d3d3",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslateblue:"#8470ff",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",violetred:"#d02090",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"};function V(t){return function(t,i,n){return b(i)?t:i<t?t:i>n?n:Math.round(i)}(0,t,255)}function F(t){return function(t,i,n){return b(i)?t:i<t?t:i>n?n:Math.round(1e4*i)/1e4}(0,t,1)}function P(t){(t=t.toLowerCase())in z&&(t=z[t]);var i,n,s=(i=t,null!==(n=C.re.exec(i))?C.parse(n):null);if(null!==s)return s;var h=function(t){var i=D.re.exec(t);return null!==i?D.parse(i):null}(t);if(null!==h)return h;var r=function(t){var i=x.re.exec(t);return null!==i?x.parse(i):null}(t);if(null!==r)return r;var u=function(t){var i=T.re.exec(t);return null!==i?T.parse(i):null}(t);return null!==u?[u[0],u[1],u[2]]:null}function I(t){var i=P(t);if(null!==i)return i;throw new Error("Passed color string "+t+" does not match any of the known color representations")}function O(t,i){if(i<0||i>255)throw new Error("invalid threshold value, valid values are [0, 255]");return function(t){return.199*t[0]+.687*t[1]+.114*t[2]}(t)>=i?"white":"black"}function R(t){return function(t){return 0===t.indexOf("#")}(t)?t:(n=I(t),s=1,"rgba("+(i=[n[0],n[1],n[2],F(s)])[0]+", "+i[1]+", "+i[2]+", "+i[3]+")");var i,n,s}function W(t){return"black"===O(I(t),160)?"white":"black"}function U(t,i,n,s,h,r){t.fillRect(i,n,r,h),t.fillRect(i+r,n,s-2*r,r),t.fillRect(i+r,n+h-r,s-2*r,r),t.fillRect(i+s-r,n,r,h)}function q(t,i,n){t.save(),t.scale(i,i),n(),t.restore()}function j(t,i,n,s,h,r){t.save(),t.globalCompositeOperation="copy",t.fillStyle=r,t.fillRect(i,n,s,h),t.restore()}!function(t){t.re=/^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/,t.parse=function(t){return[V(parseInt(t[1]+t[1],16)),V(parseInt(t[2]+t[2],16)),V(parseInt(t[3]+t[3],16))]}}(x||(x={})),function(t){t.re=/^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,t.parse=function(t){return[V(parseInt(t[1],16)),V(parseInt(t[2],16)),V(parseInt(t[3],16))]}}(D||(D={})),function(t){t.re=/^rgb\(\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*\)$/,t.parse=function(t){return[V(parseInt(t[1],10)),V(parseInt(t[2],10)),V(parseInt(t[3],10))]}}(C||(C={})),function(t){t.re=/^rgba\(\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?[\d]{0,10}(?:\.\d+)?)\s*\)$/,t.parse=function(t){return[V(parseInt(t[1],10)),V(parseInt(t[2],10)),V(parseInt(t[3],10)),F(parseFloat(t[4]))]}}(T||(T={}));var H,Y=function(){function t(t,i){this.setData(t,i)}return t.prototype.setData=function(t,i){this.m=t,this.N=i},t.prototype.draw=function(t,i,n,s,h,r){if(this.m.visible){t.font=i.font;var u=this.m.tickVisible?i.tickLength:0,e=i.borderSize,o=i.paddingTop,f=i.paddingBottom,a=i.paddingInner,c=i.paddingOuter,l=this.m.text,v=Math.ceil(n.measureText(t,l)),d=i.baselineOffset,M=i.fontSize+o+f,w=Math.ceil(.5*M),b=e+v+a+c+u,m=this.N.coordinate;this.N.fixedCoordinate&&(m=this.N.fixedCoordinate);var p,g,y=(m=Math.round(m))-w,k=y+M,N="right"===h,S=N?s:0,x=Math.ceil(s*r),D=S;if(t.fillStyle=R(this.N.background),t.lineWidth=1,t.lineCap="butt",l){N?(p=S-u,g=(D=S-b)+c):(D=S+b,p=S+u,g=S+e+u+a);var C=Math.max(1,Math.floor(r)),T=Math.max(1,Math.floor(e*r)),E=N?x:0,L=Math.round(y*r),A=Math.round(D*r),B=Math.round(m*r)-Math.floor(.5*r),z=B+C+(B-L),V=Math.round(p*r);t.save(),t.beginPath(),t.moveTo(E,L),t.lineTo(A,L),t.lineTo(A,z),t.lineTo(E,z),t.fill(),t.fillStyle=this.m.borderColor,t.fillRect(N?x-T:0,L,T,z-L),this.m.tickVisible&&(t.fillStyle=this.N.color,t.fillRect(E,B,V-E,C)),t.textAlign="left",t.fillStyle=this.N.color,q(t,r,(function(){t.fillText(l,g,k-f-d)})),t.restore()}}},t.prototype.height=function(t,i){return this.m.visible?t.fontSize+t.paddingTop+t.paddingBottom:0},t}(),K=function(){function t(t){this.S={coordinate:0,color:"#FFF",background:"#000"},this.D={text:"",visible:!1,tickVisible:!0,borderColor:""},this.C={text:"",visible:!1,tickVisible:!1,borderColor:""},this.o=!0,this.T=new(t||Y)(this.D,this.S),this.L=new(t||Y)(this.C,this.S)}return t.prototype.text=function(){return this.D.text},t.prototype.background=function(){return this.S.background},t.prototype.color=function(){return W(this.background())},t.prototype.coordinate=function(){return this.A(),this.S.coordinate},t.prototype.update=function(){this.o=!0},t.prototype.height=function(t,i){return void 0===i&&(i=!1),Math.max(this.T.height(t,i),this.L.height(t,i))},t.prototype.getFixedCoordinate=function(){return this.S.fixedCoordinate||0},t.prototype.setFixedCoordinate=function(t){this.S.fixedCoordinate=t},t.prototype.isVisible=function(){return this.A(),this.D.visible||this.C.visible},t.prototype.isAxisLabelVisible=function(){return this.A(),this.D.visible},t.prototype.isPaneLabelVisible=function(){return this.A(),this.C.visible},t.prototype.renderer=function(){return this.A(),this.T.setData(this.D,this.S),this.L.setData(this.C,this.S),this.T},t.prototype.paneRenderer=function(){return this.A(),this.T.setData(this.D,this.S),this.L.setData(this.C,this.S),this.L},t.prototype.A=function(){this.o&&(this._updateRendererData(this.D,this.C,this.S),this.o=!1)},t}(),$=function(t){function i(i,n,s){var h=t.call(this)||this;return h.k=i,h.B=n,h.V=s,h}return u(i,t),i.prototype._updateRendererData=function(t,i,n){t.visible=!1;var s=this.k.options().horzLine;if(s.labelVisible){var h=this.B.firstValue();if(this.k.visible()&&!this.B.isEmpty()&&null!==h){n.background=s.labelBackgroundColor,n.color=W(s.labelBackgroundColor);var r=this.V(this.B);n.coordinate=r.coordinate,t.text=this.B.formatPrice(r.price,h),t.visible=!0}}},i}(K),_=/[1-9]/g,X=function(){function t(){this.m=null}return t.prototype.setData=function(t){this.m=t},t.prototype.draw=function(t,i,n){var s=this;if(null!==this.m&&!1!==this.m.visible&&0!==this.m.text.length){t.font=i.font;var h=Math.round(i.widthCache.measureText(t,this.m.text,_));if(!(h<=0)){t.save();var r=i.paddingHorizontal,u=h+2*r,e=u/2,o=this.m.width,f=this.m.coordinate,a=Math.floor(f-e)+.5;a<0?(f+=Math.abs(0-a),a=Math.floor(f-e)+.5):a+u>o&&(f-=Math.abs(o-(a+u)),a=Math.floor(f-e)+.5);var l=a+u,v=0+i.borderSize+i.paddingTop+i.fontSize+i.paddingBottom;t.fillStyle=this.m.background;var d=Math.round(a*n),M=Math.round(0*n),w=Math.round(l*n),b=Math.round(v*n);t.fillRect(d,M,w-d,b-M);var m=Math.round(this.m.coordinate*n),p=M,g=Math.round((p+i.borderSize+i.tickLength)*n);t.fillStyle=this.m.color;var y=Math.max(1,Math.floor(n)),k=Math.floor(.5*n);t.fillRect(m-k,p,y,g-p);var N=v-i.baselineOffset-i.paddingBottom;t.textAlign="left",t.fillStyle=this.m.color,q(t,n,(function(){t.fillText(c(s.m).text,a+r,N)})),t.restore()}}},t}(),Z=function(t){function i(i,n,s){var h=t.call(this)||this;return h.o=!0,h.g=new X,h.p={visible:!1,background:"#4c525e",color:"white",text:"",width:0,coordinate:NaN},h.v=i,h.F=n,h.V=s,h}return u(i,t),i.prototype.update=function(){this.o=!0},i.prototype.renderer=function(){return this.o&&(this.M(),this.o=!1),this.g.setData(this.p),this.g},i.prototype.M=function(){var t=this.p;t.visible=!1;var i=this.v.options().vertLine;if(i.labelVisible){var n=this.F.timeScale();if(!n.isEmpty()){var s=n.indexToUserTime(this.v.appliedIndex());t.width=n.width();var h=this.V();h.time&&(t.coordinate=h.coordinate,t.text=n.formatDateTime(c(s)),t.visible=!0,t.background=i.labelBackgroundColor,t.color=W(i.labelBackgroundColor))}}},i}(function(){function t(){this._text="",this._background="#585858",this._coordinate=0}return t.prototype.text=function(){return this._text},t.prototype.background=function(){return this._background},t.prototype.color=function(){return"black"===O(I(this._background),150)?"white":"black"},t.prototype.coordinate=function(){return this._coordinate},t}()),J=function(){function t(){this._priceScale=null,this.P=0}return t.prototype.zorder=function(){return this.P},t.prototype.setZorder=function(t){this.P=t},t.prototype.priceScale=function(){return this._priceScale},t.prototype.setPriceScale=function(t){this._priceScale=t},t.prototype.priceAxisViews=function(t,i){return[]},t.prototype.paneViews=function(t){return[]},t.prototype.timeAxisViews=function(){return[]},t}();!function(t){t[t.Normal=0]="Normal",t[t.Magnet=1]="Magnet"}(H||(H={}));var G=function(t){function i(i,n){var s=t.call(this)||this;s.I=null,s.O=NaN,s.R=0,s.W=!0,s.U=new Map,s.q=!1,s.j=NaN,s.H=NaN,s.Y=NaN,s.K=NaN,s.F=i,s.$=n,s._=new L(i,s);var h,r;s.X=(h=function(){return s.O},r=function(){return s.H},function(t){var i=r(),n=h();if(t===c(s.I).defaultPriceScale())return{price:n,coordinate:i};var u=c(t.firstValue());return{price:t.coordinateToPrice(i,u),coordinate:i}});var u=function(t,i){return function(){return{time:s.F.timeScale().indexToUserTime(t()),coordinate:i()}}}((function(){return s.R}),(function(){return s.appliedX()}));return s.Z=new Z(s,i,u),s.J=new B(s),s}return u(i,t),i.prototype.index=function(){return this.R},i.prototype.options=function(){return this.$},i.prototype.saveOriginCoord=function(t,i){this.Y=t,this.K=i},i.prototype.clearOriginCoord=function(){this.Y=NaN,this.K=NaN},i.prototype.originCoordX=function(){return this.Y},i.prototype.originCoordY=function(){return this.K},i.prototype.setPosition=function(t,i,n){this.q||(this.q=!0),this.W=!0,this.G(t,i,n)},i.prototype.appliedIndex=function(){return this.R},i.prototype.appliedX=function(){return this.j},i.prototype.appliedY=function(){return this.H},i.prototype.visible=function(){return this.W},i.prototype.clearPosition=function(){this.W=!1,this.tt(),this.O=NaN,this.j=NaN,this.H=NaN,this.I=null,this.clearOriginCoord()},i.prototype.paneViews=function(t){return null!==this.I?[this.J,this._]:[]},i.prototype.horzLineVisible=function(t){return t===this.I&&this.$.horzLine.visible},i.prototype.vertLineVisible=function(){return this.$.vertLine.visible},i.prototype.priceAxisViews=function(t,i){this.W&&this.I===t||this.U.clear();var n=[];return this.I===t&&n.push(this.it(this.U,i,this.X)),n},i.prototype.timeAxisViews=function(){return this.W?[this.Z]:[]},i.prototype.pane=function(){return this.I},i.prototype.updateAllViews=function(){this.U.forEach((function(t){return t.update()})),this.Z.update(),this._.update()},i.prototype.nt=function(t){return t&&!t.defaultPriceScale().isEmpty()?t.defaultPriceScale():null},i.prototype.G=function(t,i,n){this.st(t,i,n)&&this.updateAllViews()},i.prototype.st=function(t,i,n){var s=this.j,h=this.H,r=this.O,u=this.R,e=this.I,o=this.nt(n);this.R=t,this.j=isNaN(t)?NaN:this.F.timeScale().indexToCoordinate(t),this.I=n;var f=null!==o?o.firstValue():null;return null!==o&&null!==f?(this.O=i,this.H=o.priceToCoordinate(i,f)):(this.O=NaN,this.H=NaN),s!==this.j||h!==this.H||u!==this.R||r!==this.O||e!==this.I},i.prototype.tt=function(){var t=this.F.serieses().map((function(t){return t.bars().lastIndex()})).filter(g),i=0===t.length?null:Math.max.apply(Math,t);this.R=null!==i?i:NaN},i.prototype.it=function(t,i,n){var s=t.get(i);return void 0===s&&(s=new $(this,i,n),t.set(i,s)),s},i}(J),Q=".",tt="'";function it(t,i){if(!d(t))return"n/a";if(!M(i))throw new TypeError("invalid length");if(i<0||i>16)throw new TypeError("invalid length");if(0===i)return t.toString();return("0000000000000000"+t.toString()).slice(-i)}var nt,st=function(){function t(t,i,n,s){if(i||(i=1),d(t)&&M(t)||(t=100),t<0)throw new TypeError("invalid base");this.B=t,this.ht=i,this.rt=s,n&&void 0!==s&&s>0&&2!==s&&4!==s&&8!==s||(this.ut=n,this.et())}return t.prototype.format=function(t){var i=t<0?"−":"";return t=Math.abs(t),this.ut?i+this.ot(t):i+this.ft(t)},t.prototype.et=function(){if(this._fractionalLength=0,this.B>0&&this.ht>0){var t=this.B;for(this.ut&&this.rt&&(t/=this.rt);t>1;)t/=10,this._fractionalLength++}},t.prototype.ft=function(t){var i;i=this.ut?Math.pow(10,this._fractionalLength||0):this.B/this.ht;var n=Math.floor(t),s="",h=void 0!==this._fractionalLength?this._fractionalLength:NaN;if(i>1){var r=+(Math.round(t*i)-n*i).toFixed(this._fractionalLength);r>=i&&(r-=i,n+=1),s=Q+it(+r.toFixed(this._fractionalLength)*this.ht,h)}else n=Math.round(n*i)/i,h>0&&(s=Q+it(0,h));return n.toFixed(0)+s},t.prototype.ot=function(t){var i=this.B/this.ht,n=Math.floor(t),s=Math.round(t*i)-n*i;if(s===i&&(s=0,n+=1),!this._fractionalLength)throw new Error("_fractionalLength is not calculated");var h="";if(this.rt){var r=s%this.rt,u=it(s=(s-r)/this.rt,this._fractionalLength),e=2===this.rt?["0","5"][r]:8===this.rt?["0","1","2","3","4","5","6","7"][r]:["0","2","5","7"][r];h=u+tt+e}else h=it(s*this.ht,this._fractionalLength);return n.toString()+tt+h},t}(),ht=function(t){function i(i){return void 0===i&&(i=100),t.call(this,i)||this}return u(i,t),i.prototype.format=function(i){return t.prototype.format.call(this,i)+"%"},i}(st),rt=function(){function t(){this.at=[]}return t.prototype.subscribe=function(t,i,n){var s={callback:t,linkedObject:i,singleshot:!0===n};this.at.push(s)},t.prototype.unsubscribe=function(t){var i=this.at.findIndex((function(i){return t===i.callback}));i>-1&&this.at.splice(i,1)},t.prototype.unsubscribeAll=function(t){this.at=this.at.filter((function(i){return i.linkedObject===t}))},t.prototype.fire=function(t,i){var n=o(this.at);this.at=this.at.filter((function(t){return!t.singleshot})),n.forEach((function(n){return n.callback(t,i)}))},t.prototype.hasListeners=function(){return this.at.length>0},t.prototype.destroy=function(){this.at=[]},t}(),ut=function(t){function i(i){var n=t.call(this)||this;return n.F=i,n}return u(i,t),i.prototype.model=function(){return this.F},i.prototype.minMove=function(){return 0},i.prototype.autoscaleInfo=function(t,i){return null},i}(J),et=function(){function t(t,i){this.ct=t,this.lt=i}return t.prototype.equals=function(t){return null!==t&&(this.ct===t.ct&&this.lt===t.lt)},t.prototype.clone=function(){return new t(this.ct,this.lt)},t.prototype.minValue=function(){return this.ct},t.prototype.setMinValue=function(t){this.ct=t},t.prototype.maxValue=function(){return this.lt},t.prototype.setMaxValue=function(t){this.lt=t},t.prototype.length=function(){return this.lt-this.ct},t.prototype.isEmpty=function(){return this.lt===this.ct||Number.isNaN(this.lt)||Number.isNaN(this.ct)},t.prototype.merge=function(i){return null===i?this:new t(Math.min(this.minValue(),i.minValue()),Math.max(this.maxValue(),i.maxValue()))},t.prototype.apply=function(t,i){this.ct=Math.min(this.ct,t),this.lt=Math.max(this.lt,i)},t.prototype.set=function(t,i){this.ct=t,this.lt=i},t.prototype.scaleAroundCenter=function(t){if(d(t)&&0!==this.lt-this.ct){var i=.5*(this.lt+this.ct),n=this.lt-i,s=this.ct-i;n*=t,s*=t,this.lt=i+n,this.ct=i+s}},t.prototype.shift=function(t){d(t)&&(this.lt+=t,this.ct+=t)},t.prototype.containsStrictly=function(t){return t.minValue()>this.ct&&t.maxValue()<this.lt},t}();function ot(t,i,n){return Math.min(Math.max(t,i),n)}function ft(t,i,n){return i-t<=n}function at(t){return t<=0?NaN:Math.log(t)/Math.log(10)}function ct(t){var i=Math.ceil(t);return i%2!=0?i-1:i}function lt(t){var i=Math.ceil(t);return i%2==0?i-1:i}function vt(t,i){var n=100*(t-i)/i;return i<0?-n:n}function dt(t,i){var n=vt(t.minValue(),i),s=vt(t.maxValue(),i);return new et(n,s)}function Mt(t,i){var n=100*(t-i)/i+100;return i<0?-n:n}function wt(t,i){var n=Mt(t.minValue(),i),s=Mt(t.maxValue(),i);return new et(n,s)}function bt(t){var i=Math.abs(t);if(i<1e-8)return 0;var n=at(i+1e-4)+4;return t<0?-n:n}function mt(t){var i=Math.abs(t);if(i<1e-8)return 0;var n=Math.pow(10,i-4)-1e-4;return t<0?-n:n}function pt(t){if(null===t)return null;var i=bt(t.minValue()),n=bt(t.maxValue());return new et(i,n)}!function(t){t[t.LogicalOffset=4]="LogicalOffset",t[t.CoordOffset=1e-4]="CoordOffset"}(nt||(nt={}));var gt=function(){function t(t,i){if(this.vt=t,this.dt=i,function(t){if(t<0)return!1;for(var i=t;i>1;i/=10)if(i%10!=0)return!1;return!0}(this.vt))this.Mt=[2,2.5,2];else{this.Mt=[];for(var n=this.vt;1!==n;){if(n%2==0)this.Mt.push(2),n/=2;else{if(n%5!=0)throw new Error("unexpected base");this.Mt.push(2),this.Mt.push(2.5),n/=5}if(this.Mt.length>100)throw new Error("something wrong with base")}}}return t.prototype.tickSpan=function(t,i,n){for(var s,h,r,u=0===this.vt?0:1/this.vt,e=Math.pow(10,Math.max(0,Math.ceil(at(t-i)))),o=0,f=this.dt[0];;){var a=ft(e,u,1e-9)&&e>u+1e-9,c=ft(e,n*f,1e-9),l=ft(e,1,1e-9);if(!(a&&c&&l))break;e/=f,f=this.dt[++o%this.dt.length]}if(e<=u+1e-9&&(e=u),e=Math.max(1,e),this.Mt.length>0&&(s=e,h=1,r=1e-9,Math.abs(s-h)<r))for(o=0,f=this.Mt[0];ft(e,n*f,1e-9)&&e>u+1e-9;)e/=f,f=this.Mt[++o%this.Mt.length];return e},t}(),yt=function(){function t(t,i,n,s){this.wt=[],this.B=t,this.vt=i,this.bt=n,this.pt=s}return t.prototype.setBase=function(t){if(t<0)throw new Error("base < 0");this.vt=t},t.prototype.tickSpan=function(t,i){if(t<i)throw new Error("high < low");var n=this.B.height(),s=(t-i)*this.gt()/n,h=new gt(this.vt,[2,2.5,2]),r=new gt(this.vt,[2,2,2.5]),u=new gt(this.vt,[2.5,2,2]),e=[];return e.push(h.tickSpan(t,i,s)),e.push(r.tickSpan(t,i,s)),e.push(u.tickSpan(t,i,s)),function(t){if(t.length<1)throw Error("array is empty");for(var i=t[0],n=1;n<t.length;++n)t[n]<i&&(i=t[n]);return i}(e)},t.prototype.rebuildTickMarks=function(){var t=this.B,i=t.firstValue();if(null!==i){var n=t.height(),s=this.bt(n-1,i),h=this.bt(0,i),r=this.B.options().entireTextOnly?this.yt()/2:0,u=r,e=n-1-r,o=Math.max(s,h),f=Math.min(s,h);if(o!==f){for(var a=this.tickSpan(o,f),c=o%a,l=o>=f?1:-1,v=null,d=0,M=o-(c+=c<0?a:0);M>f;M-=a){var w=this.pt(M,i,!0);null!==v&&Math.abs(w-v)<this.gt()||(w<u||w>e||(d<this.wt.length?(this.wt[d].coord=w,this.wt[d].label=t.formatLogical(M)):this.wt.push({coord:w,label:t.formatLogical(M)}),d++,v=w,t.isLog()&&(a=this.tickSpan(M*l,f))))}this.wt.length=d}else this.wt=[]}else this.wt=[]},t.prototype.marks=function(){return this.wt},t.prototype.yt=function(){return this.B.fontSize()},t.prototype.gt=function(){return Math.ceil(2.5*this.yt())},t}(),kt=function(){function t(t){this.kt=t}return t.prototype.format=function(t){var i="";return t<0&&(i="-",t=-t),t<995?i+this.Nt(t):t<999995?i+this.Nt(t/1e3)+"K":t<999999995?(t=1e3*Math.round(t/1e3),i+this.Nt(t/1e6)+"M"):(t=1e6*Math.round(t/1e6),i+this.Nt(t/1e9)+"B")},t.prototype.Nt=function(t){var i=Math.pow(10,this.kt);return((t=Math.round(t*i)/i)>=1e-15&&t<1?t.toFixed(this.kt).replace(/\.?0+$/,""):String(t)).replace(/(\.[1-9]*)0+$/,(function(t,i){return i}))},t}();function Nt(t,i,n,s){if(0!==i.length){var h=i[s.from].x,r=i[s.from].y;t.moveTo(h,r);for(var u=s.from+1;u<s.to;++u){var e=i[u];if(1===n){var o=i[u-1].y,f=e.x;t.lineTo(f,o)}t.lineTo(e.x,e.y)}}}var St=function(t){function i(){var i=null!==t&&t.apply(this,arguments)||this;return i._data=null,i}return u(i,t),i.prototype.setData=function(t){this._data=t},i.prototype._drawImpl=function(t){if(null!==this._data&&0!==this._data.items.length&&null!==this._data.visibleRange){t.lineCap="butt",t.strokeStyle=this._data.lineColor,t.lineWidth=this._data.lineWidth,s(t,this._data.lineStyle),t.lineWidth=1,t.beginPath(),t.moveTo(this._data.items[this._data.visibleRange.from].x,this._data.bottom),t.lineTo(this._data.items[this._data.visibleRange.from].x,this._data.items[this._data.visibleRange.from].y),Nt(t,this._data.items,this._data.lineType,this._data.visibleRange),t.lineTo(this._data.items[this._data.visibleRange.to-1].x,this._data.bottom),t.lineTo(this._data.items[this._data.visibleRange.from].x,this._data.bottom),t.closePath();var i=t.createLinearGradient(0,0,0,this._data.bottom);i.addColorStop(0,this._data.topColor),i.addColorStop(1,this._data.bottomColor),t.fillStyle=i,t.fill()}},i}(N),xt=function(t){function i(){var i=null!==t&&t.apply(this,arguments)||this;return i._data=null,i}return u(i,t),i.prototype.setData=function(t){this._data=t},i.prototype._drawImpl=function(t){null!==this._data&&0!==this._data.items.length&&null!==this._data.visibleRange&&(t.lineCap="square",t.lineWidth=this._data.lineWidth,s(t,this._data.lineStyle),t.strokeStyle=this._data.lineColor,t.lineJoin="miter",t.beginPath(),Nt(t,this._data.items,this._data.lineType,this._data.visibleRange),t.stroke())},i}(N);function Dt(t,i,n,s,h){void 0===s&&(s=0),void 0===h&&(h=t.length);for(var r=h-s;0<r;){var u=r>>1,e=s+u;n(t[e],i)?(s=e+1,r-=u+1):r=u}return s}function Ct(t,i,n,s,h){void 0===s&&(s=0),void 0===h&&(h=t.length);for(var r=h-s;0<r;){var u=r>>1,e=s+u;n(i,t[e])?r=u:(s=e+1,r-=u+1)}return s}function Tt(t,i){return t.time<i}function Et(t,i){return t<i.time}function Lt(t,i,n){var s=i.firstBar(),h=i.lastBar(),r=Dt(t,s,Tt),u=Ct(t,h,Et);if(!n)return{from:r,to:u};var e=r,o=u;return r>0&&r<t.length&&t[r].time>=s&&(e=r-1),u>0&&u<t.length&&t[u-1].time<=h&&(o=u+1),{from:e,to:o}}var At=function(){function t(t,i,n){this._invalidated=!0,this._dataInvalidated=!0,this._items=[],this._itemsVisibleRange=null,this._series=t,this._model=i,this.St=n}return t.prototype.update=function(t){this._invalidated=!0,"data"===t&&(this._dataInvalidated=!0)},t.prototype._makeValid=function(){this._dataInvalidated&&(this._fillRawPoints(),this._dataInvalidated=!1),this._invalidated&&(this._updatePoints(),this._invalidated=!1)},t.prototype._clearVisibleRange=function(){this._itemsVisibleRange=null},t.prototype._updatePoints=function(){var t=this._series.priceScale(),i=this._model.timeScale();if(this._clearVisibleRange(),!i.isEmpty()&&!t.isEmpty()){var n=i.visibleBars();if(null!==n&&0!==this._series.data().bars().size()){var s=this._series.firstValue();null!==s&&(this._itemsVisibleRange=Lt(this._items,n,this.St),this._convertToCoordinates(t,i,s.value))}}},t}(),Bt=function(t){function i(i,n){return t.call(this,i,n,!0)||this}return u(i,t),i.prototype._convertToCoordinates=function(t,i,n){i.indexesToCoordinates(this._items,y(this._itemsVisibleRange)),t.pointsArrayToCoordinates(this._items,n,y(this._itemsVisibleRange))},i.prototype._createRawItemBase=function(t,i){return{time:t,price:i,x:NaN,y:NaN}},i.prototype._fillRawPoints=function(){var t=this,i=this._series.barFunction(),n=[],s=this._series.barColorer();this._series.bars().each((function(h,r){var u=i(r.value),e=t._createRawItem(h,u,s);return n.push(e),!1})),this._items=n},i}(At),zt=function(t){function i(i,n){var s=t.call(this,i,n)||this;return s.g=new k,s.xt=new St,s.Dt=new xt,s.g.setRenderers([s.xt,s.Dt]),s}return u(i,t),i.prototype.renderer=function(t,i){this._makeValid();var n=this._series.options(),s={lineType:n.lineType,items:this._items,lineColor:n.lineColor,lineStyle:n.lineStyle,lineWidth:n.lineWidth,topColor:n.topColor,bottomColor:n.bottomColor,bottom:t,visibleRange:this._itemsVisibleRange};return this.xt.setData(s),this.Dt.setData(s),this.g},i.prototype._createRawItem=function(t,i){return this._createRawItemBase(t,i)},i}(Bt);var Vt,Ft=function(){function t(){this.m=null,this.Ct=0,this.Tt=0}return t.prototype.setData=function(t){this.m=t},t.prototype.draw=function(t,i,n,s){if(null!==this.m&&0!==this.m.bars.length&&null!==this.m.visibleRange){if(this.Ct=Math.max(1,Math.floor(function(t,i){return Math.floor(.3*t*i)}(this.m.barSpacing,i))),this.Ct>=2)Math.floor(i)%2!=this.Ct%2&&this.Ct--;this.Tt=this.m.thinBars?Math.min(this.Ct,Math.floor(i)):this.Ct;for(var h=null,r=this.m.visibleRange.from;r<this.m.visibleRange.to;++r){var u=this.m.bars[r];h!==u.color&&(t.fillStyle=u.color,h=u.color);var e=Math.floor(.5*this.Tt),o=Math.round(u.x*i),f=o-e,a=this.Tt,c=f+a-1,l=Math.round(u.highY*i)-e,v=Math.round(u.lowY*i)+e,d=Math.max(v-l,this.Tt);t.fillRect(f,l,a,d);var M=Math.ceil(1.5*this.Ct);if(this.Tt<=this.Ct){if(this.m.openVisible){var w=o-M,b=Math.max(l,Math.round(u.openY*i)-e),m=b+a-1;m>l+d-1&&(b=(m=l+d-1)-a+1),t.fillRect(w,b,f-w,m-b+1)}var p=o+M,g=Math.max(l,Math.round(u.closeY*i)-e),y=g+a-1;y>l+d-1&&(g=(y=l+d-1)-a+1),t.fillRect(c+1,g,p-c,y-g+1)}}}},t}(),Pt=function(t){function i(i,n){return t.call(this,i,n,!1)||this}return u(i,t),i.prototype._convertToCoordinates=function(t,i,n){i.indexesToCoordinates(this._items,y(this._itemsVisibleRange)),t.barPricesToCoordinates(this._items,n,y(this._itemsVisibleRange))},i.prototype._createDefaultItem=function(t,i,n){return{time:t,open:i.value[0],high:i.value[1],low:i.value[2],close:i.value[3],x:NaN,openY:NaN,highY:NaN,lowY:NaN,closeY:NaN}},i.prototype._fillRawPoints=function(){var t=this,i=[],n=this._series.barColorer();this._series.bars().each((function(s,h){var r=t._createRawItem(s,h,n);return i.push(r),!1})),this._items=i},i}(At),It=function(t){function i(i,n){var s=t.call(this,i,n)||this;return s.g=new Ft,s}return u(i,t),i.prototype.renderer=function(t,i){this._makeValid();var n=this._series.options(),s={bars:this._items,barSpacing:this._model.timeScale().barSpacing(),openVisible:n.openVisible,thinBars:n.thinBars,visibleRange:this._itemsVisibleRange};return this.g.setData(s),this.g},i.prototype._createRawItem=function(t,i,n){return e(e({},this._createDefaultItem(t,i,n)),{color:n.barStyle(t).barColor})},i}(Pt);!function(t){t[t.BarBorderWidth=1]="BarBorderWidth"}(Vt||(Vt={}));var Ot=function(){function t(){this.m=null,this.Ct=0}return t.prototype.setData=function(t){this.m=t},t.prototype.draw=function(t,i,n,s){if(null!==this.m&&0!==this.m.bars.length&&null!==this.m.visibleRange){if(this.Ct=function(t,i){var n=Math.floor(.8*t*i),s=Math.floor(t*i),h=Math.min(n,s-1);return Math.max(1,h)}(this.m.barSpacing,i),this.Ct>=2)Math.floor(i)%2!=this.Ct%2&&this.Ct--;var h=this.m.bars;this.m.wickVisible&&this.Et(t,h,this.m.visibleRange,i),this.m.borderVisible&&this.Lt(t,h,this.m.visibleRange,this.m.barSpacing,i);var r=this.At(i);(!this.m.borderVisible||this.Ct>2*r)&&this.Bt(t,h,this.m.visibleRange,i)}},t.prototype.Et=function(t,i,n,s){if(null!==this.m){var h="",r=Math.min(Math.floor(s),Math.floor(this.m.barSpacing*s));r=Math.min(r,this.Ct);for(var u=Math.floor(.5*r),e=n.from;e<n.to;e++){var o=i[e];o.wickColor!==h&&(t.fillStyle=o.wickColor,h=o.wickColor);var f=Math.round(Math.min(o.openY,o.closeY)*s),a=Math.round(Math.max(o.openY,o.closeY)*s),c=Math.round(o.highY*s),l=Math.round(o.lowY*s),v=Math.round(s*o.x);t.fillRect(v-u,c,r,f-c),t.fillRect(v-u,a+1,r,l-a)}}},t.prototype.At=function(t){var i=Math.floor(1*t);this.Ct<=2*i&&(i=Math.floor(.5*(this.Ct-1)));var n=Math.max(1,i);return this.Ct<=2*n?Math.floor(1*t):n},t.prototype.Lt=function(t,i,n,s,h){for(var r="",u=this.At(h),e=n.from;e<n.to;e++){var o=i[e];o.borderColor!==r&&(t.fillStyle=o.borderColor,r=o.borderColor);var f=Math.round(o.x*h)-Math.floor(.5*this.Ct),a=f+this.Ct-1,c=Math.round(Math.min(o.openY,o.closeY)*h),l=Math.round(Math.max(o.openY,o.closeY)*h);s>2*u?U(t,f,c,a-f+1,l-c+1,u):t.fillRect(f,c,a-f+1,l-c+1)}},t.prototype.Bt=function(t,i,n,s){if(null!==this.m)for(var h="",r=this.At(s),u=n.from;u<n.to;u++){var e=i[u],o=Math.round(Math.min(e.openY,e.closeY)*s),f=Math.round(Math.max(e.openY,e.closeY)*s),a=Math.round(e.x*s)-Math.floor(.5*this.Ct),c=a+this.Ct-1;if(this.m.borderVisible&&(a+=r,o+=r,c-=r,f-=r),!(o>f)){if(e.color!==h){var l=e.color;t.fillStyle=l,h=l}t.fillRect(a,o,c-a+1,f-o+1)}}},t}(),Rt=function(t){function i(i,n){var s=t.call(this,i,n)||this;return s.g=new Ot,s}return u(i,t),i.prototype.renderer=function(t,i){this._makeValid();var n=this._series.options(),s={bars:this._items,barSpacing:this._model.timeScale().barSpacing(),wickVisible:n.wickVisible,borderVisible:n.borderVisible,visibleRange:this._itemsVisibleRange};return this.g.setData(s),this.g},i.prototype._createRawItem=function(t,i,n){var s=n.barStyle(t);return e(e({},this._createDefaultItem(t,i,n)),{color:s.barColor,wickColor:s.barWickColor,borderColor:s.barBorderColor})},i}(Pt),Wt=function(){function t(){this.m=null,this.zt=[]}return t.prototype.setData=function(t){this.m=t,this.zt=[]},t.prototype.draw=function(t,i,n,s){if(null!==this.m&&0!==this.m.items.length&&null!==this.m.visibleRange){this.zt.length||this.Vt(i);for(var h=Math.round(this.m.histogramBase*i),r=Math.max(1,Math.floor(i)),u=this.m.visibleRange.from;u<this.m.visibleRange.to;u++){var e=this.m.items[u],o=this.zt[u-this.m.visibleRange.from],f=Math.round(e.y*i);t.fillStyle=e.color,t.fillRect(o.left,f,o.right-o.left+1,h-f+r)}}},t.prototype.Vt=function(t){if(null!==this.m&&0!==this.m.items.length&&null!==this.m.visibleRange){var i=Math.ceil(this.m.barSpacing*t)<=3?0:Math.max(1,Math.floor(t)),n=Math.round(this.m.barSpacing*t)-i;this.zt=new Array(this.m.visibleRange.to-this.m.visibleRange.from);for(var s=this.m.visibleRange.from;s<this.m.visibleRange.to;s++){var h,r=this.m.items[s],u=Math.round(r.x*t),e=void 0,o=void 0;if(n%2)e=u-(h=(n-1)/2),o=u+h;else e=u-(h=n/2),o=u+h-1;this.zt[s-this.m.visibleRange.from]={left:e,right:o,roundedCenter:u,center:r.x*t,time:r.time}}for(s=this.m.visibleRange.from+1;s<this.m.visibleRange.to;s++){var f=this.zt[s-this.m.visibleRange.from],a=this.zt[s-this.m.visibleRange.from-1];f.time===a.time+1&&(f.left-a.right!==i+1&&(a.roundedCenter>a.center?a.right=f.left-i-1:f.left=a.right+i+1))}var c=Math.ceil(this.m.barSpacing*t);for(s=this.m.visibleRange.from;s<this.m.visibleRange.to;s++){(f=this.zt[s-this.m.visibleRange.from]).right<f.left&&(f.right=f.left);var l=f.right-f.left+1;c=Math.min(l,c)}if(i>0&&c<4)for(s=this.m.visibleRange.from;s<this.m.visibleRange.to;s++){(l=(f=this.zt[s-this.m.visibleRange.from]).right-f.left+1)>c&&(f.roundedCenter>f.center?f.right-=1:f.left+=1)}}else this.zt=[]},t}();function Ut(t){return{items:[],barSpacing:t,histogramBase:NaN,visibleRange:null}}var qt,jt=function(t){function i(i,n){var s=t.call(this,i,n,!1)||this;return s.i=new k,s.Ft=Ut(0),s.Pt=new Int32Array(0),s.g=new Wt,s}return u(i,t),i.prototype.renderer=function(t,i){return this._makeValid(),this.i},i.prototype._fillRawPoints=function(){var t=this,i=this._model.timeScale().barSpacing(),n=this._series.palette();this.Ft=Ut(i);var s=this._series.barFunction();this.Pt=new Int32Array(this._series.bars().size());var h=0,r=0,u=0,e=this._series.options().color;this._series.bars().each((function(i,o){var f=s(o.value),a=o.value[4],c=function(t,i,n){return{time:t,price:i,x:NaN,y:NaN,color:n}}(i,f,null!=a?n.colorByIndex(a):e),l=null==a?0:a+1;return++r<t.Ft.items.length?t.Ft.items[r]=c:t.Ft.items.push(c),t._items[u++]={time:i,x:0},t.Pt[h++]=l,!1})),this.g.setData(this.Ft),this.i.setRenderers([this.g])},i.prototype._clearVisibleRange=function(){t.prototype._clearVisibleRange.call(this),this.Ft.visibleRange=null},i.prototype._convertToCoordinates=function(t,i,n){if(null!==this._itemsVisibleRange){var s=i.barSpacing(),h=c(i.visibleBars()),r=t.priceToCoordinate(this._series.options().base,n);i.indexesToCoordinates(this.Ft.items),t.pointsArrayToCoordinates(this.Ft.items,n),this.Ft.histogramBase=r,this.Ft.visibleRange=Lt(this.Ft.items,h,!1),this.Ft.barSpacing=s,this.g.setData(this.Ft)}},i}(At),Ht=function(t){function i(i,n){var s=t.call(this,i,n)||this;return s.Dt=new xt,s}return u(i,t),i.prototype.renderer=function(t,i){this._makeValid();var n=this._series.options(),s={items:this._items,lineColor:n.color,lineStyle:n.lineStyle,lineType:n.lineType,lineWidth:n.lineWidth,visibleRange:this._itemsVisibleRange};return this.Dt.setData(s),this.Dt},i.prototype._createRawItem=function(t,i){return this._createRawItemBase(t,i)},i}(Bt),Yt=/[2-9]/g,Kt=function(){function t(t){void 0===t&&(t=50),this.It=0,this.Ot=1,this.Rt=1,this.Wt={},this.Ut={},this.qt=t}return t.prototype.reset=function(){this.It=0,this.Ut={},this.Ot=1,this.Rt=1,this.Wt={}},t.prototype.measureText=function(t,i,n){var s=n||Yt,h=String(i).replace(s,"0");if(this.Ut[h])return this.Ut[h].width;if(this.It===this.qt){var r=this.Wt[this.Rt];delete this.Wt[this.Rt],delete this.Ut[r],this.Rt++,this.It--}var u=t.measureText(h).width;return 0===u&&i.length?0:(this.Ut[h]={width:u,tick:this.Ot},this.Wt[this.Ot]=h,this.It++,this.Ot++,u)},t}(),$t=function(){function t(t){this.jt=null,this.Ht=null,this.Yt="right",this.Kt=0,this.$t=t}return t.prototype.setParams=function(t,i,n,s){this.jt=t,this.Ht=i,this.Kt=n,this.Yt=s},t.prototype.draw=function(t,i){null!==this.Ht&&null!==this.jt&&this.jt.draw(t,this.Ht,this.$t,this.Kt,this.Yt,i)},t}(),_t=function(){function t(t,i,n){this._t=t,this.$t=new Kt(50),this.Xt=i,this.l=n,this.Zt=-1,this.g=new $t(this.$t)}return t.prototype.update=function(){this._t.update()},t.prototype.renderer=function(t,i){var n=this.l.paneForSource(this.Xt);if(null===n)return null;if(null===this.Xt.priceScale())return null;var s=n.priceScalePosition();if("overlay"===s)return null;var h=this.l.priceAxisRendererOptions();return h.fontSize!==this.Zt&&(this.Zt=h.fontSize,this.$t.reset()),this.g.setParams(this._t.paneRenderer(),h,i,s),this.g},t}(),Xt=function(){function t(){this.m=null}return t.prototype.setData=function(t){this.m=t},t.prototype.draw=function(t,i,n,r){if(null!==this.m&&!1!==this.m.visible){var u=Math.round(this.m.y*i);if(!(u<0||u>Math.ceil(this.m.height*i))){var e=Math.ceil(this.m.width*i);t.lineCap="butt",t.strokeStyle=this.m.color,t.lineWidth=Math.floor(this.m.lineWidth*i),s(t,this.m.lineStyle),h(t,u,0,e)}}},t}(),Zt=function(){function t(t){this._lineRendererData={width:0,height:0,y:0,color:"rgba(0, 0, 0, 0)",lineWidth:1,lineStyle:0,visible:!1},this._lineRenderer=new Xt,this.o=!0,this._series=t,this._model=t.model(),this._lineRenderer.setData(this._lineRendererData)}return t.prototype.update=function(){this.o=!0},t.prototype.renderer=function(t,i){return this.o&&(this._updateImpl(t,i),this.o=!1),this._lineRenderer},t}(),Jt=function(t){function i(i){return t.call(this,i)||this}return u(i,t),i.prototype._updateImpl=function(t,i){this._lineRendererData.visible=!1;var n=this._series.priceScale(),s=n.mode().mode;if(2===s||3===s){var h=this._series.options();if(h.baseLineVisible){var r=this._series.firstValue();null!==r&&(this._lineRendererData.visible=!0,this._lineRendererData.y=n.priceToCoordinate(r.value,r.value),this._lineRendererData.width=i,this._lineRendererData.height=t,this._lineRendererData.color=h.baseLineColor,this._lineRendererData.lineWidth=h.baseLineWidth,this._lineRendererData.lineStyle=h.baseLineStyle)}}},i}(Zt);function Gt(t,i){return lt(Math.min(Math.max(t,12),30)*i)}function Qt(t,i){switch(t){case"arrowDown":case"arrowUp":return Gt(i,1);case"circle":return Gt(i,.8);case"square":return Gt(i,.7)}}function ti(t){return ct(Gt(t,1))}function ii(t){return Math.max(Gt(t,.1),3)}function ni(t,i,n,s,h){var r=Qt("square",n),u=(r-1)/2,e=t-u,o=i-u;return s>=e&&s<=e+r&&h>=o&&h<=o+r}function si(t,i,n,s,h,r){var u=(Qt("arrowUp",r)-1)/2,e=(lt(r/2)-1)/2;i.fillStyle=h,i.beginPath(),t?(i.moveTo(n-u,s),i.lineTo(n,s-u),i.lineTo(n+u,s),i.lineTo(n+e,s),i.lineTo(n+e,s+u),i.lineTo(n-e,s+u),i.lineTo(n-e,s)):(i.moveTo(n-u,s),i.lineTo(n,s+u),i.lineTo(n+u,s),i.lineTo(n+e,s),i.lineTo(n+e,s-u),i.lineTo(n-e,s-u),i.lineTo(n-e,s)),i.fill()}function hi(t,i,n,s,h,r){return ni(i,n,s,h,r)}!function(t){t[t.MinShapeSize=12]="MinShapeSize",t[t.MaxShapeSize=30]="MaxShapeSize",t[t.MinShapeMargin=3]="MinShapeMargin"}(qt||(qt={}));var ri=function(t){function i(){var i=null!==t&&t.apply(this,arguments)||this;return i.m=null,i}return u(i,t),i.prototype.setData=function(t){this.m=t},i.prototype.hitTest=function(t,i){if(null===this.m||null===this.m.visibleRange)return null;for(var n=this.m.visibleRange.from;n<this.m.visibleRange.to;n++){var s=this.m.items[n];if(ei(s,t,i))return{hitTestData:s.internalId,externalId:s.externalId}}return null},i.prototype._drawImpl=function(t,i,n){if(null!==this.m&&null!==this.m.visibleRange)for(var s=this.m.visibleRange.from;s<this.m.visibleRange.to;s++){ui(this.m.items[s],t)}},i}(N);function ui(t,i){switch(t.shape){case"arrowDown":return void si(!1,i,t.x,t.y,t.color,t.size);case"arrowUp":return void si(!0,i,t.x,t.y,t.color,t.size);case"circle":return void function(t,i,n,s,h){var r=(Qt("circle",h)-1)/2;t.fillStyle=s,t.beginPath(),t.arc(i,n,r,0,2*Math.PI,!1),t.fill()}(i,t.x,t.y,t.color,t.size);case"square":return void function(t,i,n,s,h){var r=Qt("square",h),u=(r-1)/2,e=i-u,o=n-u;t.fillStyle=s,t.fillRect(e,o,r,r)}(i,t.x,t.y,t.color,t.size)}t.shape}function ei(t,i,n){switch(t.shape){case"arrowDown":case"arrowUp":return hi(0,t.x,t.y,t.size,i,n);case"circle":return function(t,i,n,s,h){var r=2+Qt("circle",n)/2,u=t-s,e=i-h;return Math.sqrt(u*u+e*e)<=r}(t.x,t.y,t.size,i,n);case"square":return ni(t.x,t.y,t.size,i,n)}t.shape}function oi(t,i,n,s,h,r,u,e){var o=d(n)?n:n.close,f=d(n)?n:n.high,a=d(n)?n:n.low,c=ti(u.barSpacing());switch(t.size=c,i.position){case"inBar":return void(t.y=r.priceToCoordinate(o,e));case"aboveBar":return t.y=r.priceToCoordinate(f,e)-c/2-s.aboveBar,void(s.aboveBar+=c+h);case"belowBar":return t.y=r.priceToCoordinate(a,e)+c/2+s.belowBar,void(s.belowBar+=c+h)}i.position}var fi,ai=function(){function t(t,i){this.o=!0,this.Jt=!0,this.Gt=!0,this.Qt=null,this.g=new ri,this.ti=t,this.F=i,this.m={items:[],visibleRange:null}}return t.prototype.update=function(t){this.o=!0,this.Gt=!0,"data"===t&&(this.Jt=!0)},t.prototype.renderer=function(t,i,n){return this.o&&this._makeValid(),this.g.setData(this.m),this.g},t.prototype.autoScaleMargins=function(){if(this.Gt){if(this.ti.indexedMarkers().length>0){var t=this.F.timeScale().barSpacing(),i=ii(t),n=1.5*ti(t)+2*i;this.Qt={above:n,below:n}}else this.Qt=null;this.Gt=!1}return this.Qt},t.prototype._makeValid=function(){var t=this.ti.priceScale(),i=this.F.timeScale(),n=this.ti.indexedMarkers();this.Jt&&(this.m.items=n.map((function(t){return{time:t.time,x:0,y:0,size:0,shape:t.shape,color:t.color,internalId:t.internalId,externalId:t.id}})),this.Jt=!1),this.m.visibleRange=null;var s=i.visibleBars();if(null!==s){var h=this.ti.firstValue();if(null!==h&&0!==this.m.items.length){var r=NaN,u=ii(i.barSpacing()),e={aboveBar:u,belowBar:u};this.m.visibleRange=Lt(this.m.items,s,!0);for(var o=this.m.visibleRange.from;o<this.m.visibleRange.to;o++){var f=n[o];f.time!==r&&(e.aboveBar=u,e.belowBar=u,r=f.time);var a=this.m.items[o];a.x=i.indexToCoordinate(f.time);var c=this.ti.dataAt(f.time);null!==c&&oi(a,f,c,e,u,t,i,h.value)}this.o=!1}}},t}(),ci=function(t){function i(i){return t.call(this,i)||this}return u(i,t),i.prototype._updateImpl=function(t,i){var n=this._lineRendererData;n.visible=!1;var s=this._series.options();if(s.priceLineVisible){var h=this._series.lastValueData(void 0,0===s.priceLineSource);h.noData||(n.visible=!0,n.y=h.coordinate,n.color=this._series.priceLineColor(h.color),n.width=i,n.height=t,n.lineWidth=s.priceLineWidth,n.lineStyle=s.priceLineStyle)}},i}(Zt),li=function(t){function i(i,n){var s=t.call(this)||this;return s.k=i,s.m=n,s}return u(i,t),i.prototype._getSource=function(){return this.k},i.prototype._getData=function(){return this.m},i.prototype._updateRendererData=function(t,i,n){t.visible=!1,i.visible=!1;var s=this.k.options(),h=s.lastValueVisible,r=""!==this.k.title(),u=0===s.seriesLastValueMode,e=this.k.lastValueData(void 0,!1);e.noData||(h&&(t.text=this._axisText(e,h,u),t.visible=0!==t.text.length),(r||u)&&(i.text=this._paneText(e,h,r,u),i.visible=i.text.length>0),n.background=this.k.priceLineColor(e.color),n.color=W(n.background),n.coordinate=e.coordinate,i.borderColor=this.k.model().options().layout.backgroundColor,t.borderColor=n.background)},i.prototype._paneText=function(t,i,n,s){var h="",r=this.k.title();return n&&0!==r.length&&(h+=r+" "),i&&s&&(h+=this.k.priceScale().isPercentage()?t.formattedPriceAbsolute:t.formattedPricePercentage),h.trim()},i.prototype._axisText=function(t,i,n){return i?n?this.k.priceScale().isPercentage()?t.formattedPricePercentage:t.formattedPriceAbsolute:t.text:""},i}(K),vi=function(t){function i(i,n){var s=t.call(this,i)||this;return s.ii=n,s}return u(i,t),i.prototype._updateImpl=function(t,i){var n=this._lineRendererData;n.visible=!1;var s=this.ii.yCoord();if(null!==s){var h=this.ii.options();n.visible=!0,n.y=s,n.color=h.color,n.width=i,n.height=t,n.lineWidth=h.lineWidth,n.lineStyle=h.lineStyle}},i}(Zt),di=function(t){function i(i,n){var s=t.call(this)||this;return s.ti=i,s.ii=n,s}return u(i,t),i.prototype._updateRendererData=function(t,i,n){t.visible=!1,i.visible=!1;var s=this.ii.options();if(s.axisLabelVisible){var h=this.ii.yCoord();null!==h&&(t.text=this.ti.priceScale().formatPriceAbsolute(s.price),t.visible=!0,n.background=s.color,n.color=W(s.color),n.coordinate=h)}},i}(K),Mi=function(){function t(t,i){this.ti=t,this.$=i,this.ni=new vi(t,this),this._t=new di(t,this)}return t.prototype.applyOptions=function(t){v(this.$,t),this.update(),this.ti.model().lightUpdate()},t.prototype.options=function(){return this.$},t.prototype.paneView=function(){return this.ni},t.prototype.priceAxisView=function(){return this._t},t.prototype.update=function(){this.ni.update(),this._t.update()},t.prototype.yCoord=function(){var t=this.ti,i=t.priceScale();if(t.model().timeScale().isEmpty()||i.isEmpty())return null;var n=t.firstValue();return null===n?null:i.priceToCoordinate(this.$.price,n.value)},t}(),wi=function(){function t(){this.si=0,this.hi=new Map,this.ri=new Map}return t.prototype.colorByIndex=function(t){return a(this.ri.get(t))},t.prototype.addColor=function(t){var i=this.hi.get(t);return void 0===i&&(i=this.si++,this.hi.set(t,i),this.ri.set(i,t)),i},t.prototype.clear=function(){this.si=0,this.hi.clear(),this.ri.clear()},t.prototype.size=function(){return this.ri.size},t}(),bi={barColor:"",barBorderColor:"",barWickColor:""},mi=function(){function t(t){this.ti=t}return t.prototype.barStyle=function(t,i){var n=this.ti.seriesType(),s=this.ti.options();switch(n){case"Line":return this.ui(s);case"Area":return this.ei(s);case"Bar":return this.oi(s,t,i);case"Candlestick":return this.fi(s,t,i);case"Histogram":return this.ai(s,t,i)}throw new Error("Unknown chart style")},t.prototype.oi=function(t,i,n){var s=e({},bi),h=t.upColor,r=t.downColor,u=h,o=r,f=c(this.ci(i,n)),a=l(f.value[0])<=l(f.value[3]);return s.barColor=a?h:r,s.barBorderColor=a?u:o,s},t.prototype.fi=function(t,i,n){var s=e({},bi),h=t.upColor,r=t.downColor,u=t.borderUpColor,o=t.borderDownColor,f=t.wickUpColor,a=t.wickDownColor,v=c(this.ci(i,n)),d=l(v.value[0])<=l(v.value[3]);return s.barColor=d?h:r,s.barBorderColor=d?u:o,s.barWickColor=d?f:a,s},t.prototype.ei=function(t){return e(e({},bi),{barColor:t.lineColor})},t.prototype.ui=function(t){return e(e({},bi),{barColor:t.color})},t.prototype.ai=function(t,i,n){var s=e({},bi),h=c(this.ci(i,n)).value[4];if(null!=h){var r=c(this.ti.palette());s.barColor=r.colorByIndex(h)}else s.barColor=t.color;return s},t.prototype.li=function(){return this.ti.bars()},t.prototype.ci=function(t,i){return void 0!==i?i.value:this.li().valueAt(t)},t}();!function(t){t[t.NearestLeft=-1]="NearestLeft",t[t.Exact=0]="Exact",t[t.NearestRight=1]="NearestRight"}(fi||(fi={}));var pi,gi=function(){function t(t,i){void 0===t&&(t=null),void 0===i&&(i=null),this.vi=[],this.di=0,this.Mi=0,this.wi=!1,this.bi=new Map,this.mi=new Map,this.pi=new Map,this.gi=t||new Map,this.yi=i}return t.prototype.clear=function(){this.vi=[],this.di=0,this.Mi=0,this.wi=!1,this.bi.clear(),this.mi.clear(),this.pi.clear()},t.prototype.first=function(){return this.size()>0?this.vi[this.di]:null},t.prototype.last=function(){return this.size()>0?this.vi[this.Mi-1]:null},t.prototype.firstIndex=function(){return this.size()>0?this.ki(this.di):null},t.prototype.lastIndex=function(){return this.size()>0?this.ki(this.Mi-1):null},t.prototype.size=function(){return this.Mi-this.di},t.prototype.isEmpty=function(){return 0===this.size()},t.prototype.contains=function(t){return null!==this.Ni(t,0)},t.prototype.valueAt=function(t){return this.search(t)},t.prototype.add=function(t,i,n){if(this.wi)return!1;var s={index:t,value:n,time:i},h=this.Ni(t,0);return this.mi.clear(),this.pi.clear(),null===h?(this.vi.splice(this.Si(t),0,s),this.di=0,this.Mi=this.vi.length,!0):(this.vi[h]=s,!1)},t.prototype.search=function(t,i,n){void 0===i&&(i=0);var s=this.Ni(t,i,n);if(null===s)return null;var h=this.xi(s);return{index:this.ki(s),time:h.time,value:h.value}},t.prototype.each=function(t){for(var i=this.di;i<this.Mi;++i){if(t(this.ki(i),this.xi(i)))break}},t.prototype.range=function(i,n){var s=new t(this.gi,this.yi);return s.vi=this.vi,s.di=this.Si(i),s.Mi=this.Di(n),s.wi=!0,s},t.prototype.minMaxOnRangeCached=function(t,i,n){if(this.isEmpty())return null;for(var s=null,h=0,r=n;h<r.length;h++){var u=r[h];s=yi(s,this.Ci(t,i,u))}return s},t.prototype.merge=function(t){return this.wi?null:0===t.length?null:this.isEmpty()||t[t.length-1].index<this.vi[0].index?this.Ti(t):t[0].index>this.vi[this.vi.length-1].index?this.Ei(t):1===t.length&&t[0].index===this.vi[this.vi.length-1].index?(this.Li(t[0]),t[0]):this.Ai(t)},t.prototype.remove=function(t){if(this.wi)return null;var i=this.Ni(t,1);if(null===i)return null;var n=this.vi.splice(i);return this.Mi=this.vi.length,this.bi.clear(),this.mi.clear(),this.pi.clear(),n.length>0?n[0]:null},t.prototype.ki=function(t){return this.vi[t].index},t.prototype.xi=function(t){return this.vi[t]},t.prototype.Ni=function(t,i,n){var s=this.Bi(t);if(null===s&&0!==i)switch(i){case-1:return this.zi(t,n);case 1:return this.Vi(t,n);default:throw new TypeError("Unknown search mode")}if(!n||null===s||0===i)return s;switch(i){case-1:return this.Fi(s);case 1:return this.Pi(s);default:throw new TypeError("Unknown search mode")}},t.prototype.Pi=function(t){for(var i=c(this.yi);t<this.Mi&&i(this.xi(t).value);)t+=1;return t===this.Mi?null:t},t.prototype.Fi=function(t){for(var i=c(this.yi);t>=this.di&&i(this.xi(t).value);)t-=1;return t<this.di?null:t},t.prototype.zi=function(t,i){var n=this.Si(t);n>this.di&&(n-=1);var s=n!==this.Mi&&this.ki(n)<t?n:null;return i&&null!==s?this.Fi(s):s},t.prototype.Vi=function(t,i){var n=this.Di(t),s=n!==this.Mi&&t<this.ki(n)?n:null;return i&&null!==s?this.Pi(s):s},t.prototype.Bi=function(t){var i=this.Si(t);return i===this.Mi||t<this.vi[i].index?null:i},t.prototype.Si=function(t){return Dt(this.vi,t,(function(t,i){return t.index<i}),this.di,this.Mi)},t.prototype.Di=function(t){return Ct(this.vi,t,(function(t,i){return i.index>t}),this.di,this.Mi)},t.prototype.Ii=function(t,i,n){var s=null,h=this.gi.get(n.name);if(void 0===h)throw new Error('Plot "'+n.name+'" is not registered');for(var r=t;r<i;r++){var u=h(this.vi[r].value);null==u||Number.isNaN(u)||(null===s?s={min:u,max:u}:(u<s.min&&(s.min=u),u>s.max&&(s.max=u)))}return s},t.prototype.Oi=function(t){var i=Math.floor(t.index/30);this.bi.forEach((function(t){return t.delete(i)}))},t.prototype.Ti=function(t){return f(!this.wi,"collection should not be readonly"),f(0!==t.length,"plotRows should not be empty"),this.mi.clear(),this.pi.clear(),this.bi.clear(),this.vi=t.concat(this.vi),this.di=0,this.Mi=this.vi.length,t[0]},t.prototype.Ei=function(t){return f(!this.wi,"collection should not be readonly"),f(0!==t.length,"plotRows should not be empty"),this.mi.clear(),this.pi.clear(),this.bi.clear(),this.vi=this.vi.concat(t),this.di=0,this.Mi=this.vi.length,t[0]},t.prototype.Li=function(t){f(!this.isEmpty(),"plot list should not be empty"),f(this.vi[this.Mi-1].index===t.index,"last row index should match new row index"),this.Oi(t),this.mi.delete(t.index),this.pi.delete(t.index),this.vi[this.Mi-1]=t},t.prototype.Ai=function(t){return f(0!==t.length,"plot rows should not be empty"),this.mi.clear(),this.pi.clear(),this.bi.clear(),this.vi=function(t,i){var n=function(t,i){var n=t.length,s=i.length,h=n+s,r=0,u=0;for(;r<n&&u<s;)t[r].index<i[u].index?r++:t[r].index>i[u].index?u++:(r++,u++,h--);return h}(t,i),s=new Array(n),h=0,r=0,u=t.length,e=i.length,o=0;for(;h<u&&r<e;)t[h].index<i[r].index?(s[o]=t[h],h++):t[h].index>i[r].index?(s[o]=i[r],r++):(s[o]=i[r],h++,r++),o++;for(;h<u;)s[o]=t[h],h++,o++;for(;r<e;)s[o]=i[r],r++,o++;return s}(this.vi,t),this.di=0,this.Mi=this.vi.length,t[0]},t.prototype.Ci=function(t,i,n){if(this.isEmpty())return null;var s=null,h=c(this.firstIndex()),r=c(this.lastIndex()),u=t-n.offset,e=i-n.offset;u=Math.max(u,h),e=Math.min(e,r);var o=30*Math.ceil(u/30),f=Math.max(o,30*Math.floor(e/30)),a=this.Si(u),l=this.Di(Math.min(e,o,i));s=yi(s,this.Ii(a,l,n));var v=this.bi.get(n.name);void 0===v&&(v=new Map,this.bi.set(n.name,v));for(var d=Math.max(o+1,u);d<f;d+=30){var M=Math.floor(d/30),w=v.get(M);if(void 0===w){var b=this.Si(30*M),m=this.Di(30*(M+1)-1);w=this.Ii(b,m,n),v.set(M,w)}s=yi(s,w)}a=this.Si(f),l=this.Di(e);return s=yi(s,this.Ii(a,l,n))},t}();function yi(t,i){return null===t?i:null===i?t:{min:Math.min(t.min,i.min),max:Math.max(t.max,i.max)}}!function(t){t[t.Open=0]="Open",t[t.High=1]="High",t[t.Low=2]="Low",t[t.Close=3]="Close",t[t.Color=4]="Color"}(pi||(pi={}));var ki={open:function(t){return t[0]},high:function(t){return t[1]},low:function(t){return t[2]},close:function(t){return t[3]},hl2:function(t){return(t[1]+t[2])/2},hlc3:function(t){return(t[1]+t[2]+t[3])/3},ohlc4:function(t){return(t[0]+t[1]+t[2]+t[3])/4}},Ni=["open","high","low","close","hl2","hlc3","ohlc4"];function Si(t){return ki[t]}var xi,Di=function(){function t(){var t;this.Ri=new gi((t=new Map,Ni.forEach((function(i,n){t.set(i,Si(i))})),t))}return t.prototype.bars=function(){return this.Ri},t.prototype.size=function(){return this.Ri.size()},t.prototype.each=function(t){this.Ri.each(t)},t.prototype.clear=function(){this.Ri.clear()},t.prototype.isEmpty=function(){return this.Ri.isEmpty()},t.prototype.first=function(){return this.Ri.first()},t.prototype.last=function(){return this.Ri.last()},t.prototype.search=function(t,i){return this.bars().search(t,i)},t.prototype.valueAt=function(t){return this.search(t)},t}(),Ci=function(t){function i(i,n,s){var h=t.call(this,i)||this;h.m=new Di,h.ni=new ci(h),h.Wi=[],h.Ui=new Jt(h),h.qi=!1,h.ji=null,h.Hi=new wi,h.Yi=[],h.Ki=[],h.$=n,h.$i=s;var r=new li(h,{model:i});return h.U=[r],h._i=new _t(r,h,i),h.Xi(),h.Zi(),h.Ji=h.barFunction(),h.Gi(),h}return u(i,t),i.prototype.destroy=function(){},i.prototype.endOfData=function(){return this.qi},i.prototype.priceLineColor=function(t){return this.$.priceLineColor||t},i.prototype.lastValueData=function(t,i,n){var s={noData:!0},h=this.priceScale();if(this.model().timeScale().isEmpty()||h.isEmpty()||this.data().isEmpty())return s;var r,u,e=this.model().timeScale().visibleBars(),o=this.firstValue();if(null===e||null===o)return s;if(i){var f=this.data().bars().last();if(null===f)return s;r=f,u=f.index}else{var a=this.data().bars().search(e.lastBar(),-1);if(null===a)return s;if(null===(r=this.data().bars().valueAt(a.index)))return s;u=a.index}var c=void 0!==t?r.value[t]:this.Ji(r.value),l=this.barColorer().barStyle(u,{value:r}),v=h.priceToCoordinate(c,o.value);return{noData:!1,price:n?c:void 0,text:h.formatPrice(c,o.value),formattedPriceAbsolute:h.formatPriceAbsolute(c),formattedPricePercentage:h.formatPricePercentage(c,o.value),color:l.barColor,coordinate:v,index:u}},i.prototype.data=function(){return this.m},i.prototype.barColorer=function(){return null!==this.ji?this.ji:(this.ji=new mi(this),this.ji)},i.prototype.options=function(){return this.$},i.prototype.applyOptions=function(t){var i=this.$.overlay;v(this.$,t),this.$.overlay=i,i&&null!==this._priceScale&&void 0!==t.scaleMargins&&this._priceScale.applyOptions({scaleMargins:this.$.scaleMargins}),void 0!==t.priceFormat&&this.Xi(),this.model().updateSource(this)},i.prototype.clearData=function(){this.m.clear(),this.Hi.clear(),this.Gi()},i.prototype.updateData=function(t,i){void 0===i&&(i=!1),i&&this.m.clear(),this.m.bars().merge(t),this.Qi(),this.J.update("data"),this._.update("data");var n=this.model().paneForSource(this);this.model().recalculatePane(n),this.model().updateSource(this),this.model().updateCrosshair(),this.model().lightUpdate()},i.prototype.setMarkers=function(t){this.Yi=t.map((function(t){return e({},t)})),this.Qi();var i=this.model().paneForSource(this);this._.update("data"),this.model().recalculatePane(i),this.model().updateSource(this),this.model().updateCrosshair(),this.model().lightUpdate()},i.prototype.markers=function(){return this.Yi},i.prototype.indexedMarkers=function(){return this.Ki},i.prototype.createPriceLine=function(t){var i=new Mi(this,t);return this.Wi.push(i),this.model().updateSource(this),i},i.prototype.removePriceLine=function(t){var i=this.Wi.indexOf(t);-1!==i&&this.Wi.splice(i,1),this.model().updateSource(this)},i.prototype.palette=function(){return this.Hi},i.prototype.seriesType=function(){return this.$i},i.prototype.firstValue=function(){var t=this.firstBar();return null===t?null:{value:this.Ji(t.value),timePoint:t.time}},i.prototype.firstBar=function(){var t=this.model().timeScale().visibleBars();if(null===t)return null;var i=t.firstBar();return this.data().search(i,1)},i.prototype.bars=function(){return this.m.bars()},i.prototype.nearestIndex=function(t,i){var n=this.nearestData(t,i);return n?n.index:null},i.prototype.nearestData=function(t,i){return M(t)?this.data().search(t,i):null},i.prototype.dataAt=function(t){var i=this.data().valueAt(t);return null===i?null:"Bar"===this.$i||"Candlestick"===this.$i?{open:i.value[0],high:i.value[1],low:i.value[2],close:i.value[3]}:this.barFunction()(i.value)},i.prototype.paneViews=function(){var t=[];this.priceScale()===this.model().mainPriceScale()&&t.push(this.Ui);for(var i=0,n=this.Wi;i<n.length;i++){var s=n[i];t.push(s.paneView())}return t.push(this.J),t.push(this.ni),t.push(this._i),t.push(this._),t},i.prototype.priceAxisViews=function(t,i){for(var n=o(this.U),s=0,h=this.Wi;s<h.length;s++){var r=h[s];n.push(r.priceAxisView())}return n},i.prototype.autoscaleInfo=function(t,i){if(!M(t)||!M(i)||this.data().isEmpty())return null;var n,s="Line"===this.$i||"Area"===this.$i||"Histogram"===this.$i?"close":null,h=null!==(n=null!==s?this.data().bars().minMaxOnRangeCached(t,i,[{name:s,offset:0}]):this.data().bars().minMaxOnRangeCached(t,i,[{name:"low",offset:0},{name:"high",offset:0}]))?new et(n.min,n.max):null;if("Histogram"===this.seriesType()){var r=this.$.base,u=new et(r,r);h=null!==h?h.merge(u):u}return{priceRange:h,margins:this._.autoScaleMargins()}},i.prototype.minMove=function(){return this.$.priceFormat.minMove},i.prototype.formatter=function(){return this.tn},i.prototype.barFunction=function(){return this.Ji},i.prototype.updateAllViews=function(){this.J.update(),this._.update();for(var t=0,i=this.U;t<i.length;t++){i[t].update()}for(var n=0,s=this.Wi;n<s.length;n++){s[n].update()}this.ni.update(),this.Ui.update()},i.prototype.setPriceScale=function(t){this._priceScale!==t&&(this._priceScale=t)},i.prototype.priceScale=function(){return c(this._priceScale)},i.prototype.markerDataAtIndex=function(t){if(!(("Line"===this.$i||"Area"===this.$i)&&this.$.crosshairMarkerVisible))return null;var i=this.m.valueAt(t);return null===i?null:{price:this.Ji(i.value),radius:this.in()}},i.prototype.title=function(){return this.$.title},i.prototype.in=function(){switch(this.$i){case"Line":case"Area":return this.$.crosshairMarkerRadius}return 0},i.prototype.Xi=function(){switch(this.$.priceFormat.type){case"custom":this.tn={format:this.$.priceFormat.formatter};break;case"volume":this.tn=new kt(this.$.priceFormat.precision);break;case"percent":this.tn=new ht(this.$.priceFormat.precision);break;default:var t=Math.pow(10,this.$.priceFormat.precision);this.tn=new st(t,this.$.priceFormat.minMove*t,!1,void 0)}null!==this._priceScale&&this._priceScale.updateFormatter()},i.prototype.Zi=function(){this.Ji=Si("close")},i.prototype.Qi=function(){var t=this.model().timeScale().points();this.Ki=this.Yi.map((function(i,n){return{time:c(t.indexOf(i.time.timestamp,!0)),position:i.position,shape:i.shape,color:i.color,id:i.id,internalId:n}}))},i.prototype.Gi=function(){switch(this._=new ai(this,this.model()),this.$i){case"Bar":this.J=new It(this,this.model());break;case"Candlestick":this.J=new Rt(this,this.model());break;case"Line":this.J=new Ht(this,this.model());break;case"Area":this.J=new zt(this,this.model());break;case"Histogram":this.J=new jt(this,this.model());break;default:throw Error("Unknown chart style assigned: "+this.$i)}},i}(ut);function Ti(t){return t.slice().sort((function(t,i){return c(t.zorder())-c(i.zorder())}))}!function(t){t[t.Normal=0]="Normal",t[t.Logarithmic=1]="Logarithmic",t[t.Percentage=2]="Percentage",t[t.IndexedTo100=3]="IndexedTo100"}(xi||(xi={}));var Ei,Li,Ai=new ht,Bi=new st(100,1),zi=function(){function t(t,i,n){this.nn=0,this.sn=null,this.hn=new rt,this.rn=null,this.un=null,this.en=new rt,this.on={isValid:!1,visibleBars:null},this.fn=0,this.an=0,this.cn=new rt,this.ln=new rt,this.vn=[],this.dn=null,this.Mn=!1,this.wn=null,this.bn=null,this.mn=null,this.pn=null,this.tn=Bi,this.gn=new rt,this.$=t,this.yn=i,this.kn=n,this.Nn=new yt(this,100,this.Sn.bind(this),this.xn.bind(this))}return t.prototype.options=function(){return this.$},t.prototype.applyOptions=function(t){if(v(this.$,t),this.updateFormatter(),void 0!==t.mode&&this.setMode({mode:t.mode}),this.gn.fire(),void 0!==t.scaleMargins){var i=a(t.scaleMargins.top),n=a(t.scaleMargins.bottom);if(i<0||i>1)throw new Error("Invalid top margin - expect value between 0 and 1, given="+i);if(n<0||n>1||i+n>1)throw new Error("Invalid bottom margin - expect value between 0 and 1, given="+n);if(i+n>1)throw new Error("Invalid margins - sum of margins must be less than 1, given="+(i+n));this.Dn(),this.bn=null}},t.prototype.optionsChanged=function(){return this.gn},t.prototype.isAutoScale=function(){return this.$.autoScale},t.prototype.isLog=function(){return 1===this.$.mode},t.prototype.isPercentage=function(){return 2===this.$.mode},t.prototype.isIndexedTo100=function(){return 3===this.$.mode},t.prototype.mode=function(){return{autoScale:this.$.autoScale,isInverted:this.$.invertScale,mode:this.$.mode}},t.prototype.setMode=function(t){var i=this.mode(),n=null;void 0!==t.autoScale&&(this.$.autoScale=t.autoScale),void 0!==t.mode&&(this.$.mode=t.mode,2!==t.mode&&3!==t.mode||(this.$.autoScale=!0),this.on.isValid=!1),1===i.mode&&t.mode!==i.mode&&(!function(t){if(null===t)return!1;var i=mt(t.minValue()),n=mt(t.maxValue());return isFinite(i)&&isFinite(n)}(this.rn)?this.$.autoScale=!0:null!==(n=function(t){if(null===t)return null;var i=mt(t.minValue()),n=mt(t.maxValue());return new et(i,n)}(this.rn))&&this.setPriceRange(n)),1===t.mode&&t.mode!==i.mode&&null!==(n=pt(this.rn))&&this.setPriceRange(n);var s=i.mode!==this.$.mode;s&&(2===i.mode||this.isPercentage())&&this.updateFormatter(),s&&(3===i.mode||this.isIndexedTo100())&&this.updateFormatter(),void 0!==t.isInverted&&i.isInverted!==t.isInverted&&(this.$.invertScale=t.isInverted,this.Cn()),this.ln.fire(i,this.mode())},t.prototype.modeChanged=function(){return this.ln},t.prototype.fontSize=function(){return this.yn.fontSize},t.prototype.height=function(){return this.nn},t.prototype.setHeight=function(t){this.nn!==t&&(this.nn=t,this.Dn(),this.bn=null)},t.prototype.internalHeight=function(){if(this.sn)return this.sn;var t=this.height()-this.Tn()-this.En();return this.sn=t,t},t.prototype.internalHeightChanged=function(){return this.hn},t.prototype.priceRange=function(){return this.Ln(),this.rn},t.prototype.priceRangeChanged=function(){return this.en},t.prototype.setPriceRange=function(t,i,n){var s=this.rn;(i||null===s&&null!==t||null!==s&&!s.equals(t))&&(this.bn=null,this.rn=t,n||this.en.fire(s,t))},t.prototype.isEmpty=function(){return this.Ln(),0===this.nn||!this.rn||this.rn.isEmpty()},t.prototype.invertedCoordinate=function(t){return this.isInverted()?t:this.height()-1-t},t.prototype.priceToCoordinate=function(t,i){return this.isPercentage()?t=vt(t,i):this.isIndexedTo100()&&(t=Mt(t,i)),this.xn(t,i)},t.prototype.pointsArrayToCoordinates=function(t,i,n){this.Ln();for(var s=this.En(),h=c(this.priceRange()),r=h.minValue(),u=h.maxValue(),e=this.internalHeight()-1,o=this.isInverted(),f=e/(u-r),a=void 0===n?0:n.from,l=void 0===n?t.length:n.to,v=this.An(),d=a;d<l;d++){var M=t[d],w=M.price;if(!isNaN(w)){var b=w;null!==v&&(b=v(M.price,i));var m=s+f*(b-r),p=o?m:this.nn-1-m;M.y=p}}},t.prototype.barPricesToCoordinates=function(t,i,n){this.Ln();for(var s=this.En(),h=c(this.priceRange()),r=h.minValue(),u=h.maxValue(),e=this.internalHeight()-1,o=this.isInverted(),f=e/(u-r),a=void 0===n?0:n.from,l=void 0===n?t.length:n.to,v=this.An(),d=a;d<l;d++){var M=t[d],w=M.open,b=M.high,m=M.low,p=M.close;null!==v&&(w=v(M.open,i),b=v(M.high,i),m=v(M.low,i),p=v(M.close,i));var g=s+f*(w-r),y=o?g:this.nn-1-g;M.openY=y,g=s+f*(b-r),y=o?g:this.nn-1-g,M.highY=y,g=s+f*(m-r),y=o?g:this.nn-1-g,M.lowY=y,g=s+f*(p-r),y=o?g:this.nn-1-g,M.closeY=y}},t.prototype.coordinateToPrice=function(t,i){var n=this.Sn(t,i);return this.logicalToPrice(n,i)},t.prototype.logicalToPrice=function(t,i){var n=t;return this.isPercentage()?n=function(t,i){return i<0&&(t=-t),t/100*i+i}(n,i):this.isIndexedTo100()&&(n=function(t,i){return t-=100,i<0&&(t=-t),t/100*i+i}(n,i)),n},t.prototype.dataSources=function(){return this.vn},t.prototype.orderedSources=function(){if(this.dn)return this.dn;for(var t=[],i=0;i<this.vn.length;i++){var n=this.vn[i];null===n.zorder()&&n.setZorder(i+1),t.push(n)}return t=Ti(t),this.dn=t,this.dn},t.prototype.hasSeries=function(){return this.Mn},t.prototype.addDataSource=function(t){-1===this.vn.indexOf(t)&&(t instanceof Ci&&(this.Mn=!0),this.vn.push(t),this.wn=null,this.updateFormatter(),this.invalidateSourcesCache())},t.prototype.removeDataSource=function(t){var i=this.vn.indexOf(t);if(-1===i)throw new Error("source is not attached to scale");this.vn.splice(i,1),t instanceof Ci&&(this.Mn=!1),this.mainSource()||this.setMode({autoScale:!0}),this.wn=null,this.updateFormatter(),this.invalidateSourcesCache()},t.prototype.mainSource=function(){if(null!==this.wn)return this.wn;for(var t=null,i=0;i<this.vn.length;i++){var n=this.vn[i];if(n instanceof Ci){t=n;break}null===t&&n instanceof ut&&(t=n)}return this.wn=t,this.wn},t.prototype.firstValue=function(){for(var t=null,i=0,n=this.vn;i<n.length;i++){var s=n[i];if(s instanceof ut){var h=s.firstValue();if(null===h)continue;(null===t||h.timePoint<t.timePoint)&&(t=h)}}return null===t?null:t.value},t.prototype.isInverted=function(){return this.$.invertScale},t.prototype.marks=function(){return this.bn?this.bn:(this.Nn.rebuildTickMarks(),this.bn=this.Nn.marks(),this.cn.fire(),this.bn)},t.prototype.onMarksChanged=function(){return this.cn},t.prototype.startScale=function(t){this.isPercentage()||this.isIndexedTo100()||null===this.mn&&null===this.un&&(this.isEmpty()||(this.mn=this.nn-t,this.un=c(this.priceRange()).clone()))},t.prototype.scaleTo=function(t){if(!this.isPercentage()&&!this.isIndexedTo100()&&null!==this.mn){this.setMode({autoScale:!1}),(t=this.nn-t)<0&&(t=0);var i=(this.mn+.2*(this.nn-1))/(t+.2*(this.nn-1)),n=c(this.un).clone();i=Math.max(i,.1),n.scaleAroundCenter(i),this.setPriceRange(n)}},t.prototype.endScale=function(){this.isPercentage()||this.isIndexedTo100()||(this.mn=null,this.un=null)},t.prototype.startScroll=function(t){this.isAutoScale()||null===this.pn&&null===this.un&&(this.isEmpty()||(this.pn=t,this.un=c(this.priceRange()).clone()))},t.prototype.scrollTo=function(t){if(!this.isAutoScale()&&null!==this.pn){var i=c(this.priceRange()).length()/(this.internalHeight()-1),n=t-this.pn;this.isInverted()&&(n*=-1);var s=n*i,h=c(this.un).clone();h.shift(s),this.setPriceRange(h,!0),this.bn=null}},t.prototype.endScroll=function(){this.isAutoScale()||null!==this.pn&&(this.pn=null,this.un=null)},t.prototype.formatter=function(){return this.tn||this.updateFormatter(),this.tn},t.prototype.formatPrice=function(t,i){switch(this.$.mode){case 2:return this.formatter().format(vt(t,i));case 3:return this.formatter().format(Mt(t,i));default:return this.Bn(t)}},t.prototype.formatLogical=function(t){switch(this.$.mode){case 2:case 3:return this.formatter().format(t);default:return this.Bn(t)}},t.prototype.formatPriceAbsolute=function(t){return this.Bn(t,this.zn())},t.prototype.formatPricePercentage=function(t,i){return t=vt(t,i),Ai.format(t)},t.prototype.sourcesForAutoScale=function(){return this.vn.filter((function(t){return t instanceof ut}))},t.prototype.recalculatePriceRange=function(t){this.on={visibleBars:t,isValid:!1}},t.prototype.updateAllViews=function(){this.vn.forEach((function(t){return t.updateAllViews()}))},t.prototype.updateFormatter=function(){this.bn=null;var t=this.mainSource(),i=100;null!==t&&(i=Math.round(1/t.minMove())),this.tn=Bi,this.isPercentage()?(this.tn=Ai,i=100):this.isIndexedTo100()?(this.tn=new st(100,1),i=100):null!==t&&(this.tn=t.formatter()),this.Nn=new yt(this,i,this.Sn.bind(this),this.xn.bind(this)),this.Nn.rebuildTickMarks()},t.prototype.invalidateSourcesCache=function(){this.dn=null},t.prototype.Tn=function(){return this.isInverted()?this.$.scaleMargins.bottom*this.height()+this.an:this.$.scaleMargins.top*this.height()+this.fn},t.prototype.En=function(){return this.isInverted()?this.$.scaleMargins.top*this.height()+this.fn:this.$.scaleMargins.bottom*this.height()+this.an},t.prototype.Ln=function(){this.on.isValid||(this.on.isValid=!0,this.Vn())},t.prototype.Dn=function(){this.sn=null,this.hn.fire()},t.prototype.xn=function(t,i){if(this.Ln(),this.isEmpty())return 0;t=this.isLog()&&t?bt(t):t;var n=c(this.priceRange()),s=this.En()+(this.internalHeight()-1)*(t-n.minValue())/n.length();return this.invertedCoordinate(s)},t.prototype.Sn=function(t,i){if(this.Ln(),this.isEmpty())return 0;var n=this.invertedCoordinate(t),s=c(this.priceRange()),h=s.minValue()+s.length()*((n-this.En())/(this.internalHeight()-1));return this.isLog()?mt(h):h},t.prototype.Cn=function(){this.bn=null,this.Nn.rebuildTickMarks()},t.prototype.zn=function(){return c(this.mainSource()).formatter()},t.prototype.Vn=function(){var t=this.on.visibleBars;if(null!==t){for(var i=null,n=0,s=0,h=0,r=this.sourcesForAutoScale();h<r.length;h++){var u=r[h],e=u.firstValue();if(null!==e){var o=u.autoscaleInfo(t.firstBar(),t.lastBar()),f=o&&o.priceRange;if(null!==f){switch(this.$.mode){case 1:f=pt(f);break;case 2:f=dt(f,e.value);break;case 3:f=wt(f,e.value)}i=null===i?f:i.merge(c(f)),null!==o&&null!==o.margins&&(n=Math.max(n,o.margins.above),s=Math.max(n,o.margins.below))}}}if(n===this.fn&&s===this.an||(this.fn=n,this.an=s,this.bn=null,this.Dn()),null!==i){if(i.minValue()===i.maxValue()){var a=this.mainSource(),l=5*(null===a||this.isPercentage()||this.isIndexedTo100()?1:a.minMove());i=new et(i.minValue()-l,i.maxValue()+l)}this.setPriceRange(i)}else null===this.rn&&this.setPriceRange(new et(-.5,.5));this.on.isValid=!0}},t.prototype.An=function(){return this.isPercentage()?vt:this.isIndexedTo100()?Mt:this.isLog()?bt:null},t.prototype.Bn=function(t,i){return void 0===this.kn.priceFormatter?(void 0===i&&(i=this.formatter()),i.format(t)):this.kn.priceFormatter(t)},t}();function Vi(t){void 0!==t.borderColor&&(t.borderUpColor=t.borderColor,t.borderDownColor=t.borderColor),void 0!==t.wickColor&&(t.wickUpColor=t.wickColor,t.wickDownColor=t.wickColor)}function Fi(t){return!d(t)&&!w(t)}function Pi(t){return d(t)}!function(t){t[t.LastPriceAndPercentageValue=0]="LastPriceAndPercentageValue",t[t.LastValueAccordingToScale=1]="LastValueAccordingToScale"}(Ei||(Ei={})),function(t){t[t.LastBar=0]="LastBar",t[t.LastVisible=1]="LastVisible"}(Li||(Li={}));var Ii;function Oi(t,i,n){return void 0!==n?n+=" ":n="",void 0===i&&(i="'Trebuchet MS', Roboto, Ubuntu, sans-serif"),""+n+t+"px "+i}!function(t){t[t.BorderSize=1]="BorderSize",t[t.TickLength=4]="TickLength"}(Ii||(Ii={}));var Ri,Wi=function(){function t(t){this.Ht={borderSize:1,tickLength:4,fontSize:NaN,font:"",fontFamily:"",color:"",paddingBottom:0,paddingInner:0,paddingOuter:0,paddingTop:0,baselineOffset:0},this.l=t}return t.prototype.options=function(){var t=this.Ht,i=this.Zt(),n=this.Fn();return t.fontSize===i&&t.fontFamily===n||(t.fontSize=i,t.fontFamily=n,t.font=Oi(i,n),t.paddingTop=Math.floor(i/3.5),t.paddingBottom=t.paddingTop,t.paddingInner=Math.max(Math.ceil(i/2-t.tickLength/2),0),t.paddingOuter=Math.ceil(i/2+t.tickLength/2),t.baselineOffset=Math.round(i/10)),t.color=this.Pn(),this.Ht},t.prototype.Pn=function(){return this.l.options().layout.textColor},t.prototype.Zt=function(){return this.l.options().layout.fontSize},t.prototype.Fn=function(){return this.l.options().layout.fontFamily},t}(),Ui=function(){function t(){this.m=null}return t.prototype.setData=function(t){this.m=t},t.prototype.draw=function(t,i,n,h){var r=this;if(null!==this.m){var u=Math.floor(i);t.lineWidth=u;var e=Math.ceil(this.m.h*i),o=Math.ceil(this.m.w*i);!function(t,i){t.save(),t.lineWidth%2&&t.translate(.5,.5),i(),t.restore()}(t,(function(){var n=c(r.m);if(n.vertLinesVisible){t.strokeStyle=n.vertLinesColor,s(t,n.vertLineStyle),t.beginPath();for(var h=0,f=n.timeMarks;h<f.length;h++){var a=f[h],l=Math.round(a.coord*i);t.moveTo(l,-u),t.lineTo(l,e+u)}t.stroke()}if(n.horzLinesVisible){t.strokeStyle=n.horzLinesColor,s(t,n.horzLineStyle),t.beginPath();for(var v=0,d=n.priceMarks;v<d.length;v++){var M=d[v],w=Math.round(M.coord*i);t.moveTo(-u,w),t.lineTo(o+u,w)}t.stroke()}}))}},t}(),qi=function(){function t(t){this.g=new Ui,this.o=!0,this.I=t}return t.prototype.update=function(){this.o=!0},t.prototype.renderer=function(t,i){if(this.o){var n=this.I.model().options().grid,s={h:t,w:i,horzLinesVisible:n.horzLines.visible,vertLinesVisible:n.vertLines.visible,horzLinesColor:n.horzLines.color,vertLinesColor:n.vertLines.color,horzLineStyle:n.horzLines.style,vertLineStyle:n.vertLines.style,priceMarks:this.I.defaultPriceScale().marks(),timeMarks:this.I.model().timeScale().marks()||[]};this.g.setData(s),this.o=!1}return this.g},t}(),ji=function(){function t(){this.In=new WeakMap,this.o=!0}return t.prototype.paneViews=function(t){var i=this.In.get(t);return void 0===i&&(i=[new qi(t)],this.In.set(t,i)),this.o&&(i.forEach((function(t){return t.update()})),this.o=!1),i},t.prototype.invalidate=function(){this.o=!0},t}();!function(t){t[t.None=0]="None",t[t.Cursor=1]="Cursor",t[t.Light=2]="Light",t[t.Full=3]="Full"}(Ri||(Ri={}));var Hi=function(){function t(t){this.On=new Map,this.Rn=!1,this.Wn=!1,this.Un=null,this.qn=t}return t.prototype.invalidatePane=function(t,i){var n=function(t,i){return void 0===t?i:{level:Math.max(t.level,i.level),autoScale:t.autoScale||i.autoScale}}(this.On.get(t),i);this.On.set(t,n)},t.prototype.invalidateAll=function(t){this.qn=Math.max(this.qn,t)},t.prototype.fullInvalidation=function(){return this.qn},t.prototype.invalidateForPane=function(t){var i=this.On.get(t);return void 0===i?{level:this.qn}:{level:Math.max(this.qn,i.level),autoScale:i.autoScale}},t.prototype.setFitContent=function(){this.Wn=!0,this.Un=null},t.prototype.getFitContent=function(){return this.Wn},t.prototype.setTargetTimeRange=function(t){this.Un=t,this.Wn=!1},t.prototype.getTargetTimeRange=function(){return this.Un},t.prototype.merge=function(t){var i=this;this.Rn=this.Rn||t.Rn,t.Wn&&this.setFitContent(),t.Un&&this.setTargetTimeRange(t.Un),this.qn=Math.max(this.qn,t.qn),t.On.forEach((function(t,n){i.invalidatePane(n,t)}))},t}(),Yi=function(){function t(t){this.$=t}return t.prototype.align=function(t,i,n){var s=t;if(0===this.$.mode)return s;var h=n.defaultPriceScale(),r=h.firstValue();if(null===r)return s;var u=h.priceToCoordinate(t,r),e=n.dataSources().filter((function(t){return t instanceof Ci})).reduce((function(t,s){if(n.isOverlay(s))return t;var h=s.priceScale(),r=s.bars();if(h.isEmpty()||!r.contains(i))return t;var u=r.valueAt(i);if(null===u)return t;var e=[u.value[3]],o=l(s.firstValue());return t.concat(e.map((function(t){return h.priceToCoordinate(t,o.value)})))}),[]);if(0===e.length)return s;e.sort((function(t,i){return Math.abs(t-u)-Math.abs(i-u)}));var o=e[0];return s=h.coordinateToPrice(o,r)},t}(),Ki=function(){function t(t,i){this.vn=[],this.jn=[],this.nn=0,this.Kt=0,this.Hn=1e3,this.Yn=null,this.dn=null,this.Kn=new rt,this.$n=t,this.F=i,this.model().mainPriceScaleOptionsChanged().subscribe(this.onPriceScaleOptionsChanged.bind(this),this),this._n=this.Xn()}return t.prototype.onPriceScaleOptionsChanged=function(){this._n.applyOptions(this.F.options().priceScale)},t.prototype.destroy=function(){this.model().mainPriceScaleOptionsChanged().unsubscribeAll(this),this._n.modeChanged().unsubscribeAll(this),this.vn.forEach((function(t){t.destroy&&t.destroy()})),this.Kn.fire()},t.prototype.stretchFactor=function(){return this.Hn},t.prototype.setStretchFactor=function(t){this.Hn=t},t.prototype.model=function(){return this.F},t.prototype.width=function(){return this.Kt},t.prototype.height=function(){return this.nn},t.prototype.setWidth=function(t){this.Kt=t,this.updateAllViews()},t.prototype.setHeight=function(t){var i=this;this.nn=t,this._n.setHeight(t),this.vn.forEach((function(n){if(i.isOverlay(n)){var s=n.priceScale();null!==s&&s.setHeight(t)}})),this.updateAllViews()},t.prototype.dataSources=function(){return this.vn},t.prototype.isOverlay=function(t){var i=t.priceScale();return null===i||this._n!==i},t.prototype.addDataSource=function(t,i,n){var s=this.Zn().minZOrder-1;this.Jn(t,i,s)},t.prototype.removeDataSource=function(t){var i=this.vn.indexOf(t);f(-1!==i,"removeDataSource: invalid data source"),this.vn.splice(i,1),t===this.Yn&&(this.Yn=null);var n=this.jn.indexOf(t);-1!==n&&this.jn.splice(n,1);var s=t.priceScale();if(s&&s.dataSources().indexOf(t)>=0&&s.removeDataSource(t),s&&null===s.mainSource()){var h=s.dataSources().length;f(0===h,"Invalid priceScale state: empty mainSource but non-empty data sources="+h),s!==this._n&&s.modeChanged().unsubscribeAll(this)}t instanceof ut&&this.Gn(),s&&t instanceof ut&&(s.invalidateSourcesCache(),this.recalculatePriceScale(s)),this.dn=null},t.prototype.priceScalePosition=function(){var t=this.F.options().priceScale.position;return"none"===t?"overlay":t},t.prototype.startScalePrice=function(t,i){t.startScale(i)},t.prototype.scalePriceTo=function(t,i){t.scaleTo(i),this.updateAllViews()},t.prototype.endScalePrice=function(t){t.endScale()},t.prototype.startScrollPrice=function(t,i){t.startScroll(i)},t.prototype.scrollPriceTo=function(t,i){t.scrollTo(i),this.updateAllViews()},t.prototype.endScrollPrice=function(t){t.endScroll()},t.prototype.setPriceAutoScale=function(t,i){t.setMode({autoScale:i}),this.$n.isEmpty()?t.setPriceRange(null):this.recalculatePriceScale(t)},t.prototype.updateAllViews=function(){this.vn.forEach((function(t){t.updateAllViews()}))},t.prototype.defaultPriceScale=function(){var t=this.mainDataSource(),i=null!==t?t.priceScale():null;return null===i&&(i=this._n),i},t.prototype.mainDataSource=function(){return this.Yn},t.prototype.recalculatePriceScale=function(t){null!==t&&t.isAutoScale()&&this.Qn(t)},t.prototype.resetPriceScale=function(t){var i=this.$n.visibleBars();t.setMode({autoScale:!0}),null!==i&&t.recalculatePriceRange(i),this.updateAllViews()},t.prototype.momentaryAutoScale=function(){this.Qn(this._n)},t.prototype.recalculate=function(){var t=this;this.recalculatePriceScale(this._n),this.vn.forEach((function(i){t.isOverlay(i)&&t.recalculatePriceScale(i.priceScale())})),this.updateAllViews(),this.F.lightUpdate()},t.prototype.isEmpty=function(){return null===this.Yn},t.prototype.containsSeries=function(){return this.vn.some((function(t){return t instanceof Ci}))},t.prototype.orderedSources=function(){return null===this.dn&&(this.dn=Ti(this.vn)),this.dn},t.prototype.onDestroyed=function(){return this.Kn},t.prototype.ts=function(t,i){return"overlay"!==i?this._n:this.Xn(!0)},t.prototype.Qn=function(t){var i=t.sourcesForAutoScale();if(i&&i.length>0&&!this.$n.isEmpty()){var n=this.$n.visibleBars();null!==n&&t.recalculatePriceRange(n)}t.updateAllViews()},t.prototype.Zn=function(){var t=this.orderedSources();if(0===t.length)return{minZOrder:0,maxZOrder:0};for(var i=0,n=0,s=0;s<t.length;s++){var h=t[s].zorder();null!==h&&(h<i&&(i=h),h>n&&(n=h))}return{minZOrder:i,maxZOrder:n}},t.prototype.Jn=function(t,i,n){var s="overlay",h=null;if(!i){var r=this.model().options().priceScale.position;s="none"===r?"overlay":r}t instanceof ut&&(h=this.ts(t,s)),this.vn.push(t),i&&this.jn.push(t),null!==h&&(h.addDataSource(t),t.setPriceScale(h)),t.setZorder(n),this.Gn(),t instanceof ut&&this.recalculatePriceScale(h),this.dn=null},t.prototype.ns=function(t,i,n){i.mode!==n.mode&&this.Qn(t)},t.prototype.Gn=function(){if(null===this.Yn||-1!==this.jn.indexOf(this.Yn)){for(var t=0,i=this.vn;t<i.length;t++){if((h=i[t])instanceof ut&&!this.isOverlay(h))return void this.ss(h)}for(var n=0,s=this.jn;n<s.length;n++){var h;if((h=s[n])instanceof ut)return void this.ss(h)}}},t.prototype.ss=function(t){var i=c(t.priceScale());this.defaultPriceScale().modeChanged().unsubscribeAll(this),i.modeChanged().subscribe(this.ns.bind(this,i),this),this.Yn=t},t.prototype.Xn=function(t){var i=p(this.F.options().priceScale);t&&(i.autoScale=!0,i.mode=0);var n=new zi(i,this.F.options().layout,this.F.options().localization);return n.setHeight(this.height()),n},t}(),$i=function(t){return t.getUTCFullYear()},_i=function(t){return it(function(t){return t.getUTCDate()}(t),2)},Xi=function(t,i){return new Date(t.getUTCFullYear(),t.getUTCMonth(),1).toLocaleString(i,{month:"long"})},Zi=function(t,i){return new Date(t.getUTCFullYear(),t.getUTCMonth(),1).toLocaleString(i,{month:"short"})},Ji=function(t){return it(function(t){return t.getUTCMonth()+1}(t),2)},Gi=function(t){return it($i(t)%100,2)},Qi=function(t){return it($i(t),4)},tn={"'yy MMM dd":function(t,i){return"'"+Gi(t)+" "+Zi(t,i)+" "+_i(t)},"'yy MMMM dd":function(t,i){return"'"+Gi(t)+" "+Xi(t,i)+" "+_i(t)},"yyyy MMM dd":function(t,i){return Qi(t)+" "+Zi(t,i)+" "+_i(t)},"yyyy MMMM dd":function(t,i){return Qi(t)+" "+Xi(t,i)+" "+_i(t)},"dd MMM 'yy":function(t,i){return _i(t)+" "+Zi(t,i)+" '"+Gi(t)},"dd MMMM 'yy":function(t,i){return _i(t)+" "+Xi(t,i)+" '"+Gi(t)},"dd MMM yyyy":function(t,i){return _i(t)+" "+Zi(t,i)+" "+Qi(t)},"dd MMMM yyyy":function(t,i){return _i(t)+" "+Xi(t,i)+" "+Qi(t)},"MMM dd, 'yy":function(t,i){return Zi(t,i)+" "+_i(t)+", '"+Gi(t)},"MMMM dd, 'yy":function(t,i){return Xi(t,i)+" "+_i(t)+", '"+Gi(t)},"MMM dd, yyyy":function(t,i){return Zi(t,i)+" "+_i(t)+", "+Qi(t)},"MMMM dd, yyyy":function(t,i){return Xi(t,i)+" "+_i(t)+", "+Qi(t)},"yyyy-MM-dd":function(t,i){return Qi(t)+"-"+Ji(t)+"-"+_i(t)},"yy-MM-dd":function(t,i){return Gi(t)+"-"+Ji(t)+"-"+_i(t)},"yy/MM/dd":function(t,i){return Gi(t)+"/"+Ji(t)+"/"+_i(t)},"yyyy/MM/dd":function(t,i){return Qi(t)+"/"+Ji(t)+"/"+_i(t)},"yy.MM.dd":function(t,i){return Gi(t)+"."+Ji(t)+"."+_i(t)},"yyyy.MM.dd":function(t,i){return Qi(t)+"."+Ji(t)+"."+_i(t)},"dd-MM-yyyy":function(t,i){return _i(t)+"-"+Ji(t)+"-"+Qi(t)},"dd-MM-yy":function(t,i){return _i(t)+"-"+Ji(t)+"-"+Gi(t)},"dd/MM/yy":function(t,i){return _i(t)+"/"+Ji(t)+"/"+Gi(t)},"dd/MM/yyyy":function(t,i){return _i(t)+"/"+Ji(t)+"/"+Qi(t)},"dd.MM.yy":function(t,i){return _i(t)+"."+Ji(t)+"."+Gi(t)},"dd.MM.yyyy":function(t,i){return _i(t)+"."+Ji(t)+"."+Qi(t)},"MM-dd-yy":function(t,i){return Ji(t)+"-"+_i(t)+"-"+Gi(t)},"MM-dd-yyyy":function(t,i){return Ji(t)+"-"+_i(t)+"-"+Qi(t)},"MM/dd/yy":function(t,i){return Ji(t)+"/"+_i(t)+"/"+Gi(t)},"MM/dd/yyyy":function(t,i){return Ji(t)+"/"+_i(t)+"/"+Qi(t)},"MM.dd.yy":function(t,i){return Ji(t)+"."+_i(t)+"."+Gi(t)},"MM.dd.yyyy":function(t,i){return Ji(t)+"."+_i(t)+"."+Qi(t)}},nn=function(){function t(t,i){void 0===t&&(t="yyyy-MM-dd"),void 0===i&&(i="default"),this.hs=tn[t],this.rs=i}return t.prototype.format=function(t){return this.hs(t,this.rs)},t}(),sn=function(){function t(t){this.us=t||"%h:%m:%s"}return t.prototype.format=function(t){return this.us.replace("%h",it(t.getUTCHours(),2)).replace("%m",it(t.getUTCMinutes(),2)).replace("%s",it(t.getUTCSeconds(),2))},t}(),hn={dateFormat:"yyyy-MM-dd",timeFormat:"%h:%m:%s",dateTimeSeparator:" ",locale:"default"},rn=function(){function t(t){void 0===t&&(t={});var i=e(e({},hn),t);this.es=new nn(i.dateFormat,i.locale),this.os=new sn(i.timeFormat),this.fs=i.dateTimeSeparator}return t.prototype.format=function(t){return""+this.es.format(t)+this.fs+this.os.format(t)},t}(),un=function(){function t(t,i){f(t<=i,"The last bar in the bars range should be greater than or equal to the first bar"),this.as=t,this.cs=i}return t.prototype.firstBar=function(){return this.as},t.prototype.lastBar=function(){return this.cs},t.prototype.count=function(){return this.cs-this.as+1},t.prototype.contains=function(t){return this.as<=t&&t<=this.cs},t.prototype.equals=function(t){return this.as===t.firstBar()&&this.cs===t.lastBar()},t}(),en=function(){function t(t,i){void 0===i&&(i=50),this.It=0,this.Ot=1,this.Rt=1,this.Ut=new Map,this.Wt=new Map,this.ls=t,this.qt=i}return t.prototype.format=function(t){var i=this.Ut.get(t.valueOf());if(void 0!==i)return i.string;if(this.It===this.qt){var n=this.Wt.get(this.Rt);this.Wt.delete(this.Rt),this.Ut.delete(a(n)),this.Rt++,this.It--}var s=this.ls(t);return this.Ut.set(t.valueOf(),{string:s,tick:this.Ot}),this.Wt.set(this.Ot,t.valueOf()),this.It++,this.Ot++,s},t}();function on(t,i){return t.index-i.index}var fn,an,cn=function(){function t(){this.vs=1/0,this.ds=-1/0,this.Ms=new Map,this.ws=[],this.bs=new rt,this.Ut=null,this.ms=NaN}return t.prototype.reset=function(){this.Ms.clear(),this.ws=[],this.vs=1/0,this.ds=-1/0,this.Ut=null,this.bs.fire()},t.prototype.merge=function(t){for(var i=this.ws,n={},s=0,h=t;s<h.length;s++){var r=h[s],u=r.index,e=r.span,o=this.Ms.get(r.index);if(o){if(o.index===r.index&&o.span===r.span){o.time=r.time;continue}this.ps(o)}this.Ms.set(u,r),this.vs>u&&(this.vs=u),this.ds<u&&(this.ds=u),void 0===(f=i[e])&&(f=[],i[e]=f),f.push(r),n[e]=!0}for(e=i.length;e--;){var f;void 0!==(f=i[e])&&(0===f.length&&delete i[e],n[e]&&f.sort(on))}this.Ut=null,this.bs.fire()},t.prototype.indexToTime=function(t){var i=this.Ms.get(t);return void 0===i?null:i.time},t.prototype.nearestIndex=function(t){for(var i=this.vs,n=this.ds;n-i>2;){if(1e3*a(this.Ms.get(i)).time.timestamp===t)return i;if(1e3*a(this.Ms.get(n)).time.timestamp===t)return n;var s=Math.round((i+n)/2);1e3*a(this.Ms.get(s)).time.timestamp>t?n=s:i=s}return i},t.prototype.build=function(t,i){var n=Math.ceil(i/t);if(this.ms===n&&this.Ut)return this.Ut;this.ms=n;for(var s=[],h=this.ws.length;h--;)if(this.ws[h]){var r=s;s=[];for(var u=r.length,e=0,o=a(this.ws[h]),f=o.length,c=1/0,l=-1/0,v=0;v<f;v++){for(var d=o[v],M=d.index;e<u;){var w=r[e],b=w.index;if(!(b<M)){c=b;break}e++,s.push(w),l=b,c=1/0}c-M>=n&&M-l>=n&&(s.push(d),l=M)}for(;e<u;e++)s.push(r[e])}return this.Ut=s,this.Ut},t.prototype.ps=function(t){var i=t.index;if(this.Ms.get(i)===t){this.Ms.delete(i),i<=this.vs&&this.vs++,i>=this.ds&&this.ds--,this.ds<this.vs&&(this.vs=1/0,this.ds=-1/0);var n=a(this.ws[t.span]),s=n.indexOf(t);-1!==s&&n.splice(s,1)}},t}(),ln=function(){function t(){this.vi=[]}return t.prototype.clear=function(){this.vi=[]},t.prototype.size=function(){return this.vi.length},t.prototype.firstIndex=function(){return this.gs(0)},t.prototype.lastIndex=function(){return this.gs(this.vi.length-1)},t.prototype.merge=function(t,i){if(0!==i.length)if(0!==this.vi.length){var n=t;if(n<0){var s=Math.abs(n);if(i.length<s)return;this.vi=new Array(s).concat(this.vi);for(var h=0;h<i.length;++h)this.vi[t+h]=i[h]}else{for(var r=n;r<this.vi.length&&r-n<i.length;++r)this.vi[r]=i[r-n];var u=n+i.length;if(u>this.vi.length){s=u-this.vi.length;for(var e=r;e<r+s;++e)this.vi.push(i[e-n])}}}else this.vi=i},t.prototype.valueAt=function(t){var i=this.ys(t);return null!==i?this.vi[i]:null},t.prototype.indexOf=function(t,i){if(this.vi.length<1)return null;if(t>this.vi[this.vi.length-1].timestamp)return i?this.vi.length-1:null;for(var n=0;n<this.vi.length;++n){if(t===this.vi[n].timestamp)return n;if(t<this.vi[n].timestamp)return i?n:null}return null},t.prototype.closestIndexLeft=function(t){var i=this.vi;if(!i.length)return null;if(Number.isNaN(t.timestamp))return null;var n=i.length-1;if(t>=i[n])return n;var s=0,h=i[s];if(t<h)return null;if(t===h)return s;for(;n>s+1;){var r=s+n>>1,u=i[r];if(u.timestamp>t.timestamp)n=r;else{if(!(u.timestamp<t.timestamp))return u.timestamp===t.timestamp?r:null;s=r}}return s},t.prototype.gs=function(t){return 0<=t&&t<this.size()?t:null},t.prototype.ys=function(t){return 0<=t&&t<this.size()?t:null},t}();!function(t){t[t.DefaultAnimationDuration=400]="DefaultAnimationDuration",t[t.MinBarSpacing=.5]="MinBarSpacing",t[t.MinVisibleBarsCount=2]="MinVisibleBarsCount"}(fn||(fn={})),function(t){t[t.Minute=20]="Minute",t[t.Hour=30]="Hour",t[t.Day=40]="Day",t[t.Week=50]="Week",t[t.Month=60]="Month",t[t.Year=70]="Year"}(an||(an={}));var vn=function(){function t(t,i,n){this.Kt=0,this.ks=null,this.Ns=new ln,this.pn=null,this.mn=null,this.Ss=new cn,this.xs=new Map,this.Ds=null,this.Cs=!0,this.Ts=new rt,this.Es=new rt,this.Ls=null,this.As=null,this.Bs=null,this.zs=[],this.$=i,this.kn=n,this.Vs=i.rightOffset,this.Fs=i.barSpacing,this.F=t,this.Ps()}return t.prototype.options=function(){return this.$},t.prototype.applyLocalizationOptions=function(t){v(this.kn,t),this.Is(),this.Ps()},t.prototype.applyOptions=function(t,i){v(this.$,t),this.$.fixLeftEdge?this.Os():this.Ls=null,void 0!==t.barSpacing&&this.setBarSpacing(t.barSpacing),void 0!==t.rightOffset&&this.setRightOffset(t.rightOffset),this.Is(),this.Ps(),this.Es.fire()},t.prototype.isEmpty=function(){return 0===this.Kt||0===this.Ns.size()},t.prototype.visibleBars=function(){return this.Cs&&(this.Cs=!1,this.Rs()),this.Ds},t.prototype.tickMarks=function(){return this.Ss},t.prototype.points=function(){return this.Ns},t.prototype.width=function(){return this.Kt},t.prototype.setWidth=function(t){if(isFinite(t)&&!(t<=0)&&this.Kt!==t){if(this.$.lockVisibleTimeRangeOnResize&&this.Kt){var i=this.Fs*t/this.Kt;this.Ws(i)}if(null!==this.Ls)if(c(this.visibleBars()).firstBar()<=this.Ls){var n=this.Kt-t;this.Vs-=Math.round(n/this.Fs)+1}this.Kt=t,this.Cs=!0,this.Us(),this.qs()}},t.prototype.indexToCoordinate=function(t){if(this.isEmpty()||!M(t))return 0;var i=this.baseIndex()+this.Vs-t;return this.Kt-(i+.5)*this.Fs},t.prototype.indexesToCoordinates=function(t,i){for(var n=this.baseIndex(),s=void 0===i?0:i.from,h=void 0===i?t.length:i.to,r=s;r<h;r++){var u=t[r].time,e=n+this.Vs-u,o=this.Kt-(e+.5)*this.Fs;t[r].x=o}},t.prototype.indexToUserTime=function(t){return this.Ss.indexToTime(t)},t.prototype.coordinateToIndex=function(t){return Math.ceil(this.js(t))},t.prototype.setRightOffset=function(t){this.Cs=!0,this.Vs=t,this.qs(),this.F.recalculateAllPanes(),this.F.lightUpdate()},t.prototype.barSpacing=function(){return this.Fs},t.prototype.setBarSpacing=function(t){this.Ws(t),this.qs(),this.F.recalculateAllPanes(),this.F.lightUpdate()},t.prototype.rightOffset=function(){return this.Vs},t.prototype.marks=function(){if(this.isEmpty())return null;if(null!==this.Bs)return this.Bs;for(var t=this.Fs,i=5*(this.F.options().layout.fontSize+4),n=Math.round(i/t),s=c(this.visibleBars()),h=Math.max(s.firstBar(),s.firstBar()-n),r=Math.max(s.lastBar(),s.lastBar()-n),u=0,e=0,o=this.Ss.build(t,i);e<o.length;e++){var f=o[e];if(h<=f.index&&f.index<=r){var a=this.Ss.indexToTime(f.index);if(null!==a){if(u<this.zs.length){var l=this.zs[u];l.coord=this.indexToCoordinate(f.index),l.label=this.Hs(a,f.span),l.span=f.span,l.major=!1}else this.zs.push({coord:this.indexToCoordinate(f.index),label:this.Hs(a,f.span),span:f.span,major:!1});u++}}}return this.zs.length=u,this.Bs=this.zs,this.zs},t.prototype.reset=function(){this.Cs=!0,this.Ns=new ln,this.pn=null,this.mn=null,this.Ys(),this.Ss.reset(),this.Ls=null},t.prototype.restoreDefault=function(){this.Cs=!0,this.setBarSpacing(this.$.barSpacing),this.setRightOffset(this.$.rightOffset)},t.prototype.fixLeftEdge=function(){return this.$.fixLeftEdge},t.prototype.setBaseIndex=function(t){this.Cs=!0,this.ks=t,this.qs(),this.Os()},t.prototype.zoom=function(t,i){var n=this.js(t),s=this.barSpacing(),h=s+i*(s/10);this.setBarSpacing(h),this.$.rightBarStaysOnScroll||this.setRightOffset(this.rightOffset()+(n-this.js(t)))},t.prototype.startScale=function(t){this.pn&&this.endScroll(),null===this.mn&&null===this.As&&(this.isEmpty()||(this.mn=t,this.Ks()))},t.prototype.scaleTo=function(t){if(null!==this.As){var i=ot(this.Kt-t,0,this.Kt),n=ot(this.Kt-c(this.mn),0,this.Kt);0!==i&&0!==n&&this.setBarSpacing(this.As.barSpacing*i/n)}},t.prototype.endScale=function(){null!==this.mn&&(this.mn=null,this.Ys())},t.prototype.startScroll=function(t){null===this.pn&&null===this.As&&(this.isEmpty()||(this.pn=t,this.Ks()))},t.prototype.scrollTo=function(t){if(this.Cs=!0,null!==this.pn){var i=(this.pn-t)/this.barSpacing();this.Vs=c(this.As).rightOffset+i,this.Cs=!0,this.qs()}},t.prototype.endScroll=function(){null!==this.pn&&(this.pn=null,this.Ys())},t.prototype.scrollToRealTime=function(){this.scrollToOffsetAnimated(this.$.rightOffset)},t.prototype.scrollToOffsetAnimated=function(t,i){var n=this;if(void 0===i&&(i=400),!isFinite(t))throw new RangeError("offset is required and must be finite number");if(!isFinite(i)||i<=0)throw new RangeError("animationDuration (optional) must be finite positive number");var s=this.Vs,h=(new Date).getTime(),r=function(){var u=((new Date).getTime()-h)/i,e=u>=1,o=e?t:s+(t-s)*u;n.setRightOffset(o),e||setTimeout(r,20)};r()},t.prototype.update=function(t,i,n){if(this.Cs=!0,i.length>0){var s=this.Ns.size();this.Ns.merge(t,i),this.Vs<0&&this.Ns.size()===s+1&&(this.Vs-=1,this.Cs=!0)}this.Ss.merge(n),this.qs()},t.prototype.visibleBarsChanged=function(){return this.Ts},t.prototype.optionsApplied=function(){return this.Es},t.prototype.baseIndex=function(){return this.ks||0},t.prototype.setVisibleRange=function(t){var i=t.count();this.Ws(this.Kt/i),this.Vs=t.lastBar()-this.baseIndex(),this.qs(),this.Cs=!0,this.F.recalculateAllPanes(),this.F.lightUpdate()},t.prototype.fitContent=function(){var t=this.Ns.firstIndex(),i=this.Ns.lastIndex();null!==t&&null!==i&&this.setVisibleRange(new un(t,i+this.$.rightOffset))},t.prototype.setTimePointsRange=function(t){var i=this.points(),n=i.firstIndex(),s=i.lastIndex();if(null!==n&&null!==s){var h=c(i.valueAt(n)).timestamp,r=c(i.valueAt(s)).timestamp,u=new un(c(i.indexOf(Math.max(h,t.from.timestamp),!0)),c(i.indexOf(Math.min(r,t.to.timestamp),!0)));this.setVisibleRange(u)}},t.prototype.formatDateTime=function(t){return void 0!==this.kn.timeFormatter?this.kn.timeFormatter(t.businessDay||t.timestamp):this.$s.format(new Date(1e3*t.timestamp))},t.prototype._s=function(t){return(this.Kt+1-t)/this.Fs},t.prototype.js=function(t){var i=this._s(t),n=this.baseIndex()+this.Vs-i;return Math.round(1e6*n)/1e6},t.prototype.Ws=function(t){var i=this.Fs;this.Fs=t,this.Us(),i!==this.Fs&&(this.Cs=!0,this.Xs())},t.prototype.Rs=function(){if(this.isEmpty())this.Zs(null);else{var t=this.baseIndex(),i=Math.ceil(this.Kt/this.Fs)-1,n=Math.round(this.Vs+t),s=n-i;this.Zs(new un(s,n))}},t.prototype.Us=function(){if(this.Fs<.5&&(this.Fs=.5,this.Cs=!0),0!==this.Kt){var t=.5*this.Kt;this.Fs>t&&(this.Fs=t,this.Cs=!0)}},t.prototype.qs=function(){var t=this.Js();this.Vs>t&&(this.Vs=t,this.Cs=!0);var i=this.Gs();null!==i&&this.Vs<i&&(this.Vs=i,this.Cs=!0)},t.prototype.Gs=function(){var t=this.Ns.firstIndex(),i=this.ks;if(null===t||null===i)return null;if(null!==this.Ls){var n=this.Kt/this.Fs;return this.Ls-i+n-1}return t-i-1+Math.min(2,this.Ns.size())},t.prototype.Js=function(){return this.Kt/this.Fs-Math.min(2,this.Ns.size())},t.prototype.Ks=function(){this.As={barSpacing:this.barSpacing(),rightOffset:this.rightOffset()}},t.prototype.Ys=function(){this.As=null},t.prototype.Hs=function(t,i){var n=this,s=this.xs.get(i);return void 0===s&&(s=new en((function(t){return n.Qs(t,i)})),this.xs.set(i,s)),void 0===t.businessDay?s.format(new Date(1e3*t.timestamp)):s.format(new Date(Date.UTC(t.businessDay.year,t.businessDay.month-1,t.businessDay.day)))},t.prototype.Qs=function(t,i){var n={},s=this.$.timeVisible;return i<20&&s?(n.hour12=!1,n.hour="2-digit",n.minute="2-digit",this.$.secondsVisible&&(n.second="2-digit")):i<40&&s?(n.hour12=!1,n.hour="2-digit",n.minute="2-digit"):i<50?n.day="numeric":i<60?n.day="numeric":i<70?n.month="short":n.year="numeric",new Date(t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate(),t.getUTCHours(),t.getUTCMinutes(),t.getUTCSeconds(),t.getUTCMilliseconds()).toLocaleString(this.kn.locale,n)},t.prototype.Zs=function(t){if(null!==t||null!==this.Ds){var i=this.Ds;this.Ds=t,(null===this.Ds||null!==i&&!this.Ds.equals(i))&&this.Ts.fire(),this.Xs()}},t.prototype.Xs=function(){this.Bs=null},t.prototype.Is=function(){this.Xs(),this.xs.clear()},t.prototype.Ps=function(){var t=this.kn.dateFormat;this.$.timeVisible?this.$s=new rn({dateFormat:t,timeFormat:this.$.secondsVisible?"%h:%m:%s":"%h:%m",dateTimeSeparator:"   ",locale:this.kn.locale}):this.$s=new nn(t,this.kn.locale)},t.prototype.Os=function(){if(this.$.fixLeftEdge){var t=this.Ns.firstIndex();if(null!==t&&this.Ls!==t){this.Ls=t;var i=c(this.visibleBars()).firstBar()-t;if(i<0){var n=this.Vs-i-1;this.setRightOffset(n)}}}},t}(),dn=function(t){function i(i){var n=t.call(this)||this;return n.th=new Map,n.m=i,n}return u(i,t),i.prototype._drawImpl=function(t){},i.prototype._drawBackgroundImpl=function(t){if(this.m.visible){t.save();for(var i=0,n=0,s=this.m.lines;n<s.length;n++){if(0!==(o=s[n]).text.length){t.font=o.font;var h=this.ih(t,o.text);h>this.m.width?o.zoom=this.m.width/h:o.zoom=1,i+=o.lineHeight*o.zoom}}var r=0;switch(this.m.vertAlign){case"top":r=0;break;case"center":r=Math.max((this.m.height-i)/2,0);break;case"bottom":r=Math.max(this.m.height-i,0)}t.fillStyle=this.m.color;for(var u=0,e=this.m.lines;u<e.length;u++){var o=e[u];t.save();var f=0;switch(this.m.horzAlign){case"left":t.textAlign="left",f=o.lineHeight/2;break;case"center":t.textAlign="center",f=this.m.width/2;break;case"right":t.textAlign="right",f=this.m.width-1-o.lineHeight/2}t.translate(f,r),t.textBaseline="top",t.font=o.font,t.scale(o.zoom,o.zoom),t.fillText(o.text,0,o.vertOffset),t.restore(),r+=o.lineHeight*o.zoom}t.restore()}},i.prototype.ih=function(t,i){var n=this.nh(t.font),s=n.get(i);return void 0===s&&(s=t.measureText(i).width,n.set(i,s)),s},i.prototype.nh=function(t){var i=this.th.get(t);return void 0===i&&(i=new Map,this.th.set(t,i)),i},i}(N),Mn=function(){function t(t){this.o=!0,this.p={visible:!1,color:"",height:0,width:0,lines:[],vertAlign:"center",horzAlign:"center"},this.g=new dn(this.p),this.k=t}return t.prototype.update=function(){this.o=!0},t.prototype.renderer=function(t,i){return this.o&&(this.M(t,i),this.o=!1),this.g},t.prototype.M=function(t,i){var n=this.k.options(),s=this.p;s.visible=n.visible,s.visible&&(s.color=n.color,s.width=i,s.height=t,s.horzAlign=n.horzAlign,s.vertAlign=n.vertAlign,s.lines=[{text:n.text,font:Oi(n.fontSize),lineHeight:1.2*n.fontSize,vertOffset:0,zoom:0}])},t}(),wn=function(t){function i(i,n){var s=t.call(this)||this;return s.$=n,s.J=new Mn(s),s}return u(i,t),i.prototype.paneViews=function(){return[this.J]},i.prototype.options=function(){return this.$},i.prototype.updateAllViews=function(){this.J.update()},i}(J),bn=function(){function t(t,i){this.sh=[],this.hh=[],this.Kt=0,this.rh=null,this.uh=null,this.eh=new rt,this.oh=new rt,this.fh=t,this.$=i,this.ah=new Wi(this),this.$n=new vn(this,i.timeScale,this.$.localization),this.lh=new ji,this.v=new G(this,i.crosshair),this.vh=new Yi(i.crosshair),this.dh=new wn(this,i.watermark),this.createPane(),this.sh[0].setStretchFactor(2e3),this.sh[0].addDataSource(this.dh,!0,!1)}return t.prototype.fullUpdate=function(){this.Mh(new Hi(3))},t.prototype.lightUpdate=function(){this.Mh(new Hi(2))},t.prototype.updateSource=function(t){var i=this.wh(t);this.Mh(i)},t.prototype.hoveredSource=function(){return this.uh},t.prototype.setHoveredSource=function(t){var i=this.uh;this.uh=t,null!==i&&this.updateSource(i.source),null!==t&&this.updateSource(t.source)},t.prototype.options=function(){return this.$},t.prototype.applyOptions=function(t){v(this.$,t),void 0!==t.priceScale&&(this.mainPriceScale().applyOptions(t.priceScale),this.eh.fire()),void 0!==t.timeScale&&this.$n.applyOptions(t.timeScale),void 0!==t.localization&&(this.$n.applyLocalizationOptions(t.localization),this.mainPriceScale().updateFormatter()),this.fullUpdate()},t.prototype.updateAllPaneViews=function(){this.sh.forEach((function(t){return t.updateAllViews()})),this.updateCrosshair()},t.prototype.timeScale=function(){return this.$n},t.prototype.panes=function(){return this.sh},t.prototype.gridSource=function(){return this.lh},t.prototype.watermarkSource=function(){return this.dh},t.prototype.crosshairSource=function(){return this.v},t.prototype.crosshairMoved=function(){return this.oh},t.prototype.width=function(){return this.Kt},t.prototype.setPaneHeight=function(t,i){t.setHeight(i),this.recalculateAllPanes(),this.lightUpdate()},t.prototype.setWidth=function(t){this.Kt=t,this.$n.setWidth(this.Kt),this.sh.forEach((function(i){return i.setWidth(t)})),this.recalculateAllPanes()},t.prototype.createPane=function(t){var i=new Ki(this.$n,this);void 0!==t?this.sh.splice(t,0,i):this.sh.push(i);var n=void 0===t?this.sh.length-1:t,s=new Hi(3);return s.invalidatePane(n,{level:0,autoScale:!0}),this.invalidate(s),i},t.prototype.startScalePrice=function(t,i,n){t.startScalePrice(i,n)},t.prototype.scalePriceTo=function(t,i,n){t.scalePriceTo(i,n),this.updateCrosshair(),this.Mh(this.bh(t,2))},t.prototype.endScalePrice=function(t,i){t.endScalePrice(i),this.Mh(this.bh(t,2))},t.prototype.startScrollPrice=function(t,i,n){i.isAutoScale()||t.startScrollPrice(i,n)},t.prototype.scrollPriceTo=function(t,i,n){i.isAutoScale()||(t.scrollPriceTo(i,n),this.updateCrosshair(),this.Mh(this.bh(t,2)))},t.prototype.endScrollPrice=function(t,i){i.isAutoScale()||(t.endScrollPrice(i),this.Mh(this.bh(t,2)))},t.prototype.setPriceAutoScale=function(t,i,n){t.setPriceAutoScale(i,n),this.Mh(this.bh(t,2))},t.prototype.resetPriceScale=function(t,i){t.resetPriceScale(i),this.Mh(this.bh(t,2))},t.prototype.startScaleTime=function(t){this.$n.startScale(t)},t.prototype.zoomTime=function(t,i){var n=this.timeScale();if(!n.isEmpty()&&0!==i){var s=n.width();t=Math.max(1,Math.min(t,s)),n.zoom(t,i),this.updateCrosshair(),this.recalculateAllPanes(),this.lightUpdate()}},t.prototype.scrollChart=function(t){this.startScrollTime(0),this.scrollTimeTo(t),this.endScrollTime()},t.prototype.scaleTimeTo=function(t){this.$n.scaleTo(t),this.recalculateAllPanes(),this.updateCrosshair(),this.lightUpdate()},t.prototype.endScaleTime=function(){this.$n.endScale(),this.lightUpdate()},t.prototype.startScrollTime=function(t){this.rh=t,this.$n.startScroll(t)},t.prototype.scrollTimeTo=function(t){var i=!1;return null!==this.rh&&Math.abs(t-this.rh)>20&&(this.rh=null,i=!0),this.$n.scrollTo(t),this.recalculateAllPanes(),this.updateCrosshair(),this.lightUpdate(),i},t.prototype.endScrollTime=function(){this.$n.endScroll(),this.lightUpdate(),this.rh=null},t.prototype.resetTimeScale=function(){this.$n.restoreDefault(),this.recalculateAllPanes(),this.updateCrosshair(),this.lightUpdate()},t.prototype.invalidate=function(t){this.fh&&this.fh(t),this.lh.invalidate(),this.lightUpdate()},t.prototype.dataSources=function(){return this.sh.reduce((function(t,i){return t.concat(i.dataSources())}),[])},t.prototype.serieses=function(){return this.hh},t.prototype.setAndSaveCurrentPosition=function(t,i,n){this.v.saveOriginCoord(t,i);var s=NaN,h=this.$n.coordinateToIndex(t),r=this.$n.visibleBars();if(null!==r&&(h=Math.min(Math.max(r.firstBar(),h),r.lastBar())),null!==n.mainDataSource()){var u=n.defaultPriceScale(),e=u.firstValue();null!==e&&(s=u.coordinateToPrice(i,e)),s=this.vh.align(s,h,n)}this.v.setPosition(h,s,n),this.mh(),this.oh.fire(this.v.appliedIndex(),{x:t,y:i})},t.prototype.clearCurrentPosition=function(){this.crosshairSource().clearPosition(),this.mh(),this.oh.fire(null,null)},t.prototype.updateCrosshair=function(){var t=this.v.pane();if(null!==t){var i=this.v.originCoordX(),n=this.v.originCoordY();this.setAndSaveCurrentPosition(i,n,t)}},t.prototype.updateTimeScale=function(t,i,n,s){s&&this.$n.reset(),this.$n.update(t,i,n)},t.prototype.updateTimeScaleBaseIndex=function(t){var i=this.hh.reduce((function(t,i){var n=i.bars();if(n.isEmpty())return t;var s=c(n.lastIndex());return void 0===t?s:Math.max(s,t)}),void 0);if(void 0!==i){var n=this.$n,s=n.baseIndex(),h=n.visibleBars();if(null!==h){var r=h.contains(s);if(void 0!==t&&t>0&&!r){var u=i-s;n.setRightOffset(n.rightOffset()-u)}}n.setBaseIndex(i)}this.updateCrosshair(),this.recalculateAllPanes(),this.lightUpdate()},t.prototype.recalculatePane=function(t){null!==t&&t.recalculate()},t.prototype.paneForSource=function(t){var i=this.sh.find((function(i){return i.orderedSources().includes(t)}));return void 0===i?null:i},t.prototype.recalculateAllPanes=function(){this.sh.forEach((function(t){return t.recalculate()})),this.updateAllPaneViews()},t.prototype.destroy=function(){this.sh.forEach((function(t){return t.destroy()})),this.sh.length=0,this.$.localization.priceFormatter=void 0,this.$.localization.timeFormatter=void 0},t.prototype.setPriceAutoScaleForAllMainSources=function(){this.sh.map((function(t){return t.mainDataSource()})).forEach((function(t){null!==t&&c(t.priceScale()).setMode({autoScale:!0})}))},t.prototype.rendererOptionsProvider=function(){return this.ah},t.prototype.priceAxisRendererOptions=function(){return this.ah.options()},t.prototype.mainPriceScaleOptionsChanged=function(){return this.eh},t.prototype.mainPriceScale=function(){return this.sh[0].defaultPriceScale()},t.prototype.createSeries=function(t,i){var n=this.sh[0],s=this.ph(i,t,n);return this.hh.push(s),1===this.hh.length?this.fullUpdate():this.lightUpdate(),s},t.prototype.removeSeries=function(t){var i=this.paneForSource(t),n=this.hh.indexOf(t);f(-1!==n,"Series not found"),this.hh.splice(n,1),c(i).removeDataSource(t),t.destroy&&t.destroy()},t.prototype.fitContent=function(){var t=new Hi(2);t.setFitContent(),this.Mh(t)},t.prototype.setTargetTimeRange=function(t){var i=new Hi(2);i.setTargetTimeRange(t),this.Mh(i)},t.prototype.bh=function(t,i){var n=new Hi(i);if(null!==t){var s=this.sh.indexOf(t);n.invalidatePane(s,{level:i})}return n},t.prototype.wh=function(t,i){return void 0===i&&(i=2),this.bh(this.paneForSource(t),i)},t.prototype.Mh=function(t){this.fh&&this.fh(t),this.lh.invalidate()},t.prototype.mh=function(){this.Mh(new Hi(1))},t.prototype.ph=function(t,i,n){var s=new Ci(this,t,i);return n.addDataSource(s,Boolean(t.overlay),!1),t.overlay&&s.applyOptions(t),s},t}(),mn=function(){function t(t,i){this.w=t,this.h=i}return t.prototype.equals=function(t){return this.w===t.w&&this.h===t.h},t}();function pn(t){return t.ownerDocument&&t.ownerDocument.defaultView&&t.ownerDocument.defaultView.devicePixelRatio||1}function gn(t){var i=c(t.getContext("2d"));return i.setTransform(1,0,0,1,0,0),i}function yn(t){var i=t.createElement("canvas");return function(t){t.style.userSelect="none",t.style.webkitUserSelect="none",t.style.msUserSelect="none",t.style.MozUserSelect="none",t.style.webkitTapHighlightColor="transparent"}(i),i}function kn(t,i){var n=yn(t),s=pn(n);return n.style.width=i.w+"px",n.style.height=i.h+"px",n.width=i.w*s,n.height=i.h*s,n}function Nn(i,n){var s=yn(c(i.ownerDocument));i.appendChild(s);var h=Object(__WEBPACK_IMPORTED_MODULE_0_fancy_canvas_coordinate_space__["a" /* bindToDevicePixelRatio */])(s);return h.resizeCanvas({width:n.w,height:n.h}),h}var Sn,xn=!!navigator.maxTouchPoints||!!navigator.msMaxTouchPoints||"ontouchstart"in window||Boolean(window.DocumentTouch&&document instanceof window.DocumentTouch),Dn="onorientationchange"in window&&xn,Cn=/Android/i.test(navigator.userAgent),Tn=/iPhone|iPad|iPod|AppleWebKit.+Mobile/i.test(navigator.userAgent),En=Cn||Tn;!function(t){t[t.ResetClick=500]="ResetClick",t[t.LongTap=240]="LongTap"}(Sn||(Sn={}));var Ln=function(){function t(t,i,n){this.gh=0,this.yh=null,this.kh=null,this.Nh=!1,this.Sh=null,this.xh=!1,this.Dh=!1,this.Ch=null,this.Th=null,this.Eh=null,this.Lh=null,this.Ah=0,this.Bh=!1,this.zh=!1,this.Vh=!1,this.Fh=t,this.Ph=i,this.$=n,this.Ih()}return t.prototype.destroy=function(){null!==this.Ch&&(this.Ch(),this.Ch=null),null!==this.Th&&(this.Th(),this.Th=null),null!==this.Eh&&(this.Eh(),this.Eh=null),this.Oh(),this.Rh()},t.prototype.Wh=function(t){var i=this;this.Th&&this.Th();var n=this.Uh.bind(this);this.Th=function(){i.Fh.removeEventListener("mousemove",n)},this.Fh.addEventListener("mousemove",n),zn(t)&&this.Uh(t);var s=this.qh(t);this.jh(s,this.Ph.mouseEnterEvent)},t.prototype.Rh=function(){null!==this.yh&&clearTimeout(this.yh),this.gh=0,this.yh=null},t.prototype.Uh=function(t){if(!this.Vh||zn(t)){var i=this.qh(t);this.jh(i,this.Ph.mouseMoveEvent)}},t.prototype.Hh=function(t){if(!("button"in t&&0!==t.button)&&null===this.Lh){var i=zn(t);if(!this.zh||!i){this.Bh=!0;var n=this.qh(t),s=l(this.Sh),h=Math.abs(s.x-n.pageX),r=Math.abs(s.y-n.pageY),u=h+r>5;if(u||!i){if(u&&!this.xh&&i){var e=.5*h,o=r>=e&&!this.$.treatVertTouchDragAsPageScroll,f=e>r&&!this.$.treatHorzTouchDragAsPageScroll;o||f||(this.zh=!0)}u&&(this.xh=!0,this.Dh=!0,i&&this.Oh()),this.zh||(this.jh(n,this.Ph.pressedMouseMoveEvent),i&&Vn(t))}}}},t.prototype.Yh=function(t){if(!("button"in t&&0!==t.button)){var i=this.qh(t);this.Oh(),this.Sh=null,this.Vh=!1,this.Eh&&(this.Eh(),this.Eh=null),zn(t)&&this.Kh(t),this.jh(i,this.Ph.mouseUpEvent),++this.gh,this.yh&&this.gh>1?(this.jh(i,this.Ph.mouseDoubleClickEvent),this.Rh()):this.Dh||this.jh(i,this.Ph.mouseClickEvent),zn(t)&&(Vn(t),this.Kh(t),0===t.touches.length&&(this.Nh=!1))}},t.prototype.Oh=function(){null!==this.kh&&(clearTimeout(this.kh),this.kh=null)},t.prototype.$h=function(t){if(!("button"in t&&0!==t.button)){var i=this.qh(t);this.Dh=!1,this.xh=!1,this.zh=!1,zn(t)&&this.Wh(t),this.Sh={x:i.pageX,y:i.pageY},this.Eh&&(this.Eh(),this.Eh=null);var n=this.Hh.bind(this),s=this.Yh.bind(this),h=this.Fh.ownerDocument.documentElement;this.Eh=function(){h.removeEventListener("touchmove",n),h.removeEventListener("touchend",s),h.removeEventListener("mousemove",n),h.removeEventListener("mouseup",s)},h.addEventListener("touchmove",n,{passive:!1}),h.addEventListener("touchend",s,{passive:!1}),this.Oh(),zn(t)&&1===t.touches.length?this.kh=setTimeout(this._h.bind(this,t),240):(h.addEventListener("mousemove",n),h.addEventListener("mouseup",s)),this.Vh=!0,this.jh(i,this.Ph.mouseDownEvent),this.yh||(this.gh=0,this.yh=setTimeout(this.Rh.bind(this),500))}},t.prototype.Ih=function(){var t=this;this.Fh.addEventListener("mouseenter",this.Wh.bind(this)),this.Fh.addEventListener("touchcancel",this.Oh.bind(this));var i=this.Fh.ownerDocument,n=function(i){t.Ph.mouseDownOutsideEvent&&(i.target&&t.Fh.contains(i.target)||t.Ph.mouseDownOutsideEvent())};this.Ch=function(){i.removeEventListener("mousedown",n),i.removeEventListener("touchstart",n)},i.addEventListener("mousedown",n),i.addEventListener("touchstart",n,{passive:!0}),this.Fh.addEventListener("mouseleave",this.Kh.bind(this)),this.Fh.addEventListener("touchstart",this.$h.bind(this),{passive:!0}),Dn||this.Fh.addEventListener("mousedown",this.$h.bind(this)),this.Xh(),this.Fh.addEventListener("touchmove",(function(){}),{passive:!1})},t.prototype.Xh=function(){var t=this;void 0===this.Ph.pinchStartEvent&&void 0===this.Ph.pinchEvent&&void 0===this.Ph.pinchEndEvent||(this.Fh.addEventListener("touchstart",(function(i){return t.Zh(i.touches)}),{passive:!0}),this.Fh.addEventListener("touchmove",(function(i){if(2===i.touches.length&&null!==t.Lh&&void 0!==t.Ph.pinchEvent){var n=Bn(i.touches[0],i.touches[1])/t.Ah;t.Ph.pinchEvent(t.Lh,n),Vn(i)}}),{passive:!1}),this.Fh.addEventListener("touchend",(function(i){t.Zh(i.touches)})))},t.prototype.Zh=function(t){1===t.length&&(this.Bh=!1),2!==t.length||this.Bh||this.Nh?this.Jh():this.Gh(t)},t.prototype.Gh=function(t){var i=An(this.Fh);this.Lh={x:(t[0].clientX-i.left+(t[1].clientX-i.left))/2,y:(t[0].clientY-i.top+(t[1].clientY-i.top))/2},this.Ah=Bn(t[0],t[1]),void 0!==this.Ph.pinchStartEvent&&this.Ph.pinchStartEvent(),this.Oh()},t.prototype.Jh=function(){null!==this.Lh&&(this.Lh=null,void 0!==this.Ph.pinchEndEvent&&this.Ph.pinchEndEvent())},t.prototype.Kh=function(t){this.Th&&this.Th();var i=this.qh(t);this.jh(i,this.Ph.mouseLeaveEvent)},t.prototype._h=function(t){var i=this.qh(t);this.jh(i,this.Ph.longTapEvent),this.Dh=!0,this.Nh=!0},t.prototype.jh=function(t,i){i&&i.call(this.Ph,t)},t.prototype.qh=function(t){var i;i="touches"in t&&t.touches.length?t.touches[0]:"changedTouches"in t&&t.changedTouches.length?t.changedTouches[0]:t;var n=An(this.Fh);return{clientX:i.clientX,clientY:i.clientY,pageX:i.pageX,pageY:i.pageY,screenX:i.screenX,screenY:i.screenY,localX:i.clientX-n.left,localY:i.clientY-n.top,ctrlKey:t.ctrlKey,altKey:t.altKey,shiftKey:t.shiftKey,metaKey:t.metaKey,type:t.type.startsWith("mouse")?"mouse":"touch",target:i.target,view:t.view}},t}();function An(t){return t.getBoundingClientRect()||{left:0,top:0}}function Bn(t,i){var n=t.clientX-i.clientX,s=t.clientY-i.clientY;return Math.sqrt(n*n+s*s)}function zn(t){return Boolean(t.touches)}function Vn(t){t.cancelable&&t.preventDefault()}var Fn,Pn=function(){function t(t,i,n,s){if(this.Qh=0,this.tr=0,this.ir=0,this.nr=0,this.sr=0,this.hr=0,this.rr=0,this.ur=t,this.er=t.paneWidgets()[i],this.or=t.paneWidgets()[n],this.ar=document.createElement("tr"),this.ar.style.height="1px",this.cr=document.createElement("td"),this.cr.style.padding="0",this.cr.setAttribute("colspan","3"),this.lr(),this.ar.appendChild(this.cr),s)this.vr=null,this.dr=null;else{this.vr=document.createElement("div"),this.vr.style.position="absolute",this.vr.style.zIndex="50",this.vr.style.height="5px",this.vr.style.width="100%",this.vr.style.backgroundColor="rgba(255, 255, 255, 0.02)",this.vr.style.cursor="ns-resize",this.cr.appendChild(this.vr);var h={mouseDownEvent:this.Mr.bind(this),pressedMouseMoveEvent:this.wr.bind(this),mouseUpEvent:this.br.bind(this)};this.dr=new Ln(this.vr,h,{treatVertTouchDragAsPageScroll:!1,treatHorzTouchDragAsPageScroll:!0})}}return t.prototype.destroy=function(){null!==this.dr&&this.dr.destroy()},t.prototype.getElement=function(){return this.ar},t.prototype.getSize=function(){return new mn(this.er.getSize().w,1)},t.prototype.getImage=function(){var t=this.getSize(),i=kn(document,t),n=gn(i);return n.fillStyle=this.ur.options().timeScale.borderColor,n.fillRect(0,0,t.w,t.h),i},t.prototype.update=function(){this.lr()},t.prototype.lr=function(){this.cr.style.background=this.ur.options().timeScale.borderColor},t.prototype.Mr=function(t){this.Qh=t.pageY,this.tr=0,this.ir=this.er.getSize().h+this.or.getSize().h,this.nr=this.er.stretchFactor()+this.or.stretchFactor(),this.sr=30,this.hr=this.ir-this.sr,this.rr=this.nr/this.ir},t.prototype.wr=function(t){this.tr=t.pageY-this.Qh;var i=this.er.getSize().h,n=ot(i+this.tr,this.sr,this.hr)*this.rr,s=this.nr-n;this.er.setStretchFactor(n),this.or.setStretchFactor(s),this.ur.adjustSize(),this.er.getSize().h!==i&&(this.Qh=t.pageY)},t.prototype.br=function(t){this.Qh=0,this.tr=0,this.ir=0,this.nr=0,this.sr=0,this.hr=0,this.rr=0},t}(),In=function(){function t(t,i,n,s){this.$t=new Kt(200),this.Zt=0,this.mr="",this.pr="",this.gr=[],this.yr=new Map,this.Zt=t,this.mr=i,this.pr=Oi(t,n,s)}return t.prototype.destroy=function(){delete this.$t,this.gr=[],this.yr.clear()},t.prototype.paintTo=function(t,i,n,s,h){var r=this.kr(t,i);if("left"!==h){var u=pn(t.canvas);n-=Math.floor(r.textWidth*u)}s-=Math.floor(r.height/2),t.drawImage(r.canvas,n,s,r.width,r.height)},t.prototype.kr=function(t,i){var n,s=this;if(this.yr.has(i))n=a(this.yr.get(i));else{if(this.gr.length>=200){var h=a(this.gr.shift());this.yr.delete(h)}var r=pn(t.canvas),u=Math.ceil(this.Zt/4.5),e=Math.round(this.Zt/10),o=Math.ceil(this.$t.measureText(t,i)),f=ct(Math.round(o+2*u)),c=ct(this.Zt+2*u),l=kn(document,new mn(f,c));n={text:i,textWidth:Math.round(Math.max(1,o)),width:Math.ceil(f*r),height:Math.ceil(c*r),canvas:l},0!==o&&(this.gr.push(n.text),this.yr.set(n.text,n)),q(t=gn(n.canvas),r,(function(){t.font=s.pr,t.fillStyle=s.mr,t.fillText(i,0,c-u-e)}))}return n},t}();!function(t){t[t.Default=0]="Default",t[t.NsResize=1]="NsResize"}(Fn||(Fn={}));var On,Rn,Wn=function(){function t(t,i,n,s){var h=this;this.B=null,this.Nr=null,this.Sr=null,this.xr=!1,this.Dr=!0,this.Cr=new Kt(50),this.Tr=new In(11,"#000"),this.mr=null,this.pr=null,this.Er=0,this.Lr=function(){h.Ar(h.ah.options()),h.I.chart().model().lightUpdate()},this.Br=function(){h.I.chart().model().lightUpdate()},this.I=t,this.$=i,this.ah=n,this.zr="left"===s,this.cr=document.createElement("div"),this.cr.style.height="100%",this.cr.style.overflow="hidden",this.cr.style.width="25px",this.cr.style.left="0",this.cr.style.position="relative",this.Vr=Nn(this.cr,new mn(16,16)),this.Vr.subscribeCanvasConfigured(this.Lr);var r=this.Vr.canvas;r.style.position="absolute",r.style.zIndex="1",r.style.left="0",r.style.top="0",this.Fr=Nn(this.cr,new mn(16,16)),this.Fr.subscribeCanvasConfigured(this.Br);var u=this.Fr.canvas;u.style.position="absolute",u.style.zIndex="2",u.style.left="0",u.style.top="0";var e={mouseDownEvent:this.Mr.bind(this),pressedMouseMoveEvent:this.wr.bind(this),mouseDownOutsideEvent:this.Pr.bind(this),mouseUpEvent:this.br.bind(this),mouseDoubleClickEvent:this.Ir.bind(this),mouseEnterEvent:this.Or.bind(this),mouseLeaveEvent:this.Rr.bind(this)};this.dr=new Ln(this.Fr.canvas,e,{treatVertTouchDragAsPageScroll:!1,treatHorzTouchDragAsPageScroll:!0})}return t.prototype.destroy=function(){this.dr.destroy(),this.Fr.unsubscribeCanvasConfigured(this.Br),this.Fr.destroy(),this.Vr.unsubscribeCanvasConfigured(this.Lr),this.Vr.destroy(),null!==this.B&&(this.B.onMarksChanged().unsubscribeAll(this),this.B.optionsChanged().unsubscribeAll(this)),this.B=null,null!==this.Sr&&(clearTimeout(this.Sr),this.Sr=null),this.Tr.destroy()},t.prototype.getElement=function(){return this.cr},t.prototype.backgroundColor=function(){return this.$.backgroundColor},t.prototype.lineColor=function(){return this.I.chart().options().priceScale.borderColor},t.prototype.textColor=function(){return this.$.textColor},t.prototype.fontSize=function(){return this.$.fontSize},t.prototype.baseFont=function(){return Oi(this.fontSize(),this.$.fontFamily)},t.prototype.rendererOptions=function(){var t=this.ah.options(),i=this.mr!==t.color,n=this.pr!==t.font;return(i||n)&&(this.Ar(t),this.mr=t.color),n&&(this.Cr.reset(),this.pr=t.font),t},t.prototype.optimalWidth=function(){if(!this.isVisible()||null===this.B)return 0;var t=34,i=this.rendererOptions(),n=gn(this.Vr.canvas),s=this.B.marks();n.font=this.baseFont(),s.length>0&&(t=Math.max(this.Cr.measureText(n,s[0].label),this.Cr.measureText(n,s[s.length-1].label)));for(var h=this.Wr(),r=h.length;r--;){var u=this.Cr.measureText(n,h[r].text());u>t&&(t=u)}var e=Math.ceil(i.borderSize+i.tickLength+i.paddingInner+i.paddingOuter+t);return e+=e%2},t.prototype.setSize=function(t){if(t.w<0||t.h<0)throw new Error("Try to set invalid size to PriceAxisWidget "+JSON.stringify(t));null!==this.Nr&&this.Nr.equals(t)||(this.Nr=t,this.Vr.resizeCanvas({width:t.w,height:t.h}),this.Fr.resizeCanvas({width:t.w,height:t.h}),this.cr.style.width=t.w+"px",this.cr.style.height=t.h+"px",this.cr.style.minWidth=t.w+"px")},t.prototype.getWidth=function(){return c(this.Nr).w},t.prototype.setPriceScale=function(t){this.B!==t&&(null!==this.B&&(this.B.onMarksChanged().unsubscribeAll(this),this.B.optionsChanged().unsubscribeAll(this)),this.B=t,t.onMarksChanged().subscribe(this.cn.bind(this),this))},t.prototype.priceScale=function(){return this.B},t.prototype.isVisible=function(){return this.Dr},t.prototype.setVisible=function(t){t!==this.Dr&&(this.cr.style.display=t?"table-cell":"none",this.Dr=t)},t.prototype.setAutoScale=function(t){var i=this.I.state();this.I.chart().model().setPriceAutoScale(i,c(this.priceScale()),t)},t.prototype.reset=function(){var t=this.I.state();this.I.chart().model().resetPriceScale(t,c(this.priceScale()))},t.prototype.paint=function(t){if(this.Dr&&null!==this.Nr){if(1!==t){var i=gn(this.Vr.canvas);this.Ur(),this.qr(i,this.Vr.pixelRatio),this.Lt(i,this.Vr.pixelRatio),this.jr(i,this.Vr.pixelRatio),this.Hr(i,this.Vr.pixelRatio)}var n=gn(this.Fr.canvas),s=this.Nr.w,h=this.Nr.h;q(n,this.Fr.pixelRatio,(function(){n.clearRect(0,0,s,h)})),this.Yr(n,this.Fr.pixelRatio)}},t.prototype.getImage=function(){return this.Vr.canvas},t.prototype.isLeft=function(){return this.zr},t.prototype.Mr=function(t){if(null!==this.B&&!this.B.isEmpty()&&this.I.chart().options().handleScale.axisPressedMouseMove){var i=this.I.chart().model(),n=this.I.state();this.xr=!0,i.startScalePrice(n,this.B,t.localY)}},t.prototype.wr=function(t){if(null!==this.B&&this.I.chart().options().handleScale.axisPressedMouseMove){var i=this.I.chart().model(),n=this.I.state(),s=this.B;i.scalePriceTo(n,s,t.localY)}},t.prototype.Pr=function(){if(null!==this.B&&this.I.chart().options().handleScale.axisPressedMouseMove){var t=this.I.chart().model(),i=this.I.state(),n=this.B;this.xr&&(this.xr=!1,t.endScalePrice(i,n))}},t.prototype.br=function(t){if(null!==this.B&&this.I.chart().options().handleScale.axisPressedMouseMove){var i=this.I.chart().model(),n=this.I.state();this.xr=!1,i.endScalePrice(n,this.B)}},t.prototype.Ir=function(t){this.I.chart().options().handleScale.axisDoubleClickReset&&this.reset()},t.prototype.Or=function(t){null!==this.B&&(!this.I.chart().model().options().handleScale.axisPressedMouseMove||this.B.isPercentage()||this.B.isIndexedTo100()||this.Kr(1))},t.prototype.Rr=function(t){this.Kr(0)},t.prototype.Wr=function(){var t=this,i=[],n=null===this.B?void 0:this.B;return function(s){for(var h=0;h<s.length;++h)for(var r=s[h].priceAxisViews(t.I.state(),n),u=0;u<r.length;u++)i.push(r[u])}(this.I.state().orderedSources()),i},t.prototype.qr=function(t,i){var n=this;if(null!==this.Nr){var s=this.Nr.w,h=this.Nr.h;q(t,i,(function(){j(t,0,0,s,h,n.backgroundColor())}))}},t.prototype.Lt=function(t,i){if(null!==this.Nr&&null!==this.B&&this.B.options().borderVisible){t.save(),t.fillStyle=this.lineColor();var n,s=Math.max(1,Math.floor(this.rendererOptions().borderSize*i));n=this.zr?Math.floor(this.Nr.w*i)-s:0,t.fillRect(n,0,s,Math.ceil(this.Nr.h*i)),t.restore()}},t.prototype.jr=function(t,i){if(null!==this.Nr&&null!==this.B){var n=this.B.marks();t.save(),t.strokeStyle=this.lineColor(),t.font=this.baseFont(),t.fillStyle=this.lineColor();var s=this.rendererOptions(),h=this.B.options().borderVisible,r=this.zr?Math.floor((this.Nr.w-s.tickLength)*i-s.borderSize*i):Math.floor(s.borderSize*i),u=this.zr?Math.round(r-s.paddingInner*i):Math.round(r+s.tickLength*i+s.paddingInner*i),e=this.zr?"right":"left",o=Math.max(1,Math.floor(i)),f=Math.floor(.5*i);if(h){var a=Math.round(s.tickLength*i);t.beginPath();for(var c=0,l=n;c<l.length;c++){var v=l[c];t.rect(r,Math.round(v.coord*i)-f,a,o)}t.fill()}t.fillStyle=this.textColor();for(var d=0,M=n;d<M.length;d++){v=M[d];this.Tr.paintTo(t,v.label,u,Math.round(v.coord*i),e)}t.restore()}},t.prototype.Ur=function(){if(null!==this.Nr&&null!==this.B){var t=this.Nr.h/2,i=[],n=this.B.orderedSources().slice(),s=this.I.state(),h=this.rendererOptions();this.B===s.defaultPriceScale()&&this.I.state().orderedSources().forEach((function(t){s.isOverlay(t)&&n.push(t)}));var r=this.B.mainSource(),u=this.B;n.forEach((function(n){var h=n.priceAxisViews(s,u);h.forEach((function(t){t.setFixedCoordinate(null),t.isVisible()&&i.push(t)})),r===n&&h.length>0&&(t=h[0].coordinate())}));var e=i.filter((function(i){return i.coordinate()<=t})),o=i.filter((function(i){return i.coordinate()>t}));if(e.sort((function(t,i){return i.coordinate()-t.coordinate()})),e.length&&o.length&&o.push(e[0]),o.sort((function(t,i){return t.coordinate()-i.coordinate()})),i.forEach((function(t){return t.setFixedCoordinate(t.coordinate())})),this.B.options().alignLabels){for(var f=1;f<e.length;f++){var a=e[f],c=(v=e[f-1]).height(h,!1);a.coordinate()>(d=v.getFixedCoordinate())-c&&a.setFixedCoordinate(d-c)}for(var l=1;l<o.length;l++){var v,d;a=o[l],c=(v=o[l-1]).height(h,!0);a.coordinate()<(d=v.getFixedCoordinate())+c&&a.setFixedCoordinate(d+c)}}}},t.prototype.Hr=function(t,i){var n=this;if(null!==this.Nr){t.save();var s=this.Nr,h=this.Wr(),r=this.rendererOptions(),u=this.zr?"right":"left";h.forEach((function(h){if(h.isAxisLabelVisible()){var e=h.renderer();t.save(),e.draw(t,r,n.Cr,s.w,u,i),t.restore()}})),t.restore()}},t.prototype.Yr=function(t,i){var n=this;if(null!==this.Nr&&null!==this.B){t.save();var s=this.Nr,h=this.I.chart().model(),r=[],u=this.I.state(),e=h.crosshairSource().priceAxisViews(u,this.B);e.length&&r.push(e);var o=this.rendererOptions(),f=this.zr?"right":"left";r.forEach((function(h){h.forEach((function(h){t.save(),h.renderer().draw(t,o,n.Cr,s.w,f,i),t.restore()}))})),t.restore()}},t.prototype.Kr=function(t){this.cr.style.cursor=1===t?"ns-resize":"default"},t.prototype.cn=function(){var t=this,i=this.optimalWidth();if(this.Er<i){var n=this.I.chart();null===this.Sr&&(this.Sr=setTimeout((function(){n&&n.model().fullUpdate(),t.Sr=null}),100))}this.Er=i},t.prototype.Ar=function(t){this.Tr.destroy(),this.Tr=new In(t.fontSize,t.color,t.fontFamily)},t}(),Un=En,qn=function(){function t(t,i){var n=this;this.Nr=new mn(0,0),this.$r=null,this._r=null,this.Xr=!1,this.Zr="none",this.Jr=new rt,this.Gr=0,this.Qr=!1,this.tu=null,this.iu=!1,this.nu=null,this.Lr=function(){return n.su&&n.F().lightUpdate()},this.Br=function(){return n.su&&n.F().lightUpdate()},this.hu=t,this.su=i,this.su.onDestroyed().subscribe(this.ru.bind(this),this,!0),this.uu=document.createElement("td"),this.uu.style.padding="0",this.uu.style.position="relative";var s=document.createElement("div");s.style.width="100%",s.style.height="100%",s.style.position="relative",s.style.overflow="hidden",this.eu=document.createElement("td"),this.eu.style.padding="0",this.ou=document.createElement("td"),this.ou.style.padding="0",this.uu.appendChild(s),this.Vr=Nn(s,new mn(16,16)),this.Vr.subscribeCanvasConfigured(this.Lr);var h=this.Vr.canvas;h.style.position="absolute",h.style.zIndex="1",h.style.left="0",h.style.top="0",this.Fr=Nn(s,new mn(16,16)),this.Fr.subscribeCanvasConfigured(this.Br);var r=this.Fr.canvas;r.style.position="absolute",r.style.zIndex="2",r.style.left="0",r.style.top="0",this.ar=document.createElement("tr"),this.ar.appendChild(this.eu),this.ar.appendChild(this.uu),this.ar.appendChild(this.ou),this.fu(),t.model().mainPriceScaleOptionsChanged().subscribe(this.au.bind(this),this),this.updatePriceAxisWidget();var u=this.chart().options().handleScroll;this.dr=new Ln(this.Fr.canvas,this,{treatVertTouchDragAsPageScroll:!u.vertTouchDrag,treatHorzTouchDragAsPageScroll:!u.horzTouchDrag})}return t.prototype.destroy=function(){null!==this.$r&&this.$r.destroy(),this.Fr.unsubscribeCanvasConfigured(this.Br),this.Fr.destroy(),this.Vr.unsubscribeCanvasConfigured(this.Lr),this.Vr.destroy(),null!==this.su&&this.su.onDestroyed().unsubscribeAll(this),this.dr.destroy()},t.prototype.state=function(){return c(this.su)},t.prototype.stateOrNull=function(){return this.su},t.prototype.setState=function(i){null!==this.su&&this.su.onDestroyed().unsubscribeAll(this),this.su=i,null!==this.su&&this.su.onDestroyed().subscribe(t.prototype.ru.bind(this),this,!0),this.updatePriceAxisWidget()},t.prototype.chart=function(){return this.hu},t.prototype.getElement=function(){return this.ar},t.prototype.updatePriceAxisWidget=function(){if(null!==this.su&&null!==this.$r&&0!==this.F().serieses().length){var t=this.su.defaultPriceScale();this.$r.setPriceScale(c(t))}},t.prototype.stretchFactor=function(){return null!==this.su?this.su.stretchFactor():0},t.prototype.setStretchFactor=function(t){this.su&&this.su.setStretchFactor(t)},t.prototype.mouseEnterEvent=function(t){if(this.su){var i=t.localX,n=t.localY;Dn||this.cu(i,n)}},t.prototype.mouseDownEvent=function(t){if(this.Qr=!1,this.iu=null!==this.tu,this.su){if(document.activeElement!==document.body&&document.activeElement!==document.documentElement)c(document.activeElement).blur();else{var i=document.getSelection();null!==i&&i.removeAllRanges()}var n=this.F();if(!this.su.defaultPriceScale().isEmpty()&&!n.timeScale().isEmpty()){if(null!==this.tu){var s=n.crosshairSource();this.nu={x:s.appliedX(),y:s.appliedY()},this.tu={x:t.localX,y:t.localY}}Dn||this.cu(t.localX,t.localY)}}},t.prototype.mouseMoveEvent=function(t){if(this.su){var i=t.localX,n=t.localY;if(this.lu()&&this.vu(),!Dn){this.cu(i,n);var s=this.hitTest(i,n);this.F().setHoveredSource(s&&{source:s.source,object:s.object}),null!==s&&void 0!==s.view.moveHandler&&s.view.moveHandler(i,n)}}},t.prototype.mouseClickEvent=function(t){if(null!==this.su){var i=t.localX,n=t.localY,s=this.hitTest(i,n);if(null!==s&&void 0!==s.view.clickHandler&&s.view.clickHandler(i,n),this.Jr.hasListeners()){var h=this.F().crosshairSource().appliedIndex();this.Jr.fire(h,{x:i,y:n})}this.du()}},t.prototype.pressedMouseMoveEvent=function(t){if(null!==this.su){var i=this.F(),n=t.localX,s=t.localY;if(null!==this.tu){this.iu=!1;var h=c(this.nu),r=h.x+(n-this.tu.x),u=h.y+(s-this.tu.y);this.cu(r,u)}else this.lu()||this.cu(n,s);if(!i.timeScale().isEmpty()){var e=this.hu.options().handleScroll;if(e.pressedMouseMove&&"touch"!==t.type||(e.horzTouchDrag||e.vertTouchDrag)&&"mouse"!==t.type){var o=this.su.defaultPriceScale();null!==this._r||this.Mu()||(this._r={x:t.clientX,y:t.clientY}),null===this._r||this._r.x===t.clientX&&this._r.y===t.clientY||this.Xr||(o.isEmpty()||i.startScrollPrice(this.su,o,t.localY),i.startScrollTime(t.localX),this.Xr=!0),this.Xr&&(o.isEmpty()||i.scrollPriceTo(this.su,o,t.localY),i.scrollTimeTo(t.localX))}}}},t.prototype.mouseUpEvent=function(t){if(null!==this.su){this.Qr=!1;var i=this.F();if(this.Xr){var n=this.su.defaultPriceScale();i.endScrollPrice(this.su,n),i.endScrollTime(),this._r=null,this.Xr=!1}}},t.prototype.longTapEvent=function(t){if(this.Qr=!0,null===this.tu&&Un){var i={x:t.localX,y:t.localY};this.wu(i,i)}},t.prototype.mouseLeaveEvent=function(t){null!==this.su&&(this.su.model().setHoveredSource(null),En||this.vu())},t.prototype.clicked=function(){return this.Jr},t.prototype.pinchStartEvent=function(){this.Gr=1},t.prototype.pinchEvent=function(t,i){if(this.hu.options().handleScale.pinch){var n=5*(i-this.Gr);this.Gr=i,this.F().zoomTime(t.x,n)}},t.prototype.hitTest=function(t,i){var n=this.su;if(null===n)return null;for(var s=0,h=n.orderedSources();s<h.length;s++){var r=h[s],u=this.bu(r.paneViews(n),t,i);if(null!==u)return{source:r,view:u.view,object:u.object}}return null},t.prototype.setPriceAxisSize=function(t){c(this.$r).setSize(new mn(t,this.Nr.h))},t.prototype.getSize=function(){return this.Nr},t.prototype.setSize=function(t){if(t.w<0||t.h<0)throw new Error("Try to set invalid size to PaneWidget "+JSON.stringify(t));this.Nr.equals(t)||(this.Nr=t,this.Vr.resizeCanvas({width:t.w,height:t.h}),this.Fr.resizeCanvas({width:t.w,height:t.h}),this.uu.style.width=t.w+"px",this.uu.style.height=t.h+"px")},t.prototype.recalculatePriceScale=function(){var t=c(this.su);t.recalculatePriceScale(t.defaultPriceScale());for(var i=0,n=t.dataSources();i<n.length;i++){var s=n[i];if(t.isOverlay(s)){var h=s.priceScale();null!==h&&t.recalculatePriceScale(h),s.updateAllViews()}}},t.prototype.getImage=function(){return this.Vr.canvas},t.prototype.paint=function(t){if(0!==t&&null!==this.su){if(t>1&&this.recalculatePriceScale(),null!==this.$r&&this.$r.paint(t),1!==t){var i=gn(this.Vr.canvas);i.save(),this.qr(i,this.mu(),this.Vr.pixelRatio),this.su&&(this.pu(i,this.Vr.pixelRatio),this.gu(i,this.Vr.pixelRatio),this.yu(i,this.Vr.pixelRatio)),i.restore()}var n=gn(this.Fr.canvas);n.clearRect(0,0,Math.ceil(this.Nr.w*this.Fr.pixelRatio),Math.ceil(this.Nr.h*this.Fr.pixelRatio)),this.ku(n,this.Fr.pixelRatio)}},t.prototype.priceAxisWidget=function(){return this.$r},t.prototype.mu=function(){return this.hu.options().layout.backgroundColor},t.prototype.ru=function(){null!==this.su&&this.su.onDestroyed().unsubscribeAll(this),this.su=null},t.prototype.qr=function(t,i,n){var s=this;q(t,n,(function(){j(t,0,0,s.Nr.w,s.Nr.h,i)}))},t.prototype.pu=function(t,i){for(var n=c(this.su),s=this.F().gridSource().paneViews(n),h=n.height(),r=n.width(),u=0,e=s;u<e.length;u++){var o=e[u];t.save();var f=o.renderer(h,r);null!==f&&f.draw(t,i,!1),t.restore()}},t.prototype.gu=function(t,i){var n=this.F().watermarkSource();if(null!==n){var s=c(this.su);if(s.containsSeries())for(var h=n.paneViews(),r=s.height(),u=s.width(),e=0,o=h;e<o.length;e++){var f=o[e];t.save();var a=f.renderer(r,u);null!==a&&a.draw(t,i,!1),t.restore()}}},t.prototype.ku=function(t,i){this.Nu(this.F().crosshairSource(),t,i)},t.prototype.yu=function(t,i){for(var n=c(this.su).orderedSources(),s=this.F().crosshairSource(),h=0,r=n;h<r.length;h++){var u=r[h];this.Su(u,t,i)}for(var e=0,o=n;e<o.length;e++){(u=o[e])!==s&&this.Nu(u,t,i)}},t.prototype.Nu=function(t,i,n){for(var s=c(this.su),h=t.paneViews(s),r=s.height(),u=s.width(),e=s.model().hoveredSource(),o=null!==e&&e.source===t,f=null!==e&&o&&void 0!==e.object?e.object.hitTestData:void 0,a=0,l=h;a<l.length;a++){var v=l[a].renderer(r,u);null!==v&&(i.save(),v.draw(i,n,o,f),i.restore())}},t.prototype.Su=function(t,i,n){for(var s=c(this.su),h=t.paneViews(s),r=s.height(),u=s.width(),e=s.model().hoveredSource(),o=null!==e&&e.source===t,f=null!==e&&o&&void 0!==e.object?e.object.hitTestData:void 0,a=0,l=h;a<l.length;a++){var v=l[a].renderer(r,u);null!==v&&void 0!==v.drawBackground&&(i.save(),v.drawBackground(i,n,o,f),i.restore())}},t.prototype.bu=function(t,i,n){for(var s=0,h=t;s<h.length;s++){var r=h[s],u=r.renderer(this.Nr.h,this.Nr.w);if(null!==u&&u.hitTest){var e=u.hitTest(i,n);if(null!==e)return{view:r,object:e}}}return null},t.prototype.au=function(){this.fu(),this.hu.adjustSize()},t.prototype.fu=function(){if(null!==this.su){var t=this.hu,i=this.su.defaultPriceScale().options().position;if(this.Zr!==i){if(null!==this.$r&&(this.$r.isLeft()?this.eu.removeChild(this.$r.getElement()):this.ou.removeChild(this.$r.getElement()),this.$r.destroy(),this.$r=null),"none"!==i){var n=t.model().rendererOptionsProvider();this.$r=new Wn(this,t.options().layout,n,i),"left"===i&&this.eu.appendChild(this.$r.getElement()),"right"===i&&this.ou.appendChild(this.$r.getElement())}this.Zr=i}}},t.prototype.lu=function(){return Un&&null===this.tu},t.prototype.Mu=function(){return Un&&this.Qr||null!==this.tu},t.prototype.xu=function(t){return Math.max(0,Math.min(t,this.Nr.w-1))},t.prototype.Du=function(t){return Math.max(0,Math.min(t,this.Nr.h-1))},t.prototype.cu=function(t,i){this.F().setAndSaveCurrentPosition(this.xu(t),this.Du(i),c(this.su))},t.prototype.vu=function(){this.F().clearCurrentPosition()},t.prototype.du=function(){this.iu&&(this.tu=null,this.vu())},t.prototype.wu=function(t,i){this.tu=t,this.iu=!1,this.cu(i.x,i.y);var n=this.F().crosshairSource();this.nu={x:n.appliedX(),y:n.appliedY()}},t.prototype.F=function(){return this.hu.model()},t}(),jn=function(){function t(t,i,n,s){var h=this;this.o=!0,this.Nr=new mn(0,0),this.Lr=function(){return h.paint(3)},this.zr="left"===t,this.ah=n.rendererOptionsProvider,this.$=i,this.Cu=s,this.cr=document.createElement("div"),this.cr.style.width="25px",this.cr.style.height="100%",this.cr.style.overflow="hidden",this.Vr=Nn(this.cr,new mn(16,16)),this.Vr.subscribeCanvasConfigured(this.Lr)}return t.prototype.destroy=function(){this.Vr.unsubscribeCanvasConfigured(this.Lr),this.Vr.destroy()},t.prototype.update=function(){this.o=!0},t.prototype.getElement=function(){return this.cr},t.prototype.getSize=function(){return this.Nr},t.prototype.setSize=function(t){if(t.w<0||t.h<0)throw new Error("Try to set invalid size to PriceAxisStub "+JSON.stringify(t));this.Nr.equals(t)||(this.Nr=t,this.Vr.resizeCanvas({width:t.w,height:t.h}),this.cr.style.width=t.w+"px",this.cr.style.minWidth=t.w+"px",this.cr.style.height=t.h+"px",this.o=!0)},t.prototype.paint=function(t){if((!(t<3)||this.o)&&0!==this.Nr.w&&0!==this.Nr.h){this.o=!1;var i=gn(this.Vr.canvas);this.qr(i,this.Vr.pixelRatio),this.Lt(i,this.Vr.pixelRatio)}},t.prototype.getImage=function(){return this.Vr.canvas},t.prototype.isLeft=function(){return this.zr},t.prototype.Lt=function(t,i){if(this.Cu()){var n=this.Nr.w;t.save(),t.fillStyle=this.$.timeScale.borderColor;var s=Math.floor(this.ah.options().borderSize*i),h=this.zr?Math.round(n*i)-s:0;t.fillRect(h,0,s,s),t.restore()}},t.prototype.qr=function(t,i){var n=this;q(t,i,(function(){j(t,0,0,n.Nr.w,n.Nr.h,n.$.layout.backgroundColor)}))},t}();function Hn(t,i){return t.span>i.span?t:i}!function(t){t[t.BorderSize=1]="BorderSize",t[t.TickLength=3]="TickLength"}(On||(On={})),function(t){t[t.Default=0]="Default",t[t.EwResize=1]="EwResize"}(Rn||(Rn={}));var Yn=function(){function t(t){var i=this;this.Tu=null,this.Eu=70,this.Ht=null,this.Lu=!1,this.Nr=new mn(0,0),this.Zr="none",this.Lr=function(){return i.hu.model().lightUpdate()},this.Br=function(){return i.hu.model().lightUpdate()},this.hu=t,this.$=t.options().layout,this.Au=document.createElement("tr"),this.Bu=document.createElement("td"),this.Bu.style.padding="0",this.zu=document.createElement("td"),this.zu.style.padding="0",this.cr=document.createElement("td"),this.cr.style.height="25px",this.cr.style.padding="0",this.Vu=document.createElement("div"),this.Vu.style.width="100%",this.Vu.style.height="100%",this.Vu.style.position="relative",this.Vu.style.overflow="hidden",this.cr.appendChild(this.Vu),this.Vr=Nn(this.Vu,new mn(16,16)),this.Vr.subscribeCanvasConfigured(this.Lr);var n=this.Vr.canvas;n.style.position="absolute",n.style.zIndex="1",n.style.left="0",n.style.top="0",this.Fr=Nn(this.Vu,new mn(16,16)),this.Fr.subscribeCanvasConfigured(this.Br);var s=this.Fr.canvas;s.style.position="absolute",s.style.zIndex="2",s.style.left="0",s.style.top="0",this.Au.appendChild(this.Bu),this.Au.appendChild(this.cr),this.Au.appendChild(this.zu),this.Fu(),this.hu.model().mainPriceScaleOptionsChanged().subscribe(this.Fu.bind(this),this),this.dr=new Ln(this.Fr.canvas,this,{treatVertTouchDragAsPageScroll:!0,treatHorzTouchDragAsPageScroll:!1})}return t.prototype.destroy=function(){this.dr.destroy(),null!==this.Tu&&this.Tu.destroy(),this.Fr.unsubscribeCanvasConfigured(this.Br),this.Fr.destroy(),this.Vr.unsubscribeCanvasConfigured(this.Lr),this.Vr.destroy()},t.prototype.getElement=function(){return this.Au},t.prototype.stub=function(){return this.Tu},t.prototype.mouseDownEvent=function(t){if(!this.Lu){this.Lu=!0;var i=this.hu.model();!i.timeScale().isEmpty()&&this.hu.options().handleScale.axisPressedMouseMove&&i.startScaleTime(t.localX)}},t.prototype.mouseDownOutsideEvent=function(){var t=this.hu.model();!t.timeScale().isEmpty()&&this.Lu&&(this.Lu=!1,this.hu.options().handleScale.axisPressedMouseMove&&t.endScaleTime())},t.prototype.pressedMouseMoveEvent=function(t){var i=this.hu.model();!i.timeScale().isEmpty()&&this.hu.options().handleScale.axisPressedMouseMove&&i.scaleTimeTo(t.localX)},t.prototype.mouseUpEvent=function(t){this.Lu=!1;var i=this.hu.model();i.timeScale().isEmpty()&&!this.hu.options().handleScale.axisPressedMouseMove||i.endScaleTime()},t.prototype.mouseDoubleClickEvent=function(){this.hu.options().handleScale.axisDoubleClickReset&&this.hu.model().resetTimeScale()},t.prototype.mouseEnterEvent=function(t){this.hu.model().options().handleScale.axisPressedMouseMove&&this.Kr(1)},t.prototype.mouseLeaveEvent=function(t){this.Kr(0)},t.prototype.getSize=function(){return this.Nr},t.prototype.setSizes=function(t,i){this.Nr&&this.Nr.equals(t)||(this.Nr=t,this.Vr.resizeCanvas({width:t.w,height:t.h}),this.Fr.resizeCanvas({width:t.w,height:t.h}),this.cr.style.width=t.w+"px",this.cr.style.height=t.h+"px"),null!==this.Tu&&this.Tu.setSize(new mn(i,t.h))},t.prototype.width=function(){return this.Nr.w},t.prototype.height=function(){return this.Nr.h},t.prototype.optimalHeight=function(){var t=this.Pu();return Math.ceil(t.borderSize+t.tickLength+t.fontSize+t.paddingTop+t.paddingBottom)},t.prototype.update=function(){var t=this,i=this.hu.model().timeScale().marks();i&&(this.Eu=70,i.forEach((function(i){t.Eu=Math.min(i.span,t.Eu)})))},t.prototype.getImage=function(){return this.Vr.canvas},t.prototype.paint=function(t){if(0!==t){if(1!==t){var i=gn(this.Vr.canvas);this.qr(i,this.Vr.pixelRatio),this.Lt(i,this.Vr.pixelRatio),this.jr(i,this.Vr.pixelRatio),this.Hr(i,this.Vr.pixelRatio),null!==this.Tu&&this.Tu.paint(t)}var n=gn(this.Fr.canvas);this.Yr(n,this.Fr.pixelRatio)}},t.prototype.qr=function(t,i){var n=this;q(t,i,(function(){j(t,0,0,n.Nr.w,n.Nr.h,n.mu())}))},t.prototype.Lt=function(t,i){if(this.hu.options().timeScale.borderVisible){t.save(),t.fillStyle=this.Iu();var n=Math.max(1,Math.floor(this.Pu().borderSize*i));t.fillRect(0,0,Math.ceil(this.Nr.w*i),n),t.restore()}},t.prototype.jr=function(t,i){var n=this,s=this.hu.model().timeScale().marks();if(s&&0!==s.length){var h=s.reduce(Hn,s[0]).span;h>30&&h<40&&(h=30),t.save(),t.strokeStyle=this.Iu();var r=this.Pu(),u=r.borderSize+r.tickLength+r.paddingTop+r.fontSize-r.baselineOffset;t.textAlign="center",t.fillStyle=this.Iu();var e=Math.floor(this.Pu().borderSize*i),o=Math.max(1,Math.floor(i)),f=Math.floor(.5*i);if(this.hu.model().timeScale().options().borderVisible){t.beginPath();for(var a=Math.round(r.tickLength*i),c=s.length;c--;){var l=Math.round(s[c].coord*i);t.rect(l-f,e,o,a)}t.fill()}t.fillStyle=this.Pn(),q(t,i,(function(){t.font=n.Ou();for(var i=0,r=s;i<r.length;i++){(f=r[i]).span<h&&t.fillText(f.label,f.coord,u)}t.font=n.Ru();for(var e=0,o=s;e<o.length;e++){var f;(f=o[e]).span>=h&&t.fillText(f.label,f.coord,u)}}))}},t.prototype.Hr=function(t,i){t.save();var n=new Set,s=this.hu.model(),h=s.dataSources();n.add(s.crosshairSource());for(var r=this.Pu(),u=0,e=h;u<e.length;u++){var o=e[u];if(!n.has(o))for(var f=0,a=o.timeAxisViews();f<a.length;f++){a[f].renderer().draw(t,r,i)}}t.restore()},t.prototype.Yr=function(t,i){t.save(),t.clearRect(0,0,Math.ceil(this.Nr.w*i),Math.ceil(this.Nr.h*i));var n=[],s=this.hu.model().crosshairSource().timeAxisViews();n.push(s);var h=this.Pu();n.forEach((function(n){n.forEach((function(n){t.save(),n.renderer().draw(t,h,i),t.restore()}))})),t.restore()},t.prototype.mu=function(){return this.$.backgroundColor},t.prototype.Iu=function(){return this.hu.options().timeScale.borderColor},t.prototype.Pn=function(){return this.$.textColor},t.prototype.Zt=function(){return this.$.fontSize},t.prototype.Ou=function(){return Oi(this.Zt(),this.$.fontFamily)},t.prototype.Ru=function(){return Oi(this.Zt(),this.$.fontFamily,"bold")},t.prototype.Pu=function(){null===this.Ht&&(this.Ht={borderSize:1,baselineOffset:NaN,paddingTop:NaN,paddingBottom:NaN,paddingHorizontal:NaN,tickLength:3,fontSize:NaN,font:"",widthCache:new Kt});var t=this.Ht,i=this.Ou();if(t.font!==i){var n=this.Zt();t.fontSize=n,t.font=i,t.paddingTop=Math.ceil(n/2.5),t.paddingBottom=t.paddingTop,t.paddingHorizontal=Math.ceil(n/2),t.baselineOffset=Math.round(this.Zt()/5),t.widthCache.reset()}return this.Ht},t.prototype.Kr=function(t){this.cr.style.cursor=1===t?"ew-resize":"default"},t.prototype.Fu=function(){var t=this.hu.model().mainPriceScale().options().position;if(t!==this.Zr){if(null!==this.Tu&&(this.Tu.isLeft()?this.Bu.removeChild(this.Tu.getElement()):this.zu.removeChild(this.Tu.getElement()),this.Tu.destroy(),this.Tu=null),"none"!==t){var i={rendererOptionsProvider:this.hu.model().rendererOptionsProvider()},n=this.hu.model();this.Tu=new jn(t,this.hu.options(),i,(function(){return n.mainPriceScale().options().borderVisible&&n.timeScale().options().borderVisible})),("left"===t?this.Bu:this.zu).appendChild(this.Tu.getElement())}this.Zr=t}},t}(),Kn=function(){function t(t,i){var n=this;this.Wu=[],this.Uu=[],this.qu=0,this.ju=new rt,this.nn=0,this.Kt=0,this.Hu=0,this.Yu=null,this.Ku=!1,this.Jr=new rt,this.oh=new rt,this.$=i,this.Au=document.createElement("div"),this.Au.classList.add("tv-lightweight-charts"),this.Au.style.overflow="hidden",this.Au.style.width="100%",this.Au.style.height="100%",this.$u=document.createElement("table"),this.$u.setAttribute("cellspacing","0"),this.Au.appendChild(this.$u),this._u=this.Xu.bind(this),this.Au.addEventListener("wheel",this._u,{passive:!1}),this.F=new bn(this.fh.bind(this),this.$),this.model().crosshairMoved().subscribe(this.Zu.bind(this),this),this.Ju=new Yn(this),this.$u.appendChild(this.Ju.getElement());var s=this.$.width,h=this.$.height;if(0===s&&0===h){var r=t.getBoundingClientRect();(s=Math.floor(r.width))%2&&(s-=1),(h=Math.floor(r.height))%2&&(h-=1)}s=Math.max(70,s),h=Math.max(50,h),this.resize(s,h),this.Gu(),t.appendChild(this.Au),this.Qu(),this.F.timeScale().optionsApplied().subscribe((function(){n.Qu(),n.adjustSize()}),this)}return t.prototype.model=function(){return this.F},t.prototype.options=function(){return this.$},t.prototype.paneWidgets=function(){return this.Wu},t.prototype.destroy=function(){this.Au.removeEventListener("wheel",this._u),0!==this.qu&&window.cancelAnimationFrame(this.qu),this.F.crosshairMoved().unsubscribeAll(this),this.F.timeScale().optionsApplied().unsubscribeAll(this),this.F.destroy();for(var t=0,i=this.Wu;t<i.length;t++){var n=i[t];this.$u.removeChild(n.getElement()),n.clicked().unsubscribeAll(this),n.destroy()}this.Wu=[];for(var s=0,h=this.Uu;s<h.length;s++){var r=h[s];this.te(r)}this.Uu=[],c(this.Ju).destroy(),null!==this.Au.parentElement&&this.Au.parentElement.removeChild(this.Au),this.oh.destroy(),this.Jr.destroy(),delete this.Au},t.prototype.resize=function(t,i,n){if(void 0===n&&(n=!1),this.nn!==i||this.Kt!==t){this.nn=i,this.Kt=t;var s=i+"px",h=t+"px";c(this.Au).style.height=s,c(this.Au).style.width=h,this.$u.style.height=s,this.$u.style.width=h,n?this.ie(new Hi(3)):this.F.fullUpdate()}},t.prototype.paint=function(t){void 0===t&&(t=new Hi(3));for(var i=0;i<this.Wu.length;i++)this.Wu[i].paint(t.invalidateForPane(i).level);this.Ju.paint(t.fullInvalidation())},t.prototype.adjustSize=function(){this.ne(),this.F.fullUpdate()},t.prototype.applyOptions=function(t){this.F.applyOptions(t),this.Qu();var i=t.width||this.Kt,n=t.height||this.nn;this.resize(i,n)},t.prototype.clicked=function(){return this.Jr},t.prototype.crosshairMoved=function(){return this.oh},t.prototype.takeScreenshot=function(){var t=this;null!==this.Yu&&(this.ie(this.Yu),this.Yu=null);var i=this.Wu[0],n=kn(document,new mn(this.Kt,this.nn)),s=gn(n),h=pn(n);return q(s,h,(function(){var n=0,h=0,r=function(){for(var i=0;i<t.Wu.length;i++){var r=t.Wu[i],u=r.getSize().h,e=c(r.priceAxisWidget()),o=e.getImage();s.drawImage(o,n,h,e.getWidth(),u),h+=u,i<t.Wu.length-1&&(h+=1)}};"left"===t.$.priceScale.position&&(r(),n=c(i.priceAxisWidget()).getWidth()),h=0;for(var u=0;u<t.Wu.length;u++){var e=t.Wu[u],o=e.getSize(),f=e.getImage();if(s.drawImage(f,n,h,o.w,o.h),h+=o.h,u<t.Wu.length-1){var a=t.Uu[u],l=a.getSize(),v=a.getImage();s.drawImage(v,n,h,l.w,l.h),h+=l.h}}n+=i.getSize().w,"right"===t.$.priceScale.position&&(h=0,r());var d=function(){var i=c(t.Ju.stub()),r=i.getSize(),u=i.getImage();s.drawImage(u,n,h,r.w,r.h)};if(t.$.timeScale.visible){n=0,"left"===t.$.priceScale.position&&(d(),n=c(i.priceAxisWidget()).getWidth());var M=t.Ju.getSize();f=t.Ju.getImage();s.drawImage(f,n,h,M.w,M.h),"right"===t.$.priceScale.position&&(n=i.getSize().w,d(),s.restore())}})),n},t.prototype.ne=function(){for(var t=0,i=0,n=0,s=this.Wu;n<s.length;n++){var h=s[n];"none"!==this.$.priceScale.position&&(i=Math.max(i,c(h.priceAxisWidget()).optimalWidth())),t+=h.stretchFactor()}var r=this.Kt,u=this.nn,e=Math.max(r-i,0),o=1*this.Uu.length,f=this.$.timeScale.visible?this.Ju.optimalHeight():0;f%2&&(f+=1);for(var a=o+f,l=u<a?0:u-a,v=l/t,d=0,M=0;M<this.Wu.length;++M){(h=this.Wu[M]).setState(this.F.panes()[M]);var w,b=0;b=M===this.Wu.length-1?l-d:Math.round(h.stretchFactor()*v),d+=w=Math.max(b,2),h.setSize(new mn(e,w)),"none"!==this.$.priceScale.position&&h.setPriceAxisSize(i),h.state()&&this.F.setPaneHeight(h.state(),w)}this.Ju.setSizes(new mn(e,f),i),this.F.setWidth(e),this.Hu!==i&&(this.Hu=i,this.ju.fire(i))},t.prototype.Xu=function(t){var i=t.deltaX/100,n=-t.deltaY/100;if(0!==i&&this.$.handleScroll.mouseWheel||0!==n&&this.$.handleScale.mouseWheel){switch(t.cancelable&&t.preventDefault(),t.deltaMode){case t.DOM_DELTA_PAGE:i*=120,n*=120;break;case t.DOM_DELTA_LINE:i*=32,n*=32}if(0!==n&&this.$.handleScale.mouseWheel){var s=Math.sign(n)*Math.min(1,Math.abs(n)),h=t.clientX-this.Au.getBoundingClientRect().left;this.model().zoomTime(h,s)}0!==i&&this.$.handleScroll.mouseWheel&&this.model().scrollChart(-80*i)}},t.prototype.ie=function(t){var i=t.fullInvalidation();if(3===i&&this.se(),3===i||2===i){for(var n=this.F.panes(),s=0;s<n.length;s++)t.invalidateForPane(s).autoScale&&n[s].momentaryAutoScale();t.getFitContent()&&this.F.timeScale().fitContent();var h=t.getTargetTimeRange();null!==h&&this.F.timeScale().setTimePointsRange(h),this.Ju.update()}this.paint(t)},t.prototype.fh=function(t){var i=this;null!==this.Yu?this.Yu.merge(t):this.Yu=t,this.Ku||(this.Ku=!0,this.qu=window.requestAnimationFrame((function(){i.Ku=!1,i.qu=0,null!==i.Yu&&(i.ie(i.Yu),i.Yu=null)})))},t.prototype.se=function(){this.Gu()},t.prototype.te=function(t){this.$u.removeChild(t.getElement()),t.destroy()},t.prototype.Gu=function(){for(var t=this.F.panes(),i=t.length,n=this.Wu.length,s=i;s<n;s++){var h=a(this.Wu.pop());this.$u.removeChild(h.getElement()),h.clicked().unsubscribeAll(this),h.destroy(),void 0!==(r=this.Uu.pop())&&this.te(r)}for(s=n;s<i;s++){if((h=new qn(this,t[s])).clicked().subscribe(this.he.bind(this),this),this.Wu.push(h),s>1){var r=new Pn(this,s-1,s,!0);this.Uu.push(r),this.$u.insertBefore(r.getElement(),this.Ju.getElement())}this.$u.insertBefore(h.getElement(),this.Ju.getElement())}for(s=0;s<i;s++){var u=t[s];(h=this.Wu[s]).state()!==u?h.setState(u):h.updatePriceAxisWidget()}this.Qu(),this.ne()},t.prototype.ue=function(t,i){var n,s=new Map;null!==t&&this.F.serieses().forEach((function(i){var n=i.dataAt(t);null!==n&&s.set(i,n)}));if(null!==t){var h=this.F.timeScale().indexToUserTime(t);null!==h&&(n=h)}var r=this.model().hoveredSource(),u=null!==r&&r.source instanceof Ci?r.source:void 0,e=null!==r&&void 0!==r.object?r.object.externalId:void 0;return{time:n,point:i||void 0,hoveredSeries:u,seriesPrices:s,hoveredObject:e}},t.prototype.he=function(t,i){var n=this;this.Jr.fire((function(){return n.ue(t,i)}))},t.prototype.Zu=function(t,i){var n=this;this.oh.fire((function(){return n.ue(t,i)}))},t.prototype.Qu=function(){var t=this.$.timeScale.visible?"":"none";this.Ju.getElement().style.display=t},t}();function $n(t){if(!Fi(t))throw new Error("time must be of type BusinessDay");var i=new Date(Date.UTC(t.year,t.month-1,t.day,0,0,0,0));return{timestamp:Math.round(i.getTime()/1e3),businessDay:t}}function _n(t){if(!Pi(t))throw new Error("time must be of type isUTCTimestamp");return{timestamp:t}}function Xn(t){return 0===t.length?null:Fi(t[0].time)?$n:_n}function Zn(t){return Pi(t)?_n(t):Fi(t)?$n(t):$n(es(t))}function Jn(t,i){var n=t.value,s=null;return"color"in t&&void 0!==t.color&&(s=i.addColor(t.color)),[n,n,n,n,s]}function Gn(t,i){return[t.open,t.high,t.low,t.close,null]}var Qn={Candlestick:Gn,Bar:Gn,Area:Jn,Histogram:Jn,Line:Jn};function ts(t){return Qn[t]}function is(t){return 60*t*60*1e3}function ns(t){return 60*t*1e3}var ss,hs=[{divisor:1,span:20},{divisor:(ss=1,1e3*ss),span:19},{divisor:ns(1),span:20},{divisor:ns(5),span:21},{divisor:ns(30),span:22},{divisor:is(1),span:30},{divisor:is(3),span:31},{divisor:is(6),span:32},{divisor:is(12),span:33}];function rs(t,i){if(null!==i){var n=new Date(1e3*i.timestamp),s=new Date(1e3*t.timestamp);if(s.getUTCFullYear()!==n.getUTCFullYear())return 70;if(s.getUTCMonth()!==n.getUTCMonth())return 60;if(s.getUTCDate()!==n.getUTCDate())return 50;for(var h=hs.length-1;h>=0;--h)if(Math.floor(n.getTime()/hs[h].divisor)!==Math.floor(s.getTime()/hs[h].divisor))return hs[h].span}return 20}function us(t,i){return t.timestamp<i.timestamp}function es(t){var i=new Date(t);if(isNaN(i.getTime()))throw new Error("Invalid date string="+t+", expected format=yyyy-mm-dd");return{day:i.getUTCDate(),month:i.getUTCMonth()+1,year:i.getUTCFullYear()}}function os(t){w(t.time)&&(t.time=es(t.time))}var fs,as=function(){function t(){this.ee=new Map,this.oe=new Map,this.fe=[]}return t.prototype.destroy=function(){this.ee.clear(),this.oe.clear(),this.fe=[]},t.prototype.setSeriesData=function(t,i){var n=this;t.clearData(),function(t){t.forEach(os)}(i),this.ee.forEach((function(i){return i.mapping.delete(t)}));var s=Xn(i);null!==s&&i.forEach((function(i){var h=s(i.time),r=n.ee.get(h.timestamp)||{index:0,mapping:new Map,timePoint:h};r.mapping.set(t,i),n.ee.set(h.timestamp,r)}));var h=new Map;return this.ee.forEach((function(t,i){t.mapping.size>0&&h.set(i,t)})),this.ae(h)},t.prototype.removeSeries=function(t){return this.setSeriesData(t,[])},t.prototype.updateSeriesData=function(t,i){os(i);var n=t.data().bars();if(n.size()>0)if(void 0!==c(n.last()).time.businessDay){if(!Fi(i.time))throw new Error("time must be of type BusinessDay")}else if(!Pi(i.time))throw new Error("time must be of type isUTCTimestamp");var s=c(Xn([i]))(i.time),h=this.ee.get(s.timestamp)||{index:0,mapping:new Map,timePoint:s},r=0===h.mapping.size;h.mapping.set(t,i);var u=!1;if(r){var e=this.ee.size;this.fe.length>0&&this.fe[this.fe.length-1].timestamp>s.timestamp?(e=Ct(this.fe,s,us),this.fe.splice(e,0,s),this.ce(e),u=!0):this.fe.push(s),h.index=e,this.oe.set(h.index,s)}this.ee.set(s.timestamp,h);var o=new Map,f=function(i){var n=a(l.oe.get(i));a(l.ee.get(n.timestamp)).mapping.forEach((function(s,h){if(u||h===t){var r=ts(h.seriesType()),e=o.get(h)||{update:[]},f={index:i,time:n,value:r(s,h.palette())};e.update.push(f),o.set(h,e)}}))},l=this;for(e=h.index;e<this.ee.size;++e)f(e);var v=r?this.le(h.index):[],d=r?this.fe.slice(h.index):[];return{timeScaleUpdate:{seriesUpdates:o,changes:d,index:h.index,marks:v}}},t.prototype.ae=function(t){var i=this;this.ee=t,this.fe=Array.from(this.ee.values()).map((function(t){return t.timePoint})),this.fe.sort((function(t,i){return t.timestamp-i.timestamp}));var n=new Map;this.fe.forEach((function(t,s){var h=a(i.ee.get(t.timestamp));h.index=s,h.mapping.forEach((function(i,h){var r=ts(h.seriesType()),u=n.get(h)||{update:[]},e={index:s,time:t,value:r(i,h.palette())};u.update.push(e),n.set(h,u)}))}));var s=null,h=this.fe.map((function(t,i){var n=rs(t,s);return s=t,{span:n,time:t,index:i}})),r={seriesUpdates:n,changes:this.fe.slice(),index:0,marks:h};return this.ve(),{timeScaleUpdate:r}},t.prototype.ce=function(t){for(var i=this.oe.size-1;i>=t;--i){var n=a(this.oe.get(i)),s=i+1;a(this.ee.get(n.timestamp)).index=s,this.oe.delete(i),this.oe.set(s,n)}},t.prototype.ve=function(){var t=this;this.oe.clear(),this.ee.forEach((function(i,n){t.oe.set(i.index,i.timePoint)}))},t.prototype.le=function(t){for(var i=[],n=this.oe.get(t-1)||null,s=t;s<this.oe.size;++s){var h=a(this.oe.get(s)),r=rs(h,n);n=h,i.push({span:r,time:h,index:s})}return i},t}(),cs={color:"#FF0000",price:0,lineStyle:2,lineWidth:1,axisLabelVisible:!0},ls=function(){function t(t){this.ii=t}return t.prototype.applyOptions=function(t){this.ii.applyOptions(t)},t.prototype.options=function(){return this.ii.options()},t.prototype.priceLine=function(){return this.ii},t}(),vs=function(){function t(t,i){this._series=t,this._dataUpdatesConsumer=i}return t.prototype.destroy=function(){delete this._series,delete this._dataUpdatesConsumer},t.prototype.priceFormatter=function(){return this._series.formatter()},t.prototype.series=function(){return this._series},t.prototype.priceToCoordinate=function(t){var i=this._series.firstValue();return null===i?null:this._series.priceScale().priceToCoordinate(t,i.value)},t.prototype.coordinateToPrice=function(t){var i=this._series.firstValue();return null===i?null:this._series.priceScale().coordinateToPrice(t,i.value)},t.prototype.setData=function(t){this._dataUpdatesConsumer.applyNewData(this._series,t)},t.prototype.update=function(t){this._dataUpdatesConsumer.updateData(this._series,t)},t.prototype.setMarkers=function(t){var i=t.map((function(t){return e(e({},t),{time:Zn(t.time)})}));this._series.setMarkers(i)},t.prototype.applyOptions=function(t){this._series.applyOptions(t)},t.prototype.options=function(){return p(this._series.options())},t.prototype.createPriceLine=function(t){var i=v(p(cs),t),n=this._series.createPriceLine(i);return new ls(n)},t.prototype.removePriceLine=function(t){this._series.removePriceLine(t.priceLine())},t}(),ds=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return u(i,t),i.prototype.applyOptions=function(i){Vi(i),t.prototype.applyOptions.call(this,i)},i}(vs),Ms={width:0,height:0,layout:{backgroundColor:"#FFFFFF",textColor:"#191919",fontSize:11,fontFamily:"'Trebuchet MS', Roboto, Ubuntu, sans-serif"},crosshair:{vertLine:{color:"#758696",width:1,style:3,visible:!0,labelVisible:!0,labelBackgroundColor:"#4c525e"},horzLine:{color:"#758696",width:1,style:3,visible:!0,labelVisible:!0,labelBackgroundColor:"#4c525e"},mode:1},grid:{vertLines:{color:"#D6DCDE",style:0,visible:!0},horzLines:{color:"#D6DCDE",style:0,visible:!0}},priceScale:{autoScale:!0,mode:0,invertScale:!1,alignLabels:!0,position:"right",borderVisible:!0,borderColor:"#2B2B43",entireTextOnly:!1,scaleMargins:{bottom:.1,top:.2}},timeScale:{rightOffset:0,barSpacing:6,fixLeftEdge:!1,lockVisibleTimeRangeOnResize:!1,rightBarStaysOnScroll:!1,borderVisible:!0,borderColor:"#2B2B43",visible:!0,timeVisible:!1,secondsVisible:!0},watermark:{color:"rgba(0, 0, 0, 0)",visible:!1,fontSize:48,text:"",horzAlign:"center",vertAlign:"center"},localization:{locale:navigator.language,dateFormat:"dd MMM 'yy"},handleScroll:{mouseWheel:!0,pressedMouseMove:!0,horzTouchDrag:!0,vertTouchDrag:!0},handleScale:{axisPressedMouseMove:!0,axisDoubleClickReset:!0,mouseWheel:!0,pinch:!0}},ws={upColor:"#26a69a",downColor:"#ef5350",wickVisible:!0,borderVisible:!0,borderColor:"#378658",borderUpColor:"#26a69a",borderDownColor:"#ef5350",wickColor:"#737375",wickUpColor:"#26a69a",wickDownColor:"#ef5350"},bs={upColor:"#26a69a",downColor:"#ef5350",openVisible:!0,thinBars:!0},ms={color:"#2196f3",lineStyle:0,lineWidth:3,lineType:0,crosshairMarkerVisible:!0,crosshairMarkerRadius:4},ps={topColor:"rgba( 46, 220, 135, 0.4)",bottomColor:"rgba( 40, 221, 100, 0)",lineColor:"#33D778",lineStyle:0,lineWidth:3,lineType:0,crosshairMarkerVisible:!0,crosshairMarkerRadius:4},gs={color:"#26a69a",base:0},ys={title:"",lastValueVisible:!0,priceLineVisible:!0,priceLineSource:0,priceLineWidth:1,priceLineColor:"",priceLineStyle:2,baseLineVisible:!0,baseLineWidth:1,baseLineColor:"#B2B5BE",baseLineStyle:0,priceFormat:{type:"price",precision:2,minMove:.01}},ks=function(){function t(t){this.l=t}return t.prototype.destroy=function(){delete this.l},t.prototype.applyOptions=function(t){this.l.applyOptions({priceScale:t})},t.prototype.options=function(){return this.B().options()},t.prototype.B=function(){return this.l.mainPriceScale()},t}();!function(t){t[t.AnimationDurationMs=1e3]="AnimationDurationMs"}(fs||(fs={}));var Ns=function(){function t(t){this.F=t}return t.prototype.destroy=function(){delete this.F},t.prototype.scrollPosition=function(){return this.$n().rightOffset()},t.prototype.scrollToPosition=function(t,i){i?this.$n().scrollToOffsetAnimated(t,1e3):this.$n().setRightOffset(t)},t.prototype.scrollToRealTime=function(){this.$n().scrollToRealTime()},t.prototype.getVisibleRange=function(){var t=this.$n().visibleBars();if(null===t)return null;var i=this.F.timeScale().points(),n=c(i.firstIndex()),s=c(i.lastIndex());return{from:Ss(c(i.valueAt(Math.max(n,t.firstBar())))),to:Ss(c(i.valueAt(Math.min(s,t.lastBar()))))}},t.prototype.setVisibleRange=function(t){var i={from:Zn(t.from),to:Zn(t.to)};this.F.setTargetTimeRange(i)},t.prototype.resetTimeScale=function(){this.F.resetTimeScale()},t.prototype.fitContent=function(){this.F.fitContent()},t.prototype.applyOptions=function(t){this.$n().applyOptions(t)},t.prototype.options=function(){return p(this.$n().options())},t.prototype.$n=function(){return this.F.timeScale()},t}();function Ss(t){return t.businessDay||t.timestamp}function xs(t){if(void 0!==t&&"custom"!==t.type){var i=t;void 0!==i.minMove&&void 0===i.precision&&(i.precision=function(t){if(t>=1)return 0;for(var i=0;i<8;i++){var n=Math.round(t);if(Math.abs(n-t)<1e-8)return i;t*=10}return i}(i.minMove))}}function Ds(t){var i=t.handleScale;m(i)&&(t.handleScale={axisDoubleClickReset:i,axisPressedMouseMove:i,mouseWheel:i,pinch:i});var n=t.handleScroll;return m(n)&&(t.handleScroll={horzTouchDrag:n,vertTouchDrag:n,mouseWheel:n,pressedMouseMove:n}),t}var Cs=function(){function t(t,i){var n=this;this.de=new as,this.Me=new rt,this.we=new Map,this.be=new Map,this.me=new rt,this.pe=new rt;var s=void 0===i?p(Ms):v(p(Ms),Ds(i));this.ur=new Kn(t,s),this.ur.model().timeScale().visibleBarsChanged().subscribe(this.ge.bind(this)),this.ur.clicked().subscribe((function(t){n.me.hasListeners()&&n.me.fire(n.ye(t()))}),this),this.ur.crosshairMoved().subscribe((function(t){n.pe.hasListeners()&&n.pe.fire(n.ye(t()))}),this);var h=this.ur.model();this.ke=new ks(h),this.Ne=new Ns(h)}return t.prototype.remove=function(){this.ur.model().timeScale().visibleBarsChanged().unsubscribeAll(this),this.ur.clicked().unsubscribeAll(this),this.ur.crosshairMoved().unsubscribeAll(this),this.ke.destroy(),this.Ne.destroy(),this.ur.destroy(),delete this.ur,this.we.forEach((function(t,i){i.destroy()})),this.we.clear(),this.be.clear(),this.Me.destroy(),this.me.destroy(),this.pe.destroy(),this.de.destroy(),delete this.de},t.prototype.resize=function(t,i,n){this.ur.resize(t,i,n)},t.prototype.addAreaSeries=function(t){void 0===t&&(t={}),xs(t.priceFormat);var i=v(p(ys),ps,t),n=this.ur.model().createSeries("Area",i),s=new vs(n,this);return this.we.set(s,n),this.be.set(n,s),s},t.prototype.addBarSeries=function(t){void 0===t&&(t={}),xs(t.priceFormat);var i=v(p(ys),bs,t),n=this.ur.model().createSeries("Bar",i),s=new vs(n,this);return this.we.set(s,n),this.be.set(n,s),s},t.prototype.addCandlestickSeries=function(t){void 0===t&&(t={}),Vi(t),xs(t.priceFormat);var i=v(p(ys),ws,t),n=this.ur.model().createSeries("Candlestick",i),s=new ds(n,this);return this.we.set(s,n),this.be.set(n,s),s},t.prototype.addHistogramSeries=function(t){void 0===t&&(t={}),xs(t.priceFormat);var i=v(p(ys),gs,t),n=this.ur.model().createSeries("Histogram",i),s=new vs(n,this);return this.we.set(s,n),this.be.set(n,s),s},t.prototype.addLineSeries=function(t){void 0===t&&(t={}),xs(t.priceFormat);var i=v(p(ys),ms,t),n=this.ur.model().createSeries("Line",i),s=new vs(n,this);return this.we.set(s,n),this.be.set(n,s),s},t.prototype.removeSeries=function(t){var i=t,n=a(this.we.get(i)),s=this.de.removeSeries(n),h=this.ur.model();h.removeSeries(n);var r=s.timeScaleUpdate;h.updateTimeScale(r.index,r.changes,r.marks,!0),r.seriesUpdates.forEach((function(t,i){i.updateData(t.update)})),h.updateTimeScaleBaseIndex(0),this.we.delete(i),this.be.delete(n)},t.prototype.applyNewData=function(t,i){var n=this.de.setSeriesData(t,i),s=this.ur.model(),h=n.timeScaleUpdate;s.updateTimeScale(h.index,h.changes,h.marks,!0),h.seriesUpdates.forEach((function(t,i){i.updateData(t.update,!0)})),s.updateTimeScaleBaseIndex(0)},t.prototype.updateData=function(t,i){var n=this.de.updateSeriesData(t,i),s=this.ur.model(),h=n.timeScaleUpdate;s.updateTimeScale(h.index,h.changes,h.marks,!1),h.seriesUpdates.forEach((function(t,i){i.updateData(t.update)})),s.updateTimeScaleBaseIndex(0)},t.prototype.subscribeClick=function(t){this.me.subscribe(t)},t.prototype.unsubscribeClick=function(t){this.me.unsubscribe(t)},t.prototype.subscribeCrosshairMove=function(t){this.pe.subscribe(t)},t.prototype.unsubscribeCrosshairMove=function(t){this.pe.unsubscribe(t)},t.prototype.subscribeVisibleTimeRangeChange=function(t){this.Me.subscribe(t)},t.prototype.unsubscribeVisibleTimeRangeChange=function(t){this.Me.unsubscribe(t)},t.prototype.priceScale=function(){return this.ke},t.prototype.timeScale=function(){return this.Ne},t.prototype.applyOptions=function(t){this.ur.applyOptions(Ds(t))},t.prototype.options=function(){return this.ur.options()},t.prototype.takeScreenshot=function(){return this.ur.takeScreenshot()},t.prototype.ge=function(){this.Me.hasListeners()&&this.Me.fire(this.timeScale().getVisibleRange())},t.prototype.Se=function(t){return a(this.be.get(t))},t.prototype.ye=function(t){var i=this,n=new Map;t.seriesPrices.forEach((function(t,s){n.set(i.Se(s),t)}));var s=void 0===t.hoveredSeries?void 0:this.Se(t.hoveredSeries);return{time:t.time&&(t.time.businessDay||t.time.timestamp),point:t.point,hoveredSeries:s,hoveredMarkerId:t.hoveredObject,seriesPrices:n}},t}();function Ts(t,i){var n=c(w(t)?document.getElementById(t):t);return new Cs(n,i)}function Es(){return"2.0.0"}


/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindToDevicePixelRatio;
function bindToDevicePixelRatio(canvas) {
    return new DevicePixelRatioBinding(canvas);
}
var DevicePixelRatioBinding = /** @class */ (function () {
    function DevicePixelRatioBinding(canvas) {
        var _this = this;
        this._resolutionMediaQueryList = null;
        this._resolutionListener = function (ev) { return _this._onResolutionChanged(); };
        this._canvasConfiguredListeners = [];
        this.canvas = canvas;
        this._canvasSize = {
            width: this.canvas.clientWidth,
            height: this.canvas.clientHeight,
        };
        this._configureCanvas();
        this._installResolutionListener();
    }
    DevicePixelRatioBinding.prototype.destroy = function () {
        this._canvasConfiguredListeners.length = 0;
        this._uninstallResolutionListener();
        this.canvas = null;
    };
    Object.defineProperty(DevicePixelRatioBinding.prototype, "canvasSize", {
        get: function () {
            return {
                width: this._canvasSize.width,
                height: this._canvasSize.height,
            };
        },
        enumerable: true,
        configurable: true
    });
    DevicePixelRatioBinding.prototype.resizeCanvas = function (size) {
        this._canvasSize = {
            width: size.width,
            height: size.height,
        };
        this._configureCanvas();
    };
    Object.defineProperty(DevicePixelRatioBinding.prototype, "pixelRatio", {
        get: function () {
            // According to DOM Level 2 Core specification, ownerDocument should never be null for HTMLCanvasElement
            // see https://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#node-ownerDoc
            var win = this.canvas.ownerDocument.defaultView;
            if (win == null) {
                throw new Error('No window is associated with the canvas');
            }
            return win.devicePixelRatio;
        },
        enumerable: true,
        configurable: true
    });
    DevicePixelRatioBinding.prototype.subscribeCanvasConfigured = function (listener) {
        this._canvasConfiguredListeners.push(listener);
    };
    DevicePixelRatioBinding.prototype.unsubscribeCanvasConfigured = function (listener) {
        this._canvasConfiguredListeners = this._canvasConfiguredListeners.filter(function (l) { return l != listener; });
    };
    DevicePixelRatioBinding.prototype._configureCanvas = function () {
        var ratio = this.pixelRatio;
        this.canvas.style.width = this._canvasSize.width + "px";
        this.canvas.style.height = this._canvasSize.height + "px";
        this.canvas.width = this._canvasSize.width * ratio;
        this.canvas.height = this._canvasSize.height * ratio;
        this._emitCanvasConfigured();
    };
    DevicePixelRatioBinding.prototype._emitCanvasConfigured = function () {
        var _this = this;
        this._canvasConfiguredListeners.forEach(function (listener) { return listener.call(_this); });
    };
    DevicePixelRatioBinding.prototype._installResolutionListener = function () {
        if (this._resolutionMediaQueryList !== null) {
            throw new Error('Resolution listener is already installed');
        }
        // According to DOM Level 2 Core specification, ownerDocument should never be null for HTMLCanvasElement
        // see https://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#node-ownerDoc
        var win = this.canvas.ownerDocument.defaultView;
        if (win == null) {
            throw new Error('No window is associated with the canvas');
        }
        var dppx = win.devicePixelRatio;
        this._resolutionMediaQueryList = win.matchMedia("all and (resolution: " + dppx + "dppx)");
        // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
        this._resolutionMediaQueryList.addListener(this._resolutionListener);
    };
    DevicePixelRatioBinding.prototype._uninstallResolutionListener = function () {
        if (this._resolutionMediaQueryList !== null) {
            // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
            this._resolutionMediaQueryList.removeListener(this._resolutionListener);
            this._resolutionMediaQueryList = null;
        }
    };
    DevicePixelRatioBinding.prototype._reinstallResolutionListener = function () {
        this._uninstallResolutionListener();
        this._installResolutionListener();
    };
    DevicePixelRatioBinding.prototype._onResolutionChanged = function () {
        this._configureCanvas();
        this._reinstallResolutionListener();
    };
    return DevicePixelRatioBinding;
}());


/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntervalButtons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_tickerHelper__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IntervalButtons_css__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IntervalButtons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__IntervalButtons_css__);







var IntervalButtons = function IntervalButtons(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'interval-buttons-wrapper' },
    Object.keys(__WEBPACK_IMPORTED_MODULE_3__helpers_tickerHelper__["a" /* SUPPORTED_TICKER_INTERVALS */]).map(function (i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedIntervalButton, {
        key: i,
        interval: i,
        value: __WEBPACK_IMPORTED_MODULE_3__helpers_tickerHelper__["a" /* SUPPORTED_TICKER_INTERVALS */][i]
      });
    })
  );
};

IntervalButtons.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var IntervalButton = function IntervalButton(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    {
      className: 'ap-inline-btn__btn lightweight-interval-button ' + (props.selectedInterval === props.value ? 'active' : ''),
      label: props.interval,
      onClick: props.changeTickersInterval,
      type: 'button' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      context.t(props.interval)
    )
  );
};

IntervalButton.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedInterval: state.tickers.interval
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    changeTickersInterval: function changeTickersInterval() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__["e" /* changeTickersInterval */])(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_tickerHelper__["b" /* convertLabelToTickerInterval */])(ownProps.interval)));
    }
  };
};
var ConnectedIntervalButton = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(IntervalButton);

/***/ }),
/* 1894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssVarHelper__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_resize__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_chart_react_lib_chart_style_css__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_chart_react_lib_chart_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_apex_chart_react_lib_chart_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_components_TradeComponent_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_components_TradeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_components_TradeComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DepthChart_css__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DepthChart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DepthChart_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');
var depthChartComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('depth-chart');

var mousePos = { x: 0, y: 0 };
var mouseOver = false;
var defaultDepthChartZoom = 5;

var DepthChartComponent = function (_React$Component) {
  _inherits(DepthChartComponent, _React$Component);

  function DepthChartComponent(props) {
    _classCallCheck(this, DepthChartComponent);

    var _this = _possibleConstructorReturn(this, (DepthChartComponent.__proto__ || Object.getPrototypeOf(DepthChartComponent)).call(this, props));

    _this.setListeners = function () {
      var chartDom = document.getElementById('depthchart');
      chartDom.addEventListener('mouseover', function () {
        mouseOver = true;
      });
      chartDom.addEventListener('mouseout', function () {
        mouseOver = false;
        _this.drawChart();
      });
      chartDom.addEventListener('mousemove', function (evt) {
        var rect = chartDom.getBoundingClientRect();
        mousePos = {
          x: evt.clientX - rect.left,
          y: evt.clientY - rect.top
        };

        _this.drawChart();
      });
      chartDom.addEventListener('click', function () {
        if (_this.mouseHoverBuy) {
          _this.props.buyPriceClicked(_this.closestMousePositionInfo.price);
        } else {
          _this.props.sellPriceClicked(_this.closestMousePositionInfo.price);
        }
      });
    };

    _this.getSellTooltipRotation = function (tooltipSize, offsetCentralChartLine, priceAxisHeight) {
      var marginTop = _this.closestMousePositionInfo.y - tooltipSize.height;
      var marginLeft = _this.closestMousePositionInfo.x - tooltipSize.width;
      var marginBottom = _this.closestMousePositionInfo.y + tooltipSize.height;
      var centralChartLimit = _this.chartWidth / 2 + offsetCentralChartLine;
      var bottomChartLimit = _this.chartHeight - priceAxisHeight;

      var rightBottomRotation = marginLeft <= centralChartLimit && marginTop <= 0;
      var rightTopRotation = marginLeft <= centralChartLimit && marginBottom >= bottomChartLimit;
      var leftBottomRotation = marginLeft >= centralChartLimit && marginTop <= 0;

      if (rightBottomRotation) {
        return { x: 1, y: -1 };
      } else if (rightTopRotation) {
        return { x: 1, y: 1 };
      } else if (leftBottomRotation) {
        return { x: -1, y: -1 };
      } else {
        return { x: -1, y: 1 };
      }
    };

    _this.getBuyTooltipRotation = function (tooltipSize, offsetCentralChartLine, priceAxisHeight) {
      var marginTop = _this.closestMousePositionInfo.y - tooltipSize.height;
      var marginRight = _this.closestMousePositionInfo.x + tooltipSize.width;
      var marginBottom = _this.closestMousePositionInfo.y + tooltipSize.height;
      var centralChartLimit = _this.chartWidth / 2 - offsetCentralChartLine;
      var bottomChartLimit = _this.chartHeight - priceAxisHeight;

      var leftBottomRotation = marginRight >= centralChartLimit && marginTop <= 0;
      var leftTopRotation = marginRight >= centralChartLimit && marginBottom >= bottomChartLimit;
      var rightBottomRotation = marginRight <= centralChartLimit && marginTop <= 0;

      if (leftBottomRotation) {
        return { x: -1, y: -1 };
      } else if (leftTopRotation) {
        return { x: -1, y: 1 };
      } else if (rightBottomRotation) {
        return { x: 1, y: -1 };
      } else {
        return { x: 1, y: 1 };
      }
    };

    _this.renderTooltip = function (depthChartTextFont, depthChartTextColor, lastTradeUpColorTransparent, lastTradeDownColorTransparent) {
      var tooltipSize = {
        width: 100,
        height: 60,
        paddingLeft: 20,
        paddingTop: 10
      };
      var offsetCentralChartLine = 60;
      var priceAxisHeight = 10;

      var sellTooltipRotation = _this.getSellTooltipRotation(tooltipSize, offsetCentralChartLine, priceAxisHeight);
      var buyTooltipRotation = _this.getBuyTooltipRotation(tooltipSize, offsetCentralChartLine, priceAxisHeight);

      var getFieldPositionX = function getFieldPositionX() {
        var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var x = _this.closestMousePositionInfo.x;

        var tooltipRotation = _this.mouseHoverBuy ? buyTooltipRotation : sellTooltipRotation;
        var rightBottomRotation = tooltipRotation.x === 1 && tooltipRotation.y === -1;
        var rightTopRotation = tooltipRotation.x === 1 && tooltipRotation.y === 1;

        if (rightBottomRotation || rightTopRotation) {
          return x + tooltipSize.paddingLeft + padding;
        } else {
          return x - tooltipSize.width + tooltipSize.paddingLeft + padding;
        }
      };

      var getFieldPositionY = function getFieldPositionY() {
        var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = _this.closestMousePositionInfo.y;

        var tooltipRotation = _this.mouseHoverBuy ? buyTooltipRotation : sellTooltipRotation;
        var rightBottomRotation = tooltipRotation.x === 1 && tooltipRotation.y === -1;
        var leftBottomRotation = tooltipRotation.x === -1 && tooltipRotation.y === -1;

        if (rightBottomRotation || leftBottomRotation) {
          return y + tooltipSize.paddingTop + padding;
        } else {
          return y - tooltipSize.height + tooltipSize.paddingTop + padding;
        }
      };

      if (mouseOver && (_this.mouseHoverBuy || _this.mouseHoverSell)) {
        _this.ctx2.beginPath();
        _this.ctx2.arc(_this.closestMousePositionInfo.x, _this.closestMousePositionInfo.y, 3, 0, 2 * Math.PI, false);
        _this.ctx2.fillStyle = 'rgba(205,205,205, 0.3)';
        _this.ctx2.fill();
        _this.ctx2.lineWidth = 1;
        _this.ctx2.strokeStyle = 'rgba(205,205,205, 0.3)';
        _this.ctx2.stroke();

        if (_this.mouseHoverBuy) {
          _this.ctx2.font = depthChartTextFont;
          _this.ctx2.fillStyle = depthChartTextColor;
          _this.ctx2.fillText(_this.closestMousePositionInfo.price.toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(), getFieldPositionY(10));
          _this.ctx2.fillText('Buy', getFieldPositionX(), getFieldPositionY(25));
          _this.ctx2.fillText(_this.closestMousePositionInfo.volume.toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(30), getFieldPositionY(25));
          _this.ctx2.fillText('Cost', getFieldPositionX(), getFieldPositionY(40));
          _this.ctx2.fillText((_this.closestMousePositionInfo.volume * _this.closestMousePositionInfo.price).toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(30), getFieldPositionY(40));
          _this.ctx2.fillStyle = lastTradeUpColorTransparent;
          _this.ctx2.fillRect(_this.closestMousePositionInfo.x, _this.closestMousePositionInfo.y - tooltipSize.height * buyTooltipRotation.y, tooltipSize.width * buyTooltipRotation.x, tooltipSize.height * buyTooltipRotation.y);
        }

        if (_this.mouseHoverSell) {
          _this.ctx2.font = depthChartTextFont;
          _this.ctx2.fillStyle = depthChartTextColor;
          _this.ctx2.fillText(_this.closestMousePositionInfo.price.toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(), getFieldPositionY(10));
          _this.ctx2.fillText('Buy', getFieldPositionX(), getFieldPositionY(25));
          _this.ctx2.fillText(_this.closestMousePositionInfo.volume.toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(30), getFieldPositionY(25));
          _this.ctx2.fillText('Cost', getFieldPositionX(), getFieldPositionY(40));
          _this.ctx2.fillText((_this.closestMousePositionInfo.volume * _this.closestMousePositionInfo.price).toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(30), getFieldPositionY(40));
          _this.ctx2.fillStyle = lastTradeDownColorTransparent;
          _this.ctx2.fillRect(_this.closestMousePositionInfo.x, _this.closestMousePositionInfo.y - tooltipSize.height * sellTooltipRotation.y, tooltipSize.width * sellTooltipRotation.x, tooltipSize.height * sellTooltipRotation.y);
        }
      }
    };

    _this.zoomDpethChartPlus = function () {
      var newDepthChartZoom = _this.state.depthchartzoom / 1.25;
      if (newDepthChartZoom < 0.0001) {
        _this.setState({
          depthchartzoom: 0.0001
        });
      } else {
        _this.setState({
          depthchartzoom: newDepthChartZoom
        });
      }

      _this.drawChart();
    };

    _this.zoomDpethChartMinus = function () {
      var newDepthChartZoom = _this.state.depthchartzoom * 1.25;
      if (newDepthChartZoom > 1000) {
        _this.setState({
          depthchartzoom: 1000
        });
      } else {
        _this.setState({
          depthchartzoom: newDepthChartZoom
        });
      }

      _this.drawChart();
    };

    _this.state = {
      depthchartzoom: _this.props.DepthChart.depthchartzoom || defaultDepthChartZoom
    };
    return _this;
  }

  _createClass(DepthChartComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.cssVariable = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssVarHelper__["a" /* getCSSVar */])();
      this.setListeners();
      this.drawChart();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedInstrument.InstrumentId !== this.props.selectedInstrument.InstrumentId) {
        this.setState({
          depthchartzoom: this.props.DepthChart.depthchartzoom || defaultDepthChartZoom
        });
      }

      this.drawChart();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'drawChart',
    value: function drawChart() {
      var _props = this.props,
          DepthChart = _props.DepthChart,
          smallScreen = _props.smallScreen,
          level2 = _props.level2;


      var depthChartHeight = DepthChart.depthChartHeight + 50 || 300;
      var depthChartTextColor = DepthChart.depthChartTextColor || 'rgb(200,200,200)'; // Grey
      var depthChartTextFont = DepthChart.depthChartTextFont || '12px';
      var depthChartXAxisTextPadding = DepthChart.depthChartXAxisTextPadding || 60;
      var depthChartYAxisTextPadding = DepthChart.depthChartYAxisTextPadding || 20;
      var depthChartBottomPadding = DepthChart.depthChartBottomPadding || 20;
      var depthChartXAxisStepCnt = DepthChart.depthChartXAxisStepCnt || 9;
      var depthChartXAxisStepColor = this.cssVariable('--chart__x-axis-step-color');
      var lastTradeDownColor = this.cssVariable('--chart__bearish-color');

      var lastTradeDownColorTransparent = this.cssVariable('--chart__bearish-color_transparent');

      var lastTradeUpColor = this.cssVariable('--chart__bullish-color');
      var lastTradeUpColorTransparent = this.cssVariable('--chart__bullish-color_transparent');

      var buyBook = level2.buy;
      var sellBook = level2.sell;

      var c2 = document.getElementById('depthchart');
      var ch = document.getElementById('depthChartHolder');
      c2.width = ch.clientWidth;
      c2.height = smallScreen ? ch.clientHeight : depthChartHeight;
      this.chartHeight = c2.height;
      this.chartWidth = c2.width;
      var maxBidPrice = 0;
      var minAskPrice = 999999;

      var sortedSellBook = sellBook.map(function (order) {
        return order.Price;
      });
      sortedSellBook.forEach(function (price) {
        if (price < minAskPrice) minAskPrice = price;
      });

      var sortedBuyBook = buyBook.map(function (order) {
        return order.Price;
      });
      sortedBuyBook.forEach(function (price) {
        if (price > maxBidPrice) maxBidPrice = price;
      });

      var center = (minAskPrice + maxBidPrice) / 2;

      this.relativeDepthChartZoom = Math.abs((minAskPrice - maxBidPrice) * this.state.depthchartzoom);

      var midMarketPrice = document.getElementById('midMarketPrice');
      midMarketPrice.innerHTML = center.toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(this.props.selectedInstrument.PriceIncrement));
      var maxAskDisplay = center + this.relativeDepthChartZoom;
      var minBidDisplay = center - this.relativeDepthChartZoom;

      var visibleAskDepth = 0;
      var sellLevels = 0;
      for (var i = sortedSellBook.length - 1; i >= 0; --i) {
        if (sellBook[i].Price > maxAskDisplay) break;
        visibleAskDepth += sellBook[i].Quantity;
        ++sellLevels;
      }
      var visibleBidDepth = 0;
      var buyLevels = 0;
      for (var _i = 0; _i < sortedBuyBook.length; _i++) {
        if (buyBook[_i].Price < minBidDisplay) break;
        visibleBidDepth += buyBook[_i].Quantity;
        ++buyLevels;
      }

      var topvisibleDepth = visibleAskDepth;
      if (visibleBidDepth > visibleAskDepth) topvisibleDepth = visibleBidDepth;

      var multX = this.chartWidth / (this.relativeDepthChartZoom * 2); // pixels per unit of price
      var multY = (this.chartHeight - depthChartBottomPadding) / topvisibleDepth; // pixels per unit of depth

      this.ctx2 = c2.getContext('2d');
      this.ctx2.clearRect(0, 0, this.chartWidth, this.chartHeight);
      var lastY = this.chartHeight - depthChartBottomPadding;
      var lastX = this.chartWidth / 2;

      this.ctx2.beginPath();
      this.ctx2.moveTo(lastX, 50);
      this.ctx2.save();
      this.ctx2.lineWidth = 1;
      this.ctx2.lineTo(lastX, this.chartHeight - depthChartBottomPadding);
      this.ctx2.strokeStyle = depthChartTextColor;
      this.ctx2.stroke();

      this.mouseHoverBuy = false;
      this.mouseHoverSell = false;
      if (mousePos.x < lastX) {
        this.mouseHoverBuy = true;
      } else if (mousePos.x > lastX) {
        this.mouseHoverSell = true;
      }

      var lastTextEntry = lastX;
      var lastpx = center;
      lastX = this.chartWidth / 2 - (center - parseFloat(sortedBuyBook[0])) * multX;

      var lastXDrawn = 0;
      var lastYDrawn = 0;

      var lastTextEntryY = lastY;
      var lastTextEntryX = lastX;
      var depthShown = 0;

      this.closestMousePositionInfo = {
        price: 0,
        volume: 0,
        x: 0,
        y: 0,
        xdiff: 999999
      };
      this.closestMousePositionInfo.mouseX = mousePos.x;

      for (var _i2 = 0; _i2 < depthChartXAxisStepCnt; _i2++) {
        var xAxisText = (minBidDisplay + this.relativeDepthChartZoom * 2 / (depthChartXAxisStepCnt - 1) * _i2).toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(this.props.selectedInstrument.PriceIncrement));
        var xAxisStepI = (this.chartWidth - 35) / (depthChartXAxisStepCnt - 1) * _i2;
        this.ctx2.font = depthChartTextFont;
        this.ctx2.fillStyle = depthChartXAxisStepColor;
        this.ctx2.fillText(xAxisText, xAxisStepI, this.chartHeight - 10);
      }

      for (var _i3 = 0; _i3 < buyLevels; _i3++) {
        var lvl = buyBook[_i3];
        depthShown += lvl.Quantity;
        var x = parseInt(lastX - (lastpx - lvl.Price) * multX, 10);
        var y = this.chartHeight - parseInt(depthShown * multY, 10) - depthChartBottomPadding;

        if (this.mouseHoverBuy) {
          if (this.closestMousePositionInfo.xdiff > Math.abs(lastX - mousePos.x)) {
            this.closestMousePositionInfo.price = lvl.Price;
            this.closestMousePositionInfo.xdiff = Math.abs(lastX - mousePos.x);
            this.closestMousePositionInfo.volume = depthShown;
            this.closestMousePositionInfo.x = lastX;
            this.closestMousePositionInfo.y = y;
          }
        }

        lastpx = lvl.Price;

        if (lastTextEntryX - x > depthChartXAxisTextPadding && x - 40 > 0) {
          lastTextEntryX = x;
        }

        if (x <= this.chartWidth && y <= this.chartHeight && x >= 0) {
          this.ctx2.beginPath();
          this.ctx2.moveTo(lastX, y);
          this.ctx2.save();
          this.ctx2.lineWidth = 1;
          this.ctx2.lineTo(x, y);
          this.ctx2.strokeStyle = lastTradeUpColor;
          this.ctx2.stroke();

          this.ctx2.beginPath();
          this.ctx2.moveTo(lastX, lastY);
          this.ctx2.lineTo(lastX, y);
          this.ctx2.stroke();
          this.ctx2.restore();
          this.ctx2.fillStyle = lastTradeUpColorTransparent;

          this.ctx2.fillRect(lastX, y, x - lastX, this.chartHeight - depthChartBottomPadding - y);

          if (lastTextEntryY - y >= depthChartYAxisTextPadding && y - 10 > 0) {
            lastTextEntryY = y;
            this.ctx2.save();
            this.ctx2.beginPath();
            this.ctx2.moveTo(x, y);
            this.ctx2.lineW = 1;
            this.ctx2.lineTo(0, y);
            this.ctx2.strokeStyle = lastTradeUpColor;
            this.ctx2.setLineDash([2, 3]);
            this.ctx2.stroke();
            this.ctx2.restore();
          }

          if (x - lastTextEntry >= depthChartXAxisTextPadding) {
            this.ctx2.save();
            this.ctx2.beginPath();
            this.ctx2.moveTo(x, this.chartHeight - depthChartBottomPadding);
            this.ctx2.lineW = 1;
            this.ctx2.lineTo(x, this.chartHeight - 10);
            this.ctx2.strokeStyle = lastTradeUpColor;
            this.ctx2.stroke();
            this.ctx2.restore();
            lastTextEntry = x;
          }

          lastXDrawn = x;
          lastYDrawn = y;
        }

        lastX = x;
        lastY = y;
      }

      this.ctx2.fillStyle = lastTradeUpColorTransparent;
      this.ctx2.fillRect(0, lastYDrawn, lastXDrawn, this.chartHeight - depthChartBottomPadding - lastYDrawn);
      this.ctx2.beginPath();
      this.ctx2.moveTo(lastXDrawn, lastYDrawn);
      this.ctx2.save();
      this.ctx2.lineWidth = 1;
      this.ctx2.lineTo(0, lastYDrawn);
      this.ctx2.strokeStyle = lastTradeUpColor;
      this.ctx2.stroke();
      this.ctx2.restore();

      lastY = this.chartHeight - depthChartBottomPadding;
      lastX = this.chartWidth / 2;
      lastTextEntry = lastX;
      lastpx = center;
      lastTextEntryY = lastY;
      lastX = this.chartWidth / 2 + (parseFloat(sortedSellBook[sortedSellBook.length - 1]) - center) * multX;
      lastTextEntryX = 0;
      var shownum = sortedSellBook.length - sellLevels - 1;
      if (shownum < 0) shownum = 0;
      var depthShownA = 0;
      for (var _i4 = sortedSellBook.length - 1; _i4 >= shownum; _i4--) {
        var _lvl = sellBook[_i4];
        depthShownA += _lvl.Quantity;
        var _x3 = parseInt(lastX + (_lvl.Price - lastpx) * multX, 10);
        var _y = this.chartHeight - parseInt(depthShownA * multY, 10) - depthChartBottomPadding;
        lastpx = _lvl.Price;

        if (this.mouseHoverSell) {
          if (this.closestMousePositionInfo.xdiff > Math.abs(lastX - mousePos.x)) {
            this.closestMousePositionInfo.xdiff = Math.abs(lastX - mousePos.x);
            this.closestMousePositionInfo.price = _lvl.Price;
            this.closestMousePositionInfo.volume = depthShownA;
            this.closestMousePositionInfo.x = lastX;
            this.closestMousePositionInfo.y = _y;
          }
        }

        if (_x3 - lastTextEntryX > depthChartXAxisTextPadding && _x3 + 40 < this.chartWidth) {
          lastTextEntryX = _x3;
        }

        if (_x3 <= this.chartWidth && _y <= this.chartHeight && _x3 >= 0) {
          this.ctx2.save();
          this.ctx2.beginPath();
          this.ctx2.moveTo(lastX, _y);
          this.ctx2.lineWidth = 1;
          this.ctx2.lineTo(_x3, _y);
          this.ctx2.strokeStyle = lastTradeDownColor;
          this.ctx2.stroke();

          this.ctx2.beginPath();
          this.ctx2.moveTo(lastX, lastY);
          this.ctx2.lineTo(lastX, _y);
          this.ctx2.stroke();
          this.ctx2.restore();
          this.ctx2.fillStyle = lastTradeDownColorTransparent;

          this.ctx2.fillRect(lastX, _y, _x3 - lastX, this.chartHeight - depthChartBottomPadding - _y);

          if (lastTextEntryY - _y >= depthChartYAxisTextPadding && _y - 10 > 0) {
            lastTextEntryY = _y;
            this.ctx2.save();
            this.ctx2.beginPath();
            this.ctx2.moveTo(this.chartWidth, _y);
            this.ctx2.lineW = 1;
            this.ctx2.lineTo(_x3, _y);
            this.ctx2.strokeStyle = lastTradeDownColor;
            this.ctx2.setLineDash([2, 3]);
            this.ctx2.stroke();
            this.ctx2.restore();
          }
          if (lastTextEntry - _x3 >= depthChartXAxisTextPadding) {
            this.ctx2.font = depthChartTextFont;
            this.ctx2.fillStyle = depthChartTextColor;
            this.ctx2.fillText(_lvl.Price.toFixed(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(this.props.selectedInstrument.PriceIncrement)), _x3, this.chartHeight);

            this.ctx2.save();
            this.ctx2.beginPath();
            this.ctx2.moveTo(_x3, this.chartHeight - depthChartBottomPadding);
            this.ctx2.lineW = 1;
            this.ctx2.lineTo(_x3, this.chartHeight - 10);
            this.ctx2.strokeStyle = lastTradeDownColor;
            this.ctx2.stroke();
            this.ctx2.restore();

            lastTextEntry = _x3;
          }
          lastXDrawn = _x3;
          lastYDrawn = _y;
        }
        lastX = _x3;
        lastY = _y;
      }

      this.ctx2.fillStyle = lastTradeDownColorTransparent;
      this.ctx2.fillRect(lastXDrawn, lastYDrawn, this.chartWidth, this.chartHeight - depthChartBottomPadding - lastYDrawn);
      this.ctx2.beginPath();
      this.ctx2.moveTo(lastXDrawn, lastYDrawn);
      this.ctx2.save();
      this.ctx2.lineWidth = 1;
      this.ctx2.lineTo(this.chartWidth, lastYDrawn);
      this.ctx2.strokeStyle = lastTradeDownColor;
      this.ctx2.stroke();
      this.ctx2.restore();

      this.renderTooltip(depthChartTextFont, depthChartTextColor, lastTradeUpColorTransparent, lastTradeDownColorTransparent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          DepthChart = _props2.DepthChart,
          smallScreen = _props2.smallScreen,
          fetching = _props2.fetching;


      var chartContainerHeight = DepthChart.depthChartHeight ? DepthChart.depthChartHeight + 50 : 350;

      if (smallScreen) {
        chartContainerHeight = '100%';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            minHeight: chartContainerHeight,
            height: chartContainerHeight
          },
          className: tradeComponentClasses() + ' ' + depthChartComponentClasses() },
        fetching && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            id: 'depthChartHolder',
            className: '' + depthChartComponentClasses('') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
            id: 'depthchart',
            style: {
              position: 'absolute',
              zIndex: 2,
              width: '100%',
              height: chartContainerHeight
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + depthChartComponentClasses('buttons') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                className: '' + depthChartComponentClasses('button--zoom'),
                onClick: function onClick() {
                  return _this2.zoomDpethChartPlus();
                } },
              '+'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { id: 'midMarketPrice' },
              '0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                className: '' + depthChartComponentClasses('button--zoom'),
                onClick: function onClick() {
                  return _this2.zoomDpethChartMinus();
                } },
              '-'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + depthChartComponentClasses('zoom-label') },
            this.context.t('Zoom: ' + this.state.depthchartzoom.toFixed(2))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + depthChartComponentClasses('label') },
            this.context.t('Mid Market Price')
          )
        )
      );
    }
  }]);

  return DepthChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DepthChartComponent.defaultProps = {
  smallScreen: false
};

DepthChartComponent.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  level2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

DepthChartComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__hocs_resize__["a" /* default */])(DepthChartComponent));

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_PaddedDecimal_PaddedDecimal__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RecentTradesComponent_css__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RecentTradesComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RecentTradesComponent_css__);










var baseClass = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('recent-trades');

var RecentTradesComponent = function RecentTradesComponent(props, context) {
  var selectedInstrument = props.selectedInstrument,
      recentTrades = props.recentTrades,
      fetching = props.fetching;


  var columns = [{
    header: context.t('Price'),
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: baseClass('table-price', row.TakerSide === 0 ? 'buy' : 'sell') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_PaddedDecimal_PaddedDecimal__["a" /* default */], {
          value: row.Price,
          bemMod: row.TakerSide === 0 ? 'buy' : 'sell',
          decimals: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)
        })
      );
    }
  }, {
    header: context.t('Qty'),
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('table-qty') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_PaddedDecimal_PaddedDecimal__["a" /* default */], {
          value: row.Quantity,
          decimals: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement)
        })
      );
    }
  }, {
    header: context.t('Time'),
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('table-time') },
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["d" /* formatTime */])(row.Timestamp)
      );
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APTable__["a" /* default */], {
    columns: columns,
    rows: recentTrades,
    baseClass: baseClass,
    empty: context.t('No recent trades'),
    fetching: fetching
  });
};

RecentTradesComponent.propTypes = {
  recentTrades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    TradeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    TakerSide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    Price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    Quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    Timestamp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }))
};

RecentTradesComponent.defaultProps = {
  recentTrades: []
};

RecentTradesComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RecentTradesComponent);

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return recentTradesSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marginSelectors__ = __webpack_require__(34);





var recentTradesSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.recentTrades;
}, __WEBPACK_IMPORTED_MODULE_2__instrumentPositionSelectors__["c" /* instrumentsWithProductFullNamesAndProductSymbols */], function (state) {
  return state.apexCore.instrument.selectedInstrumentId;
}, function (state) {
  return state.margin.instrument.selectedInstrumentId;
}, __WEBPACK_IMPORTED_MODULE_3__marginSelectors__["c" /* isMarginActiveSelector */]], function (recentTrades, instruments, standardInstrumentId, marginInstrumentId, isMarginActive) {
  var selectedInstrumentId = isMarginActive ? marginInstrumentId : standardInstrumentId;
  var tradesByInstrument = recentTrades[selectedInstrumentId];
  var instrument = instruments.find(function (item) {
    return item.InstrumentId === selectedInstrumentId;
  });

  if (!instrument || !tradesByInstrument) {
    return [];
  }

  var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;


  return tradesByInstrument.map(function (trade) {
    var quantity = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(trade.Quantity, Product1Symbol);
    var price = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["a" /* currency */])(trade.Price, Product2Symbol);

    return Object.assign({}, trade, {
      Quantity: quantity,
      Price: price
    });
  });
});

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APSegmentedButton__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BuySellTabs__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_orderHelper_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__propTypes_instrumentPropTypes__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants_userPermissionsContants__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ConfirmOrderModal__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_components_TradeComponent_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_components_TradeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__styles_components_TradeComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__OrderEntryComponent_css__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__OrderEntryComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__OrderEntryComponent_css__);























var baseClass = 'order-entry';
var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass);
var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');

var OrderEntryComponent = function OrderEntryComponent(props, context) {
  var authorizedUserPermissions = props.authorizedUserPermissions,
      openAdvancedOrderSidePane = props.openAdvancedOrderSidePane,
      openReportBlockTradeSidePane = props.openReportBlockTradeSidePane,
      orderEntryForm = props.orderEntryForm,
      marketPrice = props.marketPrice,
      selectedInstrument = props.selectedInstrument,
      handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      fetching = props.fetching,
      invalid = props.invalid,
      disableTrading = props.disableTrading,
      VerificationRequiredComponent = props.VerificationRequiredComponent,
      hideFees = props.hideFees,
      orderTotal = props.orderTotal,
      orderNet = props.orderNet,
      orderFee = props.orderFee,
      isMarginActive = props.isMarginActive,
      marginProducts = props.marginProducts,
      title = props.title;


  var buy = orderEntryForm.values.side === __WEBPACK_IMPORTED_MODULE_14__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */];
  var sell = orderEntryForm.values.side === __WEBPACK_IMPORTED_MODULE_14__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses()) },
    title || null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { onSubmit: handleSubmit, className: baseClasses('form') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BuySellTabs__["a" /* default */], {
        baseClass: baseClass,
        styleName: sell ? __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__["b" /* styleNames */].subtractive : __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__["b" /* styleNames */].additive
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('body') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('order-type-wrapper') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APSegmentedButton__["a" /* default */], {
            name: 'orderType',
            label: context.t('Order Type'),
            items: [{
              value: __WEBPACK_IMPORTED_MODULE_14__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].market.displayName,
              text: context.t('Market'),
              dataTest: 'Market Order Type'
            }, {
              value: __WEBPACK_IMPORTED_MODULE_14__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName,
              text: context.t('Limit'),
              dataTest: 'Limit Order Type'
            }, {
              value: __WEBPACK_IMPORTED_MODULE_14__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName,
              text: context.t('Stop'),
              dataTest: 'Stop Order Type'
            }],
            customClass: baseClass,
            styleName: buy ? __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__["b" /* styleNames */].additive : __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__["b" /* styleNames */].subtractive
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APNumberInput__["a" /* default */], {
          type: 'text',
          name: 'quantity',
          placeholder: '0',
          customClass: baseClass,
          label: buy ? context.t('Buy Amount') : context.t('Sell Amount'),
          labelInInput: selectedInstrument && selectedInstrument.Product1Symbol,
          validate: [__WEBPACK_IMPORTED_MODULE_10__helpers_formValidations__["c" /* biggerThanZero */]],
          decimalPlaces: selectedInstrument && Object(__WEBPACK_IMPORTED_MODULE_18__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement),
          step: selectedInstrument.QuantityIncrement
        }),
        orderEntryForm.values.orderType === __WEBPACK_IMPORTED_MODULE_14__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APNumberInput__["a" /* default */], {
            type: 'text',
            name: 'limitPrice',
            placeholder: '0',
            customClass: baseClass,
            label: context.t('Limit Price'),
            labelInInput: selectedInstrument && selectedInstrument.Product2Symbol,
            validate: [__WEBPACK_IMPORTED_MODULE_10__helpers_formValidations__["c" /* biggerThanZero */]],
            decimalPlaces: selectedInstrument && Object(__WEBPACK_IMPORTED_MODULE_18__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement),
            step: selectedInstrument.PriceIncrement
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APSelect__["b" /* default */], {
            name: 'timeInForce',
            label: context.t('Time in Force'),
            customClass: baseClasses(),
            options: [{ value: 1, label: context.t('Good Til Canceled') }, { value: 3, label: context.t('Immediate or Cancel') }, { value: 4, label: context.t('Fill or Kill') }],
            showTriangles: true
          })
        ),
        orderEntryForm.values.orderType === __WEBPACK_IMPORTED_MODULE_14__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].stopMarket.displayName && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APNumberInput__["a" /* default */], {
          type: 'text',
          name: 'stopPrice',
          placeholder: '0',
          customClass: baseClass,
          label: context.t('Stop Price'),
          labelInInput: selectedInstrument ? context.t(selectedInstrument.Product2Symbol + ':') : '',
          validate: [__WEBPACK_IMPORTED_MODULE_10__helpers_formValidations__["c" /* biggerThanZero */]],
          decimalPlaces: selectedInstrument && Object(__WEBPACK_IMPORTED_MODULE_18__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement),
          step: selectedInstrument.PriceIncrement
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: tradeComponentClasses('section') },
          isMarginActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
              name: 'borrowingPower',
              label: context.t('Borrowing Power'),
              text: (buy ? selectedInstrument.Product2Symbol : selectedInstrument.Product1Symbol) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_12__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Object(__WEBPACK_IMPORTED_MODULE_11__helpers_orderHelper_js__["b" /* getOrderBorrowingPower */])(orderEntryForm, selectedInstrument, marginProducts), Object(__WEBPACK_IMPORTED_MODULE_18__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(buy ? selectedInstrument.PriceIncrement : selectedInstrument.QuantityIncrement)),
              customClass: baseClass
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
              name: 'leverage',
              label: context.t('Leverage'),
              text: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_orderHelper_js__["d" /* getOrderLeverage */])(orderEntryForm),
              customClass: baseClass
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
            name: 'marketPrice',
            label: context.t('Market Price'),
            text: selectedInstrument.Product2Symbol + ' ' + marketPrice,
            customClass: baseClass
          }),
          !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
            label: context.t('Fees'),
            customClass: baseClass,
            text: orderFee
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
            label: context.t('Order Total'),
            text: orderTotal,
            customClass: baseClass
          }),
          !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
            label: context.t('Net'),
            text: orderNet,
            customClass: baseClass
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: tradeComponentClasses('section') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__common_APButton__["a" /* default */],
            {
              type: 'submit',
              disabled: submitting || fetching || invalid || disableTrading,
              customClass: baseClass,
              styleName: buy ? __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__["b" /* styleNames */].additive : __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__["b" /* styleNames */].subtractive },
            submitting ? context.t('Processing...') : context.t(Object(__WEBPACK_IMPORTED_MODULE_11__helpers_orderHelper_js__["k" /* getSubmitButtonText */])(orderEntryForm))
          ),
          VerificationRequiredComponent
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: tradeComponentClasses('section') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('item-button')),
              onClick: openAdvancedOrderSidePane },
            '\xAB ' + context.t('Advanced Orders')
          )
        ),
        authorizedUserPermissions && (authorizedUserPermissions.includes(__WEBPACK_IMPORTED_MODULE_16__constants_userPermissionsContants__["a" /* userPermissions */].submitBlockTrade) || authorizedUserPermissions.includes(__WEBPACK_IMPORTED_MODULE_16__constants_userPermissionsContants__["a" /* userPermissions */].superUser)) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: tradeComponentClasses('section') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('item-button')),
              onClick: openReportBlockTradeSidePane },
            '\xAB ' + context.t('Report Block Trade')
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ConfirmOrderModal__["a" /* default */], null)
  );
};

OrderEntryComponent.defaultProps = {
  submitting: false,
  isMarginActive: false
};

OrderEntryComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  authorizedUserPermissions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  openAdvancedOrderSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openReportBlockTradeSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_15__propTypes_instrumentPropTypes__["a" /* instrumentPropType */],
  orderEntryForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  marketPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  disableTrading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  ConfirmLimitOrderModalContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

OrderEntryComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (OrderEntryComponent);

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APRadioTab_APRadioTab__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APSegmentedButton_css__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APSegmentedButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__APSegmentedButton_css__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var baseClass = 'ap-segmented-button';

var APSegmentedButton = function APSegmentedButton(props) {
  var label = props.label,
      customClass = props.customClass,
      otherProps = _objectWithoutProperties(props, ['label', 'customClass']);

  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses('sb-container') },
    label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ap--label', bemClasses('group-label')) },
        label
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APRadioTab_APRadioTab__["a" /* default */], Object.assign({
      baseClass: baseClass,
      customClass: customClass
    }, otherProps))
  );
};

/* harmony default export */ __webpack_exports__["a"] = (APSegmentedButton);

/***/ }),
/* 1902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APRadioTab_APRadioTab__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);






var BuySellTabs = function BuySellTabs(props, context) {
  var baseClass = props.baseClass,
      onClick = props.onClick;


  var classes = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes('buy-sell-wrapper') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('buy-sell-radio-tab-wrapper') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APRadioTab_APRadioTab__["a" /* default */], {
        customClass: classes(),
        onClick: onClick,
        items: [{
          text: context.t('Buy'),
          value: __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */],
          styleName: 'additive',
          dataTest: 'Buy Side'
        }, {
          text: context.t('Sell'),
          value: __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */],
          styleName: 'subtractive',
          dataTest: 'Sell Side'
        }],
        name: 'side'
      })
    )
  );
};

BuySellTabs.propTypes = {
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

BuySellTabs.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellTabs);

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userPermissions; });
var userPermissions = {
  submitBlockTrade: 'SubmitBlockTrade',
  requestTransferFunds: 'RequestTransferFunds',
  trading: 'Trading',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  superUser: 'SUPERUSER'
};

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmOrderModalContainer__ = __webpack_require__(1907);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ConfirmOrderModalContainer__["a" /* default */]);

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmOrderModalComponent__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_selectors_orderTotalSelector__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_actions_snackbarActions__ = __webpack_require__(20);













var mapStateToProps = function mapStateToProps(state) {
  var form = state.form,
      product = state.apexCore.product;

  var formObj = form.orderEntry || { values: { fee: {} } };

  var productId = formObj.values.fee.ProductId || formObj.values.fee.FeeProductId;
  var feeSymbol = productId ? product.products.find(function (item) {
    return item.ProductId === productId;
  }).Product : '';
  var marketPrice = Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_buySellSelectors__["h" /* marketPriceOfSelectedInstrumentSelector */])(state, {
    side: formObj.values.side
  });

  var price = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_orderHelper__["f" /* getOrderPrice */])(formObj, marketPrice);
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var orderTotal = Object(__WEBPACK_IMPORTED_MODULE_8__redux_selectors_orderTotalSelector__["a" /* orderTotalSelector */])(state, { form: formObj.values });

  return {
    formObj: formObj,
    feeSymbol: feeSymbol,
    price: price,
    selectedInstrument: selectedInstrument,
    isMarginActive: Object(__WEBPACK_IMPORTED_MODULE_9__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state),
    orderTotal: orderTotal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    confirmReport: function confirmReport(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["f" /* placeOrderWithChecks */])(__WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].default, payload)).then(function (res) {
        if (res.result === false) {
          var text = res.errormsg && res.detail ? res.errormsg + ': ' + res.detail : res.errormsg || res.detail;
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__redux_actions_snackbarActions__["e" /* showSnack */])({
            id: 'placeOrderError',
            text: text,
            type: 'warning'
          }));
        }
      });
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConfirmOrderModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_ORDER_REPORT
})(container));

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfirmOrderModalComponent_css__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfirmOrderModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ConfirmOrderModalComponent_css__);











var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('confirm-order-modal');

var ConfirmOrderModalComponent = function ConfirmOrderModalComponent(props, context) {
  var formObj = props.formObj,
      isOpen = props.isOpen,
      close = props.close,
      confirmReport = props.confirmReport,
      feeSymbol = props.feeSymbol,
      _props$selectedInstru = props.selectedInstrument,
      QuantityIncrement = _props$selectedInstru.QuantityIncrement,
      PriceIncrement = _props$selectedInstru.PriceIncrement,
      Product1Symbol = _props$selectedInstru.Product1Symbol,
      Product2Symbol = _props$selectedInstru.Product2Symbol,
      price = props.price,
      orderTotal = props.orderTotal,
      isMarginActive = props.isMarginActive;

  var isBuySide = formObj.values.side === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */];

  var items = [{
    label: context.t('Order Type:'),
    text: formObj.values.orderType
  }, {
    label: context.t('Quantity'),
    text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(formObj.values.quantity, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(QuantityIncrement)) + ' ' + Product1Symbol
  }, {
    label: context.t('Price'),
    text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(price, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement)) + ' ' + Product2Symbol
  }, {
    label: context.t('Fee'),
    text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(formObj.values.fee.OrderFee, feeSymbol) + ' ' + feeSymbol
  }, {
    label: context.t('Value'),
    text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(orderTotal, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement)) + ' ' + Product2Symbol
  }];

  if (isMarginActive) {
    items.splice(1, 0, {
      label: context.t('Leverage'),
      text: formObj.values.fee.Leverage
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: isMarginActive ? context.t('Confirm Margin Order') : context.t('Confirm Order'),
      close: close,
      footer: {
        buttonText: isBuySide ? context.t('Confirm Buy Order') : context.t('Confirm Sell Order'),
        buttonStyle: isBuySide ? 'additive' : 'subtractive',
        onClick: function onClick() {
          return confirmReport(formObj.values);
        }
      },
      customClass: bemClasses(formObj.values.side === __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? 'bought' : 'sold') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses() },
      items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          key: item.label,
          label: item.label,
          text: item.text,
          customClass: bemClasses()
        });
      })
    )
  );
};

ConfirmOrderModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmOrderModalComponent);

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InstrumentPositionsWrapperContainer__ = __webpack_require__(1911);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InstrumentPositionsWrapperContainer__["a" /* default */]);

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InstrumentPositionsWrapperComponent__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginSelectors__ = __webpack_require__(34);




var mapStateToProps = function mapStateToProps(state) {
  return {
    isMarginActive: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__InstrumentPositionsWrapperComponent__["a" /* default */]));

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstrumentPositions__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InstrumentPositionsTabs__ = __webpack_require__(1916);





var InstrumentPositionsWrapperComponent = function InstrumentPositionsWrapperComponent(props) {
  return props.isMarginActive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InstrumentPositionsTabs__["a" /* default */], { short: props.short }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InstrumentPositions__["a" /* default */], {
    short: props.short,
    showTitle: props.showTitle
  });
};

InstrumentPositionsWrapperComponent.defaultProps = {
  isMarginActive: false
};

InstrumentPositionsWrapperComponent.propTypes = {
  isMarginActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (InstrumentPositionsWrapperComponent);

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InstrumentPositionsContainer__ = __webpack_require__(777);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InstrumentPositionsContainer__["a" /* default */]);

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_components_TradeComponent_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_components_TradeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_components_TradeComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InstrumentPositionsComponent_css__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InstrumentPositionsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InstrumentPositionsComponent_css__);









var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');
var instrumentPositionsClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('instrument-positions-summary');

var InstrumentPositionsComponent = function InstrumentPositionsComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(tradeComponentClasses(), instrumentPositionsClasses()) },
    props.showTitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradeComponentClasses('header') },
      props.positions.position1.ProductSymbol,
      props.positions.position2.ProductSymbol,
      ' ',
      context.t('Summary')
    ),
    props.fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: instrumentPositionsClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('row-label') },
          context.t('Product')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('product-symbol') },
          props.positions.position1.ProductSymbol
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('product-symbol') },
          props.positions.position2.ProductSymbol
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: instrumentPositionsClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('row-label') },
          context.t('Available Balance')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('product-available') },
          props.positions.position1.AvailableBalance
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('product-available') },
          props.positions.position2.AvailableBalance
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: instrumentPositionsClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('row-label') },
          context.t('Hold')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('product-hold') },
          props.positions.position1.Hold
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('product-hold') },
          props.positions.position2.Hold
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: instrumentPositionsClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('row-label') },
          context.t('Pending Deposits')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: instrumentPositionsClasses('product-pending-deposits') },
          props.positions.position1.PendingDeposits
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: instrumentPositionsClasses('product-pending-deposits') },
          props.positions.position2.PendingDeposits
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: instrumentPositionsClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('row-label') },
          context.t('Total Balance')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('product-total-balance') },
          props.positions.position1.Amount
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: instrumentPositionsClasses('product-total-balance') },
          props.positions.position2.Amount
        )
      )
    )
  );
};

InstrumentPositionsComponent.defaultProps = {
  showTitle: true
};

InstrumentPositionsComponent.propTypes = {
  positions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

InstrumentPositionsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (InstrumentPositionsComponent);

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InstrumentPositionsTabsComponent__ = __webpack_require__(1917);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InstrumentPositionsTabsComponent__["a" /* default */]);

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarginBalances__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InstrumentPositionsTabsComponent_css__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InstrumentPositionsTabsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InstrumentPositionsTabsComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('instrument-positions-tabs');

var InstrumentPositionsTabsComponent = function InstrumentPositionsTabsComponent(props, context) {
  var _getPanes = function _getPanes() {
    return [{
      menuItem: context.t('Balances'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MarginBalances__["d" /* MarginInstrumentPositionsContainer */], { showTitle: false });
      }
    }, {
      menuItem: context.t('Margin Overview'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MarginBalances__["f" /* MarginOverviewContainer */], { showTitle: false });
      }
    }];
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tab_Tab__["a" /* default */], { panes: _getPanes(), customClass: baseClasses() })
  );
};

InstrumentPositionsTabsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (InstrumentPositionsTabsComponent);

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarginInstrumentPositionsComponent__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);






var mapStateToProps = function mapStateToProps(state) {
  var positions = Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_instrumentPositionSelectors__["a" /* default */])(state);
  var products = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__["b" /* marginProductSelector */])(state);
  var positionsFetching = state.apexCore.position.fetching;
  var marginProductsFetching = state.margin.product.fetching;
  var position1 = products.find(function (product) {
    return product.ProductId === positions.position1.ProductId;
  });
  var position2 = products.find(function (product) {
    return product.ProductId === positions.position2.ProductId;
  });

  return {
    position1: position1,
    position2: position2,
    positionsFetching: positionsFetching,
    marginProductsFetching: marginProductsFetching
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openTransferModal: function openTransferModal(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_TRANSFER_ASSETS, { productId: productId }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__MarginInstrumentPositionsComponent__["a" /* default */]));

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APIconButton_APIconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarginInstrumentPositionsComponent_css__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarginInstrumentPositionsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__MarginInstrumentPositionsComponent_css__);










var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');
var marginInstrumentPositionsClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-instrument-positions');

var MarginInstrumentPositionsComponent = function MarginInstrumentPositionsComponent(_ref, context) {
  var openTransferModal = _ref.openTransferModal,
      position1 = _ref.position1,
      position2 = _ref.position2,
      showTitle = _ref.showTitle,
      positionsFetching = _ref.positionsFetching,
      marginProductsFetching = _ref.marginProductsFetching;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(tradeComponentClasses(), marginInstrumentPositionsClasses()) },
    showTitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradeComponentClasses('header') },
      context.t('Balances')
    ),
    positionsFetching || marginProductsFetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradeComponentClasses('body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: marginInstrumentPositionsClasses('header') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('header-item') },
          context.t('Product')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('header-item') },
          context.t('Standard')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('header-item') },
          context.t('Margin')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: marginInstrumentPositionsClasses('products-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('product-item') },
          position1.ProductSymbol
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('product-item') },
          Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(position1.StandardAmount, position1.ProductSymbol)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('transfer-btn') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APIconButton_APIconButton__["a" /* default */], {
            iconName: 'buy-sell',
            showLabel: false,
            customClass: marginInstrumentPositionsClasses('transfer-btn'),
            action: function action() {
              return openTransferModal(position1.ProductId);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('product-item') },
          Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(position1.MarginAmount, position1.ProductSymbol)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: marginInstrumentPositionsClasses('products-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('product-item') },
          position2.ProductSymbol
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('product-item') },
          Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(position2.StandardAmount, position2.ProductSymbol)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('transfer-btn') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APIconButton_APIconButton__["a" /* default */], {
            iconName: 'buy-sell',
            showLabel: false,
            customClass: marginInstrumentPositionsClasses('transfer-btn'),
            action: function action() {
              return openTransferModal(position2.ProductId);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: marginInstrumentPositionsClasses('product-item') },
          Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(position2.MarginAmount, position2.ProductSymbol)
        )
      )
    )
  );
};

MarginInstrumentPositionsComponent.defaultProps = {
  showTitle: true,
  position1: {},
  position2: {}
};

MarginInstrumentPositionsComponent.propTypes = {
  position1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  position2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

MarginInstrumentPositionsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginInstrumentPositionsComponent);

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginInstrumentPositionComponent__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__ = __webpack_require__(80);




var mapStateToProps = function mapStateToProps(state) {
  var fetching = state.margin.product.fetching;

  var productsTotalAmount = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__["c" /* productsTotalAmountSelector */])(state);

  return {
    fetching: fetching,
    standardTotalValue: productsTotalAmount.StandardTotalValue,
    marginTotalValue: productsTotalAmount.MarginTotalValue,
    productSymbol: productsTotalAmount.BaseCurrency
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginInstrumentPositionComponent__["a" /* default */]));

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentPositionComponent_css__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentPositionComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MarginInstrumentPositionComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-instrument-position');

var MarginInstrumentPositionComponent = function MarginInstrumentPositionComponent(props, context) {
  var standardTotalValue = props.standardTotalValue,
      marginTotalValue = props.marginTotalValue,
      productSymbol = props.productSymbol;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('type') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('title') },
        context.t('Standard Account Value: ')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: baseClasses('value') },
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(productSymbol, Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(standardTotalValue, productSymbol))
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('type') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('title') },
        context.t('Margin Account Value: ')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: baseClasses('value') },
        Object(__WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(productSymbol, Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(marginTotalValue, productSymbol))
      )
    )
  );
};

MarginInstrumentPositionComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginInstrumentPositionComponent);

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginOverviewComponent__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_marginActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_baseCurrenciesSelectors__ = __webpack_require__(403);





var mapStateToProps = function mapStateToProps(state) {
  var _state$margin$account = state.margin.accountState,
      accountState = _state$margin$account.accountState,
      fetching = _state$margin$account.fetching;


  var baseCurrency = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_baseCurrenciesSelectors__["b" /* baseCurrencySelector */])(state);

  return {
    accountState: accountState,
    fetching: fetching,
    baseCurrency: baseCurrency
  };
};

var mapDispatchToProps = {
  getMarginAccountState: __WEBPACK_IMPORTED_MODULE_2__redux_actions_marginActions__["o" /* getMarginAccountState */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginOverviewComponent__["a" /* default */]));

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarginOverviewComponent_css__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarginOverviewComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__MarginOverviewComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');
var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-overview');

var MarginOverviewComponent = function (_React$Component) {
  _inherits(MarginOverviewComponent, _React$Component);

  function MarginOverviewComponent() {
    _classCallCheck(this, MarginOverviewComponent);

    return _possibleConstructorReturn(this, (MarginOverviewComponent.__proto__ || Object.getPrototypeOf(MarginOverviewComponent)).apply(this, arguments));
  }

  _createClass(MarginOverviewComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.fetching) {
        this.props.getMarginAccountState();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          accountState = _props.accountState,
          showTitle = _props.showTitle,
          fetching = _props.fetching,
          baseCurrency = _props.baseCurrency;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(tradeComponentClasses(), baseClasses()) },
        showTitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: tradeComponentClasses('header') },
          this.context.t('Balances')
        ),
        fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(tradeComponentClasses('body'), baseClasses('body')) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Total Position Value')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.TotalPositionValue, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Borrowing Power')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.BorrowingPower, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Collateral Value')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.CollateralValue, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Unrealized PnL')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.UnrealizedPnl, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Realized PnL')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.RealizedPnl, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Net Account Value')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.NetAccountValue, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Amount Borrowed')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.TotalBorrowedValue, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Margin Used')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.MarginUsed, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Margin Available')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.MarginAvailable, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Maintenance Requirement')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.MaintenanceRequirement, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Liquidation Threshold')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value')) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.LiquidationThreshold, baseCurrency))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('products-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-name')) },
              this.context.t('Surplus / Deficit')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(baseClasses('product-item'), baseClasses('item-value'), baseClasses('product-item-' + (accountState.SurplusDeficit >= 0 ? 'surplus' : 'deficit'))) },
              Object(__WEBPACK_IMPORTED_MODULE_5__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(baseCurrency, Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(accountState.SurplusDeficit, baseCurrency))
            )
          )
        )
      );
    }
  }]);

  return MarginOverviewComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MarginOverviewComponent.defaultProps = {
  showTitle: true
};

MarginOverviewComponent.propTypes = {
  showTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

MarginOverviewComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginOverviewComponent);

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginTransferBetweenAccountsContainer__ = __webpack_require__(1929);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginTransferBetweenAccountsContainer__["a" /* default */]);

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginTransferBetweenAccountsComponent__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__ = __webpack_require__(9);




var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClick: function onClick() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_TRANSFER_ASSETS));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginTransferBetweenAccountsComponent__["a" /* default */]));

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarginTransferBetweenAccountsComponent_css__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarginTransferBetweenAccountsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MarginTransferBetweenAccountsComponent_css__);






var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-transfer-between-accounts');

var MarginTransferBetweenAccountsComponent = function MarginTransferBetweenAccountsComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__["a" /* default */], {
      iconName: 'buy-sell',
      label: context.t('Transfer'),
      customClass: baseClasses('action-btn '),
      action: props.onClick
    })
  );
};

MarginTransferBetweenAccountsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

MarginTransferBetweenAccountsComponent.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginTransferBetweenAccountsComponent);

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginInstrumentBalancesTableComponent__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginSelectors__ = __webpack_require__(34);






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state, _ref) {
  var isMarginActive = _ref.isMarginActive;
  return {
    fetching: isMarginActive ? state.margin.product.fetching : state.apexCore.product.fetching,
    products: isMarginActive ? Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__["b" /* marginProductSelector */])(state) : Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state),
    baseAsset: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginSelectors__["f" /* marginBaseAssetSelector */])(state)
  };
})(__WEBPACK_IMPORTED_MODULE_1__MarginInstrumentBalancesTableComponent__["a" /* default */]));

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarginInstrumentBalancesRowContainer__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentBalancesTableComponent_css__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentBalancesTableComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MarginInstrumentBalancesTableComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-instrument-balances-table');

var MarginInstrumentBalancesTable = function MarginInstrumentBalancesTable(_ref, context) {
  var fetching = _ref.fetching,
      products = _ref.products,
      isMarginActive = _ref.isMarginActive,
      baseAsset = _ref.baseAsset;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-item') },
        context.t('Market Price ({n})', {
          n: baseAsset.Product
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-item') },
        context.t('Standard Accounts')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-item') },
        context.t('Margin Accounts')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-item') },
        context.t('Borrowing Power')
      ),
      isMarginActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-item') },
        context.t('Transfers')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('body') },
      fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], null) : products.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MarginInstrumentBalancesRowContainer__["a" /* default */], {
          product: item,
          key: index,
          isMarginActive: isMarginActive
        });
      })
    )
  );
};

MarginInstrumentBalancesTable.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginInstrumentBalancesTable);

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginInstrumentBalancesRowComponent__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_marginSelectors__ = __webpack_require__(34);





var mapStateToProps = function mapStateToProps(state) {
  return {
    baseAsset: Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_marginSelectors__["f" /* marginBaseAssetSelector */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var ProductId = _ref.product.ProductId;

  return {
    openTransferModal: function openTransferModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_TRANSFER_ASSETS, { productId: ProductId }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginInstrumentBalancesRowComponent__["a" /* default */]));

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIconButton_APIconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentBalancesRowComponent_css__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentBalancesRowComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MarginInstrumentBalancesRowComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-instrument-balances-row');

var MarginInstrumentBalancesRowComponent = function MarginInstrumentBalancesRowComponent(props) {
  var isMarginActive = props.isMarginActive,
      _props$product = props.product,
      rawAmount = _props$product.rawAmount,
      MarginAmount = _props$product.MarginAmount,
      StandardAmount = _props$product.StandardAmount,
      BorrowingPower = _props$product.BorrowingPower,
      ProductPrice = _props$product.ProductPrice,
      ProductSymbol = _props$product.ProductSymbol,
      Product = props.baseAsset.Product,
      openTransferModal = props.openTransferModal;


  var makeTableCell = function makeTableCell(data) {
    return isMarginActive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      data
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      'N/A'
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('row') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('ceil') },
      makeTableCell(Object(__WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(Product, Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(ProductPrice, Product)))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('ceil') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(isMarginActive ? StandardAmount : rawAmount, ProductSymbol),
        ' ',
        ProductSymbol
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('ceil') },
      makeTableCell(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(MarginAmount, ProductSymbol),
        ' ',
        ProductSymbol
      ))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('ceil') },
      makeTableCell(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(BorrowingPower, ProductSymbol),
        ' ',
        ProductSymbol
      ))
    ),
    isMarginActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('ceil') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIconButton_APIconButton__["a" /* default */], {
        iconName: 'buy-sell',
        showLabel: false,
        customClass: baseClasses('transfer-btn'),
        action: openTransferModal
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MarginInstrumentBalancesRowComponent);

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginInstrumentSelectorTableComponent__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__ = __webpack_require__(40);





var mapStateToProps = function mapStateToProps(state, _ref) {
  var isMarginActive = _ref.isMarginActive;
  return {
    isMarginActive: isMarginActive,
    products: isMarginActive ? Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__["b" /* marginProductSelector */])(state) : Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state),
    fetching: isMarginActive ? state.margin.product.fetching : state.apexCore.product.fetching
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginInstrumentSelectorTableComponent__["a" /* default */]));

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarginInstrumentSelectorRowContainer__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentSelectorTableComponent_css__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginInstrumentSelectorTableComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MarginInstrumentSelectorTableComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-instrument-selector-table');

var MarginInstrumentSelectorTableComponent = function MarginInstrumentSelectorTableComponent(_ref, context) {
  var products = _ref.products,
      fetching = _ref.fetching,
      detailsLink = _ref.detailsLink,
      isMarginActive = _ref.isMarginActive;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-item') },
        products.length,
        context.t(' Products on Exchange')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-item') },
        context.t('Total Balance')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses() },
      fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], { customClass: baseClasses('spinner') }) : products.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MarginInstrumentSelectorRowContainer__["a" /* default */], {
          isMarginActive: isMarginActive,
          product: item,
          key: index,
          detailsLink: detailsLink
        });
      })
    )
  );
};

MarginInstrumentSelectorTableComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginInstrumentSelectorTableComponent);

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginInstrumentSelectorRowComponent__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_positionActions__ = __webpack_require__(85);




var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectPosition: function selectPosition() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_positionActions__["f" /* selectPositionAndSave */])(ownProps.product.ProductId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginInstrumentSelectorRowComponent__["a" /* default */]));

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MarginInstrumentSelectorRowComponent_css__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MarginInstrumentSelectorRowComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__MarginInstrumentSelectorRowComponent_css__);












var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-instrument-selector-row');

var MarginInstrumentSelectorRowComponent = function MarginInstrumentSelectorRowComponent(props, context) {
  var isMarginActive = props.isMarginActive,
      _props$product = props.product,
      rawAmount = _props$product.rawAmount,
      MarginAmount = _props$product.MarginAmount,
      StandardAmount = _props$product.StandardAmount,
      ProductSymbol = _props$product.ProductSymbol,
      iconFileName = _props$product.iconFileName,
      ProductFullName = _props$product.ProductFullName,
      detailsLink = props.detailsLink,
      selectPosition = props.selectPosition;


  var amt = isMarginActive ? MarginAmount + StandardAmount : rawAmount;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('row') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__["a" /* default */], { iconFileName: iconFileName, size: 24 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('product-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        ProductSymbol,
        ' ',
        ProductFullName
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        {
          className: baseClasses('details'),
          to: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])(detailsLink),
          onClick: selectPosition },
        context.t('Details'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon__["a" /* default */], { name: 'arrowNext', customClass: baseClasses('details') })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('balance-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_6__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(ProductSymbol, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(amt, ProductSymbol), true),
        ' ',
        ProductSymbol
      )
    )
  );
};

MarginInstrumentSelectorRowComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginInstrumentSelectorRowComponent);

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginDepositWithdrawContainer__ = __webpack_require__(1945);


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__MarginDepositWithdrawContainer__["a" /* default */]);

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarginDepositWithdrawComponent__ = __webpack_require__(1946);




var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openMarginDepositModal: function openMarginDepositModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_DEPOSIT));
    },
    openMarginWithdrawModal: function openMarginWithdrawModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_WITHDRAW));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__MarginDepositWithdrawComponent__["a" /* default */]));

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_APIconButton_APIconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarginDepositWithdrawComponent_css__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarginDepositWithdrawComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MarginDepositWithdrawComponent_css__);






var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-deposit-withdraw');

var MarginDepositWithdrawComponent = function MarginDepositWithdrawComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_APIconButton_APIconButton__["a" /* default */], {
      iconName: 'deposit',
      action: props.openMarginDepositModal,
      label: context.t('Deposit'),
      customClass: baseClasses('action-btn')
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_APIconButton_APIconButton__["a" /* default */], {
      iconName: 'withdraw',
      action: props.openMarginWithdrawModal,
      label: context.t('Withdraw'),
      customClass: baseClasses('action-btn')
    })
  );
};

MarginDepositWithdrawComponent.propTypes = {
  openMarginDepositModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  openMarginWithdrawModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

MarginDepositWithdrawComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginDepositWithdrawComponent);

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginBalancesFooterComponent__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);






var mapStateToProps = function mapStateToProps(state, _ref) {
  var isMarginActive = _ref.isMarginActive;

  var _productsTotalAmountS = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginProductSelectors__["c" /* productsTotalAmountSelector */])(state),
      BaseCurrency = _productsTotalAmountS.BaseCurrency,
      standardTotalValue = _productsTotalAmountS.StandardTotalValue;

  if (!isMarginActive) {
    var stdProductsTotalValue = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state).reduce(function (total, prod) {
      return total += prod.NotionalValue;
    }, 0);
    return {
      fetching: state.apexCore.product.fetching,
      totalValue: stdProductsTotalValue,
      standardTotalValue: stdProductsTotalValue,
      marginTotalValue: 0,
      borrowingTotalValue: 0,
      productSymbol: BaseCurrency
    };
  }

  var marginTotalValue = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(state, 'margin.accountState.accountState.CollateralValue', 0);

  return {
    fetching: state.margin.product.fetching,
    totalValue: standardTotalValue + marginTotalValue,
    standardTotalValue: standardTotalValue,
    marginTotalValue: marginTotalValue,
    borrowingTotalValue: __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(state, 'margin.accountState.accountState.BorrowingPower', 0),
    productSymbol: BaseCurrency
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginBalancesFooterComponent__["a" /* default */]));

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarginBalancesFooterComponent_css__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarginBalancesFooterComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MarginBalancesFooterComponent_css__);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-balances-footer');

var MarginBalancesFooter = function MarginBalancesFooter(_ref, context) {
  var isMarginActive = _ref.isMarginActive,
      fetching = _ref.fetching,
      productSymbol = _ref.productSymbol,
      totalValue = _ref.totalValue,
      standardTotalValue = _ref.standardTotalValue,
      marginTotalValue = _ref.marginTotalValue,
      borrowingTotalValue = _ref.borrowingTotalValue;

  if (fetching) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses() },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Spinner_Spinner__["a" /* default */], null)
    );
  }

  var makeCell = function makeCell(data) {
    return isMarginActive ? data : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      'N/A'
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('left-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('total-text') },
        context.t('Total Value:')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('total-value') },
        Object(__WEBPACK_IMPORTED_MODULE_3__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(productSymbol, Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(totalValue, productSymbol), true)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('right-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: baseClasses('total-value-container') }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('total-value-container') },
        Object(__WEBPACK_IMPORTED_MODULE_3__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(productSymbol, Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(standardTotalValue, productSymbol), true)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('total-value-container') },
        makeCell(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(productSymbol, Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(marginTotalValue, productSymbol), true))
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('total-value-container') },
        makeCell(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(productSymbol, Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(borrowingTotalValue, productSymbol), true))
      ),
      isMarginActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: baseClasses('total-value-container') })
    )
  );
};

MarginBalancesFooter.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginBalancesFooter);

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmLimitOrderModalComponent_css__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmLimitOrderModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfirmLimitOrderModalComponent_css__);







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('limit-order-confirmation');

var ConfirmLimitOrderModalComponent = function ConfirmLimitOrderModalComponent(props, context) {
  var formObj = props.formObj,
      isOpen = props.isOpen,
      orderFormType = props.orderFormType,
      close = props.close,
      confirmOrder = props.confirmOrder,
      limitPrice = props.limitPrice,
      marketPrice = props.marketPrice,
      priceSymbol = props.priceSymbol;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Confirm Your Limit Order'),
      close: close,
      footer: {
        buttonText: context.t('Confirm Order'),
        onClick: function onClick() {
          return confirmOrder(orderFormType, formObj);
        }
      },
      customClass: bemClasses('modal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses() },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        null,
        context.t('Please, confirm your Limit Order')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('text') },
        context.t('You are trying to place an order with `Limit price` below market price')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Your Limit Price:'),
        text: limitPrice + ' ' + priceSymbol
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Market Price:'),
        text: marketPrice + ' ' + priceSymbol
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('text') },
        context.t('Please confirm your order or exit')
      )
    )
  );
};

ConfirmLimitOrderModalComponent.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  confirmOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  limitPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  marketPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  priceSymbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  orderFormType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  formObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

ConfirmLimitOrderModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmLimitOrderModalComponent);

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenOrders__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FilledOrders__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InactiveOrders__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OpenPositions__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClosedPositions__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HeaderWithFilter__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PositionPayments__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderHistoryComponent_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderHistoryComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__OrderHistoryComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrderHistoryTables_css__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrderHistoryTables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__OrderHistoryTables_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var MarginOrderHistoryComponent = function (_Component) {
  _inherits(MarginOrderHistoryComponent, _Component);

  function MarginOrderHistoryComponent() {
    _classCallCheck(this, MarginOrderHistoryComponent);

    return _possibleConstructorReturn(this, (MarginOrderHistoryComponent.__proto__ || Object.getPrototypeOf(MarginOrderHistoryComponent)).apply(this, arguments));
  }

  _createClass(MarginOrderHistoryComponent, [{
    key: '_getPanes',
    value: function _getPanes() {
      var config = this.props.config;


      var panes = [{
        menuItem: __WEBPACK_IMPORTED_MODULE_2__OpenOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OpenOrders__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_3__FilledOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FilledOrders__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_4__InactiveOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__InactiveOrders__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_5__OpenPositions__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OpenPositions__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_6__ClosedPositions__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ClosedPositions__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_8__PositionPayments__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PositionPayments__["a" /* default */], { config: config });
        }
      }];

      return panes;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        this.props.useHeaderWithFilter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__HeaderWithFilter__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Tab_Tab__["a" /* default */], {
          defaultActiveIndex: 3,
          panes: this._getPanes(),
          classModifiers: this.props.classModifiers,
          customClass: 'order-history'
        })
      );
    }
  }]);

  return MarginOrderHistoryComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MarginOrderHistoryComponent);

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenPositionsComponent__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_marginHistorySelectors__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__ = __webpack_require__(9);







var mapStateToProps = function mapStateToProps(state, ownProps) {
  var openPositions = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_marginHistorySelectors__["b" /* openPositionsSelector */])(state, ownProps.config);
  var instruments = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);
  var activeRequests = state.margin.history.activeRequests;

  var fetching = activeRequests > 0;

  return {
    data: openPositions,
    instruments: instruments,
    fetching: fetching,
    baseAsset: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginSelectors__["f" /* marginBaseAssetSelector */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openClosePositionModal: function openClosePositionModal(position) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_CLOSE_POSITION, { position: position }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__OpenPositionsComponent__["a" /* default */]));

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CancelAPButton__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OpenPositions_css__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OpenPositions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OpenPositions_css__);








var baseClass = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var makeCell = function makeCell(data, className) {
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      title: data + ' ' + (currency ? currency : ''),
      className: baseClass('tooltip-wrapper') + ' ' + className },
    data,
    ' ',
    currency
  );
};

var OpenPositionsComponent = function OpenPositionsComponent(_ref, context) {
  var data = _ref.data,
      instruments = _ref.instruments,
      fetching = _ref.fetching,
      config = _ref.config,
      openClosePositionModal = _ref.openClosePositionModal,
      baseAsset = _ref.baseAsset;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var columns = [{
    header: context.t('Pair'),
    dataTest: 'Pair',
    cell: function cell(row) {
      var instrument = instruments.find(function (item) {
        return item.InstrumentId === row.InstrumentId;
      });
      return instrument ? instrument.Symbol : '';
    }
  }, {
    header: context.t('Position'),
    dataTest: 'Position',
    cell: function cell(row) {
      return row.Position ? context.t('Position') : makeCell('' + (row.PositionDirection === 'Long' ? '+' : '-') + Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.PositionDirection === 'Long' ? row.PositionAmount : row.BorrowedAmount, row.PositionDirection === 'Long' ? row.PositionProductSymbol : row.BorrowedProductSymbol, { removeTrailingZeroes: true }), baseClass('size'), row.PositionDirection === 'Long' ? row.PositionProductSymbol : row.BorrowedProductSymbol);
    }
  }, {
    header: context.t('Value'),
    dataTest: 'Borrowed Value',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.BorrowedValue, row.PositionProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('borrowed-value'), row.PositionProductSymbol);
    }
  }, {
    header: context.t('Cost Basis'),
    dataTest: 'Cost Basis',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.CostBasis, row.PositionProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('cost-basis'), row.PositionProductSymbol);
    }
  }, {
    header: context.t('Current Px'),
    dataTest: 'Current Px',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.CurrentPrice, row.PositionProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('current-px'), row.PositionProductSymbol);
    }
  }, {
    header: context.t('Position Value'),
    dataTest: 'Position Value',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.PositionValue, baseAsset.Product, {
        removeTrailingZeroes: true
      }), baseClass('position-value'), baseAsset.Product);
    }
  }, {
    header: context.t('Margin Used'),
    dataTest: 'Margin Used',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.MarginUsed, baseAsset.Product, {
        removeTrailingZeroes: true
      }), baseClass('margin-used'), baseAsset.Product);
    }
  }, {
    header: context.t('Int. Accrued'),
    dataTest: 'Int. Accrued',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.InterestAccrued, row.BorrowedProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('int-accrued'), row.BorrowedProductSymbol);
    }
  }, {
    header: context.t('Int. Paid'),
    dataTest: 'Int. Paid',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.InterestPaid, row.BorrowedProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('int-accrued'), row.BorrowedProductSymbol);
    }
  }, {
    header: context.t('Unrealized P&L'),
    dataTest: 'Unrealized P&L',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.UnrealizedPnL, baseAsset.Product, {
        removeTrailingZeroes: true
      }), baseClass('unrealized-pl'), baseAsset.Product);
    }
  }, {
    header: context.t('Action'),
    dataTest: 'Action',
    cell: function cell(row) {
      return row.Status === 'InClosing' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        context.t('Closing')
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_CancelAPButton__["a" /* default */], {
        text: context.t('Close'),
        dataTest: 'Close',
        customClass: baseClass(),
        onClick: function onClick() {
          return openClosePositionModal(row);
        }
      });
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APTable__["a" /* default */], {
    columns: columns,
    rows: data,
    baseClass: baseClass,
    fetching: fetching,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'OpenPositionsComponent'
  });
};

/*
 context.t('Open Positions');
 */
OpenPositionsComponent.title = 'Open Positions';

OpenPositionsComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  openClosePositionModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

OpenPositionsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (OpenPositionsComponent);

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClosedPositionsComponent__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_marginHistorySelectors__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginSelectors__ = __webpack_require__(34);






var mapStateToProps = function mapStateToProps(state, ownProps) {
  var closedPositions = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_marginHistorySelectors__["a" /* closedPositionsSelector */])(state, ownProps.config);
  var instruments = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);
  var activeRequests = state.margin.history.activeRequests;

  var fetching = activeRequests > 0;

  return {
    data: closedPositions,
    instruments: instruments,
    fetching: fetching,
    baseAsset: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginSelectors__["f" /* marginBaseAssetSelector */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ClosedPositionsComponent__["a" /* default */]));

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__ = __webpack_require__(7);






var baseClass = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var makeCell = function makeCell(data, className) {
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      title: data + ' ' + (currency ? currency : ''),
      className: baseClass('tooltip-wrapper') + ' ' + className },
    data,
    ' ',
    currency
  );
};

var makePrefix = function makePrefix(row) {
  return row.PositionDirection === 'Long' ? '+' : '-';
};

var ClosedPositionsComponent = function ClosedPositionsComponent(_ref, context) {
  var data = _ref.data,
      instruments = _ref.instruments,
      fetching = _ref.fetching,
      config = _ref.config,
      baseAsset = _ref.baseAsset;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var columns = [{
    header: context.t('PID'),
    title: context.t('Position Id'),
    dataTest: 'Position ID',
    cell: function cell(row) {
      return row.PositionId;
    }
  }, {
    header: context.t('Pair'),
    dataTest: 'Pair',
    cell: function cell(row) {
      var instrument = instruments.find(function (item) {
        return item.InstrumentId === row.InstrumentId;
      });
      return instrument ? instrument.Symbol : '';
    }
  }, {
    header: context.t('Position'),
    dataTest: 'Position',
    cell: function cell(row) {
      return row.Position ? context.t('Position') : makeCell('' + makePrefix(row) + Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.PositionAmount, row.PositionProductSymbol, { removeTrailingZeroes: true }), baseClass('size'), row.PositionProductSymbol);
    }
  }, {
    header: context.t('Borrowed Amount'),
    dataTest: 'Size',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.BorrowedAmount, row.BorrowedProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('size'), row.BorrowedProductSymbol);
    }
  }, {
    header: context.t('Cost Basis'),
    dataTest: 'Cost Basis',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.CostBasis, row.BorrowedProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('cost-basis'), row.BorrowedProductSymbol);
    }
  }, {
    header: context.t('Current Px'),
    dataTest: 'Current Px',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.CurrentPrice, row.PositionProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('current-px'), row.PositionProductSymbol);
    }
  }, {
    header: context.t('Position Value'),
    dataTest: 'Position Value',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.PositionValue, baseAsset.Product, {
        removeTrailingZeroes: true
      }), baseClass('position-value'), baseAsset.Product);
    }
  }, {
    header: context.t('Margin Used'),
    dataTest: 'Margin Used',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.MarginUsed, baseAsset.Product, {
        removeTrailingZeroes: true
      }), baseClass('margin-used'), baseAsset.Product);
    }
  }, {
    header: context.t('Int. Accrued'),
    dataTest: 'Int. Accrued',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.InterestedAccrued, row.BorrowedProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('int-accrued'), row.BorrowedProductSymbol);
    }
  }, {
    header: context.t('Int. Paid'),
    dataTest: 'Int. Paid',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.InterestPaid, row.BorrowedProductSymbol, {
        removeTrailingZeroes: true
      }), baseClass('int-accrued'), row.BorrowedProductSymbol);
    }
  }, {
    header: context.t('Realized P&L'),
    dataTest: 'Realized P&L',
    cell: function cell(row) {
      return makeCell(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.UnrealizedPnL, baseAsset.Product, {
        removeTrailingZeroes: true
      }), baseClass('realized-pl'), baseAsset.Product);
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APTable__["a" /* default */], {
    columns: columns,
    rows: data,
    baseClass: baseClass,
    fetching: fetching,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'ClosedPositionsComponent'
  });
};

/*
 this.context.t('Closed Positions');
 */
ClosedPositionsComponent.title = 'Closed Positions';

ClosedPositionsComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

ClosedPositionsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ClosedPositionsComponent);

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PositionPaymentsComponent__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginHistorySelectors__ = __webpack_require__(406);




var mapStateToProps = function mapStateToProps(state, ownProps) {
  var activeRequests = state.margin.history.activeRequests;
  var products = state.apexCore.product.products;

  var fetching = activeRequests > 0;

  return {
    data: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginHistorySelectors__["c" /* positionPaymentsSelector */])(state, ownProps.config),
    products: products,
    fetching: fetching
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__PositionPaymentsComponent__["a" /* default */]));

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);







var baseClass = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-history-table');

var PositionPaymentsComponent = function PositionPaymentsComponent(_ref, context) {
  var data = _ref.data,
      products = _ref.products,
      fetching = _ref.fetching,
      config = _ref.config;
  var maxLines = config.maxLines,
      usePagination = config.usePagination;


  var columns = [{
    header: context.t('Position ID'),
    dataTest: 'Position ID',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('current-px ') },
        row.PositionId
      );
    }
  }, {
    header: context.t('Product'),
    dataTest: 'Product',
    cell: function cell(row) {
      var product = products.find(function (i) {
        return i.ProductId === row.PaymentFromProductId;
      });
      return product ? product.Product : '';
    }
  }, {
    header: context.t('Converted From'),
    dataTest: 'Converted from Amount',
    cell: function cell(row) {
      var _products$find = products.find(function (i) {
        return i.ProductId === row.ConvertedFromProductId;
      }),
          Product = _products$find.Product;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('current-px ') },
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.ConvertedFromAmount, Product, {
          removeTrailingZeroes: true
        }) + ' ' + Product
      );
    }
  }, {
    header: context.t('Payment Amount'),
    dataTest: 'Amount',
    cell: function cell(row) {
      var _products$find2 = products.find(function (i) {
        return i.ProductId === row.PaymentFromProductId;
      }),
          Product = _products$find2.Product;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('amount') },
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(row.PaymentAmount, Product, {
          removeTrailingZeroes: true
        }) + ' ' + Product
      );
    }
  }, {
    header: context.t('Type'),
    dataTest: 'Type',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('type') },
        row.PaymentType
      );
    }
  }, {
    header: context.t('Payment ID'),
    dataTest: 'Payment ID',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('payment-id') },
        row.PositionPaymentId
      );
    }
  }, {
    header: context.t('Payment Time'),
    dataTest: 'Payment Time',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClass('payment-id') },
        Object(__WEBPACK_IMPORTED_MODULE_4__helpers_dateHelper__["g" /* ticksToDateString */])(row.PositionPaymentTimeTicks)
      );
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APTable__["a" /* default */], {
    columns: columns,
    rows: data,
    baseClass: baseClass,
    fetching: fetching,
    pageSize: maxLines,
    usePagination: usePagination,
    empty: context.t('No data is available'),
    componentName: 'ClosedPositionsComponent'
  });
};

/*
 this.context.t('Position Payments');
 */
PositionPaymentsComponent.title = 'Position Payments';

PositionPaymentsComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  products: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

PositionPaymentsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PositionPaymentsComponent);

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);






var orderEntryClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-entry');

var TradingLayout468Px = function TradingLayout468Px(props, context) {
  var OrderEntry = props.OrderEntry,
      InstrumentPositions = props.InstrumentPositions,
      RecentTrades = props.RecentTrades,
      OrderBook = props.OrderBook;


  var _getPanes = function _getPanes() {
    return [{
      menuItem: context.t('Order Entry'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderEntry, null);
      }
    }, {
      menuItem: context.t('Order Book'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderBook, null);
      }
    }, {
      menuItem: context.t('Trades'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentTrades, null);
      }
    }, {
      menuItem: context.t('Balances'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstrumentPositions, { showTitle: false });
      }
    }];
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: orderEntryClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_Tab_Tab__["a" /* default */], { panes: _getPanes(), customClass: 'trading-layout' })
  );
};

TradingLayout468Px.propTypes = {
  short: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  OrderBook: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  RecentTrades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  OrderEntry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  InstrumentPositions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

TradingLayout468Px.defaultProps = {
  short: false
};

TradingLayout468Px.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TradingLayout468Px);

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_resize__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_OrderBookComponents_OrderBookContainer__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_InstrumentRow__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MarginToggleButton__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ConfirmLimitOrderModal_ConfirmLimitOrderModalContainer__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MarginClosePosition_MarginClosePositionModal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MarginTransferAssetModal_MarginTransferAssetsModal__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_MarginClosePosition_EstimatedSettlementModal__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_PriceChart_PriceChartContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DepthChart_DepthChartContainer__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Responsive_TrandingLayout_TradingLayoutCharts1280Px__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_OrderHistoryComponents__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_OrderHistoryComponents_MarginOrderHistory__ = __webpack_require__(405);




















var tradingLayoutClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trading-layout');
var orderEntryClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-entry');
var recentTradeClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('recent-trade');
var orderBookClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-book');
var flexTableClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('flex-table');

var TradingLayout1280Px = function TradingLayout1280Px(props, context) {
  var renderActivity = function renderActivity() {
    var config = props.config,
        isMarginActive = props.isMarginActive;
    var usePagination = config.OrderHistoryData.usePagination,
        maxLines = config.TradingLayout.maxLines;

    var orderHistoryConfig = {
      usePagination: usePagination,
      maxLines: maxLines,
      filterMode: 'selectedInstrument'
    };

    return isMarginActive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_OrderHistoryComponents_MarginOrderHistory__["a" /* default */], { config: orderHistoryConfig }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_OrderHistoryComponents__["default"], { config: orderHistoryConfig });
  };

  var OrderBook = props.OrderBook,
      RecentTrades = props.RecentTrades,
      OrderEntry = props.OrderEntry,
      InstrumentPositions = props.InstrumentPositions,
      short = props.short,
      isMarginEnabledSelector = props.isMarginEnabledSelector;


  var _getPanesForFirstColumn = function _getPanesForFirstColumn() {
    return [{
      menuItem: context.t('Order Book'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: orderBookClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderBook, null)
        );
      }
    }, {
      menuItem: context.t('Recent Trades'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: recentTradeClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentTrades, null)
        );
      }
    }];
  };

  var _getPanesForSecondColumn = function _getPanesForSecondColumn() {
    return [{
      menuItem: context.t('Order Entry'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderEntry, null);
      }
    }, {
      menuItem: context.t('Balances'),
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstrumentPositions, { showTitle: false });
      }
    }];
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: tradingLayoutClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradingLayoutClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_InstrumentRow__["a" /* default */], null),
      isMarginEnabledSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_MarginToggleButton__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradingLayoutClasses('body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: tradingLayoutClasses('chart-container') },
        short ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Responsive_TrandingLayout_TradingLayoutCharts1280Px__["a" /* default */], Object.assign({
          short: props.short
        }, {
          PriceChart: __WEBPACK_IMPORTED_MODULE_12__components_PriceChart_PriceChartContainer__["a" /* default */],
          DepthChart: __WEBPACK_IMPORTED_MODULE_13__components_DepthChart_DepthChartContainer__["a" /* default */],
          showDepthChart: __WEBPACK_IMPORTED_MODULE_15__config__["b" /* default */].TradingLayout.showDepthChart
        })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: tradingLayoutClasses('chart-header') },
            context.t('Price Chart')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_PriceChart_PriceChartContainer__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_15__config__["b" /* default */].TradingLayout.showDepthChart && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_DepthChart_DepthChartContainer__["a" /* default */], null)
        )
      ),
      short ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: tradingLayoutClasses('tabs-container', 'orderbook-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_common_Tab_Tab__["a" /* default */], {
            panes: _getPanesForFirstColumn(),
            customClass: 'trading-layout'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: orderEntryClasses('container', 'orderentry-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_common_Tab_Tab__["a" /* default */], {
            panes: _getPanesForSecondColumn(),
            customClass: 'trading-layout'
          })
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: tradingLayoutClasses('tabs-container', 'orderbook-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_common_Tab_Tab__["a" /* default */], {
            panes: _getPanesForFirstColumn(),
            customClass: 'trading-layout'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: orderEntryClasses('container', 'orderentry-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: flexTableClasses('title') },
            context.t('Order Entry')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderEntry, null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstrumentPositions, null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: tradingLayoutClasses('activity-container') },
        renderActivity()
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ConfirmLimitOrderModal_ConfirmLimitOrderModalContainer__["a" /* default */], null),
    isMarginEnabledSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_MarginClosePosition_MarginClosePositionModal__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_MarginClosePosition_EstimatedSettlementModal__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_MarginTransferAssetModal_MarginTransferAssetsModal__["a" /* default */], null)
    )
  );
};

TradingLayout1280Px.defaultProps = {
  OrderBook: __WEBPACK_IMPORTED_MODULE_5__components_OrderBookComponents_OrderBookContainer__["a" /* default */]
};

TradingLayout1280Px.propTypes = {
  short: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  OrderBook: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  RecentTrades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  OrderEntry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  InstrumentPositions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

TradingLayout1280Px.defaultProps = {
  short: false
};

TradingLayout1280Px.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_resize__["a" /* default */])(TradingLayout1280Px));

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarginToggleButtonComponent__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_tradingStyleConstants__ = __webpack_require__(168);






/**
 * Note: form name is used in marginActions.
 */
var MarginToggleButtonComponentForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'tradingStyle',
  keepDirty: true,
  enableReinitialize: false,
  destroyOnUnmount: false
})(__WEBPACK_IMPORTED_MODULE_2__MarginToggleButtonComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps() {
  return {
    initialValues: {
      tradingStyle: __WEBPACK_IMPORTED_MODULE_4__constants_tradingStyleConstants__["b" /* standardTrade */]
    }
  };
};

var mapDispatchToProps = {
  enableMargin: __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__["n" /* enableMargin */],
  disableMargin: __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__["l" /* disableMargin */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(MarginToggleButtonComponentForm));

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSegmentedButton__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarginToggleButton_css__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarginToggleButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MarginToggleButton_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_tradingStyleConstants__ = __webpack_require__(168);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var baseClass = 'margin-toggle-button';
var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass);

var MarginToggleButtonComponent = function (_React$Component) {
  _inherits(MarginToggleButtonComponent, _React$Component);

  function MarginToggleButtonComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarginToggleButtonComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarginToggleButtonComponent.__proto__ || Object.getPrototypeOf(MarginToggleButtonComponent)).call.apply(_ref, [this].concat(args))), _this), _this.renderToggleButton = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSegmentedButton__["a" /* default */], {
        name: 'tradingStyle',
        label: _this.context.t('Trading Style:'),
        items: [{
          value: __WEBPACK_IMPORTED_MODULE_5__constants_tradingStyleConstants__["b" /* standardTrade */],
          text: _this.context.t('Standard'),
          dataTest: 'Standard',
          onClick: _this.props.disableMargin
        }, {
          value: __WEBPACK_IMPORTED_MODULE_5__constants_tradingStyleConstants__["a" /* marginTrade */],
          text: _this.context.t('Margin'),
          dataTest: 'Margin',
          onClick: _this.props.enableMargin
        }],
        customClass: baseClasses()
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarginToggleButtonComponent, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('container') },
        this.renderToggleButton()
      );
    }
  }]);

  return MarginToggleButtonComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MarginToggleButtonComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginToggleButtonComponent);

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarginTransferAssetsFormComponent__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginTransferActions__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginProductSelectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_marginSelectors__ = __webpack_require__(34);







var mapStateToProps = function mapStateToProps(state, ownProps) {
  var product = state.apexCore.product,
      form = state.form,
      loading = state.margin.transfer.loading,
      _state$user = state.user,
      accounts = _state$user.accounts,
      userInfo = _state$user.userInfo;

  var formObj = form.marginTransferAssets || { values: {} };
  var products = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_marginProductSelectors__["b" /* marginProductSelector */])(state);
  var marginAccount = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_marginSelectors__["e" /* marginAccountSelector */])(state);
  var selectedAsset = products.find(function (product) {
    return product.ProductId === Number(formObj.values.asset);
  });
  var amount = 0;

  if (selectedAsset) {
    amount = marginAccount.AccountId === Number(formObj.values.accountFrom) ? selectedAsset.MarginAmount : selectedAsset.StandardAmount;
  }

  return {
    formObj: formObj,
    assets: product.products,
    initialValues: {
      accountFrom: '' + userInfo.AccountId,
      accountTo: '' + marginAccount.AccountId,
      asset: ownProps.defaultProductId ? ownProps.defaultProductId : '' + product.products[0].ProductId
    },
    accounts: accounts,
    loading: loading,
    amount: amount
  };
};

var Form = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'marginTransferAssets',
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_marginTransferActions__["e" /* transferAssets */])(payload));
    Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["k" /* reset */])('marginTransferAssets');
  }
})(__WEBPACK_IMPORTED_MODULE_2__MarginTransferAssetsFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, {
  setMaxValue: __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginTransferActions__["d" /* setMaxValue */],
  change: __WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */],
  untouch: __WEBPACK_IMPORTED_MODULE_1_redux_form__["l" /* untouch */]
})(Form));

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APSelect_APSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MarginTransferAssetsModalComponent_css__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MarginTransferAssetsModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MarginTransferAssetsModalComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-transfer-assets');

var MarginTransferAssetsFormComponent = function (_React$Component) {
  _inherits(MarginTransferAssetsFormComponent, _React$Component);

  function MarginTransferAssetsFormComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarginTransferAssetsFormComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarginTransferAssetsFormComponent.__proto__ || Object.getPrototypeOf(MarginTransferAssetsFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.isEnough = function (value) {
      var amount = _this.props.amount;

      if (value > amount) {
        return _this.context.t('Not enough funds');
      }
      return undefined;
    }, _this.checkNonDefaultAccount = function () {
      var _this$props = _this.props,
          formObj = _this$props.formObj,
          accounts = _this$props.accounts;

      var accountFrom = accounts.find(function (account) {
        return account.AccountId === Number(formObj.values.accountFrom);
      });
      var accountTo = accounts.find(function (account) {
        return account.AccountId === Number(formObj.values.accountTo);
      });

      if (accountFrom && accountTo) {
        var accountFromName = accountFrom.AccountName;
        var accountToName = accountTo.AccountName;

        if (accountFrom.AccountType === accountTo.AccountType && accountFromName !== accountToName) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('error-message') },
            _this.context.t('Please select margin account')
          );
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarginTransferAssetsFormComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          assets = _props.assets,
          accounts = _props.accounts,
          formObj = _props.formObj,
          handleSubmit = _props.handleSubmit,
          setMaxValue = _props.setMaxValue,
          pristine = _props.pristine,
          invalid = _props.invalid,
          loading = _props.loading,
          change = _props.change,
          untouch = _props.untouch;


      var context = this.context;

      var arrow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: bemClasses('arrow') },
        '→'
      );

      var selectAccountOptions = accounts.map(function (account) {
        return {
          value: account.AccountId,
          label: account.AccountName
        };
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { onSubmit: handleSubmit, className: bemClasses('form') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          context.t('Here you can transfer assets between accounts')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('inline-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APSelect_APSelect__["b" /* default */], {
            name: 'asset',
            customClass: bemClasses(),
            label: '' + context.t('Asset'),
            showTriangles: true,
            options: assets.map(function (asset) {
              return {
                value: asset.ProductId,
                label: asset.Product + ' ' + asset.ProductFullName
              };
            }),
            onSelect: function onSelect() {
              change('amount', 0);
              untouch('amount');
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APNumberInput__["a" /* default */], {
            name: 'amount',
            validate: [__WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__["p" /* required */], this.isEnough],
            customClass: bemClasses(),
            label: '' + context.t('Amount'),
            iconComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
              {
                type: 'button',
                onClick: function onClick() {
                  return setMaxValue();
                },
                customClass: bemClasses('max') },
              'MAX'
            )
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('inline-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APSelect_APSelect__["b" /* default */], {
            name: 'accountFrom',
            label: '' + context.t('From Account'),
            customClass: bemClasses(),
            showTriangles: true,
            options: selectAccountOptions
          }),
          arrow,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APSelect_APSelect__["b" /* default */], {
            name: 'accountTo',
            label: '' + context.t('To Account'),
            customClass: bemClasses(),
            showTriangles: true,
            options: selectAccountOptions
          })
        ),
        formObj.values.accountFrom === formObj.values.accountTo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('error-message') },
          context.t('Please select different To and From Accounts')
        ),
        this.checkNonDefaultAccount(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('btn-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
            {
              type: 'submit',
              customClass: bemClasses(),
              disabled: formObj.values.accountFrom === formObj.values.accountTo || invalid || pristine || loading || !!this.checkNonDefaultAccount() },
            loading ? context.t('Loading') : context.t('Next')
          )
        )
      );
    }
  }]);

  return MarginTransferAssetsFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MarginTransferAssetsFormComponent.propTypes = {
  setMaxValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  formObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  pristine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

MarginTransferAssetsFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginTransferAssetsFormComponent);

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_OrderHistoryComponents__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_OrderHistoryComponents_MarginOrderHistory__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_InstrumentRow__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MarginToggleButton__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Responsive_TrandingLayout_TradingLayoutCharts1280Px__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PriceChart_PriceChartContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DepthChart_DepthChartContainer__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ConfirmLimitOrderModal_ConfirmLimitOrderModalContainer__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_MarginClosePosition_MarginClosePositionModal__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MarginClosePosition_EstimatedSettlementModal__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_MarginTransferAssetModal_MarginTransferAssetsModal__ = __webpack_require__(283);


















var orderEntryClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-entry');
var orderBookClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('order-book');
var recentTradeClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('recent-trade');
var flexTableClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('flex-table');
var tradingLayoutClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trading-layout');

var TradingLayout1440Px = function TradingLayout1440Px(props, context) {
  var renderActivity = function renderActivity() {
    var config = props.config,
        isMarginActive = props.isMarginActive;
    var usePagination = config.OrderHistoryData.usePagination,
        maxLines = config.TradingLayout.maxLines;

    var orderHistoryConfig = {
      usePagination: usePagination,
      maxLines: maxLines,
      filterMode: 'selectedInstrument'
    };

    return isMarginActive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_OrderHistoryComponents_MarginOrderHistory__["a" /* default */], { config: orderHistoryConfig }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_OrderHistoryComponents__["default"], { config: orderHistoryConfig });
  };

  var OrderBook = props.OrderBook,
      RecentTrades = props.RecentTrades,
      OrderEntry = props.OrderEntry,
      InstrumentPositions = props.InstrumentPositions,
      short = props.short,
      isMarginEnabledSelector = props.isMarginEnabledSelector;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: tradingLayoutClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradingLayoutClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_InstrumentRow__["a" /* default */], null),
      isMarginEnabledSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_MarginToggleButton__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: tradingLayoutClasses('body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: tradingLayoutClasses('chart-container') },
        !short ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: tradingLayoutClasses('chart-header') },
            context.t('Price Chart')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_PriceChart_PriceChartContainer__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].TradingLayout.showDepthChart && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DepthChart_DepthChartContainer__["a" /* default */], null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Responsive_TrandingLayout_TradingLayoutCharts1280Px__["a" /* default */], Object.assign({
          short: short
        }, {
          PriceChart: __WEBPACK_IMPORTED_MODULE_9__components_PriceChart_PriceChartContainer__["a" /* default */],
          DepthChart: __WEBPACK_IMPORTED_MODULE_10__components_DepthChart_DepthChartContainer__["a" /* default */],
          showDepthChart: __WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].TradingLayout.showDepthChart
        }))
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: orderBookClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: flexTableClasses('title') },
            context.t('Order Book')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderBook, null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: recentTradeClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: flexTableClasses('title') },
            context.t('Recent Trades')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentTrades, null)
        ),
        short ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: orderEntryClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_Tab_Tab__["a" /* default */], {
            customClass: 'trading-layout',
            panes: [{
              menuItem: context.t('Order Entry'),
              render: function render() {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderEntry, null);
              }
            }, {
              menuItem: context.t('Balances'),
              render: function render() {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstrumentPositions, { showTitle: false });
              }
            }]
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: orderEntryClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderEntry, {
            title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: flexTableClasses('title') },
              context.t('Order Entry')
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstrumentPositions, null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: tradingLayoutClasses('activity-container') },
          renderActivity()
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ConfirmLimitOrderModal_ConfirmLimitOrderModalContainer__["a" /* default */], null),
    isMarginEnabledSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_MarginClosePosition_MarginClosePositionModal__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_MarginClosePosition_EstimatedSettlementModal__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_MarginTransferAssetModal_MarginTransferAssetsModal__["a" /* default */], null)
    )
  );
};

TradingLayout1440Px.propTypes = {
  OrderBook: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  RecentTrades: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  OrderEntry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  InstrumentPositions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  short: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

TradingLayout1440Px.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TradingLayout1440Px);

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BalancesMenuItemComponent__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_MenuComponent__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BalancesMenuComponent_css__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BalancesMenuComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BalancesMenuComponent_css__);








var balancesClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('balances-menu');

var BalancesMenuComponent = function BalancesMenuComponent(props, context) {
  var menuItems = props.positions.map(function (position) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BalancesMenuItemComponent__["a" /* default */], {
      key: position.ProductId,
      position: position,
      selected: position.ProductId === props.selectedProductId,
      onItemClick: props.selectPositionAndSave
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Menu_MenuComponent__["a" /* default */],
    { customClass: balancesClasses(), dataTest: 'Asset List' },
    menuItems
  );
};

BalancesMenuComponent.propTypes = {
  positions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

BalancesMenuComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BalancesMenuComponent);

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MenuItem_MenuItemComponent__ = __webpack_require__(789);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var baseClass = 'balances-menu';
var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass);

var BalancesMenuItemComponent = function (_React$Component) {
  _inherits(BalancesMenuItemComponent, _React$Component);

  function BalancesMenuItemComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BalancesMenuItemComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BalancesMenuItemComponent.__proto__ || Object.getPrototypeOf(BalancesMenuItemComponent)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      _this.props.onItemClick(_this.props.position.ProductId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BalancesMenuItemComponent, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__MenuItem_MenuItemComponent__["a" /* default */],
        {
          onItemClick: this.handleClick,
          selected: this.props.selected,
          customClass: baseClass },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '' + baseClasses('item-icon') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_ProductIcon_ProductIconContainer__["a" /* default */], {
            iconFileName: this.props.position.iconFileName,
            size: 28
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '' + baseClasses('item-details') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + baseClasses('item-symbol-name') },
            this.props.position.Product,
            ' ',
            this.props.position.ProductFullName
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + baseClasses('item-balance-value') },
            this.props.position.Amount,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: '' + baseClasses('item-value-symbol') },
              ' ',
              this.props.position.Product,
              ' '
            )
          )
        )
      );
    }
  }]);

  return BalancesMenuItemComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BalancesMenuItemComponent.propTypes = {
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BalancesMenuItemComponent);

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuComponent_css__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MenuComponent_css__);






var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');

var baseClass = 'menu-component';

var MenuComponent = function MenuComponent(props) {
  var dataTest = props.dataTest,
      children = props.children,
      customClass = props.customClass,
      header = props.header;

  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass, customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: tradeComponentClasses() + ' ' + bemClasses() },
    header && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: '' + tradeComponentClasses('header') },
      props.header
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { className: '' + bemClasses('list'), 'data-test': dataTest },
      children
    )
  );
};

MenuComponent.propTypes = {
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dataTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element])
};

/* harmony default export */ __webpack_exports__["a"] = (MenuComponent);

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferRequestNotificationListComponent__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_transfersTableSelectors__ = __webpack_require__(792);




var mapStateToProps = function mapStateToProps(state) {
  return {
    filteredItems: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_transfersTableSelectors__["a" /* formattedTransfersRequestSelector */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__TransferRequestNotificationListComponent__["a" /* default */]));

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransferRequestNotificationItemContainer__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Pagination_PaginationContainer__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransferRequestNotificationListComponent_css__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransferRequestNotificationListComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TransferRequestNotificationListComponent_css__);








var transferRequestNotificationListClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('transfer-request-notification-list');

var renderItems = function renderItems(items, pageSize, context) {
  var totalPages = Math.ceil(items.length / pageSize || items.length);

  if (totalPages === 1) {
    return items;
  } else if (totalPages > 1) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Pagination_PaginationContainer__["a" /* default */], {
      componentName: 'transferRequest',
      content: function content(page) {
        return items.slice(pageSize * page, pageSize * (page + 1));
      },
      totalPages: totalPages
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: transferRequestNotificationListClasses('empty') },
      context.t('No Transfer Requests Available')
    );
  }
};

var TransferRequestNotificationListComponent = function TransferRequestNotificationListComponent(props, context) {
  var pageSize = props.pageSize,
      filteredItems = props.filteredItems,
      fetching = props.fetching;


  var items = filteredItems.map(function (item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TransferRequestNotificationItemContainer__["a" /* default */], {
      key: item.RequestCode,
      item: item
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: transferRequestNotificationListClasses() },
    fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__["a" /* default */], null) : renderItems(items, pageSize, context)
  );
};

TransferRequestNotificationListComponent.propTypes = {
  pageSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  filteredItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  fetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

TransferRequestNotificationListComponent.defaultProps = {
  pageSize: 3
};

TransferRequestNotificationListComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TransferRequestNotificationListComponent);

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferRequestNotificationItemComponent__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_transferRequestActions__ = __webpack_require__(98);




var mapStateToProps = function mapStateToProps(state, ownProps) {
  return Object.assign({}, ownProps.item, {
    selectedAccountId: state.user.selectedAccountId
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    approveTransferRequest: function approveTransferRequest(selectedAccountId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_transferRequestActions__["h" /* approveTransferRequest */])(ownProps.item.RequestCode)).then(function () {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_transferRequestActions__["i" /* getTransferRequestsReceived */])(selectedAccountId));
      });
    },
    rejectTransferRequest: function rejectTransferRequest(selectedAccountId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_transferRequestActions__["k" /* rejectTransferRequest */])(ownProps.item.RequestCode)).then(function () {
        return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_transferRequestActions__["i" /* getTransferRequestsReceived */])(selectedAccountId));
      });
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TransferRequestNotificationItemComponent__["a" /* default */]));

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon_APIcon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransferRequestNotificationItemComponent_css__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransferRequestNotificationItemComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TransferRequestNotificationItemComponent_css__);









var transferRequestNotificationItemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('transfer-request-notification-item');

var TransferRequestNotificationItemComponent = function TransferRequestNotificationItemComponent(props, context) {
  var iconFileName = props.iconFileName,
      ProductSymbol = props.ProductSymbol,
      ProductFullName = props.ProductFullName,
      Amount = props.Amount,
      RequestorUsername = props.RequestorUsername,
      approveTransferRequest = props.approveTransferRequest,
      rejectTransferRequest = props.rejectTransferRequest,
      selectedAccountId = props.selectedAccountId;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: transferRequestNotificationItemClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: transferRequestNotificationItemClasses('details') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: transferRequestNotificationItemClasses('type-icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon_APIcon__["a" /* default */], {
          name: 'sendWithBorder',
          customClass: transferRequestNotificationItemClasses('icon')
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: transferRequestNotificationItemClasses('product-icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__["a" /* default */], { iconFileName: iconFileName, size: 35 })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: transferRequestNotificationItemClasses('description') },
        context.t('Send'),
        ' ',
        Amount + ' ' + ProductSymbol + ' ' + ProductFullName,
        ' ',
        context.t('to'),
        ' ',
        RequestorUsername
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: transferRequestNotificationItemClasses('buttons') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__common_APButton__["a" /* default */],
        {
          onClick: function onClick() {
            return approveTransferRequest(selectedAccountId);
          },
          customClass: transferRequestNotificationItemClasses(),
          styleName: __WEBPACK_IMPORTED_MODULE_6__propTypes_commonComponent__["b" /* styleNames */].additive },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: transferRequestNotificationItemClasses('btn-text') },
          context.t('Approve')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon_APIcon__["a" /* default */], {
          name: 'simple-check',
          customClass: transferRequestNotificationItemClasses('btn-icon')
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__common_APButton__["a" /* default */],
        {
          onClick: function onClick() {
            return rejectTransferRequest(selectedAccountId);
          },
          customClass: transferRequestNotificationItemClasses(),
          styleName: __WEBPACK_IMPORTED_MODULE_6__propTypes_commonComponent__["b" /* styleNames */].subtractive },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: transferRequestNotificationItemClasses('btn-text') },
          context.t('Reject')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon_APIcon__["a" /* default */], {
          name: 'close',
          customClass: transferRequestNotificationItemClasses('btn-icon')
        })
      )
    )
  );
};

TransferRequestNotificationItemComponent.propTypes = {
  iconFileName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  ProductSymbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  ProductFullName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  Amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  RequestorUsername: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  approveTransferRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  rejectTransferRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

TransferRequestNotificationItemComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TransferRequestNotificationItemComponent);

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssetActivityDetailsContainer__ = __webpack_require__(1985);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__AssetActivityDetailsContainer__["a" /* default */]);

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssetActivityDetailsComponent__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginSelectors__ = __webpack_require__(34);




var mapStateToProps = function mapStateToProps(state) {
  return {
    isMarginActive: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__AssetActivityDetailsComponent__["a" /* default */]));

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssetActivityDetailsHeader__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderHistoryComponents_MarginOrderHistoryExtended__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderHistoryComponents__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AssetActivityDetailsComponent_css__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AssetActivityDetailsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AssetActivityDetailsComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var classes = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('asset-activity-details-component');

var AssetActivityDetailsComponent = function (_React$Component) {
  _inherits(AssetActivityDetailsComponent, _React$Component);

  function AssetActivityDetailsComponent() {
    _classCallCheck(this, AssetActivityDetailsComponent);

    return _possibleConstructorReturn(this, (AssetActivityDetailsComponent.__proto__ || Object.getPrototypeOf(AssetActivityDetailsComponent)).apply(this, arguments));
  }

  _createClass(AssetActivityDetailsComponent, [{
    key: 'render',
    value: function render() {
      var isMarginActive = this.props.isMarginActive;

      var orderHistoryConfig = {
        filterMode: 'selectedProduct',
        usePagination: false
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AssetActivityDetailsHeader__["a" /* default */], null),
        isMarginActive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OrderHistoryComponents_MarginOrderHistoryExtended__["a" /* default */], { config: orderHistoryConfig }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OrderHistoryComponents__["default"], { config: orderHistoryConfig })
      );
    }
  }]);

  return AssetActivityDetailsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (AssetActivityDetailsComponent);

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AssetActivityDetailsHeaderContainer__ = __webpack_require__(1988);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__AssetActivityDetailsHeaderContainer__["a" /* default */]);

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssetActivityDetailsHeaderComponent__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_positionActions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routeTemplates_retailTemplate__ = __webpack_require__(791);






var formSelector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('order-history-filter');

var mapStateToProps = function mapStateToProps(state) {
  var productManifest = state.productManifest;
  var product = state.apexCore.product;

  var startDate = formSelector(state, 'startDate');
  var endDate = formSelector(state, 'endDate');
  var MarginBorrowerEnabled = state.user.userInfo.MarginBorrowerEnabled;


  return {
    product: product,
    productManifest: productManifest,
    formObj: state.form['order-history-filter'] || {
      values: { product: null }
    },
    initialValues: {
      product: null
    },
    buttonBackLink: __WEBPACK_IMPORTED_MODULE_4__routeTemplates_retailTemplate__["marginBalancesPath"],
    startDate: startDate,
    endDate: endDate,
    MarginBorrowerEnabled: MarginBorrowerEnabled
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectPositionAndSave: function selectPositionAndSave(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_positionActions__["f" /* selectPositionAndSave */])(productId));
    },
    setEndDate: function setEndDate(value) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('order-history-filter', 'endDate', value));
    },
    clearDate: function clearDate(fieldName) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('order-history-filter', fieldName, null));
    },
    clearFilters: function clearFilters() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('order-history-filter', 'startDate', null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('order-history-filter', 'endDate', null));
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'order-history-filter',
  onSubmit: function onSubmit() {}
})(__WEBPACK_IMPORTED_MODULE_2__AssetActivityDetailsHeaderComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(container));

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APSelect_APSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APDatePicker_APDatePicker__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MarginToggleButton__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AssetActivityDetailsHeaderComponent_css__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AssetActivityDetailsHeaderComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AssetActivityDetailsHeaderComponent_css__);














var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__["b" /* getBEMClasses */])('asset-activity-details-header');

var AssetActivityDetailsHeaderComponent = function AssetActivityDetailsHeaderComponent(props, context) {
  var product = props.product,
      productManifest = props.productManifest,
      selectPositionAndSave = props.selectPositionAndSave,
      handleSubmit = props.handleSubmit,
      clearDate = props.clearDate,
      formObj = props.formObj,
      setEndDate = props.setEndDate,
      buttonBackLink = props.buttonBackLink,
      clearFilters = props.clearFilters,
      startDate = props.startDate,
      endDate = props.endDate,
      MarginBorrowerEnabled = props.MarginBorrowerEnabled;


  var selectedProduct = product && product.products.find(function (p) {
    return p.ProductId.toString() === ('' + __WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(formObj, 'values.product')).toString();
  });

  var productOptions = product && product.products.map(function (product) {
    var ProductId = product.ProductId,
        Product = product.Product,
        ProductFullName = product.ProductFullName;

    return {
      value: ProductId,
      label: Product + ' ' + ProductFullName
    };
  });
  productOptions.unshift({
    value: 'All',
    label: 'All Products'
  });

  var productSelectorStyleOptions = ['product'];
  if (!selectedProduct) {
    productSelectorStyleOptions.push('without-icon');
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { onSubmit: handleSubmit, className: bemClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('left-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('button-back-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])(buttonBackLink) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__common_APButton__["a" /* default */],
              { customClass: bemClasses() },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APIcon__["a" /* default */], { name: 'arrowPrevious', customClass: bemClasses() })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: bemClasses('selector-container', productSelectorStyleOptions) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('product-icon') },
            productManifest.manifest && selectedProduct && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_ProductIcon_ProductIconContainer__["a" /* default */], {
              size: 20,
              iconFileName: Object.keys(productManifest.manifest).indexOf(selectedProduct.Product) === -1 ? selectedProduct.Product + 'DEFAULT_ICON' : productManifest.manifest[selectedProduct.Product].iconFileName
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APSelect_APSelect__["b" /* default */], {
            name: 'product',
            onSelect: function onSelect(value) {
              return selectPositionAndSave(parseInt(value, 10));
            },
            customClass: bemClasses(),
            showTriangles: true,
            options: productOptions
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('right-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('date-pickers-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APDatePicker_APDatePicker__["a" /* default */], {
            name: 'startDate',
            customClass: bemClasses('from'),
            label: context.t('Date range:'),
            format: function format(value) {
              return value;
            },
            maxDate: endDate || new Date(),
            showIcon: true,
            iconClick: function iconClick() {
              return clearDate('startDate');
            },
            customChange: function customChange() {
              if (!endDate) {
                setEndDate(new Date());
              }
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APDatePicker_APDatePicker__["a" /* default */], {
            name: 'endDate',
            customClass: bemClasses('to'),
            label: context.t('to'),
            format: function format(value) {
              return value;
            },
            minDate: startDate,
            maxDate: new Date(),
            showIcon: true,
            iconClick: function iconClick() {
              return clearDate('endDate');
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__common_APButton__["a" /* default */],
            {
              customClass: bemClasses('clear'),
              type: 'button',
              onClick: clearFilters },
            context.t('Clear Filters')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            MarginBorrowerEnabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__MarginToggleButton__["a" /* default */], null)
          )
        )
      )
    )
  );
};

AssetActivityDetailsHeaderComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AssetActivityDetailsHeaderComponent);

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginOrderHistoryExtendedComponent__ = __webpack_require__(1992);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginOrderHistoryExtendedComponent__["a" /* default */]);

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenOrders__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FilledOrders__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InactiveOrders__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OpenPositions__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClosedPositions__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HeaderWithFilter__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PositionPayments__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TradeReports__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrderHistoryComponent_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OrderHistoryComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__OrderHistoryComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OrderHistoryTables_css__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OrderHistoryTables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__OrderHistoryTables_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var MarginOrderHistoryExtendedComponent = function (_Component) {
  _inherits(MarginOrderHistoryExtendedComponent, _Component);

  function MarginOrderHistoryExtendedComponent() {
    _classCallCheck(this, MarginOrderHistoryExtendedComponent);

    return _possibleConstructorReturn(this, (MarginOrderHistoryExtendedComponent.__proto__ || Object.getPrototypeOf(MarginOrderHistoryExtendedComponent)).apply(this, arguments));
  }

  _createClass(MarginOrderHistoryExtendedComponent, [{
    key: '_getPanes',
    value: function _getPanes() {
      var config = this.props.config;


      var panes = [{
        menuItem: __WEBPACK_IMPORTED_MODULE_3__FilledOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FilledOrders__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_4__InactiveOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__InactiveOrders__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_2__OpenOrders__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OpenOrders__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_5__OpenPositions__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OpenPositions__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_6__ClosedPositions__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ClosedPositions__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_8__PositionPayments__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PositionPayments__["a" /* default */], { config: config });
        }
      }, {
        menuItem: __WEBPACK_IMPORTED_MODULE_9__TradeReports__["a" /* default */].title,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TradeReports__["a" /* default */], { config: config });
        }
      }];

      return panes;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        this.props.useHeaderWithFilter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__HeaderWithFilter__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Tab_Tab__["a" /* default */], {
          defaultActiveIndex: 3,
          panes: this._getPanes(),
          classModifiers: this.props.classModifiers,
          customClass: 'order-history'
        })
      );
    }
  }]);

  return MarginOrderHistoryExtendedComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MarginOrderHistoryExtendedComponent);

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MarginBalances__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MarginTransferAssetModal_MarginTransferAssetsModal__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MarginBalances_MarginDepositWithdraw_MarginDepositModal_MarginDepositModalContainer__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MarginBalancesLayout_css__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MarginBalancesLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MarginBalancesLayout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_APButton__ = __webpack_require__(10);










var marginBalancesLayoutClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-balances-layout');

var MarginBalances = function MarginBalances(_ref, context) {
  var isMarginActive = _ref.isMarginActive,
      isMarginEnabled = _ref.isMarginEnabled,
      enableMargin = _ref.enableMargin,
      disableMargin = _ref.disableMargin,
      activateMarginTradingStyle = _ref.activateMarginTradingStyle,
      deactivateMarginTradingStyle = _ref.deactivateMarginTradingStyle,
      detailsLink = _ref.detailsLink,
      history = _ref.history;

  var wasMarginActiveOnMount = isMarginActive;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isMarginEnabled && !isMarginActive) {
      activateMarginTradingStyle();
      enableMargin();
    }

    return function () {
      if (isMarginEnabled && !wasMarginActiveOnMount) {
        deactivateMarginTradingStyle();
        disableMargin();
      }
    };
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: marginBalancesLayoutClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marginBalancesLayoutClasses('container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: marginBalancesLayoutClasses('content-wrapper') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: marginBalancesLayoutClasses('left-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: marginBalancesLayoutClasses('layout-title') },
            context.t('Balances by Product')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: marginBalancesLayoutClasses('instrument-selector-table') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_MarginBalances__["e" /* MarginInstrumentSelectorTableContainer */], {
              isMarginActive: isMarginActive,
              detailsLink: detailsLink
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: marginBalancesLayoutClasses('right-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: marginBalancesLayoutClasses('instrument-position-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: marginBalancesLayoutClasses('instrument-position') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_MarginBalances__["c" /* MarginInstrumentPositionContainer */], {
                isMarginActive: isMarginActive
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: marginBalancesLayoutClasses('transfer-between-accounts') },
              isMarginActive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_MarginBalances__["g" /* MarginTransferBetweenAccountsContainer */], {
                isMarginActive: isMarginActive
              }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: marginBalancesLayoutClasses('activate-button') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__components_common_APButton__["a" /* default */],
                  {
                    onClick: function onClick() {
                      return history.push('/settings/trade');
                    },
                    classModifiers: 'additive',
                    type: 'button',
                    customClass: 'standalone-form' },
                  'Activate Margin Trading'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: marginBalancesLayoutClasses('instrument-balances-table') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_MarginBalances__["b" /* MarginInstrumentBalancesTableContainer */], {
              isMarginActive: isMarginActive
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: marginBalancesLayoutClasses('footer') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_MarginBalances__["a" /* MarginBalancesFooterContainer */], { isMarginActive: isMarginActive })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_MarginTransferAssetModal_MarginTransferAssetsModal__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_MarginBalances_MarginDepositWithdraw_MarginDepositModal_MarginDepositModalContainer__["a" /* default */], null)
  );
};

MarginBalances.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};

MarginBalances.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* withRouter */])(MarginBalances));

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarginDepositModalComponent__ = __webpack_require__(1996);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_DEPOSIT
})(__WEBPACK_IMPORTED_MODULE_2__MarginDepositModalComponent__["a" /* default */]));

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarginDepositFormContainer__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginDepositModalComponent_css__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginDepositModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MarginDepositModalComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-deposit-modal');

var MarginDepositModal = function MarginDepositModal(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: props.isOpen,
      title: context.t('Deposit'),
      close: props.close,
      customClass: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MarginDepositFormContainer__["a" /* default */], null)
    )
  );
};

MarginDepositModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

MarginDepositModal.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = (MarginDepositModal);

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginDepositForm__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__ = __webpack_require__(9);




var mapStateToProps = function mapStateToProps(state) {
  var product = state.apexCore.product,
      user = state.user,
      modal = state.modal;

  var modalProps = modal[__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_DEPOSIT].modalProps || {};

  var selectedProduct = void 0;
  if (modalProps.productId) {
    selectedProduct = product.products.find(function (product) {
      return product.ProductId === modalProps.productId;
    });
  } else {
    selectedProduct = product.products[0];
  }

  return {
    products: product.products,
    selectedProductId: selectedProduct.ProductId,
    accounts: user.accounts,
    accountTo: user.accounts[0].AccountId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: function closeModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_DEPOSIT));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginDepositForm__["a" /* default */]));

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Retail_RetailSidePanes_FiatDeposit_FiatDepositFormContainer__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarginCryptoDepositForm__ = __webpack_require__(1999);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-deposit-form');

var MarginDepositFormComponent = function (_React$Component) {
  _inherits(MarginDepositFormComponent, _React$Component);

  function MarginDepositFormComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarginDepositFormComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarginDepositFormComponent.__proto__ || Object.getPrototypeOf(MarginDepositFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedProductId: _this.props.selectedProductId,
      selectedAccountId: _this.props.accountTo
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarginDepositFormComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          products = _props.products,
          accounts = _props.accounts,
          closeModal = _props.closeModal;
      var context = this.context;


      var selectedProduct = products.find(function (product) {
        return product.ProductId === Number(_this2.state.selectedProductId);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('title') },
          context.t('Here you can transfer assets between accounts.')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('inline-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["a" /* InnerSelect */], {
            name: 'product',
            label: context.t('Asset') + ':',
            customClass: bemClasses(),
            options: products.map(function (product) {
              var ProductId = product.ProductId,
                  Product = product.Product;

              return { value: ProductId, label: Product };
            }),
            onSelect: function onSelect(value) {
              return _this2.setState({ selectedProductId: value });
            },
            value: this.state.selectedProductId
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["a" /* InnerSelect */], {
            name: 'accountTo',
            label: context.t('To Account') + ':',
            customClass: bemClasses(),
            options: accounts.map(function (account) {
              var AccountId = account.AccountId,
                  AccountName = account.AccountName;

              return { value: AccountId, label: AccountName };
            }),
            onSelect: function onSelect(value) {
              return _this2.setState({ selectedAccountId: value });
            }
          })
        ),
        selectedProduct ? selectedProduct.ProductType === 'CryptoCurrency' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('crypto-deposit-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MarginCryptoDepositForm__["a" /* default */], { product: selectedProduct })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('confirm-btn-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
              {
                customClass: bemClasses('confirm-btn'),
                type: 'button',
                onClick: closeModal },
              context.t('Ok')
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Retail_RetailSidePanes_FiatDeposit_FiatDepositFormContainer__["a" /* default */], { product: selectedProduct }) : null
      );
    }
  }]);

  return MarginDepositFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MarginDepositFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginDepositFormComponent);

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginCryptoDepositFormContainer__ = __webpack_require__(2000);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginCryptoDepositFormContainer__["a" /* default */]);

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarginCryptoDepositFormComponent__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_depositActions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);






var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedAddress: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_depositWithdrawalSelectors__["a" /* depositAddressSelector */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectDepositProduct: function selectDepositProduct(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_depositActions__["p" /* fetchProductDepositTemplate */])(productId));
    },
    showSnack: function showSnack(text) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__["e" /* showSnack */])(text));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__MarginCryptoDepositFormComponent__["a" /* default */]));

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APQRCode_APQRCode__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_depositWithdrawalHelper__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginCryptoDepositFormComponent_css__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarginCryptoDepositFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MarginCryptoDepositFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-crypto-deposit');

var MarginCryptoDepositFormComponent = function (_React$Component) {
  _inherits(MarginCryptoDepositFormComponent, _React$Component);

  function MarginCryptoDepositFormComponent() {
    _classCallCheck(this, MarginCryptoDepositFormComponent);

    return _possibleConstructorReturn(this, (MarginCryptoDepositFormComponent.__proto__ || Object.getPrototypeOf(MarginCryptoDepositFormComponent)).apply(this, arguments));
  }

  _createClass(MarginCryptoDepositFormComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          selectDepositProduct = _props.selectDepositProduct,
          product = _props.product;

      selectDepositProduct(product.ProductId);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.product.ProductId !== this.props.product.ProductId) {
        this.props.selectDepositProduct(this.props.product.ProductId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          selectedAddress = _props2.selectedAddress,
          product = _props2.product;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('body') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('col-left') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('title') },
              this.context.t('Send cryptocurrency to this address.')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('text') },
              this.context.t('Your account will automatically update after the ' + 'cryptocurrency network confirms your transaction. ' + 'The confirmation may take up to 1 hour.')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('col-right') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APQRCode_APQRCode__["a" /* default */], {
              value: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_depositWithdrawalHelper__["a" /* getDepositType */])(product) + ':' + selectedAddress,
              size: 123
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('address-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('address-title') },
            'Address:'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('address-body') },
            selectedAddress || this.context.t('no address provided')
          )
        )
      );
    }
  }]);

  return MarginCryptoDepositFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MarginCryptoDepositFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarginCryptoDepositFormComponent);

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepositType; });
var getDepositType = function getDepositType(product) {
  return product.ProductFullName.toLowerCase().replace(/\W/g, '');
};

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BalancesListComponent__ = __webpack_require__(2007);




var mapStateToProps = function mapStateToProps(state) {
  return {
    fetching: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__["a" /* fetchingSelector */])(state),
    balances: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__BalancesListComponent__["a" /* default */]));

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BalanceItemComponent__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BalancesListComponent_css__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BalancesListComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BalancesListComponent_css__);







var productBalancesClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('product-balances');

var BalancesListComponent = function BalancesListComponent(props) {
  var items = props.balances.map(function (item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BalanceItemComponent__["a" /* default */], { key: item.ProductId, balance: item });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    props.fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: productBalancesClasses('container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: productBalancesClasses('wrapper') },
        items
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BalancesListComponent);

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BalanceItem_css__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BalanceItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BalanceItem_css__);






var balanceItemClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('balance-item');

var BalanceItemComponent = function BalanceItemComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: balanceItemClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: balanceItemClasses('group') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: balanceItemClasses('icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_ProductIcon_ProductIconContainer__["a" /* default */], {
          iconFileName: props.balance.iconFileName,
          size: 24
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: balanceItemClasses('product') },
        props.balance.Product + ' ' + props.balance.ProductFullName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: balanceItemClasses('group') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: balanceItemClasses('position') },
        props.balance.Amount
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BalanceItemComponent);

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecentActivityHeader__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecentActivityTable__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActivityComponents_css__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActivityComponents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ActivityComponents_css__);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var RecentActivityComponent = function RecentActivityComponent(props, context) {
  var width = props.width,
      themeModifier = props.themeModifier;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RecentActivityHeader__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RecentActivityTable__["a" /* default */], {
      themeModifier: themeModifier,
      width: width,
      context: context
    })
  );
};

RecentActivityComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RecentActivityComponent);

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);




var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var RecentActivityHeaderComponent = function RecentActivityHeaderComponent(props, context) {
  var headerText = props.headerText,
      children = props.children;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('header-bar') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('header-text') },
      context.t(headerText)
    ),
    children
  );
};

RecentActivityHeaderComponent.defaultProps = {
  headerText: 'Recent Activity'
};

RecentActivityHeaderComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RecentActivityHeaderComponent);

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecentActivityTableContainer__ = __webpack_require__(2015);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RecentActivityTableContainer__["a" /* default */]);

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecentActivityTableComponent__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_recentActivityHelper__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_recentActivitySelector__ = __webpack_require__(410);





var mapStateToProps = function mapStateToProps(state, ownProps) {
  var filteredActivity = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_recentActivitySelector__["a" /* getFilteredActivity */])(state, ownProps.filterForSelected);
  var content = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_recentActivityHelper__["a" /* formatActivity */])(filteredActivity.slice(0, 6), ownProps.context);

  var columns = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_recentActivityHelper__["b" /* getColumns */])(ownProps.width, ownProps.themeModifier, ownProps.context);

  return {
    columns: columns,
    content: content
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__RecentActivityTableComponent__["a" /* default */]));

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WalletCardContainer__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WalletCardGrid_css__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WalletCardGrid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WalletCardGrid_css__);







var walletCardGridClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-card-grid');

var WalletCardGrid = function WalletCardGrid(props) {
  var items = props.products.map(function (item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__WalletCardContainer__["a" /* default */], {
      key: item.ProductId,
      productId: item.ProductId,
      detailsLink: props.detailsLink
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    props.fetching || !!items.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletCardGridClasses() },
      props.fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__["a" /* default */], null) : items
    ) : ''
  );
};

/* harmony default export */ __webpack_exports__["a"] = (WalletCardGrid);

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WalletCardComponent__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_baseCurrenciesSelectors__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_positionActions__ = __webpack_require__(85);






var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _getProductByIdSelect = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["c" /* getProductByIdSelector */])(state, ownProps.productId),
      iconFileName = _getProductByIdSelect.iconFileName,
      ProductSymbol = _getProductByIdSelect.ProductSymbol,
      ProductFullName = _getProductByIdSelect.ProductFullName,
      Amount = _getProductByIdSelect.Amount,
      rawAmount = _getProductByIdSelect.rawAmount,
      ProductType = _getProductByIdSelect.ProductType,
      ProductId = _getProductByIdSelect.ProductId,
      productColor = _getProductByIdSelect.productColor;

  var baseCurrency = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_baseCurrenciesSelectors__["a" /* baseCurrencyPriceSelector */])(state, ownProps.productId);
  var isCrypto = ProductType === 'CryptoCurrency';

  return {
    iconFileName: iconFileName,
    ProductSymbol: ProductSymbol,
    ProductFullName: ProductFullName,
    Amount: Amount,
    rawAmount: rawAmount,
    isCrypto: isCrypto,
    ProductId: ProductId,
    productColor: productColor,
    baseCurrency: baseCurrency,
    detailsLink: ownProps.detailsLink
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectPositionAndSave: function selectPositionAndSave() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_positionActions__["f" /* selectPositionAndSave */])(ownProps.productId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__WalletCardComponent__["a" /* default */]));

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WalletNavItems_CryptoNavItemsContainer__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WalletNavItems_FiatNavItemsContainer__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs_resize__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WalletCard_css__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WalletCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__WalletCard_css__);














var walletCardClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-card');

var WalletCard = function WalletCard(props, context) {
  var iconFileName = props.iconFileName,
      ProductSymbol = props.ProductSymbol,
      ProductFullName = props.ProductFullName,
      Amount = props.Amount,
      rawAmount = props.rawAmount,
      isCrypto = props.isCrypto,
      ProductId = props.ProductId,
      productColor = props.productColor,
      baseCurrency = props.baseCurrency,
      width = props.width;

  var iconSize = width > 1024 ? 44 : 28;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: walletCardClasses() + ' container-with-shadow' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletCardClasses('icon-label-row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { borderTop: '4px solid ' + productColor },
          className: walletCardClasses('icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_ProductIcon_ProductIconContainer__["a" /* default */], { iconFileName: iconFileName, size: iconSize })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: walletCardClasses('symbol-label') },
        ProductSymbol + ' ' + ProductFullName
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletCardClasses('balance-row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: walletCardClasses('balance') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: walletCardClasses('label') },
          context.t('Current Balance')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: walletCardClasses('amount') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: walletCardClasses('amount-text') },
            Amount
          )
        )
      ),
      baseCurrency && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: walletCardClasses('balance') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: walletCardClasses('label') },
          baseCurrency.product,
          ' ',
          context.t('Value')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: walletCardClasses('amount') },
          Object(__WEBPACK_IMPORTED_MODULE_9__helpers_numberFormatter__["b" /* formatNumberToLocale */])(rawAmount * baseCurrency.value, baseCurrency.DecimalPlaces)
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletCardClasses('activity-link-row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: walletCardClasses('activity-link-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
          {
            className: walletCardClasses('activity-link'),
            to: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])(props.detailsLink),
            onClick: props.selectPositionAndSave },
          context.t('Details'),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APIcon__["a" /* default */], {
            name: 'arrowNext',
            customClass: walletCardClasses('next-icon')
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: walletCardClasses('icon-nav-buttons') },
        isCrypto ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__WalletNavItems_CryptoNavItemsContainer__["a" /* default */], {
          product: {
            iconFileName: iconFileName,
            ProductSymbol: ProductSymbol,
            ProductFullName: ProductFullName,
            ProductId: ProductId
          },
          showIconButtonLabel: false
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__WalletNavItems_FiatNavItemsContainer__["a" /* default */], {
          product: {
            iconFileName: iconFileName,
            ProductSymbol: ProductSymbol,
            ProductFullName: ProductFullName,
            ProductId: ProductId
          },
          showIconButtonLabel: false
        })
      )
    )
  );
};

WalletCard.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__hocs_resize__["a" /* default */])(WalletCard));

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propTypes_sendReceiveComponent__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WalletNavItems_css__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WalletNavItems_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__WalletNavItems_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var cryptoNavItemsClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-nav-item');

var CryptoNavItems = function (_React$Component) {
  _inherits(CryptoNavItems, _React$Component);

  function CryptoNavItems() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CryptoNavItems);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CryptoNavItems.__proto__ || Object.getPrototypeOf(CryptoNavItems)).call.apply(_ref, [this].concat(args))), _this), _this.onSendClick = function () {
      _this.onBtnClick(true);
    }, _this.onReceiveClick = function () {
      _this.onBtnClick(false);
    }, _this.onBtnClick = function (isSend) {
      var _this$props = _this.props,
          openSendReceiveSidePane = _this$props.openSendReceiveSidePane,
          product = _this$props.product,
          isWithdrawDisabled = _this$props.isWithdrawDisabled;


      if (isSend && isWithdrawDisabled) return;
      openSendReceiveSidePane(isSend, product);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CryptoNavItems, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showIconButtonLabel = _props.showIconButtonLabel,
          isWithdrawDisabled = _props.isWithdrawDisabled;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__["a" /* default */], {
          iconName: 'send',
          action: this.onSendClick,
          tooltipText: showIconButtonLabel ? null : this.context.t('Send'),
          customClass: cryptoNavItemsClasses(),
          showLabel: showIconButtonLabel,
          isDisabled: isWithdrawDisabled,
          label: this.context.t('Send')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__["a" /* default */], {
          iconName: 'receive',
          action: this.onReceiveClick,
          tooltipText: showIconButtonLabel ? null : this.context.t('Receive'),
          customClass: cryptoNavItemsClasses(),
          showLabel: showIconButtonLabel,
          label: this.context.t('Receive')
        })
      );
    }
  }]);

  return CryptoNavItems;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CryptoNavItems.defaultProps = {
  showIconButtonLabel: true
};

CryptoNavItems.propTypes = {
  openSendReceiveSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  product: __WEBPACK_IMPORTED_MODULE_4__propTypes_sendReceiveComponent__["a" /* product */],
  showIconButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

CryptoNavItems.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (CryptoNavItems);

/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WalletNavItems_css__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WalletNavItems_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WalletNavItems_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var fiatNavItemsClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-nav-item');

var FiatNavItems = function (_React$Component) {
  _inherits(FiatNavItems, _React$Component);

  function FiatNavItems() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FiatNavItems);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FiatNavItems.__proto__ || Object.getPrototypeOf(FiatNavItems)).call.apply(_ref, [this].concat(args))), _this), _this.onDepositClick = function () {
      if (!_this.props.isDepositDisabled) _this.onBtnClick(true);
    }, _this.onWithdrawClick = function () {
      if (!_this.props.isWithdrawDisabled) _this.onBtnClick(false);
    }, _this.onBtnClick = function (isSend) {
      var _this$props = _this.props,
          openRetailFiatSidePane = _this$props.openRetailFiatSidePane,
          product = _this$props.product,
          isDepositDisabled = _this$props.isDepositDisabled,
          isWithdrawDisabled = _this$props.isWithdrawDisabled;


      openRetailFiatSidePane(isSend, product, isDepositDisabled, isWithdrawDisabled);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FiatNavItems, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showIconButtonLabel = _props.showIconButtonLabel,
          isWithdrawDisabled = _props.isWithdrawDisabled,
          isDepositDisabled = _props.isDepositDisabled;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__["a" /* default */], {
          iconName: 'deposit',
          action: this.onDepositClick,
          tooltipText: showIconButtonLabel ? null : this.context.t('Deposit'),
          customClass: fiatNavItemsClasses(),
          showLabel: showIconButtonLabel,
          label: this.context.t('Deposit'),
          isDisabled: isDepositDisabled
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__["a" /* default */], {
          iconName: 'withdraw',
          action: this.onWithdrawClick,
          tooltipText: showIconButtonLabel ? null : this.context.t('Withdraw'),
          customClass: fiatNavItemsClasses(),
          showLabel: showIconButtonLabel,
          isDisabled: isWithdrawDisabled,
          label: this.context.t('Withdraw')
        })
      );
    }
  }]);

  return FiatNavItems;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiatNavItems.defaultProps = {
  showIconButtonLabel: true
};

FiatNavItems.propTypes = {
  openRetailFiatSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    iconFileName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ProductFullName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ProductSymbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ProductId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  showIconButtonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isWithdrawDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

FiatNavItems.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatNavItems);

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WalletRowContainer__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Retail_RetailSidePanes_FiatDeposit__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WalletRowList_css__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WalletRowList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__WalletRowList_css__);









var walletRowListClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-row-list');

var WalletRowListComponent = function WalletRowListComponent(props, context) {
  if (props.fetching) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__["a" /* default */], { customClass: walletRowListClasses });
  }

  var items = props.products.map(function (item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__WalletRowContainer__["a" /* default */], {
      key: item.ProductId,
      productId: item.ProductId,
      detailsLink: props.detailsLink
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: walletRowListClasses() },
    items,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Retail_RetailSidePanes_FiatDeposit__["a" /* DepositReferenceIdModalContainer */], null)
  );
};

WalletRowListComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (WalletRowListComponent);

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WalletRowComponent__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_positionActions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_resize__ = __webpack_require__(73);






var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _getProductByIdSelect = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["c" /* getProductByIdSelector */])(state, ownProps.productId),
      iconFileName = _getProductByIdSelect.iconFileName,
      ProductSymbol = _getProductByIdSelect.ProductSymbol,
      ProductFullName = _getProductByIdSelect.ProductFullName,
      ProductType = _getProductByIdSelect.ProductType,
      ProductId = _getProductByIdSelect.ProductId;

  var isCrypto = ProductType === 'CryptoCurrency';

  return {
    iconFileName: iconFileName,
    ProductSymbol: ProductSymbol,
    ProductFullName: ProductFullName,
    isCrypto: isCrypto,
    ProductId: ProductId,
    detailsLink: ownProps.detailsLink
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectPositionAndSave: function selectPositionAndSave() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_positionActions__["f" /* selectPositionAndSave */])(ownProps.productId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hocs_resize__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__WalletRowComponent__["a" /* default */])));

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WalletNavItems_CryptoNavItemsContainer__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WalletNavItems_FiatNavItemsContainer__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WalletRow_css__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WalletRow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__WalletRow_css__);












var walletRowClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-row');

var WalletRow = function WalletRow(props, context) {
  var iconFileName = props.iconFileName,
      ProductSymbol = props.ProductSymbol,
      ProductFullName = props.ProductFullName,
      isCrypto = props.isCrypto,
      ProductId = props.ProductId,
      width = props.width,
      detailsLink = props.detailsLink;

  var replaceActivityLink = width < 768 ? true : false;
  var iconSize = width > 1024 ? 44 : 28;

  var renderActivityLink = function renderActivityLink() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletRowClasses('activity-link') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        {
          className: walletRowClasses('activity-link'),
          to: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])(detailsLink),
          onClick: props.selectPositionAndSave },
        context.t('Details'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APIcon__["a" /* default */], {
          name: 'arrowNext',
          customClass: walletRowClasses('next-icon')
        })
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: walletRowClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletRowClasses('icon-label') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: walletRowClasses('product-icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_ProductIcon_ProductIconContainer__["a" /* default */], { iconFileName: iconFileName, size: iconSize })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: walletRowClasses('symbol-label') },
        ProductSymbol + ' ' + ProductFullName,
        replaceActivityLink && renderActivityLink()
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: walletRowClasses('activity-link-columns') },
      !replaceActivityLink && renderActivityLink(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: walletRowClasses('icon-nav-buttons') },
        isCrypto ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__WalletNavItems_CryptoNavItemsContainer__["a" /* default */], {
          product: {
            iconFileName: iconFileName,
            ProductSymbol: ProductSymbol,
            ProductFullName: ProductFullName,
            ProductId: ProductId
          },
          showIconButtonLabel: false
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__WalletNavItems_FiatNavItemsContainer__["a" /* default */], {
          product: {
            iconFileName: iconFileName,
            ProductSymbol: ProductSymbol,
            ProductFullName: ProductFullName,
            ProductId: ProductId
          },
          showIconButtonLabel: false
        })
      )
    )
  );
};

WalletRow.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (WalletRow);

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarketDataCardComponent__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarketDataCardsComponent_css__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarketDataCardsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MarketDataCardsComponent_css__);






var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('market-data-cards');

var MarketDataCardsComponent = function MarketDataCardsComponent(props) {
  var level1 = props.level1,
      instruments = props.instruments,
      products = props.products;


  var marketDataCards = instruments.map(function (instrument) {
    var InstrumentId = instrument.InstrumentId;

    var level1Data = level1[InstrumentId];

    if (!level1Data) return null;

    var Product1 = instrument.Product1,
        Product2 = instrument.Product2;

    var product1 = products.find(function (x) {
      return x.ProductId === Product1;
    });
    var product2 = products.find(function (x) {
      return x.ProductId === Product2;
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        key: InstrumentId,
        className: bemClasses('card') + ' container-with-shadow' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MarketDataCardComponent__["a" /* default */], {
        instrument: instrument,
        product1: product1,
        product2: product2,
        level1Data: level1Data
      })
    );
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('row') },
      marketDataCards
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MarketDataCardsComponent);

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propTypes_level1Data__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_level1Helper__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MarketDataCardComponent_css__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MarketDataCardComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__MarketDataCardComponent_css__);













var marketDataItemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('market-data-card');

var MarketDataCardComponent = function MarketDataCardComponent(props, context) {
  var product1 = props.product1,
      product2 = props.product2,
      instrument = props.instrument,
      _props$level1Data = props.level1Data,
      LastTradedPx = _props$level1Data.LastTradedPx,
      Rolling24HrVolume = _props$level1Data.Rolling24HrVolume,
      Rolling24HrPxChange = _props$level1Data.Rolling24HrPxChange,
      Rolling24HrPxChangePercent = _props$level1Data.Rolling24HrPxChangePercent,
      SessionHigh = _props$level1Data.SessionHigh,
      SessionLow = _props$level1Data.SessionLow,
      BestBid = _props$level1Data.BestBid,
      BestOffer = _props$level1Data.BestOffer,
      coin = props.coin;

  var rolling24HrPxChangeValue = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_level1Helper__["a" /* calculateRolling24HrPxChangeValue */])(LastTradedPx, Rolling24HrPxChange);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: marketDataItemClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marketDataItemClasses('row') },
      coin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_ProductIcon_ProductIconContainer__["a" /* default */], {
          iconFileName: product1.iconFileName,
          size: 40
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: marketDataItemClasses('coins-header-text') },
          product1.ProductFullName + ' ' + product1.ProductSymbol
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: product1.ProductFullName + ' / ' + product2.ProductFullName,
        text: product1.ProductSymbol + '/' + product2.ProductSymbol,
        customClass: marketDataItemClasses(),
        classModifiers: 'header'
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marketDataItemClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: context.t('Last Price'),
        text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(LastTradedPx, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
        customClass: marketDataItemClasses()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: context.t('24-Hour Change'),
        text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(rolling24HrPxChangeValue, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
        customClass: marketDataItemClasses(),
        classModifiers: rolling24HrPxChangeValue.gte(0) ? '24h-positive' : '24h-negative'
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marketDataItemClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: context.t('24-Hour Pct Change'),
        text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["c" /* formatPercentageValue */])(Rolling24HrPxChangePercent),
        customClass: marketDataItemClasses(),
        classModifiers: Rolling24HrPxChangePercent >= 0 ? '24h-positive' : '24h-negative'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: context.t('24-Hour Vol.'),
        text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Rolling24HrVolume, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.QuantityIncrement)),
        customClass: marketDataItemClasses()
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marketDataItemClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: context.t('24-Hour High'),
        text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(SessionHigh, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
        customClass: marketDataItemClasses()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: context.t('24-Hour Low'),
        text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(SessionLow, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
        customClass: marketDataItemClasses()
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marketDataItemClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: context.t('Bid'),
        text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(BestBid, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
        customClass: marketDataItemClasses(),
        classModifiers: 'bid'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText__["a" /* default */], {
        label: context.t('Ask'),
        text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(BestOffer, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
        customClass: marketDataItemClasses(),
        classModifiers: 'ask'
      })
    ),
    coin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marketDataItemClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: marketDataItemClasses('activity') },
        'View Activity \u2192'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: marketDataItemClasses('icons') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: marketDataItemClasses('icon-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APIcon__["a" /* default */], { name: 'buy', customClass: marketDataItemClasses('icon') })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: marketDataItemClasses('icon-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APIcon__["a" /* default */], { name: 'sell', customClass: marketDataItemClasses('icon') })
        )
      )
    )
  );
};

MarketDataCardComponent.propTypes = {
  level1Data: __WEBPACK_IMPORTED_MODULE_3__propTypes_level1Data__["b" /* type */].isRequired,
  product1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  product2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  coin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

MarketDataCardComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarketDataCardComponent);

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateRolling24HrPxChangeValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bignumber_js__);


var calculateRolling24HrPxChangeValue = function calculateRolling24HrPxChangeValue(price, change) {
  // rolling24HrPxChangeValue = LastTradedPx*(Rolling24HrPxChange(%)/(1 + Rolling24HrPxChange(%)))
  price = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(price);
  change = new __WEBPACK_IMPORTED_MODULE_0_bignumber_js___default.a(change / 100);
  return price.times(change.div(change.plus(1)));
};

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellContainer__ = __webpack_require__(2034);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellContainer__["a" /* default */]);

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuySellComponent__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);






var BuySellComponentForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'buySell',
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].RETAIL_SUBMIT_ORDER));
  },
  destroyOnUnmount: false
})(__WEBPACK_IMPORTED_MODULE_2__BuySellComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    initialValues: {
      side: __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */],
      amountRadio: 'custom',
      price: '',
      quantity: '',
      fee: '0',
      orderType: __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName,
      responseMessage: ''
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(BuySellComponentForm));

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuySellComponent_css__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuySellComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BuySellComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellOrderConfirmationModal__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellTabs__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BuySellInstrumentSelector__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BuySellOrderButton__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BuySellPresetValuesRows__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BuySellCustomRow__ = __webpack_require__(2050);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell');

var BuySellComponent = function (_React$Component) {
  _inherits(BuySellComponent, _React$Component);

  function BuySellComponent() {
    _classCallCheck(this, BuySellComponent);

    return _possibleConstructorReturn(this, (BuySellComponent.__proto__ || Object.getPrototypeOf(BuySellComponent)).apply(this, arguments));
  }

  _createClass(BuySellComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          extraInfoComponent = _props.extraInfoComponent,
          displayInstrumentSelector = _props.displayInstrumentSelector,
          themeModifier = _props.themeModifier,
          amountHeader = _props.amountHeader,
          formHeader = _props.formHeader,
          hideKYC = _props.hideKYC,
          customKYCmessage = _props.customKYCmessage;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          className: baseClasses('container', themeModifier),
          onSubmit: handleSubmit },
        formHeader && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('form-header', themeModifier) },
          formHeader
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BuySellTabs__["a" /* default */], {
          baseClasses: baseClasses,
          themeModifier: themeModifier
        }),
        displayInstrumentSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BuySellInstrumentSelector__["a" /* default */], { baseClasses: baseClasses }),
        amountHeader && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('amount-header', themeModifier) },
          this.context.t(amountHeader)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('amount-container', themeModifier) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BuySellPresetValuesRows__["a" /* default */], { baseClasses: baseClasses }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BuySellCustomRow__["a" /* default */], {
            baseClasses: baseClasses,
            themeModifier: themeModifier
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BuySellOrderConfirmationModal__["a" /* default */], null)
        ),
        extraInfoComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('extra-info-container', themeModifier) },
          extraInfoComponent
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__BuySellOrderButton__["a" /* default */], {
          baseClasses: baseClasses,
          handleSubmit: handleSubmit,
          submitting: submitting,
          hideKYC: hideKYC,
          customKYCmessage: customKYCmessage
        })
      );
    }
  }]);

  return BuySellComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BuySellComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  displayInstrumentSelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  extraInfoComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  themeModifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  hideKYC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customKYCmessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

BuySellComponent.defaultProps = {
  displayInstrumentSelector: true,
  hideKYC: false,
  amountHeader: 'Amount'
};

BuySellComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellComponent);

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellConfirmationModalContainer__ = __webpack_require__(2038);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellConfirmationModalContainer__["a" /* default */]);

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuySellConfirmationModalComponent__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);















var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;

  var buySellForm = form.buySell || { values: { fee: {} } };
  var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["a" /* getOrderFormInfoSelector */])(state);

  var price = selectedValue.price ? selectedValue.price : 0;
  var quantity = selectedValue.quantity ? selectedValue.quantity : '';
  var pricePerUnit = selectedValue.pricePerUnit ? selectedValue.pricePerUnit : 0;

  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var Product2Symbol = selectedInstrument.Product2Symbol,
      Product1 = selectedInstrument.Product1,
      Product2 = selectedInstrument.Product2,
      PriceIncrement = selectedInstrument.PriceIncrement,
      QuantityIncrement = selectedInstrument.QuantityIncrement;

  var isBuySide = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state);
  var finalQuantityProduct = isBuySide ? Product1 : Product2;
  var finalQuantity = isBuySide ? quantity : price;

  if (finalQuantityProduct === buySellForm.values.fee.ProductId) {
    finalQuantity -= buySellForm.values.fee.OrderFee;
  }

  return {
    isBuySide: isBuySide,
    positions: Object(__WEBPACK_IMPORTED_MODULE_12__redux_selectors_positionSelectors__["b" /* positionSelector */])(state),
    buySellForm: buySellForm,
    selectedInstrument: selectedInstrument,
    price: price,
    quantity: quantity,
    pricePerUnit: Object(__WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper_js__["g" /* getOrderPricePerUnit */])(pricePerUnit, Product2Symbol, Object(__WEBPACK_IMPORTED_MODULE_13__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement)),
    finalQuantity: Object(__WEBPACK_IMPORTED_MODULE_9__helpers_numberFormatter__["i" /* truncateToDecimals */])(finalQuantity, Object(__WEBPACK_IMPORTED_MODULE_13__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(isBuySide ? QuantityIncrement : PriceIncrement)),
    hideFees: !!__WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].global.hideFees,
    displayPricePerUnit: __WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].RetailBuySell.pricePerUnit
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    confirmReport: function confirmReport(form) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_orderEntryActions__["e" /* placeOrder */])(__WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].buySell, form)).then(function (res) {
        if (res.result === false) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_snackbarActions__["e" /* showSnack */])({
            id: 'confirmBuySellFail',
            text: res.errormsg || res.detail,
            type: 'warning'
          }));
        }
      });
    },
    onClose: function onClose() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_orderEntryActions__["c" /* clearBuySellForm */])());
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__BuySellConfirmationModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["b" /* MODAL_TYPES */].RETAIL_SUBMIT_ORDER
})(container));

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_orderHelper_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BuySellConfirmationModalComponent_css__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BuySellConfirmationModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__BuySellConfirmationModalComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell-order-confirmation');

var BuySellConfirmationModalComponent = function (_React$Component) {
  _inherits(BuySellConfirmationModalComponent, _React$Component);

  function BuySellConfirmationModalComponent(props) {
    _classCallCheck(this, BuySellConfirmationModalComponent);

    var _this = _possibleConstructorReturn(this, (BuySellConfirmationModalComponent.__proto__ || Object.getPrototypeOf(BuySellConfirmationModalComponent)).call(this, props));

    _this.placeOrder = function () {
      var _this$props = _this.props,
          confirmReport = _this$props.confirmReport,
          buySellForm = _this$props.buySellForm;

      _this.setState({ submitting: true });
      confirmReport(buySellForm.values).then(function (response) {
        _this.setState({ submitting: false });
      }, function (err) {});
    };

    _this.state = {
      submitting: false
    };
    return _this;
  }

  _createClass(BuySellConfirmationModalComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var responseMessage = this.props.buySellForm.values.responseMessage;
      var nextResponseMessage = nextProps.buySellForm.values.responseMessage;

      if (responseMessage && nextResponseMessage) {
        return false;
      }
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          buySellForm = _props.buySellForm,
          isOpen = _props.isOpen,
          _close = _props.close,
          selectedInstrument = _props.selectedInstrument,
          positions = _props.positions,
          price = _props.price,
          quantity = _props.quantity,
          finalQuantity = _props.finalQuantity,
          onClose = _props.onClose,
          hideFees = _props.hideFees,
          displayPricePerUnit = _props.displayPricePerUnit,
          pricePerUnit = _props.pricePerUnit;
      var context = this.context;


      var isBuySide = buySellForm.values.side === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */];
      var product = selectedInstrument.Product1Symbol;
      var responseMessage = buySellForm.values.responseMessage;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
        {
          isOpen: isOpen,
          title: context.t('' + (isBuySide ? 'Buy ' + selectedInstrument.Product1Symbol : 'Sell ' + selectedInstrument.Product1Symbol)),
          close: function close() {
            _close();
            onClose();
          },
          footer: {
            buttonText: context.t(getConfirmButtonText(isBuySide, responseMessage)),
            disabled: this.state.submitting,
            onClick: responseMessage ? function () {
              _close();
              onClose();
            } : this.placeOrder,
            overrideClose: true
          },
          customClass: bemClasses('modal') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: bemClasses('header') },
            responseMessage || context.t('Confirmation')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses('order-type'),
            label: context.t('Order Type'),
            text: context.t('Limit (Fill or Kill)')
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            label: isBuySide ? context.t('{product} to Buy', { product: product }) : context.t('{product} to Sell', { product: product }),
            text: context.t('' + quantity)
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            label: context.t('Total Transaction Cost'),
            text: context.t(selectedInstrument.Product2Symbol + ' ' + price)
          }),
          displayPricePerUnit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            label: context.t('Price Per Unit'),
            text: pricePerUnit
          }),
          !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
              customClass: bemClasses(),
              label: context.t('Fee'),
              text: context.t('' + Object(__WEBPACK_IMPORTED_MODULE_7__helpers_orderHelper_js__["c" /* getOrderFee */])(buySellForm, positions))
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
              customClass: bemClasses(),
              label: context.t('Final Quantity'),
              text: (isBuySide ? selectedInstrument.Product1Symbol : selectedInstrument.Product2Symbol) + ' ' + finalQuantity
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            label: context.t('Date'),
            text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["c" /* formatDateTime */])(new Date())
          })
        )
      );
    }
  }]);

  return BuySellConfirmationModalComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BuySellConfirmationModalComponent.defaultProps = {
  displayPricePerUnit: false
};

BuySellConfirmationModalComponent.propTypes = {
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  buySellForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  confirmReport: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  positions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired]),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired]),
  finalQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  displayPricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  pricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

BuySellConfirmationModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellConfirmationModalComponent);

var getConfirmButtonText = function getConfirmButtonText(isBuySide, responseMessage) {
  // context.t('OK')
  if (responseMessage) {
    return 'OK';
  }

  // context.t('Confirm Buy Order')
  // context.t('Confirm Sell Order')
  return isBuySide ? 'Confirm Buy Order' : 'Confirm Sell Order';
};

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellTabsComponent__ = __webpack_require__(2042);







var mapStateToProps = function mapStateToProps(state) {
  return {
    isBuySide: Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state)
  };
};

var mapDispatchToProps = {
  setBuyValue: function setBuyValue() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('buySell', 'side', __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]);
  },
  setSellValue: function setSellValue() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('buySell', 'side', __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */]);
  },
  clearForm: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["c" /* clearBuySellForm */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__BuySellTabsComponent__["a" /* default */]));

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APIcon__ = __webpack_require__(13);




var BuySellTabsComponent = function BuySellTabsComponent(props, context) {
  var baseClasses = props.baseClasses,
      clearForm = props.clearForm,
      setBuyValue = props.setBuyValue,
      setSellValue = props.setSellValue,
      isBuySide = props.isBuySide,
      themeModifier = props.themeModifier;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('tab-wrapper') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: baseClasses('tab', {
          'buy-selected': isBuySide
        }),
        onClick: function onClick() {
          clearForm();
          setBuyValue();
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIcon__["a" /* default */], {
        name: 'buy',
        classModifiers: 'big',
        customClass: baseClasses('icon')
      }),
      context.t('Buy')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: baseClasses('vertical-divider', themeModifier) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: baseClasses('tab', {
          'sell-selected': !isBuySide
        }),
        onClick: function onClick() {
          clearForm();
          setSellValue();
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIcon__["a" /* default */], {
        name: 'sell',
        classModifiers: 'big',
        customClass: baseClasses('icon')
      }),
      context.t('Sell')
    )
  );
};

BuySellTabsComponent.propTypes = {
  baseClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setBuyValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSellValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  clearForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  themeModifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

BuySellTabsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellTabsComponent);

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BuySellInstrumentSelector__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_buySellActions__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_marginSelectors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);








var mapStateToProps = function mapStateToProps(state) {
  var dealPrices = __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].RetailBuySell.dealPrices;


  var isBuySide = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state);
  // context.t('Choose a Crypto to Buy');
  // context.t('Choose a Crypto to Sell');
  var label = isBuySide ? 'Choose a Crypto to Buy' : 'Choose a Crypto to Sell';

  var instruments = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__["c" /* instrumentsWithProductFullNamesAndProductSymbols */])(state);

  var isMarginActive = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_marginSelectors__["c" /* isMarginActiveSelector */])(state);
  if (!isMarginActive) {
    var filteredInstruments = instruments.filter(function (instrument) {
      return dealPrices.hasOwnProperty(instrument.Symbol);
    });

    if (filteredInstruments.length) instruments = filteredInstruments;
  }

  return {
    instruments: instruments,
    selectedInstrument: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
    label: label
  };
};

var mapDispatchToProps = {
  onInstrumentSelect: __WEBPACK_IMPORTED_MODULE_3__redux_actions_buySellActions__["a" /* onInstrumentSelect */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BuySellInstrumentSelector__["a" /* default */]));

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect__ = __webpack_require__(43);




var BuySellInstrumentSelector = function BuySellInstrumentSelector(_ref, context) {
  var label = _ref.label,
      baseClasses = _ref.baseClasses,
      instruments = _ref.instruments,
      selectedInstrument = _ref.selectedInstrument,
      onInstrumentSelect = _ref.onInstrumentSelect;

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var preSelectedInstrument = instruments.find(function (i) {
      return i.InstrumentId === selectedInstrument.InstrumentId;
    });

    if (preSelectedInstrument || !instruments.length) return;

    var instrumentId = instruments[0].InstrumentId;
    onInstrumentSelect(instrumentId);
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('crypto-container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["a" /* InnerSelect */], {
      showTriangles: true,
      name: 'instrument',
      label: context.t(label),
      customClass: baseClasses(),
      onSelect: onInstrumentSelect,
      value: selectedInstrument.InstrumentId,
      options: instruments.map(function (instrument) {
        return {
          value: instrument.InstrumentId,
          label: instrument.Product1FullName + ' / ' + instrument.Product2FullName
        };
      })
    })
  );
};

BuySellInstrumentSelector.propTypes = {
  baseClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onInstrumentSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

BuySellInstrumentSelector.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellInstrumentSelector);

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BuySellOrderButtonComponent__ = __webpack_require__(2046);









var mapStateToProps = function mapStateToProps(state) {
  var isBuySide = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state);

  var disabled = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["i" /* tradingDisabledSelector */])(state);
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var product1 = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__["c" /* getProductByIdSelector */])(state, selectedInstrument.Product1);
  var product2 = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_productPositionSelectors__["c" /* getProductByIdSelector */])(state, selectedInstrument.Product2);
  var product1Name = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_productHelper__["c" /* getProductFullName */])(product1);
  var product2Name = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_productHelper__["c" /* getProductFullName */])(product2);

  return {
    disabled: disabled,
    isBuySide: isBuySide,
    VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_2__VerificationRequired_VerificationRequiredContainer__["a" /* default */],
    product1Name: product1Name,
    product2Name: product2Name
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_6__BuySellOrderButtonComponent__["a" /* default */]));

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__ = __webpack_require__(55);





var BuySellOrderButtonComponent = function BuySellOrderButtonComponent(props, context) {
  var baseClasses = props.baseClasses,
      handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      disabled = props.disabled,
      isBuySide = props.isBuySide,
      VerificationRequiredComponent = props.VerificationRequiredComponent,
      hideKYC = props.hideKYC,
      product1Name = props.product1Name,
      product2Name = props.product2Name,
      customKYCmessage = props.customKYCmessage,
      disableKYCLinkUnderReview = props.disableKYCLinkUnderReview;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('confirm-button-container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
      {
        customClass: baseClasses(),
        onClick: handleSubmit,
        styleName: isBuySide ? __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__["b" /* styleNames */].additive : __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__["b" /* styleNames */].subtractive,
        disabled: disabled },
      submitting ? context.t('Processing...') : context.t(
      // context.t('Buy {a} with {b}')
      // context.t('Sell {a} with {b}')
      (isBuySide ? 'Buy' : 'Sell') + ' {a} with {b}', {
        a: product1Name,
        b: product2Name
      })
    ),
    !hideKYC && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VerificationRequiredComponent, {
      customKYCmessage: customKYCmessage,
      disableKYCLinkUnderReview: disableKYCLinkUnderReview
    })
  );
};

BuySellOrderButtonComponent.propTypes = {
  baseClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hideKYC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customKYCmessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

BuySellOrderButtonComponent.defaultProps = {
  disableKYCLinkUnderReview: false
};

BuySellOrderButtonComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellOrderButtonComponent);

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellPresetValuesRowsContainer__ = __webpack_require__(2048);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellPresetValuesRowsContainer__["a" /* default */]);

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellPresetValuesRowsComponent__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);








var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;

  var formObj = form.buySell || { values: {} };
  var dealValues = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["c" /* getPriceDataForPresetValuesSelector */])(state, formObj.values.side);
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var presetValues = dealValues.map(function (deal) {
    return {
      key: deal.price,
      amountRadio: deal.price.toString(),
      value1: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(selectedInstrument.Product2Symbol, deal.price),
      value2: deal.quantity
    };
  });

  return {
    isBuySide: Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state),
    dealValues: presetValues
  };
};

var mapDispatchToProps = {
  setAmount: function setAmount(amount) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('buySell', 'amountRadio', amount);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__BuySellPresetValuesRowsComponent__["a" /* default */]));

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__ = __webpack_require__(200);




var BuySellAmountRow = function BuySellAmountRow(props) {
  var baseClasses = props.baseClasses,
      onClick = props.onClick,
      isActive = props.isActive,
      amountRadio = props.amountRadio,
      value1 = props.value1,
      value2 = props.value2,
      isBuySide = props.isBuySide,
      invertArrows = props.invertArrows;


  var arrow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    { className: baseClasses('arrow') },
    isBuySide && !invertArrows || !isBuySide && invertArrows ? '→' : '←'
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: baseClasses('amount-row', isActive && 'active'),
      onClick: onClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('first-in-row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__["a" /* default */], { name: 'amountRadio', id: amountRadio, value: amountRadio })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      value1 ? value1 : '-'
    ),
    arrow,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('last-in-row') },
      value2 ? value2 : '-'
    )
  );
};

BuySellAmountRow.propTypes = {
  baseClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  amountRadio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  value2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

BuySellAmountRow.defaultProps = {
  isActive: false
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellAmountRow);

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellCustomRowContainer__ = __webpack_require__(2051);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellCustomRowContainer__["a" /* default */]);

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BuySellCustomRowComponent__ = __webpack_require__(2052);








var selector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('buySell');

var mapStateToProps = function mapStateToProps(state) {
  return {
    isBuySide: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state),
    activeAmount: selector(state, 'amountRadio'),
    formObj: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(state, 'form.buySell', { values: {} }),
    selectedInstrument: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state)
  };
};

var mapDispatchToProps = {
  setAmount: function setAmount(amount) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('buySell', 'amountRadio', amount);
  },
  synchronizeQuantityWithPrice: __WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__["l" /* synchronizeQuantityWithPrice */],
  synchronizePriceWithQuantity: __WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__["k" /* synchronizePriceWithQuantity */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__BuySellCustomRowComponent__["a" /* default */]));

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var BuySellCustomRowComponent = function (_React$Component) {
  _inherits(BuySellCustomRowComponent, _React$Component);

  function BuySellCustomRowComponent() {
    _classCallCheck(this, BuySellCustomRowComponent);

    return _possibleConstructorReturn(this, (BuySellCustomRowComponent.__proto__ || Object.getPrototypeOf(BuySellCustomRowComponent)).apply(this, arguments));
  }

  _createClass(BuySellCustomRowComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          synchronizeQuantityWithPrice = _props.synchronizeQuantityWithPrice,
          synchronizePriceWithQuantity = _props.synchronizePriceWithQuantity,
          setAmount = _props.setAmount,
          activeAmount = _props.activeAmount,
          themeModifier = _props.themeModifier,
          formObj = _props.formObj,
          isBuySide = _props.isBuySide,
          baseClasses = _props.baseClasses,
          selectedInstrument = _props.selectedInstrument;


      var arrow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: baseClasses('arrow') },
        isBuySide ? '→' : '←'
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: baseClasses('amount-row', 'two-inputs-layout'),
          onClick: function onClick() {
            return setAmount('custom');
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('first-in-row') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__["a" /* default */], { name: 'amountRadio', id: 'custom', value: 'custom' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
            name: 'price',
            customClass: baseClasses(),
            classModifiers: (activeAmount === 'custom' ? 'active' : 'disable') + ' ' + themeModifier,
            step: selectedInstrument.PriceIncrement,
            decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_4__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement),
            customChange: function customChange(value) {
              synchronizeQuantityWithPrice(value, 'buySell', 'quantity', formObj);
            }
          })
        ),
        arrow,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('last-in-row') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
            name: 'quantity',
            step: selectedInstrument.QuantityIncrement,
            customClass: baseClasses(),
            classModifiers: (activeAmount === 'custom' ? 'active' : 'disable') + ' ' + themeModifier,
            decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_4__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.QuantityIncrement),
            customChange: function customChange(value) {
              synchronizePriceWithQuantity(value, 'buySell', 'price', formObj);
            }
          })
        )
      );
    }
  }]);

  return BuySellCustomRowComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BuySellCustomRowComponent.propTypes = {
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  formObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  synchronizeQuantityWithPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  synchronizePriceWithQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  themeModifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellCustomRowComponent);

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EotcBuySellComponent__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySell_BuySellLayoutTypes__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_buySellSelectors__ = __webpack_require__(44);









var BuySellComponentForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'buySell',
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].EOTC_SUBMIT_ORDER));
  },
  destroyOnUnmount: false
})(__WEBPACK_IMPORTED_MODULE_2__EotcBuySellComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state) {
  var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_buySellSelectors__["a" /* getOrderFormInfoSelector */])(state);
  var totalQuantity = selectedValue.quantity ? selectedValue.quantity : 0;
  var displayExtraInfoComponent = totalQuantity > 0;

  return {
    initialValues: {
      side: __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */],
      amountRadio: 'custom',
      price: '',
      quantity: '',
      fee: '0',
      orderType: __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].RetailBuySell.orderType || __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName,
      responseMessage: '',
      layoutType: __WEBPACK_IMPORTED_MODULE_5__BuySell_BuySellLayoutTypes__["a" /* BUY_SELL_LAYOUTS */].PRICE_PER_UNIT
    },
    displayExtraInfoComponent: displayExtraInfoComponent,
    invertArrows: true
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(BuySellComponentForm));

/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EotcBuySellOrderConfirmationModal__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySell_BuySellTabs__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySell_BuySellInstrumentSelector__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BuySell_BuySellOrderButton__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EotcBuySellCustomRow__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EotcBuySellPresetValuesRows__ = __webpack_require__(2062);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell');

var EotcBuySell = function (_React$Component) {
  _inherits(EotcBuySell, _React$Component);

  function EotcBuySell() {
    _classCallCheck(this, EotcBuySell);

    return _possibleConstructorReturn(this, (EotcBuySell.__proto__ || Object.getPrototypeOf(EotcBuySell)).apply(this, arguments));
  }

  _createClass(EotcBuySell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          extraInfoComponent = _props.extraInfoComponent,
          displayInstrumentSelector = _props.displayInstrumentSelector,
          themeModifier = _props.themeModifier,
          formHeader = _props.formHeader,
          hideKYC = _props.hideKYC,
          customKYCmessage = _props.customKYCmessage,
          displayExtraInfoComponent = _props.displayExtraInfoComponent;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          className: baseClasses('container', themeModifier),
          onSubmit: handleSubmit },
        formHeader && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('form-header', themeModifier) },
          formHeader
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BuySell_BuySellTabs__["a" /* default */], {
          baseClasses: baseClasses,
          themeModifier: themeModifier
        }),
        displayInstrumentSelector && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BuySell_BuySellInstrumentSelector__["a" /* default */], { baseClasses: baseClasses }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('amount-header', themeModifier) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Amount'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Price'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('amount-container', themeModifier) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__EotcBuySellPresetValuesRows__["a" /* default */], { baseClasses: baseClasses }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EotcBuySellCustomRow__["a" /* default */], {
            baseClasses: baseClasses,
            themeModifier: themeModifier
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EotcBuySellOrderConfirmationModal__["a" /* default */], { displayPricePerUnit: true })
        ),
        extraInfoComponent && displayExtraInfoComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('extra-info-container', themeModifier) },
          extraInfoComponent
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BuySell_BuySellOrderButton__["a" /* default */], {
          baseClasses: baseClasses,
          handleSubmit: handleSubmit,
          submitting: submitting,
          hideKYC: hideKYC,
          disableKYCLinkUnderReview: true,
          customKYCmessage: customKYCmessage
        })
      );
    }
  }]);

  return EotcBuySell;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EotcBuySell.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  displayInstrumentSelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  extraInfoComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  themeModifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  hideKYC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  customKYCmessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

EotcBuySell.defaultProps = {
  displayInstrumentSelector: true,
  hideKYC: false
};

EotcBuySell.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (EotcBuySell);

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EotcBuySellConfirmationModalContainer__ = __webpack_require__(2056);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__EotcBuySellConfirmationModalContainer__["a" /* default */]);

/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EotcBuySellConfirmationModalComponent__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_selectors_positionSelectors__ = __webpack_require__(52);














var mapStateToProps = function mapStateToProps(state) {
  var form = state.form,
      decimalPlaces = state.apexCore.product.decimalPlaces;

  var buySellForm = form.buySell || { values: { fee: {} } };
  var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["a" /* getOrderFormInfoSelector */])(state);

  var price = selectedValue.price ? selectedValue.price : 0;
  var quantity = selectedValue.quantity ? selectedValue.quantity : '';
  var pricePerUnit = selectedValue.pricePerUnit ? selectedValue.pricePerUnit : 0;

  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var Product1Symbol = selectedInstrument.Product1Symbol,
      Product2Symbol = selectedInstrument.Product2Symbol,
      Product1 = selectedInstrument.Product1,
      Product2 = selectedInstrument.Product2;

  var isBuySide = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state);
  var finalQuantitySymbol = isBuySide ? Product1Symbol : Product2Symbol;
  var finalQuantityProduct = isBuySide ? Product1 : Product2;
  var finalQuantity = isBuySide ? quantity : price;

  if (finalQuantityProduct === buySellForm.values.fee.ProductId) {
    finalQuantity -= buySellForm.values.fee.OrderFee;
  }

  return {
    isBuySide: isBuySide,
    positions: Object(__WEBPACK_IMPORTED_MODULE_12__redux_selectors_positionSelectors__["b" /* positionSelector */])(state),
    buySellForm: buySellForm,
    selectedInstrument: selectedInstrument,
    price: price,
    quantity: quantity,
    pricePerUnit: Object(__WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper_js__["g" /* getOrderPricePerUnit */])(pricePerUnit, Product1Symbol, Product2Symbol, decimalPlaces),
    finalQuantity: Object(__WEBPACK_IMPORTED_MODULE_9__helpers_numberFormatter__["i" /* truncateToDecimals */])(finalQuantity, decimalPlaces[finalQuantitySymbol]),
    hideFees: !!__WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].global.hideFees,
    displayPricePerUnit: __WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].RetailBuySell.pricePerUnit
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    confirmReport: function confirmReport(form) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_orderEntryActions__["e" /* placeOrder */])(__WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].buySell, form)).then(function (res) {
        if (res.result === false) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_snackbarActions__["e" /* showSnack */])({
            id: 'confirmBuySellFail',
            text: res.errormsg || res.detail,
            type: 'warning'
          }));
        }
      });
    },
    onClose: function onClose() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_orderEntryActions__["c" /* clearBuySellForm */])());
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__EotcBuySellConfirmationModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["b" /* MODAL_TYPES */].EOTC_SUBMIT_ORDER
})(container));

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_orderHelper_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EotcBuySellConfirmationModalComponent_css__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EotcBuySellConfirmationModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__EotcBuySellConfirmationModalComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell-order-confirmation');

var EotcBuySellConfirmationModalComponent = function (_React$Component) {
  _inherits(EotcBuySellConfirmationModalComponent, _React$Component);

  function EotcBuySellConfirmationModalComponent(props) {
    _classCallCheck(this, EotcBuySellConfirmationModalComponent);

    var _this = _possibleConstructorReturn(this, (EotcBuySellConfirmationModalComponent.__proto__ || Object.getPrototypeOf(EotcBuySellConfirmationModalComponent)).call(this, props));

    _this.placeOrder = function () {
      var _this$props = _this.props,
          confirmReport = _this$props.confirmReport,
          buySellForm = _this$props.buySellForm;

      _this.setState({ submitting: true });
      confirmReport(buySellForm.values).then(function (response) {
        _this.setState({ submitting: false });
      }, function (err) {});
    };

    _this.state = {
      submitting: false
    };
    return _this;
  }

  _createClass(EotcBuySellConfirmationModalComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var responseMessage = this.props.buySellForm.values.responseMessage;
      var nextResponseMessage = nextProps.buySellForm.values.responseMessage;

      if (responseMessage && nextResponseMessage) {
        return false;
      }
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          buySellForm = _props.buySellForm,
          isOpen = _props.isOpen,
          _close = _props.close,
          selectedInstrument = _props.selectedInstrument,
          positions = _props.positions,
          price = _props.price,
          quantity = _props.quantity,
          finalQuantity = _props.finalQuantity,
          onClose = _props.onClose,
          hideFees = _props.hideFees,
          displayPricePerUnit = _props.displayPricePerUnit,
          pricePerUnit = _props.pricePerUnit;
      var context = this.context;


      var isBuySide = buySellForm.values.side === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */];
      var product = selectedInstrument.Product1Symbol;
      var responseMessage = buySellForm.values.responseMessage;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
        {
          isOpen: isOpen,
          title: context.t('' + (isBuySide ? 'Buy ' + selectedInstrument.Product1Symbol : 'Sell ' + selectedInstrument.Product1Symbol)),
          close: function close() {
            _close();
            onClose();
          },
          footer: {
            buttonText: context.t(getConfirmButtonText(isBuySide, responseMessage)),
            disabled: this.state.submitting,
            onClick: responseMessage ? function () {
              _close();
              onClose();
            } : this.placeOrder,
            overrideClose: true
          },
          customClass: bemClasses('modal') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: bemClasses('header') },
            responseMessage || context.t('Confirmation')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses('order-type'),
            label: context.t('Order Type'),
            text: context.t('Limit (Fill or Kill)')
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            label: isBuySide ? context.t('{product} to Buy', { product: product }) : context.t('{product} to Sell', { product: product }),
            text: context.t('' + quantity)
          }),
          displayPricePerUnit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            label: context.t('Price Per Unit'),
            text: pricePerUnit
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            label: context.t('Total Transaction Cost'),
            text: context.t(selectedInstrument.Product2Symbol + ' ' + price)
          }),
          !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
              customClass: bemClasses(),
              label: context.t('Fee'),
              text: context.t('' + Object(__WEBPACK_IMPORTED_MODULE_7__helpers_orderHelper_js__["c" /* getOrderFee */])(buySellForm, positions))
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
              customClass: bemClasses(),
              label: context.t('Final Quantity'),
              text: (isBuySide ? selectedInstrument.Product1Symbol : selectedInstrument.Product2Symbol) + ' ' + finalQuantity
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            customClass: bemClasses(),
            label: context.t('Date'),
            text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["c" /* formatDateTime */])(new Date())
          })
        )
      );
    }
  }]);

  return EotcBuySellConfirmationModalComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EotcBuySellConfirmationModalComponent.defaultProps = {
  displayPricePerUnit: false
};

EotcBuySellConfirmationModalComponent.propTypes = {
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  buySellForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  confirmReport: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  positions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired]),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired]),
  finalQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  displayPricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  pricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

EotcBuySellConfirmationModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (EotcBuySellConfirmationModalComponent);

var getConfirmButtonText = function getConfirmButtonText(isBuySide, responseMessage) {
  // context.t('OK')
  if (responseMessage) {
    return 'OK';
  }

  // context.t('Confirm Buy Order')
  // context.t('Confirm Sell Order')
  return isBuySide ? 'Confirm Buy Order' : 'Confirm Sell Order';
};

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EotcBuySellCustomRowContainer__ = __webpack_require__(2060);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__EotcBuySellCustomRowContainer__["a" /* default */]);

/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EotcBuySellCustomRowComponent__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








var selector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('buySell');

var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;

  var formObj = form.buySell || { values: {} };
  var decimalPlaces = state.apexCore.product.decimalPlaces;

  var _getQuantityDataForPr = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["e" /* getQuantityDataForPresetAndCustomValuesSelector */])(state, formObj.values.side, formObj.values.quantity),
      _getQuantityDataForPr2 = _slicedToArray(_getQuantityDataForPr, 1),
      customValues = _getQuantityDataForPr2[0];

  var isBuySide = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state);
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  return {
    isBuySide: isBuySide,
    selectedInstrument: selectedInstrument,
    decimalPlaces: decimalPlaces,
    customValues: customValues,
    formObj: formObj,
    activeAmount: selector(state, 'amountRadio')
  };
};

var mapDispatchToProps = {
  synchronizePriceWithQuantity: __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["k" /* synchronizePriceWithQuantity */],
  setAmount: function setAmount(amount) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('buySell', 'amountRadio', amount);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__EotcBuySellCustomRowComponent__["a" /* default */]));

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__ = __webpack_require__(59);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var EotcBuySellCustomRowComponent = function (_React$Component) {
  _inherits(EotcBuySellCustomRowComponent, _React$Component);

  function EotcBuySellCustomRowComponent() {
    _classCallCheck(this, EotcBuySellCustomRowComponent);

    return _possibleConstructorReturn(this, (EotcBuySellCustomRowComponent.__proto__ || Object.getPrototypeOf(EotcBuySellCustomRowComponent)).apply(this, arguments));
  }

  _createClass(EotcBuySellCustomRowComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          synchronizePriceWithQuantity = _props.synchronizePriceWithQuantity,
          setAmount = _props.setAmount,
          activeAmount = _props.activeAmount,
          isBuySide = _props.isBuySide,
          formObj = _props.formObj,
          themeModifier = _props.themeModifier,
          customValues = _props.customValues,
          decimalPlaces = _props.decimalPlaces,
          selectedInstrument = _props.selectedInstrument,
          baseClasses = _props.baseClasses;


      var arrow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: baseClasses('arrow') },
        !isBuySide ? '→' : '←'
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: baseClasses('amount-row', 'one-input-layout'),
          onClick: function onClick() {
            return setAmount('custom');
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('first-in-row') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__["a" /* default */], { name: 'amountRadio', id: 'custom', value: 'custom' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
            name: 'quantity',
            customClass: baseClasses(),
            classModifiers: (activeAmount === 'custom' ? 'active' : 'disable') + ' ' + themeModifier,
            decimalPlaces: decimalPlaces[selectedInstrument.Product1Symbol],
            customChange: function customChange(value) {
              synchronizePriceWithQuantity(value, 'buySell', 'price', formObj);
            }
          })
        ),
        arrow,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('last-in-row') },
          customValues && customValues.pricePerUnit ? customValues.pricePerUnit : '-'
        )
      );
    }
  }]);

  return EotcBuySellCustomRowComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EotcBuySellCustomRowComponent.propTypes = {
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  formObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  customValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  synchronizePriceWithQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  decimalPlaces: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  themeModifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (EotcBuySellCustomRowComponent);

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EotcBuySellPresetValuesRowsContainer_js__ = __webpack_require__(2063);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__EotcBuySellPresetValuesRowsContainer_js__["a" /* default */]);

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySell_BuySellPresetValuesRows_BuySellPresetValuesRowsComponent__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);








var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;

  var formObj = form.buySell || { values: {} };
  var dealValues = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["f" /* getQuantityDataForPresetValuesSelector */])(state, formObj.values.side);
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var presetValues = dealValues.map(function (deal, index) {
    return {
      key: deal.quantity + '-' + index,
      amountRadio: deal.quantity.toString(),
      value1: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(selectedInstrument.Product1Symbol, deal.quantity),
      value2: deal.pricePerUnit
    };
  });

  return {
    isBuySide: Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state),
    dealValues: presetValues,
    invertArrows: true
  };
};

var mapDispatchToProps = {
  setAmount: function setAmount(amount) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('buySell', 'amountRadio', amount);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__BuySell_BuySellPresetValuesRows_BuySellPresetValuesRowsComponent__["a" /* default */]));

/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellChartOverviewContainer__ = __webpack_require__(2065);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellChartOverviewContainer__["a" /* default */]);

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BuySellChartOverviewComponent__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);




var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var product1 = selectedInstrument.Product1Symbol;
  var product2 = selectedInstrument.Product2Symbol;

  return {
    product1: product1,
    product2: product2
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_1__BuySellChartOverviewComponent__["a" /* default */]));

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RetailPriceChart_RetailPriceChartContainer__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css__);







var chartOverviewClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('chart-overview');

var BuySellChartOverviewComponent = function BuySellChartOverviewComponent(props) {
  var product1 = props.product1,
      product2 = props.product2;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: chartOverviewClasses('chart-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: chartOverviewClasses('instrument-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: chartOverviewClasses('instrument-container-text') },
          product1,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: chartOverviewClasses('icon-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'arrowNext' })
          ),
          product2
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RetailPriceChart_RetailPriceChartContainer__["a" /* default */], { customClass: 'chart-overview' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: chartOverviewClasses('instrument-table') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__["a" /* default */], { customClass: 'chart-overview-instrument' })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellChartOverviewComponent);

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_chart_react__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_chart_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_apex_chart_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_chart_react_lib_chart_style_css__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_chart_react_lib_chart_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_apex_chart_react_lib_chart_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssVarHelper__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_components_TradeComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RetailPriceChart_css__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RetailPriceChart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__RetailPriceChart_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var tradeComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-component');

var RetailPriceChartComponent = function (_React$Component) {
  _inherits(RetailPriceChartComponent, _React$Component);

  function RetailPriceChartComponent() {
    _classCallCheck(this, RetailPriceChartComponent);

    return _possibleConstructorReturn(this, (RetailPriceChartComponent.__proto__ || Object.getPrototypeOf(RetailPriceChartComponent)).apply(this, arguments));
  }

  _createClass(RetailPriceChartComponent, [{
    key: 'renderChart',
    value: function renderChart() {
      var _props = this.props,
          locale = _props.locale,
          changeTickersInterval = _props.changeTickersInterval,
          chartData = _props.chartData;


      this.chartDataSubject = new __WEBPACK_IMPORTED_MODULE_3_rxjs__["BehaviorSubject"](chartData);

      var chartConfig = {
        chartDataSubject: this.chartDataSubject,
        changeTickersInterval: changeTickersInterval,
        currency_character: '',
        locale: locale,
        time_intervals: this.getTimeIntervalsConfig(),
        price_history: this.getPriceHistoryConfig(),
        defaults: this.getDefaultConfig(),
        date_format_months: [this.context.t('Jan', {}, 'January'), this.context.t('Feb', {}, 'February'), this.context.t('Mar', {}, 'March'), this.context.t('Apr', {}, 'April'), this.context.t('May', {}, 'May (the month)'), this.context.t('Jun', {}, 'June'), this.context.t('Jul', {}, 'July'), this.context.t('Aug', {}, 'August'), this.context.t('Sep', {}, 'September'), this.context.t('Oct', {}, 'October'), this.context.t('Nov', {}, 'November'), this.context.t('Dec', {}, 'December')]
      };
      this.chart = new __WEBPACK_IMPORTED_MODULE_2_apex_chart_react___default.a('apex-chart-retail', chartConfig);
      this.chart.DrawChart();
    }
  }, {
    key: 'getTimeIntervalsConfig',
    value: function getTimeIntervalsConfig() {
      return [{
        label: '5m',
        seconds: 300
      }, {
        label: '15m',
        seconds: 900
      }, {
        label: '30m',
        seconds: 1800
      }, {
        label: '1h',
        seconds: 3600
      }, {
        label: '1d',
        seconds: 86400
      }];
    }
  }, {
    key: 'getPriceHistoryConfig',
    value: function getPriceHistoryConfig() {
      return {
        font_size: 10,
        font_face: this.cssVariable('--font__typeface'),
        border_primary_color: this.cssVariable('--chart__border-color-primary'),
        border_secondary_color: this.cssVariable('--table__row-separator-color'),
        background_color: this.cssVariable('--secondary__bg-color'),
        bullish_color: this.cssVariable('--chart__bullish-color'),
        bearish_color: this.cssVariable('--chart__bearish-color'),
        price_line_color: this.cssVariable('--chart__retail-price-line-color'),
        sma_line_color: 'transparent',
        ema_line_color: 'transparent',
        bollinger_band_upper_line_color: this.cssVariable('--chart__bollinger-band-upper-color'),
        bollinger_band_lower_line_color: this.cssVariable('--chart__bollinger-band-lower-color'),
        market_price_line_color: this.cssVariable('--chart__market-price-line-color'),
        market_price_label_color: this.cssVariable('--chart__market-price-label-color'),
        market_price_background_color: this.cssVariable('--chart__market-price-bg-color'),
        x_label_color: this.cssVariable('--font__color-secondary'),
        y_label_color: this.cssVariable('--font__color-secondary'),
        info_height: 10,
        info_precision: this.props.precision,
        y_label_width: 90,
        y_label_precision: this.props.precision,
        x_label_height: 30,
        x_label_precision: this.props.precision,
        info_labels: [this.context.t('Price'), this.context.t('Open'), this.context.t('Close'), this.context.t('High'), this.context.t('Low'), this.context.t('Volume')],
        use_grid_lines: true,
        grid_lines_dashed: true,
        grid_lines_color: this.cssVariable('--table__row-separator-color'),
        use_gradient: true,
        first_gradient_color: this.cssVariable('--chart__gradient-color-start'),
        second_gradient_color: this.cssVariable('--chart__gradient-color-end')
      };
    }
  }, {
    key: 'getDefaultConfig',
    value: function getDefaultConfig() {
      return {
        font_size: 12,
        font_face: this.cssVariable('--font__typeface'),
        history_item_width: 20,
        history_item_margin: 0,
        history_interval: 86400,
        draw_simple_moving_average: true,
        draw_exponential_moving_average: false,
        draw_bollinger_bands: false,
        chart_type: 'line',
        order_book_depth_count: 20
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.cssVariable = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssVarHelper__["a" /* getCSSVar */])();
      this.renderChart();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.chartData !== this.props.chartData) {
        this.chartDataSubject.next(this.props.chartData);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.chart) {
        this.chart.DestroyChart();
        this.chart = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var priceChartComponentClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['retail-price-chart', this.props.customClass]);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: tradeComponentClasses() + ' ' + priceChartComponentClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          id: 'apex-chart-retail',
          className: '' + priceChartComponentClasses('chart')
        })
      );
    }
  }]);

  return RetailPriceChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RetailPriceChartComponent.propTypes = {
  precision: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

RetailPriceChartComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RetailPriceChartComponent);

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellChartOverviewContainer__ = __webpack_require__(2071);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellChartOverviewContainer__["a" /* default */]);

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellChartOverviewComponent__ = __webpack_require__(2072);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellChartOverviewComponent__["a" /* default */]);

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RetailPriceChart_RetailPriceChartContainer__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuySellChartIntervalSelector__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css__ = __webpack_require__(2076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InstrumentTable_InstrumentTableItems__ = __webpack_require__(665);








var chartOverviewClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('chart-overview');

var BuySellChartOverviewComponent = function BuySellChartOverviewComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: chartOverviewClasses('chart-container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: chartOverviewClasses('title-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: chartOverviewClasses('title') },
        'Price Chart'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BuySellChartIntervalSelector__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: chartOverviewClasses('instruments-bar-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__["a" /* default */], {
        customClass: 'chart-overview-alt-layout-top',
        items: [{ field: __WEBPACK_IMPORTED_MODULE_6__InstrumentTable_InstrumentTableItems__["a" /* default */].lastPrice }, { field: __WEBPACK_IMPORTED_MODULE_6__InstrumentTable_InstrumentTableItems__["a" /* default */].dailyPercentageChange }, { field: __WEBPACK_IMPORTED_MODULE_6__InstrumentTable_InstrumentTableItems__["a" /* default */].dailyVolume }]
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: chartOverviewClasses('chart-overview-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RetailPriceChart_RetailPriceChartContainer__["a" /* default */], { customClass: 'chart-overview-alt-layout' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: chartOverviewClasses('instruments-bar-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__["a" /* default */], {
        customClass: 'chart-overview-alt-layout-bottom',
        items: [{ field: __WEBPACK_IMPORTED_MODULE_6__InstrumentTable_InstrumentTableItems__["a" /* default */].bid }, { field: __WEBPACK_IMPORTED_MODULE_6__InstrumentTable_InstrumentTableItems__["a" /* default */].ask }, { field: __WEBPACK_IMPORTED_MODULE_6__InstrumentTable_InstrumentTableItems__["a" /* default */].dailyMax }, { field: __WEBPACK_IMPORTED_MODULE_6__InstrumentTable_InstrumentTableItems__["a" /* default */].dailyMin }]
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellChartOverviewComponent);

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BuySellChartIntervalSelectorComponent__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__ = __webpack_require__(99);




var mapStateToProps = function mapStateToProps(state) {
  return {
    currentInterval: state.tickers.interval
  };
};

var mapDispatchToProps = {
  changeTickersInterval: __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__["e" /* changeTickersInterval */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BuySellChartIntervalSelectorComponent__["a" /* default */]));

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellChartIntervalSelectorComponent_css__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellChartIntervalSelectorComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BuySellChartIntervalSelectorComponent_css__);






var classes = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('chart-interval-selector');

var BuySellChartIntervalSelectorComponent = function BuySellChartIntervalSelectorComponent(props) {
  var timeIntervals = [{
    label: '1H',
    seconds: 3600
  }, {
    label: '1D',
    seconds: 86400
  }, {
    label: '1W',
    seconds: 604800
  }, {
    label: '1M',
    seconds: 2678400
  }, {
    label: '1Y',
    seconds: 31536000
  }, {
    label: 'All',
    seconds: null
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes() },
    timeIntervals.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('item'), key: item.label },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
          {
            baseClass: classes('item'),
            customClass: item.seconds === props.currentInterval ? 'selected' : null,
            onClick: function onClick() {
              return props.changeTickersInterval(item.seconds);
            } },
          item.label
        )
      );
    })
  );
};

BuySellChartIntervalSelectorComponent.propTypes = {
  currentInterval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  changeTickersInterval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellChartIntervalSelectorComponent);

/***/ }),
/* 2075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellMakeTransactionContainer__ = __webpack_require__(2078);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellMakeTransactionContainer__["a" /* default */]);

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellMakeTransactionComponent__ = __webpack_require__(2079);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellMakeTransactionComponent__["a" /* default */]);

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuySellMakeTransactionComponent_css__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuySellMakeTransactionComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BuySellMakeTransactionComponent_css__);






var classes = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell-make-transaction');

var BuySellMakeTransaction = function BuySellMakeTransaction(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes(null, props.themeModifier) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      { className: classes('title', props.themeModifier) },
      context.t('Make a Transaction')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('content', props.themeModifier) },
      props.children
    )
  );
};

BuySellMakeTransaction.propTypes = {
  displayInstrumentSelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  extraInfoComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  themeModifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

BuySellMakeTransaction.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellMakeTransaction);

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellBalancesContainer__ = __webpack_require__(2082);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellBalancesContainer__["a" /* default */]);

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BuySellBalancesComponent__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);





var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var product1 = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["c" /* getProductByIdSelector */])(state, selectedInstrument.Product1);
  var product2 = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_productPositionSelectors__["c" /* getProductByIdSelector */])(state, selectedInstrument.Product2);

  return {
    product1: product1,
    product2: product2
  };
};

var mapDispatchToProps = {};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BuySellBalancesComponent__["a" /* default */]));

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellBalancesComponent_css__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellBalancesComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BuySellBalancesComponent_css__);








var classes = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell-balances');

var BuySellBalancesComponent = function BuySellBalancesComponent(props, context) {
  var product1 = props.product1,
      product2 = props.product2,
      customClass = props.customClass;

  var product1Label = (customClass === 'compacted' && product1.ProductSymbol ? product1.ProductSymbol : '') + ' ' + product1.ProductFullName + ':';
  var product2Label = (customClass === 'compacted' && product2.ProductSymbol ? product2.ProductSymbol : '') + ' ' + product2.ProductFullName + ':';
  var product1Text = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(product1.ProductSymbol, product1.AvailableBalance, true);
  var product2Text = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(product2.ProductSymbol, product2.AvailableBalance, true);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: (customClass || '') + ' ' + classes() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: (customClass || '') + ' ' + classes('content') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        customClass: (customClass || '') + ' ' + classes(),
        label: product1Label,
        text: product1Text
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        customClass: (customClass || '') + ' ' + classes(),
        label: product2Label,
        text: product2Text
      })
    )
  );
};

BuySellBalancesComponent.propTypes = {
  product1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  product2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

BuySellBalancesComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellBalancesComponent);

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellOrderOverviewContainer__ = __webpack_require__(2086);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellOrderOverviewContainer__["a" /* default */]);

/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BuySellOrderOverviewComponent__ = __webpack_require__(2087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_orderHelper_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);










var mapStateToProps = function mapStateToProps(state) {
  var buySellForm = state.form.buySell || { values: { fee: {} } };
  var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["a" /* getOrderFormInfoSelector */])(state);
  var isBuySide = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state);

  var _selectedInstrumentSe = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
      Product1Symbol = _selectedInstrumentSe.Product1Symbol,
      Product2Symbol = _selectedInstrumentSe.Product2Symbol,
      QuantityIncrement = _selectedInstrumentSe.QuantityIncrement,
      PriceIncrement = _selectedInstrumentSe.PriceIncrement;

  var quantity = selectedValue.quantity || 0;
  var transactionCost = selectedValue.price || 0;
  var limitPrice = selectedValue.limitPrice || 0;
  var pricePerUnit = selectedValue.pricePerUnit ? selectedValue.pricePerUnit : 0;

  return {
    symbol1: Product1Symbol,
    symbol2: Product2Symbol,
    isBuySide: isBuySide,
    fee: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_orderHelper_js__["c" /* getOrderFee */])(buySellForm, Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_positionSelectors__["b" /* positionSelector */])(state), 'end'),
    price: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(limitPrice, Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement)),
    tradingDisabled: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["i" /* tradingDisabledSelector */])(state),
    transactionCost: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(transactionCost, Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement)),
    quantity: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(quantity.toString(), Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(QuantityIncrement)),
    pricePerUnit: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_orderHelper_js__["g" /* getOrderPricePerUnit */])(pricePerUnit, Product1Symbol, Object(__WEBPACK_IMPORTED_MODULE_8__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement)),
    hideFees: !!__WEBPACK_IMPORTED_MODULE_7__config__["b" /* default */].global.hideFees
  };
};

var BuySellOrderOverviewContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__BuySellOrderOverviewComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BuySellOrderOverviewContainer);

/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellOrderOverviewComponent_css__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellOrderOverviewComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BuySellOrderOverviewComponent_css__);







var classes = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell-order-overview');

var BuySellOrderOverviewComponent = function BuySellOrderOverviewComponent(props, context) {
  var symbol1 = props.symbol1,
      symbol2 = props.symbol2,
      price = props.price,
      transactionCost = props.transactionCost,
      tradingDisabled = props.tradingDisabled,
      quantity = props.quantity,
      pricePerUnit = props.pricePerUnit,
      isBuySide = props.isBuySide,
      fee = props.fee,
      hideFees = props.hideFees,
      displayPricePerUnit = props.displayPricePerUnit,
      customClass = props.customClass;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: (customClass || '') + ' ' + classes() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { className: (customClass || '') + ' ' + classes('title') },
      context.t('Transaction Overview')
    ),
    tradingDisabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('content') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: classes('content') },
        context.t('We cannot fill this request.')
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('content') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        customClass: (customClass || '') + ' ' + classes(),
        label: context.t('Price'),
        text: context.t('{price} per {symbol1}', { price: price, symbol1: symbol1 })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        customClass: (customClass || '') + ' ' + classes(),
        label: context.t('Transaction Cost'),
        text: transactionCost + ' ' + symbol2
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        customClass: (customClass || '') + ' ' + classes(),
        label: isBuySide ? context.t('{symbol1} to Buy', { symbol1: symbol1 }) : context.t('{symbol1} to Sell', { symbol1: symbol1 }),
        text: quantity
      }),
      !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        name: 'fee',
        customClass: customClass + ' ' + classes(),
        label: context.t('Fee'),
        text: fee
      }),
      displayPricePerUnit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        name: 'pricePerUnit',
        customClass: (customClass || '') + ' ' + classes(),
        label: context.t('Price per unit'),
        text: context.t(pricePerUnit)
      })
    )
  );
};

BuySellOrderOverviewComponent.defaultProps = {
  displayPricePerUnit: false
};

BuySellOrderOverviewComponent.propTypes = {
  symbol1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  symbol2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  transactionCost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  tradingDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  pricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  hideFees: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  displayPricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

BuySellOrderOverviewComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellOrderOverviewComponent);

/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuySellInstrumentSelectContainer__ = __webpack_require__(2089);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BuySellInstrumentSelectContainer__["a" /* default */]);

/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuySellInstrumentSelectComponent__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_instrumentActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_buySellActions__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BuySell_BuySellLayoutTypes__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);











var BuySellInstrumentSelectComponentForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'buySell',
  destroyOnUnmount: false
})(__WEBPACK_IMPORTED_MODULE_2__BuySellInstrumentSelectComponent__["a" /* default */]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var dealPrices = __WEBPACK_IMPORTED_MODULE_9__config__["b" /* default */].RetailBuySell.dealPrices;

  var instruments = Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_instrumentPositionSelectors__["c" /* instrumentsWithProductFullNamesAndProductSymbols */])(state).filter(function (instrument) {
    return dealPrices.hasOwnProperty(instrument.Symbol);
  });

  var layoutType = ownProps.displayPricePerUnit ? __WEBPACK_IMPORTED_MODULE_8__BuySell_BuySellLayoutTypes__["a" /* BUY_SELL_LAYOUTS */].PRICE_PER_UNIT : __WEBPACK_IMPORTED_MODULE_8__BuySell_BuySellLayoutTypes__["a" /* BUY_SELL_LAYOUTS */].AMOUNT_FOR_PRICE;

  return {
    instruments: instruments,
    selectedInstrument: selectedInstrument,
    initialValues: {
      side: __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */],
      amountRadio: 'custom',
      price: '',
      quantity: '',
      fee: '0',
      orderType: __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].limit.displayName,
      responseMessage: '',
      layoutType: layoutType
    }
  };
};

var mapDispatchToProps = {
  selectInstrument: __WEBPACK_IMPORTED_MODULE_3__redux_actions_instrumentActions__["e" /* selectInstrument */],
  clearForm: __WEBPACK_IMPORTED_MODULE_5__redux_actions_orderEntryActions__["c" /* clearBuySellForm */],
  onInstrumentSelect: __WEBPACK_IMPORTED_MODULE_6__redux_actions_buySellActions__["a" /* onInstrumentSelect */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(BuySellInstrumentSelectComponentForm));

/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuySellInstrumentSelector__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellInstrumentSelectComponent_css__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellInstrumentSelectComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BuySellInstrumentSelectComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell-select-an-instrument');

var BuySellInstrumentSelectComponent = function (_React$Component) {
  _inherits(BuySellInstrumentSelectComponent, _React$Component);

  function BuySellInstrumentSelectComponent() {
    _classCallCheck(this, BuySellInstrumentSelectComponent);

    return _possibleConstructorReturn(this, (BuySellInstrumentSelectComponent.__proto__ || Object.getPrototypeOf(BuySellInstrumentSelectComponent)).apply(this, arguments));
  }

  _createClass(BuySellInstrumentSelectComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var selectedInstrument = this.props.instruments.find(function (instrument) {
        return instrument.InstrumentId === _this2.props.selectedInstrument.InstrumentId;
      });

      if (selectedInstrument || !this.props.instruments[0]) return;

      var instrumentId = this.props.instruments[0].InstrumentId;
      this.props.selectInstrument(instrumentId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          instruments = _props.instruments,
          selectedInstrument = _props.selectedInstrument;
      var context = this.context;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('label') },
          context.t('Select an Instrument:')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BuySellInstrumentSelector__["a" /* default */], {
            name: 'instrument',
            options: instruments.map(function (instrument) {
              return {
                label: instrument.Product1FullName + ' / ' + instrument.Product2FullName,
                onClick: function onClick() {
                  return _this3.props.onInstrumentSelect(instrument.InstrumentId);
                }
              };
            }),
            instrumentsSymbols: selectedInstrument.Symbol,
            selectedInstrument: selectedInstrument.Product1FullName + ' / ' + selectedInstrument.Product2FullName,
            bemClasses: baseClasses
          })
        )
      );
    }
  }]);

  return BuySellInstrumentSelectComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BuySellInstrumentSelectComponent.propTypes = {
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  clearForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onInstrumentSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

BuySellInstrumentSelectComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellInstrumentSelectComponent);

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_PopoverMenu_PopoverMenu__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);





var InnerInstumentSelector = function InnerInstumentSelector(props) {
  var bemClasses = props.bemClasses,
      instrumentsSymbols = props.instrumentsSymbols,
      selectedInstrument = props.selectedInstrument;


  var options = props.options || [];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_PopoverMenu_PopoverMenu__["a" /* default */], {
    customClass: bemClasses('instrument-selector'),
    popoverProps: {
      trigger: function trigger(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          Object.assign({ className: bemClasses('instrument-container') }, props),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('symbols-wrapper') },
            instrumentsSymbols
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('instruments-name') },
            selectedInstrument
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('triangles-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'triangle-up' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'triangle-down' })
          )
        );
      },
      customClass: 'instrument-selector'
    },
    items: options
  });
};

var RetailInstumentSelector = function RetailInstumentSelector(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: InnerInstumentSelector }, props));
};

RetailInstumentSelector.defaultProps = {
  name: '',
  instrumentsSymbols: ''
};

RetailInstumentSelector.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  instrumentsSymbols: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  bemClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (RetailInstumentSelector);

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EotcBuySellChartOverviewComponent__ = __webpack_require__(2095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);




var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var product1 = selectedInstrument.Product1Symbol;
  var product2 = selectedInstrument.Product2Symbol;

  return {
    product1: product1,
    product2: product2
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_1__EotcBuySellChartOverviewComponent__["a" /* default */]));

/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EotcPriceChart_EotcPriceChartContainer__ = __webpack_require__(2096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BuySellChartOverviewComponent_css__);







var chartOverviewClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('chart-overview');

var BuySellChartOverviewComponent = function BuySellChartOverviewComponent(props) {
  var product1 = props.product1,
      product2 = props.product2;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: chartOverviewClasses('chart-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: chartOverviewClasses('instrument-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: chartOverviewClasses('instrument-container-text') },
          product1,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: chartOverviewClasses('icon-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'arrowNext' })
          ),
          product2
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__EotcPriceChart_EotcPriceChartContainer__["a" /* default */], { customClass: 'chart-overview' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: chartOverviewClasses('instrument-table') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__["a" /* default */], { customClass: 'chart-overview-instrument' })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BuySellChartOverviewComponent);

/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EotcPriceChartComponent__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_productHelper__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);








var DEFAULT_VALUE = '-';

var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var decimalPlaces = state.apexCore.product.decimalPlaces;


  var bidValue = state.eotcPrices.lastPrices[selectedInstrument.InstrumentId] ? state.eotcPrices.lastPrices[selectedInstrument.InstrumentId].Bid : 0;

  var askValue = state.eotcPrices.lastPrices[selectedInstrument.InstrumentId] ? state.eotcPrices.lastPrices[selectedInstrument.InstrumentId].Ask : 0;

  var theme = __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].global.theme;

  var localConfig = JSON.parse(localStorage.getItem('apexTemplate')) || {};

  return {
    selectedInstrument: selectedInstrument,
    decimalPlaces: decimalPlaces,
    bidValue: !selectedInstrument.Product2Symbol ? DEFAULT_VALUE : Object(__WEBPACK_IMPORTED_MODULE_4__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(selectedInstrument.Product2Symbol, Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(bidValue, selectedInstrument.Product2Symbol)),
    askValue: !selectedInstrument.Product2Symbol ? DEFAULT_VALUE : Object(__WEBPACK_IMPORTED_MODULE_4__helpers_productHelper__["b" /* getBalanceWithProductSymbol */])(selectedInstrument.Product2Symbol, Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(askValue, selectedInstrument.Product2Symbol)),
    theme: localConfig.theme || theme,
    instrumentsArray: state.apexCore.instrument.instruments
  };
};

var mapDispatchToProps = {
  changeTickersInterval: __WEBPACK_IMPORTED_MODULE_2__redux_actions_tickersActions__["e" /* changeTickersInterval */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__EotcPriceChartComponent__["a" /* default */]));

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_tradingView_EotcChartAPI__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jstimezonedetect__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jstimezonedetect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jstimezonedetect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_wsHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_cssVarHelper__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EotcPriceChart_css__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EotcPriceChart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__EotcPriceChart_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global TradingView */













var chartClasses = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['eotc-price-chart']);

/**
 * These items were either non-working or buggy within our TradingView implementation,
 *  and should stay disabled until they are fixed or reassessed.
 */

var disabledFeatures = ['header_settings', 'control_bar', 'context_menus', 'header_symbol_search', 'header_compare', 'use_localstorage_for_settings', 'save_chart_properties_to_local_storage', 'show_chart_property_page', 'header_resolutions', 'go_to_date'];

var EotcPriceChartComponent = function (_React$Component) {
  _inherits(EotcPriceChartComponent, _React$Component);

  function EotcPriceChartComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EotcPriceChartComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EotcPriceChartComponent.__proto__ || Object.getPrototypeOf(EotcPriceChartComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = { chartInitialized: false }, _this.script = function (location) {
      return new Promise(function (resolve) {
        _this.scripts[location] = document.createElement('script');
        _this.scripts[location].src = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])(location);
        _this.scripts[location].type = 'text/javascript';
        _this.scripts[location].async = true;
        _this.scripts[location].onload = resolve;
        document.body.appendChild(_this.scripts[location]);
      });
    }, _this.createChart = function (dataFeed) {
      var loading_BgColor = _this.cssVariable('--eotc-price-chart__bg-color');
      var bgColor = _this.cssVariable('--eotc-price-chart__bg-color');
      var gridColor = _this.cssVariable('--eotc-price-chart__border-color');
      var gridColorVertical = _this.cssVariable('--eotc-price-chart__border-color');
      var gridColorHorizontal = _this.cssVariable('--eotc-price-chart__border-color');
      var scaleFontColor = _this.cssVariable('--eotc-price-chart__scale-font-color');
      var scaleLineColor = _this.cssVariable('--eotc-price-chart__scale-line-color');
      var scaleBgColor = _this.cssVariable('--eotc-price-chart__bg-color');
      var graphUpColor = _this.cssVariable('--eotc-price-chart__graph-up-color');
      var graphDownColor = _this.cssVariable('--eotc-price-chart__graph-down-color');
      var graphBorderUpColor = _this.cssVariable('--tv-chart__graph-border-up-color');
      var graphBorderDownColor = _this.cssVariable('--tv-chart__graph-border-down-color');
      var graphUpOpaqueColor = 'rgba(' + _this.cssVariable('--pc__accent-additive') + ', .3)';
      var graphDownOpaqueColor = 'rgba(' + _this.cssVariable('--pc__accent-subtractive') + ', .3)';

      var custom_css_url = _this.props.theme === 'light' ? '' : '/vendor/tradingView/charting_library-dark-theme.css';
      var chartOptions = {
        symbol: _this.props.selectedInstrument.Symbol,
        datafeed: dataFeed,
        library_path: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])('/vendor/tradingView/'),
        autosize: true,
        interval: '60',
        container_id: 'trading-view-chart',
        loading_screen: { backgroundColor: loading_BgColor },
        custom_css_url: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])(custom_css_url),
        supportedResolutions: ['1S', '1', '5', '60', '1D', '1W', '1M', '12M'],
        time_frames: [{ text: '1m', resolution: '1' }, { text: '1h', resolution: '60' }, { text: '1d', resolution: '1D' }, { text: '1w', resolution: '1W' }, { text: '1mo', resolution: '1M' }, { text: '1y', resolution: '12M' }],
        overrides: {
          'paneProperties.background': bgColor,
          'paneProperties.gridProperties.color': gridColor,
          'paneProperties.vertGridProperties.color': gridColorVertical,
          'paneProperties.horzGridProperties.color': gridColorHorizontal,
          'paneProperties.topMargin': 15,
          'paneProperties.bottomMargin': 25,
          'scalesProperties.textColor': scaleFontColor,
          'scalesProperties.lineColor': scaleLineColor,
          'scalesProperties.showLeftScale': false,
          'scalesProperties.showRightScale': true,
          'scalesProperties.backgroundColor': scaleBgColor,
          volumePaneSize: 'large',
          'mainSeriesProperties.candleStyle.upColor': graphUpColor,
          'mainSeriesProperties.candleStyle.downColor': graphDownColor,
          'mainSeriesProperties.candleStyle.borderUpColor': graphDownColor,
          'mainSeriesProperties.candleStyle.borderDownColor': graphBorderDownColor,
          'mainSeriesProperties.candleStyle.drawWick': true,
          'mainSeriesProperties.hollowCandleStyle.upColor': graphUpColor,
          'mainSeriesProperties.hollowCandleStyle.downColor': bgColor,
          'mainSeriesProperties.hollowCandleStyle.borderUpColor': graphBorderUpColor,
          'mainSeriesProperties.hollowCandleStyle.borderDownColor': graphBorderDownColor,
          'mainSeriesProperties.hollowCandleStyle.drawWick': false,
          'mainSeriesProperties.haStyle.upColor': graphUpColor,
          'mainSeriesProperties.haStyle.downColor': graphDownColor,
          'mainSeriesProperties.haStyle.borderUpColor': graphBorderUpColor,
          'mainSeriesProperties.haStyle.borderDownColor': graphBorderDownColor,
          'mainSeriesProperties.haStyle.drawWick': false,
          'mainSeriesProperties.barStyle.upColor': graphUpColor,
          'mainSeriesProperties.barStyle.downColor': graphDownColor,
          'mainSeriesProperties.lineStyle.color': '#7898C7',
          'mainSeriesProperties.lineStyle.linewidth': '4',
          'mainSeriesProperties.areaStyle.color1': graphUpColor,
          'mainSeriesProperties.areaStyle.color2': graphUpOpaqueColor,
          'mainSeriesProperties.areaStyle.linecolor': graphUpColor,
          'mainSeriesProperties.baselineStyle.topFillColor1': graphUpOpaqueColor,
          'mainSeriesProperties.baselineStyle.topFillColor2': graphUpOpaqueColor,
          'mainSeriesProperties.baselineStyle.bottomFillColor1': graphDownOpaqueColor,
          'mainSeriesProperties.baselineStyle.bottomFillColor2': graphDownOpaqueColor,
          'mainSeriesProperties.baselineStyle.topLineColor': graphUpColor,
          'mainSeriesProperties.baselineStyle.bottomLineColor': graphDownColor
        },
        studies_overrides: {
          'volume.volume.color.0': graphDownOpaqueColor,
          'volume.volume.color.1': graphUpOpaqueColor
        }
      };

      var localOverrides = __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].TradingView || {};

      var disabled_features = void 0;
      if ('disabled_features' in localOverrides) {
        disabled_features = [].concat(_toConsumableArray(new Set([].concat(disabledFeatures, _toConsumableArray(localOverrides.disabled_features)))));
      } else {
        disabled_features = disabledFeatures;
      }

      var enabled_features = [];
      if ('enabled_features' in localOverrides) {
        enabled_features = localOverrides.enabled_features.filter(function (item) {
          return !disabledFeatures.includes(item);
        });
      }

      // For some reasons TradingView.onready is not fired, timeout is used as fallback to initialize chart after 1.5 sec
      _this.timeout = setTimeout(function () {
        if (!window.TradingView) return;
        _this.chart = new TradingView.widget(Object.assign({}, chartOptions, localOverrides, {
          disabled_features: disabled_features,
          enabled_features: enabled_features
        }));
        _this.chart.onChartReady(function () {
          _this.setState({ chartInitialized: true });
          _this.chart.chart().setChartType(2);
        });
      }, 1500);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EotcPriceChartComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (!!window.TradingView && this.props.selectedInstrument.InstrumentId !== nextProps.selectedInstrument.InstrumentId) {
        window.tvChartDataFeed = null;
        return true;
      }
      return !!window.TradingView && !!nextState && !!nextState.chartInitialized;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.chartInitialized && this.chart) {
        this.chart.chart().setSymbol(this.props.selectedInstrument.Symbol);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.cssVariable = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_cssVarHelper__["a" /* getCSSVar */])();
      this.scripts = {};

      this.script('/vendor/jquery-3.3.1.min.js').then(function () {
        return _this2.script('/vendor/tradingView/charting_library.min.js');
      }).then(function () {
        _this2.initChart();
      });
    }
  }, {
    key: 'initChart',
    value: function initChart() {
      if (!this.props.selectedInstrument.InstrumentId) return;
      this.wsUri = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_wsHelper__["a" /* getGateway */])();
      var timezone = __WEBPACK_IMPORTED_MODULE_3_jstimezonedetect___default.a.determine().name();
      var currentTimezone = timezone ? timezone : __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].TradingView.timezone;

      if (!this.chart) {
        if (!window.tvChartDataFeed) {
          window.tvChartDataFeed = new __WEBPACK_IMPORTED_MODULE_2__services_tradingView_EotcChartAPI__["a" /* default */].UDFCompatibleDatafeed(this.wsUri, null, null, this.props.customGateway, currentTimezone, this.props.decimalPlaces, this.props.instrumentsArray);
        }

        this.createChart(window.tvChartDataFeed);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      if (this.chart) {
        try {
          this.chart.remove();
        } catch (e) {
          console.warn('silently handled chart error: ', e);
        }
        this.scripts['/vendor/tradingView/charting_library.min.js'].remove();
        this.scripts['/vendor/jquery-3.3.1.min.js'].remove();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bidValue = _props.bidValue,
          askValue = _props.askValue;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: chartClasses('', {
            'with-depth-chart': __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].TradingLayout.showDepthChart
          }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: chartClasses('header') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: chartClasses('header-title') },
            this.context.t('Price Chart')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: chartClasses('header-data') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: chartClasses('bid-value') },
              this.context.t('Bid'),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                bidValue
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: chartClasses('ask-value') },
              this.context.t('Ask'),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                askValue
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            id: 'trading-view-chart',
            className: chartClasses('chart-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], null)
        )
      );
    }
  }]);

  return EotcPriceChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EotcPriceChartComponent.propTypes = {
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

EotcPriceChartComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

EotcPriceChartComponent.defaultProps = {
  bidValue: 0,
  askValue: 0
};

/* harmony default export */ __webpack_exports__["a"] = (EotcPriceChartComponent);

/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apex__ = __webpack_require__(21);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global $ */
/*
This class is roughly patched from existing ChartAPI.js
Live-data ticking is not yet implemented.

 See UDF protocol reference at
 https://github.com/tradingview/charting_library/wiki/UDF
 */


var ChartAPI = {};

var UDFCompatibleDatafeed = function UDFCompatibleDatafeed(datafeedURL, updateFrequency, protocolVersion, customGateway, currentTimezone, decimalPlaces, instrumentsArray) {
  var _this = this;

  _classCallCheck(this, UDFCompatibleDatafeed);

  this.buildBar = function (barData) {
    // {
    //  [0]: UTC
    //  [1]: InstrumentId
    //  [2]: Bid
    //  [3]: Ask
    //  [4]: Mid
    // }

    var barValue = {
      time: barData[0],
      high: barData[2],
      low: barData[3],
      open: barData[4],

      // Close = mid
      close: barData[4]
    };
    return barValue;
  };

  this.getBars = function (symbolInfo, resolution, rangeStartDate, rangeEndDate, onDataCallback, onErrorCallback, firstDataRequest) {
    var that = _this;

    // Un-used.
    if (rangeStartDate > 0 && ('' + rangeStartDate).length > 10) {
      throw new Error('Got a JS time instead of Unix one. rangeStartDate: ' + rangeStartDate + ', rangeEndDate: ' + rangeEndDate);
    }

    var interval = void 0;
    switch (resolution) {
      case '1':
        interval = 60000;
        break;
      case '60':
        interval = 3600000;
        break;
      case '1D':
        interval = 86400000;
        break;
      case '1W':
        interval = 604800000;
        break;
      case '1M':
        interval = 2592000000;
        break;
      case '1Y':
        interval = 31536000000;
        break;
      default:
        interval = 60000;
        break;
    }
    // Load a day of data on the first request, but keep it at '60' resolution.
    if (firstDataRequest) interval = 86400000;
    var newIntervalMs = interval;

    var req = {};
    req.OMSId = symbolInfo.omsId;
    req.InstrumentId = symbolInfo.instrumentId;
    req.Interval = interval;
    _this.subscriptionIntervalMs = newIntervalMs;

    __WEBPACK_IMPORTED_MODULE_0__apex__["a" /* default */].connection.RPCCall('GetLastPrices', req, function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      data = JSON.parse(data.o);
      var noData = !data.length;
      var bars = [];
      var barsCount = data.length;

      for (var i = 0; i < barsCount; ++i) {
        var barData = data[i];
        var barValue = that.buildBar(barData);
        bars.push(barValue);
      }
      if (barsCount > 0) {
        _this.gotBars = symbolInfo.name;
        _this.lastBar = bars[bars.length - 1];
      } else {
        _this.lastBar = null;
      }

      /**
       * onDataCallback() can get called with reference to old chart,
       *  causing fatal error.
       */
      try {
        onDataCallback(bars, {
          version: that._protocolVersion,
          noData: noData,
          nextTime: data.nb || data.nextTime || null
        });

        // Prevent looping when exiting a specified period of time
        var filteredBars = bars.filter(function (item) {
          return item.time >= rangeStartDate * 1000 && item.time <= rangeEndDate * 1000;
        });
        if (filteredBars.length === 0) {
          onDataCallback([], {
            version: that._protocolVersion,
            noData: true,
            nextTime: null
          });
        }
      } catch (e) {
        // onErrorCallback(e);
        console.log(e);
      }
    });
  };

  this.onMessage = function (event) {
    var synchroCallBack = _this._amsynchro[event.i];
    if (synchroCallBack === undefined) {
      if (event.n === 'PriceUpdate') {
        var data = JSON.parse(event.o);
        if (_this.callback !== undefined && _this.callback !== null) {
          var newBar = _this.buildBar(data);
          if (_this.lastBar !== null) {
            if (newBar.time - _this.subscriptionIntervalMs < _this.lastBar.time) {
              newBar.time = _this.lastBar.time;
            }
            _this.callback(newBar);
            _this.lastBar = newBar;
          }
        }
      }
    } else if (event.o === '') {
      synchroCallBack({});
    } else if (synchroCallBack != null) {
      synchroCallBack(JSON.parse(event.o));
    }
  };

  this.defaultConfiguration = function () {
    return {
      supports_search: true,
      supports_group_request: false,
      supports_marks: false,
      supports_timescale_marks: false,
      supportedResolutions: ['1S', '1', '15', '60', '1D', '1W', '1M', '12M']
    };
  };

  this.getServerTime = function (callback) {
    if (_this._configuration.supports_time) {
      _this._send(_this._datafeedURL + '/time', {}).done(function (response) {
        callback(+response);
      }).fail(function () {});
    }
  };

  this.on = function (event, callback) {
    if (!Object.prototype.hasOwnProperty.call(_this._callbacks, event)) {
      _this._callbacks[event] = [];
    }

    _this._callbacks[event].push(callback);
    return _this;
  };

  this.onInitialized = function () {
    _this._initializationFinished = true;
    _this._fireEvent('initialized');
  };

  this.onReady = function (callback) {
    var that = _this;
    if (_this._configuration) {
      setTimeout(function () {
        callback(that._configuration);
      }, 0);
    } else {
      _this.on('configuration_ready', function () {
        callback(that._configuration);
      });
    }
  };

  this.resolveSymbol = function (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
    var symbol = {};
    var instrument = _this.instrumentsArray.find(function (i) {
      return i.Symbol === symbolName;
    }) || {};

    if (instrument) {
      // might be DEPRICATED, but anyway can help
      // https://github.com/alphapoint/charting_library_wiki
      var currentDecimalPlaces = _this._decimalPlaces[instrument.Product2Symbol] || 2;

      symbol.omsId = instrument.OMSId;
      symbol.name = instrument.Symbol;
      symbol.full_name = instrument.Symbol;
      symbol.description = instrument.Symbol;
      symbol.instrumentId = instrument.InstrumentId;
      symbol.ticker = instrument.Symbol;
      symbol.minmov = 1;
      symbol.pricescale = Math.pow(10, currentDecimalPlaces); // responsible for decimal places for axis`s numbers
      symbol.timezone = _this._timezone;
      symbol.session = '24x7';
      symbol.has_intraday = true;

      setTimeout(function () {
        onSymbolResolvedCallback(symbol);
      }, 0);
    } else if (_this._symbolRetries < 10) {
      _this._symbolRetries++;
      setTimeout(function () {
        _this.resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback);
      }, 100);
    } else {
      onResolveErrorCallback('Could not resolve ' + symbolName + ' after ' + _this._symbolRetries + ' retries');
    }
  };

  this.searchSymbolsByName = function () {};

  this.searchSymbols = function () {};

  this.subscribeBars = function (symbolInfo, resolution, onRealtimeCallback) {
    _this.callback = onRealtimeCallback;
    _this.unsubscribeReqObj.OMSId = symbolInfo.omsId;
    _this.unsubscribeReqObj.InstrumentId = symbolInfo.instrumentId;
  };

  this.unsubscribeBars = function () {
    // const req = this.unsubscribeReqObj;
    // apex.connection.ws.RPCCall('UnSubscribePrices', req);
  };

  this._setupWithConfiguration = function (configurationData) {
    _this._configuration = configurationData;

    if (!_this._configuration.exchanges) {
      _this._configuration.exchanges = [];
    }

    // @obsolete; remove in 1.5
    var supportedResolutions = ['1S', '1', '60', '1D', '1W', '1M', '12M'];
    _this._configuration.supported_resolutions = supportedResolutions;

    // @obsolete; remove in 1.5
    var symbolsTypes = _this._configuration.symbols_types || _this._configuration.symbolsTypes;
    _this._configuration.symbols_types = symbolsTypes;

    if (!_this._configuration.supports_search && !_this._configuration.supports_group_request) {
      throw new Error('Unsupported datafeed configuration. Must either support search, or support group request');
    }
    if (!_this._configuration.supports_search) {
      _this._symbolSearch = new ChartAPI.SymbolSearchComponent(_this);
    }
    if (_this._configuration.supports_group_request) {
      // this component will call onInitialized() by itself
      // this._symbolsStorage = new ChartAPI.SymbolsStorage(this);
    } else {
      _this.onInitialized();
    }
    _this._fireEvent('configuration_ready');
    _this._logMessage('Initialized with ' + JSON.stringify(configurationData));
  };

  this._initialize = function () {
    _this._setupWithConfiguration(_this.defaultConfiguration());
  };

  this._fireEvent = function (event, argument) {
    if (Object.prototype.hasOwnProperty.call(_this._callbacks, event)) {
      var callbacksChain = _this._callbacks[event];
      for (var i = 0; i < callbacksChain.length; ++i) {
        callbacksChain[i](argument);
      }
      _this._callbacks[event] = [];
    }
  };

  this._logMessage = function (message) {
    if (_this._enableLogging) {
      console.log(message, new Date());
    }
  };

  this._send = function (url, params) {
    var request = url;
    if (params) {
      for (var i = 0; i < Object.keys(params).length; ++i) {
        var key = Object.keys(params)[i];
        var value = encodeURIComponent(params[key]);
        request += (i === 0 ? '?' : '&') + key + '=' + value;
      }
    }

    _this._logMessage('New request: ' + request);

    return $.ajax({
      type: 'GET',
      url: request,
      contentType: 'text/plain'
    });
  };

  this._amsynchro = {};
  this._callbacks = {};
  this._configuration = undefined;
  this._datafeedURL = datafeedURL;
  this._enableLogging = false;
  this._initializationFinished = false;
  this._historyURL = '/history';
  this._protocolVersion = protocolVersion || 2;
  this._symbolSearch = null;
  this._symbolsStorage = null;
  this._symbolResolveURL = '/symbols';
  this._symbolRetries = 0;
  this._timezone = currentTimezone;
  this._decimalPlaces = decimalPlaces || {};

  this.callback = null;
  this.connected = false;
  this.lastBar = null;
  this.unsubscribeReqObj = {};
  this.gotBars = '';
  this.subscriptionIntervalMs = 0;

  this.instrumentsArray = instrumentsArray;
  this._initialize();
  __WEBPACK_IMPORTED_MODULE_0__apex__["a" /* default */].connection.ws.filter(function (x) {
    return x.n === 'PriceUpdate';
  }).subscribe(function (response) {
    _this.onMessage(response);
  });
}
// BEWARE: this function does not consider symbol's exchange
;

ChartAPI.UDFCompatibleDatafeed = UDFCompatibleDatafeed;
/* harmony default export */ __webpack_exports__["a"] = (ChartAPI);

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EotcBuySellOrderOverviewContainer__ = __webpack_require__(2102);


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__EotcBuySellOrderOverviewContainer__["a" /* default */]);

/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EotcBuySellOrderOverviewComponent__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_orderHelper_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);









var mapStateToProps = function mapStateToProps(state) {
  var decimalPlaces = state.apexCore.product.decimalPlaces;

  var buySellForm = state.form.buySell || { values: { fee: {} } };
  var selectedValue = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["a" /* getOrderFormInfoSelector */])(state);
  var isBuySide = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["g" /* isBuySideBuySellFormSelector */])(state);

  var _selectedInstrumentSe = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state),
      Product1Symbol = _selectedInstrumentSe.Product1Symbol,
      Product2Symbol = _selectedInstrumentSe.Product2Symbol;

  var tradingDisabled = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["i" /* tradingDisabledSelector */])(state);
  var quantity = selectedValue.quantity ? selectedValue.quantity : 0;
  var transactionCost = selectedValue.price ? selectedValue.price : 0;
  var pricePerUnit = selectedValue.pricePerUnit ? selectedValue.pricePerUnit : 0;

  return {
    symbol1: Product1Symbol,
    symbol2: Product2Symbol,
    isBuySide: isBuySide,
    fee: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_orderHelper_js__["c" /* getOrderFee */])(buySellForm, Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_positionSelectors__["b" /* positionSelector */])(state), 'end'),
    notEnoughMarket: tradingDisabled,
    transactionCost: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(transactionCost, Product2Symbol),
    quantity: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(quantity.toString(), Product1Symbol),
    pricePerUnit: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_orderHelper_js__["g" /* getOrderPricePerUnit */])(pricePerUnit, Product1Symbol, Product2Symbol, decimalPlaces),
    hideFees: !!__WEBPACK_IMPORTED_MODULE_7__config__["b" /* default */].global.hideFees
  };
};

var EotcBuySellOrderOverviewContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__EotcBuySellOrderOverviewComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EotcBuySellOrderOverviewContainer);

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellOrderOverview_BuySellOrderOverviewComponent_css__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BuySellOrderOverview_BuySellOrderOverviewComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BuySellOrderOverview_BuySellOrderOverviewComponent_css__);







var classes = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('buy-sell-order-overview');

var EotcBuySellOrderOverviewComponent = function EotcBuySellOrderOverviewComponent(props, context) {
  var symbol1 = props.symbol1,
      symbol2 = props.symbol2,
      transactionCost = props.transactionCost,
      notEnoughMarket = props.notEnoughMarket,
      quantity = props.quantity,
      pricePerUnit = props.pricePerUnit,
      isBuySide = props.isBuySide,
      fee = props.fee,
      hideFees = props.hideFees,
      customClass = props.customClass;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: (customClass || '') + ' ' + classes() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { className: (customClass || '') + ' ' + classes('title') },
      context.t('Transaction Overview')
    ),
    notEnoughMarket ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('content') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: classes('content') },
        context.t('We cannot fill this request.')
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('content') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        customClass: (customClass || '') + ' ' + classes(),
        label: isBuySide ? context.t('{symbol1} to Buy', { symbol1: symbol1 }) : context.t('{symbol1} to Sell', { symbol1: symbol1 }),
        text: quantity
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        name: 'pricePerUnit',
        customClass: (customClass || '') + ' ' + classes(),
        label: context.t('Price'),
        text: context.t(pricePerUnit)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        customClass: (customClass || '') + ' ' + classes(),
        label: context.t('Transaction Cost'),
        text: transactionCost + ' ' + symbol2
      }),
      !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        name: 'fee',
        customClass: customClass + ' ' + classes(),
        label: context.t('Fee'),
        text: fee
      })
    )
  );
};

EotcBuySellOrderOverviewComponent.defaultProps = {
  displayPricePerUnit: false
};

EotcBuySellOrderOverviewComponent.propTypes = {
  symbol1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  symbol2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  transactionCost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  notEnoughMarket: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  pricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isBuySide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  hideFees: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  displayPricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

EotcBuySellOrderOverviewComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (EotcBuySellOrderOverviewComponent);

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RetailPriceChart_RetailPriceChartContainer__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InstrumentSelector_InstrumentSelectorContainer__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarketOverviewComponent_css__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarketOverviewComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MarketOverviewComponent_css__);








var marketOverviewClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('market-overview');

var MarketOverviewComponent = function MarketOverviewComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: marketOverviewClasses('body') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marketOverviewClasses('chart-component-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: marketOverviewClasses('instrument-selector') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InstrumentSelector_InstrumentSelectorContainer__["a" /* default */], {
          customClass: 'market-overview-popup',
          showFullNameInstrument: true,
          showTriangles: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RetailPriceChart_RetailPriceChartContainer__["a" /* default */], {
        customClass: marketOverviewClasses('retail-price-chart-container')
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: marketOverviewClasses('market-overview-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InstrumentTable_InstrumentTableContainer__["a" /* default */], { customClass: 'market-overview-instrument' })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MarketOverviewComponent);

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WalletNavItems_CryptoNavItemsContainer__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WalletNavItems_FiatNavItemsContainer__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Retail_RetailSidePanes_FiatDeposit__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WalletDetails_css__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WalletDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__WalletDetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_numberFormatter__ = __webpack_require__(7);












var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-details');

var WalletDetailsComponent = function WalletDetailsComponent(props, context) {
  var _props$positionDetail = props.positionDetails,
      iconFileName = _props$positionDetail.iconFileName,
      Product = _props$positionDetail.Product,
      ProductFullName = _props$positionDetail.ProductFullName,
      AvailableBalance = _props$positionDetail.AvailableBalance,
      Hold = _props$positionDetail.Hold,
      PendingDeposits = _props$positionDetail.PendingDeposits,
      Amount = _props$positionDetail.Amount,
      ProductType = _props$positionDetail.ProductType,
      ProductId = _props$positionDetail.ProductId,
      rawAmount = _props$positionDetail.rawAmount;
  var baseCurrency = props.baseCurrency;

  var isCrypto = ProductType === 'CryptoCurrency';

  var renderPositionDetails = function renderPositionDetails(label, value) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('detail') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('label') },
        context.t(label)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('value') },
        value
      )
    );
  };
  var baseCurrencyTitle = void 0;

  if (baseCurrency) {
    var convertedValue = rawAmount * baseCurrency.value;
    var formattedValue = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_numberFormatter__["b" /* formatNumberToLocale */])(convertedValue, baseCurrency.DecimalPlaces);
    baseCurrencyTitle = '(' + baseCurrency.Product + ' ' + formattedValue + ')';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    props.fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], { isInline: true, customClass: baseClasses }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('product-actions-row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('product-label') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('product-icon') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_ProductIcon_ProductIconContainer__["a" /* default */], { iconFileName: iconFileName, size: 48 })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('product-symbol-name') },
            Product + ' ' + ProductFullName,
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: baseClasses('product-conversion') },
              baseCurrencyTitle
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('wallet-nav-items') },
          isCrypto ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__WalletNavItems_CryptoNavItemsContainer__["a" /* default */], {
            product: {
              iconFileName: iconFileName,
              ProductFullName: ProductFullName,
              ProductSymbol: Product,
              ProductId: ProductId
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__WalletNavItems_FiatNavItemsContainer__["a" /* default */], {
            product: {
              iconFileName: iconFileName,
              ProductFullName: ProductFullName,
              ProductSymbol: Product,
              ProductId: ProductId
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('position-row') },
        renderPositionDetails('Available Balance', AvailableBalance),
        renderPositionDetails('Hold', Hold),
        renderPositionDetails('Pending Deposits', PendingDeposits),
        renderPositionDetails('Total Balance', Amount)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Retail_RetailSidePanes_FiatDeposit__["a" /* DepositReferenceIdModalContainer */], null)
    )
  );
};

WalletDetailsComponent.propTypes = {
  positionDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  fetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

WalletDetailsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (WalletDetailsComponent);

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecentActivityWithFilterComponent__ = __webpack_require__(2110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_resize__ = __webpack_require__(73);





var RecentActivityWithFilterComponentForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'recent-activity',
  destroyOnUnmount: false,
  initialValues: {
    type: 'all',
    startDate: undefined,
    endDate: undefined
  }
})(__WEBPACK_IMPORTED_MODULE_2__RecentActivityWithFilterComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])()(Object(__WEBPACK_IMPORTED_MODULE_3__hocs_resize__["a" /* default */])(RecentActivityWithFilterComponentForm)));

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecentActivityHeaderWithFilter__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecentActivityTableWithFilter__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecentActivity_ActivityComponents_css__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecentActivity_ActivityComponents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RecentActivity_ActivityComponents_css__);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var RecentActivityWithFilterComponent = function RecentActivityWithFilterComponent(props, context) {
  var width = props.width,
      themeModifier = props.themeModifier,
      pageSize = props.pageSize,
      minRow = props.minRow;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RecentActivityHeaderWithFilter__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RecentActivityTableWithFilter__["a" /* default */], {
      pageSize: pageSize,
      minRow: minRow,
      themeModifier: themeModifier,
      width: width,
      context: context
    })
  );
};

RecentActivityWithFilterComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RecentActivityWithFilterComponent);

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecentActivityHeaderWithFilterComponent__ = __webpack_require__(2112);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RecentActivityHeaderWithFilterComponent__["a" /* default */]);

/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecentActivity_RecentActivityHeader__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecentActivityHeaderForm__ = __webpack_require__(2113);




var RecentActivityHeaderWithFilterComponent = function RecentActivityHeaderWithFilterComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RecentActivity_RecentActivityHeader__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RecentActivityHeaderForm__["a" /* default */], null)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (RecentActivityHeaderWithFilterComponent);

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecentActivityHeaderFormContainer__ = __webpack_require__(2114);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RecentActivityHeaderFormContainer__["a" /* default */]);

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecentActivityHeaderFormComponent__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_paginationActions__ = __webpack_require__(175);





var mapStateToProps = function mapStateToProps(state) {
  var formValue = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('recent-activity');

  return {
    endDate: formValue(state, 'endDate')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setEndDate: function setEndDate(value) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('recent-activity', 'endDate', value));
    },
    clearFilters: function clearFilters() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('recent-activity', 'startDate', null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('recent-activity', 'endDate', null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('recent-activity', 'type', 'all'));
    },
    resetActivePage: function resetActivePage() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_paginationActions__["b" /* setActivePage */])({ componentName: 'RecentActivityComponent', activePage: 0 }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__RecentActivityHeaderFormComponent__["a" /* default */]));

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect_APSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APDatePicker_APDatePicker__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var RecentActivityHeaderFormComponent = function RecentActivityHeaderFormComponent(props, context) {
  var resetActivePage = props.resetActivePage,
      setEndDate = props.setEndDate,
      clearFilters = props.clearFilters,
      endDate = props.endDate;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { className: baseClasses('select-buttons') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect_APSelect__["b" /* default */], {
      name: 'type',
      customClass: baseClasses(),
      label: context.t('Activity type:'),
      options: [{ value: 'all', label: context.t('All Activities') }, { value: 'trades', label: context.t('Trades') }, { value: 'withdraw', label: context.t('Withdrawals') }, { value: 'deposit', label: context.t('Deposits') }],
      onSelect: resetActivePage,
      showTriangles: true
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APDatePicker_APDatePicker__["a" /* default */], {
      name: 'startDate',
      customClass: baseClasses('from'),
      customChange: function customChange(value) {
        resetActivePage();
        if (value && !endDate) {
          setEndDate(new Date());
        }
      },
      label: context.t('Date range:'),
      format: function format(value) {
        return value;
      },
      maxDate: new Date()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APDatePicker_APDatePicker__["a" /* default */], {
      name: 'endDate',
      customClass: baseClasses('to'),
      label: context.t('to'),
      format: function format(value) {
        return value;
      },
      customChange: resetActivePage,
      maxDate: new Date()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
      {
        customClass: baseClasses(),
        classModifiers: 'clear-filters',
        type: 'button',
        onClick: clearFilters },
      context.t('Clear Filters')
    )
  );
};

RecentActivityHeaderFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RecentActivityHeaderFormComponent);

/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecentActivityTableWithFilterContainer__ = __webpack_require__(2117);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__RecentActivityTableWithFilterContainer__["a" /* default */]);

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecentActivity_RecentActivityTable_RecentActivityTableComponent__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_recentActivityHelper__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_recentActivitySelector__ = __webpack_require__(410);






var mapStateToProps = function mapStateToProps(state, ownProps) {
  var minRow = ownProps.minRow,
      pageSize = ownProps.pageSize;

  var filteredActivity = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_recentActivitySelector__["a" /* getFilteredActivity */])(state, ownProps.filterForSelected);
  var content = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_recentActivityHelper__["a" /* formatActivity */])(filteredActivity, ownProps.context);

  var usePagination = __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].OrderHistoryData.usePagination;


  var columns = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_recentActivityHelper__["b" /* getColumns */])(ownProps.width, ownProps.themeModifier, ownProps.context);

  return {
    minRow: minRow,
    pageSize: pageSize,
    usePagination: usePagination,
    content: content,
    columns: columns
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__RecentActivity_RecentActivityTable_RecentActivityTableComponent__["a" /* default */]));

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TransferComponents_css__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TransferComponents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TransferComponents_css__);











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('transfers');

var TransfersComponent = function TransfersComponent(props, context) {
  var getAmountRow = function getAmountRow(_ref) {
    var Amount = _ref.Amount,
        product = _ref.product;
    return getMultilineCell(Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Amount, product.DecimalPlaces), product.ProductFullName);
  };

  var getDateRow = function getDateRow(_ref2) {
    var CreatedTimestamp = _ref2.CreatedTimestamp;
    return getMultilineCell(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_dateHelper__["b" /* formatDate */])(CreatedTimestamp), Object(__WEBPACK_IMPORTED_MODULE_6__helpers_dateHelper__["d" /* formatTime */])(CreatedTimestamp));
  };

  var getMultilineCell = function getMultilineCell(primarytext, secondaryText) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('multiline-col') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('primary-text') },
        primarytext
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('secondary-text') },
        secondaryText
      )
    );
  };

  var getCell = function getCell(field) {
    return function (row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('primary-text') },
        row[field]
      );
    };
  };

  var getActionButtons = function getActionButtons(row) {
    if (row.Status === 'TransferCompleted' || row.Status === 'PayerRejected') {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
        {
          styleName: __WEBPACK_IMPORTED_MODULE_5__propTypes_commonComponent__["b" /* styleNames */].additive,
          onClick: function onClick() {
            return allowRequest(row);
          } },
        context.t('Approve')
      ),
      '\xA0',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
        {
          styleName: __WEBPACK_IMPORTED_MODULE_5__propTypes_commonComponent__["b" /* styleNames */].subtractive,
          onClick: function onClick() {
            return rejectRequest(row);
          } },
        context.t('Reject')
      )
    );
  };

  var getTransfersColumns = function getTransfersColumns() {
    return [{
      header: context.t('Action'),
      classModifier: 'transfers-action',
      cell: function cell(row) {
        var selectedFilter = props.selectedFilter;

        var isSent = selectedFilter === 'sentTransfers';
        var sent = context.t('Sent') + ' ' + row.product.ProductFullName;
        var received = context.t('Received') + ' ' + row.product.ProductFullName;
        var from = context.t('From') + ' ' + row.SenderUserName;
        var to = context.t('To') + ' ' + row.ReceiverUserName;

        return isSent ? getMultilineCell(sent, to) : getMultilineCell(received, from);
      }
    }, {
      header: context.t('Amount'),
      cell: getAmountRow,
      classModifier: 'amount'
    }, {
      header: context.t('Note'),
      cell: getCell('Notes')
    }];
  };

  var allowRequest = function allowRequest(req) {
    props.approveTransferRequest(req.RequestCode);
  };

  var rejectRequest = function rejectRequest(req) {
    props.rejectTransferRequest(req.RequestCode);
  };

  var getRequestsSentColumns = function getRequestsSentColumns() {
    return [{
      header: context.t('Recipient'),
      classModifier: 'recipient',
      cell: function cell(row) {
        return getMultilineCell(context.t('You requested to Receive') + ' ' + row.product.ProductFullName, context.t('To') + ' ' + row.PayerUsername);
      }
    }, {
      header: context.t('Amount'),
      classModifier: 'amount',
      cell: getAmountRow
    }, {
      header: context.t('Time'),
      classModifier: 'time',
      cell: getDateRow
    }, {
      header: context.t('Note'),
      classModifier: 'note',
      cell: getCell('Notes')
    }, {
      header: context.t('Status'),
      classModifier: 'status',
      cell: getCell('Status')
    }];
  };

  var getRequestsReceivedColumns = function getRequestsReceivedColumns() {
    return [{
      header: context.t('Sent By'),
      classModifier: 'sent-by',
      cell: function cell(row) {
        return getMultilineCell(context.t('Request for you to send') + ' ' + row.product.ProductFullName, context.t('From') + ' ' + row.RequestorUsername);
      }
    }, {
      header: context.t('Amount'),
      classModifier: 'amount',
      cell: getAmountRow
    }, {
      header: context.t('Time'),
      classModifier: 'time',
      cell: getDateRow
    }, {
      header: context.t('Note'),
      classModifier: 'note',
      cell: getCell('Notes')
    }, {
      header: context.t('Status'),
      classModifier: 'status',
      cell: getCell('Status')
    }, {
      header: context.t('Action'),
      cell: getActionButtons
    }];
  };

  var getColumns = function getColumns(selectedFilter) {
    var columnsMethods = {
      sentTransfers: getTransfersColumns,
      receivedTransfers: getTransfersColumns,
      sentRequests: getRequestsSentColumns,
      receivedRequests: getRequestsReceivedColumns
    };

    return columnsMethods[selectedFilter]();
  };

  var usePagination = props.usePagination,
      selectedFilter = props.selectedFilter;

  var columns = getColumns(selectedFilter);
  var items = props[selectedFilter];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('wrapper') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APTable__["a" /* default */], {
      componentName: 'TransfersComponent',
      columns: columns,
      pageSize: 6,
      minRow: 6,
      rows: items,
      baseClass: baseClasses,
      headerOutside: true,
      usePagination: usePagination,
      empty: context.t('No data is available')
    })
  );
};

TransfersComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TransfersComponent);

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransfersFiltersComponent__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_paginationActions__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_transferActions__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_transferRequestActions__ = __webpack_require__(98);







var mapStateToProps = function mapStateToProps(state) {
  var _state$user$userInfo = state.user.userInfo,
      OMSId = _state$user$userInfo.OMSId,
      AccountId = _state$user$userInfo.AccountId;


  return {
    OMSId: OMSId,
    AccountId: AccountId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getTransfers: function getTransfers(OMSId, accountId) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_transferActions__["e" /* getTransfers */])(accountId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_transferActions__["d" /* getIncomingTransfers */])(OMSId, accountId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_transferRequestActions__["i" /* getTransferRequestsReceived */])(accountId, OMSId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_transferRequestActions__["j" /* getTransferRequestsRequested */])(accountId, OMSId));
    },
    resetActivePage: function resetActivePage() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_paginationActions__["b" /* setActivePage */])({ componentName: 'TransfersComponent', activePage: 0 }));
    }
  };
};

var TransfersFiltersForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'transfers-filters-form',
  initialValues: {
    transfersFilters: 'sentTransfers'
  }
})(__WEBPACK_IMPORTED_MODULE_0__TransfersFiltersComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(TransfersFiltersForm));

/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSegmentedButton__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APInlineButton__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransfersFiltersComponent_css__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransfersFiltersComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TransfersFiltersComponent_css__);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('transfers-filters');

var TransfersFiltersComponent = function TransfersFiltersComponent(props, context) {
  var resetActivePage = props.resetActivePage,
      getTransfers = props.getTransfers,
      OMSId = props.OMSId,
      AccountId = props.AccountId;

  var tabs = {
    sentTransfers: 'sentTransfers',
    receivedTransfers: 'receivedTransfers',
    sentRequests: 'sentRequests',
    receivedRequests: 'receivedRequests'
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('select-buttons') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSegmentedButton__["a" /* default */], {
        name: 'transfersFilters',
        defaultValue: tabs.sentTransfers,
        items: [{
          value: tabs.sentTransfers,
          text: context.t('Sent Transfers')
        }, {
          value: tabs.receivedTransfers,
          text: context.t('Received Transfers')
        }, {
          value: tabs.sentRequests,
          text: context.t('Sent Requests')
        }, {
          value: tabs.receivedRequests,
          text: context.t('Received Requests')
        }],
        styleName: __WEBPACK_IMPORTED_MODULE_4__propTypes_commonComponent__["b" /* styleNames */].additive,
        customClass: baseClasses(),
        onClick: resetActivePage
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APInlineButton__["a" /* default */], {
      icon: 'refresh',
      customClass: baseClasses('refresh-transfers'),
      text: context.t('Refresh Transfers'),
      onClick: function onClick() {
        getTransfers(OMSId, AccountId);
      }
    })
  );
};

TransfersFiltersComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TransfersFiltersComponent);

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainNavOptions", function() { return mainNavOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subNavItems", function() { return subNavItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletsPath", function() { return walletsPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletDetailPath", function() { return walletDetailPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routesArray", function() { return routesArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_load__ = __webpack_require__(100);



var BalancesMenuContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 83));
});
var WalletDetailsBackButtonComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 126));
});
var FixedLeftFluidLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 102));
});
var TradingLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 103));
});
var SingleFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 157));
});
var ComponentRowSingle = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 110));
});
var WalletCardGridContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 108));
});
var WalletRowListContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 109));
});
var PageFooterComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 61));
});
var WalletDetailsLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 128));
});

// context.t('Trading')
// context.t('Wallets')
// context.t('Settings')
var mainNavOptions = {
  mainNavItems: [{ text: 'Trading', icon: 'trading', path: '/trading' }, { text: 'Wallets', icon: 'wallet', path: '/wallets' }, { text: 'Settings', icon: 'settings', path: '/settings/profile' }],
  settingsPath: '/settings/profile'
};
var subNavItems = [];

var walletsPath = '/wallets';
var walletDetailPath = '/wallets/wallet-detail';

var routesArray = [{ path: '/trading', render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingLayout, null);
  } }, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      SingleFluidHeaderFixedContentLayout,
      { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        header: 'Funded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletCardGridContainer, { detailsLink: walletDetailPath })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        customClass: 'container-with-shadow',
        header: 'Unfunded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletRowListContainer, { detailsLink: walletDetailPath })
      })
    );
  }
  // this.context.t('Funded Accounts')
  // this.context.t('Unfunded Accounts')
}, {
  path: '/wallets/wallet-detail',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FixedLeftFluidLayout,
      {
        left: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsBackButtonComponent, { key: '1' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesMenuContainer, { key: '2' })] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsLayout, null)
    );
  }
}];

/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainNavOptions", function() { return mainNavOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subNavItems", function() { return subNavItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletsPath", function() { return walletsPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletDetailPath", function() { return walletDetailPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routesArray", function() { return routesArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_load__ = __webpack_require__(100);



var FixedLeftFluidLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 102));
});
var BalancesMenuContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 83));
});
var WalletDetailsBackButtonComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 126));
});
var DualHeaderDashboardLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 207));
});
var SubNavComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 208));
});
var TransferRequestNotificationList = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 154));
});
var TradingLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 103));
});
var BalancesListLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 155));
});
var RecentActivityContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 198));
});
var SingleFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 157));
});
var ComponentRowSingle = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 110));
});
var WalletCardGridContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 108));
});
var WalletRowListContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 109));
});
var DualFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 206));
});
var MarketDataCardsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 127));
});
var RetailBuySellLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 2568));
});
var MarketOverviewLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 209));
});

var PageFooterComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 61));
});

var WalletDetailsLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 128));
});

// this.context.t('Dashboard')
// this.context.t('Exchange')
// this.context.t('Buy & Sell')
// this.context.t('Wallets')
// this.context.t('User Settings')
var mainNavOptions = {
  mainNavItems: [{ text: 'Dashboard', icon: 'dashboard', path: '/dashboard' }, { text: 'Exchange', icon: 'trading', path: '/exchange' }, { text: 'Buy & Sell', icon: 'buy-sell', path: '/buy-sell' }, { text: 'Wallets', icon: 'wallet', path: '/wallets' }, { text: 'User Settings', icon: 'user-settings', path: '/settings/profile' }],
  settingsPath: '/settings/profile'
};
// this.context.t('Your Snapshot')
// this.context.t('Market Data')
var subNavItems = [{ text: 'Your Snapshot', path: '/dashboard' }, { text: 'Market Data', path: '/dashboard/market-data' }];

var walletsPath = '/wallets';
var walletDetailPath = '/wallets/wallet-detail';

var routesArray = [{
  exact: true,
  path: '/dashboard',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DualHeaderDashboardLayout, {
      headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
      notificationComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransferRequestNotificationList, null),
      component1: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketOverviewLayout, null),
      component2: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesListLayout, null),
      component3: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentActivityContainer, { filterForSelected: false }),
      footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/buy-sell',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RetailBuySellLayout, { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) });
  }
}, {
  path: '/exchange',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingLayout, null);
  }
}, {
  path: '/dashboard/market-data',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      DualFluidHeaderFixedContentLayout,
      {
        headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, { component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketDataCardsContainer, null) })
    );
  }
}, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      SingleFluidHeaderFixedContentLayout,
      { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        header: 'Funded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletCardGridContainer, { detailsLink: walletDetailPath })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        customClass: 'container-with-shadow',
        header: 'Unfunded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletRowListContainer, { detailsLink: walletDetailPath })
      })
    );
  }
  // this.context.t('Funded Accounts')
  // this.context.t('Unfunded Accounts')
}, {
  path: '/wallets/wallet-detail',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FixedLeftFluidLayout,
      {
        left: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsBackButtonComponent, { key: '1' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesMenuContainer, { key: '2' })] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsLayout, null)
    );
  }
}];

/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainNavOptions", function() { return mainNavOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subNavItems", function() { return subNavItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletsPath", function() { return walletsPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletDetailPath", function() { return walletDetailPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routesArray", function() { return routesArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_load__ = __webpack_require__(100);



var FixedLeftFluidLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 102));
});
var BalancesMenuContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 83));
});
var WalletDetailsBackButtonComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 126));
});
var DualHeaderDashboardLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 207));
});
var SubNavComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 208));
});
var TransferRequestList = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 154));
});
var TradingLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 103));
});
var BalancesListLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 155));
});
var SingleFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 157));
});
var ComponentRowSingle = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 110));
});
var WalletCardGridContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 108));
});
var WalletRowListContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 109));
});
var DualFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 206));
});
var MarketDataCardsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 127));
});
var RetailBuySellLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 2569));
});
var MarketOverviewLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 209));
});
var OrdersListLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 2570));
});
var PageFooterComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 61));
});
var WalletDetailsLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 128));
});
var OrdersListContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 2565));
});
var ActivityPage = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 2571));
});

// this.context.t('Dashboard')
// this.context.t('Exchange')
// this.context.t('Buy & Sell')
// this.context.t('Wallets')
// this.context.t('User Settings')
var mainNavOptions = {
  mainNavItems: [{ text: 'Dashboard', icon: 'dashboard', path: '/dashboard' }, { text: 'Exchange', icon: 'exchange', path: '/exchange' }, { text: 'Buy & Sell', icon: 'buy-sell', path: '/buy-sell' }, { text: 'Wallets', icon: 'wallet', path: '/wallets' }, { text: 'Activity', icon: 'activity', path: '/activity/orders' }, { text: 'User Settings', icon: 'settings', path: '/settings/profile' }],
  settingsPath: '/settings/profile'
};
// this.context.t('Your Snapshot')
// this.context.t('Market Data')
var subNavItems = [{ text: 'Your Snapshot', path: '/dashboard' }, { text: 'Market Data', path: '/dashboard/market-data' }];

var walletsPath = '/wallets';
var walletDetailPath = '/wallets/wallet-detail';

var routesArray = [{
  exact: true,
  path: '/dashboard',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DualHeaderDashboardLayout, {
      headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
      notificationComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransferRequestList, null),
      component1: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketOverviewLayout, null),
      component2: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesListLayout, null),
      component3: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrdersListLayout, { activityPath: '/activity' }),
      footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/buy-sell',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RetailBuySellLayout, { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) });
  }
}, {
  path: '/exchange',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingLayout, null);
  }
}, {
  path: '/dashboard/market-data',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      DualFluidHeaderFixedContentLayout,
      {
        headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, { component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketDataCardsContainer, null) })
    );
  }
}, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      SingleFluidHeaderFixedContentLayout,
      { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        header: 'Funded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletCardGridContainer, { detailsLink: walletDetailPath })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        customClass: 'container-with-shadow',
        header: 'Unfunded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletRowListContainer, { detailsLink: walletDetailPath })
      })
    );
  }
  // this.context.t('Funded Accounts')
  // this.context.t('Unfunded Accounts')
}, {
  path: '/wallets/wallet-detail',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FixedLeftFluidLayout,
      {
        left: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsBackButtonComponent, { key: '1' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesMenuContainer, { key: '2' })] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsLayout, null)
    );
  }
}, {
  path: '/activity/orders',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActivityPage, {
      children: function children(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrdersListContainer, Object.assign({
          filterBySelectedProduct: true,
          usePagination: true,
          minRow: 5,
          pageSize: 10,
          showOnlyActivePage: false,
          showOrderStatus: true
        }, props));
      }
    });
  }
}, {
  path: '/activity/deposit-withdraw',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActivityPage, {
      children: function children(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrdersListContainer, Object.assign({
          filterBySelectedProduct: true,
          usePagination: true,
          minRow: 5,
          pageSize: 10,
          showOnlyActivePage: false,
          showOrderStatus: true
        }, props));
      }
    });
  }
}];

/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainNavOptions", function() { return mainNavOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subNavItems", function() { return subNavItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletsPath", function() { return walletsPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletDetailPath", function() { return walletDetailPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routesArray", function() { return routesArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_load__ = __webpack_require__(100);



var FixedLeftFluidLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 102));
});
var BalancesMenuContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 83));
});
var WalletDetailsBackButtonComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 126));
});
var DualHeaderDashboardLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 207));
});
var SubNavComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 208));
});
var TradingLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 103));
});
var BalancesListLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 155));
});
var RecentActivityContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 198));
});
var SingleFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 157));
});
var ComponentRowSingle = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 110));
});
var WalletCardGridContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 108));
});
var WalletRowListContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 109));
});
var DualFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 206));
});
var MarketDataCardsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 127));
});
var RetailBuySellLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 432));
});
var MarketOverviewLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 209));
});
var PageFooterComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 61));
});
var WalletDetailsLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 128));
});

// this.context.t('Dashboard')
// this.context.t('Exchange')
// this.context.t('Buy & Sell')
// this.context.t('Wallets')
var mainNavOptions = {
  mainNavItems: [{ text: 'Dashboard', icon: 'dashboard', path: '/dashboard' }, { text: 'Trading', icon: 'trading', path: '/trading' }, { text: 'Buy & Sell', icon: 'buy-sell', path: '/buy-sell' }, { text: 'Wallets', icon: 'wallet', path: '/wallets' }, { text: 'User Settings', icon: 'user-settings', path: '/settings/profile' }],
  settingsPath: '/settings/profile'
};
// this.context.t('Your Snapshot')
// this.context.t('Market Data')
// this.context.t('Transfer Activity')
var subNavItems = [{ text: 'Your Snapshot', path: '/dashboard' }, { text: 'Market Data', path: '/dashboard/market-data' }, { text: 'Transfer Activity', path: '/dashboard/transfer-activity' }];

var walletsPath = '/wallets';
var walletDetailPath = '/wallets/wallet-detail';

var routesArray = [{
  exact: true,
  path: '/dashboard',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DualHeaderDashboardLayout, {
      headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
      component1: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketOverviewLayout, null),
      component2: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesListLayout, null),
      component3: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentActivityContainer, { filterForSelected: false }),
      footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/buy-sell',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      SingleFluidHeaderFixedContentLayout,
      { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RetailBuySellLayout, null)
    );
  }
}, {
  path: '/trading',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingLayout, null);
  }
}, {
  path: '/dashboard/market-data',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      DualFluidHeaderFixedContentLayout,
      {
        headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, { component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketDataCardsContainer, null) })
    );
  }
}, {
  path: '/dashboard/transfer-activity',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      DualFluidHeaderFixedContentLayout,
      {
        headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentActivityContainer, { filterForSelected: false })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentActivityContainer, { filterForSelected: false })
      })
    );
  }
}, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      SingleFluidHeaderFixedContentLayout,
      { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        header: 'Funded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletCardGridContainer, { detailsLink: walletDetailPath })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        customClass: 'container-with-shadow',
        header: 'Unfunded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletRowListContainer, { detailsLink: walletDetailPath })
      })
    );
  }
  // this.context.t('Funded Accounts')
  // this.context.t('Unfunded Accounts')
}, {
  path: '/wallets/wallet-detail',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FixedLeftFluidLayout,
      {
        left: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsBackButtonComponent, { key: '1' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesMenuContainer, { key: '2' })] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsLayout, null)
    );
  }
}];

/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainNavOptions", function() { return mainNavOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subNavItems", function() { return subNavItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletsPath", function() { return walletsPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "walletDetailPath", function() { return walletDetailPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "marginBalancesPath", function() { return marginBalancesPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routesArray", function() { return routesArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_load__ = __webpack_require__(100);



var FixedLeftFluidLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 102));
});
var BalancesMenuContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 83));
});
var WalletDetailsBackButtonComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 126));
});
var DualHeaderDashboardLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 207));
});
var SubNavComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 208));
});
var TransferRequestNotificationList = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 154));
});
var TradingLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 103));
});
var BalancesListLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 155));
});
var RecentActivityContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 198));
});
var RecentActivityWithFilterContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 201));
});
var SingleFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 157));
});
var ComponentRowSingle = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 110));
});
var WalletCardGridContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 108));
});
var WalletRowListContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 109));
});
var DualFluidHeaderFixedContentLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 206));
});
var MarketDataCardsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 127));
});
var RetailBuySellLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 432));
});
var MarketOverviewLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 209));
});

var PageFooterComponent = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 61));
});

var WalletDetailsLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 128));
});

var IBALayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 809));
});

var StreamingLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 810));
});

var StreamingGridContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 811));
});

// this.context.t('Dashboard')
// this.context.t('Exchange')
// this.context.t('Buy & Sell')
// this.context.t('Wallets')
// this.context.t('User Settings')
var mainNavOptions = {
  mainNavItems: [{ text: 'Dashboard', icon: 'dashboard', path: '/dashboard' }, { text: 'Exchange', icon: 'trading', path: '/exchange' }, { text: 'Streaming', icon: 'buy-sell', path: '/streaming' }, { text: 'Yield', icon: 'sell', path: '/iba' }, { text: 'Buy & Sell', icon: 'buy-sell', path: '/buy-sell' }, { text: 'Wallets', icon: 'wallet', path: '/wallets' }, { text: 'User Settings', icon: 'user-settings', path: '/settings/profile' }],
  settingsPath: '/settings/profile'
};
// this.context.t('Your Snapshot')
// this.context.t('Market Data')
var subNavItems = [{ text: 'Your Snapshot', path: '/dashboard' }, { text: 'Market Data', path: '/dashboard/market-data' }];

var walletsPath = '/wallets';
var walletDetailPath = '/wallets/wallet-detail';
var marginBalancesPath = '/margin-balances';

var routesArray = [{
  exact: true,
  path: '/dashboard',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DualHeaderDashboardLayout, {
      headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
      notificationComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransferRequestNotificationList, null),
      component1: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketOverviewLayout, null),
      component2: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesListLayout, null),
      component3: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentActivityContainer, { filterForSelected: false }),
      footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/dashboard/market-data',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      DualFluidHeaderFixedContentLayout,
      {
        headerSecondary: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubNavComponent, null),
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, { component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarketDataCardsContainer, null) })
    );
  }
}, {
  path: '/buy-sell',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RetailBuySellLayout, { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) });
  }
}, {
  path: '/exchange',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingLayout, null);
  }
}, {
  exact: true,
  path: '/streaming',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StreamingLayout, {
      component1: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StreamingGridContainer, null),
      component2: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesListLayout, null),
      component3: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentActivityWithFilterContainer, {
        filterForSelected: false,
        pageSize: 10,
        minRow: 10
      }),
      footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null)
    });
  }
}, {
  path: '/iba',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IBALayout, null);
  }
}, {
  exact: true,
  path: '/wallets',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      SingleFluidHeaderFixedContentLayout,
      { footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageFooterComponent, null) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        header: 'Funded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletCardGridContainer, { detailsLink: walletDetailPath })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentRowSingle, {
        customClass: 'container-with-shadow',
        header: 'Unfunded Accounts',
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletRowListContainer, { detailsLink: walletDetailPath })
      })
    );
  }
  // this.context.t('Funded Accounts')
  // this.context.t('Unfunded Accounts')
}, {
  path: '/wallets/wallet-detail',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FixedLeftFluidLayout,
      {
        left: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsBackButtonComponent, { key: '1' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalancesMenuContainer, { key: '2' })] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WalletDetailsLayout, null)
    );
  }
}];

/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InterestBalancesComponent__ = __webpack_require__(2130);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InterestBalancesComponent__["a" /* default */]);

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InterestBalancesTable__ = __webpack_require__(2131);





var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var InterestBalancesComponent = function InterestBalancesComponent(props, context) {
  var width = props.width,
      themeModifier = props.themeModifier,
      rates = props.rates;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('header-bar') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-text') },
        context.t('Balances')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InterestBalancesTable__["a" /* default */], {
      themeModifier: themeModifier,
      width: width,
      context: context,
      rates: rates
    })
  );
};

InterestBalancesComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (InterestBalancesComponent);

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InterestBalancesTableContainer__ = __webpack_require__(2132);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InterestBalancesTableContainer__["a" /* default */]);

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InterestBalancesTableComponent__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_interestBearingAccountsSelectors__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_positionActions__ = __webpack_require__(85);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var mapStateToProps = function mapStateToProps(state, _ref) {
  var rates = _ref.rates;

  var interestPayments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_interestBearingAccountsSelectors__["d" /* totaledInterestPaymentsSelector */])(state);
  var interestBalances = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_interestBearingAccountsSelectors__["b" /* interestBalancesSelector */])(state);
  var rows = interestBalances.filter(function (i) {
    return rates.hasOwnProperty(i.ProductId) && rates[i.ProductId].IsEnabled;
  });

  var totalValueRow = rows.reduce(function (acc, i) {
    acc.NotionalValue = acc.NotionalValue + i.NotionalValue;
    acc.Total += __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(interestPayments, [i.ProductId, 'Total'], 0) * i.NotionalRate;
    acc['7DayEarnings'] += __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(interestPayments, [i.ProductId, '7DayEarnings'], 0) * i.NotionalRate;

    return acc;
  }, _defineProperty({
    Total: 0,
    NotionalValue: 0
  }, '7DayEarnings', 0));

  return {
    rows: rows,
    totalValueRow: totalValueRow,
    interestPayments: interestPayments
  };
};

var mapDispatchToProps = {
  selectPositionAndSave: __WEBPACK_IMPORTED_MODULE_4__redux_actions_positionActions__["f" /* selectPositionAndSave */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__InterestBalancesTableComponent__["a" /* default */]));

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InterestBalances_css__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InterestBalances_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InterestBalances_css__);









var baseClass = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity', ['interest-balances']);

var InterestBalancesTableComponent = function InterestBalancesTableComponent(props, context) {
  var usePagination = props.usePagination,
      selectPositionAndSave = props.selectPositionAndSave,
      rows = props.rows,
      totalValueRow = props.totalValueRow,
      interestPayments = props.interestPayments,
      rates = props.rates;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APTable__["a" /* default */], {
    componentName: 'RecentActivityComponent',
    columns: [{
      header: context.t('Product'),
      width: '30rem',
      cell: function cell(row, _ref) {
        var rowIndex = _ref.rowIndex;

        if (rowIndex === rows.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClass('action') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClass('action-column') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: baseClass('action-text', 'primary') },
                'Total Value:'
              )
            )
          );
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["a" /* Action */], {
          themeModifier: '',
          onClick: selectPositionAndSave,
          row: row
        });
      }
    }, {
      header: context.t('Total Balance'),
      width: '20rem',
      cell: function cell(row, _ref2) {
        var rowIndex = _ref2.rowIndex;

        if (rowIndex === rows.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["b" /* Amount */], {
            value: {
              rawAmount: totalValueRow.NotionalValue,
              ProductSymbol: 'USD'
            }
          });
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["b" /* Amount */], { value: row });
      }
    }, {
      header: context.t('Market Price'),
      width: '20rem',
      cell: function cell(row, _ref3) {
        var rowIndex = _ref3.rowIndex;

        if (rowIndex === rows.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["d" /* MarketPrice */], row);
      }
    }, {
      header: context.t('Target Interest Rate'),
      width: '40rem',
      cell: function cell(row, _ref4) {
        var rowIndex = _ref4.rowIndex;

        if (rowIndex === rows.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { paddingLeft: '2.6rem' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["e" /* Text */], { text: rates[row.ProductId].Rate + '%' })
        );
      }
    }, {
      header: context.t('Interest (Total)'),
      width: '15rem',
      cell: function cell(row, _ref5) {
        var rowIndex = _ref5.rowIndex;

        if (rowIndex === rows.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { paddingLeft: '2.6rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["c" /* InterestAmount */], {
              ProductSymbol: 'USD',
              Amount: totalValueRow.Total || 0
            })
          );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { paddingLeft: '2.6rem' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["c" /* InterestAmount */], {
            ProductSymbol: row.ProductSymbol,
            Amount: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(interestPayments, [row.ProductId, 'Total'], '-')
          })
        );
      }
    }, {
      header: context.t('Interest (7 Days)'),
      width: '15rem',
      cell: function cell(row, _ref6) {
        var rowIndex = _ref6.rowIndex;

        if (rowIndex === rows.length) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { paddingLeft: '2.6rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["c" /* InterestAmount */], {
              ProductSymbol: 'USD',
              Amount: totalValueRow['7DayEarnings'] || 0
            })
          );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { paddingLeft: '2.6rem' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["c" /* InterestAmount */], {
            ProductSymbol: row.ProductSymbol,
            Amount: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(interestPayments, [row.ProductId, '7DayEarnings'], '-')
          })
        );
      }
    }],
    pageSize: 6,
    rows: rows.concat([{}]),
    baseClass: baseClass,
    headerOutside: true,
    usePagination: usePagination,
    empty: context.t('No data is available')
  });
};

InterestBalancesTableComponent.defaultProps = {
  usePagination: false
};

InterestBalancesTableComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (InterestBalancesTableComponent);

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MarketPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Amount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InterestAmount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__ = __webpack_require__(7);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity', 'interest-balances');

var Action = function Action(props, context) {
  var themeModifier = props.themeModifier,
      _onClick = props.onClick,
      row = props.row;
  var iconFileName = row.iconFileName,
      ProductId = row.ProductId;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('action') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_ProductIcon_ProductIconContainer__["a" /* default */], {
      customClass: baseClasses('product-icon', themeModifier),
      iconFileName: iconFileName,
      size: 36
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('action-column') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('action-text', 'primary') },
        row.ProductSymbol + ' ' + row.ProductFullName
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('action-text', 'secondary') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            {
              to: '/wallets/wallet-detail',
              style: {
                display: 'flex',
                alignItems: 'center'
              },
              onClick: function onClick() {
                return _onClick(ProductId);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                style: {
                  marginTop: '-1rem',
                  marginBottom: '-1rem',
                  display: 'flex',
                  alignItems: 'center'
                } },
              context.t('Details'),
              ' ',
              '   ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], {
                name: 'arrowNext',
                customClass: baseClasses('type-icon')
              })
            )
          )
        )
      )
    )
  );
};

var Text = function Text(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { classame: baseClasses('amount') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('amount-quantity') },
      props.text
    )
  );
};

var MarketPrice = function MarketPrice(_ref) {
  var NotionalValue = _ref.NotionalValue,
      NotionalProductSymbol = _ref.NotionalProductSymbol;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('amount'), style: { paddingLeft: '2.6rem' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('amount-quantity') },
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(NotionalValue, NotionalProductSymbol) + ' ' + NotionalProductSymbol
    )
  );
};

var Amount = function Amount(props) {
  var _props$value = props.value,
      ProductSymbol = _props$value.ProductSymbol,
      rawAmount = _props$value.rawAmount;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('amount') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('amount-quantity') },
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(rawAmount, ProductSymbol) + ' ' + ProductSymbol
    )
  );
};

var InterestAmount = function InterestAmount(_ref2) {
  var ProductSymbol = _ref2.ProductSymbol,
      Amount = _ref2.Amount;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('amount') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('amount-quantity') },
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Amount, ProductSymbol) + ' ' + ProductSymbol
    )
  );
};

Action.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InterestPaymentsWithFilterContainer__ = __webpack_require__(2137);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InterestPaymentsWithFilterContainer__["a" /* default */]);

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InterestPaymentsWithFilterComponent__ = __webpack_require__(2138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_resize__ = __webpack_require__(73);





var InterestPaymentsWithFilterComponentForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'interest-payments',
  destroyOnUnmount: false,
  initialValues: {
    type: 'all',
    startDate: undefined,
    endDate: undefined
  }
})(__WEBPACK_IMPORTED_MODULE_2__InterestPaymentsWithFilterComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])()(Object(__WEBPACK_IMPORTED_MODULE_3__hocs_resize__["a" /* default */])(InterestPaymentsWithFilterComponentForm)));

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InterestPaymentsHeaderWithFilter_InterestPaymentsHeaderWithFilterComponent__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InterestPaymentsTableWithFilter__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecentActivity_ActivityComponents_css__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecentActivity_ActivityComponents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RecentActivity_ActivityComponents_css__);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var RecentActivityWithFilterComponent = function RecentActivityWithFilterComponent(props, context) {
  var width = props.width,
      themeModifier = props.themeModifier,
      payments = props.payments;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InterestPaymentsHeaderWithFilter_InterestPaymentsHeaderWithFilterComponent__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__InterestPaymentsTableWithFilter__["a" /* default */], {
      payments: payments,
      themeModifier: themeModifier,
      width: width,
      context: context
    })
  );
};

RecentActivityWithFilterComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RecentActivityWithFilterComponent);

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InterestPaymentsHeaderFormContainer__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);





var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var InterestPaymentsHeaderWithFilterComponent = function InterestPaymentsHeaderWithFilterComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('header-bar') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('header-text') },
        context.t('Interest Payments')
      ),
      props.children
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InterestPaymentsHeaderFormContainer__["a" /* default */], null)
  );
};

InterestPaymentsHeaderWithFilterComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (InterestPaymentsHeaderWithFilterComponent);

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InterestPaymentsHeaderFormComponent__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_paginationActions__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_productPositionSelectors__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_interestAccountActions__ = __webpack_require__(202);







var FORM = 'interest-payments';

var mapStateToProps = function mapStateToProps(state) {
  var formValue = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])(FORM);

  return {
    endDate: formValue(state, 'endDate'),
    products: Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_productPositionSelectors__["d" /* productPositionAssetsSelector */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getInterestBalances: function getInterestBalances() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_interestAccountActions__["d" /* getInterestBalances */])());
    },
    setEndDate: function setEndDate(value) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(FORM, 'endDate', value));
    },
    clearFilters: function clearFilters() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(FORM, 'startDate', null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(FORM, 'endDate', null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(FORM, 'product', 'all'));
    },
    resetActivePage: function resetActivePage() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_paginationActions__["b" /* setActivePage */])({ componentName: 'InterestPaymentsTable', activePage: 0 }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__InterestPaymentsHeaderFormComponent__["a" /* default */]));

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect_APSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APDatePicker_APDatePicker__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var InterestPaymentsHeaderFormComponent = function InterestPaymentsHeaderFormComponent(props, context) {
  var getInterestBalances = props.getInterestBalances,
      resetActivePage = props.resetActivePage,
      setEndDate = props.setEndDate,
      clearFilters = props.clearFilters,
      endDate = props.endDate,
      products = props.products;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { className: baseClasses('select-buttons', 'interest-payments') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect_APSelect__["b" /* default */], {
      name: 'product',
      customClass: baseClasses(),
      label: context.t('Product:'),
      options: [{
        value: 'all',
        label: context.t('All')
      }].concat(products.map(function (i) {
        return {
          value: i.ProductId,
          label: context.t(i.ProductFullName)
        };
      })),
      onSelect: resetActivePage,
      showTriangles: true
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APDatePicker_APDatePicker__["a" /* default */], {
      name: 'startDate',
      customClass: baseClasses('from'),
      customChange: function customChange(value) {
        resetActivePage();
        if (value && !endDate) {
          setEndDate(new Date());
        }
      },
      label: context.t('Date range:'),
      format: function format(value) {
        return value;
      },
      maxDate: new Date()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APDatePicker_APDatePicker__["a" /* default */], {
      name: 'endDate',
      customClass: baseClasses('to'),
      label: context.t('to'),
      format: function format(value) {
        return value;
      },
      customChange: resetActivePage,
      maxDate: new Date()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
      {
        customClass: baseClasses(),
        classModifiers: 'clear-filters',
        type: 'button',
        onClick: clearFilters },
      context.t('Clear Filters')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
      {
        customClass: baseClasses(),
        classModifiers: 'clear-filters',
        type: 'button',
        onClick: getInterestBalances },
      context.t('Refresh')
    )
  );
};

InterestPaymentsHeaderFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (InterestPaymentsHeaderFormComponent);

/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InterestPaymentsTableWithFilterContainer__ = __webpack_require__(2143);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InterestPaymentsTableWithFilterContainer__["a" /* default */]);

/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InterestPayments_InterestPaymentsTable___ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_interestBearingAccountsSelectors__ = __webpack_require__(417);




var mapStateToProps = function mapStateToProps(state) {
  return {
    interestPayments: Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_interestBearingAccountsSelectors__["a" /* filteredInterestPaymentsSelector */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__InterestPayments_InterestPaymentsTable___["a" /* default */]));

/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InterestPaymentsTableContainer__ = __webpack_require__(2145);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InterestPaymentsTableContainer__["a" /* default */]);

/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InterestPaymentsTableComponent__ = __webpack_require__(2146);



var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    themeModifier: ownProps.themeModifier
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__InterestPaymentsTableComponent__["a" /* default */]));

/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__ = __webpack_require__(2147);






var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var InterestPaymentsTable = function InterestPaymentsTable(props, context) {
  var usePagination = props.usePagination,
      interestPayments = props.interestPayments;


  var columns = [{
    header: context.t('Product'),
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["a" /* Action */], {
        value: row,
        showProductIcon: true,
        themeModifier: props.themeModifier
      });
    }
  }, {
    header: context.t('Date'),
    width: '15rem',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["c" /* DateTime */], { value: row.TimeStamp });
    }
  }, {
    header: context.t('Payout Quantity'),
    width: '20rem',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["b" /* Amount */], { value: row });
    }
  }, {
    header: context.t('Transaction ID'),
    width: '40rem',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActivityCellComponents__["d" /* Status */], { value: row });
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APTable__["a" /* default */], {
    componentName: 'InterestPaymentsTable',
    columns: columns,
    pageSize: 6,
    minRow: 6,
    rows: interestPayments,
    baseClass: baseClasses,
    headerOutside: true,
    usePagination: usePagination,
    empty: context.t('No data is available')
  });
};

InterestPaymentsTable.defaultProps = {
  usePagination: false
};

InterestPaymentsTable.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (InterestPaymentsTable);

/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Amount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DateTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActivityComponents_css__ = __webpack_require__(2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActivityComponents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ActivityComponents_css__);











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('activity');

var Action = function Action(props, context) {
  var themeModifier = props.themeModifier;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('action') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIcon__["a" /* default */], { name: 'sell', customClass: baseClasses('type-icon') }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__["a" /* default */], {
      customClass: baseClasses('product-icon', themeModifier),
      iconFileName: props.value.iconFileName,
      size: 36
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('action-column') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('action-text', 'primary') },
        context.t('Earned ' + props.value.Product)
      )
    )
  );
};

var Amount = function Amount(props) {
  var _props$value = props.value,
      ProductSymbol = _props$value.ProductSymbol,
      CR = _props$value.CR;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('amount'), style: { paddingLeft: '2.8rem' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('amount-quantity') },
      Object(__WEBPACK_IMPORTED_MODULE_5__helpers_numberFormatter__["b" /* formatNumberToLocale */])(CR, ProductSymbol) + ' ' + ProductSymbol
    )
  );
};

var Status = function Status(props, context) {
  var TransactionId = props.value.TransactionId;
  var customClass = props.customClass;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: customClass + ' ' + baseClasses('status') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('status-id') },
      TransactionId
    )
  );
};

var DateTime = function DateTime(props) {
  var TimeStamp = props.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses('date', 'noPadLeft') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('date-date') },
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_dateHelper__["b" /* formatDate */])(TimeStamp)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('date-time') },
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_dateHelper__["d" /* formatTime */])(TimeStamp)
    )
  );
};

Action.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

Status.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

Status.defaultProps = {
  customClass: ''
};

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_interestBearingAccountsSelectors__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__ = __webpack_require__(7);








var RatesHeading = function RatesHeading(_ref, context) {
  var history = _ref.history,
      accountStatus = _ref.accountStatus,
      total = _ref.total;

  if (!accountStatus) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'left' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        null,
        context.t('Start Earning Interest on your Balances')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('AlphaPoint APEX allows you to automatically lend your balances to a partner liquidity pool to collect highly competitive, daily payouts.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('Your balances remain in you account, and you will be able to redeem your funds at any time.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t("Don't wait, enable interests now.")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__components_common_APButton__["a" /* default */],
        {
          onClick: function onClick() {
            return history.push('/settings/iba');
          },
          classModifiers: 'enable',
          type: 'button',
          style: { width: '70%' },
          customClass: 'standalone-form' },
        context.t('ENABLE')
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'left' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h1',
      null,
      context.t('You Are Earning on your Balances')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      context.t('So Far, APEX has earned you:')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'rate' },
      '$',
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(total, 'USD')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'small',
      null,
      context.t('Approx. notional amount based on current market rates')
    )
  );
};

RatesHeading.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    total: Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_interestBearingAccountsSelectors__["c" /* totalInterestPaymentsSelector */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["g" /* withRouter */])(RatesHeading)));

/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);





var RatesGrid = function RatesGrid(_ref, context) {
  var productsList = _ref.productsList,
      rates = _ref.rates;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'right' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      context.t("Today's Estimated Rates")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rates-grid' },
      productsList.filter(function (i) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(rates, [i.ProductId, 'IsEnabled'], false);
      }).map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rates-grid-item', key: i.ProductFullName },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_ProductIcon_ProductIconContainer__["a" /* default */], {
              product: i,
              iconFileName: i.iconFileName,
              size: 48
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'text' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                i.ProductSymbol
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                i.ProductFullName
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'rate' },
              rates[i.ProductId].Rate + '%'
            )
          )
        );
      })
    )
  );
};

RatesGrid.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (RatesGrid);

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentRowDual8020_css__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentRowDual8020_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ComponentRowDual8020_css__);




var ComponentRowDual8020 = function ComponentRowDual8020(props) {
  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('component8020-row-dual', props.customClass);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: '' + bemClasses('component-container-left') },
      props.component1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: '' + bemClasses('component-container-right') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('component-container-right-content') },
        props.component2
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ComponentRowDual8020);

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StreamingCardComponent__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StreamingCardGrid_css__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StreamingCardGrid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__StreamingCardGrid_css__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








var streamingCardGridClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('streaming-card-grid');

var TIF_GTC = 'TIF: GTC';
var TIF_FOK = 'TIF: FOK';
var TIF_IOC = 'TIF: IOC';

var StreamingCardGrid = function StreamingCardGrid(props) {
  var defaultCardData = props.instruments.map(function () {
    return {
      qty: 0,
      orderTypeValue: TIF_GTC,
      slipage: 10,
      min: 0,
      max: 0,
      newBuyPrice: '',
      newSellPrice: '',
      limitBuyPrice: '',
      limitSellPrice: ''
    };
  });

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentPos = _useState2[0],
      setCurrentPos = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentVal = _useState4[0],
      setCurrentVal = _useState4[1];

  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultCardData),
      _useState6 = _slicedToArray(_useState5, 2),
      defaultSelection = _useState6[0],
      setDefaultSelection = _useState6[1];

  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
      _useState8 = _slicedToArray(_useState7, 2),
      timezone = _useState8[0],
      setTimezone = _useState8[1];

  var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(TIF_GTC),
      _useState10 = _slicedToArray(_useState9, 2),
      orderTypeCounter = _useState10[0],
      setOrderTypeCounter = _useState10[1];

  var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([{
    value: TIF_GTC,
    label: TIF_GTC
  }, {
    value: TIF_FOK,
    label: TIF_FOK
  }, {
    value: TIF_IOC,
    label: TIF_IOC
  }]),
      _useState12 = _slicedToArray(_useState11, 2),
      orderType = _useState12[0],
      setOrderType = _useState12[1];

  var selectOrderType = function selectOrderType(position, e) {
    var newSelection = Object.assign({}, defaultSelection);
    newSelection[position].orderTypeValue = e.target.value;
    newSelection[position].slipage = 10;

    setDefaultSelection(newSelection);
    setOrderTypeCounter(e.target.value);

    if (e.target.value == TIF_GTC) {
      setTimeout(function () {
        setDefaultSlippage(0);
      }, 100);
    } else {
      setTimeout(function () {
        setDefaultSlippage(10);
      }, 100);
    }
  };

  var clearForm = function clearForm() {
    var result = Object.assign({}, defaultSelection);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.entries(result)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = _slicedToArray(_ref, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        result[key].qty = 0;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    setCurrentPos(-1);
    setCurrentVal(-1);
    setDefaultSelection(result);
    props.reset();
  };

  var getCurrentTime = function getCurrentTime() {
    var today = new Date().toGMTString();
    var currentTimezoneSplit = today.split(' ');
    var extractTime = currentTimezoneSplit[4] + ' UTC';
    return extractTime;
  };

  var setQuantityDataForSelection = function setQuantityDataForSelection(selectedPosition, selectedValue) {
    if (currentPos != -1) {
      var instrumentId = props.instruments[selectedPosition].InstrumentId;
      var newSelection = Object.assign({}, defaultSelection);

      if (selectedPosition != currentPos) {
        props.changeReduxForm({ field: 'quantity-' + currentPos, value: 0 });
        newSelection[currentPos].qty = 0;
        newSelection[currentPos].newBuyPrice = '';
        newSelection[currentPos].newSellPrice = '';
        newSelection[currentPos].limitBuyPrice = '';
        newSelection[currentPos].limitSellPrice = '';
      }

      if (instrumentId != props.selectedInstrumentId) {
        props.setInstrument({
          selectedInstrumentId: props.selectedInstrumentId,
          instrumentId: instrumentId
        });
      }

      var newBuyPrice = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["d" /* getPriceDataForQuantitiesSelector */])(props.state, '0', [parseFloat(selectedValue)]);
      var newSellPrice = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_buySellSelectors__["d" /* getPriceDataForQuantitiesSelector */])(props.state, '1', [parseFloat(selectedValue)]);

      newSelection[selectedPosition].qty = parseFloat(selectedValue);
      newSelection[selectedPosition].newBuyPrice = newBuyPrice[0].pricePerUnit != null ? newBuyPrice[0].pricePerUnit : '';
      newSelection[selectedPosition].newSellPrice = newSellPrice[0].pricePerUnit != null ? newSellPrice[0].pricePerUnit : '';
      newSelection[selectedPosition].limitBuyPrice = newBuyPrice[0].limitPrice != null ? newBuyPrice[0].limitPrice : '';
      newSelection[selectedPosition].limitSellPrice = newSellPrice[0].limitPrice != null ? newSellPrice[0].limitPrice : '';
      setDefaultSelection(newSelection);
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (props.formData && props.formData.active && props.formData.active.includes('slipage')) {
      var selectedPosition = props.formData.active.split('-')[1];
      var selectedValue = props.formData.values ? props.formData.values[props.formData.active] : 0;

      if (selectedValue > 0) {
        var newSelection = Object.assign({}, defaultSelection);
        newSelection[selectedPosition].slipage = parseFloat(selectedValue);
        setDefaultSelection(newSelection);
      }
    } else if (props.formData && props.formData.active && props.formData.active.includes('quantity')) {
      var _selectedPosition = props.formData.active.split('-')[1];
      var _selectedValue = props.formData.values ? props.formData.values[props.formData.active] : 0;

      setCurrentPos(_selectedPosition);
      setCurrentVal(_selectedValue);

      setQuantityDataForSelection(_selectedPosition, _selectedValue);
    }
  }, [props.formData]);

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var interval = setInterval(function () {
      setTimezone(getCurrentTime());
    }, 1000);
    return function () {
      clearInterval(interval);
    };
  }, []);

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setQuantityDataForSelection(currentPos, currentVal);
  }, [props.level1]);

  var setDefaultSlippage = function setDefaultSlippage(value) {
    props.instruments.map(function (item, position) {
      props.changeReduxForm({ field: 'slipage-' + position, value: value });
    });
  };

  var items = props.instruments.map(function (item, position) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StreamingCardComponent__["a" /* default */], {
      key: position,
      defaultSelection: defaultSelection,
      position: position,
      instrument: item,
      formData: props.formData,
      products: props.products,
      level1: props.level1,
      productManifest: props.productManifest,
      orderType: orderType,
      selectOrderType: selectOrderType,
      timezone: timezone,
      AccountId: props.AccountId,
      showNotification: props.showNotification,
      state: props.state,
      clearForm: clearForm,
      selectedInstrumentId: props.selectedInstrumentId,
      additionalSlipage: props.additionalSlipage
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    props.fetching || !!items.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: streamingCardGridClasses() },
      props.fetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Spinner_Spinner__["a" /* default */], null) : items
    ) : ''
  );
};

/* harmony default export */ __webpack_exports__["a"] = (StreamingCardGrid);

/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bignumber_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bignumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmOrderModal__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hocs_resize__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_recalculateOrderFeeHelper__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StreamingCard_css__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StreamingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__StreamingCard_css__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
















var streamingCardClasses = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_cssClassesHelper__["b" /* getBEMClasses */])('streaming-card');
var TIF_GTC = 'TIF: GTC';
var TIF_FOK = 'TIF: FOK';
var TIF_IOC = 'TIF: IOC';
var TIMEINFORCE_GTC = '1';
var TIMEINFORCE_FOK = '4';
var TIMEINFORCE_IOC = '3';
var MARKET_ORDER = 'Market Order';
var LIMIT_ORDER = 'Limit Order';

var StreamingCard = function StreamingCard(props, context) {
  var defaultSelection = props.defaultSelection,
      position = props.position,
      instrument = props.instrument,
      products = props.products,
      level1 = props.level1,
      selectOrderType = props.selectOrderType,
      productManifest = props.productManifest,
      timezone = props.timezone,
      AccountId = props.AccountId,
      showNotification = props.showNotification,
      clearForm = props.clearForm,
      selectedInstrumentId = props.selectedInstrumentId,
      additionalSlipage = props.additionalSlipage;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      isConfirmModalOpen = _useState2[0],
      setConfirmModal = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      form = _useState4[0],
      setForm = _useState4[1];

  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      metaData = _useState6[0],
      setMetaData = _useState6[1];

  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ OrderFee: 0, productId: 0 }),
      _useState8 = _slicedToArray(_useState7, 2),
      orderFee = _useState8[0],
      setOrderFee = _useState8[1];

  var dismissConfirmModal = function dismissConfirmModal() {
    setConfirmModal(false);
  };

  var fetchOrderFee = function fetchOrderFee(orderFeeData) {
    Object(__WEBPACK_IMPORTED_MODULE_10__helpers_recalculateOrderFeeHelper__["a" /* getOrderFee */])(orderFeeData).then(function (result) {
      var data = Object.assign({}, result, {
        product: products.find(function (prod) {
          return prod.ProductId === result.ProductId;
        }).Product
      });
      setOrderFee(data);
    });
  };

  var handleSubmit = function handleSubmit(form, orderFeeData, confirmationModalProps) {
    fetchOrderFee(orderFeeData);
    setConfirmModal(true);
    setForm(form);
    setMetaData(confirmationModalProps);
  };

  var currentLevel = level1[instrument.InstrumentId];

  var getProductName = function getProductName(product) {
    var search = products.find(function (prod) {
      return prod.Product === product;
    });
    if (search) {
      return search.ProductFullName;
    } else {
      return product;
    }
  };

  var calculateSpread = function calculateSpread(bestBid, bestOffer) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(Math.abs(bestBid - bestOffer), Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement));
  };

  var fetchProductFileName = function fetchProductFileName(symbol) {
    return Object.keys(productManifest.manifest).indexOf(symbol) === -1 ? symbol + 'DEFAULT_ICON' : productManifest.manifest[symbol].iconFileName;
  };

  var fetchStartChars = function fetchStartChars(input) {
    var startString = '';
    var middleString = '';
    var endString = '';

    var middleIndex = input.length / 2;
    var leftIndex = input.length % 2 == 0 ? middleIndex - 2 : middleIndex - 1;
    var rightIndex = input.length % 2 == 0 ? middleIndex + 1 : middleIndex + 2;

    startString = input.substring(0, leftIndex);
    middleString = input.substring(leftIndex, rightIndex);
    endString = input.substring(rightIndex, input.length);

    if (middleString.includes('.') || middleString.includes(',')) {
      leftIndex = leftIndex - 1;
      startString = input.substring(0, leftIndex);
    }

    return startString;
  };

  var fetchMiddleChars = function fetchMiddleChars(input) {
    var startString = '';
    var middleString = '';
    var endString = '';

    var middleIndex = input.length / 2;
    var leftIndex = input.length % 2 == 0 ? middleIndex - 2 : middleIndex - 1;
    var rightIndex = input.length % 2 == 0 ? middleIndex + 1 : middleIndex + 2;

    startString = input.substring(0, leftIndex);
    middleString = input.substring(leftIndex, rightIndex);
    endString = input.substring(rightIndex, input.length);

    if (middleString.includes('.') || middleString.includes(',')) {
      leftIndex = leftIndex - 1;
    }

    middleString = input.substring(leftIndex, rightIndex);
    return middleString;
  };

  var fetchLastChars = function fetchLastChars(input) {
    var endString = '';
    var middleIndex = input.length / 2;
    var leftIndex = input.length % 2 == 0 ? middleIndex - 2 : middleIndex - 1;
    var rightIndex = input.length % 2 == 0 ? middleIndex + 1 : middleIndex + 2;
    endString = input.substring(rightIndex, input.length);
    return endString;
  };

  var buyPrice = defaultSelection[position].newBuyPrice == '' ? Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(currentLevel.BestOffer, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)) : defaultSelection[position].newBuyPrice;

  var sellPrice = defaultSelection[position].newSellPrice == '' ? Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(currentLevel.BestBid, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)) : defaultSelection[position].newSellPrice;

  var limitBuyPrice = defaultSelection[position].limitBuyPrice == '' ? Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(currentLevel.BestOffer, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)) : defaultSelection[position].limitBuyPrice;

  var limitSellPrice = defaultSelection[position].limitSellPrice == '' ? Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(currentLevel.BestBid, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)) : defaultSelection[position].limitSellPrice;

  var maxValue = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["g" /* parseNumberToLocale */])(buyPrice)) + parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["g" /* parseNumberToLocale */])(buyPrice)) * (parseFloat(defaultSelection[position].slipage) + additionalSlipage) * 0.0001, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement));

  var minValue = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["g" /* parseNumberToLocale */])(sellPrice)) - parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["g" /* parseNumberToLocale */])(sellPrice)) * (parseFloat(defaultSelection[position].slipage) + additionalSlipage) * 0.0001, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement));

  var maxLimitValue = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["g" /* parseNumberToLocale */])(limitBuyPrice)) + parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["g" /* parseNumberToLocale */])(limitBuyPrice)) * (parseFloat(defaultSelection[position].slipage) + additionalSlipage) * 0.0001, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement));

  var minLimitValue = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["g" /* parseNumberToLocale */])(limitSellPrice)) - parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["g" /* parseNumberToLocale */])(limitSellPrice)) * (parseFloat(defaultSelection[position].slipage) + additionalSlipage) * 0.0001, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement));

  var buildOrderForm = function buildOrderForm(orderType, currentLevel, selectedInstrument, inputPrice, selectedSide, timeInForce, selectedPosition, limitPrice, minmaxLimitValue) {
    var price = inputPrice.replace(',', '');
    var orderFree = 0;
    var productId = selectedInstrument.Product1;
    var quantity = defaultSelection[position].qty;
    var slippage = defaultSelection[position].slipage;
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    var side = selectedSide;
    var stopPrice = '';
    var totalAmount = '0';

    var form = {
      fee: orderFee,
      limitPrice: limitPrice,
      orderType: orderType,
      quantity: quantity,
      selectedInstrumentId: selectedInstrumentId,
      side: side,
      stopPrice: stopPrice,
      timeInForce: timeInForce,
      totalAmount: totalAmount
    };

    var orderFeeData = {
      OMSId: currentLevel.OMSId,
      AccountId: AccountId,
      InstrumentId: selectedInstrumentId,
      Amount: defaultSelection[position].qty,
      Quantity: defaultSelection[position].qty,
      Side: side,
      Price: price,
      OrderType: orderType,
      BestBid: currentLevel.BestBid,
      BestOffer: currentLevel.BestOffer
    };

    var orderTotal = new __WEBPACK_IMPORTED_MODULE_2_bignumber_js___default.a(price).times(new __WEBPACK_IMPORTED_MODULE_2_bignumber_js___default.a(quantity));

    var confirmationModalProps = {
      marketPrice: price,
      orderTotal: Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(orderTotal, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(selectedInstrument.PriceIncrement)),
      Product1Symbol: selectedInstrument.Product1Symbol,
      Product2Symbol: selectedInstrument.Product2Symbol,
      isBuySide: selectedSide == '0' ? true : false,
      minmaxLimitValue: minmaxLimitValue
    };
    handleSubmit(form, orderFeeData, confirmationModalProps);
  };

  var placeBuyOrder = function placeBuyOrder(instrument, price, selectedPosition, minmaxValue, minmaxLimitValue) {
    var timeInForce = defaultSelection[position].orderTypeValue == TIF_GTC ? TIMEINFORCE_GTC : defaultSelection[position].orderTypeValue == TIF_IOC ? TIMEINFORCE_IOC : TIMEINFORCE_FOK;

    var orderType = defaultSelection[position].orderTypeValue == TIF_GTC ? MARKET_ORDER : LIMIT_ORDER;

    var selectedPrice = defaultSelection[position].orderTypeValue == TIF_GTC ? price : minmaxLimitValue;

    var limitPrice = defaultSelection[position].orderTypeValue == TIF_GTC ? price : minmaxLimitValue;

    if (defaultSelection[position].qty <= 0) {
      showNotification('Please enter valid quantity');
      return;
    }

    if (defaultSelection[position].orderTypeValue != TIF_GTC && defaultSelection[position].slipage <= 0) {
      showNotification('Please enter valid slippage');
      return;
    }

    buildOrderForm(orderType, currentLevel, instrument, selectedPrice, 0, timeInForce, selectedPosition, limitPrice, minmaxLimitValue);
  };

  var placeSellOrder = function placeSellOrder(instrument, price, selectedPosition, minmaxValue, minmaxLimitValue) {
    var timeInForce = defaultSelection[position].orderTypeValue == TIF_GTC ? TIMEINFORCE_GTC : defaultSelection[position].orderTypeValue == TIF_IOC ? TIMEINFORCE_IOC : TIMEINFORCE_FOK;

    var orderType = defaultSelection[position].orderTypeValue == TIF_GTC ? MARKET_ORDER : LIMIT_ORDER;

    var selectedPrice = defaultSelection[position].orderTypeValue == TIF_GTC ? price : minmaxLimitValue;

    var limitPrice = defaultSelection[position].orderTypeValue == TIF_GTC ? '' : minmaxLimitValue;

    if (defaultSelection[position].qty <= 0) {
      showNotification('Please enter valid quantity');
      return;
    }

    if (defaultSelection[position].orderTypeValue != TIF_GTC && defaultSelection[position].slipage <= 0) {
      showNotification('Please enter valid slippage');
      return;
    }

    buildOrderForm(orderType, currentLevel, instrument, selectedPrice, 1, timeInForce, selectedPosition, limitPrice, minmaxLimitValue);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: (defaultSelection[position].orderTypeValue != TIF_GTC ? streamingCardClasses('expanded') : streamingCardClasses()) + ' container-with-shadow' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: streamingCardClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
        label: getProductName(instrument.Product1Symbol) + ' / ' + getProductName(instrument.Product2Symbol),
        text: instrument.Symbol,
        customClass: streamingCardClasses(),
        classModifiers: 'header'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: streamingCardClasses('product-icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_ProductIcon_ProductIconContainer__["a" /* default */], {
          iconFileName: fetchProductFileName(instrument.Product1Symbol),
          size: 32
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: streamingCardClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
        label: context.t('24-Hour Low'),
        text: Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(currentLevel.SessionLow, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
        customClass: streamingCardClasses()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
        label: context.t('Spread'),
        text: calculateSpread(currentLevel.BestBid, currentLevel.BestOffer),
        customClass: streamingCardClasses(),
        classModifiers: 'spread-text'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
        label: context.t('24-Hour High'),
        text: Object(__WEBPACK_IMPORTED_MODULE_8__helpers_numberFormatter__["b" /* formatNumberToLocale */])(currentLevel.SessionHigh, Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement)),
        customClass: streamingCardClasses(),
        z: true,
        classModifiers: 'high-hour-text'
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: streamingCardClasses('qty-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APNumberInput__["a" /* default */], {
        type: 'text',
        placeholder: '0',
        name: 'quantity-' + position,
        classModifiers: 'quantity',
        customClass: streamingCardClasses(),
        decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.QuantityIncrement),
        step: instrument.QuantityIncrement
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: streamingCardClasses('sell-buy-container-for-graph') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: streamingCardClasses('sell-buy-container1') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: streamingCardClasses('sell-buy-container-graph') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: streamingCardClasses('sell-buy-container-graph-mirror') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
              onClick: function onClick() {
                return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
              },
              className: streamingCardClasses('lshapevertical-sell')
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
              onClick: function onClick() {
                return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
              },
              className: streamingCardClasses('lshapehorizontal-sell')
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: streamingCardClasses('lshapeinside-sell') }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
              onClick: function onClick() {
                return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
              },
              className: streamingCardClasses('lshapeoutside-sell')
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: streamingCardClasses('sell-buy-container2') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: streamingCardClasses('sell-buy-container-graph') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            onClick: function onClick() {
              return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
            },
            className: streamingCardClasses('lshapevertical-buy')
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            onClick: function onClick() {
              return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
            },
            className: streamingCardClasses('lshapehorizontal-buy')
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            onClick: function onClick() {
              return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
            },
            className: streamingCardClasses('lshapeinside-buy')
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            onClick: function onClick() {
              return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
            },
            className: streamingCardClasses('lshapeoutside-buy')
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: streamingCardClasses('buy-sell-text-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: streamingCardClasses('buy-sell-text-container-top') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            onClick: function onClick() {
              return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
            },
            className: streamingCardClasses('buy-text-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: streamingCardClasses('width-match-parent') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                className: streamingCardClasses('sell-text-container-span-left') },
              'Sell'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: streamingCardClasses('sell-text-container'),
            onClick: function onClick() {
              return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: streamingCardClasses('width-match-parent') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                className: streamingCardClasses('sell-text-container-span-right') },
              'Buy'
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: streamingCardClasses('buy-sell-price-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: streamingCardClasses('sell-price') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            onClick: function onClick() {
              return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
            },
            className: streamingCardClasses('sell-text-span') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            fetchStartChars(sellPrice)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: streamingCardClasses('magnifyNumber') },
            fetchMiddleChars(sellPrice)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            fetchLastChars(sellPrice)
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: streamingCardClasses('buy-price') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            onClick: function onClick() {
              return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
            },
            className: streamingCardClasses('buy-text-span') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            fetchStartChars(buyPrice)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: streamingCardClasses('magnifyNumber') },
            fetchMiddleChars(buyPrice)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            fetchLastChars(buyPrice)
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: streamingCardClasses('timezone') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: streamingCardClasses('small-text-span') },
          timezone
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'select',
          {
            value: defaultSelection[position].orderTypeValue,
            onChange: function onChange(value) {
              return selectOrderType(position, value);
            },
            className: streamingCardClasses('ap-instrument-type-select') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: TIF_GTC },
            TIF_GTC
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: TIF_FOK },
            TIF_FOK
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: TIF_IOC },
            TIF_IOC
          )
        )
      )
    ),
    defaultSelection[position].orderTypeValue != TIF_GTC && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: streamingCardClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: streamingCardClasses('slip-page-text') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: streamingCardClasses('small-text-span') },
            'Allowed slippage (bps)'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APNumberInput__["a" /* default */], {
          type: 'text',
          placeholder: '10',
          name: 'slipage-' + position,
          classModifiers: 'slippage',
          customClass: streamingCardClasses(),
          decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_9__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(instrument.PriceIncrement),
          step: instrument.PriceIncrement
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: streamingCardClasses('min-max') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: streamingCardClasses('small-text-span') },
            'Min:',
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'font',
              { className: streamingCardClasses('footer-text-span-min') },
              minLimitValue
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: streamingCardClasses('small-text-span') },
            'Max:',
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'font',
              { className: streamingCardClasses('footer-text-span-max') },
              maxLimitValue
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ConfirmOrderModal__["a" /* default */], {
      isConfirmModalOpen: isConfirmModalOpen,
      formData: form,
      dismissConfirmModal: dismissConfirmModal,
      orderFee: orderFee,
      metaData: metaData,
      priceIncrement: instrument.PriceIncrement,
      quantityIncrement: instrument.QuantityIncrement,
      clearForm: clearForm,
      selectedInstrumentId: selectedInstrumentId
    })
  );
};

StreamingCard.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__hocs_resize__["a" /* default */])(StreamingCard));

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmOrderModalContainer__ = __webpack_require__(2158);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ConfirmOrderModalContainer__["a" /* default */]);

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_level1Actions__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_level2Actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_instrumentActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConfirmOrderModalComponent__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs_modalDecorator__ = __webpack_require__(25);












var streamingForm = 'StreamingForm';

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetForm: function resetForm() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["k" /* reset */])(streamingForm));
    },
    setInstrument: function setInstrument(payload) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_instrumentActions__["f" /* setInstrument */])(payload.instrumentId));
      // resubscribe to level2
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_level1Actions__["c" /* subscribeToLevel1 */])(payload.instrumentId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_level2Actions__["g" /* unsubscribeLevel2 */])(payload.selectedInstrumentId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_level2Actions__["e" /* getLevel2Data */])(payload.instrumentId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_level2Actions__["f" /* subscribeToLevel2 */])(payload.instrumentId));
      localStorage.setItem('selectedInstrumentId', payload.instrumentId);
    },
    confirmReport: function confirmReport(payload) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["f" /* placeOrderWithChecks */])(__WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].default, payload)).then(function (res) {
        if (res.result === false) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_snackbarActions__["e" /* showSnack */])({
            id: 'placeOrderError',
            text: res.errormsg || res.detail,
            type: 'warning'
          }));
        }
      });
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_9__ConfirmOrderModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__hocs_modalDecorator__["a" /* default */])({ name: __WEBPACK_IMPORTED_MODULE_2__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_ORDER_REPORT })(container));

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfirmOrderModal_ConfirmOrderModalComponent_css__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfirmOrderModal_ConfirmOrderModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ConfirmOrderModal_ConfirmOrderModalComponent_css__);











var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('confirm-order-modal');

var ConfirmOrderModalComponent = function ConfirmOrderModalComponent(props, context) {
  var formData = props.formData,
      isConfirmModalOpen = props.isConfirmModalOpen,
      dismissConfirmModal = props.dismissConfirmModal,
      confirmReport = props.confirmReport,
      metaData = props.metaData,
      orderFee = props.orderFee,
      resetForm = props.resetForm,
      priceIncrement = props.priceIncrement,
      quantityIncrement = props.quantityIncrement,
      clearForm = props.clearForm,
      setInstrument = props.setInstrument,
      selectedInstrumentId = props.selectedInstrumentId;


  var handleSubmit = function handleSubmit() {
    setInstrument({
      selectedInstrumentId: selectedInstrumentId,
      instrumentId: formData.selectedInstrumentId
    });
    clearForm();
    formData.fee = orderFee;
    if (formData.orderType == 'Limit Order') {
      formData.limitPrice = metaData.minmaxLimitValue;
    }

    confirmReport(formData);
    resetForm();
  };

  var items = [{
    label: context.t('Order Type:'),
    text: formData.orderType
  }, {
    label: context.t('Quantity'),
    text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(formData.quantity, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(quantityIncrement)) + (' ' + metaData.Product1Symbol)
  }, {
    label: context.t('Price'),
    text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(metaData.marketPrice, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(priceIncrement)) + (' ' + metaData.Product2Symbol)
  }, {
    label: context.t('Fee'),
    text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(orderFee.OrderFee, orderFee.product) + ' ' + orderFee.product
  }, {
    label: context.t('Value'),
    text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(formData.quantity * metaData.marketPrice, Object(__WEBPACK_IMPORTED_MODULE_7__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(priceIncrement)) + ' ' + metaData.Product2Symbol
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isConfirmModalOpen,
      title: context.t('Confirm Order'),
      close: dismissConfirmModal,
      footer: {
        buttonText: metaData.isBuySide ? context.t('Confirm Buy Order') : context.t('Confirm Sell Order'),
        buttonStyle: metaData.isBuySide ? 'additive' : 'subtractive',
        onClick: function onClick() {
          return handleSubmit();
        }
      },
      customClass: bemClasses(metaData.isBuySide ? 'bought' : 'sold') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses() },
      items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          key: item.label,
          label: item.label,
          text: item.text,
          customClass: bemClasses()
        });
      })
    )
  );
};

ConfirmOrderModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmOrderModalComponent);

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOrderFee; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placeOrderHelper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_orderTotalSelector__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_selectors_marginSelectors__ = __webpack_require__(34);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











var getOrderFee = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(form) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__apex__["a" /* default */].connection.GetOrderFee({
              OMSId: form.OMSId,
              AccountId: form.AccountId,
              InstrumentId: form.InstrumentId,
              Amount: form.Amount,
              Quantity: form.Quantity,
              Side: form.Side,
              Price: form.Price,
              OrderType: parseInt(Object(__WEBPACK_IMPORTED_MODULE_5__placeOrderHelper__["c" /* getOrderTypeByName */])(form.OrderType), 10),
              MakerTaker: Object(__WEBPACK_IMPORTED_MODULE_4__orderHelper__["m" /* isMakerOrTaker */])(form.Side, form.Price, form.BestBid, form.BestOffer, parseInt(Object(__WEBPACK_IMPORTED_MODULE_5__placeOrderHelper__["c" /* getOrderTypeByName */])(form.OrderType), 10))
            });

          case 2:
            response = _context.sent;
            return _context.abrupt('return', response);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getOrderFee(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settingsNavItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return settingsRoutesArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_load__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);





var ProfileAndSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 2572));
});
var KYCSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 820));
});
var ApiKeysLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 2573));
});
var UserContactsLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 2574));
});
var AffiliateContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 2575));
});
var LoyaltyToken = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 2576));
});
var TradeSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 419));
});
var DemoSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 822));
});
var TradeReportLayout = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 2577));
});
var IBASettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_1__hocs_load__["a" /* default */])(function () {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 824));
});

// this.context.t('Profile & Security')
// this.context.t('Verification Level')
// this.context.t('API Keys')
// this.context.t('Trade Reports')
// this.context.t('User Contacts')
// this.context.t('Affiliate Program')
// this.context.t('Loyalty Token')
// this.context.t('Demo Settings')
// this.context.t('Trade Settings')
// this.context.t('Yield Settings')
var _config$Settings = __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].Settings,
    profile = _config$Settings.profile,
    apiKeys = _config$Settings.apiKeys,
    tradeReports = _config$Settings.tradeReports,
    userContacts = _config$Settings.userContacts,
    affiliate = _config$Settings.affiliate,
    loyaltyToken = _config$Settings.loyaltyToken,
    kyc = _config$Settings.kyc,
    tradeSettings = _config$Settings.tradeSettings,
    interestBearingAccountSettings = _config$Settings.interestBearingAccountSettings,
    demoMode = _config$Settings.demoMode;

var settingsNavItems = [{
  text: 'Profile & Security',
  path: '/settings/profile',
  show: profile,
  icon: 'security'
}, {
  text: 'Trade Settings',
  path: '/settings/trade',
  show: tradeSettings,
  icon: 'tasks'
}, {
  text: 'Yield Settings',
  path: '/settings/iba',
  show: interestBearingAccountSettings,
  icon: 'sell'
}, {
  text: 'Verification Level',
  path: '/settings/verification',
  show: kyc,
  icon: 'tasks'
}, { text: 'API Keys', path: '/settings/api-keys', show: apiKeys, icon: 'key' }, {
  text: 'Trade Reports',
  path: '/settings/trade-reports',
  show: tradeReports,
  icon: 'reports'
}, {
  text: 'User Contacts',
  path: '/settings/contacts',
  show: userContacts,
  icon: 'contacts'
}, {
  text: 'Affiliate Program',
  path: '/settings/affiliate',
  show: affiliate,
  icon: 'friends'
}, {
  text: 'Loyalty Token',
  path: '/settings/loyalty-token',
  show: loyaltyToken,
  icon: 'heart'
}, {
  text: 'Demo Settings',
  path: '/settings/demo-settings',
  show: demoMode,
  icon: 'paint'
}];

var settingsRoutesArray = [{
  path: '/settings/profile',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProfileAndSettingsContainer, null);
  }
}, {
  path: '/settings/trade',
  show: tradeSettings,
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradeSettingsContainer, null);
  }
}, {
  path: '/settings/iba',
  show: interestBearingAccountSettings,
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IBASettingsContainer, null);
  }
}, {
  path: '/settings/verification',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(KYCSettingsContainer, null);
  }
}, {
  path: '/settings/api-keys',
  show: apiKeys,
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ApiKeysLayout, null);
  }
}, {
  path: '/settings/trade-reports',
  show: tradeReports,
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradeReportLayout, null);
  }
}, {
  path: '/settings/contacts',
  show: userContacts,
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UserContactsLayout, null);
  }
}, {
  path: '/settings/affiliate',
  show: affiliate,
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AffiliateContainer, {
      route: '' + window.location.origin + Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])('') + '/signup?aff='
    });
  }
}, {
  path: '/settings/loyalty-token',
  show: loyaltyToken,
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoyaltyToken, null);
  }
}, {
  path: '/settings/demo-settings',
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoSettingsContainer, null);
  }
}];

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProfileForm_ProfileFormContainer__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);






var profileAndSecurityWidgetClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['profile-and-security-widget']);

var ProfileSettingsCardComponent = function ProfileSettingsCardComponent(props, context) {
  var getLayoutHeader = function getLayoutHeader(header, classes) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('header-text') },
        header
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__["a" /* default */],
    {
      header: getLayoutHeader(context.t('Profile'), profileAndSecurityWidgetClasses),
      customClass: 'profile-and-security-widget' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProfileForm_ProfileFormContainer__["a" /* default */], null)
  );
};

ProfileSettingsCardComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ProfileSettingsCardComponent);

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfileStaticComponent__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProfileFormComponent_css__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProfileFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ProfileFormComponent_css__);






var classes = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('retail-profile-form');

var ProfileFormComponent = function ProfileFormComponent(props) {
  var showUsernameField = !props.useEmailAsUsername;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UserProfileStaticComponent__["a" /* default */], {
        showUsernameField: showUsernameField,
        userInfo: {
          email: props.formObj.email,
          username: props.formObj.username
        }
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ProfileFormComponent);

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserProfileStaticComponent_css__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserProfileStaticComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UserProfileStaticComponent_css__);







var classes = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('user-profile-form-static');

var UserProfileStaticComponent = function UserProfileStaticComponent(props, context) {
  var showUsernameField = props.showUsernameField,
      userInfo = props.userInfo;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes() },
    showUsernameField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        label: context.t('Username'),
        text: userInfo.username,
        customClass: classes()
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
        label: context.t('Email'),
        text: userInfo.email,
        customClass: classes()
      })
    )
  );
};

UserProfileStaticComponent.propTypes = {
  userInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  showUsernameField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

UserProfileStaticComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (UserProfileStaticComponent);

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToProfileFormStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitUserProfileForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__ = __webpack_require__(119);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var goToProfileFormStep = function goToProfileFormStep(step) {
  return function (dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('userProfileForm', 'step', step));
  };
};

var submitUserProfileForm = function submitUserProfileForm() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var _getState, form, userInfo, values, UserId, Config, getUserConfig, response;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), form = _getState.form, userInfo = _getState.user.userInfo;
              values = form.userProfileForm.values;
              UserId = parseInt(userInfo.UserId, 10);
              Config = [{ Value: values.fname, Key: 'fname' }, { Value: values.lname, Key: 'lname' }, { Value: values.email, Key: 'email' }];
              getUserConfig = false;
              _context.next = 7;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__userActions__["r" /* setUserConfig */])(UserId, values.username, Config, getUserConfig));

            case 7:
              response = _context.sent;

              if (response.result) {
                _context.next = 11;
                break;
              }

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'SET_USER_CONFIG_ERROR',
                text: Object(__WEBPACK_IMPORTED_MODULE_4__helpers_errorTextFormatter__["a" /* formatErrorText */])(response),
                type: 'warning'
              }));
              return _context.abrupt('return');

            case 11:

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__userActions__["u" /* updateUserConfig */])(Config));

              // context.t('Your profile has been successfully updated')
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__snackbarActions__["e" /* showSnack */])({
                id: 'SET_USER_CONFIG_SUCCESS',
                text: 'Your profile has been successfully updated',
                type: 'success'
              }));

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegionSettings_RegionSettingsContainer__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);






var profileAndSecurityWidgetClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['profile-and-security-widget']);

var RegionSettingsCardComponent = function RegionSettingsCardComponent(props, context) {
  var getLayoutHeader = function getLayoutHeader(header, classes) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('header-text') },
        header
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__["a" /* default */],
    {
      header: getLayoutHeader(context.t('Region'), profileAndSecurityWidgetClasses),
      customClass: 'profile-and-security-widget' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RegionSettings_RegionSettingsContainer__["a" /* default */], null)
  );
};

RegionSettingsCardComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RegionSettingsCardComponent);

/***/ }),
/* 2172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegionFormComponent__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegionConfirmComponent__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_APStepsComponent__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RegionSettingsComponent_css__ = __webpack_require__(2178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RegionSettingsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__RegionSettingsComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var classes = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('region-settings');

var RegionSettingsComponent = function (_React$Component) {
  _inherits(RegionSettingsComponent, _React$Component);

  function RegionSettingsComponent() {
    _classCallCheck(this, RegionSettingsComponent);

    var _this = _possibleConstructorReturn(this, (RegionSettingsComponent.__proto__ || Object.getPrototypeOf(RegionSettingsComponent)).call(this));

    _this.toggleModal = function () {
      return _this.setState({ openModal: !_this.state.openModal });
    };

    _this.onSubmit = function () {
      _this.toggleModal();
      _this.props.setUserRegionConfig();
    };

    _this.state = { openModal: false };
    return _this;
  }

  _createClass(RegionSettingsComponent, [{
    key: 'render',
    value: function render() {
      var selectedLanguage = this.props.selectedLanguage;
      var openModal = this.state.openModal;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: classes() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: classes('row') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
              label: this.context.t('Language'),
              text: selectedLanguage,
              customClass: classes()
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: classes('button-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__common_APButton__["a" /* default */],
              {
                customClass: classes(),
                disabled: openModal,
                onClick: this.toggleModal },
              this.context.t('Edit')
            )
          ),
          openModal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__common_Modal_Modal__["a" /* default */],
            {
              isOpen: openModal,
              title: this.context.t('Edit Language'),
              onCancel: this.toggleModal,
              close: this.toggleModal,
              customClass: classes('ap-modal') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_APStepsComponent__["a" /* default */], Object.assign({
              childComponents: [__WEBPACK_IMPORTED_MODULE_2__RegionFormComponent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__RegionConfirmComponent__["a" /* default */]]
            }, this.props, {
              doSubmit: this.onSubmit
            }))
          )
        )
      );
    }
  }]);

  return RegionSettingsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RegionSettingsComponent.propTypes = {
  setUserRegionConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editIsDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedLanguage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

RegionSettingsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RegionSettingsComponent);

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_LayoutTemplates_ContentWithFooterLayoutTemplate_ContentWithFooterLayoutTemplate__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegionFormComponent_css__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegionFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__RegionFormComponent_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










var regionFormClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('region-form');

var RegionForm = function RegionForm(props, context) {
  var goToNextStep = props.goToNextStep,
      translations = props.translations,
      languageNames = props.languageNames;


  var languageOptions = [{ value: 'en', label: 'English' }];

  if ((typeof translations === 'undefined' ? 'undefined' : _typeof(translations)) === 'object') {
    var availableLangs = Object.keys(translations).filter(function (i) {
      return i !== 'options';
    });
    if (availableLangs.length) {
      languageOptions = availableLangs.map(function (value) {
        return {
          value: value,
          label: languageNames[value]
        };
      });
    }
  }

  var footer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
    { customClass: regionFormClasses(), onClick: function onClick() {
        return goToNextStep();
      } },
    context.t('Next')
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: regionFormClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__common_LayoutTemplates_ContentWithFooterLayoutTemplate_ContentWithFooterLayoutTemplate__["a" /* default */],
      {
        footer: footer,
        customClass: 'retail-region-editable-cwf-lt' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: regionFormClasses('input-wrapper') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["b" /* default */], {
            name: 'language',
            label: context.t('Language'),
            customClass: regionFormClasses(),
            options: languageOptions
          })
        )
      )
    )
  );
};

RegionForm.propTypes = {
  languageNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  translations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  goToStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

RegionForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RegionForm);

/***/ }),
/* 2174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_LayoutTemplates_ContentWithFooterLayoutTemplate_ContentWithFooterLayoutTemplate__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegionConfirmComponent_css__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegionConfirmComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__RegionConfirmComponent_css__);









var baseClass = 'region-confirm';
var regionConfirmClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass);

var RegionConfirm = function RegionConfirm(props, context) {
  var formObj = props.formObj,
      languageNames = props.languageNames,
      doSubmit = props.doSubmit;


  var footer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
    { customClass: regionConfirmClasses(), onClick: doSubmit },
    context.t('Update')
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: regionConfirmClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__common_LayoutTemplates_ContentWithFooterLayoutTemplate_ContentWithFooterLayoutTemplate__["a" /* default */],
      {
        footer: footer,
        customClass: baseClass + '-cwf-lt' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: regionConfirmClasses('confirm-block') },
          context.t('Confirm')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Language'),
          text: languageNames[formObj.language],
          customClass: regionConfirmClasses()
        })
      )
    )
  );
};

RegionConfirm.propTypes = {
  formObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

RegionConfirm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RegionConfirm);

/***/ }),
/* 2177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export goToRegionFormStep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setUserRegionConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__languageActions__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userActions__ = __webpack_require__(37);




var goToRegionFormStep = function goToRegionFormStep(step) {
  return function (dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["e" /* change */])('userProfileRegion', 'step', step));
  };
};

var setUserRegionConfig = function setUserRegionConfig() {
  return function (dispatch, getState) {
    var _getState = getState(),
        userProfileRegion = _getState.form.userProfileRegion,
        userInfo = _getState.user.userInfo;

    var values = userProfileRegion.values;
    var UserId = userInfo.UserId,
        UserName = userInfo.UserName;

    var configValue = [{ Key: 'Language', Value: values.language }];

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__userActions__["r" /* setUserConfig */])(UserId, UserName, configValue));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__languageActions__["b" /* changeLanguage */])(values.language));
  };
};

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThemeForm_ThemeSettingsContainer__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);






var profileAndSecurityWidgetClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['profile-and-security-widget']);

var ThemeSettingsCardComponent = function ThemeSettingsCardComponent(props, context) {
  var getLayoutHeader = function getLayoutHeader(header, classes) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('header-text') },
        header
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__["a" /* default */],
    {
      header: getLayoutHeader(context.t('Theme'), profileAndSecurityWidgetClasses),
      customClass: 'profile-and-security-widget' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ThemeForm_ThemeSettingsContainer__["a" /* default */], null)
  );
};

ThemeSettingsCardComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ThemeSettingsCardComponent);

/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThemeConfirmComponent__ = __webpack_require__(2182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeFormComponent__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APStepsComponent__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChartEnums__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeSettingsComponent_css__ = __webpack_require__(2186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeSettingsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ThemeSettingsComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var themeClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('theme-settings');

var ThemeSettingsComponent = function (_React$Component) {
  _inherits(ThemeSettingsComponent, _React$Component);

  function ThemeSettingsComponent() {
    _classCallCheck(this, ThemeSettingsComponent);

    var _this = _possibleConstructorReturn(this, (ThemeSettingsComponent.__proto__ || Object.getPrototypeOf(ThemeSettingsComponent)).call(this));

    _this.toggleModal = function () {
      return _this.setState({ openModal: !_this.state.openModal });
    };

    _this.submitForm = function () {
      var formValues = _this.props.formValues;

      var storedValues = JSON.parse(localStorage.getItem('apexTemplate')) || {};

      formValues.theme = formValues.theme.toLowerCase();

      localStorage.setItem('apexTemplate', JSON.stringify(Object.assign({}, storedValues, formValues)));

      _this.toggleModal();
      document.location.reload(true);
    };

    _this.getChildProps = function () {
      return Object.assign({
        doSubmit: _this.submitForm
      }, _this.props);
    };

    _this.state = { openModal: false };
    return _this;
  }

  _createClass(ThemeSettingsComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var formValues = this.props.formValues;
      var openModal = this.state.openModal;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: themeClasses('main') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: themeClasses('body') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: themeClasses('row') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
              label: this.context.t('Color Theme'),
              text: formValues.theme,
              customClass: themeClasses()
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: themeClasses('row') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APLabelWithText__["a" /* default */], {
              label: this.context.t('Chart'),
              text: __WEBPACK_IMPORTED_MODULE_9__ChartEnums__["a" /* chartEnums */][formValues.chart],
              customClass: themeClasses()
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: themeClasses('button-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__common_APButton__["a" /* default */],
              { customClass: themeClasses(), onClick: this.toggleModal },
              this.context.t('Edit')
            )
          ),
          openModal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__common_Modal_Modal__["a" /* default */],
            {
              isOpen: openModal,
              title: this.context.t('Edit Theme'),
              onCancel: function onCancel() {
                var localTheme = JSON.parse(localStorage.getItem('apexTemplate')).theme;
                if (_this2.props.formValues.theme !== localTheme) {
                  _this2.props.change('theme', localTheme.charAt(0).toUpperCase() + localTheme.slice(1));
                }
                _this2.toggleModal();
              },
              close: this.toggleModal,
              customClass: themeClasses('ap-modal') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APStepsComponent__["a" /* default */], Object.assign({
              childComponents: [__WEBPACK_IMPORTED_MODULE_4__ThemeFormComponent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__ThemeConfirmComponent__["a" /* default */]]
            }, this.getChildProps()))
          )
        )
      );
    }
  }]);

  return ThemeSettingsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ThemeSettingsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


ThemeSettingsComponent.propTypes = {
  formValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ThemeSettingsComponent);

/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_LayoutTemplates_ContentWithFooterLayoutTemplate_ContentWithFooterLayoutTemplate__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChartEnums__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeConfirmComponent_css__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeConfirmComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ThemeConfirmComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('theme-confirm');

var ThemeConfirm = function (_React$Component) {
  _inherits(ThemeConfirm, _React$Component);

  function ThemeConfirm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ThemeConfirm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeConfirm.__proto__ || Object.getPrototypeOf(ThemeConfirm)).call.apply(_ref, [this].concat(args))), _this), _this.update = function () {
      _this.props.doSubmit();
      _this.props.goToStep(0);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThemeConfirm, [{
    key: 'render',
    value: function render() {
      var formValues = this.props.formValues;


      var footer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
        { customClass: baseClasses(), onClick: this.update, type: 'button' },
        this.context.t('Update')
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__common_LayoutTemplates_ContentWithFooterLayoutTemplate_ContentWithFooterLayoutTemplate__["a" /* default */],
          {
            footer: footer,
            customClass: baseClasses() + '-cwf-lt' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('confirm-block') },
              this.context.t('Confirm')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
              label: this.context.t('Color Theme'),
              text: formValues.theme,
              customClass: baseClasses()
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
              label: this.context.t('Chart'),
              text: __WEBPACK_IMPORTED_MODULE_6__ChartEnums__["a" /* chartEnums */][formValues.chart],
              customClass: baseClasses()
            })
          )
        )
      );
    }
  }]);

  return ThemeConfirm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ThemeConfirm.propTypes = {
  formValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

ThemeConfirm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ThemeConfirm);

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_LayoutTemplates_ContentWithFooterLayoutTemplate_ContentWithFooterLayoutTemplate__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChartEnums__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeFormComponent_css__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ThemeFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('theme-form');

var ThemeFormEditable = function (_React$Component) {
  _inherits(ThemeFormEditable, _React$Component);

  function ThemeFormEditable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ThemeFormEditable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeFormEditable.__proto__ || Object.getPrototypeOf(ThemeFormEditable)).call.apply(_ref, [this].concat(args))), _this), _this.getThemeOptions = function () {
      return [{ value: 'Dark', label: 'Dark' }, { value: 'Light', label: 'Light' }];
    }, _this.getChartOptions = function () {
      return Object.keys(__WEBPACK_IMPORTED_MODULE_6__ChartEnums__["a" /* chartEnums */]).map(function (key) {
        return {
          value: key,
          label: __WEBPACK_IMPORTED_MODULE_6__ChartEnums__["a" /* chartEnums */][key]
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThemeFormEditable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          formValues = _props.formValues,
          change = _props.change;

      var themeOptions = this.getThemeOptions();

      if (!formValues['theme']) {
        var value = themeOptions[0].value;

        change('theme', value);
      }

      if (!formValues['chart']) {
        var _value = this.getChartOptions()[0].value;

        change('theme', _value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var goToNextStep = this.props.goToNextStep;


      var footer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
        { customClass: baseClasses(), onClick: goToNextStep },
        this.context.t('Next')
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__common_LayoutTemplates_ContentWithFooterLayoutTemplate_ContentWithFooterLayoutTemplate__["a" /* default */],
          {
            footer: footer,
            customClass: 'retail-region-editable-cwf-lt' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('input-wrapper') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["b" /* default */], {
              name: 'theme',
              label: this.context.t('Color Theme'),
              customClass: baseClasses(),
              options: this.getThemeOptions()
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('input-wrapper') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["b" /* default */], {
              name: 'chart',
              label: this.context.t('Trading Layout Chart'),
              customClass: baseClasses(),
              options: this.getChartOptions()
            })
          )
        )
      );
    }
  }]);

  return ThemeFormEditable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ThemeFormEditable.propTypes = {
  goToNextStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ThemeFormEditable.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ThemeFormEditable);

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResetPasswordForm_ResetPasswordFormComponent__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);






var profileAndSecurityWidgetClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['profile-and-security-widget']);

var PasswordSettingsCardComponent = function PasswordSettingsCardComponent(props, context) {
  var getLayoutHeader = function getLayoutHeader(header, classes) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('header-text') },
        header
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__["a" /* default */],
    {
      header: getLayoutHeader(context.t('Password'), profileAndSecurityWidgetClasses),
      customClass: 'profile-and-security-widget',
      classModifiers: ['sm'] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResetPasswordForm_ResetPasswordFormComponent__["a" /* default */], { customClass: 'retail-reset-password-form' })
  );
};

PasswordSettingsCardComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PasswordSettingsCardComponent);

/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);





var resetPasswordFormClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('reset-password-form');

var ResetPasswordConfirmComponent = function ResetPasswordConfirmComponent(props, context) {
  var submitting = props.submitting,
      handleSubmit = props.handleSubmit;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: resetPasswordFormClasses('text-info') },
      context.t('Check your email with instructions on changing your password')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: resetPasswordFormClasses('button-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
        { type: 'submit', customClass: resetPasswordFormClasses() },
        submitting ? context.t('Processing...') : context.t('Send Email')
      )
    )
  );
};

ResetPasswordConfirmComponent.propTypes = {
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

ResetPasswordConfirmComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordConfirmComponent);

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_userActions__ = __webpack_require__(37);





var ResetPasswordRequestFormContainerFactory = function ResetPasswordRequestFormContainerFactory(Component) {
  var ResetPasswordRequestFormContainer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["j" /* reduxForm */])({
    form: 'resetPasswordRequest',
    destroyOnUnmount: false,
    onSubmit: function onSubmit(payload, dispatch) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_userActions__["s" /* submitResetPasswordForm */])(payload));
    }
  })(Component);

  return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ResetPasswordRequestFormContainer);
};

var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;


  return {
    formObj: form.resetPasswordRequest ? form.resetPasswordRequest.values : {}
  };
};

var mapDispatchToProps = {
  goToStep: __WEBPACK_IMPORTED_MODULE_2__redux_actions_userActions__["n" /* goToResetPasswordFormStep */]
};

/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordRequestFormContainerFactory);

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnableTwoFactorAuth_EnableTwoFactorAuthContainerFactory__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EnableTwoFactorAuth_EnableTwoFactorAuthComponent__ = __webpack_require__(818);






var EnableTwoFactorAuthContainer = Object(__WEBPACK_IMPORTED_MODULE_3__EnableTwoFactorAuth_EnableTwoFactorAuthContainerFactory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__EnableTwoFactorAuth_EnableTwoFactorAuthComponent__["a" /* default */]);

var TwoFactorAuthSettingsCardComponent = function TwoFactorAuthSettingsCardComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__["a" /* default */],
    {
      header: context.t('Two-Factor Authentication'),
      customClass: 'profile-and-security-widget',
      classModifiers: ['sm'] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EnableTwoFactorAuthContainer, null)
  );
};

TwoFactorAuthSettingsCardComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TwoFactorAuthSettingsCardComponent);

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APSwitch_css__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APSwitch_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__APSwitch_css__);







var Switch = function Switch(props, context) {
  var input = props.input,
      onClick = props.onClick,
      customClass = props.customClass;

  var value = input.value;
  var modifier = { on: value };
  var text = value ? context.t('On') : context.t('Off');
  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('ap-switch', customClass);

  var handleClick = function handleClick() {
    onClick(value);
    input.onChange(!value);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses('switch', modifier), onClick: handleClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: bemClasses('toggle', modifier) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('text', modifier) },
      text
    )
  );
};

Switch.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var APSwitch = function APSwitch(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], Object.assign({ name: props.name, component: Switch }, props));
};

APSwitch.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (APSwitch);

/***/ }),
/* 2193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Enable2FAModal__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_userActions__ = __webpack_require__(37);







var mapStateToProps = function mapStateToProps(state) {
  return {
    GoogleQRCode: state.user.qrCode.ManualCode,
    userName: state.user.userInfo.UserName
  };
};

var mapDispatchToProps = {
  changeFieldValue: __WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */]
};

var containerForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'enable2FAModal',
  onSubmit: function onSubmit(payload, dispatch, props) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_userActions__["i" /* enable2FA */])(payload.code));
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(__WEBPACK_IMPORTED_MODULE_2__Enable2FAModal__["a" /* default */]);

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(containerForm);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].ENABLE_2FA
})(container));

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Enable2FAForm__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Enable2FAModal_css__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Enable2FAModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Enable2FAModal_css__);







var Enable2FAModal = function Enable2FAModal(props, context) {
  var GoogleQRCode = props.GoogleQRCode,
      handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      isOpen = props.isOpen,
      close = props.close,
      changeFieldValue = props.changeFieldValue,
      userName = props.userName;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Enable Two-Factor Authentication'),
      onCancel: function onCancel() {
        close();
        changeFieldValue('enableTwoFactorAuth', 'use2FA', false);
      },
      close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Enable2FAForm__["a" /* default */], {
      userName: userName,
      GoogleQRCode: GoogleQRCode,
      handleSubmit: handleSubmit,
      submitting: submitting
    })
  );
};

Enable2FAModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

Enable2FAModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Enable2FAModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Enable2FAModal);

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Disable2FAModal__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(5);







var mapDispatchToProps = {
  changeFieldValue: __WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* change */]
};

var containerForm = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["j" /* reduxForm */])({
  form: 'disable2FAModal',
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__["h" /* disable2FA */])(payload.code));
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(__WEBPACK_IMPORTED_MODULE_1__Disable2FAModal__["a" /* default */]);

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(containerForm);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].DISABLE_2FA
})(container));

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Disable2FAForm__ = __webpack_require__(2199);





var Disable2FAModal = function Disable2FAModal(props, context) {
  var handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      isOpen = props.isOpen,
      close = props.close,
      changeFieldValue = props.changeFieldValue;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Disable Two-Factor Authentication'),
      onCancel: function onCancel() {
        close();
        changeFieldValue('enableTwoFactorAuth', 'use2FA', true);
      },
      close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Disable2FAForm__["a" /* default */], { handleSubmit: handleSubmit, submitting: submitting })
  );
};

Disable2FAModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

Disable2FAModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Disable2FAModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Disable2FAModal);

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APAutoTabInput_APAutoTabInput__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Disable2FAModal_css__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Disable2FAModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Disable2FAModal_css__);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('disable-2fa-modal');

var Disable2FAForm = function Disable2FAForm(props, context) {
  var handleSubmit = props.handleSubmit;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { onSubmit: handleSubmit, className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('text-item') },
      context.t('Do you want to turn off Two-Factor Authentication for this account?')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APAutoTabInput_APAutoTabInput__["a" /* default */], {
      label: context.t('Type Authentication Code Here'),
      name: 'code',
      type: 'input',
      numberOfInputs: 6,
      validate: [__WEBPACK_IMPORTED_MODULE_4__helpers_formValidations__["p" /* required */]]
    })
  );
};

Disable2FAForm.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

Disable2FAForm.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Disable2FAForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Disable2FAForm);

/***/ }),
/* 2200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GetGoogle2FARecoveryKeyModal__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(5);








var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;

  var recoveryForm = form.google2FARecoveryKeyModal || { values: {} };

  return {
    recoveryForm: recoveryForm,
    initialValues: {
      recoveryKey: ''
    }
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showSnack: function showSnack(text) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_snackbarActions__["e" /* showSnack */])(text));
    },
    onCancel: function onCancel() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_redux_form__["k" /* reset */])('google2FARecoveryKeyModal'));
    }
  };
};

var containerForm = Object(__WEBPACK_IMPORTED_MODULE_6_redux_form__["j" /* reduxForm */])({
  destroyOnUnmount: true,
  form: 'google2FARecoveryKeyModal',
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_userActions__["j" /* getGoogle2FARecoveryCode */])(payload.code));
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(__WEBPACK_IMPORTED_MODULE_1__GetGoogle2FARecoveryKeyModal__["a" /* default */]);

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(containerForm);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].GET_GOOGLE_2FA_RECOVERY_CODE
})(container));

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APAutoTabInput_APAutoTabInput__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText_APLabelWithText__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_clipboardHelper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GetGoogle2FARecoveryKeyModal_css__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GetGoogle2FARecoveryKeyModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__GetGoogle2FARecoveryKeyModal_css__);












var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('recovery-2fa-modal');

var GetGoogle2FARecoveryKeyModal = function GetGoogle2FARecoveryKeyModal(props, context) {
  var handleSubmit = props.handleSubmit,
      isOpen = props.isOpen,
      close = props.close,
      _onCancel = props.onCancel,
      recoveryForm = props.recoveryForm,
      showSnack = props.showSnack;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Get Google 2FA Recovery Code'),
      close: close,
      onCancel: function onCancel() {
        _onCancel();
        close();
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { onSubmit: handleSubmit, className: baseClasses() },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('text-item') },
        context.t('RECOVERY')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APAutoTabInput_APAutoTabInput__["a" /* default */], {
        label: context.t('Type Authentication Code Here'),
        name: 'code',
        type: 'input',
        numberOfInputs: 6,
        validate: [__WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__["p" /* required */]]
      }),
      recoveryForm.values.recoveryKey && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: baseClasses('recovery-code-container'),
          onClick: function onClick() {
            showSnack({
              id: 'RECEIVE_RECOVERY_CODE_COPY',
              text: context.t('The Recovery Code has been copied to the clipboard.')
            });
            Object(__WEBPACK_IMPORTED_MODULE_7__helpers_clipboardHelper__["a" /* default */])(recoveryForm.values.recoveryKey);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLabelWithText_APLabelWithText__["a" /* default */], {
          className: baseClasses('copy-recovery-code'),
          name: 'recoveryKey',
          label: 'Copy Recovery Code to the clipboard'
        }),
        recoveryForm.values.recoveryKey,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APIcon__["a" /* default */], { name: 'copy', customClass: baseClasses('copy-icon') })
      )
    )
  );
};

GetGoogle2FARecoveryKeyModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

GetGoogle2FARecoveryKeyModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showSnack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  recoveryForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

GetGoogle2FARecoveryKeyModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (GetGoogle2FARecoveryKeyModal);

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYCSettingsComponent__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KYCTypeSwitchHelper__ = __webpack_require__(2209);





var mapStateToProps = function mapStateToProps(state) {
  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      kycConfig = _kycVerificationLevel.kycConfig;

  var LevelsComponent = Object(__WEBPACK_IMPORTED_MODULE_3__KYCTypeSwitchHelper__["a" /* getKYCComponent */])(kycConfig);

  return {
    LevelsComponent: LevelsComponent
  };
};

var KYCSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__KYCSettingsComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KYCSettingsContainer);

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYCSettingsComponent_css__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYCSettingsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__KYCSettingsComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYCFormSidePaneComponent_css__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYCFormSidePaneComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__KYCFormSidePaneComponent_css__);




var KYCSettingsComponent = function KYCSettingsComponent(props) {
  var LevelsComponent = props.LevelsComponent;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LevelsComponent, null);
};

/* harmony default export */ __webpack_exports__["a"] = (KYCSettingsComponent);

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getKYCComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_IM__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_IMLegacy__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_Jumio__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KYC_Manual__ = __webpack_require__(2226);





var getKYCComponent = function getKYCComponent(kycConfig) {
  switch (kycConfig.type) {
    case 'IM':
    case 'IMLegacy':
      return __WEBPACK_IMPORTED_MODULE_1__KYC_IMLegacy__["a" /* default */];
    case 'IM3.2':
      return __WEBPACK_IMPORTED_MODULE_0__KYC_IM__["a" /* default */];
    case 'Jumio':
      return __WEBPACK_IMPORTED_MODULE_2__KYC_Jumio__["a" /* default */];
    case 'Manual':
    case 'HTML':
      return __WEBPACK_IMPORTED_MODULE_3__KYC_Manual__["a" /* default */];
    default:
      break;
  }
};

/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_IMComponent__ = __webpack_require__(2211);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYC_IMComponent__["a" /* default */]);

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_IMLevelsContainer__ = __webpack_require__(2214);




var KYC_IMComponent = function KYC_IMComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC__["a" /* default */], { LevelsComponent: __WEBPACK_IMPORTED_MODULE_2__KYC_IMLevelsContainer__["a" /* default */] });
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_IMComponent);

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYCBaseComponent__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__ = __webpack_require__(37);





var mapStateToProps = function mapStateToProps(state) {
  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      verificationLevel = _kycVerificationLevel.verificationLevel,
      levelIncreaseStatus = _kycVerificationLevel.levelIncreaseStatus,
      kycConfig = _kycVerificationLevel.kycConfig;

  var highlightStyle = kycConfig.highlightStyle;

  return {
    verificationLevel: verificationLevel,
    levelIncreaseStatus: levelIncreaseStatus,
    kycConfig: kycConfig,
    highlightStyle: highlightStyle,
    userId: state.user.userInfo.UserId,
    userName: state.user.userInfo.UserName
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserConfig: function getUserConfig(userId, username) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__["l" /* getUserConfig */])(userId, username));
    }
  };
};

var KYCBaseContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__KYCBaseComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KYCBaseContainer);

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propTypes_kycConfigShapePropTypes__ = __webpack_require__(156);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var kycClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-settings');

var KYCBaseComponent = function (_React$Component) {
  _inherits(KYCBaseComponent, _React$Component);

  function KYCBaseComponent() {
    _classCallCheck(this, KYCBaseComponent);

    return _possibleConstructorReturn(this, (KYCBaseComponent.__proto__ || Object.getPrototypeOf(KYCBaseComponent)).apply(this, arguments));
  }

  _createClass(KYCBaseComponent, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          userId = _props.userId,
          userName = _props.userName,
          getUserConfig = _props.getUserConfig;


      if (!prevProps.userId && !prevProps.userName && userId && userName) {
        getUserConfig(userId, userName);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          kycConfig = _props2.kycConfig,
          verificationLevel = _props2.verificationLevel,
          levelIncreaseStatus = _props2.levelIncreaseStatus,
          LevelsComponent = _props2.LevelsComponent,
          highlightStyle = _props2.highlightStyle;

      var levels = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(kycConfig, 'levels', []);
      var level1 = levels[0];
      var level2 = levels[1];
      var level3 = levels[2];
      var level4 = levels[3];

      var KYCWorkflowLevelsComponentProps = {
        highlightStyle: highlightStyle,
        verificationLevel: verificationLevel,
        levelIncreaseStatus: levelIncreaseStatus,
        levels: levels,
        level1: level1,
        level2: level2,
        level3: level3,
        level4: level4
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(kycClasses('', highlightStyle)) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: kycClasses('header') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: kycClasses('header-text') },
            this.context.t('Current Verification Level')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: kycClasses('description') },
            this.context.t('For your security, some of our services require you to provide basic or additional levels of verification.')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: kycClasses('description') },
            this.context.t('To verify your account or to check what your current verification level is, see below.')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: kycClasses('levels') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LevelsComponent, KYCWorkflowLevelsComponentProps)
        )
      );
    }
  }]);

  return KYCBaseComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

KYCBaseComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

KYCBaseComponent.propTypes = {
  userId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  userName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  verificationLevel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  levelIncreaseStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  openKYCSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  kycConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    levels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_5__propTypes_kycConfigShapePropTypes__["a" /* kycConfigLevelShape */]))
  })
};

/* harmony default export */ __webpack_exports__["a"] = (KYCBaseComponent);

/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_IMLevelsComponent__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__ = __webpack_require__(23);




var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openKYCSidePane: function openKYCSidePane() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__["o" /* openKYC_IMSidePane */])());
    }
  };
};

var KYC_IMLevelsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__KYC_IMLevelsComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KYC_IMLevelsContainer);

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__ = __webpack_require__(288);




var KYC_IMLevelsComponent = function KYC_IMLevelsComponent(props) {
  var highlightStyle = props.highlightStyle,
      levels = props.levels,
      levelIncreaseStatus = props.levelIncreaseStatus,
      openKYCSidePane = props.openKYCSidePane,
      verificationLevel = props.verificationLevel;


  return levels.map(function (level) {
    if (level.level === 0) {
      var _levelProps = Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["a" /* getIMLevel1VerificationProps */])(verificationLevel, levelIncreaseStatus);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
        key: level.level,
        verified: true,
        config: level
      }, _levelProps, {
        highlightStyle: highlightStyle
      }));
    }

    var levelProps = level.level === 1 ? Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["b" /* getIMLevel2VerificationProps */])(verificationLevel, levelIncreaseStatus) : Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["c" /* getIMLevelVerificationProps */])(level.level, verificationLevel - 1, levelIncreaseStatus);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
      key: level.level,
      config: level
    }, levelProps, {
      openPane: openKYCSidePane,
      highlightStyle: highlightStyle
    }));
  });
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_IMLevelsComponent);

/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APIcon_APIcon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propTypes_kycConfigShapePropTypes__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KYCLevelComponent_css__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KYCLevelComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__KYCLevelComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var kycClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-level');

var KYCLevelComponent = function (_React$Component) {
  _inherits(KYCLevelComponent, _React$Component);

  function KYCLevelComponent() {
    _classCallCheck(this, KYCLevelComponent);

    return _possibleConstructorReturn(this, (KYCLevelComponent.__proto__ || Object.getPrototypeOf(KYCLevelComponent)).apply(this, arguments));
  }

  _createClass(KYCLevelComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          verified = _props.verified,
          underReview = _props.underReview,
          canIncrease = _props.canIncrease,
          currentLevel = _props.currentLevel,
          openPane = _props.openPane,
          highlightStyle = _props.highlightStyle,
          _props$config = _props.config,
          label = _props$config.label,
          button = _props$config.button,
          verifiedMessage = _props$config.verifiedMessage,
          underReviewMessage = _props$config.underReviewMessage,
          _props$config$descrip = _props$config.description,
          benefits = _props$config$descrip.benefits,
          requirements = _props$config$descrip.requirements;


      var activeCard = currentLevel ? 'selected' : '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: kycClasses(null, activeCard) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: kycClasses('header-title', activeCard) },
          this.context.t(label)
        ),
        highlightStyle === 'star' && currentLevel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIcon_APIcon__["a" /* default */], { name: 'star', className: kycClasses('star-icon') }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: kycClasses('body') },
          benefits && benefits.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: kycClasses('benefits') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: kycClasses('sub-title', activeCard) },
              this.context.t('Benefits')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: kycClasses('list') },
              benefits.map(function (benefit, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: idx, className: kycClasses('list-item') },
                  _this2.context.t(benefit)
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: kycClasses('requirements') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: kycClasses('sub-title', activeCard) },
              this.context.t('Requirements')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: kycClasses('item-description') },
              this.context.t(requirements)
            )
          )
        ),
        verified && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: kycClasses('footer', 'verified') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIcon_APIcon__["a" /* default */], {
            name: 'simple-check',
            customClass: kycClasses('verified-icon')
          }),
          this.context.t(verifiedMessage)
        ),
        underReview && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: kycClasses('footer', 'under-review') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIcon_APIcon__["a" /* default */], {
            name: 'pending',
            customClass: kycClasses('under-review-icon')
          }),
          this.context.t(underReviewMessage)
        ),
        canIncrease && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: kycClasses('footer', 'can-increase') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
            { customClass: kycClasses('change'), onClick: openPane },
            this.context.t(button) || this.context.t('Increase to {label}', { label: label })
          )
        ),
        !verified && !underReview && !canIncrease && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: kycClasses('footer', 'cannot-increase') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
            { customClass: kycClasses(), disabled: true },
            this.context.t(button) || this.context.t('Increase to {label}', { label: label })
          )
        )
      );
    }
  }]);

  return KYCLevelComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

KYCLevelComponent.propTypes = {
  verified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  underReview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  currentLevel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canIncrease: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_5__propTypes_kycConfigShapePropTypes__["a" /* kycConfigLevelShape */]),
  openPane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  highlightStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

KYCLevelComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (KYCLevelComponent);

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_IMLegacyComponent__ = __webpack_require__(2219);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYC_IMLegacyComponent__["a" /* default */]);

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_IMLegacyLevelsContainer__ = __webpack_require__(2220);




var KYC_IMLegacyComponent = function KYC_IMLegacyComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC__["a" /* default */], { LevelsComponent: __WEBPACK_IMPORTED_MODULE_2__KYC_IMLegacyLevelsContainer__["a" /* default */] });
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_IMLegacyComponent);

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_IMLegacyLevelsComponent__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__ = __webpack_require__(23);




var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openKYCSidePane: function openKYCSidePane() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__["n" /* openKYC_IMLegacySidePane */])());
    }
  };
};

var KYC_IMLegacyLevelsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__KYC_IMLegacyLevelsComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KYC_IMLegacyLevelsContainer);

/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__ = __webpack_require__(288);




var KYC_IMLegacyLevelsComponent = function KYC_IMLegacyLevelsComponent(props) {
  var highlightStyle = props.highlightStyle,
      levels = props.levels,
      levelIncreaseStatus = props.levelIncreaseStatus,
      openKYCSidePane = props.openKYCSidePane,
      verificationLevel = props.verificationLevel;


  return levels.map(function (level) {
    if (level.level === 1) {
      var levelProps = Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["a" /* getIMLevel1VerificationProps */])(verificationLevel, levelIncreaseStatus);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
        key: level.level,
        verified: true,
        config: level
      }, levelProps, {
        highlightStyle: highlightStyle
      }));
    } else {
      var _levelProps = level.level === 2 ? Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["b" /* getIMLevel2VerificationProps */])(verificationLevel, levelIncreaseStatus) : Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["c" /* getIMLevelVerificationProps */])(level.level, verificationLevel, levelIncreaseStatus);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
        key: level.level,
        config: level
      }, _levelProps, {
        openPane: openKYCSidePane,
        highlightStyle: highlightStyle
      }));
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_IMLegacyLevelsComponent);

/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_JumioComponent__ = __webpack_require__(2223);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYC_JumioComponent__["a" /* default */]);

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_JumioLevelsContainer__ = __webpack_require__(2224);




var KYC_ManualComponent = function KYC_ManualComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC__["a" /* default */], { LevelsComponent: __WEBPACK_IMPORTED_MODULE_2__KYC_JumioLevelsContainer__["a" /* default */] });
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_ManualComponent);

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_JumioLevelsComponent__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__ = __webpack_require__(23);




var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openKYCSidePane: function openKYCSidePane() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__["p" /* openKYC_JumioSidePane */])());
    }
  };
};

var KYC_JumioLevelsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__KYC_JumioLevelsComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KYC_JumioLevelsContainer);

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__ = __webpack_require__(288);




var KYC_JumioLevelsComponent = function KYC_JumioLevelsComponent(props) {
  var highlightStyle = props.highlightStyle,
      level1 = props.level1,
      level2 = props.level2,
      levelIncreaseStatus = props.levelIncreaseStatus,
      openKYCSidePane = props.openKYCSidePane,
      verificationLevel = props.verificationLevel;


  var level1Props = Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["d" /* getJumioLevel1VerificationProps */])(verificationLevel);
  var level2Props = Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["e" /* getJumioLevel2VerificationProps */])(verificationLevel, levelIncreaseStatus);

  return [level1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
    key: level1.level,
    verified: true,
    config: level1
  }, level1Props, {
    highlightStyle: highlightStyle
  })), level2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
    key: level2.level,
    config: level2
  }, level2Props, {
    openPane: openKYCSidePane,
    highlightStyle: highlightStyle
  }))];
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_JumioLevelsComponent);

/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_ManualComponent__ = __webpack_require__(2227);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYC_ManualComponent__["a" /* default */]);

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_ManualLevelsContainer__ = __webpack_require__(2228);




var KYC_ManualComponent = function KYC_ManualComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC__["a" /* default */], { LevelsComponent: __WEBPACK_IMPORTED_MODULE_2__KYC_ManualLevelsContainer__["a" /* default */] });
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_ManualComponent);

/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_ManualLevelsComponent__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__ = __webpack_require__(23);




var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openKYCSidePane: function openKYCSidePane() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__["q" /* openKYC_ManualSidePane */])());
    }
  };
};

var KYC_ManualLevelsContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__KYC_ManualLevelsComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KYC_ManualLevelsContainer);

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__ = __webpack_require__(288);




var KYCManualLevelsComponent = function KYCManualLevelsComponent(props) {
  var highlightStyle = props.highlightStyle,
      level1 = props.level1,
      level2 = props.level2,
      level3 = props.level3,
      level4 = props.level4,
      levelIncreaseStatus = props.levelIncreaseStatus,
      openKYCSidePane = props.openKYCSidePane,
      verificationLevel = props.verificationLevel;


  var level1Props = Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["f" /* getManualLevel1VerificationProps */])(verificationLevel);
  var level2Props = Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["g" /* getManualLevel2VerificationProps */])(verificationLevel, levelIncreaseStatus);
  var level3Props = Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["h" /* getManualLevel3VerificationProps */])(verificationLevel, levelIncreaseStatus);
  var level4Props = Object(__WEBPACK_IMPORTED_MODULE_2__KYC_kycLevelsVerificationPropsHelper__["i" /* getManualLevel4VerificationProps */])(verificationLevel, levelIncreaseStatus);

  return [level1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
    key: level1.level,
    verified: true,
    config: level1
  }, level1Props, {
    highlightStyle: highlightStyle
  })), level2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
    key: level2.level,
    config: level2
  }, level2Props, {
    openPane: openKYCSidePane,
    highlightStyle: highlightStyle
  })), level3 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
    key: level3.level,
    config: level3
  }, level3Props, {
    openPane: openKYCSidePane,
    highlightStyle: highlightStyle
  })), level4 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__KYC_KYCLevel__["a" /* default */], Object.assign({
    key: level4.level,
    config: level4
  }, level4Props, {
    openPane: openKYCSidePane,
    highlightStyle: highlightStyle
  }))];
};

/* harmony default export */ __webpack_exports__["a"] = (KYCManualLevelsComponent);

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApiKeysSidePaneButtonContainer__ = __webpack_require__(2231);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ApiKeysSidePaneButtonContainer__["a" /* default */]);

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApiKeysSidePaneButtonComponent__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__ = __webpack_require__(23);




var mapDispatchToProps = {
  openApiKeysSidePane: __WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__["l" /* openApiKeysSidePane */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ApiKeysSidePaneButtonComponent__["a" /* default */]));

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApiKeysSidePaneButtonComponent_css__ = __webpack_require__(2233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApiKeysSidePaneButtonComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ApiKeysSidePaneButtonComponent_css__);







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('api-keys-side-pane-button');

var ApiKeysSidePaneButtonComponent = function ApiKeysSidePaneButtonComponent(_ref, context) {
  var openApiKeysSidePane = _ref.openApiKeysSidePane;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
    {
      type: 'submit',
      customClass: baseClasses(),
      onClick: openApiKeysSidePane },
    context.t('API Key')
  );
};

ApiKeysSidePaneButtonComponent.propTypes = {
  openApiKeysSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ApiKeysSidePaneButtonComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ApiKeysSidePaneButtonComponent);

/***/ }),
/* 2233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RemoveApiKeyModal_RemoveApiKeyModalContainer__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CancelAPButton__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ApiKeyListComponent_css__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ApiKeyListComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ApiKeyListComponent_css__);










var ApiKeyListComponent = function ApiKeyListComponent(props, context) {
  var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('api-key-list', props.customClass);
  var formatPermissionValue = function formatPermissionValue(permissions, permissionName) {
    return permissions.indexOf(permissionName) !== -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: baseClasses('check') },
      '\u2713'
    ) : '';
  };

  var columns = [{
    header: context.t('Key'),
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('text-item') },
        props.customClass && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon__["a" /* default */], { name: 'bigKey', customClass: baseClasses('icon') }),
        row.APIKey
      );
    }
  }, {
    header: context.t('Allows Deposits'),
    cell: function cell(row) {
      return formatPermissionValue(row.Permissions, 'Deposit');
    }
  }, {
    header: context.t('Allows Withdraws'),
    cell: function cell(row) {
      return formatPermissionValue(row.Permissions, 'Withdraw');
    }
  }, {
    header: context.t('Allows Trading'),
    cell: function cell(row) {
      return formatPermissionValue(row.Permissions, 'Trading');
    }
  }, {
    header: context.t('Read-only'),
    cell: function cell(row) {
      return formatPermissionValue(row.Permissions, 'AccountReadOnly');
    }
  }, {
    header: '',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_CancelAPButton__["a" /* default */], {
        customClass: baseClasses(),
        text: context.t('Delete'),
        onClick: function onClick() {
          return props.removeApiKey(row.APIKey);
        }
      });
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APTable__["a" /* default */], {
      componentName: 'ApiKeysComponent',
      columns: columns,
      rows: props.apiKeys,
      baseClass: baseClasses,
      headerOutside: true,
      empty: context.t('No data is available')
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RemoveApiKeyModal_RemoveApiKeyModalContainer__["a" /* default */], null)
  );
};

ApiKeyListComponent.propTypes = {
  apiKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  removeApiKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

ApiKeyListComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ApiKeyListComponent);

/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RemoveApiKeyModal__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_apiKeyActions__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);






var mapDispatchToProps = {
  removeApiKey: __WEBPACK_IMPORTED_MODULE_2__redux_actions_apiKeyActions__["h" /* removeApiKey */]
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__RemoveApiKeyModal__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].REMOVE_API_KEY
})(container));

/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RemoveApiKeyModal_css__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RemoveApiKeyModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RemoveApiKeyModal_css__);







var removeApiKeyModalClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('remove-api-key-modal');

var RemoveApiKeyModal = function RemoveApiKeyModal(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: props.isOpen,
      title: context.t('Delete API Key'),
      customClass: 'retail-api-keys-modal-delete',
      close: props.close,
      footer: {
        buttonText: context.t('Delete'),
        buttonStyle: 'subtractive',
        onClick: function onClick() {
          return props.removeApiKey(props.apiKey);
        }
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: removeApiKeyModalClasses('text') },
      context.t('Are you sure you want to delete this API Key?')
    )
  );
};

RemoveApiKeyModal.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  apiKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  removeApiKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

RemoveApiKeyModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RemoveApiKeyModal);

/***/ }),
/* 2237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferHistoryComponent__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_transferSelectors__ = __webpack_require__(2242);




var mapStateToProps = function mapStateToProps(state) {
  var fetching = state.transfer.fetching;

  var transfers = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_transferSelectors__["a" /* transferReceiverUserNames */])(state);

  return { transfers: transfers, fetching: fetching };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__TransferHistoryComponent__["a" /* default */]));

/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransferHistoryComponent_css__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransferHistoryComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TransferHistoryComponent_css__);








var transferHistoryClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('transfer-history');

var TransferHistoryComponent = function TransferHistoryComponent(props, context) {
  var transfers = props.transfers,
      fetching = props.fetching;


  if (fetching) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: transferHistoryClasses('spinner') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Spinner_Spinner__["a" /* default */], { isInline: true })
    );
  } else if (transfers.length === 0 && !fetching) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: transferHistoryClasses('item') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'stop', customClass: transferHistoryClasses('icon') }),
      context.t('No Transfer History')
    );
  } else {
    return transfers.map(function (userName, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index, className: transferHistoryClasses('item') },
        userName
      );
    });
  }
};

TransferHistoryComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TransferHistoryComponent);

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return transferReceiverUserNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__ = __webpack_require__(88);



var transferReceiverUserNames = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.transfer.transfers;
}, function (transfers) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_arrayHelper__["a" /* distinct */])(transfers.map(function (transfer) {
    return transfer.ReceiverUserName;
  }));
});

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AffiliateComponent_css__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AffiliateComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AffiliateComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_clipboardHelper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AffiliateModalContainer__ = __webpack_require__(2244);









var affiliateClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('affiliate');

var AffiliateActiveTag = function AffiliateActiveTag(props, context) {
  var route = props.route,
      affiliate = props.affiliate,
      showSnack = props.showSnack,
      openAffiliateModal = props.openAffiliateModal;


  var affiliateTag = '' + route + affiliate.affiliateTag;

  var getModalButtonText = function getModalButtonText() {
    return affiliate.affiliateTag ? context.t('Edit') : context.t('Create');
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: affiliateClasses('container-content') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: affiliateClasses('tag') },
        affiliate.affiliateTag
      ),
      affiliate.affiliateTag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { id: 'affiliateTag', className: affiliateClasses('tag-description') },
        affiliateTag
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: affiliateClasses('btn-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
          {
            customClass: affiliateClasses(),
            onClick: function onClick() {
              return openAffiliateModal();
            } },
          getModalButtonText()
        ),
        affiliate.affiliateTag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
          {
            customClass: affiliateClasses(),
            onClick: function onClick() {
              showSnack(context.t('The affiliate tag has been copied to the clipboard.'));
              Object(__WEBPACK_IMPORTED_MODULE_4__helpers_clipboardHelper__["a" /* default */])(affiliateTag);
            } },
          context.t('Copy')
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AffiliateModalContainer__["a" /* default */], null)
  );
};

AffiliateActiveTag.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

AffiliateActiveTag.propTypes = {
  route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  affiliate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  showSnack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openAffiliateModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AffiliateActiveTag);

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AffiliateModal__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_affiliateActions__ = __webpack_require__(121);







var mapStateToProps = function mapStateToProps(state) {
  var affiliate = state.affiliate;


  return {
    initialValues: {
      tag: affiliate.affiliateTag
    }
  };
};

var mapDispatchToProps = { getAffiliate: __WEBPACK_IMPORTED_MODULE_5__redux_actions_affiliateActions__["d" /* getAffiliate */] };

var Form = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'updateAffiliate',
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_affiliateActions__["g" /* updateAffiliate */])(payload));
  }
})(__WEBPACK_IMPORTED_MODULE_2__AffiliateModal__["a" /* default */]);

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Form);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].NEW_AFFILIATE_KEY
})(container));

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);







var affiliateModalClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('affiliate-modal');

var AffiliateModal = function AffiliateModal(props, context) {
  var handleSubmit = props.handleSubmit,
      submitting = props.submitting;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: props.isOpen,
      title: context.t('Create or Edit Affiliate Tag'),
      onCancel: function onCancel() {
        props.close();
      },
      close: props.close,
      customClass: affiliateModalClasses('ap-modal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { onSubmit: handleSubmit, className: affiliateModalClasses('form') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: affiliateModalClasses('input-wraper') },
        context.t('Change tag'),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APInput__["b" /* default */], {
          customClass: affiliateModalClasses(),
          type: 'text',
          name: 'tag'
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: affiliateModalClasses('footer') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
          { type: 'submit', customClass: affiliateModalClasses() },
          submitting ? context.t('Submitting...') : context.t('Update')
        )
      )
    )
  );
};

AffiliateModal.propTypes = {
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

AffiliateModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AffiliateModal);

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AffiliateComponent_css__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AffiliateComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AffiliateComponent_css__);






var affiliateClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('affiliate');

var AffiliateCountComponent = function AffiliateCountComponent(props, context) {
  var affiliate = props.affiliate;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'section',
    { className: affiliateClasses('container-content') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: affiliateClasses('tag') },
      affiliate.affiliateCount,
      ' ',
      context.t('Affiliates')
    )
  );
};

AffiliateCountComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

AffiliateCountComponent.propTypes = {
  affiliate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AffiliateCountComponent);

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoyaltyToken_css__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoyaltyToken_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LoyaltyToken_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('loyalty-token');

var LoyaltyTokenComponent = function (_React$Component) {
  _inherits(LoyaltyTokenComponent, _React$Component);

  function LoyaltyTokenComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoyaltyTokenComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoyaltyTokenComponent.__proto__ || Object.getPrototypeOf(LoyaltyTokenComponent)).call.apply(_ref, [this].concat(args))), _this), _this.loyaltyDisabled = function (loyaltyOMSEnabled, product) {
      return !loyaltyOMSEnabled || product.Amount <= 0;
    }, _this.getLoyaltyLabel = function (loyaltyDisabled, ProductSymbol, LoyaltyDiscount) {
      var disabledText = _this.context.t('You must have a balance to use ' + ProductSymbol + ' to pay for fees');
      var enabledText = _this.context.t('Use {ProductSymbol} to pay for fees', {
        ProductSymbol: ProductSymbol
      });
      var appendText = _this.context.t('({LoyaltyDiscount}% discount )', {
        LoyaltyDiscount: LoyaltyDiscount
      });

      return (loyaltyDisabled ? disabledText : enabledText) + (' ' + appendText);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoyaltyTokenComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getOperatorLoyaltyFeeConfigs();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loyaltyOMSEnabled = _props.loyaltyOMSEnabled,
          loyaltyOMSProducts = _props.loyaltyOMSProducts,
          currentAccount = _props.currentAccount,
          updateAccount = _props.updateAccount;

      var loyaltyProductId = currentAccount && currentAccount.LoyaltyEnabled ? currentAccount.LoyaltyProductId : 0;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        loyaltyOMSEnabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('row') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('col') },
            loyaltyOMSProducts.map(function (product) {
              var disabled = _this2.loyaltyDisabled(loyaltyOMSEnabled, product);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__["a" /* default */], {
                key: product.ProductId,
                id: 'loyaltyToken' + product.ProductId,
                name: 'loyaltyToken',
                value: product.ProductId,
                label: _this2.getLoyaltyLabel(disabled, product.ProductSymbol, product.LoyaltyDiscount),
                checked: loyaltyProductId === product.ProductId,
                onChange: function onChange() {
                  return updateAccount(product);
                },
                disabled: disabled,
                customClass: baseClasses('radio')
              });
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APRadio_APRadio__["a" /* default */], {
              id: 'loyaltyToken',
              name: 'loyaltyToken',
              value: -1,
              label: this.context.t('Use default fees'),
              checked: loyaltyProductId === 0,
              onChange: function onChange() {
                return updateAccount();
              },
              customClass: baseClasses('radio')
            })
          )
        )
      );
    }
  }]);

  return LoyaltyTokenComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (LoyaltyTokenComponent);


LoyaltyTokenComponent.defaultProps = {
  loyaltyOMSProducts: [],
  loyaltyOMSEnabled: false
};

LoyaltyTokenComponent.propTypes = {
  loyaltyOMSEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  loyaltyOMSProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

LoyaltyTokenComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loyaltyTokenSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentAccountloyaltyTokenSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__positionSelectors__ = __webpack_require__(52);




var loyaltyTokenSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.loyaltyFee.loyaltyFees;
}, __WEBPACK_IMPORTED_MODULE_2__positionSelectors__["b" /* positionSelector */]], function (loyaltyFees, positions) {
  var loyaltyOMSProducts = [];
  var loyaltyOMSEnabled = true;

  positions = Object.keys(positions).map(function (p) {
    return positions[p];
  });

  loyaltyFees.forEach(function (token) {
    if (token.IsEnabled) {
      var product = positions.find(function (x) {
        return x.ProductId === token.LoyaltyProductId;
      });

      if (product) {
        var discount = token.LoyaltyDiscount * 100;

        var decimals = Math.floor(discount) !== discount ? discount.toString().split('.')[1].length || 0 : 0;

        product.LoyaltyDiscount = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_numberFormatter__["b" /* formatNumberToLocale */])(discount, decimals);
        loyaltyOMSProducts.push(product);
      }
    }
  });

  return { loyaltyOMSEnabled: loyaltyOMSEnabled, loyaltyOMSProducts: loyaltyOMSProducts };
});

var currentAccountloyaltyTokenSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.selectedAccountId;
}], function (accounts, selectedAccountId) {
  return accounts.find(function (account) {
    return selectedAccountId === account.AccountId;
  });
});

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TradeSettingsComponent__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__ = __webpack_require__(57);





var mapStateToProps = function mapStateToProps(state) {
  var marginStatus = state.margin.marginStatus;

  return {
    cardText: __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].MarginTrading.cardText,
    modalText: __WEBPACK_IMPORTED_MODULE_2__config__["b" /* default */].MarginTrading.modalText,
    marginStatus: marginStatus
  };
};

var mapDispatchToProps = {
  getMarginStatus: __WEBPACK_IMPORTED_MODULE_3__redux_actions_marginActions__["q" /* getMarginStatus */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__TradeSettingsComponent__["a" /* default */]));

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarginTrading__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TradeSettings_css__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TradeSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TradeSettings_css__);








var themeClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-settings');

var TradeSettings = function TradeSettings(_ref, context) {
  var getMarginStatus = _ref.getMarginStatus,
      cardText = _ref.cardText,
      modalText = _ref.modalText;

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    getMarginStatus();
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: themeClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: themeClasses('header') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: themeClasses('header-text') },
          context.t('Adjust Trade Settings')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: themeClasses('description') })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: themeClasses('settings') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MarginTrading__["a" /* default */], { cardText: cardText, modalText: modalText })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: themeClasses('row') })
    )
  );
};

TradeSettings.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TradeSettings);

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginTradingContainer__ = __webpack_require__(2253);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginTradingContainer__["a" /* default */]);

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarginTradingComponent__ = __webpack_require__(2254);




var mapStateToProps = function mapStateToProps(state) {
  var MarginBorrowerEnabled = state.user.userInfo.MarginBorrowerEnabled;
  var marginStatus = state.margin.accountState.marginStatus;

  var marginEnabled = MarginBorrowerEnabled ? 'enabled' : 'disabled';

  var marginStatusText = '';
  if (marginStatus === 'Pending') {
    marginStatusText = marginStatus;
  } else {
    marginStatusText = marginEnabled;
  }

  return {
    marginEnabled: marginEnabled,
    marginStatus: marginStatus,
    marginStatusText: marginStatusText.toLowerCase()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openEnableMarginTradingModal: function openEnableMarginTradingModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_TRADING));
    },
    openDisableMarginTradingModal: function openDisableMarginTradingModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_DISABLE));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__MarginTradingComponent__["a" /* default */]));

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon_APIcon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmationModal__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EnableMarginModal__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DisableMarginModal__ = __webpack_require__(2262);









var themeClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-settings');

var MarginTradingSetting = function MarginTradingSetting(_ref, context) {
  var marginEnabled = _ref.marginEnabled,
      marginStatus = _ref.marginStatus,
      marginStatusText = _ref.marginStatusText,
      openEnableMarginTradingModal = _ref.openEnableMarginTradingModal,
      openDisableMarginTradingModal = _ref.openDisableMarginTradingModal,
      cardText = _ref.cardText,
      modalText = _ref.modalText,
      disabled = _ref.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'section',
    { className: themeClasses('box') },
    marginEnabled === 'disabled' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon_APIcon__["a" /* default */], { name: 'alert' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: themeClasses('box-header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        context.t('Margin Trading')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'divider' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: themeClasses('box-body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t(cardText)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: themeClasses('status') },
        context.t('Margin Trading is'),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          ' ',
          context.t(marginStatusText)
        ),
        '.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
          {
            type: 'button',
            customClass: themeClasses('submit-button') + ' ' + marginStatusText,
            onClick: marginEnabled === 'disabled' ? openEnableMarginTradingModal : openDisableMarginTradingModal,
            disabled: disabled || marginStatus === 'Pending' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            marginStatus === 'Pending' ? context.t('Pending') : marginEnabled === 'enabled' ? context.t('Disable') : context.t('Enable')
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EnableMarginModal__["a" /* default */], { text: modalText }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ConfirmationModal__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DisableMarginModal__["a" /* default */], null)
  );
};

MarginTradingSetting.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

MarginTradingSetting.defaultProps = {
  marginEnabled: 'disabled'
};

/* harmony default export */ __webpack_exports__["a"] = (MarginTradingSetting);

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarginTradingConfirmationModal__ = __webpack_require__(2256);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__MarginTradingConfirmationModal__["a" /* default */]);

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarginTradingConfirmationModal_css__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarginTradingConfirmationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MarginTradingConfirmationModal_css__);









var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-trading-confirmation');

var MarginTradingConfirmationModal = function MarginTradingConfirmationModal(_ref, context) {
  var isOpen = _ref.isOpen,
      close = _ref.close;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Margin Trading'),
      close: close,
      footer: {
        buttonText: context.t('OK'),
        onClick: close
      },
      customClass: bemClasses('modal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('We will review your account and then notify you when you begin margin trading on the exchange.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('Thanks so much!')
      )
    )
  );
};

MarginTradingConfirmationModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired
};

MarginTradingConfirmationModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"].isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_CONFIRM
})(MarginTradingConfirmationModal));

/***/ }),
/* 2257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnableMarginConfirmationModalContainer__ = __webpack_require__(2259);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__EnableMarginConfirmationModalContainer__["a" /* default */]);

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnableMarginConfirmationModalComponent__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_marginActions__ = __webpack_require__(57);









var form = 'marginTrading';

var mapStateToProps = function mapStateToProps(state) {
  var MarginBorrowerEnabled = state.user.userInfo.MarginBorrowerEnabled;

  var marginStatus = MarginBorrowerEnabled ? 'enabled' : 'disabled';

  var formObj = state.form.marginTrading;

  var buttonIsDisabled = !__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(formObj, 'values.terms') || marginStatus !== 'disabled';

  return {
    buttonIsDisabled: buttonIsDisabled,
    showPhone: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(formObj, 'values.showPhone', false),
    phone: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(formObj, 'values.phone')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    close: function close() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["d" /* closeModal */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_TRADING));
    },
    resetForm: function resetForm() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["k" /* reset */])(form));
    },
    submitForm: function submitForm() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_marginActions__["j" /* createMarginRequest */])()).then(function (res) {
        if (res) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_CONFIRM));
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_marginActions__["q" /* getMarginStatus */])());
        }
      });
    }
  };
};

var connected = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__EnableMarginConfirmationModalComponent__["a" /* default */]);

var wrapped = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: form,
  onSubmit: function onSubmit() {}
})(connected);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_TRADING
})(wrapped));

/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APCheckbox_APCheckbox__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EnableMarginConfirmationModal_css__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EnableMarginConfirmationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__EnableMarginConfirmationModal_css__);








var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('enable-margin-confirmation');

var EnableMarginConfirmationModal = function EnableMarginConfirmationModal(_ref, context) {
  var isOpen = _ref.isOpen,
      close = _ref.close,
      buttonIsDisabled = _ref.buttonIsDisabled,
      text = _ref.text,
      submitting = _ref.submitting,
      submitForm = _ref.submitForm;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Margin Trading'),
      close: close,
      customClass: bemClasses('modal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('modal-header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: bemClasses('header') },
        context.t('Are you sure you want to enable margin trading?')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('scrollable') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          context.t(text)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('checkboxes') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APCheckbox_APCheckbox__["a" /* default */], {
            name: 'terms',
            id: 'agree',
            label: context.t('I agree to the terms.')
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__common_APButton__["a" /* default */],
        {
          type: 'button',
          disabled: buttonIsDisabled,
          onClick: function onClick() {
            return submitForm().then(function () {
              return close();
            });
          },
          customClass: 'margin-confirm' },
        submitting ? context.t('Pending') : context.t('Enable')
      )
    )
  );
};

EnableMarginConfirmationModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (EnableMarginConfirmationModal);

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DisableMarginConfirmationModalContainer__ = __webpack_require__(2263);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DisableMarginConfirmationModalContainer__["a" /* default */]);

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_marginActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DisableMarginConfirmationModalComponent__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__ = __webpack_require__(25);







var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    disableMargin: function disableMargin() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_marginActions__["m" /* disableMarginRequest */])());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_marginActions__["q" /* getMarginStatus */])());
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__DisableMarginConfirmationModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].MARGIN_DISABLE
})(container));

/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DisableMarginConfirmationModal_css__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DisableMarginConfirmationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DisableMarginConfirmationModal_css__);







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('disable-margin-confirmation');

var DisableMarginConfirmationModal = function DisableMarginConfirmationModal(_ref, context) {
  var close = _ref.close,
      isOpen = _ref.isOpen,
      disableMargin = _ref.disableMargin;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Margin Trading'),
      close: close,
      footer: {
        buttonText: context.t('OK'),
        onClick: disableMargin
      },
      customClass: bemClasses('modal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('Are you sure want to turn off margin? ' + 'If you do so, you will have to reapply to begin using margin again.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('While margin will be turned off, ' + 'any positions will remain open until closed or liquidated.')
      )
    )
  );
};

DisableMarginConfirmationModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

DisableMarginConfirmationModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DisableMarginConfirmationModal);

/***/ }),
/* 2265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APStepsComponent__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DemoSettingsStaticComponent__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DemoSettingsEditableComponent__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DemoSettingsComponent_css__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DemoSettingsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DemoSettingsComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var demoSettingsClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('demo-settings-layout');

var DemoSettingsComponent = function (_React$Component) {
  _inherits(DemoSettingsComponent, _React$Component);

  function DemoSettingsComponent() {
    _classCallCheck(this, DemoSettingsComponent);

    return _possibleConstructorReturn(this, (DemoSettingsComponent.__proto__ || Object.getPrototypeOf(DemoSettingsComponent)).apply(this, arguments));
  }

  _createClass(DemoSettingsComponent, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: demoSettingsClasses('main') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: demoSettingsClasses('info') }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: demoSettingsClasses('body') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: demoSettingsClasses('page-header') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: demoSettingsClasses('title') },
              this.context.t('Demo Settings.')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APStepsComponent__["a" /* default */], Object.assign({
            childComponents: [__WEBPACK_IMPORTED_MODULE_4__DemoSettingsStaticComponent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__DemoSettingsEditableComponent__["a" /* default */]]
          }, this.props))
        )
      );
    }
  }]);

  return DemoSettingsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DemoSettingsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["g" /* withRouter */])(DemoSettingsComponent));

/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DemoSettingsStaticComponent_css__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DemoSettingsStaticComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DemoSettingsStaticComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__ = __webpack_require__(113);









var demoSettingsStaticClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('demo-settings-static');
var demoSettingsWidgetsClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('demo-settings-widget');

var getLayoutHeader = function getLayoutHeader(context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: demoSettingsWidgetsClasses('header') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: demoSettingsWidgetsClasses('header-text') },
      context.t('Settings')
    )
  );
};

var DemoSettingsStaticComponent = function DemoSettingsStaticComponent(props, context) {
  var goToNextStep = props.goToNextStep,
      formValues = props.formValues;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__["a" /* default */],
    {
      header: getLayoutHeader(context),
      customClass: demoSettingsWidgetsClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: demoSettingsStaticClasses() },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: demoSettingsStaticClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Template'),
          text: formValues.template,
          customClass: demoSettingsStaticClasses()
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: demoSettingsStaticClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Color Theme'),
          text: formValues.theme,
          customClass: demoSettingsStaticClasses()
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: demoSettingsStaticClasses('row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Chart Type'),
          text: formValues.chart,
          customClass: demoSettingsStaticClasses()
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: demoSettingsStaticClasses('button-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
          {
            customClass: demoSettingsStaticClasses(),
            onClick: function onClick() {
              return goToNextStep();
            } },
          context.t('Edit')
        )
      )
    )
  );
};

DemoSettingsStaticComponent.defaultProps = {};

DemoSettingsStaticComponent.propTypes = {
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  goToNextStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

DemoSettingsStaticComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DemoSettingsStaticComponent);

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routeTemplates__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DemoSettingsEditableComponent_css__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DemoSettingsEditableComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__DemoSettingsEditableComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var demoSettingsClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('demo-settings');

var demoSettingsWidgetsClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('demo-settings-widget');

var DemoSettingsComponent = function (_React$Component) {
  _inherits(DemoSettingsComponent, _React$Component);

  function DemoSettingsComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DemoSettingsComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DemoSettingsComponent.__proto__ || Object.getPrototypeOf(DemoSettingsComponent)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (event) {
      var formValues = _this.props.formValues;

      localStorage.setItem('apexTemplate', JSON.stringify(formValues));
      event.preventDefault();
      _this.reloadConfigAndRefresh();
    }, _this.clearApexTemplateInLocalStorage = function (event) {
      localStorage.setItem('apexTemplate', JSON.stringify({}));
      event.preventDefault();
      _this.reloadConfigAndRefresh();
    }, _this.reloadConfigAndRefresh = function () {
      Object(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* assignConfigWithLocal */])();
      Object(__WEBPACK_IMPORTED_MODULE_6__routeTemplates__["a" /* AssignRoutes */])();
      _this.props.history.push(Object(__WEBPACK_IMPORTED_MODULE_7__helpers_path__["a" /* default */])('/login'));
      window.location.reload();
    }, _this.getLayoutHeader = function () {
      var goToStep = _this.props.goToStep;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: demoSettingsWidgetsClasses('header') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: demoSettingsWidgetsClasses('header-text') },
          _this.context.t('Edit Settings')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: function onClick() {
              return goToStep(0);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_APIcon__["a" /* default */], {
            name: 'close',
            customClass: demoSettingsWidgetsClasses('icon'),
            classModifiers: 'big'
          })
        )
      );
    }, _this.getTemplateOptions = function () {
      return [{ value: 'NEWYORK', label: 'New York' }, { value: 'MILAN', label: 'Milan' }, { value: 'LONDON', label: 'London' }];
    }, _this.getThemeOptions = function () {
      return [{ value: 'dark', label: 'Dark' }, { value: 'light', label: 'Light' }];
    }, _this.getChartOptions = function () {
      return [{ value: 'APEX', label: 'APEX' }, { value: 'TradingView', label: 'TradingView' }];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DemoSettingsComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          formValues = _props.formValues,
          change = _props.change;

      var fieldsOptions = {
        template: this.getTemplateOptions(),
        theme: this.getThemeOptions(),
        chart: this.getChartOptions()
      };

      Object.keys(fieldsOptions).forEach(function (field) {
        if (!formValues[field]) {
          var value = fieldsOptions[field][0].value;

          change(field, value);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: demoSettingsClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__common_LayoutTemplates_ContentWithHeaderLayoutTemplate_ContentWithHeaderLayoutTemplate__["a" /* default */],
          {
            header: this.getLayoutHeader(),
            customClass: demoSettingsWidgetsClasses() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { className: demoSettingsClasses('form') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: demoSettingsClasses('content-holder') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: demoSettingsClasses('row') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_APSelect__["b" /* default */], {
                    name: 'template',
                    label: this.context.t('Template'),
                    customClass: demoSettingsClasses(),
                    options: this.getTemplateOptions()
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: demoSettingsClasses('row') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_APSelect__["b" /* default */], {
                    name: 'theme',
                    label: this.context.t('Color Theme'),
                    customClass: demoSettingsClasses(),
                    options: this.getThemeOptions()
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: demoSettingsClasses('row') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_APSelect__["b" /* default */], {
                    name: 'chart',
                    label: this.context.t('Chart Type'),
                    customClass: demoSettingsClasses(),
                    options: this.getChartOptions()
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: demoSettingsClasses('row') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
                    {
                      customClass: demoSettingsClasses(),
                      onClick: this.handleSubmit },
                    'Apply'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
                    {
                      customClass: demoSettingsClasses(),
                      onClick: this.clearApexTemplateInLocalStorage },
                    'Clear'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DemoSettingsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DemoSettingsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["g" /* withRouter */])(DemoSettingsComponent));

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivityReportingButtonsContainer__ = __webpack_require__(2274);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ActivityReportingButtonsContainer__["a" /* default */]);

/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActivityReportingButtonsComponent__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__ = __webpack_require__(23);




var mapDispatchToProps = {
  openReportsSidePane: __WEBPACK_IMPORTED_MODULE_2__redux_actions_sidePaneActions__["r" /* openReportsSidePane */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ActivityReportingButtonsComponent__["a" /* default */]));

/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActivityReportingButtonsComponent_css__ = __webpack_require__(2276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActivityReportingButtonsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ActivityReportingButtonsComponent_css__);







var activityReportingButtonsClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['activity-reporting-buttons']);

var REPORT_TABS = {
  SINGLE: 0,
  CYCLICAL: 1
};

var ActivityReportingButtonsComponent = function ActivityReportingButtonsComponent(_ref, context) {
  var openReportsSidePane = _ref.openReportsSidePane;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
      {
        type: 'submit',
        onClick: function onClick() {
          return openReportsSidePane({ index: REPORT_TABS.SINGLE });
        },
        customClass: activityReportingButtonsClasses() },
      context.t('Single Report')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
      {
        type: 'submit',
        onClick: function onClick() {
          return openReportsSidePane({ index: REPORT_TABS.CYCLICAL });
        },
        customClass: activityReportingButtonsClasses() },
      context.t('Cyclical Report')
    )
  );
};

ActivityReportingButtonsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ActivityReportingButtonsComponent);

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduledReportsTableComponent__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_reportActions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_reportSelectors__ = __webpack_require__(2280);





var mapStateToProps = function mapStateToProps(state) {
  var reports = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_reportSelectors__["a" /* cancelableScheduledReportsSelector */])(state);
  var isLoading = state.report.isLoading;


  return {
    reports: reports,
    isLoading: isLoading
  };
};

var mapDispathToProps = {
  cancelReport: __WEBPACK_IMPORTED_MODULE_2__redux_actions_reportActions__["f" /* cancelReport */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispathToProps)(__WEBPACK_IMPORTED_MODULE_1__ScheduledReportsTableComponent__["a" /* default */]));

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_CancelAPButton__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScheduledReportsTableComponent_css__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScheduledReportsTableComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ScheduledReportsTableComponent_css__);









var baseClass = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('schedule-report-list');

var ScheduledReportsTableComponent = function ScheduledReportsTableComponent(props, context) {
  var reports = props.reports,
      isLoading = props.isLoading,
      cancelReport = props.cancelReport;

  var columns = [{
    header: context.t('Report Summary'),
    classModifier: 'type',
    cell: function cell(row) {
      return row.reportFlavor;
    }
  }, {
    header: context.t('Frequency'),
    classModifier: 'frequency',
    cell: function cell(row) {
      return row.ReportFrequency;
    }
  }, {
    header: context.t('Created'),
    classModifier: 'created',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_dateHelper__["c" /* formatDateTime */])(row.createTime);
    }
  }, {
    header: context.t('Actions'),
    classModifier: 'actions',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_CancelAPButton__["a" /* default */], {
        customClass: baseClass('action-btn'),
        styleName: 'subtractive',
        text: context.t('Cancel Report'),
        onClick: function onClick() {
          return cancelReport(row.RequestId);
        }
      });
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClass('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APTable__["a" /* default */], {
      columns: columns,
      baseClass: baseClass,
      rows: reports,
      empty: context.t('No Report Is Available'),
      fetching: isLoading,
      headerOutside: true
    })
  );
};

ScheduledReportsTableComponent.propTypes = {
  reports: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  cancelReport: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ScheduledReportsTableComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ScheduledReportsTableComponent);

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scheduledReportsSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelableScheduledReportsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var scheduledReportsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.report.reports;
}, function (reports) {
  return reports.filter(function (report) {
    return report.ReportFrequency !== 'onDemand';
  });
});

var cancelableScheduledReportsSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(scheduledReportsSelector, function (reports) {
  return reports.filter(function (report) {
    return report.RequestStatus !== 'UserCancelled' && report.RequestStatus !== 'SysRetired';
  });
});

/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DownloadReportComponent__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_downloadHelper__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_reportActions__ = __webpack_require__(138);





var mapStateToProps = function mapStateToProps(state) {
  var _state$report = state.report,
      reports = _state$report.reports,
      reportWriterResults = _state$report.reportWriterResults,
      isLoading = _state$report.isLoading;

  return {
    reports: reports,
    reportWriterResults: reportWriterResults,
    isLoading: isLoading,
    downloadDocument: __WEBPACK_IMPORTED_MODULE_2__helpers_downloadHelper__["a" /* downloadDocument */]
  };
};

var mapDispatchToProps = {
  getUserReportWriterResults: __WEBPACK_IMPORTED_MODULE_3__redux_actions_reportActions__["h" /* getUserReportWriterResults */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__DownloadReportComponent__["a" /* default */]));

/***/ }),
/* 2282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIconButton_APIconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_DownloadAPButton__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APTable__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DownloadReportComponent_css__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DownloadReportComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DownloadReportComponent_css__);











var baseClass = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('download-report');

var DownloadReportComponent = function DownloadReportComponent(props, context) {
  var reportWriterResults = props.reportWriterResults,
      isLoading = props.isLoading,
      getUserReportWriterResults = props.getUserReportWriterResults,
      downloadDocument = props.downloadDocument;

  var formatType = function formatType(report) {
    var summary = report.reportDescriptiveHeader.split('|');
    var startTime = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_dateHelper__["b" /* formatDate */])(__WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days___default()(summary[2], 1));
    var endTime = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_dateHelper__["b" /* formatDate */])(__WEBPACK_IMPORTED_MODULE_6_date_fns_sub_days___default()(summary[3], 1));
    return summary[0] + ' ' + summary[1] + ' from ' + startTime + ' to ' + endTime;
  };

  var isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod/i);

  var columns = [{
    header: context.t('Report Summary'),
    classModifier: 'type',
    cell: function cell(row) {
      return formatType(row);
    }
  }, {
    header: context.t('Created'),
    classModifier: 'created',
    cell: function cell(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_dateHelper__["c" /* formatDateTime */])(row.reportExecutionStartTime);
    }
  }, !isMobile && {
    header: context.t('Actions'),
    classModifier: 'actions',
    cell: function cell(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_DownloadAPButton__["a" /* default */], {
        onClick: function onClick() {
          return downloadDocument(row.descriptorId);
        },
        customClass: baseClass('action-btn'),
        styleName: 'additive',
        text: context.t('Download Report')
      });
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClass('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIconButton_APIconButton__["a" /* default */], {
      customClass: baseClass('refresh-reports'),
      iconName: 'refresh',
      action: getUserReportWriterResults,
      showLabel: false
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APTable__["a" /* default */], {
      columns: columns,
      baseClass: baseClass,
      rows: reportWriterResults,
      empty: context.t('No Report Is Available'),
      fetching: isLoading,
      headerOutside: true
    })
  );
};

DownloadReportComponent.propTypes = {
  reports: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  reportWriterResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

DownloadReportComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DownloadReportComponent);

/***/ }),
/* 2283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__APInlineButton__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__ = __webpack_require__(55);






var DownloadAPButton = function DownloadAPButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__APInlineButton__["a" /* default */], Object.assign({ styleName: __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__["b" /* styleNames */].general, icon: 'download' }, props));
};

DownloadAPButton.propTypes = {
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

DownloadAPButton.defaultProps = {
  text: 'Download'
};

/* harmony default export */ __webpack_exports__["a"] = (DownloadAPButton);

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createDocumentFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return downloadDocument; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apex__ = __webpack_require__(21);


var b64toBlob = function b64toBlob(b64Data) {
  var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

var createDocumentFile = function createDocumentFile(fileInfo, name) {
  var calls = fileInfo.numSlices;
  var blobsArray = [];
  var sliceNum = 0;
  var remainingSlices = fileInfo.numSlices;

  function saveFile() {
    var a = document.createElement('a');

    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    return function (data, fileName) {
      var blob = new Blob(data, { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);

      if ((window.navigator.appVersion.toString().indexOf('.NET') > 0 || window.navigator.appVersion.toString().indexOf('Edge') > 0) && window.navigator.msSaveBlob) {
        return window.navigator.msSaveBlob(blob, fileName + '.csv');
      }

      a.href = url;
      a.download = fileName + '.csv';
      a.click();
      return window.URL.revokeObjectURL(url);
    };
  }

  function createAndSaveFile(data) {
    if (data.statusCode === 'Success') {
      blobsArray.push(b64toBlob(data.base64Bytes));
      remainingSlices--;
      if (!remainingSlices) {
        var save = saveFile();
        save(blobsArray, name);
      }
    }
  }

  for (var i = 0; i < calls; i++) {
    __WEBPACK_IMPORTED_MODULE_0__apex__["a" /* default */].connection.DownloadDocumentSlice({
      descriptorId: fileInfo.descriptorId,
      sliceNum: sliceNum++
    }).then(function (res) {
      createAndSaveFile(res);
    });
  }
};

var downloadDocument = function downloadDocument(descriptorId) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'report';

  __WEBPACK_IMPORTED_MODULE_0__apex__["a" /* default */].connection.DownloadDocument({
    descriptorId: descriptorId
  }).then(function (res) {
    createDocumentFile(res, filename);
  });
};

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InterestSettingsComponent__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_interestAccountActions__ = __webpack_require__(202);




var mapStateToProps = function mapStateToProps(state) {
  var accountStatus = state.interestBearingAccounts.accountStatus;

  return {
    accountStatus: accountStatus
  };
};

var mapDispatchToProps = {
  getInterestAccountStatus: __WEBPACK_IMPORTED_MODULE_2__redux_actions_interestAccountActions__["c" /* getInterestAccountStatus */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__InterestSettingsComponent__["a" /* default */]));

/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InterestAccountsSettingContainer__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TradeSettings_css__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TradeSettings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TradeSettings_css__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









var themeClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-settings');

var TradeSettings = function TradeSettings(_ref, context) {
  var getInterestAccountStatus = _ref.getInterestAccountStatus,
      cardText = _ref.cardText,
      modalText = _ref.modalText;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      acctStatus = _useState2[0],
      setAcctStatus = _useState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    getInterestAccountStatus().then(function (res) {
      if (res && res.Value === 'true') {
        setAcctStatus(true);
      }
    });
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: themeClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: themeClasses('header') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: themeClasses('header-text') },
          context.t('Adjust Yield Settings')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: themeClasses('description') },
          context.t('Lorem ipsum dolor sit amet, consectetur adipiscing  elit.')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: themeClasses('settings') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InterestAccountsSettingContainer__["a" /* default */], {
          modalText: 'Interest bearing accounts allow the passive earning of income for crypto deposits.',
          accountStatus: acctStatus
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: themeClasses('row') })
    )
  );
};

TradeSettings.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TradeSettings);

/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InterestAccountsSettingContainer__ = __webpack_require__(2289);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__InterestAccountsSettingContainer__["a" /* default */]);

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InterestAccountSettingsComponent__ = __webpack_require__(2290);




var mapStateToProps = function mapStateToProps(state, ownProps) {
  var accountStatus = state.interestBearingAccounts.accountStatus;

  var enabled = accountStatus ? 'enabled' : 'disabled';

  var text = '';
  if (accountStatus === 'Pending') {
    text = accountStatus;
  } else {
    text = enabled;
  }

  return {
    enabled: enabled,
    accountStatus: accountStatus,
    text: text.toLowerCase()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openEnableModal: function openEnableModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].INTEREST_LENDING_ENABLE));
    },
    openDisableModal: function openDisableModal() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].INTEREST_DISABLE));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__InterestAccountSettingsComponent__["a" /* default */]));

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon_APIcon__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmationModal__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EnableModal__ = __webpack_require__(2294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DisableModal__ = __webpack_require__(2298);









var themeClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-settings');

var MarginTradingSetting = function MarginTradingSetting(_ref, context) {
  var enabled = _ref.enabled,
      accountStatus = _ref.accountStatus,
      text = _ref.text,
      openEnableModal = _ref.openEnableModal,
      openDisableModal = _ref.openDisableModal,
      cardText = _ref.cardText,
      disabled = _ref.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'section',
    { className: themeClasses('box') },
    !accountStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon_APIcon__["a" /* default */], { name: 'alert' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: themeClasses('box-header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        context.t('Interest Bearing Accounts')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'divider' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: themeClasses('box-body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('Apply to earn passive income on your deposits of selected products. Restrictions apply.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: themeClasses('status') },
        context.t('Lending is'),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          ' ',
          context.t(text)
        ),
        '.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
          {
            type: 'button',
            customClass: themeClasses('submit-button') + ' ' + text,
            onClick: enabled === 'disabled' ? openEnableModal : openDisableModal,
            disabled: disabled || accountStatus === 'Pending' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            accountStatus === 'Pending' ? context.t('Pending') : enabled === 'enabled' ? context.t('Disable') : context.t('Enable')
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EnableModal__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ConfirmationModal__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DisableModal__["a" /* default */], null)
  );
};

MarginTradingSetting.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

MarginTradingSetting.defaultProps = {
  enabled: 'disabled'
};

/* harmony default export */ __webpack_exports__["a"] = (MarginTradingSetting);

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmationModal__ = __webpack_require__(2292);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ConfirmationModal__["a" /* default */]);

/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmationModal_css__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ConfirmationModal_css__);









var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('margin-trading-confirmation');

var ConfirmationModal = function ConfirmationModal(_ref, context) {
  var isOpen = _ref.isOpen,
      close = _ref.close;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Interest Bearing Accounts'),
      close: close,
      footer: {
        buttonText: context.t('OK'),
        onClick: close
      },
      customClass: bemClasses('modal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('You have successfully opted in to earning interest on your balances.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
    )
  );
};

ConfirmationModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired
};

ConfirmationModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"].isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__["b" /* MODAL_TYPES */].INTEREST_ACCOUNTS_CONFIRMATION
})(ConfirmationModal));

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnableIntererstLendingModalContainer__ = __webpack_require__(2295);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__EnableIntererstLendingModalContainer__["a" /* default */]);

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnableInterestLendingModalComponent__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_interestAccountActions__ = __webpack_require__(202);








var form = 'interestAccounts';

var mapStateToProps = function mapStateToProps(state) {
  var formObj = state.form.interestAccounts;

  var buttonIsDisabled = !__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(formObj, 'values.terms');

  return {
    buttonIsDisabled: buttonIsDisabled,
    showPhone: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(formObj, 'values.showPhone', false)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetForm: function resetForm() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["k" /* reset */])(form));
    },
    submitForm: function submitForm() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_interestAccountActions__["a" /* createInterestAccountRequest */])()).then(function (res) {
        if (res) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].INTEREST_ACCOUNTS_CONFIRMATION));
        }
      });
    }
  };
};

var connected = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__EnableInterestLendingModalComponent__["a" /* default */]);

var wrapped = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: form,
  onSubmit: function onSubmit() {}
})(connected);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__hocs_modalDecorator__["a" /* default */])({
  name: 'INTEREST_LENDING_ENABLE'
})(wrapped));

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APCheckbox_APCheckbox__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnableInterestLending_css__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnableInterestLending_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EnableInterestLending_css__);







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('enable-interest-confirmation');

var EnableMarginConfirmationModal = function EnableMarginConfirmationModal(_ref, context) {
  var isOpen = _ref.isOpen,
      close = _ref.close,
      buttonIsDisabled = _ref.buttonIsDisabled,
      submitting = _ref.submitting,
      submitForm = _ref.submitForm;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Interest Bearing Accounts'),
      close: close,
      footer: {
        buttonType: 'submit',
        buttonText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          submitting ? context.t('Pending') : context.t('Enable')
        ),
        onClick: submitForm,
        disabled: buttonIsDisabled || submitting
      },
      customClass: bemClasses('modal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('modal-header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: bemClasses('header') },
        context.t('Are you sure you want to enable interesting bearing accounts and staking?')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('scrollable') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          context.t('Interest bearing accounts allow the passive earning of income for crypto deposits.')
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('checkboxes') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APCheckbox_APCheckbox__["a" /* default */], {
            name: 'terms',
            id: 'agree',
            label: context.t('I agree to the terms.')
          })
        )
      )
    )
  );
};

EnableMarginConfirmationModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (EnableMarginConfirmationModal);

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DisableModalContainer__ = __webpack_require__(2299);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DisableModalContainer__["a" /* default */]);

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisableModalComponent__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_interestAccountActions__ = __webpack_require__(202);






var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    disable: function disable() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_interestAccountActions__["b" /* disableInterestAccountRequest */])());
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__DisableModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_1__redux_actions_modalActions__["b" /* MODAL_TYPES */].INTEREST_DISABLE
})(container));

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DisableMarginConfirmationModal_css__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DisableMarginConfirmationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DisableMarginConfirmationModal_css__);







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('disable-interest-confirmation');

var DisableMarginConfirmationModal = function DisableMarginConfirmationModal(_ref, context) {
  var close = _ref.close,
      isOpen = _ref.isOpen,
      disable = _ref.disable;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Interest Bearing Accounts'),
      close: close,
      footer: {
        buttonText: context.t('OK'),
        onClick: function onClick() {
          return disable().then(close);
        }
      },
      customClass: bemClasses('modal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        context.t('Are you sure want to turn off interest bearing accounts? ' + 'If you do so, you will have to reapply to begin lending again.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
    )
  );
};

DisableMarginConfirmationModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

DisableMarginConfirmationModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DisableMarginConfirmationModal);

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_APIcon__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layouts_StandAloneLayout_StandAloneLayout__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_hocs_redirectIfAuthorized__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_SimpleProblemLoggingIn_SimpleProblemLoggingInFormContainer__ = __webpack_require__(2306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProblemLoggingInPage_css__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProblemLoggingInPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ProblemLoggingInPage_css__);
var baseClasses=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-form');var problemLoggingInPageClasses=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('problem-logging-in-page');var ProblemLoggingInPage=function ProblemLoggingInPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__layouts_StandAloneLayout_StandAloneLayout__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:baseClasses('container')+' '+problemLoggingInPageClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:baseClasses('header')+' '+problemLoggingInPageClasses('header')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:baseClasses('header-text')+' '+problemLoggingInPageClasses('header-text')},context.t('Problems Logging In?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])('/'),className:baseClasses('close-icon')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_APIcon__["a" /* default */],{name:'close',classModifiers:'big'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_SimpleProblemLoggingIn_SimpleProblemLoggingInFormContainer__["a" /* default */],{showOptions:true,useEmailAsUsername:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:baseClasses('footer')+' '+problemLoggingInPageClasses('footer')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])('/login'),className:problemLoggingInPageClasses('link')},context.t('Log In')))));};ProblemLoggingInPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_hocs_redirectIfAuthorized__["a" /* default */])(ProblemLoggingInPage,"/dashboard"));

/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SimpleProblemLoggingInFormComponent__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__ = __webpack_require__(37);





var SimpleProblemLoggingInForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'forgotPassword',
  onSubmit: function onSubmit(payload, dispatch) {
    var resetPassword = payload.resetPassword,
        Email = payload.Email;

    if (resetPassword) return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__["q" /* sendResetPasswordEmail */])(Email));

    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__["o" /* resendVerificationEmail */])({ Email: Email }));
  },
  enableReinitialize: true
})(__WEBPACK_IMPORTED_MODULE_2__SimpleProblemLoggingInFormComponent__["a" /* default */]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendResetPasswordEmail: __WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__["q" /* sendResetPasswordEmail */],
    resendVerificationEmail: __WEBPACK_IMPORTED_MODULE_3__redux_actions_userActions__["o" /* resendVerificationEmail */]
  };
};

var SimpleProblemLoggingInFormContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps())(SimpleProblemLoggingInForm);

/* harmony default export */ __webpack_exports__["a"] = (SimpleProblemLoggingInFormContainer);

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SimpleProblemLoggingInFormComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APRadio_APRadio__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_components_common_StandaloneForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SimpleProblemLoggingInForm_css__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SimpleProblemLoggingInForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SimpleProblemLoggingInForm_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-form');
var simpleProblemLoggingInFormClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('forgot-password-form');

var SimpleProblemLoggingInFormComponent = function (_React$Component) {
  _inherits(SimpleProblemLoggingInFormComponent, _React$Component);

  function SimpleProblemLoggingInFormComponent(props) {
    _classCallCheck(this, SimpleProblemLoggingInFormComponent);

    var _this = _possibleConstructorReturn(this, (SimpleProblemLoggingInFormComponent.__proto__ || Object.getPrototypeOf(SimpleProblemLoggingInFormComponent)).call(this, props));

    _this.toggleFormType = function () {
      return _this.setState({ resetPassword: !_this.state.resetPassword });
    };

    _this.sendEmail = function (values) {
      var _this$props = _this.props,
          sendResetPasswordEmail = _this$props.sendResetPasswordEmail,
          resendVerificationEmail = _this$props.resendVerificationEmail;


      if (_this.state.resetPassword) {
        return sendResetPasswordEmail(values.Email);
      }

      return resendVerificationEmail(values);
    };

    _this.state = { resetPassword: true };
    return _this;
  }

  _createClass(SimpleProblemLoggingInFormComponent, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          pristine = _props.pristine,
          invalid = _props.invalid;
      var _props2 = this.props,
          useEmailAsUsername = _props2.useEmailAsUsername,
          showOptions = _props2.showOptions;


      var validate = [__WEBPACK_IMPORTED_MODULE_7__helpers_formValidations__["p" /* required */]];
      var label = context.t('Username');

      if (useEmailAsUsername || !this.state.resetPassword) {
        validate.push(__WEBPACK_IMPORTED_MODULE_7__helpers_formValidations__["d" /* email */]);
        label = context.t('Email');
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_redux_form__["b" /* Form */],
        {
          onSubmit: handleSubmit(this.sendEmail),
          className: baseClasses('form') + ' ' + simpleProblemLoggingInFormClasses('form') },
        showOptions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: baseClasses('information-text') + ' ' + simpleProblemLoggingInFormClasses('information-text') },
            context.t('Select your issue type and provide us with your {label} below. We will follow up with a solution shortly.', { label: label.toLowerCase() })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: baseClasses('separator') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            { className: baseClasses('radio-list') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APRadio_APRadio__["a" /* default */], {
              name: 'type',
              checked: this.state.resetPassword,
              onChange: this.toggleFormType,
              customClass: simpleProblemLoggingInFormClasses(),
              label: context.t('I’m an existing user and I forgot my password.'),
              id: 'problem-login-radio1'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APRadio_APRadio__["a" /* default */], {
              name: 'type',
              checked: !this.state.resetPassword,
              onChange: this.toggleFormType,
              customClass: simpleProblemLoggingInFormClasses(),
              label: context.t('I’m a new user and I haven’t received my verification email.'),
              id: 'problem-login-radio2'
            })
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: baseClasses('information-text') + ' ' + simpleProblemLoggingInFormClasses('information-text') },
          context.t('Provide us with your {label} below. We will follow up with reset instructions.', { label: label.toLowerCase() })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APInput__["b" /* default */], {
          type: 'text',
          name: 'Email',
          customClass: simpleProblemLoggingInFormClasses(),
          label: label,
          validate: validate
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: simpleProblemLoggingInFormClasses('separator') }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
          {
            type: 'submit',
            disabled: submitting || pristine || invalid,
            customClass: simpleProblemLoggingInFormClasses(),
            styleName: __WEBPACK_IMPORTED_MODULE_8__propTypes_commonComponent__["b" /* styleNames */].additive },
          submitting ? context.t('Processing...') : context.t('Send Email')
        )
      );
    }
  }]);

  return SimpleProblemLoggingInFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
SimpleProblemLoggingInFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

SimpleProblemLoggingInFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SimpleProblemLoggingInFormComponent);

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepositConfirmationComponent__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__ = __webpack_require__(176);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DepositStatusModalComponent = function (_React$Component) {
  _inherits(DepositStatusModalComponent, _React$Component);

  function DepositStatusModalComponent() {
    _classCallCheck(this, DepositStatusModalComponent);

    var _this = _possibleConstructorReturn(this, (DepositStatusModalComponent.__proto__ || Object.getPrototypeOf(DepositStatusModalComponent)).call(this));

    _this.state = {
      txnState: '',
      title: ''
    };
    return _this;
  }

  _createClass(DepositStatusModalComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var txnState = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__["a" /* getQueryParam */])('txnState');
      var trustPayRedirect = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__["a" /* getQueryParam */])('id') && Object(__WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__["a" /* getQueryParam */])('resourcePath') && Object(__WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__["a" /* getQueryParam */])('resourcePath').includes('payment');
      var title = void 0;

      if (trustPayRedirect || txnState === '1') {
        title = 'Deposit pending';
        this.setState(function () {
          return { txnState: 1, title: title };
        });
        this.props.openModal();
      }
      if (txnState === '2') {
        title = 'Deposit succesfull';
        this.setState(function () {
          return { txnState: txnState, title: title };
        });
        this.props.openModal();
      }
      if (txnState === '3') {
        title = 'Deposit error';
        this.setState(function () {
          return { txnState: txnState, title: title };
        });
        this.props.openModal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _close = _props.close,
          isOpen = _props.isOpen;
      var _state = this.state,
          txnState = _state.txnState,
          title = _state.title;

      if (txnState) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__common_Modal_Modal__["a" /* default */],
          {
            isOpen: isOpen,
            title: this.context.t(title),
            close: function close() {
              return _close();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DepositConfirmationComponent__["a" /* default */], { txnState: txnState })
        );
      } else {
        return null;
      }
    }
  }]);

  return DepositStatusModalComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DepositStatusModalComponent.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  openModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

DepositStatusModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DepositStatusModalComponent);

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var DepositStatusComponent = function DepositStatusComponent(props, context) {
  var txnState = props.txnState;

  var status = {
    '1': {
      status: 'pending',
      firstLine: context.t('Your deposit is being processed.'),
      secondLine: context.t('Your account balance will be updated soon.')
    },
    '2': {
      status: 'successful',
      firstLine: context.t('Your deposit was successfull.'),
      secondLine: context.t('Your account balance will be updated soon.')
    },
    '3': {
      status: 'failed',
      firstLine: context.t('There was a problem with your deposit.'),
      secondLine: context.t('Please try again or contact an administrator.')
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      status[txnState].firstLine
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      status[txnState].secondLine
    )
  );
};

DepositStatusComponent.propTypes = {
  txnState: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

DepositStatusComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DepositStatusComponent);

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSnackbar_APSnackbar__ = __webpack_require__(2313);




var mapStateToProps = function mapStateToProps(state) {
  return {
    snacks: state.snackbar.snacks
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dismissSnackByUniqueId: function dismissSnackByUniqueId(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_snackbarActions__["d" /* dismissSnackByUniqueId */])(payload));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__common_APSnackbar_APSnackbar__["a" /* default */]));

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Snackbar_Snackbar__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APSnackbar_css__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APSnackbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__APSnackbar_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var APSnackbar = function (_Component) {
  _inherits(APSnackbar, _Component);

  function APSnackbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, APSnackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = APSnackbar.__proto__ || Object.getPrototypeOf(APSnackbar)).call.apply(_ref, [this].concat(args))), _this), _this.bemClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['ap-snackbar']), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(APSnackbar, [{
    key: 'closeSnack',
    value: function closeSnack(snack) {
      this.props.dismissSnackByUniqueId(snack.uniqueId);
      snack.onClose && snack.onClose();
    }
  }, {
    key: 'getSnackElement',
    value: function getSnackElement(snack) {
      var _this2 = this;

      var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var timeout = snack.timeout || __WEBPACK_IMPORTED_MODULE_4__config___["b" /* default */].Snackbar.timeout;
      var animationTimeout = Math.round(timeout / 1000);

      setTimeout(function () {
        return _this2.closeSnack(snack);
      }, timeout);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: idx, className: this.bemClasses('snack') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Snackbar_Snackbar__["a" /* default */], Object.assign({}, snack, {
          onClose: function onClose() {
            return _this2.closeSnack(_this2.props.snacks[0]);
          }
        })),
        __WEBPACK_IMPORTED_MODULE_4__config___["b" /* default */].Snackbar.showProgressBar && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: this.bemClasses('snack-progress'),
          style: { animationDuration: animationTimeout + 's' }
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: this.bemClasses() },
        __WEBPACK_IMPORTED_MODULE_4__config___["b" /* default */].Snackbar.showMultiple && this.props.snacks.map(function (snack, idx) {
          return _this3.getSnackElement(snack, idx);
        }),
        !__WEBPACK_IMPORTED_MODULE_4__config___["b" /* default */].Snackbar.showMultiple && this.props.snacks[0] && this.getSnackElement(this.props.snacks[0])
      ), document.body);
    }
  }]);

  return APSnackbar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

APSnackbar.defaultProps = {
  timeout: __WEBPACK_IMPORTED_MODULE_4__config___["b" /* default */].Snackbar.timeout,
  snacks: []
};
APSnackbar.propTypes = {
  timeout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  snacks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    timeout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    textVars: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['info', 'success', 'warning']),
    customClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  })).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (APSnackbar);

/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config___ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Snackbar_css__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Snackbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Snackbar_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Snackbar = function (_Component) {
  _inherits(Snackbar, _Component);

  function Snackbar() {
    _classCallCheck(this, Snackbar);

    return _possibleConstructorReturn(this, (Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).apply(this, arguments));
  }

  _createClass(Snackbar, [{
    key: 'render',
    value: function render() {
      var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['snackbar', this.props.customClass]);
      var _props = this.props,
          type = _props.type,
          text = _props.text,
          textVars = _props.textVars;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('', type) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('text', type) },
          this.context.t(text, textVars)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('close', type), onClick: this.props.onClose },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__APIcon__["a" /* default */], {
            name: 'close',
            className: bemClasses('close-icon'),
            customClass: bemClasses('icon'),
            classModifiers: 'big'
          })
        )
      );
    }
  }]);

  return Snackbar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Snackbar.defaultProps = {
  timeout: __WEBPACK_IMPORTED_MODULE_3__config___["b" /* default */].Snackbar.timeout,
  text: '',
  textVars: {},
  type: __WEBPACK_IMPORTED_MODULE_3__config___["b" /* default */].Snackbar.type,
  customClass: 'custom-snackbar',
  onClose: function onClose() {}
};
Snackbar.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Snackbar.propTypes = {
  timeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  textVars: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['info', 'success', 'warning']),
  customClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (Snackbar);

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TwoFactorAuthFormComponent__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__ = __webpack_require__(89);





var mapStateToProps = function mapStateToProps(state) {
  return {
    is2FARequired: state.auth.is2FARequired
  };
};

var TwoFactorAuthFormContainer = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__TwoFactorAuthFormComponent__["a" /* default */]);

var TwoFactorAuthFormContainerForm = Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["j" /* reduxForm */])({
  form: 'twoFactorAuth',
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["l" /* sendTwoFactorAuthCode */])(payload.code)).then(function (item) {
      if (item.type === __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["b" /* AUTH_ERROR */]) {
        throw new __WEBPACK_IMPORTED_MODULE_0_redux_form__["c" /* SubmissionError */]({
          _error: 'Invalid Auth Code. Please try again.'
          //context.t('Invalid Auth Code. Please try again.')
        });
      }
      return true;
    });
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(TwoFactorAuthFormContainer);

/* harmony default export */ __webpack_exports__["a"] = (TwoFactorAuthFormContainerForm);

/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TwoFactorAuthFormComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APAutoTabInput_APAutoTabInput__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_common_StandaloneForm_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_common_StandaloneForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_components_common_StandaloneForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TwoFactorAuthFormComponent_css__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TwoFactorAuthFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TwoFactorAuthFormComponent_css__);











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-form');
var twoFactorAuthFormClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('two-factor-auth-form');

var TwoFactorAuthFormComponent = function TwoFactorAuthFormComponent(props, context) {
  var handleSubmit = props.handleSubmit,
      is2FARequired = props.is2FARequired,
      error = props.error;


  if (!is2FARequired) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Redirect */], { to: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_path__["a" /* default */])('/login') });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: baseClasses('container') + ' ' + twoFactorAuthFormClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: baseClasses('header') + ' ' + twoFactorAuthFormClasses('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: baseClasses('header-text') + ' ' + twoFactorAuthFormClasses('header-text') },
        context.t('Two-Factor Authentication')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      {
        onSubmit: handleSubmit,
        className: baseClasses('form') + ' ' + twoFactorAuthFormClasses('form') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: baseClasses('information-text') + ' ' + twoFactorAuthFormClasses('information-text') },
        context.t('Enter the token from your Authenticator app.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('auto-tab-input') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APAutoTabInput_APAutoTabInput__["a" /* default */], {
          name: 'code',
          type: 'input',
          numberOfInputs: 6,
          validate: [__WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__["p" /* required */]],
          customClass: twoFactorAuthFormClasses('input')
        }),
        error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: baseClasses('error') + ' ' + twoFactorAuthFormClasses('error') },
          error
        )
      )
    )
  );
};

TwoFactorAuthFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

TwoFactorAuthFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TwoFactorAuthFormComponent);

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidePaneComponent__ = __webpack_require__(2321);




var mapStateToProps = function mapStateToProps(state) {
  var _state$sidePane = state.sidePane,
      isOpen = _state$sidePane.isOpen,
      name = _state$sidePane.name,
      data = _state$sidePane.data;

  return {
    isOpen: isOpen,
    name: name,
    data: data
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    close: function close(name) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_sidePaneActions__["j" /* closeSidePane */])(name));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__SidePaneComponent__["a" /* default */]));

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sliding_pane__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sliding_pane___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_sliding_pane__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_history__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidePaneChildren__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_sliding_pane_dist_react_sliding_pane_css__ = __webpack_require__(2475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_sliding_pane_dist_react_sliding_pane_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_sliding_pane_dist_react_sliding_pane_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SidePane_css__ = __webpack_require__(2476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SidePane_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SidePane_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SidePane = function (_Component) {
  _inherits(SidePane, _Component);

  function SidePane(props) {
    _classCallCheck(this, SidePane);

    var _this = _possibleConstructorReturn(this, (SidePane.__proto__ || Object.getPrototypeOf(SidePane)).call(this, props));

    _this.getPropsFromChild = function (_ref) {
      var title = _ref.title,
          customClass = _ref.customClass,
          hideCloseLink = _ref.hideCloseLink,
          classModifiers = _ref.classModifiers,
          hideHeader = _ref.hideHeader;

      _this.setState({
        title: title,
        customClass: customClass,
        hideCloseLink: hideCloseLink,
        classModifiers: classModifiers,
        hideHeader: hideHeader
      });
    };

    _this.returnScrollPosition = function () {
      document.body.style.position = 'static';
      window.scroll(0, _this.state.scrollPosition);
    };

    _this.renderCloseIcon = function () {
      var classes = _this.getClasses();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { onClick: _this.props.close, className: classes('close-button') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__APIcon__["a" /* default */], { name: 'close', classModifiers: 'big' })
      );
    };

    _this.closePane = function () {
      return _this.props.close(_this.props.name);
    };

    _this.unlisten = null;

    _this.state = {
      title: '',
      customClass: '',
      hideCloseLink: false,
      classModifiers: '',
      hideHeader: false,
      scrollPosition: 0
    };
    return _this;
  }

  _createClass(SidePane, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_react_modal___default.a.setAppElement(this.modalRef);
      this.unlisten = __WEBPACK_IMPORTED_MODULE_6__helpers_history__["a" /* default */].listen(function (location, action) {
        if (action === 'POP' && _this2.props.isOpen) {
          _this2.props.close();
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var bodyPosition = document.body.style.position;
      if (!this.props.isOpen && bodyPosition === 'fixed') {
        this.returnScrollPosition();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unlisten();
      this.unlisten = null;
    }
  }, {
    key: 'getClasses',
    value: function getClasses() {
      return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['ap-sidepane', this.state.customClass]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          isOpen = _props.isOpen,
          name = _props.name,
          data = _props.data,
          options = _props.options;

      var _state = this.state,
          hideCloseLink = _state.hideCloseLink,
          classModifiers = _state.classModifiers,
          otherProps = _objectWithoutProperties(_state, ['hideCloseLink', 'classModifiers']);

      var classes = this.getClasses();
      var Child = __WEBPACK_IMPORTED_MODULE_8__SidePaneChildren__["a" /* default */][name];
      var isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod/i);

      if (name && !Child) {
        console.error(this.context.t('SidePane Component named ' + name + ' not found'));
        return null;
      }

      var sidePaneOptions = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(options, name, {});

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: classes(null, classModifiers),
          ref: function ref(_ref2) {
            return _this3.modalRef = _ref2;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_sliding_pane___default.a,
          Object.assign({
            className: classes('container', classModifiers),
            overlayClassName: classes('overlay', classModifiers),
            onAfterOpen: function onAfterOpen() {
              if (isMobile) {
                // set position after opening sidepane
                setTimeout(function () {
                  _this3.setState({ scrollPosition: window.pageYOffset });
                  document.body.style.position = 'fixed';
                }, 500);
              }
            },
            onRequestClose: this.closePane,
            isOpen: isOpen
          }, otherProps),
          !hideCloseLink && this.renderCloseIcon(),
          Child && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Child, Object.assign({
            name: name,
            closeSidePane: this.closePane
          }, data, sidePaneOptions, {
            onSidePaneOpen: this.getPropsFromChild
          }))
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.isOpen) {
        var header = document.getElementsByClassName('slide-pane__header')[0];
        if (header && state.hideHeader) {
          header.classList.add('slide-pane__hide-header');
        }
      }
      return state;
    }
  }]);

  return SidePane;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SidePane.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  hideCloseLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
SidePane.defaultProps = {
  customClass: 'custom-sidepane',
  options: {}
};
SidePane.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SidePane);

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0),__webpack_require__(1),__webpack_require__(373)):"function"==typeof define&&define.amd?define("ReactSlidingPane",["react","prop-types","react-modal"],t):"object"==typeof exports?exports.ReactSlidingPane=t(require("react"),require("prop-types"),require("react-modal")):e.ReactSlidingPane=t(e.React,e[void 0],e.ReactModal)}("undefined"!=typeof self?self:this,function(e,t,n){return function(e){function t(a){if(n[a])return n[a].exports;var r=n[a]={i:a,l:!1,exports:{}};return e[a].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,a){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:a})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=0)}([function(e,t,n){"use strict";function a(e){var t=e.isOpen,n=e.title,a=e.subtitle,r=e.onRequestClose,l=e.onAfterOpen,i=e.children,s=e.className,u=e.overlayClassName,d=e.from,f=void 0===d?"right":d,m=e.width,v="slide-pane_from_"+f;return o.a.createElement(c.a,{className:"slide-pane "+v+" "+(s||""),style:{content:{width:m||"80%"}},overlayClassName:"slide-pane__overlay "+(u||""),closeTimeoutMS:p,isOpen:t,onAfterOpen:l,onRequestClose:r,contentLabel:'Modal "'+(n||"")+'"'},o.a.createElement("div",{className:"slide-pane__header"},o.a.createElement("div",{className:"slide-pane__close",onClick:r},o.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 13 22"},o.a.createElement("path",{fill:"currentColor",fillRule:"evenodd",d:"M4 11l8 8c.6.5.6 1.5 0 2-.5.6-1.5.6-2 0l-9-9c-.6-.5-.6-1.5 0-2l9-9c.5-.6 1.5-.6 2 0 .6.5.6 1.5 0 2l-8 8z"}))),o.a.createElement("div",{className:"slide-pane__title-wrapper"},o.a.createElement("h2",{className:"slide-pane__title"},n),o.a.createElement("div",{className:"slide-pane__subtitle"},a))),o.a.createElement("div",{className:"slide-pane__content"},i))}Object.defineProperty(t,"__esModule",{value:!0}),t.default=a;var r=n(1),o=n.n(r),l=n(2),i=n.n(l),s=n(3),c=n.n(s),u=n(4),p=(n.n(u),500);a.propTypes={isOpen:i.a.bool.isRequired,title:i.a.any,subtitle:i.a.any,onRequestClose:i.a.func,onAfterOpen:i.a.func,children:i.a.any.isRequired,className:i.a.string,overlayClassName:i.a.string,from:i.a.oneOf(["left","right","bottom"]),width:i.a.string}},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t){e.exports=n},function(e,t){}])});

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportBlockTradeSidePaneComponents_ReportBlockTradeSidePaneContainer__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApiKeysSidePaneComponents_ApiKeysSidePane_ApiKeysSidePaneComponent__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderEntryComponents_AdvancedOrderSidePane_AdvancedOrderSidePaneContainer__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SendReceiveSidePane_SendReceiveSidePaneContainer__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KYC_IM_KYC_IMForm__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KYC_IMLegacy_KYC_IMLegacyForm__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KYC_Jumio_KYC_JumioIframe__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KYC_Manual_KYC_ManualForm__ = __webpack_require__(2426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportSidePaneComponents_ReportSidePaneComponent__ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DepositSidePaneComponents_DepositSidePaneComponent__ = __webpack_require__(2444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WithdrawSidePaneComponents_WithdrawSidePaneComponent__ = __webpack_require__(2448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Retail_RetailSidePanes_FiatSidePaneContainer__ = __webpack_require__(839);













/* harmony default export */ __webpack_exports__["a"] = ({
  ReportBlockTrade: __WEBPACK_IMPORTED_MODULE_0__ReportBlockTradeSidePaneComponents_ReportBlockTradeSidePaneContainer__["a" /* default */],
  ApiKeys: __WEBPACK_IMPORTED_MODULE_1__ApiKeysSidePaneComponents_ApiKeysSidePane_ApiKeysSidePaneComponent__["a" /* default */],
  AdvancedOrder: __WEBPACK_IMPORTED_MODULE_2__OrderEntryComponents_AdvancedOrderSidePane_AdvancedOrderSidePaneContainer__["a" /* default */],
  SendReceive: __WEBPACK_IMPORTED_MODULE_3__SendReceiveSidePane_SendReceiveSidePaneContainer__["a" /* default */],
  KYC_IMForm: __WEBPACK_IMPORTED_MODULE_4__KYC_IM_KYC_IMForm__["a" /* default */],
  KYC_IMLegacyForm: __WEBPACK_IMPORTED_MODULE_5__KYC_IMLegacy_KYC_IMLegacyForm__["a" /* default */],
  KYC_JumioForm: __WEBPACK_IMPORTED_MODULE_6__KYC_Jumio_KYC_JumioIframe__["a" /* default */],
  KYC_ManualForm: __WEBPACK_IMPORTED_MODULE_7__KYC_Manual_KYC_ManualForm__["a" /* default */],
  Reports: __WEBPACK_IMPORTED_MODULE_8__ReportSidePaneComponents_ReportSidePaneComponent__["a" /* default */],
  Deposits: __WEBPACK_IMPORTED_MODULE_9__DepositSidePaneComponents_DepositSidePaneComponent__["a" /* default */],
  Withdraws: __WEBPACK_IMPORTED_MODULE_10__WithdrawSidePaneComponents_WithdrawSidePaneComponent__["a" /* default */],
  RetailFiat: __WEBPACK_IMPORTED_MODULE_11__Retail_RetailSidePanes_FiatSidePaneContainer__["a" /* default */]
});

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportBlockTradeSidePaneComponent__ = __webpack_require__(2325);






var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;

  return {
    form: form.reportBlockTrade
  };
};

var mapDispatchToProps = {
  setBoughtReport: function setBoughtReport() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('reportBlockTrade', 'side', __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]);
  },
  setSoldReport: function setSoldReport() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('reportBlockTrade', 'side', __WEBPACK_IMPORTED_MODULE_2__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */]);
  },
  clearReportBlockTrade: function clearReportBlockTrade() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__["d" /* clearOrderForm */])('reportBlockTrade');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__ReportBlockTradeSidePaneComponent__["a" /* default */]));

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReportBlockTradeContainer__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmBlockTradeModal_ConfirmBlockTradeModalContainer__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReportBlockTradeSidePaneComponent_css__ = __webpack_require__(2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReportBlockTradeSidePaneComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ReportBlockTradeSidePaneComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('report-block-trade-sidepane');

var ReportBlockTradeSidePane = function (_React$Component) {
  _inherits(ReportBlockTradeSidePane, _React$Component);

  function ReportBlockTradeSidePane() {
    _classCallCheck(this, ReportBlockTradeSidePane);

    return _possibleConstructorReturn(this, (ReportBlockTradeSidePane.__proto__ || Object.getPrototypeOf(ReportBlockTradeSidePane)).apply(this, arguments));
  }

  _createClass(ReportBlockTradeSidePane, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        title: this.context.t('Report Block Trade'),
        customClass: baseClasses(),
        classModifiers: 'with-tabs'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          setBoughtReport = _props.setBoughtReport,
          setSoldReport = _props.setSoldReport,
          clearReportBlockTrade = _props.clearReportBlockTrade;


      var boughtTabModifier = (form && form.values.side === __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] || !form) && 'bought-selected';

      var soldTabModifier = form && form.values.side === __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */] && 'sold-selected';

      var selectBoughtTab = function selectBoughtTab() {
        clearReportBlockTrade();
        setBoughtReport();
      };

      var selectSoldTab = function selectSoldTab() {
        clearReportBlockTrade();
        setSoldReport();
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('tab-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: baseClasses('tab', boughtTabModifier),
              onClick: selectBoughtTab },
            this.context.t('Bought')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: baseClasses('tab', soldTabModifier),
              onClick: selectSoldTab },
            this.context.t('Sold')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReportBlockTradeContainer__["a" /* default */], {
          useNewForm: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this, 'props.useNewForm', false)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ConfirmBlockTradeModal_ConfirmBlockTradeModalContainer__["a" /* default */], null)
      );
    }
  }]);

  return ReportBlockTradeSidePane;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ReportBlockTradeSidePane.propTypes = {
  setBoughtReport: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSoldReport: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

ReportBlockTradeSidePane.defaultProps = {
  onSidePaneOpen: function onSidePaneOpen() {}
};

ReportBlockTradeSidePane.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ReportBlockTradeSidePane);

/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReportBlockTradeComponent__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_store__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_selectors_orderTotalSelector__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config__ = __webpack_require__(6);


















var closeSidePane = function closeSidePane() {
  return __WEBPACK_IMPORTED_MODULE_9__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__redux_actions_sidePaneActions__["h" /* closeReportBlockTradeSidePane */])());
};

var mapStateToProps = function mapStateToProps(state, _ref) {
  var useNewForm = _ref.useNewForm;
  var form = state.form,
      product = state.apexCore.product;
  var decimalPlaces = product.decimalPlaces;


  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);

  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_11__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableTrading = _kycVerificationLevel.disableTrading;

  var formObj = form.reportBlockTrade || { values: {} };

  var instruments = Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);

  var orderTotal = form.reportBlockTrade ? Object(__WEBPACK_IMPORTED_MODULE_13__redux_selectors_orderTotalSelector__["a" /* orderTotalSelector */])(state, {
    form: form.reportBlockTrade.values,
    useNewForm: useNewForm
  }) : 0;

  if (useNewForm) {
    orderTotal = orderTotal * __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(form, 'reportBlockTrade.values.quantity', 0);
  }

  return Object.assign({
    instruments: instruments,
    selectedInstrument: selectedInstrument,
    formObj: formObj,
    decimalPlaces: decimalPlaces
  }, Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_instrumentPositionSelectors__["a" /* default */])(state), {
    positions: Object(__WEBPACK_IMPORTED_MODULE_12__redux_selectors_positionSelectors__["b" /* positionSelector */])(state),
    orderTotal: selectedInstrument.Product2Symbol + ' ' + Object(__WEBPACK_IMPORTED_MODULE_14__helpers_numberFormatter__["b" /* formatNumberToLocale */])(orderTotal, selectedInstrument.Product2Symbol),
    orderNet: Object(__WEBPACK_IMPORTED_MODULE_15__helpers_orderHelper__["e" /* getOrderNet */])(formObj, selectedInstrument, orderTotal),
    initialValues: {
      useNewForm: useNewForm,
      side: formObj.values.side || __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */],
      instrument: selectedInstrument.InstrumentId,
      quantity: '',
      fee: { OrderFee: '0' },
      totalAmount: '0',
      price: '',
      counterparty: '',
      orderType: __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["c" /* orderTypes */].reportBlockTrade.displayName,
      lockedIn: false
    },
    disableTrading: disableTrading,
    VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__VerificationRequired_VerificationRequiredContainer__["a" /* default */], { onVerificationLinkClick: closeSidePane }),
    showLockedIn: __WEBPACK_IMPORTED_MODULE_16__config__["b" /* default */].BlockTrade.showLockedIn
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var useNewForm = _ref2.useNewForm;
  return {
    onSubmit: function onSubmit() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_7__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_BLOCK_REPORT, { useNewForm: useNewForm }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["j" /* reduxForm */])({
  form: 'reportBlockTrade',
  enableReinitialize: true
})(__WEBPACK_IMPORTED_MODULE_5__ReportBlockTradeComponent__["a" /* default */])));

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APCheckbox__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__propTypes_instrumentPropTypes__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UserBalance_UserBalanceComponent__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ReportBlockTradeForm_css__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ReportBlockTradeForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ReportBlockTradeForm_css__);


















var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['report-block-trade-form']);
var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_cssClassesHelper__["b" /* getBEMClasses */])('slide-pane');
var dividerClasses = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_cssClassesHelper__["b" /* getBEMClasses */])('divider');

var ReportBlockTradeForm = function ReportBlockTradeForm(props, context) {
  var position1 = props.position1,
      position2 = props.position2,
      instruments = props.instruments,
      handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      disableTrading = props.disableTrading,
      formObj = props.formObj,
      decimalPlaces = props.decimalPlaces,
      selectedInstrument = props.selectedInstrument,
      invalid = props.invalid,
      positions = props.positions,
      VerificationRequiredComponent = props.VerificationRequiredComponent,
      showLockedIn = props.showLockedIn,
      orderTotal = props.orderTotal,
      orderNet = props.orderNet,
      useNewForm = props.useNewForm;
  var side = formObj.values.side;

  var boughtProductSymbol = side === __WEBPACK_IMPORTED_MODULE_10__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? selectedInstrument.Product1Symbol : selectedInstrument.Product2Symbol;
  var soldProductSymbol = side === __WEBPACK_IMPORTED_MODULE_10__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? selectedInstrument.Product2Symbol : selectedInstrument.Product1Symbol;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { className: slidePaneClasses('body'), onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('main-section') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('inputs-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses(null, ['with-padding']) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APSelect__["b" /* default */], {
            name: 'instrument',
            label: context.t('Instrument') + ':',
            customClass: bemClasses(),
            options: instruments.map(function (instrument) {
              var InstrumentId = instrument.InstrumentId;

              return { value: InstrumentId, label: instrument.Symbol };
            }),
            showTriangles: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('counterparty') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_APInput__["b" /* default */], {
            name: 'counterparty',
            label: context.t('Counterparty') + ':',
            customClass: bemClasses(),
            validate: [__WEBPACK_IMPORTED_MODULE_14__helpers_formValidations__["c" /* biggerThanZero */]]
          }),
          showLockedIn && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('checkbox-container') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APCheckbox__["a" /* default */], {
              name: 'lockedIn',
              type: 'checkbox',
              id: 'locked-in',
              label: context.t('Locked In')
            })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: dividerClasses(null, ['dark', 'side-pane-size']) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('inputs-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses(null, ['with-padding']) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
          name: 'quantity',
          placeholder: '0',
          label: context.t(useNewForm ? 'Quantity' : 'Product Bought') + ':',
          decimalPlaces: decimalPlaces[boughtProductSymbol],
          customClass: bemClasses(),
          labelInInput: boughtProductSymbol,
          validate: [__WEBPACK_IMPORTED_MODULE_14__helpers_formValidations__["c" /* biggerThanZero */]]
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
        name: 'price',
        placeholder: '0',
        label: context.t(useNewForm ? 'Price' : 'Product Sold') + ':',
        decimalPlaces: decimalPlaces[soldProductSymbol],
        customClass: bemClasses(),
        labelInInput: soldProductSymbol,
        validate: [__WEBPACK_IMPORTED_MODULE_14__helpers_formValidations__["c" /* biggerThanZero */]]
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: dividerClasses(null, ['dark', 'side-pane-size']) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, 'with-small-padding') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
        label: context.t('Fees') + ':',
        text: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_orderHelper__["c" /* getOrderFee */])(formObj, positions),
        customClass: bemClasses()
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, 'with-small-padding') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
        label: context.t('Received') + ':',
        text: orderNet,
        customClass: bemClasses()
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
      label: context.t('Order Total') + ':',
      text: orderTotal,
      customClass: bemClasses()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: dividerClasses(null, ['dark', 'side-pane-size']) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('user-balance-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__UserBalance_UserBalanceComponent__["a" /* default */], { position1: position1, position2: position2 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: dividerClasses(null, ['dark', 'side-pane-size']) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
        {
          type: 'submit',
          disabled: submitting || invalid || disableTrading,
          customClass: bemClasses(),
          styleName: formObj.values.side === __WEBPACK_IMPORTED_MODULE_10__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */] ? __WEBPACK_IMPORTED_MODULE_9__propTypes_commonComponent__["b" /* styleNames */].subtractive : __WEBPACK_IMPORTED_MODULE_9__propTypes_commonComponent__["b" /* styleNames */].additive },
        submitting ? context.t('Processing...') : context.t('Submit Report')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('verification-required') },
      VerificationRequiredComponent
    )
  );
};

ReportBlockTradeForm.defaultProps = {
  showLockedIn: true
};

ReportBlockTradeForm.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  position1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  position2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7__propTypes_instrumentPropTypes__["a" /* instrumentPropType */]).isRequired,
  formObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  disableTrading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  showLockedIn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

ReportBlockTradeForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ReportBlockTradeForm);

/***/ }),
/* 2328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmBlockTradeModalComponent__ = __webpack_require__(2331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_orderTotalSelector__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderFormTypes__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);










var mapStateToProps = function mapStateToProps(state) {
  var form = state.form,
      product = state.apexCore.product;


  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_8__redux_selectors_instrumentPositionSelectors__["d" /* selectedInstrumentSelector */])(state);
  var productId = form.reportBlockTrade.values.fee.ProductId || form.reportBlockTrade.values.fee.FeeProductId;
  var feeSymbol = productId ? product.products.find(function (item) {
    return item.ProductId === productId;
  }).Product : '';

  var orderTotal = form.reportBlockTrade ? Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_orderTotalSelector__["a" /* orderTotalSelector */])(state, {
    form: form.reportBlockTrade.values
  }) : 0;

  return {
    formObj: form.reportBlockTrade || { values: {} },
    selectedInstrument: selectedInstrument,
    feeSymbol: feeSymbol,
    orderTotal: orderTotal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var useNewForm = _ref.useNewForm;

  return {
    confirmReport: function confirmReport(form) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["e" /* placeOrder */])(__WEBPACK_IMPORTED_MODULE_7__constants_sendOrder_orderFormTypes__["a" /* orderFormTypes */].block, form, { useNewForm: useNewForm })).then(function (result) {
        if (result.status === 'Accepted') {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_orderEntryActions__["d" /* clearOrderForm */])('reportBlockTrade'));
        }

        if (result.result === false) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_snackbarActions__["e" /* showSnack */])({
            id: 'confirmBlockTradeFail',
            text: result.detail,
            type: 'warning'
          }));
        }
      });
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConfirmBlockTradeModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_BLOCK_REPORT
})(container));

/***/ }),
/* 2331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConfirmBlockTradeModalComponent_css__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConfirmBlockTradeModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ConfirmBlockTradeModalComponent_css__);












var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('confirm-block-trade-modal');

var ConfirmBlockTradeModal = function ConfirmBlockTradeModal(props, context) {
  var formObj = props.formObj,
      selectedInstrument = props.selectedInstrument,
      isOpen = props.isOpen,
      close = props.close,
      confirmReport = props.confirmReport,
      feeSymbol = props.feeSymbol,
      orderTotal = props.orderTotal,
      useNewForm = props.useNewForm;

  var isBuySide = formObj.values.side === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */];
  var boughtProductSymbol = isBuySide ? selectedInstrument.Product1Symbol : selectedInstrument.Product2Symbol;
  var soldProductSymbol = isBuySide ? selectedInstrument.Product2Symbol : selectedInstrument.Product1Symbol;

  var items = [{
    label: context.t('Instrument'),
    text: '' + selectedInstrument.Symbol
  }, {
    label: context.t('Counterparty'),
    text: '' + (formObj.values.counterparty ? formObj.values.counterparty : '-')
  }, {
    label: context.t('Locked in'),
    text: '' + (formObj.values.lockedIn ? context.t('Yes') : context.t('No'))
  }, {
    label: context.t(useNewForm ? 'Quantity' : 'Product Bought'),
    text: formObj.values.quantity + ' ' + boughtProductSymbol
  }, {
    label: context.t(useNewForm ? 'Price' : 'Product Sold'),
    text: formObj.values.price + ' ' + soldProductSymbol
  }, {
    label: context.t('Fee'),
    text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(formObj.values.fee.OrderFee, feeSymbol)
  }, {
    label: context.t('Final Amount'),
    text: Object(__WEBPACK_IMPORTED_MODULE_8__helpers_orderHelper__["e" /* getOrderNet */])(formObj, selectedInstrument, orderTotal, false)
  }, {
    label: context.t('Final Value'),
    text: Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(useNewForm ? formObj.values.price * formObj.values.quantity : formObj.values.price, soldProductSymbol)
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Confirm Block Trade'),
      close: close,
      footer: {
        buttonText: isBuySide ? context.t('Confirm Buy Order') : context.t('Confirm Sell Order'),
        buttonStyle: isBuySide ? 'additive' : 'subtractive',
        onClick: function onClick() {
          return confirmReport(formObj.values);
        }
      },
      customClass: bemClasses(formObj.values.side === __WEBPACK_IMPORTED_MODULE_6__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] ? 'bought' : 'sold') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses() },
      items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          key: item.label,
          label: item.label,
          text: item.text,
          customClass: bemClasses()
        });
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Date') + ':',
        text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["c" /* formatDateTime */])(new Date()),
        customClass: bemClasses()
      })
    )
  );
};

ConfirmBlockTradeModal.propTypes = {
  formObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  confirmReport: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ConfirmBlockTradeModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmBlockTradeModal);

/***/ }),
/* 2332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateApiKey_CreateApiKeyContainer__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewApiKey_NewApiKeyModalContainer__ = __webpack_require__(2338);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ApiKeysSidePaneComponent = function (_React$Component) {
  _inherits(ApiKeysSidePaneComponent, _React$Component);

  function ApiKeysSidePaneComponent() {
    _classCallCheck(this, ApiKeysSidePaneComponent);

    return _possibleConstructorReturn(this, (ApiKeysSidePaneComponent.__proto__ || Object.getPrototypeOf(ApiKeysSidePaneComponent)).apply(this, arguments));
  }

  _createClass(ApiKeysSidePaneComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        hideHeader: true,
        customClass: 'retail-api-keys-sidepane'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CreateApiKey_CreateApiKeyContainer__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NewApiKey_NewApiKeyModalContainer__["a" /* default */], null)
      );
    }
  }]);

  return ApiKeysSidePaneComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ApiKeysSidePaneComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
ApiKeysSidePaneComponent.propTypes = {
  closeSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ApiKeysSidePaneComponent);

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateApiKeyComponent__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_apiKeyActions__ = __webpack_require__(172);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["j" /* reduxForm */])({
  form: 'createApiKey',
  initialValues: {
    trading: false,
    deposit: false,
    withdraw: false,
    accountReadOnly: false
  },
  onSubmit: function onSubmit(payload, dispatch) {
    if (payload.deposit || payload.trading || payload.withdraw || payload.accountReadOnly) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_apiKeyActions__["f" /* createApiKey */])(payload));
    } else {
      throw new __WEBPACK_IMPORTED_MODULE_0_redux_form__["c" /* SubmissionError */]({
        _error: 'Please choose at least one activity'
        //context.t('Please choose at least one activity')
      });
    }
  }
})(__WEBPACK_IMPORTED_MODULE_1__CreateApiKeyComponent__["a" /* default */]));

/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APCheckbox__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateApiKeyComponent_css__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateApiKeyComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CreateApiKeyComponent_css__);









var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('create-api-key');

var CreateApiKeyComponent = function CreateApiKeyComponent(props, context) {
  var error = props.error,
      pristine = props.pristine;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    {
      onSubmit: props.handleSubmit,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('form-inline', baseClasses('slide-pane-body')) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('header') },
      context.t('Create New API Key')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('form-body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('frame') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('title') },
          context.t('Choose the following activities to allow the API Key to access:')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('input-wrapper') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APCheckbox__["a" /* default */], {
            name: 'trading',
            label: context.t('Trading'),
            id: 'trading',
            customClass: baseClasses()
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('input-wrapper') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APCheckbox__["a" /* default */], {
            name: 'deposit',
            label: context.t('Deposits'),
            id: 'deposit',
            customClass: baseClasses()
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('input-wrapper') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APCheckbox__["a" /* default */], {
            name: 'withdraw',
            label: context.t('Withdrawals'),
            id: 'withdraw',
            customClass: baseClasses()
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('input-wrapper') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APCheckbox__["a" /* default */], {
            name: 'accountReadOnly',
            label: context.t('Read Only'),
            id: 'viewonly',
            customClass: baseClasses()
          })
        ),
        error && pristine ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('error') },
          error
        ) : null
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('footer') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
          {
            type: 'submit',
            customClass: baseClasses(),
            disabled: props.submitting,
            styleName: 'additive' },
          props.submitting ? context.t('Processing...') : context.t('Create')
        )
      )
    )
  );
};

CreateApiKeyComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

CreateApiKeyComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (CreateApiKeyComponent);

/***/ }),
/* 2337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewApiKeyModal__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_apiKeyActions__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_sidePaneActions__ = __webpack_require__(23);







var mapStateToProps = function mapStateToProps(state) {
  return {
    numberOfApiKeys: state.apiKey.apiKeys.length,
    userId: state.user.userInfo.UserId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addApiKey: function addApiKey(apiKey) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_apiKeyActions__["e" /* addApiKey */])(apiKey));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_sidePaneActions__["d" /* closeApiKeysSidePane */])());
    },
    removeApiKey: function removeApiKey(apiKey) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_apiKeyActions__["h" /* removeApiKey */])(apiKey));
    }
  };
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__NewApiKeyModal__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].NEW_API_KEY
})(container));

/***/ }),
/* 2339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmApiKeyModal_ConfirmAPIKeyModal__ = __webpack_require__(2340);





var NewApiKeyModal = function NewApiKeyModal(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: props.isOpen,
      title: context.t('Create New API Key'),
      customClass: 'retail-api-keys-modal',
      onCancel: function onCancel() {
        props.removeApiKey(props.apiKey.APIKey);
        props.close();
      },
      close: props.close,
      footer: {
        buttonText: context.t('Confirm'),
        buttonStyle: 'additive',
        onClick: function onClick() {
          return props.addApiKey(props.apiKey);
        }
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ConfirmApiKeyModal_ConfirmAPIKeyModal__["a" /* default */], {
      item: props.apiKey,
      userId: props.userId,
      index: props.numberOfApiKeys
    })
  );
};

NewApiKeyModal.propTypes = {
  apiKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  userId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  numberOfApiKeys: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  addApiKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  removeApiKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

NewApiKeyModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (NewApiKeyModal);

/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_hmac_sha256__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_hmac_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_crypto_js_hmac_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmAPIKeyModal_css__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmAPIKeyModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfirmAPIKeyModal_css__);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('confirm-api-key');

var ConfirmAPIKeyModal = function ConfirmAPIKeyModal(props, context) {
  var Permissions = props.item.Permissions;

  var nonce = window.crypto.getRandomValues(new Uint32Array(1)).toString();
  var userId = props.userId,
      _props$item = props.item,
      APIKey = _props$item.APIKey,
      APISecret = _props$item.APISecret;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('key-info-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Permissions'),
        text: Permissions.join(', '),
        customClass: baseClasses()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Key'),
        text: APIKey,
        customClass: baseClasses()
      }),
      APISecret && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: context.t('Secret'),
          text: APISecret,
          customClass: baseClasses()
        })
      )
    ),
    APISecret && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('authenticate-user') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          context.t('Call {a} with the following to login:', {
            a: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'code',
              null,
              'AuthenticateUser'
            )
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'pre',
          null,
          JSON.stringify({
            APIKey: APIKey,
            Signature: __WEBPACK_IMPORTED_MODULE_2_crypto_js_hmac_sha256___default()('' + nonce + userId + APIKey, APISecret).toString(),
            UserId: userId.toString(),
            Nonce: nonce
          }, null, 2)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          context.t('To generate your own signature with a different nonce, {hmacSha256} encode your nonce, user ID, and API key, in the format {messageFormat} using the secret as your key.', {
            hmacSha256: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                href: 'https://codebeautify.org/hmac-generator',
                target: '_blank',
                rel: 'noopener noreferrer' },
              'HMAC-Sha256'
            ),
            messageFormat: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'code',
              null,
              'NonceUserIdAPIKey'
            )
          })
        )
      )
    )
  );
};

ConfirmAPIKeyModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ConfirmAPIKeyModal.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

ConfirmAPIKeyModal.defaultProps = {
  index: 0
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmAPIKeyModal);

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(421), __webpack_require__(2342), __webpack_require__(2343));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA256;

}));

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(421));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(421));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 2344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdvancedOrderSidePaneComponent__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);






var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;

  return {
    form: form.advancedOrderEntry
  };
};

var mapDispatchToProps = {
  setBuyOrder: function setBuyOrder() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('advancedOrderEntry', 'side', __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */]);
  },
  setSellOrder: function setSellOrder() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('advancedOrderEntry', 'side', __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */]);
  },
  clearAdvancedOrderEntryForm: function clearAdvancedOrderEntryForm() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_orderEntryActions__["d" /* clearOrderForm */])('advancedOrderEntry');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__AdvancedOrderSidePaneComponent__["a" /* default */]));

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdvancedOrderForm_AdvancedOrderFormContainer__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvancedOrderSidePaneComponent_css__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvancedOrderSidePaneComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AdvancedOrderSidePaneComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('advanced-order-sidepane');

var AdvancedOrderSidePane = function (_React$Component) {
  _inherits(AdvancedOrderSidePane, _React$Component);

  function AdvancedOrderSidePane() {
    _classCallCheck(this, AdvancedOrderSidePane);

    return _possibleConstructorReturn(this, (AdvancedOrderSidePane.__proto__ || Object.getPrototypeOf(AdvancedOrderSidePane)).apply(this, arguments));
  }

  _createClass(AdvancedOrderSidePane, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        title: this.context.t('Advanced Orders'),
        customClass: baseClasses(),
        classModifiers: 'with-tabs'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          setSellOrder = _props.setSellOrder,
          setBuyOrder = _props.setBuyOrder,
          clearAdvancedOrderEntryForm = _props.clearAdvancedOrderEntryForm;


      var buyTabModifier = (form && form.values.side === __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["b" /* buyValue */] || !form) && 'buy-selected';
      var sellTabModifier = form && form.values.side === __WEBPACK_IMPORTED_MODULE_4__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */] && 'sell-selected';

      var selectBuyOrder = function selectBuyOrder() {
        clearAdvancedOrderEntryForm();
        setBuyOrder();
      };

      var selectSellOrder = function selectSellOrder() {
        clearAdvancedOrderEntryForm();
        setSellOrder();
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('tab-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: baseClasses('tab', buyTabModifier),
              onClick: selectBuyOrder },
            this.context.t('Buy')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: baseClasses('tab', sellTabModifier),
              onClick: selectSellOrder },
            this.context.t('Sell')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AdvancedOrderForm_AdvancedOrderFormContainer__["a" /* default */], null)
      );
    }
  }]);

  return AdvancedOrderSidePane;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AdvancedOrderSidePane.defaultProps = {
  onSidePaneOpen: function onSidePaneOpen() {}
};

AdvancedOrderSidePane.propTypes = {
  clearAdvancedOrderEntryForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setBuyOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSellOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

AdvancedOrderSidePane.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AdvancedOrderSidePane);

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserBalance_UserBalanceComponent__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AdvancedOrderMarketPriceComponent__ = __webpack_require__(2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__propTypes_instrumentPropTypes__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_orderHelper__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_sendOrder_pegPriceTypeConstants__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_placeOrderHelper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_decimalPlaces_decimalPlacesHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AdvancedOrderForm_css__ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AdvancedOrderForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__AdvancedOrderForm_css__);



















var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__["b" /* getBEMClasses */])('advanced-order-form');
var dividerClasses = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__["b" /* getBEMClasses */])('divider');

var AdvancedOrderForm = function AdvancedOrderForm(props, context) {
  var marketPrice = props.marketPrice,
      handleSubmit = props.handleSubmit,
      instruments = props.instruments,
      submitting = props.submitting,
      formObj = props.formObj,
      positions = props.positions,
      position1 = props.position1,
      position2 = props.position2,
      clearAdvancedOrderEntryForm = props.clearAdvancedOrderEntryForm,
      selectedInstrument = props.selectedInstrument,
      _props$selectedInstru = props.selectedInstrument,
      Product1Symbol = _props$selectedInstru.Product1Symbol,
      Product2Symbol = _props$selectedInstru.Product2Symbol,
      PriceIncrement = _props$selectedInstru.PriceIncrement,
      QuantityIncrement = _props$selectedInstru.QuantityIncrement,
      disableTrading = props.disableTrading,
      invalid = props.invalid,
      VerificationRequiredComponent = props.VerificationRequiredComponent,
      hideFees = props.hideFees,
      orderTotal = props.orderTotal,
      orderNet = props.orderNet,
      isMarginActive = props.isMarginActive,
      marginProducts = props.marginProducts;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { className: bemClasses('body'), onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('main-section') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses(null, ['with-padding']) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APSelect__["b" /* default */], {
            name: 'instrument',
            label: context.t('Instrument') + ':',
            customClass: bemClasses(),
            options: instruments.map(function (instrument) {
              var InstrumentId = instrument.InstrumentId;

              return { value: InstrumentId, label: instrument.Symbol };
            }),
            showTriangles: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APSelect__["b" /* default */], {
            name: 'orderType',
            label: context.t('Order Type') + ':',
            customClass: bemClasses(),
            onChange: clearAdvancedOrderEntryForm,
            options: Object.keys(__WEBPACK_IMPORTED_MODULE_12__constants_sendOrder_orderEntryFormConstants__["a" /* advancedOrderFormTypes */]).map(function (key) {
              var displayName = __WEBPACK_IMPORTED_MODULE_12__constants_sendOrder_orderEntryFormConstants__["a" /* advancedOrderFormTypes */][key].displayName;

              return { value: displayName, label: displayName };
            }),
            showTriangles: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('main-section-limit-price') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AdvancedOrderMarketPriceComponent__["a" /* default */], {
          baseClass: bemClasses(),
          symbol1: Product1Symbol || '',
          symbol2: Product2Symbol || '',
          value: '' + marketPrice,
          formSide: formObj.values.side
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: dividerClasses(null, ['dark', 'advanced-order-side-pane-size'])
    }),
    renderQuantityField(props, context),
    Object(__WEBPACK_IMPORTED_MODULE_14__helpers_placeOrderHelper__["g" /* isLimitPriceFieldInForm */])(formObj.values.orderType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, ['with-padding']) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
        name: 'limitPrice',
        placeholder: '0',
        decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_16__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement),
        label: context.t('Limit Price') + ':',
        customClass: bemClasses(),
        labelInInput: Product2Symbol,
        validate: [__WEBPACK_IMPORTED_MODULE_15__helpers_formValidations__["c" /* biggerThanZero */]]
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_14__helpers_placeOrderHelper__["i" /* isStopPriceFieldInForm */])(formObj.values.orderType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, ['with-padding']) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
        name: 'stopPrice',
        placeholder: '0',
        decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_16__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement),
        label: context.t('Stop Price') + ':',
        customClass: bemClasses(),
        labelInInput: Product2Symbol,
        validate: [__WEBPACK_IMPORTED_MODULE_15__helpers_formValidations__["c" /* biggerThanZero */]]
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_14__helpers_placeOrderHelper__["k" /* isTrailingAmountFieldInForm */])(formObj.values.orderType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, ['with-padding']) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
        name: 'trailingAmount',
        placeholder: '0',
        decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_16__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement),
        label: context.t('Trailing Amount') + ':',
        customClass: bemClasses(),
        labelInInput: Product2Symbol,
        validate: [__WEBPACK_IMPORTED_MODULE_15__helpers_formValidations__["c" /* biggerThanZero */]]
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_14__helpers_placeOrderHelper__["f" /* isLimitOffsetFieldInForm */])(formObj.values.orderType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, ['with-padding']) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
        name: 'limitOffset',
        placeholder: '0',
        decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_16__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(PriceIncrement),
        label: context.t('Limit Offset') + ':',
        customClass: bemClasses(),
        labelInInput: Product2Symbol,
        validate: [__WEBPACK_IMPORTED_MODULE_15__helpers_formValidations__["c" /* biggerThanZero */]]
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_14__helpers_placeOrderHelper__["h" /* isPegPriceFieldInForm */])(formObj.values.orderType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('row') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APSelect__["b" /* default */], {
        name: 'pegPriceType',
        label: context.t('Peg Price') + ':',
        customClass: bemClasses(),
        classModifiers: 'short',
        options: Object.keys(__WEBPACK_IMPORTED_MODULE_13__constants_sendOrder_pegPriceTypeConstants__["b" /* pegPriceTypesNames */]).map(function (key) {
          return {
            value: key,
            label: __WEBPACK_IMPORTED_MODULE_13__constants_sendOrder_pegPriceTypeConstants__["b" /* pegPriceTypesNames */][key]
          };
        })
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_14__helpers_placeOrderHelper__["e" /* isDisplayQuantityFieldInForm */])(formObj.values.orderType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, ['with-padding']) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
        name: 'displayQuantity',
        placeholder: '0',
        decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_16__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(QuantityIncrement),
        label: context.t('Display Quantity') + ':',
        customClass: bemClasses(),
        labelInInput: Product1Symbol,
        validate: [__WEBPACK_IMPORTED_MODULE_15__helpers_formValidations__["q" /* requiredNumeric */], __WEBPACK_IMPORTED_MODULE_15__helpers_formValidations__["b" /* biggerThanOrEqualToZero */]]
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_14__helpers_placeOrderHelper__["j" /* isTimeInForceFieldInForm */])(formObj.values.orderType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses(null, ['with-padding']) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APSelect__["b" /* default */], {
        name: 'timeInForce',
        label: context.t('Time in Force') + ':',
        customClass: bemClasses(),
        options: [{ value: 1, label: context.t('Good Til Canceled') }, { value: 3, label: context.t('Immediate or Cancel') }, { value: 4, label: context.t('Fill or Kill') }]
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: dividerClasses(null, ['dark', 'advanced-order-side-pane-size-small'])
    }),
    isMarginActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
        name: 'borrowingPower',
        label: context.t('Borrowing Power'),
        text: (formObj.values.side === __WEBPACK_IMPORTED_MODULE_12__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */] ? Product1Symbol : Product2Symbol) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_10__helpers_orderHelper__["b" /* getOrderBorrowingPower */])(formObj, selectedInstrument, marginProducts),
        customClass: bemClasses()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
        name: 'leverage',
        label: context.t('Leverage'),
        text: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_orderHelper__["d" /* getOrderLeverage */])(formObj),
        customClass: bemClasses()
      })
    ),
    !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
      label: context.t('Fees') + ':',
      text: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_orderHelper__["c" /* getOrderFee */])(formObj, positions),
      customClass: bemClasses()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
      label: context.t('Order Total') + ':',
      text: orderTotal,
      customClass: bemClasses()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APLabelWithText__["a" /* default */], {
      label: context.t('Received') + ':',
      text: orderNet,
      customClass: bemClasses()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('user-balance-container') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UserBalance_UserBalanceComponent__["a" /* default */], { position1: position1, position2: position2 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: dividerClasses(null, ['dark', 'advanced-order-side-pane-size-small'])
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
      {
        type: 'submit',
        disabled: submitting || disableTrading || invalid,
        customClass: bemClasses(),
        styleName: formObj.values.side === __WEBPACK_IMPORTED_MODULE_12__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */] ? __WEBPACK_IMPORTED_MODULE_11__propTypes_commonComponent__["b" /* styleNames */].subtractive : __WEBPACK_IMPORTED_MODULE_11__propTypes_commonComponent__["b" /* styleNames */].additive },
      submitting ? context.t('Processing...') : context.t(Object(__WEBPACK_IMPORTED_MODULE_10__helpers_orderHelper__["k" /* getSubmitButtonText */])(formObj))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('verification-required') },
      VerificationRequiredComponent
    )
  );
};

var renderQuantityField = function renderQuantityField(props, context) {
  var _props$selectedInstru2 = props.selectedInstrument,
      Product1Symbol = _props$selectedInstru2.Product1Symbol,
      QuantityIncrement = _props$selectedInstru2.QuantityIncrement;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses(null, ['with-padding']) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APNumberInput__["a" /* default */], {
      name: 'quantity',
      placeholder: '0',
      label: context.t('Order Size:'),
      decimalPlaces: Object(__WEBPACK_IMPORTED_MODULE_16__helpers_decimalPlaces_decimalPlacesHelper__["a" /* convertIncrementToIntDecimalPlaces */])(QuantityIncrement),
      customClass: bemClasses(),
      labelInInput: Product1Symbol,
      validate: [__WEBPACK_IMPORTED_MODULE_15__helpers_formValidations__["c" /* biggerThanZero */]]
    })
  );
};

AdvancedOrderForm.propTypes = {
  positions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  position1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  position2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  decimalPlaces: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  selectedInstrument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  marketPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8__propTypes_instrumentPropTypes__["a" /* instrumentPropType */]).isRequired,
  formObj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  clearAdvancedOrderEntryForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  synchronizeQuantityWithPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  synchronizePriceWithQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disableTrading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

AdvancedOrderForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AdvancedOrderForm);

/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__ = __webpack_require__(28);





var AdvancedOrderLimitPrice = function AdvancedOrderLimitPrice(props, context) {
  var baseClass = props.baseClass,
      symbol1 = props.symbol1,
      symbol2 = props.symbol2,
      value = props.value,
      formSide = props.formSide;


  var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])([baseClass]);
  var priceTitle = formSide === __WEBPACK_IMPORTED_MODULE_3__constants_sendOrder_orderEntryFormConstants__["d" /* sellValue */] ? context.t('Bid Price') : context.t('Ask Price ');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: bemClasses('limit-price-block') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('limit-price-block-label') },
      priceTitle + ' ' + symbol1 + ' (' + symbol2 + ')'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: bemClasses('limit-price-block-value') },
      value
    )
  );
};

AdvancedOrderLimitPrice.propTypes = {
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  symbol1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  symbol2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
  formSide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

AdvancedOrderLimitPrice.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AdvancedOrderLimitPrice);

/***/ }),
/* 2349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_withdrawHelper__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propTypes_sendReceiveComponent__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendReceiveHeader_SendReceiveHeaderComponent__ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SendReceiveFormTabs_SendReceiveFormTabsComponent__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SendForm_SendFormContainer__ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Receive_ReceiveContainer__ = __webpack_require__(2362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SendReceiveDetails_SendReceiveDetailsComponent__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SendReceiveConfirmModal_SendReceiveConfirmModalComponent__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SendReceiveSidePane_css__ = __webpack_require__(2376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SendReceiveSidePane_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SendReceiveSidePane_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var sendReceiveClasses = Object(__WEBPACK_IMPORTED_MODULE_10__helpers_cssClassesHelper__["b" /* getBEMClasses */])('send-receive');

var SendReceiveSidePane = function (_React$Component) {
  _inherits(SendReceiveSidePane, _React$Component);

  function SendReceiveSidePane(props) {
    _classCallCheck(this, SendReceiveSidePane);

    var _this = _possibleConstructorReturn(this, (SendReceiveSidePane.__proto__ || Object.getPrototypeOf(SendReceiveSidePane)).call(this, props));

    _this.toggleUseExternalAddress = function () {
      _this.setState({ useExternalAddress: !_this.state.useExternalAddress });
    };

    _this.onUpdate = function () {
      _this.getWithdrawFee();
      _this.setTotal();
    };

    _this.setTotal = function () {
      var position = _this.props.position;
      var _this$state = _this.state,
          Amount = _this$state.data.Amount,
          fee = _this$state.fee;

      var balance = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_withdrawHelper__["a" /* getAvailableBalance */])(position.Amount, position.Hold);
      var amount = parseFloat(Amount);
      var total = 0;

      if (amount) {
        total = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_withdrawHelper__["c" /* getTotalRender */])(balance, amount, fee);
      }

      _this.setState({ total: total });
    };

    _this.getWithdrawFee = function () {
      var _this$props = _this.props,
          ProductId = _this$props.product.ProductId,
          getWithdrawFee = _this$props.getWithdrawFee;
      var Amount = _this.state.data.Amount;


      if (!isNaN(Amount)) {
        getWithdrawFee(ProductId, Amount);
      }
    };

    _this.onDataUpdate = function (data) {
      var _this$state2 = _this.state,
          Amount = _this$state2.data.Amount,
          isSend = _this$state2.isSend;

      _this.setState({ data: data }, function () {
        if (isSend && data.Amount !== Amount) {
          _this.onUpdate();
        }
      });
    };

    _this.openConfirmModal = function (data) {
      return _this.setState({ openConfirmModal: true, data: data });
    };

    _this.closeConfirmModal = function () {
      return _this.setState({ openConfirmModal: false });
    };

    _this.onTabChange = function () {
      _this.setState({
        isSend: !_this.state.isSend,
        data: {},
        useExternalAddress: true
      });
    };

    _this.submitData = function () {
      var _this$props2 = _this.props,
          receiveFunds = _this$props2.receiveFunds,
          sendFunds = _this$props2.sendFunds,
          sendToAddress = _this$props2.sendToAddress,
          ProductId = _this$props2.product.ProductId,
          template = _this$props2.template,
          TemplateType = _this$props2.template.TemplateType,
          selectedAccountId = _this$props2.selectedAccountId;
      var _this$state3 = _this.state,
          isSend = _this$state3.isSend,
          useExternalAddress = _this$state3.useExternalAddress,
          data = _this$state3.data,
          _this$state3$data = _this$state3.data,
          Notes = _this$state3$data.Notes,
          ReceiverUsername = _this$state3$data.ReceiverUsername,
          Amount = _this$state3$data.Amount;


      var payload = {
        Notes: Notes || '',
        ReceiverUsername: ReceiverUsername,
        Amount: Amount,
        ProductId: ProductId,
        selectedAccountId: selectedAccountId
      };

      var addressPayload = {
        ProductId: ProductId,
        Amount: Amount,
        TemplateType: TemplateType,
        TemplateForm: Object.assign({}, template, data)
      };

      if (isSend) {
        if (useExternalAddress) {
          sendToAddress(addressPayload);
        } else {
          sendFunds(payload);
        }
      } else {
        receiveFunds(payload);
      }
      _this.closeConfirmModal();
    };

    _this.state = {
      isSend: props.isSend,
      useExternalAddress: true,
      data: {},
      openConfirmModal: false,
      fee: null
    };
    return _this;
  }

  _createClass(SendReceiveSidePane, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        customClass: this.props.showDetails ? 'retail-sidepane-with-details' : 'retail-sidepane',
        hideHeader: true
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.fee !== this.state.fee) {
        this.setTotal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          product = _props.product,
          _props$position = _props.position,
          Amount = _props$position.Amount,
          Hold = _props$position.Hold,
          fee = _props.fee,
          showDetails = _props.showDetails,
          allowTransfer = _props.allowTransfer,
          hideFees = _props.hideFees,
          TicketAmount = _props.TicketAmount;
      var _state = this.state,
          isSend = _state.isSend,
          useExternalAddress = _state.useExternalAddress,
          data = _state.data,
          openConfirmModal = _state.openConfirmModal,
          total = _state.total;

      var balance = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_withdrawHelper__["a" /* getAvailableBalance */])(Amount, Hold);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: sendReceiveClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: sendReceiveClasses('main') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SendReceiveHeader_SendReceiveHeaderComponent__["a" /* default */], { product: product }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            { className: sendReceiveClasses('main-form') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SendReceiveFormTabs_SendReceiveFormTabsComponent__["a" /* default */], {
              isSend: isSend,
              toggleTab: this.onTabChange
            }),
            isSend ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SendForm_SendFormContainer__["a" /* default */], {
              product: product,
              useExternalAddress: useExternalAddress,
              balance: balance,
              fee: fee,
              total: total,
              showDetails: showDetails,
              toggleUseExternalAddress: this.toggleUseExternalAddress,
              onChange: this.onDataUpdate,
              onSubmit: this.openConfirmModal,
              allowTransfer: allowTransfer
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Receive_ReceiveContainer__["a" /* default */], {
              product: product,
              useExternalAddress: useExternalAddress,
              toggleUseExternalAddress: this.toggleUseExternalAddress,
              onChange: this.onDataUpdate,
              onSubmit: this.openConfirmModal,
              allowTransfer: allowTransfer
            })
          )
        ),
        showDetails && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: sendReceiveClasses('side') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            {
              className: sendReceiveClasses(isSend ? 'send-side-details' : 'side-details') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SendReceiveDetails_SendReceiveDetailsComponent__["a" /* default */], {
              isSend: isSend,
              useExternalAddress: useExternalAddress,
              details: data,
              balance: balance,
              total: total,
              product: product,
              TicketAmount: TicketAmount,
              fee: fee
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SendReceiveConfirmModal_SendReceiveConfirmModalComponent__["a" /* default */], {
          isOpen: openConfirmModal,
          useExternalAddress: useExternalAddress,
          close: this.closeConfirmModal,
          product: product,
          isSend: isSend,
          values: data,
          total: total,
          fee: fee,
          onConfirm: this.submitData,
          hideFees: hideFees
        })
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.fee !== prevState.fee) {
        return { fee: nextProps.fee };
      }
      return null;
    }
  }]);

  return SendReceiveSidePane;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SendReceiveSidePane.defaultProps = {
  showDetails: true,
  onSidePaneOpen: function onSidePaneOpen() {},
  isSend: true
};

SendReceiveSidePane.propTypes = {
  allowTransfer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  openRetailSendSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  openRetailReceiveSidePane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  product: __WEBPACK_IMPORTED_MODULE_3__propTypes_sendReceiveComponent__["a" /* product */],
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    AccountId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    Amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    Hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    OMSId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    PendingDeposits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    PendingWithdraws: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    ProductId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    ProductSymbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    TotalDayDeposits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    TotalDayWithdraws: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    TotalMonthWithdraws: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    TotalYearWithdraws: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  })
};

SendReceiveSidePane.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SendReceiveSidePane);

/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendReceiveHeader_css__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendReceiveHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SendReceiveHeader_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('send-receive-header');

var SendReceiveHeader = function (_React$Component) {
  _inherits(SendReceiveHeader, _React$Component);

  function SendReceiveHeader() {
    _classCallCheck(this, SendReceiveHeader);

    return _possibleConstructorReturn(this, (SendReceiveHeader.__proto__ || Object.getPrototypeOf(SendReceiveHeader)).apply(this, arguments));
  }

  _createClass(SendReceiveHeader, [{
    key: 'render',
    value: function render() {
      var _props$product = this.props.product,
          iconFileName = _props$product.iconFileName,
          ProductFullName = _props$product.ProductFullName,
          ProductSymbol = _props$product.ProductSymbol;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__["a" /* default */], {
          iconFileName: iconFileName,
          customClass: bemClasses('logo')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('title') },
          ProductSymbol,
          ' ',
          ProductFullName
        )
      );
    }
  }]);

  return SendReceiveHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SendReceiveHeader.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (SendReceiveHeader);

/***/ }),
/* 2353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendReceiveFormTabs_css__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendReceiveFormTabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SendReceiveFormTabs_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('send-receive-tabs');

var SendReceiveTabs = function (_React$Component) {
  _inherits(SendReceiveTabs, _React$Component);

  function SendReceiveTabs() {
    _classCallCheck(this, SendReceiveTabs);

    return _possibleConstructorReturn(this, (SendReceiveTabs.__proto__ || Object.getPrototypeOf(SendReceiveTabs)).apply(this, arguments));
  }

  _createClass(SendReceiveTabs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isSend = _props.isSend,
          toggleTab = _props.toggleTab;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: bemClasses('tab', { selected: isSend }),
            onClick: function onClick() {
              return !isSend && toggleTab();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'buy', customClass: bemClasses('tab-icon') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: bemClasses('tab-text') },
            this.context.t('Send')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: bemClasses('tab', { selected: !isSend }),
            onClick: function onClick() {
              return isSend && toggleTab();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'sell', customClass: bemClasses('tab-icon') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: bemClasses('tab-text') },
            this.context.t('Receive')
          )
        )
      );
    }
  }]);

  return SendReceiveTabs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SendReceiveTabs.propTypes = {
  isSend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggleTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

SendReceiveTabs.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SendReceiveTabs);

/***/ }),
/* 2355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SendFormComponent__ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_sidePaneActions__ = __webpack_require__(23);






var mapStateToProps = function mapStateToProps(state) {
  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableWithdraw = _kycVerificationLevel.disableWithdraw;

  var userEmail = state.user.userInfo.Email;
  var withdrawError = !!state.withdraw.error;
  return { disableWithdraw: disableWithdraw, userEmail: userEmail, withdrawError: withdrawError };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    verificationOnClick: function verificationOnClick() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_sidePaneActions__["j" /* closeSidePane */])());
    }
  };
};

var SendForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'SendForm',
  onSubmit: function onSubmit() {}
})(__WEBPACK_IMPORTED_MODULE_2__SendFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(SendForm));

/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendAddress_SendAddressContainer__ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes_sendReceiveComponent__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SendForm_css__ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SendForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SendForm_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('send-form');

var SendForm = function (_React$Component) {
  _inherits(SendForm, _React$Component);

  function SendForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SendForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SendForm.__proto__ || Object.getPrototypeOf(SendForm)).call.apply(_ref, [this].concat(args))), _this), _this.lessThanBalance = function (value) {
      var balance = _this.props.balance;

      if (balance === 0) return _this.context.t('0 balance available');
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["g" /* lessThanValue */])(balance, value);
    }, _this.checkUserEmail = function (value) {
      var userEmail = _this.props.userEmail;

      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["s" /* validateReceiverEmail */])(value, userEmail);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SendForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$product = _props.product,
          name = _props$product.ProductFullName,
          symbol = _props$product.ProductSymbol,
          decimalPlaces = _props$product.decimalPlaces,
          handleSubmit = _props.handleSubmit,
          invalid = _props.invalid,
          submitting = _props.submitting,
          onSubmit = _props.onSubmit,
          useExternalAddress = _props.useExternalAddress,
          toggleUseExternalAddress = _props.toggleUseExternalAddress,
          balance = _props.balance,
          product = _props.product,
          fee = _props.fee,
          total = _props.total,
          showDetails = _props.showDetails,
          disableWithdraw = _props.disableWithdraw,
          verificationOnClick = _props.verificationOnClick,
          allowTransfer = _props.allowTransfer,
          withdrawError = _props.withdrawError;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { onSubmit: handleSubmit(onSubmit), className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: bemClasses('send-to') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'header',
            { className: bemClasses('source') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: bemClasses('source-item-with-border') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: bemClasses('source-item', {
                    selected: useExternalAddress
                  }),
                  onClick: function onClick() {
                    !useExternalAddress && toggleUseExternalAddress();
                  } },
                this.context.t('External Wallet')
              )
            ),
            allowTransfer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: bemClasses('source-item', {
                  selected: !useExternalAddress
                }),
                onClick: function onClick() {
                  useExternalAddress && toggleUseExternalAddress();
                } },
              this.context.t('To Email Address')
            )
          )
        ),
        disableWithdraw ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__VerificationRequired_VerificationRequiredContainer__["a" /* default */], {
          disabled: disableWithdraw,
          onClick: verificationOnClick
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          useExternalAddress ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SendAddress_SendAddressContainer__["a" /* default */], { product: product, balance: balance }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: bemClasses('label-text') },
              this.context.t('Recipient’s Email Address')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APInput__["b" /* default */], {
              name: 'ReceiverUsername',
              customClass: bemClasses(),
              validate: [__WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["p" /* required */], __WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["d" /* email */], this.checkUserEmail]
            })
          ),
          (!withdrawError || !useExternalAddress) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: bemClasses('label-text') },
              this.context.t('Amount of {name} to Send', { name: name })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'section',
              { className: bemClasses('amounts') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APNumberInput__["a" /* default */], {
                name: 'Amount',
                customClass: bemClasses(),
                labelInInput: symbol,
                decimalPlaces: decimalPlaces,
                validate: [__WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["p" /* required */], this.lessThanBalance]
              })
            )
          ),
          !showDetails && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            { className: bemClasses('info-items') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_APLabelWithText__["a" /* default */], {
              label: this.context.t('Current Balance:'),
              text: balance,
              customClass: bemClasses()
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_APLabelWithText__["a" /* default */], {
              label: this.context.t('Transaction Fee:'),
              text: fee !== undefined ? fee : '-',
              customClass: bemClasses()
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_APLabelWithText__["a" /* default */], {
              label: this.context.t('Total Amount:'),
              text: total !== undefined ? total + ' ' + symbol : '-',
              customClass: bemClasses()
            })
          ),
          !useExternalAddress && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            { className: bemClasses('note') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: bemClasses('label-text') },
              this.context.t('Add a Note '),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'em',
                null,
                this.context.t('(Optional)')
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APInput__["b" /* default */], { name: 'Notes', rows: 3, customClass: bemClasses() })
          ),
          (!withdrawError || !useExternalAddress) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__common_APButton__["a" /* default */],
            {
              type: 'submit',
              customClass: bemClasses(),
              styleName: 'additive',
              disabled: invalid || submitting },
            this.context.t('Send'),
            ' ',
            name
          )
        )
      );
    }
  }]);

  return SendForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SendForm.propTypes = {
  product: __WEBPACK_IMPORTED_MODULE_10__propTypes_sendReceiveComponent__["a" /* product */].isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  useExternalAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  balance: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  toggleUseExternalAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  allowTransfer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  disableWithdraw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  verificationOnClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

SendForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SendForm);

/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SendAddressComponent__ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_withdrawActions__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





var mapStateToProps = function mapStateToProps(state) {
  return {
    withdrawInfo: state.withdraw,
    WalletsDisabledMessage: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].global.WalletsDisabledMessage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectWithdrawProduct: function selectWithdrawProduct(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_withdrawActions__["o" /* fetchProductWithdrawTemplates */])(productId));
    },
    selectWithdrawTemplate: function selectWithdrawTemplate(productId, templateType) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_withdrawActions__["n" /* fetchProductWithdrawTemplate */])(productId, templateType));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__SendAddressComponent__["a" /* default */]));

/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_formTemplateHelper__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SendAddress_css__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SendAddress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SendAddress_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('send-address');

var SendAddressComponent = function (_React$Component) {
  _inherits(SendAddressComponent, _React$Component);

  function SendAddressComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SendAddressComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SendAddressComponent.__proto__ || Object.getPrototypeOf(SendAddressComponent)).call.apply(_ref, [this].concat(args))), _this), _this.getProductData = function () {
      var _this$props = _this.props,
          selectWithdrawProduct = _this$props.selectWithdrawProduct,
          ProductId = _this$props.product.ProductId;

      selectWithdrawProduct(ProductId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SendAddressComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getProductData();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          withdrawInfo = _props.withdrawInfo,
          template = _props.withdrawInfo.template,
          product = _props.product,
          ProductId = _props.product.ProductId,
          selectWithdrawTemplate = _props.selectWithdrawTemplate,
          WalletsDisabledMessage = _props.WalletsDisabledMessage;

      var showTemplateFields = Object.keys(template || {}).length;
      var showTemplateTypeSelect = withdrawInfo.templateTypes.length > 1 && !Object.keys(withdrawInfo.templateInfo).length && !withdrawInfo.isLoading;
      var templateTypes = [{ value: '', label: 'Select an option' }].concat(_toConsumableArray(withdrawInfo.templateTypes.map(function (template) {
        return {
          value: template.TemplateName,
          label: template.TemplateName
        };
      })));

      var hasError = withdrawInfo.error || WalletsDisabledMessage;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        withdrawInfo.withdrawStatus.success ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('success') },
          this.context.t('Your withdraw ticket was created successfully.')
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('form-body') },
          hasError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('error') },
            hasError
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            withdrawInfo.isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__["a" /* default */], null),
            showTemplateTypeSelect && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.context.t('Select an option to continue the withdraw process')
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["b" /* default */], {
                name: 'TemplateType',
                customClass: baseClasses(),
                label: this.context.t('Options for withdraw'),
                onSelect: function onSelect(value) {
                  return selectWithdrawTemplate(ProductId, value);
                },
                options: templateTypes
              })
            ),
            showTemplateFields > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('section') },
              Object(__WEBPACK_IMPORTED_MODULE_4__helpers_formTemplateHelper__["b" /* templateFormRenderer */])(template, baseClasses(), this.context, product)
            )
          )
        )
      );
    }
  }]);

  return SendAddressComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SendAddressComponent.defaultProps = {
  withdrawInfo: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    TemplateForm: {},
    withdrawStatus: {},
    getWithdrawFee: function getWithdrawFee() {}
  }
};

SendAddressComponent.propTypes = {
  getWithdrawFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  selectWithdrawProduct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    ProductSymbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ProductId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }).isRequired,
  withdrawInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    templateInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    TemplateForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
    withdrawStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      success: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      RequestCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }).isRequired
  })
};

SendAddressComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SendAddressComponent);

/***/ }),
/* 2360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReceiveComponent__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_sidePaneActions__ = __webpack_require__(23);





var mapStateToProps = function mapStateToProps(state) {
  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_2__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableDeposit = _kycVerificationLevel.disableDeposit;

  return { disableDeposit: disableDeposit };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    verificationOnClick: function verificationOnClick() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_sidePaneActions__["j" /* closeSidePane */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ReceiveComponent__["a" /* default */]));

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propTypes_sendReceiveComponent__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReceiveForm_ReceiveFormContainer__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReceiveAddress_ReceiveAddressContainer__ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Receive_css__ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Receive_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Receive_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('receive');

var ReceiveComponent = function (_React$Component) {
  _inherits(ReceiveComponent, _React$Component);

  function ReceiveComponent() {
    _classCallCheck(this, ReceiveComponent);

    return _possibleConstructorReturn(this, (ReceiveComponent.__proto__ || Object.getPrototypeOf(ReceiveComponent)).apply(this, arguments));
  }

  _createClass(ReceiveComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          product = _props.product,
          useExternalAddress = _props.useExternalAddress,
          toggleUseExternalAddress = _props.toggleUseExternalAddress,
          onChange = _props.onChange,
          onSubmit = _props.onSubmit,
          disableDeposit = _props.disableDeposit,
          verificationOnClick = _props.verificationOnClick,
          allowTransfer = _props.allowTransfer;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          { className: bemClasses('source') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('source-item-with-border') },
            allowTransfer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: bemClasses('source-item', {
                  active: !useExternalAddress
                }),
                onClick: function onClick() {
                  useExternalAddress && toggleUseExternalAddress();
                } },
              this.context.t('Friend')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: bemClasses('source-item', {
                active: useExternalAddress
              }),
              onClick: function onClick() {
                !useExternalAddress && toggleUseExternalAddress();
              } },
            this.context.t('External Wallet')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: bemClasses('body') },
          disableDeposit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__VerificationRequired_VerificationRequiredContainer__["a" /* default */], {
            disabled: disableDeposit,
            onClick: verificationOnClick
          }) : useExternalAddress ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ReceiveAddress_ReceiveAddressContainer__["a" /* default */], { product: product }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReceiveForm_ReceiveFormContainer__["a" /* default */], {
            product: product,
            onChange: onChange,
            onSubmit: onSubmit
          })
        )
      );
    }
  }]);

  return ReceiveComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ReceiveComponent.propTypes = {
  product: __WEBPACK_IMPORTED_MODULE_4__propTypes_sendReceiveComponent__["a" /* product */],
  useExternalAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggleUseExternalAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  allowTransfer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  disableDeposit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  verificationOnClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

ReceiveComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ReceiveComponent);

/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReceiveFormComponent__ = __webpack_require__(2365);




var mapStateToProps = function mapStateToProps(state) {
  var userEmail = state.user.userInfo.Email;
  return {
    userEmail: userEmail
  };
};

var ReceiveForm = Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["j" /* reduxForm */])({
  form: 'ReceiveForm',
  onSubmit: function onSubmit() {}
})(__WEBPACK_IMPORTED_MODULE_2__ReceiveFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, null)(ReceiveForm));

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__propTypes_sendReceiveComponent__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReceiveForm_css__ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReceiveForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ReceiveForm_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('receive-form');

var ReceiveForm = function (_React$Component) {
  _inherits(ReceiveForm, _React$Component);

  function ReceiveForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReceiveForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReceiveForm.__proto__ || Object.getPrototypeOf(ReceiveForm)).call.apply(_ref, [this].concat(args))), _this), _this.checkUserEmail = function (value) {
      var userEmail = _this.props.userEmail;

      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["s" /* validateReceiverEmail */])(value, userEmail);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReceiveForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$product = _props.product,
          name = _props$product.ProductFullName,
          symbol = _props$product.ProductSymbol,
          decimalPlaces = _props$product.decimalPlaces,
          handleSubmit = _props.handleSubmit,
          invalid = _props.invalid,
          submitting = _props.submitting,
          onChange = _props.onChange,
          onSubmit = _props.onSubmit;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { onSubmit: handleSubmit(onSubmit), className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: bemClasses('receive-from') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: bemClasses('label-text') },
            this.context.t('Email Address to Request From')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APInput__["b" /* default */], {
            name: 'ReceiverUsername',
            customClass: bemClasses(),
            onChange: handleSubmit(onChange),
            validate: [__WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["p" /* required */], __WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["d" /* email */], this.checkUserEmail]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: bemClasses('label-text') },
          this.context.t('Amount of {name} to Request', { name: name })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: bemClasses('amounts') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APNumberInput__["a" /* default */], {
            name: 'Amount',
            customClass: bemClasses(),
            labelInInput: symbol,
            decimalPlaces: decimalPlaces,
            onChange: handleSubmit(onChange),
            validate: [__WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["p" /* required */]]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: bemClasses('note') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: bemClasses('label-text') },
            this.context.t('Add a Note '),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.context.t('(Optional)')
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APInput__["b" /* default */], { name: 'Notes', rows: 3, customClass: bemClasses() })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__common_APButton__["a" /* default */],
          {
            type: 'submit',
            customClass: bemClasses(),
            styleName: 'additive',
            disabled: invalid || submitting },
          this.context.t('Request'),
          ' ',
          name
        )
      );
    }
  }]);

  return ReceiveForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ReceiveForm.propTypes = {
  product: __WEBPACK_IMPORTED_MODULE_7__propTypes_sendReceiveComponent__["a" /* product */].isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ReceiveForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ReceiveForm);

/***/ }),
/* 2366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReceiveAddressComponent__ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_depositActions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);






var mapStateToProps = function mapStateToProps(state) {
  return {
    deposit: state.deposit,
    WalletsDisabledMessage: __WEBPACK_IMPORTED_MODULE_4__config__["b" /* default */].global.WalletsDisabledMessage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectDepositProduct: function selectDepositProduct(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_depositActions__["p" /* fetchProductDepositTemplate */])(productId));
    },
    showSnack: function showSnack(text) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_snackbarActions__["e" /* showSnack */])(text));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ReceiveAddressComponent__["a" /* default */]));

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APQRCode_APQRCode__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_clipboardHelper__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_destinationTagHelper__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReceiveAddress_css__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReceiveAddress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ReceiveAddress_css__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('receive-address');

var ReceiveAddressComponent = function (_React$Component) {
  _inherits(ReceiveAddressComponent, _React$Component);

  function ReceiveAddressComponent() {
    _classCallCheck(this, ReceiveAddressComponent);

    return _possibleConstructorReturn(this, (ReceiveAddressComponent.__proto__ || Object.getPrototypeOf(ReceiveAddressComponent)).apply(this, arguments));
  }

  _createClass(ReceiveAddressComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          selectDepositProduct = _props.selectDepositProduct,
          product = _props.product;

      selectDepositProduct(product.ProductId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          addressList = _props2.deposit.depositInfo,
          _props2$deposit = _props2.deposit,
          isLoading = _props2$deposit.isLoading,
          error = _props2$deposit.error,
          product = _props2.product,
          showSnack = _props2.showSnack,
          WalletsDisabledMessage = _props2.WalletsDisabledMessage;

      // Protocol prefix for the QR Code, lowercase name with no spaces.

      var depositType = product.ProductFullName.toLowerCase().replace(/\W/g, '');
      var selectedAddress = void 0;

      if (!isLoading && addressList.length) {
        selectedAddress = addressList[addressList.length - 1];
      }

      var _destinationTagHelper = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_destinationTagHelper__["a" /* default */])(selectedAddress),
          _destinationTagHelper2 = _slicedToArray(_destinationTagHelper, 2),
          address = _destinationTagHelper2[0],
          destinationTag = _destinationTagHelper2[1];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: bemClasses() },
        selectedAddress && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: bemClasses('description') },
            this.context.t('Scan this QR code to receive funds:')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: bemClasses('qr-code') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APQRCode_APQRCode__["a" /* default */], { value: depositType + ':' + selectedAddress })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: bemClasses('copy-address-text') },
            this.context.t('Or copy this address:')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: bemClasses('copy-address-payload'),
              onClick: function onClick() {
                showSnack({
                  id: 'RECEIVE_ADDRESS_COPY',
                  text: _this2.context.t('The address has been copied to the clipboard.')
                });
                Object(__WEBPACK_IMPORTED_MODULE_6__helpers_clipboardHelper__["a" /* default */])(address);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: bemClasses('address') },
              address
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'copy', customClass: bemClasses('copy-icon') })
          ),
          destinationTag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              onClick: function onClick() {
                showSnack({
                  id: 'RECEIVE_ADDRESS_COPY',
                  text: _this2.context.t('The destination tag has been copied to the clipboard.')
                });
                Object(__WEBPACK_IMPORTED_MODULE_6__helpers_clipboardHelper__["a" /* default */])(destinationTag);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: bemClasses('destination-tag-text') },
              this.context.t('Be sure to include this destination tag:')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: bemClasses('address') },
              destinationTag
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'copy', customClass: bemClasses('copy-icon') })
          )
        ),
        isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], {
          text: this.context.t('Loading url...'),
          customClass: bemClasses
        }),
        WalletsDisabledMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: bemClasses('error') },
          this.context.t(WalletsDisabledMessage)
        ) : error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: bemClasses('error') },
          this.context.t(error)
        )
      );
    }
  }]);

  return ReceiveAddressComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ReceiveAddressComponent.defaultProps = {
  deposit: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    depositInfo: {},
    depositStatus: {}
  },
  product: {}
};

ReceiveAddressComponent.propTypes = {
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  deposit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    templateInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    depositInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    depositStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      success: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      RequestCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }).isRequired
  })
};

ReceiveAddressComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ReceiveAddressComponent);

/***/ }),
/* 2369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_SidePaneDetailsComponent_SidePaneDetailsComponent__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SendReceiveDetailsComponent = function (_React$Component) {
  _inherits(SendReceiveDetailsComponent, _React$Component);

  function SendReceiveDetailsComponent() {
    _classCallCheck(this, SendReceiveDetailsComponent);

    return _possibleConstructorReturn(this, (SendReceiveDetailsComponent.__proto__ || Object.getPrototypeOf(SendReceiveDetailsComponent)).apply(this, arguments));
  }

  _createClass(SendReceiveDetailsComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isSend = _props.isSend,
          useExternalAddress = _props.useExternalAddress,
          balance = _props.balance,
          Amount = _props.details.Amount,
          ProductSymbol = _props.product.ProductSymbol,
          TicketAmount = _props.TicketAmount,
          fee = _props.fee;
      var getItem = __WEBPACK_IMPORTED_MODULE_2__common_SidePaneDetailsComponent_SidePaneDetailsComponent__["a" /* default */].getItem;

      var title = isSend ? this.context.t('Send Details') : this.context.t('Instructions');
      var amountText = this.context.t('Amount to Send');

      var remainingBalance = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(balance - (useExternalAddress ? TicketAmount + fee : Amount), ProductSymbol);
      var classModifiers = isSend ? 'top' : '';

      var items = [];
      var info = [];
      var infoHeader = '';

      if (isSend) {
        items.push(getItem(this.context.t('Your current {ProductSymbol} Balance', {
          ProductSymbol: ProductSymbol
        }), balance ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(balance, ProductSymbol) + ' ' + ProductSymbol : '-'));
        items.push(getItem(amountText, Amount ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(useExternalAddress ? TicketAmount : Amount, ProductSymbol) + ' ' + ProductSymbol : '-'));
        items.push(getItem(this.context.t('Fee'), useExternalAddress ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(fee, ProductSymbol) + ' ' + ProductSymbol : '-'));
        items.push(getItem(this.context.t('Remaining Balance'), Amount && balance ? remainingBalance + ' ' + ProductSymbol : '-'));
      }

      if (isSend && !useExternalAddress) {
        infoHeader = this.context.t('Note');
        info.push(this.context.t('If the sender is not a registered user of Retail, they will receive an email invitation to create an account and claim their funds.'));
      }

      if (!isSend && !useExternalAddress) {
        info.push(this.context.t('Use this form to request funds via email.'));
        info.push(this.context.t('Note - if the requestee is not a registered user of Retail, they will receive an email invitation to create an account.'));
      }
      if (!isSend && useExternalAddress) {
        info.push(this.context.t('Depositing cryptocurrency into your wallet is safe and easy. The address below can always be used to deposit cryptocurrency into your account.'));
        info.push(this.context.t('Your account will automatically update after the cryptocurrency network confirms your transaction. The confirmation may take up to 1 hour'));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_SidePaneDetailsComponent_SidePaneDetailsComponent__["a" /* default */], {
        title: title,
        items: items,
        info: info,
        infoHeader: infoHeader,
        classModifiers: classModifiers
      });
    }
  }]);

  return SendReceiveDetailsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SendReceiveDetailsComponent.propTypes = {
  isSend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  useExternalAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

SendReceiveDetailsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SendReceiveDetailsComponent);

/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SendReceiveConfirmHeaderComponent__ = __webpack_require__(2373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SendReceiveConfirmModal_css__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SendReceiveConfirmModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SendReceiveConfirmModal_css__);











var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('send-receive-confirm-modal');

var SendReceiveConfirmModal = function SendReceiveConfirmModal(props, context) {
  var isOpen = props.isOpen,
      close = props.close,
      product = props.product,
      isSend = props.isSend,
      values = props.values,
      onConfirm = props.onConfirm,
      useExternalAddress = props.useExternalAddress,
      fee = props.fee,
      total = props.total,
      hideFees = props.hideFees;

  var addressLabel = context.t('External Address');
  var sendLabel = context.t('Recipient’s Email');
  var receiveLabel = context.t('Requestee’s Email');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SendReceiveConfirmHeaderComponent__["a" /* default */], { isSend: isSend, product: product }),
      close: close,
      footer: {
        buttonText: context.t('Confirm'),
        buttonStyle: 'additive',
        onClick: onConfirm
      },
      customClass: bemClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: bemClasses('title') },
      context.t('Confirmation')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: bemClasses('details') },
      !useExternalAddress && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: isSend ? sendLabel : receiveLabel,
        text: values.ReceiverUsername,
        customClass: bemClasses()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: product.ProductSymbol + ' ' + context.t('Amount'),
        text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(values.Amount, product.ProductSymbol) + ' ' + product.ProductSymbol,
        customClass: bemClasses()
      }),
      useExternalAddress && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            label: context.t('Miner Fees'),
            text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(fee, product.ProductSymbol) + ' ' + product.ProductSymbol,
            customClass: bemClasses()
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
            label: product.ProductSymbol + ' ' + context.t('Total Amount'),
            text: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_numberFormatter__["b" /* formatNumberToLocale */])(total, product.ProductSymbol) + ' ' + product.ProductSymbol,
            customClass: bemClasses()
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
          label: addressLabel,
          text: values.ExternalAddress,
          customClass: bemClasses()
        })
      ),
      !useExternalAddress && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Note'),
        text: values.Notes,
        customClass: bemClasses()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Time'),
        text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["c" /* formatDateTime */])(new Date()),
        customClass: bemClasses()
      })
    )
  );
};

SendReceiveConfirmModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isSend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  useExternalAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

SendReceiveConfirmModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SendReceiveConfirmModal);

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendReceiveConfirmHeader_css__ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendReceiveConfirmHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SendReceiveConfirmHeader_css__);







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('send-receive-confirm-header');

var SendReceiveConfirmHeader = function SendReceiveConfirmHeader(props, context) {
  var isSend = props.isSend,
      _props$product = props.product,
      ProductFullName = _props$product.ProductFullName,
      ProductSymbol = _props$product.ProductSymbol;

  var headerText = isSend ? context.t('Send') + ' ' + ProductSymbol + ' ' + ProductFullName : ProductSymbol + ' ' + ProductFullName + ' ' + context.t('Request');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'header',
    { className: bemClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], {
      name: isSend ? 'sendWithBorder' : 'receiveWithBorder',
      customClass: bemClasses('icon')
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: bemClasses('title') },
      headerText
    )
  );
};

SendReceiveConfirmHeader.propTypes = {
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  isSend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

SendReceiveConfirmHeader.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SendReceiveConfirmHeader);

/***/ }),
/* 2374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_IMFormContainer__ = __webpack_require__(2378);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYC_IMFormContainer__["a" /* default */]);

/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KYC_IMFormComponent__ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_kycIdentityMindActions__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KYC_IMFormHelpers__ = __webpack_require__(2413);







var mapStateToProps = function mapStateToProps(state) {
  var _state$user = state.user,
      accountId = _state$user.selectedAccountId,
      _state$user$userInfo = _state$user.userInfo,
      UserId = _state$user$userInfo.UserId,
      email = _state$user$userInfo.Email,
      UserName = _state$user$userInfo.UserName;
  var _config$KYC = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].KYC,
      MinimumVerificationLevel = _config$KYC.MinimumVerificationLevel,
      useAccountId = _config$KYC.useAccountId,
      levels = _config$KYC.levels;

  var level = levels[0];
  var missingFields = Object(__WEBPACK_IMPORTED_MODULE_5__KYC_IMFormHelpers__["b" /* getMissingMandatoryFields */])(levels);
  var uploadFields = Object(__WEBPACK_IMPORTED_MODULE_5__KYC_IMFormHelpers__["a" /* getAdditionalValidationFields */])(level);
  Object(__WEBPACK_IMPORTED_MODULE_5__KYC_IMFormHelpers__["c" /* updateLevelFields */])(level, {
    suppressDefaultValidators: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].KYC.DisableIMRequiredFields
  });

  return {
    accountId: accountId,
    UserId: UserId,
    UserName: UserName,
    email: email,
    useAccountId: useAccountId,
    missingFields: missingFields,
    level: level,
    MinimumVerificationLevel: MinimumVerificationLevel,
    uploadFields: uploadFields,
    formValues: Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["h" /* getFormValues */])('kycIMForm')(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    validateUserRegistrationIdentityMind: function validateUserRegistrationIdentityMind(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_kycIdentityMindActions__["c" /* validateUserRegistrationIdentityMind */])(payload));
    },
    reset: function reset() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["k" /* reset */])('kycIMForm'));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__KYC_IMFormComponent__["a" /* default */]));

/***/ }),
/* 2379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_IMFormStepContainer__ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KYC_KYCConfirmLevelModal__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_omit__ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_omit__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var KYC_IMFormComponent = function (_React$Component) {
  _inherits(KYC_IMFormComponent, _React$Component);

  function KYC_IMFormComponent(props) {
    _classCallCheck(this, KYC_IMFormComponent);

    var _this = _possibleConstructorReturn(this, (KYC_IMFormComponent.__proto__ || Object.getPrototypeOf(KYC_IMFormComponent)).call(this, props));

    _this.onSubmit = function () {
      var level = _this.props.level;
      var page = _this.state.page;


      if (level.steps && level.steps[page + 1]) {
        _this.setState({ page: _this.state.page + 1 });
      } else {
        _this.openModal(true);
      }
    };

    _this.previousPage = function () {
      _this.setState({ page: _this.state.page - 1 });
    };

    _this.openModal = function (openModal) {
      return _this.setState({ openModal: openModal });
    };

    _this.getConfigPayload = function (values) {
      var _this$props = _this.props,
          UserName = _this$props.UserName,
          UserId = _this$props.UserId;

      var configPropsMap = {
        DocumentType: 'docType',
        DocumentState: 'docState',
        DocumentCountry: 'docCountry',
        phone: 'telephone',
        state: 'billingState'
      };

      var Config = Object.keys(values).map(function (prop) {
        return {
          Key: configPropsMap[prop] || prop,
          Value: values[prop]
        };
      });
      // temporarily setting levelIncreaseStatus to under review, no matter what (taken from widgets)
      Config.push({ Key: 'levelIncreaseStatus', Value: 'underReview' });

      return {
        UserName: UserName,
        UserId: UserId,
        Config: Config
      };
    };

    _this.getUserInfo = function (values) {
      var _this$props2 = _this.props,
          accountId = _this$props2.accountId,
          UserId = _this$props2.UserId,
          useAccountId = _this$props2.useAccountId,
          email = _this$props2.email;

      values = _this.condenseMemos(values);
      return Object.assign({}, values, {
        accountName: (useAccountId ? accountId : UserId).toString(),
        email: email,
        billingFlatNumber: '',
        salutation: ''
      });
    };

    _this.condenseMemos = function (values) {
      var memos = {};
      var memosAmount = 0;
      Object.keys(values).map(function (key) {
        memosAmount += key.match(/memo/) && (memos[key] = values[key], delete values[key]);
        return values;
      });
      memosAmount > 0 && (values['memo'] = memos);
      return values;
    };

    _this.getAdditionalValidation = function (imageFields) {
      return Object.keys(imageFields).filter(function (prop) {
        return imageFields[prop];
      }).map(function (ImageName) {
        return {
          ImageInString: imageFields[ImageName].imgSrc,
          ImageName: ImageName
        };
      });
    };

    _this.submitData = function () {
      var _this$props3 = _this.props,
          formValues = _this$props3.formValues,
          uploadFields = _this$props3.uploadFields,
          UserId = _this$props3.UserId,
          MinimumVerificationLevel = _this$props3.MinimumVerificationLevel,
          reset = _this$props3.reset,
          validateUserRegistrationIdentityMind = _this$props3.validateUserRegistrationIdentityMind,
          onSubmit = _this$props3.onSubmit;

      var values = __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(formValues, uploadFields);
      var uploadValues = __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default()(formValues, uploadFields);

      var AdditionalValidation = _this.getAdditionalValidation(uploadValues);
      var userInfo = _this.getUserInfo(Object.assign({}, values));
      var setUserConfigPayload = _this.getConfigPayload(values);

      var clientInfo = {
        alphaPointUserID: UserId.toString(),
        validationStage: MinimumVerificationLevel, // validation stage, necessary for identityMind
        validator: 'IM'
      };

      // Set params for ValidateUserRegistration request
      var validateUserRegistrationPayload = {
        clientInfo: clientInfo,
        userInfo: userInfo,
        AdditionalValidation: AdditionalValidation
      };

      var submitInfoIdentityMindPayload = {
        validateUserRegistrationPayload: validateUserRegistrationPayload,
        setUserConfigPayload: setUserConfigPayload
      };

      validateUserRegistrationIdentityMind(submitInfoIdentityMindPayload);
      reset();
      onSubmit && onSubmit();
    };

    _this.getMissingFieldsMessage = function () {
      var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-form');
      var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('slide-pane');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: slidePaneClasses('body') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: baseClasses('title') },
          _this.context.t('Verification form is not properly setup, please contact the exchange in order to solve this.')
        )
      );
    };

    _this.getSectionsForModal = function (level) {
      var sections = [];
      level.steps.forEach(function (step) {
        sections = [].concat(_toConsumableArray(sections), _toConsumableArray(step.sections));
      });
      return { sections: sections };
    };

    _this.state = {
      page: 0,
      openModal: false,
      images: {}
    };
    return _this;
  }

  _createClass(KYC_IMFormComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var missingFields = this.props.missingFields;

      if (missingFields.length > 0) {
        console.error('The following fields are missing from the configuration file: ', missingFields.map(function (f) {
          return '"' + f.name + '"';
        }).join(', '));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          processing = _props.processing,
          formValues = _props.formValues,
          level = _props.level,
          missingFields = _props.missingFields;
      var _state = this.state,
          page = _state.page,
          openModal = _state.openModal,
          images = _state.images;

      if (missingFields.length > 0) {
        return this.getMissingFieldsMessage();
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__KYC_IMFormStepContainer__["a" /* default */], {
          isFirst: page === 0,
          level: level.steps ? level.steps[page] : level,
          previousPage: this.previousPage,
          onSubmit: this.onSubmit
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__KYC_KYCConfirmLevelModal__["a" /* default */], {
          isOpen: openModal,
          close: function close() {
            return _this2.openModal(false);
          },
          onConfirm: this.submitData,
          processing: processing,
          level: level.steps ? this.getSectionsForModal(level) : level,
          values: Object.assign({}, formValues, images)
        })
      );
    }
  }]);

  return KYC_IMFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

KYC_IMFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_IMFormComponent);

/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_IMFormStepComponent__ = __webpack_require__(2381);




var mapStateToProps = function mapStateToProps(state) {
  return {
    formValues: Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["h" /* getFormValues */])('kycIMForm')(state)
  };
};

var KYCIdentityMindFormStepForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'kycIMForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(__WEBPACK_IMPORTED_MODULE_2__KYC_IMFormStepComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(KYCIdentityMindFormStepForm));

/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_kycFormHelper__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formGeneratorHelper__ = __webpack_require__(147);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-form');
var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('slide-pane');

var KYC_IMFormStepComponent = function (_React$Component) {
  _inherits(KYC_IMFormStepComponent, _React$Component);

  function KYC_IMFormStepComponent() {
    _classCallCheck(this, KYC_IMFormStepComponent);

    return _possibleConstructorReturn(this, (KYC_IMFormStepComponent.__proto__ || Object.getPrototypeOf(KYC_IMFormStepComponent)).apply(this, arguments));
  }

  _createClass(KYC_IMFormStepComponent, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props = this.props,
          invalid = _props.invalid,
          handleSubmit = _props.handleSubmit,
          previousPage = _props.previousPage,
          isFirst = _props.isFirst,
          level = _props.level,
          change = _props.change;

      var kycClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-form');
      var formValues = this.props.formValues;


      setTimeout(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_kycFormHelper__["a" /* setDropdownsDefaultValue */])(level.sections, change, formValues);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { className: slidePaneClasses('body'), onSubmit: handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('form-body') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('title') },
            context.t(level.label)
          ),
          level.sections.map(function (section, idx) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('section'), key: idx },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'header',
                { className: baseClasses('section-header') },
                context.t(section.label)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: kycClasses('section-body') },
                Object(__WEBPACK_IMPORTED_MODULE_5__helpers_formGeneratorHelper__["b" /* renderFormInputs */])(section.form, kycClasses(), context, change)
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('section') },
            !isFirst && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
              {
                type: 'button',
                customClass: baseClasses('back'),
                onClick: previousPage },
              level.prevPageLabel ? context.t(level.prevPageLabel) : context.t('Go back')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
              {
                type: 'submit',
                customClass: baseClasses(),
                disabled: invalid },
              level.nextPageLabel ? context.t(level.nextPageLabel) : context.t('Upload your ID')
            )
          )
        )
      );
    }
  }]);

  return KYC_IMFormStepComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

KYC_IMFormStepComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (KYC_IMFormStepComponent);

/***/ }),
/* 2382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_chunk__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__propTypes_kycConfigShapePropTypes__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KYCConfirmLevelModalComponent_css__ = __webpack_require__(2384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KYCConfirmLevelModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__KYCConfirmLevelModalComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var classes = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-confirm-level');

var KYCConfirmLevelModal = function (_React$Component) {
  _inherits(KYCConfirmLevelModal, _React$Component);

  function KYCConfirmLevelModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KYCConfirmLevelModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KYCConfirmLevelModal.__proto__ || Object.getPrototypeOf(KYCConfirmLevelModal)).call.apply(_ref, [this].concat(args))), _this), _this.renderImage = function (image, field) {
      return !image ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        className: classes('section-field-value-img'),
        src: image.imgSrc,
        alt: field.name
      });
    }, _this.renderUpload = function (value) {
      return !value ? null : value.file && value.file.name;
    }, _this.renderValue = function (values, field) {
      var isSimpleValue = !['date', 'image', 'upload', 'document'].includes(field.type);
      var renderMethods = {
        date: function date(_date) {
          return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__["b" /* formatDate */])(_date);
        },
        image: _this.renderImage,
        upload: _this.renderUpload,
        document: _this.renderUpload
      };
      var value = values[field.name];
      var renderValue = renderMethods[field.type];

      return isSimpleValue ? value : renderValue(value, field);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(KYCConfirmLevelModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          level = _props.level,
          values = _props.values,
          processing = _props.processing,
          _close = _props.close,
          onConfirm = _props.onConfirm,
          isOpen = _props.isOpen;

      var sectionGroups = level ? __WEBPACK_IMPORTED_MODULE_2_lodash_chunk___default()(level.sections, 2) : [];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__common_Modal_Modal__["a" /* default */],
        {
          customClass: classes(),
          isOpen: isOpen,
          title: this.context.t('Confirm Increase Verification Level Application'),
          close: function close() {
            return _close();
          },
          footer: {
            buttonText: processing ? this.context.t('Processing...') : this.context.t('Confirm'),
            disabled: processing,
            onClick: onConfirm,
            overrideClose: true,
            buttonStyle: 'success'
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('body') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: classes('description') },
            this.context.t('Thanks for applying to increase your Verification Level. Once we have approved your application, you will next be required to submit identification documentation.')
          ),
          sectionGroups.map(function (sections, idx) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: idx, className: classes('sections-wrapper') },
              sections.map(function (section, idx) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: section.label + idx, className: classes('section') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: classes('section-header') },
                    _this2.context.t(section.label)
                  ),
                  section && section.form.map(function (field, idx) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      {
                        key: field.name + idx,
                        className: classes('section-field') },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: classes('section-field-label') },
                        _this2.context.t(field.label),
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: classes('section-field-value') },
                        values && _this2.renderValue(values, field)
                      )
                    );
                  })
                );
              })
            );
          })
        )
      );
    }
  }]);

  return KYCConfirmLevelModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

KYCConfirmLevelModal.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_5__propTypes_kycConfigShapePropTypes__["a" /* kycConfigLevelShape */]),
  processing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

KYCConfirmLevelModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

KYCConfirmLevelModal.defaultProps = {
  processing: false
};

/* harmony default export */ __webpack_exports__["a"] = (KYCConfirmLevelModal);

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(235),
    isArrayLike = __webpack_require__(141),
    isIndex = __webpack_require__(245),
    isObject = __webpack_require__(67);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 2384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(2386),
    flatRest = __webpack_require__(832);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(586),
    hasIn = __webpack_require__(564);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(333);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(169),
    baseClone = __webpack_require__(2389),
    baseUnset = __webpack_require__(2409),
    castPath = __webpack_require__(133),
    copyObject = __webpack_require__(205),
    customOmitClone = __webpack_require__(2411),
    flatRest = __webpack_require__(832),
    getAllKeysIn = __webpack_require__(337);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(325),
    arrayEach = __webpack_require__(2390),
    assignValue = __webpack_require__(336),
    baseAssign = __webpack_require__(2391),
    baseAssignIn = __webpack_require__(2392),
    cloneBuffer = __webpack_require__(2393),
    copyArray = __webpack_require__(2394),
    copySymbols = __webpack_require__(2395),
    copySymbolsIn = __webpack_require__(2396),
    getAllKeys = __webpack_require__(558),
    getAllKeysIn = __webpack_require__(337),
    getTag = __webpack_require__(177),
    initCloneArray = __webpack_require__(2397),
    initCloneByTag = __webpack_require__(2398),
    initCloneObject = __webpack_require__(2403),
    isArray = __webpack_require__(63),
    isBuffer = __webpack_require__(243),
    isMap = __webpack_require__(2405),
    isObject = __webpack_require__(67),
    isSet = __webpack_require__(2407),
    keys = __webpack_require__(173),
    keysIn = __webpack_require__(339);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 2390 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(205),
    keys = __webpack_require__(173);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(205),
    keysIn = __webpack_require__(339);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(66);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(244)(module)))

/***/ }),
/* 2394 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(205),
    getSymbols = __webpack_require__(331);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(205),
    getSymbolsIn = __webpack_require__(588);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 2397 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(424),
    cloneDataView = __webpack_require__(2399),
    cloneRegExp = __webpack_require__(2400),
    cloneSymbol = __webpack_require__(2401),
    cloneTypedArray = __webpack_require__(2402);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(424);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 2400 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(424);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(2404),
    getPrototype = __webpack_require__(338),
    isPrototype = __webpack_require__(247);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(67);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(2406),
    baseUnary = __webpack_require__(246),
    nodeUtil = __webpack_require__(319);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(177),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(2408),
    baseUnary = __webpack_require__(246),
    nodeUtil = __webpack_require__(319);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(177),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(133),
    last = __webpack_require__(334),
    parent = __webpack_require__(2410),
    toKey = __webpack_require__(135);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(230),
    baseSlice = __webpack_require__(354);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(2412);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(117),
    getPrototype = __webpack_require__(338),
    isObjectLike = __webpack_require__(76);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMandatoryFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMissingMandatoryFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateLevelFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdditionalValidationFields; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getMandatoryFields = function getMandatoryFields() {
  return [{
    label: 'First Name', // this.context.t('First Name')
    name: 'firstName',
    type: 'text',
    validators: ['required']
  }, {
    label: 'Middle Name', // this.context.t('Middle Name')
    name: 'middleName',
    type: 'text',
    validators: []
  }, {
    label: 'Last Name', // this.context.t('Last Name')
    name: 'lastName',
    type: 'text',
    validators: ['required']
  }, {
    label: 'Date of Birth', // this.context.t('Date of Birth')
    name: 'dob',
    type: 'date',
    validators: ['required', 'isDate']
  }, {
    label: 'Billing Phone', // this.context.t('Billing Phone')
    name: 'phone',
    type: 'phone',
    validators: ['required']
  }, {
    label: 'Billing Country', // this.context.t('Billing Country')
    name: 'billingCountry',
    type: 'country',
    validators: ['required']
  }, {
    label: 'Billing Street Address', // this.context.t('Billing Street Address')
    name: 'billingStreetAddress',
    type: 'text',
    info: '(100 Washington Way)', // this.context.t('(100 Washington Way)')
    validators: ['required']
  }, {
    label: 'Billing State', // this.context.t('Billing State')
    name: 'state',
    type: 'text',
    info: 'Abbreviation only',
    validators: ['required']
  }, {
    label: 'Billing City', // this.context.t('Billing City')
    name: 'billingCity',
    type: 'text',
    validators: ['required']
  }, {
    label: 'Billing Zip', // this.context.t('Billing Zip')
    name: 'billingZip',
    type: 'text',
    validators: ['required', 'alphanumeric']
  }, {
    label: 'Type of ID you want to upload', // this.context.t('Type of ID you want to upload')
    name: 'DocumentType',
    type: 'select',
    options: {
      PP: 'Passport', // this.context.t('Passport'),
      DL: 'Drivers License', // this.context.t('Drivers License'),
      ID: 'Identity Card', // this.context.t('Identity Card'),
      RP: 'Residence Permit' // this.context.t('Residence Permit')
    },
    validators: ['required']
  }, {
    label: 'Document Country', // this.context.t('Document Country')
    name: 'DocumentCountry',
    type: 'country',
    validators: ['required']
  }, {
    label: 'Document State', // this.context.t('Document State')
    name: 'DocumentState',
    type: 'text',
    validators: ['required']
  }, {
    placeholder: 'Upload an image of your selected Document', // this.context.t('Upload an image of your selected Document')
    name: 'scandata',
    type: 'image',
    alt: 'Document', // this.context.t('Document')
    maxSize: 3.8, // Max Size supported by IM
    label: 'Document', // this.context.t('Document')
    validators: ['required']
  }, {
    placeholder: 'Image of the back of your Document', // this.context.t('Image of the back of your Drivers License')
    name: 'backsideimagedata',
    type: 'image',
    info: "Mandatory for driver's License",
    alt: 'Documents back', // this.context.t('Documents back')
    maxSize: 3.8, // Max Size supported by IM
    label: "Document's back", // this.context.t('Document\'s back')
    validators: ['required']
  }, {
    placeholder: 'Upload selfie', // this.context.t('Upload selfie')
    name: 'faceimages',
    label: 'Selfie', // this.context.t('Selfie')
    type: 'image',
    alt: 'Selfie picture', // this.context.t('Selfie picture')
    maxSize: 3.8, // Max Size supported by IM,
    validators: [],
    info: 'Optional - Uploading a selfie helps to verify your identity faster.' // this.context.t('Optional - Uplading a selfie helps to verify your identity faster.')
  }];
};

var iterateOnLevel = function iterateOnLevel(level, callbackFn) {
  if (level.steps) {
    level.steps.forEach(function (step) {
      step.sections.forEach(callbackFn);
    });
  } else {
    level.sections.forEach(callbackFn);
  }
};

var getAllConfigFields = function getAllConfigFields(levels) {
  var configFields = [];

  levels.forEach(function (level) {
    return iterateOnLevel(level, function (section) {
      configFields = [].concat(_toConsumableArray(configFields), _toConsumableArray(section.form || []));
    });
  });

  return configFields;
};

var getMissingMandatoryFields = function getMissingMandatoryFields(levels) {
  var mandatoryFields = getMandatoryFields();
  var configFields = getAllConfigFields(levels);

  return mandatoryFields.filter(function (mandatoryField) {
    return !configFields.find(function (field) {
      return field.name === mandatoryField.name;
    });
  });
};

var updateLevelFields = function updateLevelFields(level) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    suppressDefaultValidators: false
  };

  var mandatoryFields = getMandatoryFields();

  iterateOnLevel(level, function (section) {
    section.form.forEach(function (field) {
      var mandatoryField = mandatoryFields.find(function (f) {
        return f.name === field.name;
      });

      if (mandatoryField) {
        field.label = field.label || mandatoryField.label;
        field.info = field.info || mandatoryField.info;
        field.type = mandatoryField.type;

        if (!options.suppressDefaultValidators) {
          field.validators = field.validators ? [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(field.validators), _toConsumableArray(mandatoryField.validators))))) : mandatoryField.validators;
        }

        if (isUploadField(mandatoryField.type)) {
          field.placeholder = field.placeholder || mandatoryField.placeholder;
          field.maxSize = mandatoryField.maxSize;
        }

        if (['select', 'country'].includes(field.type)) field.options = field.options || mandatoryField.options || [];
      }
    });
  });
};

var isUploadField = function isUploadField(field) {
  return ['image', 'document', 'upload'].includes(field.type);
};

var getAdditionalValidationFields = function getAdditionalValidationFields(level) {
  var uploadFields = [];

  iterateOnLevel(level, function (section) {
    section.form.forEach(function (field) {
      if (isUploadField(field)) {
        uploadFields.push(field.name);
      }
    });
  });

  return uploadFields;
};

/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_getLevelHelper__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_IMLegacyHelpers__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KYC_IMLegacyFormComponent__ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_kycIdentityMindActions__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_authActions__ = __webpack_require__(89);









var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_kycLevelsSelectors__["a" /* kycLevelFormSelector */])(state),
      verificationLevel = _kycLevelFormSelector.verificationLevel,
      kycConfig = _kycLevelFormSelector.kycConfig,
      kyc = _kycLevelFormSelector.kyc,
      alphaPointSessiontoken = _kycLevelFormSelector.alphaPointSessiontoken,
      alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
      userConfig = _kycLevelFormSelector.userConfig,
      userName = _kycLevelFormSelector.userName,
      email = _kycLevelFormSelector.email,
      processing = _kycLevelFormSelector.processing,
      levelIncreaseStatus = _kycLevelFormSelector.levelIncreaseStatus;

  var level = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_getLevelHelper__["a" /* getDisplayLevel */])(kycConfig, Object(__WEBPACK_IMPORTED_MODULE_2__KYC_IMLegacyHelpers__["a" /* getCurrentLevel */])(verificationLevel, levelIncreaseStatus));

  return {
    level: level,
    processing: processing,
    formValues: Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["h" /* getFormValues */])('KYCIMLegacyForm')(state),
    // Used in KYCMitekComponent
    alphaPointUserID: alphaPointUserID,
    alphaPointSessiontoken: alphaPointSessiontoken,
    kycConfig: kycConfig,
    userName: userName,
    kyc: kyc,
    userConfig: userConfig,
    // Submit IM helper
    email: email
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    // Used in KYCMitekComponent
    confirmInfoMitek: function confirmInfoMitek(setUserConfigPayload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_kycIdentityMindActions__["b" /* confirmMitek */])(setUserConfigPayload));
    },
    launchMitek: function launchMitek(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_kycIdentityMindActions__["d" /* validateUserRegistrationMitek */])(payload));
    },

    // Submit IM helper
    submitInfoIdentityMind: function submitInfoIdentityMind(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_kycIdentityMindActions__["c" /* validateUserRegistrationIdentityMind */])(payload));
    },

    reset: function reset() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["k" /* reset */])('KYCIMLegacyForm'));
    },
    logout: function logout() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_authActions__["j" /* logout */])());
    }
  };
};

var KYC_IMLegacyForm = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["j" /* reduxForm */])({
  form: 'KYCIMLegacyForm',
  onSubmit: function onSubmit() {}
})(__WEBPACK_IMPORTED_MODULE_3__KYC_IMLegacyFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(KYC_IMLegacyForm));

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KYC_KYCConfirmLevelModal__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KYCMitek__ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_kycFormHelper__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_formGeneratorHelper__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__KYC_IMLegacyHelpers__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__propTypes_kycConfigShapePropTypes__ = __webpack_require__(156);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('slide-pane');

var KYC_IMLegacyFormComponent = function (_React$Component) {
  _inherits(KYC_IMLegacyFormComponent, _React$Component);

  function KYC_IMLegacyFormComponent(props) {
    _classCallCheck(this, KYC_IMLegacyFormComponent);

    var _this = _possibleConstructorReturn(this, (KYC_IMLegacyFormComponent.__proto__ || Object.getPrototypeOf(KYC_IMLegacyFormComponent)).call(this, props));

    _this.openModal = function (isOpen) {
      return _this.setState({ isOpen: isOpen });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(KYC_IMLegacyFormComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_kycFormHelper__["a" /* setDropdownsDefaultValue */])(this.props.level.sections, this.props.change);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var context = this.context;
      var _props = this.props,
          level = _props.level,
          processing = _props.processing,
          formValues = _props.formValues,
          invalid = _props.invalid,
          customClass = _props.customClass,
          logout = _props.logout,
          showCancelButton = _props.showCancelButton;

      var isLevel1 = level.level < 2;
      var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-form', customClass || '');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: slidePaneClasses('body') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('form-body') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('title') },
              context.t('Complete this form to verify your account to raise your limits and enable buys.')
            ),
            level && level.sections.map(function (section, idx) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: baseClasses('section'), key: idx },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'header',
                  { className: baseClasses('section-header') },
                  context.t(section.label)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: baseClasses('section-body') },
                  isLevel1 ? Object(__WEBPACK_IMPORTED_MODULE_7__helpers_formGeneratorHelper__["b" /* renderFormInputs */])(section.form, baseClasses(), context) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__KYCMitek__["a" /* default */], _this2.props)
                )
              );
            }),
            isLevel1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('section', 'bottom') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
                {
                  type: 'button',
                  customClass: baseClasses(),
                  disabled: invalid,
                  onClick: function onClick() {
                    return _this2.openModal(true);
                  } },
                context.t('Submit')
              ),
              showCancelButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
                {
                  type: 'button',
                  customClass: baseClasses(),
                  onClick: logout },
                context.t('Cancel')
              )
            )
          )
        ),
        isLevel1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__KYC_KYCConfirmLevelModal__["a" /* default */], {
          isOpen: this.state.isOpen,
          close: function close() {
            return _this2.openModal(false);
          },
          onConfirm: function onConfirm() {
            return Object(__WEBPACK_IMPORTED_MODULE_8__KYC_IMLegacyHelpers__["b" /* submitIdentityMindForm */])(_this2.props);
          },
          processing: processing,
          level: level,
          values: formValues
        })
      );
    }
  }]);

  return KYC_IMLegacyFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

KYC_IMLegacyFormComponent.propTypes = {
  kycConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    levels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__propTypes_kycConfigShapePropTypes__["a" /* kycConfigLevelShape */]))
  })
};

KYC_IMLegacyFormComponent.defaultProps = {
  showCancelButton: false
};

KYC_IMLegacyFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_IMLegacyFormComponent);

/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYCMitekComponent__ = __webpack_require__(2417);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYCMitekComponent__["a" /* default */]);

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYCConfirmMitekModalComponent__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIFrame_APIFrame__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propTypes_kycConfigShapePropTypes__ = __webpack_require__(156);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var KYCMitekComponent = function (_React$Component) {
  _inherits(KYCMitekComponent, _React$Component);

  function KYCMitekComponent(props) {
    _classCallCheck(this, KYCMitekComponent);

    var _this = _possibleConstructorReturn(this, (KYCMitekComponent.__proto__ || Object.getPrototypeOf(KYCMitekComponent)).call(this, props));

    _this.confirmInfoMitek = function () {
      var _this$props = _this.props,
          alphaPointUserID = _this$props.alphaPointUserID,
          userName = _this$props.userName,
          confirmInfoMitek = _this$props.confirmInfoMitek;


      var confirmInfoMitekPayload = {
        UserId: Number(alphaPointUserID),
        UserName: userName
      };

      confirmInfoMitek(confirmInfoMitekPayload);
    };

    _this.openModal = function (isOpen) {
      return _this.setState({ isOpen: isOpen });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(KYCMitekComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          alphaPointUserID = _props.alphaPointUserID,
          alphaPointSessiontoken = _props.alphaPointSessiontoken,
          _props$kycConfig = _props.kycConfig,
          type = _props$kycConfig.type,
          requestIdentifier = _props$kycConfig.requestIdentifier,
          launchMitek = _props.launchMitek,
          userConfig = _props.userConfig;


      var config = userConfig.reduce(function (item, i) {
        item[i.Key] = i.Value;
        return item;
      }, {});

      var userInfo = {
        firstName: config.fname,
        middleName: config.middleName,
        lastName: config.lname,
        dob: config.dob,
        email: config.email,
        billingStreetAddress: config.billingStreetAddress,
        billingCountry: config.billingCountry,
        billingCity: config.billingCity,
        billingState: config.billingState,
        billingZip: config.billingZip,
        phone: config.telephone,
        state: config.billingState,
        billingStreetNumber: config.billingStreetNumber,
        billingStreetType: config.billingStreetType,
        billingSuburb: config.billingCity,
        accountName: alphaPointUserID,
        billingFlatNumber: '',
        salutation: ''
      };

      var clientInfo = {
        alphaPointSessiontoken: alphaPointSessiontoken,
        alphaPointUserID: alphaPointUserID,
        validationStage: 2,
        validator: type
      };

      launchMitek({
        requestIdentifier: requestIdentifier,
        clientInfo: clientInfo,
        userInfo: userInfo
      }, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          kyc = _props2.kyc,
          processing = _props2.processing;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], { isVisible: processing }),
        !processing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIFrame_APIFrame__["a" /* default */], {
          id: 'mitek-iframe',
          src: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])('/mitek.html' + kyc.urlParams),
          customClass: 'mitek',
          onLoad: function onLoad() {
            var iframe = document.getElementById('mitek-iframe');
            var that = _this2;
            iframe.contentWindow.document.addEventListener('idchecker-finish', function () {
              iframe.contentWindow.document.querySelector('[ng-show="vm.success"]').innerHTML = ' ';
              that.openModal(true);
            }, false);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__KYCConfirmMitekModalComponent__["a" /* default */], {
          isOpen: this.state.isOpen,
          close: function close() {
            return _this2.confirmInfoMitek();
          },
          onConfirm: function onConfirm() {
            return _this2.confirmInfoMitek();
          }
        })
      );
    }
  }]);

  return KYCMitekComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (KYCMitekComponent);


KYCMitekComponent.propTypes = {
  kycConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    levels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_6__propTypes_kycConfigShapePropTypes__["a" /* kycConfigLevelShape */]))
  })
};

KYCMitekComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KYCConfirmMitekModalComponent_css__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KYCConfirmMitekModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__KYCConfirmMitekModalComponent_css__);







var classes = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-confirm-mitek');

var KYCConfirmMitekModal = function KYCConfirmMitekModal(props, context) {
  var onConfirm = props.onConfirm,
      close = props.close,
      isOpen = props.isOpen;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Confirm Identification Documents'),
      close: close,
      footer: {
        buttonText: context.t('Confirm'),
        onClick: onConfirm,
        overrideClose: true
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: classes('description') },
        context.t('Thanks for applying to increase your Verification Level. Once we have reviewed and approved your documents, you will be able to use all features of our platform.')
      )
    )
  );
};

KYCConfirmMitekModal.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

KYCConfirmMitekModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (KYCConfirmMitekModal);

/***/ }),
/* 2419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_JumioIframeContainer__ = __webpack_require__(2422);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYC_JumioIframeContainer__["a" /* default */]);

/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_kycJumioActions__ = __webpack_require__(2423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KYC_JumioIframeComponent__ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_getLevelHelper__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_snackbarActions__ = __webpack_require__(20);








var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_kycLevelsSelectors__["a" /* kycLevelFormSelector */])(state),
      verificationLevel = _kycLevelFormSelector.verificationLevel,
      kycConfig = _kycLevelFormSelector.kycConfig,
      kyc = _kycLevelFormSelector.kyc,
      alphaPointSessiontoken = _kycLevelFormSelector.alphaPointSessiontoken,
      alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
      userConfig = _kycLevelFormSelector.userConfig,
      userName = _kycLevelFormSelector.userName,
      processing = _kycLevelFormSelector.processing;

  var level = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_getLevelHelper__["a" /* getDisplayLevel */])(kycConfig, verificationLevel + 1);

  return {
    level: level,
    processing: processing,
    alphaPointUserID: alphaPointUserID,
    alphaPointSessiontoken: alphaPointSessiontoken,
    kycConfig: kycConfig,
    userName: userName,
    kyc: kyc,
    userConfig: userConfig
  };
};

var mapDispatchToProps = {
  validateUserRegistrationJumio: __WEBPACK_IMPORTED_MODULE_2__redux_actions_kycJumioActions__["a" /* validateUserRegistrationJumio */],
  closeKYC_JumioSidePane: __WEBPACK_IMPORTED_MODULE_3__redux_actions_sidePaneActions__["g" /* closeKYC_JumioSidePane */],
  showSnack: __WEBPACK_IMPORTED_MODULE_6__redux_actions_snackbarActions__["e" /* showSnack */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__KYC_JumioIframeComponent__["a" /* default */]));

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateUserRegistrationJumio; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kycActions__ = __webpack_require__(120);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var validateUserRegistrationJumio = function validateUserRegistrationJumio(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch) {
      var response, result, parsedResult;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(__WEBPACK_IMPORTED_MODULE_2__kycActions__["f" /* processingValidateUserRegistration */]);

              _context.next = 3;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__apiActions__["b" /* callAPI */])('ValidateUserRegistration', payload));

            case 3:
              response = _context.sent;
              result = void 0;


              try {
                parsedResult = JSON.parse(response.result);

                result = parsedResult.ValidationAnswerData;
              } catch (error) {
                result = response.result;
              }

              dispatch(__WEBPACK_IMPORTED_MODULE_2__kycActions__["e" /* finishedValidateUserRegistration */]);
              return _context.abrupt('return', result);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APIFrame_APIFrame__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KYCJumioIframeComponent_css__ = __webpack_require__(2425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KYCJumioIframeComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__KYCJumioIframeComponent_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var classes = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-jumio');

var KYC_JumioIframeComponent = function (_React$Component) {
  _inherits(KYC_JumioIframeComponent, _React$Component);

  function KYC_JumioIframeComponent() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, KYC_JumioIframeComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KYC_JumioIframeComponent.__proto__ || Object.getPrototypeOf(KYC_JumioIframeComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      processing: true,
      authToken: null
    }, _this.receiveMessage = function (event) {
      try {
        var data = JSON.parse(event.data);
        if (__WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(data, 'payload.value') === 'success') {
          _this.props.closeKYC_JumioSidePane();
          _this.props.showSnack({
            id: 'jumioSubmissionSuccess',
            text: _this.context.t('Documents successfully submitted for verification'),
            type: 'success'
          });

          window.removeEventListener('message', _this.receiveMessage);
        }
      } catch (e) {
        // Do nothing.
      }
    }, _this.initializeJumioIframe = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this$props, alphaPointSessiontoken, alphaPointUserID, type, payload, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, alphaPointSessiontoken = _this$props.alphaPointSessiontoken, alphaPointUserID = _this$props.alphaPointUserID, type = _this$props.kycConfig.type;
              payload = {
                clientInfo: {
                  alphaPointSessiontoken: alphaPointSessiontoken,
                  alphaPointUserID: alphaPointUserID,
                  validationStage: 1,
                  validator: type
                },
                userInfo: { accountName: alphaPointUserID }
              };
              _context.next = 4;
              return _this.props.validateUserRegistrationJumio(payload);

            case 4:
              data = _context.sent;

              if (!data) {
                _context.next = 7;
                break;
              }

              return _context.abrupt('return', _this.setState(Object.assign({
                processing: false
              }, data)));

            case 7:
              return _context.abrupt('return', _this.setState({
                processing: false,
                error: _this.context.t('Our account verification service is having difficulties connecting. Please try again later.')
              }));

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(KYC_JumioIframeComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.receiveMessage, false);

      this.initializeJumioIframe();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          processing = _state.processing,
          error = _state.error;


      if (processing) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], { isVisible: processing });
      }

      if (error) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: classes('error') },
          error
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APIFrame_APIFrame__["a" /* default */], {
        id: 'jumio-iframe',
        src: this.state.RedirectUrl,
        customClass: 'jumio'
      });
    }
  }]);

  return KYC_JumioIframeComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

KYC_JumioIframeComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_JumioIframeComponent);

/***/ }),
/* 2425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KYC_ManualFormContainer__ = __webpack_require__(2427);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__KYC_ManualFormContainer__["a" /* default */]);

/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_getLevelHelper__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KYC_ManualFormComponent__ = __webpack_require__(2428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_kycManualActions__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);








var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_kycLevelsSelectors__["a" /* kycLevelFormSelector */])(state),
      verificationLevel = _kycLevelFormSelector.verificationLevel,
      kycConfig = _kycLevelFormSelector.kycConfig,
      alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
      userName = _kycLevelFormSelector.userName,
      email = _kycLevelFormSelector.email,
      processing = _kycLevelFormSelector.processing;

  var level = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_getLevelHelper__["a" /* getDisplayLevel */])(kycConfig, verificationLevel + 1);

  return {
    // Component
    level: level,
    formValues: Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["h" /* getFormValues */])('KYC_Manual_Form')(state),
    processing: processing,
    // KYCManualHelpers
    alphaPointUserID: alphaPointUserID,
    email: email,
    currentLevel: verificationLevel,
    userName: userName
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    submitUserConfig: function submitUserConfig(setUserConfigPayload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__["r" /* setUserConfig */])(setUserConfigPayload.UserId, setUserConfigPayload.UserName, setUserConfigPayload.Config, false));
    },
    submitInfoManual: function submitInfoManual(setUserConfigForManualKYCPayload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_kycManualActions__["c" /* setUserConfigForManualKYC */])(setUserConfigForManualKYCPayload.UserId, setUserConfigForManualKYCPayload.UserName, setUserConfigForManualKYCPayload.underReviewLevel, setUserConfigForManualKYCPayload.Config));
    },
    reset: function reset() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["k" /* reset */])('KYC_Manual_Form'));
    }
  };
};

var KYC_ManualForm = Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["j" /* reduxForm */])({
  form: 'KYC_Manual_Form',
  onSubmit: function onSubmit() {}
})(__WEBPACK_IMPORTED_MODULE_2__KYC_ManualFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(KYC_ManualForm));

/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KYC_KYCConfirmLevelModal__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KYC_ManualDirectionsComponent__ = __webpack_require__(2429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_formGeneratorHelper__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_kycFormHelper__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__KYC_ManualHelpers__ = __webpack_require__(2430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__propTypes_kycConfigShapePropTypes__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('slide-pane');

var KYC_ManualFormComponent = function (_React$Component) {
  _inherits(KYC_ManualFormComponent, _React$Component);

  function KYC_ManualFormComponent(props) {
    _classCallCheck(this, KYC_ManualFormComponent);

    var _this = _possibleConstructorReturn(this, (KYC_ManualFormComponent.__proto__ || Object.getPrototypeOf(KYC_ManualFormComponent)).call(this, props));

    _this.openModal = function (isOpen) {
      return _this.setState({ isOpen: isOpen });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(KYC_ManualFormComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_7__helpers_kycFormHelper__["a" /* setDropdownsDefaultValue */])(this.props.level.sections, this.props.change);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var context = this.context;
      var _props = this.props,
          level = _props.level,
          closeSidePane = _props.closeSidePane,
          formValues = _props.formValues,
          processing = _props.processing,
          customClass = _props.customClass;

      var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-form', customClass);
      var manualDirections = level.manualDirections;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('form-inline', slidePaneClasses('body')) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('form-body') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('title') },
              context.t(level.sections[0].title || 'Complete this form to verify your account to raise your limits and enable buys.')
            ),
            level && level.sections.map(function (section, idx) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: baseClasses('section'), key: idx },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'header',
                  { className: baseClasses('section-header') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: 'text-white' },
                    _this2.context.t(section.label)
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: baseClasses('section-body') },
                  manualDirections ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__KYC_ManualDirectionsComponent__["a" /* default */], { section: section }) : Object(__WEBPACK_IMPORTED_MODULE_6__helpers_formGeneratorHelper__["b" /* renderFormInputs */])(section.form, baseClasses(), _this2.context)
                )
              );
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('section') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
                {
                  type: 'button',
                  customClass: baseClasses(),
                  onClick: manualDirections ? function () {
                    return closeSidePane();
                  } : function () {
                    return _this2.openModal(true);
                  } },
                this.context.t(manualDirections ? 'Close' : 'Submit')
              )
            )
          )
        ),
        !manualDirections && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__KYC_KYCConfirmLevelModal__["a" /* default */], {
          isOpen: this.state.isOpen,
          close: function close() {
            return _this2.openModal(false);
          },
          onConfirm: function onConfirm() {
            return Object(__WEBPACK_IMPORTED_MODULE_8__KYC_ManualHelpers__["a" /* submitManualForm */])(_this2.props);
          },
          processing: processing,
          level: level,
          values: formValues
        })
      );
    }
  }]);

  return KYC_ManualFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

KYC_ManualFormComponent.propTypes = {
  kycConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    levels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__propTypes_kycConfigShapePropTypes__["a" /* kycConfigLevelShape */]))
  })
};

KYC_ManualFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_ManualFormComponent);

/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);




var classes = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('kyc-manual-directions');

var KYC_ManualDirectionsComponent = function KYC_ManualDirectionsComponent(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: classes('description') },
      context.t(props.section.directions)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { href: 'mailto:' + props.section.email, className: classes('email') },
      props.section.email
    )
  );
};

KYC_ManualDirectionsComponent.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

KYC_ManualDirectionsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (KYC_ManualDirectionsComponent);

/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submitManualForm; });
var submitManualForm = function submitManualForm(props) {
  var alphaPointUserID = props.alphaPointUserID,
      email = props.email,
      currentLevel = props.currentLevel,
      formValues = props.formValues,
      userName = props.userName,
      submitInfoManual = props.submitInfoManual,
      reset = props.reset,
      onSubmit = props.onSubmit;

  var underReviewLevel = (currentLevel + 1).toString();
  var Config = Object.keys(formValues || {}).map(function (key) {
    return {
      Key: key,
      Value: formValues[key]
    };
  });
  Config.push({ Key: 'levelIncreaseStatus', Value: underReviewLevel }, { Key: 'email', Value: email });

  var submitInfoManualPayload = {
    UserId: parseInt(alphaPointUserID, 10),
    UserName: userName,
    underReviewLevel: underReviewLevel,
    Config: Config
  };

  submitInfoManual(submitInfoManualPayload);
  reset();
  onSubmit && onSubmit();
};

/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Tab_Tab__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateReportForm_CreateReportFormContainer__ = __webpack_require__(2432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScheduleReportComponent__ = __webpack_require__(2434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmSingleReport_ConfirmSingleReportModalContainer__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmCyclicalReport_ConfirmCyclicalReportModalContainer__ = __webpack_require__(2440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportSidePaneComponent_css__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportSidePaneComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ReportSidePaneComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__["b" /* getBEMClasses */])('reports-sidepane');

var ReportSidePane = function (_React$Component) {
  _inherits(ReportSidePane, _React$Component);

  function ReportSidePane() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReportSidePane);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportSidePane.__proto__ || Object.getPrototypeOf(ReportSidePane)).call.apply(_ref, [this].concat(args))), _this), _this.getTabs = function () {
      return [{
        menuItem: _this.context.t('Single Report'),
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CreateReportForm_CreateReportFormContainer__["a" /* default */], null);
        }
      }, {
        menuItem: _this.context.t('Cyclical Report'),
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ScheduleReportComponent__["a" /* default */], null);
        }
      }];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReportSidePane, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        hideHeader: true,
        customClass: 'reports-sidepane',
        classModifiers: 'with-tabs'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var index = this.props.index;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('body') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('header') },
          this.context.t('Create a Report')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Tab_Tab__["a" /* default */], {
          panes: this.getTabs(),
          customClass: '' + baseClasses(),
          defaultActiveIndex: index
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ConfirmSingleReport_ConfirmSingleReportModalContainer__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ConfirmCyclicalReport_ConfirmCyclicalReportModalContainer__["a" /* default */], null)
      );
    }
  }]);

  return ReportSidePane;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ReportSidePane.propTypes = {
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
ReportSidePane.defaultProps = {
  index: 0
};
ReportSidePane.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ReportSidePane);


ReportSidePane.defaultProps = {
  onSidePaneOpen: function onSidePaneOpen() {}
};

/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateReportFormComponent__ = __webpack_require__(2433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_reportsPayloadHelper__ = __webpack_require__(836);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var FORM = 'createReport';

var selector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])(FORM);

var mapStateToProps = function mapStateToProps(state) {
  var _state$user = state.user,
      accounts = _state$user.accounts,
      selectedAccountId = _state$user.selectedAccountId;


  var startDate = selector(state, 'startDate');
  var endDate = selector(state, 'endDate');

  var buttonDisabled = !startDate || startDate === '__/__/____' || !endDate || endDate === '__/__/____';

  return {
    accounts: accounts,
    startDate: startDate,
    buttonDisabled: buttonDisabled,
    selectedAccountId: selectedAccountId,
    initialValues: _defineProperty({
      type: 'TradeActivity'
    }, selectedAccountId, true)
  };
};

var CreateReportForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: FORM,
  onSubmit: function onSubmit(values, dispatch, ownProps) {
    var payload = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_reportsPayloadHelper__["a" /* getReportsPayload */])(values, ownProps);
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_SINGLE_REPORT, { payload: payload }));
  }
})(__WEBPACK_IMPORTED_MODULE_2__CreateReportFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(CreateReportForm));

/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_add_days__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_sub_days__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_sub_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_sub_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APDatePicker_APDatePicker__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReportAccountsComponent__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ReportFormComponent_css__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ReportFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ReportFormComponent_css__);












var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__["b" /* getBEMClasses */])('report-form');

var CreateReportComponent = function CreateReportComponent(props, context) {
  var accounts = props.accounts,
      startDate = props.startDate,
      buttonDisabled = props.buttonDisabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { onSubmit: props.handleSubmit, className: baseClasses('body') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('form-body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ReportAccountsComponent__["a" /* default */], { accounts: accounts }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APSelect__["b" /* default */], {
        name: 'type',
        label: context.t('Report Type:'),
        customClass: baseClasses(),
        validate: [__WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__["p" /* required */]],
        options: [{ value: 'TradeActivity', label: context.t('Trade Activity') }, { value: 'Transaction', label: context.t('Transaction') }, { value: 'Treasury', label: context.t('Treasury') }],
        showTriangles: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('datapicker-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APDatePicker_APDatePicker__["a" /* default */], {
          name: 'startDate',
          label: context.t('Start Date:'),
          customClass: baseClasses(),
          validate: [__WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__["p" /* required */]],
          maxDate: __WEBPACK_IMPORTED_MODULE_3_date_fns_sub_days___default()(new Date(), 1),
          initialOptions: { theme: 'retail' }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APDatePicker_APDatePicker__["a" /* default */], {
          name: 'endDate',
          label: context.t('End Date:'),
          customClass: baseClasses(),
          minDate: __WEBPACK_IMPORTED_MODULE_2_date_fns_add_days___default()(startDate, 1),
          maxDate: new Date(),
          validate: [__WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__["p" /* required */]],
          initialOptions: { theme: 'retail' }
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('footer') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__common_APButton__["a" /* default */],
        {
          type: 'submit',
          customClass: baseClasses(),
          styleName: 'additive',
          disabled: buttonDisabled },
        context.t('Create')
      )
    )
  );
};

CreateReportComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

CreateReportComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (CreateReportComponent);

/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleReportForm_ScheduleReportFormContainer__ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);




var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('schedule-report');

var ScheduleReportComponent = function ScheduleReportComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: baseClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ScheduleReportForm_ScheduleReportFormContainer__["a" /* default */], null)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ScheduleReportComponent);

/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScheduleReportFormComponent__ = __webpack_require__(2436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_reportsPayloadHelper__ = __webpack_require__(836);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var FORM = 'scheduleReport';
var selector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])(FORM);

var mapStateToProps = function mapStateToProps(state) {
  var _state$user = state.user,
      accounts = _state$user.accounts,
      selectedAccountId = _state$user.selectedAccountId;

  var startDate = selector(state, 'startDate');

  return {
    accounts: accounts,
    selectedAccountId: selectedAccountId,
    initialValues: _defineProperty({
      type: 'TradeActivity',
      frequency: 'Daily'
    }, selectedAccountId, true),
    buttonDisabled: !startDate || startDate === '__/__/____'
  };
};

var ScheduleReportForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: FORM,
  onSubmit: function onSubmit(values, dispatch, ownProps) {
    var payload = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_reportsPayloadHelper__["a" /* getReportsPayload */])(values, ownProps);
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_CYCLICAL_REPORT, { payload: payload }));
  }
})(__WEBPACK_IMPORTED_MODULE_2__ScheduleReportFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(ScheduleReportForm));

/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APDatePicker_APDatePicker__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReportAccountsComponent__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportFormComponent_css__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReportFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ReportFormComponent_css__);











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('report-form');

var ScheduleReportFormComponent = function ScheduleReportFormComponent(props, context) {
  var accounts = props.accounts,
      handleSubmit = props.handleSubmit,
      buttonDisabled = props.buttonDisabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { onSubmit: handleSubmit, className: baseClasses('body') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('form-body') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ReportAccountsComponent__["a" /* default */], { accounts: accounts }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["b" /* default */], {
        name: 'type',
        label: context.t('Report Type:'),
        customClass: baseClasses(),
        validate: [__WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__["p" /* required */]],
        options: [{ value: 'TradeActivity', label: context.t('Trade Activity') }, { value: 'Transaction', label: context.t('Transaction') }, { value: 'Treasury', label: context.t('Treasury') }],
        showTriangles: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('datapicker-container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APDatePicker_APDatePicker__["a" /* default */], {
          name: 'startDate',
          label: context.t('Start Date:'),
          minDate: new Date(),
          customClass: baseClasses(),
          validate: [__WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__["p" /* required */]],
          initialOptions: { theme: 'retail' }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["b" /* default */], {
          name: 'frequency',
          label: context.t('Frequency:'),
          customClass: baseClasses(),
          classModifiers: 'small',
          validate: [__WEBPACK_IMPORTED_MODULE_5__helpers_formValidations__["p" /* required */]],
          options: [{ value: 'Hourly', label: context.t('Hourly') }, { value: 'Daily', label: context.t('Daily') }, { value: 'Weekly', label: context.t('Weekly') }, { value: 'Monthly', label: context.t('Monthly') }, { value: 'Annual', label: context.t('Annual') }],
          showTriangles: true
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('footer') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__common_APButton__["a" /* default */],
        {
          type: 'submit',
          customClass: baseClasses(),
          styleName: 'additive',
          disabled: buttonDisabled },
        context.t('Create')
      )
    )
  );
};

ScheduleReportFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ScheduleReportFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ScheduleReportFormComponent);

/***/ }),
/* 2437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmSingleReportModal__ = __webpack_require__(2438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_reportActions__ = __webpack_require__(138);






var mapDispatchToProps = {
  generateReport: __WEBPACK_IMPORTED_MODULE_4__redux_actions_reportActions__["g" /* generateReport */]
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConfirmSingleReportModal__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_SINGLE_REPORT
})(container));

/***/ }),
/* 2438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmSingleReportForm__ = __webpack_require__(2439);





var ConfirmSingleReportModal = function ConfirmSingleReportModal(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: props.isOpen,
      title: context.t('Create Single Report'),
      customClass: 'confirm-report-modal',
      close: props.close,
      footer: {
        buttonText: context.t('Create Report'),
        buttonStyle: 'additive',
        onClick: function onClick() {
          return props.generateReport(props.payload);
        }
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ConfirmSingleReportForm__["a" /* default */], { payload: props.payload })
  );
};

ConfirmSingleReportModal.propTypes = {
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ConfirmSingleReportModal.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    endDate: ''
  }
};

ConfirmSingleReportModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmSingleReportModal);

/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmSingleReportModal_css__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmSingleReportModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfirmSingleReportModal_css__);








var confirmSingleReportClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('confirm-single-report');

var ConfirmSingleReportForm = function ConfirmSingleReportForm(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: confirmSingleReportClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: confirmSingleReportClasses('title') },
      context.t('Confirm')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: context.t('Report Type:'),
      text: props.payload.type,
      customClass: confirmSingleReportClasses()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: context.t('Start Date:'),
      text: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__["b" /* formatDate */])(props.payload.startDate),
      customClass: confirmSingleReportClasses()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: context.t('End Date:'),
      text: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__["b" /* formatDate */])(props.payload.endDate),
      customClass: confirmSingleReportClasses()
    })
  );
};

ConfirmSingleReportForm.propTypes = {
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

ConfirmSingleReportForm.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    endDate: ''
  }
};

ConfirmSingleReportForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmSingleReportForm);

/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmCyclicalReportModal__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_reportActions__ = __webpack_require__(138);






var mapDispatchToProps = {
  scheduleReport: __WEBPACK_IMPORTED_MODULE_4__redux_actions_reportActions__["j" /* scheduleReport */]
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__ConfirmCyclicalReportModal__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_CYCLICAL_REPORT
})(container));

/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmCyclicalReportForm__ = __webpack_require__(2442);





var ConfirmCyclicalReportModal = function ConfirmCyclicalReportModal(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: props.isOpen,
      title: context.t('Schedule a Cyclical Report'),
      customClass: 'confirm-report-modal',
      close: props.close,
      footer: {
        buttonText: context.t('Schedule Report'),
        buttonStyle: 'additive',
        onClick: function onClick() {
          return props.scheduleReport(props.payload);
        }
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ConfirmCyclicalReportForm__["a" /* default */], { payload: props.payload })
  );
};

ConfirmCyclicalReportModal.propTypes = {
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ConfirmCyclicalReportModal.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    frequency: ''
  }
};

ConfirmCyclicalReportModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmCyclicalReportModal);

/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmSingleReport_ConfirmSingleReportModal_css__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmSingleReport_ConfirmSingleReportModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfirmSingleReport_ConfirmSingleReportModal_css__);








var confirmSingleReportClasses = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('confirm-single-report');

var ConfirmCyclicalReportForm = function ConfirmCyclicalReportForm(props, context) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: confirmSingleReportClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: confirmSingleReportClasses('title') },
      context.t('Confirm')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: context.t('Report Type:'),
      text: props.payload.type,
      customClass: confirmSingleReportClasses()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: context.t('Start Date:'),
      text: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_dateHelper__["b" /* formatDate */])(props.payload.startDate),
      customClass: confirmSingleReportClasses()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APLabelWithText__["a" /* default */], {
      label: context.t('Frequency:'),
      text: props.payload.frequency,
      customClass: confirmSingleReportClasses()
    })
  );
};

ConfirmCyclicalReportForm.propTypes = {
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

ConfirmCyclicalReportForm.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    frequency: ''
  }
};

ConfirmCyclicalReportForm.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ConfirmCyclicalReportForm);

/***/ }),
/* 2443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepositFormContainer__ = __webpack_require__(2445);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DepositSidePaneComponent = function (_React$Component) {
  _inherits(DepositSidePaneComponent, _React$Component);

  function DepositSidePaneComponent() {
    _classCallCheck(this, DepositSidePaneComponent);

    return _possibleConstructorReturn(this, (DepositSidePaneComponent.__proto__ || Object.getPrototypeOf(DepositSidePaneComponent)).apply(this, arguments));
  }

  _createClass(DepositSidePaneComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        title: this.context.t('Deposit'),
        customClass: 'deposit-sidepane'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DepositFormContainer__["a" /* default */], this.props);
    }
  }]);

  return DepositSidePaneComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DepositSidePaneComponent.defaultProps = {
  onSidePaneOpen: function onSidePaneOpen() {}
};

DepositSidePaneComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DepositSidePaneComponent);

/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DepositFormComponent__ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_depositActions__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);







var formName = 'createDeposit';

var mapStateToProps = function mapStateToProps(state, _ref) {
  var product = _ref.product;

  return {
    deposit: state.deposit,
    isDasc: product.Product === 'DASC' || product.Product === 'DAS'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectDepositProduct: function selectDepositProduct(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_depositActions__["o" /* fetchAllProductDepositTemplates */])(productId));
    },
    selectDepositTemplate: function selectDepositTemplate(productId, templateType) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_depositActions__["p" /* fetchProductDepositTemplate */])(productId, templateType));
    },
    changeFieldValue: function changeFieldValue(field, value) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])(formName, field, value));
    }
  };
};

var DepositFormContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__DepositFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: formName,
  onSubmit: function onSubmit(payload, dispatch, _ref2) {
    var _ref2$product = _ref2.product,
        ProductId = _ref2$product.ProductId,
        Product = _ref2$product.Product;

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_depositActions__["n" /* createDepositTicket */])(Object.assign({}, payload, { ProductId: ProductId })));
    if (__WEBPACK_IMPORTED_MODULE_5__config__["b" /* default */].Deposit.showDepositIdModal) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].DEPOSIT_REFERENCE_ID, {
        ProductSymbol: Product
      }));
    }
  }
})(DepositFormContainer));

/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DepositTemplateFormComponent__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DepositWorkflows_DepositWorkflowsContainer__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DepositFormComponent_css__ = __webpack_require__(2447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DepositFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DepositFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('deposit-form');
var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('slide-pane');

var DepositFormComponent = function (_React$Component) {
  _inherits(DepositFormComponent, _React$Component);

  function DepositFormComponent() {
    _classCallCheck(this, DepositFormComponent);

    return _possibleConstructorReturn(this, (DepositFormComponent.__proto__ || Object.getPrototypeOf(DepositFormComponent)).apply(this, arguments));
  }

  _createClass(DepositFormComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          selectDepositProduct = _props.selectDepositProduct,
          product = _props.product;

      selectDepositProduct(product.ProductId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          handleSubmit = _props2.handleSubmit,
          submitting = _props2.submitting,
          deposit = _props2.deposit,
          product = _props2.product,
          changeFieldValue = _props2.changeFieldValue,
          selectDepositTemplate = _props2.selectDepositTemplate,
          isDasc = _props2.isDasc;

      var showTemplateTypeSelect = deposit.templateTypes.length > 1 && !Object.keys(deposit.templateInfo).length && !deposit.isLoading;
      var templateTypes = [{ value: '', label: 'Select an option' }].concat(_toConsumableArray(deposit.templateTypes.map(function (template) {
        return {
          value: template.TemplateName,
          label: template.TemplateName
        };
      })));
      var useTemplateDepositWorkflow = deposit.depositInfo && !!deposit.depositInfo.length;

      if (deposit.depositInfo.length && isDasc) {
        var dataArr = deposit.depositInfo[0].split('?dt=');
        deposit.template = { exchangeAddress: dataArr[0], memo: dataArr[1] };

        setTimeout(function () {
          //update data outside render
          changeFieldValue('exchangeAddress', deposit.template.exchangeAddress);
          changeFieldValue('memo', deposit.template.memo);
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DepositWorkflows_DepositWorkflowsContainer__["a" /* default */], {
          submitting: submitting,
          onSubmit: handleSubmit
        }),
        deposit.isLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__["a" /* default */], { customClass: baseClasses }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          deposit.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: baseClasses('error') },
            this.context.t(deposit.error)
          ),
          useTemplateDepositWorkflow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            {
              className: slidePaneClasses('body'),
              onSubmit: handleSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('form-body') },
              showTemplateTypeSelect && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  this.context.t('Select an option to continue the deposit process')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APSelect__["b" /* default */], {
                  name: 'TemplateType',
                  customClass: baseClasses(),
                  label: this.context.t('Options for deposit'),
                  onSelect: function onSelect(value) {
                    return selectDepositTemplate(product.ProductId, value);
                  },
                  options: templateTypes
                })
              ),
              !deposit.depositInfo.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DepositTemplateFormComponent__["a" /* default */], {
                product: product,
                template: deposit.template,
                submitting: submitting,
                baseClasses: baseClasses
              })
            )
          )
        )
      );
    }
  }]);

  return DepositFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DepositFormComponent.defaultProps = {
  deposit: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    depositInfo: {},
    depositStatus: {}
  }
};

DepositFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectDepositProduct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showSnack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  deposit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    templateInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    depositInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    depositStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      success: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      RequestCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }).isRequired
  })
};

DepositFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DepositFormComponent);

/***/ }),
/* 2447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WithdrawForm_WithdrawFormContainer__ = __webpack_require__(2449);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var WithdrawSidePaneComponent = function (_React$Component) {
  _inherits(WithdrawSidePaneComponent, _React$Component);

  function WithdrawSidePaneComponent() {
    _classCallCheck(this, WithdrawSidePaneComponent);

    return _possibleConstructorReturn(this, (WithdrawSidePaneComponent.__proto__ || Object.getPrototypeOf(WithdrawSidePaneComponent)).apply(this, arguments));
  }

  _createClass(WithdrawSidePaneComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen && this.props.onSidePaneOpen({
        title: 'Withdrawals',
        customClass: 'withdraw-sidepane'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__WithdrawForm_WithdrawFormContainer__["a" /* default */], this.props);
    }
  }]);

  return WithdrawSidePaneComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WithdrawSidePaneComponent.defaultProps = {
  onSidePaneOpen: function onSidePaneOpen() {}
};

WithdrawSidePaneComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (WithdrawSidePaneComponent);

/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_positionSelectors__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WithdrawFormComponent__ = __webpack_require__(2450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_withdrawActions__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_store__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);













var formSelector = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["g" /* formValueSelector */])('createWithdraw');
var closeSidePane = function closeSidePane() {
  return __WEBPACK_IMPORTED_MODULE_9__redux_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__redux_actions_sidePaneActions__["k" /* closeWithdrawSidePane */])());
};

var mapStateToProps = function mapStateToProps(state) {
  var products = Object(__WEBPACK_IMPORTED_MODULE_4__redux_selectors_depositWithdrawalSelectors__["e" /* productsListSelector */])(state);
  var positions = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_positionSelectors__["b" /* positionSelector */])(state);

  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableWithdraw = _kycVerificationLevel.disableWithdraw;

  return {
    disableWithdraw: disableWithdraw,
    products: products,
    withdrawInfo: state.withdraw,
    positions: positions,
    amountValue: formSelector(state, 'Amount'),
    selectedProductId: formSelector(state, 'ProductId'),
    hideFees: !!__WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].global.hideFees,
    VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__VerificationRequired_VerificationRequiredContainer__["a" /* default */], {
      disabled: disableWithdraw,
      onClick: closeSidePane
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectWithdrawProduct: function selectWithdrawProduct(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_withdrawActions__["o" /* fetchProductWithdrawTemplates */])(productId));
    },
    selectWithdrawTemplate: function selectWithdrawTemplate(productId, templateType) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_withdrawActions__["n" /* fetchProductWithdrawTemplate */])(productId, templateType));
    },
    getWithdrawFee: function getWithdrawFee(productId, amount) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_withdrawActions__["p" /* getWithdrawFee */])(productId, amount));
    },
    submitWithdraw: function submitWithdraw(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_withdrawActions__["m" /* createWithdrawTicket */])(payload));
    }
  };
};

var WithdrawFormContainer = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_7__WithdrawFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["j" /* reduxForm */])({
  form: 'createWithdraw',
  onSubmit: function onSubmit() {}
})(WithdrawFormContainer));

/***/ }),
/* 2450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WithdrawTemplateForm_WithdrawTemplateFormContainer__ = __webpack_require__(2451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_withdrawHelper__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WithdrawFormComponent_css__ = __webpack_require__(2460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WithdrawFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__WithdrawFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('withdraw-form');
var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('slide-pane');

var WithdrawFormComponent = function (_React$Component) {
  _inherits(WithdrawFormComponent, _React$Component);

  function WithdrawFormComponent(props) {
    _classCallCheck(this, WithdrawFormComponent);

    var _this = _possibleConstructorReturn(this, (WithdrawFormComponent.__proto__ || Object.getPrototypeOf(WithdrawFormComponent)).call(this, props));

    _this.getInitialState = function () {
      return { position: null, product: {}, errorMessage: '' };
    };

    _this.selectProduct = function (productId) {
      var _this$props = _this.props,
          selectWithdrawProduct = _this$props.selectWithdrawProduct,
          products = _this$props.products;

      var product = products.find(function (product) {
        return product.ProductId === productId;
      });

      if (product) {
        var position = _this.getPosition(product.Product);

        selectWithdrawProduct(product.ProductId);
        _this.setState({ position: position, product: product });
      } else {
        _this.setState(_this.getInitialState());
      }
    };

    _this.getPosition = function (productId) {
      return _this.props.positions.find(function (position) {
        return position.ProductSymbol === productId;
      });
    };

    _this.onAmountChange = function (amount) {
      var product = _this.state.product;

      if (!isNaN(amount)) _this.props.getWithdrawFee(product.ProductId, amount);
    };

    _this.doSubmit = function (values) {
      var _this$state$position = _this.state.position,
          Amount = _this$state$position.Amount,
          Hold = _this$state$position.Hold;
      var _this$props2 = _this.props,
          _this$props2$withdraw = _this$props2.withdrawInfo,
          fee = _this$props2$withdraw.withdrawFee,
          TemplateType = _this$props2$withdraw.template.TemplateType,
          submitWithdraw = _this$props2.submitWithdraw;

      var amount = parseFloat(values.Amount);
      var balance = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_withdrawHelper__["a" /* getAvailableBalance */])(Amount, Hold);

      if (amount <= balance) {
        values.Amount = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_withdrawHelper__["d" /* getTotalWithdrawValue */])(balance, values.Amount, fee);
      } else {
        _this.setState({
          errorMessage: _this.context.t('You have insufficient balance')
        });
        return;
      }
      return submitWithdraw(Object.assign({}, values, {
        TemplateType: TemplateType,
        ProductId: _this.state.product.ProductId
      }));
    };

    _this.getTotal = function (balance, amount, fee) {
      var total = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_withdrawHelper__["c" /* getTotalRender */])(balance, amount, fee);

      return total || total === 0 ? total : _this.context.t('Insufficient funds');
    };

    _this.getInfoText = function (value) {
      var product = _this.state.product;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: baseClasses('currency') },
          Object(__WEBPACK_IMPORTED_MODULE_7__helpers_numberFormatter__["b" /* formatNumberToLocale */])(value, product && product.Product)
        ),
        ' ',
        product && product.Product
      );
    };

    _this.state = _this.getInitialState();
    return _this;
  }

  _createClass(WithdrawFormComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var product = this.props.product;

      this.selectProduct(product.ProductId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          product = _state.product,
          _state$position = _state.position,
          Amount = _state$position.Amount,
          Hold = _state$position.Hold,
          errorMessage = _state.errorMessage;
      var _props = this.props,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          withdrawInfo = _props.withdrawInfo,
          amountValue = _props.amountValue,
          invalid = _props.invalid,
          selectWithdrawTemplate = _props.selectWithdrawTemplate,
          hideFees = _props.hideFees;

      var balance = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_withdrawHelper__["a" /* getAvailableBalance */])(Amount, Hold);
      var total = this.getTotal(balance, amountValue, withdrawInfo.withdrawFee);
      var balanceText = this.getInfoText(balance);
      var feeText = this.getInfoText(withdrawInfo.withdrawFee);
      var totalText = this.getInfoText(total);
      var receivedText = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_withdrawHelper__["d" /* getTotalWithdrawValue */])(balance, amountValue, withdrawInfo.withdrawFee);
      var showTemplateTypeSelect = withdrawInfo.templateTypes.length > 1 && !Object.keys(withdrawInfo.templateInfo).length && !withdrawInfo.isLoading;
      var templateTypes = [{ value: '', label: 'Select an option' }].concat(_toConsumableArray(withdrawInfo.templateTypes.map(function (template) {
        return {
          value: template.TemplateName,
          label: template.TemplateName
        };
      })));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          onSubmit: handleSubmit(this.doSubmit),
          className: slidePaneClasses('body') },
        withdrawInfo.withdrawStatus.success ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('success') },
          this.context.t('Your withdraw ticket was created successfully.')
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('form-body') },
          withdrawInfo.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('error-text') },
            this.context.t(withdrawInfo.error)
          ),
          withdrawInfo.isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Spinner_Spinner__["a" /* default */], { customClass: baseClasses }),
          showTemplateTypeSelect && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.context.t('Select an option to continue the withdraw process')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APSelect__["b" /* default */], {
              name: 'TemplateType',
              customClass: baseClasses(),
              label: this.context.t('Options for withdraw'),
              onSelect: function onSelect(value) {
                return selectWithdrawTemplate(product.ProductId, value);
              },
              options: templateTypes
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__WithdrawTemplateForm_WithdrawTemplateFormContainer__["a" /* default */],
            {
              submitting: submitting,
              invalid: invalid,
              baseClasses: baseClasses,
              balance: balance,
              onAmountChange: this.onAmountChange,
              errorMessage: errorMessage },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('section') },
              product && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
                  label: this.context.t('Balance:'),
                  text: balanceText,
                  dataTest: 'Balance:',
                  customClass: baseClasses()
                }),
                !hideFees && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
                  label: this.context.t('Fee:'),
                  text: feeText,
                  dataTest: 'Fee:',
                  customClass: baseClasses()
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
                  label: this.context.t('Total:'),
                  text: totalText,
                  dataTest: 'Total:',
                  customClass: baseClasses()
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
                  label: this.context.t('Received:'),
                  text: receivedText,
                  dataTest: 'Received:',
                  customClass: baseClasses()
                })
              )
            )
          )
        )
      );
    }
  }]);

  return WithdrawFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WithdrawFormComponent.defaultProps = {
  withdrawInfo: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    TemplateForm: {},
    withdrawStatus: {},
    getWithdrawFee: function getWithdrawFee() {}
  }
};

WithdrawFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getWithdrawFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectWithdrawProduct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  products: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    Product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ProductId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  })).isRequired,
  withdrawInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    templateInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    TemplateForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
    withdrawStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      success: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      RequestCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }).isRequired
  }),
  VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

WithdrawFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (WithdrawFormComponent);

/***/ }),
/* 2451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WithdrawTemplateFormComponent__ = __webpack_require__(2452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_depositWithdrawalSelectors__ = __webpack_require__(91);





var mapStateToProps = function mapStateToProps(state, _ref) {
  var submitting = _ref.submitting,
      invalid = _ref.invalid,
      onAmountChange = _ref.onAmountChange,
      baseClasses = _ref.baseClasses,
      errorMessage = _ref.errorMessage;
  return {
    template: state.withdraw.template,
    withdrawWorkflowInfo: state.withdraw.withdrawWorkflowInfo,
    product: Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_depositWithdrawalSelectors__["f" /* withdrawProductSelector */])(state),
    onAmountChange: onAmountChange,
    submitting: submitting,
    invalid: invalid,
    baseClasses: baseClasses,
    errorMessage: errorMessage
  };
};

var mapDispatchToProps = { change: __WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */] };

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__WithdrawTemplateFormComponent__["a" /* default */]));

/***/ }),
/* 2452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_formTemplateHelper__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WithdrawWorkflows_WithdrawWorkflowsContainer__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APNumberInput__ = __webpack_require__(59);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var WithdrawTemplateFormComponent = function (_React$Component) {
  _inherits(WithdrawTemplateFormComponent, _React$Component);

  function WithdrawTemplateFormComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithdrawTemplateFormComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithdrawTemplateFormComponent.__proto__ || Object.getPrototypeOf(WithdrawTemplateFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onMaxClick = function () {
      var _this$props = _this.props,
          onAmountChange = _this$props.onAmountChange,
          change = _this$props.change,
          balance = _this$props.balance;

      change('createWithdraw', 'Amount', balance);
      onAmountChange(balance);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithdrawTemplateFormComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          product = _props.product,
          _props$product = _props.product,
          Product = _props$product.Product,
          ProductId = _props$product.ProductId,
          DecimalPlaces = _props$product.DecimalPlaces,
          withdrawWorkflowInfo = _props.withdrawWorkflowInfo,
          submitting = _props.submitting,
          invalid = _props.invalid,
          baseClasses = _props.baseClasses,
          onAmountChange = _props.onAmountChange,
          children = _props.children,
          errorMessage = _props.errorMessage,
          disableWithdraw = _props.disableWithdraw,
          VerificationRequiredComponent = _props.VerificationRequiredComponent;

      var useExternalWorkflow = withdrawWorkflowInfo && Object.values(withdrawWorkflowInfo).length;

      var template = Object.assign({}, this.props.template);

      if ('ExternalAddress' in template) {
        // Has to be a new object adding/modifying a prop causes infinite renders AW-515
        template = Object.assign({ ExternalAddress: Product }, this.props.template);
      }

      return Object.keys(template).length && ProductId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: baseClasses('wrapper') },
          !template.hasOwnProperty('Amount') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('amount-with-btn') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APNumberInput__["a" /* default */], {
              type: 'text',
              key: 'Amount',
              name: 'Amount',
              'data-test': 'Amount',
              label: this.context.t('Amount'),
              customClass: baseClasses(),
              decimalPlaces: DecimalPlaces,
              customChange: function customChange(value) {
                return onAmountChange(+value);
              },
              validate: [__WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["p" /* required */], __WEBPACK_IMPORTED_MODULE_3__helpers_formValidations__["c" /* biggerThanZero */]]
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__common_APButton__["a" /* default */],
              {
                customClass: baseClasses('max'),
                type: 'button',
                styleName: 'additive',
                onClick: this.onMaxClick },
              this.context.t('Max')
            )
          ),
          errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('error-message') },
            errorMessage
          ),
          !useExternalWorkflow && Object(__WEBPACK_IMPORTED_MODULE_2__helpers_formTemplateHelper__["b" /* templateFormRenderer */])(template, baseClasses(''), this.context, product)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__WithdrawWorkflows_WithdrawWorkflowsContainer__["a" /* default */], null),
        !useExternalWorkflow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          children,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('section') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__common_APButton__["a" /* default */],
              {
                customClass: baseClasses(),
                type: 'submit',
                disabled: submitting || invalid || disableWithdraw,
                styleName: 'subtractive' },
              submitting ? this.context.t('Submitting...') : this.context.t('Place Withdraw Ticket')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('verification-required-text') },
              VerificationRequiredComponent
            )
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
    }
  }]);

  return WithdrawTemplateFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WithdrawTemplateFormComponent.defaultProps = {
  template: {},
  product: {},
  submitting: false,
  baseClasses: function baseClasses() {},
  onAmountChange: function onAmountChange() {},
  VerificationRequiredComponent: null
};

WithdrawTemplateFormComponent.propTypes = {
  template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    Product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    ProductId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    DecimalPlaces: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  baseClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onAmountChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  VerificationRequiredComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

WithdrawTemplateFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (WithdrawTemplateFormComponent);

/***/ }),
/* 2453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentProcessors_TrustpayWithdrawWorkflowContainer__ = __webpack_require__(2454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentProcessors_HyphenWithdrawWorkflowContainer__ = __webpack_require__(2456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Retail_RetailSidePanes_FiatWithdraw_BankSelect_BankSelectContainer__ = __webpack_require__(2458);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var WithdrawWorkflowsComponent = function (_React$Component) {
  _inherits(WithdrawWorkflowsComponent, _React$Component);

  function WithdrawWorkflowsComponent() {
    _classCallCheck(this, WithdrawWorkflowsComponent);

    return _possibleConstructorReturn(this, (WithdrawWorkflowsComponent.__proto__ || Object.getPrototypeOf(WithdrawWorkflowsComponent)).apply(this, arguments));
  }

  _createClass(WithdrawWorkflowsComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          templateType = _props.templateType,
          loading = _props.loading;

      var WorkflowComponent = null;

      switch (templateType) {
        case 'TrustPay':
          {
            WorkflowComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PaymentProcessors_TrustpayWithdrawWorkflowContainer__["a" /* default */], null);
            break;
          }
        case 'Hyphen':
          {
            WorkflowComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PaymentProcessors_HyphenWithdrawWorkflowContainer__["a" /* default */], null);
            break;
          }
        case 'EOTC':
          {
            WorkflowComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Retail_RetailSidePanes_FiatWithdraw_BankSelect_BankSelectContainer__["a" /* default */], null);
            break;
          }
        default:
          {
            break;
          }
      }
      return !loading ? WorkflowComponent : null;
    }
  }]);

  return WithdrawWorkflowsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

WithdrawWorkflowsComponent.propTypes = {
  templateType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (WithdrawWorkflowsComponent);

/***/ }),
/* 2454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrustpayWithdrawWorkflowComponent__ = __webpack_require__(2455);



var mapStateToProps = function mapStateToProps(state) {
  return {
    url: state.withdraw.withdrawWorkflowInfo && state.withdraw.withdrawWorkflowInfo.URL
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__TrustpayWithdrawWorkflowComponent__["a" /* default */]));

/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_scriptLoader__ = __webpack_require__(372);
/* eslint-disable no-restricted-globals */





var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('withdraw-form');

var TrustpayWithdrawWorkflowComponent = function TrustpayWithdrawWorkflowComponent(_ref) {
  var url = _ref.url;

  if (url) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('trustpay-form') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', {
        action: location.href,
        className: 'paymentWidgets',
        'data-brands': 'VISA MASTER AMEX'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_scriptLoader__["a" /* default */], { url: url })
    );
  }
  return null;
};

TrustpayWithdrawWorkflowComponent.defaultProps = {
  url: ''
};

TrustpayWithdrawWorkflowComponent.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (TrustpayWithdrawWorkflowComponent);

/***/ }),
/* 2456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_withdrawActions__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HyphenWithdrawWorkflowComponent__ = __webpack_require__(2457);




var mapStateToProps = function mapStateToProps(state) {
  return {
    template: state.withdraw.template,
    productId: state.withdraw.product,
    templateType: state.withdraw.templateType
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getBankInfoForm: function getBankInfoForm(productId, templateType) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_withdrawActions__["n" /* fetchProductWithdrawTemplate */])(productId, templateType, {
        UpdateBankData: true
      }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__HyphenWithdrawWorkflowComponent__["a" /* default */]));

/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HyphenWithdrawWorkflowComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APButton__ = __webpack_require__(10);




var HyphenWithdrawWorkflowComponent = function HyphenWithdrawWorkflowComponent(_ref, context) {
  var productId = _ref.productId,
      templateType = _ref.templateType,
      _ref$template = _ref.template,
      template = _ref$template === undefined ? {} : _ref$template,
      getBankInfoForm = _ref.getBankInfoForm;
  return !Object.keys(template).includes('BankAccountNumber') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_APButton__["a" /* default */],
    {
      onClick: function onClick() {
        return getBankInfoForm(productId, templateType);
      },
      styleName: 'additive' },
    context.t('Edit banking information')
  ) : null;
};

HyphenWithdrawWorkflowComponent.propTypes = {
  productId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  templateType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  getBankInfoForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

HyphenWithdrawWorkflowComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (HyphenWithdrawWorkflowComponent);

/***/ }),
/* 2458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BankSelectComponent__ = __webpack_require__(2459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_eotcWithdrawActions__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(5);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var mapStateToProps = function mapStateToProps(state) {
  var options = [{
    value: 'default',
    label: 'Not selected'
  }].concat(_toConsumableArray(state.eotcWithdraw.withdrawInfos.map(function (opt) {
    return {
      value: opt.AccountWithdrawInfoId,
      label: opt.Name + ' - *' + opt.AccountIdentifier
    };
  })));

  return {
    isLoading: state.eotcWithdraw.isLoading,
    options: options
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetBankField: function resetBankField(bank) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* change */])('createFiatWithdraw', 'Bank', bank));
    },
    onSelect: function onSelect(bank) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_eotcWithdrawActions__["e" /* selectWithdrawBank */])(bank));
    },
    fetchAccountWithdrawInfos: function fetchAccountWithdrawInfos() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_eotcWithdrawActions__["d" /* fetchAccountWithdrawInfos */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__BankSelectComponent__["a" /* default */]));

/***/ }),
/* 2459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect_APSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('retail-withdraw-form');

var BankSelect = function (_React$Component) {
  _inherits(BankSelect, _React$Component);

  function BankSelect() {
    _classCallCheck(this, BankSelect);

    return _possibleConstructorReturn(this, (BankSelect.__proto__ || Object.getPrototypeOf(BankSelect)).apply(this, arguments));
  }

  _createClass(BankSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchAccountWithdrawInfos();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isLoading && !this.props.isLoading) {
        if (this.props.options.length === 2) {
          var AccountWithdrawInfoId = this.props.options[1].value;

          this.props.resetBankField(AccountWithdrawInfoId);
          this.props.onSelect(AccountWithdrawInfoId);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect_APSelect__["b" /* default */], {
        name: 'Bank',
        customClass: baseClasses(),
        label: this.context.t('Bank'),
        onSelect: function onSelect(bank) {
          return _this2.props.onSelect(bank);
        },
        options: this.props.options
      });
    }
  }]);

  return BankSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BankSelect.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
BankSelect.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BankSelect);

/***/ }),
/* 2460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_withdrawHelper__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiatWithdraw__ = __webpack_require__(2462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FiatDeposit__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FiatSidePaneHeaderComponent__ = __webpack_require__(2470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiatFormTabsComponent__ = __webpack_require__(2472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiatSidePaneComponent_css__ = __webpack_require__(2474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiatSidePaneComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FiatSidePaneComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var fiatSidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-sidepane');

var FiatSidePaneComponent = function (_React$Component) {
  _inherits(FiatSidePaneComponent, _React$Component);

  function FiatSidePaneComponent(props) {
    _classCallCheck(this, FiatSidePaneComponent);

    var _this = _possibleConstructorReturn(this, (FiatSidePaneComponent.__proto__ || Object.getPrototypeOf(FiatSidePaneComponent)).call(this, props));

    _this.onTabChange = function () {
      _this.setState({
        isSend: !_this.state.isSend,
        data: {}
      });
    };

    _this.onUpdate = function () {
      _this.getWithdrawFee();
      _this.setTotal();
    };

    _this.setTotal = function () {
      var _this$props = _this.props,
          position = _this$props.position,
          fee = _this$props.fee;
      var Amount = _this.state.data.Amount;

      var amount = parseFloat(Amount);
      var balance = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_withdrawHelper__["a" /* getAvailableBalance */])(position.Amount, position.Hold);
      var total = 0;

      if (amount) {
        total = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_withdrawHelper__["b" /* getFinalBalanceWithdrawValue */])(balance, amount, fee);
      }

      _this.setState({ total: total });
    };

    _this.getWithdrawFee = function () {
      var _this$props2 = _this.props,
          ProductId = _this$props2.product.ProductId,
          getWithdrawFee = _this$props2.getWithdrawFee;
      var Amount = _this.state.data.Amount;


      if (!isNaN(Amount)) {
        getWithdrawFee(ProductId, Amount);
      }
    };

    _this.onDataUpdate = function (data) {
      var _this$state = _this.state,
          Amount = _this$state.data.Amount,
          isSend = _this$state.isSend;

      _this.setState({ data: data }, function () {
        if (!isSend && data.Amount !== Amount) {
          _this.onUpdate();
        }
      });
    };

    _this.renderInstructions = function (modificator) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: fiatSidePaneClasses('side-details', modificator) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          {
            className: fiatSidePaneClasses('instructions-header', modificator) },
          _this.context.t('Instructions')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          {
            className: fiatSidePaneClasses('address-instructions', modificator) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            _this.context.t('Step 1: Create the deposit ticket.')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            _this.context.t('Step 2: Process deposit instructions on the deposit receipt.')
          )
        )
      );
    };

    _this.state = {
      isSend: props.isSend,
      data: {},
      openConfirmModal: false
    };
    return _this;
  }

  _createClass(FiatSidePaneComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        customClass: this.props.showDetails ? 'retail-sidepane-with-details' : 'retail-sidepane',
        classModifiers: 'with-tabs',
        hideHeader: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          TicketAmount = _props.TicketAmount,
          product = _props.product,
          position = _props.position,
          fee = _props.fee,
          showDetails = _props.showDetails,
          productConfig = _props.productConfig,
          withdrawDetailsInfo = _props.withdrawDetailsInfo,
          isDepositDisabled = _props.isDepositDisabled,
          isWithdrawDisabled = _props.isWithdrawDisabled;
      var _state = this.state,
          isSend = _state.isSend,
          data = _state.data,
          total = _state.total;

      var balance = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_withdrawHelper__["a" /* getAvailableBalance */])(position.Amount, position.Hold);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: fiatSidePaneClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: fiatSidePaneClasses('main') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FiatSidePaneHeaderComponent__["a" /* default */], { product: product }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            { className: fiatSidePaneClasses('main-form') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiatFormTabsComponent__["a" /* default */], {
              isSend: isSend,
              toggleTab: this.onTabChange,
              product: product,
              balance: balance,
              isDepositDisabled: isDepositDisabled,
              isWithdrawDisabled: isWithdrawDisabled
            }),
            isSend ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FiatDeposit__["c" /* FiatDepositFormContainer */], {
              product: product,
              onChange: this.onDataUpdate
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiatWithdraw__["b" /* FiatWithdrawFormContainer */], {
              product: product,
              balance: balance,
              fee: fee,
              total: total,
              onChange: this.onDataUpdate,
              showDetails: showDetails
            })
          ),
          isSend && !showDetails ? this.renderInstructions('no-details') : null
        ),
        showDetails && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: fiatSidePaneClasses('side') },
          isSend ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FiatDeposit__["b" /* FiatDepositDetailsComponent */], { info: productConfig.instructions }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiatWithdraw__["a" /* FiatWithdrawDetailsComponent */], {
            TicketAmount: TicketAmount,
            data: data,
            fee: fee,
            product: product,
            balance: balance,
            detailsInfo: withdrawDetailsInfo
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FiatDeposit__["d" /* FiatDepositModalContainer */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiatWithdraw__["c" /* FiatWithdrawModalContainer */], null)
      );
    }
  }]);

  return FiatSidePaneComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiatSidePaneComponent.defaultProps = {
  showDetails: true,
  onSidePaneOpen: function onSidePaneOpen() {},
  isSend: true
};

FiatSidePaneComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatSidePaneComponent);

/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FiatWithdrawFormContainer__ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FiatWithdrawModalContainer__ = __webpack_require__(2466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiatWithdrawDetailsComponent__ = __webpack_require__(2469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__FiatWithdrawFormContainer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__FiatWithdrawModalContainer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FiatWithdrawDetailsComponent__["a"]; });






/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiatWithdrawFormComponent__ = __webpack_require__(2464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_withdrawActions__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_selectors_kycLevelsSelectors__ = __webpack_require__(53);








var mapStateToProps = function mapStateToProps(state) {
  var _kycVerificationLevel = Object(__WEBPACK_IMPORTED_MODULE_6__redux_selectors_kycLevelsSelectors__["b" /* kycVerificationLevelsSelector */])(state),
      disableWithdraw = _kycVerificationLevel.disableWithdraw;

  return {
    disableWithdraw: disableWithdraw,
    withdrawInfo: state.withdraw,
    products: state.apexCore.product
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    verificationOnClick: function verificationOnClick() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_sidePaneActions__["j" /* closeSidePane */])());
    },
    confirmWithdraw: function confirmWithdraw(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_withdrawActions__["m" /* createWithdrawTicket */])(payload));
    },
    selectWithdrawProduct: function selectWithdrawProduct(productId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_withdrawActions__["o" /* fetchProductWithdrawTemplates */])(productId));
    },
    selectWithdrawTemplate: function selectWithdrawTemplate(productId, templateType) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_withdrawActions__["n" /* fetchProductWithdrawTemplate */])(productId, templateType));
    }
  };
};

var FiatWithdrawForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'createFiatWithdraw',
  onSubmit: function onSubmit(payload, dispatch, _ref) {
    var fee = _ref.fee,
        template = _ref.withdrawInfo.template;

    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__["e" /* openModal */])(__WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_FIAT_WITHDRAW, { payload: payload, fee: fee, template: template }));
  }
})(__WEBPACK_IMPORTED_MODULE_2__FiatWithdrawFormComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(FiatWithdrawForm));

/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_formTemplateHelper__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_withdrawHelper__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WithdrawSidePaneComponents_WithdrawWorkflows_WithdrawWorkflowsContainer__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VerificationRequired_VerificationRequiredContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_APNumberInput__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FiatWithdrawFormComponent_css__ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FiatWithdrawFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__FiatWithdrawFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-withdraw-form');
var slidePaneClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-slide-pane');

var FiatWithdrawFormComponent = function (_React$Component) {
  _inherits(FiatWithdrawFormComponent, _React$Component);

  function FiatWithdrawFormComponent() {
    _classCallCheck(this, FiatWithdrawFormComponent);

    return _possibleConstructorReturn(this, (FiatWithdrawFormComponent.__proto__ || Object.getPrototypeOf(FiatWithdrawFormComponent)).apply(this, arguments));
  }

  _createClass(FiatWithdrawFormComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          product = _props.product,
          selectWithdrawProduct = _props.selectWithdrawProduct;

      selectWithdrawProduct(product.ProductId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.initialize(Object.assign({}, this.props.product));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          handleSubmit = _props2.handleSubmit,
          disableWithdraw = _props2.disableWithdraw,
          withdrawInfo = _props2.withdrawInfo,
          _props2$withdrawInfo = _props2.withdrawInfo,
          withdrawWorkflowInfo = _props2$withdrawInfo.withdrawWorkflowInfo,
          template = _props2$withdrawInfo.template,
          templateTypes = _props2$withdrawInfo.templateTypes,
          isLoading = _props2$withdrawInfo.isLoading,
          error = _props2$withdrawInfo.error,
          product = _props2.product,
          _props2$product = _props2.product,
          ProductSymbol = _props2$product.ProductSymbol,
          ProductId = _props2$product.ProductId,
          balance = _props2.balance,
          fee = _props2.fee,
          total = _props2.total,
          showDetails = _props2.showDetails,
          verificationOnClick = _props2.verificationOnClick,
          selectWithdrawTemplate = _props2.selectWithdrawTemplate;

      var showTemplateTypeSelect = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_withdrawHelper__["e" /* showTemplateSelect */])(withdrawInfo);
      var useExternalWithdrawWorkflow = withdrawWorkflowInfo && Object.values(withdrawWorkflowInfo).length;
      var templateTypeOptions = [{ value: '', label: 'Select an option' }].concat(_toConsumableArray(templateTypes.map(function (template) {
        return {
          value: template.TemplateName,
          label: template.TemplateName
        };
      })));
      var DecimalPlaces = this.props.products.DecimalPlaces;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__WithdrawSidePaneComponents_WithdrawWorkflows_WithdrawWorkflowsContainer__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          {
            className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(slidePaneClasses('body'), baseClasses('body')),
            onSubmit: handleSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: baseClasses('form-body') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('frame-container') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: baseClasses('frame') },
                disableWithdraw ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__VerificationRequired_VerificationRequiredContainer__["a" /* default */], {
                  disabled: disableWithdraw,
                  onClick: verificationOnClick
                }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  showTemplateTypeSelect && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_APSelect__["b" /* default */], {
                    name: 'TemplateType',
                    customClass: baseClasses(),
                    label: this.context.t('Select an option to continue the withdraw process'),
                    onSelect: function onSelect(value) {
                      return selectWithdrawTemplate(ProductId, value);
                    },
                    options: templateTypeOptions
                  }),
                  !showTemplateTypeSelect && !template.hasOwnProperty('Amount') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_APNumberInput__["a" /* default */], {
                    type: 'text',
                    name: 'Amount',
                    labelInInput: ProductSymbol,
                    label: this.context.t('Amount of ' + ProductSymbol + ' to Withdraw'),
                    decimalPlaces: DecimalPlaces,
                    customClass: baseClasses(),
                    validate: [__WEBPACK_IMPORTED_MODULE_4__helpers_formValidations__["p" /* required */], __WEBPACK_IMPORTED_MODULE_4__helpers_formValidations__["c" /* biggerThanZero */]]
                  }),
                  !useExternalWithdrawWorkflow && Object(__WEBPACK_IMPORTED_MODULE_3__helpers_formTemplateHelper__["b" /* templateFormRenderer */])(template, baseClasses(''), this.context, product),
                  !showDetails ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: baseClasses('info-items') },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_APLabelWithText__["a" /* default */], {
                      label: this.context.t('Current Balance:'),
                      text: balance + ' ' + ProductSymbol,
                      customClass: baseClasses()
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_APLabelWithText__["a" /* default */], {
                      label: this.context.t('Transaction Fee:'),
                      text: fee !== undefined ? fee : '-',
                      customClass: baseClasses()
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_APLabelWithText__["a" /* default */], {
                      label: this.context.t('Final Balance:'),
                      text: total !== undefined ? total : '-',
                      customClass: baseClasses()
                    })
                  ) : null,
                  error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: baseClasses('error') },
                    this.context.t(error)
                  ),
                  isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Spinner_Spinner__["a" /* default */], { customClass: baseClasses })
                )
              )
            ),
            !showTemplateTypeSelect && !disableWithdraw && !useExternalWithdrawWorkflow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('footer') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__common_APButton__["a" /* default */],
                {
                  customClass: baseClasses(),
                  disabled: disableWithdraw,
                  type: 'submit',
                  styleName: 'additive' },
                this.context.t('Withdraw'),
                ' ',
                ProductSymbol
              )
            )
          )
        )
      );
    }
  }]);

  return FiatWithdrawFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiatWithdrawFormComponent.defaultProps = {
  withdrawInfo: {
    template: {},
    isLoading: false,
    error: '',
    withdrawWorkflowInfo: [],
    withdrawStatus: {}
  }
};

FiatWithdrawFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSnack: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  withdrawInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    withdrawWorkflowInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    withdrawStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      success: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
      RequestCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }).isRequired
  }),
  disableWithdraw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  verificationOnClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

FiatWithdrawFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatWithdrawFormComponent);

/***/ }),
/* 2465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FiatWithdrawModalComponent__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_withdrawActions__ = __webpack_require__(78);






var mapStateToProps = function mapStateToProps(state) {
  return {
    products: state.apexCore.product
  };
};

var mapDispatchToProps = {
  submitWithdraw: __WEBPACK_IMPORTED_MODULE_4__redux_actions_withdrawActions__["m" /* createWithdrawTicket */]
};

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__FiatWithdrawModalComponent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_3__redux_actions_modalActions__["b" /* MODAL_TYPES */].CONFIRM_FIAT_WITHDRAW
})(container));

/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_formTemplateHelper__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiatWithdrawModalComponent_css__ = __webpack_require__(2468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiatWithdrawModalComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FiatWithdrawModalComponent_css__);











var fiatWithdrawModalClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-withdraw-modal');

var FiatWithdrawModalComponent = function FiatWithdrawModalComponent(props, context) {
  var template = props.template,
      payload = props.payload;
  var ProductSymbol = payload.ProductSymbol,
      ProductFullName = payload.ProductFullName,
      Amount = payload.Amount;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: props.isOpen,
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: fiatWithdrawModalClasses('header-content') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon__["a" /* default */], {
          name: 'withdrawWithBorder',
          customClass: fiatWithdrawModalClasses('icon')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: fiatWithdrawModalClasses('header-title') },
          context.t('Withdraw') + ' ' + ProductSymbol + ' ' + ProductFullName
        )
      ),
      close: props.close,
      footer: {
        buttonText: context.t('Confirm'),
        buttonStyle: 'additive',
        onClick: function onClick() {
          return props.submitWithdraw(props.payload);
        }
      },
      customClass: fiatWithdrawModalClasses() },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: fiatWithdrawModalClasses('title') },
      context.t('Confirmation')
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: fiatWithdrawModalClasses() },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Amount to Withdraw'),
        text: Amount + ' ' + ProductSymbol,
        customClass: fiatWithdrawModalClasses()
      }),
      Object(__WEBPACK_IMPORTED_MODULE_7__helpers_formTemplateHelper__["a" /* templateConfirmRenderer */])(template, payload, fiatWithdrawModalClasses, context),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Fee'),
        text: props.fee,
        customClass: fiatWithdrawModalClasses()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APLabelWithText__["a" /* default */], {
        label: context.t('Time'),
        text: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_dateHelper__["c" /* formatDateTime */])(new Date()),
        customClass: fiatWithdrawModalClasses()
      })
    )
  );
};

FiatWithdrawModalComponent.propTypes = {
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

FiatWithdrawModalComponent.defaultProps = {
  payload: {
    FullName: '',
    Amount: '',
    BankAccountName: '',
    BankAccountNumber: '',
    BankAddress: '',
    Comment: ''
  }
};

FiatWithdrawModalComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatWithdrawModalComponent);

/***/ }),
/* 2468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_SidePaneDetailsComponent_SidePaneDetailsComponent__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var FiatWithdrawDetailsComponent = function (_React$Component) {
  _inherits(FiatWithdrawDetailsComponent, _React$Component);

  function FiatWithdrawDetailsComponent() {
    _classCallCheck(this, FiatWithdrawDetailsComponent);

    return _possibleConstructorReturn(this, (FiatWithdrawDetailsComponent.__proto__ || Object.getPrototypeOf(FiatWithdrawDetailsComponent)).apply(this, arguments));
  }

  _createClass(FiatWithdrawDetailsComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Amount = _props.data.Amount,
          ProductSymbol = _props.product.ProductSymbol,
          balance = _props.balance,
          fee = _props.fee,
          detailsInfo = _props.detailsInfo,
          TicketAmount = _props.TicketAmount;
      var getItem = __WEBPACK_IMPORTED_MODULE_2__common_SidePaneDetailsComponent_SidePaneDetailsComponent__["a" /* default */].getItem;

      var currentBalance = balance ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(balance, ProductSymbol) + ' ' + ProductSymbol : '-';
      var amount = TicketAmount ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(TicketAmount, ProductSymbol) + ' ' + ProductSymbol : '-';

      /**
       * TicketAmount = `GetWithdrawFee`.TicketAmount.
       *  If (Gateway.`DeductWithdrawFee` = true), fee is already deducted.
       */
      var remainingBalance = balance && Amount ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(balance - (TicketAmount + fee), ProductSymbol) + ' ' + ProductSymbol : '-';
      var items = [getItem(this.context.t('Your current {ProductSymbol} Balance', {
        ProductSymbol: ProductSymbol
      }), currentBalance), getItem(this.context.t('Amount to Withdraw'), amount), {
        label: this.context.t('Fee'),
        text: fee ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_numberFormatter__["b" /* formatNumberToLocale */])(fee, ProductSymbol) + ' ' + ProductSymbol : '-'
      }, getItem(this.context.t('Remaining Balance'), remainingBalance)];

      var info = detailsInfo.map(function (item) {
        if (item.useLink) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: item.linkAddress },
            _this2.context.t('{text}', { text: item.text })
          );
        } else {
          return _this2.context.t('{text}', { text: item.text });
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_SidePaneDetailsComponent_SidePaneDetailsComponent__["a" /* default */], {
        title: this.context.t('Balances'),
        items: items,
        info: info,
        classModifiers: 'withdraw'
      });
    }
  }]);

  return FiatWithdrawDetailsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiatWithdrawDetailsComponent.propTypes = {
  FullName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  Amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  BankAccountName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  BankAccountNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  BankAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  Comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

FiatWithdrawDetailsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatWithdrawDetailsComponent);

/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiatSidePaneHeaderComponent_css__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiatSidePaneHeaderComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FiatSidePaneHeaderComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-sidepane-header');

var FiatSidePaneHeaderComponent = function (_React$Component) {
  _inherits(FiatSidePaneHeaderComponent, _React$Component);

  function FiatSidePaneHeaderComponent() {
    _classCallCheck(this, FiatSidePaneHeaderComponent);

    return _possibleConstructorReturn(this, (FiatSidePaneHeaderComponent.__proto__ || Object.getPrototypeOf(FiatSidePaneHeaderComponent)).apply(this, arguments));
  }

  _createClass(FiatSidePaneHeaderComponent, [{
    key: 'render',
    value: function render() {
      var _props$product = this.props.product,
          iconFileName = _props$product.iconFileName,
          ProductFullName = _props$product.ProductFullName,
          ProductSymbol = _props$product.ProductSymbol;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_ProductIcon_ProductIconContainer__["a" /* default */], {
          iconFileName: iconFileName,
          customClass: bemClasses('logo')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: bemClasses('title') },
          ProductSymbol,
          ' ',
          ProductFullName
        )
      );
    }
  }]);

  return FiatSidePaneHeaderComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiatSidePaneHeaderComponent.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (FiatSidePaneHeaderComponent);

/***/ }),
/* 2471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiatFormTabsComponent_css__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiatFormTabsComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FiatFormTabsComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('fiat-tabs');

var FiatFormTabsComponent = function (_React$Component) {
  _inherits(FiatFormTabsComponent, _React$Component);

  function FiatFormTabsComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FiatFormTabsComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FiatFormTabsComponent.__proto__ || Object.getPrototypeOf(FiatFormTabsComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onWithdrawClick = function () {
      var _this$props = _this.props,
          isSend = _this$props.isSend,
          toggleTab = _this$props.toggleTab,
          isWithdrawDisabled = _this$props.isWithdrawDisabled;

      if (isSend && !_this.isNegativeBalance() && !isWithdrawDisabled) {
        toggleTab();
      }
    }, _this.isNegativeBalance = function () {
      return _this.props.balance < 0;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FiatFormTabsComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isSend = _props.isSend,
          toggleTab = _props.toggleTab,
          isDepositDisabled = _props.isDepositDisabled,
          isWithdrawDisabled = _props.isWithdrawDisabled;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: bemClasses() },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: bemClasses('tab', {
              selected: isSend,
              disabled: isDepositDisabled
            }),
            onClick: function onClick() {
              return !isSend && !isDepositDisabled && toggleTab();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'deposit', customClass: bemClasses('tab-icon') }),
          this.context.t('Deposit')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: bemClasses('tab', {
              selected: !isSend,
              disabled: this.isNegativeBalance() || isWithdrawDisabled
            }),
            onClick: function onClick() {
              return _this2.onWithdrawClick();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'withdraw', customClass: bemClasses('tab-icon') }),
          this.context.t('Withdraw')
        )
      );
    }
  }]);

  return FiatFormTabsComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiatFormTabsComponent.propTypes = {
  isSend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggleTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  balance: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

FiatFormTabsComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiatFormTabsComponent);

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hocs_redirectIfAuthorized__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_emailLinksHelper__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routeTemplates__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_emailLinksLayoutsConstants__ = __webpack_require__(2478);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var EmailLinksLayout = function (_React$Component) {
  _inherits(EmailLinksLayout, _React$Component);

  function EmailLinksLayout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EmailLinksLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailLinksLayout.__proto__ || Object.getPrototypeOf(EmailLinksLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      StandAloneComponent: undefined
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EmailLinksLayout, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_emailLinksHelper__["e" /* checkForVerifyEmailParam */])()) return this.setState({
        StandAloneComponent: __WEBPACK_IMPORTED_MODULE_4__constants_emailLinksLayoutsConstants__["a" /* STAND_ALONE_COMPONENTS */].VerifyEmailContainer
      });else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_emailLinksHelper__["a" /* checkForConfirmWithdrawParam */])()) return this.setState({
        StandAloneComponent: __WEBPACK_IMPORTED_MODULE_4__constants_emailLinksLayoutsConstants__["a" /* STAND_ALONE_COMPONENTS */].ConfirmWithdrawContainer
      });else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_emailLinksHelper__["d" /* checkForResetPassParam */])()) return this.setState({
        StandAloneComponent: __WEBPACK_IMPORTED_MODULE_4__constants_emailLinksLayoutsConstants__["a" /* STAND_ALONE_COMPONENTS */].ResetPasswordNoAuthFormContainer
      });else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_emailLinksHelper__["b" /* checkForDepositConfirmationParam */])()) return this.setState({
        StandAloneComponent: __WEBPACK_IMPORTED_MODULE_4__constants_emailLinksLayoutsConstants__["a" /* STAND_ALONE_COMPONENTS */].DepositConfirmationContainer
      });else if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers_emailLinksHelper__["c" /* checkForLoginParam */])()) return this.setState({
        StandAloneComponent: __WEBPACK_IMPORTED_MODULE_4__constants_emailLinksLayoutsConstants__["a" /* STAND_ALONE_COMPONENTS */].StandaloneLoginContainer
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var StandAloneComponent = this.state.StandAloneComponent;

      return StandAloneComponent ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StandAloneComponent, null) : null;
    }
  }]);

  return EmailLinksLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__hocs_redirectIfAuthorized__["a" /* default */])(EmailLinksLayout, __WEBPACK_IMPORTED_MODULE_3__routeTemplates__["b" /* defaultPath */].path));

/***/ }),
/* 2478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STAND_ALONE_COMPONENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VerifyEmail_VerifyEmailContainer__ = __webpack_require__(2479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResetPasswordForm_ResetPasswordFormContainer__ = __webpack_require__(2481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ConfirmWithdraw_ConfirmWithdrawContainer__ = __webpack_require__(2485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DepositConfirmation_DepositConfirmationModalContainer__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_StandaloneLoginFormContainer__ = __webpack_require__(843);






var STAND_ALONE_COMPONENTS = {
  VerifyEmailContainer: __WEBPACK_IMPORTED_MODULE_0__components_VerifyEmail_VerifyEmailContainer__["a" /* default */],
  ResetPasswordNoAuthFormContainer: __WEBPACK_IMPORTED_MODULE_1__components_ResetPasswordForm_ResetPasswordFormContainer__["a" /* default */],
  ConfirmWithdrawContainer: __WEBPACK_IMPORTED_MODULE_2__components_ConfirmWithdraw_ConfirmWithdrawContainer__["a" /* default */],
  DepositConfirmationContainer: __WEBPACK_IMPORTED_MODULE_3__components_DepositConfirmation_DepositConfirmationModalContainer__["a" /* default */],
  StandaloneLoginContainer: __WEBPACK_IMPORTED_MODULE_4__components_Login_StandaloneLoginFormContainer__["a" /* default */]
};

/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VerifyEmailComponent__ = __webpack_require__(2480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_verifyEmailActions__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_queryParamsHelper__ = __webpack_require__(176);





var mapStateToProps = function mapStateToProps(state) {
  var processingVerifyEmail = state.apiProcessing.processingVerifyEmail,
      _state$verifyEmail = state.verifyEmail,
      message = _state$verifyEmail.message,
      error = _state$verifyEmail.error;

  return {
    processingVerifyEmail: processingVerifyEmail,
    message: message,
    error: error
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var d1 = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_queryParamsHelper__["a" /* getQueryParam */])('d1');
  var userid = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_queryParamsHelper__["a" /* getQueryParam */])('UserId');
  var verifycode = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_queryParamsHelper__["a" /* getQueryParam */])('verifycode');
  return {
    fetchConfirmEmail: function fetchConfirmEmail() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_verifyEmailActions__["c" /* fetchConfirmEmail */])({ verifycode: verifycode, userid: userid, d1: d1 }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__VerifyEmailComponent__["a" /* default */]));

/***/ }),
/* 2480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APLogo_APLogo__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_common_StandaloneModal_css__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_components_common_StandaloneModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_components_common_StandaloneModal_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-modal');

var VerifyEmailComponent = function (_React$Component) {
  _inherits(VerifyEmailComponent, _React$Component);

  function VerifyEmailComponent() {
    _classCallCheck(this, VerifyEmailComponent);

    return _possibleConstructorReturn(this, (VerifyEmailComponent.__proto__ || Object.getPrototypeOf(VerifyEmailComponent)).apply(this, arguments));
  }

  _createClass(VerifyEmailComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchConfirmEmail();
    }
  }, {
    key: 'render',
    value: function render() {
      var context = this.context,
          _props = this.props,
          processingVerifyEmail = _props.processingVerifyEmail,
          message = _props.message,
          error = _props.error;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '' + baseClasses('wrapper') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLogo_APLogo__["a" /* default */], { customClass: baseClasses('logo'), linkTo: '/' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '' + baseClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + baseClasses('body') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + baseClasses('body-text') },
              context.t(message)
            )
          ),
          message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + baseClasses('footer') },
              error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
                {
                  to: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_path__["a" /* default */])('/problem-logging-in'),
                  className: baseClasses('btn', 'subtractive') },
                context.t('Problem with verification?')
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
                {
                  to: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_path__["a" /* default */])('/login'),
                  className: baseClasses('btn', 'additive') },
                context.t('Login')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__["a" /* default */], {
            isVisible: processingVerifyEmail,
            text: 'Verifying your email address'
          })
        )
      );
    }
  }]);

  return VerifyEmailComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

VerifyEmailComponent.defaultProps = {
  fetchConfirmEmail: function fetchConfirmEmail() {},
  processingVerifyEmail: true,
  message: '',
  error: false
};
VerifyEmailComponent.propTypes = {
  fetchConfirmEmail: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  processingVerifyEmail: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  message: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  error: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
VerifyEmailComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (VerifyEmailComponent);

/***/ }),
/* 2481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResetPasswordFormComponent__ = __webpack_require__(2482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_resetPasswordActions__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__ = __webpack_require__(31);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var d1 = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__["a" /* getQueryParam */])('d1');
var userid = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__["a" /* getQueryParam */])('UserId');
var verifycode = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_queryParamsHelper__["a" /* getQueryParam */])('verifycode');

var ResetPasswordForm = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["j" /* reduxForm */])({
  form: 'resetPassword',
  asyncValidate: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(values, dispatch, fieldProps, blurredField) {
      var invalid;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(blurredField === 'matchingPassword')) {
                _context.next = 5;
                break;
              }

              invalid = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["h" /* matchingPassword */])(values.matchingPassword, values);

              if (!invalid) {
                _context.next = 4;
                break;
              }

              throw {
                matchingPassword: invalid
              };

            case 4:
              return _context.abrupt('return', undefined);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    function asyncValidate(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    }

    return asyncValidate;
  }(),
  asyncBlurFields: ['matchingPassword'],
  onSubmit: function onSubmit(payload, dispatch) {
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["r" /* validatePassword */])(payload.password);
    if (errorMessage) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["f" /* clearFields */])('resetPassword', false, true, 'password', 'matchingPassword'));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_resetPasswordActions__["g" /* setResetPasswordError */])({ errorMessage: errorMessage }));
    } else {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_resetPasswordActions__["f" /* fetchResetPassword */])({
        verifycode: verifycode,
        userid: userid,
        d1: d1,
        formValues: payload
      }));
    }
  }
})(__WEBPACK_IMPORTED_MODULE_2__ResetPasswordFormComponent__["a" /* default */]);

var selector = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["g" /* formValueSelector */])('resetPassword');

var mapStateToProps = function mapStateToProps(state) {
  var processingResetPassword = state.apiProcessing.processingResetPassword,
      _state$resetPassword = state.resetPassword,
      message = _state$resetPassword.message,
      fetchError = _state$resetPassword.error,
      validateError = _state$resetPassword.validateError;

  return {
    passwordValue: selector(state, 'password'),
    processingResetPassword: processingResetPassword,
    message: message,
    fetchError: fetchError,
    validateError: validateError
  };
};

var mapDispatchToProps = {
  clearResetPasswordError: __WEBPACK_IMPORTED_MODULE_3__redux_actions_resetPasswordActions__["e" /* clearResetPasswordError */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ResetPasswordForm));

/***/ }),
/* 2482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_passwordScore__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layouts_StandAloneLayout_StandAloneLayout__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_components_common_StandaloneForm_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_components_common_StandaloneForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_components_common_StandaloneForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ResetPasswordFormComponent_css__ = __webpack_require__(2484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ResetPasswordFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ResetPasswordFormComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-form');
var resetPasswordClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('reset-password');

var ResetPasswordFormComponent = function (_React$Component) {
  _inherits(ResetPasswordFormComponent, _React$Component);

  function ResetPasswordFormComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ResetPasswordFormComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResetPasswordFormComponent.__proto__ || Object.getPrototypeOf(ResetPasswordFormComponent)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function () {
      if (_this.props.validateError) {
        _this.props.clearResetPasswordError();
      }
    }, _this.getPasswordStrength = function () {
      var _this2 = _this,
          context = _this2.context;

      var score = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_passwordScore__["a" /* default */])(_this.props.passwordValue);
      var passwordStrengthValues = {
        0: context.t('Very Weak'),
        1: context.t('Weak'),
        2: context.t('Medium'),
        3: context.t('Strong'),
        4: context.t('Very Strong')
      };
      return passwordStrengthValues[score];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ResetPasswordFormComponent, [{
    key: 'render',
    value: function render() {
      var context = this.context,
          _props = this.props,
          processingResetPassword = _props.processingResetPassword,
          message = _props.message,
          handleSubmit = _props.handleSubmit,
          fetchError = _props.fetchError,
          pristine = _props.pristine,
          passwordValue = _props.passwordValue,
          invalid = _props.invalid,
          validateError = _props.validateError;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__layouts_StandAloneLayout_StandAloneLayout__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: baseClasses('container') + ' ' + resetPasswordClasses('container') },
          !message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: baseClasses('header') + ' ' + resetPasswordClasses('header') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + baseClasses('header-text') },
              context.t('Reset Your Password')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
              { to: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_path__["a" /* default */])('/'), className: baseClasses('close-icon') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon__["a" /* default */], { name: 'close', classModifiers: 'big' })
            )
          ),
          !message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: handleSubmit, className: '' + baseClasses('form') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APInput__["b" /* default */], {
              type: 'password',
              name: 'password',
              customClass: resetPasswordClasses(),
              label: context.t('New Password'),
              validate: [__WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__["p" /* required */]],
              readOnly: processingResetPassword,
              info: passwordValue && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: baseClasses('password-strength') },
                this.getPasswordStrength()
              ),
              onChange: this.handleChange
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APInput__["b" /* default */], {
              type: 'password',
              name: 'matchingPassword',
              customClass: resetPasswordClasses(),
              label: context.t('Repeat New Password'),
              readOnly: processingResetPassword,
              validate: [__WEBPACK_IMPORTED_MODULE_8__helpers_formValidations__["p" /* required */]],
              onChange: this.handleChange
            }),
            validateError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: baseClasses('password-error') },
              validateError
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: '' + resetPasswordClasses('separator') }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__common_APButton__["a" /* default */],
              {
                type: 'submit',
                disabled: pristine || processingResetPassword || invalid,
                customClass: '' + resetPasswordClasses(),
                styleName: __WEBPACK_IMPORTED_MODULE_3__propTypes_commonComponent__["b" /* styleNames */].additive },
              processingResetPassword ? context.t('Resetting your password...') : context.t('Reset Password')
            )
          ),
          message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + baseClasses('message') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: '' + baseClasses('message-text') },
                context.t(message)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + baseClasses('message-footer') },
              fetchError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
                {
                  to: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_path__["a" /* default */])('/problem-logging-in'),
                  className: baseClasses('btn', 'subtractive') },
                context.t('Problem resetting your password?')
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
                {
                  to: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_path__["a" /* default */])('/login'),
                  className: baseClasses('btn', 'additive') },
                context.t('Go to Exchange')
              )
            )
          )
        )
      );
    }
  }]);

  return ResetPasswordFormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ResetPasswordFormComponent.defaultProps = {
  handleSubmit: function handleSubmit() {},
  processingResetPassword: false,
  message: '',
  fetchError: false
};
ResetPasswordFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  processingResetPassword: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  fetchError: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
ResetPasswordFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordFormComponent);

/***/ }),
/* 2483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_confirmWithdrawActions__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_queryParamsHelper__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmWithdrawComponent__ = __webpack_require__(2486);





var mapStateToProps = function mapStateToProps(state) {
  var processingConfirmWithdraw = state.apiProcessing.processingConfirmWithdraw,
      _state$confirmWithdra = state.confirmWithdraw,
      message = _state$confirmWithdra.message,
      error = _state$confirmWithdra.error;

  return {
    processingConfirmWithdraw: processingConfirmWithdraw,
    message: message,
    error: error
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var d1 = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_queryParamsHelper__["a" /* getQueryParam */])('d1');
  var userid = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_queryParamsHelper__["a" /* getQueryParam */])('UserId');
  var verifycode = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_queryParamsHelper__["a" /* getQueryParam */])('verifycode');
  return {
    fetchConfirmWithdraw: function fetchConfirmWithdraw() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_confirmWithdrawActions__["c" /* fetchConfirmWithdraw */])({ verifycode: verifycode, userid: userid, d1: d1 }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ConfirmWithdrawComponent__["a" /* default */]));

/***/ }),
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APLogo_APLogo__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routeTemplates__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_components_common_StandaloneModal_css__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_components_common_StandaloneModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_components_common_StandaloneModal_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-modal');

var ConfirmWithdrawComponent = function (_React$Component) {
  _inherits(ConfirmWithdrawComponent, _React$Component);

  function ConfirmWithdrawComponent() {
    _classCallCheck(this, ConfirmWithdrawComponent);

    return _possibleConstructorReturn(this, (ConfirmWithdrawComponent.__proto__ || Object.getPrototypeOf(ConfirmWithdrawComponent)).apply(this, arguments));
  }

  _createClass(ConfirmWithdrawComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchConfirmWithdraw();
    }
  }, {
    key: 'render',
    value: function render() {
      var context = this.context,
          _props = this.props,
          processingConfirmWithdraw = _props.processingConfirmWithdraw,
          message = _props.message;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '' + baseClasses('wrapper') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APLogo_APLogo__["a" /* default */], { customClass: baseClasses('logo'), linkTo: '/' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '' + baseClasses('container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + baseClasses('body') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + baseClasses('body-text') },
              context.t(message)
            )
          ),
          message && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + baseClasses('footer') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
                {
                  to: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_path__["a" /* default */])('' + __WEBPACK_IMPORTED_MODULE_7__routeTemplates__["b" /* defaultPath */].path),
                  className: baseClasses('btn', 'additive') },
                context.t('Go to Exchange')
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Spinner_Spinner__["a" /* default */], {
            isVisible: processingConfirmWithdraw,
            text: 'Confirming your withdrawal'
          })
        )
      );
    }
  }]);

  return ConfirmWithdrawComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ConfirmWithdrawComponent.defaultProps = {
  fetchConfirmWithdraw: function fetchConfirmWithdraw() {},
  processingConfirmWithdraw: true,
  message: ''
};
ConfirmWithdrawComponent.propTypes = {
  fetchConfirmWithdraw: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  processingConfirmWithdraw: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  message: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
ConfirmWithdrawComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ConfirmWithdrawComponent);

/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginFormComponent__ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_wsHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__apex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_wsConnectionActions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_appActions__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_actions_lifeCycleActions__ = __webpack_require__(228);













var globalSiteName = __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].global.siteName,
    LoginForm = __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].LoginForm,
    _config$SignupForm = __WEBPACK_IMPORTED_MODULE_6__config__["b" /* default */].SignupForm,
    useEmailAsUsername = _config$SignupForm.useEmailAsUsername,
    active = _config$SignupForm.active;


var gateway = Object(__WEBPACK_IMPORTED_MODULE_7__helpers_wsHelper__["b" /* getLoginFormGateway */])();

var siteName = LoginForm && LoginForm.siteName ? LoginForm.siteName : globalSiteName;

var mapStateToProps = function mapStateToProps(state) {
  return {
    errorMsg: state.auth.errorMsg,
    isConnected: state.wsConnection.isConnected,
    useEmailAsUsername: useEmailAsUsername,
    active: active,
    siteName: siteName,
    gateway: gateway,
    formGateway: Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* formValueSelector */])('login')(state, 'gateway')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    resetForm: function resetForm() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */])('login', 'gateway', ''));
    },
    doSubmit: function doSubmit(payload, isConnected) {
      if (!isConnected || !navigator.onLine) {
        Object(__WEBPACK_IMPORTED_MODULE_8__apex__["d" /* setGateway */])(payload.gateway);
        localStorage.setItem('tradingServer', payload.gateway);
        Object(__WEBPACK_IMPORTED_MODULE_8__apex__["c" /* initApex */])(function () {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["i" /* login */])(payload)).then(function (action) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_wsConnectionActions__["f" /* connectionClosedCount */])(0));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__redux_actions_appActions__["b" /* loadStartupData */])());
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__redux_actions_lifeCycleActions__["b" /* onInit */])());

            if (action.type === __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["f" /* ENABLE_2FA_REQUIRED */]) {
              ownProps.history.push(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_path__["a" /* default */])('/enabletwofactorauth'));
            } else if (action.type === __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["a" /* AUTH_2FA_REQUIRED */]) {
              ownProps.history.push(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_path__["a" /* default */])('/twofactorauth'));
            }
          });
        }, function () {
          return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_wsConnectionActions__["e" /* connectionClosed */])());
        });
        return;
      }

      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["i" /* login */])(payload)).then(function (action) {
        if (action.type === __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["f" /* ENABLE_2FA_REQUIRED */]) {
          ownProps.history.push(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_path__["a" /* default */])('/enabletwofactorauth'));
        } else if (action.type === __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["a" /* AUTH_2FA_REQUIRED */]) {
          ownProps.history.push(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_path__["a" /* default */])('/twofactorauth'));
        }
      });
    }
  };
};

var LoginFormContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__LoginFormComponent__["a" /* default */]);

var LoginFormContainerForm = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'login',
  onSubmit: function onSubmit() {}
})(LoginFormContainer);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["g" /* withRouter */])(LoginFormContainerForm));

/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoginFormComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APInput__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APButton__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_APPasswordInput_APPasswordInput__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hocs_redirectIfAuthorized__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routeTemplates__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_path__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TradingServer_TradingServerComponent__ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_components_common_StandaloneForm_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_components_common_StandaloneForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_components_common_StandaloneForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__LoginFormComponent_css__ = __webpack_require__(2491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__LoginFormComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__LoginFormComponent_css__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




















var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_cssClassesHelper__["b" /* getBEMClasses */])('standalone-form');
var loginFormClasses = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_cssClassesHelper__["b" /* getBEMClasses */])('login-form');

var LoginFormComponent = function LoginFormComponent(props, context) {
  var handleSubmit = props.handleSubmit,
      errorMsg = props.errorMsg,
      submitting = props.submitting,
      doSubmit = props.doSubmit,
      isConnected = props.isConnected,
      useEmailAsUsername = props.useEmailAsUsername,
      active = props.active,
      siteName = props.siteName,
      gateway = props.gateway,
      formGateway = props.formGateway,
      resetForm = props.resetForm;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      customGateway = _useState2[0],
      setCustomGateway = _useState2[1];

  if (formGateway === 'CUSTOM' && !customGateway) {
    setCustomGateway(true);
    resetForm('gateway');
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: baseClasses('container') + ' ' + loginFormClasses('container') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('header') + ' ' + loginFormClasses('header') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: baseClasses('header-text') + ' ' + loginFormClasses('header-text') },
        context.t('Log In to {n}', {
          n: siteName
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        { to: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_path__["a" /* default */])('/'), className: baseClasses('close-icon') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_APIcon__["a" /* default */], { name: 'close', classModifiers: 'big' })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      {
        onSubmit: handleSubmit(function (values) {
          return doSubmit(values, isConnected);
        }),
        className: baseClasses('form') + ' ' + loginFormClasses('form') },
      errorMsg && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: baseClasses('error') },
        errorMsg
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APInput__["b" /* default */], {
        type: 'text',
        name: 'username',
        customClass: loginFormClasses(),
        label: useEmailAsUsername ? context.t('Email') : context.t('Username'),
        validate: [__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["p" /* required */]]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_APPasswordInput_APPasswordInput__["a" /* default */], {
        type: 'password',
        name: 'password',
        customClass: loginFormClasses(),
        label: context.t('Password'),
        validate: [__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["p" /* required */]]
      }),
      (!gateway || customGateway) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APInput__["b" /* default */], {
        type: 'text',
        name: 'gateway',
        customClass: loginFormClasses(),
        label: context.t('Gateway'),
        validate: [__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["p" /* required */]]
      }),
      !customGateway && Array.isArray(gateway) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TradingServer_TradingServerComponent__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: loginFormClasses('separator') }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__common_APButton__["a" /* default */],
        {
          type: 'submit',
          disabled: submitting,
          customClass: loginFormClasses(),
          styleName: __WEBPACK_IMPORTED_MODULE_13__propTypes_commonComponent__["b" /* styleNames */].additive },
        submitting ? context.t('Processing...') : context.t('Log In')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: baseClasses('footer') + ' ' + loginFormClasses('footer') },
      active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
          {
            to: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_path__["a" /* default */])('/signup'),
            className: loginFormClasses('link'),
            disabled: true },
          context.t('Sign Up')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: baseClasses('footer-separator') })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        {
          to: Object(__WEBPACK_IMPORTED_MODULE_10__helpers_path__["a" /* default */])('/problem-logging-in'),
          className: loginFormClasses('link'),
          disabled: true },
        context.t('Problem Logging In?')
      )
    )
  );
};

LoginFormComponent.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

LoginFormComponent.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  referrer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

LoginFormComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__hocs_redirectIfAuthorized__["a" /* default */])(LoginFormComponent, __WEBPACK_IMPORTED_MODULE_9__routeTemplates__["b" /* defaultPath */].path));

/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APSelect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_wsHelper__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_wsConnectionActions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TradingServerComponent_css__ = __webpack_require__(2490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TradingServerComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TradingServerComponent_css__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trading-server');

var TradingServer = function TradingServer(props, context) {
  var currentServer = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_wsHelper__["a" /* getGateway */])(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].global.gateway);
  var tradingServers = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* default */].global.gateway.filter(function (item) {
    return item !== currentServer;
  }).map(function (item) {
    return { value: item, label: item };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APSelect__["b" /* default */], {
    name: 'gateway',
    label: context.t('Select server') + ':',
    showTriangles: true,
    customClass: baseClasses(),
    onSelect: function onSelect(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_wsConnectionActions__["d" /* changeServer */])(value);
    },
    options: [{ value: currentServer, label: currentServer }, { value: 'CUSTOM', label: 'Custom server ...' }].concat(_toConsumableArray(tradingServers))
  });
};

TradingServer.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TradingServer);

/***/ }),
/* 2490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_PageHeaderLayout_PageHeaderLayout__ = __webpack_require__(2493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_hocs_withAuthentication__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DashboardPage__ = __webpack_require__(2502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarketDataPage__ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BuySellPage__ = __webpack_require__(2507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WalletsPage__ = __webpack_require__(2509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductDetailsPage__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentExhibitPage_ComponentExhibitPage__ = __webpack_require__(2517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SettingsPage__ = __webpack_require__(2523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_apex_web_lib_layouts_TradingLayout_TradingLayoutContainer__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_apex_web_lib_layouts_MarginBalancesLayout_MarginBalancesLayoutContainer__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apex_web_lib_layouts_AssetActivityDetailsLayout_AssetActivityDetailsLayout__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apex_web_lib_layouts_FixedLeftFluidLayout_FixedLeftFluidLayout__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apex_web_lib_components_WalletDetails_WalletDetailsBackButtonComponent__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apex_web_lib_components_BalancesMenu_BalanceMenuContainer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_apex_web_lib_layouts_WalletDetailsLayout_WalletDetailsLayout__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_apex_web_lib_components_DigitalAssets_DigitalAssetsPageContainer__ = __webpack_require__(2539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_apex_web_lib_components_DigitalAssets_DigitalAssetsOfferingProfilePageContainer__ = __webpack_require__(2542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_apex_web_lib_components_IBA_IbaLayout__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__StreamingPage__ = __webpack_require__(2545);
var InteriorPage=function InteriorPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layouts_PageHeaderLayout_PageHeaderLayout__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/dashboard',component:__WEBPACK_IMPORTED_MODULE_4__DashboardPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/dashboard/market-data',component:__WEBPACK_IMPORTED_MODULE_5__MarketDataPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/wallets',component:__WEBPACK_IMPORTED_MODULE_7__WalletsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/wallets/wallet-detail',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_apex_web_lib_layouts_FixedLeftFluidLayout_FixedLeftFluidLayout__["default"],{left:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_apex_web_lib_components_WalletDetails_WalletDetailsBackButtonComponent__["default"],{key:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_apex_web_lib_components_BalancesMenu_BalanceMenuContainer__["default"],{key:'2'})]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_apex_web_lib_layouts_WalletDetailsLayout_WalletDetailsLayout__["default"],null));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/exchange',component:__WEBPACK_IMPORTED_MODULE_11_apex_web_lib_layouts_TradingLayout_TradingLayoutContainer__["default"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/buy-sell',component:__WEBPACK_IMPORTED_MODULE_6__BuySellPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/wallets/product-details',component:__WEBPACK_IMPORTED_MODULE_8__ProductDetailsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings',component:__WEBPACK_IMPORTED_MODULE_10__SettingsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/margin-balances',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_apex_web_lib_layouts_MarginBalancesLayout_MarginBalancesLayoutContainer__["default"],{detailsLink:'/wallets/wallet-detail'});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/asset-activity-details',component:__WEBPACK_IMPORTED_MODULE_13_apex_web_lib_layouts_AssetActivityDetailsLayout_AssetActivityDetailsLayout__["default"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/iba',component:__WEBPACK_IMPORTED_MODULE_20_apex_web_lib_components_IBA_IbaLayout__["default"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/eotc',component:__WEBPACK_IMPORTED_MODULE_21__StreamingPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/digital-assets',component:__WEBPACK_IMPORTED_MODULE_18_apex_web_lib_components_DigitalAssets_DigitalAssetsPageContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/digital-assets/:id',component:__WEBPACK_IMPORTED_MODULE_19_apex_web_lib_components_DigitalAssets_DigitalAssetsOfferingProfilePageContainer__["a" /* default */]}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_hocs_withAuthentication__["a" /* default */])(InteriorPage));

/***/ }),
/* 2493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_common_APLogo_APLogo__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageHeader_PageHeaderNavComponent__ = __webpack_require__(2494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_UserSummary_UserSummaryContainer__ = __webpack_require__(2497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageHeaderLayout_css__ = __webpack_require__(2500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PageHeaderLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PageHeaderLayout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserSummaryOverrides_css__ = __webpack_require__(2501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserSummaryOverrides_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserSummaryOverrides_css__);
var pageHeaderClasses=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('page-header');var MainNavItems=[{text:'Dashboard',icon:'dashboard',path:'/dashboard'},{text:'Digital Assets',icon:'buy-sell',path:'/digital-assets'},{text:'Exchange',icon:'trading',path:'/exchange'},{text:'Balances',icon:'balance',path:'/margin-balances'},{text:'Streaming',icon:'activity',path:'/eotc'},{text:'Lending',icon:'sell',path:'/iba'},{text:'Buy & Sell',icon:'buy-sell',path:'/buy-sell'},{text:'Wallets',icon:'wallet',path:'/wallets'// { text: 'Activity', icon: 'activity', path: '/asset-activity-details' }
// { text: 'Components', icon: 'star', path: '/component' }
}];var PageHeaderComponent=function PageHeaderComponent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageHeaderClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageHeaderClasses('content-wrapper')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageHeaderClasses('header-item','logo')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_common_APLogo_APLogo__["a" /* default */],{customClass:pageHeaderClasses('logo'),linkTo:'/'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_PageHeader_PageHeaderNavComponent__["a" /* default */],{navItems:MainNavItems}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageHeaderClasses('right-panel')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_UserSummary_UserSummaryContainer__["a" /* default */],{customClass:'page-header-user-summary',settingsRoute:'/settings/user',activityRoute:'/asset-activity-details'})))));};/* harmony default export */ __webpack_exports__["a"] = (PageHeaderComponent);

/***/ }),
/* 2494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageHeaderNavMenuComponent__ = __webpack_require__(2495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageHeaderNavComponent_css__ = __webpack_require__(2496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageHeaderNavComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PageHeaderNavComponent_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageHeaderNavClasses=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('page-header-nav');var PageHeaderNavComponent=function(_React$Component){_inherits(PageHeaderNavComponent,_React$Component);function PageHeaderNavComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PageHeaderNavComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PageHeaderNavComponent.__proto__||Object.getPrototypeOf(PageHeaderNavComponent)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false},_this.handleClick=function(){if(!_this.state.isOpen){document.addEventListener('click',_this.handleOutsideClick,false);}else{document.removeEventListener('click',_this.handleOutsideClick,false);}_this.setState(function(prevState){return{isOpen:!prevState.isOpen};});},_this.handleOutsideClick=function(e){if(_this.node.contains(e.target)){return;}_this.handleClick();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PageHeaderNavComponent,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.handleOutsideClick,false);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:PageHeaderNavClasses('container',this.state.isOpen?'':'closed'),ref:function ref(node){_this2.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:PageHeaderNavClasses('menu-toggle',this.state.isOpen?'active':''),onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */],{name:'menu-toggle',customClass:PageHeaderNavClasses('icon')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageHeaderNavMenuComponent__["a" /* default */],{customClass:PageHeaderNavClasses,handleNavItemClick:this.handleClick,navItems:this.props.navItems}));}}]);return PageHeaderNavComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PageHeaderNavComponent);

/***/ }),
/* 2495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_common_APIcon__ = __webpack_require__(13);
var PageHeaderNavMenuComponent=function PageHeaderNavMenuComponent(props,context){var customClass=props.customClass,handleNavItemClick=props.handleNavItemClick;return props.navItems.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{key:item.path,to:item.path,onClick:handleNavItemClick,className:customClass('item',['hoverable']),activeClassName:customClass('item',['selected'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_common_APIcon__["a" /* default */],{name:item.icon,customClass:customClass('icon')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:customClass('label')},context.t(item.text)));});};PageHeaderNavMenuComponent.propTypes={customClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};PageHeaderNavMenuComponent.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PageHeaderNavMenuComponent);

/***/ }),
/* 2496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserSummaryComponent__ = __webpack_require__(2498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_marginSelectors__ = __webpack_require__(34);







var mapStateToProps = function mapStateToProps(state) {
  var selectedAccountId = state.user.selectedAccountId;

  var marginAccount = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_marginSelectors__["e" /* marginAccountSelector */])(state);
  var accounts = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_marginSelectors__["g" /* notMarginAccountsSelector */])(state);
  var selectedAccount = accounts.find(function (account) {
    return account.AccountId === selectedAccountId;
  });

  if (!selectedAccount && marginAccount) {
    selectedAccount = Object(__WEBPACK_IMPORTED_MODULE_5__redux_selectors_marginSelectors__["b" /* defaultAccountSelector */])(state);
  }

  return {
    accounts: accounts,
    selectedAccount: selectedAccount
  };
};

var mapDispatchToProps = {
  logout: __WEBPACK_IMPORTED_MODULE_3__redux_actions_authActions__["j" /* logout */],
  selectAccount: __WEBPACK_IMPORTED_MODULE_4__redux_actions_userActions__["p" /* selectAccount */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_2__UserSummaryComponent__["a" /* default */])));

/***/ }),
/* 2498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_PopoverMenu_PopoverMenu__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserSummaryComponent_css__ = __webpack_require__(2499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserSummaryComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserSummaryComponent_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var UserSummary = function (_React$Component) {
  _inherits(UserSummary, _React$Component);

  function UserSummary() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserSummary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserSummary.__proto__ || Object.getPrototypeOf(UserSummary)).call.apply(_ref, [this].concat(args))), _this), _this.renderMenuItems = function () {
      var _this$props = _this.props,
          accounts = _this$props.accounts,
          selectedAccount = _this$props.selectedAccount,
          history = _this$props.history,
          settingsRoute = _this$props.settingsRoute,
          activityRoute = _this$props.activityRoute;

      var menuItems = void 0;
      if (accounts.length <= 1) {
        menuItems = [{
          label: _this.context.t(selectedAccount.AccountName),
          customClass: _this.context.t('username-in-dropdown')
        }, { label: _this.context.t('Sign Out'), onClick: _this.props.logout }];
      } else {
        menuItems = [].concat(_toConsumableArray(accounts.filter(function (account) {
          return account.AccountId !== selectedAccount.AccountId;
        }).map(function (account) {
          return {
            label: _this.context.t('Switch to {accountName}', {
              accountName: account.AccountName
            }),
            onClick: function onClick() {
              return _this.props.selectAccount(account.AccountId, account.OMSID);
            }
          };
        })));
        menuItems.push({ divider: true }, { label: _this.context.t('Sign Out'), onClick: _this.props.logout });
      }
      if (settingsRoute) {
        menuItems.unshift({
          label: _this.context.t('Settings'),
          onClick: function onClick() {
            return history.push(settingsRoute);
          }
        });
      }
      if (activityRoute) {
        menuItems.unshift({
          label: _this.context.t('Activity'),
          onClick: function onClick() {
            return history.push(activityRoute);
          }
        });
      }

      return menuItems;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserSummary, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedAccount = _props.selectedAccount,
          customClass = _props.customClass;

      var bemClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])(['user-summary', customClass]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: bemClasses('container') },
        selectedAccount ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_PopoverMenu_PopoverMenu__["a" /* default */], {
          customClass: bemClasses(),
          popoverProps: {
            trigger: function trigger(props) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                Object.assign({
                  className: bemClasses('popover-menu-trigger')
                }, props),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: bemClasses('user-info-container') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIcon__["a" /* default */], { name: 'user', customClass: bemClasses('icon') }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: bemClasses('username-in-display') },
                    selectedAccount.AccountName
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                    className: bemClasses('popover-menu-trigger-triangle')
                  })
                )
              );
            },
            customClass: 'user-summary'
          },
          items: this.renderMenuItems()
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Spinner_Spinner__["a" /* default */], { isInline: true, customClass: bemClasses })
      );
    }
  }]);

  return UserSummary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

UserSummary.propTypes = {
  selectedAccount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    AccountName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  accounts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  logout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  settingsRoute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activityRoute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
UserSummary.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
UserSummary.defaultProps = {
  settingsRoute: ''
};


/* harmony default export */ __webpack_exports__["a"] = (UserSummary);

/***/ }),
/* 2499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_PageSubHeaderLayout_PageSubHeaderLayout__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_PageFooter_PageFooterComponent__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_hocs_withAuthentication__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_BalancesList__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_MarketOverview__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_components_RecentActivity_RecentActivityContainer__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_TransferRequestsNotification___ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardPage_css__ = __webpack_require__(2504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DashboardPage_css__);
var layoutClasses=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_cssClassesHelper__["b" /* getBEMClasses */])('dashboard-page');var DashboardPage=function DashboardPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('accent-bar')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layouts_PageSubHeaderLayout_PageSubHeaderLayout__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('notification-row')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_TransferRequestsNotification___["default"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('market-overview-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('market-overview-container-left')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('market-header')},context.t('Markets Overview')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_MarketOverview__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('market-overview-container-right')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('balances-header')},context.t('Balances')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_BalancesList__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('recent-activity-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_components_RecentActivity_RecentActivityContainer__["a" /* default */],{filterForSelected:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('footer')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_PageFooter_PageFooterComponent__["default"],null)));};DashboardPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_hocs_withAuthentication__["a" /* default */])(DashboardPage));

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_PageSubHeaderLayout_PageSubHeaderLayout__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_PageFooterLayout_PageFooterLayout__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_hocs_withAuthentication__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_MarketDataCardsComponent_MarketDataCardsContainer__ = __webpack_require__(127);
var layoutClasses=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('dashboard-page');var MarketDataPage=function MarketDataPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('accent-bar')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layouts_PageSubHeaderLayout_PageSubHeaderLayout__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_MarketDataCardsComponent_MarketDataCardsContainer__["default"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('footer')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layouts_PageFooterLayout_PageFooterLayout__["a" /* default */],null)));};MarketDataPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_hocs_withAuthentication__["a" /* default */])(MarketDataPage));

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_hocs_withAuthentication__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Retail_RetailBuySell__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_layouts_Responsive_EotcBuySellLayout_EotcBuySellDesktopLayout_css__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_layouts_Responsive_EotcBuySellLayout_EotcBuySellDesktopLayout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_layouts_Responsive_EotcBuySellLayout_EotcBuySellDesktopLayout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_PageFooter_PageFooterComponent__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BuySellPage_css__ = __webpack_require__(2508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BuySellPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BuySellPage_css__);
var classes=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('eotc-buy-sell-layout');var BuySellPage=function BuySellPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('accent-bar')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('col',['lg'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('make-transaction-container container-with-shadow')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('make-transaction-col-1 ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Retail_RetailBuySell__["f" /* BuySellMakeTransactionContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Retail_RetailBuySell__["d" /* BuySellContainer */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('make-transaction-col-2')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('order-overview-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Retail_RetailBuySell__["g" /* BuySellOrderOverviewContainer */],{displayPricePerUnit:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:classes('right-panel-divider')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('balances-container ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Retail_RetailBuySell__["a" /* BuySellBalancesContainer */],null)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes('footer')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_PageFooter_PageFooterComponent__["default"],null)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_hocs_withAuthentication__["a" /* default */])(BuySellPage));

/***/ }),
/* 2508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_PageFooter_PageFooterComponent__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_hocs_withAuthentication__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_WalletCards_WalletCardGridContainer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_WalletRows_WalletRowListContainer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WalletsPage_css__ = __webpack_require__(2510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WalletsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__WalletsPage_css__);
var layoutClasses=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallets-page');var detailsLink='/wallets/product-details';var WalletsPage=function WalletsPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('accent-bar')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('wallet-list-container-header')},context.t('Funded Accounts')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('wallet-card-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_WalletCards_WalletCardGridContainer__["default"],{detailsLink:detailsLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('wallet-list-container-header')},context.t('Unfunded Accounts')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('wallet-list-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_WalletRows_WalletRowListContainer__["default"],{detailsLink:detailsLink}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('footer')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_PageFooter_PageFooterComponent__["default"],null)));};WalletsPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_hocs_withAuthentication__["a" /* default */])(WalletsPage));

/***/ }),
/* 2510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_PageFooterLayout_PageFooterLayout__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WalletDetails_WalletDetailsBackButtonComponent__ = __webpack_require__(2512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_hocs_withAuthentication__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_BalancesMenu_BalanceMenuContainer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_WalletDetails_WalletDetailsContainer__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_components_Transfers_TransfersContainer__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_Transfers_TransfersFilters__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apex_web_lib_components_RecentActivityWithFilter__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductDetailsPage_css__ = __webpack_require__(2516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductDetailsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ProductDetailsPage_css__);
var layoutClasses=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_cssClassesHelper__["b" /* getBEMClasses */])('product-details-page');var backPath='/wallets';var ProductDetailsPage=function ProductDetailsPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('menu')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_WalletDetails_WalletDetailsBackButtonComponent__["a" /* default */],{key:'1',path:backPath}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_BalancesMenu_BalanceMenuContainer__["default"],{key:'2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('content')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('wallet-details')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_WalletDetails_WalletDetailsContainer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('transfers')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:layoutClasses('transfers-header')},context.t('Transfers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_apex_web_lib_components_Transfers_TransfersFilters__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_components_Transfers_TransfersContainer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_apex_web_lib_components_RecentActivityWithFilter__["default"],{filterForSelected:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__layouts_PageFooterLayout_PageFooterLayout__["a" /* default */],null));};ProductDetailsPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_hocs_withAuthentication__["a" /* default */])(ProductDetailsPage));

/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_path__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MenuItem_MenuItemComponent__ = __webpack_require__(2513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_APIcon__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WalletDetailsBackButton_css__ = __webpack_require__(2515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WalletDetailsBackButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__WalletDetailsBackButton_css__);
var baseClass=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('wallet-details-back-button');var WalletDetailsBackButtonComponent=function WalletDetailsBackButtonComponent(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MenuItem_MenuItemComponent__["a" /* default */],{customClass:baseClass(),onItemClick:function onItemClick(){return props.history.push(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_path__["a" /* default */])(props.path));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_APIcon__["a" /* default */],{name:'arrowPrevious',customClass:baseClass()}),' ',context.t('Back to Overview'));};WalletDetailsBackButtonComponent.contextTypes={router:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired}).isRequired,t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(WalletDetailsBackButtonComponent));

/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_MenuComponent_css__ = __webpack_require__(2514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_MenuComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Menu_MenuComponent_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var baseClass='menu-component';var MenuItemComponent=function(_React$Component){_inherits(MenuItemComponent,_React$Component);function MenuItemComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MenuItemComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MenuItemComponent.__proto__||Object.getPrototypeOf(MenuItemComponent)).call.apply(_ref,[this].concat(args))),_this),_this.getBEMClasses=function(){return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])(baseClass,_this.props.customClass);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MenuItemComponent,[{key:'render',value:function render(){var bemClasses=this.getBEMClasses();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:bemClasses('item',this.props.selected&&'selected'),onClick:this.props.onItemClick},this.props.children);}}]);return MenuItemComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MenuItemComponent.propTypes={onItemClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,customClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (MenuItemComponent);

/***/ }),
/* 2514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ComponentExhibitNav_ComponentExhibitNavComponent__ = __webpack_require__(2518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentMap__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentExhibitPage_css__ = __webpack_require__(2522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentExhibitPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ComponentExhibitPage_css__);
var pageClasses=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('component-exhibit-page');var ComponentExhibitPage=function ComponentExhibitPage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageClasses('side-bar')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ComponentExhibitNav_ComponentExhibitNavComponent__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:pageClasses('main')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_4__ComponentMap__["a" /* default */].map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:item.path,key:item.text,component:item.component});})))));};/* unused harmony default export */ var _unused_webpack_default_export = (ComponentExhibitPage);

/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__APNavMenuVertical_APNavMenuVertical__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ComponentExhibitPage_ComponentMap__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentExhibitNav_css__ = __webpack_require__(2521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentExhibitNav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ComponentExhibitNav_css__);
var ComponentExhibitNavClasses=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('component-menu');var ComponentExhibitNav=function ComponentExhibitNav(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__APNavMenuVertical_APNavMenuVertical__["a" /* default */],{customClass:ComponentExhibitNavClasses(),items:__WEBPACK_IMPORTED_MODULE_4__pages_ComponentExhibitPage_ComponentMap__["a" /* default */]});};ComponentExhibitNav.contextTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ComponentExhibitNav);

/***/ }),
/* 2519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apex_web_lib_components_AffiliateComponents_AffiliateActiveTagContainer__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_helpers_path__ = __webpack_require__(27);
var AffiliateActiveTagContainerWrapper=function AffiliateActiveTagContainerWrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_apex_web_lib_components_AffiliateComponents_AffiliateActiveTagContainer__["a" /* default */],{route:''+window.location.origin+Object(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_helpers_path__["a" /* default */])('')+'/signup?aff='});};/* harmony default export */ __webpack_exports__["a"] = (AffiliateActiveTagContainerWrapper);

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_PageFooter_PageFooterComponent__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SettingsMenu_SettingsMenuComponent__ = __webpack_require__(2524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserSettingsPage__ = __webpack_require__(2526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TradeReportPage__ = __webpack_require__(2528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_Settings_TradeSettings__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__APIKeysPage__ = __webpack_require__(2530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserContactsPage__ = __webpack_require__(2532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AffiliateProgramPage__ = __webpack_require__(2534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LoyaltyTokenPage__ = __webpack_require__(2536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_apex_web_lib_components_Settings_DemoSettings_DemoSettingsContainer__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_apex_web_lib_components_Settings_InterestBearingAccounts___ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apex_web_lib_components_KYCSettings__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SettingsPage_css__ = __webpack_require__(2538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SettingsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__SettingsPage_css__);
var settingsPageClasses=Object(__WEBPACK_IMPORTED_MODULE_13__helpers_cssClassesHelper__["b" /* getBEMClasses */])('settings-page');var SettingsPage=function SettingsPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:settingsPageClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:settingsPageClasses('menu')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_SettingsMenu_SettingsMenuComponent__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:settingsPageClasses('content')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/user',component:__WEBPACK_IMPORTED_MODULE_4__UserSettingsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/trade',component:__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_Settings_TradeSettings__["default"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/iba',component:__WEBPACK_IMPORTED_MODULE_12_apex_web_lib_components_Settings_InterestBearingAccounts___["default"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/trade-reports',component:__WEBPACK_IMPORTED_MODULE_5__TradeReportPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/api-keys',component:__WEBPACK_IMPORTED_MODULE_7__APIKeysPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/contacts',component:__WEBPACK_IMPORTED_MODULE_8__UserContactsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/affiliate',component:__WEBPACK_IMPORTED_MODULE_9__AffiliateProgramPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/loyalty-token',component:__WEBPACK_IMPORTED_MODULE_10__LoyaltyTokenPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/verification-level',component:__WEBPACK_IMPORTED_MODULE_14_apex_web_lib_components_KYCSettings__["default"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/settings/demo-settings',component:__WEBPACK_IMPORTED_MODULE_11_apex_web_lib_components_Settings_DemoSettings_DemoSettingsContainer__["default"]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:settingsPageClasses('footer')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_PageFooter_PageFooterComponent__["default"],null)));};/* harmony default export */ __webpack_exports__["a"] = (SettingsPage);

/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__APNavMenuVertical_APNavMenuVertical__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SettingsMenuComponent_css__ = __webpack_require__(2525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SettingsMenuComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SettingsMenuComponent_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SettingsMenuClasses=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('settings-menu');var SettingMenuItems=[{text:'Profile & Security',path:'/settings/user',icon:'security'},{text:'IBA Settings',path:'/settings/iba',icon:'sell'},{text:'Trade Settings',path:'/settings/trade',icon:'tasks'},{text:'Verification Level',path:'/settings/verification-level',icon:'tasks'},{text:'Trade Reports',path:'/settings/trade-reports',icon:'reports'},{text:'API Keys',path:'/settings/api-keys',icon:'key'},{text:'User Contacts',path:'/settings/contacts',icon:'contacts'},{text:'Affiliate Program',path:'/settings/affiliate',icon:'friends'},{text:'Loyalty Token',path:'/settings/loyalty-token',icon:'heart'},{text:'Demo Settings',path:'/settings/demo-settings',icon:'paint'}];var SettingsMenuComponent=function(_React$Component){_inherits(SettingsMenuComponent,_React$Component);function SettingsMenuComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SettingsMenuComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SettingsMenuComponent.__proto__||Object.getPrototypeOf(SettingsMenuComponent)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false},_this.handleClick=function(){if(!_this.state.isOpen){document.addEventListener('click',_this.handleOutsideClick,false);}else{document.removeEventListener('click',_this.handleOutsideClick,false);}_this.setState(function(prevState){return{isOpen:!prevState.isOpen};});},_this.handleOutsideClick=function(e){if(_this.node.contains(e.target)){return;}_this.handleClick();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SettingsMenuComponent,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('click',this.handleOutsideClick,false);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:SettingsMenuClasses('container',this.state.isOpen?'':'closed'),ref:function ref(node){_this2.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:SettingsMenuClasses('menu-toggle',this.state.isOpen?'active':''),onClick:this.handleClick},this.context.t('User Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:SettingsMenuClasses('triangles-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'triangle-up'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'triangle-down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__APNavMenuVertical_APNavMenuVertical__["a" /* default */],{customClass:SettingsMenuClasses,handleNavItemClick:this.handleClick,items:SettingMenuItems}));}}]);return SettingsMenuComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SettingsMenuComponent);SettingsMenuComponent.contextTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};

/***/ }),
/* 2525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_Settings_ProfileAndSecurity_ProfileSettingsCard__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Settings_ProfileAndSecurity_RegionSettingsCard__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_Settings_ProfileAndSecurity_ThemeSettingsCard__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_Settings_ProfileAndSecurity_PasswordSettingsCard__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_Settings_ProfileAndSecurity_TwoFactorAuthSettingsCard__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserSettingsPage_css__ = __webpack_require__(2527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserSettingsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UserSettingsPage_css__);
var userSettingsPageClasses=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cssClassesHelper__["b" /* getBEMClasses */])('user-settings-page');var UserSettingsPage=function UserSettingsPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userSettingsPageClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userSettingsPageClasses('page-header')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:userSettingsPageClasses('title')},context.t('Update Profile and Security Settings.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:userSettingsPageClasses('sub-title')},context.t(' Here you can make general settings such as...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userSettingsPageClasses('row')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_Settings_ProfileAndSecurity_ProfileSettingsCard__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Settings_ProfileAndSecurity_RegionSettingsCard__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userSettingsPageClasses('row','sm')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_Settings_ProfileAndSecurity_ThemeSettingsCard__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_Settings_ProfileAndSecurity_PasswordSettingsCard__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userSettingsPageClasses('row','sm')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_Settings_ProfileAndSecurity_TwoFactorAuthSettingsCard__["a" /* default */],null))));};UserSettingsPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (UserSettingsPage);

/***/ }),
/* 2527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_ActivityReportingComponents__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_ReportSidePaneComponents_ScheduledReportsTable__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_ReportSidePaneComponents_DownloadReportForm__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TradeReportPage_css__ = __webpack_require__(2529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TradeReportPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TradeReportPage_css__);
var tradeReportPageClasses=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('trade-report-page');var TradeReportPage=function TradeReportPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('activity-report')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('activity-report-header')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('activity-report-header-title')},context.t('Activity Reporting')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('activity-report-header-text')},context.t('All of your activity on the exchange is available for you to download as a spreadsheet. Simply choose the type of activity and the timeframe to generate your report.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('activity-report-buttons')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_ActivityReportingComponents__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('cyclical-report')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('report-header')},context.t('Cyclical Reports')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_ReportSidePaneComponents_ScheduledReportsTable__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('singal-report')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tradeReportPageClasses('report-header')},context.t('Reports Available to Download')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_ReportSidePaneComponents_DownloadReportForm__["a" /* default */],null)));};TradeReportPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TradeReportPage);

/***/ }),
/* 2529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_Settings_ApiKeys__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_ApiKeysSidePaneComponents_ApiKeyList_ApiKeyListContainer__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APIKeysPage_css__ = __webpack_require__(2531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__APIKeysPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__APIKeysPage_css__);
var apiKeysPageClasses=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('api-keys-page');var APIKeysPage=function APIKeysPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses('description-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses('header')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses('header-title')},context.t('About API Keys')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses('header-text')},context.t('The Public API is available in HTTP, WebSocket, and Get Request, with streaming data on products, product pairs, ticker activity, trades, and the order book.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses('header-text')},context.t("The Private API is accessible only by registered users and enables access and control of a user's account. All key user functions may be executed from the API, including account and order management activities."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses('actions')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_Settings_ApiKeys__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses('documentation')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_4__config__["default"].ApiKeys.documentationLink,target:'blank'},context.t('View: API Documentation »'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:apiKeysPageClasses('table-header')},context.t('Existing API Keys')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_ApiKeysSidePaneComponents_ApiKeyList_ApiKeyListContainer__["a" /* default */],{customClass:'retail-api-key-list'})));};APIKeysPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (APIKeysPage);

/***/ }),
/* 2531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_Settings_TransferHistory__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserContactsPage_css__ = __webpack_require__(2533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserContactsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UserContactsPage_css__);
var userContactsPageClasses=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('user-contacts-page');var UserContactsPage=function UserContactsPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userContactsPageClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userContactsPageClasses('block-with-text')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userContactsPageClasses('header-text')},context.t('Trading with Other On-Exchange Participants')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userContactsPageClasses('text')},context.t('You can freely transfer currency with other participants on the exchange. Simply provide the email address for your contact during the “Send” or “Receive” process. If the email address is registered on the exchange, then the user will receive the transfer. If the email address is not registered, the user will get an invitation to join the exchange.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userContactsPageClasses('transfer')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userContactsPageClasses('transfer-header')},context.t('Transfer History')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userContactsPageClasses('transfer-items')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_Settings_TransferHistory__["a" /* default */],null))));};UserContactsPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (UserContactsPage);

/***/ }),
/* 2533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_AffiliateComponents_AffiliateActiveTagContainer__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_AffiliateComponents_AffiliateCountContainer__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_path__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AffiliateProgramPage_css__ = __webpack_require__(2535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AffiliateProgramPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AffiliateProgramPage_css__);
var affiliateProgramPageClasses=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_cssClassesHelper__["b" /* getBEMClasses */])('affiliate-program-page');var AffiliateProgramPage=function AffiliateProgramPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:affiliateProgramPageClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:affiliateProgramPageClasses('main-header')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:affiliateProgramPageClasses('header')},context.t('Join the {n} Affiliate Program',{n:__WEBPACK_IMPORTED_MODULE_6__config__["default"].global.siteName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:affiliateProgramPageClasses('description')},context.t('Our affiliate program lets you earn a bonus for each successful referral registered to your account. Create an affiliate link below, copy it and email to a friend. Your friends can click on the affiliate link and sign up for an account, at which point you will see the number of affliates increase on this page.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:affiliateProgramPageClasses('body')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:affiliateProgramPageClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:affiliateProgramPageClasses('container-header')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:affiliateProgramPageClasses('container-header--title')},context.t('Current Active Tag'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_AffiliateComponents_AffiliateActiveTagContainer__["a" /* default */],{route:''+window.location.origin+Object(__WEBPACK_IMPORTED_MODULE_5__helpers_path__["a" /* default */])('')+'/signup?aff='})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:affiliateProgramPageClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:affiliateProgramPageClasses('container-header')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:affiliateProgramPageClasses('container-header--title')},context.t('Number of Active Affiliates'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_AffiliateComponents_AffiliateCountContainer__["a" /* default */],null))));};AffiliateProgramPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AffiliateProgramPage);

/***/ }),
/* 2535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_LoyaltyToken_LoyaltyTokenContainer__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoyaltyTokenPage_css__ = __webpack_require__(2537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoyaltyTokenPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LoyaltyTokenPage_css__);
var loyaltyTokenPageClasses=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_cssClassesHelper__["b" /* getBEMClasses */])('loyalty-token-page');var LoyaltyTokenPage=function LoyaltyTokenPage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:loyaltyTokenPageClasses()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:loyaltyTokenPageClasses('header')},context.t('Loyalty Token')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:loyaltyTokenPageClasses('description')},context.t('Using LTC for transaction fees applies a discount to your trading fee. If you hold LTC in your account, you have the option of having your trading fees automatically subtracted from your LTC balance.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_LoyaltyToken_LoyaltyTokenContainer__["a" /* default */],null));};LoyaltyTokenPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (LoyaltyTokenPage);

/***/ }),
/* 2537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_instrumentActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_productActions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_level2Actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DigitalAssetsPage__ = __webpack_require__(2540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_selectors_digitalAssetsSelectors__ = __webpack_require__(428);









var mapStateToProps = function mapStateToProps(state) {
  return {
    instruments: Object(__WEBPACK_IMPORTED_MODULE_1__redux_selectors_instrumentPositionSelectors__["e" /* standardInstrumentsWithProductFullNamesAndProductSymbols */])(state),
    selectedInstrument: state.apexCore.instrument.selectedInstrumentId,
    products: __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(state, 'apexCore.product.products', []),
    productAttributes: __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(state, 'productAttributes', {}),
    digitalAssets: Object(__WEBPACK_IMPORTED_MODULE_7__redux_selectors_digitalAssetsSelectors__["b" /* digitalAssetsListSelector */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, getState) {
  return {
    getProductAttributes: function getProductAttributes(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_productActions__["c" /* getProductAttributes */])(payload));
    },
    selectInstrument: function selectInstrument(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_instrumentActions__["e" /* selectInstrument */])(parseInt(payload, 10)));
    },
    unsubscribeLevel2: function unsubscribeLevel2(instrumentId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_level2Actions__["g" /* unsubscribeLevel2 */])(instrumentId));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__DigitalAssetsPage__["a" /* default */]));

/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_withAuthentication__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APIcon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PageFooter_PageFooterComponent__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TotalTokensCount__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DigitalAssetsPage_css__ = __webpack_require__(2541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DigitalAssetsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DigitalAssetsPage_css__);











var classes = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_cssClassesHelper__["b" /* getBEMClasses */])('digital-assets');

var DigitalAssetsPage = function DigitalAssetsPage(_ref) {
  var products = _ref.products,
      digitalAssets = _ref.digitalAssets,
      getProductAttributes = _ref.getProductAttributes;

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    getProductAttributes(products);
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: classes('accent-bar') }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('container') },
      !products.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Spinner_Spinner__["a" /* default */], null) : digitalAssets.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('container-header') },
          'Ongoing Offerings'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('col', ['lg']) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: classes('container-with-shadow') },
            digitalAssets.map(function (card, index) {
              var total = digitalAssets.find(function (total) {
                return total.Product1 === card.ProductId || total.Product2 === card.ProductId;
              }) || { total: 0 };
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Card, { data: card, total: total, key: index });
            })
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('container-notfound') },
        'No Digital Assets could be found'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('footer') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PageFooter_PageFooterComponent__["default"], null)
    )
  );
};

var Card = function Card(_ref2) {
  var data = _ref2.data,
      total = _ref2.total.total;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes('card') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: classes('header-div'),
        style: { backgroundImage: 'url(' + data.ProductImageURL + ')' } },
      ' '
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('card-title') },
      data.ProductFullName
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('card-description') },
      data.ProductDescription
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes('card-symbol') },
      data.Product
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('details') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('left-detail') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: classes('details-label') },
            'Amount of tokens offered:'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: classes('details-value') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TotalTokensCount__["a" /* ConnectedTotalTokens */], { ProductId: data.ProductId })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('card-actions') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('view-more') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: '/digital-assets/' + data.ProductId },
            'View More \xA0\xA0',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APIcon__["a" /* default */], { name: 'arrowNext' })
          )
        )
      )
    )
  );
};

Card.defaultProps = {
  ProductImageURL: 'http://offering-profiles-samples.surge.sh/noimagefound.png'
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hocs_withAuthentication__["a" /* default */])(DigitalAssetsPage));

/***/ }),
/* 2541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_withAuthentication__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_instrumentActions__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_sidePaneActions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DigitalAssetsOfferingProfilePage__ = __webpack_require__(2543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_productActions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_selectors_digitalAssetsSelectors__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);













var DefaultProfileURL = __WEBPACK_IMPORTED_MODULE_11__config__["b" /* default */].DigitalAssets.DefaultProfileURL;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var ProductId = parseInt(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(ownProps, 'match.params.id', 0));
  var selectedProduct = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(state, 'apexCore.product.products', []).find(function (i) {
    return i.ProductId === ProductId;
  }) || {};
  var selectedInstrument = Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_digitalAssetsSelectors__["c" /* selectedDigitalAssetInstrumentSelector */])(state, { ProductId: ProductId }) || {};
  var digitalAsset = Object(__WEBPACK_IMPORTED_MODULE_10__redux_selectors_digitalAssetsSelectors__["a" /* digitalAssetSelector */])(state, { ProductId: ProductId });

  return {
    ProductId: ProductId,
    selectedProduct: selectedProduct,
    selectedInstrument: selectedInstrument,
    selectedInstrumentId: selectedInstrument.InstrumentId,
    digitalAsset: digitalAsset,
    OfferingProfileURL: digitalAsset.OfferingProfileURL || DefaultProfileURL,
    price: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(state, ['apexCore', 'level1', state.apexCore.instrument.selectedInstrumentId, 'BestOffer'], 0)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getProductAttributes: function getProductAttributes(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_productActions__["c" /* getProductAttributes */])(payload));
    },
    openSendReceiveSidePane: function openSendReceiveSidePane(product, isBuySide) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_sidePaneActions__["u" /* openSidePane */])('AdvancedOrder', { hideHeader: true, product: product }));
      // Update form after it gets initialized by component mounting.
      setTimeout(function () {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */])('advancedOrderEntry', 'side', isBuySide));
      }, 1);
    },
    selectInstrument: function selectInstrument(payload) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_instrumentActions__["e" /* selectInstrument */])(parseInt(payload, 10)));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hocs_withAuthentication__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_8__DigitalAssetsOfferingProfilePage__["a" /* default */]))));

/***/ }),
/* 2543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_APIFrame_APIFrame__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DigitalAssetsOfferingProfilePage_css__ = __webpack_require__(2544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DigitalAssetsOfferingProfilePage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DigitalAssetsOfferingProfilePage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TotalTokensCount__ = __webpack_require__(848);








var classes = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_cssClassesHelper__["b" /* getBEMClasses */])('offering-profile');

var DigitalAssetsOfferingProfilePage = function DigitalAssetsOfferingProfilePage(props, context) {
  var ProductId = props.ProductId,
      OfferingProfileURL = props.OfferingProfileURL,
      price = props.price,
      digitalAsset = props.digitalAsset,
      isWithdrawDisabled = props.isWithdrawDisabled,
      openSendReceiveSidePane = props.openSendReceiveSidePane,
      selectInstrument = props.selectInstrument,
      selectedInstrumentId = props.selectedInstrumentId;

  var product = digitalAsset;

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (selectedInstrumentId && ProductId) {
      selectInstrument(selectedInstrumentId);
      props.getProductAttributes([{ ProductId: ProductId }]);
    }
  }, [selectedInstrumentId, ProductId]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    product && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('header') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('left') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: classes('symbol') },
            digitalAsset.Product
          ),
          '\xA0\xA0\xA0',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: classes('product') },
            digitalAsset.ProductFullName
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('right') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__["a" /* default */], {
            iconName: 'deposit',
            action: function action() {
              openSendReceiveSidePane(digitalAsset);
            },
            customClass: classes('padding'),
            label: context.t('   Buy')
          }),
          '\xA0\xA0\xA0',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_APIconButton_APIconButton__["a" /* default */], {
            style: { border: '1px solid red' },
            iconName: 'withdraw',
            action: function action() {
              openSendReceiveSidePane(digitalAsset, '1');
            },
            customClass: classes('padding'),
            isDisabled: isWithdrawDisabled,
            label: context.t('   Sell')
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('header') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('left') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: classes('tabs') },
            context.t('Asset Details')
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('right') },
          context.t('Price:'),
          ' $',
          price,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          context.t('Number of tokens for sale:'),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TotalTokensCount__["a" /* ConnectedTotalTokens */], {
            ProductId: ProductId,
            InstrumentId: selectedInstrumentId
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes('container') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: classes('iframe-container') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_APIFrame_APIFrame__["a" /* default */], {
            src: OfferingProfileURL,
            title: digitalAsset.Product,
            style: { width: '100%', height: '100%' }
          })
        )
      )
    )
  );
};

DigitalAssetsOfferingProfilePage.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DigitalAssetsOfferingProfilePage);

/***/ }),
/* 2544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_layouts_StreamingLayouts_StreamingLayout__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Streaming_StreamingGridContainer__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_RecentActivityWithFilter__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_layouts_BalancesListLayout_BalancesListLayout__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_PageFooter_PageFooterComponent__ = __webpack_require__(61);
var StreamingPage=function StreamingPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_layouts_StreamingLayouts_StreamingLayout__["default"],{component1:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_Streaming_StreamingGridContainer__["default"],null),component2:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_layouts_BalancesListLayout_BalancesListLayout__["default"],null),component3:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_RecentActivityWithFilter__["default"],{filterForSelected:false,pageSize:10,minRow:10}),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_PageFooter_PageFooterComponent__["default"],null)});};StreamingPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (StreamingPage);

/***/ }),
/* 2546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_InstrumentRow__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_PriceChart_PriceChartContainer__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_DepthChart_DepthChartContainer__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_OrderBookComponents_OrderBookContainer__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_RecentTrades_RecentTradesContainer__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SimpleExchangePage_css__ = __webpack_require__(2547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SimpleExchangePage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SimpleExchangePage_css__);
var exchangePageClasses=Object(__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_helpers_cssClassesHelper__["b" /* getBEMClasses */])('simple-exchange-page');var SimpleExchangePage=function SimpleExchangePage(props,context){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('row')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_InstrumentRow__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('body')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('chart-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('chart-header')},context.t('Price Chart')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_PriceChart_PriceChartContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_components_DepthChart_DepthChartContainer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('column-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('title')},context.t('Order Book')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_components_OrderBookComponents_OrderBookContainer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('column-container')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:exchangePageClasses('title')},context.t('Recent Trades')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_components_RecentTrades_RecentTradesContainer__["a" /* default */],null))));};SimpleExchangePage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SimpleExchangePage);

/***/ }),
/* 2547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TwoFactorAuthComponent__ = __webpack_require__(2549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);







var mapStateToProps = function mapStateToProps(state) {
  return {
    GoogleQRCode: state.user.qrCode.ManualCode,
    userName: state.user.userInfo.UserName
  };
};

var mapDispatchToProps = {
  changeFieldValue: __WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* change */]
};

var containerForm = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
  return {
    TFaType: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(state, 'user.userConfig', []).find(function (i) {
      return i.Value === '2FAType';
    })
  };
})(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["j" /* reduxForm */])({
  form: 'CONFIRM_2FA',
  onSubmit: function onSubmit(formValues, dispatch, ownProps) {
    var apiCall = ownProps.apiCall,
        apiPayload = ownProps.apiPayload,
        TfaType = ownProps.TfaType,
        close = ownProps.close,
        resolve = ownProps.resolve;


    return apiCall({
      TfaType: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(TfaType, 'Value', 'Google'),
      TFaCode: formValues.code,
      Payload: apiPayload
    }).then(function (response) {
      var data = JSON.parse(response.o);
      if (data && data.TFaAuthenticated === false) {
        throw new __WEBPACK_IMPORTED_MODULE_1_redux_form__["c" /* SubmissionError */]({
          _error: data.errMsg
        });
      }
      close();
      return resolve(data);
    });
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(__WEBPACK_IMPORTED_MODULE_2__TwoFactorAuthComponent__["a" /* default */]));

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(containerForm);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_4__redux_actions_modalActions__["b" /* MODAL_TYPES */].REQUIRE_2FA
})(container));

/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SendReceiveSidePane_SendReceiveTwoFactorAuth_SendReceiveTwoFactorAuthModal_css__ = __webpack_require__(2550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SendReceiveSidePane_SendReceiveTwoFactorAuth_SendReceiveTwoFactorAuthModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SendReceiveSidePane_SendReceiveTwoFactorAuth_SendReceiveTwoFactorAuthModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_APAutoTabInput_APAutoTabInput__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__ = __webpack_require__(31);








var baseClasses = Object(__WEBPACK_IMPORTED_MODULE_5__helpers_cssClassesHelper__["b" /* getBEMClasses */])('send-receive-two-factor-auth-modal');

var TwoFactorAuthModal = function TwoFactorAuthModal(props, context) {
  var handleSubmit = props.handleSubmit,
      isOpen = props.isOpen,
      close = props.close,
      error = props.error;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__common_Modal_Modal__["a" /* default */],
    {
      isOpen: isOpen,
      title: context.t('Two-Factor Authentication'),
      onCancel: close,
      close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { onSubmit: handleSubmit, className: baseClasses() },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('text-item') },
        context.t('Enter the token from your Authenticator app.')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_APAutoTabInput_APAutoTabInput__["a" /* default */], {
        name: 'code',
        type: 'input',
        numberOfInputs: 6,
        validate: [__WEBPACK_IMPORTED_MODULE_6__helpers_formValidations__["p" /* required */]]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: baseClasses('footer') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: error && baseClasses('text-item__failed') },
          error && context.t(error)
        )
      )
    )
  );
};

TwoFactorAuthModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

TwoFactorAuthModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

TwoFactorAuthModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TwoFactorAuthModal);

/***/ }),
/* 2550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_userActions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Enable2FAForm__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Modal_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Enable2FAModal_css__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Enable2FAModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Enable2FAModal_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var StandaloneEnable2FAModal = function (_React$Component) {
  _inherits(StandaloneEnable2FAModal, _React$Component);

  function StandaloneEnable2FAModal() {
    _classCallCheck(this, StandaloneEnable2FAModal);

    return _possibleConstructorReturn(this, (StandaloneEnable2FAModal.__proto__ || Object.getPrototypeOf(StandaloneEnable2FAModal)).apply(this, arguments));
  }

  _createClass(StandaloneEnable2FAModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          GoogleQRCode = _props.GoogleQRCode,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          close = _props.close,
          userName = _props.userName,
          Use2FAEnabled = _props.Use2FAEnabled;


      if (Use2FAEnabled) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */], { to: '/login' });
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__common_Modal_Modal__["a" /* default */],
        {
          isOpen: true,
          title: this.context.t('Enable Two-Factor Authentication'),
          close: close },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Enable2FAForm__["a" /* default */], {
          userName: userName,
          GoogleQRCode: GoogleQRCode,
          handleSubmit: handleSubmit,
          submitting: submitting
        })
      );
    }
  }]);

  return StandaloneEnable2FAModal;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

StandaloneEnable2FAModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};

StandaloneEnable2FAModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};

StandaloneEnable2FAModal.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    GoogleQRCode: state.user.qrCode.ManualCode,
    userName: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(state, 'auth.creds.username', false),
    Use2FAEnabled: state.user.userInfo.Use2FA
  };
};

var mapDispatchToProps = {
  changeFieldValue: __WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* change */],
  getGoogleQrCode: __WEBPACK_IMPORTED_MODULE_6__redux_actions_userActions__["k" /* getGoogleQrCode */]
};

var containerForm = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["j" /* reduxForm */])({
  form: 'forceEnable2FAModal',
  onSubmit: function onSubmit(payload, dispatch, props) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_userActions__["i" /* enable2FA */])(payload.code, true)).then(function (res) {
      console.log(res);
    });
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(StandaloneEnable2FAModal);

var container = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(containerForm);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__hocs_modalDecorator__["a" /* default */])({
  name: __WEBPACK_IMPORTED_MODULE_5__redux_actions_modalActions__["b" /* MODAL_TYPES */].ENABLE_2FA
})(container));

/***/ }),
/* 2552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_Ticker_TickerContainer__ = __webpack_require__(2553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_RssFeed_RssFeed__ = __webpack_require__(2557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LandingPage_css__ = __webpack_require__(2560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LandingPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LandingPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(2561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_components_common_APLogo_APLogo__ = __webpack_require__(143);
var LandingPage=function LandingPage(props,context){Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* MenuToggle */])('initialize');Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* PageHashCheck */])();Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* setSignupLinkQueryString */])();window.onscroll=function(){Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["c" /* PageHashCheck */])();Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* MenuStylize */])();};return function(){window.onscroll=null;};},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landing-content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'nav-top-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'',className:'nav-logo-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_components_common_APLogo_APLogo__["a" /* default */],{customClass:'ap-logo__img standalone-form__logo__img',linkTo:'/'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landing-nav-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/login',className:'ap-button__btn ap-button__btn--general'},context.t('Login')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/signup',className:'ap-button__btn ap-button__btn--general'},context.t('Signup')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'landing-nav-menu-toggle',className:'landing-nav-menu-toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'menu-wrapper',className:'menu-wrapper','data-status':'closed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,context.t('Home')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#features'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,context.t('Features')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#features-expanded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,context.t('Features Expanded')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#about'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,context.t('About')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#contact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,context.t('Contact')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu-item only-show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'modal-btn login-btn'},context.t('Login')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'menu-item only-show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/signup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'modal-btn register-btn'},context.t('Sign Up')))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'home',className:'chapter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fullscreen-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'fullscreen-bg__svg',xmlns:'http://www.w3.org/2000/svg',width:'1416',height:'941',viewBox:'0 0 1416 941'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{id:'a',d:'M298 12h1416v953H298z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:'none',fillRule:'evenodd',transform:'translate(-298 -12)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('mask',{id:'b',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{stroke:'#454952',strokeOpacity:'.8',mask:'url(#b)',opacity:'.4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'path',d:'M422.655 125L545 247.206 363 429M529 385L406 507.34 501.17 602M552 617l123-122.34L579.83 400M646.659 243h136.2M628.333 501H469.868M884.333 501H725.868M1141.333 501H982.868M1397.333 501h-158.465M1653.333 501h-158.465M373.333 501H214.868M561.744 183h-52.558M884.333 183H725.868M1141.333 183H982.868M1397.333 183h-158.465M1653.333 183h-158.465M324.411 183h-109.55M415.333 341H256.868M672.333 341H513.868M927.333 341H768.868M1183.333 341h-158.465M1439.333 341h-158.465M1695.333 341h-158.465M415.333 818H256.868M672.333 818H513.868M927.333 818H768.868M1183.333 818h-158.465M1439.333 818h-158.465M1695.333 818h-158.465M503.333 659H344.868M758.333 659H599.868M1014.333 659H855.868M1271.333 659h-158.465M1527.333 659h-158.465M1783.333 659h-158.465M574.667 171.667l70.911 70.911M781.34 262.66L646.42 397.58M674.264 428.264l45.3 45.3M727.663 386h173.314M607 64l77.522 77.522M630 118.667H480.301M867 118.667H717.301M402 57l-79.369 79.369M1088 236L937 387l151-151zM805 215l64.78 64.78M1034 269.667H904.645M800 452h165L864.707 552M1136 228l152.924 152H1458M1234 230l66.496 66.496M1347 228l-29.326 29.326M1767 113l-183.792 183H1534M1133 436l112.917 113H1340'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'path',d:'M1044 459l100.444-100L1235 449.155M957 624H818v124M383.77 559L285 656.9 387 758M561 663l-92.555 93H425M892.819 225c49.2-48.349 73.249-72.523 72.145-72.523-1.105 0-33.76-32.826-97.964-98.477M1114 547l57.302 57H1321M1112 97l91.685 91.685M983 136L1116.05 2.95M1195 50l87.88 88H1405M1569 47l-132 132.225L1517.638 260M1550 463.876L1608.123 406 1814 611M1574 658l-74.528 74h-124.2M1567.657 541.657l90.764 90.764M1629 697l115.388 115.388M1584 843l-107.584 107.584M375.333 845v114.803M540 844l107.199 107.199M176 37.493L261.3 123 384 0M1437 574l57.428 57.428M394 150l-92 92.474L348.287 289M350.659 243h136.2M594 315l51-51M709.44 550L635 624h149M1364.183 425L1456 516.903 1351 622M986.643 547L1075 635.201 961 749M727 816V712H602M632 775H524.513L430 869M1176.31 748l72.69 72.788L1091 979M1049 770l69.645-69H1232M1269 691l91.394 91.394M1035 962l-97-97.012L984.983 818M880 840L771.257 948.743M666 845l89.81 89.81M1211 952l81.819-82H1469M1627 959l82.477-83H1839'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,context.t('Best In Breed Asset Exchange')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/signup'},context.t('Suscipit Nibh')),context.t(', sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/signup'},context.t('Demo Our Platform')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'ap-widget':'ticker',style:{display:'flex',overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_apex_web_lib_components_Ticker_TickerContainer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'features',className:'chapter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,context.t('Key Features of Our Platform Software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-icon',src:'local/landing-page/images/icons/icon-chart-black.svg',alt:'icon1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Next-Gen Crypto Exchange'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t(' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-icon',src:'local/landing-page/images/icons/icon-bitcoinBlockchain-black.svg',alt:'icon2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Market Data Streaming'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-icon',src:'local/landing-page/images/icons/icon-pantheon-black.svg',alt:'icon3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Advanced Financial Integration'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-icon',src:'local/landing-page/images/icons/icon-blockchain-black.svg',alt:'icon4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Modular Design System'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'features-expanded',className:'chapter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,context.t('Key Features of Our Platform Software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-icon',src:'local/landing-page/images/icons/icon-chart-white.svg',alt:'icon1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Next-Gen Crypto Exchange'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,context.t('Cryptocurrency sub headline text')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dui ut ornare lectus sit amet est. Mauris sit amet massa vitae tortor condimentum lacinia quis. Velit egestas dui id ornare. Neque convallis a cras semper auctor.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-img',src:'local/landing-page/images/ap-desktop.png',alt:'icon1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-img',src:'local/landing-page/images/ap-mobile2.png',alt:'icon1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-icon',src:'local/landing-page/images/icons/icon-bitcoinBlockchain-white.svg',alt:'icon2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Market Data Streaming'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,context.t('Cryptocurrency sub headline text')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dui ut ornare lectus sit amet est. Mauris sit amet massa vitae tortor condimentum lacinia quis. Velit egestas dui id ornare. Neque convallis a cras semper auctor.'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'about',className:'chapter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,context.t('We provide the most actionable digital currency trading platform.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Enterprise Matching Engine'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Trade Any Digital Currency'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Superior Asset Security'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('We Are The Fastest'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'callToAction'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,context.t('Get Started Today.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Join now for exchange access')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/signup'},context.t('Demo Our Platform')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'content-img box-shadow',src:'local/landing-page/images/ap-trade.png',alt:'icon1'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'press',className:'chapter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,context.t('Press')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_apex_web_lib_components_RssFeed_RssFeed__["a" /* default */],{URL:'https://cors-anywhere.herokuapp.com/https://www.coindesk.com/feed/custom-rss?user=alphapoint&password=sPtQ3cWme47Pcm5jEdzf5wBVeA7DHEGm'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{id:'contact',className:'chapter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row row-contact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_6__config__["default"].global.siteName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,context.t('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitor, nunc nec mattis finibus, nulla eros suscipit nibh, sed posuere risus libero id libero.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'social'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#facebook'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'facebook',src:'local/landing-page/images/icons/social/facebook.svg'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#twitter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'twitter',src:'local/landing-page/images/icons/social/twitter.svg'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#linkedin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'linkedin',src:'local/landing-page/images/icons/social/linkedin.svg'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Sitemap')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_6__config__["default"].SignupForm.TersAndServicesLink},context.t('Terms'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_6__config__["default"].SignupForm.privacyPolicyLink},context.t('Privacy Policy'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},context.t('Fees'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_6__config__["default"].ApiKeys.documentationLink},context.t('API'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,context.t('Contact')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.google.com/maps/place/500+7th+Ave+12th+floor,+New+York,+NY+10018/@40.7532104,-73.9915204,17z/data=!3m1!4b1!4m5!3m4!1s0x89c259ac7b941903:0xec104480b543c42c!8m2!3d40.7532064!4d-73.9893264',target:'blank'},'500 7th Avenue, 12th floor,',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' New York, NY 10018')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},'support@company.com')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''},'+1 212 256 1231')))))))));};LandingPage.contextTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (LandingPage);

/***/ }),
/* 2553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TickerComponent__ = __webpack_require__(2554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__ = __webpack_require__(8);





var mapStateToProps = function mapStateToProps(state) {
  var level1 = state.apexCore.level1;


  var instruments = Object(__WEBPACK_IMPORTED_MODULE_3__redux_selectors_instrumentPositionSelectors__["b" /* instrumentSelectorInstruments */])(state);

  return {
    instruments: instruments,
    level1: level1,
    show24HrPxChange: __WEBPACK_IMPORTED_MODULE_1__config__["b" /* default */].TickerData.show24HrPxChange,
    show24HrVolume: __WEBPACK_IMPORTED_MODULE_1__config__["b" /* default */].TickerData.show24HrVolume
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_2__TickerComponent__["a" /* default */]));

/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__propTypes_level1Data__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(2555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TickerComponent_css__ = __webpack_require__(2556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TickerComponent_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TickerComponent_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_tickerHelper_js__ = __webpack_require__(773);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TickerComponent = function (_React$Component) {
  _inherits(TickerComponent, _React$Component);

  function TickerComponent() {
    _classCallCheck(this, TickerComponent);

    return _possibleConstructorReturn(this, (TickerComponent.__proto__ || Object.getPrototypeOf(TickerComponent)).apply(this, arguments));
  }

  _createClass(TickerComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_tickerHelper_js__["c" /* try_TickerColumns */])('startup');
      Object(__WEBPACK_IMPORTED_MODULE_6__helpers_tickerHelper_js__["d" /* try_TickerScroll */])('startup');

      window.addEventListener('resize', function () {
        Object(__WEBPACK_IMPORTED_MODULE_6__helpers_tickerHelper_js__["c" /* try_TickerColumns */])();
        Object(__WEBPACK_IMPORTED_MODULE_6__helpers_tickerHelper_js__["d" /* try_TickerScroll */])();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', function () {});
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          level1 = _props.level1,
          instruments = _props.instruments,
          show24HrPxChange = _props.show24HrPxChange,
          show24HrVolume = _props.show24HrVolume;

      var context = this.context;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ticker-scrolling' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ticker', id: instruments.length },
          !__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(level1) && instruments.map(function (instrument) {
            var level1Data = level1[instrument.InstrumentId] || {};
            var lastTrade = level1Data['LastTradedPx'];
            var pxChangeDirection = level1Data['Rolling24HrPxChange'] < 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'trending_down' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'trending_up' });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'ticker-block',
                key: instrument.InstrumentId,
                style: lastTrade <= 0 ? { display: 'none' } : {} },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'ticker-symbol' },
                instrument.Symbol,
                pxChangeDirection,
                show24HrPxChange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    className: level1Data['Rolling24HrPxChangePercent'] < 0 ? 'trend_down__24hr' : 'trend_up__24hr' },
                  Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["c" /* formatPercentageValue */])(level1Data['Rolling24HrPxChangePercent'], instrument.Symbol)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'ticker-last-trade' },
                Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["b" /* formatNumberToLocale */])(lastTrade, instrument.Symbol),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'currency' },
                  instrument.Product2Symbol
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'ticker-session' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  context.t('High:')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'session-value' },
                  Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["b" /* formatNumberToLocale */])(level1Data['SessionHigh'], instrument.Symbol)
                )
              ),
              show24HrVolume && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'ticker-session' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  context.t('Volume:')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'session-value' },
                  Object(__WEBPACK_IMPORTED_MODULE_2__helpers_numberFormatter__["b" /* formatNumberToLocale */])(level1Data['Rolling24HrVolume'], instrument.Symbol)
                )
              )
            );
          })
        )
      );
    }
  }]);

  return TickerComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TickerComponent.propTypes = {
  instruments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  show24HrPxChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  show24HrVolume: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

TickerComponent.defaultProps = {
  level1: __WEBPACK_IMPORTED_MODULE_3__propTypes_level1Data__["a" /* defaultProps */]
};

TickerComponent.contextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TickerComponent);

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(514),
    getTag = __webpack_require__(177),
    isArguments = __webpack_require__(242),
    isArray = __webpack_require__(63),
    isArrayLike = __webpack_require__(141),
    isBuffer = __webpack_require__(243),
    isPrototype = __webpack_require__(247),
    isTypedArray = __webpack_require__(318);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 2556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_chunk__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RssFeedItem__ = __webpack_require__(2558);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var RssFeedComponent = function RssFeedComponent(props, context) {
  var NoDataComponent = props.NoDataComponent,
      ListItem = props.ListItem,
      XmlItemSelector = props.XmlItemSelector,
      XmlItemAttributes = props.XmlItemAttributes;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      isReady = _useState2[0],
      setIsReady = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    var getData = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', fetch(props.URL).then(function (res) {
                  return res.text();
                }).then(function (doc) {
                  var items = [];
                  var parser = new window.DOMParser();

                  parser.parseFromString(doc, 'text/xml').querySelectorAll(XmlItemSelector).forEach(function (i) {
                    var node = XmlItemAttributes.reduce(function (acc, attr) {
                      acc[attr] = i.querySelector(attr).textContent;
                      return acc;
                    }, {});

                    items.push(node);
                  });

                  return items;
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function getData() {
        return _ref.apply(this, arguments);
      };
    }();

    getData().then(function (data) {
      setData(data.slice(0, props.items));
      setIsReady(true);
    });
  }, []);

  if (!isReady) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NoDataComponent, null);
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'ap-rss' },
    __WEBPACK_IMPORTED_MODULE_2_lodash_chunk___default()(data, 4).map(function (i, idx) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'row', key: idx },
        i.map(function (i) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ListItem, Object.assign({}, i, { key: i.link }));
        })
      );
    })
  );
};

RssFeedComponent.defaultProps = {
  items: 8,
  XmlItemSelector: 'item',
  XmlItemAttributes: ['title', 'description', 'link', 'image', 'category', 'creator', 'pubDate'],
  NoDataComponent: function NoDataComponent(props, context) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      'Loading...'
    );
  },
  ListItem: function ListItem(props, context) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RssFeedItem__["a" /* RssFeedItem */], Object.assign({}, props, { context: context }));
  }
};

/* harmony default export */ __webpack_exports__["a"] = (RssFeedComponent);

/***/ }),
/* 2558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RssFeedItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RssFeedItem_css__ = __webpack_require__(2559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RssFeedItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RssFeedItem_css__);




var RssFeedItem = function RssFeedItem(props, context) {
  var date = new Date(props.pubDate);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: 'rss-feed-item col-sm content-container',
      href: props.link,
      target: '_blank' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'content-top' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          props.category
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          props.title
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { height: '200', width: '200', src: props.image })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      props.description
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'small',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        props.creator
      ),
      ' -',
      ' ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        date.toDateString(__WEBPACK_IMPORTED_MODULE_1__config__["b" /* default */].global.dateTimeFormat)
      )
    )
  );
};

/***/ }),
/* 2559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getElementOffset */
/* harmony export (immutable) */ __webpack_exports__["a"] = MenuStylize;
/* harmony export (immutable) */ __webpack_exports__["c"] = PageHashCheck;
/* harmony export (immutable) */ __webpack_exports__["d"] = setSignupLinkQueryString;
/* harmony export (immutable) */ __webpack_exports__["b"] = MenuToggle;
function getElementOffset(element){var de=document.documentElement,box=element.getBoundingClientRect(),top=box.top+window.pageYOffset-de.clientTop,left=box.left+window.pageXOffset-de.clientLeft;return{top:top,left:left};}var navTop;function MenuStylize(){if(navTop==null){navTop=document.getElementsByClassName('nav-top-container')[0];}var currentScrollPosition=window.pageYOffset,navHeight=navTop.offsetHeight/2;if(currentScrollPosition>navHeight){navTop.classList.add('show-background');return;}navTop.classList.remove('show-background');}var currentHash='home';function PageHashCheck(){var chapters=document.getElementsByClassName('chapter');for(var i=0;i<chapters.length;i++){var hash=chapters[i].id,currentScrollPosition=window.pageYOffset,currentElementStart_Y=getElementOffset(chapters[i]).top,currentElementHeight=chapters[i].offsetHeight,currentElementEnd_Y=currentElementStart_Y+currentElementHeight,windowHeight=document.body.getBoundingClientRect().height;if(currentScrollPosition+windowHeight/2>currentElementStart_Y&&currentScrollPosition+windowHeight/2<currentElementEnd_Y&&currentHash!==hash){//if executed, this sets the hash, depending on browser compatibility
if(window.history.replaceState){window.history.replaceState(null,null,'#'+hash);}else{window.location.hash=hash;}currentHash=hash;}}}function setSignupLinkQueryString(){var search=window.location.search;if(search){document.querySelectorAll('a[href^="/signup').forEach(function(anchor){var clonedAnchor=anchor.cloneNode(true);clonedAnchor.setAttribute('href','/signup'+search);anchor.parentNode.replaceChild(clonedAnchor,anchor);});}}function MenuToggle(action){var menu=document.getElementById('menu-wrapper');switch(action){case'initialize':menu.addEventListener('click',function(event){if(event.target.className==='menu-wrapper menuopen'){MenuToggle();}});document.getElementById('landing-nav-menu-toggle').addEventListener('click',function(){MenuToggle();});break;default:var status=menu.getAttribute('data-status');if(status==='closed'){menu.setAttribute('data-status','open');menu.classList.add('menuopen');return;}status='closed';menu.classList.remove('menuopen');menu.setAttribute('data-status',status);}}

/***/ }),
/* 2562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_i18n__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_thunk__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apex_web_lib_redux_middlewares_authMiddleware__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apex_web_lib_redux_middlewares_languageMiddleware__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apex_web_lib_redux_middlewares_placeOrderMiddleware__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apex_web_lib_redux_middlewares_startupMiddleware__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apex_web_lib_redux_middlewares_wsConnectionMiddleware__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apex_web_lib_redux_middlewares_orderFeeMiddleware__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apex_web_lib_redux_middlewares_marginEnableMiddleware__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_apex_web_lib_redux_middlewares_priceQuantityIncrementMiddleware__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_apex_web_lib_redux_middlewares_level2monitorMiddleware__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_apex_web_lib_redux_reducers_apiReducer__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_apex_web_lib_redux_apexCore__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_apex_web_lib_redux_reducers_affiliateReducer__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apex_web_lib_redux_reducers_apiKeyReducer__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_apex_web_lib_redux_reducers_apiProcessingReducer__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_apex_web_lib_redux_reducers_authReducer__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_apex_web_lib_redux_reducers_confirmWithdrawReducer__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_apex_web_lib_redux_reducers_instrumentReducer__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_apex_web_lib_redux_reducers_depositReducer__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_apex_web_lib_redux_reducers_level1Reducer__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_apex_web_lib_redux_reducers_level2Reducer__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_apex_web_lib_redux_reducers_loyaltyFeeReducer__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_apex_web_lib_redux_reducers_modalReducer__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_apex_web_lib_redux_reducers_orderHistoryReducer__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_apex_web_lib_redux_reducers_paginationReducer__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_apex_web_lib_redux_reducers_productReducer__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_apex_web_lib_redux_reducers_productManifestReducer__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_apex_web_lib_redux_reducers_positionReducer__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_apex_web_lib_redux_reducers_recentTradesReducer__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_apex_web_lib_redux_reducers_resetPasswordReducer__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_apex_web_lib_redux_reducers_reportReducer__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_apex_web_lib_redux_reducers_sidePaneReducer__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_apex_web_lib_redux_reducers_signupReducer__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_apex_web_lib_redux_reducers_snackbarReducer__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_apex_web_lib_redux_reducers_tickersReducer__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_apex_web_lib_redux_reducers_transferReducer__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_apex_web_lib_redux_reducers_transferRequestReducer__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_apex_web_lib_redux_reducers_transferRequestRequestedReducer__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_apex_web_lib_redux_reducers_userReducer__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_apex_web_lib_redux_reducers_verifyEmailReducer__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_apex_web_lib_redux_reducers_withdrawReducer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_apex_web_lib_redux_reducers_wsConnectionReducer__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_apex_web_lib_redux_reducers_eotcReducer__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_apex_web_lib_redux_reducers_eotcWithdrawReducer__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_apex_web_lib_redux_reducers_eotcSettlementReducer__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_apex_web_lib_redux_reducers_eotcPriceReducer__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_apex_web_lib_redux_reducers_marginReducers_marginReducer__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_apex_web_lib_redux_reducers_productAttributesReducer__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_apex_web_lib_redux_reducers_interestBearingAccountsReducer__ = __webpack_require__(572);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};// reducers (sort by name)
var composeEnhancers=(typeof window==='undefined'?'undefined':_typeof(window))==='object'&&window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({actionsBlacklist:['LEVEL1_LOADED','LEVEL_2_UPDATES','REGISTER_FIELD','ADD_RECENT_TRADE']}):__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({api:__WEBPACK_IMPORTED_MODULE_13_apex_web_lib_redux_reducers_apiReducer__["a" /* default */],apexCore:__WEBPACK_IMPORTED_MODULE_14_apex_web_lib_redux_apexCore__["a" /* default */],apiKey:__WEBPACK_IMPORTED_MODULE_16_apex_web_lib_redux_reducers_apiKeyReducer__["a" /* default */],affiliate:__WEBPACK_IMPORTED_MODULE_15_apex_web_lib_redux_reducers_affiliateReducer__["a" /* default */],auth:__WEBPACK_IMPORTED_MODULE_18_apex_web_lib_redux_reducers_authReducer__["a" /* default */],form:__WEBPACK_IMPORTED_MODULE_1_redux_form__["i" /* reducer */],i18nState:__WEBPACK_IMPORTED_MODULE_2_redux_i18n__["i18nState"],instrument:__WEBPACK_IMPORTED_MODULE_20_apex_web_lib_redux_reducers_instrumentReducer__["a" /* default */],level1:__WEBPACK_IMPORTED_MODULE_22_apex_web_lib_redux_reducers_level1Reducer__["a" /* default */],level2:__WEBPACK_IMPORTED_MODULE_23_apex_web_lib_redux_reducers_level2Reducer__["a" /* default */],modal:__WEBPACK_IMPORTED_MODULE_25_apex_web_lib_redux_reducers_modalReducer__["a" /* default */],orderHistory:__WEBPACK_IMPORTED_MODULE_26_apex_web_lib_redux_reducers_orderHistoryReducer__["a" /* default */],product:__WEBPACK_IMPORTED_MODULE_28_apex_web_lib_redux_reducers_productReducer__["a" /* default */],productManifest:__WEBPACK_IMPORTED_MODULE_29_apex_web_lib_redux_reducers_productManifestReducer__["a" /* default */],position:__WEBPACK_IMPORTED_MODULE_30_apex_web_lib_redux_reducers_positionReducer__["a" /* default */],recentTrades:__WEBPACK_IMPORTED_MODULE_31_apex_web_lib_redux_reducers_recentTradesReducer__["a" /* default */],report:__WEBPACK_IMPORTED_MODULE_33_apex_web_lib_redux_reducers_reportReducer__["a" /* default */],sidePane:__WEBPACK_IMPORTED_MODULE_34_apex_web_lib_redux_reducers_sidePaneReducer__["a" /* default */],signup:__WEBPACK_IMPORTED_MODULE_35_apex_web_lib_redux_reducers_signupReducer__["a" /* default */],snackbar:__WEBPACK_IMPORTED_MODULE_36_apex_web_lib_redux_reducers_snackbarReducer__["a" /* default */],user:__WEBPACK_IMPORTED_MODULE_41_apex_web_lib_redux_reducers_userReducer__["a" /* default */],apiProcessing:__WEBPACK_IMPORTED_MODULE_17_apex_web_lib_redux_reducers_apiProcessingReducer__["a" /* default */],deposit:__WEBPACK_IMPORTED_MODULE_21_apex_web_lib_redux_reducers_depositReducer__["a" /* default */],withdraw:__WEBPACK_IMPORTED_MODULE_43_apex_web_lib_redux_reducers_withdrawReducer__["a" /* default */],wsConnection:__WEBPACK_IMPORTED_MODULE_44_apex_web_lib_redux_reducers_wsConnectionReducer__["a" /* default */],tickers:__WEBPACK_IMPORTED_MODULE_37_apex_web_lib_redux_reducers_tickersReducer__["a" /* default */],transfer:__WEBPACK_IMPORTED_MODULE_38_apex_web_lib_redux_reducers_transferReducer__["a" /* default */],transferRequest:__WEBPACK_IMPORTED_MODULE_39_apex_web_lib_redux_reducers_transferRequestReducer__["a" /* default */],paginationMemory:__WEBPACK_IMPORTED_MODULE_27_apex_web_lib_redux_reducers_paginationReducer__["a" /* default */],verifyEmail:__WEBPACK_IMPORTED_MODULE_42_apex_web_lib_redux_reducers_verifyEmailReducer__["a" /* default */],confirmWithdraw:__WEBPACK_IMPORTED_MODULE_19_apex_web_lib_redux_reducers_confirmWithdrawReducer__["a" /* default */],resetPassword:__WEBPACK_IMPORTED_MODULE_32_apex_web_lib_redux_reducers_resetPasswordReducer__["a" /* default */],loyaltyFee:__WEBPACK_IMPORTED_MODULE_24_apex_web_lib_redux_reducers_loyaltyFeeReducer__["a" /* default */],transferRequestRequested:__WEBPACK_IMPORTED_MODULE_40_apex_web_lib_redux_reducers_transferRequestRequestedReducer__["a" /* default */],eotc:__WEBPACK_IMPORTED_MODULE_45_apex_web_lib_redux_reducers_eotcReducer__["a" /* default */],eotcWithdraw:__WEBPACK_IMPORTED_MODULE_46_apex_web_lib_redux_reducers_eotcWithdrawReducer__["a" /* default */],eotcSettlement:__WEBPACK_IMPORTED_MODULE_47_apex_web_lib_redux_reducers_eotcSettlementReducer__["a" /* default */],eotcPrices:__WEBPACK_IMPORTED_MODULE_48_apex_web_lib_redux_reducers_eotcPriceReducer__["a" /* default */],margin:__WEBPACK_IMPORTED_MODULE_49_apex_web_lib_redux_reducers_marginReducers_marginReducer__["a" /* marginReducer */],productAttributes:__WEBPACK_IMPORTED_MODULE_50_apex_web_lib_redux_reducers_productAttributesReducer__["a" /* default */],interestBearingAccounts:__WEBPACK_IMPORTED_MODULE_51_apex_web_lib_redux_reducers_interestBearingAccountsReducer__["a" /* default */]});var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(rootReducer,undefined,composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_12_apex_web_lib_redux_middlewares_level2monitorMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_11_apex_web_lib_redux_middlewares_priceQuantityIncrementMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_10_apex_web_lib_redux_middlewares_marginEnableMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5_apex_web_lib_redux_middlewares_languageMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4_apex_web_lib_redux_middlewares_authMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_6_apex_web_lib_redux_middlewares_placeOrderMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_7_apex_web_lib_redux_middlewares_startupMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_8_apex_web_lib_redux_middlewares_wsConnectionMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_9_apex_web_lib_redux_middlewares_orderFeeMiddleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3_redux_thunk__["a" /* default */])));/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 2563 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1185);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.f94f5f58.js